/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from "protobufjs/minimal";

// Common aliases
const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const request = $root.request = (() => {

    /**
     * Namespace request.
     * @exports request
     * @namespace
     */
    const request = {};

    /**
     * Plan enum.
     * @name request.Plan
     * @enum {number}
     * @property {number} Free=0 Free value
     * @property {number} Basic=1 Basic value
     * @property {number} Pro=2 Pro value
     */
    request.Plan = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "Free"] = 0;
        values[valuesById[1] = "Basic"] = 1;
        values[valuesById[2] = "Pro"] = 2;
        return values;
    })();

    request.AddUser = (function() {

        /**
         * Properties of an AddUser.
         * @memberof request
         * @interface IAddUser
         * @property {string|null} [email] AddUser email
         * @property {string|null} [password] AddUser password
         * @property {request.Plan|null} [plan] AddUser plan
         * @property {string|null} [organization] AddUser organization
         * @property {string|null} [token] AddUser token
         */

        /**
         * Constructs a new AddUser.
         * @memberof request
         * @classdesc Represents an AddUser.
         * @implements IAddUser
         * @constructor
         * @param {request.IAddUser=} [properties] Properties to set
         */
        function AddUser(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddUser email.
         * @member {string} email
         * @memberof request.AddUser
         * @instance
         */
        AddUser.prototype.email = "";

        /**
         * AddUser password.
         * @member {string} password
         * @memberof request.AddUser
         * @instance
         */
        AddUser.prototype.password = "";

        /**
         * AddUser plan.
         * @member {request.Plan|null|undefined} plan
         * @memberof request.AddUser
         * @instance
         */
        AddUser.prototype.plan = null;

        /**
         * AddUser organization.
         * @member {string|null|undefined} organization
         * @memberof request.AddUser
         * @instance
         */
        AddUser.prototype.organization = null;

        /**
         * AddUser token.
         * @member {string|null|undefined} token
         * @memberof request.AddUser
         * @instance
         */
        AddUser.prototype.token = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(AddUser.prototype, "_plan", {
            get: $util.oneOfGetter($oneOfFields = ["plan"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(AddUser.prototype, "_organization", {
            get: $util.oneOfGetter($oneOfFields = ["organization"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(AddUser.prototype, "_token", {
            get: $util.oneOfGetter($oneOfFields = ["token"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new AddUser instance using the specified properties.
         * @function create
         * @memberof request.AddUser
         * @static
         * @param {request.IAddUser=} [properties] Properties to set
         * @returns {request.AddUser} AddUser instance
         */
        AddUser.create = function create(properties) {
            return new AddUser(properties);
        };

        /**
         * Encodes the specified AddUser message. Does not implicitly {@link request.AddUser.verify|verify} messages.
         * @function encode
         * @memberof request.AddUser
         * @static
         * @param {request.IAddUser} message AddUser message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddUser.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
            if (message.password != null && Object.hasOwnProperty.call(message, "password"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.password);
            if (message.plan != null && Object.hasOwnProperty.call(message, "plan"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.plan);
            if (message.organization != null && Object.hasOwnProperty.call(message, "organization"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.organization);
            if (message.token != null && Object.hasOwnProperty.call(message, "token"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.token);
            return writer;
        };

        /**
         * Encodes the specified AddUser message, length delimited. Does not implicitly {@link request.AddUser.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.AddUser
         * @static
         * @param {request.IAddUser} message AddUser message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddUser.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AddUser message from the specified reader or buffer.
         * @function decode
         * @memberof request.AddUser
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.AddUser} AddUser
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddUser.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.AddUser();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.email = reader.string();
                        break;
                    }
                case 2: {
                        message.password = reader.string();
                        break;
                    }
                case 4: {
                        message.plan = reader.int32();
                        break;
                    }
                case 5: {
                        message.organization = reader.string();
                        break;
                    }
                case 6: {
                        message.token = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AddUser message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.AddUser
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.AddUser} AddUser
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddUser.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AddUser message.
         * @function verify
         * @memberof request.AddUser
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AddUser.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            if (message.password != null && message.hasOwnProperty("password"))
                if (!$util.isString(message.password))
                    return "password: string expected";
            if (message.plan != null && message.hasOwnProperty("plan")) {
                properties._plan = 1;
                switch (message.plan) {
                default:
                    return "plan: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            }
            if (message.organization != null && message.hasOwnProperty("organization")) {
                properties._organization = 1;
                if (!$util.isString(message.organization))
                    return "organization: string expected";
            }
            if (message.token != null && message.hasOwnProperty("token")) {
                properties._token = 1;
                if (!$util.isString(message.token))
                    return "token: string expected";
            }
            return null;
        };

        /**
         * Creates an AddUser message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.AddUser
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.AddUser} AddUser
         */
        AddUser.fromObject = function fromObject(object) {
            if (object instanceof $root.request.AddUser)
                return object;
            let message = new $root.request.AddUser();
            if (object.email != null)
                message.email = String(object.email);
            if (object.password != null)
                message.password = String(object.password);
            switch (object.plan) {
            default:
                if (typeof object.plan === "number") {
                    message.plan = object.plan;
                    break;
                }
                break;
            case "Free":
            case 0:
                message.plan = 0;
                break;
            case "Basic":
            case 1:
                message.plan = 1;
                break;
            case "Pro":
            case 2:
                message.plan = 2;
                break;
            }
            if (object.organization != null)
                message.organization = String(object.organization);
            if (object.token != null)
                message.token = String(object.token);
            return message;
        };

        /**
         * Creates a plain object from an AddUser message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.AddUser
         * @static
         * @param {request.AddUser} message AddUser
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddUser.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.email = "";
                object.password = "";
            }
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.password != null && message.hasOwnProperty("password"))
                object.password = message.password;
            if (message.plan != null && message.hasOwnProperty("plan")) {
                object.plan = options.enums === String ? $root.request.Plan[message.plan] === undefined ? message.plan : $root.request.Plan[message.plan] : message.plan;
                if (options.oneofs)
                    object._plan = "plan";
            }
            if (message.organization != null && message.hasOwnProperty("organization")) {
                object.organization = message.organization;
                if (options.oneofs)
                    object._organization = "organization";
            }
            if (message.token != null && message.hasOwnProperty("token")) {
                object.token = message.token;
                if (options.oneofs)
                    object._token = "token";
            }
            return object;
        };

        /**
         * Converts this AddUser to JSON.
         * @function toJSON
         * @memberof request.AddUser
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddUser.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for AddUser
         * @function getTypeUrl
         * @memberof request.AddUser
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        AddUser.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.AddUser";
        };

        return AddUser;
    })();

    request.AddPin = (function() {

        /**
         * Properties of an AddPin.
         * @memberof request
         * @interface IAddPin
         * @property {string|null} [email] AddPin email
         * @property {string|null} [pin] AddPin pin
         * @property {string|null} [client] AddPin client
         * @property {Array.<request.AllowedPinOp>|null} [allowedOps] AddPin allowedOps
         * @property {number|Long|null} [ttl] AddPin ttl
         * @property {string|null} [name] AddPin name
         * @property {Uint8Array|null} [tokenData] AddPin tokenData
         * @property {Array.<Uint8Array>|null} [allowedObjects] AddPin allowedObjects
         */

        /**
         * Constructs a new AddPin.
         * @memberof request
         * @classdesc Represents an AddPin.
         * @implements IAddPin
         * @constructor
         * @param {request.IAddPin=} [properties] Properties to set
         */
        function AddPin(properties) {
            this.allowedOps = [];
            this.allowedObjects = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddPin email.
         * @member {string} email
         * @memberof request.AddPin
         * @instance
         */
        AddPin.prototype.email = "";

        /**
         * AddPin pin.
         * @member {string} pin
         * @memberof request.AddPin
         * @instance
         */
        AddPin.prototype.pin = "";

        /**
         * AddPin client.
         * @member {string} client
         * @memberof request.AddPin
         * @instance
         */
        AddPin.prototype.client = "";

        /**
         * AddPin allowedOps.
         * @member {Array.<request.AllowedPinOp>} allowedOps
         * @memberof request.AddPin
         * @instance
         */
        AddPin.prototype.allowedOps = $util.emptyArray;

        /**
         * AddPin ttl.
         * @member {number|Long} ttl
         * @memberof request.AddPin
         * @instance
         */
        AddPin.prototype.ttl = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * AddPin name.
         * @member {string|null|undefined} name
         * @memberof request.AddPin
         * @instance
         */
        AddPin.prototype.name = null;

        /**
         * AddPin tokenData.
         * @member {Uint8Array|null|undefined} tokenData
         * @memberof request.AddPin
         * @instance
         */
        AddPin.prototype.tokenData = null;

        /**
         * AddPin allowedObjects.
         * @member {Array.<Uint8Array>} allowedObjects
         * @memberof request.AddPin
         * @instance
         */
        AddPin.prototype.allowedObjects = $util.emptyArray;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(AddPin.prototype, "_name", {
            get: $util.oneOfGetter($oneOfFields = ["name"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(AddPin.prototype, "_tokenData", {
            get: $util.oneOfGetter($oneOfFields = ["tokenData"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new AddPin instance using the specified properties.
         * @function create
         * @memberof request.AddPin
         * @static
         * @param {request.IAddPin=} [properties] Properties to set
         * @returns {request.AddPin} AddPin instance
         */
        AddPin.create = function create(properties) {
            return new AddPin(properties);
        };

        /**
         * Encodes the specified AddPin message. Does not implicitly {@link request.AddPin.verify|verify} messages.
         * @function encode
         * @memberof request.AddPin
         * @static
         * @param {request.IAddPin} message AddPin message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddPin.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
            if (message.pin != null && Object.hasOwnProperty.call(message, "pin"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.pin);
            if (message.client != null && Object.hasOwnProperty.call(message, "client"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.client);
            if (message.allowedOps != null && message.allowedOps.length) {
                writer.uint32(/* id 4, wireType 2 =*/34).fork();
                for (let i = 0; i < message.allowedOps.length; ++i)
                    writer.int32(message.allowedOps[i]);
                writer.ldelim();
            }
            if (message.ttl != null && Object.hasOwnProperty.call(message, "ttl"))
                writer.uint32(/* id 5, wireType 0 =*/40).uint64(message.ttl);
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.name);
            if (message.tokenData != null && Object.hasOwnProperty.call(message, "tokenData"))
                writer.uint32(/* id 7, wireType 2 =*/58).bytes(message.tokenData);
            if (message.allowedObjects != null && message.allowedObjects.length)
                for (let i = 0; i < message.allowedObjects.length; ++i)
                    writer.uint32(/* id 8, wireType 2 =*/66).bytes(message.allowedObjects[i]);
            return writer;
        };

        /**
         * Encodes the specified AddPin message, length delimited. Does not implicitly {@link request.AddPin.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.AddPin
         * @static
         * @param {request.IAddPin} message AddPin message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddPin.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AddPin message from the specified reader or buffer.
         * @function decode
         * @memberof request.AddPin
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.AddPin} AddPin
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddPin.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.AddPin();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.email = reader.string();
                        break;
                    }
                case 2: {
                        message.pin = reader.string();
                        break;
                    }
                case 3: {
                        message.client = reader.string();
                        break;
                    }
                case 4: {
                        if (!(message.allowedOps && message.allowedOps.length))
                            message.allowedOps = [];
                        if ((tag & 7) === 2) {
                            let end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.allowedOps.push(reader.int32());
                        } else
                            message.allowedOps.push(reader.int32());
                        break;
                    }
                case 5: {
                        message.ttl = reader.uint64();
                        break;
                    }
                case 6: {
                        message.name = reader.string();
                        break;
                    }
                case 7: {
                        message.tokenData = reader.bytes();
                        break;
                    }
                case 8: {
                        if (!(message.allowedObjects && message.allowedObjects.length))
                            message.allowedObjects = [];
                        message.allowedObjects.push(reader.bytes());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AddPin message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.AddPin
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.AddPin} AddPin
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddPin.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AddPin message.
         * @function verify
         * @memberof request.AddPin
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AddPin.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            if (message.pin != null && message.hasOwnProperty("pin"))
                if (!$util.isString(message.pin))
                    return "pin: string expected";
            if (message.client != null && message.hasOwnProperty("client"))
                if (!$util.isString(message.client))
                    return "client: string expected";
            if (message.allowedOps != null && message.hasOwnProperty("allowedOps")) {
                if (!Array.isArray(message.allowedOps))
                    return "allowedOps: array expected";
                for (let i = 0; i < message.allowedOps.length; ++i)
                    switch (message.allowedOps[i]) {
                    default:
                        return "allowedOps: enum value[] expected";
                    case 0:
                    case 17:
                    case 21:
                    case 25:
                    case 52:
                    case 22:
                    case 23:
                    case 24:
                    case 66:
                    case 50:
                    case 55:
                    case 30:
                    case 51:
                    case 56:
                    case 15:
                    case 84:
                    case 54:
                    case 91:
                        break;
                    }
            }
            if (message.ttl != null && message.hasOwnProperty("ttl"))
                if (!$util.isInteger(message.ttl) && !(message.ttl && $util.isInteger(message.ttl.low) && $util.isInteger(message.ttl.high)))
                    return "ttl: integer|Long expected";
            if (message.name != null && message.hasOwnProperty("name")) {
                properties._name = 1;
                if (!$util.isString(message.name))
                    return "name: string expected";
            }
            if (message.tokenData != null && message.hasOwnProperty("tokenData")) {
                properties._tokenData = 1;
                if (!(message.tokenData && typeof message.tokenData.length === "number" || $util.isString(message.tokenData)))
                    return "tokenData: buffer expected";
            }
            if (message.allowedObjects != null && message.hasOwnProperty("allowedObjects")) {
                if (!Array.isArray(message.allowedObjects))
                    return "allowedObjects: array expected";
                for (let i = 0; i < message.allowedObjects.length; ++i)
                    if (!(message.allowedObjects[i] && typeof message.allowedObjects[i].length === "number" || $util.isString(message.allowedObjects[i])))
                        return "allowedObjects: buffer[] expected";
            }
            return null;
        };

        /**
         * Creates an AddPin message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.AddPin
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.AddPin} AddPin
         */
        AddPin.fromObject = function fromObject(object) {
            if (object instanceof $root.request.AddPin)
                return object;
            let message = new $root.request.AddPin();
            if (object.email != null)
                message.email = String(object.email);
            if (object.pin != null)
                message.pin = String(object.pin);
            if (object.client != null)
                message.client = String(object.client);
            if (object.allowedOps) {
                if (!Array.isArray(object.allowedOps))
                    throw TypeError(".request.AddPin.allowedOps: array expected");
                message.allowedOps = [];
                for (let i = 0; i < object.allowedOps.length; ++i)
                    switch (object.allowedOps[i]) {
                    default:
                        if (typeof object.allowedOps[i] === "number") {
                            message.allowedOps[i] = object.allowedOps[i];
                            break;
                        }
                    case "Dummy":
                    case 0:
                        message.allowedOps[i] = 0;
                        break;
                    case "PinOpGetMetaFromPath":
                    case 17:
                        message.allowedOps[i] = 17;
                        break;
                    case "PinOpGetChunk":
                    case 21:
                        message.allowedOps[i] = 21;
                        break;
                    case "PinOpListFiles":
                    case 25:
                        message.allowedOps[i] = 25;
                        break;
                    case "PinOpCopyFile":
                    case 52:
                        message.allowedOps[i] = 52;
                        break;
                    case "PinOpStartWrite":
                    case 22:
                        message.allowedOps[i] = 22;
                        break;
                    case "PinOpPutChunk":
                    case 23:
                        message.allowedOps[i] = 23;
                        break;
                    case "PinOpFinalizeWrite":
                    case 24:
                        message.allowedOps[i] = 24;
                        break;
                    case "PinOpResetVersion":
                    case 66:
                        message.allowedOps[i] = 66;
                        break;
                    case "PinOpMoveFile":
                    case 50:
                        message.allowedOps[i] = 50;
                        break;
                    case "PinOpRemoveFile":
                    case 55:
                        message.allowedOps[i] = 55;
                        break;
                    case "PinOpCreateFolder":
                    case 30:
                        message.allowedOps[i] = 30;
                        break;
                    case "PinOpMoveFolder":
                    case 51:
                        message.allowedOps[i] = 51;
                        break;
                    case "PinOpRemoveFolder":
                    case 56:
                        message.allowedOps[i] = 56;
                        break;
                    case "PinOpAddPin":
                    case 15:
                        message.allowedOps[i] = 15;
                        break;
                    case "PinOpUpdatePin":
                    case 84:
                        message.allowedOps[i] = 84;
                        break;
                    case "PinOpDeletePin":
                    case 54:
                        message.allowedOps[i] = 54;
                        break;
                    case "PinOpListPins":
                    case 91:
                        message.allowedOps[i] = 91;
                        break;
                    }
            }
            if (object.ttl != null)
                if ($util.Long)
                    (message.ttl = $util.Long.fromValue(object.ttl)).unsigned = true;
                else if (typeof object.ttl === "string")
                    message.ttl = parseInt(object.ttl, 10);
                else if (typeof object.ttl === "number")
                    message.ttl = object.ttl;
                else if (typeof object.ttl === "object")
                    message.ttl = new $util.LongBits(object.ttl.low >>> 0, object.ttl.high >>> 0).toNumber(true);
            if (object.name != null)
                message.name = String(object.name);
            if (object.tokenData != null)
                if (typeof object.tokenData === "string")
                    $util.base64.decode(object.tokenData, message.tokenData = $util.newBuffer($util.base64.length(object.tokenData)), 0);
                else if (object.tokenData.length >= 0)
                    message.tokenData = object.tokenData;
            if (object.allowedObjects) {
                if (!Array.isArray(object.allowedObjects))
                    throw TypeError(".request.AddPin.allowedObjects: array expected");
                message.allowedObjects = [];
                for (let i = 0; i < object.allowedObjects.length; ++i)
                    if (typeof object.allowedObjects[i] === "string")
                        $util.base64.decode(object.allowedObjects[i], message.allowedObjects[i] = $util.newBuffer($util.base64.length(object.allowedObjects[i])), 0);
                    else if (object.allowedObjects[i].length >= 0)
                        message.allowedObjects[i] = object.allowedObjects[i];
            }
            return message;
        };

        /**
         * Creates a plain object from an AddPin message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.AddPin
         * @static
         * @param {request.AddPin} message AddPin
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddPin.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.allowedOps = [];
                object.allowedObjects = [];
            }
            if (options.defaults) {
                object.email = "";
                object.pin = "";
                object.client = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.ttl = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.ttl = options.longs === String ? "0" : 0;
            }
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.pin != null && message.hasOwnProperty("pin"))
                object.pin = message.pin;
            if (message.client != null && message.hasOwnProperty("client"))
                object.client = message.client;
            if (message.allowedOps && message.allowedOps.length) {
                object.allowedOps = [];
                for (let j = 0; j < message.allowedOps.length; ++j)
                    object.allowedOps[j] = options.enums === String ? $root.request.AllowedPinOp[message.allowedOps[j]] === undefined ? message.allowedOps[j] : $root.request.AllowedPinOp[message.allowedOps[j]] : message.allowedOps[j];
            }
            if (message.ttl != null && message.hasOwnProperty("ttl"))
                if (typeof message.ttl === "number")
                    object.ttl = options.longs === String ? String(message.ttl) : message.ttl;
                else
                    object.ttl = options.longs === String ? $util.Long.prototype.toString.call(message.ttl) : options.longs === Number ? new $util.LongBits(message.ttl.low >>> 0, message.ttl.high >>> 0).toNumber(true) : message.ttl;
            if (message.name != null && message.hasOwnProperty("name")) {
                object.name = message.name;
                if (options.oneofs)
                    object._name = "name";
            }
            if (message.tokenData != null && message.hasOwnProperty("tokenData")) {
                object.tokenData = options.bytes === String ? $util.base64.encode(message.tokenData, 0, message.tokenData.length) : options.bytes === Array ? Array.prototype.slice.call(message.tokenData) : message.tokenData;
                if (options.oneofs)
                    object._tokenData = "tokenData";
            }
            if (message.allowedObjects && message.allowedObjects.length) {
                object.allowedObjects = [];
                for (let j = 0; j < message.allowedObjects.length; ++j)
                    object.allowedObjects[j] = options.bytes === String ? $util.base64.encode(message.allowedObjects[j], 0, message.allowedObjects[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.allowedObjects[j]) : message.allowedObjects[j];
            }
            return object;
        };

        /**
         * Converts this AddPin to JSON.
         * @function toJSON
         * @memberof request.AddPin
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddPin.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for AddPin
         * @function getTypeUrl
         * @memberof request.AddPin
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        AddPin.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.AddPin";
        };

        return AddPin;
    })();

    request.UpdatePinOps = (function() {

        /**
         * Properties of an UpdatePinOps.
         * @memberof request
         * @interface IUpdatePinOps
         * @property {string|null} [email] UpdatePinOps email
         * @property {string|null} [pinName] UpdatePinOps pinName
         * @property {Uint8Array|null} [data] UpdatePinOps data
         * @property {Array.<request.AllowedPinOp>|null} [allowedOps] UpdatePinOps allowedOps
         * @property {Array.<Uint8Array>|null} [allowedObjects] UpdatePinOps allowedObjects
         */

        /**
         * Constructs a new UpdatePinOps.
         * @memberof request
         * @classdesc Represents an UpdatePinOps.
         * @implements IUpdatePinOps
         * @constructor
         * @param {request.IUpdatePinOps=} [properties] Properties to set
         */
        function UpdatePinOps(properties) {
            this.allowedOps = [];
            this.allowedObjects = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdatePinOps email.
         * @member {string} email
         * @memberof request.UpdatePinOps
         * @instance
         */
        UpdatePinOps.prototype.email = "";

        /**
         * UpdatePinOps pinName.
         * @member {string} pinName
         * @memberof request.UpdatePinOps
         * @instance
         */
        UpdatePinOps.prototype.pinName = "";

        /**
         * UpdatePinOps data.
         * @member {Uint8Array} data
         * @memberof request.UpdatePinOps
         * @instance
         */
        UpdatePinOps.prototype.data = $util.newBuffer([]);

        /**
         * UpdatePinOps allowedOps.
         * @member {Array.<request.AllowedPinOp>} allowedOps
         * @memberof request.UpdatePinOps
         * @instance
         */
        UpdatePinOps.prototype.allowedOps = $util.emptyArray;

        /**
         * UpdatePinOps allowedObjects.
         * @member {Array.<Uint8Array>} allowedObjects
         * @memberof request.UpdatePinOps
         * @instance
         */
        UpdatePinOps.prototype.allowedObjects = $util.emptyArray;

        /**
         * Creates a new UpdatePinOps instance using the specified properties.
         * @function create
         * @memberof request.UpdatePinOps
         * @static
         * @param {request.IUpdatePinOps=} [properties] Properties to set
         * @returns {request.UpdatePinOps} UpdatePinOps instance
         */
        UpdatePinOps.create = function create(properties) {
            return new UpdatePinOps(properties);
        };

        /**
         * Encodes the specified UpdatePinOps message. Does not implicitly {@link request.UpdatePinOps.verify|verify} messages.
         * @function encode
         * @memberof request.UpdatePinOps
         * @static
         * @param {request.IUpdatePinOps} message UpdatePinOps message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdatePinOps.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
            if (message.pinName != null && Object.hasOwnProperty.call(message, "pinName"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.pinName);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.data);
            if (message.allowedOps != null && message.allowedOps.length) {
                writer.uint32(/* id 4, wireType 2 =*/34).fork();
                for (let i = 0; i < message.allowedOps.length; ++i)
                    writer.int32(message.allowedOps[i]);
                writer.ldelim();
            }
            if (message.allowedObjects != null && message.allowedObjects.length)
                for (let i = 0; i < message.allowedObjects.length; ++i)
                    writer.uint32(/* id 5, wireType 2 =*/42).bytes(message.allowedObjects[i]);
            return writer;
        };

        /**
         * Encodes the specified UpdatePinOps message, length delimited. Does not implicitly {@link request.UpdatePinOps.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.UpdatePinOps
         * @static
         * @param {request.IUpdatePinOps} message UpdatePinOps message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdatePinOps.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UpdatePinOps message from the specified reader or buffer.
         * @function decode
         * @memberof request.UpdatePinOps
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.UpdatePinOps} UpdatePinOps
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdatePinOps.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.UpdatePinOps();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.email = reader.string();
                        break;
                    }
                case 2: {
                        message.pinName = reader.string();
                        break;
                    }
                case 3: {
                        message.data = reader.bytes();
                        break;
                    }
                case 4: {
                        if (!(message.allowedOps && message.allowedOps.length))
                            message.allowedOps = [];
                        if ((tag & 7) === 2) {
                            let end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.allowedOps.push(reader.int32());
                        } else
                            message.allowedOps.push(reader.int32());
                        break;
                    }
                case 5: {
                        if (!(message.allowedObjects && message.allowedObjects.length))
                            message.allowedObjects = [];
                        message.allowedObjects.push(reader.bytes());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UpdatePinOps message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.UpdatePinOps
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.UpdatePinOps} UpdatePinOps
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdatePinOps.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UpdatePinOps message.
         * @function verify
         * @memberof request.UpdatePinOps
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UpdatePinOps.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            if (message.pinName != null && message.hasOwnProperty("pinName"))
                if (!$util.isString(message.pinName))
                    return "pinName: string expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            if (message.allowedOps != null && message.hasOwnProperty("allowedOps")) {
                if (!Array.isArray(message.allowedOps))
                    return "allowedOps: array expected";
                for (let i = 0; i < message.allowedOps.length; ++i)
                    switch (message.allowedOps[i]) {
                    default:
                        return "allowedOps: enum value[] expected";
                    case 0:
                    case 17:
                    case 21:
                    case 25:
                    case 52:
                    case 22:
                    case 23:
                    case 24:
                    case 66:
                    case 50:
                    case 55:
                    case 30:
                    case 51:
                    case 56:
                    case 15:
                    case 84:
                    case 54:
                    case 91:
                        break;
                    }
            }
            if (message.allowedObjects != null && message.hasOwnProperty("allowedObjects")) {
                if (!Array.isArray(message.allowedObjects))
                    return "allowedObjects: array expected";
                for (let i = 0; i < message.allowedObjects.length; ++i)
                    if (!(message.allowedObjects[i] && typeof message.allowedObjects[i].length === "number" || $util.isString(message.allowedObjects[i])))
                        return "allowedObjects: buffer[] expected";
            }
            return null;
        };

        /**
         * Creates an UpdatePinOps message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.UpdatePinOps
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.UpdatePinOps} UpdatePinOps
         */
        UpdatePinOps.fromObject = function fromObject(object) {
            if (object instanceof $root.request.UpdatePinOps)
                return object;
            let message = new $root.request.UpdatePinOps();
            if (object.email != null)
                message.email = String(object.email);
            if (object.pinName != null)
                message.pinName = String(object.pinName);
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            if (object.allowedOps) {
                if (!Array.isArray(object.allowedOps))
                    throw TypeError(".request.UpdatePinOps.allowedOps: array expected");
                message.allowedOps = [];
                for (let i = 0; i < object.allowedOps.length; ++i)
                    switch (object.allowedOps[i]) {
                    default:
                        if (typeof object.allowedOps[i] === "number") {
                            message.allowedOps[i] = object.allowedOps[i];
                            break;
                        }
                    case "Dummy":
                    case 0:
                        message.allowedOps[i] = 0;
                        break;
                    case "PinOpGetMetaFromPath":
                    case 17:
                        message.allowedOps[i] = 17;
                        break;
                    case "PinOpGetChunk":
                    case 21:
                        message.allowedOps[i] = 21;
                        break;
                    case "PinOpListFiles":
                    case 25:
                        message.allowedOps[i] = 25;
                        break;
                    case "PinOpCopyFile":
                    case 52:
                        message.allowedOps[i] = 52;
                        break;
                    case "PinOpStartWrite":
                    case 22:
                        message.allowedOps[i] = 22;
                        break;
                    case "PinOpPutChunk":
                    case 23:
                        message.allowedOps[i] = 23;
                        break;
                    case "PinOpFinalizeWrite":
                    case 24:
                        message.allowedOps[i] = 24;
                        break;
                    case "PinOpResetVersion":
                    case 66:
                        message.allowedOps[i] = 66;
                        break;
                    case "PinOpMoveFile":
                    case 50:
                        message.allowedOps[i] = 50;
                        break;
                    case "PinOpRemoveFile":
                    case 55:
                        message.allowedOps[i] = 55;
                        break;
                    case "PinOpCreateFolder":
                    case 30:
                        message.allowedOps[i] = 30;
                        break;
                    case "PinOpMoveFolder":
                    case 51:
                        message.allowedOps[i] = 51;
                        break;
                    case "PinOpRemoveFolder":
                    case 56:
                        message.allowedOps[i] = 56;
                        break;
                    case "PinOpAddPin":
                    case 15:
                        message.allowedOps[i] = 15;
                        break;
                    case "PinOpUpdatePin":
                    case 84:
                        message.allowedOps[i] = 84;
                        break;
                    case "PinOpDeletePin":
                    case 54:
                        message.allowedOps[i] = 54;
                        break;
                    case "PinOpListPins":
                    case 91:
                        message.allowedOps[i] = 91;
                        break;
                    }
            }
            if (object.allowedObjects) {
                if (!Array.isArray(object.allowedObjects))
                    throw TypeError(".request.UpdatePinOps.allowedObjects: array expected");
                message.allowedObjects = [];
                for (let i = 0; i < object.allowedObjects.length; ++i)
                    if (typeof object.allowedObjects[i] === "string")
                        $util.base64.decode(object.allowedObjects[i], message.allowedObjects[i] = $util.newBuffer($util.base64.length(object.allowedObjects[i])), 0);
                    else if (object.allowedObjects[i].length >= 0)
                        message.allowedObjects[i] = object.allowedObjects[i];
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdatePinOps message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.UpdatePinOps
         * @static
         * @param {request.UpdatePinOps} message UpdatePinOps
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdatePinOps.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.allowedOps = [];
                object.allowedObjects = [];
            }
            if (options.defaults) {
                object.email = "";
                object.pinName = "";
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
            }
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.pinName != null && message.hasOwnProperty("pinName"))
                object.pinName = message.pinName;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            if (message.allowedOps && message.allowedOps.length) {
                object.allowedOps = [];
                for (let j = 0; j < message.allowedOps.length; ++j)
                    object.allowedOps[j] = options.enums === String ? $root.request.AllowedPinOp[message.allowedOps[j]] === undefined ? message.allowedOps[j] : $root.request.AllowedPinOp[message.allowedOps[j]] : message.allowedOps[j];
            }
            if (message.allowedObjects && message.allowedObjects.length) {
                object.allowedObjects = [];
                for (let j = 0; j < message.allowedObjects.length; ++j)
                    object.allowedObjects[j] = options.bytes === String ? $util.base64.encode(message.allowedObjects[j], 0, message.allowedObjects[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.allowedObjects[j]) : message.allowedObjects[j];
            }
            return object;
        };

        /**
         * Converts this UpdatePinOps to JSON.
         * @function toJSON
         * @memberof request.UpdatePinOps
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdatePinOps.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for UpdatePinOps
         * @function getTypeUrl
         * @memberof request.UpdatePinOps
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        UpdatePinOps.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.UpdatePinOps";
        };

        return UpdatePinOps;
    })();

    request.DeletePin = (function() {

        /**
         * Properties of a DeletePin.
         * @memberof request
         * @interface IDeletePin
         * @property {string|null} [email] DeletePin email
         * @property {Uint8Array|null} [idSentToClient] DeletePin idSentToClient
         * @property {Uint8Array|null} [data] DeletePin data
         */

        /**
         * Constructs a new DeletePin.
         * @memberof request
         * @classdesc Represents a DeletePin.
         * @implements IDeletePin
         * @constructor
         * @param {request.IDeletePin=} [properties] Properties to set
         */
        function DeletePin(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DeletePin email.
         * @member {string} email
         * @memberof request.DeletePin
         * @instance
         */
        DeletePin.prototype.email = "";

        /**
         * DeletePin idSentToClient.
         * @member {Uint8Array} idSentToClient
         * @memberof request.DeletePin
         * @instance
         */
        DeletePin.prototype.idSentToClient = $util.newBuffer([]);

        /**
         * DeletePin data.
         * @member {Uint8Array} data
         * @memberof request.DeletePin
         * @instance
         */
        DeletePin.prototype.data = $util.newBuffer([]);

        /**
         * Creates a new DeletePin instance using the specified properties.
         * @function create
         * @memberof request.DeletePin
         * @static
         * @param {request.IDeletePin=} [properties] Properties to set
         * @returns {request.DeletePin} DeletePin instance
         */
        DeletePin.create = function create(properties) {
            return new DeletePin(properties);
        };

        /**
         * Encodes the specified DeletePin message. Does not implicitly {@link request.DeletePin.verify|verify} messages.
         * @function encode
         * @memberof request.DeletePin
         * @static
         * @param {request.IDeletePin} message DeletePin message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DeletePin.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
            if (message.idSentToClient != null && Object.hasOwnProperty.call(message, "idSentToClient"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.idSentToClient);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.data);
            return writer;
        };

        /**
         * Encodes the specified DeletePin message, length delimited. Does not implicitly {@link request.DeletePin.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.DeletePin
         * @static
         * @param {request.IDeletePin} message DeletePin message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DeletePin.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a DeletePin message from the specified reader or buffer.
         * @function decode
         * @memberof request.DeletePin
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.DeletePin} DeletePin
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DeletePin.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.DeletePin();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.email = reader.string();
                        break;
                    }
                case 2: {
                        message.idSentToClient = reader.bytes();
                        break;
                    }
                case 3: {
                        message.data = reader.bytes();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a DeletePin message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.DeletePin
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.DeletePin} DeletePin
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DeletePin.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a DeletePin message.
         * @function verify
         * @memberof request.DeletePin
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        DeletePin.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            if (message.idSentToClient != null && message.hasOwnProperty("idSentToClient"))
                if (!(message.idSentToClient && typeof message.idSentToClient.length === "number" || $util.isString(message.idSentToClient)))
                    return "idSentToClient: buffer expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            return null;
        };

        /**
         * Creates a DeletePin message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.DeletePin
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.DeletePin} DeletePin
         */
        DeletePin.fromObject = function fromObject(object) {
            if (object instanceof $root.request.DeletePin)
                return object;
            let message = new $root.request.DeletePin();
            if (object.email != null)
                message.email = String(object.email);
            if (object.idSentToClient != null)
                if (typeof object.idSentToClient === "string")
                    $util.base64.decode(object.idSentToClient, message.idSentToClient = $util.newBuffer($util.base64.length(object.idSentToClient)), 0);
                else if (object.idSentToClient.length >= 0)
                    message.idSentToClient = object.idSentToClient;
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            return message;
        };

        /**
         * Creates a plain object from a DeletePin message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.DeletePin
         * @static
         * @param {request.DeletePin} message DeletePin
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DeletePin.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.email = "";
                if (options.bytes === String)
                    object.idSentToClient = "";
                else {
                    object.idSentToClient = [];
                    if (options.bytes !== Array)
                        object.idSentToClient = $util.newBuffer(object.idSentToClient);
                }
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
            }
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.idSentToClient != null && message.hasOwnProperty("idSentToClient"))
                object.idSentToClient = options.bytes === String ? $util.base64.encode(message.idSentToClient, 0, message.idSentToClient.length) : options.bytes === Array ? Array.prototype.slice.call(message.idSentToClient) : message.idSentToClient;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            return object;
        };

        /**
         * Converts this DeletePin to JSON.
         * @function toJSON
         * @memberof request.DeletePin
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DeletePin.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for DeletePin
         * @function getTypeUrl
         * @memberof request.DeletePin
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        DeletePin.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.DeletePin";
        };

        return DeletePin;
    })();

    request.VerifyUser = (function() {

        /**
         * Properties of a VerifyUser.
         * @memberof request
         * @interface IVerifyUser
         * @property {string|null} [email] VerifyUser email
         * @property {string|null} [totp] VerifyUser totp
         * @property {string|null} [emailOtp] VerifyUser emailOtp
         * @property {Array.<request.IQueAndAns>|null} [queAndAns] VerifyUser queAndAns
         */

        /**
         * Constructs a new VerifyUser.
         * @memberof request
         * @classdesc Represents a VerifyUser.
         * @implements IVerifyUser
         * @constructor
         * @param {request.IVerifyUser=} [properties] Properties to set
         */
        function VerifyUser(properties) {
            this.queAndAns = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * VerifyUser email.
         * @member {string} email
         * @memberof request.VerifyUser
         * @instance
         */
        VerifyUser.prototype.email = "";

        /**
         * VerifyUser totp.
         * @member {string} totp
         * @memberof request.VerifyUser
         * @instance
         */
        VerifyUser.prototype.totp = "";

        /**
         * VerifyUser emailOtp.
         * @member {string} emailOtp
         * @memberof request.VerifyUser
         * @instance
         */
        VerifyUser.prototype.emailOtp = "";

        /**
         * VerifyUser queAndAns.
         * @member {Array.<request.IQueAndAns>} queAndAns
         * @memberof request.VerifyUser
         * @instance
         */
        VerifyUser.prototype.queAndAns = $util.emptyArray;

        /**
         * Creates a new VerifyUser instance using the specified properties.
         * @function create
         * @memberof request.VerifyUser
         * @static
         * @param {request.IVerifyUser=} [properties] Properties to set
         * @returns {request.VerifyUser} VerifyUser instance
         */
        VerifyUser.create = function create(properties) {
            return new VerifyUser(properties);
        };

        /**
         * Encodes the specified VerifyUser message. Does not implicitly {@link request.VerifyUser.verify|verify} messages.
         * @function encode
         * @memberof request.VerifyUser
         * @static
         * @param {request.IVerifyUser} message VerifyUser message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        VerifyUser.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
            if (message.totp != null && Object.hasOwnProperty.call(message, "totp"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.totp);
            if (message.emailOtp != null && Object.hasOwnProperty.call(message, "emailOtp"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.emailOtp);
            if (message.queAndAns != null && message.queAndAns.length)
                for (let i = 0; i < message.queAndAns.length; ++i)
                    $root.request.QueAndAns.encode(message.queAndAns[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified VerifyUser message, length delimited. Does not implicitly {@link request.VerifyUser.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.VerifyUser
         * @static
         * @param {request.IVerifyUser} message VerifyUser message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        VerifyUser.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a VerifyUser message from the specified reader or buffer.
         * @function decode
         * @memberof request.VerifyUser
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.VerifyUser} VerifyUser
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        VerifyUser.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.VerifyUser();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.email = reader.string();
                        break;
                    }
                case 2: {
                        message.totp = reader.string();
                        break;
                    }
                case 3: {
                        message.emailOtp = reader.string();
                        break;
                    }
                case 4: {
                        if (!(message.queAndAns && message.queAndAns.length))
                            message.queAndAns = [];
                        message.queAndAns.push($root.request.QueAndAns.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a VerifyUser message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.VerifyUser
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.VerifyUser} VerifyUser
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        VerifyUser.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a VerifyUser message.
         * @function verify
         * @memberof request.VerifyUser
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        VerifyUser.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            if (message.totp != null && message.hasOwnProperty("totp"))
                if (!$util.isString(message.totp))
                    return "totp: string expected";
            if (message.emailOtp != null && message.hasOwnProperty("emailOtp"))
                if (!$util.isString(message.emailOtp))
                    return "emailOtp: string expected";
            if (message.queAndAns != null && message.hasOwnProperty("queAndAns")) {
                if (!Array.isArray(message.queAndAns))
                    return "queAndAns: array expected";
                for (let i = 0; i < message.queAndAns.length; ++i) {
                    let error = $root.request.QueAndAns.verify(message.queAndAns[i]);
                    if (error)
                        return "queAndAns." + error;
                }
            }
            return null;
        };

        /**
         * Creates a VerifyUser message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.VerifyUser
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.VerifyUser} VerifyUser
         */
        VerifyUser.fromObject = function fromObject(object) {
            if (object instanceof $root.request.VerifyUser)
                return object;
            let message = new $root.request.VerifyUser();
            if (object.email != null)
                message.email = String(object.email);
            if (object.totp != null)
                message.totp = String(object.totp);
            if (object.emailOtp != null)
                message.emailOtp = String(object.emailOtp);
            if (object.queAndAns) {
                if (!Array.isArray(object.queAndAns))
                    throw TypeError(".request.VerifyUser.queAndAns: array expected");
                message.queAndAns = [];
                for (let i = 0; i < object.queAndAns.length; ++i) {
                    if (typeof object.queAndAns[i] !== "object")
                        throw TypeError(".request.VerifyUser.queAndAns: object expected");
                    message.queAndAns[i] = $root.request.QueAndAns.fromObject(object.queAndAns[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a VerifyUser message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.VerifyUser
         * @static
         * @param {request.VerifyUser} message VerifyUser
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        VerifyUser.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.queAndAns = [];
            if (options.defaults) {
                object.email = "";
                object.totp = "";
                object.emailOtp = "";
            }
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.totp != null && message.hasOwnProperty("totp"))
                object.totp = message.totp;
            if (message.emailOtp != null && message.hasOwnProperty("emailOtp"))
                object.emailOtp = message.emailOtp;
            if (message.queAndAns && message.queAndAns.length) {
                object.queAndAns = [];
                for (let j = 0; j < message.queAndAns.length; ++j)
                    object.queAndAns[j] = $root.request.QueAndAns.toObject(message.queAndAns[j], options);
            }
            return object;
        };

        /**
         * Converts this VerifyUser to JSON.
         * @function toJSON
         * @memberof request.VerifyUser
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        VerifyUser.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for VerifyUser
         * @function getTypeUrl
         * @memberof request.VerifyUser
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        VerifyUser.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.VerifyUser";
        };

        return VerifyUser;
    })();

    request.RemoveUser = (function() {

        /**
         * Properties of a RemoveUser.
         * @memberof request
         * @interface IRemoveUser
         * @property {string|null} [email] RemoveUser email
         * @property {string|null} [organization] RemoveUser organization
         * @property {string|null} [password] RemoveUser password
         */

        /**
         * Constructs a new RemoveUser.
         * @memberof request
         * @classdesc Represents a RemoveUser.
         * @implements IRemoveUser
         * @constructor
         * @param {request.IRemoveUser=} [properties] Properties to set
         */
        function RemoveUser(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveUser email.
         * @member {string} email
         * @memberof request.RemoveUser
         * @instance
         */
        RemoveUser.prototype.email = "";

        /**
         * RemoveUser organization.
         * @member {string|null|undefined} organization
         * @memberof request.RemoveUser
         * @instance
         */
        RemoveUser.prototype.organization = null;

        /**
         * RemoveUser password.
         * @member {string} password
         * @memberof request.RemoveUser
         * @instance
         */
        RemoveUser.prototype.password = "";

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(RemoveUser.prototype, "_organization", {
            get: $util.oneOfGetter($oneOfFields = ["organization"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new RemoveUser instance using the specified properties.
         * @function create
         * @memberof request.RemoveUser
         * @static
         * @param {request.IRemoveUser=} [properties] Properties to set
         * @returns {request.RemoveUser} RemoveUser instance
         */
        RemoveUser.create = function create(properties) {
            return new RemoveUser(properties);
        };

        /**
         * Encodes the specified RemoveUser message. Does not implicitly {@link request.RemoveUser.verify|verify} messages.
         * @function encode
         * @memberof request.RemoveUser
         * @static
         * @param {request.IRemoveUser} message RemoveUser message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RemoveUser.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
            if (message.password != null && Object.hasOwnProperty.call(message, "password"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.password);
            if (message.organization != null && Object.hasOwnProperty.call(message, "organization"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.organization);
            return writer;
        };

        /**
         * Encodes the specified RemoveUser message, length delimited. Does not implicitly {@link request.RemoveUser.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.RemoveUser
         * @static
         * @param {request.IRemoveUser} message RemoveUser message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RemoveUser.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RemoveUser message from the specified reader or buffer.
         * @function decode
         * @memberof request.RemoveUser
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.RemoveUser} RemoveUser
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RemoveUser.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.RemoveUser();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.email = reader.string();
                        break;
                    }
                case 5: {
                        message.organization = reader.string();
                        break;
                    }
                case 2: {
                        message.password = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RemoveUser message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.RemoveUser
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.RemoveUser} RemoveUser
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RemoveUser.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RemoveUser message.
         * @function verify
         * @memberof request.RemoveUser
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RemoveUser.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            if (message.organization != null && message.hasOwnProperty("organization")) {
                properties._organization = 1;
                if (!$util.isString(message.organization))
                    return "organization: string expected";
            }
            if (message.password != null && message.hasOwnProperty("password"))
                if (!$util.isString(message.password))
                    return "password: string expected";
            return null;
        };

        /**
         * Creates a RemoveUser message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.RemoveUser
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.RemoveUser} RemoveUser
         */
        RemoveUser.fromObject = function fromObject(object) {
            if (object instanceof $root.request.RemoveUser)
                return object;
            let message = new $root.request.RemoveUser();
            if (object.email != null)
                message.email = String(object.email);
            if (object.organization != null)
                message.organization = String(object.organization);
            if (object.password != null)
                message.password = String(object.password);
            return message;
        };

        /**
         * Creates a plain object from a RemoveUser message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.RemoveUser
         * @static
         * @param {request.RemoveUser} message RemoveUser
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveUser.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.email = "";
                object.password = "";
            }
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.password != null && message.hasOwnProperty("password"))
                object.password = message.password;
            if (message.organization != null && message.hasOwnProperty("organization")) {
                object.organization = message.organization;
                if (options.oneofs)
                    object._organization = "organization";
            }
            return object;
        };

        /**
         * Converts this RemoveUser to JSON.
         * @function toJSON
         * @memberof request.RemoveUser
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveUser.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for RemoveUser
         * @function getTypeUrl
         * @memberof request.RemoveUser
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        RemoveUser.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.RemoveUser";
        };

        return RemoveUser;
    })();

    request.PasswordReset = (function() {

        /**
         * Properties of a PasswordReset.
         * @memberof request
         * @interface IPasswordReset
         * @property {string|null} [email] PasswordReset email
         * @property {string|null} [organization] PasswordReset organization
         * @property {string|null} [totp] PasswordReset totp
         * @property {string|null} [ouEmail] PasswordReset ouEmail
         */

        /**
         * Constructs a new PasswordReset.
         * @memberof request
         * @classdesc Represents a PasswordReset.
         * @implements IPasswordReset
         * @constructor
         * @param {request.IPasswordReset=} [properties] Properties to set
         */
        function PasswordReset(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PasswordReset email.
         * @member {string} email
         * @memberof request.PasswordReset
         * @instance
         */
        PasswordReset.prototype.email = "";

        /**
         * PasswordReset organization.
         * @member {string|null|undefined} organization
         * @memberof request.PasswordReset
         * @instance
         */
        PasswordReset.prototype.organization = null;

        /**
         * PasswordReset totp.
         * @member {string} totp
         * @memberof request.PasswordReset
         * @instance
         */
        PasswordReset.prototype.totp = "";

        /**
         * PasswordReset ouEmail.
         * @member {string|null|undefined} ouEmail
         * @memberof request.PasswordReset
         * @instance
         */
        PasswordReset.prototype.ouEmail = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(PasswordReset.prototype, "_organization", {
            get: $util.oneOfGetter($oneOfFields = ["organization"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(PasswordReset.prototype, "_ouEmail", {
            get: $util.oneOfGetter($oneOfFields = ["ouEmail"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new PasswordReset instance using the specified properties.
         * @function create
         * @memberof request.PasswordReset
         * @static
         * @param {request.IPasswordReset=} [properties] Properties to set
         * @returns {request.PasswordReset} PasswordReset instance
         */
        PasswordReset.create = function create(properties) {
            return new PasswordReset(properties);
        };

        /**
         * Encodes the specified PasswordReset message. Does not implicitly {@link request.PasswordReset.verify|verify} messages.
         * @function encode
         * @memberof request.PasswordReset
         * @static
         * @param {request.IPasswordReset} message PasswordReset message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PasswordReset.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
            if (message.totp != null && Object.hasOwnProperty.call(message, "totp"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.totp);
            if (message.organization != null && Object.hasOwnProperty.call(message, "organization"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.organization);
            if (message.ouEmail != null && Object.hasOwnProperty.call(message, "ouEmail"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.ouEmail);
            return writer;
        };

        /**
         * Encodes the specified PasswordReset message, length delimited. Does not implicitly {@link request.PasswordReset.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.PasswordReset
         * @static
         * @param {request.IPasswordReset} message PasswordReset message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PasswordReset.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PasswordReset message from the specified reader or buffer.
         * @function decode
         * @memberof request.PasswordReset
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.PasswordReset} PasswordReset
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PasswordReset.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.PasswordReset();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.email = reader.string();
                        break;
                    }
                case 5: {
                        message.organization = reader.string();
                        break;
                    }
                case 2: {
                        message.totp = reader.string();
                        break;
                    }
                case 7: {
                        message.ouEmail = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PasswordReset message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.PasswordReset
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.PasswordReset} PasswordReset
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PasswordReset.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PasswordReset message.
         * @function verify
         * @memberof request.PasswordReset
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PasswordReset.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            if (message.organization != null && message.hasOwnProperty("organization")) {
                properties._organization = 1;
                if (!$util.isString(message.organization))
                    return "organization: string expected";
            }
            if (message.totp != null && message.hasOwnProperty("totp"))
                if (!$util.isString(message.totp))
                    return "totp: string expected";
            if (message.ouEmail != null && message.hasOwnProperty("ouEmail")) {
                properties._ouEmail = 1;
                if (!$util.isString(message.ouEmail))
                    return "ouEmail: string expected";
            }
            return null;
        };

        /**
         * Creates a PasswordReset message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.PasswordReset
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.PasswordReset} PasswordReset
         */
        PasswordReset.fromObject = function fromObject(object) {
            if (object instanceof $root.request.PasswordReset)
                return object;
            let message = new $root.request.PasswordReset();
            if (object.email != null)
                message.email = String(object.email);
            if (object.organization != null)
                message.organization = String(object.organization);
            if (object.totp != null)
                message.totp = String(object.totp);
            if (object.ouEmail != null)
                message.ouEmail = String(object.ouEmail);
            return message;
        };

        /**
         * Creates a plain object from a PasswordReset message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.PasswordReset
         * @static
         * @param {request.PasswordReset} message PasswordReset
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PasswordReset.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.email = "";
                object.totp = "";
            }
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.totp != null && message.hasOwnProperty("totp"))
                object.totp = message.totp;
            if (message.organization != null && message.hasOwnProperty("organization")) {
                object.organization = message.organization;
                if (options.oneofs)
                    object._organization = "organization";
            }
            if (message.ouEmail != null && message.hasOwnProperty("ouEmail")) {
                object.ouEmail = message.ouEmail;
                if (options.oneofs)
                    object._ouEmail = "ouEmail";
            }
            return object;
        };

        /**
         * Converts this PasswordReset to JSON.
         * @function toJSON
         * @memberof request.PasswordReset
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PasswordReset.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for PasswordReset
         * @function getTypeUrl
         * @memberof request.PasswordReset
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        PasswordReset.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.PasswordReset";
        };

        return PasswordReset;
    })();

    request.ChangePassword = (function() {

        /**
         * Properties of a ChangePassword.
         * @memberof request
         * @interface IChangePassword
         * @property {string|null} [email] ChangePassword email
         * @property {string|null} [oldPassword] ChangePassword oldPassword
         * @property {string|null} [newPassword] ChangePassword newPassword
         * @property {string|null} [totp] ChangePassword totp
         * @property {Uint8Array|null} [token] ChangePassword token
         * @property {request.IQueAndAns|null} [queAndAns] ChangePassword queAndAns
         */

        /**
         * Constructs a new ChangePassword.
         * @memberof request
         * @classdesc Represents a ChangePassword.
         * @implements IChangePassword
         * @constructor
         * @param {request.IChangePassword=} [properties] Properties to set
         */
        function ChangePassword(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ChangePassword email.
         * @member {string} email
         * @memberof request.ChangePassword
         * @instance
         */
        ChangePassword.prototype.email = "";

        /**
         * ChangePassword oldPassword.
         * @member {string|null|undefined} oldPassword
         * @memberof request.ChangePassword
         * @instance
         */
        ChangePassword.prototype.oldPassword = null;

        /**
         * ChangePassword newPassword.
         * @member {string} newPassword
         * @memberof request.ChangePassword
         * @instance
         */
        ChangePassword.prototype.newPassword = "";

        /**
         * ChangePassword totp.
         * @member {string|null|undefined} totp
         * @memberof request.ChangePassword
         * @instance
         */
        ChangePassword.prototype.totp = null;

        /**
         * ChangePassword token.
         * @member {Uint8Array|null|undefined} token
         * @memberof request.ChangePassword
         * @instance
         */
        ChangePassword.prototype.token = null;

        /**
         * ChangePassword queAndAns.
         * @member {request.IQueAndAns|null|undefined} queAndAns
         * @memberof request.ChangePassword
         * @instance
         */
        ChangePassword.prototype.queAndAns = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(ChangePassword.prototype, "_oldPassword", {
            get: $util.oneOfGetter($oneOfFields = ["oldPassword"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(ChangePassword.prototype, "_totp", {
            get: $util.oneOfGetter($oneOfFields = ["totp"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(ChangePassword.prototype, "_token", {
            get: $util.oneOfGetter($oneOfFields = ["token"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(ChangePassword.prototype, "_queAndAns", {
            get: $util.oneOfGetter($oneOfFields = ["queAndAns"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new ChangePassword instance using the specified properties.
         * @function create
         * @memberof request.ChangePassword
         * @static
         * @param {request.IChangePassword=} [properties] Properties to set
         * @returns {request.ChangePassword} ChangePassword instance
         */
        ChangePassword.create = function create(properties) {
            return new ChangePassword(properties);
        };

        /**
         * Encodes the specified ChangePassword message. Does not implicitly {@link request.ChangePassword.verify|verify} messages.
         * @function encode
         * @memberof request.ChangePassword
         * @static
         * @param {request.IChangePassword} message ChangePassword message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ChangePassword.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
            if (message.oldPassword != null && Object.hasOwnProperty.call(message, "oldPassword"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.oldPassword);
            if (message.newPassword != null && Object.hasOwnProperty.call(message, "newPassword"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.newPassword);
            if (message.totp != null && Object.hasOwnProperty.call(message, "totp"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.totp);
            if (message.token != null && Object.hasOwnProperty.call(message, "token"))
                writer.uint32(/* id 5, wireType 2 =*/42).bytes(message.token);
            if (message.queAndAns != null && Object.hasOwnProperty.call(message, "queAndAns"))
                $root.request.QueAndAns.encode(message.queAndAns, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified ChangePassword message, length delimited. Does not implicitly {@link request.ChangePassword.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.ChangePassword
         * @static
         * @param {request.IChangePassword} message ChangePassword message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ChangePassword.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ChangePassword message from the specified reader or buffer.
         * @function decode
         * @memberof request.ChangePassword
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.ChangePassword} ChangePassword
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ChangePassword.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.ChangePassword();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.email = reader.string();
                        break;
                    }
                case 2: {
                        message.oldPassword = reader.string();
                        break;
                    }
                case 3: {
                        message.newPassword = reader.string();
                        break;
                    }
                case 4: {
                        message.totp = reader.string();
                        break;
                    }
                case 5: {
                        message.token = reader.bytes();
                        break;
                    }
                case 6: {
                        message.queAndAns = $root.request.QueAndAns.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ChangePassword message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.ChangePassword
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.ChangePassword} ChangePassword
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ChangePassword.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ChangePassword message.
         * @function verify
         * @memberof request.ChangePassword
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ChangePassword.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            if (message.oldPassword != null && message.hasOwnProperty("oldPassword")) {
                properties._oldPassword = 1;
                if (!$util.isString(message.oldPassword))
                    return "oldPassword: string expected";
            }
            if (message.newPassword != null && message.hasOwnProperty("newPassword"))
                if (!$util.isString(message.newPassword))
                    return "newPassword: string expected";
            if (message.totp != null && message.hasOwnProperty("totp")) {
                properties._totp = 1;
                if (!$util.isString(message.totp))
                    return "totp: string expected";
            }
            if (message.token != null && message.hasOwnProperty("token")) {
                properties._token = 1;
                if (!(message.token && typeof message.token.length === "number" || $util.isString(message.token)))
                    return "token: buffer expected";
            }
            if (message.queAndAns != null && message.hasOwnProperty("queAndAns")) {
                properties._queAndAns = 1;
                {
                    let error = $root.request.QueAndAns.verify(message.queAndAns);
                    if (error)
                        return "queAndAns." + error;
                }
            }
            return null;
        };

        /**
         * Creates a ChangePassword message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.ChangePassword
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.ChangePassword} ChangePassword
         */
        ChangePassword.fromObject = function fromObject(object) {
            if (object instanceof $root.request.ChangePassword)
                return object;
            let message = new $root.request.ChangePassword();
            if (object.email != null)
                message.email = String(object.email);
            if (object.oldPassword != null)
                message.oldPassword = String(object.oldPassword);
            if (object.newPassword != null)
                message.newPassword = String(object.newPassword);
            if (object.totp != null)
                message.totp = String(object.totp);
            if (object.token != null)
                if (typeof object.token === "string")
                    $util.base64.decode(object.token, message.token = $util.newBuffer($util.base64.length(object.token)), 0);
                else if (object.token.length >= 0)
                    message.token = object.token;
            if (object.queAndAns != null) {
                if (typeof object.queAndAns !== "object")
                    throw TypeError(".request.ChangePassword.queAndAns: object expected");
                message.queAndAns = $root.request.QueAndAns.fromObject(object.queAndAns);
            }
            return message;
        };

        /**
         * Creates a plain object from a ChangePassword message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.ChangePassword
         * @static
         * @param {request.ChangePassword} message ChangePassword
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ChangePassword.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.email = "";
                object.newPassword = "";
            }
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.oldPassword != null && message.hasOwnProperty("oldPassword")) {
                object.oldPassword = message.oldPassword;
                if (options.oneofs)
                    object._oldPassword = "oldPassword";
            }
            if (message.newPassword != null && message.hasOwnProperty("newPassword"))
                object.newPassword = message.newPassword;
            if (message.totp != null && message.hasOwnProperty("totp")) {
                object.totp = message.totp;
                if (options.oneofs)
                    object._totp = "totp";
            }
            if (message.token != null && message.hasOwnProperty("token")) {
                object.token = options.bytes === String ? $util.base64.encode(message.token, 0, message.token.length) : options.bytes === Array ? Array.prototype.slice.call(message.token) : message.token;
                if (options.oneofs)
                    object._token = "token";
            }
            if (message.queAndAns != null && message.hasOwnProperty("queAndAns")) {
                object.queAndAns = $root.request.QueAndAns.toObject(message.queAndAns, options);
                if (options.oneofs)
                    object._queAndAns = "queAndAns";
            }
            return object;
        };

        /**
         * Converts this ChangePassword to JSON.
         * @function toJSON
         * @memberof request.ChangePassword
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ChangePassword.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ChangePassword
         * @function getTypeUrl
         * @memberof request.ChangePassword
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ChangePassword.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.ChangePassword";
        };

        return ChangePassword;
    })();

    request.AddOrganization = (function() {

        /**
         * Properties of an AddOrganization.
         * @memberof request
         * @interface IAddOrganization
         * @property {string|null} [email] AddOrganization email
         * @property {string|null} [organization] AddOrganization organization
         * @property {string|null} [password] AddOrganization password
         * @property {number|null} [plan] AddOrganization plan
         */

        /**
         * Constructs a new AddOrganization.
         * @memberof request
         * @classdesc Represents an AddOrganization.
         * @implements IAddOrganization
         * @constructor
         * @param {request.IAddOrganization=} [properties] Properties to set
         */
        function AddOrganization(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddOrganization email.
         * @member {string} email
         * @memberof request.AddOrganization
         * @instance
         */
        AddOrganization.prototype.email = "";

        /**
         * AddOrganization organization.
         * @member {string} organization
         * @memberof request.AddOrganization
         * @instance
         */
        AddOrganization.prototype.organization = "";

        /**
         * AddOrganization password.
         * @member {string} password
         * @memberof request.AddOrganization
         * @instance
         */
        AddOrganization.prototype.password = "";

        /**
         * AddOrganization plan.
         * @member {number} plan
         * @memberof request.AddOrganization
         * @instance
         */
        AddOrganization.prototype.plan = 0;

        /**
         * Creates a new AddOrganization instance using the specified properties.
         * @function create
         * @memberof request.AddOrganization
         * @static
         * @param {request.IAddOrganization=} [properties] Properties to set
         * @returns {request.AddOrganization} AddOrganization instance
         */
        AddOrganization.create = function create(properties) {
            return new AddOrganization(properties);
        };

        /**
         * Encodes the specified AddOrganization message. Does not implicitly {@link request.AddOrganization.verify|verify} messages.
         * @function encode
         * @memberof request.AddOrganization
         * @static
         * @param {request.IAddOrganization} message AddOrganization message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddOrganization.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
            if (message.organization != null && Object.hasOwnProperty.call(message, "organization"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.organization);
            if (message.password != null && Object.hasOwnProperty.call(message, "password"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.password);
            if (message.plan != null && Object.hasOwnProperty.call(message, "plan"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.plan);
            return writer;
        };

        /**
         * Encodes the specified AddOrganization message, length delimited. Does not implicitly {@link request.AddOrganization.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.AddOrganization
         * @static
         * @param {request.IAddOrganization} message AddOrganization message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddOrganization.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AddOrganization message from the specified reader or buffer.
         * @function decode
         * @memberof request.AddOrganization
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.AddOrganization} AddOrganization
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddOrganization.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.AddOrganization();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.email = reader.string();
                        break;
                    }
                case 2: {
                        message.organization = reader.string();
                        break;
                    }
                case 3: {
                        message.password = reader.string();
                        break;
                    }
                case 4: {
                        message.plan = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AddOrganization message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.AddOrganization
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.AddOrganization} AddOrganization
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddOrganization.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AddOrganization message.
         * @function verify
         * @memberof request.AddOrganization
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AddOrganization.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            if (message.organization != null && message.hasOwnProperty("organization"))
                if (!$util.isString(message.organization))
                    return "organization: string expected";
            if (message.password != null && message.hasOwnProperty("password"))
                if (!$util.isString(message.password))
                    return "password: string expected";
            if (message.plan != null && message.hasOwnProperty("plan"))
                if (!$util.isInteger(message.plan))
                    return "plan: integer expected";
            return null;
        };

        /**
         * Creates an AddOrganization message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.AddOrganization
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.AddOrganization} AddOrganization
         */
        AddOrganization.fromObject = function fromObject(object) {
            if (object instanceof $root.request.AddOrganization)
                return object;
            let message = new $root.request.AddOrganization();
            if (object.email != null)
                message.email = String(object.email);
            if (object.organization != null)
                message.organization = String(object.organization);
            if (object.password != null)
                message.password = String(object.password);
            if (object.plan != null)
                message.plan = object.plan | 0;
            return message;
        };

        /**
         * Creates a plain object from an AddOrganization message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.AddOrganization
         * @static
         * @param {request.AddOrganization} message AddOrganization
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddOrganization.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.email = "";
                object.organization = "";
                object.password = "";
                object.plan = 0;
            }
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.organization != null && message.hasOwnProperty("organization"))
                object.organization = message.organization;
            if (message.password != null && message.hasOwnProperty("password"))
                object.password = message.password;
            if (message.plan != null && message.hasOwnProperty("plan"))
                object.plan = message.plan;
            return object;
        };

        /**
         * Converts this AddOrganization to JSON.
         * @function toJSON
         * @memberof request.AddOrganization
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddOrganization.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for AddOrganization
         * @function getTypeUrl
         * @memberof request.AddOrganization
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        AddOrganization.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.AddOrganization";
        };

        return AddOrganization;
    })();

    request.VerifyOrganization = (function() {

        /**
         * Properties of a VerifyOrganization.
         * @memberof request
         * @interface IVerifyOrganization
         * @property {string|null} [email] VerifyOrganization email
         * @property {string|null} [organization] VerifyOrganization organization
         * @property {string|null} [totp] VerifyOrganization totp
         * @property {string|null} [emailOtp] VerifyOrganization emailOtp
         * @property {Array.<request.IQueAndAns>|null} [queAndAns] VerifyOrganization queAndAns
         */

        /**
         * Constructs a new VerifyOrganization.
         * @memberof request
         * @classdesc Represents a VerifyOrganization.
         * @implements IVerifyOrganization
         * @constructor
         * @param {request.IVerifyOrganization=} [properties] Properties to set
         */
        function VerifyOrganization(properties) {
            this.queAndAns = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * VerifyOrganization email.
         * @member {string} email
         * @memberof request.VerifyOrganization
         * @instance
         */
        VerifyOrganization.prototype.email = "";

        /**
         * VerifyOrganization organization.
         * @member {string} organization
         * @memberof request.VerifyOrganization
         * @instance
         */
        VerifyOrganization.prototype.organization = "";

        /**
         * VerifyOrganization totp.
         * @member {string} totp
         * @memberof request.VerifyOrganization
         * @instance
         */
        VerifyOrganization.prototype.totp = "";

        /**
         * VerifyOrganization emailOtp.
         * @member {string} emailOtp
         * @memberof request.VerifyOrganization
         * @instance
         */
        VerifyOrganization.prototype.emailOtp = "";

        /**
         * VerifyOrganization queAndAns.
         * @member {Array.<request.IQueAndAns>} queAndAns
         * @memberof request.VerifyOrganization
         * @instance
         */
        VerifyOrganization.prototype.queAndAns = $util.emptyArray;

        /**
         * Creates a new VerifyOrganization instance using the specified properties.
         * @function create
         * @memberof request.VerifyOrganization
         * @static
         * @param {request.IVerifyOrganization=} [properties] Properties to set
         * @returns {request.VerifyOrganization} VerifyOrganization instance
         */
        VerifyOrganization.create = function create(properties) {
            return new VerifyOrganization(properties);
        };

        /**
         * Encodes the specified VerifyOrganization message. Does not implicitly {@link request.VerifyOrganization.verify|verify} messages.
         * @function encode
         * @memberof request.VerifyOrganization
         * @static
         * @param {request.IVerifyOrganization} message VerifyOrganization message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        VerifyOrganization.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
            if (message.organization != null && Object.hasOwnProperty.call(message, "organization"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.organization);
            if (message.totp != null && Object.hasOwnProperty.call(message, "totp"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.totp);
            if (message.emailOtp != null && Object.hasOwnProperty.call(message, "emailOtp"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.emailOtp);
            if (message.queAndAns != null && message.queAndAns.length)
                for (let i = 0; i < message.queAndAns.length; ++i)
                    $root.request.QueAndAns.encode(message.queAndAns[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified VerifyOrganization message, length delimited. Does not implicitly {@link request.VerifyOrganization.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.VerifyOrganization
         * @static
         * @param {request.IVerifyOrganization} message VerifyOrganization message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        VerifyOrganization.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a VerifyOrganization message from the specified reader or buffer.
         * @function decode
         * @memberof request.VerifyOrganization
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.VerifyOrganization} VerifyOrganization
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        VerifyOrganization.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.VerifyOrganization();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.email = reader.string();
                        break;
                    }
                case 2: {
                        message.organization = reader.string();
                        break;
                    }
                case 3: {
                        message.totp = reader.string();
                        break;
                    }
                case 4: {
                        message.emailOtp = reader.string();
                        break;
                    }
                case 5: {
                        if (!(message.queAndAns && message.queAndAns.length))
                            message.queAndAns = [];
                        message.queAndAns.push($root.request.QueAndAns.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a VerifyOrganization message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.VerifyOrganization
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.VerifyOrganization} VerifyOrganization
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        VerifyOrganization.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a VerifyOrganization message.
         * @function verify
         * @memberof request.VerifyOrganization
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        VerifyOrganization.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            if (message.organization != null && message.hasOwnProperty("organization"))
                if (!$util.isString(message.organization))
                    return "organization: string expected";
            if (message.totp != null && message.hasOwnProperty("totp"))
                if (!$util.isString(message.totp))
                    return "totp: string expected";
            if (message.emailOtp != null && message.hasOwnProperty("emailOtp"))
                if (!$util.isString(message.emailOtp))
                    return "emailOtp: string expected";
            if (message.queAndAns != null && message.hasOwnProperty("queAndAns")) {
                if (!Array.isArray(message.queAndAns))
                    return "queAndAns: array expected";
                for (let i = 0; i < message.queAndAns.length; ++i) {
                    let error = $root.request.QueAndAns.verify(message.queAndAns[i]);
                    if (error)
                        return "queAndAns." + error;
                }
            }
            return null;
        };

        /**
         * Creates a VerifyOrganization message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.VerifyOrganization
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.VerifyOrganization} VerifyOrganization
         */
        VerifyOrganization.fromObject = function fromObject(object) {
            if (object instanceof $root.request.VerifyOrganization)
                return object;
            let message = new $root.request.VerifyOrganization();
            if (object.email != null)
                message.email = String(object.email);
            if (object.organization != null)
                message.organization = String(object.organization);
            if (object.totp != null)
                message.totp = String(object.totp);
            if (object.emailOtp != null)
                message.emailOtp = String(object.emailOtp);
            if (object.queAndAns) {
                if (!Array.isArray(object.queAndAns))
                    throw TypeError(".request.VerifyOrganization.queAndAns: array expected");
                message.queAndAns = [];
                for (let i = 0; i < object.queAndAns.length; ++i) {
                    if (typeof object.queAndAns[i] !== "object")
                        throw TypeError(".request.VerifyOrganization.queAndAns: object expected");
                    message.queAndAns[i] = $root.request.QueAndAns.fromObject(object.queAndAns[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a VerifyOrganization message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.VerifyOrganization
         * @static
         * @param {request.VerifyOrganization} message VerifyOrganization
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        VerifyOrganization.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.queAndAns = [];
            if (options.defaults) {
                object.email = "";
                object.organization = "";
                object.totp = "";
                object.emailOtp = "";
            }
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.organization != null && message.hasOwnProperty("organization"))
                object.organization = message.organization;
            if (message.totp != null && message.hasOwnProperty("totp"))
                object.totp = message.totp;
            if (message.emailOtp != null && message.hasOwnProperty("emailOtp"))
                object.emailOtp = message.emailOtp;
            if (message.queAndAns && message.queAndAns.length) {
                object.queAndAns = [];
                for (let j = 0; j < message.queAndAns.length; ++j)
                    object.queAndAns[j] = $root.request.QueAndAns.toObject(message.queAndAns[j], options);
            }
            return object;
        };

        /**
         * Converts this VerifyOrganization to JSON.
         * @function toJSON
         * @memberof request.VerifyOrganization
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        VerifyOrganization.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for VerifyOrganization
         * @function getTypeUrl
         * @memberof request.VerifyOrganization
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        VerifyOrganization.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.VerifyOrganization";
        };

        return VerifyOrganization;
    })();

    request.RemoveOrganization = (function() {

        /**
         * Properties of a RemoveOrganization.
         * @memberof request
         * @interface IRemoveOrganization
         * @property {string|null} [email] RemoveOrganization email
         * @property {string|null} [organization] RemoveOrganization organization
         * @property {string|null} [totp] RemoveOrganization totp
         */

        /**
         * Constructs a new RemoveOrganization.
         * @memberof request
         * @classdesc Represents a RemoveOrganization.
         * @implements IRemoveOrganization
         * @constructor
         * @param {request.IRemoveOrganization=} [properties] Properties to set
         */
        function RemoveOrganization(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveOrganization email.
         * @member {string} email
         * @memberof request.RemoveOrganization
         * @instance
         */
        RemoveOrganization.prototype.email = "";

        /**
         * RemoveOrganization organization.
         * @member {string} organization
         * @memberof request.RemoveOrganization
         * @instance
         */
        RemoveOrganization.prototype.organization = "";

        /**
         * RemoveOrganization totp.
         * @member {string} totp
         * @memberof request.RemoveOrganization
         * @instance
         */
        RemoveOrganization.prototype.totp = "";

        /**
         * Creates a new RemoveOrganization instance using the specified properties.
         * @function create
         * @memberof request.RemoveOrganization
         * @static
         * @param {request.IRemoveOrganization=} [properties] Properties to set
         * @returns {request.RemoveOrganization} RemoveOrganization instance
         */
        RemoveOrganization.create = function create(properties) {
            return new RemoveOrganization(properties);
        };

        /**
         * Encodes the specified RemoveOrganization message. Does not implicitly {@link request.RemoveOrganization.verify|verify} messages.
         * @function encode
         * @memberof request.RemoveOrganization
         * @static
         * @param {request.IRemoveOrganization} message RemoveOrganization message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RemoveOrganization.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
            if (message.organization != null && Object.hasOwnProperty.call(message, "organization"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.organization);
            if (message.totp != null && Object.hasOwnProperty.call(message, "totp"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.totp);
            return writer;
        };

        /**
         * Encodes the specified RemoveOrganization message, length delimited. Does not implicitly {@link request.RemoveOrganization.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.RemoveOrganization
         * @static
         * @param {request.IRemoveOrganization} message RemoveOrganization message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RemoveOrganization.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RemoveOrganization message from the specified reader or buffer.
         * @function decode
         * @memberof request.RemoveOrganization
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.RemoveOrganization} RemoveOrganization
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RemoveOrganization.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.RemoveOrganization();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.email = reader.string();
                        break;
                    }
                case 2: {
                        message.organization = reader.string();
                        break;
                    }
                case 3: {
                        message.totp = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RemoveOrganization message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.RemoveOrganization
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.RemoveOrganization} RemoveOrganization
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RemoveOrganization.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RemoveOrganization message.
         * @function verify
         * @memberof request.RemoveOrganization
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RemoveOrganization.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            if (message.organization != null && message.hasOwnProperty("organization"))
                if (!$util.isString(message.organization))
                    return "organization: string expected";
            if (message.totp != null && message.hasOwnProperty("totp"))
                if (!$util.isString(message.totp))
                    return "totp: string expected";
            return null;
        };

        /**
         * Creates a RemoveOrganization message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.RemoveOrganization
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.RemoveOrganization} RemoveOrganization
         */
        RemoveOrganization.fromObject = function fromObject(object) {
            if (object instanceof $root.request.RemoveOrganization)
                return object;
            let message = new $root.request.RemoveOrganization();
            if (object.email != null)
                message.email = String(object.email);
            if (object.organization != null)
                message.organization = String(object.organization);
            if (object.totp != null)
                message.totp = String(object.totp);
            return message;
        };

        /**
         * Creates a plain object from a RemoveOrganization message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.RemoveOrganization
         * @static
         * @param {request.RemoveOrganization} message RemoveOrganization
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveOrganization.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.email = "";
                object.organization = "";
                object.totp = "";
            }
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.organization != null && message.hasOwnProperty("organization"))
                object.organization = message.organization;
            if (message.totp != null && message.hasOwnProperty("totp"))
                object.totp = message.totp;
            return object;
        };

        /**
         * Converts this RemoveOrganization to JSON.
         * @function toJSON
         * @memberof request.RemoveOrganization
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveOrganization.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for RemoveOrganization
         * @function getTypeUrl
         * @memberof request.RemoveOrganization
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        RemoveOrganization.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.RemoveOrganization";
        };

        return RemoveOrganization;
    })();

    request.GetOrganization = (function() {

        /**
         * Properties of a GetOrganization.
         * @memberof request
         * @interface IGetOrganization
         * @property {string|null} [email] GetOrganization email
         */

        /**
         * Constructs a new GetOrganization.
         * @memberof request
         * @classdesc Represents a GetOrganization.
         * @implements IGetOrganization
         * @constructor
         * @param {request.IGetOrganization=} [properties] Properties to set
         */
        function GetOrganization(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetOrganization email.
         * @member {string} email
         * @memberof request.GetOrganization
         * @instance
         */
        GetOrganization.prototype.email = "";

        /**
         * Creates a new GetOrganization instance using the specified properties.
         * @function create
         * @memberof request.GetOrganization
         * @static
         * @param {request.IGetOrganization=} [properties] Properties to set
         * @returns {request.GetOrganization} GetOrganization instance
         */
        GetOrganization.create = function create(properties) {
            return new GetOrganization(properties);
        };

        /**
         * Encodes the specified GetOrganization message. Does not implicitly {@link request.GetOrganization.verify|verify} messages.
         * @function encode
         * @memberof request.GetOrganization
         * @static
         * @param {request.IGetOrganization} message GetOrganization message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetOrganization.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
            return writer;
        };

        /**
         * Encodes the specified GetOrganization message, length delimited. Does not implicitly {@link request.GetOrganization.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.GetOrganization
         * @static
         * @param {request.IGetOrganization} message GetOrganization message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetOrganization.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetOrganization message from the specified reader or buffer.
         * @function decode
         * @memberof request.GetOrganization
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.GetOrganization} GetOrganization
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetOrganization.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.GetOrganization();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.email = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetOrganization message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.GetOrganization
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.GetOrganization} GetOrganization
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetOrganization.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetOrganization message.
         * @function verify
         * @memberof request.GetOrganization
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetOrganization.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            return null;
        };

        /**
         * Creates a GetOrganization message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.GetOrganization
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.GetOrganization} GetOrganization
         */
        GetOrganization.fromObject = function fromObject(object) {
            if (object instanceof $root.request.GetOrganization)
                return object;
            let message = new $root.request.GetOrganization();
            if (object.email != null)
                message.email = String(object.email);
            return message;
        };

        /**
         * Creates a plain object from a GetOrganization message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.GetOrganization
         * @static
         * @param {request.GetOrganization} message GetOrganization
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetOrganization.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.email = "";
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            return object;
        };

        /**
         * Converts this GetOrganization to JSON.
         * @function toJSON
         * @memberof request.GetOrganization
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetOrganization.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetOrganization
         * @function getTypeUrl
         * @memberof request.GetOrganization
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetOrganization.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.GetOrganization";
        };

        return GetOrganization;
    })();

    request.ResetTOTP = (function() {

        /**
         * Properties of a ResetTOTP.
         * @memberof request
         * @interface IResetTOTP
         */

        /**
         * Constructs a new ResetTOTP.
         * @memberof request
         * @classdesc Represents a ResetTOTP.
         * @implements IResetTOTP
         * @constructor
         * @param {request.IResetTOTP=} [properties] Properties to set
         */
        function ResetTOTP(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new ResetTOTP instance using the specified properties.
         * @function create
         * @memberof request.ResetTOTP
         * @static
         * @param {request.IResetTOTP=} [properties] Properties to set
         * @returns {request.ResetTOTP} ResetTOTP instance
         */
        ResetTOTP.create = function create(properties) {
            return new ResetTOTP(properties);
        };

        /**
         * Encodes the specified ResetTOTP message. Does not implicitly {@link request.ResetTOTP.verify|verify} messages.
         * @function encode
         * @memberof request.ResetTOTP
         * @static
         * @param {request.IResetTOTP} message ResetTOTP message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ResetTOTP.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified ResetTOTP message, length delimited. Does not implicitly {@link request.ResetTOTP.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.ResetTOTP
         * @static
         * @param {request.IResetTOTP} message ResetTOTP message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ResetTOTP.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ResetTOTP message from the specified reader or buffer.
         * @function decode
         * @memberof request.ResetTOTP
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.ResetTOTP} ResetTOTP
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ResetTOTP.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.ResetTOTP();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ResetTOTP message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.ResetTOTP
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.ResetTOTP} ResetTOTP
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ResetTOTP.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ResetTOTP message.
         * @function verify
         * @memberof request.ResetTOTP
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ResetTOTP.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a ResetTOTP message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.ResetTOTP
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.ResetTOTP} ResetTOTP
         */
        ResetTOTP.fromObject = function fromObject(object) {
            if (object instanceof $root.request.ResetTOTP)
                return object;
            return new $root.request.ResetTOTP();
        };

        /**
         * Creates a plain object from a ResetTOTP message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.ResetTOTP
         * @static
         * @param {request.ResetTOTP} message ResetTOTP
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ResetTOTP.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this ResetTOTP to JSON.
         * @function toJSON
         * @memberof request.ResetTOTP
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ResetTOTP.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ResetTOTP
         * @function getTypeUrl
         * @memberof request.ResetTOTP
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ResetTOTP.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.ResetTOTP";
        };

        return ResetTOTP;
    })();

    request.InviteUser = (function() {

        /**
         * Properties of an InviteUser.
         * @memberof request
         * @interface IInviteUser
         * @property {string|null} [organization] InviteUser organization
         * @property {string|null} [email] InviteUser email
         */

        /**
         * Constructs a new InviteUser.
         * @memberof request
         * @classdesc Represents an InviteUser.
         * @implements IInviteUser
         * @constructor
         * @param {request.IInviteUser=} [properties] Properties to set
         */
        function InviteUser(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * InviteUser organization.
         * @member {string} organization
         * @memberof request.InviteUser
         * @instance
         */
        InviteUser.prototype.organization = "";

        /**
         * InviteUser email.
         * @member {string} email
         * @memberof request.InviteUser
         * @instance
         */
        InviteUser.prototype.email = "";

        /**
         * Creates a new InviteUser instance using the specified properties.
         * @function create
         * @memberof request.InviteUser
         * @static
         * @param {request.IInviteUser=} [properties] Properties to set
         * @returns {request.InviteUser} InviteUser instance
         */
        InviteUser.create = function create(properties) {
            return new InviteUser(properties);
        };

        /**
         * Encodes the specified InviteUser message. Does not implicitly {@link request.InviteUser.verify|verify} messages.
         * @function encode
         * @memberof request.InviteUser
         * @static
         * @param {request.IInviteUser} message InviteUser message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        InviteUser.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.organization != null && Object.hasOwnProperty.call(message, "organization"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.organization);
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.email);
            return writer;
        };

        /**
         * Encodes the specified InviteUser message, length delimited. Does not implicitly {@link request.InviteUser.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.InviteUser
         * @static
         * @param {request.IInviteUser} message InviteUser message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        InviteUser.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an InviteUser message from the specified reader or buffer.
         * @function decode
         * @memberof request.InviteUser
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.InviteUser} InviteUser
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        InviteUser.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.InviteUser();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.organization = reader.string();
                        break;
                    }
                case 2: {
                        message.email = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an InviteUser message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.InviteUser
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.InviteUser} InviteUser
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        InviteUser.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an InviteUser message.
         * @function verify
         * @memberof request.InviteUser
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        InviteUser.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.organization != null && message.hasOwnProperty("organization"))
                if (!$util.isString(message.organization))
                    return "organization: string expected";
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            return null;
        };

        /**
         * Creates an InviteUser message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.InviteUser
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.InviteUser} InviteUser
         */
        InviteUser.fromObject = function fromObject(object) {
            if (object instanceof $root.request.InviteUser)
                return object;
            let message = new $root.request.InviteUser();
            if (object.organization != null)
                message.organization = String(object.organization);
            if (object.email != null)
                message.email = String(object.email);
            return message;
        };

        /**
         * Creates a plain object from an InviteUser message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.InviteUser
         * @static
         * @param {request.InviteUser} message InviteUser
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        InviteUser.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.organization = "";
                object.email = "";
            }
            if (message.organization != null && message.hasOwnProperty("organization"))
                object.organization = message.organization;
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            return object;
        };

        /**
         * Converts this InviteUser to JSON.
         * @function toJSON
         * @memberof request.InviteUser
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        InviteUser.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for InviteUser
         * @function getTypeUrl
         * @memberof request.InviteUser
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        InviteUser.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.InviteUser";
        };

        return InviteUser;
    })();

    request.InitiatePayment = (function() {

        /**
         * Properties of an InitiatePayment.
         * @memberof request
         * @interface IInitiatePayment
         * @property {string|null} [email] InitiatePayment email
         * @property {string|null} [organization] InitiatePayment organization
         * @property {number|null} [plan] InitiatePayment plan
         * @property {number|null} [additionalStorage] InitiatePayment additionalStorage
         * @property {boolean|null} [isYearly] InitiatePayment isYearly
         * @property {string|null} [coupon] InitiatePayment coupon
         * @property {string|null} [gstToken] InitiatePayment gstToken
         */

        /**
         * Constructs a new InitiatePayment.
         * @memberof request
         * @classdesc Represents an InitiatePayment.
         * @implements IInitiatePayment
         * @constructor
         * @param {request.IInitiatePayment=} [properties] Properties to set
         */
        function InitiatePayment(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * InitiatePayment email.
         * @member {string} email
         * @memberof request.InitiatePayment
         * @instance
         */
        InitiatePayment.prototype.email = "";

        /**
         * InitiatePayment organization.
         * @member {string|null|undefined} organization
         * @memberof request.InitiatePayment
         * @instance
         */
        InitiatePayment.prototype.organization = null;

        /**
         * InitiatePayment plan.
         * @member {number} plan
         * @memberof request.InitiatePayment
         * @instance
         */
        InitiatePayment.prototype.plan = 0;

        /**
         * InitiatePayment additionalStorage.
         * @member {number|null|undefined} additionalStorage
         * @memberof request.InitiatePayment
         * @instance
         */
        InitiatePayment.prototype.additionalStorage = null;

        /**
         * InitiatePayment isYearly.
         * @member {boolean} isYearly
         * @memberof request.InitiatePayment
         * @instance
         */
        InitiatePayment.prototype.isYearly = false;

        /**
         * InitiatePayment coupon.
         * @member {string|null|undefined} coupon
         * @memberof request.InitiatePayment
         * @instance
         */
        InitiatePayment.prototype.coupon = null;

        /**
         * InitiatePayment gstToken.
         * @member {string|null|undefined} gstToken
         * @memberof request.InitiatePayment
         * @instance
         */
        InitiatePayment.prototype.gstToken = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(InitiatePayment.prototype, "_organization", {
            get: $util.oneOfGetter($oneOfFields = ["organization"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(InitiatePayment.prototype, "_additionalStorage", {
            get: $util.oneOfGetter($oneOfFields = ["additionalStorage"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(InitiatePayment.prototype, "_coupon", {
            get: $util.oneOfGetter($oneOfFields = ["coupon"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(InitiatePayment.prototype, "_gstToken", {
            get: $util.oneOfGetter($oneOfFields = ["gstToken"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new InitiatePayment instance using the specified properties.
         * @function create
         * @memberof request.InitiatePayment
         * @static
         * @param {request.IInitiatePayment=} [properties] Properties to set
         * @returns {request.InitiatePayment} InitiatePayment instance
         */
        InitiatePayment.create = function create(properties) {
            return new InitiatePayment(properties);
        };

        /**
         * Encodes the specified InitiatePayment message. Does not implicitly {@link request.InitiatePayment.verify|verify} messages.
         * @function encode
         * @memberof request.InitiatePayment
         * @static
         * @param {request.IInitiatePayment} message InitiatePayment message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        InitiatePayment.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
            if (message.organization != null && Object.hasOwnProperty.call(message, "organization"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.organization);
            if (message.plan != null && Object.hasOwnProperty.call(message, "plan"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.plan);
            if (message.additionalStorage != null && Object.hasOwnProperty.call(message, "additionalStorage"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.additionalStorage);
            if (message.isYearly != null && Object.hasOwnProperty.call(message, "isYearly"))
                writer.uint32(/* id 5, wireType 0 =*/40).bool(message.isYearly);
            if (message.coupon != null && Object.hasOwnProperty.call(message, "coupon"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.coupon);
            if (message.gstToken != null && Object.hasOwnProperty.call(message, "gstToken"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.gstToken);
            return writer;
        };

        /**
         * Encodes the specified InitiatePayment message, length delimited. Does not implicitly {@link request.InitiatePayment.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.InitiatePayment
         * @static
         * @param {request.IInitiatePayment} message InitiatePayment message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        InitiatePayment.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an InitiatePayment message from the specified reader or buffer.
         * @function decode
         * @memberof request.InitiatePayment
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.InitiatePayment} InitiatePayment
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        InitiatePayment.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.InitiatePayment();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.email = reader.string();
                        break;
                    }
                case 2: {
                        message.organization = reader.string();
                        break;
                    }
                case 3: {
                        message.plan = reader.int32();
                        break;
                    }
                case 4: {
                        message.additionalStorage = reader.uint32();
                        break;
                    }
                case 5: {
                        message.isYearly = reader.bool();
                        break;
                    }
                case 6: {
                        message.coupon = reader.string();
                        break;
                    }
                case 7: {
                        message.gstToken = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an InitiatePayment message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.InitiatePayment
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.InitiatePayment} InitiatePayment
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        InitiatePayment.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an InitiatePayment message.
         * @function verify
         * @memberof request.InitiatePayment
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        InitiatePayment.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            if (message.organization != null && message.hasOwnProperty("organization")) {
                properties._organization = 1;
                if (!$util.isString(message.organization))
                    return "organization: string expected";
            }
            if (message.plan != null && message.hasOwnProperty("plan"))
                if (!$util.isInteger(message.plan))
                    return "plan: integer expected";
            if (message.additionalStorage != null && message.hasOwnProperty("additionalStorage")) {
                properties._additionalStorage = 1;
                if (!$util.isInteger(message.additionalStorage))
                    return "additionalStorage: integer expected";
            }
            if (message.isYearly != null && message.hasOwnProperty("isYearly"))
                if (typeof message.isYearly !== "boolean")
                    return "isYearly: boolean expected";
            if (message.coupon != null && message.hasOwnProperty("coupon")) {
                properties._coupon = 1;
                if (!$util.isString(message.coupon))
                    return "coupon: string expected";
            }
            if (message.gstToken != null && message.hasOwnProperty("gstToken")) {
                properties._gstToken = 1;
                if (!$util.isString(message.gstToken))
                    return "gstToken: string expected";
            }
            return null;
        };

        /**
         * Creates an InitiatePayment message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.InitiatePayment
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.InitiatePayment} InitiatePayment
         */
        InitiatePayment.fromObject = function fromObject(object) {
            if (object instanceof $root.request.InitiatePayment)
                return object;
            let message = new $root.request.InitiatePayment();
            if (object.email != null)
                message.email = String(object.email);
            if (object.organization != null)
                message.organization = String(object.organization);
            if (object.plan != null)
                message.plan = object.plan | 0;
            if (object.additionalStorage != null)
                message.additionalStorage = object.additionalStorage >>> 0;
            if (object.isYearly != null)
                message.isYearly = Boolean(object.isYearly);
            if (object.coupon != null)
                message.coupon = String(object.coupon);
            if (object.gstToken != null)
                message.gstToken = String(object.gstToken);
            return message;
        };

        /**
         * Creates a plain object from an InitiatePayment message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.InitiatePayment
         * @static
         * @param {request.InitiatePayment} message InitiatePayment
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        InitiatePayment.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.email = "";
                object.plan = 0;
                object.isYearly = false;
            }
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.organization != null && message.hasOwnProperty("organization")) {
                object.organization = message.organization;
                if (options.oneofs)
                    object._organization = "organization";
            }
            if (message.plan != null && message.hasOwnProperty("plan"))
                object.plan = message.plan;
            if (message.additionalStorage != null && message.hasOwnProperty("additionalStorage")) {
                object.additionalStorage = message.additionalStorage;
                if (options.oneofs)
                    object._additionalStorage = "additionalStorage";
            }
            if (message.isYearly != null && message.hasOwnProperty("isYearly"))
                object.isYearly = message.isYearly;
            if (message.coupon != null && message.hasOwnProperty("coupon")) {
                object.coupon = message.coupon;
                if (options.oneofs)
                    object._coupon = "coupon";
            }
            if (message.gstToken != null && message.hasOwnProperty("gstToken")) {
                object.gstToken = message.gstToken;
                if (options.oneofs)
                    object._gstToken = "gstToken";
            }
            return object;
        };

        /**
         * Converts this InitiatePayment to JSON.
         * @function toJSON
         * @memberof request.InitiatePayment
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        InitiatePayment.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for InitiatePayment
         * @function getTypeUrl
         * @memberof request.InitiatePayment
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        InitiatePayment.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.InitiatePayment";
        };

        return InitiatePayment;
    })();

    request.VerifyPayment = (function() {

        /**
         * Properties of a VerifyPayment.
         * @memberof request
         * @interface IVerifyPayment
         * @property {string|null} [orderId] VerifyPayment orderId
         */

        /**
         * Constructs a new VerifyPayment.
         * @memberof request
         * @classdesc Represents a VerifyPayment.
         * @implements IVerifyPayment
         * @constructor
         * @param {request.IVerifyPayment=} [properties] Properties to set
         */
        function VerifyPayment(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * VerifyPayment orderId.
         * @member {string} orderId
         * @memberof request.VerifyPayment
         * @instance
         */
        VerifyPayment.prototype.orderId = "";

        /**
         * Creates a new VerifyPayment instance using the specified properties.
         * @function create
         * @memberof request.VerifyPayment
         * @static
         * @param {request.IVerifyPayment=} [properties] Properties to set
         * @returns {request.VerifyPayment} VerifyPayment instance
         */
        VerifyPayment.create = function create(properties) {
            return new VerifyPayment(properties);
        };

        /**
         * Encodes the specified VerifyPayment message. Does not implicitly {@link request.VerifyPayment.verify|verify} messages.
         * @function encode
         * @memberof request.VerifyPayment
         * @static
         * @param {request.IVerifyPayment} message VerifyPayment message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        VerifyPayment.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.orderId != null && Object.hasOwnProperty.call(message, "orderId"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.orderId);
            return writer;
        };

        /**
         * Encodes the specified VerifyPayment message, length delimited. Does not implicitly {@link request.VerifyPayment.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.VerifyPayment
         * @static
         * @param {request.IVerifyPayment} message VerifyPayment message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        VerifyPayment.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a VerifyPayment message from the specified reader or buffer.
         * @function decode
         * @memberof request.VerifyPayment
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.VerifyPayment} VerifyPayment
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        VerifyPayment.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.VerifyPayment();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 2: {
                        message.orderId = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a VerifyPayment message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.VerifyPayment
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.VerifyPayment} VerifyPayment
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        VerifyPayment.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a VerifyPayment message.
         * @function verify
         * @memberof request.VerifyPayment
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        VerifyPayment.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.orderId != null && message.hasOwnProperty("orderId"))
                if (!$util.isString(message.orderId))
                    return "orderId: string expected";
            return null;
        };

        /**
         * Creates a VerifyPayment message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.VerifyPayment
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.VerifyPayment} VerifyPayment
         */
        VerifyPayment.fromObject = function fromObject(object) {
            if (object instanceof $root.request.VerifyPayment)
                return object;
            let message = new $root.request.VerifyPayment();
            if (object.orderId != null)
                message.orderId = String(object.orderId);
            return message;
        };

        /**
         * Creates a plain object from a VerifyPayment message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.VerifyPayment
         * @static
         * @param {request.VerifyPayment} message VerifyPayment
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        VerifyPayment.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.orderId = "";
            if (message.orderId != null && message.hasOwnProperty("orderId"))
                object.orderId = message.orderId;
            return object;
        };

        /**
         * Converts this VerifyPayment to JSON.
         * @function toJSON
         * @memberof request.VerifyPayment
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        VerifyPayment.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for VerifyPayment
         * @function getTypeUrl
         * @memberof request.VerifyPayment
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        VerifyPayment.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.VerifyPayment";
        };

        return VerifyPayment;
    })();

    request.SignIn = (function() {

        /**
         * Properties of a SignIn.
         * @memberof request
         * @interface ISignIn
         * @property {string|null} [email] SignIn email
         * @property {string|null} [organization] SignIn organization
         * @property {string|null} [password] SignIn password
         * @property {string|null} [totp] SignIn totp
         * @property {string|null} [pin] SignIn pin
         * @property {Uint8Array|null} [data] SignIn data
         */

        /**
         * Constructs a new SignIn.
         * @memberof request
         * @classdesc Represents a SignIn.
         * @implements ISignIn
         * @constructor
         * @param {request.ISignIn=} [properties] Properties to set
         */
        function SignIn(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SignIn email.
         * @member {string} email
         * @memberof request.SignIn
         * @instance
         */
        SignIn.prototype.email = "";

        /**
         * SignIn organization.
         * @member {string|null|undefined} organization
         * @memberof request.SignIn
         * @instance
         */
        SignIn.prototype.organization = null;

        /**
         * SignIn password.
         * @member {string|null|undefined} password
         * @memberof request.SignIn
         * @instance
         */
        SignIn.prototype.password = null;

        /**
         * SignIn totp.
         * @member {string|null|undefined} totp
         * @memberof request.SignIn
         * @instance
         */
        SignIn.prototype.totp = null;

        /**
         * SignIn pin.
         * @member {string|null|undefined} pin
         * @memberof request.SignIn
         * @instance
         */
        SignIn.prototype.pin = null;

        /**
         * SignIn data.
         * @member {Uint8Array|null|undefined} data
         * @memberof request.SignIn
         * @instance
         */
        SignIn.prototype.data = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(SignIn.prototype, "_organization", {
            get: $util.oneOfGetter($oneOfFields = ["organization"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(SignIn.prototype, "_password", {
            get: $util.oneOfGetter($oneOfFields = ["password"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(SignIn.prototype, "_totp", {
            get: $util.oneOfGetter($oneOfFields = ["totp"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(SignIn.prototype, "_pin", {
            get: $util.oneOfGetter($oneOfFields = ["pin"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(SignIn.prototype, "_data", {
            get: $util.oneOfGetter($oneOfFields = ["data"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new SignIn instance using the specified properties.
         * @function create
         * @memberof request.SignIn
         * @static
         * @param {request.ISignIn=} [properties] Properties to set
         * @returns {request.SignIn} SignIn instance
         */
        SignIn.create = function create(properties) {
            return new SignIn(properties);
        };

        /**
         * Encodes the specified SignIn message. Does not implicitly {@link request.SignIn.verify|verify} messages.
         * @function encode
         * @memberof request.SignIn
         * @static
         * @param {request.ISignIn} message SignIn message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SignIn.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
            if (message.password != null && Object.hasOwnProperty.call(message, "password"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.password);
            if (message.totp != null && Object.hasOwnProperty.call(message, "totp"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.totp);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.data);
            if (message.organization != null && Object.hasOwnProperty.call(message, "organization"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.organization);
            if (message.pin != null && Object.hasOwnProperty.call(message, "pin"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.pin);
            return writer;
        };

        /**
         * Encodes the specified SignIn message, length delimited. Does not implicitly {@link request.SignIn.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.SignIn
         * @static
         * @param {request.ISignIn} message SignIn message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SignIn.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SignIn message from the specified reader or buffer.
         * @function decode
         * @memberof request.SignIn
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.SignIn} SignIn
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SignIn.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.SignIn();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.email = reader.string();
                        break;
                    }
                case 6: {
                        message.organization = reader.string();
                        break;
                    }
                case 2: {
                        message.password = reader.string();
                        break;
                    }
                case 3: {
                        message.totp = reader.string();
                        break;
                    }
                case 7: {
                        message.pin = reader.string();
                        break;
                    }
                case 4: {
                        message.data = reader.bytes();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SignIn message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.SignIn
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.SignIn} SignIn
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SignIn.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SignIn message.
         * @function verify
         * @memberof request.SignIn
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SignIn.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            if (message.organization != null && message.hasOwnProperty("organization")) {
                properties._organization = 1;
                if (!$util.isString(message.organization))
                    return "organization: string expected";
            }
            if (message.password != null && message.hasOwnProperty("password")) {
                properties._password = 1;
                if (!$util.isString(message.password))
                    return "password: string expected";
            }
            if (message.totp != null && message.hasOwnProperty("totp")) {
                properties._totp = 1;
                if (!$util.isString(message.totp))
                    return "totp: string expected";
            }
            if (message.pin != null && message.hasOwnProperty("pin")) {
                properties._pin = 1;
                if (!$util.isString(message.pin))
                    return "pin: string expected";
            }
            if (message.data != null && message.hasOwnProperty("data")) {
                properties._data = 1;
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            }
            return null;
        };

        /**
         * Creates a SignIn message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.SignIn
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.SignIn} SignIn
         */
        SignIn.fromObject = function fromObject(object) {
            if (object instanceof $root.request.SignIn)
                return object;
            let message = new $root.request.SignIn();
            if (object.email != null)
                message.email = String(object.email);
            if (object.organization != null)
                message.organization = String(object.organization);
            if (object.password != null)
                message.password = String(object.password);
            if (object.totp != null)
                message.totp = String(object.totp);
            if (object.pin != null)
                message.pin = String(object.pin);
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            return message;
        };

        /**
         * Creates a plain object from a SignIn message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.SignIn
         * @static
         * @param {request.SignIn} message SignIn
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SignIn.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.email = "";
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.password != null && message.hasOwnProperty("password")) {
                object.password = message.password;
                if (options.oneofs)
                    object._password = "password";
            }
            if (message.totp != null && message.hasOwnProperty("totp")) {
                object.totp = message.totp;
                if (options.oneofs)
                    object._totp = "totp";
            }
            if (message.data != null && message.hasOwnProperty("data")) {
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
                if (options.oneofs)
                    object._data = "data";
            }
            if (message.organization != null && message.hasOwnProperty("organization")) {
                object.organization = message.organization;
                if (options.oneofs)
                    object._organization = "organization";
            }
            if (message.pin != null && message.hasOwnProperty("pin")) {
                object.pin = message.pin;
                if (options.oneofs)
                    object._pin = "pin";
            }
            return object;
        };

        /**
         * Converts this SignIn to JSON.
         * @function toJSON
         * @memberof request.SignIn
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SignIn.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for SignIn
         * @function getTypeUrl
         * @memberof request.SignIn
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        SignIn.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.SignIn";
        };

        return SignIn;
    })();

    request.SignOut = (function() {

        /**
         * Properties of a SignOut.
         * @memberof request
         * @interface ISignOut
         * @property {string|null} [email] SignOut email
         */

        /**
         * Constructs a new SignOut.
         * @memberof request
         * @classdesc Represents a SignOut.
         * @implements ISignOut
         * @constructor
         * @param {request.ISignOut=} [properties] Properties to set
         */
        function SignOut(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SignOut email.
         * @member {string} email
         * @memberof request.SignOut
         * @instance
         */
        SignOut.prototype.email = "";

        /**
         * Creates a new SignOut instance using the specified properties.
         * @function create
         * @memberof request.SignOut
         * @static
         * @param {request.ISignOut=} [properties] Properties to set
         * @returns {request.SignOut} SignOut instance
         */
        SignOut.create = function create(properties) {
            return new SignOut(properties);
        };

        /**
         * Encodes the specified SignOut message. Does not implicitly {@link request.SignOut.verify|verify} messages.
         * @function encode
         * @memberof request.SignOut
         * @static
         * @param {request.ISignOut} message SignOut message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SignOut.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
            return writer;
        };

        /**
         * Encodes the specified SignOut message, length delimited. Does not implicitly {@link request.SignOut.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.SignOut
         * @static
         * @param {request.ISignOut} message SignOut message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SignOut.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SignOut message from the specified reader or buffer.
         * @function decode
         * @memberof request.SignOut
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.SignOut} SignOut
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SignOut.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.SignOut();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.email = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SignOut message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.SignOut
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.SignOut} SignOut
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SignOut.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SignOut message.
         * @function verify
         * @memberof request.SignOut
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SignOut.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            return null;
        };

        /**
         * Creates a SignOut message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.SignOut
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.SignOut} SignOut
         */
        SignOut.fromObject = function fromObject(object) {
            if (object instanceof $root.request.SignOut)
                return object;
            let message = new $root.request.SignOut();
            if (object.email != null)
                message.email = String(object.email);
            return message;
        };

        /**
         * Creates a plain object from a SignOut message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.SignOut
         * @static
         * @param {request.SignOut} message SignOut
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SignOut.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.email = "";
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            return object;
        };

        /**
         * Converts this SignOut to JSON.
         * @function toJSON
         * @memberof request.SignOut
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SignOut.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for SignOut
         * @function getTypeUrl
         * @memberof request.SignOut
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        SignOut.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.SignOut";
        };

        return SignOut;
    })();

    request.GetUser = (function() {

        /**
         * Properties of a GetUser.
         * @memberof request
         * @interface IGetUser
         * @property {string|null} [email] GetUser email
         */

        /**
         * Constructs a new GetUser.
         * @memberof request
         * @classdesc Represents a GetUser.
         * @implements IGetUser
         * @constructor
         * @param {request.IGetUser=} [properties] Properties to set
         */
        function GetUser(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetUser email.
         * @member {string} email
         * @memberof request.GetUser
         * @instance
         */
        GetUser.prototype.email = "";

        /**
         * Creates a new GetUser instance using the specified properties.
         * @function create
         * @memberof request.GetUser
         * @static
         * @param {request.IGetUser=} [properties] Properties to set
         * @returns {request.GetUser} GetUser instance
         */
        GetUser.create = function create(properties) {
            return new GetUser(properties);
        };

        /**
         * Encodes the specified GetUser message. Does not implicitly {@link request.GetUser.verify|verify} messages.
         * @function encode
         * @memberof request.GetUser
         * @static
         * @param {request.IGetUser} message GetUser message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetUser.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
            return writer;
        };

        /**
         * Encodes the specified GetUser message, length delimited. Does not implicitly {@link request.GetUser.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.GetUser
         * @static
         * @param {request.IGetUser} message GetUser message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetUser.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetUser message from the specified reader or buffer.
         * @function decode
         * @memberof request.GetUser
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.GetUser} GetUser
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetUser.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.GetUser();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.email = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetUser message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.GetUser
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.GetUser} GetUser
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetUser.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetUser message.
         * @function verify
         * @memberof request.GetUser
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetUser.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            return null;
        };

        /**
         * Creates a GetUser message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.GetUser
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.GetUser} GetUser
         */
        GetUser.fromObject = function fromObject(object) {
            if (object instanceof $root.request.GetUser)
                return object;
            let message = new $root.request.GetUser();
            if (object.email != null)
                message.email = String(object.email);
            return message;
        };

        /**
         * Creates a plain object from a GetUser message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.GetUser
         * @static
         * @param {request.GetUser} message GetUser
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetUser.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.email = "";
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            return object;
        };

        /**
         * Converts this GetUser to JSON.
         * @function toJSON
         * @memberof request.GetUser
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetUser.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetUser
         * @function getTypeUrl
         * @memberof request.GetUser
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetUser.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.GetUser";
        };

        return GetUser;
    })();

    request.GetFileHead = (function() {

        /**
         * Properties of a GetFileHead.
         * @memberof request
         * @interface IGetFileHead
         * @property {Uint8Array|null} [uuid] GetFileHead uuid
         * @property {boolean|null} [trashed] GetFileHead trashed
         */

        /**
         * Constructs a new GetFileHead.
         * @memberof request
         * @classdesc Represents a GetFileHead.
         * @implements IGetFileHead
         * @constructor
         * @param {request.IGetFileHead=} [properties] Properties to set
         */
        function GetFileHead(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetFileHead uuid.
         * @member {Uint8Array} uuid
         * @memberof request.GetFileHead
         * @instance
         */
        GetFileHead.prototype.uuid = $util.newBuffer([]);

        /**
         * GetFileHead trashed.
         * @member {boolean} trashed
         * @memberof request.GetFileHead
         * @instance
         */
        GetFileHead.prototype.trashed = false;

        /**
         * Creates a new GetFileHead instance using the specified properties.
         * @function create
         * @memberof request.GetFileHead
         * @static
         * @param {request.IGetFileHead=} [properties] Properties to set
         * @returns {request.GetFileHead} GetFileHead instance
         */
        GetFileHead.create = function create(properties) {
            return new GetFileHead(properties);
        };

        /**
         * Encodes the specified GetFileHead message. Does not implicitly {@link request.GetFileHead.verify|verify} messages.
         * @function encode
         * @memberof request.GetFileHead
         * @static
         * @param {request.IGetFileHead} message GetFileHead message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetFileHead.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uuid != null && Object.hasOwnProperty.call(message, "uuid"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.uuid);
            if (message.trashed != null && Object.hasOwnProperty.call(message, "trashed"))
                writer.uint32(/* id 2, wireType 0 =*/16).bool(message.trashed);
            return writer;
        };

        /**
         * Encodes the specified GetFileHead message, length delimited. Does not implicitly {@link request.GetFileHead.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.GetFileHead
         * @static
         * @param {request.IGetFileHead} message GetFileHead message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetFileHead.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetFileHead message from the specified reader or buffer.
         * @function decode
         * @memberof request.GetFileHead
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.GetFileHead} GetFileHead
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetFileHead.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.GetFileHead();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.uuid = reader.bytes();
                        break;
                    }
                case 2: {
                        message.trashed = reader.bool();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetFileHead message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.GetFileHead
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.GetFileHead} GetFileHead
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetFileHead.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetFileHead message.
         * @function verify
         * @memberof request.GetFileHead
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetFileHead.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                if (!(message.uuid && typeof message.uuid.length === "number" || $util.isString(message.uuid)))
                    return "uuid: buffer expected";
            if (message.trashed != null && message.hasOwnProperty("trashed"))
                if (typeof message.trashed !== "boolean")
                    return "trashed: boolean expected";
            return null;
        };

        /**
         * Creates a GetFileHead message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.GetFileHead
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.GetFileHead} GetFileHead
         */
        GetFileHead.fromObject = function fromObject(object) {
            if (object instanceof $root.request.GetFileHead)
                return object;
            let message = new $root.request.GetFileHead();
            if (object.uuid != null)
                if (typeof object.uuid === "string")
                    $util.base64.decode(object.uuid, message.uuid = $util.newBuffer($util.base64.length(object.uuid)), 0);
                else if (object.uuid.length >= 0)
                    message.uuid = object.uuid;
            if (object.trashed != null)
                message.trashed = Boolean(object.trashed);
            return message;
        };

        /**
         * Creates a plain object from a GetFileHead message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.GetFileHead
         * @static
         * @param {request.GetFileHead} message GetFileHead
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetFileHead.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if (options.bytes === String)
                    object.uuid = "";
                else {
                    object.uuid = [];
                    if (options.bytes !== Array)
                        object.uuid = $util.newBuffer(object.uuid);
                }
                object.trashed = false;
            }
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                object.uuid = options.bytes === String ? $util.base64.encode(message.uuid, 0, message.uuid.length) : options.bytes === Array ? Array.prototype.slice.call(message.uuid) : message.uuid;
            if (message.trashed != null && message.hasOwnProperty("trashed"))
                object.trashed = message.trashed;
            return object;
        };

        /**
         * Converts this GetFileHead to JSON.
         * @function toJSON
         * @memberof request.GetFileHead
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetFileHead.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetFileHead
         * @function getTypeUrl
         * @memberof request.GetFileHead
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetFileHead.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.GetFileHead";
        };

        return GetFileHead;
    })();

    request.Echo = (function() {

        /**
         * Properties of an Echo.
         * @memberof request
         * @interface IEcho
         * @property {number|Long|null} [flags] Echo flags
         * @property {Uint8Array|null} [data] Echo data
         */

        /**
         * Constructs a new Echo.
         * @memberof request
         * @classdesc Represents an Echo.
         * @implements IEcho
         * @constructor
         * @param {request.IEcho=} [properties] Properties to set
         */
        function Echo(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Echo flags.
         * @member {number|Long} flags
         * @memberof request.Echo
         * @instance
         */
        Echo.prototype.flags = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Echo data.
         * @member {Uint8Array} data
         * @memberof request.Echo
         * @instance
         */
        Echo.prototype.data = $util.newBuffer([]);

        /**
         * Creates a new Echo instance using the specified properties.
         * @function create
         * @memberof request.Echo
         * @static
         * @param {request.IEcho=} [properties] Properties to set
         * @returns {request.Echo} Echo instance
         */
        Echo.create = function create(properties) {
            return new Echo(properties);
        };

        /**
         * Encodes the specified Echo message. Does not implicitly {@link request.Echo.verify|verify} messages.
         * @function encode
         * @memberof request.Echo
         * @static
         * @param {request.IEcho} message Echo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Echo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.flags != null && Object.hasOwnProperty.call(message, "flags"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.flags);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.data);
            return writer;
        };

        /**
         * Encodes the specified Echo message, length delimited. Does not implicitly {@link request.Echo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.Echo
         * @static
         * @param {request.IEcho} message Echo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Echo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an Echo message from the specified reader or buffer.
         * @function decode
         * @memberof request.Echo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.Echo} Echo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Echo.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.Echo();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.flags = reader.uint64();
                        break;
                    }
                case 2: {
                        message.data = reader.bytes();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an Echo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.Echo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.Echo} Echo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Echo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an Echo message.
         * @function verify
         * @memberof request.Echo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Echo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.flags != null && message.hasOwnProperty("flags"))
                if (!$util.isInteger(message.flags) && !(message.flags && $util.isInteger(message.flags.low) && $util.isInteger(message.flags.high)))
                    return "flags: integer|Long expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            return null;
        };

        /**
         * Creates an Echo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.Echo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.Echo} Echo
         */
        Echo.fromObject = function fromObject(object) {
            if (object instanceof $root.request.Echo)
                return object;
            let message = new $root.request.Echo();
            if (object.flags != null)
                if ($util.Long)
                    (message.flags = $util.Long.fromValue(object.flags)).unsigned = true;
                else if (typeof object.flags === "string")
                    message.flags = parseInt(object.flags, 10);
                else if (typeof object.flags === "number")
                    message.flags = object.flags;
                else if (typeof object.flags === "object")
                    message.flags = new $util.LongBits(object.flags.low >>> 0, object.flags.high >>> 0).toNumber(true);
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            return message;
        };

        /**
         * Creates a plain object from an Echo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.Echo
         * @static
         * @param {request.Echo} message Echo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Echo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.flags = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.flags = options.longs === String ? "0" : 0;
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
            }
            if (message.flags != null && message.hasOwnProperty("flags"))
                if (typeof message.flags === "number")
                    object.flags = options.longs === String ? String(message.flags) : message.flags;
                else
                    object.flags = options.longs === String ? $util.Long.prototype.toString.call(message.flags) : options.longs === Number ? new $util.LongBits(message.flags.low >>> 0, message.flags.high >>> 0).toNumber(true) : message.flags;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            return object;
        };

        /**
         * Converts this Echo to JSON.
         * @function toJSON
         * @memberof request.Echo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Echo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Echo
         * @function getTypeUrl
         * @memberof request.Echo
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Echo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.Echo";
        };

        return Echo;
    })();

    request.Chunk = (function() {

        /**
         * Properties of a Chunk.
         * @memberof request
         * @interface IChunk
         * @property {Uint8Array|null} [id] Chunk id
         * @property {number|Long|null} [size] Chunk size
         * @property {number|Long|null} [offset] Chunk offset
         * @property {Uint8Array|null} [key] Chunk key
         * @property {Uint8Array|null} [iv] Chunk iv
         * @property {Uint8Array|null} [hash] Chunk hash
         */

        /**
         * Constructs a new Chunk.
         * @memberof request
         * @classdesc Represents a Chunk.
         * @implements IChunk
         * @constructor
         * @param {request.IChunk=} [properties] Properties to set
         */
        function Chunk(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Chunk id.
         * @member {Uint8Array} id
         * @memberof request.Chunk
         * @instance
         */
        Chunk.prototype.id = $util.newBuffer([]);

        /**
         * Chunk size.
         * @member {number|Long} size
         * @memberof request.Chunk
         * @instance
         */
        Chunk.prototype.size = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Chunk offset.
         * @member {number|Long} offset
         * @memberof request.Chunk
         * @instance
         */
        Chunk.prototype.offset = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Chunk key.
         * @member {Uint8Array|null|undefined} key
         * @memberof request.Chunk
         * @instance
         */
        Chunk.prototype.key = null;

        /**
         * Chunk iv.
         * @member {Uint8Array|null|undefined} iv
         * @memberof request.Chunk
         * @instance
         */
        Chunk.prototype.iv = null;

        /**
         * Chunk hash.
         * @member {Uint8Array} hash
         * @memberof request.Chunk
         * @instance
         */
        Chunk.prototype.hash = $util.newBuffer([]);

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(Chunk.prototype, "_key", {
            get: $util.oneOfGetter($oneOfFields = ["key"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(Chunk.prototype, "_iv", {
            get: $util.oneOfGetter($oneOfFields = ["iv"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new Chunk instance using the specified properties.
         * @function create
         * @memberof request.Chunk
         * @static
         * @param {request.IChunk=} [properties] Properties to set
         * @returns {request.Chunk} Chunk instance
         */
        Chunk.create = function create(properties) {
            return new Chunk(properties);
        };

        /**
         * Encodes the specified Chunk message. Does not implicitly {@link request.Chunk.verify|verify} messages.
         * @function encode
         * @memberof request.Chunk
         * @static
         * @param {request.IChunk} message Chunk message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Chunk.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.id);
            if (message.size != null && Object.hasOwnProperty.call(message, "size"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.size);
            if (message.offset != null && Object.hasOwnProperty.call(message, "offset"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.offset);
            if (message.iv != null && Object.hasOwnProperty.call(message, "iv"))
                writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.iv);
            if (message.hash != null && Object.hasOwnProperty.call(message, "hash"))
                writer.uint32(/* id 6, wireType 2 =*/50).bytes(message.hash);
            if (message.key != null && Object.hasOwnProperty.call(message, "key"))
                writer.uint32(/* id 7, wireType 2 =*/58).bytes(message.key);
            return writer;
        };

        /**
         * Encodes the specified Chunk message, length delimited. Does not implicitly {@link request.Chunk.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.Chunk
         * @static
         * @param {request.IChunk} message Chunk message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Chunk.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Chunk message from the specified reader or buffer.
         * @function decode
         * @memberof request.Chunk
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.Chunk} Chunk
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Chunk.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.Chunk();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.id = reader.bytes();
                        break;
                    }
                case 2: {
                        message.size = reader.uint64();
                        break;
                    }
                case 3: {
                        message.offset = reader.uint64();
                        break;
                    }
                case 7: {
                        message.key = reader.bytes();
                        break;
                    }
                case 4: {
                        message.iv = reader.bytes();
                        break;
                    }
                case 6: {
                        message.hash = reader.bytes();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Chunk message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.Chunk
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.Chunk} Chunk
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Chunk.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Chunk message.
         * @function verify
         * @memberof request.Chunk
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Chunk.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.id != null && message.hasOwnProperty("id"))
                if (!(message.id && typeof message.id.length === "number" || $util.isString(message.id)))
                    return "id: buffer expected";
            if (message.size != null && message.hasOwnProperty("size"))
                if (!$util.isInteger(message.size) && !(message.size && $util.isInteger(message.size.low) && $util.isInteger(message.size.high)))
                    return "size: integer|Long expected";
            if (message.offset != null && message.hasOwnProperty("offset"))
                if (!$util.isInteger(message.offset) && !(message.offset && $util.isInteger(message.offset.low) && $util.isInteger(message.offset.high)))
                    return "offset: integer|Long expected";
            if (message.key != null && message.hasOwnProperty("key")) {
                properties._key = 1;
                if (!(message.key && typeof message.key.length === "number" || $util.isString(message.key)))
                    return "key: buffer expected";
            }
            if (message.iv != null && message.hasOwnProperty("iv")) {
                properties._iv = 1;
                if (!(message.iv && typeof message.iv.length === "number" || $util.isString(message.iv)))
                    return "iv: buffer expected";
            }
            if (message.hash != null && message.hasOwnProperty("hash"))
                if (!(message.hash && typeof message.hash.length === "number" || $util.isString(message.hash)))
                    return "hash: buffer expected";
            return null;
        };

        /**
         * Creates a Chunk message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.Chunk
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.Chunk} Chunk
         */
        Chunk.fromObject = function fromObject(object) {
            if (object instanceof $root.request.Chunk)
                return object;
            let message = new $root.request.Chunk();
            if (object.id != null)
                if (typeof object.id === "string")
                    $util.base64.decode(object.id, message.id = $util.newBuffer($util.base64.length(object.id)), 0);
                else if (object.id.length >= 0)
                    message.id = object.id;
            if (object.size != null)
                if ($util.Long)
                    (message.size = $util.Long.fromValue(object.size)).unsigned = true;
                else if (typeof object.size === "string")
                    message.size = parseInt(object.size, 10);
                else if (typeof object.size === "number")
                    message.size = object.size;
                else if (typeof object.size === "object")
                    message.size = new $util.LongBits(object.size.low >>> 0, object.size.high >>> 0).toNumber(true);
            if (object.offset != null)
                if ($util.Long)
                    (message.offset = $util.Long.fromValue(object.offset)).unsigned = true;
                else if (typeof object.offset === "string")
                    message.offset = parseInt(object.offset, 10);
                else if (typeof object.offset === "number")
                    message.offset = object.offset;
                else if (typeof object.offset === "object")
                    message.offset = new $util.LongBits(object.offset.low >>> 0, object.offset.high >>> 0).toNumber(true);
            if (object.key != null)
                if (typeof object.key === "string")
                    $util.base64.decode(object.key, message.key = $util.newBuffer($util.base64.length(object.key)), 0);
                else if (object.key.length >= 0)
                    message.key = object.key;
            if (object.iv != null)
                if (typeof object.iv === "string")
                    $util.base64.decode(object.iv, message.iv = $util.newBuffer($util.base64.length(object.iv)), 0);
                else if (object.iv.length >= 0)
                    message.iv = object.iv;
            if (object.hash != null)
                if (typeof object.hash === "string")
                    $util.base64.decode(object.hash, message.hash = $util.newBuffer($util.base64.length(object.hash)), 0);
                else if (object.hash.length >= 0)
                    message.hash = object.hash;
            return message;
        };

        /**
         * Creates a plain object from a Chunk message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.Chunk
         * @static
         * @param {request.Chunk} message Chunk
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Chunk.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if (options.bytes === String)
                    object.id = "";
                else {
                    object.id = [];
                    if (options.bytes !== Array)
                        object.id = $util.newBuffer(object.id);
                }
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.size = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.size = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.offset = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.offset = options.longs === String ? "0" : 0;
                if (options.bytes === String)
                    object.hash = "";
                else {
                    object.hash = [];
                    if (options.bytes !== Array)
                        object.hash = $util.newBuffer(object.hash);
                }
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = options.bytes === String ? $util.base64.encode(message.id, 0, message.id.length) : options.bytes === Array ? Array.prototype.slice.call(message.id) : message.id;
            if (message.size != null && message.hasOwnProperty("size"))
                if (typeof message.size === "number")
                    object.size = options.longs === String ? String(message.size) : message.size;
                else
                    object.size = options.longs === String ? $util.Long.prototype.toString.call(message.size) : options.longs === Number ? new $util.LongBits(message.size.low >>> 0, message.size.high >>> 0).toNumber(true) : message.size;
            if (message.offset != null && message.hasOwnProperty("offset"))
                if (typeof message.offset === "number")
                    object.offset = options.longs === String ? String(message.offset) : message.offset;
                else
                    object.offset = options.longs === String ? $util.Long.prototype.toString.call(message.offset) : options.longs === Number ? new $util.LongBits(message.offset.low >>> 0, message.offset.high >>> 0).toNumber(true) : message.offset;
            if (message.iv != null && message.hasOwnProperty("iv")) {
                object.iv = options.bytes === String ? $util.base64.encode(message.iv, 0, message.iv.length) : options.bytes === Array ? Array.prototype.slice.call(message.iv) : message.iv;
                if (options.oneofs)
                    object._iv = "iv";
            }
            if (message.hash != null && message.hasOwnProperty("hash"))
                object.hash = options.bytes === String ? $util.base64.encode(message.hash, 0, message.hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.hash) : message.hash;
            if (message.key != null && message.hasOwnProperty("key")) {
                object.key = options.bytes === String ? $util.base64.encode(message.key, 0, message.key.length) : options.bytes === Array ? Array.prototype.slice.call(message.key) : message.key;
                if (options.oneofs)
                    object._key = "key";
            }
            return object;
        };

        /**
         * Converts this Chunk to JSON.
         * @function toJSON
         * @memberof request.Chunk
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Chunk.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Chunk
         * @function getTypeUrl
         * @memberof request.Chunk
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Chunk.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.Chunk";
        };

        return Chunk;
    })();

    request.FileVersion = (function() {

        /**
         * Properties of a FileVersion.
         * @memberof request
         * @interface IFileVersion
         * @property {string|null} [id] FileVersion id
         * @property {Array.<request.IChunk>|null} [chunks] FileVersion chunks
         * @property {number|Long|null} [creationDate] FileVersion creationDate
         */

        /**
         * Constructs a new FileVersion.
         * @memberof request
         * @classdesc Represents a FileVersion.
         * @implements IFileVersion
         * @constructor
         * @param {request.IFileVersion=} [properties] Properties to set
         */
        function FileVersion(properties) {
            this.chunks = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * FileVersion id.
         * @member {string} id
         * @memberof request.FileVersion
         * @instance
         */
        FileVersion.prototype.id = "";

        /**
         * FileVersion chunks.
         * @member {Array.<request.IChunk>} chunks
         * @memberof request.FileVersion
         * @instance
         */
        FileVersion.prototype.chunks = $util.emptyArray;

        /**
         * FileVersion creationDate.
         * @member {number|Long} creationDate
         * @memberof request.FileVersion
         * @instance
         */
        FileVersion.prototype.creationDate = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new FileVersion instance using the specified properties.
         * @function create
         * @memberof request.FileVersion
         * @static
         * @param {request.IFileVersion=} [properties] Properties to set
         * @returns {request.FileVersion} FileVersion instance
         */
        FileVersion.create = function create(properties) {
            return new FileVersion(properties);
        };

        /**
         * Encodes the specified FileVersion message. Does not implicitly {@link request.FileVersion.verify|verify} messages.
         * @function encode
         * @memberof request.FileVersion
         * @static
         * @param {request.IFileVersion} message FileVersion message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FileVersion.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.chunks != null && message.chunks.length)
                for (let i = 0; i < message.chunks.length; ++i)
                    $root.request.Chunk.encode(message.chunks[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.creationDate != null && Object.hasOwnProperty.call(message, "creationDate"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.creationDate);
            return writer;
        };

        /**
         * Encodes the specified FileVersion message, length delimited. Does not implicitly {@link request.FileVersion.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.FileVersion
         * @static
         * @param {request.IFileVersion} message FileVersion message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FileVersion.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a FileVersion message from the specified reader or buffer.
         * @function decode
         * @memberof request.FileVersion
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.FileVersion} FileVersion
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FileVersion.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.FileVersion();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.id = reader.string();
                        break;
                    }
                case 2: {
                        if (!(message.chunks && message.chunks.length))
                            message.chunks = [];
                        message.chunks.push($root.request.Chunk.decode(reader, reader.uint32()));
                        break;
                    }
                case 3: {
                        message.creationDate = reader.uint64();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a FileVersion message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.FileVersion
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.FileVersion} FileVersion
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FileVersion.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a FileVersion message.
         * @function verify
         * @memberof request.FileVersion
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        FileVersion.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.chunks != null && message.hasOwnProperty("chunks")) {
                if (!Array.isArray(message.chunks))
                    return "chunks: array expected";
                for (let i = 0; i < message.chunks.length; ++i) {
                    let error = $root.request.Chunk.verify(message.chunks[i]);
                    if (error)
                        return "chunks." + error;
                }
            }
            if (message.creationDate != null && message.hasOwnProperty("creationDate"))
                if (!$util.isInteger(message.creationDate) && !(message.creationDate && $util.isInteger(message.creationDate.low) && $util.isInteger(message.creationDate.high)))
                    return "creationDate: integer|Long expected";
            return null;
        };

        /**
         * Creates a FileVersion message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.FileVersion
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.FileVersion} FileVersion
         */
        FileVersion.fromObject = function fromObject(object) {
            if (object instanceof $root.request.FileVersion)
                return object;
            let message = new $root.request.FileVersion();
            if (object.id != null)
                message.id = String(object.id);
            if (object.chunks) {
                if (!Array.isArray(object.chunks))
                    throw TypeError(".request.FileVersion.chunks: array expected");
                message.chunks = [];
                for (let i = 0; i < object.chunks.length; ++i) {
                    if (typeof object.chunks[i] !== "object")
                        throw TypeError(".request.FileVersion.chunks: object expected");
                    message.chunks[i] = $root.request.Chunk.fromObject(object.chunks[i]);
                }
            }
            if (object.creationDate != null)
                if ($util.Long)
                    (message.creationDate = $util.Long.fromValue(object.creationDate)).unsigned = true;
                else if (typeof object.creationDate === "string")
                    message.creationDate = parseInt(object.creationDate, 10);
                else if (typeof object.creationDate === "number")
                    message.creationDate = object.creationDate;
                else if (typeof object.creationDate === "object")
                    message.creationDate = new $util.LongBits(object.creationDate.low >>> 0, object.creationDate.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a FileVersion message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.FileVersion
         * @static
         * @param {request.FileVersion} message FileVersion
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FileVersion.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.chunks = [];
            if (options.defaults) {
                object.id = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.creationDate = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.creationDate = options.longs === String ? "0" : 0;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.chunks && message.chunks.length) {
                object.chunks = [];
                for (let j = 0; j < message.chunks.length; ++j)
                    object.chunks[j] = $root.request.Chunk.toObject(message.chunks[j], options);
            }
            if (message.creationDate != null && message.hasOwnProperty("creationDate"))
                if (typeof message.creationDate === "number")
                    object.creationDate = options.longs === String ? String(message.creationDate) : message.creationDate;
                else
                    object.creationDate = options.longs === String ? $util.Long.prototype.toString.call(message.creationDate) : options.longs === Number ? new $util.LongBits(message.creationDate.low >>> 0, message.creationDate.high >>> 0).toNumber(true) : message.creationDate;
            return object;
        };

        /**
         * Converts this FileVersion to JSON.
         * @function toJSON
         * @memberof request.FileVersion
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FileVersion.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for FileVersion
         * @function getTypeUrl
         * @memberof request.FileVersion
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        FileVersion.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.FileVersion";
        };

        return FileVersion;
    })();

    request.File = (function() {

        /**
         * Properties of a File.
         * @memberof request
         * @interface IFile
         * @property {string|null} [name] File name
         * @property {Uint8Array|null} [parentUuid] File parentUuid
         * @property {Uint8Array|null} [uuid] File uuid
         * @property {string|null} [owner] File owner
         * @property {number|Long|null} [creationDate] File creationDate
         * @property {number|Long|null} [lastModifiedDate] File lastModifiedDate
         * @property {Array.<request.IFileVersion>|null} [versions] File versions
         * @property {request.IFileVersion|null} [currentVersion] File currentVersion
         * @property {boolean|null} [isLocked] File isLocked
         * @property {string|null} [lockReason] File lockReason
         * @property {Array.<string>|null} [tags] File tags
         * @property {number|Long|null} [filesize] File filesize
         * @property {boolean|null} [isClone] File isClone
         */

        /**
         * Constructs a new File.
         * @memberof request
         * @classdesc Represents a File.
         * @implements IFile
         * @constructor
         * @param {request.IFile=} [properties] Properties to set
         */
        function File(properties) {
            this.versions = [];
            this.tags = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * File name.
         * @member {string} name
         * @memberof request.File
         * @instance
         */
        File.prototype.name = "";

        /**
         * File parentUuid.
         * @member {Uint8Array|null|undefined} parentUuid
         * @memberof request.File
         * @instance
         */
        File.prototype.parentUuid = null;

        /**
         * File uuid.
         * @member {Uint8Array} uuid
         * @memberof request.File
         * @instance
         */
        File.prototype.uuid = $util.newBuffer([]);

        /**
         * File owner.
         * @member {string} owner
         * @memberof request.File
         * @instance
         */
        File.prototype.owner = "";

        /**
         * File creationDate.
         * @member {number|Long} creationDate
         * @memberof request.File
         * @instance
         */
        File.prototype.creationDate = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * File lastModifiedDate.
         * @member {number|Long} lastModifiedDate
         * @memberof request.File
         * @instance
         */
        File.prototype.lastModifiedDate = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * File versions.
         * @member {Array.<request.IFileVersion>} versions
         * @memberof request.File
         * @instance
         */
        File.prototype.versions = $util.emptyArray;

        /**
         * File currentVersion.
         * @member {request.IFileVersion|null|undefined} currentVersion
         * @memberof request.File
         * @instance
         */
        File.prototype.currentVersion = null;

        /**
         * File isLocked.
         * @member {boolean} isLocked
         * @memberof request.File
         * @instance
         */
        File.prototype.isLocked = false;

        /**
         * File lockReason.
         * @member {string|null|undefined} lockReason
         * @memberof request.File
         * @instance
         */
        File.prototype.lockReason = null;

        /**
         * File tags.
         * @member {Array.<string>} tags
         * @memberof request.File
         * @instance
         */
        File.prototype.tags = $util.emptyArray;

        /**
         * File filesize.
         * @member {number|Long} filesize
         * @memberof request.File
         * @instance
         */
        File.prototype.filesize = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * File isClone.
         * @member {boolean} isClone
         * @memberof request.File
         * @instance
         */
        File.prototype.isClone = false;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(File.prototype, "_parentUuid", {
            get: $util.oneOfGetter($oneOfFields = ["parentUuid"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(File.prototype, "_lockReason", {
            get: $util.oneOfGetter($oneOfFields = ["lockReason"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new File instance using the specified properties.
         * @function create
         * @memberof request.File
         * @static
         * @param {request.IFile=} [properties] Properties to set
         * @returns {request.File} File instance
         */
        File.create = function create(properties) {
            return new File(properties);
        };

        /**
         * Encodes the specified File message. Does not implicitly {@link request.File.verify|verify} messages.
         * @function encode
         * @memberof request.File
         * @static
         * @param {request.IFile} message File message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        File.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
            if (message.parentUuid != null && Object.hasOwnProperty.call(message, "parentUuid"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.parentUuid);
            if (message.uuid != null && Object.hasOwnProperty.call(message, "uuid"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.uuid);
            if (message.owner != null && Object.hasOwnProperty.call(message, "owner"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.owner);
            if (message.creationDate != null && Object.hasOwnProperty.call(message, "creationDate"))
                writer.uint32(/* id 5, wireType 0 =*/40).uint64(message.creationDate);
            if (message.lastModifiedDate != null && Object.hasOwnProperty.call(message, "lastModifiedDate"))
                writer.uint32(/* id 6, wireType 0 =*/48).uint64(message.lastModifiedDate);
            if (message.versions != null && message.versions.length)
                for (let i = 0; i < message.versions.length; ++i)
                    $root.request.FileVersion.encode(message.versions[i], writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
            if (message.currentVersion != null && Object.hasOwnProperty.call(message, "currentVersion"))
                $root.request.FileVersion.encode(message.currentVersion, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
            if (message.isLocked != null && Object.hasOwnProperty.call(message, "isLocked"))
                writer.uint32(/* id 10, wireType 0 =*/80).bool(message.isLocked);
            if (message.lockReason != null && Object.hasOwnProperty.call(message, "lockReason"))
                writer.uint32(/* id 11, wireType 2 =*/90).string(message.lockReason);
            if (message.tags != null && message.tags.length)
                for (let i = 0; i < message.tags.length; ++i)
                    writer.uint32(/* id 12, wireType 2 =*/98).string(message.tags[i]);
            if (message.filesize != null && Object.hasOwnProperty.call(message, "filesize"))
                writer.uint32(/* id 13, wireType 0 =*/104).uint64(message.filesize);
            if (message.isClone != null && Object.hasOwnProperty.call(message, "isClone"))
                writer.uint32(/* id 14, wireType 0 =*/112).bool(message.isClone);
            return writer;
        };

        /**
         * Encodes the specified File message, length delimited. Does not implicitly {@link request.File.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.File
         * @static
         * @param {request.IFile} message File message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        File.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a File message from the specified reader or buffer.
         * @function decode
         * @memberof request.File
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.File} File
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        File.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.File();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.name = reader.string();
                        break;
                    }
                case 2: {
                        message.parentUuid = reader.bytes();
                        break;
                    }
                case 3: {
                        message.uuid = reader.bytes();
                        break;
                    }
                case 4: {
                        message.owner = reader.string();
                        break;
                    }
                case 5: {
                        message.creationDate = reader.uint64();
                        break;
                    }
                case 6: {
                        message.lastModifiedDate = reader.uint64();
                        break;
                    }
                case 7: {
                        if (!(message.versions && message.versions.length))
                            message.versions = [];
                        message.versions.push($root.request.FileVersion.decode(reader, reader.uint32()));
                        break;
                    }
                case 8: {
                        message.currentVersion = $root.request.FileVersion.decode(reader, reader.uint32());
                        break;
                    }
                case 10: {
                        message.isLocked = reader.bool();
                        break;
                    }
                case 11: {
                        message.lockReason = reader.string();
                        break;
                    }
                case 12: {
                        if (!(message.tags && message.tags.length))
                            message.tags = [];
                        message.tags.push(reader.string());
                        break;
                    }
                case 13: {
                        message.filesize = reader.uint64();
                        break;
                    }
                case 14: {
                        message.isClone = reader.bool();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a File message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.File
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.File} File
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        File.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a File message.
         * @function verify
         * @memberof request.File
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        File.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.parentUuid != null && message.hasOwnProperty("parentUuid")) {
                properties._parentUuid = 1;
                if (!(message.parentUuid && typeof message.parentUuid.length === "number" || $util.isString(message.parentUuid)))
                    return "parentUuid: buffer expected";
            }
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                if (!(message.uuid && typeof message.uuid.length === "number" || $util.isString(message.uuid)))
                    return "uuid: buffer expected";
            if (message.owner != null && message.hasOwnProperty("owner"))
                if (!$util.isString(message.owner))
                    return "owner: string expected";
            if (message.creationDate != null && message.hasOwnProperty("creationDate"))
                if (!$util.isInteger(message.creationDate) && !(message.creationDate && $util.isInteger(message.creationDate.low) && $util.isInteger(message.creationDate.high)))
                    return "creationDate: integer|Long expected";
            if (message.lastModifiedDate != null && message.hasOwnProperty("lastModifiedDate"))
                if (!$util.isInteger(message.lastModifiedDate) && !(message.lastModifiedDate && $util.isInteger(message.lastModifiedDate.low) && $util.isInteger(message.lastModifiedDate.high)))
                    return "lastModifiedDate: integer|Long expected";
            if (message.versions != null && message.hasOwnProperty("versions")) {
                if (!Array.isArray(message.versions))
                    return "versions: array expected";
                for (let i = 0; i < message.versions.length; ++i) {
                    let error = $root.request.FileVersion.verify(message.versions[i]);
                    if (error)
                        return "versions." + error;
                }
            }
            if (message.currentVersion != null && message.hasOwnProperty("currentVersion")) {
                let error = $root.request.FileVersion.verify(message.currentVersion);
                if (error)
                    return "currentVersion." + error;
            }
            if (message.isLocked != null && message.hasOwnProperty("isLocked"))
                if (typeof message.isLocked !== "boolean")
                    return "isLocked: boolean expected";
            if (message.lockReason != null && message.hasOwnProperty("lockReason")) {
                properties._lockReason = 1;
                if (!$util.isString(message.lockReason))
                    return "lockReason: string expected";
            }
            if (message.tags != null && message.hasOwnProperty("tags")) {
                if (!Array.isArray(message.tags))
                    return "tags: array expected";
                for (let i = 0; i < message.tags.length; ++i)
                    if (!$util.isString(message.tags[i]))
                        return "tags: string[] expected";
            }
            if (message.filesize != null && message.hasOwnProperty("filesize"))
                if (!$util.isInteger(message.filesize) && !(message.filesize && $util.isInteger(message.filesize.low) && $util.isInteger(message.filesize.high)))
                    return "filesize: integer|Long expected";
            if (message.isClone != null && message.hasOwnProperty("isClone"))
                if (typeof message.isClone !== "boolean")
                    return "isClone: boolean expected";
            return null;
        };

        /**
         * Creates a File message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.File
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.File} File
         */
        File.fromObject = function fromObject(object) {
            if (object instanceof $root.request.File)
                return object;
            let message = new $root.request.File();
            if (object.name != null)
                message.name = String(object.name);
            if (object.parentUuid != null)
                if (typeof object.parentUuid === "string")
                    $util.base64.decode(object.parentUuid, message.parentUuid = $util.newBuffer($util.base64.length(object.parentUuid)), 0);
                else if (object.parentUuid.length >= 0)
                    message.parentUuid = object.parentUuid;
            if (object.uuid != null)
                if (typeof object.uuid === "string")
                    $util.base64.decode(object.uuid, message.uuid = $util.newBuffer($util.base64.length(object.uuid)), 0);
                else if (object.uuid.length >= 0)
                    message.uuid = object.uuid;
            if (object.owner != null)
                message.owner = String(object.owner);
            if (object.creationDate != null)
                if ($util.Long)
                    (message.creationDate = $util.Long.fromValue(object.creationDate)).unsigned = true;
                else if (typeof object.creationDate === "string")
                    message.creationDate = parseInt(object.creationDate, 10);
                else if (typeof object.creationDate === "number")
                    message.creationDate = object.creationDate;
                else if (typeof object.creationDate === "object")
                    message.creationDate = new $util.LongBits(object.creationDate.low >>> 0, object.creationDate.high >>> 0).toNumber(true);
            if (object.lastModifiedDate != null)
                if ($util.Long)
                    (message.lastModifiedDate = $util.Long.fromValue(object.lastModifiedDate)).unsigned = true;
                else if (typeof object.lastModifiedDate === "string")
                    message.lastModifiedDate = parseInt(object.lastModifiedDate, 10);
                else if (typeof object.lastModifiedDate === "number")
                    message.lastModifiedDate = object.lastModifiedDate;
                else if (typeof object.lastModifiedDate === "object")
                    message.lastModifiedDate = new $util.LongBits(object.lastModifiedDate.low >>> 0, object.lastModifiedDate.high >>> 0).toNumber(true);
            if (object.versions) {
                if (!Array.isArray(object.versions))
                    throw TypeError(".request.File.versions: array expected");
                message.versions = [];
                for (let i = 0; i < object.versions.length; ++i) {
                    if (typeof object.versions[i] !== "object")
                        throw TypeError(".request.File.versions: object expected");
                    message.versions[i] = $root.request.FileVersion.fromObject(object.versions[i]);
                }
            }
            if (object.currentVersion != null) {
                if (typeof object.currentVersion !== "object")
                    throw TypeError(".request.File.currentVersion: object expected");
                message.currentVersion = $root.request.FileVersion.fromObject(object.currentVersion);
            }
            if (object.isLocked != null)
                message.isLocked = Boolean(object.isLocked);
            if (object.lockReason != null)
                message.lockReason = String(object.lockReason);
            if (object.tags) {
                if (!Array.isArray(object.tags))
                    throw TypeError(".request.File.tags: array expected");
                message.tags = [];
                for (let i = 0; i < object.tags.length; ++i)
                    message.tags[i] = String(object.tags[i]);
            }
            if (object.filesize != null)
                if ($util.Long)
                    (message.filesize = $util.Long.fromValue(object.filesize)).unsigned = true;
                else if (typeof object.filesize === "string")
                    message.filesize = parseInt(object.filesize, 10);
                else if (typeof object.filesize === "number")
                    message.filesize = object.filesize;
                else if (typeof object.filesize === "object")
                    message.filesize = new $util.LongBits(object.filesize.low >>> 0, object.filesize.high >>> 0).toNumber(true);
            if (object.isClone != null)
                message.isClone = Boolean(object.isClone);
            return message;
        };

        /**
         * Creates a plain object from a File message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.File
         * @static
         * @param {request.File} message File
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        File.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.versions = [];
                object.tags = [];
            }
            if (options.defaults) {
                object.name = "";
                if (options.bytes === String)
                    object.uuid = "";
                else {
                    object.uuid = [];
                    if (options.bytes !== Array)
                        object.uuid = $util.newBuffer(object.uuid);
                }
                object.owner = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.creationDate = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.creationDate = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.lastModifiedDate = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.lastModifiedDate = options.longs === String ? "0" : 0;
                object.currentVersion = null;
                object.isLocked = false;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.filesize = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.filesize = options.longs === String ? "0" : 0;
                object.isClone = false;
            }
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.parentUuid != null && message.hasOwnProperty("parentUuid")) {
                object.parentUuid = options.bytes === String ? $util.base64.encode(message.parentUuid, 0, message.parentUuid.length) : options.bytes === Array ? Array.prototype.slice.call(message.parentUuid) : message.parentUuid;
                if (options.oneofs)
                    object._parentUuid = "parentUuid";
            }
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                object.uuid = options.bytes === String ? $util.base64.encode(message.uuid, 0, message.uuid.length) : options.bytes === Array ? Array.prototype.slice.call(message.uuid) : message.uuid;
            if (message.owner != null && message.hasOwnProperty("owner"))
                object.owner = message.owner;
            if (message.creationDate != null && message.hasOwnProperty("creationDate"))
                if (typeof message.creationDate === "number")
                    object.creationDate = options.longs === String ? String(message.creationDate) : message.creationDate;
                else
                    object.creationDate = options.longs === String ? $util.Long.prototype.toString.call(message.creationDate) : options.longs === Number ? new $util.LongBits(message.creationDate.low >>> 0, message.creationDate.high >>> 0).toNumber(true) : message.creationDate;
            if (message.lastModifiedDate != null && message.hasOwnProperty("lastModifiedDate"))
                if (typeof message.lastModifiedDate === "number")
                    object.lastModifiedDate = options.longs === String ? String(message.lastModifiedDate) : message.lastModifiedDate;
                else
                    object.lastModifiedDate = options.longs === String ? $util.Long.prototype.toString.call(message.lastModifiedDate) : options.longs === Number ? new $util.LongBits(message.lastModifiedDate.low >>> 0, message.lastModifiedDate.high >>> 0).toNumber(true) : message.lastModifiedDate;
            if (message.versions && message.versions.length) {
                object.versions = [];
                for (let j = 0; j < message.versions.length; ++j)
                    object.versions[j] = $root.request.FileVersion.toObject(message.versions[j], options);
            }
            if (message.currentVersion != null && message.hasOwnProperty("currentVersion"))
                object.currentVersion = $root.request.FileVersion.toObject(message.currentVersion, options);
            if (message.isLocked != null && message.hasOwnProperty("isLocked"))
                object.isLocked = message.isLocked;
            if (message.lockReason != null && message.hasOwnProperty("lockReason")) {
                object.lockReason = message.lockReason;
                if (options.oneofs)
                    object._lockReason = "lockReason";
            }
            if (message.tags && message.tags.length) {
                object.tags = [];
                for (let j = 0; j < message.tags.length; ++j)
                    object.tags[j] = message.tags[j];
            }
            if (message.filesize != null && message.hasOwnProperty("filesize"))
                if (typeof message.filesize === "number")
                    object.filesize = options.longs === String ? String(message.filesize) : message.filesize;
                else
                    object.filesize = options.longs === String ? $util.Long.prototype.toString.call(message.filesize) : options.longs === Number ? new $util.LongBits(message.filesize.low >>> 0, message.filesize.high >>> 0).toNumber(true) : message.filesize;
            if (message.isClone != null && message.hasOwnProperty("isClone"))
                object.isClone = message.isClone;
            return object;
        };

        /**
         * Converts this File to JSON.
         * @function toJSON
         * @memberof request.File
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        File.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for File
         * @function getTypeUrl
         * @memberof request.File
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        File.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.File";
        };

        return File;
    })();

    request.FileLock = (function() {

        /**
         * Properties of a FileLock.
         * @memberof request
         * @interface IFileLock
         * @property {Uint8Array|null} [uuid] FileLock uuid
         */

        /**
         * Constructs a new FileLock.
         * @memberof request
         * @classdesc Represents a FileLock.
         * @implements IFileLock
         * @constructor
         * @param {request.IFileLock=} [properties] Properties to set
         */
        function FileLock(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * FileLock uuid.
         * @member {Uint8Array} uuid
         * @memberof request.FileLock
         * @instance
         */
        FileLock.prototype.uuid = $util.newBuffer([]);

        /**
         * Creates a new FileLock instance using the specified properties.
         * @function create
         * @memberof request.FileLock
         * @static
         * @param {request.IFileLock=} [properties] Properties to set
         * @returns {request.FileLock} FileLock instance
         */
        FileLock.create = function create(properties) {
            return new FileLock(properties);
        };

        /**
         * Encodes the specified FileLock message. Does not implicitly {@link request.FileLock.verify|verify} messages.
         * @function encode
         * @memberof request.FileLock
         * @static
         * @param {request.IFileLock} message FileLock message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FileLock.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uuid != null && Object.hasOwnProperty.call(message, "uuid"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.uuid);
            return writer;
        };

        /**
         * Encodes the specified FileLock message, length delimited. Does not implicitly {@link request.FileLock.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.FileLock
         * @static
         * @param {request.IFileLock} message FileLock message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FileLock.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a FileLock message from the specified reader or buffer.
         * @function decode
         * @memberof request.FileLock
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.FileLock} FileLock
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FileLock.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.FileLock();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.uuid = reader.bytes();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a FileLock message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.FileLock
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.FileLock} FileLock
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FileLock.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a FileLock message.
         * @function verify
         * @memberof request.FileLock
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        FileLock.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                if (!(message.uuid && typeof message.uuid.length === "number" || $util.isString(message.uuid)))
                    return "uuid: buffer expected";
            return null;
        };

        /**
         * Creates a FileLock message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.FileLock
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.FileLock} FileLock
         */
        FileLock.fromObject = function fromObject(object) {
            if (object instanceof $root.request.FileLock)
                return object;
            let message = new $root.request.FileLock();
            if (object.uuid != null)
                if (typeof object.uuid === "string")
                    $util.base64.decode(object.uuid, message.uuid = $util.newBuffer($util.base64.length(object.uuid)), 0);
                else if (object.uuid.length >= 0)
                    message.uuid = object.uuid;
            return message;
        };

        /**
         * Creates a plain object from a FileLock message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.FileLock
         * @static
         * @param {request.FileLock} message FileLock
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FileLock.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                if (options.bytes === String)
                    object.uuid = "";
                else {
                    object.uuid = [];
                    if (options.bytes !== Array)
                        object.uuid = $util.newBuffer(object.uuid);
                }
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                object.uuid = options.bytes === String ? $util.base64.encode(message.uuid, 0, message.uuid.length) : options.bytes === Array ? Array.prototype.slice.call(message.uuid) : message.uuid;
            return object;
        };

        /**
         * Converts this FileLock to JSON.
         * @function toJSON
         * @memberof request.FileLock
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FileLock.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for FileLock
         * @function getTypeUrl
         * @memberof request.FileLock
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        FileLock.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.FileLock";
        };

        return FileLock;
    })();

    request.FileUnlock = (function() {

        /**
         * Properties of a FileUnlock.
         * @memberof request
         * @interface IFileUnlock
         * @property {Uint8Array|null} [uuid] FileUnlock uuid
         */

        /**
         * Constructs a new FileUnlock.
         * @memberof request
         * @classdesc Represents a FileUnlock.
         * @implements IFileUnlock
         * @constructor
         * @param {request.IFileUnlock=} [properties] Properties to set
         */
        function FileUnlock(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * FileUnlock uuid.
         * @member {Uint8Array} uuid
         * @memberof request.FileUnlock
         * @instance
         */
        FileUnlock.prototype.uuid = $util.newBuffer([]);

        /**
         * Creates a new FileUnlock instance using the specified properties.
         * @function create
         * @memberof request.FileUnlock
         * @static
         * @param {request.IFileUnlock=} [properties] Properties to set
         * @returns {request.FileUnlock} FileUnlock instance
         */
        FileUnlock.create = function create(properties) {
            return new FileUnlock(properties);
        };

        /**
         * Encodes the specified FileUnlock message. Does not implicitly {@link request.FileUnlock.verify|verify} messages.
         * @function encode
         * @memberof request.FileUnlock
         * @static
         * @param {request.IFileUnlock} message FileUnlock message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FileUnlock.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uuid != null && Object.hasOwnProperty.call(message, "uuid"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.uuid);
            return writer;
        };

        /**
         * Encodes the specified FileUnlock message, length delimited. Does not implicitly {@link request.FileUnlock.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.FileUnlock
         * @static
         * @param {request.IFileUnlock} message FileUnlock message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FileUnlock.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a FileUnlock message from the specified reader or buffer.
         * @function decode
         * @memberof request.FileUnlock
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.FileUnlock} FileUnlock
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FileUnlock.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.FileUnlock();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.uuid = reader.bytes();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a FileUnlock message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.FileUnlock
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.FileUnlock} FileUnlock
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FileUnlock.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a FileUnlock message.
         * @function verify
         * @memberof request.FileUnlock
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        FileUnlock.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                if (!(message.uuid && typeof message.uuid.length === "number" || $util.isString(message.uuid)))
                    return "uuid: buffer expected";
            return null;
        };

        /**
         * Creates a FileUnlock message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.FileUnlock
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.FileUnlock} FileUnlock
         */
        FileUnlock.fromObject = function fromObject(object) {
            if (object instanceof $root.request.FileUnlock)
                return object;
            let message = new $root.request.FileUnlock();
            if (object.uuid != null)
                if (typeof object.uuid === "string")
                    $util.base64.decode(object.uuid, message.uuid = $util.newBuffer($util.base64.length(object.uuid)), 0);
                else if (object.uuid.length >= 0)
                    message.uuid = object.uuid;
            return message;
        };

        /**
         * Creates a plain object from a FileUnlock message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.FileUnlock
         * @static
         * @param {request.FileUnlock} message FileUnlock
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FileUnlock.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                if (options.bytes === String)
                    object.uuid = "";
                else {
                    object.uuid = [];
                    if (options.bytes !== Array)
                        object.uuid = $util.newBuffer(object.uuid);
                }
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                object.uuid = options.bytes === String ? $util.base64.encode(message.uuid, 0, message.uuid.length) : options.bytes === Array ? Array.prototype.slice.call(message.uuid) : message.uuid;
            return object;
        };

        /**
         * Converts this FileUnlock to JSON.
         * @function toJSON
         * @memberof request.FileUnlock
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FileUnlock.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for FileUnlock
         * @function getTypeUrl
         * @memberof request.FileUnlock
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        FileUnlock.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.FileUnlock";
        };

        return FileUnlock;
    })();

    request.GetChunk = (function() {

        /**
         * Properties of a GetChunk.
         * @memberof request
         * @interface IGetChunk
         * @property {Uint8Array|null} [versionUuid] GetChunk versionUuid
         * @property {Uint8Array|null} [uuid] GetChunk uuid
         * @property {string|null} [fileFullPath] GetChunk fileFullPath
         * @property {request.ChunkFlags|null} [flag] GetChunk flag
         * @property {Uint8Array|null} [fileUuid] GetChunk fileUuid
         * @property {request.TypeOfPath|null} [typeOfPath] GetChunk typeOfPath
         */

        /**
         * Constructs a new GetChunk.
         * @memberof request
         * @classdesc Represents a GetChunk.
         * @implements IGetChunk
         * @constructor
         * @param {request.IGetChunk=} [properties] Properties to set
         */
        function GetChunk(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetChunk versionUuid.
         * @member {Uint8Array} versionUuid
         * @memberof request.GetChunk
         * @instance
         */
        GetChunk.prototype.versionUuid = $util.newBuffer([]);

        /**
         * GetChunk uuid.
         * @member {Uint8Array} uuid
         * @memberof request.GetChunk
         * @instance
         */
        GetChunk.prototype.uuid = $util.newBuffer([]);

        /**
         * GetChunk fileFullPath.
         * @member {string} fileFullPath
         * @memberof request.GetChunk
         * @instance
         */
        GetChunk.prototype.fileFullPath = "";

        /**
         * GetChunk flag.
         * @member {request.ChunkFlags} flag
         * @memberof request.GetChunk
         * @instance
         */
        GetChunk.prototype.flag = 0;

        /**
         * GetChunk fileUuid.
         * @member {Uint8Array} fileUuid
         * @memberof request.GetChunk
         * @instance
         */
        GetChunk.prototype.fileUuid = $util.newBuffer([]);

        /**
         * GetChunk typeOfPath.
         * @member {request.TypeOfPath} typeOfPath
         * @memberof request.GetChunk
         * @instance
         */
        GetChunk.prototype.typeOfPath = 0;

        /**
         * Creates a new GetChunk instance using the specified properties.
         * @function create
         * @memberof request.GetChunk
         * @static
         * @param {request.IGetChunk=} [properties] Properties to set
         * @returns {request.GetChunk} GetChunk instance
         */
        GetChunk.create = function create(properties) {
            return new GetChunk(properties);
        };

        /**
         * Encodes the specified GetChunk message. Does not implicitly {@link request.GetChunk.verify|verify} messages.
         * @function encode
         * @memberof request.GetChunk
         * @static
         * @param {request.IGetChunk} message GetChunk message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetChunk.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.versionUuid != null && Object.hasOwnProperty.call(message, "versionUuid"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.versionUuid);
            if (message.uuid != null && Object.hasOwnProperty.call(message, "uuid"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.uuid);
            if (message.fileFullPath != null && Object.hasOwnProperty.call(message, "fileFullPath"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.fileFullPath);
            if (message.flag != null && Object.hasOwnProperty.call(message, "flag"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.flag);
            if (message.fileUuid != null && Object.hasOwnProperty.call(message, "fileUuid"))
                writer.uint32(/* id 7, wireType 2 =*/58).bytes(message.fileUuid);
            if (message.typeOfPath != null && Object.hasOwnProperty.call(message, "typeOfPath"))
                writer.uint32(/* id 8, wireType 0 =*/64).int32(message.typeOfPath);
            return writer;
        };

        /**
         * Encodes the specified GetChunk message, length delimited. Does not implicitly {@link request.GetChunk.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.GetChunk
         * @static
         * @param {request.IGetChunk} message GetChunk message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetChunk.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetChunk message from the specified reader or buffer.
         * @function decode
         * @memberof request.GetChunk
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.GetChunk} GetChunk
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetChunk.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.GetChunk();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.versionUuid = reader.bytes();
                        break;
                    }
                case 2: {
                        message.uuid = reader.bytes();
                        break;
                    }
                case 3: {
                        message.fileFullPath = reader.string();
                        break;
                    }
                case 4: {
                        message.flag = reader.int32();
                        break;
                    }
                case 7: {
                        message.fileUuid = reader.bytes();
                        break;
                    }
                case 8: {
                        message.typeOfPath = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetChunk message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.GetChunk
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.GetChunk} GetChunk
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetChunk.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetChunk message.
         * @function verify
         * @memberof request.GetChunk
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetChunk.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.versionUuid != null && message.hasOwnProperty("versionUuid"))
                if (!(message.versionUuid && typeof message.versionUuid.length === "number" || $util.isString(message.versionUuid)))
                    return "versionUuid: buffer expected";
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                if (!(message.uuid && typeof message.uuid.length === "number" || $util.isString(message.uuid)))
                    return "uuid: buffer expected";
            if (message.fileFullPath != null && message.hasOwnProperty("fileFullPath"))
                if (!$util.isString(message.fileFullPath))
                    return "fileFullPath: string expected";
            if (message.flag != null && message.hasOwnProperty("flag"))
                switch (message.flag) {
                default:
                    return "flag: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            if (message.fileUuid != null && message.hasOwnProperty("fileUuid"))
                if (!(message.fileUuid && typeof message.fileUuid.length === "number" || $util.isString(message.fileUuid)))
                    return "fileUuid: buffer expected";
            if (message.typeOfPath != null && message.hasOwnProperty("typeOfPath"))
                switch (message.typeOfPath) {
                default:
                    return "typeOfPath: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                    break;
                }
            return null;
        };

        /**
         * Creates a GetChunk message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.GetChunk
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.GetChunk} GetChunk
         */
        GetChunk.fromObject = function fromObject(object) {
            if (object instanceof $root.request.GetChunk)
                return object;
            let message = new $root.request.GetChunk();
            if (object.versionUuid != null)
                if (typeof object.versionUuid === "string")
                    $util.base64.decode(object.versionUuid, message.versionUuid = $util.newBuffer($util.base64.length(object.versionUuid)), 0);
                else if (object.versionUuid.length >= 0)
                    message.versionUuid = object.versionUuid;
            if (object.uuid != null)
                if (typeof object.uuid === "string")
                    $util.base64.decode(object.uuid, message.uuid = $util.newBuffer($util.base64.length(object.uuid)), 0);
                else if (object.uuid.length >= 0)
                    message.uuid = object.uuid;
            if (object.fileFullPath != null)
                message.fileFullPath = String(object.fileFullPath);
            switch (object.flag) {
            default:
                if (typeof object.flag === "number") {
                    message.flag = object.flag;
                    break;
                }
                break;
            case "NONE":
            case 0:
                message.flag = 0;
                break;
            case "START":
            case 1:
                message.flag = 1;
                break;
            case "STOP":
            case 2:
                message.flag = 2;
                break;
            }
            if (object.fileUuid != null)
                if (typeof object.fileUuid === "string")
                    $util.base64.decode(object.fileUuid, message.fileUuid = $util.newBuffer($util.base64.length(object.fileUuid)), 0);
                else if (object.fileUuid.length >= 0)
                    message.fileUuid = object.fileUuid;
            switch (object.typeOfPath) {
            default:
                if (typeof object.typeOfPath === "number") {
                    message.typeOfPath = object.typeOfPath;
                    break;
                }
                break;
            case "TShareUser":
            case 0:
                message.typeOfPath = 0;
                break;
            case "TFolder":
            case 1:
                message.typeOfPath = 1;
                break;
            case "TShareTeam":
            case 2:
                message.typeOfPath = 2;
                break;
            case "TShareExternal":
            case 3:
                message.typeOfPath = 3;
                break;
            case "TFlow":
            case 4:
                message.typeOfPath = 4;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a GetChunk message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.GetChunk
         * @static
         * @param {request.GetChunk} message GetChunk
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetChunk.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if (options.bytes === String)
                    object.versionUuid = "";
                else {
                    object.versionUuid = [];
                    if (options.bytes !== Array)
                        object.versionUuid = $util.newBuffer(object.versionUuid);
                }
                if (options.bytes === String)
                    object.uuid = "";
                else {
                    object.uuid = [];
                    if (options.bytes !== Array)
                        object.uuid = $util.newBuffer(object.uuid);
                }
                object.fileFullPath = "";
                object.flag = options.enums === String ? "NONE" : 0;
                if (options.bytes === String)
                    object.fileUuid = "";
                else {
                    object.fileUuid = [];
                    if (options.bytes !== Array)
                        object.fileUuid = $util.newBuffer(object.fileUuid);
                }
                object.typeOfPath = options.enums === String ? "TShareUser" : 0;
            }
            if (message.versionUuid != null && message.hasOwnProperty("versionUuid"))
                object.versionUuid = options.bytes === String ? $util.base64.encode(message.versionUuid, 0, message.versionUuid.length) : options.bytes === Array ? Array.prototype.slice.call(message.versionUuid) : message.versionUuid;
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                object.uuid = options.bytes === String ? $util.base64.encode(message.uuid, 0, message.uuid.length) : options.bytes === Array ? Array.prototype.slice.call(message.uuid) : message.uuid;
            if (message.fileFullPath != null && message.hasOwnProperty("fileFullPath"))
                object.fileFullPath = message.fileFullPath;
            if (message.flag != null && message.hasOwnProperty("flag"))
                object.flag = options.enums === String ? $root.request.ChunkFlags[message.flag] === undefined ? message.flag : $root.request.ChunkFlags[message.flag] : message.flag;
            if (message.fileUuid != null && message.hasOwnProperty("fileUuid"))
                object.fileUuid = options.bytes === String ? $util.base64.encode(message.fileUuid, 0, message.fileUuid.length) : options.bytes === Array ? Array.prototype.slice.call(message.fileUuid) : message.fileUuid;
            if (message.typeOfPath != null && message.hasOwnProperty("typeOfPath"))
                object.typeOfPath = options.enums === String ? $root.request.TypeOfPath[message.typeOfPath] === undefined ? message.typeOfPath : $root.request.TypeOfPath[message.typeOfPath] : message.typeOfPath;
            return object;
        };

        /**
         * Converts this GetChunk to JSON.
         * @function toJSON
         * @memberof request.GetChunk
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetChunk.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetChunk
         * @function getTypeUrl
         * @memberof request.GetChunk
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetChunk.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.GetChunk";
        };

        return GetChunk;
    })();

    request.StartWrite = (function() {

        /**
         * Properties of a StartWrite.
         * @memberof request
         * @interface IStartWrite
         * @property {Uint8Array|null} [uuid] StartWrite uuid
         * @property {number|Long|null} [filesize] StartWrite filesize
         * @property {string|null} [parentPath] StartWrite parentPath
         * @property {string|null} [filename] StartWrite filename
         * @property {number|null} [compresstionType] StartWrite compresstionType
         * @property {number|Long|null} [chunkSize] StartWrite chunkSize
         * @property {request.TypeOfPath|null} [typeOfPath] StartWrite typeOfPath
         * @property {Uint8Array|null} [thumbNail] StartWrite thumbNail
         * @property {string|null} [fileType] StartWrite fileType
         */

        /**
         * Constructs a new StartWrite.
         * @memberof request
         * @classdesc Represents a StartWrite.
         * @implements IStartWrite
         * @constructor
         * @param {request.IStartWrite=} [properties] Properties to set
         */
        function StartWrite(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * StartWrite uuid.
         * @member {Uint8Array} uuid
         * @memberof request.StartWrite
         * @instance
         */
        StartWrite.prototype.uuid = $util.newBuffer([]);

        /**
         * StartWrite filesize.
         * @member {number|Long} filesize
         * @memberof request.StartWrite
         * @instance
         */
        StartWrite.prototype.filesize = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * StartWrite parentPath.
         * @member {string} parentPath
         * @memberof request.StartWrite
         * @instance
         */
        StartWrite.prototype.parentPath = "";

        /**
         * StartWrite filename.
         * @member {string|null|undefined} filename
         * @memberof request.StartWrite
         * @instance
         */
        StartWrite.prototype.filename = null;

        /**
         * StartWrite compresstionType.
         * @member {number} compresstionType
         * @memberof request.StartWrite
         * @instance
         */
        StartWrite.prototype.compresstionType = 0;

        /**
         * StartWrite chunkSize.
         * @member {number|Long} chunkSize
         * @memberof request.StartWrite
         * @instance
         */
        StartWrite.prototype.chunkSize = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * StartWrite typeOfPath.
         * @member {request.TypeOfPath} typeOfPath
         * @memberof request.StartWrite
         * @instance
         */
        StartWrite.prototype.typeOfPath = 0;

        /**
         * StartWrite thumbNail.
         * @member {Uint8Array} thumbNail
         * @memberof request.StartWrite
         * @instance
         */
        StartWrite.prototype.thumbNail = $util.newBuffer([]);

        /**
         * StartWrite fileType.
         * @member {string} fileType
         * @memberof request.StartWrite
         * @instance
         */
        StartWrite.prototype.fileType = "";

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(StartWrite.prototype, "_filename", {
            get: $util.oneOfGetter($oneOfFields = ["filename"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new StartWrite instance using the specified properties.
         * @function create
         * @memberof request.StartWrite
         * @static
         * @param {request.IStartWrite=} [properties] Properties to set
         * @returns {request.StartWrite} StartWrite instance
         */
        StartWrite.create = function create(properties) {
            return new StartWrite(properties);
        };

        /**
         * Encodes the specified StartWrite message. Does not implicitly {@link request.StartWrite.verify|verify} messages.
         * @function encode
         * @memberof request.StartWrite
         * @static
         * @param {request.IStartWrite} message StartWrite message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StartWrite.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uuid != null && Object.hasOwnProperty.call(message, "uuid"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.uuid);
            if (message.filesize != null && Object.hasOwnProperty.call(message, "filesize"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.filesize);
            if (message.parentPath != null && Object.hasOwnProperty.call(message, "parentPath"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.parentPath);
            if (message.filename != null && Object.hasOwnProperty.call(message, "filename"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.filename);
            if (message.compresstionType != null && Object.hasOwnProperty.call(message, "compresstionType"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.compresstionType);
            if (message.chunkSize != null && Object.hasOwnProperty.call(message, "chunkSize"))
                writer.uint32(/* id 6, wireType 0 =*/48).uint64(message.chunkSize);
            if (message.typeOfPath != null && Object.hasOwnProperty.call(message, "typeOfPath"))
                writer.uint32(/* id 8, wireType 0 =*/64).int32(message.typeOfPath);
            if (message.thumbNail != null && Object.hasOwnProperty.call(message, "thumbNail"))
                writer.uint32(/* id 9, wireType 2 =*/74).bytes(message.thumbNail);
            if (message.fileType != null && Object.hasOwnProperty.call(message, "fileType"))
                writer.uint32(/* id 10, wireType 2 =*/82).string(message.fileType);
            return writer;
        };

        /**
         * Encodes the specified StartWrite message, length delimited. Does not implicitly {@link request.StartWrite.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.StartWrite
         * @static
         * @param {request.IStartWrite} message StartWrite message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StartWrite.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a StartWrite message from the specified reader or buffer.
         * @function decode
         * @memberof request.StartWrite
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.StartWrite} StartWrite
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StartWrite.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.StartWrite();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.uuid = reader.bytes();
                        break;
                    }
                case 2: {
                        message.filesize = reader.uint64();
                        break;
                    }
                case 3: {
                        message.parentPath = reader.string();
                        break;
                    }
                case 4: {
                        message.filename = reader.string();
                        break;
                    }
                case 5: {
                        message.compresstionType = reader.int32();
                        break;
                    }
                case 6: {
                        message.chunkSize = reader.uint64();
                        break;
                    }
                case 8: {
                        message.typeOfPath = reader.int32();
                        break;
                    }
                case 9: {
                        message.thumbNail = reader.bytes();
                        break;
                    }
                case 10: {
                        message.fileType = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a StartWrite message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.StartWrite
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.StartWrite} StartWrite
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StartWrite.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a StartWrite message.
         * @function verify
         * @memberof request.StartWrite
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        StartWrite.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                if (!(message.uuid && typeof message.uuid.length === "number" || $util.isString(message.uuid)))
                    return "uuid: buffer expected";
            if (message.filesize != null && message.hasOwnProperty("filesize"))
                if (!$util.isInteger(message.filesize) && !(message.filesize && $util.isInteger(message.filesize.low) && $util.isInteger(message.filesize.high)))
                    return "filesize: integer|Long expected";
            if (message.parentPath != null && message.hasOwnProperty("parentPath"))
                if (!$util.isString(message.parentPath))
                    return "parentPath: string expected";
            if (message.filename != null && message.hasOwnProperty("filename")) {
                properties._filename = 1;
                if (!$util.isString(message.filename))
                    return "filename: string expected";
            }
            if (message.compresstionType != null && message.hasOwnProperty("compresstionType"))
                if (!$util.isInteger(message.compresstionType))
                    return "compresstionType: integer expected";
            if (message.chunkSize != null && message.hasOwnProperty("chunkSize"))
                if (!$util.isInteger(message.chunkSize) && !(message.chunkSize && $util.isInteger(message.chunkSize.low) && $util.isInteger(message.chunkSize.high)))
                    return "chunkSize: integer|Long expected";
            if (message.typeOfPath != null && message.hasOwnProperty("typeOfPath"))
                switch (message.typeOfPath) {
                default:
                    return "typeOfPath: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                    break;
                }
            if (message.thumbNail != null && message.hasOwnProperty("thumbNail"))
                if (!(message.thumbNail && typeof message.thumbNail.length === "number" || $util.isString(message.thumbNail)))
                    return "thumbNail: buffer expected";
            if (message.fileType != null && message.hasOwnProperty("fileType"))
                if (!$util.isString(message.fileType))
                    return "fileType: string expected";
            return null;
        };

        /**
         * Creates a StartWrite message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.StartWrite
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.StartWrite} StartWrite
         */
        StartWrite.fromObject = function fromObject(object) {
            if (object instanceof $root.request.StartWrite)
                return object;
            let message = new $root.request.StartWrite();
            if (object.uuid != null)
                if (typeof object.uuid === "string")
                    $util.base64.decode(object.uuid, message.uuid = $util.newBuffer($util.base64.length(object.uuid)), 0);
                else if (object.uuid.length >= 0)
                    message.uuid = object.uuid;
            if (object.filesize != null)
                if ($util.Long)
                    (message.filesize = $util.Long.fromValue(object.filesize)).unsigned = true;
                else if (typeof object.filesize === "string")
                    message.filesize = parseInt(object.filesize, 10);
                else if (typeof object.filesize === "number")
                    message.filesize = object.filesize;
                else if (typeof object.filesize === "object")
                    message.filesize = new $util.LongBits(object.filesize.low >>> 0, object.filesize.high >>> 0).toNumber(true);
            if (object.parentPath != null)
                message.parentPath = String(object.parentPath);
            if (object.filename != null)
                message.filename = String(object.filename);
            if (object.compresstionType != null)
                message.compresstionType = object.compresstionType | 0;
            if (object.chunkSize != null)
                if ($util.Long)
                    (message.chunkSize = $util.Long.fromValue(object.chunkSize)).unsigned = true;
                else if (typeof object.chunkSize === "string")
                    message.chunkSize = parseInt(object.chunkSize, 10);
                else if (typeof object.chunkSize === "number")
                    message.chunkSize = object.chunkSize;
                else if (typeof object.chunkSize === "object")
                    message.chunkSize = new $util.LongBits(object.chunkSize.low >>> 0, object.chunkSize.high >>> 0).toNumber(true);
            switch (object.typeOfPath) {
            default:
                if (typeof object.typeOfPath === "number") {
                    message.typeOfPath = object.typeOfPath;
                    break;
                }
                break;
            case "TShareUser":
            case 0:
                message.typeOfPath = 0;
                break;
            case "TFolder":
            case 1:
                message.typeOfPath = 1;
                break;
            case "TShareTeam":
            case 2:
                message.typeOfPath = 2;
                break;
            case "TShareExternal":
            case 3:
                message.typeOfPath = 3;
                break;
            case "TFlow":
            case 4:
                message.typeOfPath = 4;
                break;
            }
            if (object.thumbNail != null)
                if (typeof object.thumbNail === "string")
                    $util.base64.decode(object.thumbNail, message.thumbNail = $util.newBuffer($util.base64.length(object.thumbNail)), 0);
                else if (object.thumbNail.length >= 0)
                    message.thumbNail = object.thumbNail;
            if (object.fileType != null)
                message.fileType = String(object.fileType);
            return message;
        };

        /**
         * Creates a plain object from a StartWrite message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.StartWrite
         * @static
         * @param {request.StartWrite} message StartWrite
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        StartWrite.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if (options.bytes === String)
                    object.uuid = "";
                else {
                    object.uuid = [];
                    if (options.bytes !== Array)
                        object.uuid = $util.newBuffer(object.uuid);
                }
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.filesize = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.filesize = options.longs === String ? "0" : 0;
                object.parentPath = "";
                object.compresstionType = 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.chunkSize = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.chunkSize = options.longs === String ? "0" : 0;
                object.typeOfPath = options.enums === String ? "TShareUser" : 0;
                if (options.bytes === String)
                    object.thumbNail = "";
                else {
                    object.thumbNail = [];
                    if (options.bytes !== Array)
                        object.thumbNail = $util.newBuffer(object.thumbNail);
                }
                object.fileType = "";
            }
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                object.uuid = options.bytes === String ? $util.base64.encode(message.uuid, 0, message.uuid.length) : options.bytes === Array ? Array.prototype.slice.call(message.uuid) : message.uuid;
            if (message.filesize != null && message.hasOwnProperty("filesize"))
                if (typeof message.filesize === "number")
                    object.filesize = options.longs === String ? String(message.filesize) : message.filesize;
                else
                    object.filesize = options.longs === String ? $util.Long.prototype.toString.call(message.filesize) : options.longs === Number ? new $util.LongBits(message.filesize.low >>> 0, message.filesize.high >>> 0).toNumber(true) : message.filesize;
            if (message.parentPath != null && message.hasOwnProperty("parentPath"))
                object.parentPath = message.parentPath;
            if (message.filename != null && message.hasOwnProperty("filename")) {
                object.filename = message.filename;
                if (options.oneofs)
                    object._filename = "filename";
            }
            if (message.compresstionType != null && message.hasOwnProperty("compresstionType"))
                object.compresstionType = message.compresstionType;
            if (message.chunkSize != null && message.hasOwnProperty("chunkSize"))
                if (typeof message.chunkSize === "number")
                    object.chunkSize = options.longs === String ? String(message.chunkSize) : message.chunkSize;
                else
                    object.chunkSize = options.longs === String ? $util.Long.prototype.toString.call(message.chunkSize) : options.longs === Number ? new $util.LongBits(message.chunkSize.low >>> 0, message.chunkSize.high >>> 0).toNumber(true) : message.chunkSize;
            if (message.typeOfPath != null && message.hasOwnProperty("typeOfPath"))
                object.typeOfPath = options.enums === String ? $root.request.TypeOfPath[message.typeOfPath] === undefined ? message.typeOfPath : $root.request.TypeOfPath[message.typeOfPath] : message.typeOfPath;
            if (message.thumbNail != null && message.hasOwnProperty("thumbNail"))
                object.thumbNail = options.bytes === String ? $util.base64.encode(message.thumbNail, 0, message.thumbNail.length) : options.bytes === Array ? Array.prototype.slice.call(message.thumbNail) : message.thumbNail;
            if (message.fileType != null && message.hasOwnProperty("fileType"))
                object.fileType = message.fileType;
            return object;
        };

        /**
         * Converts this StartWrite to JSON.
         * @function toJSON
         * @memberof request.StartWrite
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        StartWrite.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for StartWrite
         * @function getTypeUrl
         * @memberof request.StartWrite
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        StartWrite.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.StartWrite";
        };

        return StartWrite;
    })();

    request.PutChunk = (function() {

        /**
         * Properties of a PutChunk.
         * @memberof request
         * @interface IPutChunk
         * @property {Uint8Array|null} [versionUuid] PutChunk versionUuid
         * @property {Uint8Array|null} [uuid] PutChunk uuid
         * @property {number|Long|null} [fileChunkOffset] PutChunk fileChunkOffset
         * @property {Uint8Array|null} [data] PutChunk data
         * @property {Uint8Array|null} [hash] PutChunk hash
         * @property {request.ChunkFlags|null} [flag] PutChunk flag
         */

        /**
         * Constructs a new PutChunk.
         * @memberof request
         * @classdesc Represents a PutChunk.
         * @implements IPutChunk
         * @constructor
         * @param {request.IPutChunk=} [properties] Properties to set
         */
        function PutChunk(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PutChunk versionUuid.
         * @member {Uint8Array|null|undefined} versionUuid
         * @memberof request.PutChunk
         * @instance
         */
        PutChunk.prototype.versionUuid = null;

        /**
         * PutChunk uuid.
         * @member {Uint8Array} uuid
         * @memberof request.PutChunk
         * @instance
         */
        PutChunk.prototype.uuid = $util.newBuffer([]);

        /**
         * PutChunk fileChunkOffset.
         * @member {number|Long|null|undefined} fileChunkOffset
         * @memberof request.PutChunk
         * @instance
         */
        PutChunk.prototype.fileChunkOffset = null;

        /**
         * PutChunk data.
         * @member {Uint8Array|null|undefined} data
         * @memberof request.PutChunk
         * @instance
         */
        PutChunk.prototype.data = null;

        /**
         * PutChunk hash.
         * @member {Uint8Array|null|undefined} hash
         * @memberof request.PutChunk
         * @instance
         */
        PutChunk.prototype.hash = null;

        /**
         * PutChunk flag.
         * @member {request.ChunkFlags} flag
         * @memberof request.PutChunk
         * @instance
         */
        PutChunk.prototype.flag = 0;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(PutChunk.prototype, "_versionUuid", {
            get: $util.oneOfGetter($oneOfFields = ["versionUuid"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(PutChunk.prototype, "_fileChunkOffset", {
            get: $util.oneOfGetter($oneOfFields = ["fileChunkOffset"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(PutChunk.prototype, "_data", {
            get: $util.oneOfGetter($oneOfFields = ["data"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(PutChunk.prototype, "_hash", {
            get: $util.oneOfGetter($oneOfFields = ["hash"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new PutChunk instance using the specified properties.
         * @function create
         * @memberof request.PutChunk
         * @static
         * @param {request.IPutChunk=} [properties] Properties to set
         * @returns {request.PutChunk} PutChunk instance
         */
        PutChunk.create = function create(properties) {
            return new PutChunk(properties);
        };

        /**
         * Encodes the specified PutChunk message. Does not implicitly {@link request.PutChunk.verify|verify} messages.
         * @function encode
         * @memberof request.PutChunk
         * @static
         * @param {request.IPutChunk} message PutChunk message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PutChunk.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.versionUuid != null && Object.hasOwnProperty.call(message, "versionUuid"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.versionUuid);
            if (message.uuid != null && Object.hasOwnProperty.call(message, "uuid"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.uuid);
            if (message.fileChunkOffset != null && Object.hasOwnProperty.call(message, "fileChunkOffset"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.fileChunkOffset);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.data);
            if (message.hash != null && Object.hasOwnProperty.call(message, "hash"))
                writer.uint32(/* id 5, wireType 2 =*/42).bytes(message.hash);
            if (message.flag != null && Object.hasOwnProperty.call(message, "flag"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.flag);
            return writer;
        };

        /**
         * Encodes the specified PutChunk message, length delimited. Does not implicitly {@link request.PutChunk.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.PutChunk
         * @static
         * @param {request.IPutChunk} message PutChunk message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PutChunk.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PutChunk message from the specified reader or buffer.
         * @function decode
         * @memberof request.PutChunk
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.PutChunk} PutChunk
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PutChunk.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.PutChunk();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.versionUuid = reader.bytes();
                        break;
                    }
                case 2: {
                        message.uuid = reader.bytes();
                        break;
                    }
                case 3: {
                        message.fileChunkOffset = reader.uint64();
                        break;
                    }
                case 4: {
                        message.data = reader.bytes();
                        break;
                    }
                case 5: {
                        message.hash = reader.bytes();
                        break;
                    }
                case 6: {
                        message.flag = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PutChunk message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.PutChunk
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.PutChunk} PutChunk
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PutChunk.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PutChunk message.
         * @function verify
         * @memberof request.PutChunk
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PutChunk.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.versionUuid != null && message.hasOwnProperty("versionUuid")) {
                properties._versionUuid = 1;
                if (!(message.versionUuid && typeof message.versionUuid.length === "number" || $util.isString(message.versionUuid)))
                    return "versionUuid: buffer expected";
            }
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                if (!(message.uuid && typeof message.uuid.length === "number" || $util.isString(message.uuid)))
                    return "uuid: buffer expected";
            if (message.fileChunkOffset != null && message.hasOwnProperty("fileChunkOffset")) {
                properties._fileChunkOffset = 1;
                if (!$util.isInteger(message.fileChunkOffset) && !(message.fileChunkOffset && $util.isInteger(message.fileChunkOffset.low) && $util.isInteger(message.fileChunkOffset.high)))
                    return "fileChunkOffset: integer|Long expected";
            }
            if (message.data != null && message.hasOwnProperty("data")) {
                properties._data = 1;
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            }
            if (message.hash != null && message.hasOwnProperty("hash")) {
                properties._hash = 1;
                if (!(message.hash && typeof message.hash.length === "number" || $util.isString(message.hash)))
                    return "hash: buffer expected";
            }
            if (message.flag != null && message.hasOwnProperty("flag"))
                switch (message.flag) {
                default:
                    return "flag: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            return null;
        };

        /**
         * Creates a PutChunk message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.PutChunk
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.PutChunk} PutChunk
         */
        PutChunk.fromObject = function fromObject(object) {
            if (object instanceof $root.request.PutChunk)
                return object;
            let message = new $root.request.PutChunk();
            if (object.versionUuid != null)
                if (typeof object.versionUuid === "string")
                    $util.base64.decode(object.versionUuid, message.versionUuid = $util.newBuffer($util.base64.length(object.versionUuid)), 0);
                else if (object.versionUuid.length >= 0)
                    message.versionUuid = object.versionUuid;
            if (object.uuid != null)
                if (typeof object.uuid === "string")
                    $util.base64.decode(object.uuid, message.uuid = $util.newBuffer($util.base64.length(object.uuid)), 0);
                else if (object.uuid.length >= 0)
                    message.uuid = object.uuid;
            if (object.fileChunkOffset != null)
                if ($util.Long)
                    (message.fileChunkOffset = $util.Long.fromValue(object.fileChunkOffset)).unsigned = true;
                else if (typeof object.fileChunkOffset === "string")
                    message.fileChunkOffset = parseInt(object.fileChunkOffset, 10);
                else if (typeof object.fileChunkOffset === "number")
                    message.fileChunkOffset = object.fileChunkOffset;
                else if (typeof object.fileChunkOffset === "object")
                    message.fileChunkOffset = new $util.LongBits(object.fileChunkOffset.low >>> 0, object.fileChunkOffset.high >>> 0).toNumber(true);
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            if (object.hash != null)
                if (typeof object.hash === "string")
                    $util.base64.decode(object.hash, message.hash = $util.newBuffer($util.base64.length(object.hash)), 0);
                else if (object.hash.length >= 0)
                    message.hash = object.hash;
            switch (object.flag) {
            default:
                if (typeof object.flag === "number") {
                    message.flag = object.flag;
                    break;
                }
                break;
            case "NONE":
            case 0:
                message.flag = 0;
                break;
            case "START":
            case 1:
                message.flag = 1;
                break;
            case "STOP":
            case 2:
                message.flag = 2;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a PutChunk message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.PutChunk
         * @static
         * @param {request.PutChunk} message PutChunk
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PutChunk.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if (options.bytes === String)
                    object.uuid = "";
                else {
                    object.uuid = [];
                    if (options.bytes !== Array)
                        object.uuid = $util.newBuffer(object.uuid);
                }
                object.flag = options.enums === String ? "NONE" : 0;
            }
            if (message.versionUuid != null && message.hasOwnProperty("versionUuid")) {
                object.versionUuid = options.bytes === String ? $util.base64.encode(message.versionUuid, 0, message.versionUuid.length) : options.bytes === Array ? Array.prototype.slice.call(message.versionUuid) : message.versionUuid;
                if (options.oneofs)
                    object._versionUuid = "versionUuid";
            }
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                object.uuid = options.bytes === String ? $util.base64.encode(message.uuid, 0, message.uuid.length) : options.bytes === Array ? Array.prototype.slice.call(message.uuid) : message.uuid;
            if (message.fileChunkOffset != null && message.hasOwnProperty("fileChunkOffset")) {
                if (typeof message.fileChunkOffset === "number")
                    object.fileChunkOffset = options.longs === String ? String(message.fileChunkOffset) : message.fileChunkOffset;
                else
                    object.fileChunkOffset = options.longs === String ? $util.Long.prototype.toString.call(message.fileChunkOffset) : options.longs === Number ? new $util.LongBits(message.fileChunkOffset.low >>> 0, message.fileChunkOffset.high >>> 0).toNumber(true) : message.fileChunkOffset;
                if (options.oneofs)
                    object._fileChunkOffset = "fileChunkOffset";
            }
            if (message.data != null && message.hasOwnProperty("data")) {
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
                if (options.oneofs)
                    object._data = "data";
            }
            if (message.hash != null && message.hasOwnProperty("hash")) {
                object.hash = options.bytes === String ? $util.base64.encode(message.hash, 0, message.hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.hash) : message.hash;
                if (options.oneofs)
                    object._hash = "hash";
            }
            if (message.flag != null && message.hasOwnProperty("flag"))
                object.flag = options.enums === String ? $root.request.ChunkFlags[message.flag] === undefined ? message.flag : $root.request.ChunkFlags[message.flag] : message.flag;
            return object;
        };

        /**
         * Converts this PutChunk to JSON.
         * @function toJSON
         * @memberof request.PutChunk
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PutChunk.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for PutChunk
         * @function getTypeUrl
         * @memberof request.PutChunk
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        PutChunk.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.PutChunk";
        };

        return PutChunk;
    })();

    /**
     * ChunkFlags enum.
     * @name request.ChunkFlags
     * @enum {number}
     * @property {number} NONE=0 NONE value
     * @property {number} START=1 START value
     * @property {number} STOP=2 STOP value
     */
    request.ChunkFlags = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "NONE"] = 0;
        values[valuesById[1] = "START"] = 1;
        values[valuesById[2] = "STOP"] = 2;
        return values;
    })();

    request.ResetVersion = (function() {

        /**
         * Properties of a ResetVersion.
         * @memberof request
         * @interface IResetVersion
         * @property {string|null} [filePath] ResetVersion filePath
         * @property {Uint8Array|null} [versionId] ResetVersion versionId
         */

        /**
         * Constructs a new ResetVersion.
         * @memberof request
         * @classdesc Represents a ResetVersion.
         * @implements IResetVersion
         * @constructor
         * @param {request.IResetVersion=} [properties] Properties to set
         */
        function ResetVersion(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ResetVersion filePath.
         * @member {string} filePath
         * @memberof request.ResetVersion
         * @instance
         */
        ResetVersion.prototype.filePath = "";

        /**
         * ResetVersion versionId.
         * @member {Uint8Array} versionId
         * @memberof request.ResetVersion
         * @instance
         */
        ResetVersion.prototype.versionId = $util.newBuffer([]);

        /**
         * Creates a new ResetVersion instance using the specified properties.
         * @function create
         * @memberof request.ResetVersion
         * @static
         * @param {request.IResetVersion=} [properties] Properties to set
         * @returns {request.ResetVersion} ResetVersion instance
         */
        ResetVersion.create = function create(properties) {
            return new ResetVersion(properties);
        };

        /**
         * Encodes the specified ResetVersion message. Does not implicitly {@link request.ResetVersion.verify|verify} messages.
         * @function encode
         * @memberof request.ResetVersion
         * @static
         * @param {request.IResetVersion} message ResetVersion message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ResetVersion.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.filePath != null && Object.hasOwnProperty.call(message, "filePath"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.filePath);
            if (message.versionId != null && Object.hasOwnProperty.call(message, "versionId"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.versionId);
            return writer;
        };

        /**
         * Encodes the specified ResetVersion message, length delimited. Does not implicitly {@link request.ResetVersion.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.ResetVersion
         * @static
         * @param {request.IResetVersion} message ResetVersion message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ResetVersion.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ResetVersion message from the specified reader or buffer.
         * @function decode
         * @memberof request.ResetVersion
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.ResetVersion} ResetVersion
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ResetVersion.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.ResetVersion();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.filePath = reader.string();
                        break;
                    }
                case 2: {
                        message.versionId = reader.bytes();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ResetVersion message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.ResetVersion
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.ResetVersion} ResetVersion
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ResetVersion.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ResetVersion message.
         * @function verify
         * @memberof request.ResetVersion
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ResetVersion.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.filePath != null && message.hasOwnProperty("filePath"))
                if (!$util.isString(message.filePath))
                    return "filePath: string expected";
            if (message.versionId != null && message.hasOwnProperty("versionId"))
                if (!(message.versionId && typeof message.versionId.length === "number" || $util.isString(message.versionId)))
                    return "versionId: buffer expected";
            return null;
        };

        /**
         * Creates a ResetVersion message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.ResetVersion
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.ResetVersion} ResetVersion
         */
        ResetVersion.fromObject = function fromObject(object) {
            if (object instanceof $root.request.ResetVersion)
                return object;
            let message = new $root.request.ResetVersion();
            if (object.filePath != null)
                message.filePath = String(object.filePath);
            if (object.versionId != null)
                if (typeof object.versionId === "string")
                    $util.base64.decode(object.versionId, message.versionId = $util.newBuffer($util.base64.length(object.versionId)), 0);
                else if (object.versionId.length >= 0)
                    message.versionId = object.versionId;
            return message;
        };

        /**
         * Creates a plain object from a ResetVersion message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.ResetVersion
         * @static
         * @param {request.ResetVersion} message ResetVersion
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ResetVersion.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.filePath = "";
                if (options.bytes === String)
                    object.versionId = "";
                else {
                    object.versionId = [];
                    if (options.bytes !== Array)
                        object.versionId = $util.newBuffer(object.versionId);
                }
            }
            if (message.filePath != null && message.hasOwnProperty("filePath"))
                object.filePath = message.filePath;
            if (message.versionId != null && message.hasOwnProperty("versionId"))
                object.versionId = options.bytes === String ? $util.base64.encode(message.versionId, 0, message.versionId.length) : options.bytes === Array ? Array.prototype.slice.call(message.versionId) : message.versionId;
            return object;
        };

        /**
         * Converts this ResetVersion to JSON.
         * @function toJSON
         * @memberof request.ResetVersion
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ResetVersion.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ResetVersion
         * @function getTypeUrl
         * @memberof request.ResetVersion
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ResetVersion.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.ResetVersion";
        };

        return ResetVersion;
    })();

    request.FinalizeWrite = (function() {

        /**
         * Properties of a FinalizeWrite.
         * @memberof request
         * @interface IFinalizeWrite
         * @property {Uint8Array|null} [uuid] FinalizeWrite uuid
         * @property {Uint8Array|null} [versionUuid] FinalizeWrite versionUuid
         * @property {number|Long|null} [fileSize] FinalizeWrite fileSize
         * @property {Array.<string>|null} [tags] FinalizeWrite tags
         * @property {string|null} [fileType] FinalizeWrite fileType
         */

        /**
         * Constructs a new FinalizeWrite.
         * @memberof request
         * @classdesc Represents a FinalizeWrite.
         * @implements IFinalizeWrite
         * @constructor
         * @param {request.IFinalizeWrite=} [properties] Properties to set
         */
        function FinalizeWrite(properties) {
            this.tags = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * FinalizeWrite uuid.
         * @member {Uint8Array} uuid
         * @memberof request.FinalizeWrite
         * @instance
         */
        FinalizeWrite.prototype.uuid = $util.newBuffer([]);

        /**
         * FinalizeWrite versionUuid.
         * @member {Uint8Array|null|undefined} versionUuid
         * @memberof request.FinalizeWrite
         * @instance
         */
        FinalizeWrite.prototype.versionUuid = null;

        /**
         * FinalizeWrite fileSize.
         * @member {number|Long} fileSize
         * @memberof request.FinalizeWrite
         * @instance
         */
        FinalizeWrite.prototype.fileSize = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * FinalizeWrite tags.
         * @member {Array.<string>} tags
         * @memberof request.FinalizeWrite
         * @instance
         */
        FinalizeWrite.prototype.tags = $util.emptyArray;

        /**
         * FinalizeWrite fileType.
         * @member {string} fileType
         * @memberof request.FinalizeWrite
         * @instance
         */
        FinalizeWrite.prototype.fileType = "";

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(FinalizeWrite.prototype, "_versionUuid", {
            get: $util.oneOfGetter($oneOfFields = ["versionUuid"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new FinalizeWrite instance using the specified properties.
         * @function create
         * @memberof request.FinalizeWrite
         * @static
         * @param {request.IFinalizeWrite=} [properties] Properties to set
         * @returns {request.FinalizeWrite} FinalizeWrite instance
         */
        FinalizeWrite.create = function create(properties) {
            return new FinalizeWrite(properties);
        };

        /**
         * Encodes the specified FinalizeWrite message. Does not implicitly {@link request.FinalizeWrite.verify|verify} messages.
         * @function encode
         * @memberof request.FinalizeWrite
         * @static
         * @param {request.IFinalizeWrite} message FinalizeWrite message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FinalizeWrite.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uuid != null && Object.hasOwnProperty.call(message, "uuid"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.uuid);
            if (message.versionUuid != null && Object.hasOwnProperty.call(message, "versionUuid"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.versionUuid);
            if (message.fileSize != null && Object.hasOwnProperty.call(message, "fileSize"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.fileSize);
            if (message.tags != null && message.tags.length)
                for (let i = 0; i < message.tags.length; ++i)
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.tags[i]);
            if (message.fileType != null && Object.hasOwnProperty.call(message, "fileType"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.fileType);
            return writer;
        };

        /**
         * Encodes the specified FinalizeWrite message, length delimited. Does not implicitly {@link request.FinalizeWrite.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.FinalizeWrite
         * @static
         * @param {request.IFinalizeWrite} message FinalizeWrite message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FinalizeWrite.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a FinalizeWrite message from the specified reader or buffer.
         * @function decode
         * @memberof request.FinalizeWrite
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.FinalizeWrite} FinalizeWrite
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FinalizeWrite.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.FinalizeWrite();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.uuid = reader.bytes();
                        break;
                    }
                case 2: {
                        message.versionUuid = reader.bytes();
                        break;
                    }
                case 3: {
                        message.fileSize = reader.uint64();
                        break;
                    }
                case 4: {
                        if (!(message.tags && message.tags.length))
                            message.tags = [];
                        message.tags.push(reader.string());
                        break;
                    }
                case 5: {
                        message.fileType = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a FinalizeWrite message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.FinalizeWrite
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.FinalizeWrite} FinalizeWrite
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FinalizeWrite.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a FinalizeWrite message.
         * @function verify
         * @memberof request.FinalizeWrite
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        FinalizeWrite.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                if (!(message.uuid && typeof message.uuid.length === "number" || $util.isString(message.uuid)))
                    return "uuid: buffer expected";
            if (message.versionUuid != null && message.hasOwnProperty("versionUuid")) {
                properties._versionUuid = 1;
                if (!(message.versionUuid && typeof message.versionUuid.length === "number" || $util.isString(message.versionUuid)))
                    return "versionUuid: buffer expected";
            }
            if (message.fileSize != null && message.hasOwnProperty("fileSize"))
                if (!$util.isInteger(message.fileSize) && !(message.fileSize && $util.isInteger(message.fileSize.low) && $util.isInteger(message.fileSize.high)))
                    return "fileSize: integer|Long expected";
            if (message.tags != null && message.hasOwnProperty("tags")) {
                if (!Array.isArray(message.tags))
                    return "tags: array expected";
                for (let i = 0; i < message.tags.length; ++i)
                    if (!$util.isString(message.tags[i]))
                        return "tags: string[] expected";
            }
            if (message.fileType != null && message.hasOwnProperty("fileType"))
                if (!$util.isString(message.fileType))
                    return "fileType: string expected";
            return null;
        };

        /**
         * Creates a FinalizeWrite message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.FinalizeWrite
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.FinalizeWrite} FinalizeWrite
         */
        FinalizeWrite.fromObject = function fromObject(object) {
            if (object instanceof $root.request.FinalizeWrite)
                return object;
            let message = new $root.request.FinalizeWrite();
            if (object.uuid != null)
                if (typeof object.uuid === "string")
                    $util.base64.decode(object.uuid, message.uuid = $util.newBuffer($util.base64.length(object.uuid)), 0);
                else if (object.uuid.length >= 0)
                    message.uuid = object.uuid;
            if (object.versionUuid != null)
                if (typeof object.versionUuid === "string")
                    $util.base64.decode(object.versionUuid, message.versionUuid = $util.newBuffer($util.base64.length(object.versionUuid)), 0);
                else if (object.versionUuid.length >= 0)
                    message.versionUuid = object.versionUuid;
            if (object.fileSize != null)
                if ($util.Long)
                    (message.fileSize = $util.Long.fromValue(object.fileSize)).unsigned = true;
                else if (typeof object.fileSize === "string")
                    message.fileSize = parseInt(object.fileSize, 10);
                else if (typeof object.fileSize === "number")
                    message.fileSize = object.fileSize;
                else if (typeof object.fileSize === "object")
                    message.fileSize = new $util.LongBits(object.fileSize.low >>> 0, object.fileSize.high >>> 0).toNumber(true);
            if (object.tags) {
                if (!Array.isArray(object.tags))
                    throw TypeError(".request.FinalizeWrite.tags: array expected");
                message.tags = [];
                for (let i = 0; i < object.tags.length; ++i)
                    message.tags[i] = String(object.tags[i]);
            }
            if (object.fileType != null)
                message.fileType = String(object.fileType);
            return message;
        };

        /**
         * Creates a plain object from a FinalizeWrite message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.FinalizeWrite
         * @static
         * @param {request.FinalizeWrite} message FinalizeWrite
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FinalizeWrite.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.tags = [];
            if (options.defaults) {
                if (options.bytes === String)
                    object.uuid = "";
                else {
                    object.uuid = [];
                    if (options.bytes !== Array)
                        object.uuid = $util.newBuffer(object.uuid);
                }
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.fileSize = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.fileSize = options.longs === String ? "0" : 0;
                object.fileType = "";
            }
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                object.uuid = options.bytes === String ? $util.base64.encode(message.uuid, 0, message.uuid.length) : options.bytes === Array ? Array.prototype.slice.call(message.uuid) : message.uuid;
            if (message.versionUuid != null && message.hasOwnProperty("versionUuid")) {
                object.versionUuid = options.bytes === String ? $util.base64.encode(message.versionUuid, 0, message.versionUuid.length) : options.bytes === Array ? Array.prototype.slice.call(message.versionUuid) : message.versionUuid;
                if (options.oneofs)
                    object._versionUuid = "versionUuid";
            }
            if (message.fileSize != null && message.hasOwnProperty("fileSize"))
                if (typeof message.fileSize === "number")
                    object.fileSize = options.longs === String ? String(message.fileSize) : message.fileSize;
                else
                    object.fileSize = options.longs === String ? $util.Long.prototype.toString.call(message.fileSize) : options.longs === Number ? new $util.LongBits(message.fileSize.low >>> 0, message.fileSize.high >>> 0).toNumber(true) : message.fileSize;
            if (message.tags && message.tags.length) {
                object.tags = [];
                for (let j = 0; j < message.tags.length; ++j)
                    object.tags[j] = message.tags[j];
            }
            if (message.fileType != null && message.hasOwnProperty("fileType"))
                object.fileType = message.fileType;
            return object;
        };

        /**
         * Converts this FinalizeWrite to JSON.
         * @function toJSON
         * @memberof request.FinalizeWrite
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FinalizeWrite.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for FinalizeWrite
         * @function getTypeUrl
         * @memberof request.FinalizeWrite
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        FinalizeWrite.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.FinalizeWrite";
        };

        return FinalizeWrite;
    })();

    /**
     * OrderBy enum.
     * @name request.OrderBy
     * @enum {number}
     * @property {number} UPDATEDTIME=0 UPDATEDTIME value
     * @property {number} CREATEDTIME=1 CREATEDTIME value
     * @property {number} NAME=2 NAME value
     * @property {number} SIZE=3 SIZE value
     */
    request.OrderBy = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UPDATEDTIME"] = 0;
        values[valuesById[1] = "CREATEDTIME"] = 1;
        values[valuesById[2] = "NAME"] = 2;
        values[valuesById[3] = "SIZE"] = 3;
        return values;
    })();

    request.ListFiles = (function() {

        /**
         * Properties of a ListFiles.
         * @memberof request
         * @interface IListFiles
         * @property {Uint8Array|null} [parentUuid] ListFiles parentUuid
         * @property {string|null} [snapshotId] ListFiles snapshotId
         * @property {Uint8Array|null} [pageToken] ListFiles pageToken
         * @property {boolean|null} [trashed] ListFiles trashed
         * @property {number|Long|null} [pageSize] ListFiles pageSize
         * @property {request.OrderBy|null} [orderBy] ListFiles orderBy
         */

        /**
         * Constructs a new ListFiles.
         * @memberof request
         * @classdesc Represents a ListFiles.
         * @implements IListFiles
         * @constructor
         * @param {request.IListFiles=} [properties] Properties to set
         */
        function ListFiles(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListFiles parentUuid.
         * @member {Uint8Array|null|undefined} parentUuid
         * @memberof request.ListFiles
         * @instance
         */
        ListFiles.prototype.parentUuid = null;

        /**
         * ListFiles snapshotId.
         * @member {string|null|undefined} snapshotId
         * @memberof request.ListFiles
         * @instance
         */
        ListFiles.prototype.snapshotId = null;

        /**
         * ListFiles pageToken.
         * @member {Uint8Array|null|undefined} pageToken
         * @memberof request.ListFiles
         * @instance
         */
        ListFiles.prototype.pageToken = null;

        /**
         * ListFiles trashed.
         * @member {boolean|null|undefined} trashed
         * @memberof request.ListFiles
         * @instance
         */
        ListFiles.prototype.trashed = null;

        /**
         * ListFiles pageSize.
         * @member {number|Long|null|undefined} pageSize
         * @memberof request.ListFiles
         * @instance
         */
        ListFiles.prototype.pageSize = null;

        /**
         * ListFiles orderBy.
         * @member {request.OrderBy|null|undefined} orderBy
         * @memberof request.ListFiles
         * @instance
         */
        ListFiles.prototype.orderBy = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(ListFiles.prototype, "_parentUuid", {
            get: $util.oneOfGetter($oneOfFields = ["parentUuid"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(ListFiles.prototype, "_snapshotId", {
            get: $util.oneOfGetter($oneOfFields = ["snapshotId"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(ListFiles.prototype, "_pageToken", {
            get: $util.oneOfGetter($oneOfFields = ["pageToken"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(ListFiles.prototype, "_trashed", {
            get: $util.oneOfGetter($oneOfFields = ["trashed"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(ListFiles.prototype, "_pageSize", {
            get: $util.oneOfGetter($oneOfFields = ["pageSize"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(ListFiles.prototype, "_orderBy", {
            get: $util.oneOfGetter($oneOfFields = ["orderBy"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new ListFiles instance using the specified properties.
         * @function create
         * @memberof request.ListFiles
         * @static
         * @param {request.IListFiles=} [properties] Properties to set
         * @returns {request.ListFiles} ListFiles instance
         */
        ListFiles.create = function create(properties) {
            return new ListFiles(properties);
        };

        /**
         * Encodes the specified ListFiles message. Does not implicitly {@link request.ListFiles.verify|verify} messages.
         * @function encode
         * @memberof request.ListFiles
         * @static
         * @param {request.IListFiles} message ListFiles message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListFiles.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.parentUuid != null && Object.hasOwnProperty.call(message, "parentUuid"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.parentUuid);
            if (message.snapshotId != null && Object.hasOwnProperty.call(message, "snapshotId"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.snapshotId);
            if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.pageToken);
            if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.pageSize);
            if (message.trashed != null && Object.hasOwnProperty.call(message, "trashed"))
                writer.uint32(/* id 5, wireType 0 =*/40).bool(message.trashed);
            if (message.orderBy != null && Object.hasOwnProperty.call(message, "orderBy"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.orderBy);
            return writer;
        };

        /**
         * Encodes the specified ListFiles message, length delimited. Does not implicitly {@link request.ListFiles.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.ListFiles
         * @static
         * @param {request.IListFiles} message ListFiles message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListFiles.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ListFiles message from the specified reader or buffer.
         * @function decode
         * @memberof request.ListFiles
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.ListFiles} ListFiles
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListFiles.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.ListFiles();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.parentUuid = reader.bytes();
                        break;
                    }
                case 2: {
                        message.snapshotId = reader.string();
                        break;
                    }
                case 3: {
                        message.pageToken = reader.bytes();
                        break;
                    }
                case 5: {
                        message.trashed = reader.bool();
                        break;
                    }
                case 4: {
                        message.pageSize = reader.uint64();
                        break;
                    }
                case 6: {
                        message.orderBy = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ListFiles message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.ListFiles
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.ListFiles} ListFiles
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListFiles.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ListFiles message.
         * @function verify
         * @memberof request.ListFiles
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ListFiles.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.parentUuid != null && message.hasOwnProperty("parentUuid")) {
                properties._parentUuid = 1;
                if (!(message.parentUuid && typeof message.parentUuid.length === "number" || $util.isString(message.parentUuid)))
                    return "parentUuid: buffer expected";
            }
            if (message.snapshotId != null && message.hasOwnProperty("snapshotId")) {
                properties._snapshotId = 1;
                if (!$util.isString(message.snapshotId))
                    return "snapshotId: string expected";
            }
            if (message.pageToken != null && message.hasOwnProperty("pageToken")) {
                properties._pageToken = 1;
                if (!(message.pageToken && typeof message.pageToken.length === "number" || $util.isString(message.pageToken)))
                    return "pageToken: buffer expected";
            }
            if (message.trashed != null && message.hasOwnProperty("trashed")) {
                properties._trashed = 1;
                if (typeof message.trashed !== "boolean")
                    return "trashed: boolean expected";
            }
            if (message.pageSize != null && message.hasOwnProperty("pageSize")) {
                properties._pageSize = 1;
                if (!$util.isInteger(message.pageSize) && !(message.pageSize && $util.isInteger(message.pageSize.low) && $util.isInteger(message.pageSize.high)))
                    return "pageSize: integer|Long expected";
            }
            if (message.orderBy != null && message.hasOwnProperty("orderBy")) {
                properties._orderBy = 1;
                switch (message.orderBy) {
                default:
                    return "orderBy: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            }
            return null;
        };

        /**
         * Creates a ListFiles message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.ListFiles
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.ListFiles} ListFiles
         */
        ListFiles.fromObject = function fromObject(object) {
            if (object instanceof $root.request.ListFiles)
                return object;
            let message = new $root.request.ListFiles();
            if (object.parentUuid != null)
                if (typeof object.parentUuid === "string")
                    $util.base64.decode(object.parentUuid, message.parentUuid = $util.newBuffer($util.base64.length(object.parentUuid)), 0);
                else if (object.parentUuid.length >= 0)
                    message.parentUuid = object.parentUuid;
            if (object.snapshotId != null)
                message.snapshotId = String(object.snapshotId);
            if (object.pageToken != null)
                if (typeof object.pageToken === "string")
                    $util.base64.decode(object.pageToken, message.pageToken = $util.newBuffer($util.base64.length(object.pageToken)), 0);
                else if (object.pageToken.length >= 0)
                    message.pageToken = object.pageToken;
            if (object.trashed != null)
                message.trashed = Boolean(object.trashed);
            if (object.pageSize != null)
                if ($util.Long)
                    (message.pageSize = $util.Long.fromValue(object.pageSize)).unsigned = true;
                else if (typeof object.pageSize === "string")
                    message.pageSize = parseInt(object.pageSize, 10);
                else if (typeof object.pageSize === "number")
                    message.pageSize = object.pageSize;
                else if (typeof object.pageSize === "object")
                    message.pageSize = new $util.LongBits(object.pageSize.low >>> 0, object.pageSize.high >>> 0).toNumber(true);
            switch (object.orderBy) {
            default:
                if (typeof object.orderBy === "number") {
                    message.orderBy = object.orderBy;
                    break;
                }
                break;
            case "UPDATEDTIME":
            case 0:
                message.orderBy = 0;
                break;
            case "CREATEDTIME":
            case 1:
                message.orderBy = 1;
                break;
            case "NAME":
            case 2:
                message.orderBy = 2;
                break;
            case "SIZE":
            case 3:
                message.orderBy = 3;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a ListFiles message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.ListFiles
         * @static
         * @param {request.ListFiles} message ListFiles
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListFiles.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (message.parentUuid != null && message.hasOwnProperty("parentUuid")) {
                object.parentUuid = options.bytes === String ? $util.base64.encode(message.parentUuid, 0, message.parentUuid.length) : options.bytes === Array ? Array.prototype.slice.call(message.parentUuid) : message.parentUuid;
                if (options.oneofs)
                    object._parentUuid = "parentUuid";
            }
            if (message.snapshotId != null && message.hasOwnProperty("snapshotId")) {
                object.snapshotId = message.snapshotId;
                if (options.oneofs)
                    object._snapshotId = "snapshotId";
            }
            if (message.pageToken != null && message.hasOwnProperty("pageToken")) {
                object.pageToken = options.bytes === String ? $util.base64.encode(message.pageToken, 0, message.pageToken.length) : options.bytes === Array ? Array.prototype.slice.call(message.pageToken) : message.pageToken;
                if (options.oneofs)
                    object._pageToken = "pageToken";
            }
            if (message.pageSize != null && message.hasOwnProperty("pageSize")) {
                if (typeof message.pageSize === "number")
                    object.pageSize = options.longs === String ? String(message.pageSize) : message.pageSize;
                else
                    object.pageSize = options.longs === String ? $util.Long.prototype.toString.call(message.pageSize) : options.longs === Number ? new $util.LongBits(message.pageSize.low >>> 0, message.pageSize.high >>> 0).toNumber(true) : message.pageSize;
                if (options.oneofs)
                    object._pageSize = "pageSize";
            }
            if (message.trashed != null && message.hasOwnProperty("trashed")) {
                object.trashed = message.trashed;
                if (options.oneofs)
                    object._trashed = "trashed";
            }
            if (message.orderBy != null && message.hasOwnProperty("orderBy")) {
                object.orderBy = options.enums === String ? $root.request.OrderBy[message.orderBy] === undefined ? message.orderBy : $root.request.OrderBy[message.orderBy] : message.orderBy;
                if (options.oneofs)
                    object._orderBy = "orderBy";
            }
            return object;
        };

        /**
         * Converts this ListFiles to JSON.
         * @function toJSON
         * @memberof request.ListFiles
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListFiles.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ListFiles
         * @function getTypeUrl
         * @memberof request.ListFiles
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ListFiles.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.ListFiles";
        };

        return ListFiles;
    })();

    request.GetMetaFromPath = (function() {

        /**
         * Properties of a GetMetaFromPath.
         * @memberof request
         * @interface IGetMetaFromPath
         * @property {string|null} [path] GetMetaFromPath path
         * @property {boolean|null} [trashed] GetMetaFromPath trashed
         * @property {request.TypeOfPath|null} [typeOfPath] GetMetaFromPath typeOfPath
         * @property {Array.<string>|null} [tags] GetMetaFromPath tags
         * @property {string|null} [fileType] GetMetaFromPath fileType
         */

        /**
         * Constructs a new GetMetaFromPath.
         * @memberof request
         * @classdesc Represents a GetMetaFromPath.
         * @implements IGetMetaFromPath
         * @constructor
         * @param {request.IGetMetaFromPath=} [properties] Properties to set
         */
        function GetMetaFromPath(properties) {
            this.tags = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetMetaFromPath path.
         * @member {string} path
         * @memberof request.GetMetaFromPath
         * @instance
         */
        GetMetaFromPath.prototype.path = "";

        /**
         * GetMetaFromPath trashed.
         * @member {boolean} trashed
         * @memberof request.GetMetaFromPath
         * @instance
         */
        GetMetaFromPath.prototype.trashed = false;

        /**
         * GetMetaFromPath typeOfPath.
         * @member {request.TypeOfPath} typeOfPath
         * @memberof request.GetMetaFromPath
         * @instance
         */
        GetMetaFromPath.prototype.typeOfPath = 0;

        /**
         * GetMetaFromPath tags.
         * @member {Array.<string>} tags
         * @memberof request.GetMetaFromPath
         * @instance
         */
        GetMetaFromPath.prototype.tags = $util.emptyArray;

        /**
         * GetMetaFromPath fileType.
         * @member {string} fileType
         * @memberof request.GetMetaFromPath
         * @instance
         */
        GetMetaFromPath.prototype.fileType = "";

        /**
         * Creates a new GetMetaFromPath instance using the specified properties.
         * @function create
         * @memberof request.GetMetaFromPath
         * @static
         * @param {request.IGetMetaFromPath=} [properties] Properties to set
         * @returns {request.GetMetaFromPath} GetMetaFromPath instance
         */
        GetMetaFromPath.create = function create(properties) {
            return new GetMetaFromPath(properties);
        };

        /**
         * Encodes the specified GetMetaFromPath message. Does not implicitly {@link request.GetMetaFromPath.verify|verify} messages.
         * @function encode
         * @memberof request.GetMetaFromPath
         * @static
         * @param {request.IGetMetaFromPath} message GetMetaFromPath message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetMetaFromPath.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.path != null && Object.hasOwnProperty.call(message, "path"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.path);
            if (message.trashed != null && Object.hasOwnProperty.call(message, "trashed"))
                writer.uint32(/* id 2, wireType 0 =*/16).bool(message.trashed);
            if (message.typeOfPath != null && Object.hasOwnProperty.call(message, "typeOfPath"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.typeOfPath);
            if (message.tags != null && message.tags.length)
                for (let i = 0; i < message.tags.length; ++i)
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.tags[i]);
            if (message.fileType != null && Object.hasOwnProperty.call(message, "fileType"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.fileType);
            return writer;
        };

        /**
         * Encodes the specified GetMetaFromPath message, length delimited. Does not implicitly {@link request.GetMetaFromPath.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.GetMetaFromPath
         * @static
         * @param {request.IGetMetaFromPath} message GetMetaFromPath message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetMetaFromPath.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetMetaFromPath message from the specified reader or buffer.
         * @function decode
         * @memberof request.GetMetaFromPath
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.GetMetaFromPath} GetMetaFromPath
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetMetaFromPath.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.GetMetaFromPath();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.path = reader.string();
                        break;
                    }
                case 2: {
                        message.trashed = reader.bool();
                        break;
                    }
                case 3: {
                        message.typeOfPath = reader.int32();
                        break;
                    }
                case 4: {
                        if (!(message.tags && message.tags.length))
                            message.tags = [];
                        message.tags.push(reader.string());
                        break;
                    }
                case 5: {
                        message.fileType = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetMetaFromPath message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.GetMetaFromPath
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.GetMetaFromPath} GetMetaFromPath
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetMetaFromPath.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetMetaFromPath message.
         * @function verify
         * @memberof request.GetMetaFromPath
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetMetaFromPath.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.path != null && message.hasOwnProperty("path"))
                if (!$util.isString(message.path))
                    return "path: string expected";
            if (message.trashed != null && message.hasOwnProperty("trashed"))
                if (typeof message.trashed !== "boolean")
                    return "trashed: boolean expected";
            if (message.typeOfPath != null && message.hasOwnProperty("typeOfPath"))
                switch (message.typeOfPath) {
                default:
                    return "typeOfPath: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                    break;
                }
            if (message.tags != null && message.hasOwnProperty("tags")) {
                if (!Array.isArray(message.tags))
                    return "tags: array expected";
                for (let i = 0; i < message.tags.length; ++i)
                    if (!$util.isString(message.tags[i]))
                        return "tags: string[] expected";
            }
            if (message.fileType != null && message.hasOwnProperty("fileType"))
                if (!$util.isString(message.fileType))
                    return "fileType: string expected";
            return null;
        };

        /**
         * Creates a GetMetaFromPath message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.GetMetaFromPath
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.GetMetaFromPath} GetMetaFromPath
         */
        GetMetaFromPath.fromObject = function fromObject(object) {
            if (object instanceof $root.request.GetMetaFromPath)
                return object;
            let message = new $root.request.GetMetaFromPath();
            if (object.path != null)
                message.path = String(object.path);
            if (object.trashed != null)
                message.trashed = Boolean(object.trashed);
            switch (object.typeOfPath) {
            default:
                if (typeof object.typeOfPath === "number") {
                    message.typeOfPath = object.typeOfPath;
                    break;
                }
                break;
            case "TShareUser":
            case 0:
                message.typeOfPath = 0;
                break;
            case "TFolder":
            case 1:
                message.typeOfPath = 1;
                break;
            case "TShareTeam":
            case 2:
                message.typeOfPath = 2;
                break;
            case "TShareExternal":
            case 3:
                message.typeOfPath = 3;
                break;
            case "TFlow":
            case 4:
                message.typeOfPath = 4;
                break;
            }
            if (object.tags) {
                if (!Array.isArray(object.tags))
                    throw TypeError(".request.GetMetaFromPath.tags: array expected");
                message.tags = [];
                for (let i = 0; i < object.tags.length; ++i)
                    message.tags[i] = String(object.tags[i]);
            }
            if (object.fileType != null)
                message.fileType = String(object.fileType);
            return message;
        };

        /**
         * Creates a plain object from a GetMetaFromPath message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.GetMetaFromPath
         * @static
         * @param {request.GetMetaFromPath} message GetMetaFromPath
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetMetaFromPath.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.tags = [];
            if (options.defaults) {
                object.path = "";
                object.trashed = false;
                object.typeOfPath = options.enums === String ? "TShareUser" : 0;
                object.fileType = "";
            }
            if (message.path != null && message.hasOwnProperty("path"))
                object.path = message.path;
            if (message.trashed != null && message.hasOwnProperty("trashed"))
                object.trashed = message.trashed;
            if (message.typeOfPath != null && message.hasOwnProperty("typeOfPath"))
                object.typeOfPath = options.enums === String ? $root.request.TypeOfPath[message.typeOfPath] === undefined ? message.typeOfPath : $root.request.TypeOfPath[message.typeOfPath] : message.typeOfPath;
            if (message.tags && message.tags.length) {
                object.tags = [];
                for (let j = 0; j < message.tags.length; ++j)
                    object.tags[j] = message.tags[j];
            }
            if (message.fileType != null && message.hasOwnProperty("fileType"))
                object.fileType = message.fileType;
            return object;
        };

        /**
         * Converts this GetMetaFromPath to JSON.
         * @function toJSON
         * @memberof request.GetMetaFromPath
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetMetaFromPath.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetMetaFromPath
         * @function getTypeUrl
         * @memberof request.GetMetaFromPath
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetMetaFromPath.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.GetMetaFromPath";
        };

        return GetMetaFromPath;
    })();

    request.GetProfileFileMeta = (function() {

        /**
         * Properties of a GetProfileFileMeta.
         * @memberof request
         * @interface IGetProfileFileMeta
         * @property {string|null} [name] GetProfileFileMeta name
         */

        /**
         * Constructs a new GetProfileFileMeta.
         * @memberof request
         * @classdesc Represents a GetProfileFileMeta.
         * @implements IGetProfileFileMeta
         * @constructor
         * @param {request.IGetProfileFileMeta=} [properties] Properties to set
         */
        function GetProfileFileMeta(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetProfileFileMeta name.
         * @member {string} name
         * @memberof request.GetProfileFileMeta
         * @instance
         */
        GetProfileFileMeta.prototype.name = "";

        /**
         * Creates a new GetProfileFileMeta instance using the specified properties.
         * @function create
         * @memberof request.GetProfileFileMeta
         * @static
         * @param {request.IGetProfileFileMeta=} [properties] Properties to set
         * @returns {request.GetProfileFileMeta} GetProfileFileMeta instance
         */
        GetProfileFileMeta.create = function create(properties) {
            return new GetProfileFileMeta(properties);
        };

        /**
         * Encodes the specified GetProfileFileMeta message. Does not implicitly {@link request.GetProfileFileMeta.verify|verify} messages.
         * @function encode
         * @memberof request.GetProfileFileMeta
         * @static
         * @param {request.IGetProfileFileMeta} message GetProfileFileMeta message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetProfileFileMeta.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
            return writer;
        };

        /**
         * Encodes the specified GetProfileFileMeta message, length delimited. Does not implicitly {@link request.GetProfileFileMeta.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.GetProfileFileMeta
         * @static
         * @param {request.IGetProfileFileMeta} message GetProfileFileMeta message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetProfileFileMeta.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetProfileFileMeta message from the specified reader or buffer.
         * @function decode
         * @memberof request.GetProfileFileMeta
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.GetProfileFileMeta} GetProfileFileMeta
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetProfileFileMeta.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.GetProfileFileMeta();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.name = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetProfileFileMeta message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.GetProfileFileMeta
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.GetProfileFileMeta} GetProfileFileMeta
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetProfileFileMeta.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetProfileFileMeta message.
         * @function verify
         * @memberof request.GetProfileFileMeta
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetProfileFileMeta.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            return null;
        };

        /**
         * Creates a GetProfileFileMeta message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.GetProfileFileMeta
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.GetProfileFileMeta} GetProfileFileMeta
         */
        GetProfileFileMeta.fromObject = function fromObject(object) {
            if (object instanceof $root.request.GetProfileFileMeta)
                return object;
            let message = new $root.request.GetProfileFileMeta();
            if (object.name != null)
                message.name = String(object.name);
            return message;
        };

        /**
         * Creates a plain object from a GetProfileFileMeta message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.GetProfileFileMeta
         * @static
         * @param {request.GetProfileFileMeta} message GetProfileFileMeta
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetProfileFileMeta.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.name = "";
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            return object;
        };

        /**
         * Converts this GetProfileFileMeta to JSON.
         * @function toJSON
         * @memberof request.GetProfileFileMeta
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetProfileFileMeta.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetProfileFileMeta
         * @function getTypeUrl
         * @memberof request.GetProfileFileMeta
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetProfileFileMeta.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.GetProfileFileMeta";
        };

        return GetProfileFileMeta;
    })();

    request.Remove = (function() {

        /**
         * Properties of a Remove.
         * @memberof request
         * @interface IRemove
         * @property {Uint8Array|null} [uuid] Remove uuid
         * @property {string|null} [versionId] Remove versionId
         */

        /**
         * Constructs a new Remove.
         * @memberof request
         * @classdesc Represents a Remove.
         * @implements IRemove
         * @constructor
         * @param {request.IRemove=} [properties] Properties to set
         */
        function Remove(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Remove uuid.
         * @member {Uint8Array} uuid
         * @memberof request.Remove
         * @instance
         */
        Remove.prototype.uuid = $util.newBuffer([]);

        /**
         * Remove versionId.
         * @member {string|null|undefined} versionId
         * @memberof request.Remove
         * @instance
         */
        Remove.prototype.versionId = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(Remove.prototype, "_versionId", {
            get: $util.oneOfGetter($oneOfFields = ["versionId"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new Remove instance using the specified properties.
         * @function create
         * @memberof request.Remove
         * @static
         * @param {request.IRemove=} [properties] Properties to set
         * @returns {request.Remove} Remove instance
         */
        Remove.create = function create(properties) {
            return new Remove(properties);
        };

        /**
         * Encodes the specified Remove message. Does not implicitly {@link request.Remove.verify|verify} messages.
         * @function encode
         * @memberof request.Remove
         * @static
         * @param {request.IRemove} message Remove message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Remove.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uuid != null && Object.hasOwnProperty.call(message, "uuid"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.uuid);
            if (message.versionId != null && Object.hasOwnProperty.call(message, "versionId"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.versionId);
            return writer;
        };

        /**
         * Encodes the specified Remove message, length delimited. Does not implicitly {@link request.Remove.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.Remove
         * @static
         * @param {request.IRemove} message Remove message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Remove.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Remove message from the specified reader or buffer.
         * @function decode
         * @memberof request.Remove
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.Remove} Remove
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Remove.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.Remove();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.uuid = reader.bytes();
                        break;
                    }
                case 2: {
                        message.versionId = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Remove message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.Remove
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.Remove} Remove
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Remove.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Remove message.
         * @function verify
         * @memberof request.Remove
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Remove.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                if (!(message.uuid && typeof message.uuid.length === "number" || $util.isString(message.uuid)))
                    return "uuid: buffer expected";
            if (message.versionId != null && message.hasOwnProperty("versionId")) {
                properties._versionId = 1;
                if (!$util.isString(message.versionId))
                    return "versionId: string expected";
            }
            return null;
        };

        /**
         * Creates a Remove message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.Remove
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.Remove} Remove
         */
        Remove.fromObject = function fromObject(object) {
            if (object instanceof $root.request.Remove)
                return object;
            let message = new $root.request.Remove();
            if (object.uuid != null)
                if (typeof object.uuid === "string")
                    $util.base64.decode(object.uuid, message.uuid = $util.newBuffer($util.base64.length(object.uuid)), 0);
                else if (object.uuid.length >= 0)
                    message.uuid = object.uuid;
            if (object.versionId != null)
                message.versionId = String(object.versionId);
            return message;
        };

        /**
         * Creates a plain object from a Remove message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.Remove
         * @static
         * @param {request.Remove} message Remove
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Remove.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                if (options.bytes === String)
                    object.uuid = "";
                else {
                    object.uuid = [];
                    if (options.bytes !== Array)
                        object.uuid = $util.newBuffer(object.uuid);
                }
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                object.uuid = options.bytes === String ? $util.base64.encode(message.uuid, 0, message.uuid.length) : options.bytes === Array ? Array.prototype.slice.call(message.uuid) : message.uuid;
            if (message.versionId != null && message.hasOwnProperty("versionId")) {
                object.versionId = message.versionId;
                if (options.oneofs)
                    object._versionId = "versionId";
            }
            return object;
        };

        /**
         * Converts this Remove to JSON.
         * @function toJSON
         * @memberof request.Remove
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Remove.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Remove
         * @function getTypeUrl
         * @memberof request.Remove
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Remove.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.Remove";
        };

        return Remove;
    })();

    request.Copy = (function() {

        /**
         * Properties of a Copy.
         * @memberof request
         * @interface ICopy
         * @property {Uint8Array|null} [uuid] Copy uuid
         * @property {Uint8Array|null} [dstUuid] Copy dstUuid
         * @property {boolean|null} [keepHistory] Copy keepHistory
         * @property {string|null} [newOwner] Copy newOwner
         */

        /**
         * Constructs a new Copy.
         * @memberof request
         * @classdesc Represents a Copy.
         * @implements ICopy
         * @constructor
         * @param {request.ICopy=} [properties] Properties to set
         */
        function Copy(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Copy uuid.
         * @member {Uint8Array} uuid
         * @memberof request.Copy
         * @instance
         */
        Copy.prototype.uuid = $util.newBuffer([]);

        /**
         * Copy dstUuid.
         * @member {Uint8Array} dstUuid
         * @memberof request.Copy
         * @instance
         */
        Copy.prototype.dstUuid = $util.newBuffer([]);

        /**
         * Copy keepHistory.
         * @member {boolean|null|undefined} keepHistory
         * @memberof request.Copy
         * @instance
         */
        Copy.prototype.keepHistory = null;

        /**
         * Copy newOwner.
         * @member {string|null|undefined} newOwner
         * @memberof request.Copy
         * @instance
         */
        Copy.prototype.newOwner = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(Copy.prototype, "_keepHistory", {
            get: $util.oneOfGetter($oneOfFields = ["keepHistory"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(Copy.prototype, "_newOwner", {
            get: $util.oneOfGetter($oneOfFields = ["newOwner"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new Copy instance using the specified properties.
         * @function create
         * @memberof request.Copy
         * @static
         * @param {request.ICopy=} [properties] Properties to set
         * @returns {request.Copy} Copy instance
         */
        Copy.create = function create(properties) {
            return new Copy(properties);
        };

        /**
         * Encodes the specified Copy message. Does not implicitly {@link request.Copy.verify|verify} messages.
         * @function encode
         * @memberof request.Copy
         * @static
         * @param {request.ICopy} message Copy message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Copy.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uuid != null && Object.hasOwnProperty.call(message, "uuid"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.uuid);
            if (message.dstUuid != null && Object.hasOwnProperty.call(message, "dstUuid"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.dstUuid);
            if (message.keepHistory != null && Object.hasOwnProperty.call(message, "keepHistory"))
                writer.uint32(/* id 3, wireType 0 =*/24).bool(message.keepHistory);
            if (message.newOwner != null && Object.hasOwnProperty.call(message, "newOwner"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.newOwner);
            return writer;
        };

        /**
         * Encodes the specified Copy message, length delimited. Does not implicitly {@link request.Copy.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.Copy
         * @static
         * @param {request.ICopy} message Copy message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Copy.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Copy message from the specified reader or buffer.
         * @function decode
         * @memberof request.Copy
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.Copy} Copy
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Copy.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.Copy();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.uuid = reader.bytes();
                        break;
                    }
                case 2: {
                        message.dstUuid = reader.bytes();
                        break;
                    }
                case 3: {
                        message.keepHistory = reader.bool();
                        break;
                    }
                case 4: {
                        message.newOwner = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Copy message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.Copy
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.Copy} Copy
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Copy.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Copy message.
         * @function verify
         * @memberof request.Copy
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Copy.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                if (!(message.uuid && typeof message.uuid.length === "number" || $util.isString(message.uuid)))
                    return "uuid: buffer expected";
            if (message.dstUuid != null && message.hasOwnProperty("dstUuid"))
                if (!(message.dstUuid && typeof message.dstUuid.length === "number" || $util.isString(message.dstUuid)))
                    return "dstUuid: buffer expected";
            if (message.keepHistory != null && message.hasOwnProperty("keepHistory")) {
                properties._keepHistory = 1;
                if (typeof message.keepHistory !== "boolean")
                    return "keepHistory: boolean expected";
            }
            if (message.newOwner != null && message.hasOwnProperty("newOwner")) {
                properties._newOwner = 1;
                if (!$util.isString(message.newOwner))
                    return "newOwner: string expected";
            }
            return null;
        };

        /**
         * Creates a Copy message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.Copy
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.Copy} Copy
         */
        Copy.fromObject = function fromObject(object) {
            if (object instanceof $root.request.Copy)
                return object;
            let message = new $root.request.Copy();
            if (object.uuid != null)
                if (typeof object.uuid === "string")
                    $util.base64.decode(object.uuid, message.uuid = $util.newBuffer($util.base64.length(object.uuid)), 0);
                else if (object.uuid.length >= 0)
                    message.uuid = object.uuid;
            if (object.dstUuid != null)
                if (typeof object.dstUuid === "string")
                    $util.base64.decode(object.dstUuid, message.dstUuid = $util.newBuffer($util.base64.length(object.dstUuid)), 0);
                else if (object.dstUuid.length >= 0)
                    message.dstUuid = object.dstUuid;
            if (object.keepHistory != null)
                message.keepHistory = Boolean(object.keepHistory);
            if (object.newOwner != null)
                message.newOwner = String(object.newOwner);
            return message;
        };

        /**
         * Creates a plain object from a Copy message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.Copy
         * @static
         * @param {request.Copy} message Copy
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Copy.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if (options.bytes === String)
                    object.uuid = "";
                else {
                    object.uuid = [];
                    if (options.bytes !== Array)
                        object.uuid = $util.newBuffer(object.uuid);
                }
                if (options.bytes === String)
                    object.dstUuid = "";
                else {
                    object.dstUuid = [];
                    if (options.bytes !== Array)
                        object.dstUuid = $util.newBuffer(object.dstUuid);
                }
            }
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                object.uuid = options.bytes === String ? $util.base64.encode(message.uuid, 0, message.uuid.length) : options.bytes === Array ? Array.prototype.slice.call(message.uuid) : message.uuid;
            if (message.dstUuid != null && message.hasOwnProperty("dstUuid"))
                object.dstUuid = options.bytes === String ? $util.base64.encode(message.dstUuid, 0, message.dstUuid.length) : options.bytes === Array ? Array.prototype.slice.call(message.dstUuid) : message.dstUuid;
            if (message.keepHistory != null && message.hasOwnProperty("keepHistory")) {
                object.keepHistory = message.keepHistory;
                if (options.oneofs)
                    object._keepHistory = "keepHistory";
            }
            if (message.newOwner != null && message.hasOwnProperty("newOwner")) {
                object.newOwner = message.newOwner;
                if (options.oneofs)
                    object._newOwner = "newOwner";
            }
            return object;
        };

        /**
         * Converts this Copy to JSON.
         * @function toJSON
         * @memberof request.Copy
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Copy.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Copy
         * @function getTypeUrl
         * @memberof request.Copy
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Copy.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.Copy";
        };

        return Copy;
    })();

    request.CopyFolder = (function() {

        /**
         * Properties of a CopyFolder.
         * @memberof request
         * @interface ICopyFolder
         * @property {Uint8Array|null} [uuid] CopyFolder uuid
         * @property {string|null} [newOwner] CopyFolder newOwner
         * @property {string|null} [destinationPath] CopyFolder destinationPath
         * @property {request.TypeOfPath|null} [typeOfPath] CopyFolder typeOfPath
         */

        /**
         * Constructs a new CopyFolder.
         * @memberof request
         * @classdesc Represents a CopyFolder.
         * @implements ICopyFolder
         * @constructor
         * @param {request.ICopyFolder=} [properties] Properties to set
         */
        function CopyFolder(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CopyFolder uuid.
         * @member {Uint8Array} uuid
         * @memberof request.CopyFolder
         * @instance
         */
        CopyFolder.prototype.uuid = $util.newBuffer([]);

        /**
         * CopyFolder newOwner.
         * @member {string|null|undefined} newOwner
         * @memberof request.CopyFolder
         * @instance
         */
        CopyFolder.prototype.newOwner = null;

        /**
         * CopyFolder destinationPath.
         * @member {string} destinationPath
         * @memberof request.CopyFolder
         * @instance
         */
        CopyFolder.prototype.destinationPath = "";

        /**
         * CopyFolder typeOfPath.
         * @member {request.TypeOfPath} typeOfPath
         * @memberof request.CopyFolder
         * @instance
         */
        CopyFolder.prototype.typeOfPath = 0;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(CopyFolder.prototype, "_newOwner", {
            get: $util.oneOfGetter($oneOfFields = ["newOwner"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new CopyFolder instance using the specified properties.
         * @function create
         * @memberof request.CopyFolder
         * @static
         * @param {request.ICopyFolder=} [properties] Properties to set
         * @returns {request.CopyFolder} CopyFolder instance
         */
        CopyFolder.create = function create(properties) {
            return new CopyFolder(properties);
        };

        /**
         * Encodes the specified CopyFolder message. Does not implicitly {@link request.CopyFolder.verify|verify} messages.
         * @function encode
         * @memberof request.CopyFolder
         * @static
         * @param {request.ICopyFolder} message CopyFolder message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CopyFolder.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uuid != null && Object.hasOwnProperty.call(message, "uuid"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.uuid);
            if (message.newOwner != null && Object.hasOwnProperty.call(message, "newOwner"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.newOwner);
            if (message.destinationPath != null && Object.hasOwnProperty.call(message, "destinationPath"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.destinationPath);
            if (message.typeOfPath != null && Object.hasOwnProperty.call(message, "typeOfPath"))
                writer.uint32(/* id 8, wireType 0 =*/64).int32(message.typeOfPath);
            return writer;
        };

        /**
         * Encodes the specified CopyFolder message, length delimited. Does not implicitly {@link request.CopyFolder.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.CopyFolder
         * @static
         * @param {request.ICopyFolder} message CopyFolder message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CopyFolder.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CopyFolder message from the specified reader or buffer.
         * @function decode
         * @memberof request.CopyFolder
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.CopyFolder} CopyFolder
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CopyFolder.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.CopyFolder();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.uuid = reader.bytes();
                        break;
                    }
                case 3: {
                        message.newOwner = reader.string();
                        break;
                    }
                case 4: {
                        message.destinationPath = reader.string();
                        break;
                    }
                case 8: {
                        message.typeOfPath = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CopyFolder message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.CopyFolder
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.CopyFolder} CopyFolder
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CopyFolder.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CopyFolder message.
         * @function verify
         * @memberof request.CopyFolder
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CopyFolder.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                if (!(message.uuid && typeof message.uuid.length === "number" || $util.isString(message.uuid)))
                    return "uuid: buffer expected";
            if (message.newOwner != null && message.hasOwnProperty("newOwner")) {
                properties._newOwner = 1;
                if (!$util.isString(message.newOwner))
                    return "newOwner: string expected";
            }
            if (message.destinationPath != null && message.hasOwnProperty("destinationPath"))
                if (!$util.isString(message.destinationPath))
                    return "destinationPath: string expected";
            if (message.typeOfPath != null && message.hasOwnProperty("typeOfPath"))
                switch (message.typeOfPath) {
                default:
                    return "typeOfPath: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                    break;
                }
            return null;
        };

        /**
         * Creates a CopyFolder message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.CopyFolder
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.CopyFolder} CopyFolder
         */
        CopyFolder.fromObject = function fromObject(object) {
            if (object instanceof $root.request.CopyFolder)
                return object;
            let message = new $root.request.CopyFolder();
            if (object.uuid != null)
                if (typeof object.uuid === "string")
                    $util.base64.decode(object.uuid, message.uuid = $util.newBuffer($util.base64.length(object.uuid)), 0);
                else if (object.uuid.length >= 0)
                    message.uuid = object.uuid;
            if (object.newOwner != null)
                message.newOwner = String(object.newOwner);
            if (object.destinationPath != null)
                message.destinationPath = String(object.destinationPath);
            switch (object.typeOfPath) {
            default:
                if (typeof object.typeOfPath === "number") {
                    message.typeOfPath = object.typeOfPath;
                    break;
                }
                break;
            case "TShareUser":
            case 0:
                message.typeOfPath = 0;
                break;
            case "TFolder":
            case 1:
                message.typeOfPath = 1;
                break;
            case "TShareTeam":
            case 2:
                message.typeOfPath = 2;
                break;
            case "TShareExternal":
            case 3:
                message.typeOfPath = 3;
                break;
            case "TFlow":
            case 4:
                message.typeOfPath = 4;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a CopyFolder message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.CopyFolder
         * @static
         * @param {request.CopyFolder} message CopyFolder
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CopyFolder.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if (options.bytes === String)
                    object.uuid = "";
                else {
                    object.uuid = [];
                    if (options.bytes !== Array)
                        object.uuid = $util.newBuffer(object.uuid);
                }
                object.destinationPath = "";
                object.typeOfPath = options.enums === String ? "TShareUser" : 0;
            }
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                object.uuid = options.bytes === String ? $util.base64.encode(message.uuid, 0, message.uuid.length) : options.bytes === Array ? Array.prototype.slice.call(message.uuid) : message.uuid;
            if (message.newOwner != null && message.hasOwnProperty("newOwner")) {
                object.newOwner = message.newOwner;
                if (options.oneofs)
                    object._newOwner = "newOwner";
            }
            if (message.destinationPath != null && message.hasOwnProperty("destinationPath"))
                object.destinationPath = message.destinationPath;
            if (message.typeOfPath != null && message.hasOwnProperty("typeOfPath"))
                object.typeOfPath = options.enums === String ? $root.request.TypeOfPath[message.typeOfPath] === undefined ? message.typeOfPath : $root.request.TypeOfPath[message.typeOfPath] : message.typeOfPath;
            return object;
        };

        /**
         * Converts this CopyFolder to JSON.
         * @function toJSON
         * @memberof request.CopyFolder
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CopyFolder.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CopyFolder
         * @function getTypeUrl
         * @memberof request.CopyFolder
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CopyFolder.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.CopyFolder";
        };

        return CopyFolder;
    })();

    request.CopyFile = (function() {

        /**
         * Properties of a CopyFile.
         * @memberof request
         * @interface ICopyFile
         * @property {string|null} [fileFullPath] CopyFile fileFullPath
         * @property {string|null} [destinationParentPath] CopyFile destinationParentPath
         * @property {string|null} [newFileName] CopyFile newFileName
         * @property {string|null} [newOwner] CopyFile newOwner
         * @property {Uint8Array|null} [versionId] CopyFile versionId
         * @property {request.TypeOfPath|null} [typeOfPath] CopyFile typeOfPath
         */

        /**
         * Constructs a new CopyFile.
         * @memberof request
         * @classdesc Represents a CopyFile.
         * @implements ICopyFile
         * @constructor
         * @param {request.ICopyFile=} [properties] Properties to set
         */
        function CopyFile(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CopyFile fileFullPath.
         * @member {string} fileFullPath
         * @memberof request.CopyFile
         * @instance
         */
        CopyFile.prototype.fileFullPath = "";

        /**
         * CopyFile destinationParentPath.
         * @member {string} destinationParentPath
         * @memberof request.CopyFile
         * @instance
         */
        CopyFile.prototype.destinationParentPath = "";

        /**
         * CopyFile newFileName.
         * @member {string|null|undefined} newFileName
         * @memberof request.CopyFile
         * @instance
         */
        CopyFile.prototype.newFileName = null;

        /**
         * CopyFile newOwner.
         * @member {string|null|undefined} newOwner
         * @memberof request.CopyFile
         * @instance
         */
        CopyFile.prototype.newOwner = null;

        /**
         * CopyFile versionId.
         * @member {Uint8Array|null|undefined} versionId
         * @memberof request.CopyFile
         * @instance
         */
        CopyFile.prototype.versionId = null;

        /**
         * CopyFile typeOfPath.
         * @member {request.TypeOfPath} typeOfPath
         * @memberof request.CopyFile
         * @instance
         */
        CopyFile.prototype.typeOfPath = 0;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(CopyFile.prototype, "_newFileName", {
            get: $util.oneOfGetter($oneOfFields = ["newFileName"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(CopyFile.prototype, "_newOwner", {
            get: $util.oneOfGetter($oneOfFields = ["newOwner"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(CopyFile.prototype, "_versionId", {
            get: $util.oneOfGetter($oneOfFields = ["versionId"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new CopyFile instance using the specified properties.
         * @function create
         * @memberof request.CopyFile
         * @static
         * @param {request.ICopyFile=} [properties] Properties to set
         * @returns {request.CopyFile} CopyFile instance
         */
        CopyFile.create = function create(properties) {
            return new CopyFile(properties);
        };

        /**
         * Encodes the specified CopyFile message. Does not implicitly {@link request.CopyFile.verify|verify} messages.
         * @function encode
         * @memberof request.CopyFile
         * @static
         * @param {request.ICopyFile} message CopyFile message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CopyFile.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.fileFullPath != null && Object.hasOwnProperty.call(message, "fileFullPath"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.fileFullPath);
            if (message.destinationParentPath != null && Object.hasOwnProperty.call(message, "destinationParentPath"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.destinationParentPath);
            if (message.newFileName != null && Object.hasOwnProperty.call(message, "newFileName"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.newFileName);
            if (message.newOwner != null && Object.hasOwnProperty.call(message, "newOwner"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.newOwner);
            if (message.versionId != null && Object.hasOwnProperty.call(message, "versionId"))
                writer.uint32(/* id 5, wireType 2 =*/42).bytes(message.versionId);
            if (message.typeOfPath != null && Object.hasOwnProperty.call(message, "typeOfPath"))
                writer.uint32(/* id 8, wireType 0 =*/64).int32(message.typeOfPath);
            return writer;
        };

        /**
         * Encodes the specified CopyFile message, length delimited. Does not implicitly {@link request.CopyFile.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.CopyFile
         * @static
         * @param {request.ICopyFile} message CopyFile message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CopyFile.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CopyFile message from the specified reader or buffer.
         * @function decode
         * @memberof request.CopyFile
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.CopyFile} CopyFile
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CopyFile.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.CopyFile();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.fileFullPath = reader.string();
                        break;
                    }
                case 2: {
                        message.destinationParentPath = reader.string();
                        break;
                    }
                case 3: {
                        message.newFileName = reader.string();
                        break;
                    }
                case 4: {
                        message.newOwner = reader.string();
                        break;
                    }
                case 5: {
                        message.versionId = reader.bytes();
                        break;
                    }
                case 8: {
                        message.typeOfPath = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CopyFile message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.CopyFile
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.CopyFile} CopyFile
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CopyFile.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CopyFile message.
         * @function verify
         * @memberof request.CopyFile
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CopyFile.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.fileFullPath != null && message.hasOwnProperty("fileFullPath"))
                if (!$util.isString(message.fileFullPath))
                    return "fileFullPath: string expected";
            if (message.destinationParentPath != null && message.hasOwnProperty("destinationParentPath"))
                if (!$util.isString(message.destinationParentPath))
                    return "destinationParentPath: string expected";
            if (message.newFileName != null && message.hasOwnProperty("newFileName")) {
                properties._newFileName = 1;
                if (!$util.isString(message.newFileName))
                    return "newFileName: string expected";
            }
            if (message.newOwner != null && message.hasOwnProperty("newOwner")) {
                properties._newOwner = 1;
                if (!$util.isString(message.newOwner))
                    return "newOwner: string expected";
            }
            if (message.versionId != null && message.hasOwnProperty("versionId")) {
                properties._versionId = 1;
                if (!(message.versionId && typeof message.versionId.length === "number" || $util.isString(message.versionId)))
                    return "versionId: buffer expected";
            }
            if (message.typeOfPath != null && message.hasOwnProperty("typeOfPath"))
                switch (message.typeOfPath) {
                default:
                    return "typeOfPath: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                    break;
                }
            return null;
        };

        /**
         * Creates a CopyFile message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.CopyFile
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.CopyFile} CopyFile
         */
        CopyFile.fromObject = function fromObject(object) {
            if (object instanceof $root.request.CopyFile)
                return object;
            let message = new $root.request.CopyFile();
            if (object.fileFullPath != null)
                message.fileFullPath = String(object.fileFullPath);
            if (object.destinationParentPath != null)
                message.destinationParentPath = String(object.destinationParentPath);
            if (object.newFileName != null)
                message.newFileName = String(object.newFileName);
            if (object.newOwner != null)
                message.newOwner = String(object.newOwner);
            if (object.versionId != null)
                if (typeof object.versionId === "string")
                    $util.base64.decode(object.versionId, message.versionId = $util.newBuffer($util.base64.length(object.versionId)), 0);
                else if (object.versionId.length >= 0)
                    message.versionId = object.versionId;
            switch (object.typeOfPath) {
            default:
                if (typeof object.typeOfPath === "number") {
                    message.typeOfPath = object.typeOfPath;
                    break;
                }
                break;
            case "TShareUser":
            case 0:
                message.typeOfPath = 0;
                break;
            case "TFolder":
            case 1:
                message.typeOfPath = 1;
                break;
            case "TShareTeam":
            case 2:
                message.typeOfPath = 2;
                break;
            case "TShareExternal":
            case 3:
                message.typeOfPath = 3;
                break;
            case "TFlow":
            case 4:
                message.typeOfPath = 4;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a CopyFile message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.CopyFile
         * @static
         * @param {request.CopyFile} message CopyFile
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CopyFile.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.fileFullPath = "";
                object.destinationParentPath = "";
                object.typeOfPath = options.enums === String ? "TShareUser" : 0;
            }
            if (message.fileFullPath != null && message.hasOwnProperty("fileFullPath"))
                object.fileFullPath = message.fileFullPath;
            if (message.destinationParentPath != null && message.hasOwnProperty("destinationParentPath"))
                object.destinationParentPath = message.destinationParentPath;
            if (message.newFileName != null && message.hasOwnProperty("newFileName")) {
                object.newFileName = message.newFileName;
                if (options.oneofs)
                    object._newFileName = "newFileName";
            }
            if (message.newOwner != null && message.hasOwnProperty("newOwner")) {
                object.newOwner = message.newOwner;
                if (options.oneofs)
                    object._newOwner = "newOwner";
            }
            if (message.versionId != null && message.hasOwnProperty("versionId")) {
                object.versionId = options.bytes === String ? $util.base64.encode(message.versionId, 0, message.versionId.length) : options.bytes === Array ? Array.prototype.slice.call(message.versionId) : message.versionId;
                if (options.oneofs)
                    object._versionId = "versionId";
            }
            if (message.typeOfPath != null && message.hasOwnProperty("typeOfPath"))
                object.typeOfPath = options.enums === String ? $root.request.TypeOfPath[message.typeOfPath] === undefined ? message.typeOfPath : $root.request.TypeOfPath[message.typeOfPath] : message.typeOfPath;
            return object;
        };

        /**
         * Converts this CopyFile to JSON.
         * @function toJSON
         * @memberof request.CopyFile
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CopyFile.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CopyFile
         * @function getTypeUrl
         * @memberof request.CopyFile
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CopyFile.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.CopyFile";
        };

        return CopyFile;
    })();

    request.MoveFile = (function() {

        /**
         * Properties of a MoveFile.
         * @memberof request
         * @interface IMoveFile
         * @property {string|null} [fileFullPath] MoveFile fileFullPath
         * @property {string|null} [destinationParentPath] MoveFile destinationParentPath
         * @property {string|null} [newFileName] MoveFile newFileName
         * @property {string|null} [newOwner] MoveFile newOwner
         */

        /**
         * Constructs a new MoveFile.
         * @memberof request
         * @classdesc Represents a MoveFile.
         * @implements IMoveFile
         * @constructor
         * @param {request.IMoveFile=} [properties] Properties to set
         */
        function MoveFile(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MoveFile fileFullPath.
         * @member {string} fileFullPath
         * @memberof request.MoveFile
         * @instance
         */
        MoveFile.prototype.fileFullPath = "";

        /**
         * MoveFile destinationParentPath.
         * @member {string} destinationParentPath
         * @memberof request.MoveFile
         * @instance
         */
        MoveFile.prototype.destinationParentPath = "";

        /**
         * MoveFile newFileName.
         * @member {string|null|undefined} newFileName
         * @memberof request.MoveFile
         * @instance
         */
        MoveFile.prototype.newFileName = null;

        /**
         * MoveFile newOwner.
         * @member {string|null|undefined} newOwner
         * @memberof request.MoveFile
         * @instance
         */
        MoveFile.prototype.newOwner = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(MoveFile.prototype, "_newFileName", {
            get: $util.oneOfGetter($oneOfFields = ["newFileName"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(MoveFile.prototype, "_newOwner", {
            get: $util.oneOfGetter($oneOfFields = ["newOwner"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new MoveFile instance using the specified properties.
         * @function create
         * @memberof request.MoveFile
         * @static
         * @param {request.IMoveFile=} [properties] Properties to set
         * @returns {request.MoveFile} MoveFile instance
         */
        MoveFile.create = function create(properties) {
            return new MoveFile(properties);
        };

        /**
         * Encodes the specified MoveFile message. Does not implicitly {@link request.MoveFile.verify|verify} messages.
         * @function encode
         * @memberof request.MoveFile
         * @static
         * @param {request.IMoveFile} message MoveFile message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MoveFile.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.fileFullPath != null && Object.hasOwnProperty.call(message, "fileFullPath"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.fileFullPath);
            if (message.destinationParentPath != null && Object.hasOwnProperty.call(message, "destinationParentPath"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.destinationParentPath);
            if (message.newFileName != null && Object.hasOwnProperty.call(message, "newFileName"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.newFileName);
            if (message.newOwner != null && Object.hasOwnProperty.call(message, "newOwner"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.newOwner);
            return writer;
        };

        /**
         * Encodes the specified MoveFile message, length delimited. Does not implicitly {@link request.MoveFile.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.MoveFile
         * @static
         * @param {request.IMoveFile} message MoveFile message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MoveFile.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MoveFile message from the specified reader or buffer.
         * @function decode
         * @memberof request.MoveFile
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.MoveFile} MoveFile
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MoveFile.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.MoveFile();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.fileFullPath = reader.string();
                        break;
                    }
                case 2: {
                        message.destinationParentPath = reader.string();
                        break;
                    }
                case 3: {
                        message.newFileName = reader.string();
                        break;
                    }
                case 4: {
                        message.newOwner = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MoveFile message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.MoveFile
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.MoveFile} MoveFile
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MoveFile.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MoveFile message.
         * @function verify
         * @memberof request.MoveFile
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MoveFile.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.fileFullPath != null && message.hasOwnProperty("fileFullPath"))
                if (!$util.isString(message.fileFullPath))
                    return "fileFullPath: string expected";
            if (message.destinationParentPath != null && message.hasOwnProperty("destinationParentPath"))
                if (!$util.isString(message.destinationParentPath))
                    return "destinationParentPath: string expected";
            if (message.newFileName != null && message.hasOwnProperty("newFileName")) {
                properties._newFileName = 1;
                if (!$util.isString(message.newFileName))
                    return "newFileName: string expected";
            }
            if (message.newOwner != null && message.hasOwnProperty("newOwner")) {
                properties._newOwner = 1;
                if (!$util.isString(message.newOwner))
                    return "newOwner: string expected";
            }
            return null;
        };

        /**
         * Creates a MoveFile message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.MoveFile
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.MoveFile} MoveFile
         */
        MoveFile.fromObject = function fromObject(object) {
            if (object instanceof $root.request.MoveFile)
                return object;
            let message = new $root.request.MoveFile();
            if (object.fileFullPath != null)
                message.fileFullPath = String(object.fileFullPath);
            if (object.destinationParentPath != null)
                message.destinationParentPath = String(object.destinationParentPath);
            if (object.newFileName != null)
                message.newFileName = String(object.newFileName);
            if (object.newOwner != null)
                message.newOwner = String(object.newOwner);
            return message;
        };

        /**
         * Creates a plain object from a MoveFile message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.MoveFile
         * @static
         * @param {request.MoveFile} message MoveFile
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MoveFile.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.fileFullPath = "";
                object.destinationParentPath = "";
            }
            if (message.fileFullPath != null && message.hasOwnProperty("fileFullPath"))
                object.fileFullPath = message.fileFullPath;
            if (message.destinationParentPath != null && message.hasOwnProperty("destinationParentPath"))
                object.destinationParentPath = message.destinationParentPath;
            if (message.newFileName != null && message.hasOwnProperty("newFileName")) {
                object.newFileName = message.newFileName;
                if (options.oneofs)
                    object._newFileName = "newFileName";
            }
            if (message.newOwner != null && message.hasOwnProperty("newOwner")) {
                object.newOwner = message.newOwner;
                if (options.oneofs)
                    object._newOwner = "newOwner";
            }
            return object;
        };

        /**
         * Converts this MoveFile to JSON.
         * @function toJSON
         * @memberof request.MoveFile
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MoveFile.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for MoveFile
         * @function getTypeUrl
         * @memberof request.MoveFile
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        MoveFile.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.MoveFile";
        };

        return MoveFile;
    })();

    request.MoveFolder = (function() {

        /**
         * Properties of a MoveFolder.
         * @memberof request
         * @interface IMoveFolder
         * @property {string|null} [fileFullPath] MoveFolder fileFullPath
         * @property {string|null} [destinationParentPath] MoveFolder destinationParentPath
         * @property {string|null} [newFileName] MoveFolder newFileName
         * @property {string|null} [newOwner] MoveFolder newOwner
         */

        /**
         * Constructs a new MoveFolder.
         * @memberof request
         * @classdesc Represents a MoveFolder.
         * @implements IMoveFolder
         * @constructor
         * @param {request.IMoveFolder=} [properties] Properties to set
         */
        function MoveFolder(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MoveFolder fileFullPath.
         * @member {string} fileFullPath
         * @memberof request.MoveFolder
         * @instance
         */
        MoveFolder.prototype.fileFullPath = "";

        /**
         * MoveFolder destinationParentPath.
         * @member {string} destinationParentPath
         * @memberof request.MoveFolder
         * @instance
         */
        MoveFolder.prototype.destinationParentPath = "";

        /**
         * MoveFolder newFileName.
         * @member {string|null|undefined} newFileName
         * @memberof request.MoveFolder
         * @instance
         */
        MoveFolder.prototype.newFileName = null;

        /**
         * MoveFolder newOwner.
         * @member {string|null|undefined} newOwner
         * @memberof request.MoveFolder
         * @instance
         */
        MoveFolder.prototype.newOwner = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(MoveFolder.prototype, "_newFileName", {
            get: $util.oneOfGetter($oneOfFields = ["newFileName"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(MoveFolder.prototype, "_newOwner", {
            get: $util.oneOfGetter($oneOfFields = ["newOwner"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new MoveFolder instance using the specified properties.
         * @function create
         * @memberof request.MoveFolder
         * @static
         * @param {request.IMoveFolder=} [properties] Properties to set
         * @returns {request.MoveFolder} MoveFolder instance
         */
        MoveFolder.create = function create(properties) {
            return new MoveFolder(properties);
        };

        /**
         * Encodes the specified MoveFolder message. Does not implicitly {@link request.MoveFolder.verify|verify} messages.
         * @function encode
         * @memberof request.MoveFolder
         * @static
         * @param {request.IMoveFolder} message MoveFolder message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MoveFolder.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.fileFullPath != null && Object.hasOwnProperty.call(message, "fileFullPath"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.fileFullPath);
            if (message.destinationParentPath != null && Object.hasOwnProperty.call(message, "destinationParentPath"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.destinationParentPath);
            if (message.newFileName != null && Object.hasOwnProperty.call(message, "newFileName"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.newFileName);
            if (message.newOwner != null && Object.hasOwnProperty.call(message, "newOwner"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.newOwner);
            return writer;
        };

        /**
         * Encodes the specified MoveFolder message, length delimited. Does not implicitly {@link request.MoveFolder.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.MoveFolder
         * @static
         * @param {request.IMoveFolder} message MoveFolder message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MoveFolder.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MoveFolder message from the specified reader or buffer.
         * @function decode
         * @memberof request.MoveFolder
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.MoveFolder} MoveFolder
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MoveFolder.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.MoveFolder();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.fileFullPath = reader.string();
                        break;
                    }
                case 2: {
                        message.destinationParentPath = reader.string();
                        break;
                    }
                case 3: {
                        message.newFileName = reader.string();
                        break;
                    }
                case 4: {
                        message.newOwner = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MoveFolder message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.MoveFolder
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.MoveFolder} MoveFolder
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MoveFolder.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MoveFolder message.
         * @function verify
         * @memberof request.MoveFolder
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MoveFolder.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.fileFullPath != null && message.hasOwnProperty("fileFullPath"))
                if (!$util.isString(message.fileFullPath))
                    return "fileFullPath: string expected";
            if (message.destinationParentPath != null && message.hasOwnProperty("destinationParentPath"))
                if (!$util.isString(message.destinationParentPath))
                    return "destinationParentPath: string expected";
            if (message.newFileName != null && message.hasOwnProperty("newFileName")) {
                properties._newFileName = 1;
                if (!$util.isString(message.newFileName))
                    return "newFileName: string expected";
            }
            if (message.newOwner != null && message.hasOwnProperty("newOwner")) {
                properties._newOwner = 1;
                if (!$util.isString(message.newOwner))
                    return "newOwner: string expected";
            }
            return null;
        };

        /**
         * Creates a MoveFolder message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.MoveFolder
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.MoveFolder} MoveFolder
         */
        MoveFolder.fromObject = function fromObject(object) {
            if (object instanceof $root.request.MoveFolder)
                return object;
            let message = new $root.request.MoveFolder();
            if (object.fileFullPath != null)
                message.fileFullPath = String(object.fileFullPath);
            if (object.destinationParentPath != null)
                message.destinationParentPath = String(object.destinationParentPath);
            if (object.newFileName != null)
                message.newFileName = String(object.newFileName);
            if (object.newOwner != null)
                message.newOwner = String(object.newOwner);
            return message;
        };

        /**
         * Creates a plain object from a MoveFolder message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.MoveFolder
         * @static
         * @param {request.MoveFolder} message MoveFolder
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MoveFolder.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.fileFullPath = "";
                object.destinationParentPath = "";
            }
            if (message.fileFullPath != null && message.hasOwnProperty("fileFullPath"))
                object.fileFullPath = message.fileFullPath;
            if (message.destinationParentPath != null && message.hasOwnProperty("destinationParentPath"))
                object.destinationParentPath = message.destinationParentPath;
            if (message.newFileName != null && message.hasOwnProperty("newFileName")) {
                object.newFileName = message.newFileName;
                if (options.oneofs)
                    object._newFileName = "newFileName";
            }
            if (message.newOwner != null && message.hasOwnProperty("newOwner")) {
                object.newOwner = message.newOwner;
                if (options.oneofs)
                    object._newOwner = "newOwner";
            }
            return object;
        };

        /**
         * Converts this MoveFolder to JSON.
         * @function toJSON
         * @memberof request.MoveFolder
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MoveFolder.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for MoveFolder
         * @function getTypeUrl
         * @memberof request.MoveFolder
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        MoveFolder.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.MoveFolder";
        };

        return MoveFolder;
    })();

    request.Child = (function() {

        /**
         * Properties of a Child.
         * @memberof request
         * @interface IChild
         * @property {boolean|null} [isFolder] Child isFolder
         * @property {Uint8Array|null} [uuid] Child uuid
         */

        /**
         * Constructs a new Child.
         * @memberof request
         * @classdesc Represents a Child.
         * @implements IChild
         * @constructor
         * @param {request.IChild=} [properties] Properties to set
         */
        function Child(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Child isFolder.
         * @member {boolean} isFolder
         * @memberof request.Child
         * @instance
         */
        Child.prototype.isFolder = false;

        /**
         * Child uuid.
         * @member {Uint8Array} uuid
         * @memberof request.Child
         * @instance
         */
        Child.prototype.uuid = $util.newBuffer([]);

        /**
         * Creates a new Child instance using the specified properties.
         * @function create
         * @memberof request.Child
         * @static
         * @param {request.IChild=} [properties] Properties to set
         * @returns {request.Child} Child instance
         */
        Child.create = function create(properties) {
            return new Child(properties);
        };

        /**
         * Encodes the specified Child message. Does not implicitly {@link request.Child.verify|verify} messages.
         * @function encode
         * @memberof request.Child
         * @static
         * @param {request.IChild} message Child message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Child.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.isFolder != null && Object.hasOwnProperty.call(message, "isFolder"))
                writer.uint32(/* id 1, wireType 0 =*/8).bool(message.isFolder);
            if (message.uuid != null && Object.hasOwnProperty.call(message, "uuid"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.uuid);
            return writer;
        };

        /**
         * Encodes the specified Child message, length delimited. Does not implicitly {@link request.Child.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.Child
         * @static
         * @param {request.IChild} message Child message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Child.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Child message from the specified reader or buffer.
         * @function decode
         * @memberof request.Child
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.Child} Child
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Child.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.Child();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.isFolder = reader.bool();
                        break;
                    }
                case 2: {
                        message.uuid = reader.bytes();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Child message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.Child
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.Child} Child
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Child.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Child message.
         * @function verify
         * @memberof request.Child
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Child.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.isFolder != null && message.hasOwnProperty("isFolder"))
                if (typeof message.isFolder !== "boolean")
                    return "isFolder: boolean expected";
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                if (!(message.uuid && typeof message.uuid.length === "number" || $util.isString(message.uuid)))
                    return "uuid: buffer expected";
            return null;
        };

        /**
         * Creates a Child message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.Child
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.Child} Child
         */
        Child.fromObject = function fromObject(object) {
            if (object instanceof $root.request.Child)
                return object;
            let message = new $root.request.Child();
            if (object.isFolder != null)
                message.isFolder = Boolean(object.isFolder);
            if (object.uuid != null)
                if (typeof object.uuid === "string")
                    $util.base64.decode(object.uuid, message.uuid = $util.newBuffer($util.base64.length(object.uuid)), 0);
                else if (object.uuid.length >= 0)
                    message.uuid = object.uuid;
            return message;
        };

        /**
         * Creates a plain object from a Child message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.Child
         * @static
         * @param {request.Child} message Child
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Child.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.isFolder = false;
                if (options.bytes === String)
                    object.uuid = "";
                else {
                    object.uuid = [];
                    if (options.bytes !== Array)
                        object.uuid = $util.newBuffer(object.uuid);
                }
            }
            if (message.isFolder != null && message.hasOwnProperty("isFolder"))
                object.isFolder = message.isFolder;
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                object.uuid = options.bytes === String ? $util.base64.encode(message.uuid, 0, message.uuid.length) : options.bytes === Array ? Array.prototype.slice.call(message.uuid) : message.uuid;
            return object;
        };

        /**
         * Converts this Child to JSON.
         * @function toJSON
         * @memberof request.Child
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Child.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Child
         * @function getTypeUrl
         * @memberof request.Child
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Child.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.Child";
        };

        return Child;
    })();

    request.FolderSnapshot = (function() {

        /**
         * Properties of a FolderSnapshot.
         * @memberof request
         * @interface IFolderSnapshot
         * @property {string|null} [id] FolderSnapshot id
         * @property {Uint8Array|null} [uuidOfClone] FolderSnapshot uuidOfClone
         * @property {number|Long|null} [creationDate] FolderSnapshot creationDate
         */

        /**
         * Constructs a new FolderSnapshot.
         * @memberof request
         * @classdesc Represents a FolderSnapshot.
         * @implements IFolderSnapshot
         * @constructor
         * @param {request.IFolderSnapshot=} [properties] Properties to set
         */
        function FolderSnapshot(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * FolderSnapshot id.
         * @member {string} id
         * @memberof request.FolderSnapshot
         * @instance
         */
        FolderSnapshot.prototype.id = "";

        /**
         * FolderSnapshot uuidOfClone.
         * @member {Uint8Array} uuidOfClone
         * @memberof request.FolderSnapshot
         * @instance
         */
        FolderSnapshot.prototype.uuidOfClone = $util.newBuffer([]);

        /**
         * FolderSnapshot creationDate.
         * @member {number|Long} creationDate
         * @memberof request.FolderSnapshot
         * @instance
         */
        FolderSnapshot.prototype.creationDate = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new FolderSnapshot instance using the specified properties.
         * @function create
         * @memberof request.FolderSnapshot
         * @static
         * @param {request.IFolderSnapshot=} [properties] Properties to set
         * @returns {request.FolderSnapshot} FolderSnapshot instance
         */
        FolderSnapshot.create = function create(properties) {
            return new FolderSnapshot(properties);
        };

        /**
         * Encodes the specified FolderSnapshot message. Does not implicitly {@link request.FolderSnapshot.verify|verify} messages.
         * @function encode
         * @memberof request.FolderSnapshot
         * @static
         * @param {request.IFolderSnapshot} message FolderSnapshot message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FolderSnapshot.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.uuidOfClone != null && Object.hasOwnProperty.call(message, "uuidOfClone"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.uuidOfClone);
            if (message.creationDate != null && Object.hasOwnProperty.call(message, "creationDate"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.creationDate);
            return writer;
        };

        /**
         * Encodes the specified FolderSnapshot message, length delimited. Does not implicitly {@link request.FolderSnapshot.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.FolderSnapshot
         * @static
         * @param {request.IFolderSnapshot} message FolderSnapshot message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FolderSnapshot.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a FolderSnapshot message from the specified reader or buffer.
         * @function decode
         * @memberof request.FolderSnapshot
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.FolderSnapshot} FolderSnapshot
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FolderSnapshot.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.FolderSnapshot();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.id = reader.string();
                        break;
                    }
                case 2: {
                        message.uuidOfClone = reader.bytes();
                        break;
                    }
                case 3: {
                        message.creationDate = reader.uint64();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a FolderSnapshot message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.FolderSnapshot
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.FolderSnapshot} FolderSnapshot
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FolderSnapshot.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a FolderSnapshot message.
         * @function verify
         * @memberof request.FolderSnapshot
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        FolderSnapshot.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.uuidOfClone != null && message.hasOwnProperty("uuidOfClone"))
                if (!(message.uuidOfClone && typeof message.uuidOfClone.length === "number" || $util.isString(message.uuidOfClone)))
                    return "uuidOfClone: buffer expected";
            if (message.creationDate != null && message.hasOwnProperty("creationDate"))
                if (!$util.isInteger(message.creationDate) && !(message.creationDate && $util.isInteger(message.creationDate.low) && $util.isInteger(message.creationDate.high)))
                    return "creationDate: integer|Long expected";
            return null;
        };

        /**
         * Creates a FolderSnapshot message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.FolderSnapshot
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.FolderSnapshot} FolderSnapshot
         */
        FolderSnapshot.fromObject = function fromObject(object) {
            if (object instanceof $root.request.FolderSnapshot)
                return object;
            let message = new $root.request.FolderSnapshot();
            if (object.id != null)
                message.id = String(object.id);
            if (object.uuidOfClone != null)
                if (typeof object.uuidOfClone === "string")
                    $util.base64.decode(object.uuidOfClone, message.uuidOfClone = $util.newBuffer($util.base64.length(object.uuidOfClone)), 0);
                else if (object.uuidOfClone.length >= 0)
                    message.uuidOfClone = object.uuidOfClone;
            if (object.creationDate != null)
                if ($util.Long)
                    (message.creationDate = $util.Long.fromValue(object.creationDate)).unsigned = true;
                else if (typeof object.creationDate === "string")
                    message.creationDate = parseInt(object.creationDate, 10);
                else if (typeof object.creationDate === "number")
                    message.creationDate = object.creationDate;
                else if (typeof object.creationDate === "object")
                    message.creationDate = new $util.LongBits(object.creationDate.low >>> 0, object.creationDate.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a FolderSnapshot message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.FolderSnapshot
         * @static
         * @param {request.FolderSnapshot} message FolderSnapshot
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FolderSnapshot.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.id = "";
                if (options.bytes === String)
                    object.uuidOfClone = "";
                else {
                    object.uuidOfClone = [];
                    if (options.bytes !== Array)
                        object.uuidOfClone = $util.newBuffer(object.uuidOfClone);
                }
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.creationDate = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.creationDate = options.longs === String ? "0" : 0;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.uuidOfClone != null && message.hasOwnProperty("uuidOfClone"))
                object.uuidOfClone = options.bytes === String ? $util.base64.encode(message.uuidOfClone, 0, message.uuidOfClone.length) : options.bytes === Array ? Array.prototype.slice.call(message.uuidOfClone) : message.uuidOfClone;
            if (message.creationDate != null && message.hasOwnProperty("creationDate"))
                if (typeof message.creationDate === "number")
                    object.creationDate = options.longs === String ? String(message.creationDate) : message.creationDate;
                else
                    object.creationDate = options.longs === String ? $util.Long.prototype.toString.call(message.creationDate) : options.longs === Number ? new $util.LongBits(message.creationDate.low >>> 0, message.creationDate.high >>> 0).toNumber(true) : message.creationDate;
            return object;
        };

        /**
         * Converts this FolderSnapshot to JSON.
         * @function toJSON
         * @memberof request.FolderSnapshot
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FolderSnapshot.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for FolderSnapshot
         * @function getTypeUrl
         * @memberof request.FolderSnapshot
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        FolderSnapshot.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.FolderSnapshot";
        };

        return FolderSnapshot;
    })();

    request.Folder = (function() {

        /**
         * Properties of a Folder.
         * @memberof request
         * @interface IFolder
         * @property {Uint8Array|null} [uuid] Folder uuid
         * @property {string|null} [name] Folder name
         * @property {Array.<request.IFolderSnapshot>|null} [snapshots] Folder snapshots
         * @property {boolean|null} [isClone] Folder isClone
         * @property {number|Long|null} [creationDate] Folder creationDate
         * @property {Uint8Array|null} [parentUuid] Folder parentUuid
         * @property {number|Long|null} [lastModifiedDate] Folder lastModifiedDate
         */

        /**
         * Constructs a new Folder.
         * @memberof request
         * @classdesc Represents a Folder.
         * @implements IFolder
         * @constructor
         * @param {request.IFolder=} [properties] Properties to set
         */
        function Folder(properties) {
            this.snapshots = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Folder uuid.
         * @member {Uint8Array} uuid
         * @memberof request.Folder
         * @instance
         */
        Folder.prototype.uuid = $util.newBuffer([]);

        /**
         * Folder name.
         * @member {string} name
         * @memberof request.Folder
         * @instance
         */
        Folder.prototype.name = "";

        /**
         * Folder snapshots.
         * @member {Array.<request.IFolderSnapshot>} snapshots
         * @memberof request.Folder
         * @instance
         */
        Folder.prototype.snapshots = $util.emptyArray;

        /**
         * Folder isClone.
         * @member {boolean} isClone
         * @memberof request.Folder
         * @instance
         */
        Folder.prototype.isClone = false;

        /**
         * Folder creationDate.
         * @member {number|Long} creationDate
         * @memberof request.Folder
         * @instance
         */
        Folder.prototype.creationDate = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Folder parentUuid.
         * @member {Uint8Array|null|undefined} parentUuid
         * @memberof request.Folder
         * @instance
         */
        Folder.prototype.parentUuid = null;

        /**
         * Folder lastModifiedDate.
         * @member {number|Long} lastModifiedDate
         * @memberof request.Folder
         * @instance
         */
        Folder.prototype.lastModifiedDate = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(Folder.prototype, "_parentUuid", {
            get: $util.oneOfGetter($oneOfFields = ["parentUuid"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new Folder instance using the specified properties.
         * @function create
         * @memberof request.Folder
         * @static
         * @param {request.IFolder=} [properties] Properties to set
         * @returns {request.Folder} Folder instance
         */
        Folder.create = function create(properties) {
            return new Folder(properties);
        };

        /**
         * Encodes the specified Folder message. Does not implicitly {@link request.Folder.verify|verify} messages.
         * @function encode
         * @memberof request.Folder
         * @static
         * @param {request.IFolder} message Folder message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Folder.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uuid != null && Object.hasOwnProperty.call(message, "uuid"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.uuid);
            if (message.snapshots != null && message.snapshots.length)
                for (let i = 0; i < message.snapshots.length; ++i)
                    $root.request.FolderSnapshot.encode(message.snapshots[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.creationDate != null && Object.hasOwnProperty.call(message, "creationDate"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.creationDate);
            if (message.lastModifiedDate != null && Object.hasOwnProperty.call(message, "lastModifiedDate"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.lastModifiedDate);
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.name);
            if (message.isClone != null && Object.hasOwnProperty.call(message, "isClone"))
                writer.uint32(/* id 6, wireType 0 =*/48).bool(message.isClone);
            if (message.parentUuid != null && Object.hasOwnProperty.call(message, "parentUuid"))
                writer.uint32(/* id 7, wireType 2 =*/58).bytes(message.parentUuid);
            return writer;
        };

        /**
         * Encodes the specified Folder message, length delimited. Does not implicitly {@link request.Folder.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.Folder
         * @static
         * @param {request.IFolder} message Folder message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Folder.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Folder message from the specified reader or buffer.
         * @function decode
         * @memberof request.Folder
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.Folder} Folder
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Folder.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.Folder();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.uuid = reader.bytes();
                        break;
                    }
                case 5: {
                        message.name = reader.string();
                        break;
                    }
                case 2: {
                        if (!(message.snapshots && message.snapshots.length))
                            message.snapshots = [];
                        message.snapshots.push($root.request.FolderSnapshot.decode(reader, reader.uint32()));
                        break;
                    }
                case 6: {
                        message.isClone = reader.bool();
                        break;
                    }
                case 3: {
                        message.creationDate = reader.uint64();
                        break;
                    }
                case 7: {
                        message.parentUuid = reader.bytes();
                        break;
                    }
                case 4: {
                        message.lastModifiedDate = reader.uint64();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Folder message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.Folder
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.Folder} Folder
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Folder.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Folder message.
         * @function verify
         * @memberof request.Folder
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Folder.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                if (!(message.uuid && typeof message.uuid.length === "number" || $util.isString(message.uuid)))
                    return "uuid: buffer expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.snapshots != null && message.hasOwnProperty("snapshots")) {
                if (!Array.isArray(message.snapshots))
                    return "snapshots: array expected";
                for (let i = 0; i < message.snapshots.length; ++i) {
                    let error = $root.request.FolderSnapshot.verify(message.snapshots[i]);
                    if (error)
                        return "snapshots." + error;
                }
            }
            if (message.isClone != null && message.hasOwnProperty("isClone"))
                if (typeof message.isClone !== "boolean")
                    return "isClone: boolean expected";
            if (message.creationDate != null && message.hasOwnProperty("creationDate"))
                if (!$util.isInteger(message.creationDate) && !(message.creationDate && $util.isInteger(message.creationDate.low) && $util.isInteger(message.creationDate.high)))
                    return "creationDate: integer|Long expected";
            if (message.parentUuid != null && message.hasOwnProperty("parentUuid")) {
                properties._parentUuid = 1;
                if (!(message.parentUuid && typeof message.parentUuid.length === "number" || $util.isString(message.parentUuid)))
                    return "parentUuid: buffer expected";
            }
            if (message.lastModifiedDate != null && message.hasOwnProperty("lastModifiedDate"))
                if (!$util.isInteger(message.lastModifiedDate) && !(message.lastModifiedDate && $util.isInteger(message.lastModifiedDate.low) && $util.isInteger(message.lastModifiedDate.high)))
                    return "lastModifiedDate: integer|Long expected";
            return null;
        };

        /**
         * Creates a Folder message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.Folder
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.Folder} Folder
         */
        Folder.fromObject = function fromObject(object) {
            if (object instanceof $root.request.Folder)
                return object;
            let message = new $root.request.Folder();
            if (object.uuid != null)
                if (typeof object.uuid === "string")
                    $util.base64.decode(object.uuid, message.uuid = $util.newBuffer($util.base64.length(object.uuid)), 0);
                else if (object.uuid.length >= 0)
                    message.uuid = object.uuid;
            if (object.name != null)
                message.name = String(object.name);
            if (object.snapshots) {
                if (!Array.isArray(object.snapshots))
                    throw TypeError(".request.Folder.snapshots: array expected");
                message.snapshots = [];
                for (let i = 0; i < object.snapshots.length; ++i) {
                    if (typeof object.snapshots[i] !== "object")
                        throw TypeError(".request.Folder.snapshots: object expected");
                    message.snapshots[i] = $root.request.FolderSnapshot.fromObject(object.snapshots[i]);
                }
            }
            if (object.isClone != null)
                message.isClone = Boolean(object.isClone);
            if (object.creationDate != null)
                if ($util.Long)
                    (message.creationDate = $util.Long.fromValue(object.creationDate)).unsigned = true;
                else if (typeof object.creationDate === "string")
                    message.creationDate = parseInt(object.creationDate, 10);
                else if (typeof object.creationDate === "number")
                    message.creationDate = object.creationDate;
                else if (typeof object.creationDate === "object")
                    message.creationDate = new $util.LongBits(object.creationDate.low >>> 0, object.creationDate.high >>> 0).toNumber(true);
            if (object.parentUuid != null)
                if (typeof object.parentUuid === "string")
                    $util.base64.decode(object.parentUuid, message.parentUuid = $util.newBuffer($util.base64.length(object.parentUuid)), 0);
                else if (object.parentUuid.length >= 0)
                    message.parentUuid = object.parentUuid;
            if (object.lastModifiedDate != null)
                if ($util.Long)
                    (message.lastModifiedDate = $util.Long.fromValue(object.lastModifiedDate)).unsigned = true;
                else if (typeof object.lastModifiedDate === "string")
                    message.lastModifiedDate = parseInt(object.lastModifiedDate, 10);
                else if (typeof object.lastModifiedDate === "number")
                    message.lastModifiedDate = object.lastModifiedDate;
                else if (typeof object.lastModifiedDate === "object")
                    message.lastModifiedDate = new $util.LongBits(object.lastModifiedDate.low >>> 0, object.lastModifiedDate.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a Folder message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.Folder
         * @static
         * @param {request.Folder} message Folder
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Folder.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.snapshots = [];
            if (options.defaults) {
                if (options.bytes === String)
                    object.uuid = "";
                else {
                    object.uuid = [];
                    if (options.bytes !== Array)
                        object.uuid = $util.newBuffer(object.uuid);
                }
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.creationDate = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.creationDate = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.lastModifiedDate = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.lastModifiedDate = options.longs === String ? "0" : 0;
                object.name = "";
                object.isClone = false;
            }
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                object.uuid = options.bytes === String ? $util.base64.encode(message.uuid, 0, message.uuid.length) : options.bytes === Array ? Array.prototype.slice.call(message.uuid) : message.uuid;
            if (message.snapshots && message.snapshots.length) {
                object.snapshots = [];
                for (let j = 0; j < message.snapshots.length; ++j)
                    object.snapshots[j] = $root.request.FolderSnapshot.toObject(message.snapshots[j], options);
            }
            if (message.creationDate != null && message.hasOwnProperty("creationDate"))
                if (typeof message.creationDate === "number")
                    object.creationDate = options.longs === String ? String(message.creationDate) : message.creationDate;
                else
                    object.creationDate = options.longs === String ? $util.Long.prototype.toString.call(message.creationDate) : options.longs === Number ? new $util.LongBits(message.creationDate.low >>> 0, message.creationDate.high >>> 0).toNumber(true) : message.creationDate;
            if (message.lastModifiedDate != null && message.hasOwnProperty("lastModifiedDate"))
                if (typeof message.lastModifiedDate === "number")
                    object.lastModifiedDate = options.longs === String ? String(message.lastModifiedDate) : message.lastModifiedDate;
                else
                    object.lastModifiedDate = options.longs === String ? $util.Long.prototype.toString.call(message.lastModifiedDate) : options.longs === Number ? new $util.LongBits(message.lastModifiedDate.low >>> 0, message.lastModifiedDate.high >>> 0).toNumber(true) : message.lastModifiedDate;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.isClone != null && message.hasOwnProperty("isClone"))
                object.isClone = message.isClone;
            if (message.parentUuid != null && message.hasOwnProperty("parentUuid")) {
                object.parentUuid = options.bytes === String ? $util.base64.encode(message.parentUuid, 0, message.parentUuid.length) : options.bytes === Array ? Array.prototype.slice.call(message.parentUuid) : message.parentUuid;
                if (options.oneofs)
                    object._parentUuid = "parentUuid";
            }
            return object;
        };

        /**
         * Converts this Folder to JSON.
         * @function toJSON
         * @memberof request.Folder
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Folder.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Folder
         * @function getTypeUrl
         * @memberof request.Folder
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Folder.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.Folder";
        };

        return Folder;
    })();

    request.GetFolder = (function() {

        /**
         * Properties of a GetFolder.
         * @memberof request
         * @interface IGetFolder
         * @property {Uint8Array|null} [uuid] GetFolder uuid
         */

        /**
         * Constructs a new GetFolder.
         * @memberof request
         * @classdesc Represents a GetFolder.
         * @implements IGetFolder
         * @constructor
         * @param {request.IGetFolder=} [properties] Properties to set
         */
        function GetFolder(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetFolder uuid.
         * @member {Uint8Array} uuid
         * @memberof request.GetFolder
         * @instance
         */
        GetFolder.prototype.uuid = $util.newBuffer([]);

        /**
         * Creates a new GetFolder instance using the specified properties.
         * @function create
         * @memberof request.GetFolder
         * @static
         * @param {request.IGetFolder=} [properties] Properties to set
         * @returns {request.GetFolder} GetFolder instance
         */
        GetFolder.create = function create(properties) {
            return new GetFolder(properties);
        };

        /**
         * Encodes the specified GetFolder message. Does not implicitly {@link request.GetFolder.verify|verify} messages.
         * @function encode
         * @memberof request.GetFolder
         * @static
         * @param {request.IGetFolder} message GetFolder message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetFolder.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uuid != null && Object.hasOwnProperty.call(message, "uuid"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.uuid);
            return writer;
        };

        /**
         * Encodes the specified GetFolder message, length delimited. Does not implicitly {@link request.GetFolder.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.GetFolder
         * @static
         * @param {request.IGetFolder} message GetFolder message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetFolder.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetFolder message from the specified reader or buffer.
         * @function decode
         * @memberof request.GetFolder
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.GetFolder} GetFolder
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetFolder.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.GetFolder();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.uuid = reader.bytes();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetFolder message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.GetFolder
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.GetFolder} GetFolder
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetFolder.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetFolder message.
         * @function verify
         * @memberof request.GetFolder
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetFolder.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                if (!(message.uuid && typeof message.uuid.length === "number" || $util.isString(message.uuid)))
                    return "uuid: buffer expected";
            return null;
        };

        /**
         * Creates a GetFolder message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.GetFolder
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.GetFolder} GetFolder
         */
        GetFolder.fromObject = function fromObject(object) {
            if (object instanceof $root.request.GetFolder)
                return object;
            let message = new $root.request.GetFolder();
            if (object.uuid != null)
                if (typeof object.uuid === "string")
                    $util.base64.decode(object.uuid, message.uuid = $util.newBuffer($util.base64.length(object.uuid)), 0);
                else if (object.uuid.length >= 0)
                    message.uuid = object.uuid;
            return message;
        };

        /**
         * Creates a plain object from a GetFolder message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.GetFolder
         * @static
         * @param {request.GetFolder} message GetFolder
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetFolder.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                if (options.bytes === String)
                    object.uuid = "";
                else {
                    object.uuid = [];
                    if (options.bytes !== Array)
                        object.uuid = $util.newBuffer(object.uuid);
                }
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                object.uuid = options.bytes === String ? $util.base64.encode(message.uuid, 0, message.uuid.length) : options.bytes === Array ? Array.prototype.slice.call(message.uuid) : message.uuid;
            return object;
        };

        /**
         * Converts this GetFolder to JSON.
         * @function toJSON
         * @memberof request.GetFolder
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetFolder.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetFolder
         * @function getTypeUrl
         * @memberof request.GetFolder
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetFolder.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.GetFolder";
        };

        return GetFolder;
    })();

    request.KeyValMapping = (function() {

        /**
         * Properties of a KeyValMapping.
         * @memberof request
         * @interface IKeyValMapping
         * @property {string|null} [attribute] KeyValMapping attribute
         * @property {Uint8Array|null} [value] KeyValMapping value
         */

        /**
         * Constructs a new KeyValMapping.
         * @memberof request
         * @classdesc Represents a KeyValMapping.
         * @implements IKeyValMapping
         * @constructor
         * @param {request.IKeyValMapping=} [properties] Properties to set
         */
        function KeyValMapping(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * KeyValMapping attribute.
         * @member {string} attribute
         * @memberof request.KeyValMapping
         * @instance
         */
        KeyValMapping.prototype.attribute = "";

        /**
         * KeyValMapping value.
         * @member {Uint8Array} value
         * @memberof request.KeyValMapping
         * @instance
         */
        KeyValMapping.prototype.value = $util.newBuffer([]);

        /**
         * Creates a new KeyValMapping instance using the specified properties.
         * @function create
         * @memberof request.KeyValMapping
         * @static
         * @param {request.IKeyValMapping=} [properties] Properties to set
         * @returns {request.KeyValMapping} KeyValMapping instance
         */
        KeyValMapping.create = function create(properties) {
            return new KeyValMapping(properties);
        };

        /**
         * Encodes the specified KeyValMapping message. Does not implicitly {@link request.KeyValMapping.verify|verify} messages.
         * @function encode
         * @memberof request.KeyValMapping
         * @static
         * @param {request.IKeyValMapping} message KeyValMapping message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        KeyValMapping.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.attribute != null && Object.hasOwnProperty.call(message, "attribute"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.attribute);
            if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.value);
            return writer;
        };

        /**
         * Encodes the specified KeyValMapping message, length delimited. Does not implicitly {@link request.KeyValMapping.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.KeyValMapping
         * @static
         * @param {request.IKeyValMapping} message KeyValMapping message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        KeyValMapping.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a KeyValMapping message from the specified reader or buffer.
         * @function decode
         * @memberof request.KeyValMapping
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.KeyValMapping} KeyValMapping
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        KeyValMapping.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.KeyValMapping();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.attribute = reader.string();
                        break;
                    }
                case 2: {
                        message.value = reader.bytes();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a KeyValMapping message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.KeyValMapping
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.KeyValMapping} KeyValMapping
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        KeyValMapping.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a KeyValMapping message.
         * @function verify
         * @memberof request.KeyValMapping
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        KeyValMapping.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.attribute != null && message.hasOwnProperty("attribute"))
                if (!$util.isString(message.attribute))
                    return "attribute: string expected";
            if (message.value != null && message.hasOwnProperty("value"))
                if (!(message.value && typeof message.value.length === "number" || $util.isString(message.value)))
                    return "value: buffer expected";
            return null;
        };

        /**
         * Creates a KeyValMapping message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.KeyValMapping
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.KeyValMapping} KeyValMapping
         */
        KeyValMapping.fromObject = function fromObject(object) {
            if (object instanceof $root.request.KeyValMapping)
                return object;
            let message = new $root.request.KeyValMapping();
            if (object.attribute != null)
                message.attribute = String(object.attribute);
            if (object.value != null)
                if (typeof object.value === "string")
                    $util.base64.decode(object.value, message.value = $util.newBuffer($util.base64.length(object.value)), 0);
                else if (object.value.length >= 0)
                    message.value = object.value;
            return message;
        };

        /**
         * Creates a plain object from a KeyValMapping message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.KeyValMapping
         * @static
         * @param {request.KeyValMapping} message KeyValMapping
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        KeyValMapping.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.attribute = "";
                if (options.bytes === String)
                    object.value = "";
                else {
                    object.value = [];
                    if (options.bytes !== Array)
                        object.value = $util.newBuffer(object.value);
                }
            }
            if (message.attribute != null && message.hasOwnProperty("attribute"))
                object.attribute = message.attribute;
            if (message.value != null && message.hasOwnProperty("value"))
                object.value = options.bytes === String ? $util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
            return object;
        };

        /**
         * Converts this KeyValMapping to JSON.
         * @function toJSON
         * @memberof request.KeyValMapping
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        KeyValMapping.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for KeyValMapping
         * @function getTypeUrl
         * @memberof request.KeyValMapping
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        KeyValMapping.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.KeyValMapping";
        };

        return KeyValMapping;
    })();

    request.Policy = (function() {

        /**
         * Properties of a Policy.
         * @memberof request
         * @interface IPolicy
         * @property {Array.<request.IKeyValMapping>|null} [attrToValue] Policy attrToValue
         */

        /**
         * Constructs a new Policy.
         * @memberof request
         * @classdesc Represents a Policy.
         * @implements IPolicy
         * @constructor
         * @param {request.IPolicy=} [properties] Properties to set
         */
        function Policy(properties) {
            this.attrToValue = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Policy attrToValue.
         * @member {Array.<request.IKeyValMapping>} attrToValue
         * @memberof request.Policy
         * @instance
         */
        Policy.prototype.attrToValue = $util.emptyArray;

        /**
         * Creates a new Policy instance using the specified properties.
         * @function create
         * @memberof request.Policy
         * @static
         * @param {request.IPolicy=} [properties] Properties to set
         * @returns {request.Policy} Policy instance
         */
        Policy.create = function create(properties) {
            return new Policy(properties);
        };

        /**
         * Encodes the specified Policy message. Does not implicitly {@link request.Policy.verify|verify} messages.
         * @function encode
         * @memberof request.Policy
         * @static
         * @param {request.IPolicy} message Policy message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Policy.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.attrToValue != null && message.attrToValue.length)
                for (let i = 0; i < message.attrToValue.length; ++i)
                    $root.request.KeyValMapping.encode(message.attrToValue[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified Policy message, length delimited. Does not implicitly {@link request.Policy.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.Policy
         * @static
         * @param {request.IPolicy} message Policy message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Policy.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Policy message from the specified reader or buffer.
         * @function decode
         * @memberof request.Policy
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.Policy} Policy
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Policy.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.Policy();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        if (!(message.attrToValue && message.attrToValue.length))
                            message.attrToValue = [];
                        message.attrToValue.push($root.request.KeyValMapping.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Policy message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.Policy
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.Policy} Policy
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Policy.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Policy message.
         * @function verify
         * @memberof request.Policy
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Policy.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.attrToValue != null && message.hasOwnProperty("attrToValue")) {
                if (!Array.isArray(message.attrToValue))
                    return "attrToValue: array expected";
                for (let i = 0; i < message.attrToValue.length; ++i) {
                    let error = $root.request.KeyValMapping.verify(message.attrToValue[i]);
                    if (error)
                        return "attrToValue." + error;
                }
            }
            return null;
        };

        /**
         * Creates a Policy message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.Policy
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.Policy} Policy
         */
        Policy.fromObject = function fromObject(object) {
            if (object instanceof $root.request.Policy)
                return object;
            let message = new $root.request.Policy();
            if (object.attrToValue) {
                if (!Array.isArray(object.attrToValue))
                    throw TypeError(".request.Policy.attrToValue: array expected");
                message.attrToValue = [];
                for (let i = 0; i < object.attrToValue.length; ++i) {
                    if (typeof object.attrToValue[i] !== "object")
                        throw TypeError(".request.Policy.attrToValue: object expected");
                    message.attrToValue[i] = $root.request.KeyValMapping.fromObject(object.attrToValue[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a Policy message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.Policy
         * @static
         * @param {request.Policy} message Policy
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Policy.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.attrToValue = [];
            if (message.attrToValue && message.attrToValue.length) {
                object.attrToValue = [];
                for (let j = 0; j < message.attrToValue.length; ++j)
                    object.attrToValue[j] = $root.request.KeyValMapping.toObject(message.attrToValue[j], options);
            }
            return object;
        };

        /**
         * Converts this Policy to JSON.
         * @function toJSON
         * @memberof request.Policy
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Policy.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Policy
         * @function getTypeUrl
         * @memberof request.Policy
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Policy.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.Policy";
        };

        return Policy;
    })();

    request.CreateFolder = (function() {

        /**
         * Properties of a CreateFolder.
         * @memberof request
         * @interface ICreateFolder
         * @property {string|null} [name] CreateFolder name
         * @property {string|null} [parentPath] CreateFolder parentPath
         * @property {request.TypeOfPath|null} [typeOfPath] CreateFolder typeOfPath
         * @property {request.IPolicy|null} [policy] CreateFolder policy
         */

        /**
         * Constructs a new CreateFolder.
         * @memberof request
         * @classdesc Represents a CreateFolder.
         * @implements ICreateFolder
         * @constructor
         * @param {request.ICreateFolder=} [properties] Properties to set
         */
        function CreateFolder(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CreateFolder name.
         * @member {string} name
         * @memberof request.CreateFolder
         * @instance
         */
        CreateFolder.prototype.name = "";

        /**
         * CreateFolder parentPath.
         * @member {string} parentPath
         * @memberof request.CreateFolder
         * @instance
         */
        CreateFolder.prototype.parentPath = "";

        /**
         * CreateFolder typeOfPath.
         * @member {request.TypeOfPath} typeOfPath
         * @memberof request.CreateFolder
         * @instance
         */
        CreateFolder.prototype.typeOfPath = 0;

        /**
         * CreateFolder policy.
         * @member {request.IPolicy|null|undefined} policy
         * @memberof request.CreateFolder
         * @instance
         */
        CreateFolder.prototype.policy = null;

        /**
         * Creates a new CreateFolder instance using the specified properties.
         * @function create
         * @memberof request.CreateFolder
         * @static
         * @param {request.ICreateFolder=} [properties] Properties to set
         * @returns {request.CreateFolder} CreateFolder instance
         */
        CreateFolder.create = function create(properties) {
            return new CreateFolder(properties);
        };

        /**
         * Encodes the specified CreateFolder message. Does not implicitly {@link request.CreateFolder.verify|verify} messages.
         * @function encode
         * @memberof request.CreateFolder
         * @static
         * @param {request.ICreateFolder} message CreateFolder message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateFolder.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.parentPath != null && Object.hasOwnProperty.call(message, "parentPath"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.parentPath);
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.name);
            if (message.typeOfPath != null && Object.hasOwnProperty.call(message, "typeOfPath"))
                writer.uint32(/* id 8, wireType 0 =*/64).int32(message.typeOfPath);
            if (message.policy != null && Object.hasOwnProperty.call(message, "policy"))
                $root.request.Policy.encode(message.policy, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified CreateFolder message, length delimited. Does not implicitly {@link request.CreateFolder.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.CreateFolder
         * @static
         * @param {request.ICreateFolder} message CreateFolder message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateFolder.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CreateFolder message from the specified reader or buffer.
         * @function decode
         * @memberof request.CreateFolder
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.CreateFolder} CreateFolder
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateFolder.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.CreateFolder();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 3: {
                        message.name = reader.string();
                        break;
                    }
                case 2: {
                        message.parentPath = reader.string();
                        break;
                    }
                case 8: {
                        message.typeOfPath = reader.int32();
                        break;
                    }
                case 9: {
                        message.policy = $root.request.Policy.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CreateFolder message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.CreateFolder
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.CreateFolder} CreateFolder
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateFolder.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CreateFolder message.
         * @function verify
         * @memberof request.CreateFolder
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CreateFolder.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.parentPath != null && message.hasOwnProperty("parentPath"))
                if (!$util.isString(message.parentPath))
                    return "parentPath: string expected";
            if (message.typeOfPath != null && message.hasOwnProperty("typeOfPath"))
                switch (message.typeOfPath) {
                default:
                    return "typeOfPath: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                    break;
                }
            if (message.policy != null && message.hasOwnProperty("policy")) {
                let error = $root.request.Policy.verify(message.policy);
                if (error)
                    return "policy." + error;
            }
            return null;
        };

        /**
         * Creates a CreateFolder message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.CreateFolder
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.CreateFolder} CreateFolder
         */
        CreateFolder.fromObject = function fromObject(object) {
            if (object instanceof $root.request.CreateFolder)
                return object;
            let message = new $root.request.CreateFolder();
            if (object.name != null)
                message.name = String(object.name);
            if (object.parentPath != null)
                message.parentPath = String(object.parentPath);
            switch (object.typeOfPath) {
            default:
                if (typeof object.typeOfPath === "number") {
                    message.typeOfPath = object.typeOfPath;
                    break;
                }
                break;
            case "TShareUser":
            case 0:
                message.typeOfPath = 0;
                break;
            case "TFolder":
            case 1:
                message.typeOfPath = 1;
                break;
            case "TShareTeam":
            case 2:
                message.typeOfPath = 2;
                break;
            case "TShareExternal":
            case 3:
                message.typeOfPath = 3;
                break;
            case "TFlow":
            case 4:
                message.typeOfPath = 4;
                break;
            }
            if (object.policy != null) {
                if (typeof object.policy !== "object")
                    throw TypeError(".request.CreateFolder.policy: object expected");
                message.policy = $root.request.Policy.fromObject(object.policy);
            }
            return message;
        };

        /**
         * Creates a plain object from a CreateFolder message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.CreateFolder
         * @static
         * @param {request.CreateFolder} message CreateFolder
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CreateFolder.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.parentPath = "";
                object.name = "";
                object.typeOfPath = options.enums === String ? "TShareUser" : 0;
                object.policy = null;
            }
            if (message.parentPath != null && message.hasOwnProperty("parentPath"))
                object.parentPath = message.parentPath;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.typeOfPath != null && message.hasOwnProperty("typeOfPath"))
                object.typeOfPath = options.enums === String ? $root.request.TypeOfPath[message.typeOfPath] === undefined ? message.typeOfPath : $root.request.TypeOfPath[message.typeOfPath] : message.typeOfPath;
            if (message.policy != null && message.hasOwnProperty("policy"))
                object.policy = $root.request.Policy.toObject(message.policy, options);
            return object;
        };

        /**
         * Converts this CreateFolder to JSON.
         * @function toJSON
         * @memberof request.CreateFolder
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CreateFolder.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CreateFolder
         * @function getTypeUrl
         * @memberof request.CreateFolder
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CreateFolder.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.CreateFolder";
        };

        return CreateFolder;
    })();

    request.GetPolicyFromName = (function() {

        /**
         * Properties of a GetPolicyFromName.
         * @memberof request
         * @interface IGetPolicyFromName
         * @property {string|null} [path] GetPolicyFromName path
         * @property {request.TypeOfPath|null} [typeOfPath] GetPolicyFromName typeOfPath
         */

        /**
         * Constructs a new GetPolicyFromName.
         * @memberof request
         * @classdesc Represents a GetPolicyFromName.
         * @implements IGetPolicyFromName
         * @constructor
         * @param {request.IGetPolicyFromName=} [properties] Properties to set
         */
        function GetPolicyFromName(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetPolicyFromName path.
         * @member {string} path
         * @memberof request.GetPolicyFromName
         * @instance
         */
        GetPolicyFromName.prototype.path = "";

        /**
         * GetPolicyFromName typeOfPath.
         * @member {request.TypeOfPath} typeOfPath
         * @memberof request.GetPolicyFromName
         * @instance
         */
        GetPolicyFromName.prototype.typeOfPath = 0;

        /**
         * Creates a new GetPolicyFromName instance using the specified properties.
         * @function create
         * @memberof request.GetPolicyFromName
         * @static
         * @param {request.IGetPolicyFromName=} [properties] Properties to set
         * @returns {request.GetPolicyFromName} GetPolicyFromName instance
         */
        GetPolicyFromName.create = function create(properties) {
            return new GetPolicyFromName(properties);
        };

        /**
         * Encodes the specified GetPolicyFromName message. Does not implicitly {@link request.GetPolicyFromName.verify|verify} messages.
         * @function encode
         * @memberof request.GetPolicyFromName
         * @static
         * @param {request.IGetPolicyFromName} message GetPolicyFromName message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetPolicyFromName.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.path != null && Object.hasOwnProperty.call(message, "path"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.path);
            if (message.typeOfPath != null && Object.hasOwnProperty.call(message, "typeOfPath"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.typeOfPath);
            return writer;
        };

        /**
         * Encodes the specified GetPolicyFromName message, length delimited. Does not implicitly {@link request.GetPolicyFromName.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.GetPolicyFromName
         * @static
         * @param {request.IGetPolicyFromName} message GetPolicyFromName message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetPolicyFromName.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetPolicyFromName message from the specified reader or buffer.
         * @function decode
         * @memberof request.GetPolicyFromName
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.GetPolicyFromName} GetPolicyFromName
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetPolicyFromName.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.GetPolicyFromName();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.path = reader.string();
                        break;
                    }
                case 2: {
                        message.typeOfPath = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetPolicyFromName message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.GetPolicyFromName
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.GetPolicyFromName} GetPolicyFromName
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetPolicyFromName.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetPolicyFromName message.
         * @function verify
         * @memberof request.GetPolicyFromName
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetPolicyFromName.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.path != null && message.hasOwnProperty("path"))
                if (!$util.isString(message.path))
                    return "path: string expected";
            if (message.typeOfPath != null && message.hasOwnProperty("typeOfPath"))
                switch (message.typeOfPath) {
                default:
                    return "typeOfPath: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                    break;
                }
            return null;
        };

        /**
         * Creates a GetPolicyFromName message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.GetPolicyFromName
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.GetPolicyFromName} GetPolicyFromName
         */
        GetPolicyFromName.fromObject = function fromObject(object) {
            if (object instanceof $root.request.GetPolicyFromName)
                return object;
            let message = new $root.request.GetPolicyFromName();
            if (object.path != null)
                message.path = String(object.path);
            switch (object.typeOfPath) {
            default:
                if (typeof object.typeOfPath === "number") {
                    message.typeOfPath = object.typeOfPath;
                    break;
                }
                break;
            case "TShareUser":
            case 0:
                message.typeOfPath = 0;
                break;
            case "TFolder":
            case 1:
                message.typeOfPath = 1;
                break;
            case "TShareTeam":
            case 2:
                message.typeOfPath = 2;
                break;
            case "TShareExternal":
            case 3:
                message.typeOfPath = 3;
                break;
            case "TFlow":
            case 4:
                message.typeOfPath = 4;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a GetPolicyFromName message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.GetPolicyFromName
         * @static
         * @param {request.GetPolicyFromName} message GetPolicyFromName
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetPolicyFromName.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.path = "";
                object.typeOfPath = options.enums === String ? "TShareUser" : 0;
            }
            if (message.path != null && message.hasOwnProperty("path"))
                object.path = message.path;
            if (message.typeOfPath != null && message.hasOwnProperty("typeOfPath"))
                object.typeOfPath = options.enums === String ? $root.request.TypeOfPath[message.typeOfPath] === undefined ? message.typeOfPath : $root.request.TypeOfPath[message.typeOfPath] : message.typeOfPath;
            return object;
        };

        /**
         * Converts this GetPolicyFromName to JSON.
         * @function toJSON
         * @memberof request.GetPolicyFromName
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetPolicyFromName.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetPolicyFromName
         * @function getTypeUrl
         * @memberof request.GetPolicyFromName
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetPolicyFromName.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.GetPolicyFromName";
        };

        return GetPolicyFromName;
    })();

    request.CreateSnapshot = (function() {

        /**
         * Properties of a CreateSnapshot.
         * @memberof request
         * @interface ICreateSnapshot
         * @property {Uint8Array|null} [uuid] CreateSnapshot uuid
         * @property {string|null} [snapshotName] CreateSnapshot snapshotName
         */

        /**
         * Constructs a new CreateSnapshot.
         * @memberof request
         * @classdesc Represents a CreateSnapshot.
         * @implements ICreateSnapshot
         * @constructor
         * @param {request.ICreateSnapshot=} [properties] Properties to set
         */
        function CreateSnapshot(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CreateSnapshot uuid.
         * @member {Uint8Array} uuid
         * @memberof request.CreateSnapshot
         * @instance
         */
        CreateSnapshot.prototype.uuid = $util.newBuffer([]);

        /**
         * CreateSnapshot snapshotName.
         * @member {string} snapshotName
         * @memberof request.CreateSnapshot
         * @instance
         */
        CreateSnapshot.prototype.snapshotName = "";

        /**
         * Creates a new CreateSnapshot instance using the specified properties.
         * @function create
         * @memberof request.CreateSnapshot
         * @static
         * @param {request.ICreateSnapshot=} [properties] Properties to set
         * @returns {request.CreateSnapshot} CreateSnapshot instance
         */
        CreateSnapshot.create = function create(properties) {
            return new CreateSnapshot(properties);
        };

        /**
         * Encodes the specified CreateSnapshot message. Does not implicitly {@link request.CreateSnapshot.verify|verify} messages.
         * @function encode
         * @memberof request.CreateSnapshot
         * @static
         * @param {request.ICreateSnapshot} message CreateSnapshot message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateSnapshot.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uuid != null && Object.hasOwnProperty.call(message, "uuid"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.uuid);
            if (message.snapshotName != null && Object.hasOwnProperty.call(message, "snapshotName"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.snapshotName);
            return writer;
        };

        /**
         * Encodes the specified CreateSnapshot message, length delimited. Does not implicitly {@link request.CreateSnapshot.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.CreateSnapshot
         * @static
         * @param {request.ICreateSnapshot} message CreateSnapshot message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateSnapshot.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CreateSnapshot message from the specified reader or buffer.
         * @function decode
         * @memberof request.CreateSnapshot
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.CreateSnapshot} CreateSnapshot
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateSnapshot.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.CreateSnapshot();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.uuid = reader.bytes();
                        break;
                    }
                case 2: {
                        message.snapshotName = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CreateSnapshot message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.CreateSnapshot
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.CreateSnapshot} CreateSnapshot
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateSnapshot.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CreateSnapshot message.
         * @function verify
         * @memberof request.CreateSnapshot
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CreateSnapshot.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                if (!(message.uuid && typeof message.uuid.length === "number" || $util.isString(message.uuid)))
                    return "uuid: buffer expected";
            if (message.snapshotName != null && message.hasOwnProperty("snapshotName"))
                if (!$util.isString(message.snapshotName))
                    return "snapshotName: string expected";
            return null;
        };

        /**
         * Creates a CreateSnapshot message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.CreateSnapshot
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.CreateSnapshot} CreateSnapshot
         */
        CreateSnapshot.fromObject = function fromObject(object) {
            if (object instanceof $root.request.CreateSnapshot)
                return object;
            let message = new $root.request.CreateSnapshot();
            if (object.uuid != null)
                if (typeof object.uuid === "string")
                    $util.base64.decode(object.uuid, message.uuid = $util.newBuffer($util.base64.length(object.uuid)), 0);
                else if (object.uuid.length >= 0)
                    message.uuid = object.uuid;
            if (object.snapshotName != null)
                message.snapshotName = String(object.snapshotName);
            return message;
        };

        /**
         * Creates a plain object from a CreateSnapshot message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.CreateSnapshot
         * @static
         * @param {request.CreateSnapshot} message CreateSnapshot
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CreateSnapshot.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if (options.bytes === String)
                    object.uuid = "";
                else {
                    object.uuid = [];
                    if (options.bytes !== Array)
                        object.uuid = $util.newBuffer(object.uuid);
                }
                object.snapshotName = "";
            }
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                object.uuid = options.bytes === String ? $util.base64.encode(message.uuid, 0, message.uuid.length) : options.bytes === Array ? Array.prototype.slice.call(message.uuid) : message.uuid;
            if (message.snapshotName != null && message.hasOwnProperty("snapshotName"))
                object.snapshotName = message.snapshotName;
            return object;
        };

        /**
         * Converts this CreateSnapshot to JSON.
         * @function toJSON
         * @memberof request.CreateSnapshot
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CreateSnapshot.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CreateSnapshot
         * @function getTypeUrl
         * @memberof request.CreateSnapshot
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CreateSnapshot.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.CreateSnapshot";
        };

        return CreateSnapshot;
    })();

    /**
     * SecretType enum.
     * @name request.SecretType
     * @enum {number}
     * @property {number} PASSWORD=0 PASSWORD value
     * @property {number} CARD=1 CARD value
     * @property {number} NOTE=2 NOTE value
     * @property {number} IDENTITY=3 IDENTITY value
     * @property {number} KEYVALUES=4 KEYVALUES value
     * @property {number} KEYS=5 KEYS value
     * @property {number} CERTIFICATE=6 CERTIFICATE value
     * @property {number} PRIVATEKEY=7 PRIVATEKEY value
     */
    request.SecretType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "PASSWORD"] = 0;
        values[valuesById[1] = "CARD"] = 1;
        values[valuesById[2] = "NOTE"] = 2;
        values[valuesById[3] = "IDENTITY"] = 3;
        values[valuesById[4] = "KEYVALUES"] = 4;
        values[valuesById[5] = "KEYS"] = 5;
        values[valuesById[6] = "CERTIFICATE"] = 6;
        values[valuesById[7] = "PRIVATEKEY"] = 7;
        return values;
    })();

    request.GetSecret = (function() {

        /**
         * Properties of a GetSecret.
         * @memberof request
         * @interface IGetSecret
         * @property {string|null} [path] GetSecret path
         */

        /**
         * Constructs a new GetSecret.
         * @memberof request
         * @classdesc Represents a GetSecret.
         * @implements IGetSecret
         * @constructor
         * @param {request.IGetSecret=} [properties] Properties to set
         */
        function GetSecret(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetSecret path.
         * @member {string} path
         * @memberof request.GetSecret
         * @instance
         */
        GetSecret.prototype.path = "";

        /**
         * Creates a new GetSecret instance using the specified properties.
         * @function create
         * @memberof request.GetSecret
         * @static
         * @param {request.IGetSecret=} [properties] Properties to set
         * @returns {request.GetSecret} GetSecret instance
         */
        GetSecret.create = function create(properties) {
            return new GetSecret(properties);
        };

        /**
         * Encodes the specified GetSecret message. Does not implicitly {@link request.GetSecret.verify|verify} messages.
         * @function encode
         * @memberof request.GetSecret
         * @static
         * @param {request.IGetSecret} message GetSecret message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetSecret.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.path != null && Object.hasOwnProperty.call(message, "path"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.path);
            return writer;
        };

        /**
         * Encodes the specified GetSecret message, length delimited. Does not implicitly {@link request.GetSecret.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.GetSecret
         * @static
         * @param {request.IGetSecret} message GetSecret message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetSecret.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetSecret message from the specified reader or buffer.
         * @function decode
         * @memberof request.GetSecret
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.GetSecret} GetSecret
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetSecret.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.GetSecret();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 2: {
                        message.path = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetSecret message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.GetSecret
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.GetSecret} GetSecret
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetSecret.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetSecret message.
         * @function verify
         * @memberof request.GetSecret
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetSecret.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.path != null && message.hasOwnProperty("path"))
                if (!$util.isString(message.path))
                    return "path: string expected";
            return null;
        };

        /**
         * Creates a GetSecret message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.GetSecret
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.GetSecret} GetSecret
         */
        GetSecret.fromObject = function fromObject(object) {
            if (object instanceof $root.request.GetSecret)
                return object;
            let message = new $root.request.GetSecret();
            if (object.path != null)
                message.path = String(object.path);
            return message;
        };

        /**
         * Creates a plain object from a GetSecret message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.GetSecret
         * @static
         * @param {request.GetSecret} message GetSecret
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetSecret.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.path = "";
            if (message.path != null && message.hasOwnProperty("path"))
                object.path = message.path;
            return object;
        };

        /**
         * Converts this GetSecret to JSON.
         * @function toJSON
         * @memberof request.GetSecret
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetSecret.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetSecret
         * @function getTypeUrl
         * @memberof request.GetSecret
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetSecret.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.GetSecret";
        };

        return GetSecret;
    })();

    request.AddSecret = (function() {

        /**
         * Properties of an AddSecret.
         * @memberof request
         * @interface IAddSecret
         * @property {string|null} [path] AddSecret path
         * @property {number|Long|null} [expiry] AddSecret expiry
         * @property {number|Long|null} [rotateInterval] AddSecret rotateInterval
         * @property {request.ISecretData|null} [secretData] AddSecret secretData
         */

        /**
         * Constructs a new AddSecret.
         * @memberof request
         * @classdesc Represents an AddSecret.
         * @implements IAddSecret
         * @constructor
         * @param {request.IAddSecret=} [properties] Properties to set
         */
        function AddSecret(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddSecret path.
         * @member {string} path
         * @memberof request.AddSecret
         * @instance
         */
        AddSecret.prototype.path = "";

        /**
         * AddSecret expiry.
         * @member {number|Long|null|undefined} expiry
         * @memberof request.AddSecret
         * @instance
         */
        AddSecret.prototype.expiry = null;

        /**
         * AddSecret rotateInterval.
         * @member {number|Long|null|undefined} rotateInterval
         * @memberof request.AddSecret
         * @instance
         */
        AddSecret.prototype.rotateInterval = null;

        /**
         * AddSecret secretData.
         * @member {request.ISecretData|null|undefined} secretData
         * @memberof request.AddSecret
         * @instance
         */
        AddSecret.prototype.secretData = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(AddSecret.prototype, "_expiry", {
            get: $util.oneOfGetter($oneOfFields = ["expiry"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(AddSecret.prototype, "_rotateInterval", {
            get: $util.oneOfGetter($oneOfFields = ["rotateInterval"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new AddSecret instance using the specified properties.
         * @function create
         * @memberof request.AddSecret
         * @static
         * @param {request.IAddSecret=} [properties] Properties to set
         * @returns {request.AddSecret} AddSecret instance
         */
        AddSecret.create = function create(properties) {
            return new AddSecret(properties);
        };

        /**
         * Encodes the specified AddSecret message. Does not implicitly {@link request.AddSecret.verify|verify} messages.
         * @function encode
         * @memberof request.AddSecret
         * @static
         * @param {request.IAddSecret} message AddSecret message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddSecret.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.path != null && Object.hasOwnProperty.call(message, "path"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.path);
            if (message.expiry != null && Object.hasOwnProperty.call(message, "expiry"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.expiry);
            if (message.rotateInterval != null && Object.hasOwnProperty.call(message, "rotateInterval"))
                writer.uint32(/* id 5, wireType 0 =*/40).uint64(message.rotateInterval);
            if (message.secretData != null && Object.hasOwnProperty.call(message, "secretData"))
                $root.request.SecretData.encode(message.secretData, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified AddSecret message, length delimited. Does not implicitly {@link request.AddSecret.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.AddSecret
         * @static
         * @param {request.IAddSecret} message AddSecret message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddSecret.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AddSecret message from the specified reader or buffer.
         * @function decode
         * @memberof request.AddSecret
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.AddSecret} AddSecret
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddSecret.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.AddSecret();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 3: {
                        message.path = reader.string();
                        break;
                    }
                case 4: {
                        message.expiry = reader.uint64();
                        break;
                    }
                case 5: {
                        message.rotateInterval = reader.uint64();
                        break;
                    }
                case 6: {
                        message.secretData = $root.request.SecretData.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AddSecret message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.AddSecret
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.AddSecret} AddSecret
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddSecret.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AddSecret message.
         * @function verify
         * @memberof request.AddSecret
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AddSecret.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.path != null && message.hasOwnProperty("path"))
                if (!$util.isString(message.path))
                    return "path: string expected";
            if (message.expiry != null && message.hasOwnProperty("expiry")) {
                properties._expiry = 1;
                if (!$util.isInteger(message.expiry) && !(message.expiry && $util.isInteger(message.expiry.low) && $util.isInteger(message.expiry.high)))
                    return "expiry: integer|Long expected";
            }
            if (message.rotateInterval != null && message.hasOwnProperty("rotateInterval")) {
                properties._rotateInterval = 1;
                if (!$util.isInteger(message.rotateInterval) && !(message.rotateInterval && $util.isInteger(message.rotateInterval.low) && $util.isInteger(message.rotateInterval.high)))
                    return "rotateInterval: integer|Long expected";
            }
            if (message.secretData != null && message.hasOwnProperty("secretData")) {
                let error = $root.request.SecretData.verify(message.secretData);
                if (error)
                    return "secretData." + error;
            }
            return null;
        };

        /**
         * Creates an AddSecret message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.AddSecret
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.AddSecret} AddSecret
         */
        AddSecret.fromObject = function fromObject(object) {
            if (object instanceof $root.request.AddSecret)
                return object;
            let message = new $root.request.AddSecret();
            if (object.path != null)
                message.path = String(object.path);
            if (object.expiry != null)
                if ($util.Long)
                    (message.expiry = $util.Long.fromValue(object.expiry)).unsigned = true;
                else if (typeof object.expiry === "string")
                    message.expiry = parseInt(object.expiry, 10);
                else if (typeof object.expiry === "number")
                    message.expiry = object.expiry;
                else if (typeof object.expiry === "object")
                    message.expiry = new $util.LongBits(object.expiry.low >>> 0, object.expiry.high >>> 0).toNumber(true);
            if (object.rotateInterval != null)
                if ($util.Long)
                    (message.rotateInterval = $util.Long.fromValue(object.rotateInterval)).unsigned = true;
                else if (typeof object.rotateInterval === "string")
                    message.rotateInterval = parseInt(object.rotateInterval, 10);
                else if (typeof object.rotateInterval === "number")
                    message.rotateInterval = object.rotateInterval;
                else if (typeof object.rotateInterval === "object")
                    message.rotateInterval = new $util.LongBits(object.rotateInterval.low >>> 0, object.rotateInterval.high >>> 0).toNumber(true);
            if (object.secretData != null) {
                if (typeof object.secretData !== "object")
                    throw TypeError(".request.AddSecret.secretData: object expected");
                message.secretData = $root.request.SecretData.fromObject(object.secretData);
            }
            return message;
        };

        /**
         * Creates a plain object from an AddSecret message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.AddSecret
         * @static
         * @param {request.AddSecret} message AddSecret
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddSecret.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.path = "";
                object.secretData = null;
            }
            if (message.path != null && message.hasOwnProperty("path"))
                object.path = message.path;
            if (message.expiry != null && message.hasOwnProperty("expiry")) {
                if (typeof message.expiry === "number")
                    object.expiry = options.longs === String ? String(message.expiry) : message.expiry;
                else
                    object.expiry = options.longs === String ? $util.Long.prototype.toString.call(message.expiry) : options.longs === Number ? new $util.LongBits(message.expiry.low >>> 0, message.expiry.high >>> 0).toNumber(true) : message.expiry;
                if (options.oneofs)
                    object._expiry = "expiry";
            }
            if (message.rotateInterval != null && message.hasOwnProperty("rotateInterval")) {
                if (typeof message.rotateInterval === "number")
                    object.rotateInterval = options.longs === String ? String(message.rotateInterval) : message.rotateInterval;
                else
                    object.rotateInterval = options.longs === String ? $util.Long.prototype.toString.call(message.rotateInterval) : options.longs === Number ? new $util.LongBits(message.rotateInterval.low >>> 0, message.rotateInterval.high >>> 0).toNumber(true) : message.rotateInterval;
                if (options.oneofs)
                    object._rotateInterval = "rotateInterval";
            }
            if (message.secretData != null && message.hasOwnProperty("secretData"))
                object.secretData = $root.request.SecretData.toObject(message.secretData, options);
            return object;
        };

        /**
         * Converts this AddSecret to JSON.
         * @function toJSON
         * @memberof request.AddSecret
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddSecret.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for AddSecret
         * @function getTypeUrl
         * @memberof request.AddSecret
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        AddSecret.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.AddSecret";
        };

        return AddSecret;
    })();

    request.DeleteSecret = (function() {

        /**
         * Properties of a DeleteSecret.
         * @memberof request
         * @interface IDeleteSecret
         * @property {string|null} [path] DeleteSecret path
         */

        /**
         * Constructs a new DeleteSecret.
         * @memberof request
         * @classdesc Represents a DeleteSecret.
         * @implements IDeleteSecret
         * @constructor
         * @param {request.IDeleteSecret=} [properties] Properties to set
         */
        function DeleteSecret(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DeleteSecret path.
         * @member {string} path
         * @memberof request.DeleteSecret
         * @instance
         */
        DeleteSecret.prototype.path = "";

        /**
         * Creates a new DeleteSecret instance using the specified properties.
         * @function create
         * @memberof request.DeleteSecret
         * @static
         * @param {request.IDeleteSecret=} [properties] Properties to set
         * @returns {request.DeleteSecret} DeleteSecret instance
         */
        DeleteSecret.create = function create(properties) {
            return new DeleteSecret(properties);
        };

        /**
         * Encodes the specified DeleteSecret message. Does not implicitly {@link request.DeleteSecret.verify|verify} messages.
         * @function encode
         * @memberof request.DeleteSecret
         * @static
         * @param {request.IDeleteSecret} message DeleteSecret message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DeleteSecret.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.path != null && Object.hasOwnProperty.call(message, "path"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.path);
            return writer;
        };

        /**
         * Encodes the specified DeleteSecret message, length delimited. Does not implicitly {@link request.DeleteSecret.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.DeleteSecret
         * @static
         * @param {request.IDeleteSecret} message DeleteSecret message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DeleteSecret.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a DeleteSecret message from the specified reader or buffer.
         * @function decode
         * @memberof request.DeleteSecret
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.DeleteSecret} DeleteSecret
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DeleteSecret.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.DeleteSecret();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 2: {
                        message.path = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a DeleteSecret message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.DeleteSecret
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.DeleteSecret} DeleteSecret
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DeleteSecret.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a DeleteSecret message.
         * @function verify
         * @memberof request.DeleteSecret
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        DeleteSecret.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.path != null && message.hasOwnProperty("path"))
                if (!$util.isString(message.path))
                    return "path: string expected";
            return null;
        };

        /**
         * Creates a DeleteSecret message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.DeleteSecret
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.DeleteSecret} DeleteSecret
         */
        DeleteSecret.fromObject = function fromObject(object) {
            if (object instanceof $root.request.DeleteSecret)
                return object;
            let message = new $root.request.DeleteSecret();
            if (object.path != null)
                message.path = String(object.path);
            return message;
        };

        /**
         * Creates a plain object from a DeleteSecret message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.DeleteSecret
         * @static
         * @param {request.DeleteSecret} message DeleteSecret
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DeleteSecret.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.path = "";
            if (message.path != null && message.hasOwnProperty("path"))
                object.path = message.path;
            return object;
        };

        /**
         * Converts this DeleteSecret to JSON.
         * @function toJSON
         * @memberof request.DeleteSecret
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DeleteSecret.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for DeleteSecret
         * @function getTypeUrl
         * @memberof request.DeleteSecret
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        DeleteSecret.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.DeleteSecret";
        };

        return DeleteSecret;
    })();

    request.DestroySecret = (function() {

        /**
         * Properties of a DestroySecret.
         * @memberof request
         * @interface IDestroySecret
         * @property {string|null} [path] DestroySecret path
         */

        /**
         * Constructs a new DestroySecret.
         * @memberof request
         * @classdesc Represents a DestroySecret.
         * @implements IDestroySecret
         * @constructor
         * @param {request.IDestroySecret=} [properties] Properties to set
         */
        function DestroySecret(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DestroySecret path.
         * @member {string} path
         * @memberof request.DestroySecret
         * @instance
         */
        DestroySecret.prototype.path = "";

        /**
         * Creates a new DestroySecret instance using the specified properties.
         * @function create
         * @memberof request.DestroySecret
         * @static
         * @param {request.IDestroySecret=} [properties] Properties to set
         * @returns {request.DestroySecret} DestroySecret instance
         */
        DestroySecret.create = function create(properties) {
            return new DestroySecret(properties);
        };

        /**
         * Encodes the specified DestroySecret message. Does not implicitly {@link request.DestroySecret.verify|verify} messages.
         * @function encode
         * @memberof request.DestroySecret
         * @static
         * @param {request.IDestroySecret} message DestroySecret message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DestroySecret.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.path != null && Object.hasOwnProperty.call(message, "path"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.path);
            return writer;
        };

        /**
         * Encodes the specified DestroySecret message, length delimited. Does not implicitly {@link request.DestroySecret.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.DestroySecret
         * @static
         * @param {request.IDestroySecret} message DestroySecret message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DestroySecret.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a DestroySecret message from the specified reader or buffer.
         * @function decode
         * @memberof request.DestroySecret
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.DestroySecret} DestroySecret
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DestroySecret.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.DestroySecret();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 2: {
                        message.path = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a DestroySecret message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.DestroySecret
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.DestroySecret} DestroySecret
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DestroySecret.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a DestroySecret message.
         * @function verify
         * @memberof request.DestroySecret
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        DestroySecret.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.path != null && message.hasOwnProperty("path"))
                if (!$util.isString(message.path))
                    return "path: string expected";
            return null;
        };

        /**
         * Creates a DestroySecret message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.DestroySecret
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.DestroySecret} DestroySecret
         */
        DestroySecret.fromObject = function fromObject(object) {
            if (object instanceof $root.request.DestroySecret)
                return object;
            let message = new $root.request.DestroySecret();
            if (object.path != null)
                message.path = String(object.path);
            return message;
        };

        /**
         * Creates a plain object from a DestroySecret message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.DestroySecret
         * @static
         * @param {request.DestroySecret} message DestroySecret
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DestroySecret.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.path = "";
            if (message.path != null && message.hasOwnProperty("path"))
                object.path = message.path;
            return object;
        };

        /**
         * Converts this DestroySecret to JSON.
         * @function toJSON
         * @memberof request.DestroySecret
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DestroySecret.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for DestroySecret
         * @function getTypeUrl
         * @memberof request.DestroySecret
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        DestroySecret.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.DestroySecret";
        };

        return DestroySecret;
    })();

    request.UpdateSecret = (function() {

        /**
         * Properties of an UpdateSecret.
         * @memberof request
         * @interface IUpdateSecret
         * @property {string|null} [path] UpdateSecret path
         * @property {number|Long|null} [expiry] UpdateSecret expiry
         * @property {request.ISecretData|null} [secretData] UpdateSecret secretData
         */

        /**
         * Constructs a new UpdateSecret.
         * @memberof request
         * @classdesc Represents an UpdateSecret.
         * @implements IUpdateSecret
         * @constructor
         * @param {request.IUpdateSecret=} [properties] Properties to set
         */
        function UpdateSecret(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateSecret path.
         * @member {string} path
         * @memberof request.UpdateSecret
         * @instance
         */
        UpdateSecret.prototype.path = "";

        /**
         * UpdateSecret expiry.
         * @member {number|Long|null|undefined} expiry
         * @memberof request.UpdateSecret
         * @instance
         */
        UpdateSecret.prototype.expiry = null;

        /**
         * UpdateSecret secretData.
         * @member {request.ISecretData|null|undefined} secretData
         * @memberof request.UpdateSecret
         * @instance
         */
        UpdateSecret.prototype.secretData = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(UpdateSecret.prototype, "_expiry", {
            get: $util.oneOfGetter($oneOfFields = ["expiry"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new UpdateSecret instance using the specified properties.
         * @function create
         * @memberof request.UpdateSecret
         * @static
         * @param {request.IUpdateSecret=} [properties] Properties to set
         * @returns {request.UpdateSecret} UpdateSecret instance
         */
        UpdateSecret.create = function create(properties) {
            return new UpdateSecret(properties);
        };

        /**
         * Encodes the specified UpdateSecret message. Does not implicitly {@link request.UpdateSecret.verify|verify} messages.
         * @function encode
         * @memberof request.UpdateSecret
         * @static
         * @param {request.IUpdateSecret} message UpdateSecret message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateSecret.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.path != null && Object.hasOwnProperty.call(message, "path"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.path);
            if (message.expiry != null && Object.hasOwnProperty.call(message, "expiry"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.expiry);
            if (message.secretData != null && Object.hasOwnProperty.call(message, "secretData"))
                $root.request.SecretData.encode(message.secretData, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified UpdateSecret message, length delimited. Does not implicitly {@link request.UpdateSecret.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.UpdateSecret
         * @static
         * @param {request.IUpdateSecret} message UpdateSecret message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateSecret.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UpdateSecret message from the specified reader or buffer.
         * @function decode
         * @memberof request.UpdateSecret
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.UpdateSecret} UpdateSecret
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateSecret.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.UpdateSecret();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 2: {
                        message.path = reader.string();
                        break;
                    }
                case 3: {
                        message.expiry = reader.uint64();
                        break;
                    }
                case 4: {
                        message.secretData = $root.request.SecretData.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UpdateSecret message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.UpdateSecret
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.UpdateSecret} UpdateSecret
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateSecret.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UpdateSecret message.
         * @function verify
         * @memberof request.UpdateSecret
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UpdateSecret.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.path != null && message.hasOwnProperty("path"))
                if (!$util.isString(message.path))
                    return "path: string expected";
            if (message.expiry != null && message.hasOwnProperty("expiry")) {
                properties._expiry = 1;
                if (!$util.isInteger(message.expiry) && !(message.expiry && $util.isInteger(message.expiry.low) && $util.isInteger(message.expiry.high)))
                    return "expiry: integer|Long expected";
            }
            if (message.secretData != null && message.hasOwnProperty("secretData")) {
                let error = $root.request.SecretData.verify(message.secretData);
                if (error)
                    return "secretData." + error;
            }
            return null;
        };

        /**
         * Creates an UpdateSecret message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.UpdateSecret
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.UpdateSecret} UpdateSecret
         */
        UpdateSecret.fromObject = function fromObject(object) {
            if (object instanceof $root.request.UpdateSecret)
                return object;
            let message = new $root.request.UpdateSecret();
            if (object.path != null)
                message.path = String(object.path);
            if (object.expiry != null)
                if ($util.Long)
                    (message.expiry = $util.Long.fromValue(object.expiry)).unsigned = true;
                else if (typeof object.expiry === "string")
                    message.expiry = parseInt(object.expiry, 10);
                else if (typeof object.expiry === "number")
                    message.expiry = object.expiry;
                else if (typeof object.expiry === "object")
                    message.expiry = new $util.LongBits(object.expiry.low >>> 0, object.expiry.high >>> 0).toNumber(true);
            if (object.secretData != null) {
                if (typeof object.secretData !== "object")
                    throw TypeError(".request.UpdateSecret.secretData: object expected");
                message.secretData = $root.request.SecretData.fromObject(object.secretData);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateSecret message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.UpdateSecret
         * @static
         * @param {request.UpdateSecret} message UpdateSecret
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateSecret.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.path = "";
                object.secretData = null;
            }
            if (message.path != null && message.hasOwnProperty("path"))
                object.path = message.path;
            if (message.expiry != null && message.hasOwnProperty("expiry")) {
                if (typeof message.expiry === "number")
                    object.expiry = options.longs === String ? String(message.expiry) : message.expiry;
                else
                    object.expiry = options.longs === String ? $util.Long.prototype.toString.call(message.expiry) : options.longs === Number ? new $util.LongBits(message.expiry.low >>> 0, message.expiry.high >>> 0).toNumber(true) : message.expiry;
                if (options.oneofs)
                    object._expiry = "expiry";
            }
            if (message.secretData != null && message.hasOwnProperty("secretData"))
                object.secretData = $root.request.SecretData.toObject(message.secretData, options);
            return object;
        };

        /**
         * Converts this UpdateSecret to JSON.
         * @function toJSON
         * @memberof request.UpdateSecret
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateSecret.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for UpdateSecret
         * @function getTypeUrl
         * @memberof request.UpdateSecret
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        UpdateSecret.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.UpdateSecret";
        };

        return UpdateSecret;
    })();

    request.ListSecrets = (function() {

        /**
         * Properties of a ListSecrets.
         * @memberof request
         * @interface IListSecrets
         */

        /**
         * Constructs a new ListSecrets.
         * @memberof request
         * @classdesc Represents a ListSecrets.
         * @implements IListSecrets
         * @constructor
         * @param {request.IListSecrets=} [properties] Properties to set
         */
        function ListSecrets(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new ListSecrets instance using the specified properties.
         * @function create
         * @memberof request.ListSecrets
         * @static
         * @param {request.IListSecrets=} [properties] Properties to set
         * @returns {request.ListSecrets} ListSecrets instance
         */
        ListSecrets.create = function create(properties) {
            return new ListSecrets(properties);
        };

        /**
         * Encodes the specified ListSecrets message. Does not implicitly {@link request.ListSecrets.verify|verify} messages.
         * @function encode
         * @memberof request.ListSecrets
         * @static
         * @param {request.IListSecrets} message ListSecrets message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListSecrets.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified ListSecrets message, length delimited. Does not implicitly {@link request.ListSecrets.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.ListSecrets
         * @static
         * @param {request.IListSecrets} message ListSecrets message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListSecrets.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ListSecrets message from the specified reader or buffer.
         * @function decode
         * @memberof request.ListSecrets
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.ListSecrets} ListSecrets
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListSecrets.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.ListSecrets();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ListSecrets message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.ListSecrets
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.ListSecrets} ListSecrets
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListSecrets.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ListSecrets message.
         * @function verify
         * @memberof request.ListSecrets
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ListSecrets.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a ListSecrets message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.ListSecrets
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.ListSecrets} ListSecrets
         */
        ListSecrets.fromObject = function fromObject(object) {
            if (object instanceof $root.request.ListSecrets)
                return object;
            return new $root.request.ListSecrets();
        };

        /**
         * Creates a plain object from a ListSecrets message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.ListSecrets
         * @static
         * @param {request.ListSecrets} message ListSecrets
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListSecrets.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this ListSecrets to JSON.
         * @function toJSON
         * @memberof request.ListSecrets
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListSecrets.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ListSecrets
         * @function getTypeUrl
         * @memberof request.ListSecrets
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ListSecrets.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.ListSecrets";
        };

        return ListSecrets;
    })();

    request.QuickListSecrets = (function() {

        /**
         * Properties of a QuickListSecrets.
         * @memberof request
         * @interface IQuickListSecrets
         */

        /**
         * Constructs a new QuickListSecrets.
         * @memberof request
         * @classdesc Represents a QuickListSecrets.
         * @implements IQuickListSecrets
         * @constructor
         * @param {request.IQuickListSecrets=} [properties] Properties to set
         */
        function QuickListSecrets(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new QuickListSecrets instance using the specified properties.
         * @function create
         * @memberof request.QuickListSecrets
         * @static
         * @param {request.IQuickListSecrets=} [properties] Properties to set
         * @returns {request.QuickListSecrets} QuickListSecrets instance
         */
        QuickListSecrets.create = function create(properties) {
            return new QuickListSecrets(properties);
        };

        /**
         * Encodes the specified QuickListSecrets message. Does not implicitly {@link request.QuickListSecrets.verify|verify} messages.
         * @function encode
         * @memberof request.QuickListSecrets
         * @static
         * @param {request.IQuickListSecrets} message QuickListSecrets message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        QuickListSecrets.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified QuickListSecrets message, length delimited. Does not implicitly {@link request.QuickListSecrets.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.QuickListSecrets
         * @static
         * @param {request.IQuickListSecrets} message QuickListSecrets message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        QuickListSecrets.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a QuickListSecrets message from the specified reader or buffer.
         * @function decode
         * @memberof request.QuickListSecrets
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.QuickListSecrets} QuickListSecrets
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        QuickListSecrets.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.QuickListSecrets();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a QuickListSecrets message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.QuickListSecrets
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.QuickListSecrets} QuickListSecrets
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        QuickListSecrets.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a QuickListSecrets message.
         * @function verify
         * @memberof request.QuickListSecrets
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        QuickListSecrets.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a QuickListSecrets message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.QuickListSecrets
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.QuickListSecrets} QuickListSecrets
         */
        QuickListSecrets.fromObject = function fromObject(object) {
            if (object instanceof $root.request.QuickListSecrets)
                return object;
            return new $root.request.QuickListSecrets();
        };

        /**
         * Creates a plain object from a QuickListSecrets message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.QuickListSecrets
         * @static
         * @param {request.QuickListSecrets} message QuickListSecrets
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        QuickListSecrets.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this QuickListSecrets to JSON.
         * @function toJSON
         * @memberof request.QuickListSecrets
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        QuickListSecrets.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for QuickListSecrets
         * @function getTypeUrl
         * @memberof request.QuickListSecrets
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        QuickListSecrets.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.QuickListSecrets";
        };

        return QuickListSecrets;
    })();

    request.ListSecretSubkeys = (function() {

        /**
         * Properties of a ListSecretSubkeys.
         * @memberof request
         * @interface IListSecretSubkeys
         * @property {string|null} [path] ListSecretSubkeys path
         */

        /**
         * Constructs a new ListSecretSubkeys.
         * @memberof request
         * @classdesc Represents a ListSecretSubkeys.
         * @implements IListSecretSubkeys
         * @constructor
         * @param {request.IListSecretSubkeys=} [properties] Properties to set
         */
        function ListSecretSubkeys(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListSecretSubkeys path.
         * @member {string} path
         * @memberof request.ListSecretSubkeys
         * @instance
         */
        ListSecretSubkeys.prototype.path = "";

        /**
         * Creates a new ListSecretSubkeys instance using the specified properties.
         * @function create
         * @memberof request.ListSecretSubkeys
         * @static
         * @param {request.IListSecretSubkeys=} [properties] Properties to set
         * @returns {request.ListSecretSubkeys} ListSecretSubkeys instance
         */
        ListSecretSubkeys.create = function create(properties) {
            return new ListSecretSubkeys(properties);
        };

        /**
         * Encodes the specified ListSecretSubkeys message. Does not implicitly {@link request.ListSecretSubkeys.verify|verify} messages.
         * @function encode
         * @memberof request.ListSecretSubkeys
         * @static
         * @param {request.IListSecretSubkeys} message ListSecretSubkeys message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListSecretSubkeys.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.path != null && Object.hasOwnProperty.call(message, "path"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.path);
            return writer;
        };

        /**
         * Encodes the specified ListSecretSubkeys message, length delimited. Does not implicitly {@link request.ListSecretSubkeys.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.ListSecretSubkeys
         * @static
         * @param {request.IListSecretSubkeys} message ListSecretSubkeys message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListSecretSubkeys.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ListSecretSubkeys message from the specified reader or buffer.
         * @function decode
         * @memberof request.ListSecretSubkeys
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.ListSecretSubkeys} ListSecretSubkeys
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListSecretSubkeys.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.ListSecretSubkeys();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 2: {
                        message.path = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ListSecretSubkeys message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.ListSecretSubkeys
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.ListSecretSubkeys} ListSecretSubkeys
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListSecretSubkeys.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ListSecretSubkeys message.
         * @function verify
         * @memberof request.ListSecretSubkeys
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ListSecretSubkeys.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.path != null && message.hasOwnProperty("path"))
                if (!$util.isString(message.path))
                    return "path: string expected";
            return null;
        };

        /**
         * Creates a ListSecretSubkeys message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.ListSecretSubkeys
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.ListSecretSubkeys} ListSecretSubkeys
         */
        ListSecretSubkeys.fromObject = function fromObject(object) {
            if (object instanceof $root.request.ListSecretSubkeys)
                return object;
            let message = new $root.request.ListSecretSubkeys();
            if (object.path != null)
                message.path = String(object.path);
            return message;
        };

        /**
         * Creates a plain object from a ListSecretSubkeys message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.ListSecretSubkeys
         * @static
         * @param {request.ListSecretSubkeys} message ListSecretSubkeys
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListSecretSubkeys.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.path = "";
            if (message.path != null && message.hasOwnProperty("path"))
                object.path = message.path;
            return object;
        };

        /**
         * Converts this ListSecretSubkeys to JSON.
         * @function toJSON
         * @memberof request.ListSecretSubkeys
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListSecretSubkeys.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ListSecretSubkeys
         * @function getTypeUrl
         * @memberof request.ListSecretSubkeys
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ListSecretSubkeys.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.ListSecretSubkeys";
        };

        return ListSecretSubkeys;
    })();

    request.UndeleteSecret = (function() {

        /**
         * Properties of an UndeleteSecret.
         * @memberof request
         * @interface IUndeleteSecret
         * @property {string|null} [path] UndeleteSecret path
         */

        /**
         * Constructs a new UndeleteSecret.
         * @memberof request
         * @classdesc Represents an UndeleteSecret.
         * @implements IUndeleteSecret
         * @constructor
         * @param {request.IUndeleteSecret=} [properties] Properties to set
         */
        function UndeleteSecret(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UndeleteSecret path.
         * @member {string} path
         * @memberof request.UndeleteSecret
         * @instance
         */
        UndeleteSecret.prototype.path = "";

        /**
         * Creates a new UndeleteSecret instance using the specified properties.
         * @function create
         * @memberof request.UndeleteSecret
         * @static
         * @param {request.IUndeleteSecret=} [properties] Properties to set
         * @returns {request.UndeleteSecret} UndeleteSecret instance
         */
        UndeleteSecret.create = function create(properties) {
            return new UndeleteSecret(properties);
        };

        /**
         * Encodes the specified UndeleteSecret message. Does not implicitly {@link request.UndeleteSecret.verify|verify} messages.
         * @function encode
         * @memberof request.UndeleteSecret
         * @static
         * @param {request.IUndeleteSecret} message UndeleteSecret message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UndeleteSecret.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.path != null && Object.hasOwnProperty.call(message, "path"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.path);
            return writer;
        };

        /**
         * Encodes the specified UndeleteSecret message, length delimited. Does not implicitly {@link request.UndeleteSecret.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.UndeleteSecret
         * @static
         * @param {request.IUndeleteSecret} message UndeleteSecret message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UndeleteSecret.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UndeleteSecret message from the specified reader or buffer.
         * @function decode
         * @memberof request.UndeleteSecret
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.UndeleteSecret} UndeleteSecret
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UndeleteSecret.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.UndeleteSecret();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 2: {
                        message.path = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UndeleteSecret message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.UndeleteSecret
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.UndeleteSecret} UndeleteSecret
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UndeleteSecret.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UndeleteSecret message.
         * @function verify
         * @memberof request.UndeleteSecret
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UndeleteSecret.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.path != null && message.hasOwnProperty("path"))
                if (!$util.isString(message.path))
                    return "path: string expected";
            return null;
        };

        /**
         * Creates an UndeleteSecret message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.UndeleteSecret
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.UndeleteSecret} UndeleteSecret
         */
        UndeleteSecret.fromObject = function fromObject(object) {
            if (object instanceof $root.request.UndeleteSecret)
                return object;
            let message = new $root.request.UndeleteSecret();
            if (object.path != null)
                message.path = String(object.path);
            return message;
        };

        /**
         * Creates a plain object from an UndeleteSecret message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.UndeleteSecret
         * @static
         * @param {request.UndeleteSecret} message UndeleteSecret
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UndeleteSecret.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.path = "";
            if (message.path != null && message.hasOwnProperty("path"))
                object.path = message.path;
            return object;
        };

        /**
         * Converts this UndeleteSecret to JSON.
         * @function toJSON
         * @memberof request.UndeleteSecret
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UndeleteSecret.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for UndeleteSecret
         * @function getTypeUrl
         * @memberof request.UndeleteSecret
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        UndeleteSecret.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.UndeleteSecret";
        };

        return UndeleteSecret;
    })();

    request.Password = (function() {

        /**
         * Properties of a Password.
         * @memberof request
         * @interface IPassword
         * @property {string|null} [username] Password username
         * @property {string|null} [password] Password password
         * @property {string|null} [url] Password url
         * @property {string|null} [totpSecret] Password totpSecret
         * @property {string|null} [notes] Password notes
         */

        /**
         * Constructs a new Password.
         * @memberof request
         * @classdesc Represents a Password.
         * @implements IPassword
         * @constructor
         * @param {request.IPassword=} [properties] Properties to set
         */
        function Password(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Password username.
         * @member {string} username
         * @memberof request.Password
         * @instance
         */
        Password.prototype.username = "";

        /**
         * Password password.
         * @member {string} password
         * @memberof request.Password
         * @instance
         */
        Password.prototype.password = "";

        /**
         * Password url.
         * @member {string} url
         * @memberof request.Password
         * @instance
         */
        Password.prototype.url = "";

        /**
         * Password totpSecret.
         * @member {string} totpSecret
         * @memberof request.Password
         * @instance
         */
        Password.prototype.totpSecret = "";

        /**
         * Password notes.
         * @member {string} notes
         * @memberof request.Password
         * @instance
         */
        Password.prototype.notes = "";

        /**
         * Creates a new Password instance using the specified properties.
         * @function create
         * @memberof request.Password
         * @static
         * @param {request.IPassword=} [properties] Properties to set
         * @returns {request.Password} Password instance
         */
        Password.create = function create(properties) {
            return new Password(properties);
        };

        /**
         * Encodes the specified Password message. Does not implicitly {@link request.Password.verify|verify} messages.
         * @function encode
         * @memberof request.Password
         * @static
         * @param {request.IPassword} message Password message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Password.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.username != null && Object.hasOwnProperty.call(message, "username"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.username);
            if (message.password != null && Object.hasOwnProperty.call(message, "password"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.password);
            if (message.url != null && Object.hasOwnProperty.call(message, "url"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.url);
            if (message.notes != null && Object.hasOwnProperty.call(message, "notes"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.notes);
            if (message.totpSecret != null && Object.hasOwnProperty.call(message, "totpSecret"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.totpSecret);
            return writer;
        };

        /**
         * Encodes the specified Password message, length delimited. Does not implicitly {@link request.Password.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.Password
         * @static
         * @param {request.IPassword} message Password message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Password.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Password message from the specified reader or buffer.
         * @function decode
         * @memberof request.Password
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.Password} Password
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Password.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.Password();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 2: {
                        message.username = reader.string();
                        break;
                    }
                case 3: {
                        message.password = reader.string();
                        break;
                    }
                case 4: {
                        message.url = reader.string();
                        break;
                    }
                case 6: {
                        message.totpSecret = reader.string();
                        break;
                    }
                case 5: {
                        message.notes = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Password message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.Password
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.Password} Password
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Password.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Password message.
         * @function verify
         * @memberof request.Password
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Password.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.username != null && message.hasOwnProperty("username"))
                if (!$util.isString(message.username))
                    return "username: string expected";
            if (message.password != null && message.hasOwnProperty("password"))
                if (!$util.isString(message.password))
                    return "password: string expected";
            if (message.url != null && message.hasOwnProperty("url"))
                if (!$util.isString(message.url))
                    return "url: string expected";
            if (message.totpSecret != null && message.hasOwnProperty("totpSecret"))
                if (!$util.isString(message.totpSecret))
                    return "totpSecret: string expected";
            if (message.notes != null && message.hasOwnProperty("notes"))
                if (!$util.isString(message.notes))
                    return "notes: string expected";
            return null;
        };

        /**
         * Creates a Password message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.Password
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.Password} Password
         */
        Password.fromObject = function fromObject(object) {
            if (object instanceof $root.request.Password)
                return object;
            let message = new $root.request.Password();
            if (object.username != null)
                message.username = String(object.username);
            if (object.password != null)
                message.password = String(object.password);
            if (object.url != null)
                message.url = String(object.url);
            if (object.totpSecret != null)
                message.totpSecret = String(object.totpSecret);
            if (object.notes != null)
                message.notes = String(object.notes);
            return message;
        };

        /**
         * Creates a plain object from a Password message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.Password
         * @static
         * @param {request.Password} message Password
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Password.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.username = "";
                object.password = "";
                object.url = "";
                object.notes = "";
                object.totpSecret = "";
            }
            if (message.username != null && message.hasOwnProperty("username"))
                object.username = message.username;
            if (message.password != null && message.hasOwnProperty("password"))
                object.password = message.password;
            if (message.url != null && message.hasOwnProperty("url"))
                object.url = message.url;
            if (message.notes != null && message.hasOwnProperty("notes"))
                object.notes = message.notes;
            if (message.totpSecret != null && message.hasOwnProperty("totpSecret"))
                object.totpSecret = message.totpSecret;
            return object;
        };

        /**
         * Converts this Password to JSON.
         * @function toJSON
         * @memberof request.Password
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Password.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Password
         * @function getTypeUrl
         * @memberof request.Password
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Password.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.Password";
        };

        return Password;
    })();

    request.Card = (function() {

        /**
         * Properties of a Card.
         * @memberof request
         * @interface ICard
         * @property {string|null} [number] Card number
         * @property {string|null} [cvv] Card cvv
         * @property {string|null} [expiry] Card expiry
         * @property {string|null} [notes] Card notes
         */

        /**
         * Constructs a new Card.
         * @memberof request
         * @classdesc Represents a Card.
         * @implements ICard
         * @constructor
         * @param {request.ICard=} [properties] Properties to set
         */
        function Card(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Card number.
         * @member {string} number
         * @memberof request.Card
         * @instance
         */
        Card.prototype.number = "";

        /**
         * Card cvv.
         * @member {string} cvv
         * @memberof request.Card
         * @instance
         */
        Card.prototype.cvv = "";

        /**
         * Card expiry.
         * @member {string} expiry
         * @memberof request.Card
         * @instance
         */
        Card.prototype.expiry = "";

        /**
         * Card notes.
         * @member {string} notes
         * @memberof request.Card
         * @instance
         */
        Card.prototype.notes = "";

        /**
         * Creates a new Card instance using the specified properties.
         * @function create
         * @memberof request.Card
         * @static
         * @param {request.ICard=} [properties] Properties to set
         * @returns {request.Card} Card instance
         */
        Card.create = function create(properties) {
            return new Card(properties);
        };

        /**
         * Encodes the specified Card message. Does not implicitly {@link request.Card.verify|verify} messages.
         * @function encode
         * @memberof request.Card
         * @static
         * @param {request.ICard} message Card message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Card.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.number != null && Object.hasOwnProperty.call(message, "number"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.number);
            if (message.cvv != null && Object.hasOwnProperty.call(message, "cvv"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.cvv);
            if (message.expiry != null && Object.hasOwnProperty.call(message, "expiry"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.expiry);
            if (message.notes != null && Object.hasOwnProperty.call(message, "notes"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.notes);
            return writer;
        };

        /**
         * Encodes the specified Card message, length delimited. Does not implicitly {@link request.Card.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.Card
         * @static
         * @param {request.ICard} message Card message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Card.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Card message from the specified reader or buffer.
         * @function decode
         * @memberof request.Card
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.Card} Card
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Card.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.Card();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 2: {
                        message.number = reader.string();
                        break;
                    }
                case 3: {
                        message.cvv = reader.string();
                        break;
                    }
                case 4: {
                        message.expiry = reader.string();
                        break;
                    }
                case 5: {
                        message.notes = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Card message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.Card
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.Card} Card
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Card.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Card message.
         * @function verify
         * @memberof request.Card
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Card.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.number != null && message.hasOwnProperty("number"))
                if (!$util.isString(message.number))
                    return "number: string expected";
            if (message.cvv != null && message.hasOwnProperty("cvv"))
                if (!$util.isString(message.cvv))
                    return "cvv: string expected";
            if (message.expiry != null && message.hasOwnProperty("expiry"))
                if (!$util.isString(message.expiry))
                    return "expiry: string expected";
            if (message.notes != null && message.hasOwnProperty("notes"))
                if (!$util.isString(message.notes))
                    return "notes: string expected";
            return null;
        };

        /**
         * Creates a Card message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.Card
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.Card} Card
         */
        Card.fromObject = function fromObject(object) {
            if (object instanceof $root.request.Card)
                return object;
            let message = new $root.request.Card();
            if (object.number != null)
                message.number = String(object.number);
            if (object.cvv != null)
                message.cvv = String(object.cvv);
            if (object.expiry != null)
                message.expiry = String(object.expiry);
            if (object.notes != null)
                message.notes = String(object.notes);
            return message;
        };

        /**
         * Creates a plain object from a Card message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.Card
         * @static
         * @param {request.Card} message Card
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Card.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.number = "";
                object.cvv = "";
                object.expiry = "";
                object.notes = "";
            }
            if (message.number != null && message.hasOwnProperty("number"))
                object.number = message.number;
            if (message.cvv != null && message.hasOwnProperty("cvv"))
                object.cvv = message.cvv;
            if (message.expiry != null && message.hasOwnProperty("expiry"))
                object.expiry = message.expiry;
            if (message.notes != null && message.hasOwnProperty("notes"))
                object.notes = message.notes;
            return object;
        };

        /**
         * Converts this Card to JSON.
         * @function toJSON
         * @memberof request.Card
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Card.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Card
         * @function getTypeUrl
         * @memberof request.Card
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Card.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.Card";
        };

        return Card;
    })();

    request.Note = (function() {

        /**
         * Properties of a Note.
         * @memberof request
         * @interface INote
         * @property {string|null} [content] Note content
         */

        /**
         * Constructs a new Note.
         * @memberof request
         * @classdesc Represents a Note.
         * @implements INote
         * @constructor
         * @param {request.INote=} [properties] Properties to set
         */
        function Note(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Note content.
         * @member {string} content
         * @memberof request.Note
         * @instance
         */
        Note.prototype.content = "";

        /**
         * Creates a new Note instance using the specified properties.
         * @function create
         * @memberof request.Note
         * @static
         * @param {request.INote=} [properties] Properties to set
         * @returns {request.Note} Note instance
         */
        Note.create = function create(properties) {
            return new Note(properties);
        };

        /**
         * Encodes the specified Note message. Does not implicitly {@link request.Note.verify|verify} messages.
         * @function encode
         * @memberof request.Note
         * @static
         * @param {request.INote} message Note message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Note.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.content != null && Object.hasOwnProperty.call(message, "content"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.content);
            return writer;
        };

        /**
         * Encodes the specified Note message, length delimited. Does not implicitly {@link request.Note.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.Note
         * @static
         * @param {request.INote} message Note message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Note.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Note message from the specified reader or buffer.
         * @function decode
         * @memberof request.Note
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.Note} Note
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Note.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.Note();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 2: {
                        message.content = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Note message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.Note
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.Note} Note
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Note.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Note message.
         * @function verify
         * @memberof request.Note
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Note.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.content != null && message.hasOwnProperty("content"))
                if (!$util.isString(message.content))
                    return "content: string expected";
            return null;
        };

        /**
         * Creates a Note message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.Note
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.Note} Note
         */
        Note.fromObject = function fromObject(object) {
            if (object instanceof $root.request.Note)
                return object;
            let message = new $root.request.Note();
            if (object.content != null)
                message.content = String(object.content);
            return message;
        };

        /**
         * Creates a plain object from a Note message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.Note
         * @static
         * @param {request.Note} message Note
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Note.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.content = "";
            if (message.content != null && message.hasOwnProperty("content"))
                object.content = message.content;
            return object;
        };

        /**
         * Converts this Note to JSON.
         * @function toJSON
         * @memberof request.Note
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Note.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Note
         * @function getTypeUrl
         * @memberof request.Note
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Note.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.Note";
        };

        return Note;
    })();

    request.Identity = (function() {

        /**
         * Properties of an Identity.
         * @memberof request
         * @interface IIdentity
         * @property {string|null} [number] Identity number
         * @property {string|null} [notes] Identity notes
         */

        /**
         * Constructs a new Identity.
         * @memberof request
         * @classdesc Represents an Identity.
         * @implements IIdentity
         * @constructor
         * @param {request.IIdentity=} [properties] Properties to set
         */
        function Identity(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Identity number.
         * @member {string} number
         * @memberof request.Identity
         * @instance
         */
        Identity.prototype.number = "";

        /**
         * Identity notes.
         * @member {string} notes
         * @memberof request.Identity
         * @instance
         */
        Identity.prototype.notes = "";

        /**
         * Creates a new Identity instance using the specified properties.
         * @function create
         * @memberof request.Identity
         * @static
         * @param {request.IIdentity=} [properties] Properties to set
         * @returns {request.Identity} Identity instance
         */
        Identity.create = function create(properties) {
            return new Identity(properties);
        };

        /**
         * Encodes the specified Identity message. Does not implicitly {@link request.Identity.verify|verify} messages.
         * @function encode
         * @memberof request.Identity
         * @static
         * @param {request.IIdentity} message Identity message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Identity.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.number != null && Object.hasOwnProperty.call(message, "number"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.number);
            if (message.notes != null && Object.hasOwnProperty.call(message, "notes"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.notes);
            return writer;
        };

        /**
         * Encodes the specified Identity message, length delimited. Does not implicitly {@link request.Identity.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.Identity
         * @static
         * @param {request.IIdentity} message Identity message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Identity.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an Identity message from the specified reader or buffer.
         * @function decode
         * @memberof request.Identity
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.Identity} Identity
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Identity.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.Identity();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 2: {
                        message.number = reader.string();
                        break;
                    }
                case 5: {
                        message.notes = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an Identity message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.Identity
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.Identity} Identity
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Identity.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an Identity message.
         * @function verify
         * @memberof request.Identity
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Identity.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.number != null && message.hasOwnProperty("number"))
                if (!$util.isString(message.number))
                    return "number: string expected";
            if (message.notes != null && message.hasOwnProperty("notes"))
                if (!$util.isString(message.notes))
                    return "notes: string expected";
            return null;
        };

        /**
         * Creates an Identity message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.Identity
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.Identity} Identity
         */
        Identity.fromObject = function fromObject(object) {
            if (object instanceof $root.request.Identity)
                return object;
            let message = new $root.request.Identity();
            if (object.number != null)
                message.number = String(object.number);
            if (object.notes != null)
                message.notes = String(object.notes);
            return message;
        };

        /**
         * Creates a plain object from an Identity message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.Identity
         * @static
         * @param {request.Identity} message Identity
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Identity.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.number = "";
                object.notes = "";
            }
            if (message.number != null && message.hasOwnProperty("number"))
                object.number = message.number;
            if (message.notes != null && message.hasOwnProperty("notes"))
                object.notes = message.notes;
            return object;
        };

        /**
         * Converts this Identity to JSON.
         * @function toJSON
         * @memberof request.Identity
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Identity.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Identity
         * @function getTypeUrl
         * @memberof request.Identity
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Identity.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.Identity";
        };

        return Identity;
    })();

    request.KeyValue = (function() {

        /**
         * Properties of a KeyValue.
         * @memberof request
         * @interface IKeyValue
         * @property {Array.<string>|null} [key] KeyValue key
         * @property {Array.<string>|null} [value] KeyValue value
         */

        /**
         * Constructs a new KeyValue.
         * @memberof request
         * @classdesc Represents a KeyValue.
         * @implements IKeyValue
         * @constructor
         * @param {request.IKeyValue=} [properties] Properties to set
         */
        function KeyValue(properties) {
            this.key = [];
            this.value = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * KeyValue key.
         * @member {Array.<string>} key
         * @memberof request.KeyValue
         * @instance
         */
        KeyValue.prototype.key = $util.emptyArray;

        /**
         * KeyValue value.
         * @member {Array.<string>} value
         * @memberof request.KeyValue
         * @instance
         */
        KeyValue.prototype.value = $util.emptyArray;

        /**
         * Creates a new KeyValue instance using the specified properties.
         * @function create
         * @memberof request.KeyValue
         * @static
         * @param {request.IKeyValue=} [properties] Properties to set
         * @returns {request.KeyValue} KeyValue instance
         */
        KeyValue.create = function create(properties) {
            return new KeyValue(properties);
        };

        /**
         * Encodes the specified KeyValue message. Does not implicitly {@link request.KeyValue.verify|verify} messages.
         * @function encode
         * @memberof request.KeyValue
         * @static
         * @param {request.IKeyValue} message KeyValue message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        KeyValue.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.key != null && message.key.length)
                for (let i = 0; i < message.key.length; ++i)
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.key[i]);
            if (message.value != null && message.value.length)
                for (let i = 0; i < message.value.length; ++i)
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.value[i]);
            return writer;
        };

        /**
         * Encodes the specified KeyValue message, length delimited. Does not implicitly {@link request.KeyValue.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.KeyValue
         * @static
         * @param {request.IKeyValue} message KeyValue message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        KeyValue.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a KeyValue message from the specified reader or buffer.
         * @function decode
         * @memberof request.KeyValue
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.KeyValue} KeyValue
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        KeyValue.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.KeyValue();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        if (!(message.key && message.key.length))
                            message.key = [];
                        message.key.push(reader.string());
                        break;
                    }
                case 2: {
                        if (!(message.value && message.value.length))
                            message.value = [];
                        message.value.push(reader.string());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a KeyValue message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.KeyValue
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.KeyValue} KeyValue
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        KeyValue.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a KeyValue message.
         * @function verify
         * @memberof request.KeyValue
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        KeyValue.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.key != null && message.hasOwnProperty("key")) {
                if (!Array.isArray(message.key))
                    return "key: array expected";
                for (let i = 0; i < message.key.length; ++i)
                    if (!$util.isString(message.key[i]))
                        return "key: string[] expected";
            }
            if (message.value != null && message.hasOwnProperty("value")) {
                if (!Array.isArray(message.value))
                    return "value: array expected";
                for (let i = 0; i < message.value.length; ++i)
                    if (!$util.isString(message.value[i]))
                        return "value: string[] expected";
            }
            return null;
        };

        /**
         * Creates a KeyValue message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.KeyValue
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.KeyValue} KeyValue
         */
        KeyValue.fromObject = function fromObject(object) {
            if (object instanceof $root.request.KeyValue)
                return object;
            let message = new $root.request.KeyValue();
            if (object.key) {
                if (!Array.isArray(object.key))
                    throw TypeError(".request.KeyValue.key: array expected");
                message.key = [];
                for (let i = 0; i < object.key.length; ++i)
                    message.key[i] = String(object.key[i]);
            }
            if (object.value) {
                if (!Array.isArray(object.value))
                    throw TypeError(".request.KeyValue.value: array expected");
                message.value = [];
                for (let i = 0; i < object.value.length; ++i)
                    message.value[i] = String(object.value[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a KeyValue message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.KeyValue
         * @static
         * @param {request.KeyValue} message KeyValue
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        KeyValue.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.key = [];
                object.value = [];
            }
            if (message.key && message.key.length) {
                object.key = [];
                for (let j = 0; j < message.key.length; ++j)
                    object.key[j] = message.key[j];
            }
            if (message.value && message.value.length) {
                object.value = [];
                for (let j = 0; j < message.value.length; ++j)
                    object.value[j] = message.value[j];
            }
            return object;
        };

        /**
         * Converts this KeyValue to JSON.
         * @function toJSON
         * @memberof request.KeyValue
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        KeyValue.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for KeyValue
         * @function getTypeUrl
         * @memberof request.KeyValue
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        KeyValue.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.KeyValue";
        };

        return KeyValue;
    })();

    request.Key = (function() {

        /**
         * Properties of a Key.
         * @memberof request
         * @interface IKey
         * @property {Uint8Array|null} [random] Key random
         * @property {Uint8Array|null} [alphanumeric] Key alphanumeric
         * @property {number|null} [minSize] Key minSize
         * @property {number|null} [maxSize] Key maxSize
         */

        /**
         * Constructs a new Key.
         * @memberof request
         * @classdesc Represents a Key.
         * @implements IKey
         * @constructor
         * @param {request.IKey=} [properties] Properties to set
         */
        function Key(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Key random.
         * @member {Uint8Array|null|undefined} random
         * @memberof request.Key
         * @instance
         */
        Key.prototype.random = null;

        /**
         * Key alphanumeric.
         * @member {Uint8Array|null|undefined} alphanumeric
         * @memberof request.Key
         * @instance
         */
        Key.prototype.alphanumeric = null;

        /**
         * Key minSize.
         * @member {number|null|undefined} minSize
         * @memberof request.Key
         * @instance
         */
        Key.prototype.minSize = null;

        /**
         * Key maxSize.
         * @member {number|null|undefined} maxSize
         * @memberof request.Key
         * @instance
         */
        Key.prototype.maxSize = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * Key Format.
         * @member {"random"|"alphanumeric"|undefined} Format
         * @memberof request.Key
         * @instance
         */
        Object.defineProperty(Key.prototype, "Format", {
            get: $util.oneOfGetter($oneOfFields = ["random", "alphanumeric"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(Key.prototype, "_minSize", {
            get: $util.oneOfGetter($oneOfFields = ["minSize"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(Key.prototype, "_maxSize", {
            get: $util.oneOfGetter($oneOfFields = ["maxSize"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new Key instance using the specified properties.
         * @function create
         * @memberof request.Key
         * @static
         * @param {request.IKey=} [properties] Properties to set
         * @returns {request.Key} Key instance
         */
        Key.create = function create(properties) {
            return new Key(properties);
        };

        /**
         * Encodes the specified Key message. Does not implicitly {@link request.Key.verify|verify} messages.
         * @function encode
         * @memberof request.Key
         * @static
         * @param {request.IKey} message Key message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Key.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.random != null && Object.hasOwnProperty.call(message, "random"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.random);
            if (message.alphanumeric != null && Object.hasOwnProperty.call(message, "alphanumeric"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.alphanumeric);
            if (message.minSize != null && Object.hasOwnProperty.call(message, "minSize"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.minSize);
            if (message.maxSize != null && Object.hasOwnProperty.call(message, "maxSize"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.maxSize);
            return writer;
        };

        /**
         * Encodes the specified Key message, length delimited. Does not implicitly {@link request.Key.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.Key
         * @static
         * @param {request.IKey} message Key message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Key.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Key message from the specified reader or buffer.
         * @function decode
         * @memberof request.Key
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.Key} Key
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Key.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.Key();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 2: {
                        message.random = reader.bytes();
                        break;
                    }
                case 3: {
                        message.alphanumeric = reader.bytes();
                        break;
                    }
                case 4: {
                        message.minSize = reader.int32();
                        break;
                    }
                case 5: {
                        message.maxSize = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Key message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.Key
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.Key} Key
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Key.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Key message.
         * @function verify
         * @memberof request.Key
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Key.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.random != null && message.hasOwnProperty("random")) {
                properties.Format = 1;
                if (!(message.random && typeof message.random.length === "number" || $util.isString(message.random)))
                    return "random: buffer expected";
            }
            if (message.alphanumeric != null && message.hasOwnProperty("alphanumeric")) {
                if (properties.Format === 1)
                    return "Format: multiple values";
                properties.Format = 1;
                if (!(message.alphanumeric && typeof message.alphanumeric.length === "number" || $util.isString(message.alphanumeric)))
                    return "alphanumeric: buffer expected";
            }
            if (message.minSize != null && message.hasOwnProperty("minSize")) {
                properties._minSize = 1;
                if (!$util.isInteger(message.minSize))
                    return "minSize: integer expected";
            }
            if (message.maxSize != null && message.hasOwnProperty("maxSize")) {
                properties._maxSize = 1;
                if (!$util.isInteger(message.maxSize))
                    return "maxSize: integer expected";
            }
            return null;
        };

        /**
         * Creates a Key message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.Key
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.Key} Key
         */
        Key.fromObject = function fromObject(object) {
            if (object instanceof $root.request.Key)
                return object;
            let message = new $root.request.Key();
            if (object.random != null)
                if (typeof object.random === "string")
                    $util.base64.decode(object.random, message.random = $util.newBuffer($util.base64.length(object.random)), 0);
                else if (object.random.length >= 0)
                    message.random = object.random;
            if (object.alphanumeric != null)
                if (typeof object.alphanumeric === "string")
                    $util.base64.decode(object.alphanumeric, message.alphanumeric = $util.newBuffer($util.base64.length(object.alphanumeric)), 0);
                else if (object.alphanumeric.length >= 0)
                    message.alphanumeric = object.alphanumeric;
            if (object.minSize != null)
                message.minSize = object.minSize | 0;
            if (object.maxSize != null)
                message.maxSize = object.maxSize | 0;
            return message;
        };

        /**
         * Creates a plain object from a Key message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.Key
         * @static
         * @param {request.Key} message Key
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Key.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (message.random != null && message.hasOwnProperty("random")) {
                object.random = options.bytes === String ? $util.base64.encode(message.random, 0, message.random.length) : options.bytes === Array ? Array.prototype.slice.call(message.random) : message.random;
                if (options.oneofs)
                    object.Format = "random";
            }
            if (message.alphanumeric != null && message.hasOwnProperty("alphanumeric")) {
                object.alphanumeric = options.bytes === String ? $util.base64.encode(message.alphanumeric, 0, message.alphanumeric.length) : options.bytes === Array ? Array.prototype.slice.call(message.alphanumeric) : message.alphanumeric;
                if (options.oneofs)
                    object.Format = "alphanumeric";
            }
            if (message.minSize != null && message.hasOwnProperty("minSize")) {
                object.minSize = message.minSize;
                if (options.oneofs)
                    object._minSize = "minSize";
            }
            if (message.maxSize != null && message.hasOwnProperty("maxSize")) {
                object.maxSize = message.maxSize;
                if (options.oneofs)
                    object._maxSize = "maxSize";
            }
            return object;
        };

        /**
         * Converts this Key to JSON.
         * @function toJSON
         * @memberof request.Key
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Key.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Key
         * @function getTypeUrl
         * @memberof request.Key
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Key.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.Key";
        };

        return Key;
    })();

    request.Certificate = (function() {

        /**
         * Properties of a Certificate.
         * @memberof request
         * @interface ICertificate
         * @property {Uint8Array|null} [value] Certificate value
         */

        /**
         * Constructs a new Certificate.
         * @memberof request
         * @classdesc Represents a Certificate.
         * @implements ICertificate
         * @constructor
         * @param {request.ICertificate=} [properties] Properties to set
         */
        function Certificate(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Certificate value.
         * @member {Uint8Array} value
         * @memberof request.Certificate
         * @instance
         */
        Certificate.prototype.value = $util.newBuffer([]);

        /**
         * Creates a new Certificate instance using the specified properties.
         * @function create
         * @memberof request.Certificate
         * @static
         * @param {request.ICertificate=} [properties] Properties to set
         * @returns {request.Certificate} Certificate instance
         */
        Certificate.create = function create(properties) {
            return new Certificate(properties);
        };

        /**
         * Encodes the specified Certificate message. Does not implicitly {@link request.Certificate.verify|verify} messages.
         * @function encode
         * @memberof request.Certificate
         * @static
         * @param {request.ICertificate} message Certificate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Certificate.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.value);
            return writer;
        };

        /**
         * Encodes the specified Certificate message, length delimited. Does not implicitly {@link request.Certificate.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.Certificate
         * @static
         * @param {request.ICertificate} message Certificate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Certificate.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Certificate message from the specified reader or buffer.
         * @function decode
         * @memberof request.Certificate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.Certificate} Certificate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Certificate.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.Certificate();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.value = reader.bytes();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Certificate message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.Certificate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.Certificate} Certificate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Certificate.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Certificate message.
         * @function verify
         * @memberof request.Certificate
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Certificate.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.value != null && message.hasOwnProperty("value"))
                if (!(message.value && typeof message.value.length === "number" || $util.isString(message.value)))
                    return "value: buffer expected";
            return null;
        };

        /**
         * Creates a Certificate message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.Certificate
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.Certificate} Certificate
         */
        Certificate.fromObject = function fromObject(object) {
            if (object instanceof $root.request.Certificate)
                return object;
            let message = new $root.request.Certificate();
            if (object.value != null)
                if (typeof object.value === "string")
                    $util.base64.decode(object.value, message.value = $util.newBuffer($util.base64.length(object.value)), 0);
                else if (object.value.length >= 0)
                    message.value = object.value;
            return message;
        };

        /**
         * Creates a plain object from a Certificate message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.Certificate
         * @static
         * @param {request.Certificate} message Certificate
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Certificate.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                if (options.bytes === String)
                    object.value = "";
                else {
                    object.value = [];
                    if (options.bytes !== Array)
                        object.value = $util.newBuffer(object.value);
                }
            if (message.value != null && message.hasOwnProperty("value"))
                object.value = options.bytes === String ? $util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
            return object;
        };

        /**
         * Converts this Certificate to JSON.
         * @function toJSON
         * @memberof request.Certificate
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Certificate.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Certificate
         * @function getTypeUrl
         * @memberof request.Certificate
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Certificate.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.Certificate";
        };

        return Certificate;
    })();

    request.PrivateKey = (function() {

        /**
         * Properties of a PrivateKey.
         * @memberof request
         * @interface IPrivateKey
         * @property {Uint8Array|null} [value] PrivateKey value
         */

        /**
         * Constructs a new PrivateKey.
         * @memberof request
         * @classdesc Represents a PrivateKey.
         * @implements IPrivateKey
         * @constructor
         * @param {request.IPrivateKey=} [properties] Properties to set
         */
        function PrivateKey(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PrivateKey value.
         * @member {Uint8Array} value
         * @memberof request.PrivateKey
         * @instance
         */
        PrivateKey.prototype.value = $util.newBuffer([]);

        /**
         * Creates a new PrivateKey instance using the specified properties.
         * @function create
         * @memberof request.PrivateKey
         * @static
         * @param {request.IPrivateKey=} [properties] Properties to set
         * @returns {request.PrivateKey} PrivateKey instance
         */
        PrivateKey.create = function create(properties) {
            return new PrivateKey(properties);
        };

        /**
         * Encodes the specified PrivateKey message. Does not implicitly {@link request.PrivateKey.verify|verify} messages.
         * @function encode
         * @memberof request.PrivateKey
         * @static
         * @param {request.IPrivateKey} message PrivateKey message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PrivateKey.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.value);
            return writer;
        };

        /**
         * Encodes the specified PrivateKey message, length delimited. Does not implicitly {@link request.PrivateKey.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.PrivateKey
         * @static
         * @param {request.IPrivateKey} message PrivateKey message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PrivateKey.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PrivateKey message from the specified reader or buffer.
         * @function decode
         * @memberof request.PrivateKey
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.PrivateKey} PrivateKey
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PrivateKey.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.PrivateKey();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.value = reader.bytes();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PrivateKey message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.PrivateKey
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.PrivateKey} PrivateKey
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PrivateKey.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PrivateKey message.
         * @function verify
         * @memberof request.PrivateKey
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PrivateKey.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.value != null && message.hasOwnProperty("value"))
                if (!(message.value && typeof message.value.length === "number" || $util.isString(message.value)))
                    return "value: buffer expected";
            return null;
        };

        /**
         * Creates a PrivateKey message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.PrivateKey
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.PrivateKey} PrivateKey
         */
        PrivateKey.fromObject = function fromObject(object) {
            if (object instanceof $root.request.PrivateKey)
                return object;
            let message = new $root.request.PrivateKey();
            if (object.value != null)
                if (typeof object.value === "string")
                    $util.base64.decode(object.value, message.value = $util.newBuffer($util.base64.length(object.value)), 0);
                else if (object.value.length >= 0)
                    message.value = object.value;
            return message;
        };

        /**
         * Creates a plain object from a PrivateKey message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.PrivateKey
         * @static
         * @param {request.PrivateKey} message PrivateKey
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PrivateKey.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                if (options.bytes === String)
                    object.value = "";
                else {
                    object.value = [];
                    if (options.bytes !== Array)
                        object.value = $util.newBuffer(object.value);
                }
            if (message.value != null && message.hasOwnProperty("value"))
                object.value = options.bytes === String ? $util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
            return object;
        };

        /**
         * Converts this PrivateKey to JSON.
         * @function toJSON
         * @memberof request.PrivateKey
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PrivateKey.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for PrivateKey
         * @function getTypeUrl
         * @memberof request.PrivateKey
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        PrivateKey.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.PrivateKey";
        };

        return PrivateKey;
    })();

    request.SecretData = (function() {

        /**
         * Properties of a SecretData.
         * @memberof request
         * @interface ISecretData
         * @property {request.SecretType|null} [type] SecretData type
         * @property {request.IPassword|null} [password] SecretData password
         * @property {request.ICard|null} [card] SecretData card
         * @property {request.INote|null} [note] SecretData note
         * @property {request.IIdentity|null} [identity] SecretData identity
         * @property {request.IKeyValue|null} [keyValue] SecretData keyValue
         * @property {request.IKey|null} [key] SecretData key
         * @property {request.ICertificate|null} [certificate] SecretData certificate
         * @property {request.IPrivateKey|null} [privatekey] SecretData privatekey
         */

        /**
         * Constructs a new SecretData.
         * @memberof request
         * @classdesc Represents a SecretData.
         * @implements ISecretData
         * @constructor
         * @param {request.ISecretData=} [properties] Properties to set
         */
        function SecretData(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SecretData type.
         * @member {request.SecretType} type
         * @memberof request.SecretData
         * @instance
         */
        SecretData.prototype.type = 0;

        /**
         * SecretData password.
         * @member {request.IPassword|null|undefined} password
         * @memberof request.SecretData
         * @instance
         */
        SecretData.prototype.password = null;

        /**
         * SecretData card.
         * @member {request.ICard|null|undefined} card
         * @memberof request.SecretData
         * @instance
         */
        SecretData.prototype.card = null;

        /**
         * SecretData note.
         * @member {request.INote|null|undefined} note
         * @memberof request.SecretData
         * @instance
         */
        SecretData.prototype.note = null;

        /**
         * SecretData identity.
         * @member {request.IIdentity|null|undefined} identity
         * @memberof request.SecretData
         * @instance
         */
        SecretData.prototype.identity = null;

        /**
         * SecretData keyValue.
         * @member {request.IKeyValue|null|undefined} keyValue
         * @memberof request.SecretData
         * @instance
         */
        SecretData.prototype.keyValue = null;

        /**
         * SecretData key.
         * @member {request.IKey|null|undefined} key
         * @memberof request.SecretData
         * @instance
         */
        SecretData.prototype.key = null;

        /**
         * SecretData certificate.
         * @member {request.ICertificate|null|undefined} certificate
         * @memberof request.SecretData
         * @instance
         */
        SecretData.prototype.certificate = null;

        /**
         * SecretData privatekey.
         * @member {request.IPrivateKey|null|undefined} privatekey
         * @memberof request.SecretData
         * @instance
         */
        SecretData.prototype.privatekey = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * SecretData Data.
         * @member {"password"|"card"|"note"|"identity"|"keyValue"|"key"|"certificate"|"privatekey"|undefined} Data
         * @memberof request.SecretData
         * @instance
         */
        Object.defineProperty(SecretData.prototype, "Data", {
            get: $util.oneOfGetter($oneOfFields = ["password", "card", "note", "identity", "keyValue", "key", "certificate", "privatekey"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new SecretData instance using the specified properties.
         * @function create
         * @memberof request.SecretData
         * @static
         * @param {request.ISecretData=} [properties] Properties to set
         * @returns {request.SecretData} SecretData instance
         */
        SecretData.create = function create(properties) {
            return new SecretData(properties);
        };

        /**
         * Encodes the specified SecretData message. Does not implicitly {@link request.SecretData.verify|verify} messages.
         * @function encode
         * @memberof request.SecretData
         * @static
         * @param {request.ISecretData} message SecretData message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SecretData.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.type);
            if (message.password != null && Object.hasOwnProperty.call(message, "password"))
                $root.request.Password.encode(message.password, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
            if (message.card != null && Object.hasOwnProperty.call(message, "card"))
                $root.request.Card.encode(message.card, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
            if (message.note != null && Object.hasOwnProperty.call(message, "note"))
                $root.request.Note.encode(message.note, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
            if (message.identity != null && Object.hasOwnProperty.call(message, "identity"))
                $root.request.Identity.encode(message.identity, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
            if (message.keyValue != null && Object.hasOwnProperty.call(message, "keyValue"))
                $root.request.KeyValue.encode(message.keyValue, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
            if (message.key != null && Object.hasOwnProperty.call(message, "key"))
                $root.request.Key.encode(message.key, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
            if (message.certificate != null && Object.hasOwnProperty.call(message, "certificate"))
                $root.request.Certificate.encode(message.certificate, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
            if (message.privatekey != null && Object.hasOwnProperty.call(message, "privatekey"))
                $root.request.PrivateKey.encode(message.privatekey, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified SecretData message, length delimited. Does not implicitly {@link request.SecretData.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.SecretData
         * @static
         * @param {request.ISecretData} message SecretData message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SecretData.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SecretData message from the specified reader or buffer.
         * @function decode
         * @memberof request.SecretData
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.SecretData} SecretData
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SecretData.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.SecretData();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.type = reader.int32();
                        break;
                    }
                case 5: {
                        message.password = $root.request.Password.decode(reader, reader.uint32());
                        break;
                    }
                case 6: {
                        message.card = $root.request.Card.decode(reader, reader.uint32());
                        break;
                    }
                case 7: {
                        message.note = $root.request.Note.decode(reader, reader.uint32());
                        break;
                    }
                case 8: {
                        message.identity = $root.request.Identity.decode(reader, reader.uint32());
                        break;
                    }
                case 9: {
                        message.keyValue = $root.request.KeyValue.decode(reader, reader.uint32());
                        break;
                    }
                case 10: {
                        message.key = $root.request.Key.decode(reader, reader.uint32());
                        break;
                    }
                case 11: {
                        message.certificate = $root.request.Certificate.decode(reader, reader.uint32());
                        break;
                    }
                case 12: {
                        message.privatekey = $root.request.PrivateKey.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SecretData message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.SecretData
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.SecretData} SecretData
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SecretData.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SecretData message.
         * @function verify
         * @memberof request.SecretData
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SecretData.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.type != null && message.hasOwnProperty("type"))
                switch (message.type) {
                default:
                    return "type: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                    break;
                }
            if (message.password != null && message.hasOwnProperty("password")) {
                properties.Data = 1;
                {
                    let error = $root.request.Password.verify(message.password);
                    if (error)
                        return "password." + error;
                }
            }
            if (message.card != null && message.hasOwnProperty("card")) {
                if (properties.Data === 1)
                    return "Data: multiple values";
                properties.Data = 1;
                {
                    let error = $root.request.Card.verify(message.card);
                    if (error)
                        return "card." + error;
                }
            }
            if (message.note != null && message.hasOwnProperty("note")) {
                if (properties.Data === 1)
                    return "Data: multiple values";
                properties.Data = 1;
                {
                    let error = $root.request.Note.verify(message.note);
                    if (error)
                        return "note." + error;
                }
            }
            if (message.identity != null && message.hasOwnProperty("identity")) {
                if (properties.Data === 1)
                    return "Data: multiple values";
                properties.Data = 1;
                {
                    let error = $root.request.Identity.verify(message.identity);
                    if (error)
                        return "identity." + error;
                }
            }
            if (message.keyValue != null && message.hasOwnProperty("keyValue")) {
                if (properties.Data === 1)
                    return "Data: multiple values";
                properties.Data = 1;
                {
                    let error = $root.request.KeyValue.verify(message.keyValue);
                    if (error)
                        return "keyValue." + error;
                }
            }
            if (message.key != null && message.hasOwnProperty("key")) {
                if (properties.Data === 1)
                    return "Data: multiple values";
                properties.Data = 1;
                {
                    let error = $root.request.Key.verify(message.key);
                    if (error)
                        return "key." + error;
                }
            }
            if (message.certificate != null && message.hasOwnProperty("certificate")) {
                if (properties.Data === 1)
                    return "Data: multiple values";
                properties.Data = 1;
                {
                    let error = $root.request.Certificate.verify(message.certificate);
                    if (error)
                        return "certificate." + error;
                }
            }
            if (message.privatekey != null && message.hasOwnProperty("privatekey")) {
                if (properties.Data === 1)
                    return "Data: multiple values";
                properties.Data = 1;
                {
                    let error = $root.request.PrivateKey.verify(message.privatekey);
                    if (error)
                        return "privatekey." + error;
                }
            }
            return null;
        };

        /**
         * Creates a SecretData message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.SecretData
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.SecretData} SecretData
         */
        SecretData.fromObject = function fromObject(object) {
            if (object instanceof $root.request.SecretData)
                return object;
            let message = new $root.request.SecretData();
            switch (object.type) {
            default:
                if (typeof object.type === "number") {
                    message.type = object.type;
                    break;
                }
                break;
            case "PASSWORD":
            case 0:
                message.type = 0;
                break;
            case "CARD":
            case 1:
                message.type = 1;
                break;
            case "NOTE":
            case 2:
                message.type = 2;
                break;
            case "IDENTITY":
            case 3:
                message.type = 3;
                break;
            case "KEYVALUES":
            case 4:
                message.type = 4;
                break;
            case "KEYS":
            case 5:
                message.type = 5;
                break;
            case "CERTIFICATE":
            case 6:
                message.type = 6;
                break;
            case "PRIVATEKEY":
            case 7:
                message.type = 7;
                break;
            }
            if (object.password != null) {
                if (typeof object.password !== "object")
                    throw TypeError(".request.SecretData.password: object expected");
                message.password = $root.request.Password.fromObject(object.password);
            }
            if (object.card != null) {
                if (typeof object.card !== "object")
                    throw TypeError(".request.SecretData.card: object expected");
                message.card = $root.request.Card.fromObject(object.card);
            }
            if (object.note != null) {
                if (typeof object.note !== "object")
                    throw TypeError(".request.SecretData.note: object expected");
                message.note = $root.request.Note.fromObject(object.note);
            }
            if (object.identity != null) {
                if (typeof object.identity !== "object")
                    throw TypeError(".request.SecretData.identity: object expected");
                message.identity = $root.request.Identity.fromObject(object.identity);
            }
            if (object.keyValue != null) {
                if (typeof object.keyValue !== "object")
                    throw TypeError(".request.SecretData.keyValue: object expected");
                message.keyValue = $root.request.KeyValue.fromObject(object.keyValue);
            }
            if (object.key != null) {
                if (typeof object.key !== "object")
                    throw TypeError(".request.SecretData.key: object expected");
                message.key = $root.request.Key.fromObject(object.key);
            }
            if (object.certificate != null) {
                if (typeof object.certificate !== "object")
                    throw TypeError(".request.SecretData.certificate: object expected");
                message.certificate = $root.request.Certificate.fromObject(object.certificate);
            }
            if (object.privatekey != null) {
                if (typeof object.privatekey !== "object")
                    throw TypeError(".request.SecretData.privatekey: object expected");
                message.privatekey = $root.request.PrivateKey.fromObject(object.privatekey);
            }
            return message;
        };

        /**
         * Creates a plain object from a SecretData message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.SecretData
         * @static
         * @param {request.SecretData} message SecretData
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SecretData.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.type = options.enums === String ? "PASSWORD" : 0;
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = options.enums === String ? $root.request.SecretType[message.type] === undefined ? message.type : $root.request.SecretType[message.type] : message.type;
            if (message.password != null && message.hasOwnProperty("password")) {
                object.password = $root.request.Password.toObject(message.password, options);
                if (options.oneofs)
                    object.Data = "password";
            }
            if (message.card != null && message.hasOwnProperty("card")) {
                object.card = $root.request.Card.toObject(message.card, options);
                if (options.oneofs)
                    object.Data = "card";
            }
            if (message.note != null && message.hasOwnProperty("note")) {
                object.note = $root.request.Note.toObject(message.note, options);
                if (options.oneofs)
                    object.Data = "note";
            }
            if (message.identity != null && message.hasOwnProperty("identity")) {
                object.identity = $root.request.Identity.toObject(message.identity, options);
                if (options.oneofs)
                    object.Data = "identity";
            }
            if (message.keyValue != null && message.hasOwnProperty("keyValue")) {
                object.keyValue = $root.request.KeyValue.toObject(message.keyValue, options);
                if (options.oneofs)
                    object.Data = "keyValue";
            }
            if (message.key != null && message.hasOwnProperty("key")) {
                object.key = $root.request.Key.toObject(message.key, options);
                if (options.oneofs)
                    object.Data = "key";
            }
            if (message.certificate != null && message.hasOwnProperty("certificate")) {
                object.certificate = $root.request.Certificate.toObject(message.certificate, options);
                if (options.oneofs)
                    object.Data = "certificate";
            }
            if (message.privatekey != null && message.hasOwnProperty("privatekey")) {
                object.privatekey = $root.request.PrivateKey.toObject(message.privatekey, options);
                if (options.oneofs)
                    object.Data = "privatekey";
            }
            return object;
        };

        /**
         * Converts this SecretData to JSON.
         * @function toJSON
         * @memberof request.SecretData
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SecretData.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for SecretData
         * @function getTypeUrl
         * @memberof request.SecretData
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        SecretData.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.SecretData";
        };

        return SecretData;
    })();

    request.SecretVersion = (function() {

        /**
         * Properties of a SecretVersion.
         * @memberof request
         * @interface ISecretVersion
         * @property {number|Long|null} [id] SecretVersion id
         * @property {number|Long|null} [creationTime] SecretVersion creationTime
         * @property {request.ISecretData|null} [secretData] SecretVersion secretData
         */

        /**
         * Constructs a new SecretVersion.
         * @memberof request
         * @classdesc Represents a SecretVersion.
         * @implements ISecretVersion
         * @constructor
         * @param {request.ISecretVersion=} [properties] Properties to set
         */
        function SecretVersion(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SecretVersion id.
         * @member {number|Long} id
         * @memberof request.SecretVersion
         * @instance
         */
        SecretVersion.prototype.id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * SecretVersion creationTime.
         * @member {number|Long} creationTime
         * @memberof request.SecretVersion
         * @instance
         */
        SecretVersion.prototype.creationTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * SecretVersion secretData.
         * @member {request.ISecretData|null|undefined} secretData
         * @memberof request.SecretVersion
         * @instance
         */
        SecretVersion.prototype.secretData = null;

        /**
         * Creates a new SecretVersion instance using the specified properties.
         * @function create
         * @memberof request.SecretVersion
         * @static
         * @param {request.ISecretVersion=} [properties] Properties to set
         * @returns {request.SecretVersion} SecretVersion instance
         */
        SecretVersion.create = function create(properties) {
            return new SecretVersion(properties);
        };

        /**
         * Encodes the specified SecretVersion message. Does not implicitly {@link request.SecretVersion.verify|verify} messages.
         * @function encode
         * @memberof request.SecretVersion
         * @static
         * @param {request.ISecretVersion} message SecretVersion message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SecretVersion.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.id);
            if (message.creationTime != null && Object.hasOwnProperty.call(message, "creationTime"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.creationTime);
            if (message.secretData != null && Object.hasOwnProperty.call(message, "secretData"))
                $root.request.SecretData.encode(message.secretData, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified SecretVersion message, length delimited. Does not implicitly {@link request.SecretVersion.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.SecretVersion
         * @static
         * @param {request.ISecretVersion} message SecretVersion message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SecretVersion.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SecretVersion message from the specified reader or buffer.
         * @function decode
         * @memberof request.SecretVersion
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.SecretVersion} SecretVersion
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SecretVersion.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.SecretVersion();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.id = reader.uint64();
                        break;
                    }
                case 2: {
                        message.creationTime = reader.uint64();
                        break;
                    }
                case 3: {
                        message.secretData = $root.request.SecretData.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SecretVersion message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.SecretVersion
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.SecretVersion} SecretVersion
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SecretVersion.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SecretVersion message.
         * @function verify
         * @memberof request.SecretVersion
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SecretVersion.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                    return "id: integer|Long expected";
            if (message.creationTime != null && message.hasOwnProperty("creationTime"))
                if (!$util.isInteger(message.creationTime) && !(message.creationTime && $util.isInteger(message.creationTime.low) && $util.isInteger(message.creationTime.high)))
                    return "creationTime: integer|Long expected";
            if (message.secretData != null && message.hasOwnProperty("secretData")) {
                let error = $root.request.SecretData.verify(message.secretData);
                if (error)
                    return "secretData." + error;
            }
            return null;
        };

        /**
         * Creates a SecretVersion message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.SecretVersion
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.SecretVersion} SecretVersion
         */
        SecretVersion.fromObject = function fromObject(object) {
            if (object instanceof $root.request.SecretVersion)
                return object;
            let message = new $root.request.SecretVersion();
            if (object.id != null)
                if ($util.Long)
                    (message.id = $util.Long.fromValue(object.id)).unsigned = true;
                else if (typeof object.id === "string")
                    message.id = parseInt(object.id, 10);
                else if (typeof object.id === "number")
                    message.id = object.id;
                else if (typeof object.id === "object")
                    message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber(true);
            if (object.creationTime != null)
                if ($util.Long)
                    (message.creationTime = $util.Long.fromValue(object.creationTime)).unsigned = true;
                else if (typeof object.creationTime === "string")
                    message.creationTime = parseInt(object.creationTime, 10);
                else if (typeof object.creationTime === "number")
                    message.creationTime = object.creationTime;
                else if (typeof object.creationTime === "object")
                    message.creationTime = new $util.LongBits(object.creationTime.low >>> 0, object.creationTime.high >>> 0).toNumber(true);
            if (object.secretData != null) {
                if (typeof object.secretData !== "object")
                    throw TypeError(".request.SecretVersion.secretData: object expected");
                message.secretData = $root.request.SecretData.fromObject(object.secretData);
            }
            return message;
        };

        /**
         * Creates a plain object from a SecretVersion message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.SecretVersion
         * @static
         * @param {request.SecretVersion} message SecretVersion
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SecretVersion.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.id = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.creationTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.creationTime = options.longs === String ? "0" : 0;
                object.secretData = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                if (typeof message.id === "number")
                    object.id = options.longs === String ? String(message.id) : message.id;
                else
                    object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber(true) : message.id;
            if (message.creationTime != null && message.hasOwnProperty("creationTime"))
                if (typeof message.creationTime === "number")
                    object.creationTime = options.longs === String ? String(message.creationTime) : message.creationTime;
                else
                    object.creationTime = options.longs === String ? $util.Long.prototype.toString.call(message.creationTime) : options.longs === Number ? new $util.LongBits(message.creationTime.low >>> 0, message.creationTime.high >>> 0).toNumber(true) : message.creationTime;
            if (message.secretData != null && message.hasOwnProperty("secretData"))
                object.secretData = $root.request.SecretData.toObject(message.secretData, options);
            return object;
        };

        /**
         * Converts this SecretVersion to JSON.
         * @function toJSON
         * @memberof request.SecretVersion
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SecretVersion.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for SecretVersion
         * @function getTypeUrl
         * @memberof request.SecretVersion
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        SecretVersion.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.SecretVersion";
        };

        return SecretVersion;
    })();

    request.Secret = (function() {

        /**
         * Properties of a Secret.
         * @memberof request
         * @interface ISecret
         * @property {string|null} [path] Secret path
         * @property {Uint8Array|null} [uuid] Secret uuid
         * @property {number|Long|null} [expiry] Secret expiry
         * @property {Array.<request.ISecretVersion>|null} [versions] Secret versions
         * @property {boolean|null} [isExpired] Secret isExpired
         * @property {number|Long|null} [rotateInterval] Secret rotateInterval
         * @property {number|Long|null} [lastRotatedTime] Secret lastRotatedTime
         */

        /**
         * Constructs a new Secret.
         * @memberof request
         * @classdesc Represents a Secret.
         * @implements ISecret
         * @constructor
         * @param {request.ISecret=} [properties] Properties to set
         */
        function Secret(properties) {
            this.versions = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Secret path.
         * @member {string} path
         * @memberof request.Secret
         * @instance
         */
        Secret.prototype.path = "";

        /**
         * Secret uuid.
         * @member {Uint8Array} uuid
         * @memberof request.Secret
         * @instance
         */
        Secret.prototype.uuid = $util.newBuffer([]);

        /**
         * Secret expiry.
         * @member {number|Long} expiry
         * @memberof request.Secret
         * @instance
         */
        Secret.prototype.expiry = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Secret versions.
         * @member {Array.<request.ISecretVersion>} versions
         * @memberof request.Secret
         * @instance
         */
        Secret.prototype.versions = $util.emptyArray;

        /**
         * Secret isExpired.
         * @member {boolean} isExpired
         * @memberof request.Secret
         * @instance
         */
        Secret.prototype.isExpired = false;

        /**
         * Secret rotateInterval.
         * @member {number|Long} rotateInterval
         * @memberof request.Secret
         * @instance
         */
        Secret.prototype.rotateInterval = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Secret lastRotatedTime.
         * @member {number|Long} lastRotatedTime
         * @memberof request.Secret
         * @instance
         */
        Secret.prototype.lastRotatedTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new Secret instance using the specified properties.
         * @function create
         * @memberof request.Secret
         * @static
         * @param {request.ISecret=} [properties] Properties to set
         * @returns {request.Secret} Secret instance
         */
        Secret.create = function create(properties) {
            return new Secret(properties);
        };

        /**
         * Encodes the specified Secret message. Does not implicitly {@link request.Secret.verify|verify} messages.
         * @function encode
         * @memberof request.Secret
         * @static
         * @param {request.ISecret} message Secret message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Secret.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.path != null && Object.hasOwnProperty.call(message, "path"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.path);
            if (message.uuid != null && Object.hasOwnProperty.call(message, "uuid"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.uuid);
            if (message.expiry != null && Object.hasOwnProperty.call(message, "expiry"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.expiry);
            if (message.versions != null && message.versions.length)
                for (let i = 0; i < message.versions.length; ++i)
                    $root.request.SecretVersion.encode(message.versions[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
            if (message.isExpired != null && Object.hasOwnProperty.call(message, "isExpired"))
                writer.uint32(/* id 6, wireType 0 =*/48).bool(message.isExpired);
            if (message.rotateInterval != null && Object.hasOwnProperty.call(message, "rotateInterval"))
                writer.uint32(/* id 8, wireType 0 =*/64).uint64(message.rotateInterval);
            if (message.lastRotatedTime != null && Object.hasOwnProperty.call(message, "lastRotatedTime"))
                writer.uint32(/* id 9, wireType 0 =*/72).uint64(message.lastRotatedTime);
            return writer;
        };

        /**
         * Encodes the specified Secret message, length delimited. Does not implicitly {@link request.Secret.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.Secret
         * @static
         * @param {request.ISecret} message Secret message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Secret.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Secret message from the specified reader or buffer.
         * @function decode
         * @memberof request.Secret
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.Secret} Secret
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Secret.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.Secret();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 2: {
                        message.path = reader.string();
                        break;
                    }
                case 3: {
                        message.uuid = reader.bytes();
                        break;
                    }
                case 4: {
                        message.expiry = reader.uint64();
                        break;
                    }
                case 5: {
                        if (!(message.versions && message.versions.length))
                            message.versions = [];
                        message.versions.push($root.request.SecretVersion.decode(reader, reader.uint32()));
                        break;
                    }
                case 6: {
                        message.isExpired = reader.bool();
                        break;
                    }
                case 8: {
                        message.rotateInterval = reader.uint64();
                        break;
                    }
                case 9: {
                        message.lastRotatedTime = reader.uint64();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Secret message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.Secret
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.Secret} Secret
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Secret.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Secret message.
         * @function verify
         * @memberof request.Secret
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Secret.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.path != null && message.hasOwnProperty("path"))
                if (!$util.isString(message.path))
                    return "path: string expected";
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                if (!(message.uuid && typeof message.uuid.length === "number" || $util.isString(message.uuid)))
                    return "uuid: buffer expected";
            if (message.expiry != null && message.hasOwnProperty("expiry"))
                if (!$util.isInteger(message.expiry) && !(message.expiry && $util.isInteger(message.expiry.low) && $util.isInteger(message.expiry.high)))
                    return "expiry: integer|Long expected";
            if (message.versions != null && message.hasOwnProperty("versions")) {
                if (!Array.isArray(message.versions))
                    return "versions: array expected";
                for (let i = 0; i < message.versions.length; ++i) {
                    let error = $root.request.SecretVersion.verify(message.versions[i]);
                    if (error)
                        return "versions." + error;
                }
            }
            if (message.isExpired != null && message.hasOwnProperty("isExpired"))
                if (typeof message.isExpired !== "boolean")
                    return "isExpired: boolean expected";
            if (message.rotateInterval != null && message.hasOwnProperty("rotateInterval"))
                if (!$util.isInteger(message.rotateInterval) && !(message.rotateInterval && $util.isInteger(message.rotateInterval.low) && $util.isInteger(message.rotateInterval.high)))
                    return "rotateInterval: integer|Long expected";
            if (message.lastRotatedTime != null && message.hasOwnProperty("lastRotatedTime"))
                if (!$util.isInteger(message.lastRotatedTime) && !(message.lastRotatedTime && $util.isInteger(message.lastRotatedTime.low) && $util.isInteger(message.lastRotatedTime.high)))
                    return "lastRotatedTime: integer|Long expected";
            return null;
        };

        /**
         * Creates a Secret message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.Secret
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.Secret} Secret
         */
        Secret.fromObject = function fromObject(object) {
            if (object instanceof $root.request.Secret)
                return object;
            let message = new $root.request.Secret();
            if (object.path != null)
                message.path = String(object.path);
            if (object.uuid != null)
                if (typeof object.uuid === "string")
                    $util.base64.decode(object.uuid, message.uuid = $util.newBuffer($util.base64.length(object.uuid)), 0);
                else if (object.uuid.length >= 0)
                    message.uuid = object.uuid;
            if (object.expiry != null)
                if ($util.Long)
                    (message.expiry = $util.Long.fromValue(object.expiry)).unsigned = true;
                else if (typeof object.expiry === "string")
                    message.expiry = parseInt(object.expiry, 10);
                else if (typeof object.expiry === "number")
                    message.expiry = object.expiry;
                else if (typeof object.expiry === "object")
                    message.expiry = new $util.LongBits(object.expiry.low >>> 0, object.expiry.high >>> 0).toNumber(true);
            if (object.versions) {
                if (!Array.isArray(object.versions))
                    throw TypeError(".request.Secret.versions: array expected");
                message.versions = [];
                for (let i = 0; i < object.versions.length; ++i) {
                    if (typeof object.versions[i] !== "object")
                        throw TypeError(".request.Secret.versions: object expected");
                    message.versions[i] = $root.request.SecretVersion.fromObject(object.versions[i]);
                }
            }
            if (object.isExpired != null)
                message.isExpired = Boolean(object.isExpired);
            if (object.rotateInterval != null)
                if ($util.Long)
                    (message.rotateInterval = $util.Long.fromValue(object.rotateInterval)).unsigned = true;
                else if (typeof object.rotateInterval === "string")
                    message.rotateInterval = parseInt(object.rotateInterval, 10);
                else if (typeof object.rotateInterval === "number")
                    message.rotateInterval = object.rotateInterval;
                else if (typeof object.rotateInterval === "object")
                    message.rotateInterval = new $util.LongBits(object.rotateInterval.low >>> 0, object.rotateInterval.high >>> 0).toNumber(true);
            if (object.lastRotatedTime != null)
                if ($util.Long)
                    (message.lastRotatedTime = $util.Long.fromValue(object.lastRotatedTime)).unsigned = true;
                else if (typeof object.lastRotatedTime === "string")
                    message.lastRotatedTime = parseInt(object.lastRotatedTime, 10);
                else if (typeof object.lastRotatedTime === "number")
                    message.lastRotatedTime = object.lastRotatedTime;
                else if (typeof object.lastRotatedTime === "object")
                    message.lastRotatedTime = new $util.LongBits(object.lastRotatedTime.low >>> 0, object.lastRotatedTime.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a Secret message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.Secret
         * @static
         * @param {request.Secret} message Secret
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Secret.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.versions = [];
            if (options.defaults) {
                object.path = "";
                if (options.bytes === String)
                    object.uuid = "";
                else {
                    object.uuid = [];
                    if (options.bytes !== Array)
                        object.uuid = $util.newBuffer(object.uuid);
                }
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.expiry = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.expiry = options.longs === String ? "0" : 0;
                object.isExpired = false;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.rotateInterval = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.rotateInterval = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.lastRotatedTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.lastRotatedTime = options.longs === String ? "0" : 0;
            }
            if (message.path != null && message.hasOwnProperty("path"))
                object.path = message.path;
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                object.uuid = options.bytes === String ? $util.base64.encode(message.uuid, 0, message.uuid.length) : options.bytes === Array ? Array.prototype.slice.call(message.uuid) : message.uuid;
            if (message.expiry != null && message.hasOwnProperty("expiry"))
                if (typeof message.expiry === "number")
                    object.expiry = options.longs === String ? String(message.expiry) : message.expiry;
                else
                    object.expiry = options.longs === String ? $util.Long.prototype.toString.call(message.expiry) : options.longs === Number ? new $util.LongBits(message.expiry.low >>> 0, message.expiry.high >>> 0).toNumber(true) : message.expiry;
            if (message.versions && message.versions.length) {
                object.versions = [];
                for (let j = 0; j < message.versions.length; ++j)
                    object.versions[j] = $root.request.SecretVersion.toObject(message.versions[j], options);
            }
            if (message.isExpired != null && message.hasOwnProperty("isExpired"))
                object.isExpired = message.isExpired;
            if (message.rotateInterval != null && message.hasOwnProperty("rotateInterval"))
                if (typeof message.rotateInterval === "number")
                    object.rotateInterval = options.longs === String ? String(message.rotateInterval) : message.rotateInterval;
                else
                    object.rotateInterval = options.longs === String ? $util.Long.prototype.toString.call(message.rotateInterval) : options.longs === Number ? new $util.LongBits(message.rotateInterval.low >>> 0, message.rotateInterval.high >>> 0).toNumber(true) : message.rotateInterval;
            if (message.lastRotatedTime != null && message.hasOwnProperty("lastRotatedTime"))
                if (typeof message.lastRotatedTime === "number")
                    object.lastRotatedTime = options.longs === String ? String(message.lastRotatedTime) : message.lastRotatedTime;
                else
                    object.lastRotatedTime = options.longs === String ? $util.Long.prototype.toString.call(message.lastRotatedTime) : options.longs === Number ? new $util.LongBits(message.lastRotatedTime.low >>> 0, message.lastRotatedTime.high >>> 0).toNumber(true) : message.lastRotatedTime;
            return object;
        };

        /**
         * Converts this Secret to JSON.
         * @function toJSON
         * @memberof request.Secret
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Secret.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Secret
         * @function getTypeUrl
         * @memberof request.Secret
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Secret.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.Secret";
        };

        return Secret;
    })();

    request.GetRandomBytes = (function() {

        /**
         * Properties of a GetRandomBytes.
         * @memberof request
         * @interface IGetRandomBytes
         * @property {boolean|null} [isAlphanumeric] GetRandomBytes isAlphanumeric
         * @property {number|null} [size] GetRandomBytes size
         */

        /**
         * Constructs a new GetRandomBytes.
         * @memberof request
         * @classdesc Represents a GetRandomBytes.
         * @implements IGetRandomBytes
         * @constructor
         * @param {request.IGetRandomBytes=} [properties] Properties to set
         */
        function GetRandomBytes(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetRandomBytes isAlphanumeric.
         * @member {boolean} isAlphanumeric
         * @memberof request.GetRandomBytes
         * @instance
         */
        GetRandomBytes.prototype.isAlphanumeric = false;

        /**
         * GetRandomBytes size.
         * @member {number} size
         * @memberof request.GetRandomBytes
         * @instance
         */
        GetRandomBytes.prototype.size = 0;

        /**
         * Creates a new GetRandomBytes instance using the specified properties.
         * @function create
         * @memberof request.GetRandomBytes
         * @static
         * @param {request.IGetRandomBytes=} [properties] Properties to set
         * @returns {request.GetRandomBytes} GetRandomBytes instance
         */
        GetRandomBytes.create = function create(properties) {
            return new GetRandomBytes(properties);
        };

        /**
         * Encodes the specified GetRandomBytes message. Does not implicitly {@link request.GetRandomBytes.verify|verify} messages.
         * @function encode
         * @memberof request.GetRandomBytes
         * @static
         * @param {request.IGetRandomBytes} message GetRandomBytes message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetRandomBytes.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.isAlphanumeric != null && Object.hasOwnProperty.call(message, "isAlphanumeric"))
                writer.uint32(/* id 1, wireType 0 =*/8).bool(message.isAlphanumeric);
            if (message.size != null && Object.hasOwnProperty.call(message, "size"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.size);
            return writer;
        };

        /**
         * Encodes the specified GetRandomBytes message, length delimited. Does not implicitly {@link request.GetRandomBytes.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.GetRandomBytes
         * @static
         * @param {request.IGetRandomBytes} message GetRandomBytes message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetRandomBytes.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetRandomBytes message from the specified reader or buffer.
         * @function decode
         * @memberof request.GetRandomBytes
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.GetRandomBytes} GetRandomBytes
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetRandomBytes.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.GetRandomBytes();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.isAlphanumeric = reader.bool();
                        break;
                    }
                case 2: {
                        message.size = reader.uint32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetRandomBytes message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.GetRandomBytes
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.GetRandomBytes} GetRandomBytes
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetRandomBytes.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetRandomBytes message.
         * @function verify
         * @memberof request.GetRandomBytes
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetRandomBytes.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.isAlphanumeric != null && message.hasOwnProperty("isAlphanumeric"))
                if (typeof message.isAlphanumeric !== "boolean")
                    return "isAlphanumeric: boolean expected";
            if (message.size != null && message.hasOwnProperty("size"))
                if (!$util.isInteger(message.size))
                    return "size: integer expected";
            return null;
        };

        /**
         * Creates a GetRandomBytes message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.GetRandomBytes
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.GetRandomBytes} GetRandomBytes
         */
        GetRandomBytes.fromObject = function fromObject(object) {
            if (object instanceof $root.request.GetRandomBytes)
                return object;
            let message = new $root.request.GetRandomBytes();
            if (object.isAlphanumeric != null)
                message.isAlphanumeric = Boolean(object.isAlphanumeric);
            if (object.size != null)
                message.size = object.size >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a GetRandomBytes message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.GetRandomBytes
         * @static
         * @param {request.GetRandomBytes} message GetRandomBytes
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetRandomBytes.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.isAlphanumeric = false;
                object.size = 0;
            }
            if (message.isAlphanumeric != null && message.hasOwnProperty("isAlphanumeric"))
                object.isAlphanumeric = message.isAlphanumeric;
            if (message.size != null && message.hasOwnProperty("size"))
                object.size = message.size;
            return object;
        };

        /**
         * Converts this GetRandomBytes to JSON.
         * @function toJSON
         * @memberof request.GetRandomBytes
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetRandomBytes.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetRandomBytes
         * @function getTypeUrl
         * @memberof request.GetRandomBytes
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetRandomBytes.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.GetRandomBytes";
        };

        return GetRandomBytes;
    })();

    request.SetRolesTeamsToUser = (function() {

        /**
         * Properties of a SetRolesTeamsToUser.
         * @memberof request
         * @interface ISetRolesTeamsToUser
         * @property {string|null} [emailOfUser] SetRolesTeamsToUser emailOfUser
         * @property {Array.<string>|null} [nameOfRoles] SetRolesTeamsToUser nameOfRoles
         * @property {Array.<string>|null} [nameOfTeams] SetRolesTeamsToUser nameOfTeams
         */

        /**
         * Constructs a new SetRolesTeamsToUser.
         * @memberof request
         * @classdesc Represents a SetRolesTeamsToUser.
         * @implements ISetRolesTeamsToUser
         * @constructor
         * @param {request.ISetRolesTeamsToUser=} [properties] Properties to set
         */
        function SetRolesTeamsToUser(properties) {
            this.nameOfRoles = [];
            this.nameOfTeams = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SetRolesTeamsToUser emailOfUser.
         * @member {string} emailOfUser
         * @memberof request.SetRolesTeamsToUser
         * @instance
         */
        SetRolesTeamsToUser.prototype.emailOfUser = "";

        /**
         * SetRolesTeamsToUser nameOfRoles.
         * @member {Array.<string>} nameOfRoles
         * @memberof request.SetRolesTeamsToUser
         * @instance
         */
        SetRolesTeamsToUser.prototype.nameOfRoles = $util.emptyArray;

        /**
         * SetRolesTeamsToUser nameOfTeams.
         * @member {Array.<string>} nameOfTeams
         * @memberof request.SetRolesTeamsToUser
         * @instance
         */
        SetRolesTeamsToUser.prototype.nameOfTeams = $util.emptyArray;

        /**
         * Creates a new SetRolesTeamsToUser instance using the specified properties.
         * @function create
         * @memberof request.SetRolesTeamsToUser
         * @static
         * @param {request.ISetRolesTeamsToUser=} [properties] Properties to set
         * @returns {request.SetRolesTeamsToUser} SetRolesTeamsToUser instance
         */
        SetRolesTeamsToUser.create = function create(properties) {
            return new SetRolesTeamsToUser(properties);
        };

        /**
         * Encodes the specified SetRolesTeamsToUser message. Does not implicitly {@link request.SetRolesTeamsToUser.verify|verify} messages.
         * @function encode
         * @memberof request.SetRolesTeamsToUser
         * @static
         * @param {request.ISetRolesTeamsToUser} message SetRolesTeamsToUser message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SetRolesTeamsToUser.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.emailOfUser != null && Object.hasOwnProperty.call(message, "emailOfUser"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.emailOfUser);
            if (message.nameOfRoles != null && message.nameOfRoles.length)
                for (let i = 0; i < message.nameOfRoles.length; ++i)
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.nameOfRoles[i]);
            if (message.nameOfTeams != null && message.nameOfTeams.length)
                for (let i = 0; i < message.nameOfTeams.length; ++i)
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.nameOfTeams[i]);
            return writer;
        };

        /**
         * Encodes the specified SetRolesTeamsToUser message, length delimited. Does not implicitly {@link request.SetRolesTeamsToUser.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.SetRolesTeamsToUser
         * @static
         * @param {request.ISetRolesTeamsToUser} message SetRolesTeamsToUser message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SetRolesTeamsToUser.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SetRolesTeamsToUser message from the specified reader or buffer.
         * @function decode
         * @memberof request.SetRolesTeamsToUser
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.SetRolesTeamsToUser} SetRolesTeamsToUser
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SetRolesTeamsToUser.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.SetRolesTeamsToUser();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.emailOfUser = reader.string();
                        break;
                    }
                case 2: {
                        if (!(message.nameOfRoles && message.nameOfRoles.length))
                            message.nameOfRoles = [];
                        message.nameOfRoles.push(reader.string());
                        break;
                    }
                case 3: {
                        if (!(message.nameOfTeams && message.nameOfTeams.length))
                            message.nameOfTeams = [];
                        message.nameOfTeams.push(reader.string());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SetRolesTeamsToUser message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.SetRolesTeamsToUser
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.SetRolesTeamsToUser} SetRolesTeamsToUser
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SetRolesTeamsToUser.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SetRolesTeamsToUser message.
         * @function verify
         * @memberof request.SetRolesTeamsToUser
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SetRolesTeamsToUser.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.emailOfUser != null && message.hasOwnProperty("emailOfUser"))
                if (!$util.isString(message.emailOfUser))
                    return "emailOfUser: string expected";
            if (message.nameOfRoles != null && message.hasOwnProperty("nameOfRoles")) {
                if (!Array.isArray(message.nameOfRoles))
                    return "nameOfRoles: array expected";
                for (let i = 0; i < message.nameOfRoles.length; ++i)
                    if (!$util.isString(message.nameOfRoles[i]))
                        return "nameOfRoles: string[] expected";
            }
            if (message.nameOfTeams != null && message.hasOwnProperty("nameOfTeams")) {
                if (!Array.isArray(message.nameOfTeams))
                    return "nameOfTeams: array expected";
                for (let i = 0; i < message.nameOfTeams.length; ++i)
                    if (!$util.isString(message.nameOfTeams[i]))
                        return "nameOfTeams: string[] expected";
            }
            return null;
        };

        /**
         * Creates a SetRolesTeamsToUser message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.SetRolesTeamsToUser
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.SetRolesTeamsToUser} SetRolesTeamsToUser
         */
        SetRolesTeamsToUser.fromObject = function fromObject(object) {
            if (object instanceof $root.request.SetRolesTeamsToUser)
                return object;
            let message = new $root.request.SetRolesTeamsToUser();
            if (object.emailOfUser != null)
                message.emailOfUser = String(object.emailOfUser);
            if (object.nameOfRoles) {
                if (!Array.isArray(object.nameOfRoles))
                    throw TypeError(".request.SetRolesTeamsToUser.nameOfRoles: array expected");
                message.nameOfRoles = [];
                for (let i = 0; i < object.nameOfRoles.length; ++i)
                    message.nameOfRoles[i] = String(object.nameOfRoles[i]);
            }
            if (object.nameOfTeams) {
                if (!Array.isArray(object.nameOfTeams))
                    throw TypeError(".request.SetRolesTeamsToUser.nameOfTeams: array expected");
                message.nameOfTeams = [];
                for (let i = 0; i < object.nameOfTeams.length; ++i)
                    message.nameOfTeams[i] = String(object.nameOfTeams[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a SetRolesTeamsToUser message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.SetRolesTeamsToUser
         * @static
         * @param {request.SetRolesTeamsToUser} message SetRolesTeamsToUser
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SetRolesTeamsToUser.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.nameOfRoles = [];
                object.nameOfTeams = [];
            }
            if (options.defaults)
                object.emailOfUser = "";
            if (message.emailOfUser != null && message.hasOwnProperty("emailOfUser"))
                object.emailOfUser = message.emailOfUser;
            if (message.nameOfRoles && message.nameOfRoles.length) {
                object.nameOfRoles = [];
                for (let j = 0; j < message.nameOfRoles.length; ++j)
                    object.nameOfRoles[j] = message.nameOfRoles[j];
            }
            if (message.nameOfTeams && message.nameOfTeams.length) {
                object.nameOfTeams = [];
                for (let j = 0; j < message.nameOfTeams.length; ++j)
                    object.nameOfTeams[j] = message.nameOfTeams[j];
            }
            return object;
        };

        /**
         * Converts this SetRolesTeamsToUser to JSON.
         * @function toJSON
         * @memberof request.SetRolesTeamsToUser
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SetRolesTeamsToUser.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for SetRolesTeamsToUser
         * @function getTypeUrl
         * @memberof request.SetRolesTeamsToUser
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        SetRolesTeamsToUser.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.SetRolesTeamsToUser";
        };

        return SetRolesTeamsToUser;
    })();

    /**
     * AllowedPinOp enum.
     * @name request.AllowedPinOp
     * @enum {number}
     * @property {number} Dummy=0 Dummy value
     * @property {number} PinOpGetMetaFromPath=17 PinOpGetMetaFromPath value
     * @property {number} PinOpGetChunk=21 PinOpGetChunk value
     * @property {number} PinOpListFiles=25 PinOpListFiles value
     * @property {number} PinOpCopyFile=52 PinOpCopyFile value
     * @property {number} PinOpStartWrite=22 PinOpStartWrite value
     * @property {number} PinOpPutChunk=23 PinOpPutChunk value
     * @property {number} PinOpFinalizeWrite=24 PinOpFinalizeWrite value
     * @property {number} PinOpResetVersion=66 PinOpResetVersion value
     * @property {number} PinOpMoveFile=50 PinOpMoveFile value
     * @property {number} PinOpRemoveFile=55 PinOpRemoveFile value
     * @property {number} PinOpCreateFolder=30 PinOpCreateFolder value
     * @property {number} PinOpMoveFolder=51 PinOpMoveFolder value
     * @property {number} PinOpRemoveFolder=56 PinOpRemoveFolder value
     * @property {number} PinOpAddPin=15 PinOpAddPin value
     * @property {number} PinOpUpdatePin=84 PinOpUpdatePin value
     * @property {number} PinOpDeletePin=54 PinOpDeletePin value
     * @property {number} PinOpListPins=91 PinOpListPins value
     */
    request.AllowedPinOp = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "Dummy"] = 0;
        values[valuesById[17] = "PinOpGetMetaFromPath"] = 17;
        values[valuesById[21] = "PinOpGetChunk"] = 21;
        values[valuesById[25] = "PinOpListFiles"] = 25;
        values[valuesById[52] = "PinOpCopyFile"] = 52;
        values[valuesById[22] = "PinOpStartWrite"] = 22;
        values[valuesById[23] = "PinOpPutChunk"] = 23;
        values[valuesById[24] = "PinOpFinalizeWrite"] = 24;
        values[valuesById[66] = "PinOpResetVersion"] = 66;
        values[valuesById[50] = "PinOpMoveFile"] = 50;
        values[valuesById[55] = "PinOpRemoveFile"] = 55;
        values[valuesById[30] = "PinOpCreateFolder"] = 30;
        values[valuesById[51] = "PinOpMoveFolder"] = 51;
        values[valuesById[56] = "PinOpRemoveFolder"] = 56;
        values[valuesById[15] = "PinOpAddPin"] = 15;
        values[valuesById[84] = "PinOpUpdatePin"] = 84;
        values[valuesById[54] = "PinOpDeletePin"] = 54;
        values[valuesById[91] = "PinOpListPins"] = 91;
        return values;
    })();

    /**
     * ClientType enum.
     * @name request.ClientType
     * @enum {number}
     * @property {number} APP=0 APP value
     * @property {number} BROWSER=1 BROWSER value
     */
    request.ClientType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "APP"] = 0;
        values[valuesById[1] = "BROWSER"] = 1;
        return values;
    })();

    request.PinObjectInDb = (function() {

        /**
         * Properties of a PinObjectInDb.
         * @memberof request
         * @interface IPinObjectInDb
         * @property {number|Long|null} [ttl] PinObjectInDb ttl
         * @property {string|null} [ip] PinObjectInDb ip
         * @property {request.ClientType|null} [ctype] PinObjectInDb ctype
         * @property {string|null} [email] PinObjectInDb email
         * @property {string|null} [client] PinObjectInDb client
         * @property {number|Long|null} [creationTime] PinObjectInDb creationTime
         * @property {Array.<request.Op>|null} [allowedPinOps] PinObjectInDb allowedPinOps
         * @property {string|null} [name] PinObjectInDb name
         * @property {Array.<Uint8Array>|null} [allowedObjects] PinObjectInDb allowedObjects
         */

        /**
         * Constructs a new PinObjectInDb.
         * @memberof request
         * @classdesc Represents a PinObjectInDb.
         * @implements IPinObjectInDb
         * @constructor
         * @param {request.IPinObjectInDb=} [properties] Properties to set
         */
        function PinObjectInDb(properties) {
            this.allowedPinOps = [];
            this.allowedObjects = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PinObjectInDb ttl.
         * @member {number|Long} ttl
         * @memberof request.PinObjectInDb
         * @instance
         */
        PinObjectInDb.prototype.ttl = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * PinObjectInDb ip.
         * @member {string} ip
         * @memberof request.PinObjectInDb
         * @instance
         */
        PinObjectInDb.prototype.ip = "";

        /**
         * PinObjectInDb ctype.
         * @member {request.ClientType} ctype
         * @memberof request.PinObjectInDb
         * @instance
         */
        PinObjectInDb.prototype.ctype = 0;

        /**
         * PinObjectInDb email.
         * @member {string} email
         * @memberof request.PinObjectInDb
         * @instance
         */
        PinObjectInDb.prototype.email = "";

        /**
         * PinObjectInDb client.
         * @member {string} client
         * @memberof request.PinObjectInDb
         * @instance
         */
        PinObjectInDb.prototype.client = "";

        /**
         * PinObjectInDb creationTime.
         * @member {number|Long} creationTime
         * @memberof request.PinObjectInDb
         * @instance
         */
        PinObjectInDb.prototype.creationTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * PinObjectInDb allowedPinOps.
         * @member {Array.<request.Op>} allowedPinOps
         * @memberof request.PinObjectInDb
         * @instance
         */
        PinObjectInDb.prototype.allowedPinOps = $util.emptyArray;

        /**
         * PinObjectInDb name.
         * @member {string|null|undefined} name
         * @memberof request.PinObjectInDb
         * @instance
         */
        PinObjectInDb.prototype.name = null;

        /**
         * PinObjectInDb allowedObjects.
         * @member {Array.<Uint8Array>} allowedObjects
         * @memberof request.PinObjectInDb
         * @instance
         */
        PinObjectInDb.prototype.allowedObjects = $util.emptyArray;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(PinObjectInDb.prototype, "_name", {
            get: $util.oneOfGetter($oneOfFields = ["name"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new PinObjectInDb instance using the specified properties.
         * @function create
         * @memberof request.PinObjectInDb
         * @static
         * @param {request.IPinObjectInDb=} [properties] Properties to set
         * @returns {request.PinObjectInDb} PinObjectInDb instance
         */
        PinObjectInDb.create = function create(properties) {
            return new PinObjectInDb(properties);
        };

        /**
         * Encodes the specified PinObjectInDb message. Does not implicitly {@link request.PinObjectInDb.verify|verify} messages.
         * @function encode
         * @memberof request.PinObjectInDb
         * @static
         * @param {request.IPinObjectInDb} message PinObjectInDb message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PinObjectInDb.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.ttl != null && Object.hasOwnProperty.call(message, "ttl"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.ttl);
            if (message.ip != null && Object.hasOwnProperty.call(message, "ip"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.ip);
            if (message.ctype != null && Object.hasOwnProperty.call(message, "ctype"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.ctype);
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.email);
            if (message.creationTime != null && Object.hasOwnProperty.call(message, "creationTime"))
                writer.uint32(/* id 5, wireType 0 =*/40).uint64(message.creationTime);
            if (message.client != null && Object.hasOwnProperty.call(message, "client"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.client);
            if (message.allowedPinOps != null && message.allowedPinOps.length) {
                writer.uint32(/* id 7, wireType 2 =*/58).fork();
                for (let i = 0; i < message.allowedPinOps.length; ++i)
                    writer.int32(message.allowedPinOps[i]);
                writer.ldelim();
            }
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.name);
            if (message.allowedObjects != null && message.allowedObjects.length)
                for (let i = 0; i < message.allowedObjects.length; ++i)
                    writer.uint32(/* id 9, wireType 2 =*/74).bytes(message.allowedObjects[i]);
            return writer;
        };

        /**
         * Encodes the specified PinObjectInDb message, length delimited. Does not implicitly {@link request.PinObjectInDb.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.PinObjectInDb
         * @static
         * @param {request.IPinObjectInDb} message PinObjectInDb message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PinObjectInDb.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PinObjectInDb message from the specified reader or buffer.
         * @function decode
         * @memberof request.PinObjectInDb
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.PinObjectInDb} PinObjectInDb
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PinObjectInDb.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.PinObjectInDb();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.ttl = reader.uint64();
                        break;
                    }
                case 2: {
                        message.ip = reader.string();
                        break;
                    }
                case 3: {
                        message.ctype = reader.int32();
                        break;
                    }
                case 4: {
                        message.email = reader.string();
                        break;
                    }
                case 6: {
                        message.client = reader.string();
                        break;
                    }
                case 5: {
                        message.creationTime = reader.uint64();
                        break;
                    }
                case 7: {
                        if (!(message.allowedPinOps && message.allowedPinOps.length))
                            message.allowedPinOps = [];
                        if ((tag & 7) === 2) {
                            let end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.allowedPinOps.push(reader.int32());
                        } else
                            message.allowedPinOps.push(reader.int32());
                        break;
                    }
                case 8: {
                        message.name = reader.string();
                        break;
                    }
                case 9: {
                        if (!(message.allowedObjects && message.allowedObjects.length))
                            message.allowedObjects = [];
                        message.allowedObjects.push(reader.bytes());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PinObjectInDb message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.PinObjectInDb
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.PinObjectInDb} PinObjectInDb
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PinObjectInDb.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PinObjectInDb message.
         * @function verify
         * @memberof request.PinObjectInDb
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PinObjectInDb.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.ttl != null && message.hasOwnProperty("ttl"))
                if (!$util.isInteger(message.ttl) && !(message.ttl && $util.isInteger(message.ttl.low) && $util.isInteger(message.ttl.high)))
                    return "ttl: integer|Long expected";
            if (message.ip != null && message.hasOwnProperty("ip"))
                if (!$util.isString(message.ip))
                    return "ip: string expected";
            if (message.ctype != null && message.hasOwnProperty("ctype"))
                switch (message.ctype) {
                default:
                    return "ctype: enum value expected";
                case 0:
                case 1:
                    break;
                }
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            if (message.client != null && message.hasOwnProperty("client"))
                if (!$util.isString(message.client))
                    return "client: string expected";
            if (message.creationTime != null && message.hasOwnProperty("creationTime"))
                if (!$util.isInteger(message.creationTime) && !(message.creationTime && $util.isInteger(message.creationTime.low) && $util.isInteger(message.creationTime.high)))
                    return "creationTime: integer|Long expected";
            if (message.allowedPinOps != null && message.hasOwnProperty("allowedPinOps")) {
                if (!Array.isArray(message.allowedPinOps))
                    return "allowedPinOps: array expected";
                for (let i = 0; i < message.allowedPinOps.length; ++i)
                    switch (message.allowedPinOps[i]) {
                    default:
                        return "allowedPinOps: enum value[] expected";
                    case 0:
                    case 2:
                    case 3:
                    case 4:
                    case 6:
                    case 9:
                    case 10:
                    case 11:
                    case 12:
                    case 13:
                    case 14:
                    case 15:
                    case 54:
                    case 16:
                    case 17:
                    case 19:
                    case 20:
                    case 21:
                    case 22:
                    case 23:
                    case 24:
                    case 25:
                    case 26:
                    case 27:
                    case 28:
                    case 29:
                    case 30:
                    case 31:
                    case 32:
                    case 33:
                    case 34:
                    case 35:
                    case 36:
                    case 37:
                    case 87:
                    case 38:
                    case 39:
                    case 40:
                    case 41:
                    case 42:
                    case 43:
                    case 44:
                    case 81:
                    case 49:
                    case 45:
                    case 46:
                    case 47:
                    case 48:
                    case 80:
                    case 50:
                    case 51:
                    case 52:
                    case 53:
                    case 82:
                    case 55:
                    case 56:
                    case 57:
                    case 58:
                    case 59:
                    case 60:
                    case 69:
                    case 62:
                    case 63:
                    case 64:
                    case 65:
                    case 66:
                    case 67:
                    case 68:
                    case 71:
                    case 72:
                    case 73:
                    case 74:
                    case 75:
                    case 76:
                    case 77:
                    case 83:
                    case 84:
                    case 86:
                    case 88:
                    case 89:
                    case 90:
                    case 91:
                    case 92:
                    case 93:
                    case 94:
                    case 95:
                    case 96:
                    case 97:
                    case 98:
                    case 99:
                    case 100:
                    case 101:
                    case 102:
                    case 103:
                    case 104:
                    case 105:
                    case 106:
                    case 107:
                    case 108:
                    case 109:
                    case 110:
                    case 111:
                    case 112:
                    case 113:
                    case 114:
                    case 115:
                    case 116:
                    case 117:
                    case 118:
                    case 119:
                    case 120:
                    case 121:
                    case 122:
                    case 123:
                    case 124:
                    case 125:
                    case 126:
                    case 127:
                    case 128:
                    case 129:
                        break;
                    }
            }
            if (message.name != null && message.hasOwnProperty("name")) {
                properties._name = 1;
                if (!$util.isString(message.name))
                    return "name: string expected";
            }
            if (message.allowedObjects != null && message.hasOwnProperty("allowedObjects")) {
                if (!Array.isArray(message.allowedObjects))
                    return "allowedObjects: array expected";
                for (let i = 0; i < message.allowedObjects.length; ++i)
                    if (!(message.allowedObjects[i] && typeof message.allowedObjects[i].length === "number" || $util.isString(message.allowedObjects[i])))
                        return "allowedObjects: buffer[] expected";
            }
            return null;
        };

        /**
         * Creates a PinObjectInDb message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.PinObjectInDb
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.PinObjectInDb} PinObjectInDb
         */
        PinObjectInDb.fromObject = function fromObject(object) {
            if (object instanceof $root.request.PinObjectInDb)
                return object;
            let message = new $root.request.PinObjectInDb();
            if (object.ttl != null)
                if ($util.Long)
                    (message.ttl = $util.Long.fromValue(object.ttl)).unsigned = true;
                else if (typeof object.ttl === "string")
                    message.ttl = parseInt(object.ttl, 10);
                else if (typeof object.ttl === "number")
                    message.ttl = object.ttl;
                else if (typeof object.ttl === "object")
                    message.ttl = new $util.LongBits(object.ttl.low >>> 0, object.ttl.high >>> 0).toNumber(true);
            if (object.ip != null)
                message.ip = String(object.ip);
            switch (object.ctype) {
            default:
                if (typeof object.ctype === "number") {
                    message.ctype = object.ctype;
                    break;
                }
                break;
            case "APP":
            case 0:
                message.ctype = 0;
                break;
            case "BROWSER":
            case 1:
                message.ctype = 1;
                break;
            }
            if (object.email != null)
                message.email = String(object.email);
            if (object.client != null)
                message.client = String(object.client);
            if (object.creationTime != null)
                if ($util.Long)
                    (message.creationTime = $util.Long.fromValue(object.creationTime)).unsigned = true;
                else if (typeof object.creationTime === "string")
                    message.creationTime = parseInt(object.creationTime, 10);
                else if (typeof object.creationTime === "number")
                    message.creationTime = object.creationTime;
                else if (typeof object.creationTime === "object")
                    message.creationTime = new $util.LongBits(object.creationTime.low >>> 0, object.creationTime.high >>> 0).toNumber(true);
            if (object.allowedPinOps) {
                if (!Array.isArray(object.allowedPinOps))
                    throw TypeError(".request.PinObjectInDb.allowedPinOps: array expected");
                message.allowedPinOps = [];
                for (let i = 0; i < object.allowedPinOps.length; ++i)
                    switch (object.allowedPinOps[i]) {
                    default:
                        if (typeof object.allowedPinOps[i] === "number") {
                            message.allowedPinOps[i] = object.allowedPinOps[i];
                            break;
                        }
                    case "OpAddUser":
                    case 0:
                        message.allowedPinOps[i] = 0;
                        break;
                    case "OpRemoveUser":
                    case 2:
                        message.allowedPinOps[i] = 2;
                        break;
                    case "OpPasswordReset":
                    case 3:
                        message.allowedPinOps[i] = 3;
                        break;
                    case "OpChangePassword":
                    case 4:
                        message.allowedPinOps[i] = 4;
                        break;
                    case "OpInitiatePayment":
                    case 6:
                        message.allowedPinOps[i] = 6;
                        break;
                    case "OpInviteUser":
                    case 9:
                        message.allowedPinOps[i] = 9;
                        break;
                    case "OpGetUser":
                    case 10:
                        message.allowedPinOps[i] = 10;
                        break;
                    case "OpListUsers":
                    case 11:
                        message.allowedPinOps[i] = 11;
                        break;
                    case "OpRemoveOrganization":
                    case 12:
                        message.allowedPinOps[i] = 12;
                        break;
                    case "OpVerifyOrganization":
                    case 13:
                        message.allowedPinOps[i] = 13;
                        break;
                    case "OpGetOrganization":
                    case 14:
                        message.allowedPinOps[i] = 14;
                        break;
                    case "OpAddPin":
                    case 15:
                        message.allowedPinOps[i] = 15;
                        break;
                    case "OPDeletePin":
                    case 54:
                        message.allowedPinOps[i] = 54;
                        break;
                    case "OpVerifyUser":
                    case 16:
                        message.allowedPinOps[i] = 16;
                        break;
                    case "OpGetMetaFromPath":
                    case 17:
                        message.allowedPinOps[i] = 17;
                        break;
                    case "OpFileLock":
                    case 19:
                        message.allowedPinOps[i] = 19;
                        break;
                    case "OpFileUnlock":
                    case 20:
                        message.allowedPinOps[i] = 20;
                        break;
                    case "OpGetChunk":
                    case 21:
                        message.allowedPinOps[i] = 21;
                        break;
                    case "OpStartWrite":
                    case 22:
                        message.allowedPinOps[i] = 22;
                        break;
                    case "OpPutChunk":
                    case 23:
                        message.allowedPinOps[i] = 23;
                        break;
                    case "OpFinalizeWrite":
                    case 24:
                        message.allowedPinOps[i] = 24;
                        break;
                    case "OpListFiles":
                    case 25:
                        message.allowedPinOps[i] = 25;
                        break;
                    case "OpRemove":
                    case 26:
                        message.allowedPinOps[i] = 26;
                        break;
                    case "OpCopy":
                    case 27:
                        message.allowedPinOps[i] = 27;
                        break;
                    case "OpMove":
                    case 28:
                        message.allowedPinOps[i] = 28;
                        break;
                    case "OpGetFolder":
                    case 29:
                        message.allowedPinOps[i] = 29;
                        break;
                    case "OpCreateFolder":
                    case 30:
                        message.allowedPinOps[i] = 30;
                        break;
                    case "OpCreateSnapshot":
                    case 31:
                        message.allowedPinOps[i] = 31;
                        break;
                    case "OpVerifyPayment":
                    case 32:
                        message.allowedPinOps[i] = 32;
                        break;
                    case "OpGetSecret":
                    case 33:
                        message.allowedPinOps[i] = 33;
                        break;
                    case "OpAddSecret":
                    case 34:
                        message.allowedPinOps[i] = 34;
                        break;
                    case "OpRemoveSecret":
                    case 35:
                        message.allowedPinOps[i] = 35;
                        break;
                    case "OpUpdateSecret":
                    case 36:
                        message.allowedPinOps[i] = 36;
                        break;
                    case "OpListSecrets":
                    case 37:
                        message.allowedPinOps[i] = 37;
                        break;
                    case "OpQuickListSecrets":
                    case 87:
                        message.allowedPinOps[i] = 87;
                        break;
                    case "OpListSecretSubkeys":
                    case 38:
                        message.allowedPinOps[i] = 38;
                        break;
                    case "OpUndeleteSecret":
                    case 39:
                        message.allowedPinOps[i] = 39;
                        break;
                    case "OpDestroySecret":
                    case 40:
                        message.allowedPinOps[i] = 40;
                        break;
                    case "OpAddRole":
                    case 41:
                        message.allowedPinOps[i] = 41;
                        break;
                    case "OpRemoveRole":
                    case 42:
                        message.allowedPinOps[i] = 42;
                        break;
                    case "OpUpdateRole":
                    case 43:
                        message.allowedPinOps[i] = 43;
                        break;
                    case "OpListRoles":
                    case 44:
                        message.allowedPinOps[i] = 44;
                        break;
                    case "OpGetRole":
                    case 81:
                        message.allowedPinOps[i] = 81;
                        break;
                    case "OpIsOperationAllowed":
                    case 49:
                        message.allowedPinOps[i] = 49;
                        break;
                    case "OpListTeams":
                    case 45:
                        message.allowedPinOps[i] = 45;
                        break;
                    case "OpAddTeam":
                    case 46:
                        message.allowedPinOps[i] = 46;
                        break;
                    case "OpRemoveTeam":
                    case 47:
                        message.allowedPinOps[i] = 47;
                        break;
                    case "OpUpdateTeam":
                    case 48:
                        message.allowedPinOps[i] = 48;
                        break;
                    case "OpGetTeam":
                    case 80:
                        message.allowedPinOps[i] = 80;
                        break;
                    case "OpMoveFile":
                    case 50:
                        message.allowedPinOps[i] = 50;
                        break;
                    case "OpMoveFolder":
                    case 51:
                        message.allowedPinOps[i] = 51;
                        break;
                    case "OpCopyFile":
                    case 52:
                        message.allowedPinOps[i] = 52;
                        break;
                    case "OpCopyFolder":
                    case 53:
                        message.allowedPinOps[i] = 53;
                        break;
                    case "OpRestoreVersion":
                    case 82:
                        message.allowedPinOps[i] = 82;
                        break;
                    case "OpRemoveFile":
                    case 55:
                        message.allowedPinOps[i] = 55;
                        break;
                    case "OpRemoveFolder":
                    case 56:
                        message.allowedPinOps[i] = 56;
                        break;
                    case "OpUntrashFile":
                    case 57:
                        message.allowedPinOps[i] = 57;
                        break;
                    case "OpUntrashFolder":
                    case 58:
                        message.allowedPinOps[i] = 58;
                        break;
                    case "OpUndoStartWrite":
                    case 59:
                        message.allowedPinOps[i] = 59;
                        break;
                    case "OpDetachClonedFolder":
                    case 60:
                        message.allowedPinOps[i] = 60;
                        break;
                    case "OpGetProfileFileMeta":
                    case 69:
                        message.allowedPinOps[i] = 69;
                        break;
                    case "OpRenameFile":
                    case 62:
                        message.allowedPinOps[i] = 62;
                        break;
                    case "OpRenameFolder":
                    case 63:
                        message.allowedPinOps[i] = 63;
                        break;
                    case "OpList":
                    case 64:
                        message.allowedPinOps[i] = 64;
                        break;
                    case "OpAuditLogMessage":
                    case 65:
                        message.allowedPinOps[i] = 65;
                        break;
                    case "OpResetVersion":
                    case 66:
                        message.allowedPinOps[i] = 66;
                        break;
                    case "OpSetUser":
                    case 67:
                        message.allowedPinOps[i] = 67;
                        break;
                    case "OpFinalizeProfileWrite":
                    case 68:
                        message.allowedPinOps[i] = 68;
                        break;
                    case "OpGetUserType":
                    case 71:
                        message.allowedPinOps[i] = 71;
                        break;
                    case "OpGetRandomBytes":
                    case 72:
                        message.allowedPinOps[i] = 72;
                        break;
                    case "OpShare":
                    case 73:
                        message.allowedPinOps[i] = 73;
                        break;
                    case "OpUnshare":
                    case 74:
                        message.allowedPinOps[i] = 74;
                        break;
                    case "OpUpdateShare":
                    case 75:
                        message.allowedPinOps[i] = 75;
                        break;
                    case "OpListShares":
                    case 76:
                        message.allowedPinOps[i] = 76;
                        break;
                    case "OpResetTOTP":
                    case 77:
                        message.allowedPinOps[i] = 77;
                        break;
                    case "OpSetRolesTeamsToUser":
                    case 83:
                        message.allowedPinOps[i] = 83;
                        break;
                    case "OpUpdatePinOps":
                    case 84:
                        message.allowedPinOps[i] = 84;
                        break;
                    case "OpGetRolesAndTeamsOfUser":
                    case 86:
                        message.allowedPinOps[i] = 86;
                        break;
                    case "OpVerifyAuditLogMeta":
                    case 88:
                        message.allowedPinOps[i] = 88;
                        break;
                    case "OpGetAuditLog":
                    case 89:
                        message.allowedPinOps[i] = 89;
                        break;
                    case "OpDeleteAuditLog":
                    case 90:
                        message.allowedPinOps[i] = 90;
                        break;
                    case "OpListPins":
                    case 91:
                        message.allowedPinOps[i] = 91;
                        break;
                    case "OpListQuestions":
                    case 92:
                        message.allowedPinOps[i] = 92;
                        break;
                    case "OpMigrateToStorage":
                    case 93:
                        message.allowedPinOps[i] = 93;
                        break;
                    case "OpVerifyBYOSCreds":
                    case 94:
                        message.allowedPinOps[i] = 94;
                        break;
                    case "OpUpdateStorageCreds":
                    case 95:
                        message.allowedPinOps[i] = 95;
                        break;
                    case "OpRemoveOrganizationUser":
                    case 96:
                        message.allowedPinOps[i] = 96;
                        break;
                    case "OpAddSpace":
                    case 97:
                        message.allowedPinOps[i] = 97;
                        break;
                    case "OpAddUserToSpace":
                    case 98:
                        message.allowedPinOps[i] = 98;
                        break;
                    case "OpRemoveUserFromSpace":
                    case 99:
                        message.allowedPinOps[i] = 99;
                        break;
                    case "OpUpdatePermissionsOfSpace":
                    case 100:
                        message.allowedPinOps[i] = 100;
                        break;
                    case "OpAddObjectToSpace":
                    case 101:
                        message.allowedPinOps[i] = 101;
                        break;
                    case "OpRemoveObjectFromSpace":
                    case 102:
                        message.allowedPinOps[i] = 102;
                        break;
                    case "OpRemoveSpace":
                    case 103:
                        message.allowedPinOps[i] = 103;
                        break;
                    case "OpSendOtpToExternalUser":
                    case 104:
                        message.allowedPinOps[i] = 104;
                        break;
                    case "OpSignInToSpace":
                    case 105:
                        message.allowedPinOps[i] = 105;
                        break;
                    case "OpListSpaces":
                    case 106:
                        message.allowedPinOps[i] = 106;
                        break;
                    case "OpUpdateTags":
                    case 107:
                        message.allowedPinOps[i] = 107;
                        break;
                    case "OpAddComment":
                    case 108:
                        message.allowedPinOps[i] = 108;
                        break;
                    case "OpGetComment":
                    case 109:
                        message.allowedPinOps[i] = 109;
                        break;
                    case "OpListComments":
                    case 110:
                        message.allowedPinOps[i] = 110;
                        break;
                    case "OpRemoveComment":
                    case 111:
                        message.allowedPinOps[i] = 111;
                        break;
                    case "OpUpdateComment":
                    case 112:
                        message.allowedPinOps[i] = 112;
                        break;
                    case "OpGetStorageCreds":
                    case 113:
                        message.allowedPinOps[i] = 113;
                        break;
                    case "OpGetPlan":
                    case 114:
                        message.allowedPinOps[i] = 114;
                        break;
                    case "OpValidateCoupon":
                    case 115:
                        message.allowedPinOps[i] = 115;
                        break;
                    case "OpRemoveVersion":
                    case 116:
                        message.allowedPinOps[i] = 116;
                        break;
                    case "OpGetProfilePictureOfUser":
                    case 117:
                        message.allowedPinOps[i] = 117;
                        break;
                    case "OpEmptyTrash":
                    case 118:
                        message.allowedPinOps[i] = 118;
                        break;
                    case "OpGetThumbnail":
                    case 119:
                        message.allowedPinOps[i] = 119;
                        break;
                    case "OpSetThumbnail":
                    case 120:
                        message.allowedPinOps[i] = 120;
                        break;
                    case "OpYsentinel":
                    case 121:
                        message.allowedPinOps[i] = 121;
                        break;
                    case "OpCreateAlert":
                    case 122:
                        message.allowedPinOps[i] = 122;
                        break;
                    case "OpListAlerts":
                    case 123:
                        message.allowedPinOps[i] = 123;
                        break;
                    case "OpDeleteAlert":
                    case 124:
                        message.allowedPinOps[i] = 124;
                        break;
                    case "OpUpdateAlert":
                    case 125:
                        message.allowedPinOps[i] = 125;
                        break;
                    case "OpBlockUser":
                    case 126:
                        message.allowedPinOps[i] = 126;
                        break;
                    case "OpUnblockUser":
                    case 127:
                        message.allowedPinOps[i] = 127;
                        break;
                    case "UpdateOrganizationSettings":
                    case 128:
                        message.allowedPinOps[i] = 128;
                        break;
                    case "GetOrganizationSettings":
                    case 129:
                        message.allowedPinOps[i] = 129;
                        break;
                    }
            }
            if (object.name != null)
                message.name = String(object.name);
            if (object.allowedObjects) {
                if (!Array.isArray(object.allowedObjects))
                    throw TypeError(".request.PinObjectInDb.allowedObjects: array expected");
                message.allowedObjects = [];
                for (let i = 0; i < object.allowedObjects.length; ++i)
                    if (typeof object.allowedObjects[i] === "string")
                        $util.base64.decode(object.allowedObjects[i], message.allowedObjects[i] = $util.newBuffer($util.base64.length(object.allowedObjects[i])), 0);
                    else if (object.allowedObjects[i].length >= 0)
                        message.allowedObjects[i] = object.allowedObjects[i];
            }
            return message;
        };

        /**
         * Creates a plain object from a PinObjectInDb message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.PinObjectInDb
         * @static
         * @param {request.PinObjectInDb} message PinObjectInDb
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PinObjectInDb.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.allowedPinOps = [];
                object.allowedObjects = [];
            }
            if (options.defaults) {
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.ttl = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.ttl = options.longs === String ? "0" : 0;
                object.ip = "";
                object.ctype = options.enums === String ? "APP" : 0;
                object.email = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.creationTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.creationTime = options.longs === String ? "0" : 0;
                object.client = "";
            }
            if (message.ttl != null && message.hasOwnProperty("ttl"))
                if (typeof message.ttl === "number")
                    object.ttl = options.longs === String ? String(message.ttl) : message.ttl;
                else
                    object.ttl = options.longs === String ? $util.Long.prototype.toString.call(message.ttl) : options.longs === Number ? new $util.LongBits(message.ttl.low >>> 0, message.ttl.high >>> 0).toNumber(true) : message.ttl;
            if (message.ip != null && message.hasOwnProperty("ip"))
                object.ip = message.ip;
            if (message.ctype != null && message.hasOwnProperty("ctype"))
                object.ctype = options.enums === String ? $root.request.ClientType[message.ctype] === undefined ? message.ctype : $root.request.ClientType[message.ctype] : message.ctype;
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.creationTime != null && message.hasOwnProperty("creationTime"))
                if (typeof message.creationTime === "number")
                    object.creationTime = options.longs === String ? String(message.creationTime) : message.creationTime;
                else
                    object.creationTime = options.longs === String ? $util.Long.prototype.toString.call(message.creationTime) : options.longs === Number ? new $util.LongBits(message.creationTime.low >>> 0, message.creationTime.high >>> 0).toNumber(true) : message.creationTime;
            if (message.client != null && message.hasOwnProperty("client"))
                object.client = message.client;
            if (message.allowedPinOps && message.allowedPinOps.length) {
                object.allowedPinOps = [];
                for (let j = 0; j < message.allowedPinOps.length; ++j)
                    object.allowedPinOps[j] = options.enums === String ? $root.request.Op[message.allowedPinOps[j]] === undefined ? message.allowedPinOps[j] : $root.request.Op[message.allowedPinOps[j]] : message.allowedPinOps[j];
            }
            if (message.name != null && message.hasOwnProperty("name")) {
                object.name = message.name;
                if (options.oneofs)
                    object._name = "name";
            }
            if (message.allowedObjects && message.allowedObjects.length) {
                object.allowedObjects = [];
                for (let j = 0; j < message.allowedObjects.length; ++j)
                    object.allowedObjects[j] = options.bytes === String ? $util.base64.encode(message.allowedObjects[j], 0, message.allowedObjects[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.allowedObjects[j]) : message.allowedObjects[j];
            }
            return object;
        };

        /**
         * Converts this PinObjectInDb to JSON.
         * @function toJSON
         * @memberof request.PinObjectInDb
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PinObjectInDb.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for PinObjectInDb
         * @function getTypeUrl
         * @memberof request.PinObjectInDb
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        PinObjectInDb.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.PinObjectInDb";
        };

        return PinObjectInDb;
    })();

    request.PinObjectResponse = (function() {

        /**
         * Properties of a PinObjectResponse.
         * @memberof request
         * @interface IPinObjectResponse
         * @property {Uint8Array|null} [token] PinObjectResponse token
         * @property {string|null} [email] PinObjectResponse email
         * @property {string|null} [organizationName] PinObjectResponse organizationName
         */

        /**
         * Constructs a new PinObjectResponse.
         * @memberof request
         * @classdesc Represents a PinObjectResponse.
         * @implements IPinObjectResponse
         * @constructor
         * @param {request.IPinObjectResponse=} [properties] Properties to set
         */
        function PinObjectResponse(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PinObjectResponse token.
         * @member {Uint8Array} token
         * @memberof request.PinObjectResponse
         * @instance
         */
        PinObjectResponse.prototype.token = $util.newBuffer([]);

        /**
         * PinObjectResponse email.
         * @member {string} email
         * @memberof request.PinObjectResponse
         * @instance
         */
        PinObjectResponse.prototype.email = "";

        /**
         * PinObjectResponse organizationName.
         * @member {string|null|undefined} organizationName
         * @memberof request.PinObjectResponse
         * @instance
         */
        PinObjectResponse.prototype.organizationName = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(PinObjectResponse.prototype, "_organizationName", {
            get: $util.oneOfGetter($oneOfFields = ["organizationName"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new PinObjectResponse instance using the specified properties.
         * @function create
         * @memberof request.PinObjectResponse
         * @static
         * @param {request.IPinObjectResponse=} [properties] Properties to set
         * @returns {request.PinObjectResponse} PinObjectResponse instance
         */
        PinObjectResponse.create = function create(properties) {
            return new PinObjectResponse(properties);
        };

        /**
         * Encodes the specified PinObjectResponse message. Does not implicitly {@link request.PinObjectResponse.verify|verify} messages.
         * @function encode
         * @memberof request.PinObjectResponse
         * @static
         * @param {request.IPinObjectResponse} message PinObjectResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PinObjectResponse.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.token != null && Object.hasOwnProperty.call(message, "token"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.token);
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.email);
            if (message.organizationName != null && Object.hasOwnProperty.call(message, "organizationName"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.organizationName);
            return writer;
        };

        /**
         * Encodes the specified PinObjectResponse message, length delimited. Does not implicitly {@link request.PinObjectResponse.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.PinObjectResponse
         * @static
         * @param {request.IPinObjectResponse} message PinObjectResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PinObjectResponse.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PinObjectResponse message from the specified reader or buffer.
         * @function decode
         * @memberof request.PinObjectResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.PinObjectResponse} PinObjectResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PinObjectResponse.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.PinObjectResponse();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.token = reader.bytes();
                        break;
                    }
                case 2: {
                        message.email = reader.string();
                        break;
                    }
                case 3: {
                        message.organizationName = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PinObjectResponse message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.PinObjectResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.PinObjectResponse} PinObjectResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PinObjectResponse.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PinObjectResponse message.
         * @function verify
         * @memberof request.PinObjectResponse
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PinObjectResponse.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.token != null && message.hasOwnProperty("token"))
                if (!(message.token && typeof message.token.length === "number" || $util.isString(message.token)))
                    return "token: buffer expected";
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            if (message.organizationName != null && message.hasOwnProperty("organizationName")) {
                properties._organizationName = 1;
                if (!$util.isString(message.organizationName))
                    return "organizationName: string expected";
            }
            return null;
        };

        /**
         * Creates a PinObjectResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.PinObjectResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.PinObjectResponse} PinObjectResponse
         */
        PinObjectResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.request.PinObjectResponse)
                return object;
            let message = new $root.request.PinObjectResponse();
            if (object.token != null)
                if (typeof object.token === "string")
                    $util.base64.decode(object.token, message.token = $util.newBuffer($util.base64.length(object.token)), 0);
                else if (object.token.length >= 0)
                    message.token = object.token;
            if (object.email != null)
                message.email = String(object.email);
            if (object.organizationName != null)
                message.organizationName = String(object.organizationName);
            return message;
        };

        /**
         * Creates a plain object from a PinObjectResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.PinObjectResponse
         * @static
         * @param {request.PinObjectResponse} message PinObjectResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PinObjectResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if (options.bytes === String)
                    object.token = "";
                else {
                    object.token = [];
                    if (options.bytes !== Array)
                        object.token = $util.newBuffer(object.token);
                }
                object.email = "";
            }
            if (message.token != null && message.hasOwnProperty("token"))
                object.token = options.bytes === String ? $util.base64.encode(message.token, 0, message.token.length) : options.bytes === Array ? Array.prototype.slice.call(message.token) : message.token;
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.organizationName != null && message.hasOwnProperty("organizationName")) {
                object.organizationName = message.organizationName;
                if (options.oneofs)
                    object._organizationName = "organizationName";
            }
            return object;
        };

        /**
         * Converts this PinObjectResponse to JSON.
         * @function toJSON
         * @memberof request.PinObjectResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PinObjectResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for PinObjectResponse
         * @function getTypeUrl
         * @memberof request.PinObjectResponse
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        PinObjectResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.PinObjectResponse";
        };

        return PinObjectResponse;
    })();

    /**
     * Op enum.
     * @name request.Op
     * @enum {number}
     * @property {number} OpAddUser=0 OpAddUser value
     * @property {number} OpRemoveUser=2 OpRemoveUser value
     * @property {number} OpPasswordReset=3 OpPasswordReset value
     * @property {number} OpChangePassword=4 OpChangePassword value
     * @property {number} OpInitiatePayment=6 OpInitiatePayment value
     * @property {number} OpInviteUser=9 OpInviteUser value
     * @property {number} OpGetUser=10 OpGetUser value
     * @property {number} OpListUsers=11 OpListUsers value
     * @property {number} OpRemoveOrganization=12 OpRemoveOrganization value
     * @property {number} OpVerifyOrganization=13 OpVerifyOrganization value
     * @property {number} OpGetOrganization=14 OpGetOrganization value
     * @property {number} OpAddPin=15 OpAddPin value
     * @property {number} OPDeletePin=54 OPDeletePin value
     * @property {number} OpVerifyUser=16 OpVerifyUser value
     * @property {number} OpGetMetaFromPath=17 OpGetMetaFromPath value
     * @property {number} OpFileLock=19 OpFileLock value
     * @property {number} OpFileUnlock=20 OpFileUnlock value
     * @property {number} OpGetChunk=21 OpGetChunk value
     * @property {number} OpStartWrite=22 OpStartWrite value
     * @property {number} OpPutChunk=23 OpPutChunk value
     * @property {number} OpFinalizeWrite=24 OpFinalizeWrite value
     * @property {number} OpListFiles=25 OpListFiles value
     * @property {number} OpRemove=26 OpRemove value
     * @property {number} OpCopy=27 OpCopy value
     * @property {number} OpMove=28 OpMove value
     * @property {number} OpGetFolder=29 OpGetFolder value
     * @property {number} OpCreateFolder=30 OpCreateFolder value
     * @property {number} OpCreateSnapshot=31 OpCreateSnapshot value
     * @property {number} OpVerifyPayment=32 OpVerifyPayment value
     * @property {number} OpGetSecret=33 OpGetSecret value
     * @property {number} OpAddSecret=34 OpAddSecret value
     * @property {number} OpRemoveSecret=35 OpRemoveSecret value
     * @property {number} OpUpdateSecret=36 OpUpdateSecret value
     * @property {number} OpListSecrets=37 OpListSecrets value
     * @property {number} OpQuickListSecrets=87 OpQuickListSecrets value
     * @property {number} OpListSecretSubkeys=38 OpListSecretSubkeys value
     * @property {number} OpUndeleteSecret=39 OpUndeleteSecret value
     * @property {number} OpDestroySecret=40 OpDestroySecret value
     * @property {number} OpAddRole=41 OpAddRole value
     * @property {number} OpRemoveRole=42 OpRemoveRole value
     * @property {number} OpUpdateRole=43 OpUpdateRole value
     * @property {number} OpListRoles=44 OpListRoles value
     * @property {number} OpGetRole=81 OpGetRole value
     * @property {number} OpIsOperationAllowed=49 OpIsOperationAllowed value
     * @property {number} OpListTeams=45 OpListTeams value
     * @property {number} OpAddTeam=46 OpAddTeam value
     * @property {number} OpRemoveTeam=47 OpRemoveTeam value
     * @property {number} OpUpdateTeam=48 OpUpdateTeam value
     * @property {number} OpGetTeam=80 OpGetTeam value
     * @property {number} OpMoveFile=50 OpMoveFile value
     * @property {number} OpMoveFolder=51 OpMoveFolder value
     * @property {number} OpCopyFile=52 OpCopyFile value
     * @property {number} OpCopyFolder=53 OpCopyFolder value
     * @property {number} OpRestoreVersion=82 OpRestoreVersion value
     * @property {number} OpRemoveFile=55 OpRemoveFile value
     * @property {number} OpRemoveFolder=56 OpRemoveFolder value
     * @property {number} OpUntrashFile=57 OpUntrashFile value
     * @property {number} OpUntrashFolder=58 OpUntrashFolder value
     * @property {number} OpUndoStartWrite=59 OpUndoStartWrite value
     * @property {number} OpDetachClonedFolder=60 OpDetachClonedFolder value
     * @property {number} OpGetProfileFileMeta=69 OpGetProfileFileMeta value
     * @property {number} OpRenameFile=62 OpRenameFile value
     * @property {number} OpRenameFolder=63 OpRenameFolder value
     * @property {number} OpList=64 OpList value
     * @property {number} OpAuditLogMessage=65 OpAuditLogMessage value
     * @property {number} OpResetVersion=66 OpResetVersion value
     * @property {number} OpSetUser=67 OpSetUser value
     * @property {number} OpFinalizeProfileWrite=68 OpFinalizeProfileWrite value
     * @property {number} OpGetUserType=71 OpGetUserType value
     * @property {number} OpGetRandomBytes=72 OpGetRandomBytes value
     * @property {number} OpShare=73 OpShare value
     * @property {number} OpUnshare=74 OpUnshare value
     * @property {number} OpUpdateShare=75 OpUpdateShare value
     * @property {number} OpListShares=76 OpListShares value
     * @property {number} OpResetTOTP=77 OpResetTOTP value
     * @property {number} OpSetRolesTeamsToUser=83 OpSetRolesTeamsToUser value
     * @property {number} OpUpdatePinOps=84 OpUpdatePinOps value
     * @property {number} OpGetRolesAndTeamsOfUser=86 OpGetRolesAndTeamsOfUser value
     * @property {number} OpVerifyAuditLogMeta=88 OpVerifyAuditLogMeta value
     * @property {number} OpGetAuditLog=89 OpGetAuditLog value
     * @property {number} OpDeleteAuditLog=90 OpDeleteAuditLog value
     * @property {number} OpListPins=91 OpListPins value
     * @property {number} OpListQuestions=92 OpListQuestions value
     * @property {number} OpMigrateToStorage=93 OpMigrateToStorage value
     * @property {number} OpVerifyBYOSCreds=94 OpVerifyBYOSCreds value
     * @property {number} OpUpdateStorageCreds=95 OpUpdateStorageCreds value
     * @property {number} OpRemoveOrganizationUser=96 OpRemoveOrganizationUser value
     * @property {number} OpAddSpace=97 OpAddSpace value
     * @property {number} OpAddUserToSpace=98 OpAddUserToSpace value
     * @property {number} OpRemoveUserFromSpace=99 OpRemoveUserFromSpace value
     * @property {number} OpUpdatePermissionsOfSpace=100 OpUpdatePermissionsOfSpace value
     * @property {number} OpAddObjectToSpace=101 OpAddObjectToSpace value
     * @property {number} OpRemoveObjectFromSpace=102 OpRemoveObjectFromSpace value
     * @property {number} OpRemoveSpace=103 OpRemoveSpace value
     * @property {number} OpSendOtpToExternalUser=104 OpSendOtpToExternalUser value
     * @property {number} OpSignInToSpace=105 OpSignInToSpace value
     * @property {number} OpListSpaces=106 OpListSpaces value
     * @property {number} OpUpdateTags=107 OpUpdateTags value
     * @property {number} OpAddComment=108 OpAddComment value
     * @property {number} OpGetComment=109 OpGetComment value
     * @property {number} OpListComments=110 OpListComments value
     * @property {number} OpRemoveComment=111 OpRemoveComment value
     * @property {number} OpUpdateComment=112 OpUpdateComment value
     * @property {number} OpGetStorageCreds=113 OpGetStorageCreds value
     * @property {number} OpGetPlan=114 OpGetPlan value
     * @property {number} OpValidateCoupon=115 OpValidateCoupon value
     * @property {number} OpRemoveVersion=116 OpRemoveVersion value
     * @property {number} OpGetProfilePictureOfUser=117 OpGetProfilePictureOfUser value
     * @property {number} OpEmptyTrash=118 OpEmptyTrash value
     * @property {number} OpGetThumbnail=119 OpGetThumbnail value
     * @property {number} OpSetThumbnail=120 OpSetThumbnail value
     * @property {number} OpYsentinel=121 OpYsentinel value
     * @property {number} OpCreateAlert=122 OpCreateAlert value
     * @property {number} OpListAlerts=123 OpListAlerts value
     * @property {number} OpDeleteAlert=124 OpDeleteAlert value
     * @property {number} OpUpdateAlert=125 OpUpdateAlert value
     * @property {number} OpBlockUser=126 OpBlockUser value
     * @property {number} OpUnblockUser=127 OpUnblockUser value
     * @property {number} UpdateOrganizationSettings=128 UpdateOrganizationSettings value
     * @property {number} GetOrganizationSettings=129 GetOrganizationSettings value
     */
    request.Op = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "OpAddUser"] = 0;
        values[valuesById[2] = "OpRemoveUser"] = 2;
        values[valuesById[3] = "OpPasswordReset"] = 3;
        values[valuesById[4] = "OpChangePassword"] = 4;
        values[valuesById[6] = "OpInitiatePayment"] = 6;
        values[valuesById[9] = "OpInviteUser"] = 9;
        values[valuesById[10] = "OpGetUser"] = 10;
        values[valuesById[11] = "OpListUsers"] = 11;
        values[valuesById[12] = "OpRemoveOrganization"] = 12;
        values[valuesById[13] = "OpVerifyOrganization"] = 13;
        values[valuesById[14] = "OpGetOrganization"] = 14;
        values[valuesById[15] = "OpAddPin"] = 15;
        values[valuesById[54] = "OPDeletePin"] = 54;
        values[valuesById[16] = "OpVerifyUser"] = 16;
        values[valuesById[17] = "OpGetMetaFromPath"] = 17;
        values[valuesById[19] = "OpFileLock"] = 19;
        values[valuesById[20] = "OpFileUnlock"] = 20;
        values[valuesById[21] = "OpGetChunk"] = 21;
        values[valuesById[22] = "OpStartWrite"] = 22;
        values[valuesById[23] = "OpPutChunk"] = 23;
        values[valuesById[24] = "OpFinalizeWrite"] = 24;
        values[valuesById[25] = "OpListFiles"] = 25;
        values[valuesById[26] = "OpRemove"] = 26;
        values[valuesById[27] = "OpCopy"] = 27;
        values[valuesById[28] = "OpMove"] = 28;
        values[valuesById[29] = "OpGetFolder"] = 29;
        values[valuesById[30] = "OpCreateFolder"] = 30;
        values[valuesById[31] = "OpCreateSnapshot"] = 31;
        values[valuesById[32] = "OpVerifyPayment"] = 32;
        values[valuesById[33] = "OpGetSecret"] = 33;
        values[valuesById[34] = "OpAddSecret"] = 34;
        values[valuesById[35] = "OpRemoveSecret"] = 35;
        values[valuesById[36] = "OpUpdateSecret"] = 36;
        values[valuesById[37] = "OpListSecrets"] = 37;
        values[valuesById[87] = "OpQuickListSecrets"] = 87;
        values[valuesById[38] = "OpListSecretSubkeys"] = 38;
        values[valuesById[39] = "OpUndeleteSecret"] = 39;
        values[valuesById[40] = "OpDestroySecret"] = 40;
        values[valuesById[41] = "OpAddRole"] = 41;
        values[valuesById[42] = "OpRemoveRole"] = 42;
        values[valuesById[43] = "OpUpdateRole"] = 43;
        values[valuesById[44] = "OpListRoles"] = 44;
        values[valuesById[81] = "OpGetRole"] = 81;
        values[valuesById[49] = "OpIsOperationAllowed"] = 49;
        values[valuesById[45] = "OpListTeams"] = 45;
        values[valuesById[46] = "OpAddTeam"] = 46;
        values[valuesById[47] = "OpRemoveTeam"] = 47;
        values[valuesById[48] = "OpUpdateTeam"] = 48;
        values[valuesById[80] = "OpGetTeam"] = 80;
        values[valuesById[50] = "OpMoveFile"] = 50;
        values[valuesById[51] = "OpMoveFolder"] = 51;
        values[valuesById[52] = "OpCopyFile"] = 52;
        values[valuesById[53] = "OpCopyFolder"] = 53;
        values[valuesById[82] = "OpRestoreVersion"] = 82;
        values[valuesById[55] = "OpRemoveFile"] = 55;
        values[valuesById[56] = "OpRemoveFolder"] = 56;
        values[valuesById[57] = "OpUntrashFile"] = 57;
        values[valuesById[58] = "OpUntrashFolder"] = 58;
        values[valuesById[59] = "OpUndoStartWrite"] = 59;
        values[valuesById[60] = "OpDetachClonedFolder"] = 60;
        values[valuesById[69] = "OpGetProfileFileMeta"] = 69;
        values[valuesById[62] = "OpRenameFile"] = 62;
        values[valuesById[63] = "OpRenameFolder"] = 63;
        values[valuesById[64] = "OpList"] = 64;
        values[valuesById[65] = "OpAuditLogMessage"] = 65;
        values[valuesById[66] = "OpResetVersion"] = 66;
        values[valuesById[67] = "OpSetUser"] = 67;
        values[valuesById[68] = "OpFinalizeProfileWrite"] = 68;
        values[valuesById[71] = "OpGetUserType"] = 71;
        values[valuesById[72] = "OpGetRandomBytes"] = 72;
        values[valuesById[73] = "OpShare"] = 73;
        values[valuesById[74] = "OpUnshare"] = 74;
        values[valuesById[75] = "OpUpdateShare"] = 75;
        values[valuesById[76] = "OpListShares"] = 76;
        values[valuesById[77] = "OpResetTOTP"] = 77;
        values[valuesById[83] = "OpSetRolesTeamsToUser"] = 83;
        values[valuesById[84] = "OpUpdatePinOps"] = 84;
        values[valuesById[86] = "OpGetRolesAndTeamsOfUser"] = 86;
        values[valuesById[88] = "OpVerifyAuditLogMeta"] = 88;
        values[valuesById[89] = "OpGetAuditLog"] = 89;
        values[valuesById[90] = "OpDeleteAuditLog"] = 90;
        values[valuesById[91] = "OpListPins"] = 91;
        values[valuesById[92] = "OpListQuestions"] = 92;
        values[valuesById[93] = "OpMigrateToStorage"] = 93;
        values[valuesById[94] = "OpVerifyBYOSCreds"] = 94;
        values[valuesById[95] = "OpUpdateStorageCreds"] = 95;
        values[valuesById[96] = "OpRemoveOrganizationUser"] = 96;
        values[valuesById[97] = "OpAddSpace"] = 97;
        values[valuesById[98] = "OpAddUserToSpace"] = 98;
        values[valuesById[99] = "OpRemoveUserFromSpace"] = 99;
        values[valuesById[100] = "OpUpdatePermissionsOfSpace"] = 100;
        values[valuesById[101] = "OpAddObjectToSpace"] = 101;
        values[valuesById[102] = "OpRemoveObjectFromSpace"] = 102;
        values[valuesById[103] = "OpRemoveSpace"] = 103;
        values[valuesById[104] = "OpSendOtpToExternalUser"] = 104;
        values[valuesById[105] = "OpSignInToSpace"] = 105;
        values[valuesById[106] = "OpListSpaces"] = 106;
        values[valuesById[107] = "OpUpdateTags"] = 107;
        values[valuesById[108] = "OpAddComment"] = 108;
        values[valuesById[109] = "OpGetComment"] = 109;
        values[valuesById[110] = "OpListComments"] = 110;
        values[valuesById[111] = "OpRemoveComment"] = 111;
        values[valuesById[112] = "OpUpdateComment"] = 112;
        values[valuesById[113] = "OpGetStorageCreds"] = 113;
        values[valuesById[114] = "OpGetPlan"] = 114;
        values[valuesById[115] = "OpValidateCoupon"] = 115;
        values[valuesById[116] = "OpRemoveVersion"] = 116;
        values[valuesById[117] = "OpGetProfilePictureOfUser"] = 117;
        values[valuesById[118] = "OpEmptyTrash"] = 118;
        values[valuesById[119] = "OpGetThumbnail"] = 119;
        values[valuesById[120] = "OpSetThumbnail"] = 120;
        values[valuesById[121] = "OpYsentinel"] = 121;
        values[valuesById[122] = "OpCreateAlert"] = 122;
        values[valuesById[123] = "OpListAlerts"] = 123;
        values[valuesById[124] = "OpDeleteAlert"] = 124;
        values[valuesById[125] = "OpUpdateAlert"] = 125;
        values[valuesById[126] = "OpBlockUser"] = 126;
        values[valuesById[127] = "OpUnblockUser"] = 127;
        values[valuesById[128] = "UpdateOrganizationSettings"] = 128;
        values[valuesById[129] = "GetOrganizationSettings"] = 129;
        return values;
    })();

    request.Role = (function() {

        /**
         * Properties of a Role.
         * @memberof request
         * @interface IRole
         * @property {string|null} [name] Role name
         * @property {Array.<request.Op>|null} [permissions] Role permissions
         * @property {Uint8Array|null} [uuid] Role uuid
         */

        /**
         * Constructs a new Role.
         * @memberof request
         * @classdesc Represents a Role.
         * @implements IRole
         * @constructor
         * @param {request.IRole=} [properties] Properties to set
         */
        function Role(properties) {
            this.permissions = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Role name.
         * @member {string} name
         * @memberof request.Role
         * @instance
         */
        Role.prototype.name = "";

        /**
         * Role permissions.
         * @member {Array.<request.Op>} permissions
         * @memberof request.Role
         * @instance
         */
        Role.prototype.permissions = $util.emptyArray;

        /**
         * Role uuid.
         * @member {Uint8Array} uuid
         * @memberof request.Role
         * @instance
         */
        Role.prototype.uuid = $util.newBuffer([]);

        /**
         * Creates a new Role instance using the specified properties.
         * @function create
         * @memberof request.Role
         * @static
         * @param {request.IRole=} [properties] Properties to set
         * @returns {request.Role} Role instance
         */
        Role.create = function create(properties) {
            return new Role(properties);
        };

        /**
         * Encodes the specified Role message. Does not implicitly {@link request.Role.verify|verify} messages.
         * @function encode
         * @memberof request.Role
         * @static
         * @param {request.IRole} message Role message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Role.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
            if (message.permissions != null && message.permissions.length) {
                writer.uint32(/* id 3, wireType 2 =*/26).fork();
                for (let i = 0; i < message.permissions.length; ++i)
                    writer.int32(message.permissions[i]);
                writer.ldelim();
            }
            if (message.uuid != null && Object.hasOwnProperty.call(message, "uuid"))
                writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.uuid);
            return writer;
        };

        /**
         * Encodes the specified Role message, length delimited. Does not implicitly {@link request.Role.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.Role
         * @static
         * @param {request.IRole} message Role message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Role.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Role message from the specified reader or buffer.
         * @function decode
         * @memberof request.Role
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.Role} Role
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Role.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.Role();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.name = reader.string();
                        break;
                    }
                case 3: {
                        if (!(message.permissions && message.permissions.length))
                            message.permissions = [];
                        if ((tag & 7) === 2) {
                            let end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.permissions.push(reader.int32());
                        } else
                            message.permissions.push(reader.int32());
                        break;
                    }
                case 4: {
                        message.uuid = reader.bytes();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Role message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.Role
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.Role} Role
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Role.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Role message.
         * @function verify
         * @memberof request.Role
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Role.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.permissions != null && message.hasOwnProperty("permissions")) {
                if (!Array.isArray(message.permissions))
                    return "permissions: array expected";
                for (let i = 0; i < message.permissions.length; ++i)
                    switch (message.permissions[i]) {
                    default:
                        return "permissions: enum value[] expected";
                    case 0:
                    case 2:
                    case 3:
                    case 4:
                    case 6:
                    case 9:
                    case 10:
                    case 11:
                    case 12:
                    case 13:
                    case 14:
                    case 15:
                    case 54:
                    case 16:
                    case 17:
                    case 19:
                    case 20:
                    case 21:
                    case 22:
                    case 23:
                    case 24:
                    case 25:
                    case 26:
                    case 27:
                    case 28:
                    case 29:
                    case 30:
                    case 31:
                    case 32:
                    case 33:
                    case 34:
                    case 35:
                    case 36:
                    case 37:
                    case 87:
                    case 38:
                    case 39:
                    case 40:
                    case 41:
                    case 42:
                    case 43:
                    case 44:
                    case 81:
                    case 49:
                    case 45:
                    case 46:
                    case 47:
                    case 48:
                    case 80:
                    case 50:
                    case 51:
                    case 52:
                    case 53:
                    case 82:
                    case 55:
                    case 56:
                    case 57:
                    case 58:
                    case 59:
                    case 60:
                    case 69:
                    case 62:
                    case 63:
                    case 64:
                    case 65:
                    case 66:
                    case 67:
                    case 68:
                    case 71:
                    case 72:
                    case 73:
                    case 74:
                    case 75:
                    case 76:
                    case 77:
                    case 83:
                    case 84:
                    case 86:
                    case 88:
                    case 89:
                    case 90:
                    case 91:
                    case 92:
                    case 93:
                    case 94:
                    case 95:
                    case 96:
                    case 97:
                    case 98:
                    case 99:
                    case 100:
                    case 101:
                    case 102:
                    case 103:
                    case 104:
                    case 105:
                    case 106:
                    case 107:
                    case 108:
                    case 109:
                    case 110:
                    case 111:
                    case 112:
                    case 113:
                    case 114:
                    case 115:
                    case 116:
                    case 117:
                    case 118:
                    case 119:
                    case 120:
                    case 121:
                    case 122:
                    case 123:
                    case 124:
                    case 125:
                    case 126:
                    case 127:
                    case 128:
                    case 129:
                        break;
                    }
            }
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                if (!(message.uuid && typeof message.uuid.length === "number" || $util.isString(message.uuid)))
                    return "uuid: buffer expected";
            return null;
        };

        /**
         * Creates a Role message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.Role
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.Role} Role
         */
        Role.fromObject = function fromObject(object) {
            if (object instanceof $root.request.Role)
                return object;
            let message = new $root.request.Role();
            if (object.name != null)
                message.name = String(object.name);
            if (object.permissions) {
                if (!Array.isArray(object.permissions))
                    throw TypeError(".request.Role.permissions: array expected");
                message.permissions = [];
                for (let i = 0; i < object.permissions.length; ++i)
                    switch (object.permissions[i]) {
                    default:
                        if (typeof object.permissions[i] === "number") {
                            message.permissions[i] = object.permissions[i];
                            break;
                        }
                    case "OpAddUser":
                    case 0:
                        message.permissions[i] = 0;
                        break;
                    case "OpRemoveUser":
                    case 2:
                        message.permissions[i] = 2;
                        break;
                    case "OpPasswordReset":
                    case 3:
                        message.permissions[i] = 3;
                        break;
                    case "OpChangePassword":
                    case 4:
                        message.permissions[i] = 4;
                        break;
                    case "OpInitiatePayment":
                    case 6:
                        message.permissions[i] = 6;
                        break;
                    case "OpInviteUser":
                    case 9:
                        message.permissions[i] = 9;
                        break;
                    case "OpGetUser":
                    case 10:
                        message.permissions[i] = 10;
                        break;
                    case "OpListUsers":
                    case 11:
                        message.permissions[i] = 11;
                        break;
                    case "OpRemoveOrganization":
                    case 12:
                        message.permissions[i] = 12;
                        break;
                    case "OpVerifyOrganization":
                    case 13:
                        message.permissions[i] = 13;
                        break;
                    case "OpGetOrganization":
                    case 14:
                        message.permissions[i] = 14;
                        break;
                    case "OpAddPin":
                    case 15:
                        message.permissions[i] = 15;
                        break;
                    case "OPDeletePin":
                    case 54:
                        message.permissions[i] = 54;
                        break;
                    case "OpVerifyUser":
                    case 16:
                        message.permissions[i] = 16;
                        break;
                    case "OpGetMetaFromPath":
                    case 17:
                        message.permissions[i] = 17;
                        break;
                    case "OpFileLock":
                    case 19:
                        message.permissions[i] = 19;
                        break;
                    case "OpFileUnlock":
                    case 20:
                        message.permissions[i] = 20;
                        break;
                    case "OpGetChunk":
                    case 21:
                        message.permissions[i] = 21;
                        break;
                    case "OpStartWrite":
                    case 22:
                        message.permissions[i] = 22;
                        break;
                    case "OpPutChunk":
                    case 23:
                        message.permissions[i] = 23;
                        break;
                    case "OpFinalizeWrite":
                    case 24:
                        message.permissions[i] = 24;
                        break;
                    case "OpListFiles":
                    case 25:
                        message.permissions[i] = 25;
                        break;
                    case "OpRemove":
                    case 26:
                        message.permissions[i] = 26;
                        break;
                    case "OpCopy":
                    case 27:
                        message.permissions[i] = 27;
                        break;
                    case "OpMove":
                    case 28:
                        message.permissions[i] = 28;
                        break;
                    case "OpGetFolder":
                    case 29:
                        message.permissions[i] = 29;
                        break;
                    case "OpCreateFolder":
                    case 30:
                        message.permissions[i] = 30;
                        break;
                    case "OpCreateSnapshot":
                    case 31:
                        message.permissions[i] = 31;
                        break;
                    case "OpVerifyPayment":
                    case 32:
                        message.permissions[i] = 32;
                        break;
                    case "OpGetSecret":
                    case 33:
                        message.permissions[i] = 33;
                        break;
                    case "OpAddSecret":
                    case 34:
                        message.permissions[i] = 34;
                        break;
                    case "OpRemoveSecret":
                    case 35:
                        message.permissions[i] = 35;
                        break;
                    case "OpUpdateSecret":
                    case 36:
                        message.permissions[i] = 36;
                        break;
                    case "OpListSecrets":
                    case 37:
                        message.permissions[i] = 37;
                        break;
                    case "OpQuickListSecrets":
                    case 87:
                        message.permissions[i] = 87;
                        break;
                    case "OpListSecretSubkeys":
                    case 38:
                        message.permissions[i] = 38;
                        break;
                    case "OpUndeleteSecret":
                    case 39:
                        message.permissions[i] = 39;
                        break;
                    case "OpDestroySecret":
                    case 40:
                        message.permissions[i] = 40;
                        break;
                    case "OpAddRole":
                    case 41:
                        message.permissions[i] = 41;
                        break;
                    case "OpRemoveRole":
                    case 42:
                        message.permissions[i] = 42;
                        break;
                    case "OpUpdateRole":
                    case 43:
                        message.permissions[i] = 43;
                        break;
                    case "OpListRoles":
                    case 44:
                        message.permissions[i] = 44;
                        break;
                    case "OpGetRole":
                    case 81:
                        message.permissions[i] = 81;
                        break;
                    case "OpIsOperationAllowed":
                    case 49:
                        message.permissions[i] = 49;
                        break;
                    case "OpListTeams":
                    case 45:
                        message.permissions[i] = 45;
                        break;
                    case "OpAddTeam":
                    case 46:
                        message.permissions[i] = 46;
                        break;
                    case "OpRemoveTeam":
                    case 47:
                        message.permissions[i] = 47;
                        break;
                    case "OpUpdateTeam":
                    case 48:
                        message.permissions[i] = 48;
                        break;
                    case "OpGetTeam":
                    case 80:
                        message.permissions[i] = 80;
                        break;
                    case "OpMoveFile":
                    case 50:
                        message.permissions[i] = 50;
                        break;
                    case "OpMoveFolder":
                    case 51:
                        message.permissions[i] = 51;
                        break;
                    case "OpCopyFile":
                    case 52:
                        message.permissions[i] = 52;
                        break;
                    case "OpCopyFolder":
                    case 53:
                        message.permissions[i] = 53;
                        break;
                    case "OpRestoreVersion":
                    case 82:
                        message.permissions[i] = 82;
                        break;
                    case "OpRemoveFile":
                    case 55:
                        message.permissions[i] = 55;
                        break;
                    case "OpRemoveFolder":
                    case 56:
                        message.permissions[i] = 56;
                        break;
                    case "OpUntrashFile":
                    case 57:
                        message.permissions[i] = 57;
                        break;
                    case "OpUntrashFolder":
                    case 58:
                        message.permissions[i] = 58;
                        break;
                    case "OpUndoStartWrite":
                    case 59:
                        message.permissions[i] = 59;
                        break;
                    case "OpDetachClonedFolder":
                    case 60:
                        message.permissions[i] = 60;
                        break;
                    case "OpGetProfileFileMeta":
                    case 69:
                        message.permissions[i] = 69;
                        break;
                    case "OpRenameFile":
                    case 62:
                        message.permissions[i] = 62;
                        break;
                    case "OpRenameFolder":
                    case 63:
                        message.permissions[i] = 63;
                        break;
                    case "OpList":
                    case 64:
                        message.permissions[i] = 64;
                        break;
                    case "OpAuditLogMessage":
                    case 65:
                        message.permissions[i] = 65;
                        break;
                    case "OpResetVersion":
                    case 66:
                        message.permissions[i] = 66;
                        break;
                    case "OpSetUser":
                    case 67:
                        message.permissions[i] = 67;
                        break;
                    case "OpFinalizeProfileWrite":
                    case 68:
                        message.permissions[i] = 68;
                        break;
                    case "OpGetUserType":
                    case 71:
                        message.permissions[i] = 71;
                        break;
                    case "OpGetRandomBytes":
                    case 72:
                        message.permissions[i] = 72;
                        break;
                    case "OpShare":
                    case 73:
                        message.permissions[i] = 73;
                        break;
                    case "OpUnshare":
                    case 74:
                        message.permissions[i] = 74;
                        break;
                    case "OpUpdateShare":
                    case 75:
                        message.permissions[i] = 75;
                        break;
                    case "OpListShares":
                    case 76:
                        message.permissions[i] = 76;
                        break;
                    case "OpResetTOTP":
                    case 77:
                        message.permissions[i] = 77;
                        break;
                    case "OpSetRolesTeamsToUser":
                    case 83:
                        message.permissions[i] = 83;
                        break;
                    case "OpUpdatePinOps":
                    case 84:
                        message.permissions[i] = 84;
                        break;
                    case "OpGetRolesAndTeamsOfUser":
                    case 86:
                        message.permissions[i] = 86;
                        break;
                    case "OpVerifyAuditLogMeta":
                    case 88:
                        message.permissions[i] = 88;
                        break;
                    case "OpGetAuditLog":
                    case 89:
                        message.permissions[i] = 89;
                        break;
                    case "OpDeleteAuditLog":
                    case 90:
                        message.permissions[i] = 90;
                        break;
                    case "OpListPins":
                    case 91:
                        message.permissions[i] = 91;
                        break;
                    case "OpListQuestions":
                    case 92:
                        message.permissions[i] = 92;
                        break;
                    case "OpMigrateToStorage":
                    case 93:
                        message.permissions[i] = 93;
                        break;
                    case "OpVerifyBYOSCreds":
                    case 94:
                        message.permissions[i] = 94;
                        break;
                    case "OpUpdateStorageCreds":
                    case 95:
                        message.permissions[i] = 95;
                        break;
                    case "OpRemoveOrganizationUser":
                    case 96:
                        message.permissions[i] = 96;
                        break;
                    case "OpAddSpace":
                    case 97:
                        message.permissions[i] = 97;
                        break;
                    case "OpAddUserToSpace":
                    case 98:
                        message.permissions[i] = 98;
                        break;
                    case "OpRemoveUserFromSpace":
                    case 99:
                        message.permissions[i] = 99;
                        break;
                    case "OpUpdatePermissionsOfSpace":
                    case 100:
                        message.permissions[i] = 100;
                        break;
                    case "OpAddObjectToSpace":
                    case 101:
                        message.permissions[i] = 101;
                        break;
                    case "OpRemoveObjectFromSpace":
                    case 102:
                        message.permissions[i] = 102;
                        break;
                    case "OpRemoveSpace":
                    case 103:
                        message.permissions[i] = 103;
                        break;
                    case "OpSendOtpToExternalUser":
                    case 104:
                        message.permissions[i] = 104;
                        break;
                    case "OpSignInToSpace":
                    case 105:
                        message.permissions[i] = 105;
                        break;
                    case "OpListSpaces":
                    case 106:
                        message.permissions[i] = 106;
                        break;
                    case "OpUpdateTags":
                    case 107:
                        message.permissions[i] = 107;
                        break;
                    case "OpAddComment":
                    case 108:
                        message.permissions[i] = 108;
                        break;
                    case "OpGetComment":
                    case 109:
                        message.permissions[i] = 109;
                        break;
                    case "OpListComments":
                    case 110:
                        message.permissions[i] = 110;
                        break;
                    case "OpRemoveComment":
                    case 111:
                        message.permissions[i] = 111;
                        break;
                    case "OpUpdateComment":
                    case 112:
                        message.permissions[i] = 112;
                        break;
                    case "OpGetStorageCreds":
                    case 113:
                        message.permissions[i] = 113;
                        break;
                    case "OpGetPlan":
                    case 114:
                        message.permissions[i] = 114;
                        break;
                    case "OpValidateCoupon":
                    case 115:
                        message.permissions[i] = 115;
                        break;
                    case "OpRemoveVersion":
                    case 116:
                        message.permissions[i] = 116;
                        break;
                    case "OpGetProfilePictureOfUser":
                    case 117:
                        message.permissions[i] = 117;
                        break;
                    case "OpEmptyTrash":
                    case 118:
                        message.permissions[i] = 118;
                        break;
                    case "OpGetThumbnail":
                    case 119:
                        message.permissions[i] = 119;
                        break;
                    case "OpSetThumbnail":
                    case 120:
                        message.permissions[i] = 120;
                        break;
                    case "OpYsentinel":
                    case 121:
                        message.permissions[i] = 121;
                        break;
                    case "OpCreateAlert":
                    case 122:
                        message.permissions[i] = 122;
                        break;
                    case "OpListAlerts":
                    case 123:
                        message.permissions[i] = 123;
                        break;
                    case "OpDeleteAlert":
                    case 124:
                        message.permissions[i] = 124;
                        break;
                    case "OpUpdateAlert":
                    case 125:
                        message.permissions[i] = 125;
                        break;
                    case "OpBlockUser":
                    case 126:
                        message.permissions[i] = 126;
                        break;
                    case "OpUnblockUser":
                    case 127:
                        message.permissions[i] = 127;
                        break;
                    case "UpdateOrganizationSettings":
                    case 128:
                        message.permissions[i] = 128;
                        break;
                    case "GetOrganizationSettings":
                    case 129:
                        message.permissions[i] = 129;
                        break;
                    }
            }
            if (object.uuid != null)
                if (typeof object.uuid === "string")
                    $util.base64.decode(object.uuid, message.uuid = $util.newBuffer($util.base64.length(object.uuid)), 0);
                else if (object.uuid.length >= 0)
                    message.uuid = object.uuid;
            return message;
        };

        /**
         * Creates a plain object from a Role message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.Role
         * @static
         * @param {request.Role} message Role
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Role.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.permissions = [];
            if (options.defaults) {
                object.name = "";
                if (options.bytes === String)
                    object.uuid = "";
                else {
                    object.uuid = [];
                    if (options.bytes !== Array)
                        object.uuid = $util.newBuffer(object.uuid);
                }
            }
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.permissions && message.permissions.length) {
                object.permissions = [];
                for (let j = 0; j < message.permissions.length; ++j)
                    object.permissions[j] = options.enums === String ? $root.request.Op[message.permissions[j]] === undefined ? message.permissions[j] : $root.request.Op[message.permissions[j]] : message.permissions[j];
            }
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                object.uuid = options.bytes === String ? $util.base64.encode(message.uuid, 0, message.uuid.length) : options.bytes === Array ? Array.prototype.slice.call(message.uuid) : message.uuid;
            return object;
        };

        /**
         * Converts this Role to JSON.
         * @function toJSON
         * @memberof request.Role
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Role.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Role
         * @function getTypeUrl
         * @memberof request.Role
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Role.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.Role";
        };

        return Role;
    })();

    request.AddRole = (function() {

        /**
         * Properties of an AddRole.
         * @memberof request
         * @interface IAddRole
         * @property {string|null} [name] AddRole name
         * @property {Array.<request.Op>|null} [permissions] AddRole permissions
         */

        /**
         * Constructs a new AddRole.
         * @memberof request
         * @classdesc Represents an AddRole.
         * @implements IAddRole
         * @constructor
         * @param {request.IAddRole=} [properties] Properties to set
         */
        function AddRole(properties) {
            this.permissions = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddRole name.
         * @member {string} name
         * @memberof request.AddRole
         * @instance
         */
        AddRole.prototype.name = "";

        /**
         * AddRole permissions.
         * @member {Array.<request.Op>} permissions
         * @memberof request.AddRole
         * @instance
         */
        AddRole.prototype.permissions = $util.emptyArray;

        /**
         * Creates a new AddRole instance using the specified properties.
         * @function create
         * @memberof request.AddRole
         * @static
         * @param {request.IAddRole=} [properties] Properties to set
         * @returns {request.AddRole} AddRole instance
         */
        AddRole.create = function create(properties) {
            return new AddRole(properties);
        };

        /**
         * Encodes the specified AddRole message. Does not implicitly {@link request.AddRole.verify|verify} messages.
         * @function encode
         * @memberof request.AddRole
         * @static
         * @param {request.IAddRole} message AddRole message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddRole.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
            if (message.permissions != null && message.permissions.length) {
                writer.uint32(/* id 2, wireType 2 =*/18).fork();
                for (let i = 0; i < message.permissions.length; ++i)
                    writer.int32(message.permissions[i]);
                writer.ldelim();
            }
            return writer;
        };

        /**
         * Encodes the specified AddRole message, length delimited. Does not implicitly {@link request.AddRole.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.AddRole
         * @static
         * @param {request.IAddRole} message AddRole message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddRole.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AddRole message from the specified reader or buffer.
         * @function decode
         * @memberof request.AddRole
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.AddRole} AddRole
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddRole.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.AddRole();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.name = reader.string();
                        break;
                    }
                case 2: {
                        if (!(message.permissions && message.permissions.length))
                            message.permissions = [];
                        if ((tag & 7) === 2) {
                            let end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.permissions.push(reader.int32());
                        } else
                            message.permissions.push(reader.int32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AddRole message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.AddRole
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.AddRole} AddRole
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddRole.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AddRole message.
         * @function verify
         * @memberof request.AddRole
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AddRole.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.permissions != null && message.hasOwnProperty("permissions")) {
                if (!Array.isArray(message.permissions))
                    return "permissions: array expected";
                for (let i = 0; i < message.permissions.length; ++i)
                    switch (message.permissions[i]) {
                    default:
                        return "permissions: enum value[] expected";
                    case 0:
                    case 2:
                    case 3:
                    case 4:
                    case 6:
                    case 9:
                    case 10:
                    case 11:
                    case 12:
                    case 13:
                    case 14:
                    case 15:
                    case 54:
                    case 16:
                    case 17:
                    case 19:
                    case 20:
                    case 21:
                    case 22:
                    case 23:
                    case 24:
                    case 25:
                    case 26:
                    case 27:
                    case 28:
                    case 29:
                    case 30:
                    case 31:
                    case 32:
                    case 33:
                    case 34:
                    case 35:
                    case 36:
                    case 37:
                    case 87:
                    case 38:
                    case 39:
                    case 40:
                    case 41:
                    case 42:
                    case 43:
                    case 44:
                    case 81:
                    case 49:
                    case 45:
                    case 46:
                    case 47:
                    case 48:
                    case 80:
                    case 50:
                    case 51:
                    case 52:
                    case 53:
                    case 82:
                    case 55:
                    case 56:
                    case 57:
                    case 58:
                    case 59:
                    case 60:
                    case 69:
                    case 62:
                    case 63:
                    case 64:
                    case 65:
                    case 66:
                    case 67:
                    case 68:
                    case 71:
                    case 72:
                    case 73:
                    case 74:
                    case 75:
                    case 76:
                    case 77:
                    case 83:
                    case 84:
                    case 86:
                    case 88:
                    case 89:
                    case 90:
                    case 91:
                    case 92:
                    case 93:
                    case 94:
                    case 95:
                    case 96:
                    case 97:
                    case 98:
                    case 99:
                    case 100:
                    case 101:
                    case 102:
                    case 103:
                    case 104:
                    case 105:
                    case 106:
                    case 107:
                    case 108:
                    case 109:
                    case 110:
                    case 111:
                    case 112:
                    case 113:
                    case 114:
                    case 115:
                    case 116:
                    case 117:
                    case 118:
                    case 119:
                    case 120:
                    case 121:
                    case 122:
                    case 123:
                    case 124:
                    case 125:
                    case 126:
                    case 127:
                    case 128:
                    case 129:
                        break;
                    }
            }
            return null;
        };

        /**
         * Creates an AddRole message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.AddRole
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.AddRole} AddRole
         */
        AddRole.fromObject = function fromObject(object) {
            if (object instanceof $root.request.AddRole)
                return object;
            let message = new $root.request.AddRole();
            if (object.name != null)
                message.name = String(object.name);
            if (object.permissions) {
                if (!Array.isArray(object.permissions))
                    throw TypeError(".request.AddRole.permissions: array expected");
                message.permissions = [];
                for (let i = 0; i < object.permissions.length; ++i)
                    switch (object.permissions[i]) {
                    default:
                        if (typeof object.permissions[i] === "number") {
                            message.permissions[i] = object.permissions[i];
                            break;
                        }
                    case "OpAddUser":
                    case 0:
                        message.permissions[i] = 0;
                        break;
                    case "OpRemoveUser":
                    case 2:
                        message.permissions[i] = 2;
                        break;
                    case "OpPasswordReset":
                    case 3:
                        message.permissions[i] = 3;
                        break;
                    case "OpChangePassword":
                    case 4:
                        message.permissions[i] = 4;
                        break;
                    case "OpInitiatePayment":
                    case 6:
                        message.permissions[i] = 6;
                        break;
                    case "OpInviteUser":
                    case 9:
                        message.permissions[i] = 9;
                        break;
                    case "OpGetUser":
                    case 10:
                        message.permissions[i] = 10;
                        break;
                    case "OpListUsers":
                    case 11:
                        message.permissions[i] = 11;
                        break;
                    case "OpRemoveOrganization":
                    case 12:
                        message.permissions[i] = 12;
                        break;
                    case "OpVerifyOrganization":
                    case 13:
                        message.permissions[i] = 13;
                        break;
                    case "OpGetOrganization":
                    case 14:
                        message.permissions[i] = 14;
                        break;
                    case "OpAddPin":
                    case 15:
                        message.permissions[i] = 15;
                        break;
                    case "OPDeletePin":
                    case 54:
                        message.permissions[i] = 54;
                        break;
                    case "OpVerifyUser":
                    case 16:
                        message.permissions[i] = 16;
                        break;
                    case "OpGetMetaFromPath":
                    case 17:
                        message.permissions[i] = 17;
                        break;
                    case "OpFileLock":
                    case 19:
                        message.permissions[i] = 19;
                        break;
                    case "OpFileUnlock":
                    case 20:
                        message.permissions[i] = 20;
                        break;
                    case "OpGetChunk":
                    case 21:
                        message.permissions[i] = 21;
                        break;
                    case "OpStartWrite":
                    case 22:
                        message.permissions[i] = 22;
                        break;
                    case "OpPutChunk":
                    case 23:
                        message.permissions[i] = 23;
                        break;
                    case "OpFinalizeWrite":
                    case 24:
                        message.permissions[i] = 24;
                        break;
                    case "OpListFiles":
                    case 25:
                        message.permissions[i] = 25;
                        break;
                    case "OpRemove":
                    case 26:
                        message.permissions[i] = 26;
                        break;
                    case "OpCopy":
                    case 27:
                        message.permissions[i] = 27;
                        break;
                    case "OpMove":
                    case 28:
                        message.permissions[i] = 28;
                        break;
                    case "OpGetFolder":
                    case 29:
                        message.permissions[i] = 29;
                        break;
                    case "OpCreateFolder":
                    case 30:
                        message.permissions[i] = 30;
                        break;
                    case "OpCreateSnapshot":
                    case 31:
                        message.permissions[i] = 31;
                        break;
                    case "OpVerifyPayment":
                    case 32:
                        message.permissions[i] = 32;
                        break;
                    case "OpGetSecret":
                    case 33:
                        message.permissions[i] = 33;
                        break;
                    case "OpAddSecret":
                    case 34:
                        message.permissions[i] = 34;
                        break;
                    case "OpRemoveSecret":
                    case 35:
                        message.permissions[i] = 35;
                        break;
                    case "OpUpdateSecret":
                    case 36:
                        message.permissions[i] = 36;
                        break;
                    case "OpListSecrets":
                    case 37:
                        message.permissions[i] = 37;
                        break;
                    case "OpQuickListSecrets":
                    case 87:
                        message.permissions[i] = 87;
                        break;
                    case "OpListSecretSubkeys":
                    case 38:
                        message.permissions[i] = 38;
                        break;
                    case "OpUndeleteSecret":
                    case 39:
                        message.permissions[i] = 39;
                        break;
                    case "OpDestroySecret":
                    case 40:
                        message.permissions[i] = 40;
                        break;
                    case "OpAddRole":
                    case 41:
                        message.permissions[i] = 41;
                        break;
                    case "OpRemoveRole":
                    case 42:
                        message.permissions[i] = 42;
                        break;
                    case "OpUpdateRole":
                    case 43:
                        message.permissions[i] = 43;
                        break;
                    case "OpListRoles":
                    case 44:
                        message.permissions[i] = 44;
                        break;
                    case "OpGetRole":
                    case 81:
                        message.permissions[i] = 81;
                        break;
                    case "OpIsOperationAllowed":
                    case 49:
                        message.permissions[i] = 49;
                        break;
                    case "OpListTeams":
                    case 45:
                        message.permissions[i] = 45;
                        break;
                    case "OpAddTeam":
                    case 46:
                        message.permissions[i] = 46;
                        break;
                    case "OpRemoveTeam":
                    case 47:
                        message.permissions[i] = 47;
                        break;
                    case "OpUpdateTeam":
                    case 48:
                        message.permissions[i] = 48;
                        break;
                    case "OpGetTeam":
                    case 80:
                        message.permissions[i] = 80;
                        break;
                    case "OpMoveFile":
                    case 50:
                        message.permissions[i] = 50;
                        break;
                    case "OpMoveFolder":
                    case 51:
                        message.permissions[i] = 51;
                        break;
                    case "OpCopyFile":
                    case 52:
                        message.permissions[i] = 52;
                        break;
                    case "OpCopyFolder":
                    case 53:
                        message.permissions[i] = 53;
                        break;
                    case "OpRestoreVersion":
                    case 82:
                        message.permissions[i] = 82;
                        break;
                    case "OpRemoveFile":
                    case 55:
                        message.permissions[i] = 55;
                        break;
                    case "OpRemoveFolder":
                    case 56:
                        message.permissions[i] = 56;
                        break;
                    case "OpUntrashFile":
                    case 57:
                        message.permissions[i] = 57;
                        break;
                    case "OpUntrashFolder":
                    case 58:
                        message.permissions[i] = 58;
                        break;
                    case "OpUndoStartWrite":
                    case 59:
                        message.permissions[i] = 59;
                        break;
                    case "OpDetachClonedFolder":
                    case 60:
                        message.permissions[i] = 60;
                        break;
                    case "OpGetProfileFileMeta":
                    case 69:
                        message.permissions[i] = 69;
                        break;
                    case "OpRenameFile":
                    case 62:
                        message.permissions[i] = 62;
                        break;
                    case "OpRenameFolder":
                    case 63:
                        message.permissions[i] = 63;
                        break;
                    case "OpList":
                    case 64:
                        message.permissions[i] = 64;
                        break;
                    case "OpAuditLogMessage":
                    case 65:
                        message.permissions[i] = 65;
                        break;
                    case "OpResetVersion":
                    case 66:
                        message.permissions[i] = 66;
                        break;
                    case "OpSetUser":
                    case 67:
                        message.permissions[i] = 67;
                        break;
                    case "OpFinalizeProfileWrite":
                    case 68:
                        message.permissions[i] = 68;
                        break;
                    case "OpGetUserType":
                    case 71:
                        message.permissions[i] = 71;
                        break;
                    case "OpGetRandomBytes":
                    case 72:
                        message.permissions[i] = 72;
                        break;
                    case "OpShare":
                    case 73:
                        message.permissions[i] = 73;
                        break;
                    case "OpUnshare":
                    case 74:
                        message.permissions[i] = 74;
                        break;
                    case "OpUpdateShare":
                    case 75:
                        message.permissions[i] = 75;
                        break;
                    case "OpListShares":
                    case 76:
                        message.permissions[i] = 76;
                        break;
                    case "OpResetTOTP":
                    case 77:
                        message.permissions[i] = 77;
                        break;
                    case "OpSetRolesTeamsToUser":
                    case 83:
                        message.permissions[i] = 83;
                        break;
                    case "OpUpdatePinOps":
                    case 84:
                        message.permissions[i] = 84;
                        break;
                    case "OpGetRolesAndTeamsOfUser":
                    case 86:
                        message.permissions[i] = 86;
                        break;
                    case "OpVerifyAuditLogMeta":
                    case 88:
                        message.permissions[i] = 88;
                        break;
                    case "OpGetAuditLog":
                    case 89:
                        message.permissions[i] = 89;
                        break;
                    case "OpDeleteAuditLog":
                    case 90:
                        message.permissions[i] = 90;
                        break;
                    case "OpListPins":
                    case 91:
                        message.permissions[i] = 91;
                        break;
                    case "OpListQuestions":
                    case 92:
                        message.permissions[i] = 92;
                        break;
                    case "OpMigrateToStorage":
                    case 93:
                        message.permissions[i] = 93;
                        break;
                    case "OpVerifyBYOSCreds":
                    case 94:
                        message.permissions[i] = 94;
                        break;
                    case "OpUpdateStorageCreds":
                    case 95:
                        message.permissions[i] = 95;
                        break;
                    case "OpRemoveOrganizationUser":
                    case 96:
                        message.permissions[i] = 96;
                        break;
                    case "OpAddSpace":
                    case 97:
                        message.permissions[i] = 97;
                        break;
                    case "OpAddUserToSpace":
                    case 98:
                        message.permissions[i] = 98;
                        break;
                    case "OpRemoveUserFromSpace":
                    case 99:
                        message.permissions[i] = 99;
                        break;
                    case "OpUpdatePermissionsOfSpace":
                    case 100:
                        message.permissions[i] = 100;
                        break;
                    case "OpAddObjectToSpace":
                    case 101:
                        message.permissions[i] = 101;
                        break;
                    case "OpRemoveObjectFromSpace":
                    case 102:
                        message.permissions[i] = 102;
                        break;
                    case "OpRemoveSpace":
                    case 103:
                        message.permissions[i] = 103;
                        break;
                    case "OpSendOtpToExternalUser":
                    case 104:
                        message.permissions[i] = 104;
                        break;
                    case "OpSignInToSpace":
                    case 105:
                        message.permissions[i] = 105;
                        break;
                    case "OpListSpaces":
                    case 106:
                        message.permissions[i] = 106;
                        break;
                    case "OpUpdateTags":
                    case 107:
                        message.permissions[i] = 107;
                        break;
                    case "OpAddComment":
                    case 108:
                        message.permissions[i] = 108;
                        break;
                    case "OpGetComment":
                    case 109:
                        message.permissions[i] = 109;
                        break;
                    case "OpListComments":
                    case 110:
                        message.permissions[i] = 110;
                        break;
                    case "OpRemoveComment":
                    case 111:
                        message.permissions[i] = 111;
                        break;
                    case "OpUpdateComment":
                    case 112:
                        message.permissions[i] = 112;
                        break;
                    case "OpGetStorageCreds":
                    case 113:
                        message.permissions[i] = 113;
                        break;
                    case "OpGetPlan":
                    case 114:
                        message.permissions[i] = 114;
                        break;
                    case "OpValidateCoupon":
                    case 115:
                        message.permissions[i] = 115;
                        break;
                    case "OpRemoveVersion":
                    case 116:
                        message.permissions[i] = 116;
                        break;
                    case "OpGetProfilePictureOfUser":
                    case 117:
                        message.permissions[i] = 117;
                        break;
                    case "OpEmptyTrash":
                    case 118:
                        message.permissions[i] = 118;
                        break;
                    case "OpGetThumbnail":
                    case 119:
                        message.permissions[i] = 119;
                        break;
                    case "OpSetThumbnail":
                    case 120:
                        message.permissions[i] = 120;
                        break;
                    case "OpYsentinel":
                    case 121:
                        message.permissions[i] = 121;
                        break;
                    case "OpCreateAlert":
                    case 122:
                        message.permissions[i] = 122;
                        break;
                    case "OpListAlerts":
                    case 123:
                        message.permissions[i] = 123;
                        break;
                    case "OpDeleteAlert":
                    case 124:
                        message.permissions[i] = 124;
                        break;
                    case "OpUpdateAlert":
                    case 125:
                        message.permissions[i] = 125;
                        break;
                    case "OpBlockUser":
                    case 126:
                        message.permissions[i] = 126;
                        break;
                    case "OpUnblockUser":
                    case 127:
                        message.permissions[i] = 127;
                        break;
                    case "UpdateOrganizationSettings":
                    case 128:
                        message.permissions[i] = 128;
                        break;
                    case "GetOrganizationSettings":
                    case 129:
                        message.permissions[i] = 129;
                        break;
                    }
            }
            return message;
        };

        /**
         * Creates a plain object from an AddRole message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.AddRole
         * @static
         * @param {request.AddRole} message AddRole
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddRole.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.permissions = [];
            if (options.defaults)
                object.name = "";
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.permissions && message.permissions.length) {
                object.permissions = [];
                for (let j = 0; j < message.permissions.length; ++j)
                    object.permissions[j] = options.enums === String ? $root.request.Op[message.permissions[j]] === undefined ? message.permissions[j] : $root.request.Op[message.permissions[j]] : message.permissions[j];
            }
            return object;
        };

        /**
         * Converts this AddRole to JSON.
         * @function toJSON
         * @memberof request.AddRole
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddRole.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for AddRole
         * @function getTypeUrl
         * @memberof request.AddRole
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        AddRole.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.AddRole";
        };

        return AddRole;
    })();

    request.RemoveRole = (function() {

        /**
         * Properties of a RemoveRole.
         * @memberof request
         * @interface IRemoveRole
         * @property {string|null} [name] RemoveRole name
         */

        /**
         * Constructs a new RemoveRole.
         * @memberof request
         * @classdesc Represents a RemoveRole.
         * @implements IRemoveRole
         * @constructor
         * @param {request.IRemoveRole=} [properties] Properties to set
         */
        function RemoveRole(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveRole name.
         * @member {string} name
         * @memberof request.RemoveRole
         * @instance
         */
        RemoveRole.prototype.name = "";

        /**
         * Creates a new RemoveRole instance using the specified properties.
         * @function create
         * @memberof request.RemoveRole
         * @static
         * @param {request.IRemoveRole=} [properties] Properties to set
         * @returns {request.RemoveRole} RemoveRole instance
         */
        RemoveRole.create = function create(properties) {
            return new RemoveRole(properties);
        };

        /**
         * Encodes the specified RemoveRole message. Does not implicitly {@link request.RemoveRole.verify|verify} messages.
         * @function encode
         * @memberof request.RemoveRole
         * @static
         * @param {request.IRemoveRole} message RemoveRole message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RemoveRole.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
            return writer;
        };

        /**
         * Encodes the specified RemoveRole message, length delimited. Does not implicitly {@link request.RemoveRole.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.RemoveRole
         * @static
         * @param {request.IRemoveRole} message RemoveRole message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RemoveRole.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RemoveRole message from the specified reader or buffer.
         * @function decode
         * @memberof request.RemoveRole
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.RemoveRole} RemoveRole
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RemoveRole.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.RemoveRole();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.name = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RemoveRole message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.RemoveRole
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.RemoveRole} RemoveRole
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RemoveRole.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RemoveRole message.
         * @function verify
         * @memberof request.RemoveRole
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RemoveRole.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            return null;
        };

        /**
         * Creates a RemoveRole message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.RemoveRole
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.RemoveRole} RemoveRole
         */
        RemoveRole.fromObject = function fromObject(object) {
            if (object instanceof $root.request.RemoveRole)
                return object;
            let message = new $root.request.RemoveRole();
            if (object.name != null)
                message.name = String(object.name);
            return message;
        };

        /**
         * Creates a plain object from a RemoveRole message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.RemoveRole
         * @static
         * @param {request.RemoveRole} message RemoveRole
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveRole.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.name = "";
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            return object;
        };

        /**
         * Converts this RemoveRole to JSON.
         * @function toJSON
         * @memberof request.RemoveRole
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveRole.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for RemoveRole
         * @function getTypeUrl
         * @memberof request.RemoveRole
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        RemoveRole.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.RemoveRole";
        };

        return RemoveRole;
    })();

    request.UpdateRole = (function() {

        /**
         * Properties of an UpdateRole.
         * @memberof request
         * @interface IUpdateRole
         * @property {string|null} [name] UpdateRole name
         * @property {Array.<request.Op>|null} [permissions] UpdateRole permissions
         */

        /**
         * Constructs a new UpdateRole.
         * @memberof request
         * @classdesc Represents an UpdateRole.
         * @implements IUpdateRole
         * @constructor
         * @param {request.IUpdateRole=} [properties] Properties to set
         */
        function UpdateRole(properties) {
            this.permissions = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateRole name.
         * @member {string} name
         * @memberof request.UpdateRole
         * @instance
         */
        UpdateRole.prototype.name = "";

        /**
         * UpdateRole permissions.
         * @member {Array.<request.Op>} permissions
         * @memberof request.UpdateRole
         * @instance
         */
        UpdateRole.prototype.permissions = $util.emptyArray;

        /**
         * Creates a new UpdateRole instance using the specified properties.
         * @function create
         * @memberof request.UpdateRole
         * @static
         * @param {request.IUpdateRole=} [properties] Properties to set
         * @returns {request.UpdateRole} UpdateRole instance
         */
        UpdateRole.create = function create(properties) {
            return new UpdateRole(properties);
        };

        /**
         * Encodes the specified UpdateRole message. Does not implicitly {@link request.UpdateRole.verify|verify} messages.
         * @function encode
         * @memberof request.UpdateRole
         * @static
         * @param {request.IUpdateRole} message UpdateRole message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateRole.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
            if (message.permissions != null && message.permissions.length) {
                writer.uint32(/* id 2, wireType 2 =*/18).fork();
                for (let i = 0; i < message.permissions.length; ++i)
                    writer.int32(message.permissions[i]);
                writer.ldelim();
            }
            return writer;
        };

        /**
         * Encodes the specified UpdateRole message, length delimited. Does not implicitly {@link request.UpdateRole.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.UpdateRole
         * @static
         * @param {request.IUpdateRole} message UpdateRole message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateRole.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UpdateRole message from the specified reader or buffer.
         * @function decode
         * @memberof request.UpdateRole
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.UpdateRole} UpdateRole
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateRole.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.UpdateRole();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.name = reader.string();
                        break;
                    }
                case 2: {
                        if (!(message.permissions && message.permissions.length))
                            message.permissions = [];
                        if ((tag & 7) === 2) {
                            let end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.permissions.push(reader.int32());
                        } else
                            message.permissions.push(reader.int32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UpdateRole message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.UpdateRole
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.UpdateRole} UpdateRole
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateRole.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UpdateRole message.
         * @function verify
         * @memberof request.UpdateRole
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UpdateRole.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.permissions != null && message.hasOwnProperty("permissions")) {
                if (!Array.isArray(message.permissions))
                    return "permissions: array expected";
                for (let i = 0; i < message.permissions.length; ++i)
                    switch (message.permissions[i]) {
                    default:
                        return "permissions: enum value[] expected";
                    case 0:
                    case 2:
                    case 3:
                    case 4:
                    case 6:
                    case 9:
                    case 10:
                    case 11:
                    case 12:
                    case 13:
                    case 14:
                    case 15:
                    case 54:
                    case 16:
                    case 17:
                    case 19:
                    case 20:
                    case 21:
                    case 22:
                    case 23:
                    case 24:
                    case 25:
                    case 26:
                    case 27:
                    case 28:
                    case 29:
                    case 30:
                    case 31:
                    case 32:
                    case 33:
                    case 34:
                    case 35:
                    case 36:
                    case 37:
                    case 87:
                    case 38:
                    case 39:
                    case 40:
                    case 41:
                    case 42:
                    case 43:
                    case 44:
                    case 81:
                    case 49:
                    case 45:
                    case 46:
                    case 47:
                    case 48:
                    case 80:
                    case 50:
                    case 51:
                    case 52:
                    case 53:
                    case 82:
                    case 55:
                    case 56:
                    case 57:
                    case 58:
                    case 59:
                    case 60:
                    case 69:
                    case 62:
                    case 63:
                    case 64:
                    case 65:
                    case 66:
                    case 67:
                    case 68:
                    case 71:
                    case 72:
                    case 73:
                    case 74:
                    case 75:
                    case 76:
                    case 77:
                    case 83:
                    case 84:
                    case 86:
                    case 88:
                    case 89:
                    case 90:
                    case 91:
                    case 92:
                    case 93:
                    case 94:
                    case 95:
                    case 96:
                    case 97:
                    case 98:
                    case 99:
                    case 100:
                    case 101:
                    case 102:
                    case 103:
                    case 104:
                    case 105:
                    case 106:
                    case 107:
                    case 108:
                    case 109:
                    case 110:
                    case 111:
                    case 112:
                    case 113:
                    case 114:
                    case 115:
                    case 116:
                    case 117:
                    case 118:
                    case 119:
                    case 120:
                    case 121:
                    case 122:
                    case 123:
                    case 124:
                    case 125:
                    case 126:
                    case 127:
                    case 128:
                    case 129:
                        break;
                    }
            }
            return null;
        };

        /**
         * Creates an UpdateRole message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.UpdateRole
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.UpdateRole} UpdateRole
         */
        UpdateRole.fromObject = function fromObject(object) {
            if (object instanceof $root.request.UpdateRole)
                return object;
            let message = new $root.request.UpdateRole();
            if (object.name != null)
                message.name = String(object.name);
            if (object.permissions) {
                if (!Array.isArray(object.permissions))
                    throw TypeError(".request.UpdateRole.permissions: array expected");
                message.permissions = [];
                for (let i = 0; i < object.permissions.length; ++i)
                    switch (object.permissions[i]) {
                    default:
                        if (typeof object.permissions[i] === "number") {
                            message.permissions[i] = object.permissions[i];
                            break;
                        }
                    case "OpAddUser":
                    case 0:
                        message.permissions[i] = 0;
                        break;
                    case "OpRemoveUser":
                    case 2:
                        message.permissions[i] = 2;
                        break;
                    case "OpPasswordReset":
                    case 3:
                        message.permissions[i] = 3;
                        break;
                    case "OpChangePassword":
                    case 4:
                        message.permissions[i] = 4;
                        break;
                    case "OpInitiatePayment":
                    case 6:
                        message.permissions[i] = 6;
                        break;
                    case "OpInviteUser":
                    case 9:
                        message.permissions[i] = 9;
                        break;
                    case "OpGetUser":
                    case 10:
                        message.permissions[i] = 10;
                        break;
                    case "OpListUsers":
                    case 11:
                        message.permissions[i] = 11;
                        break;
                    case "OpRemoveOrganization":
                    case 12:
                        message.permissions[i] = 12;
                        break;
                    case "OpVerifyOrganization":
                    case 13:
                        message.permissions[i] = 13;
                        break;
                    case "OpGetOrganization":
                    case 14:
                        message.permissions[i] = 14;
                        break;
                    case "OpAddPin":
                    case 15:
                        message.permissions[i] = 15;
                        break;
                    case "OPDeletePin":
                    case 54:
                        message.permissions[i] = 54;
                        break;
                    case "OpVerifyUser":
                    case 16:
                        message.permissions[i] = 16;
                        break;
                    case "OpGetMetaFromPath":
                    case 17:
                        message.permissions[i] = 17;
                        break;
                    case "OpFileLock":
                    case 19:
                        message.permissions[i] = 19;
                        break;
                    case "OpFileUnlock":
                    case 20:
                        message.permissions[i] = 20;
                        break;
                    case "OpGetChunk":
                    case 21:
                        message.permissions[i] = 21;
                        break;
                    case "OpStartWrite":
                    case 22:
                        message.permissions[i] = 22;
                        break;
                    case "OpPutChunk":
                    case 23:
                        message.permissions[i] = 23;
                        break;
                    case "OpFinalizeWrite":
                    case 24:
                        message.permissions[i] = 24;
                        break;
                    case "OpListFiles":
                    case 25:
                        message.permissions[i] = 25;
                        break;
                    case "OpRemove":
                    case 26:
                        message.permissions[i] = 26;
                        break;
                    case "OpCopy":
                    case 27:
                        message.permissions[i] = 27;
                        break;
                    case "OpMove":
                    case 28:
                        message.permissions[i] = 28;
                        break;
                    case "OpGetFolder":
                    case 29:
                        message.permissions[i] = 29;
                        break;
                    case "OpCreateFolder":
                    case 30:
                        message.permissions[i] = 30;
                        break;
                    case "OpCreateSnapshot":
                    case 31:
                        message.permissions[i] = 31;
                        break;
                    case "OpVerifyPayment":
                    case 32:
                        message.permissions[i] = 32;
                        break;
                    case "OpGetSecret":
                    case 33:
                        message.permissions[i] = 33;
                        break;
                    case "OpAddSecret":
                    case 34:
                        message.permissions[i] = 34;
                        break;
                    case "OpRemoveSecret":
                    case 35:
                        message.permissions[i] = 35;
                        break;
                    case "OpUpdateSecret":
                    case 36:
                        message.permissions[i] = 36;
                        break;
                    case "OpListSecrets":
                    case 37:
                        message.permissions[i] = 37;
                        break;
                    case "OpQuickListSecrets":
                    case 87:
                        message.permissions[i] = 87;
                        break;
                    case "OpListSecretSubkeys":
                    case 38:
                        message.permissions[i] = 38;
                        break;
                    case "OpUndeleteSecret":
                    case 39:
                        message.permissions[i] = 39;
                        break;
                    case "OpDestroySecret":
                    case 40:
                        message.permissions[i] = 40;
                        break;
                    case "OpAddRole":
                    case 41:
                        message.permissions[i] = 41;
                        break;
                    case "OpRemoveRole":
                    case 42:
                        message.permissions[i] = 42;
                        break;
                    case "OpUpdateRole":
                    case 43:
                        message.permissions[i] = 43;
                        break;
                    case "OpListRoles":
                    case 44:
                        message.permissions[i] = 44;
                        break;
                    case "OpGetRole":
                    case 81:
                        message.permissions[i] = 81;
                        break;
                    case "OpIsOperationAllowed":
                    case 49:
                        message.permissions[i] = 49;
                        break;
                    case "OpListTeams":
                    case 45:
                        message.permissions[i] = 45;
                        break;
                    case "OpAddTeam":
                    case 46:
                        message.permissions[i] = 46;
                        break;
                    case "OpRemoveTeam":
                    case 47:
                        message.permissions[i] = 47;
                        break;
                    case "OpUpdateTeam":
                    case 48:
                        message.permissions[i] = 48;
                        break;
                    case "OpGetTeam":
                    case 80:
                        message.permissions[i] = 80;
                        break;
                    case "OpMoveFile":
                    case 50:
                        message.permissions[i] = 50;
                        break;
                    case "OpMoveFolder":
                    case 51:
                        message.permissions[i] = 51;
                        break;
                    case "OpCopyFile":
                    case 52:
                        message.permissions[i] = 52;
                        break;
                    case "OpCopyFolder":
                    case 53:
                        message.permissions[i] = 53;
                        break;
                    case "OpRestoreVersion":
                    case 82:
                        message.permissions[i] = 82;
                        break;
                    case "OpRemoveFile":
                    case 55:
                        message.permissions[i] = 55;
                        break;
                    case "OpRemoveFolder":
                    case 56:
                        message.permissions[i] = 56;
                        break;
                    case "OpUntrashFile":
                    case 57:
                        message.permissions[i] = 57;
                        break;
                    case "OpUntrashFolder":
                    case 58:
                        message.permissions[i] = 58;
                        break;
                    case "OpUndoStartWrite":
                    case 59:
                        message.permissions[i] = 59;
                        break;
                    case "OpDetachClonedFolder":
                    case 60:
                        message.permissions[i] = 60;
                        break;
                    case "OpGetProfileFileMeta":
                    case 69:
                        message.permissions[i] = 69;
                        break;
                    case "OpRenameFile":
                    case 62:
                        message.permissions[i] = 62;
                        break;
                    case "OpRenameFolder":
                    case 63:
                        message.permissions[i] = 63;
                        break;
                    case "OpList":
                    case 64:
                        message.permissions[i] = 64;
                        break;
                    case "OpAuditLogMessage":
                    case 65:
                        message.permissions[i] = 65;
                        break;
                    case "OpResetVersion":
                    case 66:
                        message.permissions[i] = 66;
                        break;
                    case "OpSetUser":
                    case 67:
                        message.permissions[i] = 67;
                        break;
                    case "OpFinalizeProfileWrite":
                    case 68:
                        message.permissions[i] = 68;
                        break;
                    case "OpGetUserType":
                    case 71:
                        message.permissions[i] = 71;
                        break;
                    case "OpGetRandomBytes":
                    case 72:
                        message.permissions[i] = 72;
                        break;
                    case "OpShare":
                    case 73:
                        message.permissions[i] = 73;
                        break;
                    case "OpUnshare":
                    case 74:
                        message.permissions[i] = 74;
                        break;
                    case "OpUpdateShare":
                    case 75:
                        message.permissions[i] = 75;
                        break;
                    case "OpListShares":
                    case 76:
                        message.permissions[i] = 76;
                        break;
                    case "OpResetTOTP":
                    case 77:
                        message.permissions[i] = 77;
                        break;
                    case "OpSetRolesTeamsToUser":
                    case 83:
                        message.permissions[i] = 83;
                        break;
                    case "OpUpdatePinOps":
                    case 84:
                        message.permissions[i] = 84;
                        break;
                    case "OpGetRolesAndTeamsOfUser":
                    case 86:
                        message.permissions[i] = 86;
                        break;
                    case "OpVerifyAuditLogMeta":
                    case 88:
                        message.permissions[i] = 88;
                        break;
                    case "OpGetAuditLog":
                    case 89:
                        message.permissions[i] = 89;
                        break;
                    case "OpDeleteAuditLog":
                    case 90:
                        message.permissions[i] = 90;
                        break;
                    case "OpListPins":
                    case 91:
                        message.permissions[i] = 91;
                        break;
                    case "OpListQuestions":
                    case 92:
                        message.permissions[i] = 92;
                        break;
                    case "OpMigrateToStorage":
                    case 93:
                        message.permissions[i] = 93;
                        break;
                    case "OpVerifyBYOSCreds":
                    case 94:
                        message.permissions[i] = 94;
                        break;
                    case "OpUpdateStorageCreds":
                    case 95:
                        message.permissions[i] = 95;
                        break;
                    case "OpRemoveOrganizationUser":
                    case 96:
                        message.permissions[i] = 96;
                        break;
                    case "OpAddSpace":
                    case 97:
                        message.permissions[i] = 97;
                        break;
                    case "OpAddUserToSpace":
                    case 98:
                        message.permissions[i] = 98;
                        break;
                    case "OpRemoveUserFromSpace":
                    case 99:
                        message.permissions[i] = 99;
                        break;
                    case "OpUpdatePermissionsOfSpace":
                    case 100:
                        message.permissions[i] = 100;
                        break;
                    case "OpAddObjectToSpace":
                    case 101:
                        message.permissions[i] = 101;
                        break;
                    case "OpRemoveObjectFromSpace":
                    case 102:
                        message.permissions[i] = 102;
                        break;
                    case "OpRemoveSpace":
                    case 103:
                        message.permissions[i] = 103;
                        break;
                    case "OpSendOtpToExternalUser":
                    case 104:
                        message.permissions[i] = 104;
                        break;
                    case "OpSignInToSpace":
                    case 105:
                        message.permissions[i] = 105;
                        break;
                    case "OpListSpaces":
                    case 106:
                        message.permissions[i] = 106;
                        break;
                    case "OpUpdateTags":
                    case 107:
                        message.permissions[i] = 107;
                        break;
                    case "OpAddComment":
                    case 108:
                        message.permissions[i] = 108;
                        break;
                    case "OpGetComment":
                    case 109:
                        message.permissions[i] = 109;
                        break;
                    case "OpListComments":
                    case 110:
                        message.permissions[i] = 110;
                        break;
                    case "OpRemoveComment":
                    case 111:
                        message.permissions[i] = 111;
                        break;
                    case "OpUpdateComment":
                    case 112:
                        message.permissions[i] = 112;
                        break;
                    case "OpGetStorageCreds":
                    case 113:
                        message.permissions[i] = 113;
                        break;
                    case "OpGetPlan":
                    case 114:
                        message.permissions[i] = 114;
                        break;
                    case "OpValidateCoupon":
                    case 115:
                        message.permissions[i] = 115;
                        break;
                    case "OpRemoveVersion":
                    case 116:
                        message.permissions[i] = 116;
                        break;
                    case "OpGetProfilePictureOfUser":
                    case 117:
                        message.permissions[i] = 117;
                        break;
                    case "OpEmptyTrash":
                    case 118:
                        message.permissions[i] = 118;
                        break;
                    case "OpGetThumbnail":
                    case 119:
                        message.permissions[i] = 119;
                        break;
                    case "OpSetThumbnail":
                    case 120:
                        message.permissions[i] = 120;
                        break;
                    case "OpYsentinel":
                    case 121:
                        message.permissions[i] = 121;
                        break;
                    case "OpCreateAlert":
                    case 122:
                        message.permissions[i] = 122;
                        break;
                    case "OpListAlerts":
                    case 123:
                        message.permissions[i] = 123;
                        break;
                    case "OpDeleteAlert":
                    case 124:
                        message.permissions[i] = 124;
                        break;
                    case "OpUpdateAlert":
                    case 125:
                        message.permissions[i] = 125;
                        break;
                    case "OpBlockUser":
                    case 126:
                        message.permissions[i] = 126;
                        break;
                    case "OpUnblockUser":
                    case 127:
                        message.permissions[i] = 127;
                        break;
                    case "UpdateOrganizationSettings":
                    case 128:
                        message.permissions[i] = 128;
                        break;
                    case "GetOrganizationSettings":
                    case 129:
                        message.permissions[i] = 129;
                        break;
                    }
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateRole message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.UpdateRole
         * @static
         * @param {request.UpdateRole} message UpdateRole
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateRole.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.permissions = [];
            if (options.defaults)
                object.name = "";
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.permissions && message.permissions.length) {
                object.permissions = [];
                for (let j = 0; j < message.permissions.length; ++j)
                    object.permissions[j] = options.enums === String ? $root.request.Op[message.permissions[j]] === undefined ? message.permissions[j] : $root.request.Op[message.permissions[j]] : message.permissions[j];
            }
            return object;
        };

        /**
         * Converts this UpdateRole to JSON.
         * @function toJSON
         * @memberof request.UpdateRole
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateRole.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for UpdateRole
         * @function getTypeUrl
         * @memberof request.UpdateRole
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        UpdateRole.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.UpdateRole";
        };

        return UpdateRole;
    })();

    request.ListRoles = (function() {

        /**
         * Properties of a ListRoles.
         * @memberof request
         * @interface IListRoles
         */

        /**
         * Constructs a new ListRoles.
         * @memberof request
         * @classdesc Represents a ListRoles.
         * @implements IListRoles
         * @constructor
         * @param {request.IListRoles=} [properties] Properties to set
         */
        function ListRoles(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new ListRoles instance using the specified properties.
         * @function create
         * @memberof request.ListRoles
         * @static
         * @param {request.IListRoles=} [properties] Properties to set
         * @returns {request.ListRoles} ListRoles instance
         */
        ListRoles.create = function create(properties) {
            return new ListRoles(properties);
        };

        /**
         * Encodes the specified ListRoles message. Does not implicitly {@link request.ListRoles.verify|verify} messages.
         * @function encode
         * @memberof request.ListRoles
         * @static
         * @param {request.IListRoles} message ListRoles message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListRoles.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified ListRoles message, length delimited. Does not implicitly {@link request.ListRoles.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.ListRoles
         * @static
         * @param {request.IListRoles} message ListRoles message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListRoles.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ListRoles message from the specified reader or buffer.
         * @function decode
         * @memberof request.ListRoles
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.ListRoles} ListRoles
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListRoles.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.ListRoles();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ListRoles message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.ListRoles
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.ListRoles} ListRoles
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListRoles.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ListRoles message.
         * @function verify
         * @memberof request.ListRoles
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ListRoles.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a ListRoles message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.ListRoles
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.ListRoles} ListRoles
         */
        ListRoles.fromObject = function fromObject(object) {
            if (object instanceof $root.request.ListRoles)
                return object;
            return new $root.request.ListRoles();
        };

        /**
         * Creates a plain object from a ListRoles message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.ListRoles
         * @static
         * @param {request.ListRoles} message ListRoles
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListRoles.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this ListRoles to JSON.
         * @function toJSON
         * @memberof request.ListRoles
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListRoles.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ListRoles
         * @function getTypeUrl
         * @memberof request.ListRoles
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ListRoles.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.ListRoles";
        };

        return ListRoles;
    })();

    request.GetRole = (function() {

        /**
         * Properties of a GetRole.
         * @memberof request
         * @interface IGetRole
         * @property {string|null} [name] GetRole name
         */

        /**
         * Constructs a new GetRole.
         * @memberof request
         * @classdesc Represents a GetRole.
         * @implements IGetRole
         * @constructor
         * @param {request.IGetRole=} [properties] Properties to set
         */
        function GetRole(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetRole name.
         * @member {string} name
         * @memberof request.GetRole
         * @instance
         */
        GetRole.prototype.name = "";

        /**
         * Creates a new GetRole instance using the specified properties.
         * @function create
         * @memberof request.GetRole
         * @static
         * @param {request.IGetRole=} [properties] Properties to set
         * @returns {request.GetRole} GetRole instance
         */
        GetRole.create = function create(properties) {
            return new GetRole(properties);
        };

        /**
         * Encodes the specified GetRole message. Does not implicitly {@link request.GetRole.verify|verify} messages.
         * @function encode
         * @memberof request.GetRole
         * @static
         * @param {request.IGetRole} message GetRole message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetRole.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
            return writer;
        };

        /**
         * Encodes the specified GetRole message, length delimited. Does not implicitly {@link request.GetRole.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.GetRole
         * @static
         * @param {request.IGetRole} message GetRole message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetRole.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetRole message from the specified reader or buffer.
         * @function decode
         * @memberof request.GetRole
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.GetRole} GetRole
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetRole.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.GetRole();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.name = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetRole message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.GetRole
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.GetRole} GetRole
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetRole.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetRole message.
         * @function verify
         * @memberof request.GetRole
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetRole.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            return null;
        };

        /**
         * Creates a GetRole message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.GetRole
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.GetRole} GetRole
         */
        GetRole.fromObject = function fromObject(object) {
            if (object instanceof $root.request.GetRole)
                return object;
            let message = new $root.request.GetRole();
            if (object.name != null)
                message.name = String(object.name);
            return message;
        };

        /**
         * Creates a plain object from a GetRole message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.GetRole
         * @static
         * @param {request.GetRole} message GetRole
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetRole.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.name = "";
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            return object;
        };

        /**
         * Converts this GetRole to JSON.
         * @function toJSON
         * @memberof request.GetRole
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetRole.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetRole
         * @function getTypeUrl
         * @memberof request.GetRole
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetRole.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.GetRole";
        };

        return GetRole;
    })();

    request.Team = (function() {

        /**
         * Properties of a Team.
         * @memberof request
         * @interface ITeam
         * @property {string|null} [name] Team name
         * @property {Array.<string>|null} [roles] Team roles
         * @property {Array.<Uint8Array>|null} [roleUuids] Team roleUuids
         * @property {Uint8Array|null} [uuid] Team uuid
         */

        /**
         * Constructs a new Team.
         * @memberof request
         * @classdesc Represents a Team.
         * @implements ITeam
         * @constructor
         * @param {request.ITeam=} [properties] Properties to set
         */
        function Team(properties) {
            this.roles = [];
            this.roleUuids = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Team name.
         * @member {string} name
         * @memberof request.Team
         * @instance
         */
        Team.prototype.name = "";

        /**
         * Team roles.
         * @member {Array.<string>} roles
         * @memberof request.Team
         * @instance
         */
        Team.prototype.roles = $util.emptyArray;

        /**
         * Team roleUuids.
         * @member {Array.<Uint8Array>} roleUuids
         * @memberof request.Team
         * @instance
         */
        Team.prototype.roleUuids = $util.emptyArray;

        /**
         * Team uuid.
         * @member {Uint8Array} uuid
         * @memberof request.Team
         * @instance
         */
        Team.prototype.uuid = $util.newBuffer([]);

        /**
         * Creates a new Team instance using the specified properties.
         * @function create
         * @memberof request.Team
         * @static
         * @param {request.ITeam=} [properties] Properties to set
         * @returns {request.Team} Team instance
         */
        Team.create = function create(properties) {
            return new Team(properties);
        };

        /**
         * Encodes the specified Team message. Does not implicitly {@link request.Team.verify|verify} messages.
         * @function encode
         * @memberof request.Team
         * @static
         * @param {request.ITeam} message Team message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Team.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
            if (message.roles != null && message.roles.length)
                for (let i = 0; i < message.roles.length; ++i)
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.roles[i]);
            if (message.uuid != null && Object.hasOwnProperty.call(message, "uuid"))
                writer.uint32(/* id 5, wireType 2 =*/42).bytes(message.uuid);
            if (message.roleUuids != null && message.roleUuids.length)
                for (let i = 0; i < message.roleUuids.length; ++i)
                    writer.uint32(/* id 6, wireType 2 =*/50).bytes(message.roleUuids[i]);
            return writer;
        };

        /**
         * Encodes the specified Team message, length delimited. Does not implicitly {@link request.Team.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.Team
         * @static
         * @param {request.ITeam} message Team message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Team.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Team message from the specified reader or buffer.
         * @function decode
         * @memberof request.Team
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.Team} Team
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Team.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.Team();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 2: {
                        message.name = reader.string();
                        break;
                    }
                case 4: {
                        if (!(message.roles && message.roles.length))
                            message.roles = [];
                        message.roles.push(reader.string());
                        break;
                    }
                case 6: {
                        if (!(message.roleUuids && message.roleUuids.length))
                            message.roleUuids = [];
                        message.roleUuids.push(reader.bytes());
                        break;
                    }
                case 5: {
                        message.uuid = reader.bytes();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Team message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.Team
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.Team} Team
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Team.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Team message.
         * @function verify
         * @memberof request.Team
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Team.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.roles != null && message.hasOwnProperty("roles")) {
                if (!Array.isArray(message.roles))
                    return "roles: array expected";
                for (let i = 0; i < message.roles.length; ++i)
                    if (!$util.isString(message.roles[i]))
                        return "roles: string[] expected";
            }
            if (message.roleUuids != null && message.hasOwnProperty("roleUuids")) {
                if (!Array.isArray(message.roleUuids))
                    return "roleUuids: array expected";
                for (let i = 0; i < message.roleUuids.length; ++i)
                    if (!(message.roleUuids[i] && typeof message.roleUuids[i].length === "number" || $util.isString(message.roleUuids[i])))
                        return "roleUuids: buffer[] expected";
            }
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                if (!(message.uuid && typeof message.uuid.length === "number" || $util.isString(message.uuid)))
                    return "uuid: buffer expected";
            return null;
        };

        /**
         * Creates a Team message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.Team
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.Team} Team
         */
        Team.fromObject = function fromObject(object) {
            if (object instanceof $root.request.Team)
                return object;
            let message = new $root.request.Team();
            if (object.name != null)
                message.name = String(object.name);
            if (object.roles) {
                if (!Array.isArray(object.roles))
                    throw TypeError(".request.Team.roles: array expected");
                message.roles = [];
                for (let i = 0; i < object.roles.length; ++i)
                    message.roles[i] = String(object.roles[i]);
            }
            if (object.roleUuids) {
                if (!Array.isArray(object.roleUuids))
                    throw TypeError(".request.Team.roleUuids: array expected");
                message.roleUuids = [];
                for (let i = 0; i < object.roleUuids.length; ++i)
                    if (typeof object.roleUuids[i] === "string")
                        $util.base64.decode(object.roleUuids[i], message.roleUuids[i] = $util.newBuffer($util.base64.length(object.roleUuids[i])), 0);
                    else if (object.roleUuids[i].length >= 0)
                        message.roleUuids[i] = object.roleUuids[i];
            }
            if (object.uuid != null)
                if (typeof object.uuid === "string")
                    $util.base64.decode(object.uuid, message.uuid = $util.newBuffer($util.base64.length(object.uuid)), 0);
                else if (object.uuid.length >= 0)
                    message.uuid = object.uuid;
            return message;
        };

        /**
         * Creates a plain object from a Team message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.Team
         * @static
         * @param {request.Team} message Team
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Team.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.roles = [];
                object.roleUuids = [];
            }
            if (options.defaults) {
                object.name = "";
                if (options.bytes === String)
                    object.uuid = "";
                else {
                    object.uuid = [];
                    if (options.bytes !== Array)
                        object.uuid = $util.newBuffer(object.uuid);
                }
            }
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.roles && message.roles.length) {
                object.roles = [];
                for (let j = 0; j < message.roles.length; ++j)
                    object.roles[j] = message.roles[j];
            }
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                object.uuid = options.bytes === String ? $util.base64.encode(message.uuid, 0, message.uuid.length) : options.bytes === Array ? Array.prototype.slice.call(message.uuid) : message.uuid;
            if (message.roleUuids && message.roleUuids.length) {
                object.roleUuids = [];
                for (let j = 0; j < message.roleUuids.length; ++j)
                    object.roleUuids[j] = options.bytes === String ? $util.base64.encode(message.roleUuids[j], 0, message.roleUuids[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.roleUuids[j]) : message.roleUuids[j];
            }
            return object;
        };

        /**
         * Converts this Team to JSON.
         * @function toJSON
         * @memberof request.Team
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Team.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Team
         * @function getTypeUrl
         * @memberof request.Team
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Team.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.Team";
        };

        return Team;
    })();

    request.AddTeam = (function() {

        /**
         * Properties of an AddTeam.
         * @memberof request
         * @interface IAddTeam
         * @property {string|null} [name] AddTeam name
         * @property {Array.<string>|null} [roles] AddTeam roles
         */

        /**
         * Constructs a new AddTeam.
         * @memberof request
         * @classdesc Represents an AddTeam.
         * @implements IAddTeam
         * @constructor
         * @param {request.IAddTeam=} [properties] Properties to set
         */
        function AddTeam(properties) {
            this.roles = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddTeam name.
         * @member {string} name
         * @memberof request.AddTeam
         * @instance
         */
        AddTeam.prototype.name = "";

        /**
         * AddTeam roles.
         * @member {Array.<string>} roles
         * @memberof request.AddTeam
         * @instance
         */
        AddTeam.prototype.roles = $util.emptyArray;

        /**
         * Creates a new AddTeam instance using the specified properties.
         * @function create
         * @memberof request.AddTeam
         * @static
         * @param {request.IAddTeam=} [properties] Properties to set
         * @returns {request.AddTeam} AddTeam instance
         */
        AddTeam.create = function create(properties) {
            return new AddTeam(properties);
        };

        /**
         * Encodes the specified AddTeam message. Does not implicitly {@link request.AddTeam.verify|verify} messages.
         * @function encode
         * @memberof request.AddTeam
         * @static
         * @param {request.IAddTeam} message AddTeam message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddTeam.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
            if (message.roles != null && message.roles.length)
                for (let i = 0; i < message.roles.length; ++i)
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.roles[i]);
            return writer;
        };

        /**
         * Encodes the specified AddTeam message, length delimited. Does not implicitly {@link request.AddTeam.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.AddTeam
         * @static
         * @param {request.IAddTeam} message AddTeam message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddTeam.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AddTeam message from the specified reader or buffer.
         * @function decode
         * @memberof request.AddTeam
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.AddTeam} AddTeam
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddTeam.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.AddTeam();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.name = reader.string();
                        break;
                    }
                case 2: {
                        if (!(message.roles && message.roles.length))
                            message.roles = [];
                        message.roles.push(reader.string());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AddTeam message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.AddTeam
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.AddTeam} AddTeam
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddTeam.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AddTeam message.
         * @function verify
         * @memberof request.AddTeam
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AddTeam.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.roles != null && message.hasOwnProperty("roles")) {
                if (!Array.isArray(message.roles))
                    return "roles: array expected";
                for (let i = 0; i < message.roles.length; ++i)
                    if (!$util.isString(message.roles[i]))
                        return "roles: string[] expected";
            }
            return null;
        };

        /**
         * Creates an AddTeam message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.AddTeam
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.AddTeam} AddTeam
         */
        AddTeam.fromObject = function fromObject(object) {
            if (object instanceof $root.request.AddTeam)
                return object;
            let message = new $root.request.AddTeam();
            if (object.name != null)
                message.name = String(object.name);
            if (object.roles) {
                if (!Array.isArray(object.roles))
                    throw TypeError(".request.AddTeam.roles: array expected");
                message.roles = [];
                for (let i = 0; i < object.roles.length; ++i)
                    message.roles[i] = String(object.roles[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from an AddTeam message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.AddTeam
         * @static
         * @param {request.AddTeam} message AddTeam
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddTeam.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.roles = [];
            if (options.defaults)
                object.name = "";
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.roles && message.roles.length) {
                object.roles = [];
                for (let j = 0; j < message.roles.length; ++j)
                    object.roles[j] = message.roles[j];
            }
            return object;
        };

        /**
         * Converts this AddTeam to JSON.
         * @function toJSON
         * @memberof request.AddTeam
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddTeam.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for AddTeam
         * @function getTypeUrl
         * @memberof request.AddTeam
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        AddTeam.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.AddTeam";
        };

        return AddTeam;
    })();

    request.RemoveTeam = (function() {

        /**
         * Properties of a RemoveTeam.
         * @memberof request
         * @interface IRemoveTeam
         * @property {string|null} [name] RemoveTeam name
         */

        /**
         * Constructs a new RemoveTeam.
         * @memberof request
         * @classdesc Represents a RemoveTeam.
         * @implements IRemoveTeam
         * @constructor
         * @param {request.IRemoveTeam=} [properties] Properties to set
         */
        function RemoveTeam(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveTeam name.
         * @member {string} name
         * @memberof request.RemoveTeam
         * @instance
         */
        RemoveTeam.prototype.name = "";

        /**
         * Creates a new RemoveTeam instance using the specified properties.
         * @function create
         * @memberof request.RemoveTeam
         * @static
         * @param {request.IRemoveTeam=} [properties] Properties to set
         * @returns {request.RemoveTeam} RemoveTeam instance
         */
        RemoveTeam.create = function create(properties) {
            return new RemoveTeam(properties);
        };

        /**
         * Encodes the specified RemoveTeam message. Does not implicitly {@link request.RemoveTeam.verify|verify} messages.
         * @function encode
         * @memberof request.RemoveTeam
         * @static
         * @param {request.IRemoveTeam} message RemoveTeam message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RemoveTeam.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
            return writer;
        };

        /**
         * Encodes the specified RemoveTeam message, length delimited. Does not implicitly {@link request.RemoveTeam.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.RemoveTeam
         * @static
         * @param {request.IRemoveTeam} message RemoveTeam message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RemoveTeam.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RemoveTeam message from the specified reader or buffer.
         * @function decode
         * @memberof request.RemoveTeam
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.RemoveTeam} RemoveTeam
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RemoveTeam.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.RemoveTeam();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.name = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RemoveTeam message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.RemoveTeam
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.RemoveTeam} RemoveTeam
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RemoveTeam.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RemoveTeam message.
         * @function verify
         * @memberof request.RemoveTeam
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RemoveTeam.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            return null;
        };

        /**
         * Creates a RemoveTeam message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.RemoveTeam
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.RemoveTeam} RemoveTeam
         */
        RemoveTeam.fromObject = function fromObject(object) {
            if (object instanceof $root.request.RemoveTeam)
                return object;
            let message = new $root.request.RemoveTeam();
            if (object.name != null)
                message.name = String(object.name);
            return message;
        };

        /**
         * Creates a plain object from a RemoveTeam message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.RemoveTeam
         * @static
         * @param {request.RemoveTeam} message RemoveTeam
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveTeam.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.name = "";
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            return object;
        };

        /**
         * Converts this RemoveTeam to JSON.
         * @function toJSON
         * @memberof request.RemoveTeam
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveTeam.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for RemoveTeam
         * @function getTypeUrl
         * @memberof request.RemoveTeam
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        RemoveTeam.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.RemoveTeam";
        };

        return RemoveTeam;
    })();

    request.UpdateTeam = (function() {

        /**
         * Properties of an UpdateTeam.
         * @memberof request
         * @interface IUpdateTeam
         * @property {string|null} [name] UpdateTeam name
         * @property {Array.<string>|null} [roles] UpdateTeam roles
         */

        /**
         * Constructs a new UpdateTeam.
         * @memberof request
         * @classdesc Represents an UpdateTeam.
         * @implements IUpdateTeam
         * @constructor
         * @param {request.IUpdateTeam=} [properties] Properties to set
         */
        function UpdateTeam(properties) {
            this.roles = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateTeam name.
         * @member {string} name
         * @memberof request.UpdateTeam
         * @instance
         */
        UpdateTeam.prototype.name = "";

        /**
         * UpdateTeam roles.
         * @member {Array.<string>} roles
         * @memberof request.UpdateTeam
         * @instance
         */
        UpdateTeam.prototype.roles = $util.emptyArray;

        /**
         * Creates a new UpdateTeam instance using the specified properties.
         * @function create
         * @memberof request.UpdateTeam
         * @static
         * @param {request.IUpdateTeam=} [properties] Properties to set
         * @returns {request.UpdateTeam} UpdateTeam instance
         */
        UpdateTeam.create = function create(properties) {
            return new UpdateTeam(properties);
        };

        /**
         * Encodes the specified UpdateTeam message. Does not implicitly {@link request.UpdateTeam.verify|verify} messages.
         * @function encode
         * @memberof request.UpdateTeam
         * @static
         * @param {request.IUpdateTeam} message UpdateTeam message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateTeam.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
            if (message.roles != null && message.roles.length)
                for (let i = 0; i < message.roles.length; ++i)
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.roles[i]);
            return writer;
        };

        /**
         * Encodes the specified UpdateTeam message, length delimited. Does not implicitly {@link request.UpdateTeam.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.UpdateTeam
         * @static
         * @param {request.IUpdateTeam} message UpdateTeam message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateTeam.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UpdateTeam message from the specified reader or buffer.
         * @function decode
         * @memberof request.UpdateTeam
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.UpdateTeam} UpdateTeam
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateTeam.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.UpdateTeam();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 2: {
                        message.name = reader.string();
                        break;
                    }
                case 3: {
                        if (!(message.roles && message.roles.length))
                            message.roles = [];
                        message.roles.push(reader.string());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UpdateTeam message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.UpdateTeam
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.UpdateTeam} UpdateTeam
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateTeam.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UpdateTeam message.
         * @function verify
         * @memberof request.UpdateTeam
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UpdateTeam.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.roles != null && message.hasOwnProperty("roles")) {
                if (!Array.isArray(message.roles))
                    return "roles: array expected";
                for (let i = 0; i < message.roles.length; ++i)
                    if (!$util.isString(message.roles[i]))
                        return "roles: string[] expected";
            }
            return null;
        };

        /**
         * Creates an UpdateTeam message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.UpdateTeam
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.UpdateTeam} UpdateTeam
         */
        UpdateTeam.fromObject = function fromObject(object) {
            if (object instanceof $root.request.UpdateTeam)
                return object;
            let message = new $root.request.UpdateTeam();
            if (object.name != null)
                message.name = String(object.name);
            if (object.roles) {
                if (!Array.isArray(object.roles))
                    throw TypeError(".request.UpdateTeam.roles: array expected");
                message.roles = [];
                for (let i = 0; i < object.roles.length; ++i)
                    message.roles[i] = String(object.roles[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateTeam message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.UpdateTeam
         * @static
         * @param {request.UpdateTeam} message UpdateTeam
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateTeam.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.roles = [];
            if (options.defaults)
                object.name = "";
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.roles && message.roles.length) {
                object.roles = [];
                for (let j = 0; j < message.roles.length; ++j)
                    object.roles[j] = message.roles[j];
            }
            return object;
        };

        /**
         * Converts this UpdateTeam to JSON.
         * @function toJSON
         * @memberof request.UpdateTeam
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateTeam.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for UpdateTeam
         * @function getTypeUrl
         * @memberof request.UpdateTeam
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        UpdateTeam.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.UpdateTeam";
        };

        return UpdateTeam;
    })();

    request.ListTeams = (function() {

        /**
         * Properties of a ListTeams.
         * @memberof request
         * @interface IListTeams
         */

        /**
         * Constructs a new ListTeams.
         * @memberof request
         * @classdesc Represents a ListTeams.
         * @implements IListTeams
         * @constructor
         * @param {request.IListTeams=} [properties] Properties to set
         */
        function ListTeams(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new ListTeams instance using the specified properties.
         * @function create
         * @memberof request.ListTeams
         * @static
         * @param {request.IListTeams=} [properties] Properties to set
         * @returns {request.ListTeams} ListTeams instance
         */
        ListTeams.create = function create(properties) {
            return new ListTeams(properties);
        };

        /**
         * Encodes the specified ListTeams message. Does not implicitly {@link request.ListTeams.verify|verify} messages.
         * @function encode
         * @memberof request.ListTeams
         * @static
         * @param {request.IListTeams} message ListTeams message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListTeams.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified ListTeams message, length delimited. Does not implicitly {@link request.ListTeams.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.ListTeams
         * @static
         * @param {request.IListTeams} message ListTeams message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListTeams.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ListTeams message from the specified reader or buffer.
         * @function decode
         * @memberof request.ListTeams
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.ListTeams} ListTeams
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListTeams.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.ListTeams();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ListTeams message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.ListTeams
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.ListTeams} ListTeams
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListTeams.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ListTeams message.
         * @function verify
         * @memberof request.ListTeams
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ListTeams.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a ListTeams message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.ListTeams
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.ListTeams} ListTeams
         */
        ListTeams.fromObject = function fromObject(object) {
            if (object instanceof $root.request.ListTeams)
                return object;
            return new $root.request.ListTeams();
        };

        /**
         * Creates a plain object from a ListTeams message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.ListTeams
         * @static
         * @param {request.ListTeams} message ListTeams
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListTeams.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this ListTeams to JSON.
         * @function toJSON
         * @memberof request.ListTeams
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListTeams.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ListTeams
         * @function getTypeUrl
         * @memberof request.ListTeams
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ListTeams.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.ListTeams";
        };

        return ListTeams;
    })();

    request.GetTeam = (function() {

        /**
         * Properties of a GetTeam.
         * @memberof request
         * @interface IGetTeam
         * @property {string|null} [name] GetTeam name
         */

        /**
         * Constructs a new GetTeam.
         * @memberof request
         * @classdesc Represents a GetTeam.
         * @implements IGetTeam
         * @constructor
         * @param {request.IGetTeam=} [properties] Properties to set
         */
        function GetTeam(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetTeam name.
         * @member {string} name
         * @memberof request.GetTeam
         * @instance
         */
        GetTeam.prototype.name = "";

        /**
         * Creates a new GetTeam instance using the specified properties.
         * @function create
         * @memberof request.GetTeam
         * @static
         * @param {request.IGetTeam=} [properties] Properties to set
         * @returns {request.GetTeam} GetTeam instance
         */
        GetTeam.create = function create(properties) {
            return new GetTeam(properties);
        };

        /**
         * Encodes the specified GetTeam message. Does not implicitly {@link request.GetTeam.verify|verify} messages.
         * @function encode
         * @memberof request.GetTeam
         * @static
         * @param {request.IGetTeam} message GetTeam message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetTeam.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
            return writer;
        };

        /**
         * Encodes the specified GetTeam message, length delimited. Does not implicitly {@link request.GetTeam.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.GetTeam
         * @static
         * @param {request.IGetTeam} message GetTeam message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetTeam.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetTeam message from the specified reader or buffer.
         * @function decode
         * @memberof request.GetTeam
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.GetTeam} GetTeam
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetTeam.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.GetTeam();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.name = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetTeam message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.GetTeam
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.GetTeam} GetTeam
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetTeam.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetTeam message.
         * @function verify
         * @memberof request.GetTeam
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetTeam.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            return null;
        };

        /**
         * Creates a GetTeam message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.GetTeam
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.GetTeam} GetTeam
         */
        GetTeam.fromObject = function fromObject(object) {
            if (object instanceof $root.request.GetTeam)
                return object;
            let message = new $root.request.GetTeam();
            if (object.name != null)
                message.name = String(object.name);
            return message;
        };

        /**
         * Creates a plain object from a GetTeam message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.GetTeam
         * @static
         * @param {request.GetTeam} message GetTeam
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetTeam.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.name = "";
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            return object;
        };

        /**
         * Converts this GetTeam to JSON.
         * @function toJSON
         * @memberof request.GetTeam
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetTeam.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetTeam
         * @function getTypeUrl
         * @memberof request.GetTeam
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetTeam.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.GetTeam";
        };

        return GetTeam;
    })();

    request.IsOperationAllowed = (function() {

        /**
         * Properties of an IsOperationAllowed.
         * @memberof request
         * @interface IIsOperationAllowed
         * @property {string|null} [roleName] IsOperationAllowed roleName
         * @property {string|null} [teamName] IsOperationAllowed teamName
         * @property {request.Op|null} [operation] IsOperationAllowed operation
         */

        /**
         * Constructs a new IsOperationAllowed.
         * @memberof request
         * @classdesc Represents an IsOperationAllowed.
         * @implements IIsOperationAllowed
         * @constructor
         * @param {request.IIsOperationAllowed=} [properties] Properties to set
         */
        function IsOperationAllowed(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * IsOperationAllowed roleName.
         * @member {string|null|undefined} roleName
         * @memberof request.IsOperationAllowed
         * @instance
         */
        IsOperationAllowed.prototype.roleName = null;

        /**
         * IsOperationAllowed teamName.
         * @member {string|null|undefined} teamName
         * @memberof request.IsOperationAllowed
         * @instance
         */
        IsOperationAllowed.prototype.teamName = null;

        /**
         * IsOperationAllowed operation.
         * @member {request.Op} operation
         * @memberof request.IsOperationAllowed
         * @instance
         */
        IsOperationAllowed.prototype.operation = 0;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(IsOperationAllowed.prototype, "_roleName", {
            get: $util.oneOfGetter($oneOfFields = ["roleName"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(IsOperationAllowed.prototype, "_teamName", {
            get: $util.oneOfGetter($oneOfFields = ["teamName"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new IsOperationAllowed instance using the specified properties.
         * @function create
         * @memberof request.IsOperationAllowed
         * @static
         * @param {request.IIsOperationAllowed=} [properties] Properties to set
         * @returns {request.IsOperationAllowed} IsOperationAllowed instance
         */
        IsOperationAllowed.create = function create(properties) {
            return new IsOperationAllowed(properties);
        };

        /**
         * Encodes the specified IsOperationAllowed message. Does not implicitly {@link request.IsOperationAllowed.verify|verify} messages.
         * @function encode
         * @memberof request.IsOperationAllowed
         * @static
         * @param {request.IIsOperationAllowed} message IsOperationAllowed message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        IsOperationAllowed.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.roleName != null && Object.hasOwnProperty.call(message, "roleName"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.roleName);
            if (message.teamName != null && Object.hasOwnProperty.call(message, "teamName"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.teamName);
            if (message.operation != null && Object.hasOwnProperty.call(message, "operation"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.operation);
            return writer;
        };

        /**
         * Encodes the specified IsOperationAllowed message, length delimited. Does not implicitly {@link request.IsOperationAllowed.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.IsOperationAllowed
         * @static
         * @param {request.IIsOperationAllowed} message IsOperationAllowed message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        IsOperationAllowed.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an IsOperationAllowed message from the specified reader or buffer.
         * @function decode
         * @memberof request.IsOperationAllowed
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.IsOperationAllowed} IsOperationAllowed
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        IsOperationAllowed.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.IsOperationAllowed();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.roleName = reader.string();
                        break;
                    }
                case 2: {
                        message.teamName = reader.string();
                        break;
                    }
                case 3: {
                        message.operation = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an IsOperationAllowed message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.IsOperationAllowed
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.IsOperationAllowed} IsOperationAllowed
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        IsOperationAllowed.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an IsOperationAllowed message.
         * @function verify
         * @memberof request.IsOperationAllowed
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        IsOperationAllowed.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.roleName != null && message.hasOwnProperty("roleName")) {
                properties._roleName = 1;
                if (!$util.isString(message.roleName))
                    return "roleName: string expected";
            }
            if (message.teamName != null && message.hasOwnProperty("teamName")) {
                properties._teamName = 1;
                if (!$util.isString(message.teamName))
                    return "teamName: string expected";
            }
            if (message.operation != null && message.hasOwnProperty("operation"))
                switch (message.operation) {
                default:
                    return "operation: enum value expected";
                case 0:
                case 2:
                case 3:
                case 4:
                case 6:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 54:
                case 16:
                case 17:
                case 19:
                case 20:
                case 21:
                case 22:
                case 23:
                case 24:
                case 25:
                case 26:
                case 27:
                case 28:
                case 29:
                case 30:
                case 31:
                case 32:
                case 33:
                case 34:
                case 35:
                case 36:
                case 37:
                case 87:
                case 38:
                case 39:
                case 40:
                case 41:
                case 42:
                case 43:
                case 44:
                case 81:
                case 49:
                case 45:
                case 46:
                case 47:
                case 48:
                case 80:
                case 50:
                case 51:
                case 52:
                case 53:
                case 82:
                case 55:
                case 56:
                case 57:
                case 58:
                case 59:
                case 60:
                case 69:
                case 62:
                case 63:
                case 64:
                case 65:
                case 66:
                case 67:
                case 68:
                case 71:
                case 72:
                case 73:
                case 74:
                case 75:
                case 76:
                case 77:
                case 83:
                case 84:
                case 86:
                case 88:
                case 89:
                case 90:
                case 91:
                case 92:
                case 93:
                case 94:
                case 95:
                case 96:
                case 97:
                case 98:
                case 99:
                case 100:
                case 101:
                case 102:
                case 103:
                case 104:
                case 105:
                case 106:
                case 107:
                case 108:
                case 109:
                case 110:
                case 111:
                case 112:
                case 113:
                case 114:
                case 115:
                case 116:
                case 117:
                case 118:
                case 119:
                case 120:
                case 121:
                case 122:
                case 123:
                case 124:
                case 125:
                case 126:
                case 127:
                case 128:
                case 129:
                    break;
                }
            return null;
        };

        /**
         * Creates an IsOperationAllowed message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.IsOperationAllowed
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.IsOperationAllowed} IsOperationAllowed
         */
        IsOperationAllowed.fromObject = function fromObject(object) {
            if (object instanceof $root.request.IsOperationAllowed)
                return object;
            let message = new $root.request.IsOperationAllowed();
            if (object.roleName != null)
                message.roleName = String(object.roleName);
            if (object.teamName != null)
                message.teamName = String(object.teamName);
            switch (object.operation) {
            default:
                if (typeof object.operation === "number") {
                    message.operation = object.operation;
                    break;
                }
                break;
            case "OpAddUser":
            case 0:
                message.operation = 0;
                break;
            case "OpRemoveUser":
            case 2:
                message.operation = 2;
                break;
            case "OpPasswordReset":
            case 3:
                message.operation = 3;
                break;
            case "OpChangePassword":
            case 4:
                message.operation = 4;
                break;
            case "OpInitiatePayment":
            case 6:
                message.operation = 6;
                break;
            case "OpInviteUser":
            case 9:
                message.operation = 9;
                break;
            case "OpGetUser":
            case 10:
                message.operation = 10;
                break;
            case "OpListUsers":
            case 11:
                message.operation = 11;
                break;
            case "OpRemoveOrganization":
            case 12:
                message.operation = 12;
                break;
            case "OpVerifyOrganization":
            case 13:
                message.operation = 13;
                break;
            case "OpGetOrganization":
            case 14:
                message.operation = 14;
                break;
            case "OpAddPin":
            case 15:
                message.operation = 15;
                break;
            case "OPDeletePin":
            case 54:
                message.operation = 54;
                break;
            case "OpVerifyUser":
            case 16:
                message.operation = 16;
                break;
            case "OpGetMetaFromPath":
            case 17:
                message.operation = 17;
                break;
            case "OpFileLock":
            case 19:
                message.operation = 19;
                break;
            case "OpFileUnlock":
            case 20:
                message.operation = 20;
                break;
            case "OpGetChunk":
            case 21:
                message.operation = 21;
                break;
            case "OpStartWrite":
            case 22:
                message.operation = 22;
                break;
            case "OpPutChunk":
            case 23:
                message.operation = 23;
                break;
            case "OpFinalizeWrite":
            case 24:
                message.operation = 24;
                break;
            case "OpListFiles":
            case 25:
                message.operation = 25;
                break;
            case "OpRemove":
            case 26:
                message.operation = 26;
                break;
            case "OpCopy":
            case 27:
                message.operation = 27;
                break;
            case "OpMove":
            case 28:
                message.operation = 28;
                break;
            case "OpGetFolder":
            case 29:
                message.operation = 29;
                break;
            case "OpCreateFolder":
            case 30:
                message.operation = 30;
                break;
            case "OpCreateSnapshot":
            case 31:
                message.operation = 31;
                break;
            case "OpVerifyPayment":
            case 32:
                message.operation = 32;
                break;
            case "OpGetSecret":
            case 33:
                message.operation = 33;
                break;
            case "OpAddSecret":
            case 34:
                message.operation = 34;
                break;
            case "OpRemoveSecret":
            case 35:
                message.operation = 35;
                break;
            case "OpUpdateSecret":
            case 36:
                message.operation = 36;
                break;
            case "OpListSecrets":
            case 37:
                message.operation = 37;
                break;
            case "OpQuickListSecrets":
            case 87:
                message.operation = 87;
                break;
            case "OpListSecretSubkeys":
            case 38:
                message.operation = 38;
                break;
            case "OpUndeleteSecret":
            case 39:
                message.operation = 39;
                break;
            case "OpDestroySecret":
            case 40:
                message.operation = 40;
                break;
            case "OpAddRole":
            case 41:
                message.operation = 41;
                break;
            case "OpRemoveRole":
            case 42:
                message.operation = 42;
                break;
            case "OpUpdateRole":
            case 43:
                message.operation = 43;
                break;
            case "OpListRoles":
            case 44:
                message.operation = 44;
                break;
            case "OpGetRole":
            case 81:
                message.operation = 81;
                break;
            case "OpIsOperationAllowed":
            case 49:
                message.operation = 49;
                break;
            case "OpListTeams":
            case 45:
                message.operation = 45;
                break;
            case "OpAddTeam":
            case 46:
                message.operation = 46;
                break;
            case "OpRemoveTeam":
            case 47:
                message.operation = 47;
                break;
            case "OpUpdateTeam":
            case 48:
                message.operation = 48;
                break;
            case "OpGetTeam":
            case 80:
                message.operation = 80;
                break;
            case "OpMoveFile":
            case 50:
                message.operation = 50;
                break;
            case "OpMoveFolder":
            case 51:
                message.operation = 51;
                break;
            case "OpCopyFile":
            case 52:
                message.operation = 52;
                break;
            case "OpCopyFolder":
            case 53:
                message.operation = 53;
                break;
            case "OpRestoreVersion":
            case 82:
                message.operation = 82;
                break;
            case "OpRemoveFile":
            case 55:
                message.operation = 55;
                break;
            case "OpRemoveFolder":
            case 56:
                message.operation = 56;
                break;
            case "OpUntrashFile":
            case 57:
                message.operation = 57;
                break;
            case "OpUntrashFolder":
            case 58:
                message.operation = 58;
                break;
            case "OpUndoStartWrite":
            case 59:
                message.operation = 59;
                break;
            case "OpDetachClonedFolder":
            case 60:
                message.operation = 60;
                break;
            case "OpGetProfileFileMeta":
            case 69:
                message.operation = 69;
                break;
            case "OpRenameFile":
            case 62:
                message.operation = 62;
                break;
            case "OpRenameFolder":
            case 63:
                message.operation = 63;
                break;
            case "OpList":
            case 64:
                message.operation = 64;
                break;
            case "OpAuditLogMessage":
            case 65:
                message.operation = 65;
                break;
            case "OpResetVersion":
            case 66:
                message.operation = 66;
                break;
            case "OpSetUser":
            case 67:
                message.operation = 67;
                break;
            case "OpFinalizeProfileWrite":
            case 68:
                message.operation = 68;
                break;
            case "OpGetUserType":
            case 71:
                message.operation = 71;
                break;
            case "OpGetRandomBytes":
            case 72:
                message.operation = 72;
                break;
            case "OpShare":
            case 73:
                message.operation = 73;
                break;
            case "OpUnshare":
            case 74:
                message.operation = 74;
                break;
            case "OpUpdateShare":
            case 75:
                message.operation = 75;
                break;
            case "OpListShares":
            case 76:
                message.operation = 76;
                break;
            case "OpResetTOTP":
            case 77:
                message.operation = 77;
                break;
            case "OpSetRolesTeamsToUser":
            case 83:
                message.operation = 83;
                break;
            case "OpUpdatePinOps":
            case 84:
                message.operation = 84;
                break;
            case "OpGetRolesAndTeamsOfUser":
            case 86:
                message.operation = 86;
                break;
            case "OpVerifyAuditLogMeta":
            case 88:
                message.operation = 88;
                break;
            case "OpGetAuditLog":
            case 89:
                message.operation = 89;
                break;
            case "OpDeleteAuditLog":
            case 90:
                message.operation = 90;
                break;
            case "OpListPins":
            case 91:
                message.operation = 91;
                break;
            case "OpListQuestions":
            case 92:
                message.operation = 92;
                break;
            case "OpMigrateToStorage":
            case 93:
                message.operation = 93;
                break;
            case "OpVerifyBYOSCreds":
            case 94:
                message.operation = 94;
                break;
            case "OpUpdateStorageCreds":
            case 95:
                message.operation = 95;
                break;
            case "OpRemoveOrganizationUser":
            case 96:
                message.operation = 96;
                break;
            case "OpAddSpace":
            case 97:
                message.operation = 97;
                break;
            case "OpAddUserToSpace":
            case 98:
                message.operation = 98;
                break;
            case "OpRemoveUserFromSpace":
            case 99:
                message.operation = 99;
                break;
            case "OpUpdatePermissionsOfSpace":
            case 100:
                message.operation = 100;
                break;
            case "OpAddObjectToSpace":
            case 101:
                message.operation = 101;
                break;
            case "OpRemoveObjectFromSpace":
            case 102:
                message.operation = 102;
                break;
            case "OpRemoveSpace":
            case 103:
                message.operation = 103;
                break;
            case "OpSendOtpToExternalUser":
            case 104:
                message.operation = 104;
                break;
            case "OpSignInToSpace":
            case 105:
                message.operation = 105;
                break;
            case "OpListSpaces":
            case 106:
                message.operation = 106;
                break;
            case "OpUpdateTags":
            case 107:
                message.operation = 107;
                break;
            case "OpAddComment":
            case 108:
                message.operation = 108;
                break;
            case "OpGetComment":
            case 109:
                message.operation = 109;
                break;
            case "OpListComments":
            case 110:
                message.operation = 110;
                break;
            case "OpRemoveComment":
            case 111:
                message.operation = 111;
                break;
            case "OpUpdateComment":
            case 112:
                message.operation = 112;
                break;
            case "OpGetStorageCreds":
            case 113:
                message.operation = 113;
                break;
            case "OpGetPlan":
            case 114:
                message.operation = 114;
                break;
            case "OpValidateCoupon":
            case 115:
                message.operation = 115;
                break;
            case "OpRemoveVersion":
            case 116:
                message.operation = 116;
                break;
            case "OpGetProfilePictureOfUser":
            case 117:
                message.operation = 117;
                break;
            case "OpEmptyTrash":
            case 118:
                message.operation = 118;
                break;
            case "OpGetThumbnail":
            case 119:
                message.operation = 119;
                break;
            case "OpSetThumbnail":
            case 120:
                message.operation = 120;
                break;
            case "OpYsentinel":
            case 121:
                message.operation = 121;
                break;
            case "OpCreateAlert":
            case 122:
                message.operation = 122;
                break;
            case "OpListAlerts":
            case 123:
                message.operation = 123;
                break;
            case "OpDeleteAlert":
            case 124:
                message.operation = 124;
                break;
            case "OpUpdateAlert":
            case 125:
                message.operation = 125;
                break;
            case "OpBlockUser":
            case 126:
                message.operation = 126;
                break;
            case "OpUnblockUser":
            case 127:
                message.operation = 127;
                break;
            case "UpdateOrganizationSettings":
            case 128:
                message.operation = 128;
                break;
            case "GetOrganizationSettings":
            case 129:
                message.operation = 129;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from an IsOperationAllowed message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.IsOperationAllowed
         * @static
         * @param {request.IsOperationAllowed} message IsOperationAllowed
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        IsOperationAllowed.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.operation = options.enums === String ? "OpAddUser" : 0;
            if (message.roleName != null && message.hasOwnProperty("roleName")) {
                object.roleName = message.roleName;
                if (options.oneofs)
                    object._roleName = "roleName";
            }
            if (message.teamName != null && message.hasOwnProperty("teamName")) {
                object.teamName = message.teamName;
                if (options.oneofs)
                    object._teamName = "teamName";
            }
            if (message.operation != null && message.hasOwnProperty("operation"))
                object.operation = options.enums === String ? $root.request.Op[message.operation] === undefined ? message.operation : $root.request.Op[message.operation] : message.operation;
            return object;
        };

        /**
         * Converts this IsOperationAllowed to JSON.
         * @function toJSON
         * @memberof request.IsOperationAllowed
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        IsOperationAllowed.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for IsOperationAllowed
         * @function getTypeUrl
         * @memberof request.IsOperationAllowed
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        IsOperationAllowed.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.IsOperationAllowed";
        };

        return IsOperationAllowed;
    })();

    request.RestoreVersion = (function() {

        /**
         * Properties of a RestoreVersion.
         * @memberof request
         * @interface IRestoreVersion
         * @property {Uint8Array|null} [fileuuid] RestoreVersion fileuuid
         * @property {string|null} [versionId] RestoreVersion versionId
         */

        /**
         * Constructs a new RestoreVersion.
         * @memberof request
         * @classdesc Represents a RestoreVersion.
         * @implements IRestoreVersion
         * @constructor
         * @param {request.IRestoreVersion=} [properties] Properties to set
         */
        function RestoreVersion(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RestoreVersion fileuuid.
         * @member {Uint8Array} fileuuid
         * @memberof request.RestoreVersion
         * @instance
         */
        RestoreVersion.prototype.fileuuid = $util.newBuffer([]);

        /**
         * RestoreVersion versionId.
         * @member {string} versionId
         * @memberof request.RestoreVersion
         * @instance
         */
        RestoreVersion.prototype.versionId = "";

        /**
         * Creates a new RestoreVersion instance using the specified properties.
         * @function create
         * @memberof request.RestoreVersion
         * @static
         * @param {request.IRestoreVersion=} [properties] Properties to set
         * @returns {request.RestoreVersion} RestoreVersion instance
         */
        RestoreVersion.create = function create(properties) {
            return new RestoreVersion(properties);
        };

        /**
         * Encodes the specified RestoreVersion message. Does not implicitly {@link request.RestoreVersion.verify|verify} messages.
         * @function encode
         * @memberof request.RestoreVersion
         * @static
         * @param {request.IRestoreVersion} message RestoreVersion message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RestoreVersion.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.fileuuid != null && Object.hasOwnProperty.call(message, "fileuuid"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.fileuuid);
            if (message.versionId != null && Object.hasOwnProperty.call(message, "versionId"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.versionId);
            return writer;
        };

        /**
         * Encodes the specified RestoreVersion message, length delimited. Does not implicitly {@link request.RestoreVersion.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.RestoreVersion
         * @static
         * @param {request.IRestoreVersion} message RestoreVersion message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RestoreVersion.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RestoreVersion message from the specified reader or buffer.
         * @function decode
         * @memberof request.RestoreVersion
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.RestoreVersion} RestoreVersion
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RestoreVersion.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.RestoreVersion();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.fileuuid = reader.bytes();
                        break;
                    }
                case 2: {
                        message.versionId = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RestoreVersion message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.RestoreVersion
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.RestoreVersion} RestoreVersion
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RestoreVersion.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RestoreVersion message.
         * @function verify
         * @memberof request.RestoreVersion
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RestoreVersion.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.fileuuid != null && message.hasOwnProperty("fileuuid"))
                if (!(message.fileuuid && typeof message.fileuuid.length === "number" || $util.isString(message.fileuuid)))
                    return "fileuuid: buffer expected";
            if (message.versionId != null && message.hasOwnProperty("versionId"))
                if (!$util.isString(message.versionId))
                    return "versionId: string expected";
            return null;
        };

        /**
         * Creates a RestoreVersion message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.RestoreVersion
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.RestoreVersion} RestoreVersion
         */
        RestoreVersion.fromObject = function fromObject(object) {
            if (object instanceof $root.request.RestoreVersion)
                return object;
            let message = new $root.request.RestoreVersion();
            if (object.fileuuid != null)
                if (typeof object.fileuuid === "string")
                    $util.base64.decode(object.fileuuid, message.fileuuid = $util.newBuffer($util.base64.length(object.fileuuid)), 0);
                else if (object.fileuuid.length >= 0)
                    message.fileuuid = object.fileuuid;
            if (object.versionId != null)
                message.versionId = String(object.versionId);
            return message;
        };

        /**
         * Creates a plain object from a RestoreVersion message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.RestoreVersion
         * @static
         * @param {request.RestoreVersion} message RestoreVersion
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RestoreVersion.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if (options.bytes === String)
                    object.fileuuid = "";
                else {
                    object.fileuuid = [];
                    if (options.bytes !== Array)
                        object.fileuuid = $util.newBuffer(object.fileuuid);
                }
                object.versionId = "";
            }
            if (message.fileuuid != null && message.hasOwnProperty("fileuuid"))
                object.fileuuid = options.bytes === String ? $util.base64.encode(message.fileuuid, 0, message.fileuuid.length) : options.bytes === Array ? Array.prototype.slice.call(message.fileuuid) : message.fileuuid;
            if (message.versionId != null && message.hasOwnProperty("versionId"))
                object.versionId = message.versionId;
            return object;
        };

        /**
         * Converts this RestoreVersion to JSON.
         * @function toJSON
         * @memberof request.RestoreVersion
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RestoreVersion.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for RestoreVersion
         * @function getTypeUrl
         * @memberof request.RestoreVersion
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        RestoreVersion.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.RestoreVersion";
        };

        return RestoreVersion;
    })();

    request.RemoveFile = (function() {

        /**
         * Properties of a RemoveFile.
         * @memberof request
         * @interface IRemoveFile
         * @property {string|null} [fileFullPath] RemoveFile fileFullPath
         * @property {boolean|null} [isPerm] RemoveFile isPerm
         */

        /**
         * Constructs a new RemoveFile.
         * @memberof request
         * @classdesc Represents a RemoveFile.
         * @implements IRemoveFile
         * @constructor
         * @param {request.IRemoveFile=} [properties] Properties to set
         */
        function RemoveFile(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveFile fileFullPath.
         * @member {string} fileFullPath
         * @memberof request.RemoveFile
         * @instance
         */
        RemoveFile.prototype.fileFullPath = "";

        /**
         * RemoveFile isPerm.
         * @member {boolean} isPerm
         * @memberof request.RemoveFile
         * @instance
         */
        RemoveFile.prototype.isPerm = false;

        /**
         * Creates a new RemoveFile instance using the specified properties.
         * @function create
         * @memberof request.RemoveFile
         * @static
         * @param {request.IRemoveFile=} [properties] Properties to set
         * @returns {request.RemoveFile} RemoveFile instance
         */
        RemoveFile.create = function create(properties) {
            return new RemoveFile(properties);
        };

        /**
         * Encodes the specified RemoveFile message. Does not implicitly {@link request.RemoveFile.verify|verify} messages.
         * @function encode
         * @memberof request.RemoveFile
         * @static
         * @param {request.IRemoveFile} message RemoveFile message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RemoveFile.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.fileFullPath != null && Object.hasOwnProperty.call(message, "fileFullPath"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.fileFullPath);
            if (message.isPerm != null && Object.hasOwnProperty.call(message, "isPerm"))
                writer.uint32(/* id 2, wireType 0 =*/16).bool(message.isPerm);
            return writer;
        };

        /**
         * Encodes the specified RemoveFile message, length delimited. Does not implicitly {@link request.RemoveFile.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.RemoveFile
         * @static
         * @param {request.IRemoveFile} message RemoveFile message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RemoveFile.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RemoveFile message from the specified reader or buffer.
         * @function decode
         * @memberof request.RemoveFile
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.RemoveFile} RemoveFile
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RemoveFile.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.RemoveFile();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.fileFullPath = reader.string();
                        break;
                    }
                case 2: {
                        message.isPerm = reader.bool();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RemoveFile message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.RemoveFile
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.RemoveFile} RemoveFile
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RemoveFile.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RemoveFile message.
         * @function verify
         * @memberof request.RemoveFile
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RemoveFile.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.fileFullPath != null && message.hasOwnProperty("fileFullPath"))
                if (!$util.isString(message.fileFullPath))
                    return "fileFullPath: string expected";
            if (message.isPerm != null && message.hasOwnProperty("isPerm"))
                if (typeof message.isPerm !== "boolean")
                    return "isPerm: boolean expected";
            return null;
        };

        /**
         * Creates a RemoveFile message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.RemoveFile
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.RemoveFile} RemoveFile
         */
        RemoveFile.fromObject = function fromObject(object) {
            if (object instanceof $root.request.RemoveFile)
                return object;
            let message = new $root.request.RemoveFile();
            if (object.fileFullPath != null)
                message.fileFullPath = String(object.fileFullPath);
            if (object.isPerm != null)
                message.isPerm = Boolean(object.isPerm);
            return message;
        };

        /**
         * Creates a plain object from a RemoveFile message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.RemoveFile
         * @static
         * @param {request.RemoveFile} message RemoveFile
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveFile.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.fileFullPath = "";
                object.isPerm = false;
            }
            if (message.fileFullPath != null && message.hasOwnProperty("fileFullPath"))
                object.fileFullPath = message.fileFullPath;
            if (message.isPerm != null && message.hasOwnProperty("isPerm"))
                object.isPerm = message.isPerm;
            return object;
        };

        /**
         * Converts this RemoveFile to JSON.
         * @function toJSON
         * @memberof request.RemoveFile
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveFile.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for RemoveFile
         * @function getTypeUrl
         * @memberof request.RemoveFile
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        RemoveFile.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.RemoveFile";
        };

        return RemoveFile;
    })();

    request.RemoveFolder = (function() {

        /**
         * Properties of a RemoveFolder.
         * @memberof request
         * @interface IRemoveFolder
         * @property {string|null} [folderFullPath] RemoveFolder folderFullPath
         * @property {boolean|null} [isPerm] RemoveFolder isPerm
         */

        /**
         * Constructs a new RemoveFolder.
         * @memberof request
         * @classdesc Represents a RemoveFolder.
         * @implements IRemoveFolder
         * @constructor
         * @param {request.IRemoveFolder=} [properties] Properties to set
         */
        function RemoveFolder(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveFolder folderFullPath.
         * @member {string} folderFullPath
         * @memberof request.RemoveFolder
         * @instance
         */
        RemoveFolder.prototype.folderFullPath = "";

        /**
         * RemoveFolder isPerm.
         * @member {boolean} isPerm
         * @memberof request.RemoveFolder
         * @instance
         */
        RemoveFolder.prototype.isPerm = false;

        /**
         * Creates a new RemoveFolder instance using the specified properties.
         * @function create
         * @memberof request.RemoveFolder
         * @static
         * @param {request.IRemoveFolder=} [properties] Properties to set
         * @returns {request.RemoveFolder} RemoveFolder instance
         */
        RemoveFolder.create = function create(properties) {
            return new RemoveFolder(properties);
        };

        /**
         * Encodes the specified RemoveFolder message. Does not implicitly {@link request.RemoveFolder.verify|verify} messages.
         * @function encode
         * @memberof request.RemoveFolder
         * @static
         * @param {request.IRemoveFolder} message RemoveFolder message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RemoveFolder.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.folderFullPath != null && Object.hasOwnProperty.call(message, "folderFullPath"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.folderFullPath);
            if (message.isPerm != null && Object.hasOwnProperty.call(message, "isPerm"))
                writer.uint32(/* id 2, wireType 0 =*/16).bool(message.isPerm);
            return writer;
        };

        /**
         * Encodes the specified RemoveFolder message, length delimited. Does not implicitly {@link request.RemoveFolder.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.RemoveFolder
         * @static
         * @param {request.IRemoveFolder} message RemoveFolder message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RemoveFolder.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RemoveFolder message from the specified reader or buffer.
         * @function decode
         * @memberof request.RemoveFolder
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.RemoveFolder} RemoveFolder
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RemoveFolder.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.RemoveFolder();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.folderFullPath = reader.string();
                        break;
                    }
                case 2: {
                        message.isPerm = reader.bool();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RemoveFolder message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.RemoveFolder
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.RemoveFolder} RemoveFolder
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RemoveFolder.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RemoveFolder message.
         * @function verify
         * @memberof request.RemoveFolder
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RemoveFolder.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.folderFullPath != null && message.hasOwnProperty("folderFullPath"))
                if (!$util.isString(message.folderFullPath))
                    return "folderFullPath: string expected";
            if (message.isPerm != null && message.hasOwnProperty("isPerm"))
                if (typeof message.isPerm !== "boolean")
                    return "isPerm: boolean expected";
            return null;
        };

        /**
         * Creates a RemoveFolder message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.RemoveFolder
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.RemoveFolder} RemoveFolder
         */
        RemoveFolder.fromObject = function fromObject(object) {
            if (object instanceof $root.request.RemoveFolder)
                return object;
            let message = new $root.request.RemoveFolder();
            if (object.folderFullPath != null)
                message.folderFullPath = String(object.folderFullPath);
            if (object.isPerm != null)
                message.isPerm = Boolean(object.isPerm);
            return message;
        };

        /**
         * Creates a plain object from a RemoveFolder message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.RemoveFolder
         * @static
         * @param {request.RemoveFolder} message RemoveFolder
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveFolder.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.folderFullPath = "";
                object.isPerm = false;
            }
            if (message.folderFullPath != null && message.hasOwnProperty("folderFullPath"))
                object.folderFullPath = message.folderFullPath;
            if (message.isPerm != null && message.hasOwnProperty("isPerm"))
                object.isPerm = message.isPerm;
            return object;
        };

        /**
         * Converts this RemoveFolder to JSON.
         * @function toJSON
         * @memberof request.RemoveFolder
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveFolder.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for RemoveFolder
         * @function getTypeUrl
         * @memberof request.RemoveFolder
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        RemoveFolder.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.RemoveFolder";
        };

        return RemoveFolder;
    })();

    request.UntrashFile = (function() {

        /**
         * Properties of an UntrashFile.
         * @memberof request
         * @interface IUntrashFile
         * @property {string|null} [fileFullPath] UntrashFile fileFullPath
         */

        /**
         * Constructs a new UntrashFile.
         * @memberof request
         * @classdesc Represents an UntrashFile.
         * @implements IUntrashFile
         * @constructor
         * @param {request.IUntrashFile=} [properties] Properties to set
         */
        function UntrashFile(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UntrashFile fileFullPath.
         * @member {string} fileFullPath
         * @memberof request.UntrashFile
         * @instance
         */
        UntrashFile.prototype.fileFullPath = "";

        /**
         * Creates a new UntrashFile instance using the specified properties.
         * @function create
         * @memberof request.UntrashFile
         * @static
         * @param {request.IUntrashFile=} [properties] Properties to set
         * @returns {request.UntrashFile} UntrashFile instance
         */
        UntrashFile.create = function create(properties) {
            return new UntrashFile(properties);
        };

        /**
         * Encodes the specified UntrashFile message. Does not implicitly {@link request.UntrashFile.verify|verify} messages.
         * @function encode
         * @memberof request.UntrashFile
         * @static
         * @param {request.IUntrashFile} message UntrashFile message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UntrashFile.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.fileFullPath != null && Object.hasOwnProperty.call(message, "fileFullPath"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.fileFullPath);
            return writer;
        };

        /**
         * Encodes the specified UntrashFile message, length delimited. Does not implicitly {@link request.UntrashFile.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.UntrashFile
         * @static
         * @param {request.IUntrashFile} message UntrashFile message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UntrashFile.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UntrashFile message from the specified reader or buffer.
         * @function decode
         * @memberof request.UntrashFile
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.UntrashFile} UntrashFile
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UntrashFile.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.UntrashFile();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.fileFullPath = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UntrashFile message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.UntrashFile
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.UntrashFile} UntrashFile
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UntrashFile.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UntrashFile message.
         * @function verify
         * @memberof request.UntrashFile
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UntrashFile.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.fileFullPath != null && message.hasOwnProperty("fileFullPath"))
                if (!$util.isString(message.fileFullPath))
                    return "fileFullPath: string expected";
            return null;
        };

        /**
         * Creates an UntrashFile message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.UntrashFile
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.UntrashFile} UntrashFile
         */
        UntrashFile.fromObject = function fromObject(object) {
            if (object instanceof $root.request.UntrashFile)
                return object;
            let message = new $root.request.UntrashFile();
            if (object.fileFullPath != null)
                message.fileFullPath = String(object.fileFullPath);
            return message;
        };

        /**
         * Creates a plain object from an UntrashFile message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.UntrashFile
         * @static
         * @param {request.UntrashFile} message UntrashFile
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UntrashFile.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.fileFullPath = "";
            if (message.fileFullPath != null && message.hasOwnProperty("fileFullPath"))
                object.fileFullPath = message.fileFullPath;
            return object;
        };

        /**
         * Converts this UntrashFile to JSON.
         * @function toJSON
         * @memberof request.UntrashFile
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UntrashFile.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for UntrashFile
         * @function getTypeUrl
         * @memberof request.UntrashFile
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        UntrashFile.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.UntrashFile";
        };

        return UntrashFile;
    })();

    request.UntrashFolder = (function() {

        /**
         * Properties of an UntrashFolder.
         * @memberof request
         * @interface IUntrashFolder
         * @property {string|null} [folderFullPath] UntrashFolder folderFullPath
         */

        /**
         * Constructs a new UntrashFolder.
         * @memberof request
         * @classdesc Represents an UntrashFolder.
         * @implements IUntrashFolder
         * @constructor
         * @param {request.IUntrashFolder=} [properties] Properties to set
         */
        function UntrashFolder(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UntrashFolder folderFullPath.
         * @member {string} folderFullPath
         * @memberof request.UntrashFolder
         * @instance
         */
        UntrashFolder.prototype.folderFullPath = "";

        /**
         * Creates a new UntrashFolder instance using the specified properties.
         * @function create
         * @memberof request.UntrashFolder
         * @static
         * @param {request.IUntrashFolder=} [properties] Properties to set
         * @returns {request.UntrashFolder} UntrashFolder instance
         */
        UntrashFolder.create = function create(properties) {
            return new UntrashFolder(properties);
        };

        /**
         * Encodes the specified UntrashFolder message. Does not implicitly {@link request.UntrashFolder.verify|verify} messages.
         * @function encode
         * @memberof request.UntrashFolder
         * @static
         * @param {request.IUntrashFolder} message UntrashFolder message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UntrashFolder.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.folderFullPath != null && Object.hasOwnProperty.call(message, "folderFullPath"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.folderFullPath);
            return writer;
        };

        /**
         * Encodes the specified UntrashFolder message, length delimited. Does not implicitly {@link request.UntrashFolder.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.UntrashFolder
         * @static
         * @param {request.IUntrashFolder} message UntrashFolder message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UntrashFolder.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UntrashFolder message from the specified reader or buffer.
         * @function decode
         * @memberof request.UntrashFolder
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.UntrashFolder} UntrashFolder
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UntrashFolder.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.UntrashFolder();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.folderFullPath = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UntrashFolder message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.UntrashFolder
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.UntrashFolder} UntrashFolder
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UntrashFolder.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UntrashFolder message.
         * @function verify
         * @memberof request.UntrashFolder
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UntrashFolder.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.folderFullPath != null && message.hasOwnProperty("folderFullPath"))
                if (!$util.isString(message.folderFullPath))
                    return "folderFullPath: string expected";
            return null;
        };

        /**
         * Creates an UntrashFolder message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.UntrashFolder
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.UntrashFolder} UntrashFolder
         */
        UntrashFolder.fromObject = function fromObject(object) {
            if (object instanceof $root.request.UntrashFolder)
                return object;
            let message = new $root.request.UntrashFolder();
            if (object.folderFullPath != null)
                message.folderFullPath = String(object.folderFullPath);
            return message;
        };

        /**
         * Creates a plain object from an UntrashFolder message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.UntrashFolder
         * @static
         * @param {request.UntrashFolder} message UntrashFolder
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UntrashFolder.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.folderFullPath = "";
            if (message.folderFullPath != null && message.hasOwnProperty("folderFullPath"))
                object.folderFullPath = message.folderFullPath;
            return object;
        };

        /**
         * Converts this UntrashFolder to JSON.
         * @function toJSON
         * @memberof request.UntrashFolder
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UntrashFolder.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for UntrashFolder
         * @function getTypeUrl
         * @memberof request.UntrashFolder
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        UntrashFolder.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.UntrashFolder";
        };

        return UntrashFolder;
    })();

    request.UndoStartWrite = (function() {

        /**
         * Properties of an UndoStartWrite.
         * @memberof request
         * @interface IUndoStartWrite
         * @property {Uint8Array|null} [fileuuid] UndoStartWrite fileuuid
         */

        /**
         * Constructs a new UndoStartWrite.
         * @memberof request
         * @classdesc Represents an UndoStartWrite.
         * @implements IUndoStartWrite
         * @constructor
         * @param {request.IUndoStartWrite=} [properties] Properties to set
         */
        function UndoStartWrite(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UndoStartWrite fileuuid.
         * @member {Uint8Array} fileuuid
         * @memberof request.UndoStartWrite
         * @instance
         */
        UndoStartWrite.prototype.fileuuid = $util.newBuffer([]);

        /**
         * Creates a new UndoStartWrite instance using the specified properties.
         * @function create
         * @memberof request.UndoStartWrite
         * @static
         * @param {request.IUndoStartWrite=} [properties] Properties to set
         * @returns {request.UndoStartWrite} UndoStartWrite instance
         */
        UndoStartWrite.create = function create(properties) {
            return new UndoStartWrite(properties);
        };

        /**
         * Encodes the specified UndoStartWrite message. Does not implicitly {@link request.UndoStartWrite.verify|verify} messages.
         * @function encode
         * @memberof request.UndoStartWrite
         * @static
         * @param {request.IUndoStartWrite} message UndoStartWrite message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UndoStartWrite.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.fileuuid != null && Object.hasOwnProperty.call(message, "fileuuid"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.fileuuid);
            return writer;
        };

        /**
         * Encodes the specified UndoStartWrite message, length delimited. Does not implicitly {@link request.UndoStartWrite.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.UndoStartWrite
         * @static
         * @param {request.IUndoStartWrite} message UndoStartWrite message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UndoStartWrite.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UndoStartWrite message from the specified reader or buffer.
         * @function decode
         * @memberof request.UndoStartWrite
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.UndoStartWrite} UndoStartWrite
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UndoStartWrite.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.UndoStartWrite();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.fileuuid = reader.bytes();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UndoStartWrite message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.UndoStartWrite
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.UndoStartWrite} UndoStartWrite
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UndoStartWrite.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UndoStartWrite message.
         * @function verify
         * @memberof request.UndoStartWrite
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UndoStartWrite.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.fileuuid != null && message.hasOwnProperty("fileuuid"))
                if (!(message.fileuuid && typeof message.fileuuid.length === "number" || $util.isString(message.fileuuid)))
                    return "fileuuid: buffer expected";
            return null;
        };

        /**
         * Creates an UndoStartWrite message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.UndoStartWrite
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.UndoStartWrite} UndoStartWrite
         */
        UndoStartWrite.fromObject = function fromObject(object) {
            if (object instanceof $root.request.UndoStartWrite)
                return object;
            let message = new $root.request.UndoStartWrite();
            if (object.fileuuid != null)
                if (typeof object.fileuuid === "string")
                    $util.base64.decode(object.fileuuid, message.fileuuid = $util.newBuffer($util.base64.length(object.fileuuid)), 0);
                else if (object.fileuuid.length >= 0)
                    message.fileuuid = object.fileuuid;
            return message;
        };

        /**
         * Creates a plain object from an UndoStartWrite message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.UndoStartWrite
         * @static
         * @param {request.UndoStartWrite} message UndoStartWrite
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UndoStartWrite.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                if (options.bytes === String)
                    object.fileuuid = "";
                else {
                    object.fileuuid = [];
                    if (options.bytes !== Array)
                        object.fileuuid = $util.newBuffer(object.fileuuid);
                }
            if (message.fileuuid != null && message.hasOwnProperty("fileuuid"))
                object.fileuuid = options.bytes === String ? $util.base64.encode(message.fileuuid, 0, message.fileuuid.length) : options.bytes === Array ? Array.prototype.slice.call(message.fileuuid) : message.fileuuid;
            return object;
        };

        /**
         * Converts this UndoStartWrite to JSON.
         * @function toJSON
         * @memberof request.UndoStartWrite
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UndoStartWrite.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for UndoStartWrite
         * @function getTypeUrl
         * @memberof request.UndoStartWrite
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        UndoStartWrite.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.UndoStartWrite";
        };

        return UndoStartWrite;
    })();

    request.DetachClonedFolder = (function() {

        /**
         * Properties of a DetachClonedFolder.
         * @memberof request
         * @interface IDetachClonedFolder
         * @property {string|null} [snapshotId] DetachClonedFolder snapshotId
         * @property {Uint8Array|null} [folderUuid] DetachClonedFolder folderUuid
         */

        /**
         * Constructs a new DetachClonedFolder.
         * @memberof request
         * @classdesc Represents a DetachClonedFolder.
         * @implements IDetachClonedFolder
         * @constructor
         * @param {request.IDetachClonedFolder=} [properties] Properties to set
         */
        function DetachClonedFolder(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DetachClonedFolder snapshotId.
         * @member {string} snapshotId
         * @memberof request.DetachClonedFolder
         * @instance
         */
        DetachClonedFolder.prototype.snapshotId = "";

        /**
         * DetachClonedFolder folderUuid.
         * @member {Uint8Array} folderUuid
         * @memberof request.DetachClonedFolder
         * @instance
         */
        DetachClonedFolder.prototype.folderUuid = $util.newBuffer([]);

        /**
         * Creates a new DetachClonedFolder instance using the specified properties.
         * @function create
         * @memberof request.DetachClonedFolder
         * @static
         * @param {request.IDetachClonedFolder=} [properties] Properties to set
         * @returns {request.DetachClonedFolder} DetachClonedFolder instance
         */
        DetachClonedFolder.create = function create(properties) {
            return new DetachClonedFolder(properties);
        };

        /**
         * Encodes the specified DetachClonedFolder message. Does not implicitly {@link request.DetachClonedFolder.verify|verify} messages.
         * @function encode
         * @memberof request.DetachClonedFolder
         * @static
         * @param {request.IDetachClonedFolder} message DetachClonedFolder message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DetachClonedFolder.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.snapshotId != null && Object.hasOwnProperty.call(message, "snapshotId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.snapshotId);
            if (message.folderUuid != null && Object.hasOwnProperty.call(message, "folderUuid"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.folderUuid);
            return writer;
        };

        /**
         * Encodes the specified DetachClonedFolder message, length delimited. Does not implicitly {@link request.DetachClonedFolder.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.DetachClonedFolder
         * @static
         * @param {request.IDetachClonedFolder} message DetachClonedFolder message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DetachClonedFolder.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a DetachClonedFolder message from the specified reader or buffer.
         * @function decode
         * @memberof request.DetachClonedFolder
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.DetachClonedFolder} DetachClonedFolder
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DetachClonedFolder.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.DetachClonedFolder();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.snapshotId = reader.string();
                        break;
                    }
                case 2: {
                        message.folderUuid = reader.bytes();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a DetachClonedFolder message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.DetachClonedFolder
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.DetachClonedFolder} DetachClonedFolder
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DetachClonedFolder.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a DetachClonedFolder message.
         * @function verify
         * @memberof request.DetachClonedFolder
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        DetachClonedFolder.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.snapshotId != null && message.hasOwnProperty("snapshotId"))
                if (!$util.isString(message.snapshotId))
                    return "snapshotId: string expected";
            if (message.folderUuid != null && message.hasOwnProperty("folderUuid"))
                if (!(message.folderUuid && typeof message.folderUuid.length === "number" || $util.isString(message.folderUuid)))
                    return "folderUuid: buffer expected";
            return null;
        };

        /**
         * Creates a DetachClonedFolder message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.DetachClonedFolder
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.DetachClonedFolder} DetachClonedFolder
         */
        DetachClonedFolder.fromObject = function fromObject(object) {
            if (object instanceof $root.request.DetachClonedFolder)
                return object;
            let message = new $root.request.DetachClonedFolder();
            if (object.snapshotId != null)
                message.snapshotId = String(object.snapshotId);
            if (object.folderUuid != null)
                if (typeof object.folderUuid === "string")
                    $util.base64.decode(object.folderUuid, message.folderUuid = $util.newBuffer($util.base64.length(object.folderUuid)), 0);
                else if (object.folderUuid.length >= 0)
                    message.folderUuid = object.folderUuid;
            return message;
        };

        /**
         * Creates a plain object from a DetachClonedFolder message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.DetachClonedFolder
         * @static
         * @param {request.DetachClonedFolder} message DetachClonedFolder
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DetachClonedFolder.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.snapshotId = "";
                if (options.bytes === String)
                    object.folderUuid = "";
                else {
                    object.folderUuid = [];
                    if (options.bytes !== Array)
                        object.folderUuid = $util.newBuffer(object.folderUuid);
                }
            }
            if (message.snapshotId != null && message.hasOwnProperty("snapshotId"))
                object.snapshotId = message.snapshotId;
            if (message.folderUuid != null && message.hasOwnProperty("folderUuid"))
                object.folderUuid = options.bytes === String ? $util.base64.encode(message.folderUuid, 0, message.folderUuid.length) : options.bytes === Array ? Array.prototype.slice.call(message.folderUuid) : message.folderUuid;
            return object;
        };

        /**
         * Converts this DetachClonedFolder to JSON.
         * @function toJSON
         * @memberof request.DetachClonedFolder
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DetachClonedFolder.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for DetachClonedFolder
         * @function getTypeUrl
         * @memberof request.DetachClonedFolder
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        DetachClonedFolder.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.DetachClonedFolder";
        };

        return DetachClonedFolder;
    })();

    request.RenameFile = (function() {

        /**
         * Properties of a RenameFile.
         * @memberof request
         * @interface IRenameFile
         * @property {string|null} [filePath] RenameFile filePath
         * @property {string|null} [newName] RenameFile newName
         */

        /**
         * Constructs a new RenameFile.
         * @memberof request
         * @classdesc Represents a RenameFile.
         * @implements IRenameFile
         * @constructor
         * @param {request.IRenameFile=} [properties] Properties to set
         */
        function RenameFile(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RenameFile filePath.
         * @member {string} filePath
         * @memberof request.RenameFile
         * @instance
         */
        RenameFile.prototype.filePath = "";

        /**
         * RenameFile newName.
         * @member {string} newName
         * @memberof request.RenameFile
         * @instance
         */
        RenameFile.prototype.newName = "";

        /**
         * Creates a new RenameFile instance using the specified properties.
         * @function create
         * @memberof request.RenameFile
         * @static
         * @param {request.IRenameFile=} [properties] Properties to set
         * @returns {request.RenameFile} RenameFile instance
         */
        RenameFile.create = function create(properties) {
            return new RenameFile(properties);
        };

        /**
         * Encodes the specified RenameFile message. Does not implicitly {@link request.RenameFile.verify|verify} messages.
         * @function encode
         * @memberof request.RenameFile
         * @static
         * @param {request.IRenameFile} message RenameFile message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RenameFile.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.filePath != null && Object.hasOwnProperty.call(message, "filePath"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.filePath);
            if (message.newName != null && Object.hasOwnProperty.call(message, "newName"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.newName);
            return writer;
        };

        /**
         * Encodes the specified RenameFile message, length delimited. Does not implicitly {@link request.RenameFile.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.RenameFile
         * @static
         * @param {request.IRenameFile} message RenameFile message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RenameFile.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RenameFile message from the specified reader or buffer.
         * @function decode
         * @memberof request.RenameFile
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.RenameFile} RenameFile
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RenameFile.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.RenameFile();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.filePath = reader.string();
                        break;
                    }
                case 2: {
                        message.newName = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RenameFile message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.RenameFile
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.RenameFile} RenameFile
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RenameFile.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RenameFile message.
         * @function verify
         * @memberof request.RenameFile
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RenameFile.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.filePath != null && message.hasOwnProperty("filePath"))
                if (!$util.isString(message.filePath))
                    return "filePath: string expected";
            if (message.newName != null && message.hasOwnProperty("newName"))
                if (!$util.isString(message.newName))
                    return "newName: string expected";
            return null;
        };

        /**
         * Creates a RenameFile message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.RenameFile
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.RenameFile} RenameFile
         */
        RenameFile.fromObject = function fromObject(object) {
            if (object instanceof $root.request.RenameFile)
                return object;
            let message = new $root.request.RenameFile();
            if (object.filePath != null)
                message.filePath = String(object.filePath);
            if (object.newName != null)
                message.newName = String(object.newName);
            return message;
        };

        /**
         * Creates a plain object from a RenameFile message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.RenameFile
         * @static
         * @param {request.RenameFile} message RenameFile
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RenameFile.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.filePath = "";
                object.newName = "";
            }
            if (message.filePath != null && message.hasOwnProperty("filePath"))
                object.filePath = message.filePath;
            if (message.newName != null && message.hasOwnProperty("newName"))
                object.newName = message.newName;
            return object;
        };

        /**
         * Converts this RenameFile to JSON.
         * @function toJSON
         * @memberof request.RenameFile
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RenameFile.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for RenameFile
         * @function getTypeUrl
         * @memberof request.RenameFile
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        RenameFile.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.RenameFile";
        };

        return RenameFile;
    })();

    request.RenameFolder = (function() {

        /**
         * Properties of a RenameFolder.
         * @memberof request
         * @interface IRenameFolder
         * @property {string|null} [folderPath] RenameFolder folderPath
         * @property {string|null} [newName] RenameFolder newName
         */

        /**
         * Constructs a new RenameFolder.
         * @memberof request
         * @classdesc Represents a RenameFolder.
         * @implements IRenameFolder
         * @constructor
         * @param {request.IRenameFolder=} [properties] Properties to set
         */
        function RenameFolder(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RenameFolder folderPath.
         * @member {string} folderPath
         * @memberof request.RenameFolder
         * @instance
         */
        RenameFolder.prototype.folderPath = "";

        /**
         * RenameFolder newName.
         * @member {string} newName
         * @memberof request.RenameFolder
         * @instance
         */
        RenameFolder.prototype.newName = "";

        /**
         * Creates a new RenameFolder instance using the specified properties.
         * @function create
         * @memberof request.RenameFolder
         * @static
         * @param {request.IRenameFolder=} [properties] Properties to set
         * @returns {request.RenameFolder} RenameFolder instance
         */
        RenameFolder.create = function create(properties) {
            return new RenameFolder(properties);
        };

        /**
         * Encodes the specified RenameFolder message. Does not implicitly {@link request.RenameFolder.verify|verify} messages.
         * @function encode
         * @memberof request.RenameFolder
         * @static
         * @param {request.IRenameFolder} message RenameFolder message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RenameFolder.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.folderPath != null && Object.hasOwnProperty.call(message, "folderPath"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.folderPath);
            if (message.newName != null && Object.hasOwnProperty.call(message, "newName"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.newName);
            return writer;
        };

        /**
         * Encodes the specified RenameFolder message, length delimited. Does not implicitly {@link request.RenameFolder.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.RenameFolder
         * @static
         * @param {request.IRenameFolder} message RenameFolder message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RenameFolder.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RenameFolder message from the specified reader or buffer.
         * @function decode
         * @memberof request.RenameFolder
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.RenameFolder} RenameFolder
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RenameFolder.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.RenameFolder();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.folderPath = reader.string();
                        break;
                    }
                case 2: {
                        message.newName = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RenameFolder message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.RenameFolder
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.RenameFolder} RenameFolder
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RenameFolder.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RenameFolder message.
         * @function verify
         * @memberof request.RenameFolder
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RenameFolder.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.folderPath != null && message.hasOwnProperty("folderPath"))
                if (!$util.isString(message.folderPath))
                    return "folderPath: string expected";
            if (message.newName != null && message.hasOwnProperty("newName"))
                if (!$util.isString(message.newName))
                    return "newName: string expected";
            return null;
        };

        /**
         * Creates a RenameFolder message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.RenameFolder
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.RenameFolder} RenameFolder
         */
        RenameFolder.fromObject = function fromObject(object) {
            if (object instanceof $root.request.RenameFolder)
                return object;
            let message = new $root.request.RenameFolder();
            if (object.folderPath != null)
                message.folderPath = String(object.folderPath);
            if (object.newName != null)
                message.newName = String(object.newName);
            return message;
        };

        /**
         * Creates a plain object from a RenameFolder message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.RenameFolder
         * @static
         * @param {request.RenameFolder} message RenameFolder
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RenameFolder.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.folderPath = "";
                object.newName = "";
            }
            if (message.folderPath != null && message.hasOwnProperty("folderPath"))
                object.folderPath = message.folderPath;
            if (message.newName != null && message.hasOwnProperty("newName"))
                object.newName = message.newName;
            return object;
        };

        /**
         * Converts this RenameFolder to JSON.
         * @function toJSON
         * @memberof request.RenameFolder
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RenameFolder.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for RenameFolder
         * @function getTypeUrl
         * @memberof request.RenameFolder
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        RenameFolder.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.RenameFolder";
        };

        return RenameFolder;
    })();

    /**
     * ListType enum.
     * @name request.ListType
     * @enum {number}
     * @property {number} Chunks=0 Chunks value
     * @property {number} FilesAndFolders=1 FilesAndFolders value
     * @property {number} Secrets=2 Secrets value
     * @property {number} Roles=3 Roles value
     * @property {number} Teams=4 Teams value
     * @property {number} Users=5 Users value
     * @property {number} AuditLogs=6 AuditLogs value
     */
    request.ListType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "Chunks"] = 0;
        values[valuesById[1] = "FilesAndFolders"] = 1;
        values[valuesById[2] = "Secrets"] = 2;
        values[valuesById[3] = "Roles"] = 3;
        values[valuesById[4] = "Teams"] = 4;
        values[valuesById[5] = "Users"] = 5;
        values[valuesById[6] = "AuditLogs"] = 6;
        return values;
    })();

    /**
     * TypeOfObj enum.
     * @name request.TypeOfObj
     * @enum {number}
     * @property {number} TypeFolder=0 TypeFolder value
     * @property {number} TypeFile=1 TypeFile value
     */
    request.TypeOfObj = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "TypeFolder"] = 0;
        values[valuesById[1] = "TypeFile"] = 1;
        return values;
    })();

    /**
     * TypeOfPath enum.
     * @name request.TypeOfPath
     * @enum {number}
     * @property {number} TShareUser=0 TShareUser value
     * @property {number} TFolder=1 TFolder value
     * @property {number} TShareTeam=2 TShareTeam value
     * @property {number} TShareExternal=3 TShareExternal value
     * @property {number} TFlow=4 TFlow value
     */
    request.TypeOfPath = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "TShareUser"] = 0;
        values[valuesById[1] = "TFolder"] = 1;
        values[valuesById[2] = "TShareTeam"] = 2;
        values[valuesById[3] = "TShareExternal"] = 3;
        values[valuesById[4] = "TFlow"] = 4;
        return values;
    })();

    request.ListPins = (function() {

        /**
         * Properties of a ListPins.
         * @memberof request
         * @interface IListPins
         * @property {Uint8Array|null} [pageToken] ListPins pageToken
         * @property {number|Long|null} [pageSize] ListPins pageSize
         */

        /**
         * Constructs a new ListPins.
         * @memberof request
         * @classdesc Represents a ListPins.
         * @implements IListPins
         * @constructor
         * @param {request.IListPins=} [properties] Properties to set
         */
        function ListPins(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListPins pageToken.
         * @member {Uint8Array|null|undefined} pageToken
         * @memberof request.ListPins
         * @instance
         */
        ListPins.prototype.pageToken = null;

        /**
         * ListPins pageSize.
         * @member {number|Long|null|undefined} pageSize
         * @memberof request.ListPins
         * @instance
         */
        ListPins.prototype.pageSize = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(ListPins.prototype, "_pageToken", {
            get: $util.oneOfGetter($oneOfFields = ["pageToken"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(ListPins.prototype, "_pageSize", {
            get: $util.oneOfGetter($oneOfFields = ["pageSize"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new ListPins instance using the specified properties.
         * @function create
         * @memberof request.ListPins
         * @static
         * @param {request.IListPins=} [properties] Properties to set
         * @returns {request.ListPins} ListPins instance
         */
        ListPins.create = function create(properties) {
            return new ListPins(properties);
        };

        /**
         * Encodes the specified ListPins message. Does not implicitly {@link request.ListPins.verify|verify} messages.
         * @function encode
         * @memberof request.ListPins
         * @static
         * @param {request.IListPins} message ListPins message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListPins.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.pageToken);
            if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.pageSize);
            return writer;
        };

        /**
         * Encodes the specified ListPins message, length delimited. Does not implicitly {@link request.ListPins.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.ListPins
         * @static
         * @param {request.IListPins} message ListPins message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListPins.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ListPins message from the specified reader or buffer.
         * @function decode
         * @memberof request.ListPins
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.ListPins} ListPins
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListPins.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.ListPins();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.pageToken = reader.bytes();
                        break;
                    }
                case 2: {
                        message.pageSize = reader.uint64();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ListPins message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.ListPins
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.ListPins} ListPins
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListPins.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ListPins message.
         * @function verify
         * @memberof request.ListPins
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ListPins.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.pageToken != null && message.hasOwnProperty("pageToken")) {
                properties._pageToken = 1;
                if (!(message.pageToken && typeof message.pageToken.length === "number" || $util.isString(message.pageToken)))
                    return "pageToken: buffer expected";
            }
            if (message.pageSize != null && message.hasOwnProperty("pageSize")) {
                properties._pageSize = 1;
                if (!$util.isInteger(message.pageSize) && !(message.pageSize && $util.isInteger(message.pageSize.low) && $util.isInteger(message.pageSize.high)))
                    return "pageSize: integer|Long expected";
            }
            return null;
        };

        /**
         * Creates a ListPins message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.ListPins
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.ListPins} ListPins
         */
        ListPins.fromObject = function fromObject(object) {
            if (object instanceof $root.request.ListPins)
                return object;
            let message = new $root.request.ListPins();
            if (object.pageToken != null)
                if (typeof object.pageToken === "string")
                    $util.base64.decode(object.pageToken, message.pageToken = $util.newBuffer($util.base64.length(object.pageToken)), 0);
                else if (object.pageToken.length >= 0)
                    message.pageToken = object.pageToken;
            if (object.pageSize != null)
                if ($util.Long)
                    (message.pageSize = $util.Long.fromValue(object.pageSize)).unsigned = true;
                else if (typeof object.pageSize === "string")
                    message.pageSize = parseInt(object.pageSize, 10);
                else if (typeof object.pageSize === "number")
                    message.pageSize = object.pageSize;
                else if (typeof object.pageSize === "object")
                    message.pageSize = new $util.LongBits(object.pageSize.low >>> 0, object.pageSize.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a ListPins message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.ListPins
         * @static
         * @param {request.ListPins} message ListPins
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListPins.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (message.pageToken != null && message.hasOwnProperty("pageToken")) {
                object.pageToken = options.bytes === String ? $util.base64.encode(message.pageToken, 0, message.pageToken.length) : options.bytes === Array ? Array.prototype.slice.call(message.pageToken) : message.pageToken;
                if (options.oneofs)
                    object._pageToken = "pageToken";
            }
            if (message.pageSize != null && message.hasOwnProperty("pageSize")) {
                if (typeof message.pageSize === "number")
                    object.pageSize = options.longs === String ? String(message.pageSize) : message.pageSize;
                else
                    object.pageSize = options.longs === String ? $util.Long.prototype.toString.call(message.pageSize) : options.longs === Number ? new $util.LongBits(message.pageSize.low >>> 0, message.pageSize.high >>> 0).toNumber(true) : message.pageSize;
                if (options.oneofs)
                    object._pageSize = "pageSize";
            }
            return object;
        };

        /**
         * Converts this ListPins to JSON.
         * @function toJSON
         * @memberof request.ListPins
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListPins.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ListPins
         * @function getTypeUrl
         * @memberof request.ListPins
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ListPins.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.ListPins";
        };

        return ListPins;
    })();

    /**
     * SpaceOpPermissions enum.
     * @name request.SpaceOpPermissions
     * @enum {number}
     * @property {number} SpaceOpGetMetaFromPath=0 SpaceOpGetMetaFromPath value
     * @property {number} SpaceOpGetChunk=1 SpaceOpGetChunk value
     * @property {number} SpaceOpListFiles=2 SpaceOpListFiles value
     * @property {number} SpaceOpStartWrite=4 SpaceOpStartWrite value
     * @property {number} SpaceOpPutChunk=5 SpaceOpPutChunk value
     * @property {number} SpaceOpFinalizeWrite=6 SpaceOpFinalizeWrite value
     * @property {number} SpaceOpCreateFolder=7 SpaceOpCreateFolder value
     * @property {number} SpaceAddComment=11 SpaceAddComment value
     * @property {number} SpaceListComments=12 SpaceListComments value
     * @property {number} SpaceUpdateComment=13 SpaceUpdateComment value
     * @property {number} SpaceRemoveComment=14 SpaceRemoveComment value
     * @property {number} SpaceGetComment=15 SpaceGetComment value
     */
    request.SpaceOpPermissions = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "SpaceOpGetMetaFromPath"] = 0;
        values[valuesById[1] = "SpaceOpGetChunk"] = 1;
        values[valuesById[2] = "SpaceOpListFiles"] = 2;
        values[valuesById[4] = "SpaceOpStartWrite"] = 4;
        values[valuesById[5] = "SpaceOpPutChunk"] = 5;
        values[valuesById[6] = "SpaceOpFinalizeWrite"] = 6;
        values[valuesById[7] = "SpaceOpCreateFolder"] = 7;
        values[valuesById[11] = "SpaceAddComment"] = 11;
        values[valuesById[12] = "SpaceListComments"] = 12;
        values[valuesById[13] = "SpaceUpdateComment"] = 13;
        values[valuesById[14] = "SpaceRemoveComment"] = 14;
        values[valuesById[15] = "SpaceGetComment"] = 15;
        return values;
    })();

    /**
     * SpaceAutoDeletion enum.
     * @name request.SpaceAutoDeletion
     * @enum {number}
     * @property {number} REMOVE_USER=0 REMOVE_USER value
     * @property {number} REMOVE_OBJECT=1 REMOVE_OBJECT value
     * @property {number} REMOVE_SPACE=2 REMOVE_SPACE value
     */
    request.SpaceAutoDeletion = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "REMOVE_USER"] = 0;
        values[valuesById[1] = "REMOVE_OBJECT"] = 1;
        values[valuesById[2] = "REMOVE_SPACE"] = 2;
        return values;
    })();

    request.SpaceAutoObjectDeletion = (function() {

        /**
         * Properties of a SpaceAutoObjectDeletion.
         * @memberof request
         * @interface ISpaceAutoObjectDeletion
         * @property {string|null} [object] SpaceAutoObjectDeletion object
         * @property {number|Long|null} [time] SpaceAutoObjectDeletion time
         * @property {request.SpaceAutoDeletion|null} [spaceAutoDeletion] SpaceAutoObjectDeletion spaceAutoDeletion
         */

        /**
         * Constructs a new SpaceAutoObjectDeletion.
         * @memberof request
         * @classdesc Represents a SpaceAutoObjectDeletion.
         * @implements ISpaceAutoObjectDeletion
         * @constructor
         * @param {request.ISpaceAutoObjectDeletion=} [properties] Properties to set
         */
        function SpaceAutoObjectDeletion(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SpaceAutoObjectDeletion object.
         * @member {string} object
         * @memberof request.SpaceAutoObjectDeletion
         * @instance
         */
        SpaceAutoObjectDeletion.prototype.object = "";

        /**
         * SpaceAutoObjectDeletion time.
         * @member {number|Long} time
         * @memberof request.SpaceAutoObjectDeletion
         * @instance
         */
        SpaceAutoObjectDeletion.prototype.time = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * SpaceAutoObjectDeletion spaceAutoDeletion.
         * @member {request.SpaceAutoDeletion} spaceAutoDeletion
         * @memberof request.SpaceAutoObjectDeletion
         * @instance
         */
        SpaceAutoObjectDeletion.prototype.spaceAutoDeletion = 0;

        /**
         * Creates a new SpaceAutoObjectDeletion instance using the specified properties.
         * @function create
         * @memberof request.SpaceAutoObjectDeletion
         * @static
         * @param {request.ISpaceAutoObjectDeletion=} [properties] Properties to set
         * @returns {request.SpaceAutoObjectDeletion} SpaceAutoObjectDeletion instance
         */
        SpaceAutoObjectDeletion.create = function create(properties) {
            return new SpaceAutoObjectDeletion(properties);
        };

        /**
         * Encodes the specified SpaceAutoObjectDeletion message. Does not implicitly {@link request.SpaceAutoObjectDeletion.verify|verify} messages.
         * @function encode
         * @memberof request.SpaceAutoObjectDeletion
         * @static
         * @param {request.ISpaceAutoObjectDeletion} message SpaceAutoObjectDeletion message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SpaceAutoObjectDeletion.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.object != null && Object.hasOwnProperty.call(message, "object"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.object);
            if (message.time != null && Object.hasOwnProperty.call(message, "time"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.time);
            if (message.spaceAutoDeletion != null && Object.hasOwnProperty.call(message, "spaceAutoDeletion"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.spaceAutoDeletion);
            return writer;
        };

        /**
         * Encodes the specified SpaceAutoObjectDeletion message, length delimited. Does not implicitly {@link request.SpaceAutoObjectDeletion.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.SpaceAutoObjectDeletion
         * @static
         * @param {request.ISpaceAutoObjectDeletion} message SpaceAutoObjectDeletion message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SpaceAutoObjectDeletion.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SpaceAutoObjectDeletion message from the specified reader or buffer.
         * @function decode
         * @memberof request.SpaceAutoObjectDeletion
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.SpaceAutoObjectDeletion} SpaceAutoObjectDeletion
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SpaceAutoObjectDeletion.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.SpaceAutoObjectDeletion();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.object = reader.string();
                        break;
                    }
                case 2: {
                        message.time = reader.uint64();
                        break;
                    }
                case 3: {
                        message.spaceAutoDeletion = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SpaceAutoObjectDeletion message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.SpaceAutoObjectDeletion
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.SpaceAutoObjectDeletion} SpaceAutoObjectDeletion
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SpaceAutoObjectDeletion.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SpaceAutoObjectDeletion message.
         * @function verify
         * @memberof request.SpaceAutoObjectDeletion
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SpaceAutoObjectDeletion.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.object != null && message.hasOwnProperty("object"))
                if (!$util.isString(message.object))
                    return "object: string expected";
            if (message.time != null && message.hasOwnProperty("time"))
                if (!$util.isInteger(message.time) && !(message.time && $util.isInteger(message.time.low) && $util.isInteger(message.time.high)))
                    return "time: integer|Long expected";
            if (message.spaceAutoDeletion != null && message.hasOwnProperty("spaceAutoDeletion"))
                switch (message.spaceAutoDeletion) {
                default:
                    return "spaceAutoDeletion: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            return null;
        };

        /**
         * Creates a SpaceAutoObjectDeletion message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.SpaceAutoObjectDeletion
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.SpaceAutoObjectDeletion} SpaceAutoObjectDeletion
         */
        SpaceAutoObjectDeletion.fromObject = function fromObject(object) {
            if (object instanceof $root.request.SpaceAutoObjectDeletion)
                return object;
            let message = new $root.request.SpaceAutoObjectDeletion();
            if (object.object != null)
                message.object = String(object.object);
            if (object.time != null)
                if ($util.Long)
                    (message.time = $util.Long.fromValue(object.time)).unsigned = true;
                else if (typeof object.time === "string")
                    message.time = parseInt(object.time, 10);
                else if (typeof object.time === "number")
                    message.time = object.time;
                else if (typeof object.time === "object")
                    message.time = new $util.LongBits(object.time.low >>> 0, object.time.high >>> 0).toNumber(true);
            switch (object.spaceAutoDeletion) {
            default:
                if (typeof object.spaceAutoDeletion === "number") {
                    message.spaceAutoDeletion = object.spaceAutoDeletion;
                    break;
                }
                break;
            case "REMOVE_USER":
            case 0:
                message.spaceAutoDeletion = 0;
                break;
            case "REMOVE_OBJECT":
            case 1:
                message.spaceAutoDeletion = 1;
                break;
            case "REMOVE_SPACE":
            case 2:
                message.spaceAutoDeletion = 2;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a SpaceAutoObjectDeletion message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.SpaceAutoObjectDeletion
         * @static
         * @param {request.SpaceAutoObjectDeletion} message SpaceAutoObjectDeletion
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SpaceAutoObjectDeletion.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.object = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.time = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.time = options.longs === String ? "0" : 0;
                object.spaceAutoDeletion = options.enums === String ? "REMOVE_USER" : 0;
            }
            if (message.object != null && message.hasOwnProperty("object"))
                object.object = message.object;
            if (message.time != null && message.hasOwnProperty("time"))
                if (typeof message.time === "number")
                    object.time = options.longs === String ? String(message.time) : message.time;
                else
                    object.time = options.longs === String ? $util.Long.prototype.toString.call(message.time) : options.longs === Number ? new $util.LongBits(message.time.low >>> 0, message.time.high >>> 0).toNumber(true) : message.time;
            if (message.spaceAutoDeletion != null && message.hasOwnProperty("spaceAutoDeletion"))
                object.spaceAutoDeletion = options.enums === String ? $root.request.SpaceAutoDeletion[message.spaceAutoDeletion] === undefined ? message.spaceAutoDeletion : $root.request.SpaceAutoDeletion[message.spaceAutoDeletion] : message.spaceAutoDeletion;
            return object;
        };

        /**
         * Converts this SpaceAutoObjectDeletion to JSON.
         * @function toJSON
         * @memberof request.SpaceAutoObjectDeletion
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SpaceAutoObjectDeletion.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for SpaceAutoObjectDeletion
         * @function getTypeUrl
         * @memberof request.SpaceAutoObjectDeletion
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        SpaceAutoObjectDeletion.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.SpaceAutoObjectDeletion";
        };

        return SpaceAutoObjectDeletion;
    })();

    request.AddSpace = (function() {

        /**
         * Properties of an AddSpace.
         * @memberof request
         * @interface IAddSpace
         * @property {Array.<request.SpaceOpPermissions>|null} [operations] AddSpace operations
         * @property {string|null} [name] AddSpace name
         */

        /**
         * Constructs a new AddSpace.
         * @memberof request
         * @classdesc Represents an AddSpace.
         * @implements IAddSpace
         * @constructor
         * @param {request.IAddSpace=} [properties] Properties to set
         */
        function AddSpace(properties) {
            this.operations = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddSpace operations.
         * @member {Array.<request.SpaceOpPermissions>} operations
         * @memberof request.AddSpace
         * @instance
         */
        AddSpace.prototype.operations = $util.emptyArray;

        /**
         * AddSpace name.
         * @member {string} name
         * @memberof request.AddSpace
         * @instance
         */
        AddSpace.prototype.name = "";

        /**
         * Creates a new AddSpace instance using the specified properties.
         * @function create
         * @memberof request.AddSpace
         * @static
         * @param {request.IAddSpace=} [properties] Properties to set
         * @returns {request.AddSpace} AddSpace instance
         */
        AddSpace.create = function create(properties) {
            return new AddSpace(properties);
        };

        /**
         * Encodes the specified AddSpace message. Does not implicitly {@link request.AddSpace.verify|verify} messages.
         * @function encode
         * @memberof request.AddSpace
         * @static
         * @param {request.IAddSpace} message AddSpace message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddSpace.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.operations != null && message.operations.length) {
                writer.uint32(/* id 1, wireType 2 =*/10).fork();
                for (let i = 0; i < message.operations.length; ++i)
                    writer.int32(message.operations[i]);
                writer.ldelim();
            }
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
            return writer;
        };

        /**
         * Encodes the specified AddSpace message, length delimited. Does not implicitly {@link request.AddSpace.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.AddSpace
         * @static
         * @param {request.IAddSpace} message AddSpace message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddSpace.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AddSpace message from the specified reader or buffer.
         * @function decode
         * @memberof request.AddSpace
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.AddSpace} AddSpace
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddSpace.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.AddSpace();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        if (!(message.operations && message.operations.length))
                            message.operations = [];
                        if ((tag & 7) === 2) {
                            let end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.operations.push(reader.int32());
                        } else
                            message.operations.push(reader.int32());
                        break;
                    }
                case 2: {
                        message.name = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AddSpace message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.AddSpace
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.AddSpace} AddSpace
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddSpace.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AddSpace message.
         * @function verify
         * @memberof request.AddSpace
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AddSpace.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.operations != null && message.hasOwnProperty("operations")) {
                if (!Array.isArray(message.operations))
                    return "operations: array expected";
                for (let i = 0; i < message.operations.length; ++i)
                    switch (message.operations[i]) {
                    default:
                        return "operations: enum value[] expected";
                    case 0:
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                    case 11:
                    case 12:
                    case 13:
                    case 14:
                    case 15:
                        break;
                    }
            }
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            return null;
        };

        /**
         * Creates an AddSpace message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.AddSpace
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.AddSpace} AddSpace
         */
        AddSpace.fromObject = function fromObject(object) {
            if (object instanceof $root.request.AddSpace)
                return object;
            let message = new $root.request.AddSpace();
            if (object.operations) {
                if (!Array.isArray(object.operations))
                    throw TypeError(".request.AddSpace.operations: array expected");
                message.operations = [];
                for (let i = 0; i < object.operations.length; ++i)
                    switch (object.operations[i]) {
                    default:
                        if (typeof object.operations[i] === "number") {
                            message.operations[i] = object.operations[i];
                            break;
                        }
                    case "SpaceOpGetMetaFromPath":
                    case 0:
                        message.operations[i] = 0;
                        break;
                    case "SpaceOpGetChunk":
                    case 1:
                        message.operations[i] = 1;
                        break;
                    case "SpaceOpListFiles":
                    case 2:
                        message.operations[i] = 2;
                        break;
                    case "SpaceOpStartWrite":
                    case 4:
                        message.operations[i] = 4;
                        break;
                    case "SpaceOpPutChunk":
                    case 5:
                        message.operations[i] = 5;
                        break;
                    case "SpaceOpFinalizeWrite":
                    case 6:
                        message.operations[i] = 6;
                        break;
                    case "SpaceOpCreateFolder":
                    case 7:
                        message.operations[i] = 7;
                        break;
                    case "SpaceAddComment":
                    case 11:
                        message.operations[i] = 11;
                        break;
                    case "SpaceListComments":
                    case 12:
                        message.operations[i] = 12;
                        break;
                    case "SpaceUpdateComment":
                    case 13:
                        message.operations[i] = 13;
                        break;
                    case "SpaceRemoveComment":
                    case 14:
                        message.operations[i] = 14;
                        break;
                    case "SpaceGetComment":
                    case 15:
                        message.operations[i] = 15;
                        break;
                    }
            }
            if (object.name != null)
                message.name = String(object.name);
            return message;
        };

        /**
         * Creates a plain object from an AddSpace message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.AddSpace
         * @static
         * @param {request.AddSpace} message AddSpace
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddSpace.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.operations = [];
            if (options.defaults)
                object.name = "";
            if (message.operations && message.operations.length) {
                object.operations = [];
                for (let j = 0; j < message.operations.length; ++j)
                    object.operations[j] = options.enums === String ? $root.request.SpaceOpPermissions[message.operations[j]] === undefined ? message.operations[j] : $root.request.SpaceOpPermissions[message.operations[j]] : message.operations[j];
            }
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            return object;
        };

        /**
         * Converts this AddSpace to JSON.
         * @function toJSON
         * @memberof request.AddSpace
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddSpace.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for AddSpace
         * @function getTypeUrl
         * @memberof request.AddSpace
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        AddSpace.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.AddSpace";
        };

        return AddSpace;
    })();

    request.AddUserToSpace = (function() {

        /**
         * Properties of an AddUserToSpace.
         * @memberof request
         * @interface IAddUserToSpace
         * @property {string|null} [email] AddUserToSpace email
         * @property {string|null} [spaceName] AddUserToSpace spaceName
         */

        /**
         * Constructs a new AddUserToSpace.
         * @memberof request
         * @classdesc Represents an AddUserToSpace.
         * @implements IAddUserToSpace
         * @constructor
         * @param {request.IAddUserToSpace=} [properties] Properties to set
         */
        function AddUserToSpace(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddUserToSpace email.
         * @member {string} email
         * @memberof request.AddUserToSpace
         * @instance
         */
        AddUserToSpace.prototype.email = "";

        /**
         * AddUserToSpace spaceName.
         * @member {string} spaceName
         * @memberof request.AddUserToSpace
         * @instance
         */
        AddUserToSpace.prototype.spaceName = "";

        /**
         * Creates a new AddUserToSpace instance using the specified properties.
         * @function create
         * @memberof request.AddUserToSpace
         * @static
         * @param {request.IAddUserToSpace=} [properties] Properties to set
         * @returns {request.AddUserToSpace} AddUserToSpace instance
         */
        AddUserToSpace.create = function create(properties) {
            return new AddUserToSpace(properties);
        };

        /**
         * Encodes the specified AddUserToSpace message. Does not implicitly {@link request.AddUserToSpace.verify|verify} messages.
         * @function encode
         * @memberof request.AddUserToSpace
         * @static
         * @param {request.IAddUserToSpace} message AddUserToSpace message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddUserToSpace.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
            if (message.spaceName != null && Object.hasOwnProperty.call(message, "spaceName"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.spaceName);
            return writer;
        };

        /**
         * Encodes the specified AddUserToSpace message, length delimited. Does not implicitly {@link request.AddUserToSpace.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.AddUserToSpace
         * @static
         * @param {request.IAddUserToSpace} message AddUserToSpace message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddUserToSpace.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AddUserToSpace message from the specified reader or buffer.
         * @function decode
         * @memberof request.AddUserToSpace
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.AddUserToSpace} AddUserToSpace
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddUserToSpace.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.AddUserToSpace();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.email = reader.string();
                        break;
                    }
                case 2: {
                        message.spaceName = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AddUserToSpace message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.AddUserToSpace
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.AddUserToSpace} AddUserToSpace
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddUserToSpace.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AddUserToSpace message.
         * @function verify
         * @memberof request.AddUserToSpace
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AddUserToSpace.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            if (message.spaceName != null && message.hasOwnProperty("spaceName"))
                if (!$util.isString(message.spaceName))
                    return "spaceName: string expected";
            return null;
        };

        /**
         * Creates an AddUserToSpace message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.AddUserToSpace
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.AddUserToSpace} AddUserToSpace
         */
        AddUserToSpace.fromObject = function fromObject(object) {
            if (object instanceof $root.request.AddUserToSpace)
                return object;
            let message = new $root.request.AddUserToSpace();
            if (object.email != null)
                message.email = String(object.email);
            if (object.spaceName != null)
                message.spaceName = String(object.spaceName);
            return message;
        };

        /**
         * Creates a plain object from an AddUserToSpace message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.AddUserToSpace
         * @static
         * @param {request.AddUserToSpace} message AddUserToSpace
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddUserToSpace.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.email = "";
                object.spaceName = "";
            }
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.spaceName != null && message.hasOwnProperty("spaceName"))
                object.spaceName = message.spaceName;
            return object;
        };

        /**
         * Converts this AddUserToSpace to JSON.
         * @function toJSON
         * @memberof request.AddUserToSpace
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddUserToSpace.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for AddUserToSpace
         * @function getTypeUrl
         * @memberof request.AddUserToSpace
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        AddUserToSpace.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.AddUserToSpace";
        };

        return AddUserToSpace;
    })();

    request.RemoveUserFromSpace = (function() {

        /**
         * Properties of a RemoveUserFromSpace.
         * @memberof request
         * @interface IRemoveUserFromSpace
         * @property {string|null} [email] RemoveUserFromSpace email
         * @property {string|null} [spaceName] RemoveUserFromSpace spaceName
         */

        /**
         * Constructs a new RemoveUserFromSpace.
         * @memberof request
         * @classdesc Represents a RemoveUserFromSpace.
         * @implements IRemoveUserFromSpace
         * @constructor
         * @param {request.IRemoveUserFromSpace=} [properties] Properties to set
         */
        function RemoveUserFromSpace(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveUserFromSpace email.
         * @member {string} email
         * @memberof request.RemoveUserFromSpace
         * @instance
         */
        RemoveUserFromSpace.prototype.email = "";

        /**
         * RemoveUserFromSpace spaceName.
         * @member {string} spaceName
         * @memberof request.RemoveUserFromSpace
         * @instance
         */
        RemoveUserFromSpace.prototype.spaceName = "";

        /**
         * Creates a new RemoveUserFromSpace instance using the specified properties.
         * @function create
         * @memberof request.RemoveUserFromSpace
         * @static
         * @param {request.IRemoveUserFromSpace=} [properties] Properties to set
         * @returns {request.RemoveUserFromSpace} RemoveUserFromSpace instance
         */
        RemoveUserFromSpace.create = function create(properties) {
            return new RemoveUserFromSpace(properties);
        };

        /**
         * Encodes the specified RemoveUserFromSpace message. Does not implicitly {@link request.RemoveUserFromSpace.verify|verify} messages.
         * @function encode
         * @memberof request.RemoveUserFromSpace
         * @static
         * @param {request.IRemoveUserFromSpace} message RemoveUserFromSpace message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RemoveUserFromSpace.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
            if (message.spaceName != null && Object.hasOwnProperty.call(message, "spaceName"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.spaceName);
            return writer;
        };

        /**
         * Encodes the specified RemoveUserFromSpace message, length delimited. Does not implicitly {@link request.RemoveUserFromSpace.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.RemoveUserFromSpace
         * @static
         * @param {request.IRemoveUserFromSpace} message RemoveUserFromSpace message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RemoveUserFromSpace.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RemoveUserFromSpace message from the specified reader or buffer.
         * @function decode
         * @memberof request.RemoveUserFromSpace
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.RemoveUserFromSpace} RemoveUserFromSpace
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RemoveUserFromSpace.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.RemoveUserFromSpace();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.email = reader.string();
                        break;
                    }
                case 2: {
                        message.spaceName = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RemoveUserFromSpace message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.RemoveUserFromSpace
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.RemoveUserFromSpace} RemoveUserFromSpace
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RemoveUserFromSpace.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RemoveUserFromSpace message.
         * @function verify
         * @memberof request.RemoveUserFromSpace
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RemoveUserFromSpace.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            if (message.spaceName != null && message.hasOwnProperty("spaceName"))
                if (!$util.isString(message.spaceName))
                    return "spaceName: string expected";
            return null;
        };

        /**
         * Creates a RemoveUserFromSpace message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.RemoveUserFromSpace
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.RemoveUserFromSpace} RemoveUserFromSpace
         */
        RemoveUserFromSpace.fromObject = function fromObject(object) {
            if (object instanceof $root.request.RemoveUserFromSpace)
                return object;
            let message = new $root.request.RemoveUserFromSpace();
            if (object.email != null)
                message.email = String(object.email);
            if (object.spaceName != null)
                message.spaceName = String(object.spaceName);
            return message;
        };

        /**
         * Creates a plain object from a RemoveUserFromSpace message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.RemoveUserFromSpace
         * @static
         * @param {request.RemoveUserFromSpace} message RemoveUserFromSpace
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveUserFromSpace.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.email = "";
                object.spaceName = "";
            }
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.spaceName != null && message.hasOwnProperty("spaceName"))
                object.spaceName = message.spaceName;
            return object;
        };

        /**
         * Converts this RemoveUserFromSpace to JSON.
         * @function toJSON
         * @memberof request.RemoveUserFromSpace
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveUserFromSpace.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for RemoveUserFromSpace
         * @function getTypeUrl
         * @memberof request.RemoveUserFromSpace
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        RemoveUserFromSpace.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.RemoveUserFromSpace";
        };

        return RemoveUserFromSpace;
    })();

    request.UpdatePermissionsOfSpace = (function() {

        /**
         * Properties of an UpdatePermissionsOfSpace.
         * @memberof request
         * @interface IUpdatePermissionsOfSpace
         * @property {Array.<request.SpaceOpPermissions>|null} [operations] UpdatePermissionsOfSpace operations
         * @property {string|null} [spaceName] UpdatePermissionsOfSpace spaceName
         * @property {Array.<request.ISpaceAutoObjectDeletion>|null} [objects] UpdatePermissionsOfSpace objects
         * @property {number|Long|null} [maxFileSize] UpdatePermissionsOfSpace maxFileSize
         * @property {number|Long|null} [maximumSpaceSize] UpdatePermissionsOfSpace maximumSpaceSize
         * @property {Array.<string>|null} [allowedFileTypes] UpdatePermissionsOfSpace allowedFileTypes
         * @property {Array.<string>|null} [deniedFileTypes] UpdatePermissionsOfSpace deniedFileTypes
         * @property {Array.<string>|null} [allowedIps] UpdatePermissionsOfSpace allowedIps
         * @property {Array.<string>|null} [deniedIps] UpdatePermissionsOfSpace deniedIps
         * @property {Array.<string>|null} [allowedCountries] UpdatePermissionsOfSpace allowedCountries
         * @property {Array.<string>|null} [deniedCountries] UpdatePermissionsOfSpace deniedCountries
         * @property {Array.<string>|null} [allowedRegions] UpdatePermissionsOfSpace allowedRegions
         * @property {Array.<string>|null} [deniedRegions] UpdatePermissionsOfSpace deniedRegions
         */

        /**
         * Constructs a new UpdatePermissionsOfSpace.
         * @memberof request
         * @classdesc Represents an UpdatePermissionsOfSpace.
         * @implements IUpdatePermissionsOfSpace
         * @constructor
         * @param {request.IUpdatePermissionsOfSpace=} [properties] Properties to set
         */
        function UpdatePermissionsOfSpace(properties) {
            this.operations = [];
            this.objects = [];
            this.allowedFileTypes = [];
            this.deniedFileTypes = [];
            this.allowedIps = [];
            this.deniedIps = [];
            this.allowedCountries = [];
            this.deniedCountries = [];
            this.allowedRegions = [];
            this.deniedRegions = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdatePermissionsOfSpace operations.
         * @member {Array.<request.SpaceOpPermissions>} operations
         * @memberof request.UpdatePermissionsOfSpace
         * @instance
         */
        UpdatePermissionsOfSpace.prototype.operations = $util.emptyArray;

        /**
         * UpdatePermissionsOfSpace spaceName.
         * @member {string} spaceName
         * @memberof request.UpdatePermissionsOfSpace
         * @instance
         */
        UpdatePermissionsOfSpace.prototype.spaceName = "";

        /**
         * UpdatePermissionsOfSpace objects.
         * @member {Array.<request.ISpaceAutoObjectDeletion>} objects
         * @memberof request.UpdatePermissionsOfSpace
         * @instance
         */
        UpdatePermissionsOfSpace.prototype.objects = $util.emptyArray;

        /**
         * UpdatePermissionsOfSpace maxFileSize.
         * @member {number|Long|null|undefined} maxFileSize
         * @memberof request.UpdatePermissionsOfSpace
         * @instance
         */
        UpdatePermissionsOfSpace.prototype.maxFileSize = null;

        /**
         * UpdatePermissionsOfSpace maximumSpaceSize.
         * @member {number|Long|null|undefined} maximumSpaceSize
         * @memberof request.UpdatePermissionsOfSpace
         * @instance
         */
        UpdatePermissionsOfSpace.prototype.maximumSpaceSize = null;

        /**
         * UpdatePermissionsOfSpace allowedFileTypes.
         * @member {Array.<string>} allowedFileTypes
         * @memberof request.UpdatePermissionsOfSpace
         * @instance
         */
        UpdatePermissionsOfSpace.prototype.allowedFileTypes = $util.emptyArray;

        /**
         * UpdatePermissionsOfSpace deniedFileTypes.
         * @member {Array.<string>} deniedFileTypes
         * @memberof request.UpdatePermissionsOfSpace
         * @instance
         */
        UpdatePermissionsOfSpace.prototype.deniedFileTypes = $util.emptyArray;

        /**
         * UpdatePermissionsOfSpace allowedIps.
         * @member {Array.<string>} allowedIps
         * @memberof request.UpdatePermissionsOfSpace
         * @instance
         */
        UpdatePermissionsOfSpace.prototype.allowedIps = $util.emptyArray;

        /**
         * UpdatePermissionsOfSpace deniedIps.
         * @member {Array.<string>} deniedIps
         * @memberof request.UpdatePermissionsOfSpace
         * @instance
         */
        UpdatePermissionsOfSpace.prototype.deniedIps = $util.emptyArray;

        /**
         * UpdatePermissionsOfSpace allowedCountries.
         * @member {Array.<string>} allowedCountries
         * @memberof request.UpdatePermissionsOfSpace
         * @instance
         */
        UpdatePermissionsOfSpace.prototype.allowedCountries = $util.emptyArray;

        /**
         * UpdatePermissionsOfSpace deniedCountries.
         * @member {Array.<string>} deniedCountries
         * @memberof request.UpdatePermissionsOfSpace
         * @instance
         */
        UpdatePermissionsOfSpace.prototype.deniedCountries = $util.emptyArray;

        /**
         * UpdatePermissionsOfSpace allowedRegions.
         * @member {Array.<string>} allowedRegions
         * @memberof request.UpdatePermissionsOfSpace
         * @instance
         */
        UpdatePermissionsOfSpace.prototype.allowedRegions = $util.emptyArray;

        /**
         * UpdatePermissionsOfSpace deniedRegions.
         * @member {Array.<string>} deniedRegions
         * @memberof request.UpdatePermissionsOfSpace
         * @instance
         */
        UpdatePermissionsOfSpace.prototype.deniedRegions = $util.emptyArray;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(UpdatePermissionsOfSpace.prototype, "_maxFileSize", {
            get: $util.oneOfGetter($oneOfFields = ["maxFileSize"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(UpdatePermissionsOfSpace.prototype, "_maximumSpaceSize", {
            get: $util.oneOfGetter($oneOfFields = ["maximumSpaceSize"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new UpdatePermissionsOfSpace instance using the specified properties.
         * @function create
         * @memberof request.UpdatePermissionsOfSpace
         * @static
         * @param {request.IUpdatePermissionsOfSpace=} [properties] Properties to set
         * @returns {request.UpdatePermissionsOfSpace} UpdatePermissionsOfSpace instance
         */
        UpdatePermissionsOfSpace.create = function create(properties) {
            return new UpdatePermissionsOfSpace(properties);
        };

        /**
         * Encodes the specified UpdatePermissionsOfSpace message. Does not implicitly {@link request.UpdatePermissionsOfSpace.verify|verify} messages.
         * @function encode
         * @memberof request.UpdatePermissionsOfSpace
         * @static
         * @param {request.IUpdatePermissionsOfSpace} message UpdatePermissionsOfSpace message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdatePermissionsOfSpace.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.operations != null && message.operations.length) {
                writer.uint32(/* id 1, wireType 2 =*/10).fork();
                for (let i = 0; i < message.operations.length; ++i)
                    writer.int32(message.operations[i]);
                writer.ldelim();
            }
            if (message.spaceName != null && Object.hasOwnProperty.call(message, "spaceName"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.spaceName);
            if (message.objects != null && message.objects.length)
                for (let i = 0; i < message.objects.length; ++i)
                    $root.request.SpaceAutoObjectDeletion.encode(message.objects[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.maxFileSize != null && Object.hasOwnProperty.call(message, "maxFileSize"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.maxFileSize);
            if (message.maximumSpaceSize != null && Object.hasOwnProperty.call(message, "maximumSpaceSize"))
                writer.uint32(/* id 5, wireType 0 =*/40).uint64(message.maximumSpaceSize);
            if (message.allowedFileTypes != null && message.allowedFileTypes.length)
                for (let i = 0; i < message.allowedFileTypes.length; ++i)
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.allowedFileTypes[i]);
            if (message.deniedFileTypes != null && message.deniedFileTypes.length)
                for (let i = 0; i < message.deniedFileTypes.length; ++i)
                    writer.uint32(/* id 7, wireType 2 =*/58).string(message.deniedFileTypes[i]);
            if (message.allowedIps != null && message.allowedIps.length)
                for (let i = 0; i < message.allowedIps.length; ++i)
                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.allowedIps[i]);
            if (message.deniedIps != null && message.deniedIps.length)
                for (let i = 0; i < message.deniedIps.length; ++i)
                    writer.uint32(/* id 9, wireType 2 =*/74).string(message.deniedIps[i]);
            if (message.allowedCountries != null && message.allowedCountries.length)
                for (let i = 0; i < message.allowedCountries.length; ++i)
                    writer.uint32(/* id 10, wireType 2 =*/82).string(message.allowedCountries[i]);
            if (message.deniedCountries != null && message.deniedCountries.length)
                for (let i = 0; i < message.deniedCountries.length; ++i)
                    writer.uint32(/* id 11, wireType 2 =*/90).string(message.deniedCountries[i]);
            if (message.allowedRegions != null && message.allowedRegions.length)
                for (let i = 0; i < message.allowedRegions.length; ++i)
                    writer.uint32(/* id 12, wireType 2 =*/98).string(message.allowedRegions[i]);
            if (message.deniedRegions != null && message.deniedRegions.length)
                for (let i = 0; i < message.deniedRegions.length; ++i)
                    writer.uint32(/* id 13, wireType 2 =*/106).string(message.deniedRegions[i]);
            return writer;
        };

        /**
         * Encodes the specified UpdatePermissionsOfSpace message, length delimited. Does not implicitly {@link request.UpdatePermissionsOfSpace.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.UpdatePermissionsOfSpace
         * @static
         * @param {request.IUpdatePermissionsOfSpace} message UpdatePermissionsOfSpace message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdatePermissionsOfSpace.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UpdatePermissionsOfSpace message from the specified reader or buffer.
         * @function decode
         * @memberof request.UpdatePermissionsOfSpace
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.UpdatePermissionsOfSpace} UpdatePermissionsOfSpace
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdatePermissionsOfSpace.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.UpdatePermissionsOfSpace();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        if (!(message.operations && message.operations.length))
                            message.operations = [];
                        if ((tag & 7) === 2) {
                            let end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.operations.push(reader.int32());
                        } else
                            message.operations.push(reader.int32());
                        break;
                    }
                case 2: {
                        message.spaceName = reader.string();
                        break;
                    }
                case 3: {
                        if (!(message.objects && message.objects.length))
                            message.objects = [];
                        message.objects.push($root.request.SpaceAutoObjectDeletion.decode(reader, reader.uint32()));
                        break;
                    }
                case 4: {
                        message.maxFileSize = reader.uint64();
                        break;
                    }
                case 5: {
                        message.maximumSpaceSize = reader.uint64();
                        break;
                    }
                case 6: {
                        if (!(message.allowedFileTypes && message.allowedFileTypes.length))
                            message.allowedFileTypes = [];
                        message.allowedFileTypes.push(reader.string());
                        break;
                    }
                case 7: {
                        if (!(message.deniedFileTypes && message.deniedFileTypes.length))
                            message.deniedFileTypes = [];
                        message.deniedFileTypes.push(reader.string());
                        break;
                    }
                case 8: {
                        if (!(message.allowedIps && message.allowedIps.length))
                            message.allowedIps = [];
                        message.allowedIps.push(reader.string());
                        break;
                    }
                case 9: {
                        if (!(message.deniedIps && message.deniedIps.length))
                            message.deniedIps = [];
                        message.deniedIps.push(reader.string());
                        break;
                    }
                case 10: {
                        if (!(message.allowedCountries && message.allowedCountries.length))
                            message.allowedCountries = [];
                        message.allowedCountries.push(reader.string());
                        break;
                    }
                case 11: {
                        if (!(message.deniedCountries && message.deniedCountries.length))
                            message.deniedCountries = [];
                        message.deniedCountries.push(reader.string());
                        break;
                    }
                case 12: {
                        if (!(message.allowedRegions && message.allowedRegions.length))
                            message.allowedRegions = [];
                        message.allowedRegions.push(reader.string());
                        break;
                    }
                case 13: {
                        if (!(message.deniedRegions && message.deniedRegions.length))
                            message.deniedRegions = [];
                        message.deniedRegions.push(reader.string());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UpdatePermissionsOfSpace message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.UpdatePermissionsOfSpace
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.UpdatePermissionsOfSpace} UpdatePermissionsOfSpace
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdatePermissionsOfSpace.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UpdatePermissionsOfSpace message.
         * @function verify
         * @memberof request.UpdatePermissionsOfSpace
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UpdatePermissionsOfSpace.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.operations != null && message.hasOwnProperty("operations")) {
                if (!Array.isArray(message.operations))
                    return "operations: array expected";
                for (let i = 0; i < message.operations.length; ++i)
                    switch (message.operations[i]) {
                    default:
                        return "operations: enum value[] expected";
                    case 0:
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                    case 11:
                    case 12:
                    case 13:
                    case 14:
                    case 15:
                        break;
                    }
            }
            if (message.spaceName != null && message.hasOwnProperty("spaceName"))
                if (!$util.isString(message.spaceName))
                    return "spaceName: string expected";
            if (message.objects != null && message.hasOwnProperty("objects")) {
                if (!Array.isArray(message.objects))
                    return "objects: array expected";
                for (let i = 0; i < message.objects.length; ++i) {
                    let error = $root.request.SpaceAutoObjectDeletion.verify(message.objects[i]);
                    if (error)
                        return "objects." + error;
                }
            }
            if (message.maxFileSize != null && message.hasOwnProperty("maxFileSize")) {
                properties._maxFileSize = 1;
                if (!$util.isInteger(message.maxFileSize) && !(message.maxFileSize && $util.isInteger(message.maxFileSize.low) && $util.isInteger(message.maxFileSize.high)))
                    return "maxFileSize: integer|Long expected";
            }
            if (message.maximumSpaceSize != null && message.hasOwnProperty("maximumSpaceSize")) {
                properties._maximumSpaceSize = 1;
                if (!$util.isInteger(message.maximumSpaceSize) && !(message.maximumSpaceSize && $util.isInteger(message.maximumSpaceSize.low) && $util.isInteger(message.maximumSpaceSize.high)))
                    return "maximumSpaceSize: integer|Long expected";
            }
            if (message.allowedFileTypes != null && message.hasOwnProperty("allowedFileTypes")) {
                if (!Array.isArray(message.allowedFileTypes))
                    return "allowedFileTypes: array expected";
                for (let i = 0; i < message.allowedFileTypes.length; ++i)
                    if (!$util.isString(message.allowedFileTypes[i]))
                        return "allowedFileTypes: string[] expected";
            }
            if (message.deniedFileTypes != null && message.hasOwnProperty("deniedFileTypes")) {
                if (!Array.isArray(message.deniedFileTypes))
                    return "deniedFileTypes: array expected";
                for (let i = 0; i < message.deniedFileTypes.length; ++i)
                    if (!$util.isString(message.deniedFileTypes[i]))
                        return "deniedFileTypes: string[] expected";
            }
            if (message.allowedIps != null && message.hasOwnProperty("allowedIps")) {
                if (!Array.isArray(message.allowedIps))
                    return "allowedIps: array expected";
                for (let i = 0; i < message.allowedIps.length; ++i)
                    if (!$util.isString(message.allowedIps[i]))
                        return "allowedIps: string[] expected";
            }
            if (message.deniedIps != null && message.hasOwnProperty("deniedIps")) {
                if (!Array.isArray(message.deniedIps))
                    return "deniedIps: array expected";
                for (let i = 0; i < message.deniedIps.length; ++i)
                    if (!$util.isString(message.deniedIps[i]))
                        return "deniedIps: string[] expected";
            }
            if (message.allowedCountries != null && message.hasOwnProperty("allowedCountries")) {
                if (!Array.isArray(message.allowedCountries))
                    return "allowedCountries: array expected";
                for (let i = 0; i < message.allowedCountries.length; ++i)
                    if (!$util.isString(message.allowedCountries[i]))
                        return "allowedCountries: string[] expected";
            }
            if (message.deniedCountries != null && message.hasOwnProperty("deniedCountries")) {
                if (!Array.isArray(message.deniedCountries))
                    return "deniedCountries: array expected";
                for (let i = 0; i < message.deniedCountries.length; ++i)
                    if (!$util.isString(message.deniedCountries[i]))
                        return "deniedCountries: string[] expected";
            }
            if (message.allowedRegions != null && message.hasOwnProperty("allowedRegions")) {
                if (!Array.isArray(message.allowedRegions))
                    return "allowedRegions: array expected";
                for (let i = 0; i < message.allowedRegions.length; ++i)
                    if (!$util.isString(message.allowedRegions[i]))
                        return "allowedRegions: string[] expected";
            }
            if (message.deniedRegions != null && message.hasOwnProperty("deniedRegions")) {
                if (!Array.isArray(message.deniedRegions))
                    return "deniedRegions: array expected";
                for (let i = 0; i < message.deniedRegions.length; ++i)
                    if (!$util.isString(message.deniedRegions[i]))
                        return "deniedRegions: string[] expected";
            }
            return null;
        };

        /**
         * Creates an UpdatePermissionsOfSpace message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.UpdatePermissionsOfSpace
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.UpdatePermissionsOfSpace} UpdatePermissionsOfSpace
         */
        UpdatePermissionsOfSpace.fromObject = function fromObject(object) {
            if (object instanceof $root.request.UpdatePermissionsOfSpace)
                return object;
            let message = new $root.request.UpdatePermissionsOfSpace();
            if (object.operations) {
                if (!Array.isArray(object.operations))
                    throw TypeError(".request.UpdatePermissionsOfSpace.operations: array expected");
                message.operations = [];
                for (let i = 0; i < object.operations.length; ++i)
                    switch (object.operations[i]) {
                    default:
                        if (typeof object.operations[i] === "number") {
                            message.operations[i] = object.operations[i];
                            break;
                        }
                    case "SpaceOpGetMetaFromPath":
                    case 0:
                        message.operations[i] = 0;
                        break;
                    case "SpaceOpGetChunk":
                    case 1:
                        message.operations[i] = 1;
                        break;
                    case "SpaceOpListFiles":
                    case 2:
                        message.operations[i] = 2;
                        break;
                    case "SpaceOpStartWrite":
                    case 4:
                        message.operations[i] = 4;
                        break;
                    case "SpaceOpPutChunk":
                    case 5:
                        message.operations[i] = 5;
                        break;
                    case "SpaceOpFinalizeWrite":
                    case 6:
                        message.operations[i] = 6;
                        break;
                    case "SpaceOpCreateFolder":
                    case 7:
                        message.operations[i] = 7;
                        break;
                    case "SpaceAddComment":
                    case 11:
                        message.operations[i] = 11;
                        break;
                    case "SpaceListComments":
                    case 12:
                        message.operations[i] = 12;
                        break;
                    case "SpaceUpdateComment":
                    case 13:
                        message.operations[i] = 13;
                        break;
                    case "SpaceRemoveComment":
                    case 14:
                        message.operations[i] = 14;
                        break;
                    case "SpaceGetComment":
                    case 15:
                        message.operations[i] = 15;
                        break;
                    }
            }
            if (object.spaceName != null)
                message.spaceName = String(object.spaceName);
            if (object.objects) {
                if (!Array.isArray(object.objects))
                    throw TypeError(".request.UpdatePermissionsOfSpace.objects: array expected");
                message.objects = [];
                for (let i = 0; i < object.objects.length; ++i) {
                    if (typeof object.objects[i] !== "object")
                        throw TypeError(".request.UpdatePermissionsOfSpace.objects: object expected");
                    message.objects[i] = $root.request.SpaceAutoObjectDeletion.fromObject(object.objects[i]);
                }
            }
            if (object.maxFileSize != null)
                if ($util.Long)
                    (message.maxFileSize = $util.Long.fromValue(object.maxFileSize)).unsigned = true;
                else if (typeof object.maxFileSize === "string")
                    message.maxFileSize = parseInt(object.maxFileSize, 10);
                else if (typeof object.maxFileSize === "number")
                    message.maxFileSize = object.maxFileSize;
                else if (typeof object.maxFileSize === "object")
                    message.maxFileSize = new $util.LongBits(object.maxFileSize.low >>> 0, object.maxFileSize.high >>> 0).toNumber(true);
            if (object.maximumSpaceSize != null)
                if ($util.Long)
                    (message.maximumSpaceSize = $util.Long.fromValue(object.maximumSpaceSize)).unsigned = true;
                else if (typeof object.maximumSpaceSize === "string")
                    message.maximumSpaceSize = parseInt(object.maximumSpaceSize, 10);
                else if (typeof object.maximumSpaceSize === "number")
                    message.maximumSpaceSize = object.maximumSpaceSize;
                else if (typeof object.maximumSpaceSize === "object")
                    message.maximumSpaceSize = new $util.LongBits(object.maximumSpaceSize.low >>> 0, object.maximumSpaceSize.high >>> 0).toNumber(true);
            if (object.allowedFileTypes) {
                if (!Array.isArray(object.allowedFileTypes))
                    throw TypeError(".request.UpdatePermissionsOfSpace.allowedFileTypes: array expected");
                message.allowedFileTypes = [];
                for (let i = 0; i < object.allowedFileTypes.length; ++i)
                    message.allowedFileTypes[i] = String(object.allowedFileTypes[i]);
            }
            if (object.deniedFileTypes) {
                if (!Array.isArray(object.deniedFileTypes))
                    throw TypeError(".request.UpdatePermissionsOfSpace.deniedFileTypes: array expected");
                message.deniedFileTypes = [];
                for (let i = 0; i < object.deniedFileTypes.length; ++i)
                    message.deniedFileTypes[i] = String(object.deniedFileTypes[i]);
            }
            if (object.allowedIps) {
                if (!Array.isArray(object.allowedIps))
                    throw TypeError(".request.UpdatePermissionsOfSpace.allowedIps: array expected");
                message.allowedIps = [];
                for (let i = 0; i < object.allowedIps.length; ++i)
                    message.allowedIps[i] = String(object.allowedIps[i]);
            }
            if (object.deniedIps) {
                if (!Array.isArray(object.deniedIps))
                    throw TypeError(".request.UpdatePermissionsOfSpace.deniedIps: array expected");
                message.deniedIps = [];
                for (let i = 0; i < object.deniedIps.length; ++i)
                    message.deniedIps[i] = String(object.deniedIps[i]);
            }
            if (object.allowedCountries) {
                if (!Array.isArray(object.allowedCountries))
                    throw TypeError(".request.UpdatePermissionsOfSpace.allowedCountries: array expected");
                message.allowedCountries = [];
                for (let i = 0; i < object.allowedCountries.length; ++i)
                    message.allowedCountries[i] = String(object.allowedCountries[i]);
            }
            if (object.deniedCountries) {
                if (!Array.isArray(object.deniedCountries))
                    throw TypeError(".request.UpdatePermissionsOfSpace.deniedCountries: array expected");
                message.deniedCountries = [];
                for (let i = 0; i < object.deniedCountries.length; ++i)
                    message.deniedCountries[i] = String(object.deniedCountries[i]);
            }
            if (object.allowedRegions) {
                if (!Array.isArray(object.allowedRegions))
                    throw TypeError(".request.UpdatePermissionsOfSpace.allowedRegions: array expected");
                message.allowedRegions = [];
                for (let i = 0; i < object.allowedRegions.length; ++i)
                    message.allowedRegions[i] = String(object.allowedRegions[i]);
            }
            if (object.deniedRegions) {
                if (!Array.isArray(object.deniedRegions))
                    throw TypeError(".request.UpdatePermissionsOfSpace.deniedRegions: array expected");
                message.deniedRegions = [];
                for (let i = 0; i < object.deniedRegions.length; ++i)
                    message.deniedRegions[i] = String(object.deniedRegions[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdatePermissionsOfSpace message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.UpdatePermissionsOfSpace
         * @static
         * @param {request.UpdatePermissionsOfSpace} message UpdatePermissionsOfSpace
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdatePermissionsOfSpace.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.operations = [];
                object.objects = [];
                object.allowedFileTypes = [];
                object.deniedFileTypes = [];
                object.allowedIps = [];
                object.deniedIps = [];
                object.allowedCountries = [];
                object.deniedCountries = [];
                object.allowedRegions = [];
                object.deniedRegions = [];
            }
            if (options.defaults)
                object.spaceName = "";
            if (message.operations && message.operations.length) {
                object.operations = [];
                for (let j = 0; j < message.operations.length; ++j)
                    object.operations[j] = options.enums === String ? $root.request.SpaceOpPermissions[message.operations[j]] === undefined ? message.operations[j] : $root.request.SpaceOpPermissions[message.operations[j]] : message.operations[j];
            }
            if (message.spaceName != null && message.hasOwnProperty("spaceName"))
                object.spaceName = message.spaceName;
            if (message.objects && message.objects.length) {
                object.objects = [];
                for (let j = 0; j < message.objects.length; ++j)
                    object.objects[j] = $root.request.SpaceAutoObjectDeletion.toObject(message.objects[j], options);
            }
            if (message.maxFileSize != null && message.hasOwnProperty("maxFileSize")) {
                if (typeof message.maxFileSize === "number")
                    object.maxFileSize = options.longs === String ? String(message.maxFileSize) : message.maxFileSize;
                else
                    object.maxFileSize = options.longs === String ? $util.Long.prototype.toString.call(message.maxFileSize) : options.longs === Number ? new $util.LongBits(message.maxFileSize.low >>> 0, message.maxFileSize.high >>> 0).toNumber(true) : message.maxFileSize;
                if (options.oneofs)
                    object._maxFileSize = "maxFileSize";
            }
            if (message.maximumSpaceSize != null && message.hasOwnProperty("maximumSpaceSize")) {
                if (typeof message.maximumSpaceSize === "number")
                    object.maximumSpaceSize = options.longs === String ? String(message.maximumSpaceSize) : message.maximumSpaceSize;
                else
                    object.maximumSpaceSize = options.longs === String ? $util.Long.prototype.toString.call(message.maximumSpaceSize) : options.longs === Number ? new $util.LongBits(message.maximumSpaceSize.low >>> 0, message.maximumSpaceSize.high >>> 0).toNumber(true) : message.maximumSpaceSize;
                if (options.oneofs)
                    object._maximumSpaceSize = "maximumSpaceSize";
            }
            if (message.allowedFileTypes && message.allowedFileTypes.length) {
                object.allowedFileTypes = [];
                for (let j = 0; j < message.allowedFileTypes.length; ++j)
                    object.allowedFileTypes[j] = message.allowedFileTypes[j];
            }
            if (message.deniedFileTypes && message.deniedFileTypes.length) {
                object.deniedFileTypes = [];
                for (let j = 0; j < message.deniedFileTypes.length; ++j)
                    object.deniedFileTypes[j] = message.deniedFileTypes[j];
            }
            if (message.allowedIps && message.allowedIps.length) {
                object.allowedIps = [];
                for (let j = 0; j < message.allowedIps.length; ++j)
                    object.allowedIps[j] = message.allowedIps[j];
            }
            if (message.deniedIps && message.deniedIps.length) {
                object.deniedIps = [];
                for (let j = 0; j < message.deniedIps.length; ++j)
                    object.deniedIps[j] = message.deniedIps[j];
            }
            if (message.allowedCountries && message.allowedCountries.length) {
                object.allowedCountries = [];
                for (let j = 0; j < message.allowedCountries.length; ++j)
                    object.allowedCountries[j] = message.allowedCountries[j];
            }
            if (message.deniedCountries && message.deniedCountries.length) {
                object.deniedCountries = [];
                for (let j = 0; j < message.deniedCountries.length; ++j)
                    object.deniedCountries[j] = message.deniedCountries[j];
            }
            if (message.allowedRegions && message.allowedRegions.length) {
                object.allowedRegions = [];
                for (let j = 0; j < message.allowedRegions.length; ++j)
                    object.allowedRegions[j] = message.allowedRegions[j];
            }
            if (message.deniedRegions && message.deniedRegions.length) {
                object.deniedRegions = [];
                for (let j = 0; j < message.deniedRegions.length; ++j)
                    object.deniedRegions[j] = message.deniedRegions[j];
            }
            return object;
        };

        /**
         * Converts this UpdatePermissionsOfSpace to JSON.
         * @function toJSON
         * @memberof request.UpdatePermissionsOfSpace
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdatePermissionsOfSpace.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for UpdatePermissionsOfSpace
         * @function getTypeUrl
         * @memberof request.UpdatePermissionsOfSpace
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        UpdatePermissionsOfSpace.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.UpdatePermissionsOfSpace";
        };

        return UpdatePermissionsOfSpace;
    })();

    request.AddObjectToSpace = (function() {

        /**
         * Properties of an AddObjectToSpace.
         * @memberof request
         * @interface IAddObjectToSpace
         * @property {string|null} [pathOfObj] AddObjectToSpace pathOfObj
         * @property {request.TypeOfPath|null} [typeOfPath] AddObjectToSpace typeOfPath
         * @property {string|null} [spaceName] AddObjectToSpace spaceName
         * @property {request.TypeOfObj|null} [typeOfObj] AddObjectToSpace typeOfObj
         */

        /**
         * Constructs a new AddObjectToSpace.
         * @memberof request
         * @classdesc Represents an AddObjectToSpace.
         * @implements IAddObjectToSpace
         * @constructor
         * @param {request.IAddObjectToSpace=} [properties] Properties to set
         */
        function AddObjectToSpace(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddObjectToSpace pathOfObj.
         * @member {string} pathOfObj
         * @memberof request.AddObjectToSpace
         * @instance
         */
        AddObjectToSpace.prototype.pathOfObj = "";

        /**
         * AddObjectToSpace typeOfPath.
         * @member {request.TypeOfPath} typeOfPath
         * @memberof request.AddObjectToSpace
         * @instance
         */
        AddObjectToSpace.prototype.typeOfPath = 0;

        /**
         * AddObjectToSpace spaceName.
         * @member {string} spaceName
         * @memberof request.AddObjectToSpace
         * @instance
         */
        AddObjectToSpace.prototype.spaceName = "";

        /**
         * AddObjectToSpace typeOfObj.
         * @member {request.TypeOfObj} typeOfObj
         * @memberof request.AddObjectToSpace
         * @instance
         */
        AddObjectToSpace.prototype.typeOfObj = 0;

        /**
         * Creates a new AddObjectToSpace instance using the specified properties.
         * @function create
         * @memberof request.AddObjectToSpace
         * @static
         * @param {request.IAddObjectToSpace=} [properties] Properties to set
         * @returns {request.AddObjectToSpace} AddObjectToSpace instance
         */
        AddObjectToSpace.create = function create(properties) {
            return new AddObjectToSpace(properties);
        };

        /**
         * Encodes the specified AddObjectToSpace message. Does not implicitly {@link request.AddObjectToSpace.verify|verify} messages.
         * @function encode
         * @memberof request.AddObjectToSpace
         * @static
         * @param {request.IAddObjectToSpace} message AddObjectToSpace message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddObjectToSpace.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pathOfObj != null && Object.hasOwnProperty.call(message, "pathOfObj"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.pathOfObj);
            if (message.typeOfPath != null && Object.hasOwnProperty.call(message, "typeOfPath"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.typeOfPath);
            if (message.spaceName != null && Object.hasOwnProperty.call(message, "spaceName"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.spaceName);
            if (message.typeOfObj != null && Object.hasOwnProperty.call(message, "typeOfObj"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.typeOfObj);
            return writer;
        };

        /**
         * Encodes the specified AddObjectToSpace message, length delimited. Does not implicitly {@link request.AddObjectToSpace.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.AddObjectToSpace
         * @static
         * @param {request.IAddObjectToSpace} message AddObjectToSpace message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddObjectToSpace.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AddObjectToSpace message from the specified reader or buffer.
         * @function decode
         * @memberof request.AddObjectToSpace
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.AddObjectToSpace} AddObjectToSpace
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddObjectToSpace.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.AddObjectToSpace();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.pathOfObj = reader.string();
                        break;
                    }
                case 2: {
                        message.typeOfPath = reader.int32();
                        break;
                    }
                case 3: {
                        message.spaceName = reader.string();
                        break;
                    }
                case 4: {
                        message.typeOfObj = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AddObjectToSpace message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.AddObjectToSpace
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.AddObjectToSpace} AddObjectToSpace
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddObjectToSpace.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AddObjectToSpace message.
         * @function verify
         * @memberof request.AddObjectToSpace
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AddObjectToSpace.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pathOfObj != null && message.hasOwnProperty("pathOfObj"))
                if (!$util.isString(message.pathOfObj))
                    return "pathOfObj: string expected";
            if (message.typeOfPath != null && message.hasOwnProperty("typeOfPath"))
                switch (message.typeOfPath) {
                default:
                    return "typeOfPath: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                    break;
                }
            if (message.spaceName != null && message.hasOwnProperty("spaceName"))
                if (!$util.isString(message.spaceName))
                    return "spaceName: string expected";
            if (message.typeOfObj != null && message.hasOwnProperty("typeOfObj"))
                switch (message.typeOfObj) {
                default:
                    return "typeOfObj: enum value expected";
                case 0:
                case 1:
                    break;
                }
            return null;
        };

        /**
         * Creates an AddObjectToSpace message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.AddObjectToSpace
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.AddObjectToSpace} AddObjectToSpace
         */
        AddObjectToSpace.fromObject = function fromObject(object) {
            if (object instanceof $root.request.AddObjectToSpace)
                return object;
            let message = new $root.request.AddObjectToSpace();
            if (object.pathOfObj != null)
                message.pathOfObj = String(object.pathOfObj);
            switch (object.typeOfPath) {
            default:
                if (typeof object.typeOfPath === "number") {
                    message.typeOfPath = object.typeOfPath;
                    break;
                }
                break;
            case "TShareUser":
            case 0:
                message.typeOfPath = 0;
                break;
            case "TFolder":
            case 1:
                message.typeOfPath = 1;
                break;
            case "TShareTeam":
            case 2:
                message.typeOfPath = 2;
                break;
            case "TShareExternal":
            case 3:
                message.typeOfPath = 3;
                break;
            case "TFlow":
            case 4:
                message.typeOfPath = 4;
                break;
            }
            if (object.spaceName != null)
                message.spaceName = String(object.spaceName);
            switch (object.typeOfObj) {
            default:
                if (typeof object.typeOfObj === "number") {
                    message.typeOfObj = object.typeOfObj;
                    break;
                }
                break;
            case "TypeFolder":
            case 0:
                message.typeOfObj = 0;
                break;
            case "TypeFile":
            case 1:
                message.typeOfObj = 1;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from an AddObjectToSpace message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.AddObjectToSpace
         * @static
         * @param {request.AddObjectToSpace} message AddObjectToSpace
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddObjectToSpace.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.pathOfObj = "";
                object.typeOfPath = options.enums === String ? "TShareUser" : 0;
                object.spaceName = "";
                object.typeOfObj = options.enums === String ? "TypeFolder" : 0;
            }
            if (message.pathOfObj != null && message.hasOwnProperty("pathOfObj"))
                object.pathOfObj = message.pathOfObj;
            if (message.typeOfPath != null && message.hasOwnProperty("typeOfPath"))
                object.typeOfPath = options.enums === String ? $root.request.TypeOfPath[message.typeOfPath] === undefined ? message.typeOfPath : $root.request.TypeOfPath[message.typeOfPath] : message.typeOfPath;
            if (message.spaceName != null && message.hasOwnProperty("spaceName"))
                object.spaceName = message.spaceName;
            if (message.typeOfObj != null && message.hasOwnProperty("typeOfObj"))
                object.typeOfObj = options.enums === String ? $root.request.TypeOfObj[message.typeOfObj] === undefined ? message.typeOfObj : $root.request.TypeOfObj[message.typeOfObj] : message.typeOfObj;
            return object;
        };

        /**
         * Converts this AddObjectToSpace to JSON.
         * @function toJSON
         * @memberof request.AddObjectToSpace
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddObjectToSpace.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for AddObjectToSpace
         * @function getTypeUrl
         * @memberof request.AddObjectToSpace
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        AddObjectToSpace.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.AddObjectToSpace";
        };

        return AddObjectToSpace;
    })();

    request.RemoveObjectFromSpace = (function() {

        /**
         * Properties of a RemoveObjectFromSpace.
         * @memberof request
         * @interface IRemoveObjectFromSpace
         * @property {string|null} [uuid] RemoveObjectFromSpace uuid
         * @property {string|null} [spaceName] external_shared/{uuid}
         */

        /**
         * Constructs a new RemoveObjectFromSpace.
         * @memberof request
         * @classdesc Represents a RemoveObjectFromSpace.
         * @implements IRemoveObjectFromSpace
         * @constructor
         * @param {request.IRemoveObjectFromSpace=} [properties] Properties to set
         */
        function RemoveObjectFromSpace(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveObjectFromSpace uuid.
         * @member {string} uuid
         * @memberof request.RemoveObjectFromSpace
         * @instance
         */
        RemoveObjectFromSpace.prototype.uuid = "";

        /**
         * external_shared/{uuid}
         * @member {string} spaceName
         * @memberof request.RemoveObjectFromSpace
         * @instance
         */
        RemoveObjectFromSpace.prototype.spaceName = "";

        /**
         * Creates a new RemoveObjectFromSpace instance using the specified properties.
         * @function create
         * @memberof request.RemoveObjectFromSpace
         * @static
         * @param {request.IRemoveObjectFromSpace=} [properties] Properties to set
         * @returns {request.RemoveObjectFromSpace} RemoveObjectFromSpace instance
         */
        RemoveObjectFromSpace.create = function create(properties) {
            return new RemoveObjectFromSpace(properties);
        };

        /**
         * Encodes the specified RemoveObjectFromSpace message. Does not implicitly {@link request.RemoveObjectFromSpace.verify|verify} messages.
         * @function encode
         * @memberof request.RemoveObjectFromSpace
         * @static
         * @param {request.IRemoveObjectFromSpace} message RemoveObjectFromSpace message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RemoveObjectFromSpace.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uuid != null && Object.hasOwnProperty.call(message, "uuid"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.uuid);
            if (message.spaceName != null && Object.hasOwnProperty.call(message, "spaceName"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.spaceName);
            return writer;
        };

        /**
         * Encodes the specified RemoveObjectFromSpace message, length delimited. Does not implicitly {@link request.RemoveObjectFromSpace.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.RemoveObjectFromSpace
         * @static
         * @param {request.IRemoveObjectFromSpace} message RemoveObjectFromSpace message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RemoveObjectFromSpace.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RemoveObjectFromSpace message from the specified reader or buffer.
         * @function decode
         * @memberof request.RemoveObjectFromSpace
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.RemoveObjectFromSpace} RemoveObjectFromSpace
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RemoveObjectFromSpace.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.RemoveObjectFromSpace();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.uuid = reader.string();
                        break;
                    }
                case 2: {
                        message.spaceName = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RemoveObjectFromSpace message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.RemoveObjectFromSpace
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.RemoveObjectFromSpace} RemoveObjectFromSpace
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RemoveObjectFromSpace.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RemoveObjectFromSpace message.
         * @function verify
         * @memberof request.RemoveObjectFromSpace
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RemoveObjectFromSpace.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                if (!$util.isString(message.uuid))
                    return "uuid: string expected";
            if (message.spaceName != null && message.hasOwnProperty("spaceName"))
                if (!$util.isString(message.spaceName))
                    return "spaceName: string expected";
            return null;
        };

        /**
         * Creates a RemoveObjectFromSpace message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.RemoveObjectFromSpace
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.RemoveObjectFromSpace} RemoveObjectFromSpace
         */
        RemoveObjectFromSpace.fromObject = function fromObject(object) {
            if (object instanceof $root.request.RemoveObjectFromSpace)
                return object;
            let message = new $root.request.RemoveObjectFromSpace();
            if (object.uuid != null)
                message.uuid = String(object.uuid);
            if (object.spaceName != null)
                message.spaceName = String(object.spaceName);
            return message;
        };

        /**
         * Creates a plain object from a RemoveObjectFromSpace message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.RemoveObjectFromSpace
         * @static
         * @param {request.RemoveObjectFromSpace} message RemoveObjectFromSpace
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveObjectFromSpace.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.uuid = "";
                object.spaceName = "";
            }
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                object.uuid = message.uuid;
            if (message.spaceName != null && message.hasOwnProperty("spaceName"))
                object.spaceName = message.spaceName;
            return object;
        };

        /**
         * Converts this RemoveObjectFromSpace to JSON.
         * @function toJSON
         * @memberof request.RemoveObjectFromSpace
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveObjectFromSpace.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for RemoveObjectFromSpace
         * @function getTypeUrl
         * @memberof request.RemoveObjectFromSpace
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        RemoveObjectFromSpace.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.RemoveObjectFromSpace";
        };

        return RemoveObjectFromSpace;
    })();

    request.RemoveSpace = (function() {

        /**
         * Properties of a RemoveSpace.
         * @memberof request
         * @interface IRemoveSpace
         * @property {string|null} [spaceName] RemoveSpace spaceName
         */

        /**
         * Constructs a new RemoveSpace.
         * @memberof request
         * @classdesc Represents a RemoveSpace.
         * @implements IRemoveSpace
         * @constructor
         * @param {request.IRemoveSpace=} [properties] Properties to set
         */
        function RemoveSpace(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveSpace spaceName.
         * @member {string} spaceName
         * @memberof request.RemoveSpace
         * @instance
         */
        RemoveSpace.prototype.spaceName = "";

        /**
         * Creates a new RemoveSpace instance using the specified properties.
         * @function create
         * @memberof request.RemoveSpace
         * @static
         * @param {request.IRemoveSpace=} [properties] Properties to set
         * @returns {request.RemoveSpace} RemoveSpace instance
         */
        RemoveSpace.create = function create(properties) {
            return new RemoveSpace(properties);
        };

        /**
         * Encodes the specified RemoveSpace message. Does not implicitly {@link request.RemoveSpace.verify|verify} messages.
         * @function encode
         * @memberof request.RemoveSpace
         * @static
         * @param {request.IRemoveSpace} message RemoveSpace message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RemoveSpace.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.spaceName != null && Object.hasOwnProperty.call(message, "spaceName"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.spaceName);
            return writer;
        };

        /**
         * Encodes the specified RemoveSpace message, length delimited. Does not implicitly {@link request.RemoveSpace.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.RemoveSpace
         * @static
         * @param {request.IRemoveSpace} message RemoveSpace message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RemoveSpace.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RemoveSpace message from the specified reader or buffer.
         * @function decode
         * @memberof request.RemoveSpace
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.RemoveSpace} RemoveSpace
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RemoveSpace.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.RemoveSpace();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.spaceName = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RemoveSpace message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.RemoveSpace
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.RemoveSpace} RemoveSpace
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RemoveSpace.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RemoveSpace message.
         * @function verify
         * @memberof request.RemoveSpace
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RemoveSpace.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.spaceName != null && message.hasOwnProperty("spaceName"))
                if (!$util.isString(message.spaceName))
                    return "spaceName: string expected";
            return null;
        };

        /**
         * Creates a RemoveSpace message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.RemoveSpace
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.RemoveSpace} RemoveSpace
         */
        RemoveSpace.fromObject = function fromObject(object) {
            if (object instanceof $root.request.RemoveSpace)
                return object;
            let message = new $root.request.RemoveSpace();
            if (object.spaceName != null)
                message.spaceName = String(object.spaceName);
            return message;
        };

        /**
         * Creates a plain object from a RemoveSpace message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.RemoveSpace
         * @static
         * @param {request.RemoveSpace} message RemoveSpace
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveSpace.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.spaceName = "";
            if (message.spaceName != null && message.hasOwnProperty("spaceName"))
                object.spaceName = message.spaceName;
            return object;
        };

        /**
         * Converts this RemoveSpace to JSON.
         * @function toJSON
         * @memberof request.RemoveSpace
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveSpace.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for RemoveSpace
         * @function getTypeUrl
         * @memberof request.RemoveSpace
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        RemoveSpace.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.RemoveSpace";
        };

        return RemoveSpace;
    })();

    request.SendOtpToExternalUser = (function() {

        /**
         * Properties of a SendOtpToExternalUser.
         * @memberof request
         * @interface ISendOtpToExternalUser
         * @property {string|null} [ownerEmail] SendOtpToExternalUser ownerEmail
         * @property {string|null} [token] SendOtpToExternalUser token
         * @property {string|null} [externalUserEmail] SendOtpToExternalUser externalUserEmail
         * @property {string|null} [spaceName] SendOtpToExternalUser spaceName
         */

        /**
         * Constructs a new SendOtpToExternalUser.
         * @memberof request
         * @classdesc Represents a SendOtpToExternalUser.
         * @implements ISendOtpToExternalUser
         * @constructor
         * @param {request.ISendOtpToExternalUser=} [properties] Properties to set
         */
        function SendOtpToExternalUser(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SendOtpToExternalUser ownerEmail.
         * @member {string} ownerEmail
         * @memberof request.SendOtpToExternalUser
         * @instance
         */
        SendOtpToExternalUser.prototype.ownerEmail = "";

        /**
         * SendOtpToExternalUser token.
         * @member {string} token
         * @memberof request.SendOtpToExternalUser
         * @instance
         */
        SendOtpToExternalUser.prototype.token = "";

        /**
         * SendOtpToExternalUser externalUserEmail.
         * @member {string} externalUserEmail
         * @memberof request.SendOtpToExternalUser
         * @instance
         */
        SendOtpToExternalUser.prototype.externalUserEmail = "";

        /**
         * SendOtpToExternalUser spaceName.
         * @member {string} spaceName
         * @memberof request.SendOtpToExternalUser
         * @instance
         */
        SendOtpToExternalUser.prototype.spaceName = "";

        /**
         * Creates a new SendOtpToExternalUser instance using the specified properties.
         * @function create
         * @memberof request.SendOtpToExternalUser
         * @static
         * @param {request.ISendOtpToExternalUser=} [properties] Properties to set
         * @returns {request.SendOtpToExternalUser} SendOtpToExternalUser instance
         */
        SendOtpToExternalUser.create = function create(properties) {
            return new SendOtpToExternalUser(properties);
        };

        /**
         * Encodes the specified SendOtpToExternalUser message. Does not implicitly {@link request.SendOtpToExternalUser.verify|verify} messages.
         * @function encode
         * @memberof request.SendOtpToExternalUser
         * @static
         * @param {request.ISendOtpToExternalUser} message SendOtpToExternalUser message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SendOtpToExternalUser.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.ownerEmail != null && Object.hasOwnProperty.call(message, "ownerEmail"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.ownerEmail);
            if (message.token != null && Object.hasOwnProperty.call(message, "token"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.token);
            if (message.externalUserEmail != null && Object.hasOwnProperty.call(message, "externalUserEmail"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.externalUserEmail);
            if (message.spaceName != null && Object.hasOwnProperty.call(message, "spaceName"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.spaceName);
            return writer;
        };

        /**
         * Encodes the specified SendOtpToExternalUser message, length delimited. Does not implicitly {@link request.SendOtpToExternalUser.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.SendOtpToExternalUser
         * @static
         * @param {request.ISendOtpToExternalUser} message SendOtpToExternalUser message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SendOtpToExternalUser.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SendOtpToExternalUser message from the specified reader or buffer.
         * @function decode
         * @memberof request.SendOtpToExternalUser
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.SendOtpToExternalUser} SendOtpToExternalUser
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SendOtpToExternalUser.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.SendOtpToExternalUser();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 2: {
                        message.ownerEmail = reader.string();
                        break;
                    }
                case 3: {
                        message.token = reader.string();
                        break;
                    }
                case 4: {
                        message.externalUserEmail = reader.string();
                        break;
                    }
                case 5: {
                        message.spaceName = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SendOtpToExternalUser message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.SendOtpToExternalUser
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.SendOtpToExternalUser} SendOtpToExternalUser
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SendOtpToExternalUser.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SendOtpToExternalUser message.
         * @function verify
         * @memberof request.SendOtpToExternalUser
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SendOtpToExternalUser.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.ownerEmail != null && message.hasOwnProperty("ownerEmail"))
                if (!$util.isString(message.ownerEmail))
                    return "ownerEmail: string expected";
            if (message.token != null && message.hasOwnProperty("token"))
                if (!$util.isString(message.token))
                    return "token: string expected";
            if (message.externalUserEmail != null && message.hasOwnProperty("externalUserEmail"))
                if (!$util.isString(message.externalUserEmail))
                    return "externalUserEmail: string expected";
            if (message.spaceName != null && message.hasOwnProperty("spaceName"))
                if (!$util.isString(message.spaceName))
                    return "spaceName: string expected";
            return null;
        };

        /**
         * Creates a SendOtpToExternalUser message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.SendOtpToExternalUser
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.SendOtpToExternalUser} SendOtpToExternalUser
         */
        SendOtpToExternalUser.fromObject = function fromObject(object) {
            if (object instanceof $root.request.SendOtpToExternalUser)
                return object;
            let message = new $root.request.SendOtpToExternalUser();
            if (object.ownerEmail != null)
                message.ownerEmail = String(object.ownerEmail);
            if (object.token != null)
                message.token = String(object.token);
            if (object.externalUserEmail != null)
                message.externalUserEmail = String(object.externalUserEmail);
            if (object.spaceName != null)
                message.spaceName = String(object.spaceName);
            return message;
        };

        /**
         * Creates a plain object from a SendOtpToExternalUser message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.SendOtpToExternalUser
         * @static
         * @param {request.SendOtpToExternalUser} message SendOtpToExternalUser
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SendOtpToExternalUser.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.ownerEmail = "";
                object.token = "";
                object.externalUserEmail = "";
                object.spaceName = "";
            }
            if (message.ownerEmail != null && message.hasOwnProperty("ownerEmail"))
                object.ownerEmail = message.ownerEmail;
            if (message.token != null && message.hasOwnProperty("token"))
                object.token = message.token;
            if (message.externalUserEmail != null && message.hasOwnProperty("externalUserEmail"))
                object.externalUserEmail = message.externalUserEmail;
            if (message.spaceName != null && message.hasOwnProperty("spaceName"))
                object.spaceName = message.spaceName;
            return object;
        };

        /**
         * Converts this SendOtpToExternalUser to JSON.
         * @function toJSON
         * @memberof request.SendOtpToExternalUser
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SendOtpToExternalUser.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for SendOtpToExternalUser
         * @function getTypeUrl
         * @memberof request.SendOtpToExternalUser
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        SendOtpToExternalUser.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.SendOtpToExternalUser";
        };

        return SendOtpToExternalUser;
    })();

    request.SendOtpToExternalUserIfNotExist = (function() {

        /**
         * Properties of a SendOtpToExternalUserIfNotExist.
         * @memberof request
         * @interface ISendOtpToExternalUserIfNotExist
         * @property {string|null} [ownerEmail] SendOtpToExternalUserIfNotExist ownerEmail
         * @property {string|null} [token] SendOtpToExternalUserIfNotExist token
         * @property {string|null} [externalUserEmail] SendOtpToExternalUserIfNotExist externalUserEmail
         * @property {string|null} [spaceName] SendOtpToExternalUserIfNotExist spaceName
         */

        /**
         * Constructs a new SendOtpToExternalUserIfNotExist.
         * @memberof request
         * @classdesc Represents a SendOtpToExternalUserIfNotExist.
         * @implements ISendOtpToExternalUserIfNotExist
         * @constructor
         * @param {request.ISendOtpToExternalUserIfNotExist=} [properties] Properties to set
         */
        function SendOtpToExternalUserIfNotExist(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SendOtpToExternalUserIfNotExist ownerEmail.
         * @member {string} ownerEmail
         * @memberof request.SendOtpToExternalUserIfNotExist
         * @instance
         */
        SendOtpToExternalUserIfNotExist.prototype.ownerEmail = "";

        /**
         * SendOtpToExternalUserIfNotExist token.
         * @member {string} token
         * @memberof request.SendOtpToExternalUserIfNotExist
         * @instance
         */
        SendOtpToExternalUserIfNotExist.prototype.token = "";

        /**
         * SendOtpToExternalUserIfNotExist externalUserEmail.
         * @member {string} externalUserEmail
         * @memberof request.SendOtpToExternalUserIfNotExist
         * @instance
         */
        SendOtpToExternalUserIfNotExist.prototype.externalUserEmail = "";

        /**
         * SendOtpToExternalUserIfNotExist spaceName.
         * @member {string} spaceName
         * @memberof request.SendOtpToExternalUserIfNotExist
         * @instance
         */
        SendOtpToExternalUserIfNotExist.prototype.spaceName = "";

        /**
         * Creates a new SendOtpToExternalUserIfNotExist instance using the specified properties.
         * @function create
         * @memberof request.SendOtpToExternalUserIfNotExist
         * @static
         * @param {request.ISendOtpToExternalUserIfNotExist=} [properties] Properties to set
         * @returns {request.SendOtpToExternalUserIfNotExist} SendOtpToExternalUserIfNotExist instance
         */
        SendOtpToExternalUserIfNotExist.create = function create(properties) {
            return new SendOtpToExternalUserIfNotExist(properties);
        };

        /**
         * Encodes the specified SendOtpToExternalUserIfNotExist message. Does not implicitly {@link request.SendOtpToExternalUserIfNotExist.verify|verify} messages.
         * @function encode
         * @memberof request.SendOtpToExternalUserIfNotExist
         * @static
         * @param {request.ISendOtpToExternalUserIfNotExist} message SendOtpToExternalUserIfNotExist message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SendOtpToExternalUserIfNotExist.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.ownerEmail != null && Object.hasOwnProperty.call(message, "ownerEmail"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.ownerEmail);
            if (message.token != null && Object.hasOwnProperty.call(message, "token"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.token);
            if (message.externalUserEmail != null && Object.hasOwnProperty.call(message, "externalUserEmail"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.externalUserEmail);
            if (message.spaceName != null && Object.hasOwnProperty.call(message, "spaceName"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.spaceName);
            return writer;
        };

        /**
         * Encodes the specified SendOtpToExternalUserIfNotExist message, length delimited. Does not implicitly {@link request.SendOtpToExternalUserIfNotExist.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.SendOtpToExternalUserIfNotExist
         * @static
         * @param {request.ISendOtpToExternalUserIfNotExist} message SendOtpToExternalUserIfNotExist message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SendOtpToExternalUserIfNotExist.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SendOtpToExternalUserIfNotExist message from the specified reader or buffer.
         * @function decode
         * @memberof request.SendOtpToExternalUserIfNotExist
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.SendOtpToExternalUserIfNotExist} SendOtpToExternalUserIfNotExist
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SendOtpToExternalUserIfNotExist.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.SendOtpToExternalUserIfNotExist();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 2: {
                        message.ownerEmail = reader.string();
                        break;
                    }
                case 3: {
                        message.token = reader.string();
                        break;
                    }
                case 4: {
                        message.externalUserEmail = reader.string();
                        break;
                    }
                case 5: {
                        message.spaceName = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SendOtpToExternalUserIfNotExist message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.SendOtpToExternalUserIfNotExist
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.SendOtpToExternalUserIfNotExist} SendOtpToExternalUserIfNotExist
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SendOtpToExternalUserIfNotExist.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SendOtpToExternalUserIfNotExist message.
         * @function verify
         * @memberof request.SendOtpToExternalUserIfNotExist
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SendOtpToExternalUserIfNotExist.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.ownerEmail != null && message.hasOwnProperty("ownerEmail"))
                if (!$util.isString(message.ownerEmail))
                    return "ownerEmail: string expected";
            if (message.token != null && message.hasOwnProperty("token"))
                if (!$util.isString(message.token))
                    return "token: string expected";
            if (message.externalUserEmail != null && message.hasOwnProperty("externalUserEmail"))
                if (!$util.isString(message.externalUserEmail))
                    return "externalUserEmail: string expected";
            if (message.spaceName != null && message.hasOwnProperty("spaceName"))
                if (!$util.isString(message.spaceName))
                    return "spaceName: string expected";
            return null;
        };

        /**
         * Creates a SendOtpToExternalUserIfNotExist message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.SendOtpToExternalUserIfNotExist
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.SendOtpToExternalUserIfNotExist} SendOtpToExternalUserIfNotExist
         */
        SendOtpToExternalUserIfNotExist.fromObject = function fromObject(object) {
            if (object instanceof $root.request.SendOtpToExternalUserIfNotExist)
                return object;
            let message = new $root.request.SendOtpToExternalUserIfNotExist();
            if (object.ownerEmail != null)
                message.ownerEmail = String(object.ownerEmail);
            if (object.token != null)
                message.token = String(object.token);
            if (object.externalUserEmail != null)
                message.externalUserEmail = String(object.externalUserEmail);
            if (object.spaceName != null)
                message.spaceName = String(object.spaceName);
            return message;
        };

        /**
         * Creates a plain object from a SendOtpToExternalUserIfNotExist message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.SendOtpToExternalUserIfNotExist
         * @static
         * @param {request.SendOtpToExternalUserIfNotExist} message SendOtpToExternalUserIfNotExist
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SendOtpToExternalUserIfNotExist.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.ownerEmail = "";
                object.token = "";
                object.externalUserEmail = "";
                object.spaceName = "";
            }
            if (message.ownerEmail != null && message.hasOwnProperty("ownerEmail"))
                object.ownerEmail = message.ownerEmail;
            if (message.token != null && message.hasOwnProperty("token"))
                object.token = message.token;
            if (message.externalUserEmail != null && message.hasOwnProperty("externalUserEmail"))
                object.externalUserEmail = message.externalUserEmail;
            if (message.spaceName != null && message.hasOwnProperty("spaceName"))
                object.spaceName = message.spaceName;
            return object;
        };

        /**
         * Converts this SendOtpToExternalUserIfNotExist to JSON.
         * @function toJSON
         * @memberof request.SendOtpToExternalUserIfNotExist
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SendOtpToExternalUserIfNotExist.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for SendOtpToExternalUserIfNotExist
         * @function getTypeUrl
         * @memberof request.SendOtpToExternalUserIfNotExist
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        SendOtpToExternalUserIfNotExist.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.SendOtpToExternalUserIfNotExist";
        };

        return SendOtpToExternalUserIfNotExist;
    })();

    request.SignInToSpace = (function() {

        /**
         * Properties of a SignInToSpace.
         * @memberof request
         * @interface ISignInToSpace
         * @property {string|null} [otp] SignInToSpace otp
         * @property {string|null} [externalUserEmail] SignInToSpace externalUserEmail
         * @property {string|null} [token] SignInToSpace token
         * @property {string|null} [ownerEmail] SignInToSpace ownerEmail
         * @property {string|null} [spaceName] SignInToSpace spaceName
         */

        /**
         * Constructs a new SignInToSpace.
         * @memberof request
         * @classdesc Represents a SignInToSpace.
         * @implements ISignInToSpace
         * @constructor
         * @param {request.ISignInToSpace=} [properties] Properties to set
         */
        function SignInToSpace(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SignInToSpace otp.
         * @member {string} otp
         * @memberof request.SignInToSpace
         * @instance
         */
        SignInToSpace.prototype.otp = "";

        /**
         * SignInToSpace externalUserEmail.
         * @member {string} externalUserEmail
         * @memberof request.SignInToSpace
         * @instance
         */
        SignInToSpace.prototype.externalUserEmail = "";

        /**
         * SignInToSpace token.
         * @member {string} token
         * @memberof request.SignInToSpace
         * @instance
         */
        SignInToSpace.prototype.token = "";

        /**
         * SignInToSpace ownerEmail.
         * @member {string} ownerEmail
         * @memberof request.SignInToSpace
         * @instance
         */
        SignInToSpace.prototype.ownerEmail = "";

        /**
         * SignInToSpace spaceName.
         * @member {string} spaceName
         * @memberof request.SignInToSpace
         * @instance
         */
        SignInToSpace.prototype.spaceName = "";

        /**
         * Creates a new SignInToSpace instance using the specified properties.
         * @function create
         * @memberof request.SignInToSpace
         * @static
         * @param {request.ISignInToSpace=} [properties] Properties to set
         * @returns {request.SignInToSpace} SignInToSpace instance
         */
        SignInToSpace.create = function create(properties) {
            return new SignInToSpace(properties);
        };

        /**
         * Encodes the specified SignInToSpace message. Does not implicitly {@link request.SignInToSpace.verify|verify} messages.
         * @function encode
         * @memberof request.SignInToSpace
         * @static
         * @param {request.ISignInToSpace} message SignInToSpace message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SignInToSpace.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.otp != null && Object.hasOwnProperty.call(message, "otp"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.otp);
            if (message.externalUserEmail != null && Object.hasOwnProperty.call(message, "externalUserEmail"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.externalUserEmail);
            if (message.token != null && Object.hasOwnProperty.call(message, "token"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.token);
            if (message.ownerEmail != null && Object.hasOwnProperty.call(message, "ownerEmail"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.ownerEmail);
            if (message.spaceName != null && Object.hasOwnProperty.call(message, "spaceName"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.spaceName);
            return writer;
        };

        /**
         * Encodes the specified SignInToSpace message, length delimited. Does not implicitly {@link request.SignInToSpace.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.SignInToSpace
         * @static
         * @param {request.ISignInToSpace} message SignInToSpace message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SignInToSpace.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SignInToSpace message from the specified reader or buffer.
         * @function decode
         * @memberof request.SignInToSpace
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.SignInToSpace} SignInToSpace
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SignInToSpace.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.SignInToSpace();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.otp = reader.string();
                        break;
                    }
                case 2: {
                        message.externalUserEmail = reader.string();
                        break;
                    }
                case 3: {
                        message.token = reader.string();
                        break;
                    }
                case 4: {
                        message.ownerEmail = reader.string();
                        break;
                    }
                case 5: {
                        message.spaceName = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SignInToSpace message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.SignInToSpace
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.SignInToSpace} SignInToSpace
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SignInToSpace.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SignInToSpace message.
         * @function verify
         * @memberof request.SignInToSpace
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SignInToSpace.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.otp != null && message.hasOwnProperty("otp"))
                if (!$util.isString(message.otp))
                    return "otp: string expected";
            if (message.externalUserEmail != null && message.hasOwnProperty("externalUserEmail"))
                if (!$util.isString(message.externalUserEmail))
                    return "externalUserEmail: string expected";
            if (message.token != null && message.hasOwnProperty("token"))
                if (!$util.isString(message.token))
                    return "token: string expected";
            if (message.ownerEmail != null && message.hasOwnProperty("ownerEmail"))
                if (!$util.isString(message.ownerEmail))
                    return "ownerEmail: string expected";
            if (message.spaceName != null && message.hasOwnProperty("spaceName"))
                if (!$util.isString(message.spaceName))
                    return "spaceName: string expected";
            return null;
        };

        /**
         * Creates a SignInToSpace message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.SignInToSpace
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.SignInToSpace} SignInToSpace
         */
        SignInToSpace.fromObject = function fromObject(object) {
            if (object instanceof $root.request.SignInToSpace)
                return object;
            let message = new $root.request.SignInToSpace();
            if (object.otp != null)
                message.otp = String(object.otp);
            if (object.externalUserEmail != null)
                message.externalUserEmail = String(object.externalUserEmail);
            if (object.token != null)
                message.token = String(object.token);
            if (object.ownerEmail != null)
                message.ownerEmail = String(object.ownerEmail);
            if (object.spaceName != null)
                message.spaceName = String(object.spaceName);
            return message;
        };

        /**
         * Creates a plain object from a SignInToSpace message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.SignInToSpace
         * @static
         * @param {request.SignInToSpace} message SignInToSpace
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SignInToSpace.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.otp = "";
                object.externalUserEmail = "";
                object.token = "";
                object.ownerEmail = "";
                object.spaceName = "";
            }
            if (message.otp != null && message.hasOwnProperty("otp"))
                object.otp = message.otp;
            if (message.externalUserEmail != null && message.hasOwnProperty("externalUserEmail"))
                object.externalUserEmail = message.externalUserEmail;
            if (message.token != null && message.hasOwnProperty("token"))
                object.token = message.token;
            if (message.ownerEmail != null && message.hasOwnProperty("ownerEmail"))
                object.ownerEmail = message.ownerEmail;
            if (message.spaceName != null && message.hasOwnProperty("spaceName"))
                object.spaceName = message.spaceName;
            return object;
        };

        /**
         * Converts this SignInToSpace to JSON.
         * @function toJSON
         * @memberof request.SignInToSpace
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SignInToSpace.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for SignInToSpace
         * @function getTypeUrl
         * @memberof request.SignInToSpace
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        SignInToSpace.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.SignInToSpace";
        };

        return SignInToSpace;
    })();

    request.ListSpaces = (function() {

        /**
         * Properties of a ListSpaces.
         * @memberof request
         * @interface IListSpaces
         * @property {Uint8Array|null} [pageToken] ListSpaces pageToken
         * @property {number|null} [pageSize] ListSpaces pageSize
         */

        /**
         * Constructs a new ListSpaces.
         * @memberof request
         * @classdesc Represents a ListSpaces.
         * @implements IListSpaces
         * @constructor
         * @param {request.IListSpaces=} [properties] Properties to set
         */
        function ListSpaces(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListSpaces pageToken.
         * @member {Uint8Array|null|undefined} pageToken
         * @memberof request.ListSpaces
         * @instance
         */
        ListSpaces.prototype.pageToken = null;

        /**
         * ListSpaces pageSize.
         * @member {number|null|undefined} pageSize
         * @memberof request.ListSpaces
         * @instance
         */
        ListSpaces.prototype.pageSize = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(ListSpaces.prototype, "_pageToken", {
            get: $util.oneOfGetter($oneOfFields = ["pageToken"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(ListSpaces.prototype, "_pageSize", {
            get: $util.oneOfGetter($oneOfFields = ["pageSize"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new ListSpaces instance using the specified properties.
         * @function create
         * @memberof request.ListSpaces
         * @static
         * @param {request.IListSpaces=} [properties] Properties to set
         * @returns {request.ListSpaces} ListSpaces instance
         */
        ListSpaces.create = function create(properties) {
            return new ListSpaces(properties);
        };

        /**
         * Encodes the specified ListSpaces message. Does not implicitly {@link request.ListSpaces.verify|verify} messages.
         * @function encode
         * @memberof request.ListSpaces
         * @static
         * @param {request.IListSpaces} message ListSpaces message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListSpaces.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.pageToken);
            if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.pageSize);
            return writer;
        };

        /**
         * Encodes the specified ListSpaces message, length delimited. Does not implicitly {@link request.ListSpaces.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.ListSpaces
         * @static
         * @param {request.IListSpaces} message ListSpaces message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListSpaces.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ListSpaces message from the specified reader or buffer.
         * @function decode
         * @memberof request.ListSpaces
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.ListSpaces} ListSpaces
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListSpaces.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.ListSpaces();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.pageToken = reader.bytes();
                        break;
                    }
                case 2: {
                        message.pageSize = reader.uint32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ListSpaces message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.ListSpaces
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.ListSpaces} ListSpaces
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListSpaces.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ListSpaces message.
         * @function verify
         * @memberof request.ListSpaces
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ListSpaces.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.pageToken != null && message.hasOwnProperty("pageToken")) {
                properties._pageToken = 1;
                if (!(message.pageToken && typeof message.pageToken.length === "number" || $util.isString(message.pageToken)))
                    return "pageToken: buffer expected";
            }
            if (message.pageSize != null && message.hasOwnProperty("pageSize")) {
                properties._pageSize = 1;
                if (!$util.isInteger(message.pageSize))
                    return "pageSize: integer expected";
            }
            return null;
        };

        /**
         * Creates a ListSpaces message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.ListSpaces
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.ListSpaces} ListSpaces
         */
        ListSpaces.fromObject = function fromObject(object) {
            if (object instanceof $root.request.ListSpaces)
                return object;
            let message = new $root.request.ListSpaces();
            if (object.pageToken != null)
                if (typeof object.pageToken === "string")
                    $util.base64.decode(object.pageToken, message.pageToken = $util.newBuffer($util.base64.length(object.pageToken)), 0);
                else if (object.pageToken.length >= 0)
                    message.pageToken = object.pageToken;
            if (object.pageSize != null)
                message.pageSize = object.pageSize >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a ListSpaces message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.ListSpaces
         * @static
         * @param {request.ListSpaces} message ListSpaces
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListSpaces.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (message.pageToken != null && message.hasOwnProperty("pageToken")) {
                object.pageToken = options.bytes === String ? $util.base64.encode(message.pageToken, 0, message.pageToken.length) : options.bytes === Array ? Array.prototype.slice.call(message.pageToken) : message.pageToken;
                if (options.oneofs)
                    object._pageToken = "pageToken";
            }
            if (message.pageSize != null && message.hasOwnProperty("pageSize")) {
                object.pageSize = message.pageSize;
                if (options.oneofs)
                    object._pageSize = "pageSize";
            }
            return object;
        };

        /**
         * Converts this ListSpaces to JSON.
         * @function toJSON
         * @memberof request.ListSpaces
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListSpaces.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ListSpaces
         * @function getTypeUrl
         * @memberof request.ListSpaces
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ListSpaces.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.ListSpaces";
        };

        return ListSpaces;
    })();

    request.Range = (function() {

        /**
         * Properties of a Range.
         * @memberof request
         * @interface IRange
         * @property {number|Long|null} [minVal] Range minVal
         * @property {number|Long|null} [maxVal] Range maxVal
         */

        /**
         * Constructs a new Range.
         * @memberof request
         * @classdesc Represents a Range.
         * @implements IRange
         * @constructor
         * @param {request.IRange=} [properties] Properties to set
         */
        function Range(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Range minVal.
         * @member {number|Long|null|undefined} minVal
         * @memberof request.Range
         * @instance
         */
        Range.prototype.minVal = null;

        /**
         * Range maxVal.
         * @member {number|Long|null|undefined} maxVal
         * @memberof request.Range
         * @instance
         */
        Range.prototype.maxVal = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(Range.prototype, "_minVal", {
            get: $util.oneOfGetter($oneOfFields = ["minVal"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(Range.prototype, "_maxVal", {
            get: $util.oneOfGetter($oneOfFields = ["maxVal"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new Range instance using the specified properties.
         * @function create
         * @memberof request.Range
         * @static
         * @param {request.IRange=} [properties] Properties to set
         * @returns {request.Range} Range instance
         */
        Range.create = function create(properties) {
            return new Range(properties);
        };

        /**
         * Encodes the specified Range message. Does not implicitly {@link request.Range.verify|verify} messages.
         * @function encode
         * @memberof request.Range
         * @static
         * @param {request.IRange} message Range message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Range.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.minVal != null && Object.hasOwnProperty.call(message, "minVal"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.minVal);
            if (message.maxVal != null && Object.hasOwnProperty.call(message, "maxVal"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.maxVal);
            return writer;
        };

        /**
         * Encodes the specified Range message, length delimited. Does not implicitly {@link request.Range.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.Range
         * @static
         * @param {request.IRange} message Range message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Range.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Range message from the specified reader or buffer.
         * @function decode
         * @memberof request.Range
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.Range} Range
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Range.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.Range();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.minVal = reader.uint64();
                        break;
                    }
                case 2: {
                        message.maxVal = reader.uint64();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Range message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.Range
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.Range} Range
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Range.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Range message.
         * @function verify
         * @memberof request.Range
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Range.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.minVal != null && message.hasOwnProperty("minVal")) {
                properties._minVal = 1;
                if (!$util.isInteger(message.minVal) && !(message.minVal && $util.isInteger(message.minVal.low) && $util.isInteger(message.minVal.high)))
                    return "minVal: integer|Long expected";
            }
            if (message.maxVal != null && message.hasOwnProperty("maxVal")) {
                properties._maxVal = 1;
                if (!$util.isInteger(message.maxVal) && !(message.maxVal && $util.isInteger(message.maxVal.low) && $util.isInteger(message.maxVal.high)))
                    return "maxVal: integer|Long expected";
            }
            return null;
        };

        /**
         * Creates a Range message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.Range
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.Range} Range
         */
        Range.fromObject = function fromObject(object) {
            if (object instanceof $root.request.Range)
                return object;
            let message = new $root.request.Range();
            if (object.minVal != null)
                if ($util.Long)
                    (message.minVal = $util.Long.fromValue(object.minVal)).unsigned = true;
                else if (typeof object.minVal === "string")
                    message.minVal = parseInt(object.minVal, 10);
                else if (typeof object.minVal === "number")
                    message.minVal = object.minVal;
                else if (typeof object.minVal === "object")
                    message.minVal = new $util.LongBits(object.minVal.low >>> 0, object.minVal.high >>> 0).toNumber(true);
            if (object.maxVal != null)
                if ($util.Long)
                    (message.maxVal = $util.Long.fromValue(object.maxVal)).unsigned = true;
                else if (typeof object.maxVal === "string")
                    message.maxVal = parseInt(object.maxVal, 10);
                else if (typeof object.maxVal === "number")
                    message.maxVal = object.maxVal;
                else if (typeof object.maxVal === "object")
                    message.maxVal = new $util.LongBits(object.maxVal.low >>> 0, object.maxVal.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a Range message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.Range
         * @static
         * @param {request.Range} message Range
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Range.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (message.minVal != null && message.hasOwnProperty("minVal")) {
                if (typeof message.minVal === "number")
                    object.minVal = options.longs === String ? String(message.minVal) : message.minVal;
                else
                    object.minVal = options.longs === String ? $util.Long.prototype.toString.call(message.minVal) : options.longs === Number ? new $util.LongBits(message.minVal.low >>> 0, message.minVal.high >>> 0).toNumber(true) : message.minVal;
                if (options.oneofs)
                    object._minVal = "minVal";
            }
            if (message.maxVal != null && message.hasOwnProperty("maxVal")) {
                if (typeof message.maxVal === "number")
                    object.maxVal = options.longs === String ? String(message.maxVal) : message.maxVal;
                else
                    object.maxVal = options.longs === String ? $util.Long.prototype.toString.call(message.maxVal) : options.longs === Number ? new $util.LongBits(message.maxVal.low >>> 0, message.maxVal.high >>> 0).toNumber(true) : message.maxVal;
                if (options.oneofs)
                    object._maxVal = "maxVal";
            }
            return object;
        };

        /**
         * Converts this Range to JSON.
         * @function toJSON
         * @memberof request.Range
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Range.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Range
         * @function getTypeUrl
         * @memberof request.Range
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Range.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.Range";
        };

        return Range;
    })();

    request.GenericFlag = (function() {

        /**
         * Properties of a GenericFlag.
         * @memberof request
         * @interface IGenericFlag
         * @property {string|null} [name] GenericFlag name
         * @property {boolean|null} [flag] GenericFlag flag
         */

        /**
         * Constructs a new GenericFlag.
         * @memberof request
         * @classdesc Represents a GenericFlag.
         * @implements IGenericFlag
         * @constructor
         * @param {request.IGenericFlag=} [properties] Properties to set
         */
        function GenericFlag(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GenericFlag name.
         * @member {string} name
         * @memberof request.GenericFlag
         * @instance
         */
        GenericFlag.prototype.name = "";

        /**
         * GenericFlag flag.
         * @member {boolean} flag
         * @memberof request.GenericFlag
         * @instance
         */
        GenericFlag.prototype.flag = false;

        /**
         * Creates a new GenericFlag instance using the specified properties.
         * @function create
         * @memberof request.GenericFlag
         * @static
         * @param {request.IGenericFlag=} [properties] Properties to set
         * @returns {request.GenericFlag} GenericFlag instance
         */
        GenericFlag.create = function create(properties) {
            return new GenericFlag(properties);
        };

        /**
         * Encodes the specified GenericFlag message. Does not implicitly {@link request.GenericFlag.verify|verify} messages.
         * @function encode
         * @memberof request.GenericFlag
         * @static
         * @param {request.IGenericFlag} message GenericFlag message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GenericFlag.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
            if (message.flag != null && Object.hasOwnProperty.call(message, "flag"))
                writer.uint32(/* id 2, wireType 0 =*/16).bool(message.flag);
            return writer;
        };

        /**
         * Encodes the specified GenericFlag message, length delimited. Does not implicitly {@link request.GenericFlag.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.GenericFlag
         * @static
         * @param {request.IGenericFlag} message GenericFlag message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GenericFlag.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GenericFlag message from the specified reader or buffer.
         * @function decode
         * @memberof request.GenericFlag
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.GenericFlag} GenericFlag
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GenericFlag.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.GenericFlag();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.name = reader.string();
                        break;
                    }
                case 2: {
                        message.flag = reader.bool();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GenericFlag message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.GenericFlag
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.GenericFlag} GenericFlag
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GenericFlag.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GenericFlag message.
         * @function verify
         * @memberof request.GenericFlag
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GenericFlag.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.flag != null && message.hasOwnProperty("flag"))
                if (typeof message.flag !== "boolean")
                    return "flag: boolean expected";
            return null;
        };

        /**
         * Creates a GenericFlag message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.GenericFlag
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.GenericFlag} GenericFlag
         */
        GenericFlag.fromObject = function fromObject(object) {
            if (object instanceof $root.request.GenericFlag)
                return object;
            let message = new $root.request.GenericFlag();
            if (object.name != null)
                message.name = String(object.name);
            if (object.flag != null)
                message.flag = Boolean(object.flag);
            return message;
        };

        /**
         * Creates a plain object from a GenericFlag message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.GenericFlag
         * @static
         * @param {request.GenericFlag} message GenericFlag
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GenericFlag.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.name = "";
                object.flag = false;
            }
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.flag != null && message.hasOwnProperty("flag"))
                object.flag = message.flag;
            return object;
        };

        /**
         * Converts this GenericFlag to JSON.
         * @function toJSON
         * @memberof request.GenericFlag
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GenericFlag.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GenericFlag
         * @function getTypeUrl
         * @memberof request.GenericFlag
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GenericFlag.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.GenericFlag";
        };

        return GenericFlag;
    })();

    request.RegexOptions = (function() {

        /**
         * Properties of a RegexOptions.
         * @memberof request
         * @interface IRegexOptions
         * @property {Array.<request.IRange>|null} [time] RegexOptions time
         * @property {Array.<request.IRange>|null} [size] RegexOptions size
         * @property {Array.<request.IGenericFlag>|null} [tags] RegexOptions tags
         * @property {Array.<request.IGenericFlag>|null} [fileType] RegexOptions fileType
         * @property {string|null} [regex] RegexOptions regex
         */

        /**
         * Constructs a new RegexOptions.
         * @memberof request
         * @classdesc Represents a RegexOptions.
         * @implements IRegexOptions
         * @constructor
         * @param {request.IRegexOptions=} [properties] Properties to set
         */
        function RegexOptions(properties) {
            this.time = [];
            this.size = [];
            this.tags = [];
            this.fileType = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RegexOptions time.
         * @member {Array.<request.IRange>} time
         * @memberof request.RegexOptions
         * @instance
         */
        RegexOptions.prototype.time = $util.emptyArray;

        /**
         * RegexOptions size.
         * @member {Array.<request.IRange>} size
         * @memberof request.RegexOptions
         * @instance
         */
        RegexOptions.prototype.size = $util.emptyArray;

        /**
         * RegexOptions tags.
         * @member {Array.<request.IGenericFlag>} tags
         * @memberof request.RegexOptions
         * @instance
         */
        RegexOptions.prototype.tags = $util.emptyArray;

        /**
         * RegexOptions fileType.
         * @member {Array.<request.IGenericFlag>} fileType
         * @memberof request.RegexOptions
         * @instance
         */
        RegexOptions.prototype.fileType = $util.emptyArray;

        /**
         * RegexOptions regex.
         * @member {string|null|undefined} regex
         * @memberof request.RegexOptions
         * @instance
         */
        RegexOptions.prototype.regex = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(RegexOptions.prototype, "_regex", {
            get: $util.oneOfGetter($oneOfFields = ["regex"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new RegexOptions instance using the specified properties.
         * @function create
         * @memberof request.RegexOptions
         * @static
         * @param {request.IRegexOptions=} [properties] Properties to set
         * @returns {request.RegexOptions} RegexOptions instance
         */
        RegexOptions.create = function create(properties) {
            return new RegexOptions(properties);
        };

        /**
         * Encodes the specified RegexOptions message. Does not implicitly {@link request.RegexOptions.verify|verify} messages.
         * @function encode
         * @memberof request.RegexOptions
         * @static
         * @param {request.IRegexOptions} message RegexOptions message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RegexOptions.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.time != null && message.time.length)
                for (let i = 0; i < message.time.length; ++i)
                    $root.request.Range.encode(message.time[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.size != null && message.size.length)
                for (let i = 0; i < message.size.length; ++i)
                    $root.request.Range.encode(message.size[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.tags != null && message.tags.length)
                for (let i = 0; i < message.tags.length; ++i)
                    $root.request.GenericFlag.encode(message.tags[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.fileType != null && message.fileType.length)
                for (let i = 0; i < message.fileType.length; ++i)
                    $root.request.GenericFlag.encode(message.fileType[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            if (message.regex != null && Object.hasOwnProperty.call(message, "regex"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.regex);
            return writer;
        };

        /**
         * Encodes the specified RegexOptions message, length delimited. Does not implicitly {@link request.RegexOptions.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.RegexOptions
         * @static
         * @param {request.IRegexOptions} message RegexOptions message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RegexOptions.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RegexOptions message from the specified reader or buffer.
         * @function decode
         * @memberof request.RegexOptions
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.RegexOptions} RegexOptions
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RegexOptions.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.RegexOptions();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        if (!(message.time && message.time.length))
                            message.time = [];
                        message.time.push($root.request.Range.decode(reader, reader.uint32()));
                        break;
                    }
                case 2: {
                        if (!(message.size && message.size.length))
                            message.size = [];
                        message.size.push($root.request.Range.decode(reader, reader.uint32()));
                        break;
                    }
                case 3: {
                        if (!(message.tags && message.tags.length))
                            message.tags = [];
                        message.tags.push($root.request.GenericFlag.decode(reader, reader.uint32()));
                        break;
                    }
                case 4: {
                        if (!(message.fileType && message.fileType.length))
                            message.fileType = [];
                        message.fileType.push($root.request.GenericFlag.decode(reader, reader.uint32()));
                        break;
                    }
                case 5: {
                        message.regex = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RegexOptions message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.RegexOptions
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.RegexOptions} RegexOptions
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RegexOptions.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RegexOptions message.
         * @function verify
         * @memberof request.RegexOptions
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RegexOptions.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.time != null && message.hasOwnProperty("time")) {
                if (!Array.isArray(message.time))
                    return "time: array expected";
                for (let i = 0; i < message.time.length; ++i) {
                    let error = $root.request.Range.verify(message.time[i]);
                    if (error)
                        return "time." + error;
                }
            }
            if (message.size != null && message.hasOwnProperty("size")) {
                if (!Array.isArray(message.size))
                    return "size: array expected";
                for (let i = 0; i < message.size.length; ++i) {
                    let error = $root.request.Range.verify(message.size[i]);
                    if (error)
                        return "size." + error;
                }
            }
            if (message.tags != null && message.hasOwnProperty("tags")) {
                if (!Array.isArray(message.tags))
                    return "tags: array expected";
                for (let i = 0; i < message.tags.length; ++i) {
                    let error = $root.request.GenericFlag.verify(message.tags[i]);
                    if (error)
                        return "tags." + error;
                }
            }
            if (message.fileType != null && message.hasOwnProperty("fileType")) {
                if (!Array.isArray(message.fileType))
                    return "fileType: array expected";
                for (let i = 0; i < message.fileType.length; ++i) {
                    let error = $root.request.GenericFlag.verify(message.fileType[i]);
                    if (error)
                        return "fileType." + error;
                }
            }
            if (message.regex != null && message.hasOwnProperty("regex")) {
                properties._regex = 1;
                if (!$util.isString(message.regex))
                    return "regex: string expected";
            }
            return null;
        };

        /**
         * Creates a RegexOptions message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.RegexOptions
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.RegexOptions} RegexOptions
         */
        RegexOptions.fromObject = function fromObject(object) {
            if (object instanceof $root.request.RegexOptions)
                return object;
            let message = new $root.request.RegexOptions();
            if (object.time) {
                if (!Array.isArray(object.time))
                    throw TypeError(".request.RegexOptions.time: array expected");
                message.time = [];
                for (let i = 0; i < object.time.length; ++i) {
                    if (typeof object.time[i] !== "object")
                        throw TypeError(".request.RegexOptions.time: object expected");
                    message.time[i] = $root.request.Range.fromObject(object.time[i]);
                }
            }
            if (object.size) {
                if (!Array.isArray(object.size))
                    throw TypeError(".request.RegexOptions.size: array expected");
                message.size = [];
                for (let i = 0; i < object.size.length; ++i) {
                    if (typeof object.size[i] !== "object")
                        throw TypeError(".request.RegexOptions.size: object expected");
                    message.size[i] = $root.request.Range.fromObject(object.size[i]);
                }
            }
            if (object.tags) {
                if (!Array.isArray(object.tags))
                    throw TypeError(".request.RegexOptions.tags: array expected");
                message.tags = [];
                for (let i = 0; i < object.tags.length; ++i) {
                    if (typeof object.tags[i] !== "object")
                        throw TypeError(".request.RegexOptions.tags: object expected");
                    message.tags[i] = $root.request.GenericFlag.fromObject(object.tags[i]);
                }
            }
            if (object.fileType) {
                if (!Array.isArray(object.fileType))
                    throw TypeError(".request.RegexOptions.fileType: array expected");
                message.fileType = [];
                for (let i = 0; i < object.fileType.length; ++i) {
                    if (typeof object.fileType[i] !== "object")
                        throw TypeError(".request.RegexOptions.fileType: object expected");
                    message.fileType[i] = $root.request.GenericFlag.fromObject(object.fileType[i]);
                }
            }
            if (object.regex != null)
                message.regex = String(object.regex);
            return message;
        };

        /**
         * Creates a plain object from a RegexOptions message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.RegexOptions
         * @static
         * @param {request.RegexOptions} message RegexOptions
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RegexOptions.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.time = [];
                object.size = [];
                object.tags = [];
                object.fileType = [];
            }
            if (message.time && message.time.length) {
                object.time = [];
                for (let j = 0; j < message.time.length; ++j)
                    object.time[j] = $root.request.Range.toObject(message.time[j], options);
            }
            if (message.size && message.size.length) {
                object.size = [];
                for (let j = 0; j < message.size.length; ++j)
                    object.size[j] = $root.request.Range.toObject(message.size[j], options);
            }
            if (message.tags && message.tags.length) {
                object.tags = [];
                for (let j = 0; j < message.tags.length; ++j)
                    object.tags[j] = $root.request.GenericFlag.toObject(message.tags[j], options);
            }
            if (message.fileType && message.fileType.length) {
                object.fileType = [];
                for (let j = 0; j < message.fileType.length; ++j)
                    object.fileType[j] = $root.request.GenericFlag.toObject(message.fileType[j], options);
            }
            if (message.regex != null && message.hasOwnProperty("regex")) {
                object.regex = message.regex;
                if (options.oneofs)
                    object._regex = "regex";
            }
            return object;
        };

        /**
         * Converts this RegexOptions to JSON.
         * @function toJSON
         * @memberof request.RegexOptions
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RegexOptions.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for RegexOptions
         * @function getTypeUrl
         * @memberof request.RegexOptions
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        RegexOptions.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.RegexOptions";
        };

        return RegexOptions;
    })();

    request.List = (function() {

        /**
         * Properties of a List.
         * @memberof request
         * @interface IList
         * @property {Uint8Array|null} [uuid] List uuid
         * @property {string|null} [path] List path
         * @property {request.ListType|null} [type] List type
         * @property {Uint8Array|null} [pageToken] List pageToken
         * @property {number|Long|null} [pageSize] List pageSize
         * @property {request.OrderBy|null} [orderBy] List orderBy
         * @property {string|null} [regex] List regex
         * @property {request.TypeOfPath|null} [typeOfPath] List typeOfPath
         * @property {boolean|null} [onlyFolders] List onlyFolders
         * @property {boolean|null} [onlyNames] List onlyNames
         * @property {request.IRegexOptions|null} [regexOptions] List regexOptions
         */

        /**
         * Constructs a new List.
         * @memberof request
         * @classdesc Represents a List.
         * @implements IList
         * @constructor
         * @param {request.IList=} [properties] Properties to set
         */
        function List(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * List uuid.
         * @member {Uint8Array|null|undefined} uuid
         * @memberof request.List
         * @instance
         */
        List.prototype.uuid = null;

        /**
         * List path.
         * @member {string|null|undefined} path
         * @memberof request.List
         * @instance
         */
        List.prototype.path = null;

        /**
         * List type.
         * @member {request.ListType} type
         * @memberof request.List
         * @instance
         */
        List.prototype.type = 0;

        /**
         * List pageToken.
         * @member {Uint8Array|null|undefined} pageToken
         * @memberof request.List
         * @instance
         */
        List.prototype.pageToken = null;

        /**
         * List pageSize.
         * @member {number|Long|null|undefined} pageSize
         * @memberof request.List
         * @instance
         */
        List.prototype.pageSize = null;

        /**
         * List orderBy.
         * @member {request.OrderBy|null|undefined} orderBy
         * @memberof request.List
         * @instance
         */
        List.prototype.orderBy = null;

        /**
         * List regex.
         * @member {string|null|undefined} regex
         * @memberof request.List
         * @instance
         */
        List.prototype.regex = null;

        /**
         * List typeOfPath.
         * @member {request.TypeOfPath} typeOfPath
         * @memberof request.List
         * @instance
         */
        List.prototype.typeOfPath = 0;

        /**
         * List onlyFolders.
         * @member {boolean|null|undefined} onlyFolders
         * @memberof request.List
         * @instance
         */
        List.prototype.onlyFolders = null;

        /**
         * List onlyNames.
         * @member {boolean|null|undefined} onlyNames
         * @memberof request.List
         * @instance
         */
        List.prototype.onlyNames = null;

        /**
         * List regexOptions.
         * @member {request.IRegexOptions|null|undefined} regexOptions
         * @memberof request.List
         * @instance
         */
        List.prototype.regexOptions = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(List.prototype, "_uuid", {
            get: $util.oneOfGetter($oneOfFields = ["uuid"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(List.prototype, "_path", {
            get: $util.oneOfGetter($oneOfFields = ["path"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(List.prototype, "_pageToken", {
            get: $util.oneOfGetter($oneOfFields = ["pageToken"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(List.prototype, "_pageSize", {
            get: $util.oneOfGetter($oneOfFields = ["pageSize"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(List.prototype, "_orderBy", {
            get: $util.oneOfGetter($oneOfFields = ["orderBy"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(List.prototype, "_regex", {
            get: $util.oneOfGetter($oneOfFields = ["regex"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(List.prototype, "_onlyFolders", {
            get: $util.oneOfGetter($oneOfFields = ["onlyFolders"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(List.prototype, "_onlyNames", {
            get: $util.oneOfGetter($oneOfFields = ["onlyNames"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(List.prototype, "_regexOptions", {
            get: $util.oneOfGetter($oneOfFields = ["regexOptions"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new List instance using the specified properties.
         * @function create
         * @memberof request.List
         * @static
         * @param {request.IList=} [properties] Properties to set
         * @returns {request.List} List instance
         */
        List.create = function create(properties) {
            return new List(properties);
        };

        /**
         * Encodes the specified List message. Does not implicitly {@link request.List.verify|verify} messages.
         * @function encode
         * @memberof request.List
         * @static
         * @param {request.IList} message List message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        List.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uuid != null && Object.hasOwnProperty.call(message, "uuid"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.uuid);
            if (message.path != null && Object.hasOwnProperty.call(message, "path"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.path);
            if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.type);
            if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.pageToken);
            if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                writer.uint32(/* id 5, wireType 0 =*/40).uint64(message.pageSize);
            if (message.orderBy != null && Object.hasOwnProperty.call(message, "orderBy"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.orderBy);
            if (message.regex != null && Object.hasOwnProperty.call(message, "regex"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.regex);
            if (message.typeOfPath != null && Object.hasOwnProperty.call(message, "typeOfPath"))
                writer.uint32(/* id 8, wireType 0 =*/64).int32(message.typeOfPath);
            if (message.onlyFolders != null && Object.hasOwnProperty.call(message, "onlyFolders"))
                writer.uint32(/* id 9, wireType 0 =*/72).bool(message.onlyFolders);
            if (message.onlyNames != null && Object.hasOwnProperty.call(message, "onlyNames"))
                writer.uint32(/* id 10, wireType 0 =*/80).bool(message.onlyNames);
            if (message.regexOptions != null && Object.hasOwnProperty.call(message, "regexOptions"))
                $root.request.RegexOptions.encode(message.regexOptions, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified List message, length delimited. Does not implicitly {@link request.List.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.List
         * @static
         * @param {request.IList} message List message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        List.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a List message from the specified reader or buffer.
         * @function decode
         * @memberof request.List
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.List} List
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        List.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.List();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.uuid = reader.bytes();
                        break;
                    }
                case 2: {
                        message.path = reader.string();
                        break;
                    }
                case 3: {
                        message.type = reader.int32();
                        break;
                    }
                case 4: {
                        message.pageToken = reader.bytes();
                        break;
                    }
                case 5: {
                        message.pageSize = reader.uint64();
                        break;
                    }
                case 6: {
                        message.orderBy = reader.int32();
                        break;
                    }
                case 7: {
                        message.regex = reader.string();
                        break;
                    }
                case 8: {
                        message.typeOfPath = reader.int32();
                        break;
                    }
                case 9: {
                        message.onlyFolders = reader.bool();
                        break;
                    }
                case 10: {
                        message.onlyNames = reader.bool();
                        break;
                    }
                case 11: {
                        message.regexOptions = $root.request.RegexOptions.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a List message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.List
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.List} List
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        List.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a List message.
         * @function verify
         * @memberof request.List
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        List.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.uuid != null && message.hasOwnProperty("uuid")) {
                properties._uuid = 1;
                if (!(message.uuid && typeof message.uuid.length === "number" || $util.isString(message.uuid)))
                    return "uuid: buffer expected";
            }
            if (message.path != null && message.hasOwnProperty("path")) {
                properties._path = 1;
                if (!$util.isString(message.path))
                    return "path: string expected";
            }
            if (message.type != null && message.hasOwnProperty("type"))
                switch (message.type) {
                default:
                    return "type: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                    break;
                }
            if (message.pageToken != null && message.hasOwnProperty("pageToken")) {
                properties._pageToken = 1;
                if (!(message.pageToken && typeof message.pageToken.length === "number" || $util.isString(message.pageToken)))
                    return "pageToken: buffer expected";
            }
            if (message.pageSize != null && message.hasOwnProperty("pageSize")) {
                properties._pageSize = 1;
                if (!$util.isInteger(message.pageSize) && !(message.pageSize && $util.isInteger(message.pageSize.low) && $util.isInteger(message.pageSize.high)))
                    return "pageSize: integer|Long expected";
            }
            if (message.orderBy != null && message.hasOwnProperty("orderBy")) {
                properties._orderBy = 1;
                switch (message.orderBy) {
                default:
                    return "orderBy: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            }
            if (message.regex != null && message.hasOwnProperty("regex")) {
                properties._regex = 1;
                if (!$util.isString(message.regex))
                    return "regex: string expected";
            }
            if (message.typeOfPath != null && message.hasOwnProperty("typeOfPath"))
                switch (message.typeOfPath) {
                default:
                    return "typeOfPath: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                    break;
                }
            if (message.onlyFolders != null && message.hasOwnProperty("onlyFolders")) {
                properties._onlyFolders = 1;
                if (typeof message.onlyFolders !== "boolean")
                    return "onlyFolders: boolean expected";
            }
            if (message.onlyNames != null && message.hasOwnProperty("onlyNames")) {
                properties._onlyNames = 1;
                if (typeof message.onlyNames !== "boolean")
                    return "onlyNames: boolean expected";
            }
            if (message.regexOptions != null && message.hasOwnProperty("regexOptions")) {
                properties._regexOptions = 1;
                {
                    let error = $root.request.RegexOptions.verify(message.regexOptions);
                    if (error)
                        return "regexOptions." + error;
                }
            }
            return null;
        };

        /**
         * Creates a List message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.List
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.List} List
         */
        List.fromObject = function fromObject(object) {
            if (object instanceof $root.request.List)
                return object;
            let message = new $root.request.List();
            if (object.uuid != null)
                if (typeof object.uuid === "string")
                    $util.base64.decode(object.uuid, message.uuid = $util.newBuffer($util.base64.length(object.uuid)), 0);
                else if (object.uuid.length >= 0)
                    message.uuid = object.uuid;
            if (object.path != null)
                message.path = String(object.path);
            switch (object.type) {
            default:
                if (typeof object.type === "number") {
                    message.type = object.type;
                    break;
                }
                break;
            case "Chunks":
            case 0:
                message.type = 0;
                break;
            case "FilesAndFolders":
            case 1:
                message.type = 1;
                break;
            case "Secrets":
            case 2:
                message.type = 2;
                break;
            case "Roles":
            case 3:
                message.type = 3;
                break;
            case "Teams":
            case 4:
                message.type = 4;
                break;
            case "Users":
            case 5:
                message.type = 5;
                break;
            case "AuditLogs":
            case 6:
                message.type = 6;
                break;
            }
            if (object.pageToken != null)
                if (typeof object.pageToken === "string")
                    $util.base64.decode(object.pageToken, message.pageToken = $util.newBuffer($util.base64.length(object.pageToken)), 0);
                else if (object.pageToken.length >= 0)
                    message.pageToken = object.pageToken;
            if (object.pageSize != null)
                if ($util.Long)
                    (message.pageSize = $util.Long.fromValue(object.pageSize)).unsigned = true;
                else if (typeof object.pageSize === "string")
                    message.pageSize = parseInt(object.pageSize, 10);
                else if (typeof object.pageSize === "number")
                    message.pageSize = object.pageSize;
                else if (typeof object.pageSize === "object")
                    message.pageSize = new $util.LongBits(object.pageSize.low >>> 0, object.pageSize.high >>> 0).toNumber(true);
            switch (object.orderBy) {
            default:
                if (typeof object.orderBy === "number") {
                    message.orderBy = object.orderBy;
                    break;
                }
                break;
            case "UPDATEDTIME":
            case 0:
                message.orderBy = 0;
                break;
            case "CREATEDTIME":
            case 1:
                message.orderBy = 1;
                break;
            case "NAME":
            case 2:
                message.orderBy = 2;
                break;
            case "SIZE":
            case 3:
                message.orderBy = 3;
                break;
            }
            if (object.regex != null)
                message.regex = String(object.regex);
            switch (object.typeOfPath) {
            default:
                if (typeof object.typeOfPath === "number") {
                    message.typeOfPath = object.typeOfPath;
                    break;
                }
                break;
            case "TShareUser":
            case 0:
                message.typeOfPath = 0;
                break;
            case "TFolder":
            case 1:
                message.typeOfPath = 1;
                break;
            case "TShareTeam":
            case 2:
                message.typeOfPath = 2;
                break;
            case "TShareExternal":
            case 3:
                message.typeOfPath = 3;
                break;
            case "TFlow":
            case 4:
                message.typeOfPath = 4;
                break;
            }
            if (object.onlyFolders != null)
                message.onlyFolders = Boolean(object.onlyFolders);
            if (object.onlyNames != null)
                message.onlyNames = Boolean(object.onlyNames);
            if (object.regexOptions != null) {
                if (typeof object.regexOptions !== "object")
                    throw TypeError(".request.List.regexOptions: object expected");
                message.regexOptions = $root.request.RegexOptions.fromObject(object.regexOptions);
            }
            return message;
        };

        /**
         * Creates a plain object from a List message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.List
         * @static
         * @param {request.List} message List
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        List.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.type = options.enums === String ? "Chunks" : 0;
                object.typeOfPath = options.enums === String ? "TShareUser" : 0;
            }
            if (message.uuid != null && message.hasOwnProperty("uuid")) {
                object.uuid = options.bytes === String ? $util.base64.encode(message.uuid, 0, message.uuid.length) : options.bytes === Array ? Array.prototype.slice.call(message.uuid) : message.uuid;
                if (options.oneofs)
                    object._uuid = "uuid";
            }
            if (message.path != null && message.hasOwnProperty("path")) {
                object.path = message.path;
                if (options.oneofs)
                    object._path = "path";
            }
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = options.enums === String ? $root.request.ListType[message.type] === undefined ? message.type : $root.request.ListType[message.type] : message.type;
            if (message.pageToken != null && message.hasOwnProperty("pageToken")) {
                object.pageToken = options.bytes === String ? $util.base64.encode(message.pageToken, 0, message.pageToken.length) : options.bytes === Array ? Array.prototype.slice.call(message.pageToken) : message.pageToken;
                if (options.oneofs)
                    object._pageToken = "pageToken";
            }
            if (message.pageSize != null && message.hasOwnProperty("pageSize")) {
                if (typeof message.pageSize === "number")
                    object.pageSize = options.longs === String ? String(message.pageSize) : message.pageSize;
                else
                    object.pageSize = options.longs === String ? $util.Long.prototype.toString.call(message.pageSize) : options.longs === Number ? new $util.LongBits(message.pageSize.low >>> 0, message.pageSize.high >>> 0).toNumber(true) : message.pageSize;
                if (options.oneofs)
                    object._pageSize = "pageSize";
            }
            if (message.orderBy != null && message.hasOwnProperty("orderBy")) {
                object.orderBy = options.enums === String ? $root.request.OrderBy[message.orderBy] === undefined ? message.orderBy : $root.request.OrderBy[message.orderBy] : message.orderBy;
                if (options.oneofs)
                    object._orderBy = "orderBy";
            }
            if (message.regex != null && message.hasOwnProperty("regex")) {
                object.regex = message.regex;
                if (options.oneofs)
                    object._regex = "regex";
            }
            if (message.typeOfPath != null && message.hasOwnProperty("typeOfPath"))
                object.typeOfPath = options.enums === String ? $root.request.TypeOfPath[message.typeOfPath] === undefined ? message.typeOfPath : $root.request.TypeOfPath[message.typeOfPath] : message.typeOfPath;
            if (message.onlyFolders != null && message.hasOwnProperty("onlyFolders")) {
                object.onlyFolders = message.onlyFolders;
                if (options.oneofs)
                    object._onlyFolders = "onlyFolders";
            }
            if (message.onlyNames != null && message.hasOwnProperty("onlyNames")) {
                object.onlyNames = message.onlyNames;
                if (options.oneofs)
                    object._onlyNames = "onlyNames";
            }
            if (message.regexOptions != null && message.hasOwnProperty("regexOptions")) {
                object.regexOptions = $root.request.RegexOptions.toObject(message.regexOptions, options);
                if (options.oneofs)
                    object._regexOptions = "regexOptions";
            }
            return object;
        };

        /**
         * Converts this List to JSON.
         * @function toJSON
         * @memberof request.List
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        List.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for List
         * @function getTypeUrl
         * @memberof request.List
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        List.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.List";
        };

        return List;
    })();

    request.ProfileChunkList = (function() {

        /**
         * Properties of a ProfileChunkList.
         * @memberof request
         * @interface IProfileChunkList
         * @property {Uint8Array|null} [uuid] ProfileChunkList uuid
         * @property {Uint8Array|null} [pageToken] ProfileChunkList pageToken
         * @property {number|Long|null} [pageSize] ProfileChunkList pageSize
         * @property {string|null} [path] ProfileChunkList path
         */

        /**
         * Constructs a new ProfileChunkList.
         * @memberof request
         * @classdesc Represents a ProfileChunkList.
         * @implements IProfileChunkList
         * @constructor
         * @param {request.IProfileChunkList=} [properties] Properties to set
         */
        function ProfileChunkList(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ProfileChunkList uuid.
         * @member {Uint8Array|null|undefined} uuid
         * @memberof request.ProfileChunkList
         * @instance
         */
        ProfileChunkList.prototype.uuid = null;

        /**
         * ProfileChunkList pageToken.
         * @member {Uint8Array|null|undefined} pageToken
         * @memberof request.ProfileChunkList
         * @instance
         */
        ProfileChunkList.prototype.pageToken = null;

        /**
         * ProfileChunkList pageSize.
         * @member {number|Long|null|undefined} pageSize
         * @memberof request.ProfileChunkList
         * @instance
         */
        ProfileChunkList.prototype.pageSize = null;

        /**
         * ProfileChunkList path.
         * @member {string} path
         * @memberof request.ProfileChunkList
         * @instance
         */
        ProfileChunkList.prototype.path = "";

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(ProfileChunkList.prototype, "_uuid", {
            get: $util.oneOfGetter($oneOfFields = ["uuid"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(ProfileChunkList.prototype, "_pageToken", {
            get: $util.oneOfGetter($oneOfFields = ["pageToken"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(ProfileChunkList.prototype, "_pageSize", {
            get: $util.oneOfGetter($oneOfFields = ["pageSize"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new ProfileChunkList instance using the specified properties.
         * @function create
         * @memberof request.ProfileChunkList
         * @static
         * @param {request.IProfileChunkList=} [properties] Properties to set
         * @returns {request.ProfileChunkList} ProfileChunkList instance
         */
        ProfileChunkList.create = function create(properties) {
            return new ProfileChunkList(properties);
        };

        /**
         * Encodes the specified ProfileChunkList message. Does not implicitly {@link request.ProfileChunkList.verify|verify} messages.
         * @function encode
         * @memberof request.ProfileChunkList
         * @static
         * @param {request.IProfileChunkList} message ProfileChunkList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProfileChunkList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uuid != null && Object.hasOwnProperty.call(message, "uuid"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.uuid);
            if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.pageToken);
            if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                writer.uint32(/* id 5, wireType 0 =*/40).uint64(message.pageSize);
            if (message.path != null && Object.hasOwnProperty.call(message, "path"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.path);
            return writer;
        };

        /**
         * Encodes the specified ProfileChunkList message, length delimited. Does not implicitly {@link request.ProfileChunkList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.ProfileChunkList
         * @static
         * @param {request.IProfileChunkList} message ProfileChunkList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProfileChunkList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ProfileChunkList message from the specified reader or buffer.
         * @function decode
         * @memberof request.ProfileChunkList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.ProfileChunkList} ProfileChunkList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProfileChunkList.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.ProfileChunkList();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.uuid = reader.bytes();
                        break;
                    }
                case 4: {
                        message.pageToken = reader.bytes();
                        break;
                    }
                case 5: {
                        message.pageSize = reader.uint64();
                        break;
                    }
                case 6: {
                        message.path = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ProfileChunkList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.ProfileChunkList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.ProfileChunkList} ProfileChunkList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProfileChunkList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ProfileChunkList message.
         * @function verify
         * @memberof request.ProfileChunkList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ProfileChunkList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.uuid != null && message.hasOwnProperty("uuid")) {
                properties._uuid = 1;
                if (!(message.uuid && typeof message.uuid.length === "number" || $util.isString(message.uuid)))
                    return "uuid: buffer expected";
            }
            if (message.pageToken != null && message.hasOwnProperty("pageToken")) {
                properties._pageToken = 1;
                if (!(message.pageToken && typeof message.pageToken.length === "number" || $util.isString(message.pageToken)))
                    return "pageToken: buffer expected";
            }
            if (message.pageSize != null && message.hasOwnProperty("pageSize")) {
                properties._pageSize = 1;
                if (!$util.isInteger(message.pageSize) && !(message.pageSize && $util.isInteger(message.pageSize.low) && $util.isInteger(message.pageSize.high)))
                    return "pageSize: integer|Long expected";
            }
            if (message.path != null && message.hasOwnProperty("path"))
                if (!$util.isString(message.path))
                    return "path: string expected";
            return null;
        };

        /**
         * Creates a ProfileChunkList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.ProfileChunkList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.ProfileChunkList} ProfileChunkList
         */
        ProfileChunkList.fromObject = function fromObject(object) {
            if (object instanceof $root.request.ProfileChunkList)
                return object;
            let message = new $root.request.ProfileChunkList();
            if (object.uuid != null)
                if (typeof object.uuid === "string")
                    $util.base64.decode(object.uuid, message.uuid = $util.newBuffer($util.base64.length(object.uuid)), 0);
                else if (object.uuid.length >= 0)
                    message.uuid = object.uuid;
            if (object.pageToken != null)
                if (typeof object.pageToken === "string")
                    $util.base64.decode(object.pageToken, message.pageToken = $util.newBuffer($util.base64.length(object.pageToken)), 0);
                else if (object.pageToken.length >= 0)
                    message.pageToken = object.pageToken;
            if (object.pageSize != null)
                if ($util.Long)
                    (message.pageSize = $util.Long.fromValue(object.pageSize)).unsigned = true;
                else if (typeof object.pageSize === "string")
                    message.pageSize = parseInt(object.pageSize, 10);
                else if (typeof object.pageSize === "number")
                    message.pageSize = object.pageSize;
                else if (typeof object.pageSize === "object")
                    message.pageSize = new $util.LongBits(object.pageSize.low >>> 0, object.pageSize.high >>> 0).toNumber(true);
            if (object.path != null)
                message.path = String(object.path);
            return message;
        };

        /**
         * Creates a plain object from a ProfileChunkList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.ProfileChunkList
         * @static
         * @param {request.ProfileChunkList} message ProfileChunkList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ProfileChunkList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.path = "";
            if (message.uuid != null && message.hasOwnProperty("uuid")) {
                object.uuid = options.bytes === String ? $util.base64.encode(message.uuid, 0, message.uuid.length) : options.bytes === Array ? Array.prototype.slice.call(message.uuid) : message.uuid;
                if (options.oneofs)
                    object._uuid = "uuid";
            }
            if (message.pageToken != null && message.hasOwnProperty("pageToken")) {
                object.pageToken = options.bytes === String ? $util.base64.encode(message.pageToken, 0, message.pageToken.length) : options.bytes === Array ? Array.prototype.slice.call(message.pageToken) : message.pageToken;
                if (options.oneofs)
                    object._pageToken = "pageToken";
            }
            if (message.pageSize != null && message.hasOwnProperty("pageSize")) {
                if (typeof message.pageSize === "number")
                    object.pageSize = options.longs === String ? String(message.pageSize) : message.pageSize;
                else
                    object.pageSize = options.longs === String ? $util.Long.prototype.toString.call(message.pageSize) : options.longs === Number ? new $util.LongBits(message.pageSize.low >>> 0, message.pageSize.high >>> 0).toNumber(true) : message.pageSize;
                if (options.oneofs)
                    object._pageSize = "pageSize";
            }
            if (message.path != null && message.hasOwnProperty("path"))
                object.path = message.path;
            return object;
        };

        /**
         * Converts this ProfileChunkList to JSON.
         * @function toJSON
         * @memberof request.ProfileChunkList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ProfileChunkList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ProfileChunkList
         * @function getTypeUrl
         * @memberof request.ProfileChunkList
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ProfileChunkList.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.ProfileChunkList";
        };

        return ProfileChunkList;
    })();

    request.AuditLogMessage = (function() {

        /**
         * Properties of an AuditLogMessage.
         * @memberof request
         * @interface IAuditLogMessage
         * @property {Uint8Array|null} [uuid] AuditLogMessage uuid
         * @property {Uint8Array|null} [log] AuditLogMessage log
         * @property {string|null} [logFile] AuditLogMessage logFile
         */

        /**
         * Constructs a new AuditLogMessage.
         * @memberof request
         * @classdesc Represents an AuditLogMessage.
         * @implements IAuditLogMessage
         * @constructor
         * @param {request.IAuditLogMessage=} [properties] Properties to set
         */
        function AuditLogMessage(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AuditLogMessage uuid.
         * @member {Uint8Array} uuid
         * @memberof request.AuditLogMessage
         * @instance
         */
        AuditLogMessage.prototype.uuid = $util.newBuffer([]);

        /**
         * AuditLogMessage log.
         * @member {Uint8Array} log
         * @memberof request.AuditLogMessage
         * @instance
         */
        AuditLogMessage.prototype.log = $util.newBuffer([]);

        /**
         * AuditLogMessage logFile.
         * @member {string|null|undefined} logFile
         * @memberof request.AuditLogMessage
         * @instance
         */
        AuditLogMessage.prototype.logFile = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(AuditLogMessage.prototype, "_logFile", {
            get: $util.oneOfGetter($oneOfFields = ["logFile"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new AuditLogMessage instance using the specified properties.
         * @function create
         * @memberof request.AuditLogMessage
         * @static
         * @param {request.IAuditLogMessage=} [properties] Properties to set
         * @returns {request.AuditLogMessage} AuditLogMessage instance
         */
        AuditLogMessage.create = function create(properties) {
            return new AuditLogMessage(properties);
        };

        /**
         * Encodes the specified AuditLogMessage message. Does not implicitly {@link request.AuditLogMessage.verify|verify} messages.
         * @function encode
         * @memberof request.AuditLogMessage
         * @static
         * @param {request.IAuditLogMessage} message AuditLogMessage message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AuditLogMessage.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uuid != null && Object.hasOwnProperty.call(message, "uuid"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.uuid);
            if (message.log != null && Object.hasOwnProperty.call(message, "log"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.log);
            if (message.logFile != null && Object.hasOwnProperty.call(message, "logFile"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.logFile);
            return writer;
        };

        /**
         * Encodes the specified AuditLogMessage message, length delimited. Does not implicitly {@link request.AuditLogMessage.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.AuditLogMessage
         * @static
         * @param {request.IAuditLogMessage} message AuditLogMessage message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AuditLogMessage.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AuditLogMessage message from the specified reader or buffer.
         * @function decode
         * @memberof request.AuditLogMessage
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.AuditLogMessage} AuditLogMessage
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AuditLogMessage.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.AuditLogMessage();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.uuid = reader.bytes();
                        break;
                    }
                case 2: {
                        message.log = reader.bytes();
                        break;
                    }
                case 3: {
                        message.logFile = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AuditLogMessage message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.AuditLogMessage
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.AuditLogMessage} AuditLogMessage
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AuditLogMessage.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AuditLogMessage message.
         * @function verify
         * @memberof request.AuditLogMessage
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AuditLogMessage.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                if (!(message.uuid && typeof message.uuid.length === "number" || $util.isString(message.uuid)))
                    return "uuid: buffer expected";
            if (message.log != null && message.hasOwnProperty("log"))
                if (!(message.log && typeof message.log.length === "number" || $util.isString(message.log)))
                    return "log: buffer expected";
            if (message.logFile != null && message.hasOwnProperty("logFile")) {
                properties._logFile = 1;
                if (!$util.isString(message.logFile))
                    return "logFile: string expected";
            }
            return null;
        };

        /**
         * Creates an AuditLogMessage message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.AuditLogMessage
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.AuditLogMessage} AuditLogMessage
         */
        AuditLogMessage.fromObject = function fromObject(object) {
            if (object instanceof $root.request.AuditLogMessage)
                return object;
            let message = new $root.request.AuditLogMessage();
            if (object.uuid != null)
                if (typeof object.uuid === "string")
                    $util.base64.decode(object.uuid, message.uuid = $util.newBuffer($util.base64.length(object.uuid)), 0);
                else if (object.uuid.length >= 0)
                    message.uuid = object.uuid;
            if (object.log != null)
                if (typeof object.log === "string")
                    $util.base64.decode(object.log, message.log = $util.newBuffer($util.base64.length(object.log)), 0);
                else if (object.log.length >= 0)
                    message.log = object.log;
            if (object.logFile != null)
                message.logFile = String(object.logFile);
            return message;
        };

        /**
         * Creates a plain object from an AuditLogMessage message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.AuditLogMessage
         * @static
         * @param {request.AuditLogMessage} message AuditLogMessage
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AuditLogMessage.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if (options.bytes === String)
                    object.uuid = "";
                else {
                    object.uuid = [];
                    if (options.bytes !== Array)
                        object.uuid = $util.newBuffer(object.uuid);
                }
                if (options.bytes === String)
                    object.log = "";
                else {
                    object.log = [];
                    if (options.bytes !== Array)
                        object.log = $util.newBuffer(object.log);
                }
            }
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                object.uuid = options.bytes === String ? $util.base64.encode(message.uuid, 0, message.uuid.length) : options.bytes === Array ? Array.prototype.slice.call(message.uuid) : message.uuid;
            if (message.log != null && message.hasOwnProperty("log"))
                object.log = options.bytes === String ? $util.base64.encode(message.log, 0, message.log.length) : options.bytes === Array ? Array.prototype.slice.call(message.log) : message.log;
            if (message.logFile != null && message.hasOwnProperty("logFile")) {
                object.logFile = message.logFile;
                if (options.oneofs)
                    object._logFile = "logFile";
            }
            return object;
        };

        /**
         * Converts this AuditLogMessage to JSON.
         * @function toJSON
         * @memberof request.AuditLogMessage
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AuditLogMessage.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for AuditLogMessage
         * @function getTypeUrl
         * @memberof request.AuditLogMessage
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        AuditLogMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.AuditLogMessage";
        };

        return AuditLogMessage;
    })();

    request.VerifyAuditLogMeta = (function() {

        /**
         * Properties of a VerifyAuditLogMeta.
         * @memberof request
         * @interface IVerifyAuditLogMeta
         * @property {string|null} [name] VerifyAuditLogMeta name
         */

        /**
         * Constructs a new VerifyAuditLogMeta.
         * @memberof request
         * @classdesc Represents a VerifyAuditLogMeta.
         * @implements IVerifyAuditLogMeta
         * @constructor
         * @param {request.IVerifyAuditLogMeta=} [properties] Properties to set
         */
        function VerifyAuditLogMeta(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * VerifyAuditLogMeta name.
         * @member {string} name
         * @memberof request.VerifyAuditLogMeta
         * @instance
         */
        VerifyAuditLogMeta.prototype.name = "";

        /**
         * Creates a new VerifyAuditLogMeta instance using the specified properties.
         * @function create
         * @memberof request.VerifyAuditLogMeta
         * @static
         * @param {request.IVerifyAuditLogMeta=} [properties] Properties to set
         * @returns {request.VerifyAuditLogMeta} VerifyAuditLogMeta instance
         */
        VerifyAuditLogMeta.create = function create(properties) {
            return new VerifyAuditLogMeta(properties);
        };

        /**
         * Encodes the specified VerifyAuditLogMeta message. Does not implicitly {@link request.VerifyAuditLogMeta.verify|verify} messages.
         * @function encode
         * @memberof request.VerifyAuditLogMeta
         * @static
         * @param {request.IVerifyAuditLogMeta} message VerifyAuditLogMeta message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        VerifyAuditLogMeta.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
            return writer;
        };

        /**
         * Encodes the specified VerifyAuditLogMeta message, length delimited. Does not implicitly {@link request.VerifyAuditLogMeta.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.VerifyAuditLogMeta
         * @static
         * @param {request.IVerifyAuditLogMeta} message VerifyAuditLogMeta message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        VerifyAuditLogMeta.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a VerifyAuditLogMeta message from the specified reader or buffer.
         * @function decode
         * @memberof request.VerifyAuditLogMeta
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.VerifyAuditLogMeta} VerifyAuditLogMeta
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        VerifyAuditLogMeta.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.VerifyAuditLogMeta();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.name = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a VerifyAuditLogMeta message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.VerifyAuditLogMeta
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.VerifyAuditLogMeta} VerifyAuditLogMeta
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        VerifyAuditLogMeta.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a VerifyAuditLogMeta message.
         * @function verify
         * @memberof request.VerifyAuditLogMeta
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        VerifyAuditLogMeta.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            return null;
        };

        /**
         * Creates a VerifyAuditLogMeta message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.VerifyAuditLogMeta
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.VerifyAuditLogMeta} VerifyAuditLogMeta
         */
        VerifyAuditLogMeta.fromObject = function fromObject(object) {
            if (object instanceof $root.request.VerifyAuditLogMeta)
                return object;
            let message = new $root.request.VerifyAuditLogMeta();
            if (object.name != null)
                message.name = String(object.name);
            return message;
        };

        /**
         * Creates a plain object from a VerifyAuditLogMeta message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.VerifyAuditLogMeta
         * @static
         * @param {request.VerifyAuditLogMeta} message VerifyAuditLogMeta
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        VerifyAuditLogMeta.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.name = "";
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            return object;
        };

        /**
         * Converts this VerifyAuditLogMeta to JSON.
         * @function toJSON
         * @memberof request.VerifyAuditLogMeta
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        VerifyAuditLogMeta.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for VerifyAuditLogMeta
         * @function getTypeUrl
         * @memberof request.VerifyAuditLogMeta
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        VerifyAuditLogMeta.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.VerifyAuditLogMeta";
        };

        return VerifyAuditLogMeta;
    })();

    request.GetLedgerRange = (function() {

        /**
         * Properties of a GetLedgerRange.
         * @memberof request
         * @interface IGetLedgerRange
         * @property {number|Long|null} [startTime] GetLedgerRange startTime
         * @property {number|Long|null} [endTime] GetLedgerRange endTime
         */

        /**
         * Constructs a new GetLedgerRange.
         * @memberof request
         * @classdesc Represents a GetLedgerRange.
         * @implements IGetLedgerRange
         * @constructor
         * @param {request.IGetLedgerRange=} [properties] Properties to set
         */
        function GetLedgerRange(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetLedgerRange startTime.
         * @member {number|Long} startTime
         * @memberof request.GetLedgerRange
         * @instance
         */
        GetLedgerRange.prototype.startTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * GetLedgerRange endTime.
         * @member {number|Long} endTime
         * @memberof request.GetLedgerRange
         * @instance
         */
        GetLedgerRange.prototype.endTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new GetLedgerRange instance using the specified properties.
         * @function create
         * @memberof request.GetLedgerRange
         * @static
         * @param {request.IGetLedgerRange=} [properties] Properties to set
         * @returns {request.GetLedgerRange} GetLedgerRange instance
         */
        GetLedgerRange.create = function create(properties) {
            return new GetLedgerRange(properties);
        };

        /**
         * Encodes the specified GetLedgerRange message. Does not implicitly {@link request.GetLedgerRange.verify|verify} messages.
         * @function encode
         * @memberof request.GetLedgerRange
         * @static
         * @param {request.IGetLedgerRange} message GetLedgerRange message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetLedgerRange.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.startTime != null && Object.hasOwnProperty.call(message, "startTime"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.startTime);
            if (message.endTime != null && Object.hasOwnProperty.call(message, "endTime"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.endTime);
            return writer;
        };

        /**
         * Encodes the specified GetLedgerRange message, length delimited. Does not implicitly {@link request.GetLedgerRange.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.GetLedgerRange
         * @static
         * @param {request.IGetLedgerRange} message GetLedgerRange message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetLedgerRange.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetLedgerRange message from the specified reader or buffer.
         * @function decode
         * @memberof request.GetLedgerRange
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.GetLedgerRange} GetLedgerRange
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetLedgerRange.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.GetLedgerRange();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.startTime = reader.uint64();
                        break;
                    }
                case 2: {
                        message.endTime = reader.uint64();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetLedgerRange message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.GetLedgerRange
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.GetLedgerRange} GetLedgerRange
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetLedgerRange.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetLedgerRange message.
         * @function verify
         * @memberof request.GetLedgerRange
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetLedgerRange.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.startTime != null && message.hasOwnProperty("startTime"))
                if (!$util.isInteger(message.startTime) && !(message.startTime && $util.isInteger(message.startTime.low) && $util.isInteger(message.startTime.high)))
                    return "startTime: integer|Long expected";
            if (message.endTime != null && message.hasOwnProperty("endTime"))
                if (!$util.isInteger(message.endTime) && !(message.endTime && $util.isInteger(message.endTime.low) && $util.isInteger(message.endTime.high)))
                    return "endTime: integer|Long expected";
            return null;
        };

        /**
         * Creates a GetLedgerRange message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.GetLedgerRange
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.GetLedgerRange} GetLedgerRange
         */
        GetLedgerRange.fromObject = function fromObject(object) {
            if (object instanceof $root.request.GetLedgerRange)
                return object;
            let message = new $root.request.GetLedgerRange();
            if (object.startTime != null)
                if ($util.Long)
                    (message.startTime = $util.Long.fromValue(object.startTime)).unsigned = true;
                else if (typeof object.startTime === "string")
                    message.startTime = parseInt(object.startTime, 10);
                else if (typeof object.startTime === "number")
                    message.startTime = object.startTime;
                else if (typeof object.startTime === "object")
                    message.startTime = new $util.LongBits(object.startTime.low >>> 0, object.startTime.high >>> 0).toNumber(true);
            if (object.endTime != null)
                if ($util.Long)
                    (message.endTime = $util.Long.fromValue(object.endTime)).unsigned = true;
                else if (typeof object.endTime === "string")
                    message.endTime = parseInt(object.endTime, 10);
                else if (typeof object.endTime === "number")
                    message.endTime = object.endTime;
                else if (typeof object.endTime === "object")
                    message.endTime = new $util.LongBits(object.endTime.low >>> 0, object.endTime.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a GetLedgerRange message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.GetLedgerRange
         * @static
         * @param {request.GetLedgerRange} message GetLedgerRange
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetLedgerRange.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.startTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.startTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.endTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.endTime = options.longs === String ? "0" : 0;
            }
            if (message.startTime != null && message.hasOwnProperty("startTime"))
                if (typeof message.startTime === "number")
                    object.startTime = options.longs === String ? String(message.startTime) : message.startTime;
                else
                    object.startTime = options.longs === String ? $util.Long.prototype.toString.call(message.startTime) : options.longs === Number ? new $util.LongBits(message.startTime.low >>> 0, message.startTime.high >>> 0).toNumber(true) : message.startTime;
            if (message.endTime != null && message.hasOwnProperty("endTime"))
                if (typeof message.endTime === "number")
                    object.endTime = options.longs === String ? String(message.endTime) : message.endTime;
                else
                    object.endTime = options.longs === String ? $util.Long.prototype.toString.call(message.endTime) : options.longs === Number ? new $util.LongBits(message.endTime.low >>> 0, message.endTime.high >>> 0).toNumber(true) : message.endTime;
            return object;
        };

        /**
         * Converts this GetLedgerRange to JSON.
         * @function toJSON
         * @memberof request.GetLedgerRange
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetLedgerRange.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetLedgerRange
         * @function getTypeUrl
         * @memberof request.GetLedgerRange
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetLedgerRange.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.GetLedgerRange";
        };

        return GetLedgerRange;
    })();

    request.GetAuditLog = (function() {

        /**
         * Properties of a GetAuditLog.
         * @memberof request
         * @interface IGetAuditLog
         * @property {string|null} [name] GetAuditLog name
         * @property {request.ChunkFlags|null} [chunkFlags] GetAuditLog chunkFlags
         */

        /**
         * Constructs a new GetAuditLog.
         * @memberof request
         * @classdesc Represents a GetAuditLog.
         * @implements IGetAuditLog
         * @constructor
         * @param {request.IGetAuditLog=} [properties] Properties to set
         */
        function GetAuditLog(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetAuditLog name.
         * @member {string} name
         * @memberof request.GetAuditLog
         * @instance
         */
        GetAuditLog.prototype.name = "";

        /**
         * GetAuditLog chunkFlags.
         * @member {request.ChunkFlags} chunkFlags
         * @memberof request.GetAuditLog
         * @instance
         */
        GetAuditLog.prototype.chunkFlags = 0;

        /**
         * Creates a new GetAuditLog instance using the specified properties.
         * @function create
         * @memberof request.GetAuditLog
         * @static
         * @param {request.IGetAuditLog=} [properties] Properties to set
         * @returns {request.GetAuditLog} GetAuditLog instance
         */
        GetAuditLog.create = function create(properties) {
            return new GetAuditLog(properties);
        };

        /**
         * Encodes the specified GetAuditLog message. Does not implicitly {@link request.GetAuditLog.verify|verify} messages.
         * @function encode
         * @memberof request.GetAuditLog
         * @static
         * @param {request.IGetAuditLog} message GetAuditLog message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetAuditLog.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
            if (message.chunkFlags != null && Object.hasOwnProperty.call(message, "chunkFlags"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.chunkFlags);
            return writer;
        };

        /**
         * Encodes the specified GetAuditLog message, length delimited. Does not implicitly {@link request.GetAuditLog.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.GetAuditLog
         * @static
         * @param {request.IGetAuditLog} message GetAuditLog message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetAuditLog.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetAuditLog message from the specified reader or buffer.
         * @function decode
         * @memberof request.GetAuditLog
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.GetAuditLog} GetAuditLog
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetAuditLog.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.GetAuditLog();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.name = reader.string();
                        break;
                    }
                case 2: {
                        message.chunkFlags = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetAuditLog message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.GetAuditLog
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.GetAuditLog} GetAuditLog
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetAuditLog.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetAuditLog message.
         * @function verify
         * @memberof request.GetAuditLog
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetAuditLog.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.chunkFlags != null && message.hasOwnProperty("chunkFlags"))
                switch (message.chunkFlags) {
                default:
                    return "chunkFlags: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            return null;
        };

        /**
         * Creates a GetAuditLog message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.GetAuditLog
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.GetAuditLog} GetAuditLog
         */
        GetAuditLog.fromObject = function fromObject(object) {
            if (object instanceof $root.request.GetAuditLog)
                return object;
            let message = new $root.request.GetAuditLog();
            if (object.name != null)
                message.name = String(object.name);
            switch (object.chunkFlags) {
            default:
                if (typeof object.chunkFlags === "number") {
                    message.chunkFlags = object.chunkFlags;
                    break;
                }
                break;
            case "NONE":
            case 0:
                message.chunkFlags = 0;
                break;
            case "START":
            case 1:
                message.chunkFlags = 1;
                break;
            case "STOP":
            case 2:
                message.chunkFlags = 2;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a GetAuditLog message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.GetAuditLog
         * @static
         * @param {request.GetAuditLog} message GetAuditLog
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetAuditLog.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.name = "";
                object.chunkFlags = options.enums === String ? "NONE" : 0;
            }
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.chunkFlags != null && message.hasOwnProperty("chunkFlags"))
                object.chunkFlags = options.enums === String ? $root.request.ChunkFlags[message.chunkFlags] === undefined ? message.chunkFlags : $root.request.ChunkFlags[message.chunkFlags] : message.chunkFlags;
            return object;
        };

        /**
         * Converts this GetAuditLog to JSON.
         * @function toJSON
         * @memberof request.GetAuditLog
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetAuditLog.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetAuditLog
         * @function getTypeUrl
         * @memberof request.GetAuditLog
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetAuditLog.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.GetAuditLog";
        };

        return GetAuditLog;
    })();

    request.DeleteAuditLog = (function() {

        /**
         * Properties of a DeleteAuditLog.
         * @memberof request
         * @interface IDeleteAuditLog
         * @property {string|null} [name] DeleteAuditLog name
         */

        /**
         * Constructs a new DeleteAuditLog.
         * @memberof request
         * @classdesc Represents a DeleteAuditLog.
         * @implements IDeleteAuditLog
         * @constructor
         * @param {request.IDeleteAuditLog=} [properties] Properties to set
         */
        function DeleteAuditLog(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DeleteAuditLog name.
         * @member {string} name
         * @memberof request.DeleteAuditLog
         * @instance
         */
        DeleteAuditLog.prototype.name = "";

        /**
         * Creates a new DeleteAuditLog instance using the specified properties.
         * @function create
         * @memberof request.DeleteAuditLog
         * @static
         * @param {request.IDeleteAuditLog=} [properties] Properties to set
         * @returns {request.DeleteAuditLog} DeleteAuditLog instance
         */
        DeleteAuditLog.create = function create(properties) {
            return new DeleteAuditLog(properties);
        };

        /**
         * Encodes the specified DeleteAuditLog message. Does not implicitly {@link request.DeleteAuditLog.verify|verify} messages.
         * @function encode
         * @memberof request.DeleteAuditLog
         * @static
         * @param {request.IDeleteAuditLog} message DeleteAuditLog message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DeleteAuditLog.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
            return writer;
        };

        /**
         * Encodes the specified DeleteAuditLog message, length delimited. Does not implicitly {@link request.DeleteAuditLog.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.DeleteAuditLog
         * @static
         * @param {request.IDeleteAuditLog} message DeleteAuditLog message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DeleteAuditLog.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a DeleteAuditLog message from the specified reader or buffer.
         * @function decode
         * @memberof request.DeleteAuditLog
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.DeleteAuditLog} DeleteAuditLog
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DeleteAuditLog.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.DeleteAuditLog();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.name = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a DeleteAuditLog message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.DeleteAuditLog
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.DeleteAuditLog} DeleteAuditLog
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DeleteAuditLog.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a DeleteAuditLog message.
         * @function verify
         * @memberof request.DeleteAuditLog
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        DeleteAuditLog.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            return null;
        };

        /**
         * Creates a DeleteAuditLog message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.DeleteAuditLog
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.DeleteAuditLog} DeleteAuditLog
         */
        DeleteAuditLog.fromObject = function fromObject(object) {
            if (object instanceof $root.request.DeleteAuditLog)
                return object;
            let message = new $root.request.DeleteAuditLog();
            if (object.name != null)
                message.name = String(object.name);
            return message;
        };

        /**
         * Creates a plain object from a DeleteAuditLog message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.DeleteAuditLog
         * @static
         * @param {request.DeleteAuditLog} message DeleteAuditLog
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DeleteAuditLog.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.name = "";
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            return object;
        };

        /**
         * Converts this DeleteAuditLog to JSON.
         * @function toJSON
         * @memberof request.DeleteAuditLog
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DeleteAuditLog.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for DeleteAuditLog
         * @function getTypeUrl
         * @memberof request.DeleteAuditLog
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        DeleteAuditLog.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.DeleteAuditLog";
        };

        return DeleteAuditLog;
    })();

    request.UserProfile = (function() {

        /**
         * Properties of a UserProfile.
         * @memberof request
         * @interface IUserProfile
         * @property {string|null} [firstname] UserProfile firstname
         * @property {string|null} [lastname] UserProfile lastname
         * @property {string|null} [location] UserProfile location
         * @property {string|null} [phone] UserProfile phone
         * @property {string|null} [address] UserProfile address
         * @property {Uint8Array|null} [profilePicture] UserProfile profilePicture
         */

        /**
         * Constructs a new UserProfile.
         * @memberof request
         * @classdesc Represents a UserProfile.
         * @implements IUserProfile
         * @constructor
         * @param {request.IUserProfile=} [properties] Properties to set
         */
        function UserProfile(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UserProfile firstname.
         * @member {string} firstname
         * @memberof request.UserProfile
         * @instance
         */
        UserProfile.prototype.firstname = "";

        /**
         * UserProfile lastname.
         * @member {string} lastname
         * @memberof request.UserProfile
         * @instance
         */
        UserProfile.prototype.lastname = "";

        /**
         * UserProfile location.
         * @member {string} location
         * @memberof request.UserProfile
         * @instance
         */
        UserProfile.prototype.location = "";

        /**
         * UserProfile phone.
         * @member {string} phone
         * @memberof request.UserProfile
         * @instance
         */
        UserProfile.prototype.phone = "";

        /**
         * UserProfile address.
         * @member {string} address
         * @memberof request.UserProfile
         * @instance
         */
        UserProfile.prototype.address = "";

        /**
         * UserProfile profilePicture.
         * @member {Uint8Array} profilePicture
         * @memberof request.UserProfile
         * @instance
         */
        UserProfile.prototype.profilePicture = $util.newBuffer([]);

        /**
         * Creates a new UserProfile instance using the specified properties.
         * @function create
         * @memberof request.UserProfile
         * @static
         * @param {request.IUserProfile=} [properties] Properties to set
         * @returns {request.UserProfile} UserProfile instance
         */
        UserProfile.create = function create(properties) {
            return new UserProfile(properties);
        };

        /**
         * Encodes the specified UserProfile message. Does not implicitly {@link request.UserProfile.verify|verify} messages.
         * @function encode
         * @memberof request.UserProfile
         * @static
         * @param {request.IUserProfile} message UserProfile message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UserProfile.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.firstname != null && Object.hasOwnProperty.call(message, "firstname"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.firstname);
            if (message.lastname != null && Object.hasOwnProperty.call(message, "lastname"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.lastname);
            if (message.location != null && Object.hasOwnProperty.call(message, "location"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.location);
            if (message.phone != null && Object.hasOwnProperty.call(message, "phone"))
                writer.uint32(/* id 9, wireType 2 =*/74).string(message.phone);
            if (message.address != null && Object.hasOwnProperty.call(message, "address"))
                writer.uint32(/* id 10, wireType 2 =*/82).string(message.address);
            if (message.profilePicture != null && Object.hasOwnProperty.call(message, "profilePicture"))
                writer.uint32(/* id 11, wireType 2 =*/90).bytes(message.profilePicture);
            return writer;
        };

        /**
         * Encodes the specified UserProfile message, length delimited. Does not implicitly {@link request.UserProfile.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.UserProfile
         * @static
         * @param {request.IUserProfile} message UserProfile message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UserProfile.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a UserProfile message from the specified reader or buffer.
         * @function decode
         * @memberof request.UserProfile
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.UserProfile} UserProfile
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UserProfile.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.UserProfile();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 4: {
                        message.firstname = reader.string();
                        break;
                    }
                case 5: {
                        message.lastname = reader.string();
                        break;
                    }
                case 8: {
                        message.location = reader.string();
                        break;
                    }
                case 9: {
                        message.phone = reader.string();
                        break;
                    }
                case 10: {
                        message.address = reader.string();
                        break;
                    }
                case 11: {
                        message.profilePicture = reader.bytes();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a UserProfile message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.UserProfile
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.UserProfile} UserProfile
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UserProfile.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a UserProfile message.
         * @function verify
         * @memberof request.UserProfile
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UserProfile.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.firstname != null && message.hasOwnProperty("firstname"))
                if (!$util.isString(message.firstname))
                    return "firstname: string expected";
            if (message.lastname != null && message.hasOwnProperty("lastname"))
                if (!$util.isString(message.lastname))
                    return "lastname: string expected";
            if (message.location != null && message.hasOwnProperty("location"))
                if (!$util.isString(message.location))
                    return "location: string expected";
            if (message.phone != null && message.hasOwnProperty("phone"))
                if (!$util.isString(message.phone))
                    return "phone: string expected";
            if (message.address != null && message.hasOwnProperty("address"))
                if (!$util.isString(message.address))
                    return "address: string expected";
            if (message.profilePicture != null && message.hasOwnProperty("profilePicture"))
                if (!(message.profilePicture && typeof message.profilePicture.length === "number" || $util.isString(message.profilePicture)))
                    return "profilePicture: buffer expected";
            return null;
        };

        /**
         * Creates a UserProfile message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.UserProfile
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.UserProfile} UserProfile
         */
        UserProfile.fromObject = function fromObject(object) {
            if (object instanceof $root.request.UserProfile)
                return object;
            let message = new $root.request.UserProfile();
            if (object.firstname != null)
                message.firstname = String(object.firstname);
            if (object.lastname != null)
                message.lastname = String(object.lastname);
            if (object.location != null)
                message.location = String(object.location);
            if (object.phone != null)
                message.phone = String(object.phone);
            if (object.address != null)
                message.address = String(object.address);
            if (object.profilePicture != null)
                if (typeof object.profilePicture === "string")
                    $util.base64.decode(object.profilePicture, message.profilePicture = $util.newBuffer($util.base64.length(object.profilePicture)), 0);
                else if (object.profilePicture.length >= 0)
                    message.profilePicture = object.profilePicture;
            return message;
        };

        /**
         * Creates a plain object from a UserProfile message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.UserProfile
         * @static
         * @param {request.UserProfile} message UserProfile
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UserProfile.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.firstname = "";
                object.lastname = "";
                object.location = "";
                object.phone = "";
                object.address = "";
                if (options.bytes === String)
                    object.profilePicture = "";
                else {
                    object.profilePicture = [];
                    if (options.bytes !== Array)
                        object.profilePicture = $util.newBuffer(object.profilePicture);
                }
            }
            if (message.firstname != null && message.hasOwnProperty("firstname"))
                object.firstname = message.firstname;
            if (message.lastname != null && message.hasOwnProperty("lastname"))
                object.lastname = message.lastname;
            if (message.location != null && message.hasOwnProperty("location"))
                object.location = message.location;
            if (message.phone != null && message.hasOwnProperty("phone"))
                object.phone = message.phone;
            if (message.address != null && message.hasOwnProperty("address"))
                object.address = message.address;
            if (message.profilePicture != null && message.hasOwnProperty("profilePicture"))
                object.profilePicture = options.bytes === String ? $util.base64.encode(message.profilePicture, 0, message.profilePicture.length) : options.bytes === Array ? Array.prototype.slice.call(message.profilePicture) : message.profilePicture;
            return object;
        };

        /**
         * Converts this UserProfile to JSON.
         * @function toJSON
         * @memberof request.UserProfile
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UserProfile.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for UserProfile
         * @function getTypeUrl
         * @memberof request.UserProfile
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        UserProfile.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.UserProfile";
        };

        return UserProfile;
    })();

    request.OrganizationProfile = (function() {

        /**
         * Properties of an OrganizationProfile.
         * @memberof request
         * @interface IOrganizationProfile
         * @property {string|null} [phone] OrganizationProfile phone
         * @property {string|null} [address] OrganizationProfile address
         * @property {string|null} [taxId] OrganizationProfile taxId
         * @property {string|null} [vatId] OrganizationProfile vatId
         * @property {string|null} [registrationId] OrganizationProfile registrationId
         * @property {Uint8Array|null} [logo] OrganizationProfile logo
         * @property {string|null} [location] OrganizationProfile location
         */

        /**
         * Constructs a new OrganizationProfile.
         * @memberof request
         * @classdesc Represents an OrganizationProfile.
         * @implements IOrganizationProfile
         * @constructor
         * @param {request.IOrganizationProfile=} [properties] Properties to set
         */
        function OrganizationProfile(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * OrganizationProfile phone.
         * @member {string} phone
         * @memberof request.OrganizationProfile
         * @instance
         */
        OrganizationProfile.prototype.phone = "";

        /**
         * OrganizationProfile address.
         * @member {string} address
         * @memberof request.OrganizationProfile
         * @instance
         */
        OrganizationProfile.prototype.address = "";

        /**
         * OrganizationProfile taxId.
         * @member {string} taxId
         * @memberof request.OrganizationProfile
         * @instance
         */
        OrganizationProfile.prototype.taxId = "";

        /**
         * OrganizationProfile vatId.
         * @member {string} vatId
         * @memberof request.OrganizationProfile
         * @instance
         */
        OrganizationProfile.prototype.vatId = "";

        /**
         * OrganizationProfile registrationId.
         * @member {string} registrationId
         * @memberof request.OrganizationProfile
         * @instance
         */
        OrganizationProfile.prototype.registrationId = "";

        /**
         * OrganizationProfile logo.
         * @member {Uint8Array} logo
         * @memberof request.OrganizationProfile
         * @instance
         */
        OrganizationProfile.prototype.logo = $util.newBuffer([]);

        /**
         * OrganizationProfile location.
         * @member {string} location
         * @memberof request.OrganizationProfile
         * @instance
         */
        OrganizationProfile.prototype.location = "";

        /**
         * Creates a new OrganizationProfile instance using the specified properties.
         * @function create
         * @memberof request.OrganizationProfile
         * @static
         * @param {request.IOrganizationProfile=} [properties] Properties to set
         * @returns {request.OrganizationProfile} OrganizationProfile instance
         */
        OrganizationProfile.create = function create(properties) {
            return new OrganizationProfile(properties);
        };

        /**
         * Encodes the specified OrganizationProfile message. Does not implicitly {@link request.OrganizationProfile.verify|verify} messages.
         * @function encode
         * @memberof request.OrganizationProfile
         * @static
         * @param {request.IOrganizationProfile} message OrganizationProfile message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OrganizationProfile.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.phone != null && Object.hasOwnProperty.call(message, "phone"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.phone);
            if (message.address != null && Object.hasOwnProperty.call(message, "address"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.address);
            if (message.taxId != null && Object.hasOwnProperty.call(message, "taxId"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.taxId);
            if (message.vatId != null && Object.hasOwnProperty.call(message, "vatId"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.vatId);
            if (message.registrationId != null && Object.hasOwnProperty.call(message, "registrationId"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.registrationId);
            if (message.logo != null && Object.hasOwnProperty.call(message, "logo"))
                writer.uint32(/* id 9, wireType 2 =*/74).bytes(message.logo);
            if (message.location != null && Object.hasOwnProperty.call(message, "location"))
                writer.uint32(/* id 10, wireType 2 =*/82).string(message.location);
            return writer;
        };

        /**
         * Encodes the specified OrganizationProfile message, length delimited. Does not implicitly {@link request.OrganizationProfile.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.OrganizationProfile
         * @static
         * @param {request.IOrganizationProfile} message OrganizationProfile message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OrganizationProfile.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an OrganizationProfile message from the specified reader or buffer.
         * @function decode
         * @memberof request.OrganizationProfile
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.OrganizationProfile} OrganizationProfile
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OrganizationProfile.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.OrganizationProfile();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 3: {
                        message.phone = reader.string();
                        break;
                    }
                case 4: {
                        message.address = reader.string();
                        break;
                    }
                case 5: {
                        message.taxId = reader.string();
                        break;
                    }
                case 6: {
                        message.vatId = reader.string();
                        break;
                    }
                case 7: {
                        message.registrationId = reader.string();
                        break;
                    }
                case 9: {
                        message.logo = reader.bytes();
                        break;
                    }
                case 10: {
                        message.location = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an OrganizationProfile message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.OrganizationProfile
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.OrganizationProfile} OrganizationProfile
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OrganizationProfile.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an OrganizationProfile message.
         * @function verify
         * @memberof request.OrganizationProfile
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        OrganizationProfile.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.phone != null && message.hasOwnProperty("phone"))
                if (!$util.isString(message.phone))
                    return "phone: string expected";
            if (message.address != null && message.hasOwnProperty("address"))
                if (!$util.isString(message.address))
                    return "address: string expected";
            if (message.taxId != null && message.hasOwnProperty("taxId"))
                if (!$util.isString(message.taxId))
                    return "taxId: string expected";
            if (message.vatId != null && message.hasOwnProperty("vatId"))
                if (!$util.isString(message.vatId))
                    return "vatId: string expected";
            if (message.registrationId != null && message.hasOwnProperty("registrationId"))
                if (!$util.isString(message.registrationId))
                    return "registrationId: string expected";
            if (message.logo != null && message.hasOwnProperty("logo"))
                if (!(message.logo && typeof message.logo.length === "number" || $util.isString(message.logo)))
                    return "logo: buffer expected";
            if (message.location != null && message.hasOwnProperty("location"))
                if (!$util.isString(message.location))
                    return "location: string expected";
            return null;
        };

        /**
         * Creates an OrganizationProfile message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.OrganizationProfile
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.OrganizationProfile} OrganizationProfile
         */
        OrganizationProfile.fromObject = function fromObject(object) {
            if (object instanceof $root.request.OrganizationProfile)
                return object;
            let message = new $root.request.OrganizationProfile();
            if (object.phone != null)
                message.phone = String(object.phone);
            if (object.address != null)
                message.address = String(object.address);
            if (object.taxId != null)
                message.taxId = String(object.taxId);
            if (object.vatId != null)
                message.vatId = String(object.vatId);
            if (object.registrationId != null)
                message.registrationId = String(object.registrationId);
            if (object.logo != null)
                if (typeof object.logo === "string")
                    $util.base64.decode(object.logo, message.logo = $util.newBuffer($util.base64.length(object.logo)), 0);
                else if (object.logo.length >= 0)
                    message.logo = object.logo;
            if (object.location != null)
                message.location = String(object.location);
            return message;
        };

        /**
         * Creates a plain object from an OrganizationProfile message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.OrganizationProfile
         * @static
         * @param {request.OrganizationProfile} message OrganizationProfile
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        OrganizationProfile.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.phone = "";
                object.address = "";
                object.taxId = "";
                object.vatId = "";
                object.registrationId = "";
                if (options.bytes === String)
                    object.logo = "";
                else {
                    object.logo = [];
                    if (options.bytes !== Array)
                        object.logo = $util.newBuffer(object.logo);
                }
                object.location = "";
            }
            if (message.phone != null && message.hasOwnProperty("phone"))
                object.phone = message.phone;
            if (message.address != null && message.hasOwnProperty("address"))
                object.address = message.address;
            if (message.taxId != null && message.hasOwnProperty("taxId"))
                object.taxId = message.taxId;
            if (message.vatId != null && message.hasOwnProperty("vatId"))
                object.vatId = message.vatId;
            if (message.registrationId != null && message.hasOwnProperty("registrationId"))
                object.registrationId = message.registrationId;
            if (message.logo != null && message.hasOwnProperty("logo"))
                object.logo = options.bytes === String ? $util.base64.encode(message.logo, 0, message.logo.length) : options.bytes === Array ? Array.prototype.slice.call(message.logo) : message.logo;
            if (message.location != null && message.hasOwnProperty("location"))
                object.location = message.location;
            return object;
        };

        /**
         * Converts this OrganizationProfile to JSON.
         * @function toJSON
         * @memberof request.OrganizationProfile
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        OrganizationProfile.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for OrganizationProfile
         * @function getTypeUrl
         * @memberof request.OrganizationProfile
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        OrganizationProfile.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.OrganizationProfile";
        };

        return OrganizationProfile;
    })();

    request.UserProfileMeta = (function() {

        /**
         * Properties of a UserProfileMeta.
         * @memberof request
         * @interface IUserProfileMeta
         * @property {request.IUserProfile|null} [userObj] UserProfileMeta userObj
         * @property {request.IOrganizationProfile|null} [organizationObj] UserProfileMeta organizationObj
         */

        /**
         * Constructs a new UserProfileMeta.
         * @memberof request
         * @classdesc Represents a UserProfileMeta.
         * @implements IUserProfileMeta
         * @constructor
         * @param {request.IUserProfileMeta=} [properties] Properties to set
         */
        function UserProfileMeta(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UserProfileMeta userObj.
         * @member {request.IUserProfile|null|undefined} userObj
         * @memberof request.UserProfileMeta
         * @instance
         */
        UserProfileMeta.prototype.userObj = null;

        /**
         * UserProfileMeta organizationObj.
         * @member {request.IOrganizationProfile|null|undefined} organizationObj
         * @memberof request.UserProfileMeta
         * @instance
         */
        UserProfileMeta.prototype.organizationObj = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * UserProfileMeta user.
         * @member {"userObj"|"organizationObj"|undefined} user
         * @memberof request.UserProfileMeta
         * @instance
         */
        Object.defineProperty(UserProfileMeta.prototype, "user", {
            get: $util.oneOfGetter($oneOfFields = ["userObj", "organizationObj"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new UserProfileMeta instance using the specified properties.
         * @function create
         * @memberof request.UserProfileMeta
         * @static
         * @param {request.IUserProfileMeta=} [properties] Properties to set
         * @returns {request.UserProfileMeta} UserProfileMeta instance
         */
        UserProfileMeta.create = function create(properties) {
            return new UserProfileMeta(properties);
        };

        /**
         * Encodes the specified UserProfileMeta message. Does not implicitly {@link request.UserProfileMeta.verify|verify} messages.
         * @function encode
         * @memberof request.UserProfileMeta
         * @static
         * @param {request.IUserProfileMeta} message UserProfileMeta message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UserProfileMeta.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.userObj != null && Object.hasOwnProperty.call(message, "userObj"))
                $root.request.UserProfile.encode(message.userObj, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.organizationObj != null && Object.hasOwnProperty.call(message, "organizationObj"))
                $root.request.OrganizationProfile.encode(message.organizationObj, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified UserProfileMeta message, length delimited. Does not implicitly {@link request.UserProfileMeta.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.UserProfileMeta
         * @static
         * @param {request.IUserProfileMeta} message UserProfileMeta message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UserProfileMeta.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a UserProfileMeta message from the specified reader or buffer.
         * @function decode
         * @memberof request.UserProfileMeta
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.UserProfileMeta} UserProfileMeta
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UserProfileMeta.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.UserProfileMeta();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.userObj = $root.request.UserProfile.decode(reader, reader.uint32());
                        break;
                    }
                case 2: {
                        message.organizationObj = $root.request.OrganizationProfile.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a UserProfileMeta message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.UserProfileMeta
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.UserProfileMeta} UserProfileMeta
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UserProfileMeta.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a UserProfileMeta message.
         * @function verify
         * @memberof request.UserProfileMeta
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UserProfileMeta.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.userObj != null && message.hasOwnProperty("userObj")) {
                properties.user = 1;
                {
                    let error = $root.request.UserProfile.verify(message.userObj);
                    if (error)
                        return "userObj." + error;
                }
            }
            if (message.organizationObj != null && message.hasOwnProperty("organizationObj")) {
                if (properties.user === 1)
                    return "user: multiple values";
                properties.user = 1;
                {
                    let error = $root.request.OrganizationProfile.verify(message.organizationObj);
                    if (error)
                        return "organizationObj." + error;
                }
            }
            return null;
        };

        /**
         * Creates a UserProfileMeta message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.UserProfileMeta
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.UserProfileMeta} UserProfileMeta
         */
        UserProfileMeta.fromObject = function fromObject(object) {
            if (object instanceof $root.request.UserProfileMeta)
                return object;
            let message = new $root.request.UserProfileMeta();
            if (object.userObj != null) {
                if (typeof object.userObj !== "object")
                    throw TypeError(".request.UserProfileMeta.userObj: object expected");
                message.userObj = $root.request.UserProfile.fromObject(object.userObj);
            }
            if (object.organizationObj != null) {
                if (typeof object.organizationObj !== "object")
                    throw TypeError(".request.UserProfileMeta.organizationObj: object expected");
                message.organizationObj = $root.request.OrganizationProfile.fromObject(object.organizationObj);
            }
            return message;
        };

        /**
         * Creates a plain object from a UserProfileMeta message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.UserProfileMeta
         * @static
         * @param {request.UserProfileMeta} message UserProfileMeta
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UserProfileMeta.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (message.userObj != null && message.hasOwnProperty("userObj")) {
                object.userObj = $root.request.UserProfile.toObject(message.userObj, options);
                if (options.oneofs)
                    object.user = "userObj";
            }
            if (message.organizationObj != null && message.hasOwnProperty("organizationObj")) {
                object.organizationObj = $root.request.OrganizationProfile.toObject(message.organizationObj, options);
                if (options.oneofs)
                    object.user = "organizationObj";
            }
            return object;
        };

        /**
         * Converts this UserProfileMeta to JSON.
         * @function toJSON
         * @memberof request.UserProfileMeta
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UserProfileMeta.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for UserProfileMeta
         * @function getTypeUrl
         * @memberof request.UserProfileMeta
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        UserProfileMeta.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.UserProfileMeta";
        };

        return UserProfileMeta;
    })();

    request.SetUser = (function() {

        /**
         * Properties of a SetUser.
         * @memberof request
         * @interface ISetUser
         * @property {request.IUserProfileMeta|null} [usermeta] SetUser usermeta
         * @property {string|null} [email] SetUser email
         */

        /**
         * Constructs a new SetUser.
         * @memberof request
         * @classdesc Represents a SetUser.
         * @implements ISetUser
         * @constructor
         * @param {request.ISetUser=} [properties] Properties to set
         */
        function SetUser(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SetUser usermeta.
         * @member {request.IUserProfileMeta|null|undefined} usermeta
         * @memberof request.SetUser
         * @instance
         */
        SetUser.prototype.usermeta = null;

        /**
         * SetUser email.
         * @member {string} email
         * @memberof request.SetUser
         * @instance
         */
        SetUser.prototype.email = "";

        /**
         * Creates a new SetUser instance using the specified properties.
         * @function create
         * @memberof request.SetUser
         * @static
         * @param {request.ISetUser=} [properties] Properties to set
         * @returns {request.SetUser} SetUser instance
         */
        SetUser.create = function create(properties) {
            return new SetUser(properties);
        };

        /**
         * Encodes the specified SetUser message. Does not implicitly {@link request.SetUser.verify|verify} messages.
         * @function encode
         * @memberof request.SetUser
         * @static
         * @param {request.ISetUser} message SetUser message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SetUser.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.usermeta != null && Object.hasOwnProperty.call(message, "usermeta"))
                $root.request.UserProfileMeta.encode(message.usermeta, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.email);
            return writer;
        };

        /**
         * Encodes the specified SetUser message, length delimited. Does not implicitly {@link request.SetUser.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.SetUser
         * @static
         * @param {request.ISetUser} message SetUser message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SetUser.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SetUser message from the specified reader or buffer.
         * @function decode
         * @memberof request.SetUser
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.SetUser} SetUser
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SetUser.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.SetUser();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.usermeta = $root.request.UserProfileMeta.decode(reader, reader.uint32());
                        break;
                    }
                case 2: {
                        message.email = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SetUser message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.SetUser
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.SetUser} SetUser
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SetUser.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SetUser message.
         * @function verify
         * @memberof request.SetUser
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SetUser.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.usermeta != null && message.hasOwnProperty("usermeta")) {
                let error = $root.request.UserProfileMeta.verify(message.usermeta);
                if (error)
                    return "usermeta." + error;
            }
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            return null;
        };

        /**
         * Creates a SetUser message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.SetUser
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.SetUser} SetUser
         */
        SetUser.fromObject = function fromObject(object) {
            if (object instanceof $root.request.SetUser)
                return object;
            let message = new $root.request.SetUser();
            if (object.usermeta != null) {
                if (typeof object.usermeta !== "object")
                    throw TypeError(".request.SetUser.usermeta: object expected");
                message.usermeta = $root.request.UserProfileMeta.fromObject(object.usermeta);
            }
            if (object.email != null)
                message.email = String(object.email);
            return message;
        };

        /**
         * Creates a plain object from a SetUser message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.SetUser
         * @static
         * @param {request.SetUser} message SetUser
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SetUser.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.usermeta = null;
                object.email = "";
            }
            if (message.usermeta != null && message.hasOwnProperty("usermeta"))
                object.usermeta = $root.request.UserProfileMeta.toObject(message.usermeta, options);
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            return object;
        };

        /**
         * Converts this SetUser to JSON.
         * @function toJSON
         * @memberof request.SetUser
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SetUser.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for SetUser
         * @function getTypeUrl
         * @memberof request.SetUser
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        SetUser.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.SetUser";
        };

        return SetUser;
    })();

    request.FinalizeProfileWrite = (function() {

        /**
         * Properties of a FinalizeProfileWrite.
         * @memberof request
         * @interface IFinalizeProfileWrite
         * @property {Uint8Array|null} [uuid] FinalizeProfileWrite uuid
         * @property {Uint8Array|null} [versionUuid] FinalizeProfileWrite versionUuid
         */

        /**
         * Constructs a new FinalizeProfileWrite.
         * @memberof request
         * @classdesc Represents a FinalizeProfileWrite.
         * @implements IFinalizeProfileWrite
         * @constructor
         * @param {request.IFinalizeProfileWrite=} [properties] Properties to set
         */
        function FinalizeProfileWrite(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * FinalizeProfileWrite uuid.
         * @member {Uint8Array} uuid
         * @memberof request.FinalizeProfileWrite
         * @instance
         */
        FinalizeProfileWrite.prototype.uuid = $util.newBuffer([]);

        /**
         * FinalizeProfileWrite versionUuid.
         * @member {Uint8Array} versionUuid
         * @memberof request.FinalizeProfileWrite
         * @instance
         */
        FinalizeProfileWrite.prototype.versionUuid = $util.newBuffer([]);

        /**
         * Creates a new FinalizeProfileWrite instance using the specified properties.
         * @function create
         * @memberof request.FinalizeProfileWrite
         * @static
         * @param {request.IFinalizeProfileWrite=} [properties] Properties to set
         * @returns {request.FinalizeProfileWrite} FinalizeProfileWrite instance
         */
        FinalizeProfileWrite.create = function create(properties) {
            return new FinalizeProfileWrite(properties);
        };

        /**
         * Encodes the specified FinalizeProfileWrite message. Does not implicitly {@link request.FinalizeProfileWrite.verify|verify} messages.
         * @function encode
         * @memberof request.FinalizeProfileWrite
         * @static
         * @param {request.IFinalizeProfileWrite} message FinalizeProfileWrite message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FinalizeProfileWrite.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uuid != null && Object.hasOwnProperty.call(message, "uuid"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.uuid);
            if (message.versionUuid != null && Object.hasOwnProperty.call(message, "versionUuid"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.versionUuid);
            return writer;
        };

        /**
         * Encodes the specified FinalizeProfileWrite message, length delimited. Does not implicitly {@link request.FinalizeProfileWrite.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.FinalizeProfileWrite
         * @static
         * @param {request.IFinalizeProfileWrite} message FinalizeProfileWrite message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FinalizeProfileWrite.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a FinalizeProfileWrite message from the specified reader or buffer.
         * @function decode
         * @memberof request.FinalizeProfileWrite
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.FinalizeProfileWrite} FinalizeProfileWrite
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FinalizeProfileWrite.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.FinalizeProfileWrite();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.uuid = reader.bytes();
                        break;
                    }
                case 2: {
                        message.versionUuid = reader.bytes();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a FinalizeProfileWrite message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.FinalizeProfileWrite
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.FinalizeProfileWrite} FinalizeProfileWrite
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FinalizeProfileWrite.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a FinalizeProfileWrite message.
         * @function verify
         * @memberof request.FinalizeProfileWrite
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        FinalizeProfileWrite.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                if (!(message.uuid && typeof message.uuid.length === "number" || $util.isString(message.uuid)))
                    return "uuid: buffer expected";
            if (message.versionUuid != null && message.hasOwnProperty("versionUuid"))
                if (!(message.versionUuid && typeof message.versionUuid.length === "number" || $util.isString(message.versionUuid)))
                    return "versionUuid: buffer expected";
            return null;
        };

        /**
         * Creates a FinalizeProfileWrite message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.FinalizeProfileWrite
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.FinalizeProfileWrite} FinalizeProfileWrite
         */
        FinalizeProfileWrite.fromObject = function fromObject(object) {
            if (object instanceof $root.request.FinalizeProfileWrite)
                return object;
            let message = new $root.request.FinalizeProfileWrite();
            if (object.uuid != null)
                if (typeof object.uuid === "string")
                    $util.base64.decode(object.uuid, message.uuid = $util.newBuffer($util.base64.length(object.uuid)), 0);
                else if (object.uuid.length >= 0)
                    message.uuid = object.uuid;
            if (object.versionUuid != null)
                if (typeof object.versionUuid === "string")
                    $util.base64.decode(object.versionUuid, message.versionUuid = $util.newBuffer($util.base64.length(object.versionUuid)), 0);
                else if (object.versionUuid.length >= 0)
                    message.versionUuid = object.versionUuid;
            return message;
        };

        /**
         * Creates a plain object from a FinalizeProfileWrite message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.FinalizeProfileWrite
         * @static
         * @param {request.FinalizeProfileWrite} message FinalizeProfileWrite
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FinalizeProfileWrite.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if (options.bytes === String)
                    object.uuid = "";
                else {
                    object.uuid = [];
                    if (options.bytes !== Array)
                        object.uuid = $util.newBuffer(object.uuid);
                }
                if (options.bytes === String)
                    object.versionUuid = "";
                else {
                    object.versionUuid = [];
                    if (options.bytes !== Array)
                        object.versionUuid = $util.newBuffer(object.versionUuid);
                }
            }
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                object.uuid = options.bytes === String ? $util.base64.encode(message.uuid, 0, message.uuid.length) : options.bytes === Array ? Array.prototype.slice.call(message.uuid) : message.uuid;
            if (message.versionUuid != null && message.hasOwnProperty("versionUuid"))
                object.versionUuid = options.bytes === String ? $util.base64.encode(message.versionUuid, 0, message.versionUuid.length) : options.bytes === Array ? Array.prototype.slice.call(message.versionUuid) : message.versionUuid;
            return object;
        };

        /**
         * Converts this FinalizeProfileWrite to JSON.
         * @function toJSON
         * @memberof request.FinalizeProfileWrite
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FinalizeProfileWrite.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for FinalizeProfileWrite
         * @function getTypeUrl
         * @memberof request.FinalizeProfileWrite
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        FinalizeProfileWrite.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.FinalizeProfileWrite";
        };

        return FinalizeProfileWrite;
    })();

    /**
     * Action enum.
     * @name request.Action
     * @enum {number}
     * @property {number} ALLOW=0 ALLOW value
     * @property {number} DENY=1 DENY value
     */
    request.Action = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "ALLOW"] = 0;
        values[valuesById[1] = "DENY"] = 1;
        return values;
    })();

    /**
     * SubjectType enum.
     * @name request.SubjectType
     * @enum {number}
     * @property {number} USER=0 USER value
     * @property {number} TEAM=1 TEAM value
     */
    request.SubjectType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "USER"] = 0;
        values[valuesById[1] = "TEAM"] = 1;
        return values;
    })();

    request.GetUserType = (function() {

        /**
         * Properties of a GetUserType.
         * @memberof request
         * @interface IGetUserType
         * @property {string|null} [email] GetUserType email
         */

        /**
         * Constructs a new GetUserType.
         * @memberof request
         * @classdesc Represents a GetUserType.
         * @implements IGetUserType
         * @constructor
         * @param {request.IGetUserType=} [properties] Properties to set
         */
        function GetUserType(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetUserType email.
         * @member {string} email
         * @memberof request.GetUserType
         * @instance
         */
        GetUserType.prototype.email = "";

        /**
         * Creates a new GetUserType instance using the specified properties.
         * @function create
         * @memberof request.GetUserType
         * @static
         * @param {request.IGetUserType=} [properties] Properties to set
         * @returns {request.GetUserType} GetUserType instance
         */
        GetUserType.create = function create(properties) {
            return new GetUserType(properties);
        };

        /**
         * Encodes the specified GetUserType message. Does not implicitly {@link request.GetUserType.verify|verify} messages.
         * @function encode
         * @memberof request.GetUserType
         * @static
         * @param {request.IGetUserType} message GetUserType message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetUserType.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
            return writer;
        };

        /**
         * Encodes the specified GetUserType message, length delimited. Does not implicitly {@link request.GetUserType.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.GetUserType
         * @static
         * @param {request.IGetUserType} message GetUserType message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetUserType.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetUserType message from the specified reader or buffer.
         * @function decode
         * @memberof request.GetUserType
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.GetUserType} GetUserType
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetUserType.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.GetUserType();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.email = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetUserType message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.GetUserType
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.GetUserType} GetUserType
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetUserType.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetUserType message.
         * @function verify
         * @memberof request.GetUserType
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetUserType.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            return null;
        };

        /**
         * Creates a GetUserType message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.GetUserType
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.GetUserType} GetUserType
         */
        GetUserType.fromObject = function fromObject(object) {
            if (object instanceof $root.request.GetUserType)
                return object;
            let message = new $root.request.GetUserType();
            if (object.email != null)
                message.email = String(object.email);
            return message;
        };

        /**
         * Creates a plain object from a GetUserType message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.GetUserType
         * @static
         * @param {request.GetUserType} message GetUserType
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetUserType.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.email = "";
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            return object;
        };

        /**
         * Converts this GetUserType to JSON.
         * @function toJSON
         * @memberof request.GetUserType
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetUserType.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetUserType
         * @function getTypeUrl
         * @memberof request.GetUserType
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetUserType.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.GetUserType";
        };

        return GetUserType;
    })();

    request.ActionEntry = (function() {

        /**
         * Properties of an ActionEntry.
         * @memberof request
         * @interface IActionEntry
         * @property {request.Action|null} [action] ActionEntry action
         * @property {string|null} [subject] ActionEntry subject
         * @property {request.SubjectType|null} [subjectType] ActionEntry subjectType
         * @property {Array.<number>|null} [opIds] ActionEntry opIds
         */

        /**
         * Constructs a new ActionEntry.
         * @memberof request
         * @classdesc Represents an ActionEntry.
         * @implements IActionEntry
         * @constructor
         * @param {request.IActionEntry=} [properties] Properties to set
         */
        function ActionEntry(properties) {
            this.opIds = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ActionEntry action.
         * @member {request.Action} action
         * @memberof request.ActionEntry
         * @instance
         */
        ActionEntry.prototype.action = 0;

        /**
         * ActionEntry subject.
         * @member {string} subject
         * @memberof request.ActionEntry
         * @instance
         */
        ActionEntry.prototype.subject = "";

        /**
         * ActionEntry subjectType.
         * @member {request.SubjectType} subjectType
         * @memberof request.ActionEntry
         * @instance
         */
        ActionEntry.prototype.subjectType = 0;

        /**
         * ActionEntry opIds.
         * @member {Array.<number>} opIds
         * @memberof request.ActionEntry
         * @instance
         */
        ActionEntry.prototype.opIds = $util.emptyArray;

        /**
         * Creates a new ActionEntry instance using the specified properties.
         * @function create
         * @memberof request.ActionEntry
         * @static
         * @param {request.IActionEntry=} [properties] Properties to set
         * @returns {request.ActionEntry} ActionEntry instance
         */
        ActionEntry.create = function create(properties) {
            return new ActionEntry(properties);
        };

        /**
         * Encodes the specified ActionEntry message. Does not implicitly {@link request.ActionEntry.verify|verify} messages.
         * @function encode
         * @memberof request.ActionEntry
         * @static
         * @param {request.IActionEntry} message ActionEntry message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ActionEntry.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.action != null && Object.hasOwnProperty.call(message, "action"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.action);
            if (message.subject != null && Object.hasOwnProperty.call(message, "subject"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.subject);
            if (message.subjectType != null && Object.hasOwnProperty.call(message, "subjectType"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.subjectType);
            if (message.opIds != null && message.opIds.length) {
                writer.uint32(/* id 4, wireType 2 =*/34).fork();
                for (let i = 0; i < message.opIds.length; ++i)
                    writer.int32(message.opIds[i]);
                writer.ldelim();
            }
            return writer;
        };

        /**
         * Encodes the specified ActionEntry message, length delimited. Does not implicitly {@link request.ActionEntry.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.ActionEntry
         * @static
         * @param {request.IActionEntry} message ActionEntry message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ActionEntry.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ActionEntry message from the specified reader or buffer.
         * @function decode
         * @memberof request.ActionEntry
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.ActionEntry} ActionEntry
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ActionEntry.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.ActionEntry();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.action = reader.int32();
                        break;
                    }
                case 2: {
                        message.subject = reader.string();
                        break;
                    }
                case 3: {
                        message.subjectType = reader.int32();
                        break;
                    }
                case 4: {
                        if (!(message.opIds && message.opIds.length))
                            message.opIds = [];
                        if ((tag & 7) === 2) {
                            let end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.opIds.push(reader.int32());
                        } else
                            message.opIds.push(reader.int32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an ActionEntry message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.ActionEntry
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.ActionEntry} ActionEntry
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ActionEntry.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ActionEntry message.
         * @function verify
         * @memberof request.ActionEntry
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ActionEntry.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.action != null && message.hasOwnProperty("action"))
                switch (message.action) {
                default:
                    return "action: enum value expected";
                case 0:
                case 1:
                    break;
                }
            if (message.subject != null && message.hasOwnProperty("subject"))
                if (!$util.isString(message.subject))
                    return "subject: string expected";
            if (message.subjectType != null && message.hasOwnProperty("subjectType"))
                switch (message.subjectType) {
                default:
                    return "subjectType: enum value expected";
                case 0:
                case 1:
                    break;
                }
            if (message.opIds != null && message.hasOwnProperty("opIds")) {
                if (!Array.isArray(message.opIds))
                    return "opIds: array expected";
                for (let i = 0; i < message.opIds.length; ++i)
                    if (!$util.isInteger(message.opIds[i]))
                        return "opIds: integer[] expected";
            }
            return null;
        };

        /**
         * Creates an ActionEntry message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.ActionEntry
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.ActionEntry} ActionEntry
         */
        ActionEntry.fromObject = function fromObject(object) {
            if (object instanceof $root.request.ActionEntry)
                return object;
            let message = new $root.request.ActionEntry();
            switch (object.action) {
            default:
                if (typeof object.action === "number") {
                    message.action = object.action;
                    break;
                }
                break;
            case "ALLOW":
            case 0:
                message.action = 0;
                break;
            case "DENY":
            case 1:
                message.action = 1;
                break;
            }
            if (object.subject != null)
                message.subject = String(object.subject);
            switch (object.subjectType) {
            default:
                if (typeof object.subjectType === "number") {
                    message.subjectType = object.subjectType;
                    break;
                }
                break;
            case "USER":
            case 0:
                message.subjectType = 0;
                break;
            case "TEAM":
            case 1:
                message.subjectType = 1;
                break;
            }
            if (object.opIds) {
                if (!Array.isArray(object.opIds))
                    throw TypeError(".request.ActionEntry.opIds: array expected");
                message.opIds = [];
                for (let i = 0; i < object.opIds.length; ++i)
                    message.opIds[i] = object.opIds[i] | 0;
            }
            return message;
        };

        /**
         * Creates a plain object from an ActionEntry message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.ActionEntry
         * @static
         * @param {request.ActionEntry} message ActionEntry
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ActionEntry.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.opIds = [];
            if (options.defaults) {
                object.action = options.enums === String ? "ALLOW" : 0;
                object.subject = "";
                object.subjectType = options.enums === String ? "USER" : 0;
            }
            if (message.action != null && message.hasOwnProperty("action"))
                object.action = options.enums === String ? $root.request.Action[message.action] === undefined ? message.action : $root.request.Action[message.action] : message.action;
            if (message.subject != null && message.hasOwnProperty("subject"))
                object.subject = message.subject;
            if (message.subjectType != null && message.hasOwnProperty("subjectType"))
                object.subjectType = options.enums === String ? $root.request.SubjectType[message.subjectType] === undefined ? message.subjectType : $root.request.SubjectType[message.subjectType] : message.subjectType;
            if (message.opIds && message.opIds.length) {
                object.opIds = [];
                for (let j = 0; j < message.opIds.length; ++j)
                    object.opIds[j] = message.opIds[j];
            }
            return object;
        };

        /**
         * Converts this ActionEntry to JSON.
         * @function toJSON
         * @memberof request.ActionEntry
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ActionEntry.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ActionEntry
         * @function getTypeUrl
         * @memberof request.ActionEntry
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ActionEntry.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.ActionEntry";
        };

        return ActionEntry;
    })();

    request.ACL = (function() {

        /**
         * Properties of a ACL.
         * @memberof request
         * @interface IACL
         * @property {string|null} [objectPath] ACL objectPath
         * @property {string|null} [ownerEmail] ACL ownerEmail
         * @property {Array.<request.IActionEntry>|null} [actions] ACL actions
         * @property {request.TypeOfPath|null} [typeOfPath] ACL typeOfPath
         */

        /**
         * Constructs a new ACL.
         * @memberof request
         * @classdesc Represents a ACL.
         * @implements IACL
         * @constructor
         * @param {request.IACL=} [properties] Properties to set
         */
        function ACL(properties) {
            this.actions = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ACL objectPath.
         * @member {string} objectPath
         * @memberof request.ACL
         * @instance
         */
        ACL.prototype.objectPath = "";

        /**
         * ACL ownerEmail.
         * @member {string} ownerEmail
         * @memberof request.ACL
         * @instance
         */
        ACL.prototype.ownerEmail = "";

        /**
         * ACL actions.
         * @member {Array.<request.IActionEntry>} actions
         * @memberof request.ACL
         * @instance
         */
        ACL.prototype.actions = $util.emptyArray;

        /**
         * ACL typeOfPath.
         * @member {request.TypeOfPath} typeOfPath
         * @memberof request.ACL
         * @instance
         */
        ACL.prototype.typeOfPath = 0;

        /**
         * Creates a new ACL instance using the specified properties.
         * @function create
         * @memberof request.ACL
         * @static
         * @param {request.IACL=} [properties] Properties to set
         * @returns {request.ACL} ACL instance
         */
        ACL.create = function create(properties) {
            return new ACL(properties);
        };

        /**
         * Encodes the specified ACL message. Does not implicitly {@link request.ACL.verify|verify} messages.
         * @function encode
         * @memberof request.ACL
         * @static
         * @param {request.IACL} message ACL message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ACL.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.objectPath != null && Object.hasOwnProperty.call(message, "objectPath"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.objectPath);
            if (message.ownerEmail != null && Object.hasOwnProperty.call(message, "ownerEmail"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.ownerEmail);
            if (message.actions != null && message.actions.length)
                for (let i = 0; i < message.actions.length; ++i)
                    $root.request.ActionEntry.encode(message.actions[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.typeOfPath != null && Object.hasOwnProperty.call(message, "typeOfPath"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.typeOfPath);
            return writer;
        };

        /**
         * Encodes the specified ACL message, length delimited. Does not implicitly {@link request.ACL.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.ACL
         * @static
         * @param {request.IACL} message ACL message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ACL.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ACL message from the specified reader or buffer.
         * @function decode
         * @memberof request.ACL
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.ACL} ACL
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ACL.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.ACL();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.objectPath = reader.string();
                        break;
                    }
                case 2: {
                        message.ownerEmail = reader.string();
                        break;
                    }
                case 3: {
                        if (!(message.actions && message.actions.length))
                            message.actions = [];
                        message.actions.push($root.request.ActionEntry.decode(reader, reader.uint32()));
                        break;
                    }
                case 4: {
                        message.typeOfPath = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ACL message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.ACL
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.ACL} ACL
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ACL.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ACL message.
         * @function verify
         * @memberof request.ACL
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ACL.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.objectPath != null && message.hasOwnProperty("objectPath"))
                if (!$util.isString(message.objectPath))
                    return "objectPath: string expected";
            if (message.ownerEmail != null && message.hasOwnProperty("ownerEmail"))
                if (!$util.isString(message.ownerEmail))
                    return "ownerEmail: string expected";
            if (message.actions != null && message.hasOwnProperty("actions")) {
                if (!Array.isArray(message.actions))
                    return "actions: array expected";
                for (let i = 0; i < message.actions.length; ++i) {
                    let error = $root.request.ActionEntry.verify(message.actions[i]);
                    if (error)
                        return "actions." + error;
                }
            }
            if (message.typeOfPath != null && message.hasOwnProperty("typeOfPath"))
                switch (message.typeOfPath) {
                default:
                    return "typeOfPath: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                    break;
                }
            return null;
        };

        /**
         * Creates a ACL message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.ACL
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.ACL} ACL
         */
        ACL.fromObject = function fromObject(object) {
            if (object instanceof $root.request.ACL)
                return object;
            let message = new $root.request.ACL();
            if (object.objectPath != null)
                message.objectPath = String(object.objectPath);
            if (object.ownerEmail != null)
                message.ownerEmail = String(object.ownerEmail);
            if (object.actions) {
                if (!Array.isArray(object.actions))
                    throw TypeError(".request.ACL.actions: array expected");
                message.actions = [];
                for (let i = 0; i < object.actions.length; ++i) {
                    if (typeof object.actions[i] !== "object")
                        throw TypeError(".request.ACL.actions: object expected");
                    message.actions[i] = $root.request.ActionEntry.fromObject(object.actions[i]);
                }
            }
            switch (object.typeOfPath) {
            default:
                if (typeof object.typeOfPath === "number") {
                    message.typeOfPath = object.typeOfPath;
                    break;
                }
                break;
            case "TShareUser":
            case 0:
                message.typeOfPath = 0;
                break;
            case "TFolder":
            case 1:
                message.typeOfPath = 1;
                break;
            case "TShareTeam":
            case 2:
                message.typeOfPath = 2;
                break;
            case "TShareExternal":
            case 3:
                message.typeOfPath = 3;
                break;
            case "TFlow":
            case 4:
                message.typeOfPath = 4;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a ACL message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.ACL
         * @static
         * @param {request.ACL} message ACL
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ACL.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.actions = [];
            if (options.defaults) {
                object.objectPath = "";
                object.ownerEmail = "";
                object.typeOfPath = options.enums === String ? "TShareUser" : 0;
            }
            if (message.objectPath != null && message.hasOwnProperty("objectPath"))
                object.objectPath = message.objectPath;
            if (message.ownerEmail != null && message.hasOwnProperty("ownerEmail"))
                object.ownerEmail = message.ownerEmail;
            if (message.actions && message.actions.length) {
                object.actions = [];
                for (let j = 0; j < message.actions.length; ++j)
                    object.actions[j] = $root.request.ActionEntry.toObject(message.actions[j], options);
            }
            if (message.typeOfPath != null && message.hasOwnProperty("typeOfPath"))
                object.typeOfPath = options.enums === String ? $root.request.TypeOfPath[message.typeOfPath] === undefined ? message.typeOfPath : $root.request.TypeOfPath[message.typeOfPath] : message.typeOfPath;
            return object;
        };

        /**
         * Converts this ACL to JSON.
         * @function toJSON
         * @memberof request.ACL
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ACL.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ACL
         * @function getTypeUrl
         * @memberof request.ACL
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ACL.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.ACL";
        };

        return ACL;
    })();

    request.Share = (function() {

        /**
         * Properties of a Share.
         * @memberof request
         * @interface IShare
         * @property {request.IACL|null} [acl] Share acl
         */

        /**
         * Constructs a new Share.
         * @memberof request
         * @classdesc Represents a Share.
         * @implements IShare
         * @constructor
         * @param {request.IShare=} [properties] Properties to set
         */
        function Share(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Share acl.
         * @member {request.IACL|null|undefined} acl
         * @memberof request.Share
         * @instance
         */
        Share.prototype.acl = null;

        /**
         * Creates a new Share instance using the specified properties.
         * @function create
         * @memberof request.Share
         * @static
         * @param {request.IShare=} [properties] Properties to set
         * @returns {request.Share} Share instance
         */
        Share.create = function create(properties) {
            return new Share(properties);
        };

        /**
         * Encodes the specified Share message. Does not implicitly {@link request.Share.verify|verify} messages.
         * @function encode
         * @memberof request.Share
         * @static
         * @param {request.IShare} message Share message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Share.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.acl != null && Object.hasOwnProperty.call(message, "acl"))
                $root.request.ACL.encode(message.acl, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified Share message, length delimited. Does not implicitly {@link request.Share.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.Share
         * @static
         * @param {request.IShare} message Share message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Share.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Share message from the specified reader or buffer.
         * @function decode
         * @memberof request.Share
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.Share} Share
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Share.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.Share();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.acl = $root.request.ACL.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Share message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.Share
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.Share} Share
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Share.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Share message.
         * @function verify
         * @memberof request.Share
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Share.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.acl != null && message.hasOwnProperty("acl")) {
                let error = $root.request.ACL.verify(message.acl);
                if (error)
                    return "acl." + error;
            }
            return null;
        };

        /**
         * Creates a Share message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.Share
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.Share} Share
         */
        Share.fromObject = function fromObject(object) {
            if (object instanceof $root.request.Share)
                return object;
            let message = new $root.request.Share();
            if (object.acl != null) {
                if (typeof object.acl !== "object")
                    throw TypeError(".request.Share.acl: object expected");
                message.acl = $root.request.ACL.fromObject(object.acl);
            }
            return message;
        };

        /**
         * Creates a plain object from a Share message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.Share
         * @static
         * @param {request.Share} message Share
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Share.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.acl = null;
            if (message.acl != null && message.hasOwnProperty("acl"))
                object.acl = $root.request.ACL.toObject(message.acl, options);
            return object;
        };

        /**
         * Converts this Share to JSON.
         * @function toJSON
         * @memberof request.Share
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Share.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Share
         * @function getTypeUrl
         * @memberof request.Share
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Share.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.Share";
        };

        return Share;
    })();

    request.Unshare = (function() {

        /**
         * Properties of an Unshare.
         * @memberof request
         * @interface IUnshare
         * @property {string|null} [objectPath] Unshare objectPath
         */

        /**
         * Constructs a new Unshare.
         * @memberof request
         * @classdesc Represents an Unshare.
         * @implements IUnshare
         * @constructor
         * @param {request.IUnshare=} [properties] Properties to set
         */
        function Unshare(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Unshare objectPath.
         * @member {string} objectPath
         * @memberof request.Unshare
         * @instance
         */
        Unshare.prototype.objectPath = "";

        /**
         * Creates a new Unshare instance using the specified properties.
         * @function create
         * @memberof request.Unshare
         * @static
         * @param {request.IUnshare=} [properties] Properties to set
         * @returns {request.Unshare} Unshare instance
         */
        Unshare.create = function create(properties) {
            return new Unshare(properties);
        };

        /**
         * Encodes the specified Unshare message. Does not implicitly {@link request.Unshare.verify|verify} messages.
         * @function encode
         * @memberof request.Unshare
         * @static
         * @param {request.IUnshare} message Unshare message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Unshare.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.objectPath != null && Object.hasOwnProperty.call(message, "objectPath"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.objectPath);
            return writer;
        };

        /**
         * Encodes the specified Unshare message, length delimited. Does not implicitly {@link request.Unshare.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.Unshare
         * @static
         * @param {request.IUnshare} message Unshare message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Unshare.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an Unshare message from the specified reader or buffer.
         * @function decode
         * @memberof request.Unshare
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.Unshare} Unshare
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Unshare.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.Unshare();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.objectPath = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an Unshare message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.Unshare
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.Unshare} Unshare
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Unshare.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an Unshare message.
         * @function verify
         * @memberof request.Unshare
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Unshare.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.objectPath != null && message.hasOwnProperty("objectPath"))
                if (!$util.isString(message.objectPath))
                    return "objectPath: string expected";
            return null;
        };

        /**
         * Creates an Unshare message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.Unshare
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.Unshare} Unshare
         */
        Unshare.fromObject = function fromObject(object) {
            if (object instanceof $root.request.Unshare)
                return object;
            let message = new $root.request.Unshare();
            if (object.objectPath != null)
                message.objectPath = String(object.objectPath);
            return message;
        };

        /**
         * Creates a plain object from an Unshare message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.Unshare
         * @static
         * @param {request.Unshare} message Unshare
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Unshare.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.objectPath = "";
            if (message.objectPath != null && message.hasOwnProperty("objectPath"))
                object.objectPath = message.objectPath;
            return object;
        };

        /**
         * Converts this Unshare to JSON.
         * @function toJSON
         * @memberof request.Unshare
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Unshare.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Unshare
         * @function getTypeUrl
         * @memberof request.Unshare
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Unshare.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.Unshare";
        };

        return Unshare;
    })();

    request.UpdateShare = (function() {

        /**
         * Properties of an UpdateShare.
         * @memberof request
         * @interface IUpdateShare
         * @property {request.IACL|null} [acl] UpdateShare acl
         */

        /**
         * Constructs a new UpdateShare.
         * @memberof request
         * @classdesc Represents an UpdateShare.
         * @implements IUpdateShare
         * @constructor
         * @param {request.IUpdateShare=} [properties] Properties to set
         */
        function UpdateShare(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateShare acl.
         * @member {request.IACL|null|undefined} acl
         * @memberof request.UpdateShare
         * @instance
         */
        UpdateShare.prototype.acl = null;

        /**
         * Creates a new UpdateShare instance using the specified properties.
         * @function create
         * @memberof request.UpdateShare
         * @static
         * @param {request.IUpdateShare=} [properties] Properties to set
         * @returns {request.UpdateShare} UpdateShare instance
         */
        UpdateShare.create = function create(properties) {
            return new UpdateShare(properties);
        };

        /**
         * Encodes the specified UpdateShare message. Does not implicitly {@link request.UpdateShare.verify|verify} messages.
         * @function encode
         * @memberof request.UpdateShare
         * @static
         * @param {request.IUpdateShare} message UpdateShare message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateShare.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.acl != null && Object.hasOwnProperty.call(message, "acl"))
                $root.request.ACL.encode(message.acl, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified UpdateShare message, length delimited. Does not implicitly {@link request.UpdateShare.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.UpdateShare
         * @static
         * @param {request.IUpdateShare} message UpdateShare message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateShare.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UpdateShare message from the specified reader or buffer.
         * @function decode
         * @memberof request.UpdateShare
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.UpdateShare} UpdateShare
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateShare.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.UpdateShare();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.acl = $root.request.ACL.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UpdateShare message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.UpdateShare
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.UpdateShare} UpdateShare
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateShare.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UpdateShare message.
         * @function verify
         * @memberof request.UpdateShare
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UpdateShare.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.acl != null && message.hasOwnProperty("acl")) {
                let error = $root.request.ACL.verify(message.acl);
                if (error)
                    return "acl." + error;
            }
            return null;
        };

        /**
         * Creates an UpdateShare message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.UpdateShare
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.UpdateShare} UpdateShare
         */
        UpdateShare.fromObject = function fromObject(object) {
            if (object instanceof $root.request.UpdateShare)
                return object;
            let message = new $root.request.UpdateShare();
            if (object.acl != null) {
                if (typeof object.acl !== "object")
                    throw TypeError(".request.UpdateShare.acl: object expected");
                message.acl = $root.request.ACL.fromObject(object.acl);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateShare message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.UpdateShare
         * @static
         * @param {request.UpdateShare} message UpdateShare
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateShare.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.acl = null;
            if (message.acl != null && message.hasOwnProperty("acl"))
                object.acl = $root.request.ACL.toObject(message.acl, options);
            return object;
        };

        /**
         * Converts this UpdateShare to JSON.
         * @function toJSON
         * @memberof request.UpdateShare
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateShare.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for UpdateShare
         * @function getTypeUrl
         * @memberof request.UpdateShare
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        UpdateShare.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.UpdateShare";
        };

        return UpdateShare;
    })();

    request.ListShares = (function() {

        /**
         * Properties of a ListShares.
         * @memberof request
         * @interface IListShares
         * @property {string|null} [objectPath] ListShares objectPath
         */

        /**
         * Constructs a new ListShares.
         * @memberof request
         * @classdesc Represents a ListShares.
         * @implements IListShares
         * @constructor
         * @param {request.IListShares=} [properties] Properties to set
         */
        function ListShares(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListShares objectPath.
         * @member {string} objectPath
         * @memberof request.ListShares
         * @instance
         */
        ListShares.prototype.objectPath = "";

        /**
         * Creates a new ListShares instance using the specified properties.
         * @function create
         * @memberof request.ListShares
         * @static
         * @param {request.IListShares=} [properties] Properties to set
         * @returns {request.ListShares} ListShares instance
         */
        ListShares.create = function create(properties) {
            return new ListShares(properties);
        };

        /**
         * Encodes the specified ListShares message. Does not implicitly {@link request.ListShares.verify|verify} messages.
         * @function encode
         * @memberof request.ListShares
         * @static
         * @param {request.IListShares} message ListShares message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListShares.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.objectPath != null && Object.hasOwnProperty.call(message, "objectPath"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.objectPath);
            return writer;
        };

        /**
         * Encodes the specified ListShares message, length delimited. Does not implicitly {@link request.ListShares.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.ListShares
         * @static
         * @param {request.IListShares} message ListShares message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListShares.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ListShares message from the specified reader or buffer.
         * @function decode
         * @memberof request.ListShares
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.ListShares} ListShares
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListShares.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.ListShares();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.objectPath = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ListShares message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.ListShares
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.ListShares} ListShares
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListShares.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ListShares message.
         * @function verify
         * @memberof request.ListShares
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ListShares.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.objectPath != null && message.hasOwnProperty("objectPath"))
                if (!$util.isString(message.objectPath))
                    return "objectPath: string expected";
            return null;
        };

        /**
         * Creates a ListShares message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.ListShares
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.ListShares} ListShares
         */
        ListShares.fromObject = function fromObject(object) {
            if (object instanceof $root.request.ListShares)
                return object;
            let message = new $root.request.ListShares();
            if (object.objectPath != null)
                message.objectPath = String(object.objectPath);
            return message;
        };

        /**
         * Creates a plain object from a ListShares message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.ListShares
         * @static
         * @param {request.ListShares} message ListShares
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListShares.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.objectPath = "";
            if (message.objectPath != null && message.hasOwnProperty("objectPath"))
                object.objectPath = message.objectPath;
            return object;
        };

        /**
         * Converts this ListShares to JSON.
         * @function toJSON
         * @memberof request.ListShares
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListShares.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ListShares
         * @function getTypeUrl
         * @memberof request.ListShares
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ListShares.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.ListShares";
        };

        return ListShares;
    })();

    request.GetRolesAndTeamsOfUser = (function() {

        /**
         * Properties of a GetRolesAndTeamsOfUser.
         * @memberof request
         * @interface IGetRolesAndTeamsOfUser
         * @property {string|null} [emailOfUser] GetRolesAndTeamsOfUser emailOfUser
         */

        /**
         * Constructs a new GetRolesAndTeamsOfUser.
         * @memberof request
         * @classdesc Represents a GetRolesAndTeamsOfUser.
         * @implements IGetRolesAndTeamsOfUser
         * @constructor
         * @param {request.IGetRolesAndTeamsOfUser=} [properties] Properties to set
         */
        function GetRolesAndTeamsOfUser(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetRolesAndTeamsOfUser emailOfUser.
         * @member {string} emailOfUser
         * @memberof request.GetRolesAndTeamsOfUser
         * @instance
         */
        GetRolesAndTeamsOfUser.prototype.emailOfUser = "";

        /**
         * Creates a new GetRolesAndTeamsOfUser instance using the specified properties.
         * @function create
         * @memberof request.GetRolesAndTeamsOfUser
         * @static
         * @param {request.IGetRolesAndTeamsOfUser=} [properties] Properties to set
         * @returns {request.GetRolesAndTeamsOfUser} GetRolesAndTeamsOfUser instance
         */
        GetRolesAndTeamsOfUser.create = function create(properties) {
            return new GetRolesAndTeamsOfUser(properties);
        };

        /**
         * Encodes the specified GetRolesAndTeamsOfUser message. Does not implicitly {@link request.GetRolesAndTeamsOfUser.verify|verify} messages.
         * @function encode
         * @memberof request.GetRolesAndTeamsOfUser
         * @static
         * @param {request.IGetRolesAndTeamsOfUser} message GetRolesAndTeamsOfUser message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetRolesAndTeamsOfUser.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.emailOfUser != null && Object.hasOwnProperty.call(message, "emailOfUser"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.emailOfUser);
            return writer;
        };

        /**
         * Encodes the specified GetRolesAndTeamsOfUser message, length delimited. Does not implicitly {@link request.GetRolesAndTeamsOfUser.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.GetRolesAndTeamsOfUser
         * @static
         * @param {request.IGetRolesAndTeamsOfUser} message GetRolesAndTeamsOfUser message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetRolesAndTeamsOfUser.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetRolesAndTeamsOfUser message from the specified reader or buffer.
         * @function decode
         * @memberof request.GetRolesAndTeamsOfUser
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.GetRolesAndTeamsOfUser} GetRolesAndTeamsOfUser
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetRolesAndTeamsOfUser.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.GetRolesAndTeamsOfUser();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.emailOfUser = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetRolesAndTeamsOfUser message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.GetRolesAndTeamsOfUser
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.GetRolesAndTeamsOfUser} GetRolesAndTeamsOfUser
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetRolesAndTeamsOfUser.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetRolesAndTeamsOfUser message.
         * @function verify
         * @memberof request.GetRolesAndTeamsOfUser
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetRolesAndTeamsOfUser.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.emailOfUser != null && message.hasOwnProperty("emailOfUser"))
                if (!$util.isString(message.emailOfUser))
                    return "emailOfUser: string expected";
            return null;
        };

        /**
         * Creates a GetRolesAndTeamsOfUser message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.GetRolesAndTeamsOfUser
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.GetRolesAndTeamsOfUser} GetRolesAndTeamsOfUser
         */
        GetRolesAndTeamsOfUser.fromObject = function fromObject(object) {
            if (object instanceof $root.request.GetRolesAndTeamsOfUser)
                return object;
            let message = new $root.request.GetRolesAndTeamsOfUser();
            if (object.emailOfUser != null)
                message.emailOfUser = String(object.emailOfUser);
            return message;
        };

        /**
         * Creates a plain object from a GetRolesAndTeamsOfUser message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.GetRolesAndTeamsOfUser
         * @static
         * @param {request.GetRolesAndTeamsOfUser} message GetRolesAndTeamsOfUser
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetRolesAndTeamsOfUser.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.emailOfUser = "";
            if (message.emailOfUser != null && message.hasOwnProperty("emailOfUser"))
                object.emailOfUser = message.emailOfUser;
            return object;
        };

        /**
         * Converts this GetRolesAndTeamsOfUser to JSON.
         * @function toJSON
         * @memberof request.GetRolesAndTeamsOfUser
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetRolesAndTeamsOfUser.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetRolesAndTeamsOfUser
         * @function getTypeUrl
         * @memberof request.GetRolesAndTeamsOfUser
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetRolesAndTeamsOfUser.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.GetRolesAndTeamsOfUser";
        };

        return GetRolesAndTeamsOfUser;
    })();

    request.ListUsers = (function() {

        /**
         * Properties of a ListUsers.
         * @memberof request
         * @interface IListUsers
         * @property {Uint8Array|null} [pageTokenListUser] ListUsers pageTokenListUser
         * @property {number|null} [pageSize] ListUsers pageSize
         */

        /**
         * Constructs a new ListUsers.
         * @memberof request
         * @classdesc Represents a ListUsers.
         * @implements IListUsers
         * @constructor
         * @param {request.IListUsers=} [properties] Properties to set
         */
        function ListUsers(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListUsers pageTokenListUser.
         * @member {Uint8Array|null|undefined} pageTokenListUser
         * @memberof request.ListUsers
         * @instance
         */
        ListUsers.prototype.pageTokenListUser = null;

        /**
         * ListUsers pageSize.
         * @member {number|null|undefined} pageSize
         * @memberof request.ListUsers
         * @instance
         */
        ListUsers.prototype.pageSize = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(ListUsers.prototype, "_pageTokenListUser", {
            get: $util.oneOfGetter($oneOfFields = ["pageTokenListUser"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(ListUsers.prototype, "_pageSize", {
            get: $util.oneOfGetter($oneOfFields = ["pageSize"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new ListUsers instance using the specified properties.
         * @function create
         * @memberof request.ListUsers
         * @static
         * @param {request.IListUsers=} [properties] Properties to set
         * @returns {request.ListUsers} ListUsers instance
         */
        ListUsers.create = function create(properties) {
            return new ListUsers(properties);
        };

        /**
         * Encodes the specified ListUsers message. Does not implicitly {@link request.ListUsers.verify|verify} messages.
         * @function encode
         * @memberof request.ListUsers
         * @static
         * @param {request.IListUsers} message ListUsers message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListUsers.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pageTokenListUser != null && Object.hasOwnProperty.call(message, "pageTokenListUser"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.pageTokenListUser);
            if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.pageSize);
            return writer;
        };

        /**
         * Encodes the specified ListUsers message, length delimited. Does not implicitly {@link request.ListUsers.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.ListUsers
         * @static
         * @param {request.IListUsers} message ListUsers message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListUsers.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ListUsers message from the specified reader or buffer.
         * @function decode
         * @memberof request.ListUsers
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.ListUsers} ListUsers
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListUsers.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.ListUsers();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.pageTokenListUser = reader.bytes();
                        break;
                    }
                case 2: {
                        message.pageSize = reader.uint32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ListUsers message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.ListUsers
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.ListUsers} ListUsers
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListUsers.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ListUsers message.
         * @function verify
         * @memberof request.ListUsers
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ListUsers.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.pageTokenListUser != null && message.hasOwnProperty("pageTokenListUser")) {
                properties._pageTokenListUser = 1;
                if (!(message.pageTokenListUser && typeof message.pageTokenListUser.length === "number" || $util.isString(message.pageTokenListUser)))
                    return "pageTokenListUser: buffer expected";
            }
            if (message.pageSize != null && message.hasOwnProperty("pageSize")) {
                properties._pageSize = 1;
                if (!$util.isInteger(message.pageSize))
                    return "pageSize: integer expected";
            }
            return null;
        };

        /**
         * Creates a ListUsers message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.ListUsers
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.ListUsers} ListUsers
         */
        ListUsers.fromObject = function fromObject(object) {
            if (object instanceof $root.request.ListUsers)
                return object;
            let message = new $root.request.ListUsers();
            if (object.pageTokenListUser != null)
                if (typeof object.pageTokenListUser === "string")
                    $util.base64.decode(object.pageTokenListUser, message.pageTokenListUser = $util.newBuffer($util.base64.length(object.pageTokenListUser)), 0);
                else if (object.pageTokenListUser.length >= 0)
                    message.pageTokenListUser = object.pageTokenListUser;
            if (object.pageSize != null)
                message.pageSize = object.pageSize >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a ListUsers message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.ListUsers
         * @static
         * @param {request.ListUsers} message ListUsers
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListUsers.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (message.pageTokenListUser != null && message.hasOwnProperty("pageTokenListUser")) {
                object.pageTokenListUser = options.bytes === String ? $util.base64.encode(message.pageTokenListUser, 0, message.pageTokenListUser.length) : options.bytes === Array ? Array.prototype.slice.call(message.pageTokenListUser) : message.pageTokenListUser;
                if (options.oneofs)
                    object._pageTokenListUser = "pageTokenListUser";
            }
            if (message.pageSize != null && message.hasOwnProperty("pageSize")) {
                object.pageSize = message.pageSize;
                if (options.oneofs)
                    object._pageSize = "pageSize";
            }
            return object;
        };

        /**
         * Converts this ListUsers to JSON.
         * @function toJSON
         * @memberof request.ListUsers
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListUsers.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ListUsers
         * @function getTypeUrl
         * @memberof request.ListUsers
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ListUsers.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.ListUsers";
        };

        return ListUsers;
    })();

    request.RestartPutChunk = (function() {

        /**
         * Properties of a RestartPutChunk.
         * @memberof request
         * @interface IRestartPutChunk
         * @property {Uint8Array|null} [versionUuid] RestartPutChunk versionUuid
         * @property {Uint8Array|null} [chunkUuid] RestartPutChunk chunkUuid
         */

        /**
         * Constructs a new RestartPutChunk.
         * @memberof request
         * @classdesc Represents a RestartPutChunk.
         * @implements IRestartPutChunk
         * @constructor
         * @param {request.IRestartPutChunk=} [properties] Properties to set
         */
        function RestartPutChunk(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RestartPutChunk versionUuid.
         * @member {Uint8Array} versionUuid
         * @memberof request.RestartPutChunk
         * @instance
         */
        RestartPutChunk.prototype.versionUuid = $util.newBuffer([]);

        /**
         * RestartPutChunk chunkUuid.
         * @member {Uint8Array} chunkUuid
         * @memberof request.RestartPutChunk
         * @instance
         */
        RestartPutChunk.prototype.chunkUuid = $util.newBuffer([]);

        /**
         * Creates a new RestartPutChunk instance using the specified properties.
         * @function create
         * @memberof request.RestartPutChunk
         * @static
         * @param {request.IRestartPutChunk=} [properties] Properties to set
         * @returns {request.RestartPutChunk} RestartPutChunk instance
         */
        RestartPutChunk.create = function create(properties) {
            return new RestartPutChunk(properties);
        };

        /**
         * Encodes the specified RestartPutChunk message. Does not implicitly {@link request.RestartPutChunk.verify|verify} messages.
         * @function encode
         * @memberof request.RestartPutChunk
         * @static
         * @param {request.IRestartPutChunk} message RestartPutChunk message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RestartPutChunk.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.versionUuid != null && Object.hasOwnProperty.call(message, "versionUuid"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.versionUuid);
            if (message.chunkUuid != null && Object.hasOwnProperty.call(message, "chunkUuid"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.chunkUuid);
            return writer;
        };

        /**
         * Encodes the specified RestartPutChunk message, length delimited. Does not implicitly {@link request.RestartPutChunk.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.RestartPutChunk
         * @static
         * @param {request.IRestartPutChunk} message RestartPutChunk message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RestartPutChunk.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RestartPutChunk message from the specified reader or buffer.
         * @function decode
         * @memberof request.RestartPutChunk
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.RestartPutChunk} RestartPutChunk
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RestartPutChunk.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.RestartPutChunk();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.versionUuid = reader.bytes();
                        break;
                    }
                case 2: {
                        message.chunkUuid = reader.bytes();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RestartPutChunk message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.RestartPutChunk
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.RestartPutChunk} RestartPutChunk
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RestartPutChunk.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RestartPutChunk message.
         * @function verify
         * @memberof request.RestartPutChunk
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RestartPutChunk.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.versionUuid != null && message.hasOwnProperty("versionUuid"))
                if (!(message.versionUuid && typeof message.versionUuid.length === "number" || $util.isString(message.versionUuid)))
                    return "versionUuid: buffer expected";
            if (message.chunkUuid != null && message.hasOwnProperty("chunkUuid"))
                if (!(message.chunkUuid && typeof message.chunkUuid.length === "number" || $util.isString(message.chunkUuid)))
                    return "chunkUuid: buffer expected";
            return null;
        };

        /**
         * Creates a RestartPutChunk message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.RestartPutChunk
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.RestartPutChunk} RestartPutChunk
         */
        RestartPutChunk.fromObject = function fromObject(object) {
            if (object instanceof $root.request.RestartPutChunk)
                return object;
            let message = new $root.request.RestartPutChunk();
            if (object.versionUuid != null)
                if (typeof object.versionUuid === "string")
                    $util.base64.decode(object.versionUuid, message.versionUuid = $util.newBuffer($util.base64.length(object.versionUuid)), 0);
                else if (object.versionUuid.length >= 0)
                    message.versionUuid = object.versionUuid;
            if (object.chunkUuid != null)
                if (typeof object.chunkUuid === "string")
                    $util.base64.decode(object.chunkUuid, message.chunkUuid = $util.newBuffer($util.base64.length(object.chunkUuid)), 0);
                else if (object.chunkUuid.length >= 0)
                    message.chunkUuid = object.chunkUuid;
            return message;
        };

        /**
         * Creates a plain object from a RestartPutChunk message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.RestartPutChunk
         * @static
         * @param {request.RestartPutChunk} message RestartPutChunk
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RestartPutChunk.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if (options.bytes === String)
                    object.versionUuid = "";
                else {
                    object.versionUuid = [];
                    if (options.bytes !== Array)
                        object.versionUuid = $util.newBuffer(object.versionUuid);
                }
                if (options.bytes === String)
                    object.chunkUuid = "";
                else {
                    object.chunkUuid = [];
                    if (options.bytes !== Array)
                        object.chunkUuid = $util.newBuffer(object.chunkUuid);
                }
            }
            if (message.versionUuid != null && message.hasOwnProperty("versionUuid"))
                object.versionUuid = options.bytes === String ? $util.base64.encode(message.versionUuid, 0, message.versionUuid.length) : options.bytes === Array ? Array.prototype.slice.call(message.versionUuid) : message.versionUuid;
            if (message.chunkUuid != null && message.hasOwnProperty("chunkUuid"))
                object.chunkUuid = options.bytes === String ? $util.base64.encode(message.chunkUuid, 0, message.chunkUuid.length) : options.bytes === Array ? Array.prototype.slice.call(message.chunkUuid) : message.chunkUuid;
            return object;
        };

        /**
         * Converts this RestartPutChunk to JSON.
         * @function toJSON
         * @memberof request.RestartPutChunk
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RestartPutChunk.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for RestartPutChunk
         * @function getTypeUrl
         * @memberof request.RestartPutChunk
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        RestartPutChunk.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.RestartPutChunk";
        };

        return RestartPutChunk;
    })();

    request.GetMetaFromSharedPath = (function() {

        /**
         * Properties of a GetMetaFromSharedPath.
         * @memberof request
         * @interface IGetMetaFromSharedPath
         * @property {string|null} [path] GetMetaFromSharedPath path
         * @property {request.TypeOfPath|null} [typeOfPath] GetMetaFromSharedPath typeOfPath
         */

        /**
         * Constructs a new GetMetaFromSharedPath.
         * @memberof request
         * @classdesc Represents a GetMetaFromSharedPath.
         * @implements IGetMetaFromSharedPath
         * @constructor
         * @param {request.IGetMetaFromSharedPath=} [properties] Properties to set
         */
        function GetMetaFromSharedPath(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetMetaFromSharedPath path.
         * @member {string} path
         * @memberof request.GetMetaFromSharedPath
         * @instance
         */
        GetMetaFromSharedPath.prototype.path = "";

        /**
         * GetMetaFromSharedPath typeOfPath.
         * @member {request.TypeOfPath} typeOfPath
         * @memberof request.GetMetaFromSharedPath
         * @instance
         */
        GetMetaFromSharedPath.prototype.typeOfPath = 0;

        /**
         * Creates a new GetMetaFromSharedPath instance using the specified properties.
         * @function create
         * @memberof request.GetMetaFromSharedPath
         * @static
         * @param {request.IGetMetaFromSharedPath=} [properties] Properties to set
         * @returns {request.GetMetaFromSharedPath} GetMetaFromSharedPath instance
         */
        GetMetaFromSharedPath.create = function create(properties) {
            return new GetMetaFromSharedPath(properties);
        };

        /**
         * Encodes the specified GetMetaFromSharedPath message. Does not implicitly {@link request.GetMetaFromSharedPath.verify|verify} messages.
         * @function encode
         * @memberof request.GetMetaFromSharedPath
         * @static
         * @param {request.IGetMetaFromSharedPath} message GetMetaFromSharedPath message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetMetaFromSharedPath.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.path != null && Object.hasOwnProperty.call(message, "path"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.path);
            if (message.typeOfPath != null && Object.hasOwnProperty.call(message, "typeOfPath"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.typeOfPath);
            return writer;
        };

        /**
         * Encodes the specified GetMetaFromSharedPath message, length delimited. Does not implicitly {@link request.GetMetaFromSharedPath.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.GetMetaFromSharedPath
         * @static
         * @param {request.IGetMetaFromSharedPath} message GetMetaFromSharedPath message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetMetaFromSharedPath.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetMetaFromSharedPath message from the specified reader or buffer.
         * @function decode
         * @memberof request.GetMetaFromSharedPath
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.GetMetaFromSharedPath} GetMetaFromSharedPath
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetMetaFromSharedPath.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.GetMetaFromSharedPath();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.path = reader.string();
                        break;
                    }
                case 2: {
                        message.typeOfPath = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetMetaFromSharedPath message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.GetMetaFromSharedPath
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.GetMetaFromSharedPath} GetMetaFromSharedPath
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetMetaFromSharedPath.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetMetaFromSharedPath message.
         * @function verify
         * @memberof request.GetMetaFromSharedPath
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetMetaFromSharedPath.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.path != null && message.hasOwnProperty("path"))
                if (!$util.isString(message.path))
                    return "path: string expected";
            if (message.typeOfPath != null && message.hasOwnProperty("typeOfPath"))
                switch (message.typeOfPath) {
                default:
                    return "typeOfPath: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                    break;
                }
            return null;
        };

        /**
         * Creates a GetMetaFromSharedPath message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.GetMetaFromSharedPath
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.GetMetaFromSharedPath} GetMetaFromSharedPath
         */
        GetMetaFromSharedPath.fromObject = function fromObject(object) {
            if (object instanceof $root.request.GetMetaFromSharedPath)
                return object;
            let message = new $root.request.GetMetaFromSharedPath();
            if (object.path != null)
                message.path = String(object.path);
            switch (object.typeOfPath) {
            default:
                if (typeof object.typeOfPath === "number") {
                    message.typeOfPath = object.typeOfPath;
                    break;
                }
                break;
            case "TShareUser":
            case 0:
                message.typeOfPath = 0;
                break;
            case "TFolder":
            case 1:
                message.typeOfPath = 1;
                break;
            case "TShareTeam":
            case 2:
                message.typeOfPath = 2;
                break;
            case "TShareExternal":
            case 3:
                message.typeOfPath = 3;
                break;
            case "TFlow":
            case 4:
                message.typeOfPath = 4;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a GetMetaFromSharedPath message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.GetMetaFromSharedPath
         * @static
         * @param {request.GetMetaFromSharedPath} message GetMetaFromSharedPath
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetMetaFromSharedPath.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.path = "";
                object.typeOfPath = options.enums === String ? "TShareUser" : 0;
            }
            if (message.path != null && message.hasOwnProperty("path"))
                object.path = message.path;
            if (message.typeOfPath != null && message.hasOwnProperty("typeOfPath"))
                object.typeOfPath = options.enums === String ? $root.request.TypeOfPath[message.typeOfPath] === undefined ? message.typeOfPath : $root.request.TypeOfPath[message.typeOfPath] : message.typeOfPath;
            return object;
        };

        /**
         * Converts this GetMetaFromSharedPath to JSON.
         * @function toJSON
         * @memberof request.GetMetaFromSharedPath
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetMetaFromSharedPath.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetMetaFromSharedPath
         * @function getTypeUrl
         * @memberof request.GetMetaFromSharedPath
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetMetaFromSharedPath.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.GetMetaFromSharedPath";
        };

        return GetMetaFromSharedPath;
    })();

    request.QueAndAns = (function() {

        /**
         * Properties of a QueAndAns.
         * @memberof request
         * @interface IQueAndAns
         * @property {string|null} [question] QueAndAns question
         * @property {string|null} [answer] QueAndAns answer
         */

        /**
         * Constructs a new QueAndAns.
         * @memberof request
         * @classdesc Represents a QueAndAns.
         * @implements IQueAndAns
         * @constructor
         * @param {request.IQueAndAns=} [properties] Properties to set
         */
        function QueAndAns(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * QueAndAns question.
         * @member {string} question
         * @memberof request.QueAndAns
         * @instance
         */
        QueAndAns.prototype.question = "";

        /**
         * QueAndAns answer.
         * @member {string} answer
         * @memberof request.QueAndAns
         * @instance
         */
        QueAndAns.prototype.answer = "";

        /**
         * Creates a new QueAndAns instance using the specified properties.
         * @function create
         * @memberof request.QueAndAns
         * @static
         * @param {request.IQueAndAns=} [properties] Properties to set
         * @returns {request.QueAndAns} QueAndAns instance
         */
        QueAndAns.create = function create(properties) {
            return new QueAndAns(properties);
        };

        /**
         * Encodes the specified QueAndAns message. Does not implicitly {@link request.QueAndAns.verify|verify} messages.
         * @function encode
         * @memberof request.QueAndAns
         * @static
         * @param {request.IQueAndAns} message QueAndAns message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        QueAndAns.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.question != null && Object.hasOwnProperty.call(message, "question"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.question);
            if (message.answer != null && Object.hasOwnProperty.call(message, "answer"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.answer);
            return writer;
        };

        /**
         * Encodes the specified QueAndAns message, length delimited. Does not implicitly {@link request.QueAndAns.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.QueAndAns
         * @static
         * @param {request.IQueAndAns} message QueAndAns message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        QueAndAns.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a QueAndAns message from the specified reader or buffer.
         * @function decode
         * @memberof request.QueAndAns
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.QueAndAns} QueAndAns
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        QueAndAns.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.QueAndAns();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.question = reader.string();
                        break;
                    }
                case 2: {
                        message.answer = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a QueAndAns message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.QueAndAns
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.QueAndAns} QueAndAns
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        QueAndAns.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a QueAndAns message.
         * @function verify
         * @memberof request.QueAndAns
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        QueAndAns.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.question != null && message.hasOwnProperty("question"))
                if (!$util.isString(message.question))
                    return "question: string expected";
            if (message.answer != null && message.hasOwnProperty("answer"))
                if (!$util.isString(message.answer))
                    return "answer: string expected";
            return null;
        };

        /**
         * Creates a QueAndAns message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.QueAndAns
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.QueAndAns} QueAndAns
         */
        QueAndAns.fromObject = function fromObject(object) {
            if (object instanceof $root.request.QueAndAns)
                return object;
            let message = new $root.request.QueAndAns();
            if (object.question != null)
                message.question = String(object.question);
            if (object.answer != null)
                message.answer = String(object.answer);
            return message;
        };

        /**
         * Creates a plain object from a QueAndAns message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.QueAndAns
         * @static
         * @param {request.QueAndAns} message QueAndAns
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        QueAndAns.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.question = "";
                object.answer = "";
            }
            if (message.question != null && message.hasOwnProperty("question"))
                object.question = message.question;
            if (message.answer != null && message.hasOwnProperty("answer"))
                object.answer = message.answer;
            return object;
        };

        /**
         * Converts this QueAndAns to JSON.
         * @function toJSON
         * @memberof request.QueAndAns
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        QueAndAns.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for QueAndAns
         * @function getTypeUrl
         * @memberof request.QueAndAns
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        QueAndAns.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.QueAndAns";
        };

        return QueAndAns;
    })();

    request.ListQuestions = (function() {

        /**
         * Properties of a ListQuestions.
         * @memberof request
         * @interface IListQuestions
         * @property {string|null} [email] ListQuestions email
         */

        /**
         * Constructs a new ListQuestions.
         * @memberof request
         * @classdesc Represents a ListQuestions.
         * @implements IListQuestions
         * @constructor
         * @param {request.IListQuestions=} [properties] Properties to set
         */
        function ListQuestions(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListQuestions email.
         * @member {string} email
         * @memberof request.ListQuestions
         * @instance
         */
        ListQuestions.prototype.email = "";

        /**
         * Creates a new ListQuestions instance using the specified properties.
         * @function create
         * @memberof request.ListQuestions
         * @static
         * @param {request.IListQuestions=} [properties] Properties to set
         * @returns {request.ListQuestions} ListQuestions instance
         */
        ListQuestions.create = function create(properties) {
            return new ListQuestions(properties);
        };

        /**
         * Encodes the specified ListQuestions message. Does not implicitly {@link request.ListQuestions.verify|verify} messages.
         * @function encode
         * @memberof request.ListQuestions
         * @static
         * @param {request.IListQuestions} message ListQuestions message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListQuestions.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
            return writer;
        };

        /**
         * Encodes the specified ListQuestions message, length delimited. Does not implicitly {@link request.ListQuestions.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.ListQuestions
         * @static
         * @param {request.IListQuestions} message ListQuestions message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListQuestions.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ListQuestions message from the specified reader or buffer.
         * @function decode
         * @memberof request.ListQuestions
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.ListQuestions} ListQuestions
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListQuestions.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.ListQuestions();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.email = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ListQuestions message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.ListQuestions
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.ListQuestions} ListQuestions
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListQuestions.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ListQuestions message.
         * @function verify
         * @memberof request.ListQuestions
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ListQuestions.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            return null;
        };

        /**
         * Creates a ListQuestions message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.ListQuestions
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.ListQuestions} ListQuestions
         */
        ListQuestions.fromObject = function fromObject(object) {
            if (object instanceof $root.request.ListQuestions)
                return object;
            let message = new $root.request.ListQuestions();
            if (object.email != null)
                message.email = String(object.email);
            return message;
        };

        /**
         * Creates a plain object from a ListQuestions message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.ListQuestions
         * @static
         * @param {request.ListQuestions} message ListQuestions
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListQuestions.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.email = "";
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            return object;
        };

        /**
         * Converts this ListQuestions to JSON.
         * @function toJSON
         * @memberof request.ListQuestions
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListQuestions.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ListQuestions
         * @function getTypeUrl
         * @memberof request.ListQuestions
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ListQuestions.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.ListQuestions";
        };

        return ListQuestions;
    })();

    request.AwsS3 = (function() {

        /**
         * Properties of an AwsS3.
         * @memberof request
         * @interface IAwsS3
         * @property {string|null} [accessKeyId] AwsS3 accessKeyId
         * @property {string|null} [secretAccessKey] AwsS3 secretAccessKey
         * @property {string|null} [sessionToken] AwsS3 sessionToken
         * @property {string|null} [region] AwsS3 region
         * @property {string|null} [endpointUrl] AwsS3 endpointUrl
         */

        /**
         * Constructs a new AwsS3.
         * @memberof request
         * @classdesc Represents an AwsS3.
         * @implements IAwsS3
         * @constructor
         * @param {request.IAwsS3=} [properties] Properties to set
         */
        function AwsS3(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AwsS3 accessKeyId.
         * @member {string} accessKeyId
         * @memberof request.AwsS3
         * @instance
         */
        AwsS3.prototype.accessKeyId = "";

        /**
         * AwsS3 secretAccessKey.
         * @member {string} secretAccessKey
         * @memberof request.AwsS3
         * @instance
         */
        AwsS3.prototype.secretAccessKey = "";

        /**
         * AwsS3 sessionToken.
         * @member {string} sessionToken
         * @memberof request.AwsS3
         * @instance
         */
        AwsS3.prototype.sessionToken = "";

        /**
         * AwsS3 region.
         * @member {string} region
         * @memberof request.AwsS3
         * @instance
         */
        AwsS3.prototype.region = "";

        /**
         * AwsS3 endpointUrl.
         * @member {string} endpointUrl
         * @memberof request.AwsS3
         * @instance
         */
        AwsS3.prototype.endpointUrl = "";

        /**
         * Creates a new AwsS3 instance using the specified properties.
         * @function create
         * @memberof request.AwsS3
         * @static
         * @param {request.IAwsS3=} [properties] Properties to set
         * @returns {request.AwsS3} AwsS3 instance
         */
        AwsS3.create = function create(properties) {
            return new AwsS3(properties);
        };

        /**
         * Encodes the specified AwsS3 message. Does not implicitly {@link request.AwsS3.verify|verify} messages.
         * @function encode
         * @memberof request.AwsS3
         * @static
         * @param {request.IAwsS3} message AwsS3 message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AwsS3.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.accessKeyId != null && Object.hasOwnProperty.call(message, "accessKeyId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.accessKeyId);
            if (message.secretAccessKey != null && Object.hasOwnProperty.call(message, "secretAccessKey"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.secretAccessKey);
            if (message.sessionToken != null && Object.hasOwnProperty.call(message, "sessionToken"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.sessionToken);
            if (message.region != null && Object.hasOwnProperty.call(message, "region"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.region);
            if (message.endpointUrl != null && Object.hasOwnProperty.call(message, "endpointUrl"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.endpointUrl);
            return writer;
        };

        /**
         * Encodes the specified AwsS3 message, length delimited. Does not implicitly {@link request.AwsS3.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.AwsS3
         * @static
         * @param {request.IAwsS3} message AwsS3 message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AwsS3.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AwsS3 message from the specified reader or buffer.
         * @function decode
         * @memberof request.AwsS3
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.AwsS3} AwsS3
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AwsS3.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.AwsS3();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.accessKeyId = reader.string();
                        break;
                    }
                case 2: {
                        message.secretAccessKey = reader.string();
                        break;
                    }
                case 3: {
                        message.sessionToken = reader.string();
                        break;
                    }
                case 4: {
                        message.region = reader.string();
                        break;
                    }
                case 5: {
                        message.endpointUrl = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AwsS3 message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.AwsS3
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.AwsS3} AwsS3
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AwsS3.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AwsS3 message.
         * @function verify
         * @memberof request.AwsS3
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AwsS3.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.accessKeyId != null && message.hasOwnProperty("accessKeyId"))
                if (!$util.isString(message.accessKeyId))
                    return "accessKeyId: string expected";
            if (message.secretAccessKey != null && message.hasOwnProperty("secretAccessKey"))
                if (!$util.isString(message.secretAccessKey))
                    return "secretAccessKey: string expected";
            if (message.sessionToken != null && message.hasOwnProperty("sessionToken"))
                if (!$util.isString(message.sessionToken))
                    return "sessionToken: string expected";
            if (message.region != null && message.hasOwnProperty("region"))
                if (!$util.isString(message.region))
                    return "region: string expected";
            if (message.endpointUrl != null && message.hasOwnProperty("endpointUrl"))
                if (!$util.isString(message.endpointUrl))
                    return "endpointUrl: string expected";
            return null;
        };

        /**
         * Creates an AwsS3 message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.AwsS3
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.AwsS3} AwsS3
         */
        AwsS3.fromObject = function fromObject(object) {
            if (object instanceof $root.request.AwsS3)
                return object;
            let message = new $root.request.AwsS3();
            if (object.accessKeyId != null)
                message.accessKeyId = String(object.accessKeyId);
            if (object.secretAccessKey != null)
                message.secretAccessKey = String(object.secretAccessKey);
            if (object.sessionToken != null)
                message.sessionToken = String(object.sessionToken);
            if (object.region != null)
                message.region = String(object.region);
            if (object.endpointUrl != null)
                message.endpointUrl = String(object.endpointUrl);
            return message;
        };

        /**
         * Creates a plain object from an AwsS3 message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.AwsS3
         * @static
         * @param {request.AwsS3} message AwsS3
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AwsS3.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.accessKeyId = "";
                object.secretAccessKey = "";
                object.sessionToken = "";
                object.region = "";
                object.endpointUrl = "";
            }
            if (message.accessKeyId != null && message.hasOwnProperty("accessKeyId"))
                object.accessKeyId = message.accessKeyId;
            if (message.secretAccessKey != null && message.hasOwnProperty("secretAccessKey"))
                object.secretAccessKey = message.secretAccessKey;
            if (message.sessionToken != null && message.hasOwnProperty("sessionToken"))
                object.sessionToken = message.sessionToken;
            if (message.region != null && message.hasOwnProperty("region"))
                object.region = message.region;
            if (message.endpointUrl != null && message.hasOwnProperty("endpointUrl"))
                object.endpointUrl = message.endpointUrl;
            return object;
        };

        /**
         * Converts this AwsS3 to JSON.
         * @function toJSON
         * @memberof request.AwsS3
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AwsS3.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for AwsS3
         * @function getTypeUrl
         * @memberof request.AwsS3
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        AwsS3.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.AwsS3";
        };

        return AwsS3;
    })();

    request.AzureBlob = (function() {

        /**
         * Properties of an AzureBlob.
         * @memberof request
         * @interface IAzureBlob
         * @property {string|null} [accountName] AzureBlob accountName
         * @property {string|null} [accountKey] AzureBlob accountKey
         * @property {string|null} [connectionString] AzureBlob connectionString
         */

        /**
         * Constructs a new AzureBlob.
         * @memberof request
         * @classdesc Represents an AzureBlob.
         * @implements IAzureBlob
         * @constructor
         * @param {request.IAzureBlob=} [properties] Properties to set
         */
        function AzureBlob(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AzureBlob accountName.
         * @member {string} accountName
         * @memberof request.AzureBlob
         * @instance
         */
        AzureBlob.prototype.accountName = "";

        /**
         * AzureBlob accountKey.
         * @member {string} accountKey
         * @memberof request.AzureBlob
         * @instance
         */
        AzureBlob.prototype.accountKey = "";

        /**
         * AzureBlob connectionString.
         * @member {string} connectionString
         * @memberof request.AzureBlob
         * @instance
         */
        AzureBlob.prototype.connectionString = "";

        /**
         * Creates a new AzureBlob instance using the specified properties.
         * @function create
         * @memberof request.AzureBlob
         * @static
         * @param {request.IAzureBlob=} [properties] Properties to set
         * @returns {request.AzureBlob} AzureBlob instance
         */
        AzureBlob.create = function create(properties) {
            return new AzureBlob(properties);
        };

        /**
         * Encodes the specified AzureBlob message. Does not implicitly {@link request.AzureBlob.verify|verify} messages.
         * @function encode
         * @memberof request.AzureBlob
         * @static
         * @param {request.IAzureBlob} message AzureBlob message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AzureBlob.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.accountName != null && Object.hasOwnProperty.call(message, "accountName"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.accountName);
            if (message.accountKey != null && Object.hasOwnProperty.call(message, "accountKey"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.accountKey);
            if (message.connectionString != null && Object.hasOwnProperty.call(message, "connectionString"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.connectionString);
            return writer;
        };

        /**
         * Encodes the specified AzureBlob message, length delimited. Does not implicitly {@link request.AzureBlob.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.AzureBlob
         * @static
         * @param {request.IAzureBlob} message AzureBlob message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AzureBlob.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AzureBlob message from the specified reader or buffer.
         * @function decode
         * @memberof request.AzureBlob
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.AzureBlob} AzureBlob
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AzureBlob.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.AzureBlob();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.accountName = reader.string();
                        break;
                    }
                case 2: {
                        message.accountKey = reader.string();
                        break;
                    }
                case 3: {
                        message.connectionString = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AzureBlob message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.AzureBlob
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.AzureBlob} AzureBlob
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AzureBlob.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AzureBlob message.
         * @function verify
         * @memberof request.AzureBlob
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AzureBlob.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.accountName != null && message.hasOwnProperty("accountName"))
                if (!$util.isString(message.accountName))
                    return "accountName: string expected";
            if (message.accountKey != null && message.hasOwnProperty("accountKey"))
                if (!$util.isString(message.accountKey))
                    return "accountKey: string expected";
            if (message.connectionString != null && message.hasOwnProperty("connectionString"))
                if (!$util.isString(message.connectionString))
                    return "connectionString: string expected";
            return null;
        };

        /**
         * Creates an AzureBlob message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.AzureBlob
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.AzureBlob} AzureBlob
         */
        AzureBlob.fromObject = function fromObject(object) {
            if (object instanceof $root.request.AzureBlob)
                return object;
            let message = new $root.request.AzureBlob();
            if (object.accountName != null)
                message.accountName = String(object.accountName);
            if (object.accountKey != null)
                message.accountKey = String(object.accountKey);
            if (object.connectionString != null)
                message.connectionString = String(object.connectionString);
            return message;
        };

        /**
         * Creates a plain object from an AzureBlob message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.AzureBlob
         * @static
         * @param {request.AzureBlob} message AzureBlob
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AzureBlob.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.accountName = "";
                object.accountKey = "";
                object.connectionString = "";
            }
            if (message.accountName != null && message.hasOwnProperty("accountName"))
                object.accountName = message.accountName;
            if (message.accountKey != null && message.hasOwnProperty("accountKey"))
                object.accountKey = message.accountKey;
            if (message.connectionString != null && message.hasOwnProperty("connectionString"))
                object.connectionString = message.connectionString;
            return object;
        };

        /**
         * Converts this AzureBlob to JSON.
         * @function toJSON
         * @memberof request.AzureBlob
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AzureBlob.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for AzureBlob
         * @function getTypeUrl
         * @memberof request.AzureBlob
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        AzureBlob.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.AzureBlob";
        };

        return AzureBlob;
    })();

    request.GoogleCloudStorage = (function() {

        /**
         * Properties of a GoogleCloudStorage.
         * @memberof request
         * @interface IGoogleCloudStorage
         * @property {string|null} [projectId] GoogleCloudStorage projectId
         * @property {string|null} [clientEmail] GoogleCloudStorage clientEmail
         * @property {string|null} [privateKeyId] GoogleCloudStorage privateKeyId
         * @property {string|null} [privateKey] GoogleCloudStorage privateKey
         * @property {string|null} [clientId] GoogleCloudStorage clientId
         * @property {string|null} [credentialsJson] GoogleCloudStorage credentialsJson
         */

        /**
         * Constructs a new GoogleCloudStorage.
         * @memberof request
         * @classdesc Represents a GoogleCloudStorage.
         * @implements IGoogleCloudStorage
         * @constructor
         * @param {request.IGoogleCloudStorage=} [properties] Properties to set
         */
        function GoogleCloudStorage(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GoogleCloudStorage projectId.
         * @member {string} projectId
         * @memberof request.GoogleCloudStorage
         * @instance
         */
        GoogleCloudStorage.prototype.projectId = "";

        /**
         * GoogleCloudStorage clientEmail.
         * @member {string} clientEmail
         * @memberof request.GoogleCloudStorage
         * @instance
         */
        GoogleCloudStorage.prototype.clientEmail = "";

        /**
         * GoogleCloudStorage privateKeyId.
         * @member {string} privateKeyId
         * @memberof request.GoogleCloudStorage
         * @instance
         */
        GoogleCloudStorage.prototype.privateKeyId = "";

        /**
         * GoogleCloudStorage privateKey.
         * @member {string} privateKey
         * @memberof request.GoogleCloudStorage
         * @instance
         */
        GoogleCloudStorage.prototype.privateKey = "";

        /**
         * GoogleCloudStorage clientId.
         * @member {string} clientId
         * @memberof request.GoogleCloudStorage
         * @instance
         */
        GoogleCloudStorage.prototype.clientId = "";

        /**
         * GoogleCloudStorage credentialsJson.
         * @member {string} credentialsJson
         * @memberof request.GoogleCloudStorage
         * @instance
         */
        GoogleCloudStorage.prototype.credentialsJson = "";

        /**
         * Creates a new GoogleCloudStorage instance using the specified properties.
         * @function create
         * @memberof request.GoogleCloudStorage
         * @static
         * @param {request.IGoogleCloudStorage=} [properties] Properties to set
         * @returns {request.GoogleCloudStorage} GoogleCloudStorage instance
         */
        GoogleCloudStorage.create = function create(properties) {
            return new GoogleCloudStorage(properties);
        };

        /**
         * Encodes the specified GoogleCloudStorage message. Does not implicitly {@link request.GoogleCloudStorage.verify|verify} messages.
         * @function encode
         * @memberof request.GoogleCloudStorage
         * @static
         * @param {request.IGoogleCloudStorage} message GoogleCloudStorage message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GoogleCloudStorage.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.projectId != null && Object.hasOwnProperty.call(message, "projectId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.projectId);
            if (message.clientEmail != null && Object.hasOwnProperty.call(message, "clientEmail"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.clientEmail);
            if (message.privateKeyId != null && Object.hasOwnProperty.call(message, "privateKeyId"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.privateKeyId);
            if (message.privateKey != null && Object.hasOwnProperty.call(message, "privateKey"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.privateKey);
            if (message.clientId != null && Object.hasOwnProperty.call(message, "clientId"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.clientId);
            if (message.credentialsJson != null && Object.hasOwnProperty.call(message, "credentialsJson"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.credentialsJson);
            return writer;
        };

        /**
         * Encodes the specified GoogleCloudStorage message, length delimited. Does not implicitly {@link request.GoogleCloudStorage.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.GoogleCloudStorage
         * @static
         * @param {request.IGoogleCloudStorage} message GoogleCloudStorage message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GoogleCloudStorage.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GoogleCloudStorage message from the specified reader or buffer.
         * @function decode
         * @memberof request.GoogleCloudStorage
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.GoogleCloudStorage} GoogleCloudStorage
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GoogleCloudStorage.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.GoogleCloudStorage();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.projectId = reader.string();
                        break;
                    }
                case 2: {
                        message.clientEmail = reader.string();
                        break;
                    }
                case 3: {
                        message.privateKeyId = reader.string();
                        break;
                    }
                case 4: {
                        message.privateKey = reader.string();
                        break;
                    }
                case 5: {
                        message.clientId = reader.string();
                        break;
                    }
                case 6: {
                        message.credentialsJson = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GoogleCloudStorage message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.GoogleCloudStorage
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.GoogleCloudStorage} GoogleCloudStorage
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GoogleCloudStorage.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GoogleCloudStorage message.
         * @function verify
         * @memberof request.GoogleCloudStorage
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GoogleCloudStorage.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.projectId != null && message.hasOwnProperty("projectId"))
                if (!$util.isString(message.projectId))
                    return "projectId: string expected";
            if (message.clientEmail != null && message.hasOwnProperty("clientEmail"))
                if (!$util.isString(message.clientEmail))
                    return "clientEmail: string expected";
            if (message.privateKeyId != null && message.hasOwnProperty("privateKeyId"))
                if (!$util.isString(message.privateKeyId))
                    return "privateKeyId: string expected";
            if (message.privateKey != null && message.hasOwnProperty("privateKey"))
                if (!$util.isString(message.privateKey))
                    return "privateKey: string expected";
            if (message.clientId != null && message.hasOwnProperty("clientId"))
                if (!$util.isString(message.clientId))
                    return "clientId: string expected";
            if (message.credentialsJson != null && message.hasOwnProperty("credentialsJson"))
                if (!$util.isString(message.credentialsJson))
                    return "credentialsJson: string expected";
            return null;
        };

        /**
         * Creates a GoogleCloudStorage message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.GoogleCloudStorage
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.GoogleCloudStorage} GoogleCloudStorage
         */
        GoogleCloudStorage.fromObject = function fromObject(object) {
            if (object instanceof $root.request.GoogleCloudStorage)
                return object;
            let message = new $root.request.GoogleCloudStorage();
            if (object.projectId != null)
                message.projectId = String(object.projectId);
            if (object.clientEmail != null)
                message.clientEmail = String(object.clientEmail);
            if (object.privateKeyId != null)
                message.privateKeyId = String(object.privateKeyId);
            if (object.privateKey != null)
                message.privateKey = String(object.privateKey);
            if (object.clientId != null)
                message.clientId = String(object.clientId);
            if (object.credentialsJson != null)
                message.credentialsJson = String(object.credentialsJson);
            return message;
        };

        /**
         * Creates a plain object from a GoogleCloudStorage message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.GoogleCloudStorage
         * @static
         * @param {request.GoogleCloudStorage} message GoogleCloudStorage
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GoogleCloudStorage.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.projectId = "";
                object.clientEmail = "";
                object.privateKeyId = "";
                object.privateKey = "";
                object.clientId = "";
                object.credentialsJson = "";
            }
            if (message.projectId != null && message.hasOwnProperty("projectId"))
                object.projectId = message.projectId;
            if (message.clientEmail != null && message.hasOwnProperty("clientEmail"))
                object.clientEmail = message.clientEmail;
            if (message.privateKeyId != null && message.hasOwnProperty("privateKeyId"))
                object.privateKeyId = message.privateKeyId;
            if (message.privateKey != null && message.hasOwnProperty("privateKey"))
                object.privateKey = message.privateKey;
            if (message.clientId != null && message.hasOwnProperty("clientId"))
                object.clientId = message.clientId;
            if (message.credentialsJson != null && message.hasOwnProperty("credentialsJson"))
                object.credentialsJson = message.credentialsJson;
            return object;
        };

        /**
         * Converts this GoogleCloudStorage to JSON.
         * @function toJSON
         * @memberof request.GoogleCloudStorage
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GoogleCloudStorage.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GoogleCloudStorage
         * @function getTypeUrl
         * @memberof request.GoogleCloudStorage
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GoogleCloudStorage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.GoogleCloudStorage";
        };

        return GoogleCloudStorage;
    })();

    request.Minio = (function() {

        /**
         * Properties of a Minio.
         * @memberof request
         * @interface IMinio
         * @property {string|null} [accessKey] Minio accessKey
         * @property {string|null} [secretKey] Minio secretKey
         * @property {string|null} [endpoint] Minio endpoint
         * @property {boolean|null} [useSsl] Minio useSsl
         */

        /**
         * Constructs a new Minio.
         * @memberof request
         * @classdesc Represents a Minio.
         * @implements IMinio
         * @constructor
         * @param {request.IMinio=} [properties] Properties to set
         */
        function Minio(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Minio accessKey.
         * @member {string} accessKey
         * @memberof request.Minio
         * @instance
         */
        Minio.prototype.accessKey = "";

        /**
         * Minio secretKey.
         * @member {string} secretKey
         * @memberof request.Minio
         * @instance
         */
        Minio.prototype.secretKey = "";

        /**
         * Minio endpoint.
         * @member {string} endpoint
         * @memberof request.Minio
         * @instance
         */
        Minio.prototype.endpoint = "";

        /**
         * Minio useSsl.
         * @member {boolean} useSsl
         * @memberof request.Minio
         * @instance
         */
        Minio.prototype.useSsl = false;

        /**
         * Creates a new Minio instance using the specified properties.
         * @function create
         * @memberof request.Minio
         * @static
         * @param {request.IMinio=} [properties] Properties to set
         * @returns {request.Minio} Minio instance
         */
        Minio.create = function create(properties) {
            return new Minio(properties);
        };

        /**
         * Encodes the specified Minio message. Does not implicitly {@link request.Minio.verify|verify} messages.
         * @function encode
         * @memberof request.Minio
         * @static
         * @param {request.IMinio} message Minio message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Minio.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.accessKey != null && Object.hasOwnProperty.call(message, "accessKey"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.accessKey);
            if (message.secretKey != null && Object.hasOwnProperty.call(message, "secretKey"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.secretKey);
            if (message.endpoint != null && Object.hasOwnProperty.call(message, "endpoint"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.endpoint);
            if (message.useSsl != null && Object.hasOwnProperty.call(message, "useSsl"))
                writer.uint32(/* id 4, wireType 0 =*/32).bool(message.useSsl);
            return writer;
        };

        /**
         * Encodes the specified Minio message, length delimited. Does not implicitly {@link request.Minio.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.Minio
         * @static
         * @param {request.IMinio} message Minio message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Minio.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Minio message from the specified reader or buffer.
         * @function decode
         * @memberof request.Minio
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.Minio} Minio
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Minio.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.Minio();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.accessKey = reader.string();
                        break;
                    }
                case 2: {
                        message.secretKey = reader.string();
                        break;
                    }
                case 3: {
                        message.endpoint = reader.string();
                        break;
                    }
                case 4: {
                        message.useSsl = reader.bool();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Minio message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.Minio
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.Minio} Minio
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Minio.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Minio message.
         * @function verify
         * @memberof request.Minio
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Minio.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.accessKey != null && message.hasOwnProperty("accessKey"))
                if (!$util.isString(message.accessKey))
                    return "accessKey: string expected";
            if (message.secretKey != null && message.hasOwnProperty("secretKey"))
                if (!$util.isString(message.secretKey))
                    return "secretKey: string expected";
            if (message.endpoint != null && message.hasOwnProperty("endpoint"))
                if (!$util.isString(message.endpoint))
                    return "endpoint: string expected";
            if (message.useSsl != null && message.hasOwnProperty("useSsl"))
                if (typeof message.useSsl !== "boolean")
                    return "useSsl: boolean expected";
            return null;
        };

        /**
         * Creates a Minio message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.Minio
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.Minio} Minio
         */
        Minio.fromObject = function fromObject(object) {
            if (object instanceof $root.request.Minio)
                return object;
            let message = new $root.request.Minio();
            if (object.accessKey != null)
                message.accessKey = String(object.accessKey);
            if (object.secretKey != null)
                message.secretKey = String(object.secretKey);
            if (object.endpoint != null)
                message.endpoint = String(object.endpoint);
            if (object.useSsl != null)
                message.useSsl = Boolean(object.useSsl);
            return message;
        };

        /**
         * Creates a plain object from a Minio message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.Minio
         * @static
         * @param {request.Minio} message Minio
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Minio.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.accessKey = "";
                object.secretKey = "";
                object.endpoint = "";
                object.useSsl = false;
            }
            if (message.accessKey != null && message.hasOwnProperty("accessKey"))
                object.accessKey = message.accessKey;
            if (message.secretKey != null && message.hasOwnProperty("secretKey"))
                object.secretKey = message.secretKey;
            if (message.endpoint != null && message.hasOwnProperty("endpoint"))
                object.endpoint = message.endpoint;
            if (message.useSsl != null && message.hasOwnProperty("useSsl"))
                object.useSsl = message.useSsl;
            return object;
        };

        /**
         * Converts this Minio to JSON.
         * @function toJSON
         * @memberof request.Minio
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Minio.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Minio
         * @function getTypeUrl
         * @memberof request.Minio
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Minio.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.Minio";
        };

        return Minio;
    })();

    request.StorageType = (function() {

        /**
         * Properties of a StorageType.
         * @memberof request
         * @interface IStorageType
         * @property {request.IAwsS3|null} [awsS3] StorageType awsS3
         * @property {request.IAzureBlob|null} [azureBlob] StorageType azureBlob
         * @property {request.IGoogleCloudStorage|null} [googleCloudStorage] StorageType googleCloudStorage
         * @property {request.IMinio|null} [minio] StorageType minio
         */

        /**
         * Constructs a new StorageType.
         * @memberof request
         * @classdesc Represents a StorageType.
         * @implements IStorageType
         * @constructor
         * @param {request.IStorageType=} [properties] Properties to set
         */
        function StorageType(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * StorageType awsS3.
         * @member {request.IAwsS3|null|undefined} awsS3
         * @memberof request.StorageType
         * @instance
         */
        StorageType.prototype.awsS3 = null;

        /**
         * StorageType azureBlob.
         * @member {request.IAzureBlob|null|undefined} azureBlob
         * @memberof request.StorageType
         * @instance
         */
        StorageType.prototype.azureBlob = null;

        /**
         * StorageType googleCloudStorage.
         * @member {request.IGoogleCloudStorage|null|undefined} googleCloudStorage
         * @memberof request.StorageType
         * @instance
         */
        StorageType.prototype.googleCloudStorage = null;

        /**
         * StorageType minio.
         * @member {request.IMinio|null|undefined} minio
         * @memberof request.StorageType
         * @instance
         */
        StorageType.prototype.minio = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * StorageType storage.
         * @member {"awsS3"|"azureBlob"|"googleCloudStorage"|"minio"|undefined} storage
         * @memberof request.StorageType
         * @instance
         */
        Object.defineProperty(StorageType.prototype, "storage", {
            get: $util.oneOfGetter($oneOfFields = ["awsS3", "azureBlob", "googleCloudStorage", "minio"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new StorageType instance using the specified properties.
         * @function create
         * @memberof request.StorageType
         * @static
         * @param {request.IStorageType=} [properties] Properties to set
         * @returns {request.StorageType} StorageType instance
         */
        StorageType.create = function create(properties) {
            return new StorageType(properties);
        };

        /**
         * Encodes the specified StorageType message. Does not implicitly {@link request.StorageType.verify|verify} messages.
         * @function encode
         * @memberof request.StorageType
         * @static
         * @param {request.IStorageType} message StorageType message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StorageType.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.awsS3 != null && Object.hasOwnProperty.call(message, "awsS3"))
                $root.request.AwsS3.encode(message.awsS3, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.azureBlob != null && Object.hasOwnProperty.call(message, "azureBlob"))
                $root.request.AzureBlob.encode(message.azureBlob, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.googleCloudStorage != null && Object.hasOwnProperty.call(message, "googleCloudStorage"))
                $root.request.GoogleCloudStorage.encode(message.googleCloudStorage, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.minio != null && Object.hasOwnProperty.call(message, "minio"))
                $root.request.Minio.encode(message.minio, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified StorageType message, length delimited. Does not implicitly {@link request.StorageType.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.StorageType
         * @static
         * @param {request.IStorageType} message StorageType message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StorageType.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a StorageType message from the specified reader or buffer.
         * @function decode
         * @memberof request.StorageType
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.StorageType} StorageType
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StorageType.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.StorageType();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.awsS3 = $root.request.AwsS3.decode(reader, reader.uint32());
                        break;
                    }
                case 2: {
                        message.azureBlob = $root.request.AzureBlob.decode(reader, reader.uint32());
                        break;
                    }
                case 3: {
                        message.googleCloudStorage = $root.request.GoogleCloudStorage.decode(reader, reader.uint32());
                        break;
                    }
                case 4: {
                        message.minio = $root.request.Minio.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a StorageType message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.StorageType
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.StorageType} StorageType
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StorageType.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a StorageType message.
         * @function verify
         * @memberof request.StorageType
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        StorageType.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.awsS3 != null && message.hasOwnProperty("awsS3")) {
                properties.storage = 1;
                {
                    let error = $root.request.AwsS3.verify(message.awsS3);
                    if (error)
                        return "awsS3." + error;
                }
            }
            if (message.azureBlob != null && message.hasOwnProperty("azureBlob")) {
                if (properties.storage === 1)
                    return "storage: multiple values";
                properties.storage = 1;
                {
                    let error = $root.request.AzureBlob.verify(message.azureBlob);
                    if (error)
                        return "azureBlob." + error;
                }
            }
            if (message.googleCloudStorage != null && message.hasOwnProperty("googleCloudStorage")) {
                if (properties.storage === 1)
                    return "storage: multiple values";
                properties.storage = 1;
                {
                    let error = $root.request.GoogleCloudStorage.verify(message.googleCloudStorage);
                    if (error)
                        return "googleCloudStorage." + error;
                }
            }
            if (message.minio != null && message.hasOwnProperty("minio")) {
                if (properties.storage === 1)
                    return "storage: multiple values";
                properties.storage = 1;
                {
                    let error = $root.request.Minio.verify(message.minio);
                    if (error)
                        return "minio." + error;
                }
            }
            return null;
        };

        /**
         * Creates a StorageType message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.StorageType
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.StorageType} StorageType
         */
        StorageType.fromObject = function fromObject(object) {
            if (object instanceof $root.request.StorageType)
                return object;
            let message = new $root.request.StorageType();
            if (object.awsS3 != null) {
                if (typeof object.awsS3 !== "object")
                    throw TypeError(".request.StorageType.awsS3: object expected");
                message.awsS3 = $root.request.AwsS3.fromObject(object.awsS3);
            }
            if (object.azureBlob != null) {
                if (typeof object.azureBlob !== "object")
                    throw TypeError(".request.StorageType.azureBlob: object expected");
                message.azureBlob = $root.request.AzureBlob.fromObject(object.azureBlob);
            }
            if (object.googleCloudStorage != null) {
                if (typeof object.googleCloudStorage !== "object")
                    throw TypeError(".request.StorageType.googleCloudStorage: object expected");
                message.googleCloudStorage = $root.request.GoogleCloudStorage.fromObject(object.googleCloudStorage);
            }
            if (object.minio != null) {
                if (typeof object.minio !== "object")
                    throw TypeError(".request.StorageType.minio: object expected");
                message.minio = $root.request.Minio.fromObject(object.minio);
            }
            return message;
        };

        /**
         * Creates a plain object from a StorageType message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.StorageType
         * @static
         * @param {request.StorageType} message StorageType
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        StorageType.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (message.awsS3 != null && message.hasOwnProperty("awsS3")) {
                object.awsS3 = $root.request.AwsS3.toObject(message.awsS3, options);
                if (options.oneofs)
                    object.storage = "awsS3";
            }
            if (message.azureBlob != null && message.hasOwnProperty("azureBlob")) {
                object.azureBlob = $root.request.AzureBlob.toObject(message.azureBlob, options);
                if (options.oneofs)
                    object.storage = "azureBlob";
            }
            if (message.googleCloudStorage != null && message.hasOwnProperty("googleCloudStorage")) {
                object.googleCloudStorage = $root.request.GoogleCloudStorage.toObject(message.googleCloudStorage, options);
                if (options.oneofs)
                    object.storage = "googleCloudStorage";
            }
            if (message.minio != null && message.hasOwnProperty("minio")) {
                object.minio = $root.request.Minio.toObject(message.minio, options);
                if (options.oneofs)
                    object.storage = "minio";
            }
            return object;
        };

        /**
         * Converts this StorageType to JSON.
         * @function toJSON
         * @memberof request.StorageType
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        StorageType.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for StorageType
         * @function getTypeUrl
         * @memberof request.StorageType
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        StorageType.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.StorageType";
        };

        return StorageType;
    })();

    request.VerifyBYOSCreds = (function() {

        /**
         * Properties of a VerifyBYOSCreds.
         * @memberof request
         * @interface IVerifyBYOSCreds
         * @property {request.IStorageType|null} [storageType] VerifyBYOSCreds storageType
         */

        /**
         * Constructs a new VerifyBYOSCreds.
         * @memberof request
         * @classdesc Represents a VerifyBYOSCreds.
         * @implements IVerifyBYOSCreds
         * @constructor
         * @param {request.IVerifyBYOSCreds=} [properties] Properties to set
         */
        function VerifyBYOSCreds(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * VerifyBYOSCreds storageType.
         * @member {request.IStorageType|null|undefined} storageType
         * @memberof request.VerifyBYOSCreds
         * @instance
         */
        VerifyBYOSCreds.prototype.storageType = null;

        /**
         * Creates a new VerifyBYOSCreds instance using the specified properties.
         * @function create
         * @memberof request.VerifyBYOSCreds
         * @static
         * @param {request.IVerifyBYOSCreds=} [properties] Properties to set
         * @returns {request.VerifyBYOSCreds} VerifyBYOSCreds instance
         */
        VerifyBYOSCreds.create = function create(properties) {
            return new VerifyBYOSCreds(properties);
        };

        /**
         * Encodes the specified VerifyBYOSCreds message. Does not implicitly {@link request.VerifyBYOSCreds.verify|verify} messages.
         * @function encode
         * @memberof request.VerifyBYOSCreds
         * @static
         * @param {request.IVerifyBYOSCreds} message VerifyBYOSCreds message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        VerifyBYOSCreds.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.storageType != null && Object.hasOwnProperty.call(message, "storageType"))
                $root.request.StorageType.encode(message.storageType, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified VerifyBYOSCreds message, length delimited. Does not implicitly {@link request.VerifyBYOSCreds.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.VerifyBYOSCreds
         * @static
         * @param {request.IVerifyBYOSCreds} message VerifyBYOSCreds message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        VerifyBYOSCreds.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a VerifyBYOSCreds message from the specified reader or buffer.
         * @function decode
         * @memberof request.VerifyBYOSCreds
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.VerifyBYOSCreds} VerifyBYOSCreds
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        VerifyBYOSCreds.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.VerifyBYOSCreds();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.storageType = $root.request.StorageType.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a VerifyBYOSCreds message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.VerifyBYOSCreds
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.VerifyBYOSCreds} VerifyBYOSCreds
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        VerifyBYOSCreds.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a VerifyBYOSCreds message.
         * @function verify
         * @memberof request.VerifyBYOSCreds
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        VerifyBYOSCreds.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.storageType != null && message.hasOwnProperty("storageType")) {
                let error = $root.request.StorageType.verify(message.storageType);
                if (error)
                    return "storageType." + error;
            }
            return null;
        };

        /**
         * Creates a VerifyBYOSCreds message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.VerifyBYOSCreds
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.VerifyBYOSCreds} VerifyBYOSCreds
         */
        VerifyBYOSCreds.fromObject = function fromObject(object) {
            if (object instanceof $root.request.VerifyBYOSCreds)
                return object;
            let message = new $root.request.VerifyBYOSCreds();
            if (object.storageType != null) {
                if (typeof object.storageType !== "object")
                    throw TypeError(".request.VerifyBYOSCreds.storageType: object expected");
                message.storageType = $root.request.StorageType.fromObject(object.storageType);
            }
            return message;
        };

        /**
         * Creates a plain object from a VerifyBYOSCreds message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.VerifyBYOSCreds
         * @static
         * @param {request.VerifyBYOSCreds} message VerifyBYOSCreds
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        VerifyBYOSCreds.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.storageType = null;
            if (message.storageType != null && message.hasOwnProperty("storageType"))
                object.storageType = $root.request.StorageType.toObject(message.storageType, options);
            return object;
        };

        /**
         * Converts this VerifyBYOSCreds to JSON.
         * @function toJSON
         * @memberof request.VerifyBYOSCreds
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        VerifyBYOSCreds.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for VerifyBYOSCreds
         * @function getTypeUrl
         * @memberof request.VerifyBYOSCreds
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        VerifyBYOSCreds.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.VerifyBYOSCreds";
        };

        return VerifyBYOSCreds;
    })();

    request.MigrateToStorage = (function() {

        /**
         * Properties of a MigrateToStorage.
         * @memberof request
         * @interface IMigrateToStorage
         * @property {request.IStorageType|null} [storageType] MigrateToStorage storageType
         */

        /**
         * Constructs a new MigrateToStorage.
         * @memberof request
         * @classdesc Represents a MigrateToStorage.
         * @implements IMigrateToStorage
         * @constructor
         * @param {request.IMigrateToStorage=} [properties] Properties to set
         */
        function MigrateToStorage(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MigrateToStorage storageType.
         * @member {request.IStorageType|null|undefined} storageType
         * @memberof request.MigrateToStorage
         * @instance
         */
        MigrateToStorage.prototype.storageType = null;

        /**
         * Creates a new MigrateToStorage instance using the specified properties.
         * @function create
         * @memberof request.MigrateToStorage
         * @static
         * @param {request.IMigrateToStorage=} [properties] Properties to set
         * @returns {request.MigrateToStorage} MigrateToStorage instance
         */
        MigrateToStorage.create = function create(properties) {
            return new MigrateToStorage(properties);
        };

        /**
         * Encodes the specified MigrateToStorage message. Does not implicitly {@link request.MigrateToStorage.verify|verify} messages.
         * @function encode
         * @memberof request.MigrateToStorage
         * @static
         * @param {request.IMigrateToStorage} message MigrateToStorage message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MigrateToStorage.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.storageType != null && Object.hasOwnProperty.call(message, "storageType"))
                $root.request.StorageType.encode(message.storageType, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified MigrateToStorage message, length delimited. Does not implicitly {@link request.MigrateToStorage.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.MigrateToStorage
         * @static
         * @param {request.IMigrateToStorage} message MigrateToStorage message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MigrateToStorage.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MigrateToStorage message from the specified reader or buffer.
         * @function decode
         * @memberof request.MigrateToStorage
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.MigrateToStorage} MigrateToStorage
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MigrateToStorage.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.MigrateToStorage();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.storageType = $root.request.StorageType.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MigrateToStorage message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.MigrateToStorage
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.MigrateToStorage} MigrateToStorage
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MigrateToStorage.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MigrateToStorage message.
         * @function verify
         * @memberof request.MigrateToStorage
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MigrateToStorage.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.storageType != null && message.hasOwnProperty("storageType")) {
                let error = $root.request.StorageType.verify(message.storageType);
                if (error)
                    return "storageType." + error;
            }
            return null;
        };

        /**
         * Creates a MigrateToStorage message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.MigrateToStorage
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.MigrateToStorage} MigrateToStorage
         */
        MigrateToStorage.fromObject = function fromObject(object) {
            if (object instanceof $root.request.MigrateToStorage)
                return object;
            let message = new $root.request.MigrateToStorage();
            if (object.storageType != null) {
                if (typeof object.storageType !== "object")
                    throw TypeError(".request.MigrateToStorage.storageType: object expected");
                message.storageType = $root.request.StorageType.fromObject(object.storageType);
            }
            return message;
        };

        /**
         * Creates a plain object from a MigrateToStorage message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.MigrateToStorage
         * @static
         * @param {request.MigrateToStorage} message MigrateToStorage
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MigrateToStorage.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.storageType = null;
            if (message.storageType != null && message.hasOwnProperty("storageType"))
                object.storageType = $root.request.StorageType.toObject(message.storageType, options);
            return object;
        };

        /**
         * Converts this MigrateToStorage to JSON.
         * @function toJSON
         * @memberof request.MigrateToStorage
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MigrateToStorage.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for MigrateToStorage
         * @function getTypeUrl
         * @memberof request.MigrateToStorage
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        MigrateToStorage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.MigrateToStorage";
        };

        return MigrateToStorage;
    })();

    request.UpdateStorageCreds = (function() {

        /**
         * Properties of an UpdateStorageCreds.
         * @memberof request
         * @interface IUpdateStorageCreds
         * @property {request.IStorageType|null} [storageType] UpdateStorageCreds storageType
         */

        /**
         * Constructs a new UpdateStorageCreds.
         * @memberof request
         * @classdesc Represents an UpdateStorageCreds.
         * @implements IUpdateStorageCreds
         * @constructor
         * @param {request.IUpdateStorageCreds=} [properties] Properties to set
         */
        function UpdateStorageCreds(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateStorageCreds storageType.
         * @member {request.IStorageType|null|undefined} storageType
         * @memberof request.UpdateStorageCreds
         * @instance
         */
        UpdateStorageCreds.prototype.storageType = null;

        /**
         * Creates a new UpdateStorageCreds instance using the specified properties.
         * @function create
         * @memberof request.UpdateStorageCreds
         * @static
         * @param {request.IUpdateStorageCreds=} [properties] Properties to set
         * @returns {request.UpdateStorageCreds} UpdateStorageCreds instance
         */
        UpdateStorageCreds.create = function create(properties) {
            return new UpdateStorageCreds(properties);
        };

        /**
         * Encodes the specified UpdateStorageCreds message. Does not implicitly {@link request.UpdateStorageCreds.verify|verify} messages.
         * @function encode
         * @memberof request.UpdateStorageCreds
         * @static
         * @param {request.IUpdateStorageCreds} message UpdateStorageCreds message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateStorageCreds.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.storageType != null && Object.hasOwnProperty.call(message, "storageType"))
                $root.request.StorageType.encode(message.storageType, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified UpdateStorageCreds message, length delimited. Does not implicitly {@link request.UpdateStorageCreds.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.UpdateStorageCreds
         * @static
         * @param {request.IUpdateStorageCreds} message UpdateStorageCreds message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateStorageCreds.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UpdateStorageCreds message from the specified reader or buffer.
         * @function decode
         * @memberof request.UpdateStorageCreds
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.UpdateStorageCreds} UpdateStorageCreds
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateStorageCreds.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.UpdateStorageCreds();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.storageType = $root.request.StorageType.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UpdateStorageCreds message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.UpdateStorageCreds
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.UpdateStorageCreds} UpdateStorageCreds
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateStorageCreds.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UpdateStorageCreds message.
         * @function verify
         * @memberof request.UpdateStorageCreds
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UpdateStorageCreds.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.storageType != null && message.hasOwnProperty("storageType")) {
                let error = $root.request.StorageType.verify(message.storageType);
                if (error)
                    return "storageType." + error;
            }
            return null;
        };

        /**
         * Creates an UpdateStorageCreds message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.UpdateStorageCreds
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.UpdateStorageCreds} UpdateStorageCreds
         */
        UpdateStorageCreds.fromObject = function fromObject(object) {
            if (object instanceof $root.request.UpdateStorageCreds)
                return object;
            let message = new $root.request.UpdateStorageCreds();
            if (object.storageType != null) {
                if (typeof object.storageType !== "object")
                    throw TypeError(".request.UpdateStorageCreds.storageType: object expected");
                message.storageType = $root.request.StorageType.fromObject(object.storageType);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateStorageCreds message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.UpdateStorageCreds
         * @static
         * @param {request.UpdateStorageCreds} message UpdateStorageCreds
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateStorageCreds.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.storageType = null;
            if (message.storageType != null && message.hasOwnProperty("storageType"))
                object.storageType = $root.request.StorageType.toObject(message.storageType, options);
            return object;
        };

        /**
         * Converts this UpdateStorageCreds to JSON.
         * @function toJSON
         * @memberof request.UpdateStorageCreds
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateStorageCreds.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for UpdateStorageCreds
         * @function getTypeUrl
         * @memberof request.UpdateStorageCreds
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        UpdateStorageCreds.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.UpdateStorageCreds";
        };

        return UpdateStorageCreds;
    })();

    request.GetStorageCreds = (function() {

        /**
         * Properties of a GetStorageCreds.
         * @memberof request
         * @interface IGetStorageCreds
         */

        /**
         * Constructs a new GetStorageCreds.
         * @memberof request
         * @classdesc Represents a GetStorageCreds.
         * @implements IGetStorageCreds
         * @constructor
         * @param {request.IGetStorageCreds=} [properties] Properties to set
         */
        function GetStorageCreds(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new GetStorageCreds instance using the specified properties.
         * @function create
         * @memberof request.GetStorageCreds
         * @static
         * @param {request.IGetStorageCreds=} [properties] Properties to set
         * @returns {request.GetStorageCreds} GetStorageCreds instance
         */
        GetStorageCreds.create = function create(properties) {
            return new GetStorageCreds(properties);
        };

        /**
         * Encodes the specified GetStorageCreds message. Does not implicitly {@link request.GetStorageCreds.verify|verify} messages.
         * @function encode
         * @memberof request.GetStorageCreds
         * @static
         * @param {request.IGetStorageCreds} message GetStorageCreds message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetStorageCreds.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified GetStorageCreds message, length delimited. Does not implicitly {@link request.GetStorageCreds.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.GetStorageCreds
         * @static
         * @param {request.IGetStorageCreds} message GetStorageCreds message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetStorageCreds.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetStorageCreds message from the specified reader or buffer.
         * @function decode
         * @memberof request.GetStorageCreds
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.GetStorageCreds} GetStorageCreds
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetStorageCreds.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.GetStorageCreds();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetStorageCreds message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.GetStorageCreds
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.GetStorageCreds} GetStorageCreds
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetStorageCreds.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetStorageCreds message.
         * @function verify
         * @memberof request.GetStorageCreds
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetStorageCreds.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a GetStorageCreds message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.GetStorageCreds
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.GetStorageCreds} GetStorageCreds
         */
        GetStorageCreds.fromObject = function fromObject(object) {
            if (object instanceof $root.request.GetStorageCreds)
                return object;
            return new $root.request.GetStorageCreds();
        };

        /**
         * Creates a plain object from a GetStorageCreds message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.GetStorageCreds
         * @static
         * @param {request.GetStorageCreds} message GetStorageCreds
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetStorageCreds.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this GetStorageCreds to JSON.
         * @function toJSON
         * @memberof request.GetStorageCreds
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetStorageCreds.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetStorageCreds
         * @function getTypeUrl
         * @memberof request.GetStorageCreds
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetStorageCreds.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.GetStorageCreds";
        };

        return GetStorageCreds;
    })();

    request.VerifyUserForAudit = (function() {

        /**
         * Properties of a VerifyUserForAudit.
         * @memberof request
         * @interface IVerifyUserForAudit
         * @property {string|null} [pin] VerifyUserForAudit pin
         * @property {Uint8Array|null} [data] VerifyUserForAudit data
         * @property {string|null} [operation] VerifyUserForAudit operation
         */

        /**
         * Constructs a new VerifyUserForAudit.
         * @memberof request
         * @classdesc Represents a VerifyUserForAudit.
         * @implements IVerifyUserForAudit
         * @constructor
         * @param {request.IVerifyUserForAudit=} [properties] Properties to set
         */
        function VerifyUserForAudit(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * VerifyUserForAudit pin.
         * @member {string} pin
         * @memberof request.VerifyUserForAudit
         * @instance
         */
        VerifyUserForAudit.prototype.pin = "";

        /**
         * VerifyUserForAudit data.
         * @member {Uint8Array} data
         * @memberof request.VerifyUserForAudit
         * @instance
         */
        VerifyUserForAudit.prototype.data = $util.newBuffer([]);

        /**
         * VerifyUserForAudit operation.
         * @member {string} operation
         * @memberof request.VerifyUserForAudit
         * @instance
         */
        VerifyUserForAudit.prototype.operation = "";

        /**
         * Creates a new VerifyUserForAudit instance using the specified properties.
         * @function create
         * @memberof request.VerifyUserForAudit
         * @static
         * @param {request.IVerifyUserForAudit=} [properties] Properties to set
         * @returns {request.VerifyUserForAudit} VerifyUserForAudit instance
         */
        VerifyUserForAudit.create = function create(properties) {
            return new VerifyUserForAudit(properties);
        };

        /**
         * Encodes the specified VerifyUserForAudit message. Does not implicitly {@link request.VerifyUserForAudit.verify|verify} messages.
         * @function encode
         * @memberof request.VerifyUserForAudit
         * @static
         * @param {request.IVerifyUserForAudit} message VerifyUserForAudit message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        VerifyUserForAudit.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pin != null && Object.hasOwnProperty.call(message, "pin"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.pin);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.data);
            if (message.operation != null && Object.hasOwnProperty.call(message, "operation"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.operation);
            return writer;
        };

        /**
         * Encodes the specified VerifyUserForAudit message, length delimited. Does not implicitly {@link request.VerifyUserForAudit.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.VerifyUserForAudit
         * @static
         * @param {request.IVerifyUserForAudit} message VerifyUserForAudit message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        VerifyUserForAudit.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a VerifyUserForAudit message from the specified reader or buffer.
         * @function decode
         * @memberof request.VerifyUserForAudit
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.VerifyUserForAudit} VerifyUserForAudit
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        VerifyUserForAudit.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.VerifyUserForAudit();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.pin = reader.string();
                        break;
                    }
                case 2: {
                        message.data = reader.bytes();
                        break;
                    }
                case 3: {
                        message.operation = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a VerifyUserForAudit message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.VerifyUserForAudit
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.VerifyUserForAudit} VerifyUserForAudit
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        VerifyUserForAudit.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a VerifyUserForAudit message.
         * @function verify
         * @memberof request.VerifyUserForAudit
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        VerifyUserForAudit.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pin != null && message.hasOwnProperty("pin"))
                if (!$util.isString(message.pin))
                    return "pin: string expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            if (message.operation != null && message.hasOwnProperty("operation"))
                if (!$util.isString(message.operation))
                    return "operation: string expected";
            return null;
        };

        /**
         * Creates a VerifyUserForAudit message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.VerifyUserForAudit
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.VerifyUserForAudit} VerifyUserForAudit
         */
        VerifyUserForAudit.fromObject = function fromObject(object) {
            if (object instanceof $root.request.VerifyUserForAudit)
                return object;
            let message = new $root.request.VerifyUserForAudit();
            if (object.pin != null)
                message.pin = String(object.pin);
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            if (object.operation != null)
                message.operation = String(object.operation);
            return message;
        };

        /**
         * Creates a plain object from a VerifyUserForAudit message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.VerifyUserForAudit
         * @static
         * @param {request.VerifyUserForAudit} message VerifyUserForAudit
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        VerifyUserForAudit.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.pin = "";
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
                object.operation = "";
            }
            if (message.pin != null && message.hasOwnProperty("pin"))
                object.pin = message.pin;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            if (message.operation != null && message.hasOwnProperty("operation"))
                object.operation = message.operation;
            return object;
        };

        /**
         * Converts this VerifyUserForAudit to JSON.
         * @function toJSON
         * @memberof request.VerifyUserForAudit
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        VerifyUserForAudit.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for VerifyUserForAudit
         * @function getTypeUrl
         * @memberof request.VerifyUserForAudit
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        VerifyUserForAudit.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.VerifyUserForAudit";
        };

        return VerifyUserForAudit;
    })();

    request.RemoveOrganizationUser = (function() {

        /**
         * Properties of a RemoveOrganizationUser.
         * @memberof request
         * @interface IRemoveOrganizationUser
         * @property {string|null} [email] RemoveOrganizationUser email
         * @property {string|null} [totp] RemoveOrganizationUser totp
         */

        /**
         * Constructs a new RemoveOrganizationUser.
         * @memberof request
         * @classdesc Represents a RemoveOrganizationUser.
         * @implements IRemoveOrganizationUser
         * @constructor
         * @param {request.IRemoveOrganizationUser=} [properties] Properties to set
         */
        function RemoveOrganizationUser(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveOrganizationUser email.
         * @member {string} email
         * @memberof request.RemoveOrganizationUser
         * @instance
         */
        RemoveOrganizationUser.prototype.email = "";

        /**
         * RemoveOrganizationUser totp.
         * @member {string} totp
         * @memberof request.RemoveOrganizationUser
         * @instance
         */
        RemoveOrganizationUser.prototype.totp = "";

        /**
         * Creates a new RemoveOrganizationUser instance using the specified properties.
         * @function create
         * @memberof request.RemoveOrganizationUser
         * @static
         * @param {request.IRemoveOrganizationUser=} [properties] Properties to set
         * @returns {request.RemoveOrganizationUser} RemoveOrganizationUser instance
         */
        RemoveOrganizationUser.create = function create(properties) {
            return new RemoveOrganizationUser(properties);
        };

        /**
         * Encodes the specified RemoveOrganizationUser message. Does not implicitly {@link request.RemoveOrganizationUser.verify|verify} messages.
         * @function encode
         * @memberof request.RemoveOrganizationUser
         * @static
         * @param {request.IRemoveOrganizationUser} message RemoveOrganizationUser message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RemoveOrganizationUser.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
            if (message.totp != null && Object.hasOwnProperty.call(message, "totp"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.totp);
            return writer;
        };

        /**
         * Encodes the specified RemoveOrganizationUser message, length delimited. Does not implicitly {@link request.RemoveOrganizationUser.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.RemoveOrganizationUser
         * @static
         * @param {request.IRemoveOrganizationUser} message RemoveOrganizationUser message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RemoveOrganizationUser.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RemoveOrganizationUser message from the specified reader or buffer.
         * @function decode
         * @memberof request.RemoveOrganizationUser
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.RemoveOrganizationUser} RemoveOrganizationUser
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RemoveOrganizationUser.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.RemoveOrganizationUser();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.email = reader.string();
                        break;
                    }
                case 2: {
                        message.totp = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RemoveOrganizationUser message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.RemoveOrganizationUser
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.RemoveOrganizationUser} RemoveOrganizationUser
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RemoveOrganizationUser.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RemoveOrganizationUser message.
         * @function verify
         * @memberof request.RemoveOrganizationUser
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RemoveOrganizationUser.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            if (message.totp != null && message.hasOwnProperty("totp"))
                if (!$util.isString(message.totp))
                    return "totp: string expected";
            return null;
        };

        /**
         * Creates a RemoveOrganizationUser message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.RemoveOrganizationUser
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.RemoveOrganizationUser} RemoveOrganizationUser
         */
        RemoveOrganizationUser.fromObject = function fromObject(object) {
            if (object instanceof $root.request.RemoveOrganizationUser)
                return object;
            let message = new $root.request.RemoveOrganizationUser();
            if (object.email != null)
                message.email = String(object.email);
            if (object.totp != null)
                message.totp = String(object.totp);
            return message;
        };

        /**
         * Creates a plain object from a RemoveOrganizationUser message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.RemoveOrganizationUser
         * @static
         * @param {request.RemoveOrganizationUser} message RemoveOrganizationUser
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveOrganizationUser.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.email = "";
                object.totp = "";
            }
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.totp != null && message.hasOwnProperty("totp"))
                object.totp = message.totp;
            return object;
        };

        /**
         * Converts this RemoveOrganizationUser to JSON.
         * @function toJSON
         * @memberof request.RemoveOrganizationUser
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveOrganizationUser.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for RemoveOrganizationUser
         * @function getTypeUrl
         * @memberof request.RemoveOrganizationUser
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        RemoveOrganizationUser.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.RemoveOrganizationUser";
        };

        return RemoveOrganizationUser;
    })();

    request.GetStorageValue = (function() {

        /**
         * Properties of a GetStorageValue.
         * @memberof request
         * @interface IGetStorageValue
         */

        /**
         * Constructs a new GetStorageValue.
         * @memberof request
         * @classdesc Represents a GetStorageValue.
         * @implements IGetStorageValue
         * @constructor
         * @param {request.IGetStorageValue=} [properties] Properties to set
         */
        function GetStorageValue(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new GetStorageValue instance using the specified properties.
         * @function create
         * @memberof request.GetStorageValue
         * @static
         * @param {request.IGetStorageValue=} [properties] Properties to set
         * @returns {request.GetStorageValue} GetStorageValue instance
         */
        GetStorageValue.create = function create(properties) {
            return new GetStorageValue(properties);
        };

        /**
         * Encodes the specified GetStorageValue message. Does not implicitly {@link request.GetStorageValue.verify|verify} messages.
         * @function encode
         * @memberof request.GetStorageValue
         * @static
         * @param {request.IGetStorageValue} message GetStorageValue message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetStorageValue.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified GetStorageValue message, length delimited. Does not implicitly {@link request.GetStorageValue.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.GetStorageValue
         * @static
         * @param {request.IGetStorageValue} message GetStorageValue message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetStorageValue.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetStorageValue message from the specified reader or buffer.
         * @function decode
         * @memberof request.GetStorageValue
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.GetStorageValue} GetStorageValue
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetStorageValue.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.GetStorageValue();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetStorageValue message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.GetStorageValue
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.GetStorageValue} GetStorageValue
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetStorageValue.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetStorageValue message.
         * @function verify
         * @memberof request.GetStorageValue
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetStorageValue.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a GetStorageValue message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.GetStorageValue
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.GetStorageValue} GetStorageValue
         */
        GetStorageValue.fromObject = function fromObject(object) {
            if (object instanceof $root.request.GetStorageValue)
                return object;
            return new $root.request.GetStorageValue();
        };

        /**
         * Creates a plain object from a GetStorageValue message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.GetStorageValue
         * @static
         * @param {request.GetStorageValue} message GetStorageValue
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetStorageValue.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this GetStorageValue to JSON.
         * @function toJSON
         * @memberof request.GetStorageValue
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetStorageValue.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetStorageValue
         * @function getTypeUrl
         * @memberof request.GetStorageValue
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetStorageValue.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.GetStorageValue";
        };

        return GetStorageValue;
    })();

    request.UpdateTags = (function() {

        /**
         * Properties of an UpdateTags.
         * @memberof request
         * @interface IUpdateTags
         * @property {string|null} [parentPath] UpdateTags parentPath
         * @property {string|null} [fileName] UpdateTags fileName
         * @property {Array.<string>|null} [tags] UpdateTags tags
         */

        /**
         * Constructs a new UpdateTags.
         * @memberof request
         * @classdesc Represents an UpdateTags.
         * @implements IUpdateTags
         * @constructor
         * @param {request.IUpdateTags=} [properties] Properties to set
         */
        function UpdateTags(properties) {
            this.tags = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateTags parentPath.
         * @member {string} parentPath
         * @memberof request.UpdateTags
         * @instance
         */
        UpdateTags.prototype.parentPath = "";

        /**
         * UpdateTags fileName.
         * @member {string} fileName
         * @memberof request.UpdateTags
         * @instance
         */
        UpdateTags.prototype.fileName = "";

        /**
         * UpdateTags tags.
         * @member {Array.<string>} tags
         * @memberof request.UpdateTags
         * @instance
         */
        UpdateTags.prototype.tags = $util.emptyArray;

        /**
         * Creates a new UpdateTags instance using the specified properties.
         * @function create
         * @memberof request.UpdateTags
         * @static
         * @param {request.IUpdateTags=} [properties] Properties to set
         * @returns {request.UpdateTags} UpdateTags instance
         */
        UpdateTags.create = function create(properties) {
            return new UpdateTags(properties);
        };

        /**
         * Encodes the specified UpdateTags message. Does not implicitly {@link request.UpdateTags.verify|verify} messages.
         * @function encode
         * @memberof request.UpdateTags
         * @static
         * @param {request.IUpdateTags} message UpdateTags message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateTags.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.parentPath != null && Object.hasOwnProperty.call(message, "parentPath"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.parentPath);
            if (message.fileName != null && Object.hasOwnProperty.call(message, "fileName"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.fileName);
            if (message.tags != null && message.tags.length)
                for (let i = 0; i < message.tags.length; ++i)
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.tags[i]);
            return writer;
        };

        /**
         * Encodes the specified UpdateTags message, length delimited. Does not implicitly {@link request.UpdateTags.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.UpdateTags
         * @static
         * @param {request.IUpdateTags} message UpdateTags message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateTags.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UpdateTags message from the specified reader or buffer.
         * @function decode
         * @memberof request.UpdateTags
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.UpdateTags} UpdateTags
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateTags.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.UpdateTags();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.parentPath = reader.string();
                        break;
                    }
                case 2: {
                        message.fileName = reader.string();
                        break;
                    }
                case 3: {
                        if (!(message.tags && message.tags.length))
                            message.tags = [];
                        message.tags.push(reader.string());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UpdateTags message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.UpdateTags
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.UpdateTags} UpdateTags
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateTags.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UpdateTags message.
         * @function verify
         * @memberof request.UpdateTags
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UpdateTags.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.parentPath != null && message.hasOwnProperty("parentPath"))
                if (!$util.isString(message.parentPath))
                    return "parentPath: string expected";
            if (message.fileName != null && message.hasOwnProperty("fileName"))
                if (!$util.isString(message.fileName))
                    return "fileName: string expected";
            if (message.tags != null && message.hasOwnProperty("tags")) {
                if (!Array.isArray(message.tags))
                    return "tags: array expected";
                for (let i = 0; i < message.tags.length; ++i)
                    if (!$util.isString(message.tags[i]))
                        return "tags: string[] expected";
            }
            return null;
        };

        /**
         * Creates an UpdateTags message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.UpdateTags
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.UpdateTags} UpdateTags
         */
        UpdateTags.fromObject = function fromObject(object) {
            if (object instanceof $root.request.UpdateTags)
                return object;
            let message = new $root.request.UpdateTags();
            if (object.parentPath != null)
                message.parentPath = String(object.parentPath);
            if (object.fileName != null)
                message.fileName = String(object.fileName);
            if (object.tags) {
                if (!Array.isArray(object.tags))
                    throw TypeError(".request.UpdateTags.tags: array expected");
                message.tags = [];
                for (let i = 0; i < object.tags.length; ++i)
                    message.tags[i] = String(object.tags[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateTags message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.UpdateTags
         * @static
         * @param {request.UpdateTags} message UpdateTags
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateTags.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.tags = [];
            if (options.defaults) {
                object.parentPath = "";
                object.fileName = "";
            }
            if (message.parentPath != null && message.hasOwnProperty("parentPath"))
                object.parentPath = message.parentPath;
            if (message.fileName != null && message.hasOwnProperty("fileName"))
                object.fileName = message.fileName;
            if (message.tags && message.tags.length) {
                object.tags = [];
                for (let j = 0; j < message.tags.length; ++j)
                    object.tags[j] = message.tags[j];
            }
            return object;
        };

        /**
         * Converts this UpdateTags to JSON.
         * @function toJSON
         * @memberof request.UpdateTags
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateTags.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for UpdateTags
         * @function getTypeUrl
         * @memberof request.UpdateTags
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        UpdateTags.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.UpdateTags";
        };

        return UpdateTags;
    })();

    request.Reply = (function() {

        /**
         * Properties of a Reply.
         * @memberof request
         * @interface IReply
         * @property {string|null} [email] Reply email
         * @property {string|null} [content] Reply content
         * @property {number|Long|null} [createdTime] Reply createdTime
         * @property {number|Long|null} [modifiedTime] Reply modifiedTime
         */

        /**
         * Constructs a new Reply.
         * @memberof request
         * @classdesc Represents a Reply.
         * @implements IReply
         * @constructor
         * @param {request.IReply=} [properties] Properties to set
         */
        function Reply(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Reply email.
         * @member {string} email
         * @memberof request.Reply
         * @instance
         */
        Reply.prototype.email = "";

        /**
         * Reply content.
         * @member {string} content
         * @memberof request.Reply
         * @instance
         */
        Reply.prototype.content = "";

        /**
         * Reply createdTime.
         * @member {number|Long} createdTime
         * @memberof request.Reply
         * @instance
         */
        Reply.prototype.createdTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Reply modifiedTime.
         * @member {number|Long} modifiedTime
         * @memberof request.Reply
         * @instance
         */
        Reply.prototype.modifiedTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new Reply instance using the specified properties.
         * @function create
         * @memberof request.Reply
         * @static
         * @param {request.IReply=} [properties] Properties to set
         * @returns {request.Reply} Reply instance
         */
        Reply.create = function create(properties) {
            return new Reply(properties);
        };

        /**
         * Encodes the specified Reply message. Does not implicitly {@link request.Reply.verify|verify} messages.
         * @function encode
         * @memberof request.Reply
         * @static
         * @param {request.IReply} message Reply message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Reply.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
            if (message.content != null && Object.hasOwnProperty.call(message, "content"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.content);
            if (message.createdTime != null && Object.hasOwnProperty.call(message, "createdTime"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.createdTime);
            if (message.modifiedTime != null && Object.hasOwnProperty.call(message, "modifiedTime"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.modifiedTime);
            return writer;
        };

        /**
         * Encodes the specified Reply message, length delimited. Does not implicitly {@link request.Reply.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.Reply
         * @static
         * @param {request.IReply} message Reply message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Reply.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Reply message from the specified reader or buffer.
         * @function decode
         * @memberof request.Reply
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.Reply} Reply
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Reply.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.Reply();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.email = reader.string();
                        break;
                    }
                case 2: {
                        message.content = reader.string();
                        break;
                    }
                case 3: {
                        message.createdTime = reader.uint64();
                        break;
                    }
                case 4: {
                        message.modifiedTime = reader.uint64();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Reply message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.Reply
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.Reply} Reply
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Reply.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Reply message.
         * @function verify
         * @memberof request.Reply
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Reply.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            if (message.content != null && message.hasOwnProperty("content"))
                if (!$util.isString(message.content))
                    return "content: string expected";
            if (message.createdTime != null && message.hasOwnProperty("createdTime"))
                if (!$util.isInteger(message.createdTime) && !(message.createdTime && $util.isInteger(message.createdTime.low) && $util.isInteger(message.createdTime.high)))
                    return "createdTime: integer|Long expected";
            if (message.modifiedTime != null && message.hasOwnProperty("modifiedTime"))
                if (!$util.isInteger(message.modifiedTime) && !(message.modifiedTime && $util.isInteger(message.modifiedTime.low) && $util.isInteger(message.modifiedTime.high)))
                    return "modifiedTime: integer|Long expected";
            return null;
        };

        /**
         * Creates a Reply message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.Reply
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.Reply} Reply
         */
        Reply.fromObject = function fromObject(object) {
            if (object instanceof $root.request.Reply)
                return object;
            let message = new $root.request.Reply();
            if (object.email != null)
                message.email = String(object.email);
            if (object.content != null)
                message.content = String(object.content);
            if (object.createdTime != null)
                if ($util.Long)
                    (message.createdTime = $util.Long.fromValue(object.createdTime)).unsigned = true;
                else if (typeof object.createdTime === "string")
                    message.createdTime = parseInt(object.createdTime, 10);
                else if (typeof object.createdTime === "number")
                    message.createdTime = object.createdTime;
                else if (typeof object.createdTime === "object")
                    message.createdTime = new $util.LongBits(object.createdTime.low >>> 0, object.createdTime.high >>> 0).toNumber(true);
            if (object.modifiedTime != null)
                if ($util.Long)
                    (message.modifiedTime = $util.Long.fromValue(object.modifiedTime)).unsigned = true;
                else if (typeof object.modifiedTime === "string")
                    message.modifiedTime = parseInt(object.modifiedTime, 10);
                else if (typeof object.modifiedTime === "number")
                    message.modifiedTime = object.modifiedTime;
                else if (typeof object.modifiedTime === "object")
                    message.modifiedTime = new $util.LongBits(object.modifiedTime.low >>> 0, object.modifiedTime.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a Reply message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.Reply
         * @static
         * @param {request.Reply} message Reply
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Reply.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.email = "";
                object.content = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.createdTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.createdTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.modifiedTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.modifiedTime = options.longs === String ? "0" : 0;
            }
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.content != null && message.hasOwnProperty("content"))
                object.content = message.content;
            if (message.createdTime != null && message.hasOwnProperty("createdTime"))
                if (typeof message.createdTime === "number")
                    object.createdTime = options.longs === String ? String(message.createdTime) : message.createdTime;
                else
                    object.createdTime = options.longs === String ? $util.Long.prototype.toString.call(message.createdTime) : options.longs === Number ? new $util.LongBits(message.createdTime.low >>> 0, message.createdTime.high >>> 0).toNumber(true) : message.createdTime;
            if (message.modifiedTime != null && message.hasOwnProperty("modifiedTime"))
                if (typeof message.modifiedTime === "number")
                    object.modifiedTime = options.longs === String ? String(message.modifiedTime) : message.modifiedTime;
                else
                    object.modifiedTime = options.longs === String ? $util.Long.prototype.toString.call(message.modifiedTime) : options.longs === Number ? new $util.LongBits(message.modifiedTime.low >>> 0, message.modifiedTime.high >>> 0).toNumber(true) : message.modifiedTime;
            return object;
        };

        /**
         * Converts this Reply to JSON.
         * @function toJSON
         * @memberof request.Reply
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Reply.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Reply
         * @function getTypeUrl
         * @memberof request.Reply
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Reply.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.Reply";
        };

        return Reply;
    })();

    request.Comment = (function() {

        /**
         * Properties of a Comment.
         * @memberof request
         * @interface IComment
         * @property {string|null} [email] Comment email
         * @property {string|null} [content] Comment content
         * @property {number|Long|null} [createdTime] Comment createdTime
         * @property {number|Long|null} [modifiedTime] Comment modifiedTime
         * @property {Array.<string>|null} [mentionedEmails] Comment mentionedEmails
         * @property {Array.<request.IReply>|null} [replies] Comment replies
         */

        /**
         * Constructs a new Comment.
         * @memberof request
         * @classdesc Represents a Comment.
         * @implements IComment
         * @constructor
         * @param {request.IComment=} [properties] Properties to set
         */
        function Comment(properties) {
            this.mentionedEmails = [];
            this.replies = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Comment email.
         * @member {string} email
         * @memberof request.Comment
         * @instance
         */
        Comment.prototype.email = "";

        /**
         * Comment content.
         * @member {string} content
         * @memberof request.Comment
         * @instance
         */
        Comment.prototype.content = "";

        /**
         * Comment createdTime.
         * @member {number|Long} createdTime
         * @memberof request.Comment
         * @instance
         */
        Comment.prototype.createdTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Comment modifiedTime.
         * @member {number|Long} modifiedTime
         * @memberof request.Comment
         * @instance
         */
        Comment.prototype.modifiedTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Comment mentionedEmails.
         * @member {Array.<string>} mentionedEmails
         * @memberof request.Comment
         * @instance
         */
        Comment.prototype.mentionedEmails = $util.emptyArray;

        /**
         * Comment replies.
         * @member {Array.<request.IReply>} replies
         * @memberof request.Comment
         * @instance
         */
        Comment.prototype.replies = $util.emptyArray;

        /**
         * Creates a new Comment instance using the specified properties.
         * @function create
         * @memberof request.Comment
         * @static
         * @param {request.IComment=} [properties] Properties to set
         * @returns {request.Comment} Comment instance
         */
        Comment.create = function create(properties) {
            return new Comment(properties);
        };

        /**
         * Encodes the specified Comment message. Does not implicitly {@link request.Comment.verify|verify} messages.
         * @function encode
         * @memberof request.Comment
         * @static
         * @param {request.IComment} message Comment message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Comment.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
            if (message.content != null && Object.hasOwnProperty.call(message, "content"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.content);
            if (message.createdTime != null && Object.hasOwnProperty.call(message, "createdTime"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.createdTime);
            if (message.modifiedTime != null && Object.hasOwnProperty.call(message, "modifiedTime"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.modifiedTime);
            if (message.mentionedEmails != null && message.mentionedEmails.length)
                for (let i = 0; i < message.mentionedEmails.length; ++i)
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.mentionedEmails[i]);
            if (message.replies != null && message.replies.length)
                for (let i = 0; i < message.replies.length; ++i)
                    $root.request.Reply.encode(message.replies[i], writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified Comment message, length delimited. Does not implicitly {@link request.Comment.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.Comment
         * @static
         * @param {request.IComment} message Comment message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Comment.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Comment message from the specified reader or buffer.
         * @function decode
         * @memberof request.Comment
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.Comment} Comment
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Comment.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.Comment();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.email = reader.string();
                        break;
                    }
                case 2: {
                        message.content = reader.string();
                        break;
                    }
                case 3: {
                        message.createdTime = reader.uint64();
                        break;
                    }
                case 4: {
                        message.modifiedTime = reader.uint64();
                        break;
                    }
                case 5: {
                        if (!(message.mentionedEmails && message.mentionedEmails.length))
                            message.mentionedEmails = [];
                        message.mentionedEmails.push(reader.string());
                        break;
                    }
                case 6: {
                        if (!(message.replies && message.replies.length))
                            message.replies = [];
                        message.replies.push($root.request.Reply.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Comment message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.Comment
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.Comment} Comment
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Comment.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Comment message.
         * @function verify
         * @memberof request.Comment
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Comment.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            if (message.content != null && message.hasOwnProperty("content"))
                if (!$util.isString(message.content))
                    return "content: string expected";
            if (message.createdTime != null && message.hasOwnProperty("createdTime"))
                if (!$util.isInteger(message.createdTime) && !(message.createdTime && $util.isInteger(message.createdTime.low) && $util.isInteger(message.createdTime.high)))
                    return "createdTime: integer|Long expected";
            if (message.modifiedTime != null && message.hasOwnProperty("modifiedTime"))
                if (!$util.isInteger(message.modifiedTime) && !(message.modifiedTime && $util.isInteger(message.modifiedTime.low) && $util.isInteger(message.modifiedTime.high)))
                    return "modifiedTime: integer|Long expected";
            if (message.mentionedEmails != null && message.hasOwnProperty("mentionedEmails")) {
                if (!Array.isArray(message.mentionedEmails))
                    return "mentionedEmails: array expected";
                for (let i = 0; i < message.mentionedEmails.length; ++i)
                    if (!$util.isString(message.mentionedEmails[i]))
                        return "mentionedEmails: string[] expected";
            }
            if (message.replies != null && message.hasOwnProperty("replies")) {
                if (!Array.isArray(message.replies))
                    return "replies: array expected";
                for (let i = 0; i < message.replies.length; ++i) {
                    let error = $root.request.Reply.verify(message.replies[i]);
                    if (error)
                        return "replies." + error;
                }
            }
            return null;
        };

        /**
         * Creates a Comment message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.Comment
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.Comment} Comment
         */
        Comment.fromObject = function fromObject(object) {
            if (object instanceof $root.request.Comment)
                return object;
            let message = new $root.request.Comment();
            if (object.email != null)
                message.email = String(object.email);
            if (object.content != null)
                message.content = String(object.content);
            if (object.createdTime != null)
                if ($util.Long)
                    (message.createdTime = $util.Long.fromValue(object.createdTime)).unsigned = true;
                else if (typeof object.createdTime === "string")
                    message.createdTime = parseInt(object.createdTime, 10);
                else if (typeof object.createdTime === "number")
                    message.createdTime = object.createdTime;
                else if (typeof object.createdTime === "object")
                    message.createdTime = new $util.LongBits(object.createdTime.low >>> 0, object.createdTime.high >>> 0).toNumber(true);
            if (object.modifiedTime != null)
                if ($util.Long)
                    (message.modifiedTime = $util.Long.fromValue(object.modifiedTime)).unsigned = true;
                else if (typeof object.modifiedTime === "string")
                    message.modifiedTime = parseInt(object.modifiedTime, 10);
                else if (typeof object.modifiedTime === "number")
                    message.modifiedTime = object.modifiedTime;
                else if (typeof object.modifiedTime === "object")
                    message.modifiedTime = new $util.LongBits(object.modifiedTime.low >>> 0, object.modifiedTime.high >>> 0).toNumber(true);
            if (object.mentionedEmails) {
                if (!Array.isArray(object.mentionedEmails))
                    throw TypeError(".request.Comment.mentionedEmails: array expected");
                message.mentionedEmails = [];
                for (let i = 0; i < object.mentionedEmails.length; ++i)
                    message.mentionedEmails[i] = String(object.mentionedEmails[i]);
            }
            if (object.replies) {
                if (!Array.isArray(object.replies))
                    throw TypeError(".request.Comment.replies: array expected");
                message.replies = [];
                for (let i = 0; i < object.replies.length; ++i) {
                    if (typeof object.replies[i] !== "object")
                        throw TypeError(".request.Comment.replies: object expected");
                    message.replies[i] = $root.request.Reply.fromObject(object.replies[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a Comment message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.Comment
         * @static
         * @param {request.Comment} message Comment
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Comment.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.mentionedEmails = [];
                object.replies = [];
            }
            if (options.defaults) {
                object.email = "";
                object.content = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.createdTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.createdTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.modifiedTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.modifiedTime = options.longs === String ? "0" : 0;
            }
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.content != null && message.hasOwnProperty("content"))
                object.content = message.content;
            if (message.createdTime != null && message.hasOwnProperty("createdTime"))
                if (typeof message.createdTime === "number")
                    object.createdTime = options.longs === String ? String(message.createdTime) : message.createdTime;
                else
                    object.createdTime = options.longs === String ? $util.Long.prototype.toString.call(message.createdTime) : options.longs === Number ? new $util.LongBits(message.createdTime.low >>> 0, message.createdTime.high >>> 0).toNumber(true) : message.createdTime;
            if (message.modifiedTime != null && message.hasOwnProperty("modifiedTime"))
                if (typeof message.modifiedTime === "number")
                    object.modifiedTime = options.longs === String ? String(message.modifiedTime) : message.modifiedTime;
                else
                    object.modifiedTime = options.longs === String ? $util.Long.prototype.toString.call(message.modifiedTime) : options.longs === Number ? new $util.LongBits(message.modifiedTime.low >>> 0, message.modifiedTime.high >>> 0).toNumber(true) : message.modifiedTime;
            if (message.mentionedEmails && message.mentionedEmails.length) {
                object.mentionedEmails = [];
                for (let j = 0; j < message.mentionedEmails.length; ++j)
                    object.mentionedEmails[j] = message.mentionedEmails[j];
            }
            if (message.replies && message.replies.length) {
                object.replies = [];
                for (let j = 0; j < message.replies.length; ++j)
                    object.replies[j] = $root.request.Reply.toObject(message.replies[j], options);
            }
            return object;
        };

        /**
         * Converts this Comment to JSON.
         * @function toJSON
         * @memberof request.Comment
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Comment.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Comment
         * @function getTypeUrl
         * @memberof request.Comment
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Comment.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.Comment";
        };

        return Comment;
    })();

    request.AddComment = (function() {

        /**
         * Properties of an AddComment.
         * @memberof request
         * @interface IAddComment
         * @property {string|null} [parentPath] AddComment parentPath
         * @property {string|null} [fileName] AddComment fileName
         * @property {string|null} [location] AddComment location
         * @property {request.IComment|null} [comment] AddComment comment
         */

        /**
         * Constructs a new AddComment.
         * @memberof request
         * @classdesc Represents an AddComment.
         * @implements IAddComment
         * @constructor
         * @param {request.IAddComment=} [properties] Properties to set
         */
        function AddComment(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddComment parentPath.
         * @member {string} parentPath
         * @memberof request.AddComment
         * @instance
         */
        AddComment.prototype.parentPath = "";

        /**
         * AddComment fileName.
         * @member {string} fileName
         * @memberof request.AddComment
         * @instance
         */
        AddComment.prototype.fileName = "";

        /**
         * AddComment location.
         * @member {string} location
         * @memberof request.AddComment
         * @instance
         */
        AddComment.prototype.location = "";

        /**
         * AddComment comment.
         * @member {request.IComment|null|undefined} comment
         * @memberof request.AddComment
         * @instance
         */
        AddComment.prototype.comment = null;

        /**
         * Creates a new AddComment instance using the specified properties.
         * @function create
         * @memberof request.AddComment
         * @static
         * @param {request.IAddComment=} [properties] Properties to set
         * @returns {request.AddComment} AddComment instance
         */
        AddComment.create = function create(properties) {
            return new AddComment(properties);
        };

        /**
         * Encodes the specified AddComment message. Does not implicitly {@link request.AddComment.verify|verify} messages.
         * @function encode
         * @memberof request.AddComment
         * @static
         * @param {request.IAddComment} message AddComment message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddComment.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.parentPath != null && Object.hasOwnProperty.call(message, "parentPath"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.parentPath);
            if (message.fileName != null && Object.hasOwnProperty.call(message, "fileName"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.fileName);
            if (message.location != null && Object.hasOwnProperty.call(message, "location"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.location);
            if (message.comment != null && Object.hasOwnProperty.call(message, "comment"))
                $root.request.Comment.encode(message.comment, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified AddComment message, length delimited. Does not implicitly {@link request.AddComment.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.AddComment
         * @static
         * @param {request.IAddComment} message AddComment message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddComment.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AddComment message from the specified reader or buffer.
         * @function decode
         * @memberof request.AddComment
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.AddComment} AddComment
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddComment.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.AddComment();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.parentPath = reader.string();
                        break;
                    }
                case 2: {
                        message.fileName = reader.string();
                        break;
                    }
                case 3: {
                        message.location = reader.string();
                        break;
                    }
                case 4: {
                        message.comment = $root.request.Comment.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AddComment message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.AddComment
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.AddComment} AddComment
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddComment.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AddComment message.
         * @function verify
         * @memberof request.AddComment
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AddComment.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.parentPath != null && message.hasOwnProperty("parentPath"))
                if (!$util.isString(message.parentPath))
                    return "parentPath: string expected";
            if (message.fileName != null && message.hasOwnProperty("fileName"))
                if (!$util.isString(message.fileName))
                    return "fileName: string expected";
            if (message.location != null && message.hasOwnProperty("location"))
                if (!$util.isString(message.location))
                    return "location: string expected";
            if (message.comment != null && message.hasOwnProperty("comment")) {
                let error = $root.request.Comment.verify(message.comment);
                if (error)
                    return "comment." + error;
            }
            return null;
        };

        /**
         * Creates an AddComment message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.AddComment
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.AddComment} AddComment
         */
        AddComment.fromObject = function fromObject(object) {
            if (object instanceof $root.request.AddComment)
                return object;
            let message = new $root.request.AddComment();
            if (object.parentPath != null)
                message.parentPath = String(object.parentPath);
            if (object.fileName != null)
                message.fileName = String(object.fileName);
            if (object.location != null)
                message.location = String(object.location);
            if (object.comment != null) {
                if (typeof object.comment !== "object")
                    throw TypeError(".request.AddComment.comment: object expected");
                message.comment = $root.request.Comment.fromObject(object.comment);
            }
            return message;
        };

        /**
         * Creates a plain object from an AddComment message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.AddComment
         * @static
         * @param {request.AddComment} message AddComment
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddComment.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.parentPath = "";
                object.fileName = "";
                object.location = "";
                object.comment = null;
            }
            if (message.parentPath != null && message.hasOwnProperty("parentPath"))
                object.parentPath = message.parentPath;
            if (message.fileName != null && message.hasOwnProperty("fileName"))
                object.fileName = message.fileName;
            if (message.location != null && message.hasOwnProperty("location"))
                object.location = message.location;
            if (message.comment != null && message.hasOwnProperty("comment"))
                object.comment = $root.request.Comment.toObject(message.comment, options);
            return object;
        };

        /**
         * Converts this AddComment to JSON.
         * @function toJSON
         * @memberof request.AddComment
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddComment.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for AddComment
         * @function getTypeUrl
         * @memberof request.AddComment
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        AddComment.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.AddComment";
        };

        return AddComment;
    })();

    request.RemoveComment = (function() {

        /**
         * Properties of a RemoveComment.
         * @memberof request
         * @interface IRemoveComment
         * @property {string|null} [parentPath] RemoveComment parentPath
         * @property {string|null} [fileName] RemoveComment fileName
         * @property {Uint8Array|null} [commentId] RemoveComment commentId
         */

        /**
         * Constructs a new RemoveComment.
         * @memberof request
         * @classdesc Represents a RemoveComment.
         * @implements IRemoveComment
         * @constructor
         * @param {request.IRemoveComment=} [properties] Properties to set
         */
        function RemoveComment(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveComment parentPath.
         * @member {string} parentPath
         * @memberof request.RemoveComment
         * @instance
         */
        RemoveComment.prototype.parentPath = "";

        /**
         * RemoveComment fileName.
         * @member {string} fileName
         * @memberof request.RemoveComment
         * @instance
         */
        RemoveComment.prototype.fileName = "";

        /**
         * RemoveComment commentId.
         * @member {Uint8Array} commentId
         * @memberof request.RemoveComment
         * @instance
         */
        RemoveComment.prototype.commentId = $util.newBuffer([]);

        /**
         * Creates a new RemoveComment instance using the specified properties.
         * @function create
         * @memberof request.RemoveComment
         * @static
         * @param {request.IRemoveComment=} [properties] Properties to set
         * @returns {request.RemoveComment} RemoveComment instance
         */
        RemoveComment.create = function create(properties) {
            return new RemoveComment(properties);
        };

        /**
         * Encodes the specified RemoveComment message. Does not implicitly {@link request.RemoveComment.verify|verify} messages.
         * @function encode
         * @memberof request.RemoveComment
         * @static
         * @param {request.IRemoveComment} message RemoveComment message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RemoveComment.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.parentPath != null && Object.hasOwnProperty.call(message, "parentPath"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.parentPath);
            if (message.fileName != null && Object.hasOwnProperty.call(message, "fileName"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.fileName);
            if (message.commentId != null && Object.hasOwnProperty.call(message, "commentId"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.commentId);
            return writer;
        };

        /**
         * Encodes the specified RemoveComment message, length delimited. Does not implicitly {@link request.RemoveComment.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.RemoveComment
         * @static
         * @param {request.IRemoveComment} message RemoveComment message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RemoveComment.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RemoveComment message from the specified reader or buffer.
         * @function decode
         * @memberof request.RemoveComment
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.RemoveComment} RemoveComment
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RemoveComment.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.RemoveComment();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.parentPath = reader.string();
                        break;
                    }
                case 2: {
                        message.fileName = reader.string();
                        break;
                    }
                case 3: {
                        message.commentId = reader.bytes();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RemoveComment message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.RemoveComment
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.RemoveComment} RemoveComment
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RemoveComment.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RemoveComment message.
         * @function verify
         * @memberof request.RemoveComment
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RemoveComment.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.parentPath != null && message.hasOwnProperty("parentPath"))
                if (!$util.isString(message.parentPath))
                    return "parentPath: string expected";
            if (message.fileName != null && message.hasOwnProperty("fileName"))
                if (!$util.isString(message.fileName))
                    return "fileName: string expected";
            if (message.commentId != null && message.hasOwnProperty("commentId"))
                if (!(message.commentId && typeof message.commentId.length === "number" || $util.isString(message.commentId)))
                    return "commentId: buffer expected";
            return null;
        };

        /**
         * Creates a RemoveComment message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.RemoveComment
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.RemoveComment} RemoveComment
         */
        RemoveComment.fromObject = function fromObject(object) {
            if (object instanceof $root.request.RemoveComment)
                return object;
            let message = new $root.request.RemoveComment();
            if (object.parentPath != null)
                message.parentPath = String(object.parentPath);
            if (object.fileName != null)
                message.fileName = String(object.fileName);
            if (object.commentId != null)
                if (typeof object.commentId === "string")
                    $util.base64.decode(object.commentId, message.commentId = $util.newBuffer($util.base64.length(object.commentId)), 0);
                else if (object.commentId.length >= 0)
                    message.commentId = object.commentId;
            return message;
        };

        /**
         * Creates a plain object from a RemoveComment message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.RemoveComment
         * @static
         * @param {request.RemoveComment} message RemoveComment
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveComment.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.parentPath = "";
                object.fileName = "";
                if (options.bytes === String)
                    object.commentId = "";
                else {
                    object.commentId = [];
                    if (options.bytes !== Array)
                        object.commentId = $util.newBuffer(object.commentId);
                }
            }
            if (message.parentPath != null && message.hasOwnProperty("parentPath"))
                object.parentPath = message.parentPath;
            if (message.fileName != null && message.hasOwnProperty("fileName"))
                object.fileName = message.fileName;
            if (message.commentId != null && message.hasOwnProperty("commentId"))
                object.commentId = options.bytes === String ? $util.base64.encode(message.commentId, 0, message.commentId.length) : options.bytes === Array ? Array.prototype.slice.call(message.commentId) : message.commentId;
            return object;
        };

        /**
         * Converts this RemoveComment to JSON.
         * @function toJSON
         * @memberof request.RemoveComment
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveComment.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for RemoveComment
         * @function getTypeUrl
         * @memberof request.RemoveComment
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        RemoveComment.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.RemoveComment";
        };

        return RemoveComment;
    })();

    /**
     * UpdateType enum.
     * @name request.UpdateType
     * @enum {number}
     * @property {number} UpdateText=0 UpdateText value
     * @property {number} UpdateReplyText=1 UpdateReplyText value
     * @property {number} UpdateStatus=2 UpdateStatus value
     * @property {number} AddReply=3 AddReply value
     * @property {number} DeleteReply=4 DeleteReply value
     * @property {number} UpdateLocation=5 UpdateLocation value
     */
    request.UpdateType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UpdateText"] = 0;
        values[valuesById[1] = "UpdateReplyText"] = 1;
        values[valuesById[2] = "UpdateStatus"] = 2;
        values[valuesById[3] = "AddReply"] = 3;
        values[valuesById[4] = "DeleteReply"] = 4;
        values[valuesById[5] = "UpdateLocation"] = 5;
        return values;
    })();

    request.UpdateComment = (function() {

        /**
         * Properties of an UpdateComment.
         * @memberof request
         * @interface IUpdateComment
         * @property {string|null} [parentPath] UpdateComment parentPath
         * @property {string|null} [fileName] UpdateComment fileName
         * @property {Uint8Array|null} [commentId] UpdateComment commentId
         * @property {request.IComment|null} [comment] UpdateComment comment
         * @property {string|null} [location] UpdateComment location
         * @property {string|null} [state] UpdateComment state
         * @property {request.UpdateType|null} [updateType] UpdateComment updateType
         * @property {number|Long|null} [replyIndex] UpdateComment replyIndex
         * @property {boolean|null} [isResolved] UpdateComment isResolved
         * @property {boolean|null} [reOpen] UpdateComment reOpen
         */

        /**
         * Constructs a new UpdateComment.
         * @memberof request
         * @classdesc Represents an UpdateComment.
         * @implements IUpdateComment
         * @constructor
         * @param {request.IUpdateComment=} [properties] Properties to set
         */
        function UpdateComment(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateComment parentPath.
         * @member {string} parentPath
         * @memberof request.UpdateComment
         * @instance
         */
        UpdateComment.prototype.parentPath = "";

        /**
         * UpdateComment fileName.
         * @member {string} fileName
         * @memberof request.UpdateComment
         * @instance
         */
        UpdateComment.prototype.fileName = "";

        /**
         * UpdateComment commentId.
         * @member {Uint8Array} commentId
         * @memberof request.UpdateComment
         * @instance
         */
        UpdateComment.prototype.commentId = $util.newBuffer([]);

        /**
         * UpdateComment comment.
         * @member {request.IComment|null|undefined} comment
         * @memberof request.UpdateComment
         * @instance
         */
        UpdateComment.prototype.comment = null;

        /**
         * UpdateComment location.
         * @member {string} location
         * @memberof request.UpdateComment
         * @instance
         */
        UpdateComment.prototype.location = "";

        /**
         * UpdateComment state.
         * @member {string} state
         * @memberof request.UpdateComment
         * @instance
         */
        UpdateComment.prototype.state = "";

        /**
         * UpdateComment updateType.
         * @member {request.UpdateType} updateType
         * @memberof request.UpdateComment
         * @instance
         */
        UpdateComment.prototype.updateType = 0;

        /**
         * UpdateComment replyIndex.
         * @member {number|Long|null|undefined} replyIndex
         * @memberof request.UpdateComment
         * @instance
         */
        UpdateComment.prototype.replyIndex = null;

        /**
         * UpdateComment isResolved.
         * @member {boolean|null|undefined} isResolved
         * @memberof request.UpdateComment
         * @instance
         */
        UpdateComment.prototype.isResolved = null;

        /**
         * UpdateComment reOpen.
         * @member {boolean|null|undefined} reOpen
         * @memberof request.UpdateComment
         * @instance
         */
        UpdateComment.prototype.reOpen = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(UpdateComment.prototype, "_replyIndex", {
            get: $util.oneOfGetter($oneOfFields = ["replyIndex"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(UpdateComment.prototype, "_isResolved", {
            get: $util.oneOfGetter($oneOfFields = ["isResolved"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(UpdateComment.prototype, "_reOpen", {
            get: $util.oneOfGetter($oneOfFields = ["reOpen"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new UpdateComment instance using the specified properties.
         * @function create
         * @memberof request.UpdateComment
         * @static
         * @param {request.IUpdateComment=} [properties] Properties to set
         * @returns {request.UpdateComment} UpdateComment instance
         */
        UpdateComment.create = function create(properties) {
            return new UpdateComment(properties);
        };

        /**
         * Encodes the specified UpdateComment message. Does not implicitly {@link request.UpdateComment.verify|verify} messages.
         * @function encode
         * @memberof request.UpdateComment
         * @static
         * @param {request.IUpdateComment} message UpdateComment message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateComment.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.parentPath != null && Object.hasOwnProperty.call(message, "parentPath"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.parentPath);
            if (message.fileName != null && Object.hasOwnProperty.call(message, "fileName"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.fileName);
            if (message.commentId != null && Object.hasOwnProperty.call(message, "commentId"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.commentId);
            if (message.comment != null && Object.hasOwnProperty.call(message, "comment"))
                $root.request.Comment.encode(message.comment, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            if (message.location != null && Object.hasOwnProperty.call(message, "location"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.location);
            if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.state);
            if (message.updateType != null && Object.hasOwnProperty.call(message, "updateType"))
                writer.uint32(/* id 7, wireType 0 =*/56).int32(message.updateType);
            if (message.replyIndex != null && Object.hasOwnProperty.call(message, "replyIndex"))
                writer.uint32(/* id 8, wireType 0 =*/64).uint64(message.replyIndex);
            if (message.isResolved != null && Object.hasOwnProperty.call(message, "isResolved"))
                writer.uint32(/* id 9, wireType 0 =*/72).bool(message.isResolved);
            if (message.reOpen != null && Object.hasOwnProperty.call(message, "reOpen"))
                writer.uint32(/* id 10, wireType 0 =*/80).bool(message.reOpen);
            return writer;
        };

        /**
         * Encodes the specified UpdateComment message, length delimited. Does not implicitly {@link request.UpdateComment.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.UpdateComment
         * @static
         * @param {request.IUpdateComment} message UpdateComment message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateComment.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UpdateComment message from the specified reader or buffer.
         * @function decode
         * @memberof request.UpdateComment
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.UpdateComment} UpdateComment
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateComment.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.UpdateComment();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.parentPath = reader.string();
                        break;
                    }
                case 2: {
                        message.fileName = reader.string();
                        break;
                    }
                case 3: {
                        message.commentId = reader.bytes();
                        break;
                    }
                case 4: {
                        message.comment = $root.request.Comment.decode(reader, reader.uint32());
                        break;
                    }
                case 5: {
                        message.location = reader.string();
                        break;
                    }
                case 6: {
                        message.state = reader.string();
                        break;
                    }
                case 7: {
                        message.updateType = reader.int32();
                        break;
                    }
                case 8: {
                        message.replyIndex = reader.uint64();
                        break;
                    }
                case 9: {
                        message.isResolved = reader.bool();
                        break;
                    }
                case 10: {
                        message.reOpen = reader.bool();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UpdateComment message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.UpdateComment
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.UpdateComment} UpdateComment
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateComment.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UpdateComment message.
         * @function verify
         * @memberof request.UpdateComment
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UpdateComment.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.parentPath != null && message.hasOwnProperty("parentPath"))
                if (!$util.isString(message.parentPath))
                    return "parentPath: string expected";
            if (message.fileName != null && message.hasOwnProperty("fileName"))
                if (!$util.isString(message.fileName))
                    return "fileName: string expected";
            if (message.commentId != null && message.hasOwnProperty("commentId"))
                if (!(message.commentId && typeof message.commentId.length === "number" || $util.isString(message.commentId)))
                    return "commentId: buffer expected";
            if (message.comment != null && message.hasOwnProperty("comment")) {
                let error = $root.request.Comment.verify(message.comment);
                if (error)
                    return "comment." + error;
            }
            if (message.location != null && message.hasOwnProperty("location"))
                if (!$util.isString(message.location))
                    return "location: string expected";
            if (message.state != null && message.hasOwnProperty("state"))
                if (!$util.isString(message.state))
                    return "state: string expected";
            if (message.updateType != null && message.hasOwnProperty("updateType"))
                switch (message.updateType) {
                default:
                    return "updateType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            if (message.replyIndex != null && message.hasOwnProperty("replyIndex")) {
                properties._replyIndex = 1;
                if (!$util.isInteger(message.replyIndex) && !(message.replyIndex && $util.isInteger(message.replyIndex.low) && $util.isInteger(message.replyIndex.high)))
                    return "replyIndex: integer|Long expected";
            }
            if (message.isResolved != null && message.hasOwnProperty("isResolved")) {
                properties._isResolved = 1;
                if (typeof message.isResolved !== "boolean")
                    return "isResolved: boolean expected";
            }
            if (message.reOpen != null && message.hasOwnProperty("reOpen")) {
                properties._reOpen = 1;
                if (typeof message.reOpen !== "boolean")
                    return "reOpen: boolean expected";
            }
            return null;
        };

        /**
         * Creates an UpdateComment message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.UpdateComment
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.UpdateComment} UpdateComment
         */
        UpdateComment.fromObject = function fromObject(object) {
            if (object instanceof $root.request.UpdateComment)
                return object;
            let message = new $root.request.UpdateComment();
            if (object.parentPath != null)
                message.parentPath = String(object.parentPath);
            if (object.fileName != null)
                message.fileName = String(object.fileName);
            if (object.commentId != null)
                if (typeof object.commentId === "string")
                    $util.base64.decode(object.commentId, message.commentId = $util.newBuffer($util.base64.length(object.commentId)), 0);
                else if (object.commentId.length >= 0)
                    message.commentId = object.commentId;
            if (object.comment != null) {
                if (typeof object.comment !== "object")
                    throw TypeError(".request.UpdateComment.comment: object expected");
                message.comment = $root.request.Comment.fromObject(object.comment);
            }
            if (object.location != null)
                message.location = String(object.location);
            if (object.state != null)
                message.state = String(object.state);
            switch (object.updateType) {
            default:
                if (typeof object.updateType === "number") {
                    message.updateType = object.updateType;
                    break;
                }
                break;
            case "UpdateText":
            case 0:
                message.updateType = 0;
                break;
            case "UpdateReplyText":
            case 1:
                message.updateType = 1;
                break;
            case "UpdateStatus":
            case 2:
                message.updateType = 2;
                break;
            case "AddReply":
            case 3:
                message.updateType = 3;
                break;
            case "DeleteReply":
            case 4:
                message.updateType = 4;
                break;
            case "UpdateLocation":
            case 5:
                message.updateType = 5;
                break;
            }
            if (object.replyIndex != null)
                if ($util.Long)
                    (message.replyIndex = $util.Long.fromValue(object.replyIndex)).unsigned = true;
                else if (typeof object.replyIndex === "string")
                    message.replyIndex = parseInt(object.replyIndex, 10);
                else if (typeof object.replyIndex === "number")
                    message.replyIndex = object.replyIndex;
                else if (typeof object.replyIndex === "object")
                    message.replyIndex = new $util.LongBits(object.replyIndex.low >>> 0, object.replyIndex.high >>> 0).toNumber(true);
            if (object.isResolved != null)
                message.isResolved = Boolean(object.isResolved);
            if (object.reOpen != null)
                message.reOpen = Boolean(object.reOpen);
            return message;
        };

        /**
         * Creates a plain object from an UpdateComment message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.UpdateComment
         * @static
         * @param {request.UpdateComment} message UpdateComment
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateComment.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.parentPath = "";
                object.fileName = "";
                if (options.bytes === String)
                    object.commentId = "";
                else {
                    object.commentId = [];
                    if (options.bytes !== Array)
                        object.commentId = $util.newBuffer(object.commentId);
                }
                object.comment = null;
                object.location = "";
                object.state = "";
                object.updateType = options.enums === String ? "UpdateText" : 0;
            }
            if (message.parentPath != null && message.hasOwnProperty("parentPath"))
                object.parentPath = message.parentPath;
            if (message.fileName != null && message.hasOwnProperty("fileName"))
                object.fileName = message.fileName;
            if (message.commentId != null && message.hasOwnProperty("commentId"))
                object.commentId = options.bytes === String ? $util.base64.encode(message.commentId, 0, message.commentId.length) : options.bytes === Array ? Array.prototype.slice.call(message.commentId) : message.commentId;
            if (message.comment != null && message.hasOwnProperty("comment"))
                object.comment = $root.request.Comment.toObject(message.comment, options);
            if (message.location != null && message.hasOwnProperty("location"))
                object.location = message.location;
            if (message.state != null && message.hasOwnProperty("state"))
                object.state = message.state;
            if (message.updateType != null && message.hasOwnProperty("updateType"))
                object.updateType = options.enums === String ? $root.request.UpdateType[message.updateType] === undefined ? message.updateType : $root.request.UpdateType[message.updateType] : message.updateType;
            if (message.replyIndex != null && message.hasOwnProperty("replyIndex")) {
                if (typeof message.replyIndex === "number")
                    object.replyIndex = options.longs === String ? String(message.replyIndex) : message.replyIndex;
                else
                    object.replyIndex = options.longs === String ? $util.Long.prototype.toString.call(message.replyIndex) : options.longs === Number ? new $util.LongBits(message.replyIndex.low >>> 0, message.replyIndex.high >>> 0).toNumber(true) : message.replyIndex;
                if (options.oneofs)
                    object._replyIndex = "replyIndex";
            }
            if (message.isResolved != null && message.hasOwnProperty("isResolved")) {
                object.isResolved = message.isResolved;
                if (options.oneofs)
                    object._isResolved = "isResolved";
            }
            if (message.reOpen != null && message.hasOwnProperty("reOpen")) {
                object.reOpen = message.reOpen;
                if (options.oneofs)
                    object._reOpen = "reOpen";
            }
            return object;
        };

        /**
         * Converts this UpdateComment to JSON.
         * @function toJSON
         * @memberof request.UpdateComment
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateComment.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for UpdateComment
         * @function getTypeUrl
         * @memberof request.UpdateComment
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        UpdateComment.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.UpdateComment";
        };

        return UpdateComment;
    })();

    request.ListComments = (function() {

        /**
         * Properties of a ListComments.
         * @memberof request
         * @interface IListComments
         * @property {string|null} [parentPath] ListComments parentPath
         * @property {string|null} [fileName] ListComments fileName
         * @property {number|Long|null} [currentTime] ListComments currentTime
         * @property {number|Long|null} [currentItems] ListComments currentItems
         */

        /**
         * Constructs a new ListComments.
         * @memberof request
         * @classdesc Represents a ListComments.
         * @implements IListComments
         * @constructor
         * @param {request.IListComments=} [properties] Properties to set
         */
        function ListComments(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListComments parentPath.
         * @member {string} parentPath
         * @memberof request.ListComments
         * @instance
         */
        ListComments.prototype.parentPath = "";

        /**
         * ListComments fileName.
         * @member {string} fileName
         * @memberof request.ListComments
         * @instance
         */
        ListComments.prototype.fileName = "";

        /**
         * ListComments currentTime.
         * @member {number|Long} currentTime
         * @memberof request.ListComments
         * @instance
         */
        ListComments.prototype.currentTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * ListComments currentItems.
         * @member {number|Long} currentItems
         * @memberof request.ListComments
         * @instance
         */
        ListComments.prototype.currentItems = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new ListComments instance using the specified properties.
         * @function create
         * @memberof request.ListComments
         * @static
         * @param {request.IListComments=} [properties] Properties to set
         * @returns {request.ListComments} ListComments instance
         */
        ListComments.create = function create(properties) {
            return new ListComments(properties);
        };

        /**
         * Encodes the specified ListComments message. Does not implicitly {@link request.ListComments.verify|verify} messages.
         * @function encode
         * @memberof request.ListComments
         * @static
         * @param {request.IListComments} message ListComments message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListComments.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.parentPath != null && Object.hasOwnProperty.call(message, "parentPath"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.parentPath);
            if (message.fileName != null && Object.hasOwnProperty.call(message, "fileName"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.fileName);
            if (message.currentTime != null && Object.hasOwnProperty.call(message, "currentTime"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.currentTime);
            if (message.currentItems != null && Object.hasOwnProperty.call(message, "currentItems"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.currentItems);
            return writer;
        };

        /**
         * Encodes the specified ListComments message, length delimited. Does not implicitly {@link request.ListComments.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.ListComments
         * @static
         * @param {request.IListComments} message ListComments message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListComments.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ListComments message from the specified reader or buffer.
         * @function decode
         * @memberof request.ListComments
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.ListComments} ListComments
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListComments.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.ListComments();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.parentPath = reader.string();
                        break;
                    }
                case 2: {
                        message.fileName = reader.string();
                        break;
                    }
                case 3: {
                        message.currentTime = reader.uint64();
                        break;
                    }
                case 4: {
                        message.currentItems = reader.uint64();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ListComments message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.ListComments
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.ListComments} ListComments
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListComments.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ListComments message.
         * @function verify
         * @memberof request.ListComments
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ListComments.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.parentPath != null && message.hasOwnProperty("parentPath"))
                if (!$util.isString(message.parentPath))
                    return "parentPath: string expected";
            if (message.fileName != null && message.hasOwnProperty("fileName"))
                if (!$util.isString(message.fileName))
                    return "fileName: string expected";
            if (message.currentTime != null && message.hasOwnProperty("currentTime"))
                if (!$util.isInteger(message.currentTime) && !(message.currentTime && $util.isInteger(message.currentTime.low) && $util.isInteger(message.currentTime.high)))
                    return "currentTime: integer|Long expected";
            if (message.currentItems != null && message.hasOwnProperty("currentItems"))
                if (!$util.isInteger(message.currentItems) && !(message.currentItems && $util.isInteger(message.currentItems.low) && $util.isInteger(message.currentItems.high)))
                    return "currentItems: integer|Long expected";
            return null;
        };

        /**
         * Creates a ListComments message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.ListComments
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.ListComments} ListComments
         */
        ListComments.fromObject = function fromObject(object) {
            if (object instanceof $root.request.ListComments)
                return object;
            let message = new $root.request.ListComments();
            if (object.parentPath != null)
                message.parentPath = String(object.parentPath);
            if (object.fileName != null)
                message.fileName = String(object.fileName);
            if (object.currentTime != null)
                if ($util.Long)
                    (message.currentTime = $util.Long.fromValue(object.currentTime)).unsigned = true;
                else if (typeof object.currentTime === "string")
                    message.currentTime = parseInt(object.currentTime, 10);
                else if (typeof object.currentTime === "number")
                    message.currentTime = object.currentTime;
                else if (typeof object.currentTime === "object")
                    message.currentTime = new $util.LongBits(object.currentTime.low >>> 0, object.currentTime.high >>> 0).toNumber(true);
            if (object.currentItems != null)
                if ($util.Long)
                    (message.currentItems = $util.Long.fromValue(object.currentItems)).unsigned = true;
                else if (typeof object.currentItems === "string")
                    message.currentItems = parseInt(object.currentItems, 10);
                else if (typeof object.currentItems === "number")
                    message.currentItems = object.currentItems;
                else if (typeof object.currentItems === "object")
                    message.currentItems = new $util.LongBits(object.currentItems.low >>> 0, object.currentItems.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a ListComments message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.ListComments
         * @static
         * @param {request.ListComments} message ListComments
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListComments.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.parentPath = "";
                object.fileName = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.currentTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.currentTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.currentItems = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.currentItems = options.longs === String ? "0" : 0;
            }
            if (message.parentPath != null && message.hasOwnProperty("parentPath"))
                object.parentPath = message.parentPath;
            if (message.fileName != null && message.hasOwnProperty("fileName"))
                object.fileName = message.fileName;
            if (message.currentTime != null && message.hasOwnProperty("currentTime"))
                if (typeof message.currentTime === "number")
                    object.currentTime = options.longs === String ? String(message.currentTime) : message.currentTime;
                else
                    object.currentTime = options.longs === String ? $util.Long.prototype.toString.call(message.currentTime) : options.longs === Number ? new $util.LongBits(message.currentTime.low >>> 0, message.currentTime.high >>> 0).toNumber(true) : message.currentTime;
            if (message.currentItems != null && message.hasOwnProperty("currentItems"))
                if (typeof message.currentItems === "number")
                    object.currentItems = options.longs === String ? String(message.currentItems) : message.currentItems;
                else
                    object.currentItems = options.longs === String ? $util.Long.prototype.toString.call(message.currentItems) : options.longs === Number ? new $util.LongBits(message.currentItems.low >>> 0, message.currentItems.high >>> 0).toNumber(true) : message.currentItems;
            return object;
        };

        /**
         * Converts this ListComments to JSON.
         * @function toJSON
         * @memberof request.ListComments
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListComments.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ListComments
         * @function getTypeUrl
         * @memberof request.ListComments
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ListComments.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.ListComments";
        };

        return ListComments;
    })();

    request.GetComment = (function() {

        /**
         * Properties of a GetComment.
         * @memberof request
         * @interface IGetComment
         * @property {string|null} [parentPath] GetComment parentPath
         * @property {string|null} [fileName] GetComment fileName
         * @property {Uint8Array|null} [commentId] GetComment commentId
         */

        /**
         * Constructs a new GetComment.
         * @memberof request
         * @classdesc Represents a GetComment.
         * @implements IGetComment
         * @constructor
         * @param {request.IGetComment=} [properties] Properties to set
         */
        function GetComment(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetComment parentPath.
         * @member {string} parentPath
         * @memberof request.GetComment
         * @instance
         */
        GetComment.prototype.parentPath = "";

        /**
         * GetComment fileName.
         * @member {string} fileName
         * @memberof request.GetComment
         * @instance
         */
        GetComment.prototype.fileName = "";

        /**
         * GetComment commentId.
         * @member {Uint8Array} commentId
         * @memberof request.GetComment
         * @instance
         */
        GetComment.prototype.commentId = $util.newBuffer([]);

        /**
         * Creates a new GetComment instance using the specified properties.
         * @function create
         * @memberof request.GetComment
         * @static
         * @param {request.IGetComment=} [properties] Properties to set
         * @returns {request.GetComment} GetComment instance
         */
        GetComment.create = function create(properties) {
            return new GetComment(properties);
        };

        /**
         * Encodes the specified GetComment message. Does not implicitly {@link request.GetComment.verify|verify} messages.
         * @function encode
         * @memberof request.GetComment
         * @static
         * @param {request.IGetComment} message GetComment message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetComment.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.parentPath != null && Object.hasOwnProperty.call(message, "parentPath"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.parentPath);
            if (message.fileName != null && Object.hasOwnProperty.call(message, "fileName"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.fileName);
            if (message.commentId != null && Object.hasOwnProperty.call(message, "commentId"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.commentId);
            return writer;
        };

        /**
         * Encodes the specified GetComment message, length delimited. Does not implicitly {@link request.GetComment.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.GetComment
         * @static
         * @param {request.IGetComment} message GetComment message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetComment.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetComment message from the specified reader or buffer.
         * @function decode
         * @memberof request.GetComment
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.GetComment} GetComment
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetComment.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.GetComment();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.parentPath = reader.string();
                        break;
                    }
                case 2: {
                        message.fileName = reader.string();
                        break;
                    }
                case 3: {
                        message.commentId = reader.bytes();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetComment message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.GetComment
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.GetComment} GetComment
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetComment.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetComment message.
         * @function verify
         * @memberof request.GetComment
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetComment.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.parentPath != null && message.hasOwnProperty("parentPath"))
                if (!$util.isString(message.parentPath))
                    return "parentPath: string expected";
            if (message.fileName != null && message.hasOwnProperty("fileName"))
                if (!$util.isString(message.fileName))
                    return "fileName: string expected";
            if (message.commentId != null && message.hasOwnProperty("commentId"))
                if (!(message.commentId && typeof message.commentId.length === "number" || $util.isString(message.commentId)))
                    return "commentId: buffer expected";
            return null;
        };

        /**
         * Creates a GetComment message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.GetComment
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.GetComment} GetComment
         */
        GetComment.fromObject = function fromObject(object) {
            if (object instanceof $root.request.GetComment)
                return object;
            let message = new $root.request.GetComment();
            if (object.parentPath != null)
                message.parentPath = String(object.parentPath);
            if (object.fileName != null)
                message.fileName = String(object.fileName);
            if (object.commentId != null)
                if (typeof object.commentId === "string")
                    $util.base64.decode(object.commentId, message.commentId = $util.newBuffer($util.base64.length(object.commentId)), 0);
                else if (object.commentId.length >= 0)
                    message.commentId = object.commentId;
            return message;
        };

        /**
         * Creates a plain object from a GetComment message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.GetComment
         * @static
         * @param {request.GetComment} message GetComment
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetComment.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.parentPath = "";
                object.fileName = "";
                if (options.bytes === String)
                    object.commentId = "";
                else {
                    object.commentId = [];
                    if (options.bytes !== Array)
                        object.commentId = $util.newBuffer(object.commentId);
                }
            }
            if (message.parentPath != null && message.hasOwnProperty("parentPath"))
                object.parentPath = message.parentPath;
            if (message.fileName != null && message.hasOwnProperty("fileName"))
                object.fileName = message.fileName;
            if (message.commentId != null && message.hasOwnProperty("commentId"))
                object.commentId = options.bytes === String ? $util.base64.encode(message.commentId, 0, message.commentId.length) : options.bytes === Array ? Array.prototype.slice.call(message.commentId) : message.commentId;
            return object;
        };

        /**
         * Converts this GetComment to JSON.
         * @function toJSON
         * @memberof request.GetComment
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetComment.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetComment
         * @function getTypeUrl
         * @memberof request.GetComment
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetComment.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.GetComment";
        };

        return GetComment;
    })();

    request.SessionData = (function() {

        /**
         * Properties of a SessionData.
         * @memberof request
         * @interface ISessionData
         * @property {Uint8Array|null} [data] SessionData data
         * @property {number|Long|null} [timestamp] SessionData timestamp
         */

        /**
         * Constructs a new SessionData.
         * @memberof request
         * @classdesc Represents a SessionData.
         * @implements ISessionData
         * @constructor
         * @param {request.ISessionData=} [properties] Properties to set
         */
        function SessionData(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SessionData data.
         * @member {Uint8Array} data
         * @memberof request.SessionData
         * @instance
         */
        SessionData.prototype.data = $util.newBuffer([]);

        /**
         * SessionData timestamp.
         * @member {number|Long} timestamp
         * @memberof request.SessionData
         * @instance
         */
        SessionData.prototype.timestamp = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new SessionData instance using the specified properties.
         * @function create
         * @memberof request.SessionData
         * @static
         * @param {request.ISessionData=} [properties] Properties to set
         * @returns {request.SessionData} SessionData instance
         */
        SessionData.create = function create(properties) {
            return new SessionData(properties);
        };

        /**
         * Encodes the specified SessionData message. Does not implicitly {@link request.SessionData.verify|verify} messages.
         * @function encode
         * @memberof request.SessionData
         * @static
         * @param {request.ISessionData} message SessionData message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SessionData.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.data);
            if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.timestamp);
            return writer;
        };

        /**
         * Encodes the specified SessionData message, length delimited. Does not implicitly {@link request.SessionData.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.SessionData
         * @static
         * @param {request.ISessionData} message SessionData message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SessionData.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SessionData message from the specified reader or buffer.
         * @function decode
         * @memberof request.SessionData
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.SessionData} SessionData
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SessionData.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.SessionData();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.data = reader.bytes();
                        break;
                    }
                case 2: {
                        message.timestamp = reader.uint64();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SessionData message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.SessionData
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.SessionData} SessionData
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SessionData.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SessionData message.
         * @function verify
         * @memberof request.SessionData
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SessionData.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                if (!$util.isInteger(message.timestamp) && !(message.timestamp && $util.isInteger(message.timestamp.low) && $util.isInteger(message.timestamp.high)))
                    return "timestamp: integer|Long expected";
            return null;
        };

        /**
         * Creates a SessionData message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.SessionData
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.SessionData} SessionData
         */
        SessionData.fromObject = function fromObject(object) {
            if (object instanceof $root.request.SessionData)
                return object;
            let message = new $root.request.SessionData();
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            if (object.timestamp != null)
                if ($util.Long)
                    (message.timestamp = $util.Long.fromValue(object.timestamp)).unsigned = true;
                else if (typeof object.timestamp === "string")
                    message.timestamp = parseInt(object.timestamp, 10);
                else if (typeof object.timestamp === "number")
                    message.timestamp = object.timestamp;
                else if (typeof object.timestamp === "object")
                    message.timestamp = new $util.LongBits(object.timestamp.low >>> 0, object.timestamp.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a SessionData message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.SessionData
         * @static
         * @param {request.SessionData} message SessionData
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SessionData.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.timestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.timestamp = options.longs === String ? "0" : 0;
            }
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                if (typeof message.timestamp === "number")
                    object.timestamp = options.longs === String ? String(message.timestamp) : message.timestamp;
                else
                    object.timestamp = options.longs === String ? $util.Long.prototype.toString.call(message.timestamp) : options.longs === Number ? new $util.LongBits(message.timestamp.low >>> 0, message.timestamp.high >>> 0).toNumber(true) : message.timestamp;
            return object;
        };

        /**
         * Converts this SessionData to JSON.
         * @function toJSON
         * @memberof request.SessionData
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SessionData.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for SessionData
         * @function getTypeUrl
         * @memberof request.SessionData
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        SessionData.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.SessionData";
        };

        return SessionData;
    })();

    request.GetPlan = (function() {

        /**
         * Properties of a GetPlan.
         * @memberof request
         * @interface IGetPlan
         * @property {number|null} [planId] GetPlan planId
         */

        /**
         * Constructs a new GetPlan.
         * @memberof request
         * @classdesc Represents a GetPlan.
         * @implements IGetPlan
         * @constructor
         * @param {request.IGetPlan=} [properties] Properties to set
         */
        function GetPlan(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetPlan planId.
         * @member {number} planId
         * @memberof request.GetPlan
         * @instance
         */
        GetPlan.prototype.planId = 0;

        /**
         * Creates a new GetPlan instance using the specified properties.
         * @function create
         * @memberof request.GetPlan
         * @static
         * @param {request.IGetPlan=} [properties] Properties to set
         * @returns {request.GetPlan} GetPlan instance
         */
        GetPlan.create = function create(properties) {
            return new GetPlan(properties);
        };

        /**
         * Encodes the specified GetPlan message. Does not implicitly {@link request.GetPlan.verify|verify} messages.
         * @function encode
         * @memberof request.GetPlan
         * @static
         * @param {request.IGetPlan} message GetPlan message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetPlan.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.planId != null && Object.hasOwnProperty.call(message, "planId"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.planId);
            return writer;
        };

        /**
         * Encodes the specified GetPlan message, length delimited. Does not implicitly {@link request.GetPlan.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.GetPlan
         * @static
         * @param {request.IGetPlan} message GetPlan message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetPlan.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetPlan message from the specified reader or buffer.
         * @function decode
         * @memberof request.GetPlan
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.GetPlan} GetPlan
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetPlan.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.GetPlan();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.planId = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetPlan message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.GetPlan
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.GetPlan} GetPlan
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetPlan.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetPlan message.
         * @function verify
         * @memberof request.GetPlan
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetPlan.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.planId != null && message.hasOwnProperty("planId"))
                if (!$util.isInteger(message.planId))
                    return "planId: integer expected";
            return null;
        };

        /**
         * Creates a GetPlan message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.GetPlan
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.GetPlan} GetPlan
         */
        GetPlan.fromObject = function fromObject(object) {
            if (object instanceof $root.request.GetPlan)
                return object;
            let message = new $root.request.GetPlan();
            if (object.planId != null)
                message.planId = object.planId | 0;
            return message;
        };

        /**
         * Creates a plain object from a GetPlan message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.GetPlan
         * @static
         * @param {request.GetPlan} message GetPlan
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetPlan.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.planId = 0;
            if (message.planId != null && message.hasOwnProperty("planId"))
                object.planId = message.planId;
            return object;
        };

        /**
         * Converts this GetPlan to JSON.
         * @function toJSON
         * @memberof request.GetPlan
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetPlan.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetPlan
         * @function getTypeUrl
         * @memberof request.GetPlan
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetPlan.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.GetPlan";
        };

        return GetPlan;
    })();

    request.ListPlans = (function() {

        /**
         * Properties of a ListPlans.
         * @memberof request
         * @interface IListPlans
         * @property {string|null} [customer] ListPlans customer
         */

        /**
         * Constructs a new ListPlans.
         * @memberof request
         * @classdesc Represents a ListPlans.
         * @implements IListPlans
         * @constructor
         * @param {request.IListPlans=} [properties] Properties to set
         */
        function ListPlans(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListPlans customer.
         * @member {string} customer
         * @memberof request.ListPlans
         * @instance
         */
        ListPlans.prototype.customer = "";

        /**
         * Creates a new ListPlans instance using the specified properties.
         * @function create
         * @memberof request.ListPlans
         * @static
         * @param {request.IListPlans=} [properties] Properties to set
         * @returns {request.ListPlans} ListPlans instance
         */
        ListPlans.create = function create(properties) {
            return new ListPlans(properties);
        };

        /**
         * Encodes the specified ListPlans message. Does not implicitly {@link request.ListPlans.verify|verify} messages.
         * @function encode
         * @memberof request.ListPlans
         * @static
         * @param {request.IListPlans} message ListPlans message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListPlans.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.customer != null && Object.hasOwnProperty.call(message, "customer"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.customer);
            return writer;
        };

        /**
         * Encodes the specified ListPlans message, length delimited. Does not implicitly {@link request.ListPlans.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.ListPlans
         * @static
         * @param {request.IListPlans} message ListPlans message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListPlans.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ListPlans message from the specified reader or buffer.
         * @function decode
         * @memberof request.ListPlans
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.ListPlans} ListPlans
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListPlans.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.ListPlans();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.customer = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ListPlans message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.ListPlans
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.ListPlans} ListPlans
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListPlans.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ListPlans message.
         * @function verify
         * @memberof request.ListPlans
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ListPlans.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.customer != null && message.hasOwnProperty("customer"))
                if (!$util.isString(message.customer))
                    return "customer: string expected";
            return null;
        };

        /**
         * Creates a ListPlans message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.ListPlans
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.ListPlans} ListPlans
         */
        ListPlans.fromObject = function fromObject(object) {
            if (object instanceof $root.request.ListPlans)
                return object;
            let message = new $root.request.ListPlans();
            if (object.customer != null)
                message.customer = String(object.customer);
            return message;
        };

        /**
         * Creates a plain object from a ListPlans message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.ListPlans
         * @static
         * @param {request.ListPlans} message ListPlans
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListPlans.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.customer = "";
            if (message.customer != null && message.hasOwnProperty("customer"))
                object.customer = message.customer;
            return object;
        };

        /**
         * Converts this ListPlans to JSON.
         * @function toJSON
         * @memberof request.ListPlans
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListPlans.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ListPlans
         * @function getTypeUrl
         * @memberof request.ListPlans
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ListPlans.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.ListPlans";
        };

        return ListPlans;
    })();

    request.UpgradePlan = (function() {

        /**
         * Properties of an UpgradePlan.
         * @memberof request
         * @interface IUpgradePlan
         * @property {string|null} [email] UpgradePlan email
         */

        /**
         * Constructs a new UpgradePlan.
         * @memberof request
         * @classdesc Represents an UpgradePlan.
         * @implements IUpgradePlan
         * @constructor
         * @param {request.IUpgradePlan=} [properties] Properties to set
         */
        function UpgradePlan(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpgradePlan email.
         * @member {string} email
         * @memberof request.UpgradePlan
         * @instance
         */
        UpgradePlan.prototype.email = "";

        /**
         * Creates a new UpgradePlan instance using the specified properties.
         * @function create
         * @memberof request.UpgradePlan
         * @static
         * @param {request.IUpgradePlan=} [properties] Properties to set
         * @returns {request.UpgradePlan} UpgradePlan instance
         */
        UpgradePlan.create = function create(properties) {
            return new UpgradePlan(properties);
        };

        /**
         * Encodes the specified UpgradePlan message. Does not implicitly {@link request.UpgradePlan.verify|verify} messages.
         * @function encode
         * @memberof request.UpgradePlan
         * @static
         * @param {request.IUpgradePlan} message UpgradePlan message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpgradePlan.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
            return writer;
        };

        /**
         * Encodes the specified UpgradePlan message, length delimited. Does not implicitly {@link request.UpgradePlan.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.UpgradePlan
         * @static
         * @param {request.IUpgradePlan} message UpgradePlan message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpgradePlan.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UpgradePlan message from the specified reader or buffer.
         * @function decode
         * @memberof request.UpgradePlan
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.UpgradePlan} UpgradePlan
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpgradePlan.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.UpgradePlan();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.email = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UpgradePlan message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.UpgradePlan
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.UpgradePlan} UpgradePlan
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpgradePlan.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UpgradePlan message.
         * @function verify
         * @memberof request.UpgradePlan
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UpgradePlan.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            return null;
        };

        /**
         * Creates an UpgradePlan message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.UpgradePlan
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.UpgradePlan} UpgradePlan
         */
        UpgradePlan.fromObject = function fromObject(object) {
            if (object instanceof $root.request.UpgradePlan)
                return object;
            let message = new $root.request.UpgradePlan();
            if (object.email != null)
                message.email = String(object.email);
            return message;
        };

        /**
         * Creates a plain object from an UpgradePlan message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.UpgradePlan
         * @static
         * @param {request.UpgradePlan} message UpgradePlan
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpgradePlan.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.email = "";
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            return object;
        };

        /**
         * Converts this UpgradePlan to JSON.
         * @function toJSON
         * @memberof request.UpgradePlan
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpgradePlan.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for UpgradePlan
         * @function getTypeUrl
         * @memberof request.UpgradePlan
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        UpgradePlan.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.UpgradePlan";
        };

        return UpgradePlan;
    })();

    request.ValidateCoupon = (function() {

        /**
         * Properties of a ValidateCoupon.
         * @memberof request
         * @interface IValidateCoupon
         * @property {string|null} [email] ValidateCoupon email
         * @property {string|null} [coupon] ValidateCoupon coupon
         * @property {boolean|null} [isYearly] ValidateCoupon isYearly
         */

        /**
         * Constructs a new ValidateCoupon.
         * @memberof request
         * @classdesc Represents a ValidateCoupon.
         * @implements IValidateCoupon
         * @constructor
         * @param {request.IValidateCoupon=} [properties] Properties to set
         */
        function ValidateCoupon(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ValidateCoupon email.
         * @member {string} email
         * @memberof request.ValidateCoupon
         * @instance
         */
        ValidateCoupon.prototype.email = "";

        /**
         * ValidateCoupon coupon.
         * @member {string} coupon
         * @memberof request.ValidateCoupon
         * @instance
         */
        ValidateCoupon.prototype.coupon = "";

        /**
         * ValidateCoupon isYearly.
         * @member {boolean} isYearly
         * @memberof request.ValidateCoupon
         * @instance
         */
        ValidateCoupon.prototype.isYearly = false;

        /**
         * Creates a new ValidateCoupon instance using the specified properties.
         * @function create
         * @memberof request.ValidateCoupon
         * @static
         * @param {request.IValidateCoupon=} [properties] Properties to set
         * @returns {request.ValidateCoupon} ValidateCoupon instance
         */
        ValidateCoupon.create = function create(properties) {
            return new ValidateCoupon(properties);
        };

        /**
         * Encodes the specified ValidateCoupon message. Does not implicitly {@link request.ValidateCoupon.verify|verify} messages.
         * @function encode
         * @memberof request.ValidateCoupon
         * @static
         * @param {request.IValidateCoupon} message ValidateCoupon message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ValidateCoupon.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
            if (message.coupon != null && Object.hasOwnProperty.call(message, "coupon"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.coupon);
            if (message.isYearly != null && Object.hasOwnProperty.call(message, "isYearly"))
                writer.uint32(/* id 3, wireType 0 =*/24).bool(message.isYearly);
            return writer;
        };

        /**
         * Encodes the specified ValidateCoupon message, length delimited. Does not implicitly {@link request.ValidateCoupon.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.ValidateCoupon
         * @static
         * @param {request.IValidateCoupon} message ValidateCoupon message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ValidateCoupon.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ValidateCoupon message from the specified reader or buffer.
         * @function decode
         * @memberof request.ValidateCoupon
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.ValidateCoupon} ValidateCoupon
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ValidateCoupon.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.ValidateCoupon();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.email = reader.string();
                        break;
                    }
                case 2: {
                        message.coupon = reader.string();
                        break;
                    }
                case 3: {
                        message.isYearly = reader.bool();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ValidateCoupon message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.ValidateCoupon
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.ValidateCoupon} ValidateCoupon
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ValidateCoupon.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ValidateCoupon message.
         * @function verify
         * @memberof request.ValidateCoupon
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ValidateCoupon.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            if (message.coupon != null && message.hasOwnProperty("coupon"))
                if (!$util.isString(message.coupon))
                    return "coupon: string expected";
            if (message.isYearly != null && message.hasOwnProperty("isYearly"))
                if (typeof message.isYearly !== "boolean")
                    return "isYearly: boolean expected";
            return null;
        };

        /**
         * Creates a ValidateCoupon message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.ValidateCoupon
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.ValidateCoupon} ValidateCoupon
         */
        ValidateCoupon.fromObject = function fromObject(object) {
            if (object instanceof $root.request.ValidateCoupon)
                return object;
            let message = new $root.request.ValidateCoupon();
            if (object.email != null)
                message.email = String(object.email);
            if (object.coupon != null)
                message.coupon = String(object.coupon);
            if (object.isYearly != null)
                message.isYearly = Boolean(object.isYearly);
            return message;
        };

        /**
         * Creates a plain object from a ValidateCoupon message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.ValidateCoupon
         * @static
         * @param {request.ValidateCoupon} message ValidateCoupon
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ValidateCoupon.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.email = "";
                object.coupon = "";
                object.isYearly = false;
            }
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.coupon != null && message.hasOwnProperty("coupon"))
                object.coupon = message.coupon;
            if (message.isYearly != null && message.hasOwnProperty("isYearly"))
                object.isYearly = message.isYearly;
            return object;
        };

        /**
         * Converts this ValidateCoupon to JSON.
         * @function toJSON
         * @memberof request.ValidateCoupon
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ValidateCoupon.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ValidateCoupon
         * @function getTypeUrl
         * @memberof request.ValidateCoupon
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ValidateCoupon.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.ValidateCoupon";
        };

        return ValidateCoupon;
    })();

    request.RemoveVersion = (function() {

        /**
         * Properties of a RemoveVersion.
         * @memberof request
         * @interface IRemoveVersion
         * @property {string|null} [parentPath] RemoveVersion parentPath
         * @property {string|null} [fileName] RemoveVersion fileName
         * @property {Uint8Array|null} [versionUuid] RemoveVersion versionUuid
         */

        /**
         * Constructs a new RemoveVersion.
         * @memberof request
         * @classdesc Represents a RemoveVersion.
         * @implements IRemoveVersion
         * @constructor
         * @param {request.IRemoveVersion=} [properties] Properties to set
         */
        function RemoveVersion(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveVersion parentPath.
         * @member {string} parentPath
         * @memberof request.RemoveVersion
         * @instance
         */
        RemoveVersion.prototype.parentPath = "";

        /**
         * RemoveVersion fileName.
         * @member {string} fileName
         * @memberof request.RemoveVersion
         * @instance
         */
        RemoveVersion.prototype.fileName = "";

        /**
         * RemoveVersion versionUuid.
         * @member {Uint8Array} versionUuid
         * @memberof request.RemoveVersion
         * @instance
         */
        RemoveVersion.prototype.versionUuid = $util.newBuffer([]);

        /**
         * Creates a new RemoveVersion instance using the specified properties.
         * @function create
         * @memberof request.RemoveVersion
         * @static
         * @param {request.IRemoveVersion=} [properties] Properties to set
         * @returns {request.RemoveVersion} RemoveVersion instance
         */
        RemoveVersion.create = function create(properties) {
            return new RemoveVersion(properties);
        };

        /**
         * Encodes the specified RemoveVersion message. Does not implicitly {@link request.RemoveVersion.verify|verify} messages.
         * @function encode
         * @memberof request.RemoveVersion
         * @static
         * @param {request.IRemoveVersion} message RemoveVersion message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RemoveVersion.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.parentPath != null && Object.hasOwnProperty.call(message, "parentPath"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.parentPath);
            if (message.fileName != null && Object.hasOwnProperty.call(message, "fileName"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.fileName);
            if (message.versionUuid != null && Object.hasOwnProperty.call(message, "versionUuid"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.versionUuid);
            return writer;
        };

        /**
         * Encodes the specified RemoveVersion message, length delimited. Does not implicitly {@link request.RemoveVersion.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.RemoveVersion
         * @static
         * @param {request.IRemoveVersion} message RemoveVersion message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RemoveVersion.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RemoveVersion message from the specified reader or buffer.
         * @function decode
         * @memberof request.RemoveVersion
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.RemoveVersion} RemoveVersion
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RemoveVersion.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.RemoveVersion();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.parentPath = reader.string();
                        break;
                    }
                case 2: {
                        message.fileName = reader.string();
                        break;
                    }
                case 3: {
                        message.versionUuid = reader.bytes();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RemoveVersion message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.RemoveVersion
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.RemoveVersion} RemoveVersion
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RemoveVersion.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RemoveVersion message.
         * @function verify
         * @memberof request.RemoveVersion
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RemoveVersion.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.parentPath != null && message.hasOwnProperty("parentPath"))
                if (!$util.isString(message.parentPath))
                    return "parentPath: string expected";
            if (message.fileName != null && message.hasOwnProperty("fileName"))
                if (!$util.isString(message.fileName))
                    return "fileName: string expected";
            if (message.versionUuid != null && message.hasOwnProperty("versionUuid"))
                if (!(message.versionUuid && typeof message.versionUuid.length === "number" || $util.isString(message.versionUuid)))
                    return "versionUuid: buffer expected";
            return null;
        };

        /**
         * Creates a RemoveVersion message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.RemoveVersion
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.RemoveVersion} RemoveVersion
         */
        RemoveVersion.fromObject = function fromObject(object) {
            if (object instanceof $root.request.RemoveVersion)
                return object;
            let message = new $root.request.RemoveVersion();
            if (object.parentPath != null)
                message.parentPath = String(object.parentPath);
            if (object.fileName != null)
                message.fileName = String(object.fileName);
            if (object.versionUuid != null)
                if (typeof object.versionUuid === "string")
                    $util.base64.decode(object.versionUuid, message.versionUuid = $util.newBuffer($util.base64.length(object.versionUuid)), 0);
                else if (object.versionUuid.length >= 0)
                    message.versionUuid = object.versionUuid;
            return message;
        };

        /**
         * Creates a plain object from a RemoveVersion message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.RemoveVersion
         * @static
         * @param {request.RemoveVersion} message RemoveVersion
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveVersion.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.parentPath = "";
                object.fileName = "";
                if (options.bytes === String)
                    object.versionUuid = "";
                else {
                    object.versionUuid = [];
                    if (options.bytes !== Array)
                        object.versionUuid = $util.newBuffer(object.versionUuid);
                }
            }
            if (message.parentPath != null && message.hasOwnProperty("parentPath"))
                object.parentPath = message.parentPath;
            if (message.fileName != null && message.hasOwnProperty("fileName"))
                object.fileName = message.fileName;
            if (message.versionUuid != null && message.hasOwnProperty("versionUuid"))
                object.versionUuid = options.bytes === String ? $util.base64.encode(message.versionUuid, 0, message.versionUuid.length) : options.bytes === Array ? Array.prototype.slice.call(message.versionUuid) : message.versionUuid;
            return object;
        };

        /**
         * Converts this RemoveVersion to JSON.
         * @function toJSON
         * @memberof request.RemoveVersion
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveVersion.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for RemoveVersion
         * @function getTypeUrl
         * @memberof request.RemoveVersion
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        RemoveVersion.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.RemoveVersion";
        };

        return RemoveVersion;
    })();

    request.GetProfilePictureOfUser = (function() {

        /**
         * Properties of a GetProfilePictureOfUser.
         * @memberof request
         * @interface IGetProfilePictureOfUser
         * @property {string|null} [email] GetProfilePictureOfUser email
         */

        /**
         * Constructs a new GetProfilePictureOfUser.
         * @memberof request
         * @classdesc Represents a GetProfilePictureOfUser.
         * @implements IGetProfilePictureOfUser
         * @constructor
         * @param {request.IGetProfilePictureOfUser=} [properties] Properties to set
         */
        function GetProfilePictureOfUser(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetProfilePictureOfUser email.
         * @member {string} email
         * @memberof request.GetProfilePictureOfUser
         * @instance
         */
        GetProfilePictureOfUser.prototype.email = "";

        /**
         * Creates a new GetProfilePictureOfUser instance using the specified properties.
         * @function create
         * @memberof request.GetProfilePictureOfUser
         * @static
         * @param {request.IGetProfilePictureOfUser=} [properties] Properties to set
         * @returns {request.GetProfilePictureOfUser} GetProfilePictureOfUser instance
         */
        GetProfilePictureOfUser.create = function create(properties) {
            return new GetProfilePictureOfUser(properties);
        };

        /**
         * Encodes the specified GetProfilePictureOfUser message. Does not implicitly {@link request.GetProfilePictureOfUser.verify|verify} messages.
         * @function encode
         * @memberof request.GetProfilePictureOfUser
         * @static
         * @param {request.IGetProfilePictureOfUser} message GetProfilePictureOfUser message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetProfilePictureOfUser.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
            return writer;
        };

        /**
         * Encodes the specified GetProfilePictureOfUser message, length delimited. Does not implicitly {@link request.GetProfilePictureOfUser.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.GetProfilePictureOfUser
         * @static
         * @param {request.IGetProfilePictureOfUser} message GetProfilePictureOfUser message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetProfilePictureOfUser.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetProfilePictureOfUser message from the specified reader or buffer.
         * @function decode
         * @memberof request.GetProfilePictureOfUser
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.GetProfilePictureOfUser} GetProfilePictureOfUser
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetProfilePictureOfUser.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.GetProfilePictureOfUser();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.email = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetProfilePictureOfUser message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.GetProfilePictureOfUser
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.GetProfilePictureOfUser} GetProfilePictureOfUser
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetProfilePictureOfUser.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetProfilePictureOfUser message.
         * @function verify
         * @memberof request.GetProfilePictureOfUser
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetProfilePictureOfUser.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            return null;
        };

        /**
         * Creates a GetProfilePictureOfUser message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.GetProfilePictureOfUser
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.GetProfilePictureOfUser} GetProfilePictureOfUser
         */
        GetProfilePictureOfUser.fromObject = function fromObject(object) {
            if (object instanceof $root.request.GetProfilePictureOfUser)
                return object;
            let message = new $root.request.GetProfilePictureOfUser();
            if (object.email != null)
                message.email = String(object.email);
            return message;
        };

        /**
         * Creates a plain object from a GetProfilePictureOfUser message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.GetProfilePictureOfUser
         * @static
         * @param {request.GetProfilePictureOfUser} message GetProfilePictureOfUser
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetProfilePictureOfUser.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.email = "";
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            return object;
        };

        /**
         * Converts this GetProfilePictureOfUser to JSON.
         * @function toJSON
         * @memberof request.GetProfilePictureOfUser
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetProfilePictureOfUser.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetProfilePictureOfUser
         * @function getTypeUrl
         * @memberof request.GetProfilePictureOfUser
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetProfilePictureOfUser.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.GetProfilePictureOfUser";
        };

        return GetProfilePictureOfUser;
    })();

    request.EmptyTrash = (function() {

        /**
         * Properties of an EmptyTrash.
         * @memberof request
         * @interface IEmptyTrash
         * @property {Array.<string>|null} [objects] EmptyTrash objects
         * @property {Array.<boolean>|null} [isFolders] EmptyTrash isFolders
         */

        /**
         * Constructs a new EmptyTrash.
         * @memberof request
         * @classdesc Represents an EmptyTrash.
         * @implements IEmptyTrash
         * @constructor
         * @param {request.IEmptyTrash=} [properties] Properties to set
         */
        function EmptyTrash(properties) {
            this.objects = [];
            this.isFolders = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * EmptyTrash objects.
         * @member {Array.<string>} objects
         * @memberof request.EmptyTrash
         * @instance
         */
        EmptyTrash.prototype.objects = $util.emptyArray;

        /**
         * EmptyTrash isFolders.
         * @member {Array.<boolean>} isFolders
         * @memberof request.EmptyTrash
         * @instance
         */
        EmptyTrash.prototype.isFolders = $util.emptyArray;

        /**
         * Creates a new EmptyTrash instance using the specified properties.
         * @function create
         * @memberof request.EmptyTrash
         * @static
         * @param {request.IEmptyTrash=} [properties] Properties to set
         * @returns {request.EmptyTrash} EmptyTrash instance
         */
        EmptyTrash.create = function create(properties) {
            return new EmptyTrash(properties);
        };

        /**
         * Encodes the specified EmptyTrash message. Does not implicitly {@link request.EmptyTrash.verify|verify} messages.
         * @function encode
         * @memberof request.EmptyTrash
         * @static
         * @param {request.IEmptyTrash} message EmptyTrash message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EmptyTrash.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.objects != null && message.objects.length)
                for (let i = 0; i < message.objects.length; ++i)
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.objects[i]);
            if (message.isFolders != null && message.isFolders.length) {
                writer.uint32(/* id 2, wireType 2 =*/18).fork();
                for (let i = 0; i < message.isFolders.length; ++i)
                    writer.bool(message.isFolders[i]);
                writer.ldelim();
            }
            return writer;
        };

        /**
         * Encodes the specified EmptyTrash message, length delimited. Does not implicitly {@link request.EmptyTrash.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.EmptyTrash
         * @static
         * @param {request.IEmptyTrash} message EmptyTrash message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EmptyTrash.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an EmptyTrash message from the specified reader or buffer.
         * @function decode
         * @memberof request.EmptyTrash
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.EmptyTrash} EmptyTrash
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EmptyTrash.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.EmptyTrash();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        if (!(message.objects && message.objects.length))
                            message.objects = [];
                        message.objects.push(reader.string());
                        break;
                    }
                case 2: {
                        if (!(message.isFolders && message.isFolders.length))
                            message.isFolders = [];
                        if ((tag & 7) === 2) {
                            let end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.isFolders.push(reader.bool());
                        } else
                            message.isFolders.push(reader.bool());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an EmptyTrash message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.EmptyTrash
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.EmptyTrash} EmptyTrash
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EmptyTrash.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an EmptyTrash message.
         * @function verify
         * @memberof request.EmptyTrash
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        EmptyTrash.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.objects != null && message.hasOwnProperty("objects")) {
                if (!Array.isArray(message.objects))
                    return "objects: array expected";
                for (let i = 0; i < message.objects.length; ++i)
                    if (!$util.isString(message.objects[i]))
                        return "objects: string[] expected";
            }
            if (message.isFolders != null && message.hasOwnProperty("isFolders")) {
                if (!Array.isArray(message.isFolders))
                    return "isFolders: array expected";
                for (let i = 0; i < message.isFolders.length; ++i)
                    if (typeof message.isFolders[i] !== "boolean")
                        return "isFolders: boolean[] expected";
            }
            return null;
        };

        /**
         * Creates an EmptyTrash message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.EmptyTrash
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.EmptyTrash} EmptyTrash
         */
        EmptyTrash.fromObject = function fromObject(object) {
            if (object instanceof $root.request.EmptyTrash)
                return object;
            let message = new $root.request.EmptyTrash();
            if (object.objects) {
                if (!Array.isArray(object.objects))
                    throw TypeError(".request.EmptyTrash.objects: array expected");
                message.objects = [];
                for (let i = 0; i < object.objects.length; ++i)
                    message.objects[i] = String(object.objects[i]);
            }
            if (object.isFolders) {
                if (!Array.isArray(object.isFolders))
                    throw TypeError(".request.EmptyTrash.isFolders: array expected");
                message.isFolders = [];
                for (let i = 0; i < object.isFolders.length; ++i)
                    message.isFolders[i] = Boolean(object.isFolders[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from an EmptyTrash message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.EmptyTrash
         * @static
         * @param {request.EmptyTrash} message EmptyTrash
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        EmptyTrash.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.objects = [];
                object.isFolders = [];
            }
            if (message.objects && message.objects.length) {
                object.objects = [];
                for (let j = 0; j < message.objects.length; ++j)
                    object.objects[j] = message.objects[j];
            }
            if (message.isFolders && message.isFolders.length) {
                object.isFolders = [];
                for (let j = 0; j < message.isFolders.length; ++j)
                    object.isFolders[j] = message.isFolders[j];
            }
            return object;
        };

        /**
         * Converts this EmptyTrash to JSON.
         * @function toJSON
         * @memberof request.EmptyTrash
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        EmptyTrash.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for EmptyTrash
         * @function getTypeUrl
         * @memberof request.EmptyTrash
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        EmptyTrash.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.EmptyTrash";
        };

        return EmptyTrash;
    })();

    request.SetThumbnail = (function() {

        /**
         * Properties of a SetThumbnail.
         * @memberof request
         * @interface ISetThumbnail
         * @property {string|null} [parentPath] SetThumbnail parentPath
         * @property {string|null} [fileName] SetThumbnail fileName
         * @property {request.TypeOfPath|null} [typeOfPath] SetThumbnail typeOfPath
         * @property {Uint8Array|null} [versionUuid] SetThumbnail versionUuid
         * @property {Uint8Array|null} [thumbnail] SetThumbnail thumbnail
         */

        /**
         * Constructs a new SetThumbnail.
         * @memberof request
         * @classdesc Represents a SetThumbnail.
         * @implements ISetThumbnail
         * @constructor
         * @param {request.ISetThumbnail=} [properties] Properties to set
         */
        function SetThumbnail(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SetThumbnail parentPath.
         * @member {string} parentPath
         * @memberof request.SetThumbnail
         * @instance
         */
        SetThumbnail.prototype.parentPath = "";

        /**
         * SetThumbnail fileName.
         * @member {string} fileName
         * @memberof request.SetThumbnail
         * @instance
         */
        SetThumbnail.prototype.fileName = "";

        /**
         * SetThumbnail typeOfPath.
         * @member {request.TypeOfPath} typeOfPath
         * @memberof request.SetThumbnail
         * @instance
         */
        SetThumbnail.prototype.typeOfPath = 0;

        /**
         * SetThumbnail versionUuid.
         * @member {Uint8Array} versionUuid
         * @memberof request.SetThumbnail
         * @instance
         */
        SetThumbnail.prototype.versionUuid = $util.newBuffer([]);

        /**
         * SetThumbnail thumbnail.
         * @member {Uint8Array} thumbnail
         * @memberof request.SetThumbnail
         * @instance
         */
        SetThumbnail.prototype.thumbnail = $util.newBuffer([]);

        /**
         * Creates a new SetThumbnail instance using the specified properties.
         * @function create
         * @memberof request.SetThumbnail
         * @static
         * @param {request.ISetThumbnail=} [properties] Properties to set
         * @returns {request.SetThumbnail} SetThumbnail instance
         */
        SetThumbnail.create = function create(properties) {
            return new SetThumbnail(properties);
        };

        /**
         * Encodes the specified SetThumbnail message. Does not implicitly {@link request.SetThumbnail.verify|verify} messages.
         * @function encode
         * @memberof request.SetThumbnail
         * @static
         * @param {request.ISetThumbnail} message SetThumbnail message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SetThumbnail.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.parentPath != null && Object.hasOwnProperty.call(message, "parentPath"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.parentPath);
            if (message.fileName != null && Object.hasOwnProperty.call(message, "fileName"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.fileName);
            if (message.typeOfPath != null && Object.hasOwnProperty.call(message, "typeOfPath"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.typeOfPath);
            if (message.versionUuid != null && Object.hasOwnProperty.call(message, "versionUuid"))
                writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.versionUuid);
            if (message.thumbnail != null && Object.hasOwnProperty.call(message, "thumbnail"))
                writer.uint32(/* id 5, wireType 2 =*/42).bytes(message.thumbnail);
            return writer;
        };

        /**
         * Encodes the specified SetThumbnail message, length delimited. Does not implicitly {@link request.SetThumbnail.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.SetThumbnail
         * @static
         * @param {request.ISetThumbnail} message SetThumbnail message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SetThumbnail.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SetThumbnail message from the specified reader or buffer.
         * @function decode
         * @memberof request.SetThumbnail
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.SetThumbnail} SetThumbnail
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SetThumbnail.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.SetThumbnail();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.parentPath = reader.string();
                        break;
                    }
                case 2: {
                        message.fileName = reader.string();
                        break;
                    }
                case 3: {
                        message.typeOfPath = reader.int32();
                        break;
                    }
                case 4: {
                        message.versionUuid = reader.bytes();
                        break;
                    }
                case 5: {
                        message.thumbnail = reader.bytes();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SetThumbnail message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.SetThumbnail
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.SetThumbnail} SetThumbnail
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SetThumbnail.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SetThumbnail message.
         * @function verify
         * @memberof request.SetThumbnail
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SetThumbnail.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.parentPath != null && message.hasOwnProperty("parentPath"))
                if (!$util.isString(message.parentPath))
                    return "parentPath: string expected";
            if (message.fileName != null && message.hasOwnProperty("fileName"))
                if (!$util.isString(message.fileName))
                    return "fileName: string expected";
            if (message.typeOfPath != null && message.hasOwnProperty("typeOfPath"))
                switch (message.typeOfPath) {
                default:
                    return "typeOfPath: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                    break;
                }
            if (message.versionUuid != null && message.hasOwnProperty("versionUuid"))
                if (!(message.versionUuid && typeof message.versionUuid.length === "number" || $util.isString(message.versionUuid)))
                    return "versionUuid: buffer expected";
            if (message.thumbnail != null && message.hasOwnProperty("thumbnail"))
                if (!(message.thumbnail && typeof message.thumbnail.length === "number" || $util.isString(message.thumbnail)))
                    return "thumbnail: buffer expected";
            return null;
        };

        /**
         * Creates a SetThumbnail message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.SetThumbnail
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.SetThumbnail} SetThumbnail
         */
        SetThumbnail.fromObject = function fromObject(object) {
            if (object instanceof $root.request.SetThumbnail)
                return object;
            let message = new $root.request.SetThumbnail();
            if (object.parentPath != null)
                message.parentPath = String(object.parentPath);
            if (object.fileName != null)
                message.fileName = String(object.fileName);
            switch (object.typeOfPath) {
            default:
                if (typeof object.typeOfPath === "number") {
                    message.typeOfPath = object.typeOfPath;
                    break;
                }
                break;
            case "TShareUser":
            case 0:
                message.typeOfPath = 0;
                break;
            case "TFolder":
            case 1:
                message.typeOfPath = 1;
                break;
            case "TShareTeam":
            case 2:
                message.typeOfPath = 2;
                break;
            case "TShareExternal":
            case 3:
                message.typeOfPath = 3;
                break;
            case "TFlow":
            case 4:
                message.typeOfPath = 4;
                break;
            }
            if (object.versionUuid != null)
                if (typeof object.versionUuid === "string")
                    $util.base64.decode(object.versionUuid, message.versionUuid = $util.newBuffer($util.base64.length(object.versionUuid)), 0);
                else if (object.versionUuid.length >= 0)
                    message.versionUuid = object.versionUuid;
            if (object.thumbnail != null)
                if (typeof object.thumbnail === "string")
                    $util.base64.decode(object.thumbnail, message.thumbnail = $util.newBuffer($util.base64.length(object.thumbnail)), 0);
                else if (object.thumbnail.length >= 0)
                    message.thumbnail = object.thumbnail;
            return message;
        };

        /**
         * Creates a plain object from a SetThumbnail message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.SetThumbnail
         * @static
         * @param {request.SetThumbnail} message SetThumbnail
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SetThumbnail.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.parentPath = "";
                object.fileName = "";
                object.typeOfPath = options.enums === String ? "TShareUser" : 0;
                if (options.bytes === String)
                    object.versionUuid = "";
                else {
                    object.versionUuid = [];
                    if (options.bytes !== Array)
                        object.versionUuid = $util.newBuffer(object.versionUuid);
                }
                if (options.bytes === String)
                    object.thumbnail = "";
                else {
                    object.thumbnail = [];
                    if (options.bytes !== Array)
                        object.thumbnail = $util.newBuffer(object.thumbnail);
                }
            }
            if (message.parentPath != null && message.hasOwnProperty("parentPath"))
                object.parentPath = message.parentPath;
            if (message.fileName != null && message.hasOwnProperty("fileName"))
                object.fileName = message.fileName;
            if (message.typeOfPath != null && message.hasOwnProperty("typeOfPath"))
                object.typeOfPath = options.enums === String ? $root.request.TypeOfPath[message.typeOfPath] === undefined ? message.typeOfPath : $root.request.TypeOfPath[message.typeOfPath] : message.typeOfPath;
            if (message.versionUuid != null && message.hasOwnProperty("versionUuid"))
                object.versionUuid = options.bytes === String ? $util.base64.encode(message.versionUuid, 0, message.versionUuid.length) : options.bytes === Array ? Array.prototype.slice.call(message.versionUuid) : message.versionUuid;
            if (message.thumbnail != null && message.hasOwnProperty("thumbnail"))
                object.thumbnail = options.bytes === String ? $util.base64.encode(message.thumbnail, 0, message.thumbnail.length) : options.bytes === Array ? Array.prototype.slice.call(message.thumbnail) : message.thumbnail;
            return object;
        };

        /**
         * Converts this SetThumbnail to JSON.
         * @function toJSON
         * @memberof request.SetThumbnail
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SetThumbnail.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for SetThumbnail
         * @function getTypeUrl
         * @memberof request.SetThumbnail
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        SetThumbnail.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.SetThumbnail";
        };

        return SetThumbnail;
    })();

    request.GetThumbnail = (function() {

        /**
         * Properties of a GetThumbnail.
         * @memberof request
         * @interface IGetThumbnail
         * @property {string|null} [parentPath] GetThumbnail parentPath
         * @property {string|null} [fileName] GetThumbnail fileName
         * @property {request.TypeOfPath|null} [typeOfPath] GetThumbnail typeOfPath
         * @property {Uint8Array|null} [versionUuid] GetThumbnail versionUuid
         */

        /**
         * Constructs a new GetThumbnail.
         * @memberof request
         * @classdesc Represents a GetThumbnail.
         * @implements IGetThumbnail
         * @constructor
         * @param {request.IGetThumbnail=} [properties] Properties to set
         */
        function GetThumbnail(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetThumbnail parentPath.
         * @member {string} parentPath
         * @memberof request.GetThumbnail
         * @instance
         */
        GetThumbnail.prototype.parentPath = "";

        /**
         * GetThumbnail fileName.
         * @member {string} fileName
         * @memberof request.GetThumbnail
         * @instance
         */
        GetThumbnail.prototype.fileName = "";

        /**
         * GetThumbnail typeOfPath.
         * @member {request.TypeOfPath} typeOfPath
         * @memberof request.GetThumbnail
         * @instance
         */
        GetThumbnail.prototype.typeOfPath = 0;

        /**
         * GetThumbnail versionUuid.
         * @member {Uint8Array} versionUuid
         * @memberof request.GetThumbnail
         * @instance
         */
        GetThumbnail.prototype.versionUuid = $util.newBuffer([]);

        /**
         * Creates a new GetThumbnail instance using the specified properties.
         * @function create
         * @memberof request.GetThumbnail
         * @static
         * @param {request.IGetThumbnail=} [properties] Properties to set
         * @returns {request.GetThumbnail} GetThumbnail instance
         */
        GetThumbnail.create = function create(properties) {
            return new GetThumbnail(properties);
        };

        /**
         * Encodes the specified GetThumbnail message. Does not implicitly {@link request.GetThumbnail.verify|verify} messages.
         * @function encode
         * @memberof request.GetThumbnail
         * @static
         * @param {request.IGetThumbnail} message GetThumbnail message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetThumbnail.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.parentPath != null && Object.hasOwnProperty.call(message, "parentPath"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.parentPath);
            if (message.fileName != null && Object.hasOwnProperty.call(message, "fileName"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.fileName);
            if (message.typeOfPath != null && Object.hasOwnProperty.call(message, "typeOfPath"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.typeOfPath);
            if (message.versionUuid != null && Object.hasOwnProperty.call(message, "versionUuid"))
                writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.versionUuid);
            return writer;
        };

        /**
         * Encodes the specified GetThumbnail message, length delimited. Does not implicitly {@link request.GetThumbnail.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.GetThumbnail
         * @static
         * @param {request.IGetThumbnail} message GetThumbnail message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetThumbnail.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetThumbnail message from the specified reader or buffer.
         * @function decode
         * @memberof request.GetThumbnail
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.GetThumbnail} GetThumbnail
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetThumbnail.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.GetThumbnail();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.parentPath = reader.string();
                        break;
                    }
                case 2: {
                        message.fileName = reader.string();
                        break;
                    }
                case 3: {
                        message.typeOfPath = reader.int32();
                        break;
                    }
                case 4: {
                        message.versionUuid = reader.bytes();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetThumbnail message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.GetThumbnail
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.GetThumbnail} GetThumbnail
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetThumbnail.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetThumbnail message.
         * @function verify
         * @memberof request.GetThumbnail
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetThumbnail.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.parentPath != null && message.hasOwnProperty("parentPath"))
                if (!$util.isString(message.parentPath))
                    return "parentPath: string expected";
            if (message.fileName != null && message.hasOwnProperty("fileName"))
                if (!$util.isString(message.fileName))
                    return "fileName: string expected";
            if (message.typeOfPath != null && message.hasOwnProperty("typeOfPath"))
                switch (message.typeOfPath) {
                default:
                    return "typeOfPath: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                    break;
                }
            if (message.versionUuid != null && message.hasOwnProperty("versionUuid"))
                if (!(message.versionUuid && typeof message.versionUuid.length === "number" || $util.isString(message.versionUuid)))
                    return "versionUuid: buffer expected";
            return null;
        };

        /**
         * Creates a GetThumbnail message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.GetThumbnail
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.GetThumbnail} GetThumbnail
         */
        GetThumbnail.fromObject = function fromObject(object) {
            if (object instanceof $root.request.GetThumbnail)
                return object;
            let message = new $root.request.GetThumbnail();
            if (object.parentPath != null)
                message.parentPath = String(object.parentPath);
            if (object.fileName != null)
                message.fileName = String(object.fileName);
            switch (object.typeOfPath) {
            default:
                if (typeof object.typeOfPath === "number") {
                    message.typeOfPath = object.typeOfPath;
                    break;
                }
                break;
            case "TShareUser":
            case 0:
                message.typeOfPath = 0;
                break;
            case "TFolder":
            case 1:
                message.typeOfPath = 1;
                break;
            case "TShareTeam":
            case 2:
                message.typeOfPath = 2;
                break;
            case "TShareExternal":
            case 3:
                message.typeOfPath = 3;
                break;
            case "TFlow":
            case 4:
                message.typeOfPath = 4;
                break;
            }
            if (object.versionUuid != null)
                if (typeof object.versionUuid === "string")
                    $util.base64.decode(object.versionUuid, message.versionUuid = $util.newBuffer($util.base64.length(object.versionUuid)), 0);
                else if (object.versionUuid.length >= 0)
                    message.versionUuid = object.versionUuid;
            return message;
        };

        /**
         * Creates a plain object from a GetThumbnail message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.GetThumbnail
         * @static
         * @param {request.GetThumbnail} message GetThumbnail
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetThumbnail.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.parentPath = "";
                object.fileName = "";
                object.typeOfPath = options.enums === String ? "TShareUser" : 0;
                if (options.bytes === String)
                    object.versionUuid = "";
                else {
                    object.versionUuid = [];
                    if (options.bytes !== Array)
                        object.versionUuid = $util.newBuffer(object.versionUuid);
                }
            }
            if (message.parentPath != null && message.hasOwnProperty("parentPath"))
                object.parentPath = message.parentPath;
            if (message.fileName != null && message.hasOwnProperty("fileName"))
                object.fileName = message.fileName;
            if (message.typeOfPath != null && message.hasOwnProperty("typeOfPath"))
                object.typeOfPath = options.enums === String ? $root.request.TypeOfPath[message.typeOfPath] === undefined ? message.typeOfPath : $root.request.TypeOfPath[message.typeOfPath] : message.typeOfPath;
            if (message.versionUuid != null && message.hasOwnProperty("versionUuid"))
                object.versionUuid = options.bytes === String ? $util.base64.encode(message.versionUuid, 0, message.versionUuid.length) : options.bytes === Array ? Array.prototype.slice.call(message.versionUuid) : message.versionUuid;
            return object;
        };

        /**
         * Converts this GetThumbnail to JSON.
         * @function toJSON
         * @memberof request.GetThumbnail
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetThumbnail.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetThumbnail
         * @function getTypeUrl
         * @memberof request.GetThumbnail
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetThumbnail.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.GetThumbnail";
        };

        return GetThumbnail;
    })();

    request.BlockUser = (function() {

        /**
         * Properties of a BlockUser.
         * @memberof request
         * @interface IBlockUser
         * @property {string|null} [email] BlockUser email
         */

        /**
         * Constructs a new BlockUser.
         * @memberof request
         * @classdesc Represents a BlockUser.
         * @implements IBlockUser
         * @constructor
         * @param {request.IBlockUser=} [properties] Properties to set
         */
        function BlockUser(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BlockUser email.
         * @member {string} email
         * @memberof request.BlockUser
         * @instance
         */
        BlockUser.prototype.email = "";

        /**
         * Creates a new BlockUser instance using the specified properties.
         * @function create
         * @memberof request.BlockUser
         * @static
         * @param {request.IBlockUser=} [properties] Properties to set
         * @returns {request.BlockUser} BlockUser instance
         */
        BlockUser.create = function create(properties) {
            return new BlockUser(properties);
        };

        /**
         * Encodes the specified BlockUser message. Does not implicitly {@link request.BlockUser.verify|verify} messages.
         * @function encode
         * @memberof request.BlockUser
         * @static
         * @param {request.IBlockUser} message BlockUser message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BlockUser.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
            return writer;
        };

        /**
         * Encodes the specified BlockUser message, length delimited. Does not implicitly {@link request.BlockUser.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.BlockUser
         * @static
         * @param {request.IBlockUser} message BlockUser message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BlockUser.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a BlockUser message from the specified reader or buffer.
         * @function decode
         * @memberof request.BlockUser
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.BlockUser} BlockUser
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BlockUser.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.BlockUser();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.email = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a BlockUser message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.BlockUser
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.BlockUser} BlockUser
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BlockUser.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a BlockUser message.
         * @function verify
         * @memberof request.BlockUser
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        BlockUser.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            return null;
        };

        /**
         * Creates a BlockUser message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.BlockUser
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.BlockUser} BlockUser
         */
        BlockUser.fromObject = function fromObject(object) {
            if (object instanceof $root.request.BlockUser)
                return object;
            let message = new $root.request.BlockUser();
            if (object.email != null)
                message.email = String(object.email);
            return message;
        };

        /**
         * Creates a plain object from a BlockUser message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.BlockUser
         * @static
         * @param {request.BlockUser} message BlockUser
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BlockUser.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.email = "";
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            return object;
        };

        /**
         * Converts this BlockUser to JSON.
         * @function toJSON
         * @memberof request.BlockUser
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BlockUser.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for BlockUser
         * @function getTypeUrl
         * @memberof request.BlockUser
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        BlockUser.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.BlockUser";
        };

        return BlockUser;
    })();

    request.UnblockUser = (function() {

        /**
         * Properties of an UnblockUser.
         * @memberof request
         * @interface IUnblockUser
         * @property {string|null} [email] UnblockUser email
         */

        /**
         * Constructs a new UnblockUser.
         * @memberof request
         * @classdesc Represents an UnblockUser.
         * @implements IUnblockUser
         * @constructor
         * @param {request.IUnblockUser=} [properties] Properties to set
         */
        function UnblockUser(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UnblockUser email.
         * @member {string} email
         * @memberof request.UnblockUser
         * @instance
         */
        UnblockUser.prototype.email = "";

        /**
         * Creates a new UnblockUser instance using the specified properties.
         * @function create
         * @memberof request.UnblockUser
         * @static
         * @param {request.IUnblockUser=} [properties] Properties to set
         * @returns {request.UnblockUser} UnblockUser instance
         */
        UnblockUser.create = function create(properties) {
            return new UnblockUser(properties);
        };

        /**
         * Encodes the specified UnblockUser message. Does not implicitly {@link request.UnblockUser.verify|verify} messages.
         * @function encode
         * @memberof request.UnblockUser
         * @static
         * @param {request.IUnblockUser} message UnblockUser message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UnblockUser.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
            return writer;
        };

        /**
         * Encodes the specified UnblockUser message, length delimited. Does not implicitly {@link request.UnblockUser.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.UnblockUser
         * @static
         * @param {request.IUnblockUser} message UnblockUser message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UnblockUser.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UnblockUser message from the specified reader or buffer.
         * @function decode
         * @memberof request.UnblockUser
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.UnblockUser} UnblockUser
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UnblockUser.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.UnblockUser();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.email = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UnblockUser message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.UnblockUser
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.UnblockUser} UnblockUser
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UnblockUser.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UnblockUser message.
         * @function verify
         * @memberof request.UnblockUser
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UnblockUser.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            return null;
        };

        /**
         * Creates an UnblockUser message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.UnblockUser
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.UnblockUser} UnblockUser
         */
        UnblockUser.fromObject = function fromObject(object) {
            if (object instanceof $root.request.UnblockUser)
                return object;
            let message = new $root.request.UnblockUser();
            if (object.email != null)
                message.email = String(object.email);
            return message;
        };

        /**
         * Creates a plain object from an UnblockUser message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.UnblockUser
         * @static
         * @param {request.UnblockUser} message UnblockUser
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UnblockUser.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.email = "";
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            return object;
        };

        /**
         * Converts this UnblockUser to JSON.
         * @function toJSON
         * @memberof request.UnblockUser
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UnblockUser.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for UnblockUser
         * @function getTypeUrl
         * @memberof request.UnblockUser
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        UnblockUser.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.UnblockUser";
        };

        return UnblockUser;
    })();

    request.UpdateOrgSettings = (function() {

        /**
         * Properties of an UpdateOrgSettings.
         * @memberof request
         * @interface IUpdateOrgSettings
         * @property {Array.<string>|null} [allowedCountries] UpdateOrgSettings allowedCountries
         * @property {Array.<string>|null} [deniedCountries] UpdateOrgSettings deniedCountries
         * @property {Array.<string>|null} [allowedRegions] UpdateOrgSettings allowedRegions
         * @property {Array.<string>|null} [deniedRegions] UpdateOrgSettings deniedRegions
         * @property {Array.<string>|null} [allowedFileTypes] UpdateOrgSettings allowedFileTypes
         * @property {Array.<string>|null} [deniedFileTypes] UpdateOrgSettings deniedFileTypes
         */

        /**
         * Constructs a new UpdateOrgSettings.
         * @memberof request
         * @classdesc Represents an UpdateOrgSettings.
         * @implements IUpdateOrgSettings
         * @constructor
         * @param {request.IUpdateOrgSettings=} [properties] Properties to set
         */
        function UpdateOrgSettings(properties) {
            this.allowedCountries = [];
            this.deniedCountries = [];
            this.allowedRegions = [];
            this.deniedRegions = [];
            this.allowedFileTypes = [];
            this.deniedFileTypes = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateOrgSettings allowedCountries.
         * @member {Array.<string>} allowedCountries
         * @memberof request.UpdateOrgSettings
         * @instance
         */
        UpdateOrgSettings.prototype.allowedCountries = $util.emptyArray;

        /**
         * UpdateOrgSettings deniedCountries.
         * @member {Array.<string>} deniedCountries
         * @memberof request.UpdateOrgSettings
         * @instance
         */
        UpdateOrgSettings.prototype.deniedCountries = $util.emptyArray;

        /**
         * UpdateOrgSettings allowedRegions.
         * @member {Array.<string>} allowedRegions
         * @memberof request.UpdateOrgSettings
         * @instance
         */
        UpdateOrgSettings.prototype.allowedRegions = $util.emptyArray;

        /**
         * UpdateOrgSettings deniedRegions.
         * @member {Array.<string>} deniedRegions
         * @memberof request.UpdateOrgSettings
         * @instance
         */
        UpdateOrgSettings.prototype.deniedRegions = $util.emptyArray;

        /**
         * UpdateOrgSettings allowedFileTypes.
         * @member {Array.<string>} allowedFileTypes
         * @memberof request.UpdateOrgSettings
         * @instance
         */
        UpdateOrgSettings.prototype.allowedFileTypes = $util.emptyArray;

        /**
         * UpdateOrgSettings deniedFileTypes.
         * @member {Array.<string>} deniedFileTypes
         * @memberof request.UpdateOrgSettings
         * @instance
         */
        UpdateOrgSettings.prototype.deniedFileTypes = $util.emptyArray;

        /**
         * Creates a new UpdateOrgSettings instance using the specified properties.
         * @function create
         * @memberof request.UpdateOrgSettings
         * @static
         * @param {request.IUpdateOrgSettings=} [properties] Properties to set
         * @returns {request.UpdateOrgSettings} UpdateOrgSettings instance
         */
        UpdateOrgSettings.create = function create(properties) {
            return new UpdateOrgSettings(properties);
        };

        /**
         * Encodes the specified UpdateOrgSettings message. Does not implicitly {@link request.UpdateOrgSettings.verify|verify} messages.
         * @function encode
         * @memberof request.UpdateOrgSettings
         * @static
         * @param {request.IUpdateOrgSettings} message UpdateOrgSettings message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateOrgSettings.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.allowedCountries != null && message.allowedCountries.length)
                for (let i = 0; i < message.allowedCountries.length; ++i)
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.allowedCountries[i]);
            if (message.deniedCountries != null && message.deniedCountries.length)
                for (let i = 0; i < message.deniedCountries.length; ++i)
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.deniedCountries[i]);
            if (message.allowedRegions != null && message.allowedRegions.length)
                for (let i = 0; i < message.allowedRegions.length; ++i)
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.allowedRegions[i]);
            if (message.deniedRegions != null && message.deniedRegions.length)
                for (let i = 0; i < message.deniedRegions.length; ++i)
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.deniedRegions[i]);
            if (message.allowedFileTypes != null && message.allowedFileTypes.length)
                for (let i = 0; i < message.allowedFileTypes.length; ++i)
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.allowedFileTypes[i]);
            if (message.deniedFileTypes != null && message.deniedFileTypes.length)
                for (let i = 0; i < message.deniedFileTypes.length; ++i)
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.deniedFileTypes[i]);
            return writer;
        };

        /**
         * Encodes the specified UpdateOrgSettings message, length delimited. Does not implicitly {@link request.UpdateOrgSettings.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.UpdateOrgSettings
         * @static
         * @param {request.IUpdateOrgSettings} message UpdateOrgSettings message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateOrgSettings.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UpdateOrgSettings message from the specified reader or buffer.
         * @function decode
         * @memberof request.UpdateOrgSettings
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.UpdateOrgSettings} UpdateOrgSettings
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateOrgSettings.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.UpdateOrgSettings();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        if (!(message.allowedCountries && message.allowedCountries.length))
                            message.allowedCountries = [];
                        message.allowedCountries.push(reader.string());
                        break;
                    }
                case 2: {
                        if (!(message.deniedCountries && message.deniedCountries.length))
                            message.deniedCountries = [];
                        message.deniedCountries.push(reader.string());
                        break;
                    }
                case 3: {
                        if (!(message.allowedRegions && message.allowedRegions.length))
                            message.allowedRegions = [];
                        message.allowedRegions.push(reader.string());
                        break;
                    }
                case 4: {
                        if (!(message.deniedRegions && message.deniedRegions.length))
                            message.deniedRegions = [];
                        message.deniedRegions.push(reader.string());
                        break;
                    }
                case 5: {
                        if (!(message.allowedFileTypes && message.allowedFileTypes.length))
                            message.allowedFileTypes = [];
                        message.allowedFileTypes.push(reader.string());
                        break;
                    }
                case 6: {
                        if (!(message.deniedFileTypes && message.deniedFileTypes.length))
                            message.deniedFileTypes = [];
                        message.deniedFileTypes.push(reader.string());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UpdateOrgSettings message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.UpdateOrgSettings
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.UpdateOrgSettings} UpdateOrgSettings
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateOrgSettings.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UpdateOrgSettings message.
         * @function verify
         * @memberof request.UpdateOrgSettings
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UpdateOrgSettings.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.allowedCountries != null && message.hasOwnProperty("allowedCountries")) {
                if (!Array.isArray(message.allowedCountries))
                    return "allowedCountries: array expected";
                for (let i = 0; i < message.allowedCountries.length; ++i)
                    if (!$util.isString(message.allowedCountries[i]))
                        return "allowedCountries: string[] expected";
            }
            if (message.deniedCountries != null && message.hasOwnProperty("deniedCountries")) {
                if (!Array.isArray(message.deniedCountries))
                    return "deniedCountries: array expected";
                for (let i = 0; i < message.deniedCountries.length; ++i)
                    if (!$util.isString(message.deniedCountries[i]))
                        return "deniedCountries: string[] expected";
            }
            if (message.allowedRegions != null && message.hasOwnProperty("allowedRegions")) {
                if (!Array.isArray(message.allowedRegions))
                    return "allowedRegions: array expected";
                for (let i = 0; i < message.allowedRegions.length; ++i)
                    if (!$util.isString(message.allowedRegions[i]))
                        return "allowedRegions: string[] expected";
            }
            if (message.deniedRegions != null && message.hasOwnProperty("deniedRegions")) {
                if (!Array.isArray(message.deniedRegions))
                    return "deniedRegions: array expected";
                for (let i = 0; i < message.deniedRegions.length; ++i)
                    if (!$util.isString(message.deniedRegions[i]))
                        return "deniedRegions: string[] expected";
            }
            if (message.allowedFileTypes != null && message.hasOwnProperty("allowedFileTypes")) {
                if (!Array.isArray(message.allowedFileTypes))
                    return "allowedFileTypes: array expected";
                for (let i = 0; i < message.allowedFileTypes.length; ++i)
                    if (!$util.isString(message.allowedFileTypes[i]))
                        return "allowedFileTypes: string[] expected";
            }
            if (message.deniedFileTypes != null && message.hasOwnProperty("deniedFileTypes")) {
                if (!Array.isArray(message.deniedFileTypes))
                    return "deniedFileTypes: array expected";
                for (let i = 0; i < message.deniedFileTypes.length; ++i)
                    if (!$util.isString(message.deniedFileTypes[i]))
                        return "deniedFileTypes: string[] expected";
            }
            return null;
        };

        /**
         * Creates an UpdateOrgSettings message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.UpdateOrgSettings
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.UpdateOrgSettings} UpdateOrgSettings
         */
        UpdateOrgSettings.fromObject = function fromObject(object) {
            if (object instanceof $root.request.UpdateOrgSettings)
                return object;
            let message = new $root.request.UpdateOrgSettings();
            if (object.allowedCountries) {
                if (!Array.isArray(object.allowedCountries))
                    throw TypeError(".request.UpdateOrgSettings.allowedCountries: array expected");
                message.allowedCountries = [];
                for (let i = 0; i < object.allowedCountries.length; ++i)
                    message.allowedCountries[i] = String(object.allowedCountries[i]);
            }
            if (object.deniedCountries) {
                if (!Array.isArray(object.deniedCountries))
                    throw TypeError(".request.UpdateOrgSettings.deniedCountries: array expected");
                message.deniedCountries = [];
                for (let i = 0; i < object.deniedCountries.length; ++i)
                    message.deniedCountries[i] = String(object.deniedCountries[i]);
            }
            if (object.allowedRegions) {
                if (!Array.isArray(object.allowedRegions))
                    throw TypeError(".request.UpdateOrgSettings.allowedRegions: array expected");
                message.allowedRegions = [];
                for (let i = 0; i < object.allowedRegions.length; ++i)
                    message.allowedRegions[i] = String(object.allowedRegions[i]);
            }
            if (object.deniedRegions) {
                if (!Array.isArray(object.deniedRegions))
                    throw TypeError(".request.UpdateOrgSettings.deniedRegions: array expected");
                message.deniedRegions = [];
                for (let i = 0; i < object.deniedRegions.length; ++i)
                    message.deniedRegions[i] = String(object.deniedRegions[i]);
            }
            if (object.allowedFileTypes) {
                if (!Array.isArray(object.allowedFileTypes))
                    throw TypeError(".request.UpdateOrgSettings.allowedFileTypes: array expected");
                message.allowedFileTypes = [];
                for (let i = 0; i < object.allowedFileTypes.length; ++i)
                    message.allowedFileTypes[i] = String(object.allowedFileTypes[i]);
            }
            if (object.deniedFileTypes) {
                if (!Array.isArray(object.deniedFileTypes))
                    throw TypeError(".request.UpdateOrgSettings.deniedFileTypes: array expected");
                message.deniedFileTypes = [];
                for (let i = 0; i < object.deniedFileTypes.length; ++i)
                    message.deniedFileTypes[i] = String(object.deniedFileTypes[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateOrgSettings message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.UpdateOrgSettings
         * @static
         * @param {request.UpdateOrgSettings} message UpdateOrgSettings
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateOrgSettings.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.allowedCountries = [];
                object.deniedCountries = [];
                object.allowedRegions = [];
                object.deniedRegions = [];
                object.allowedFileTypes = [];
                object.deniedFileTypes = [];
            }
            if (message.allowedCountries && message.allowedCountries.length) {
                object.allowedCountries = [];
                for (let j = 0; j < message.allowedCountries.length; ++j)
                    object.allowedCountries[j] = message.allowedCountries[j];
            }
            if (message.deniedCountries && message.deniedCountries.length) {
                object.deniedCountries = [];
                for (let j = 0; j < message.deniedCountries.length; ++j)
                    object.deniedCountries[j] = message.deniedCountries[j];
            }
            if (message.allowedRegions && message.allowedRegions.length) {
                object.allowedRegions = [];
                for (let j = 0; j < message.allowedRegions.length; ++j)
                    object.allowedRegions[j] = message.allowedRegions[j];
            }
            if (message.deniedRegions && message.deniedRegions.length) {
                object.deniedRegions = [];
                for (let j = 0; j < message.deniedRegions.length; ++j)
                    object.deniedRegions[j] = message.deniedRegions[j];
            }
            if (message.allowedFileTypes && message.allowedFileTypes.length) {
                object.allowedFileTypes = [];
                for (let j = 0; j < message.allowedFileTypes.length; ++j)
                    object.allowedFileTypes[j] = message.allowedFileTypes[j];
            }
            if (message.deniedFileTypes && message.deniedFileTypes.length) {
                object.deniedFileTypes = [];
                for (let j = 0; j < message.deniedFileTypes.length; ++j)
                    object.deniedFileTypes[j] = message.deniedFileTypes[j];
            }
            return object;
        };

        /**
         * Converts this UpdateOrgSettings to JSON.
         * @function toJSON
         * @memberof request.UpdateOrgSettings
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateOrgSettings.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for UpdateOrgSettings
         * @function getTypeUrl
         * @memberof request.UpdateOrgSettings
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        UpdateOrgSettings.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.UpdateOrgSettings";
        };

        return UpdateOrgSettings;
    })();

    request.GetOrgSettings = (function() {

        /**
         * Properties of a GetOrgSettings.
         * @memberof request
         * @interface IGetOrgSettings
         */

        /**
         * Constructs a new GetOrgSettings.
         * @memberof request
         * @classdesc Represents a GetOrgSettings.
         * @implements IGetOrgSettings
         * @constructor
         * @param {request.IGetOrgSettings=} [properties] Properties to set
         */
        function GetOrgSettings(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new GetOrgSettings instance using the specified properties.
         * @function create
         * @memberof request.GetOrgSettings
         * @static
         * @param {request.IGetOrgSettings=} [properties] Properties to set
         * @returns {request.GetOrgSettings} GetOrgSettings instance
         */
        GetOrgSettings.create = function create(properties) {
            return new GetOrgSettings(properties);
        };

        /**
         * Encodes the specified GetOrgSettings message. Does not implicitly {@link request.GetOrgSettings.verify|verify} messages.
         * @function encode
         * @memberof request.GetOrgSettings
         * @static
         * @param {request.IGetOrgSettings} message GetOrgSettings message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetOrgSettings.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified GetOrgSettings message, length delimited. Does not implicitly {@link request.GetOrgSettings.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.GetOrgSettings
         * @static
         * @param {request.IGetOrgSettings} message GetOrgSettings message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetOrgSettings.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetOrgSettings message from the specified reader or buffer.
         * @function decode
         * @memberof request.GetOrgSettings
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.GetOrgSettings} GetOrgSettings
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetOrgSettings.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.GetOrgSettings();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetOrgSettings message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.GetOrgSettings
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.GetOrgSettings} GetOrgSettings
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetOrgSettings.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetOrgSettings message.
         * @function verify
         * @memberof request.GetOrgSettings
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetOrgSettings.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a GetOrgSettings message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.GetOrgSettings
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.GetOrgSettings} GetOrgSettings
         */
        GetOrgSettings.fromObject = function fromObject(object) {
            if (object instanceof $root.request.GetOrgSettings)
                return object;
            return new $root.request.GetOrgSettings();
        };

        /**
         * Creates a plain object from a GetOrgSettings message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.GetOrgSettings
         * @static
         * @param {request.GetOrgSettings} message GetOrgSettings
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetOrgSettings.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this GetOrgSettings to JSON.
         * @function toJSON
         * @memberof request.GetOrgSettings
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetOrgSettings.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetOrgSettings
         * @function getTypeUrl
         * @memberof request.GetOrgSettings
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetOrgSettings.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.GetOrgSettings";
        };

        return GetOrgSettings;
    })();

    request.Request = (function() {

        /**
         * Properties of a Request.
         * @memberof request
         * @interface IRequest
         * @property {number|Long|null} [reqCreateTime] Request reqCreateTime
         * @property {number|Long|null} [id] Request id
         * @property {request.IAddUser|null} [addUser] Request addUser
         * @property {request.IRemoveUser|null} [removeUser] Request removeUser
         * @property {request.IPasswordReset|null} [passwordReset] Request passwordReset
         * @property {request.IChangePassword|null} [changePassword] Request changePassword
         * @property {request.IAddOrganization|null} [addOrganization] Request addOrganization
         * @property {request.IInitiatePayment|null} [initiatePayment] Request initiatePayment
         * @property {request.ISignIn|null} [signIn] Request signIn
         * @property {request.ISignOut|null} [signOut] Request signOut
         * @property {request.IInviteUser|null} [inviteUser] Request inviteUser
         * @property {request.IGetUser|null} [getUser] Request getUser
         * @property {request.IListUsers|null} [listUsers] Request listUsers
         * @property {request.IRemoveOrganization|null} [removeOrganization] Request removeOrganization
         * @property {request.IVerifyOrganization|null} [verifyOrganization] Request verifyOrganization
         * @property {request.IGetOrganization|null} [getOrganization] Request getOrganization
         * @property {request.IAddPin|null} [addPin] Request addPin
         * @property {request.IVerifyUser|null} [verifyUser] Request verifyUser
         * @property {request.IGetFileHead|null} [getFileHead] Request getFileHead
         * @property {request.IEcho|null} [echo] Request echo
         * @property {request.IFileLock|null} [fileLock] Request fileLock
         * @property {request.IFileUnlock|null} [fileUnlock] Request fileUnlock
         * @property {request.IGetChunk|null} [getChunk] Request getChunk
         * @property {request.IStartWrite|null} [startWrite] Request startWrite
         * @property {request.IPutChunk|null} [putChunk] Request putChunk
         * @property {request.IFinalizeWrite|null} [finalizeWrite] Request finalizeWrite
         * @property {request.IListFiles|null} [listFiles] Request listFiles
         * @property {request.IRemove|null} [remove] Request remove
         * @property {request.IGetFolder|null} [getFolder] Request getFolder
         * @property {request.ICreateFolder|null} [createFolder] Request createFolder
         * @property {request.ICreateSnapshot|null} [CreateSnapshot] Request CreateSnapshot
         * @property {request.IVerifyPayment|null} [VerifyPayment] Request VerifyPayment
         * @property {request.IGetSecret|null} [getSecret] Request getSecret
         * @property {request.IAddSecret|null} [addSecret] Request addSecret
         * @property {request.IDeleteSecret|null} [deleteSecret] Request deleteSecret
         * @property {request.IUpdateSecret|null} [updateSecret] Request updateSecret
         * @property {request.IListSecrets|null} [listSecrets] Request listSecrets
         * @property {request.IQuickListSecrets|null} [quickListSecrets] Request quickListSecrets
         * @property {request.IListSecretSubkeys|null} [listSecretSubkeys] Request listSecretSubkeys
         * @property {request.IUndeleteSecret|null} [undeleteSecret] Request undeleteSecret
         * @property {request.IDestroySecret|null} [destroySecret] Request destroySecret
         * @property {request.IAddRole|null} [addRole] Request addRole
         * @property {request.IRemoveRole|null} [removeRole] Request removeRole
         * @property {request.IUpdateRole|null} [updateRole] Request updateRole
         * @property {request.IListRoles|null} [listRoles] Request listRoles
         * @property {request.IGetRole|null} [getRole] Request getRole
         * @property {request.IAddTeam|null} [addTeam] Request addTeam
         * @property {request.IRemoveTeam|null} [removeTeam] Request removeTeam
         * @property {request.IUpdateTeam|null} [updateTeam] Request updateTeam
         * @property {request.IListTeams|null} [listTeams] Request listTeams
         * @property {request.IGetTeam|null} [getTeam] Request getTeam
         * @property {request.IIsOperationAllowed|null} [isOperationAllowed] Request isOperationAllowed
         * @property {request.IMoveFile|null} [moveFile] Request moveFile
         * @property {request.IMoveFolder|null} [moveFolder] Request moveFolder
         * @property {request.ICopyFile|null} [copyFile] Request copyFile
         * @property {request.ICopyFolder|null} [copyFolder] Request copyFolder
         * @property {request.IRestoreVersion|null} [restoreVersion] Request restoreVersion
         * @property {request.IRemoveFile|null} [removeFile] Request removeFile
         * @property {request.IRemoveFolder|null} [removeFolder] Request removeFolder
         * @property {request.IUntrashFile|null} [untrashFile] Request untrashFile
         * @property {request.IUntrashFolder|null} [untrashFolder] Request untrashFolder
         * @property {request.IUndoStartWrite|null} [undoStartWrite] Request undoStartWrite
         * @property {request.IDetachClonedFolder|null} [detachClonedFolder] Request detachClonedFolder
         * @property {request.IGetMetaFromPath|null} [getMetaFromPath] Request getMetaFromPath
         * @property {request.IRenameFile|null} [renameFile] Request renameFile
         * @property {request.IRenameFolder|null} [renameFolder] Request renameFolder
         * @property {request.IList|null} [list] Request list
         * @property {request.IAuditLogMessage|null} [auditLogMessage] Request auditLogMessage
         * @property {request.IResetVersion|null} [resetVersion] Request resetVersion
         * @property {request.ISetUser|null} [setUser] Request setUser
         * @property {request.IFinalizeProfileWrite|null} [finalizeProfileWrite] Request finalizeProfileWrite
         * @property {request.IGetProfileFileMeta|null} [getProfileFileMeta] Request getProfileFileMeta
         * @property {request.IProfileChunkList|null} [profileChunkList] Request profileChunkList
         * @property {request.IGetUserType|null} [getUserType] Request getUserType
         * @property {request.IGetRandomBytes|null} [getRandomBytes] Request getRandomBytes
         * @property {request.IShare|null} [share] Request share
         * @property {request.IUnshare|null} [unshare] Request unshare
         * @property {request.IUpdateShare|null} [updateShare] Request updateShare
         * @property {request.IListShares|null} [listShares] Request listShares
         * @property {request.IResetTOTP|null} [resetTOTP] Request resetTOTP
         * @property {request.ISetRolesTeamsToUser|null} [setRolesTeamsToUser] Request setRolesTeamsToUser
         * @property {request.IUpdatePinOps|null} [updatePinOps] Request updatePinOps
         * @property {request.IDeletePin|null} [deletePin] Request deletePin
         * @property {request.IGetRolesAndTeamsOfUser|null} [getRolesAndTeamsOfUser] Request getRolesAndTeamsOfUser
         * @property {request.IRestartPutChunk|null} [restartPutChunk] Request restartPutChunk
         * @property {request.IVerifyAuditLogMeta|null} [verifyAuditLogMeta] Request verifyAuditLogMeta
         * @property {request.IGetAuditLog|null} [getAuditLog] Request getAuditLog
         * @property {request.IDeleteAuditLog|null} [deleteAuditLog] Request deleteAuditLog
         * @property {request.IGetLedgerRange|null} [getLedgerRange] Request getLedgerRange
         * @property {request.IListPins|null} [listPins] Request listPins
         * @property {request.IGetMetaFromSharedPath|null} [getMetaFromSharedPath] Request getMetaFromSharedPath
         * @property {request.IListQuestions|null} [listQuestions] Request listQuestions
         * @property {request.IVerifyBYOSCreds|null} [verifyBYOSCreds] Request verifyBYOSCreds
         * @property {request.IMigrateToStorage|null} [migrateToStorage] Request migrateToStorage
         * @property {request.IUpdateStorageCreds|null} [updateStorageCreds] Request updateStorageCreds
         * @property {request.IVerifyUserForAudit|null} [verifyUserForAudit] Request verifyUserForAudit
         * @property {request.IRemoveOrganizationUser|null} [removeOrganizationUser] Request removeOrganizationUser
         * @property {request.IAddSpace|null} [addSpace] Request addSpace
         * @property {request.IAddUserToSpace|null} [addUserToSpace] Request addUserToSpace
         * @property {request.IRemoveUserFromSpace|null} [removeUserFromSpace] Request removeUserFromSpace
         * @property {request.IUpdatePermissionsOfSpace|null} [updatePermissionsOfSpace] Request updatePermissionsOfSpace
         * @property {request.IAddObjectToSpace|null} [addObjectToSpace] Request addObjectToSpace
         * @property {request.IRemoveObjectFromSpace|null} [removeObjectFromSpace] Request removeObjectFromSpace
         * @property {request.IRemoveSpace|null} [removeSpace] Request removeSpace
         * @property {request.ISendOtpToExternalUser|null} [sendOtpToExternalUser] Request sendOtpToExternalUser
         * @property {request.ISignInToSpace|null} [signInToSpace] Request signInToSpace
         * @property {request.IListSpaces|null} [listSpaces] Request listSpaces
         * @property {request.ISendOtpToExternalUserIfNotExist|null} [sendOtpToExternalUserIfNotExist] Request sendOtpToExternalUserIfNotExist
         * @property {request.IGetStorageValue|null} [getStorageValue] Request getStorageValue
         * @property {request.IUpdateTags|null} [updateTags] Request updateTags
         * @property {request.IAddComment|null} [addComment] Request addComment
         * @property {request.IRemoveComment|null} [removeComment] Request removeComment
         * @property {request.IListComments|null} [listComments] Request listComments
         * @property {request.IUpdateComment|null} [updateComment] Request updateComment
         * @property {request.IGetComment|null} [getComment] Request getComment
         * @property {request.ISessionData|null} [sessionData] Request sessionData
         * @property {request.IGetStorageCreds|null} [getStorageCreds] Request getStorageCreds
         * @property {request.IGetPlan|null} [getPlan] Request getPlan
         * @property {request.IListPlans|null} [listPlans] Request listPlans
         * @property {request.IUpgradePlan|null} [upgradePlan] Request upgradePlan
         * @property {request.IValidateCoupon|null} [validateCoupon] Request validateCoupon
         * @property {request.IRemoveVersion|null} [removeVersion] Request removeVersion
         * @property {request.IGetProfilePictureOfUser|null} [getProfilePictureOfUser] Request getProfilePictureOfUser
         * @property {request.IEmptyTrash|null} [emptyTrash] Request emptyTrash
         * @property {request.ISetThumbnail|null} [setThumbnail] Request setThumbnail
         * @property {request.IGetThumbnail|null} [getThumbnail] Request getThumbnail
         * @property {request.IBlockUser|null} [blockUser] Request blockUser
         * @property {request.IUnblockUser|null} [unblockUser] Request unblockUser
         * @property {request.IUpdateOrgSettings|null} [updateOrgSettings] Request updateOrgSettings
         * @property {request.IGetOrgSettings|null} [getOrgSettings] Request getOrgSettings
         */

        /**
         * Constructs a new Request.
         * @memberof request
         * @classdesc Represents a Request.
         * @implements IRequest
         * @constructor
         * @param {request.IRequest=} [properties] Properties to set
         */
        function Request(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Request reqCreateTime.
         * @member {number|Long} reqCreateTime
         * @memberof request.Request
         * @instance
         */
        Request.prototype.reqCreateTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Request id.
         * @member {number|Long|null|undefined} id
         * @memberof request.Request
         * @instance
         */
        Request.prototype.id = null;

        /**
         * Request addUser.
         * @member {request.IAddUser|null|undefined} addUser
         * @memberof request.Request
         * @instance
         */
        Request.prototype.addUser = null;

        /**
         * Request removeUser.
         * @member {request.IRemoveUser|null|undefined} removeUser
         * @memberof request.Request
         * @instance
         */
        Request.prototype.removeUser = null;

        /**
         * Request passwordReset.
         * @member {request.IPasswordReset|null|undefined} passwordReset
         * @memberof request.Request
         * @instance
         */
        Request.prototype.passwordReset = null;

        /**
         * Request changePassword.
         * @member {request.IChangePassword|null|undefined} changePassword
         * @memberof request.Request
         * @instance
         */
        Request.prototype.changePassword = null;

        /**
         * Request addOrganization.
         * @member {request.IAddOrganization|null|undefined} addOrganization
         * @memberof request.Request
         * @instance
         */
        Request.prototype.addOrganization = null;

        /**
         * Request initiatePayment.
         * @member {request.IInitiatePayment|null|undefined} initiatePayment
         * @memberof request.Request
         * @instance
         */
        Request.prototype.initiatePayment = null;

        /**
         * Request signIn.
         * @member {request.ISignIn|null|undefined} signIn
         * @memberof request.Request
         * @instance
         */
        Request.prototype.signIn = null;

        /**
         * Request signOut.
         * @member {request.ISignOut|null|undefined} signOut
         * @memberof request.Request
         * @instance
         */
        Request.prototype.signOut = null;

        /**
         * Request inviteUser.
         * @member {request.IInviteUser|null|undefined} inviteUser
         * @memberof request.Request
         * @instance
         */
        Request.prototype.inviteUser = null;

        /**
         * Request getUser.
         * @member {request.IGetUser|null|undefined} getUser
         * @memberof request.Request
         * @instance
         */
        Request.prototype.getUser = null;

        /**
         * Request listUsers.
         * @member {request.IListUsers|null|undefined} listUsers
         * @memberof request.Request
         * @instance
         */
        Request.prototype.listUsers = null;

        /**
         * Request removeOrganization.
         * @member {request.IRemoveOrganization|null|undefined} removeOrganization
         * @memberof request.Request
         * @instance
         */
        Request.prototype.removeOrganization = null;

        /**
         * Request verifyOrganization.
         * @member {request.IVerifyOrganization|null|undefined} verifyOrganization
         * @memberof request.Request
         * @instance
         */
        Request.prototype.verifyOrganization = null;

        /**
         * Request getOrganization.
         * @member {request.IGetOrganization|null|undefined} getOrganization
         * @memberof request.Request
         * @instance
         */
        Request.prototype.getOrganization = null;

        /**
         * Request addPin.
         * @member {request.IAddPin|null|undefined} addPin
         * @memberof request.Request
         * @instance
         */
        Request.prototype.addPin = null;

        /**
         * Request verifyUser.
         * @member {request.IVerifyUser|null|undefined} verifyUser
         * @memberof request.Request
         * @instance
         */
        Request.prototype.verifyUser = null;

        /**
         * Request getFileHead.
         * @member {request.IGetFileHead|null|undefined} getFileHead
         * @memberof request.Request
         * @instance
         */
        Request.prototype.getFileHead = null;

        /**
         * Request echo.
         * @member {request.IEcho|null|undefined} echo
         * @memberof request.Request
         * @instance
         */
        Request.prototype.echo = null;

        /**
         * Request fileLock.
         * @member {request.IFileLock|null|undefined} fileLock
         * @memberof request.Request
         * @instance
         */
        Request.prototype.fileLock = null;

        /**
         * Request fileUnlock.
         * @member {request.IFileUnlock|null|undefined} fileUnlock
         * @memberof request.Request
         * @instance
         */
        Request.prototype.fileUnlock = null;

        /**
         * Request getChunk.
         * @member {request.IGetChunk|null|undefined} getChunk
         * @memberof request.Request
         * @instance
         */
        Request.prototype.getChunk = null;

        /**
         * Request startWrite.
         * @member {request.IStartWrite|null|undefined} startWrite
         * @memberof request.Request
         * @instance
         */
        Request.prototype.startWrite = null;

        /**
         * Request putChunk.
         * @member {request.IPutChunk|null|undefined} putChunk
         * @memberof request.Request
         * @instance
         */
        Request.prototype.putChunk = null;

        /**
         * Request finalizeWrite.
         * @member {request.IFinalizeWrite|null|undefined} finalizeWrite
         * @memberof request.Request
         * @instance
         */
        Request.prototype.finalizeWrite = null;

        /**
         * Request listFiles.
         * @member {request.IListFiles|null|undefined} listFiles
         * @memberof request.Request
         * @instance
         */
        Request.prototype.listFiles = null;

        /**
         * Request remove.
         * @member {request.IRemove|null|undefined} remove
         * @memberof request.Request
         * @instance
         */
        Request.prototype.remove = null;

        /**
         * Request getFolder.
         * @member {request.IGetFolder|null|undefined} getFolder
         * @memberof request.Request
         * @instance
         */
        Request.prototype.getFolder = null;

        /**
         * Request createFolder.
         * @member {request.ICreateFolder|null|undefined} createFolder
         * @memberof request.Request
         * @instance
         */
        Request.prototype.createFolder = null;

        /**
         * Request CreateSnapshot.
         * @member {request.ICreateSnapshot|null|undefined} CreateSnapshot
         * @memberof request.Request
         * @instance
         */
        Request.prototype.CreateSnapshot = null;

        /**
         * Request VerifyPayment.
         * @member {request.IVerifyPayment|null|undefined} VerifyPayment
         * @memberof request.Request
         * @instance
         */
        Request.prototype.VerifyPayment = null;

        /**
         * Request getSecret.
         * @member {request.IGetSecret|null|undefined} getSecret
         * @memberof request.Request
         * @instance
         */
        Request.prototype.getSecret = null;

        /**
         * Request addSecret.
         * @member {request.IAddSecret|null|undefined} addSecret
         * @memberof request.Request
         * @instance
         */
        Request.prototype.addSecret = null;

        /**
         * Request deleteSecret.
         * @member {request.IDeleteSecret|null|undefined} deleteSecret
         * @memberof request.Request
         * @instance
         */
        Request.prototype.deleteSecret = null;

        /**
         * Request updateSecret.
         * @member {request.IUpdateSecret|null|undefined} updateSecret
         * @memberof request.Request
         * @instance
         */
        Request.prototype.updateSecret = null;

        /**
         * Request listSecrets.
         * @member {request.IListSecrets|null|undefined} listSecrets
         * @memberof request.Request
         * @instance
         */
        Request.prototype.listSecrets = null;

        /**
         * Request quickListSecrets.
         * @member {request.IQuickListSecrets|null|undefined} quickListSecrets
         * @memberof request.Request
         * @instance
         */
        Request.prototype.quickListSecrets = null;

        /**
         * Request listSecretSubkeys.
         * @member {request.IListSecretSubkeys|null|undefined} listSecretSubkeys
         * @memberof request.Request
         * @instance
         */
        Request.prototype.listSecretSubkeys = null;

        /**
         * Request undeleteSecret.
         * @member {request.IUndeleteSecret|null|undefined} undeleteSecret
         * @memberof request.Request
         * @instance
         */
        Request.prototype.undeleteSecret = null;

        /**
         * Request destroySecret.
         * @member {request.IDestroySecret|null|undefined} destroySecret
         * @memberof request.Request
         * @instance
         */
        Request.prototype.destroySecret = null;

        /**
         * Request addRole.
         * @member {request.IAddRole|null|undefined} addRole
         * @memberof request.Request
         * @instance
         */
        Request.prototype.addRole = null;

        /**
         * Request removeRole.
         * @member {request.IRemoveRole|null|undefined} removeRole
         * @memberof request.Request
         * @instance
         */
        Request.prototype.removeRole = null;

        /**
         * Request updateRole.
         * @member {request.IUpdateRole|null|undefined} updateRole
         * @memberof request.Request
         * @instance
         */
        Request.prototype.updateRole = null;

        /**
         * Request listRoles.
         * @member {request.IListRoles|null|undefined} listRoles
         * @memberof request.Request
         * @instance
         */
        Request.prototype.listRoles = null;

        /**
         * Request getRole.
         * @member {request.IGetRole|null|undefined} getRole
         * @memberof request.Request
         * @instance
         */
        Request.prototype.getRole = null;

        /**
         * Request addTeam.
         * @member {request.IAddTeam|null|undefined} addTeam
         * @memberof request.Request
         * @instance
         */
        Request.prototype.addTeam = null;

        /**
         * Request removeTeam.
         * @member {request.IRemoveTeam|null|undefined} removeTeam
         * @memberof request.Request
         * @instance
         */
        Request.prototype.removeTeam = null;

        /**
         * Request updateTeam.
         * @member {request.IUpdateTeam|null|undefined} updateTeam
         * @memberof request.Request
         * @instance
         */
        Request.prototype.updateTeam = null;

        /**
         * Request listTeams.
         * @member {request.IListTeams|null|undefined} listTeams
         * @memberof request.Request
         * @instance
         */
        Request.prototype.listTeams = null;

        /**
         * Request getTeam.
         * @member {request.IGetTeam|null|undefined} getTeam
         * @memberof request.Request
         * @instance
         */
        Request.prototype.getTeam = null;

        /**
         * Request isOperationAllowed.
         * @member {request.IIsOperationAllowed|null|undefined} isOperationAllowed
         * @memberof request.Request
         * @instance
         */
        Request.prototype.isOperationAllowed = null;

        /**
         * Request moveFile.
         * @member {request.IMoveFile|null|undefined} moveFile
         * @memberof request.Request
         * @instance
         */
        Request.prototype.moveFile = null;

        /**
         * Request moveFolder.
         * @member {request.IMoveFolder|null|undefined} moveFolder
         * @memberof request.Request
         * @instance
         */
        Request.prototype.moveFolder = null;

        /**
         * Request copyFile.
         * @member {request.ICopyFile|null|undefined} copyFile
         * @memberof request.Request
         * @instance
         */
        Request.prototype.copyFile = null;

        /**
         * Request copyFolder.
         * @member {request.ICopyFolder|null|undefined} copyFolder
         * @memberof request.Request
         * @instance
         */
        Request.prototype.copyFolder = null;

        /**
         * Request restoreVersion.
         * @member {request.IRestoreVersion|null|undefined} restoreVersion
         * @memberof request.Request
         * @instance
         */
        Request.prototype.restoreVersion = null;

        /**
         * Request removeFile.
         * @member {request.IRemoveFile|null|undefined} removeFile
         * @memberof request.Request
         * @instance
         */
        Request.prototype.removeFile = null;

        /**
         * Request removeFolder.
         * @member {request.IRemoveFolder|null|undefined} removeFolder
         * @memberof request.Request
         * @instance
         */
        Request.prototype.removeFolder = null;

        /**
         * Request untrashFile.
         * @member {request.IUntrashFile|null|undefined} untrashFile
         * @memberof request.Request
         * @instance
         */
        Request.prototype.untrashFile = null;

        /**
         * Request untrashFolder.
         * @member {request.IUntrashFolder|null|undefined} untrashFolder
         * @memberof request.Request
         * @instance
         */
        Request.prototype.untrashFolder = null;

        /**
         * Request undoStartWrite.
         * @member {request.IUndoStartWrite|null|undefined} undoStartWrite
         * @memberof request.Request
         * @instance
         */
        Request.prototype.undoStartWrite = null;

        /**
         * Request detachClonedFolder.
         * @member {request.IDetachClonedFolder|null|undefined} detachClonedFolder
         * @memberof request.Request
         * @instance
         */
        Request.prototype.detachClonedFolder = null;

        /**
         * Request getMetaFromPath.
         * @member {request.IGetMetaFromPath|null|undefined} getMetaFromPath
         * @memberof request.Request
         * @instance
         */
        Request.prototype.getMetaFromPath = null;

        /**
         * Request renameFile.
         * @member {request.IRenameFile|null|undefined} renameFile
         * @memberof request.Request
         * @instance
         */
        Request.prototype.renameFile = null;

        /**
         * Request renameFolder.
         * @member {request.IRenameFolder|null|undefined} renameFolder
         * @memberof request.Request
         * @instance
         */
        Request.prototype.renameFolder = null;

        /**
         * Request list.
         * @member {request.IList|null|undefined} list
         * @memberof request.Request
         * @instance
         */
        Request.prototype.list = null;

        /**
         * Request auditLogMessage.
         * @member {request.IAuditLogMessage|null|undefined} auditLogMessage
         * @memberof request.Request
         * @instance
         */
        Request.prototype.auditLogMessage = null;

        /**
         * Request resetVersion.
         * @member {request.IResetVersion|null|undefined} resetVersion
         * @memberof request.Request
         * @instance
         */
        Request.prototype.resetVersion = null;

        /**
         * Request setUser.
         * @member {request.ISetUser|null|undefined} setUser
         * @memberof request.Request
         * @instance
         */
        Request.prototype.setUser = null;

        /**
         * Request finalizeProfileWrite.
         * @member {request.IFinalizeProfileWrite|null|undefined} finalizeProfileWrite
         * @memberof request.Request
         * @instance
         */
        Request.prototype.finalizeProfileWrite = null;

        /**
         * Request getProfileFileMeta.
         * @member {request.IGetProfileFileMeta|null|undefined} getProfileFileMeta
         * @memberof request.Request
         * @instance
         */
        Request.prototype.getProfileFileMeta = null;

        /**
         * Request profileChunkList.
         * @member {request.IProfileChunkList|null|undefined} profileChunkList
         * @memberof request.Request
         * @instance
         */
        Request.prototype.profileChunkList = null;

        /**
         * Request getUserType.
         * @member {request.IGetUserType|null|undefined} getUserType
         * @memberof request.Request
         * @instance
         */
        Request.prototype.getUserType = null;

        /**
         * Request getRandomBytes.
         * @member {request.IGetRandomBytes|null|undefined} getRandomBytes
         * @memberof request.Request
         * @instance
         */
        Request.prototype.getRandomBytes = null;

        /**
         * Request share.
         * @member {request.IShare|null|undefined} share
         * @memberof request.Request
         * @instance
         */
        Request.prototype.share = null;

        /**
         * Request unshare.
         * @member {request.IUnshare|null|undefined} unshare
         * @memberof request.Request
         * @instance
         */
        Request.prototype.unshare = null;

        /**
         * Request updateShare.
         * @member {request.IUpdateShare|null|undefined} updateShare
         * @memberof request.Request
         * @instance
         */
        Request.prototype.updateShare = null;

        /**
         * Request listShares.
         * @member {request.IListShares|null|undefined} listShares
         * @memberof request.Request
         * @instance
         */
        Request.prototype.listShares = null;

        /**
         * Request resetTOTP.
         * @member {request.IResetTOTP|null|undefined} resetTOTP
         * @memberof request.Request
         * @instance
         */
        Request.prototype.resetTOTP = null;

        /**
         * Request setRolesTeamsToUser.
         * @member {request.ISetRolesTeamsToUser|null|undefined} setRolesTeamsToUser
         * @memberof request.Request
         * @instance
         */
        Request.prototype.setRolesTeamsToUser = null;

        /**
         * Request updatePinOps.
         * @member {request.IUpdatePinOps|null|undefined} updatePinOps
         * @memberof request.Request
         * @instance
         */
        Request.prototype.updatePinOps = null;

        /**
         * Request deletePin.
         * @member {request.IDeletePin|null|undefined} deletePin
         * @memberof request.Request
         * @instance
         */
        Request.prototype.deletePin = null;

        /**
         * Request getRolesAndTeamsOfUser.
         * @member {request.IGetRolesAndTeamsOfUser|null|undefined} getRolesAndTeamsOfUser
         * @memberof request.Request
         * @instance
         */
        Request.prototype.getRolesAndTeamsOfUser = null;

        /**
         * Request restartPutChunk.
         * @member {request.IRestartPutChunk|null|undefined} restartPutChunk
         * @memberof request.Request
         * @instance
         */
        Request.prototype.restartPutChunk = null;

        /**
         * Request verifyAuditLogMeta.
         * @member {request.IVerifyAuditLogMeta|null|undefined} verifyAuditLogMeta
         * @memberof request.Request
         * @instance
         */
        Request.prototype.verifyAuditLogMeta = null;

        /**
         * Request getAuditLog.
         * @member {request.IGetAuditLog|null|undefined} getAuditLog
         * @memberof request.Request
         * @instance
         */
        Request.prototype.getAuditLog = null;

        /**
         * Request deleteAuditLog.
         * @member {request.IDeleteAuditLog|null|undefined} deleteAuditLog
         * @memberof request.Request
         * @instance
         */
        Request.prototype.deleteAuditLog = null;

        /**
         * Request getLedgerRange.
         * @member {request.IGetLedgerRange|null|undefined} getLedgerRange
         * @memberof request.Request
         * @instance
         */
        Request.prototype.getLedgerRange = null;

        /**
         * Request listPins.
         * @member {request.IListPins|null|undefined} listPins
         * @memberof request.Request
         * @instance
         */
        Request.prototype.listPins = null;

        /**
         * Request getMetaFromSharedPath.
         * @member {request.IGetMetaFromSharedPath|null|undefined} getMetaFromSharedPath
         * @memberof request.Request
         * @instance
         */
        Request.prototype.getMetaFromSharedPath = null;

        /**
         * Request listQuestions.
         * @member {request.IListQuestions|null|undefined} listQuestions
         * @memberof request.Request
         * @instance
         */
        Request.prototype.listQuestions = null;

        /**
         * Request verifyBYOSCreds.
         * @member {request.IVerifyBYOSCreds|null|undefined} verifyBYOSCreds
         * @memberof request.Request
         * @instance
         */
        Request.prototype.verifyBYOSCreds = null;

        /**
         * Request migrateToStorage.
         * @member {request.IMigrateToStorage|null|undefined} migrateToStorage
         * @memberof request.Request
         * @instance
         */
        Request.prototype.migrateToStorage = null;

        /**
         * Request updateStorageCreds.
         * @member {request.IUpdateStorageCreds|null|undefined} updateStorageCreds
         * @memberof request.Request
         * @instance
         */
        Request.prototype.updateStorageCreds = null;

        /**
         * Request verifyUserForAudit.
         * @member {request.IVerifyUserForAudit|null|undefined} verifyUserForAudit
         * @memberof request.Request
         * @instance
         */
        Request.prototype.verifyUserForAudit = null;

        /**
         * Request removeOrganizationUser.
         * @member {request.IRemoveOrganizationUser|null|undefined} removeOrganizationUser
         * @memberof request.Request
         * @instance
         */
        Request.prototype.removeOrganizationUser = null;

        /**
         * Request addSpace.
         * @member {request.IAddSpace|null|undefined} addSpace
         * @memberof request.Request
         * @instance
         */
        Request.prototype.addSpace = null;

        /**
         * Request addUserToSpace.
         * @member {request.IAddUserToSpace|null|undefined} addUserToSpace
         * @memberof request.Request
         * @instance
         */
        Request.prototype.addUserToSpace = null;

        /**
         * Request removeUserFromSpace.
         * @member {request.IRemoveUserFromSpace|null|undefined} removeUserFromSpace
         * @memberof request.Request
         * @instance
         */
        Request.prototype.removeUserFromSpace = null;

        /**
         * Request updatePermissionsOfSpace.
         * @member {request.IUpdatePermissionsOfSpace|null|undefined} updatePermissionsOfSpace
         * @memberof request.Request
         * @instance
         */
        Request.prototype.updatePermissionsOfSpace = null;

        /**
         * Request addObjectToSpace.
         * @member {request.IAddObjectToSpace|null|undefined} addObjectToSpace
         * @memberof request.Request
         * @instance
         */
        Request.prototype.addObjectToSpace = null;

        /**
         * Request removeObjectFromSpace.
         * @member {request.IRemoveObjectFromSpace|null|undefined} removeObjectFromSpace
         * @memberof request.Request
         * @instance
         */
        Request.prototype.removeObjectFromSpace = null;

        /**
         * Request removeSpace.
         * @member {request.IRemoveSpace|null|undefined} removeSpace
         * @memberof request.Request
         * @instance
         */
        Request.prototype.removeSpace = null;

        /**
         * Request sendOtpToExternalUser.
         * @member {request.ISendOtpToExternalUser|null|undefined} sendOtpToExternalUser
         * @memberof request.Request
         * @instance
         */
        Request.prototype.sendOtpToExternalUser = null;

        /**
         * Request signInToSpace.
         * @member {request.ISignInToSpace|null|undefined} signInToSpace
         * @memberof request.Request
         * @instance
         */
        Request.prototype.signInToSpace = null;

        /**
         * Request listSpaces.
         * @member {request.IListSpaces|null|undefined} listSpaces
         * @memberof request.Request
         * @instance
         */
        Request.prototype.listSpaces = null;

        /**
         * Request sendOtpToExternalUserIfNotExist.
         * @member {request.ISendOtpToExternalUserIfNotExist|null|undefined} sendOtpToExternalUserIfNotExist
         * @memberof request.Request
         * @instance
         */
        Request.prototype.sendOtpToExternalUserIfNotExist = null;

        /**
         * Request getStorageValue.
         * @member {request.IGetStorageValue|null|undefined} getStorageValue
         * @memberof request.Request
         * @instance
         */
        Request.prototype.getStorageValue = null;

        /**
         * Request updateTags.
         * @member {request.IUpdateTags|null|undefined} updateTags
         * @memberof request.Request
         * @instance
         */
        Request.prototype.updateTags = null;

        /**
         * Request addComment.
         * @member {request.IAddComment|null|undefined} addComment
         * @memberof request.Request
         * @instance
         */
        Request.prototype.addComment = null;

        /**
         * Request removeComment.
         * @member {request.IRemoveComment|null|undefined} removeComment
         * @memberof request.Request
         * @instance
         */
        Request.prototype.removeComment = null;

        /**
         * Request listComments.
         * @member {request.IListComments|null|undefined} listComments
         * @memberof request.Request
         * @instance
         */
        Request.prototype.listComments = null;

        /**
         * Request updateComment.
         * @member {request.IUpdateComment|null|undefined} updateComment
         * @memberof request.Request
         * @instance
         */
        Request.prototype.updateComment = null;

        /**
         * Request getComment.
         * @member {request.IGetComment|null|undefined} getComment
         * @memberof request.Request
         * @instance
         */
        Request.prototype.getComment = null;

        /**
         * Request sessionData.
         * @member {request.ISessionData|null|undefined} sessionData
         * @memberof request.Request
         * @instance
         */
        Request.prototype.sessionData = null;

        /**
         * Request getStorageCreds.
         * @member {request.IGetStorageCreds|null|undefined} getStorageCreds
         * @memberof request.Request
         * @instance
         */
        Request.prototype.getStorageCreds = null;

        /**
         * Request getPlan.
         * @member {request.IGetPlan|null|undefined} getPlan
         * @memberof request.Request
         * @instance
         */
        Request.prototype.getPlan = null;

        /**
         * Request listPlans.
         * @member {request.IListPlans|null|undefined} listPlans
         * @memberof request.Request
         * @instance
         */
        Request.prototype.listPlans = null;

        /**
         * Request upgradePlan.
         * @member {request.IUpgradePlan|null|undefined} upgradePlan
         * @memberof request.Request
         * @instance
         */
        Request.prototype.upgradePlan = null;

        /**
         * Request validateCoupon.
         * @member {request.IValidateCoupon|null|undefined} validateCoupon
         * @memberof request.Request
         * @instance
         */
        Request.prototype.validateCoupon = null;

        /**
         * Request removeVersion.
         * @member {request.IRemoveVersion|null|undefined} removeVersion
         * @memberof request.Request
         * @instance
         */
        Request.prototype.removeVersion = null;

        /**
         * Request getProfilePictureOfUser.
         * @member {request.IGetProfilePictureOfUser|null|undefined} getProfilePictureOfUser
         * @memberof request.Request
         * @instance
         */
        Request.prototype.getProfilePictureOfUser = null;

        /**
         * Request emptyTrash.
         * @member {request.IEmptyTrash|null|undefined} emptyTrash
         * @memberof request.Request
         * @instance
         */
        Request.prototype.emptyTrash = null;

        /**
         * Request setThumbnail.
         * @member {request.ISetThumbnail|null|undefined} setThumbnail
         * @memberof request.Request
         * @instance
         */
        Request.prototype.setThumbnail = null;

        /**
         * Request getThumbnail.
         * @member {request.IGetThumbnail|null|undefined} getThumbnail
         * @memberof request.Request
         * @instance
         */
        Request.prototype.getThumbnail = null;

        /**
         * Request blockUser.
         * @member {request.IBlockUser|null|undefined} blockUser
         * @memberof request.Request
         * @instance
         */
        Request.prototype.blockUser = null;

        /**
         * Request unblockUser.
         * @member {request.IUnblockUser|null|undefined} unblockUser
         * @memberof request.Request
         * @instance
         */
        Request.prototype.unblockUser = null;

        /**
         * Request updateOrgSettings.
         * @member {request.IUpdateOrgSettings|null|undefined} updateOrgSettings
         * @memberof request.Request
         * @instance
         */
        Request.prototype.updateOrgSettings = null;

        /**
         * Request getOrgSettings.
         * @member {request.IGetOrgSettings|null|undefined} getOrgSettings
         * @memberof request.Request
         * @instance
         */
        Request.prototype.getOrgSettings = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(Request.prototype, "_id", {
            get: $util.oneOfGetter($oneOfFields = ["id"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Request Operation.
         * @member {"addUser"|"removeUser"|"passwordReset"|"changePassword"|"addOrganization"|"initiatePayment"|"signIn"|"signOut"|"inviteUser"|"getUser"|"listUsers"|"removeOrganization"|"verifyOrganization"|"getOrganization"|"addPin"|"verifyUser"|"getFileHead"|"echo"|"fileLock"|"fileUnlock"|"getChunk"|"startWrite"|"putChunk"|"finalizeWrite"|"listFiles"|"remove"|"getFolder"|"createFolder"|"CreateSnapshot"|"VerifyPayment"|"getSecret"|"addSecret"|"deleteSecret"|"updateSecret"|"listSecrets"|"quickListSecrets"|"listSecretSubkeys"|"undeleteSecret"|"destroySecret"|"addRole"|"removeRole"|"updateRole"|"listRoles"|"getRole"|"addTeam"|"removeTeam"|"updateTeam"|"listTeams"|"getTeam"|"isOperationAllowed"|"moveFile"|"moveFolder"|"copyFile"|"copyFolder"|"restoreVersion"|"removeFile"|"removeFolder"|"untrashFile"|"untrashFolder"|"undoStartWrite"|"detachClonedFolder"|"getMetaFromPath"|"renameFile"|"renameFolder"|"list"|"auditLogMessage"|"resetVersion"|"setUser"|"finalizeProfileWrite"|"getProfileFileMeta"|"profileChunkList"|"getUserType"|"getRandomBytes"|"share"|"unshare"|"updateShare"|"listShares"|"resetTOTP"|"setRolesTeamsToUser"|"updatePinOps"|"deletePin"|"getRolesAndTeamsOfUser"|"restartPutChunk"|"verifyAuditLogMeta"|"getAuditLog"|"deleteAuditLog"|"getLedgerRange"|"listPins"|"getMetaFromSharedPath"|"listQuestions"|"verifyBYOSCreds"|"migrateToStorage"|"updateStorageCreds"|"verifyUserForAudit"|"removeOrganizationUser"|"addSpace"|"addUserToSpace"|"removeUserFromSpace"|"updatePermissionsOfSpace"|"addObjectToSpace"|"removeObjectFromSpace"|"removeSpace"|"sendOtpToExternalUser"|"signInToSpace"|"listSpaces"|"sendOtpToExternalUserIfNotExist"|"getStorageValue"|"updateTags"|"addComment"|"removeComment"|"listComments"|"updateComment"|"getComment"|"sessionData"|"getStorageCreds"|"getPlan"|"listPlans"|"upgradePlan"|"validateCoupon"|"removeVersion"|"getProfilePictureOfUser"|"emptyTrash"|"setThumbnail"|"getThumbnail"|"blockUser"|"unblockUser"|"updateOrgSettings"|"getOrgSettings"|undefined} Operation
         * @memberof request.Request
         * @instance
         */
        Object.defineProperty(Request.prototype, "Operation", {
            get: $util.oneOfGetter($oneOfFields = ["addUser", "removeUser", "passwordReset", "changePassword", "addOrganization", "initiatePayment", "signIn", "signOut", "inviteUser", "getUser", "listUsers", "removeOrganization", "verifyOrganization", "getOrganization", "addPin", "verifyUser", "getFileHead", "echo", "fileLock", "fileUnlock", "getChunk", "startWrite", "putChunk", "finalizeWrite", "listFiles", "remove", "getFolder", "createFolder", "CreateSnapshot", "VerifyPayment", "getSecret", "addSecret", "deleteSecret", "updateSecret", "listSecrets", "quickListSecrets", "listSecretSubkeys", "undeleteSecret", "destroySecret", "addRole", "removeRole", "updateRole", "listRoles", "getRole", "addTeam", "removeTeam", "updateTeam", "listTeams", "getTeam", "isOperationAllowed", "moveFile", "moveFolder", "copyFile", "copyFolder", "restoreVersion", "removeFile", "removeFolder", "untrashFile", "untrashFolder", "undoStartWrite", "detachClonedFolder", "getMetaFromPath", "renameFile", "renameFolder", "list", "auditLogMessage", "resetVersion", "setUser", "finalizeProfileWrite", "getProfileFileMeta", "profileChunkList", "getUserType", "getRandomBytes", "share", "unshare", "updateShare", "listShares", "resetTOTP", "setRolesTeamsToUser", "updatePinOps", "deletePin", "getRolesAndTeamsOfUser", "restartPutChunk", "verifyAuditLogMeta", "getAuditLog", "deleteAuditLog", "getLedgerRange", "listPins", "getMetaFromSharedPath", "listQuestions", "verifyBYOSCreds", "migrateToStorage", "updateStorageCreds", "verifyUserForAudit", "removeOrganizationUser", "addSpace", "addUserToSpace", "removeUserFromSpace", "updatePermissionsOfSpace", "addObjectToSpace", "removeObjectFromSpace", "removeSpace", "sendOtpToExternalUser", "signInToSpace", "listSpaces", "sendOtpToExternalUserIfNotExist", "getStorageValue", "updateTags", "addComment", "removeComment", "listComments", "updateComment", "getComment", "sessionData", "getStorageCreds", "getPlan", "listPlans", "upgradePlan", "validateCoupon", "removeVersion", "getProfilePictureOfUser", "emptyTrash", "setThumbnail", "getThumbnail", "blockUser", "unblockUser", "updateOrgSettings", "getOrgSettings"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new Request instance using the specified properties.
         * @function create
         * @memberof request.Request
         * @static
         * @param {request.IRequest=} [properties] Properties to set
         * @returns {request.Request} Request instance
         */
        Request.create = function create(properties) {
            return new Request(properties);
        };

        /**
         * Encodes the specified Request message. Does not implicitly {@link request.Request.verify|verify} messages.
         * @function encode
         * @memberof request.Request
         * @static
         * @param {request.IRequest} message Request message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Request.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.addUser != null && Object.hasOwnProperty.call(message, "addUser"))
                $root.request.AddUser.encode(message.addUser, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.removeUser != null && Object.hasOwnProperty.call(message, "removeUser"))
                $root.request.RemoveUser.encode(message.removeUser, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.passwordReset != null && Object.hasOwnProperty.call(message, "passwordReset"))
                $root.request.PasswordReset.encode(message.passwordReset, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.changePassword != null && Object.hasOwnProperty.call(message, "changePassword"))
                $root.request.ChangePassword.encode(message.changePassword, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            if (message.addOrganization != null && Object.hasOwnProperty.call(message, "addOrganization"))
                $root.request.AddOrganization.encode(message.addOrganization, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
            if (message.initiatePayment != null && Object.hasOwnProperty.call(message, "initiatePayment"))
                $root.request.InitiatePayment.encode(message.initiatePayment, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
            if (message.signIn != null && Object.hasOwnProperty.call(message, "signIn"))
                $root.request.SignIn.encode(message.signIn, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
            if (message.signOut != null && Object.hasOwnProperty.call(message, "signOut"))
                $root.request.SignOut.encode(message.signOut, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
            if (message.inviteUser != null && Object.hasOwnProperty.call(message, "inviteUser"))
                $root.request.InviteUser.encode(message.inviteUser, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
            if (message.getUser != null && Object.hasOwnProperty.call(message, "getUser"))
                $root.request.GetUser.encode(message.getUser, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
            if (message.listUsers != null && Object.hasOwnProperty.call(message, "listUsers"))
                $root.request.ListUsers.encode(message.listUsers, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
            if (message.removeOrganization != null && Object.hasOwnProperty.call(message, "removeOrganization"))
                $root.request.RemoveOrganization.encode(message.removeOrganization, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
            if (message.verifyOrganization != null && Object.hasOwnProperty.call(message, "verifyOrganization"))
                $root.request.VerifyOrganization.encode(message.verifyOrganization, writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
            if (message.getOrganization != null && Object.hasOwnProperty.call(message, "getOrganization"))
                $root.request.GetOrganization.encode(message.getOrganization, writer.uint32(/* id 14, wireType 2 =*/114).fork()).ldelim();
            if (message.addPin != null && Object.hasOwnProperty.call(message, "addPin"))
                $root.request.AddPin.encode(message.addPin, writer.uint32(/* id 15, wireType 2 =*/122).fork()).ldelim();
            if (message.verifyUser != null && Object.hasOwnProperty.call(message, "verifyUser"))
                $root.request.VerifyUser.encode(message.verifyUser, writer.uint32(/* id 16, wireType 2 =*/130).fork()).ldelim();
            if (message.getFileHead != null && Object.hasOwnProperty.call(message, "getFileHead"))
                $root.request.GetFileHead.encode(message.getFileHead, writer.uint32(/* id 17, wireType 2 =*/138).fork()).ldelim();
            if (message.echo != null && Object.hasOwnProperty.call(message, "echo"))
                $root.request.Echo.encode(message.echo, writer.uint32(/* id 18, wireType 2 =*/146).fork()).ldelim();
            if (message.fileLock != null && Object.hasOwnProperty.call(message, "fileLock"))
                $root.request.FileLock.encode(message.fileLock, writer.uint32(/* id 19, wireType 2 =*/154).fork()).ldelim();
            if (message.fileUnlock != null && Object.hasOwnProperty.call(message, "fileUnlock"))
                $root.request.FileUnlock.encode(message.fileUnlock, writer.uint32(/* id 20, wireType 2 =*/162).fork()).ldelim();
            if (message.getChunk != null && Object.hasOwnProperty.call(message, "getChunk"))
                $root.request.GetChunk.encode(message.getChunk, writer.uint32(/* id 21, wireType 2 =*/170).fork()).ldelim();
            if (message.startWrite != null && Object.hasOwnProperty.call(message, "startWrite"))
                $root.request.StartWrite.encode(message.startWrite, writer.uint32(/* id 22, wireType 2 =*/178).fork()).ldelim();
            if (message.putChunk != null && Object.hasOwnProperty.call(message, "putChunk"))
                $root.request.PutChunk.encode(message.putChunk, writer.uint32(/* id 23, wireType 2 =*/186).fork()).ldelim();
            if (message.finalizeWrite != null && Object.hasOwnProperty.call(message, "finalizeWrite"))
                $root.request.FinalizeWrite.encode(message.finalizeWrite, writer.uint32(/* id 24, wireType 2 =*/194).fork()).ldelim();
            if (message.listFiles != null && Object.hasOwnProperty.call(message, "listFiles"))
                $root.request.ListFiles.encode(message.listFiles, writer.uint32(/* id 25, wireType 2 =*/202).fork()).ldelim();
            if (message.remove != null && Object.hasOwnProperty.call(message, "remove"))
                $root.request.Remove.encode(message.remove, writer.uint32(/* id 26, wireType 2 =*/210).fork()).ldelim();
            if (message.getFolder != null && Object.hasOwnProperty.call(message, "getFolder"))
                $root.request.GetFolder.encode(message.getFolder, writer.uint32(/* id 29, wireType 2 =*/234).fork()).ldelim();
            if (message.createFolder != null && Object.hasOwnProperty.call(message, "createFolder"))
                $root.request.CreateFolder.encode(message.createFolder, writer.uint32(/* id 30, wireType 2 =*/242).fork()).ldelim();
            if (message.CreateSnapshot != null && Object.hasOwnProperty.call(message, "CreateSnapshot"))
                $root.request.CreateSnapshot.encode(message.CreateSnapshot, writer.uint32(/* id 31, wireType 2 =*/250).fork()).ldelim();
            if (message.VerifyPayment != null && Object.hasOwnProperty.call(message, "VerifyPayment"))
                $root.request.VerifyPayment.encode(message.VerifyPayment, writer.uint32(/* id 32, wireType 2 =*/258).fork()).ldelim();
            if (message.getSecret != null && Object.hasOwnProperty.call(message, "getSecret"))
                $root.request.GetSecret.encode(message.getSecret, writer.uint32(/* id 33, wireType 2 =*/266).fork()).ldelim();
            if (message.addSecret != null && Object.hasOwnProperty.call(message, "addSecret"))
                $root.request.AddSecret.encode(message.addSecret, writer.uint32(/* id 34, wireType 2 =*/274).fork()).ldelim();
            if (message.deleteSecret != null && Object.hasOwnProperty.call(message, "deleteSecret"))
                $root.request.DeleteSecret.encode(message.deleteSecret, writer.uint32(/* id 35, wireType 2 =*/282).fork()).ldelim();
            if (message.updateSecret != null && Object.hasOwnProperty.call(message, "updateSecret"))
                $root.request.UpdateSecret.encode(message.updateSecret, writer.uint32(/* id 36, wireType 2 =*/290).fork()).ldelim();
            if (message.listSecrets != null && Object.hasOwnProperty.call(message, "listSecrets"))
                $root.request.ListSecrets.encode(message.listSecrets, writer.uint32(/* id 37, wireType 2 =*/298).fork()).ldelim();
            if (message.listSecretSubkeys != null && Object.hasOwnProperty.call(message, "listSecretSubkeys"))
                $root.request.ListSecretSubkeys.encode(message.listSecretSubkeys, writer.uint32(/* id 38, wireType 2 =*/306).fork()).ldelim();
            if (message.undeleteSecret != null && Object.hasOwnProperty.call(message, "undeleteSecret"))
                $root.request.UndeleteSecret.encode(message.undeleteSecret, writer.uint32(/* id 39, wireType 2 =*/314).fork()).ldelim();
            if (message.destroySecret != null && Object.hasOwnProperty.call(message, "destroySecret"))
                $root.request.DestroySecret.encode(message.destroySecret, writer.uint32(/* id 40, wireType 2 =*/322).fork()).ldelim();
            if (message.addRole != null && Object.hasOwnProperty.call(message, "addRole"))
                $root.request.AddRole.encode(message.addRole, writer.uint32(/* id 41, wireType 2 =*/330).fork()).ldelim();
            if (message.removeRole != null && Object.hasOwnProperty.call(message, "removeRole"))
                $root.request.RemoveRole.encode(message.removeRole, writer.uint32(/* id 42, wireType 2 =*/338).fork()).ldelim();
            if (message.updateRole != null && Object.hasOwnProperty.call(message, "updateRole"))
                $root.request.UpdateRole.encode(message.updateRole, writer.uint32(/* id 43, wireType 2 =*/346).fork()).ldelim();
            if (message.listRoles != null && Object.hasOwnProperty.call(message, "listRoles"))
                $root.request.ListRoles.encode(message.listRoles, writer.uint32(/* id 44, wireType 2 =*/354).fork()).ldelim();
            if (message.addTeam != null && Object.hasOwnProperty.call(message, "addTeam"))
                $root.request.AddTeam.encode(message.addTeam, writer.uint32(/* id 45, wireType 2 =*/362).fork()).ldelim();
            if (message.removeTeam != null && Object.hasOwnProperty.call(message, "removeTeam"))
                $root.request.RemoveTeam.encode(message.removeTeam, writer.uint32(/* id 46, wireType 2 =*/370).fork()).ldelim();
            if (message.updateTeam != null && Object.hasOwnProperty.call(message, "updateTeam"))
                $root.request.UpdateTeam.encode(message.updateTeam, writer.uint32(/* id 47, wireType 2 =*/378).fork()).ldelim();
            if (message.listTeams != null && Object.hasOwnProperty.call(message, "listTeams"))
                $root.request.ListTeams.encode(message.listTeams, writer.uint32(/* id 48, wireType 2 =*/386).fork()).ldelim();
            if (message.isOperationAllowed != null && Object.hasOwnProperty.call(message, "isOperationAllowed"))
                $root.request.IsOperationAllowed.encode(message.isOperationAllowed, writer.uint32(/* id 49, wireType 2 =*/394).fork()).ldelim();
            if (message.moveFile != null && Object.hasOwnProperty.call(message, "moveFile"))
                $root.request.MoveFile.encode(message.moveFile, writer.uint32(/* id 50, wireType 2 =*/402).fork()).ldelim();
            if (message.moveFolder != null && Object.hasOwnProperty.call(message, "moveFolder"))
                $root.request.MoveFolder.encode(message.moveFolder, writer.uint32(/* id 51, wireType 2 =*/410).fork()).ldelim();
            if (message.copyFile != null && Object.hasOwnProperty.call(message, "copyFile"))
                $root.request.CopyFile.encode(message.copyFile, writer.uint32(/* id 52, wireType 2 =*/418).fork()).ldelim();
            if (message.copyFolder != null && Object.hasOwnProperty.call(message, "copyFolder"))
                $root.request.CopyFolder.encode(message.copyFolder, writer.uint32(/* id 53, wireType 2 =*/426).fork()).ldelim();
            if (message.restoreVersion != null && Object.hasOwnProperty.call(message, "restoreVersion"))
                $root.request.RestoreVersion.encode(message.restoreVersion, writer.uint32(/* id 54, wireType 2 =*/434).fork()).ldelim();
            if (message.removeFile != null && Object.hasOwnProperty.call(message, "removeFile"))
                $root.request.RemoveFile.encode(message.removeFile, writer.uint32(/* id 55, wireType 2 =*/442).fork()).ldelim();
            if (message.removeFolder != null && Object.hasOwnProperty.call(message, "removeFolder"))
                $root.request.RemoveFolder.encode(message.removeFolder, writer.uint32(/* id 56, wireType 2 =*/450).fork()).ldelim();
            if (message.untrashFile != null && Object.hasOwnProperty.call(message, "untrashFile"))
                $root.request.UntrashFile.encode(message.untrashFile, writer.uint32(/* id 57, wireType 2 =*/458).fork()).ldelim();
            if (message.untrashFolder != null && Object.hasOwnProperty.call(message, "untrashFolder"))
                $root.request.UntrashFolder.encode(message.untrashFolder, writer.uint32(/* id 58, wireType 2 =*/466).fork()).ldelim();
            if (message.undoStartWrite != null && Object.hasOwnProperty.call(message, "undoStartWrite"))
                $root.request.UndoStartWrite.encode(message.undoStartWrite, writer.uint32(/* id 59, wireType 2 =*/474).fork()).ldelim();
            if (message.detachClonedFolder != null && Object.hasOwnProperty.call(message, "detachClonedFolder"))
                $root.request.DetachClonedFolder.encode(message.detachClonedFolder, writer.uint32(/* id 60, wireType 2 =*/482).fork()).ldelim();
            if (message.getMetaFromPath != null && Object.hasOwnProperty.call(message, "getMetaFromPath"))
                $root.request.GetMetaFromPath.encode(message.getMetaFromPath, writer.uint32(/* id 61, wireType 2 =*/490).fork()).ldelim();
            if (message.renameFile != null && Object.hasOwnProperty.call(message, "renameFile"))
                $root.request.RenameFile.encode(message.renameFile, writer.uint32(/* id 62, wireType 2 =*/498).fork()).ldelim();
            if (message.renameFolder != null && Object.hasOwnProperty.call(message, "renameFolder"))
                $root.request.RenameFolder.encode(message.renameFolder, writer.uint32(/* id 63, wireType 2 =*/506).fork()).ldelim();
            if (message.list != null && Object.hasOwnProperty.call(message, "list"))
                $root.request.List.encode(message.list, writer.uint32(/* id 64, wireType 2 =*/514).fork()).ldelim();
            if (message.auditLogMessage != null && Object.hasOwnProperty.call(message, "auditLogMessage"))
                $root.request.AuditLogMessage.encode(message.auditLogMessage, writer.uint32(/* id 65, wireType 2 =*/522).fork()).ldelim();
            if (message.resetVersion != null && Object.hasOwnProperty.call(message, "resetVersion"))
                $root.request.ResetVersion.encode(message.resetVersion, writer.uint32(/* id 66, wireType 2 =*/530).fork()).ldelim();
            if (message.setUser != null && Object.hasOwnProperty.call(message, "setUser"))
                $root.request.SetUser.encode(message.setUser, writer.uint32(/* id 67, wireType 2 =*/538).fork()).ldelim();
            if (message.finalizeProfileWrite != null && Object.hasOwnProperty.call(message, "finalizeProfileWrite"))
                $root.request.FinalizeProfileWrite.encode(message.finalizeProfileWrite, writer.uint32(/* id 68, wireType 2 =*/546).fork()).ldelim();
            if (message.getProfileFileMeta != null && Object.hasOwnProperty.call(message, "getProfileFileMeta"))
                $root.request.GetProfileFileMeta.encode(message.getProfileFileMeta, writer.uint32(/* id 69, wireType 2 =*/554).fork()).ldelim();
            if (message.profileChunkList != null && Object.hasOwnProperty.call(message, "profileChunkList"))
                $root.request.ProfileChunkList.encode(message.profileChunkList, writer.uint32(/* id 70, wireType 2 =*/562).fork()).ldelim();
            if (message.getUserType != null && Object.hasOwnProperty.call(message, "getUserType"))
                $root.request.GetUserType.encode(message.getUserType, writer.uint32(/* id 71, wireType 2 =*/570).fork()).ldelim();
            if (message.getRandomBytes != null && Object.hasOwnProperty.call(message, "getRandomBytes"))
                $root.request.GetRandomBytes.encode(message.getRandomBytes, writer.uint32(/* id 72, wireType 2 =*/578).fork()).ldelim();
            if (message.share != null && Object.hasOwnProperty.call(message, "share"))
                $root.request.Share.encode(message.share, writer.uint32(/* id 73, wireType 2 =*/586).fork()).ldelim();
            if (message.unshare != null && Object.hasOwnProperty.call(message, "unshare"))
                $root.request.Unshare.encode(message.unshare, writer.uint32(/* id 74, wireType 2 =*/594).fork()).ldelim();
            if (message.updateShare != null && Object.hasOwnProperty.call(message, "updateShare"))
                $root.request.UpdateShare.encode(message.updateShare, writer.uint32(/* id 75, wireType 2 =*/602).fork()).ldelim();
            if (message.listShares != null && Object.hasOwnProperty.call(message, "listShares"))
                $root.request.ListShares.encode(message.listShares, writer.uint32(/* id 76, wireType 2 =*/610).fork()).ldelim();
            if (message.resetTOTP != null && Object.hasOwnProperty.call(message, "resetTOTP"))
                $root.request.ResetTOTP.encode(message.resetTOTP, writer.uint32(/* id 77, wireType 2 =*/618).fork()).ldelim();
            if (message.getTeam != null && Object.hasOwnProperty.call(message, "getTeam"))
                $root.request.GetTeam.encode(message.getTeam, writer.uint32(/* id 80, wireType 2 =*/642).fork()).ldelim();
            if (message.getRole != null && Object.hasOwnProperty.call(message, "getRole"))
                $root.request.GetRole.encode(message.getRole, writer.uint32(/* id 81, wireType 2 =*/650).fork()).ldelim();
            if (message.setRolesTeamsToUser != null && Object.hasOwnProperty.call(message, "setRolesTeamsToUser"))
                $root.request.SetRolesTeamsToUser.encode(message.setRolesTeamsToUser, writer.uint32(/* id 83, wireType 2 =*/666).fork()).ldelim();
            if (message.updatePinOps != null && Object.hasOwnProperty.call(message, "updatePinOps"))
                $root.request.UpdatePinOps.encode(message.updatePinOps, writer.uint32(/* id 84, wireType 2 =*/674).fork()).ldelim();
            if (message.deletePin != null && Object.hasOwnProperty.call(message, "deletePin"))
                $root.request.DeletePin.encode(message.deletePin, writer.uint32(/* id 85, wireType 2 =*/682).fork()).ldelim();
            if (message.getRolesAndTeamsOfUser != null && Object.hasOwnProperty.call(message, "getRolesAndTeamsOfUser"))
                $root.request.GetRolesAndTeamsOfUser.encode(message.getRolesAndTeamsOfUser, writer.uint32(/* id 86, wireType 2 =*/690).fork()).ldelim();
            if (message.quickListSecrets != null && Object.hasOwnProperty.call(message, "quickListSecrets"))
                $root.request.QuickListSecrets.encode(message.quickListSecrets, writer.uint32(/* id 87, wireType 2 =*/698).fork()).ldelim();
            if (message.restartPutChunk != null && Object.hasOwnProperty.call(message, "restartPutChunk"))
                $root.request.RestartPutChunk.encode(message.restartPutChunk, writer.uint32(/* id 88, wireType 2 =*/706).fork()).ldelim();
            if (message.verifyAuditLogMeta != null && Object.hasOwnProperty.call(message, "verifyAuditLogMeta"))
                $root.request.VerifyAuditLogMeta.encode(message.verifyAuditLogMeta, writer.uint32(/* id 89, wireType 2 =*/714).fork()).ldelim();
            if (message.getAuditLog != null && Object.hasOwnProperty.call(message, "getAuditLog"))
                $root.request.GetAuditLog.encode(message.getAuditLog, writer.uint32(/* id 90, wireType 2 =*/722).fork()).ldelim();
            if (message.deleteAuditLog != null && Object.hasOwnProperty.call(message, "deleteAuditLog"))
                $root.request.DeleteAuditLog.encode(message.deleteAuditLog, writer.uint32(/* id 91, wireType 2 =*/730).fork()).ldelim();
            if (message.getLedgerRange != null && Object.hasOwnProperty.call(message, "getLedgerRange"))
                $root.request.GetLedgerRange.encode(message.getLedgerRange, writer.uint32(/* id 92, wireType 2 =*/738).fork()).ldelim();
            if (message.listPins != null && Object.hasOwnProperty.call(message, "listPins"))
                $root.request.ListPins.encode(message.listPins, writer.uint32(/* id 93, wireType 2 =*/746).fork()).ldelim();
            if (message.getMetaFromSharedPath != null && Object.hasOwnProperty.call(message, "getMetaFromSharedPath"))
                $root.request.GetMetaFromSharedPath.encode(message.getMetaFromSharedPath, writer.uint32(/* id 94, wireType 2 =*/754).fork()).ldelim();
            if (message.listQuestions != null && Object.hasOwnProperty.call(message, "listQuestions"))
                $root.request.ListQuestions.encode(message.listQuestions, writer.uint32(/* id 95, wireType 2 =*/762).fork()).ldelim();
            if (message.verifyBYOSCreds != null && Object.hasOwnProperty.call(message, "verifyBYOSCreds"))
                $root.request.VerifyBYOSCreds.encode(message.verifyBYOSCreds, writer.uint32(/* id 96, wireType 2 =*/770).fork()).ldelim();
            if (message.migrateToStorage != null && Object.hasOwnProperty.call(message, "migrateToStorage"))
                $root.request.MigrateToStorage.encode(message.migrateToStorage, writer.uint32(/* id 97, wireType 2 =*/778).fork()).ldelim();
            if (message.updateStorageCreds != null && Object.hasOwnProperty.call(message, "updateStorageCreds"))
                $root.request.UpdateStorageCreds.encode(message.updateStorageCreds, writer.uint32(/* id 98, wireType 2 =*/786).fork()).ldelim();
            if (message.verifyUserForAudit != null && Object.hasOwnProperty.call(message, "verifyUserForAudit"))
                $root.request.VerifyUserForAudit.encode(message.verifyUserForAudit, writer.uint32(/* id 99, wireType 2 =*/794).fork()).ldelim();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 100, wireType 0 =*/800).uint64(message.id);
            if (message.removeOrganizationUser != null && Object.hasOwnProperty.call(message, "removeOrganizationUser"))
                $root.request.RemoveOrganizationUser.encode(message.removeOrganizationUser, writer.uint32(/* id 101, wireType 2 =*/810).fork()).ldelim();
            if (message.reqCreateTime != null && Object.hasOwnProperty.call(message, "reqCreateTime"))
                writer.uint32(/* id 102, wireType 0 =*/816).uint64(message.reqCreateTime);
            if (message.addSpace != null && Object.hasOwnProperty.call(message, "addSpace"))
                $root.request.AddSpace.encode(message.addSpace, writer.uint32(/* id 104, wireType 2 =*/834).fork()).ldelim();
            if (message.addUserToSpace != null && Object.hasOwnProperty.call(message, "addUserToSpace"))
                $root.request.AddUserToSpace.encode(message.addUserToSpace, writer.uint32(/* id 105, wireType 2 =*/842).fork()).ldelim();
            if (message.removeUserFromSpace != null && Object.hasOwnProperty.call(message, "removeUserFromSpace"))
                $root.request.RemoveUserFromSpace.encode(message.removeUserFromSpace, writer.uint32(/* id 106, wireType 2 =*/850).fork()).ldelim();
            if (message.updatePermissionsOfSpace != null && Object.hasOwnProperty.call(message, "updatePermissionsOfSpace"))
                $root.request.UpdatePermissionsOfSpace.encode(message.updatePermissionsOfSpace, writer.uint32(/* id 107, wireType 2 =*/858).fork()).ldelim();
            if (message.addObjectToSpace != null && Object.hasOwnProperty.call(message, "addObjectToSpace"))
                $root.request.AddObjectToSpace.encode(message.addObjectToSpace, writer.uint32(/* id 108, wireType 2 =*/866).fork()).ldelim();
            if (message.removeObjectFromSpace != null && Object.hasOwnProperty.call(message, "removeObjectFromSpace"))
                $root.request.RemoveObjectFromSpace.encode(message.removeObjectFromSpace, writer.uint32(/* id 109, wireType 2 =*/874).fork()).ldelim();
            if (message.removeSpace != null && Object.hasOwnProperty.call(message, "removeSpace"))
                $root.request.RemoveSpace.encode(message.removeSpace, writer.uint32(/* id 110, wireType 2 =*/882).fork()).ldelim();
            if (message.sendOtpToExternalUser != null && Object.hasOwnProperty.call(message, "sendOtpToExternalUser"))
                $root.request.SendOtpToExternalUser.encode(message.sendOtpToExternalUser, writer.uint32(/* id 111, wireType 2 =*/890).fork()).ldelim();
            if (message.signInToSpace != null && Object.hasOwnProperty.call(message, "signInToSpace"))
                $root.request.SignInToSpace.encode(message.signInToSpace, writer.uint32(/* id 112, wireType 2 =*/898).fork()).ldelim();
            if (message.listSpaces != null && Object.hasOwnProperty.call(message, "listSpaces"))
                $root.request.ListSpaces.encode(message.listSpaces, writer.uint32(/* id 113, wireType 2 =*/906).fork()).ldelim();
            if (message.sendOtpToExternalUserIfNotExist != null && Object.hasOwnProperty.call(message, "sendOtpToExternalUserIfNotExist"))
                $root.request.SendOtpToExternalUserIfNotExist.encode(message.sendOtpToExternalUserIfNotExist, writer.uint32(/* id 114, wireType 2 =*/914).fork()).ldelim();
            if (message.getStorageValue != null && Object.hasOwnProperty.call(message, "getStorageValue"))
                $root.request.GetStorageValue.encode(message.getStorageValue, writer.uint32(/* id 115, wireType 2 =*/922).fork()).ldelim();
            if (message.updateTags != null && Object.hasOwnProperty.call(message, "updateTags"))
                $root.request.UpdateTags.encode(message.updateTags, writer.uint32(/* id 116, wireType 2 =*/930).fork()).ldelim();
            if (message.addComment != null && Object.hasOwnProperty.call(message, "addComment"))
                $root.request.AddComment.encode(message.addComment, writer.uint32(/* id 117, wireType 2 =*/938).fork()).ldelim();
            if (message.removeComment != null && Object.hasOwnProperty.call(message, "removeComment"))
                $root.request.RemoveComment.encode(message.removeComment, writer.uint32(/* id 118, wireType 2 =*/946).fork()).ldelim();
            if (message.listComments != null && Object.hasOwnProperty.call(message, "listComments"))
                $root.request.ListComments.encode(message.listComments, writer.uint32(/* id 119, wireType 2 =*/954).fork()).ldelim();
            if (message.updateComment != null && Object.hasOwnProperty.call(message, "updateComment"))
                $root.request.UpdateComment.encode(message.updateComment, writer.uint32(/* id 120, wireType 2 =*/962).fork()).ldelim();
            if (message.getComment != null && Object.hasOwnProperty.call(message, "getComment"))
                $root.request.GetComment.encode(message.getComment, writer.uint32(/* id 121, wireType 2 =*/970).fork()).ldelim();
            if (message.sessionData != null && Object.hasOwnProperty.call(message, "sessionData"))
                $root.request.SessionData.encode(message.sessionData, writer.uint32(/* id 122, wireType 2 =*/978).fork()).ldelim();
            if (message.getStorageCreds != null && Object.hasOwnProperty.call(message, "getStorageCreds"))
                $root.request.GetStorageCreds.encode(message.getStorageCreds, writer.uint32(/* id 123, wireType 2 =*/986).fork()).ldelim();
            if (message.listPlans != null && Object.hasOwnProperty.call(message, "listPlans"))
                $root.request.ListPlans.encode(message.listPlans, writer.uint32(/* id 124, wireType 2 =*/994).fork()).ldelim();
            if (message.upgradePlan != null && Object.hasOwnProperty.call(message, "upgradePlan"))
                $root.request.UpgradePlan.encode(message.upgradePlan, writer.uint32(/* id 125, wireType 2 =*/1002).fork()).ldelim();
            if (message.validateCoupon != null && Object.hasOwnProperty.call(message, "validateCoupon"))
                $root.request.ValidateCoupon.encode(message.validateCoupon, writer.uint32(/* id 126, wireType 2 =*/1010).fork()).ldelim();
            if (message.getPlan != null && Object.hasOwnProperty.call(message, "getPlan"))
                $root.request.GetPlan.encode(message.getPlan, writer.uint32(/* id 127, wireType 2 =*/1018).fork()).ldelim();
            if (message.removeVersion != null && Object.hasOwnProperty.call(message, "removeVersion"))
                $root.request.RemoveVersion.encode(message.removeVersion, writer.uint32(/* id 128, wireType 2 =*/1026).fork()).ldelim();
            if (message.getProfilePictureOfUser != null && Object.hasOwnProperty.call(message, "getProfilePictureOfUser"))
                $root.request.GetProfilePictureOfUser.encode(message.getProfilePictureOfUser, writer.uint32(/* id 129, wireType 2 =*/1034).fork()).ldelim();
            if (message.emptyTrash != null && Object.hasOwnProperty.call(message, "emptyTrash"))
                $root.request.EmptyTrash.encode(message.emptyTrash, writer.uint32(/* id 130, wireType 2 =*/1042).fork()).ldelim();
            if (message.setThumbnail != null && Object.hasOwnProperty.call(message, "setThumbnail"))
                $root.request.SetThumbnail.encode(message.setThumbnail, writer.uint32(/* id 131, wireType 2 =*/1050).fork()).ldelim();
            if (message.getThumbnail != null && Object.hasOwnProperty.call(message, "getThumbnail"))
                $root.request.GetThumbnail.encode(message.getThumbnail, writer.uint32(/* id 132, wireType 2 =*/1058).fork()).ldelim();
            if (message.blockUser != null && Object.hasOwnProperty.call(message, "blockUser"))
                $root.request.BlockUser.encode(message.blockUser, writer.uint32(/* id 133, wireType 2 =*/1066).fork()).ldelim();
            if (message.unblockUser != null && Object.hasOwnProperty.call(message, "unblockUser"))
                $root.request.UnblockUser.encode(message.unblockUser, writer.uint32(/* id 134, wireType 2 =*/1074).fork()).ldelim();
            if (message.updateOrgSettings != null && Object.hasOwnProperty.call(message, "updateOrgSettings"))
                $root.request.UpdateOrgSettings.encode(message.updateOrgSettings, writer.uint32(/* id 135, wireType 2 =*/1082).fork()).ldelim();
            if (message.getOrgSettings != null && Object.hasOwnProperty.call(message, "getOrgSettings"))
                $root.request.GetOrgSettings.encode(message.getOrgSettings, writer.uint32(/* id 136, wireType 2 =*/1090).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified Request message, length delimited. Does not implicitly {@link request.Request.verify|verify} messages.
         * @function encodeDelimited
         * @memberof request.Request
         * @static
         * @param {request.IRequest} message Request message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Request.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Request message from the specified reader or buffer.
         * @function decode
         * @memberof request.Request
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {request.Request} Request
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Request.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.request.Request();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 102: {
                        message.reqCreateTime = reader.uint64();
                        break;
                    }
                case 100: {
                        message.id = reader.uint64();
                        break;
                    }
                case 1: {
                        message.addUser = $root.request.AddUser.decode(reader, reader.uint32());
                        break;
                    }
                case 2: {
                        message.removeUser = $root.request.RemoveUser.decode(reader, reader.uint32());
                        break;
                    }
                case 3: {
                        message.passwordReset = $root.request.PasswordReset.decode(reader, reader.uint32());
                        break;
                    }
                case 4: {
                        message.changePassword = $root.request.ChangePassword.decode(reader, reader.uint32());
                        break;
                    }
                case 5: {
                        message.addOrganization = $root.request.AddOrganization.decode(reader, reader.uint32());
                        break;
                    }
                case 6: {
                        message.initiatePayment = $root.request.InitiatePayment.decode(reader, reader.uint32());
                        break;
                    }
                case 7: {
                        message.signIn = $root.request.SignIn.decode(reader, reader.uint32());
                        break;
                    }
                case 8: {
                        message.signOut = $root.request.SignOut.decode(reader, reader.uint32());
                        break;
                    }
                case 9: {
                        message.inviteUser = $root.request.InviteUser.decode(reader, reader.uint32());
                        break;
                    }
                case 10: {
                        message.getUser = $root.request.GetUser.decode(reader, reader.uint32());
                        break;
                    }
                case 11: {
                        message.listUsers = $root.request.ListUsers.decode(reader, reader.uint32());
                        break;
                    }
                case 12: {
                        message.removeOrganization = $root.request.RemoveOrganization.decode(reader, reader.uint32());
                        break;
                    }
                case 13: {
                        message.verifyOrganization = $root.request.VerifyOrganization.decode(reader, reader.uint32());
                        break;
                    }
                case 14: {
                        message.getOrganization = $root.request.GetOrganization.decode(reader, reader.uint32());
                        break;
                    }
                case 15: {
                        message.addPin = $root.request.AddPin.decode(reader, reader.uint32());
                        break;
                    }
                case 16: {
                        message.verifyUser = $root.request.VerifyUser.decode(reader, reader.uint32());
                        break;
                    }
                case 17: {
                        message.getFileHead = $root.request.GetFileHead.decode(reader, reader.uint32());
                        break;
                    }
                case 18: {
                        message.echo = $root.request.Echo.decode(reader, reader.uint32());
                        break;
                    }
                case 19: {
                        message.fileLock = $root.request.FileLock.decode(reader, reader.uint32());
                        break;
                    }
                case 20: {
                        message.fileUnlock = $root.request.FileUnlock.decode(reader, reader.uint32());
                        break;
                    }
                case 21: {
                        message.getChunk = $root.request.GetChunk.decode(reader, reader.uint32());
                        break;
                    }
                case 22: {
                        message.startWrite = $root.request.StartWrite.decode(reader, reader.uint32());
                        break;
                    }
                case 23: {
                        message.putChunk = $root.request.PutChunk.decode(reader, reader.uint32());
                        break;
                    }
                case 24: {
                        message.finalizeWrite = $root.request.FinalizeWrite.decode(reader, reader.uint32());
                        break;
                    }
                case 25: {
                        message.listFiles = $root.request.ListFiles.decode(reader, reader.uint32());
                        break;
                    }
                case 26: {
                        message.remove = $root.request.Remove.decode(reader, reader.uint32());
                        break;
                    }
                case 29: {
                        message.getFolder = $root.request.GetFolder.decode(reader, reader.uint32());
                        break;
                    }
                case 30: {
                        message.createFolder = $root.request.CreateFolder.decode(reader, reader.uint32());
                        break;
                    }
                case 31: {
                        message.CreateSnapshot = $root.request.CreateSnapshot.decode(reader, reader.uint32());
                        break;
                    }
                case 32: {
                        message.VerifyPayment = $root.request.VerifyPayment.decode(reader, reader.uint32());
                        break;
                    }
                case 33: {
                        message.getSecret = $root.request.GetSecret.decode(reader, reader.uint32());
                        break;
                    }
                case 34: {
                        message.addSecret = $root.request.AddSecret.decode(reader, reader.uint32());
                        break;
                    }
                case 35: {
                        message.deleteSecret = $root.request.DeleteSecret.decode(reader, reader.uint32());
                        break;
                    }
                case 36: {
                        message.updateSecret = $root.request.UpdateSecret.decode(reader, reader.uint32());
                        break;
                    }
                case 37: {
                        message.listSecrets = $root.request.ListSecrets.decode(reader, reader.uint32());
                        break;
                    }
                case 87: {
                        message.quickListSecrets = $root.request.QuickListSecrets.decode(reader, reader.uint32());
                        break;
                    }
                case 38: {
                        message.listSecretSubkeys = $root.request.ListSecretSubkeys.decode(reader, reader.uint32());
                        break;
                    }
                case 39: {
                        message.undeleteSecret = $root.request.UndeleteSecret.decode(reader, reader.uint32());
                        break;
                    }
                case 40: {
                        message.destroySecret = $root.request.DestroySecret.decode(reader, reader.uint32());
                        break;
                    }
                case 41: {
                        message.addRole = $root.request.AddRole.decode(reader, reader.uint32());
                        break;
                    }
                case 42: {
                        message.removeRole = $root.request.RemoveRole.decode(reader, reader.uint32());
                        break;
                    }
                case 43: {
                        message.updateRole = $root.request.UpdateRole.decode(reader, reader.uint32());
                        break;
                    }
                case 44: {
                        message.listRoles = $root.request.ListRoles.decode(reader, reader.uint32());
                        break;
                    }
                case 81: {
                        message.getRole = $root.request.GetRole.decode(reader, reader.uint32());
                        break;
                    }
                case 45: {
                        message.addTeam = $root.request.AddTeam.decode(reader, reader.uint32());
                        break;
                    }
                case 46: {
                        message.removeTeam = $root.request.RemoveTeam.decode(reader, reader.uint32());
                        break;
                    }
                case 47: {
                        message.updateTeam = $root.request.UpdateTeam.decode(reader, reader.uint32());
                        break;
                    }
                case 48: {
                        message.listTeams = $root.request.ListTeams.decode(reader, reader.uint32());
                        break;
                    }
                case 80: {
                        message.getTeam = $root.request.GetTeam.decode(reader, reader.uint32());
                        break;
                    }
                case 49: {
                        message.isOperationAllowed = $root.request.IsOperationAllowed.decode(reader, reader.uint32());
                        break;
                    }
                case 50: {
                        message.moveFile = $root.request.MoveFile.decode(reader, reader.uint32());
                        break;
                    }
                case 51: {
                        message.moveFolder = $root.request.MoveFolder.decode(reader, reader.uint32());
                        break;
                    }
                case 52: {
                        message.copyFile = $root.request.CopyFile.decode(reader, reader.uint32());
                        break;
                    }
                case 53: {
                        message.copyFolder = $root.request.CopyFolder.decode(reader, reader.uint32());
                        break;
                    }
                case 54: {
                        message.restoreVersion = $root.request.RestoreVersion.decode(reader, reader.uint32());
                        break;
                    }
                case 55: {
                        message.removeFile = $root.request.RemoveFile.decode(reader, reader.uint32());
                        break;
                    }
                case 56: {
                        message.removeFolder = $root.request.RemoveFolder.decode(reader, reader.uint32());
                        break;
                    }
                case 57: {
                        message.untrashFile = $root.request.UntrashFile.decode(reader, reader.uint32());
                        break;
                    }
                case 58: {
                        message.untrashFolder = $root.request.UntrashFolder.decode(reader, reader.uint32());
                        break;
                    }
                case 59: {
                        message.undoStartWrite = $root.request.UndoStartWrite.decode(reader, reader.uint32());
                        break;
                    }
                case 60: {
                        message.detachClonedFolder = $root.request.DetachClonedFolder.decode(reader, reader.uint32());
                        break;
                    }
                case 61: {
                        message.getMetaFromPath = $root.request.GetMetaFromPath.decode(reader, reader.uint32());
                        break;
                    }
                case 62: {
                        message.renameFile = $root.request.RenameFile.decode(reader, reader.uint32());
                        break;
                    }
                case 63: {
                        message.renameFolder = $root.request.RenameFolder.decode(reader, reader.uint32());
                        break;
                    }
                case 64: {
                        message.list = $root.request.List.decode(reader, reader.uint32());
                        break;
                    }
                case 65: {
                        message.auditLogMessage = $root.request.AuditLogMessage.decode(reader, reader.uint32());
                        break;
                    }
                case 66: {
                        message.resetVersion = $root.request.ResetVersion.decode(reader, reader.uint32());
                        break;
                    }
                case 67: {
                        message.setUser = $root.request.SetUser.decode(reader, reader.uint32());
                        break;
                    }
                case 68: {
                        message.finalizeProfileWrite = $root.request.FinalizeProfileWrite.decode(reader, reader.uint32());
                        break;
                    }
                case 69: {
                        message.getProfileFileMeta = $root.request.GetProfileFileMeta.decode(reader, reader.uint32());
                        break;
                    }
                case 70: {
                        message.profileChunkList = $root.request.ProfileChunkList.decode(reader, reader.uint32());
                        break;
                    }
                case 71: {
                        message.getUserType = $root.request.GetUserType.decode(reader, reader.uint32());
                        break;
                    }
                case 72: {
                        message.getRandomBytes = $root.request.GetRandomBytes.decode(reader, reader.uint32());
                        break;
                    }
                case 73: {
                        message.share = $root.request.Share.decode(reader, reader.uint32());
                        break;
                    }
                case 74: {
                        message.unshare = $root.request.Unshare.decode(reader, reader.uint32());
                        break;
                    }
                case 75: {
                        message.updateShare = $root.request.UpdateShare.decode(reader, reader.uint32());
                        break;
                    }
                case 76: {
                        message.listShares = $root.request.ListShares.decode(reader, reader.uint32());
                        break;
                    }
                case 77: {
                        message.resetTOTP = $root.request.ResetTOTP.decode(reader, reader.uint32());
                        break;
                    }
                case 83: {
                        message.setRolesTeamsToUser = $root.request.SetRolesTeamsToUser.decode(reader, reader.uint32());
                        break;
                    }
                case 84: {
                        message.updatePinOps = $root.request.UpdatePinOps.decode(reader, reader.uint32());
                        break;
                    }
                case 85: {
                        message.deletePin = $root.request.DeletePin.decode(reader, reader.uint32());
                        break;
                    }
                case 86: {
                        message.getRolesAndTeamsOfUser = $root.request.GetRolesAndTeamsOfUser.decode(reader, reader.uint32());
                        break;
                    }
                case 88: {
                        message.restartPutChunk = $root.request.RestartPutChunk.decode(reader, reader.uint32());
                        break;
                    }
                case 89: {
                        message.verifyAuditLogMeta = $root.request.VerifyAuditLogMeta.decode(reader, reader.uint32());
                        break;
                    }
                case 90: {
                        message.getAuditLog = $root.request.GetAuditLog.decode(reader, reader.uint32());
                        break;
                    }
                case 91: {
                        message.deleteAuditLog = $root.request.DeleteAuditLog.decode(reader, reader.uint32());
                        break;
                    }
                case 92: {
                        message.getLedgerRange = $root.request.GetLedgerRange.decode(reader, reader.uint32());
                        break;
                    }
                case 93: {
                        message.listPins = $root.request.ListPins.decode(reader, reader.uint32());
                        break;
                    }
                case 94: {
                        message.getMetaFromSharedPath = $root.request.GetMetaFromSharedPath.decode(reader, reader.uint32());
                        break;
                    }
                case 95: {
                        message.listQuestions = $root.request.ListQuestions.decode(reader, reader.uint32());
                        break;
                    }
                case 96: {
                        message.verifyBYOSCreds = $root.request.VerifyBYOSCreds.decode(reader, reader.uint32());
                        break;
                    }
                case 97: {
                        message.migrateToStorage = $root.request.MigrateToStorage.decode(reader, reader.uint32());
                        break;
                    }
                case 98: {
                        message.updateStorageCreds = $root.request.UpdateStorageCreds.decode(reader, reader.uint32());
                        break;
                    }
                case 99: {
                        message.verifyUserForAudit = $root.request.VerifyUserForAudit.decode(reader, reader.uint32());
                        break;
                    }
                case 101: {
                        message.removeOrganizationUser = $root.request.RemoveOrganizationUser.decode(reader, reader.uint32());
                        break;
                    }
                case 104: {
                        message.addSpace = $root.request.AddSpace.decode(reader, reader.uint32());
                        break;
                    }
                case 105: {
                        message.addUserToSpace = $root.request.AddUserToSpace.decode(reader, reader.uint32());
                        break;
                    }
                case 106: {
                        message.removeUserFromSpace = $root.request.RemoveUserFromSpace.decode(reader, reader.uint32());
                        break;
                    }
                case 107: {
                        message.updatePermissionsOfSpace = $root.request.UpdatePermissionsOfSpace.decode(reader, reader.uint32());
                        break;
                    }
                case 108: {
                        message.addObjectToSpace = $root.request.AddObjectToSpace.decode(reader, reader.uint32());
                        break;
                    }
                case 109: {
                        message.removeObjectFromSpace = $root.request.RemoveObjectFromSpace.decode(reader, reader.uint32());
                        break;
                    }
                case 110: {
                        message.removeSpace = $root.request.RemoveSpace.decode(reader, reader.uint32());
                        break;
                    }
                case 111: {
                        message.sendOtpToExternalUser = $root.request.SendOtpToExternalUser.decode(reader, reader.uint32());
                        break;
                    }
                case 112: {
                        message.signInToSpace = $root.request.SignInToSpace.decode(reader, reader.uint32());
                        break;
                    }
                case 113: {
                        message.listSpaces = $root.request.ListSpaces.decode(reader, reader.uint32());
                        break;
                    }
                case 114: {
                        message.sendOtpToExternalUserIfNotExist = $root.request.SendOtpToExternalUserIfNotExist.decode(reader, reader.uint32());
                        break;
                    }
                case 115: {
                        message.getStorageValue = $root.request.GetStorageValue.decode(reader, reader.uint32());
                        break;
                    }
                case 116: {
                        message.updateTags = $root.request.UpdateTags.decode(reader, reader.uint32());
                        break;
                    }
                case 117: {
                        message.addComment = $root.request.AddComment.decode(reader, reader.uint32());
                        break;
                    }
                case 118: {
                        message.removeComment = $root.request.RemoveComment.decode(reader, reader.uint32());
                        break;
                    }
                case 119: {
                        message.listComments = $root.request.ListComments.decode(reader, reader.uint32());
                        break;
                    }
                case 120: {
                        message.updateComment = $root.request.UpdateComment.decode(reader, reader.uint32());
                        break;
                    }
                case 121: {
                        message.getComment = $root.request.GetComment.decode(reader, reader.uint32());
                        break;
                    }
                case 122: {
                        message.sessionData = $root.request.SessionData.decode(reader, reader.uint32());
                        break;
                    }
                case 123: {
                        message.getStorageCreds = $root.request.GetStorageCreds.decode(reader, reader.uint32());
                        break;
                    }
                case 127: {
                        message.getPlan = $root.request.GetPlan.decode(reader, reader.uint32());
                        break;
                    }
                case 124: {
                        message.listPlans = $root.request.ListPlans.decode(reader, reader.uint32());
                        break;
                    }
                case 125: {
                        message.upgradePlan = $root.request.UpgradePlan.decode(reader, reader.uint32());
                        break;
                    }
                case 126: {
                        message.validateCoupon = $root.request.ValidateCoupon.decode(reader, reader.uint32());
                        break;
                    }
                case 128: {
                        message.removeVersion = $root.request.RemoveVersion.decode(reader, reader.uint32());
                        break;
                    }
                case 129: {
                        message.getProfilePictureOfUser = $root.request.GetProfilePictureOfUser.decode(reader, reader.uint32());
                        break;
                    }
                case 130: {
                        message.emptyTrash = $root.request.EmptyTrash.decode(reader, reader.uint32());
                        break;
                    }
                case 131: {
                        message.setThumbnail = $root.request.SetThumbnail.decode(reader, reader.uint32());
                        break;
                    }
                case 132: {
                        message.getThumbnail = $root.request.GetThumbnail.decode(reader, reader.uint32());
                        break;
                    }
                case 133: {
                        message.blockUser = $root.request.BlockUser.decode(reader, reader.uint32());
                        break;
                    }
                case 134: {
                        message.unblockUser = $root.request.UnblockUser.decode(reader, reader.uint32());
                        break;
                    }
                case 135: {
                        message.updateOrgSettings = $root.request.UpdateOrgSettings.decode(reader, reader.uint32());
                        break;
                    }
                case 136: {
                        message.getOrgSettings = $root.request.GetOrgSettings.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Request message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof request.Request
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {request.Request} Request
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Request.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Request message.
         * @function verify
         * @memberof request.Request
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Request.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.reqCreateTime != null && message.hasOwnProperty("reqCreateTime"))
                if (!$util.isInteger(message.reqCreateTime) && !(message.reqCreateTime && $util.isInteger(message.reqCreateTime.low) && $util.isInteger(message.reqCreateTime.high)))
                    return "reqCreateTime: integer|Long expected";
            if (message.id != null && message.hasOwnProperty("id")) {
                properties._id = 1;
                if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                    return "id: integer|Long expected";
            }
            if (message.addUser != null && message.hasOwnProperty("addUser")) {
                properties.Operation = 1;
                {
                    let error = $root.request.AddUser.verify(message.addUser);
                    if (error)
                        return "addUser." + error;
                }
            }
            if (message.removeUser != null && message.hasOwnProperty("removeUser")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.RemoveUser.verify(message.removeUser);
                    if (error)
                        return "removeUser." + error;
                }
            }
            if (message.passwordReset != null && message.hasOwnProperty("passwordReset")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.PasswordReset.verify(message.passwordReset);
                    if (error)
                        return "passwordReset." + error;
                }
            }
            if (message.changePassword != null && message.hasOwnProperty("changePassword")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.ChangePassword.verify(message.changePassword);
                    if (error)
                        return "changePassword." + error;
                }
            }
            if (message.addOrganization != null && message.hasOwnProperty("addOrganization")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.AddOrganization.verify(message.addOrganization);
                    if (error)
                        return "addOrganization." + error;
                }
            }
            if (message.initiatePayment != null && message.hasOwnProperty("initiatePayment")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.InitiatePayment.verify(message.initiatePayment);
                    if (error)
                        return "initiatePayment." + error;
                }
            }
            if (message.signIn != null && message.hasOwnProperty("signIn")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.SignIn.verify(message.signIn);
                    if (error)
                        return "signIn." + error;
                }
            }
            if (message.signOut != null && message.hasOwnProperty("signOut")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.SignOut.verify(message.signOut);
                    if (error)
                        return "signOut." + error;
                }
            }
            if (message.inviteUser != null && message.hasOwnProperty("inviteUser")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.InviteUser.verify(message.inviteUser);
                    if (error)
                        return "inviteUser." + error;
                }
            }
            if (message.getUser != null && message.hasOwnProperty("getUser")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.GetUser.verify(message.getUser);
                    if (error)
                        return "getUser." + error;
                }
            }
            if (message.listUsers != null && message.hasOwnProperty("listUsers")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.ListUsers.verify(message.listUsers);
                    if (error)
                        return "listUsers." + error;
                }
            }
            if (message.removeOrganization != null && message.hasOwnProperty("removeOrganization")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.RemoveOrganization.verify(message.removeOrganization);
                    if (error)
                        return "removeOrganization." + error;
                }
            }
            if (message.verifyOrganization != null && message.hasOwnProperty("verifyOrganization")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.VerifyOrganization.verify(message.verifyOrganization);
                    if (error)
                        return "verifyOrganization." + error;
                }
            }
            if (message.getOrganization != null && message.hasOwnProperty("getOrganization")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.GetOrganization.verify(message.getOrganization);
                    if (error)
                        return "getOrganization." + error;
                }
            }
            if (message.addPin != null && message.hasOwnProperty("addPin")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.AddPin.verify(message.addPin);
                    if (error)
                        return "addPin." + error;
                }
            }
            if (message.verifyUser != null && message.hasOwnProperty("verifyUser")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.VerifyUser.verify(message.verifyUser);
                    if (error)
                        return "verifyUser." + error;
                }
            }
            if (message.getFileHead != null && message.hasOwnProperty("getFileHead")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.GetFileHead.verify(message.getFileHead);
                    if (error)
                        return "getFileHead." + error;
                }
            }
            if (message.echo != null && message.hasOwnProperty("echo")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.Echo.verify(message.echo);
                    if (error)
                        return "echo." + error;
                }
            }
            if (message.fileLock != null && message.hasOwnProperty("fileLock")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.FileLock.verify(message.fileLock);
                    if (error)
                        return "fileLock." + error;
                }
            }
            if (message.fileUnlock != null && message.hasOwnProperty("fileUnlock")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.FileUnlock.verify(message.fileUnlock);
                    if (error)
                        return "fileUnlock." + error;
                }
            }
            if (message.getChunk != null && message.hasOwnProperty("getChunk")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.GetChunk.verify(message.getChunk);
                    if (error)
                        return "getChunk." + error;
                }
            }
            if (message.startWrite != null && message.hasOwnProperty("startWrite")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.StartWrite.verify(message.startWrite);
                    if (error)
                        return "startWrite." + error;
                }
            }
            if (message.putChunk != null && message.hasOwnProperty("putChunk")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.PutChunk.verify(message.putChunk);
                    if (error)
                        return "putChunk." + error;
                }
            }
            if (message.finalizeWrite != null && message.hasOwnProperty("finalizeWrite")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.FinalizeWrite.verify(message.finalizeWrite);
                    if (error)
                        return "finalizeWrite." + error;
                }
            }
            if (message.listFiles != null && message.hasOwnProperty("listFiles")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.ListFiles.verify(message.listFiles);
                    if (error)
                        return "listFiles." + error;
                }
            }
            if (message.remove != null && message.hasOwnProperty("remove")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.Remove.verify(message.remove);
                    if (error)
                        return "remove." + error;
                }
            }
            if (message.getFolder != null && message.hasOwnProperty("getFolder")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.GetFolder.verify(message.getFolder);
                    if (error)
                        return "getFolder." + error;
                }
            }
            if (message.createFolder != null && message.hasOwnProperty("createFolder")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.CreateFolder.verify(message.createFolder);
                    if (error)
                        return "createFolder." + error;
                }
            }
            if (message.CreateSnapshot != null && message.hasOwnProperty("CreateSnapshot")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.CreateSnapshot.verify(message.CreateSnapshot);
                    if (error)
                        return "CreateSnapshot." + error;
                }
            }
            if (message.VerifyPayment != null && message.hasOwnProperty("VerifyPayment")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.VerifyPayment.verify(message.VerifyPayment);
                    if (error)
                        return "VerifyPayment." + error;
                }
            }
            if (message.getSecret != null && message.hasOwnProperty("getSecret")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.GetSecret.verify(message.getSecret);
                    if (error)
                        return "getSecret." + error;
                }
            }
            if (message.addSecret != null && message.hasOwnProperty("addSecret")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.AddSecret.verify(message.addSecret);
                    if (error)
                        return "addSecret." + error;
                }
            }
            if (message.deleteSecret != null && message.hasOwnProperty("deleteSecret")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.DeleteSecret.verify(message.deleteSecret);
                    if (error)
                        return "deleteSecret." + error;
                }
            }
            if (message.updateSecret != null && message.hasOwnProperty("updateSecret")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.UpdateSecret.verify(message.updateSecret);
                    if (error)
                        return "updateSecret." + error;
                }
            }
            if (message.listSecrets != null && message.hasOwnProperty("listSecrets")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.ListSecrets.verify(message.listSecrets);
                    if (error)
                        return "listSecrets." + error;
                }
            }
            if (message.quickListSecrets != null && message.hasOwnProperty("quickListSecrets")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.QuickListSecrets.verify(message.quickListSecrets);
                    if (error)
                        return "quickListSecrets." + error;
                }
            }
            if (message.listSecretSubkeys != null && message.hasOwnProperty("listSecretSubkeys")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.ListSecretSubkeys.verify(message.listSecretSubkeys);
                    if (error)
                        return "listSecretSubkeys." + error;
                }
            }
            if (message.undeleteSecret != null && message.hasOwnProperty("undeleteSecret")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.UndeleteSecret.verify(message.undeleteSecret);
                    if (error)
                        return "undeleteSecret." + error;
                }
            }
            if (message.destroySecret != null && message.hasOwnProperty("destroySecret")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.DestroySecret.verify(message.destroySecret);
                    if (error)
                        return "destroySecret." + error;
                }
            }
            if (message.addRole != null && message.hasOwnProperty("addRole")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.AddRole.verify(message.addRole);
                    if (error)
                        return "addRole." + error;
                }
            }
            if (message.removeRole != null && message.hasOwnProperty("removeRole")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.RemoveRole.verify(message.removeRole);
                    if (error)
                        return "removeRole." + error;
                }
            }
            if (message.updateRole != null && message.hasOwnProperty("updateRole")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.UpdateRole.verify(message.updateRole);
                    if (error)
                        return "updateRole." + error;
                }
            }
            if (message.listRoles != null && message.hasOwnProperty("listRoles")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.ListRoles.verify(message.listRoles);
                    if (error)
                        return "listRoles." + error;
                }
            }
            if (message.getRole != null && message.hasOwnProperty("getRole")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.GetRole.verify(message.getRole);
                    if (error)
                        return "getRole." + error;
                }
            }
            if (message.addTeam != null && message.hasOwnProperty("addTeam")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.AddTeam.verify(message.addTeam);
                    if (error)
                        return "addTeam." + error;
                }
            }
            if (message.removeTeam != null && message.hasOwnProperty("removeTeam")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.RemoveTeam.verify(message.removeTeam);
                    if (error)
                        return "removeTeam." + error;
                }
            }
            if (message.updateTeam != null && message.hasOwnProperty("updateTeam")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.UpdateTeam.verify(message.updateTeam);
                    if (error)
                        return "updateTeam." + error;
                }
            }
            if (message.listTeams != null && message.hasOwnProperty("listTeams")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.ListTeams.verify(message.listTeams);
                    if (error)
                        return "listTeams." + error;
                }
            }
            if (message.getTeam != null && message.hasOwnProperty("getTeam")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.GetTeam.verify(message.getTeam);
                    if (error)
                        return "getTeam." + error;
                }
            }
            if (message.isOperationAllowed != null && message.hasOwnProperty("isOperationAllowed")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.IsOperationAllowed.verify(message.isOperationAllowed);
                    if (error)
                        return "isOperationAllowed." + error;
                }
            }
            if (message.moveFile != null && message.hasOwnProperty("moveFile")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.MoveFile.verify(message.moveFile);
                    if (error)
                        return "moveFile." + error;
                }
            }
            if (message.moveFolder != null && message.hasOwnProperty("moveFolder")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.MoveFolder.verify(message.moveFolder);
                    if (error)
                        return "moveFolder." + error;
                }
            }
            if (message.copyFile != null && message.hasOwnProperty("copyFile")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.CopyFile.verify(message.copyFile);
                    if (error)
                        return "copyFile." + error;
                }
            }
            if (message.copyFolder != null && message.hasOwnProperty("copyFolder")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.CopyFolder.verify(message.copyFolder);
                    if (error)
                        return "copyFolder." + error;
                }
            }
            if (message.restoreVersion != null && message.hasOwnProperty("restoreVersion")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.RestoreVersion.verify(message.restoreVersion);
                    if (error)
                        return "restoreVersion." + error;
                }
            }
            if (message.removeFile != null && message.hasOwnProperty("removeFile")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.RemoveFile.verify(message.removeFile);
                    if (error)
                        return "removeFile." + error;
                }
            }
            if (message.removeFolder != null && message.hasOwnProperty("removeFolder")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.RemoveFolder.verify(message.removeFolder);
                    if (error)
                        return "removeFolder." + error;
                }
            }
            if (message.untrashFile != null && message.hasOwnProperty("untrashFile")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.UntrashFile.verify(message.untrashFile);
                    if (error)
                        return "untrashFile." + error;
                }
            }
            if (message.untrashFolder != null && message.hasOwnProperty("untrashFolder")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.UntrashFolder.verify(message.untrashFolder);
                    if (error)
                        return "untrashFolder." + error;
                }
            }
            if (message.undoStartWrite != null && message.hasOwnProperty("undoStartWrite")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.UndoStartWrite.verify(message.undoStartWrite);
                    if (error)
                        return "undoStartWrite." + error;
                }
            }
            if (message.detachClonedFolder != null && message.hasOwnProperty("detachClonedFolder")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.DetachClonedFolder.verify(message.detachClonedFolder);
                    if (error)
                        return "detachClonedFolder." + error;
                }
            }
            if (message.getMetaFromPath != null && message.hasOwnProperty("getMetaFromPath")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.GetMetaFromPath.verify(message.getMetaFromPath);
                    if (error)
                        return "getMetaFromPath." + error;
                }
            }
            if (message.renameFile != null && message.hasOwnProperty("renameFile")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.RenameFile.verify(message.renameFile);
                    if (error)
                        return "renameFile." + error;
                }
            }
            if (message.renameFolder != null && message.hasOwnProperty("renameFolder")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.RenameFolder.verify(message.renameFolder);
                    if (error)
                        return "renameFolder." + error;
                }
            }
            if (message.list != null && message.hasOwnProperty("list")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.List.verify(message.list);
                    if (error)
                        return "list." + error;
                }
            }
            if (message.auditLogMessage != null && message.hasOwnProperty("auditLogMessage")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.AuditLogMessage.verify(message.auditLogMessage);
                    if (error)
                        return "auditLogMessage." + error;
                }
            }
            if (message.resetVersion != null && message.hasOwnProperty("resetVersion")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.ResetVersion.verify(message.resetVersion);
                    if (error)
                        return "resetVersion." + error;
                }
            }
            if (message.setUser != null && message.hasOwnProperty("setUser")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.SetUser.verify(message.setUser);
                    if (error)
                        return "setUser." + error;
                }
            }
            if (message.finalizeProfileWrite != null && message.hasOwnProperty("finalizeProfileWrite")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.FinalizeProfileWrite.verify(message.finalizeProfileWrite);
                    if (error)
                        return "finalizeProfileWrite." + error;
                }
            }
            if (message.getProfileFileMeta != null && message.hasOwnProperty("getProfileFileMeta")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.GetProfileFileMeta.verify(message.getProfileFileMeta);
                    if (error)
                        return "getProfileFileMeta." + error;
                }
            }
            if (message.profileChunkList != null && message.hasOwnProperty("profileChunkList")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.ProfileChunkList.verify(message.profileChunkList);
                    if (error)
                        return "profileChunkList." + error;
                }
            }
            if (message.getUserType != null && message.hasOwnProperty("getUserType")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.GetUserType.verify(message.getUserType);
                    if (error)
                        return "getUserType." + error;
                }
            }
            if (message.getRandomBytes != null && message.hasOwnProperty("getRandomBytes")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.GetRandomBytes.verify(message.getRandomBytes);
                    if (error)
                        return "getRandomBytes." + error;
                }
            }
            if (message.share != null && message.hasOwnProperty("share")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.Share.verify(message.share);
                    if (error)
                        return "share." + error;
                }
            }
            if (message.unshare != null && message.hasOwnProperty("unshare")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.Unshare.verify(message.unshare);
                    if (error)
                        return "unshare." + error;
                }
            }
            if (message.updateShare != null && message.hasOwnProperty("updateShare")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.UpdateShare.verify(message.updateShare);
                    if (error)
                        return "updateShare." + error;
                }
            }
            if (message.listShares != null && message.hasOwnProperty("listShares")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.ListShares.verify(message.listShares);
                    if (error)
                        return "listShares." + error;
                }
            }
            if (message.resetTOTP != null && message.hasOwnProperty("resetTOTP")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.ResetTOTP.verify(message.resetTOTP);
                    if (error)
                        return "resetTOTP." + error;
                }
            }
            if (message.setRolesTeamsToUser != null && message.hasOwnProperty("setRolesTeamsToUser")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.SetRolesTeamsToUser.verify(message.setRolesTeamsToUser);
                    if (error)
                        return "setRolesTeamsToUser." + error;
                }
            }
            if (message.updatePinOps != null && message.hasOwnProperty("updatePinOps")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.UpdatePinOps.verify(message.updatePinOps);
                    if (error)
                        return "updatePinOps." + error;
                }
            }
            if (message.deletePin != null && message.hasOwnProperty("deletePin")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.DeletePin.verify(message.deletePin);
                    if (error)
                        return "deletePin." + error;
                }
            }
            if (message.getRolesAndTeamsOfUser != null && message.hasOwnProperty("getRolesAndTeamsOfUser")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.GetRolesAndTeamsOfUser.verify(message.getRolesAndTeamsOfUser);
                    if (error)
                        return "getRolesAndTeamsOfUser." + error;
                }
            }
            if (message.restartPutChunk != null && message.hasOwnProperty("restartPutChunk")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.RestartPutChunk.verify(message.restartPutChunk);
                    if (error)
                        return "restartPutChunk." + error;
                }
            }
            if (message.verifyAuditLogMeta != null && message.hasOwnProperty("verifyAuditLogMeta")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.VerifyAuditLogMeta.verify(message.verifyAuditLogMeta);
                    if (error)
                        return "verifyAuditLogMeta." + error;
                }
            }
            if (message.getAuditLog != null && message.hasOwnProperty("getAuditLog")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.GetAuditLog.verify(message.getAuditLog);
                    if (error)
                        return "getAuditLog." + error;
                }
            }
            if (message.deleteAuditLog != null && message.hasOwnProperty("deleteAuditLog")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.DeleteAuditLog.verify(message.deleteAuditLog);
                    if (error)
                        return "deleteAuditLog." + error;
                }
            }
            if (message.getLedgerRange != null && message.hasOwnProperty("getLedgerRange")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.GetLedgerRange.verify(message.getLedgerRange);
                    if (error)
                        return "getLedgerRange." + error;
                }
            }
            if (message.listPins != null && message.hasOwnProperty("listPins")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.ListPins.verify(message.listPins);
                    if (error)
                        return "listPins." + error;
                }
            }
            if (message.getMetaFromSharedPath != null && message.hasOwnProperty("getMetaFromSharedPath")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.GetMetaFromSharedPath.verify(message.getMetaFromSharedPath);
                    if (error)
                        return "getMetaFromSharedPath." + error;
                }
            }
            if (message.listQuestions != null && message.hasOwnProperty("listQuestions")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.ListQuestions.verify(message.listQuestions);
                    if (error)
                        return "listQuestions." + error;
                }
            }
            if (message.verifyBYOSCreds != null && message.hasOwnProperty("verifyBYOSCreds")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.VerifyBYOSCreds.verify(message.verifyBYOSCreds);
                    if (error)
                        return "verifyBYOSCreds." + error;
                }
            }
            if (message.migrateToStorage != null && message.hasOwnProperty("migrateToStorage")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.MigrateToStorage.verify(message.migrateToStorage);
                    if (error)
                        return "migrateToStorage." + error;
                }
            }
            if (message.updateStorageCreds != null && message.hasOwnProperty("updateStorageCreds")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.UpdateStorageCreds.verify(message.updateStorageCreds);
                    if (error)
                        return "updateStorageCreds." + error;
                }
            }
            if (message.verifyUserForAudit != null && message.hasOwnProperty("verifyUserForAudit")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.VerifyUserForAudit.verify(message.verifyUserForAudit);
                    if (error)
                        return "verifyUserForAudit." + error;
                }
            }
            if (message.removeOrganizationUser != null && message.hasOwnProperty("removeOrganizationUser")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.RemoveOrganizationUser.verify(message.removeOrganizationUser);
                    if (error)
                        return "removeOrganizationUser." + error;
                }
            }
            if (message.addSpace != null && message.hasOwnProperty("addSpace")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.AddSpace.verify(message.addSpace);
                    if (error)
                        return "addSpace." + error;
                }
            }
            if (message.addUserToSpace != null && message.hasOwnProperty("addUserToSpace")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.AddUserToSpace.verify(message.addUserToSpace);
                    if (error)
                        return "addUserToSpace." + error;
                }
            }
            if (message.removeUserFromSpace != null && message.hasOwnProperty("removeUserFromSpace")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.RemoveUserFromSpace.verify(message.removeUserFromSpace);
                    if (error)
                        return "removeUserFromSpace." + error;
                }
            }
            if (message.updatePermissionsOfSpace != null && message.hasOwnProperty("updatePermissionsOfSpace")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.UpdatePermissionsOfSpace.verify(message.updatePermissionsOfSpace);
                    if (error)
                        return "updatePermissionsOfSpace." + error;
                }
            }
            if (message.addObjectToSpace != null && message.hasOwnProperty("addObjectToSpace")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.AddObjectToSpace.verify(message.addObjectToSpace);
                    if (error)
                        return "addObjectToSpace." + error;
                }
            }
            if (message.removeObjectFromSpace != null && message.hasOwnProperty("removeObjectFromSpace")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.RemoveObjectFromSpace.verify(message.removeObjectFromSpace);
                    if (error)
                        return "removeObjectFromSpace." + error;
                }
            }
            if (message.removeSpace != null && message.hasOwnProperty("removeSpace")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.RemoveSpace.verify(message.removeSpace);
                    if (error)
                        return "removeSpace." + error;
                }
            }
            if (message.sendOtpToExternalUser != null && message.hasOwnProperty("sendOtpToExternalUser")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.SendOtpToExternalUser.verify(message.sendOtpToExternalUser);
                    if (error)
                        return "sendOtpToExternalUser." + error;
                }
            }
            if (message.signInToSpace != null && message.hasOwnProperty("signInToSpace")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.SignInToSpace.verify(message.signInToSpace);
                    if (error)
                        return "signInToSpace." + error;
                }
            }
            if (message.listSpaces != null && message.hasOwnProperty("listSpaces")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.ListSpaces.verify(message.listSpaces);
                    if (error)
                        return "listSpaces." + error;
                }
            }
            if (message.sendOtpToExternalUserIfNotExist != null && message.hasOwnProperty("sendOtpToExternalUserIfNotExist")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.SendOtpToExternalUserIfNotExist.verify(message.sendOtpToExternalUserIfNotExist);
                    if (error)
                        return "sendOtpToExternalUserIfNotExist." + error;
                }
            }
            if (message.getStorageValue != null && message.hasOwnProperty("getStorageValue")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.GetStorageValue.verify(message.getStorageValue);
                    if (error)
                        return "getStorageValue." + error;
                }
            }
            if (message.updateTags != null && message.hasOwnProperty("updateTags")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.UpdateTags.verify(message.updateTags);
                    if (error)
                        return "updateTags." + error;
                }
            }
            if (message.addComment != null && message.hasOwnProperty("addComment")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.AddComment.verify(message.addComment);
                    if (error)
                        return "addComment." + error;
                }
            }
            if (message.removeComment != null && message.hasOwnProperty("removeComment")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.RemoveComment.verify(message.removeComment);
                    if (error)
                        return "removeComment." + error;
                }
            }
            if (message.listComments != null && message.hasOwnProperty("listComments")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.ListComments.verify(message.listComments);
                    if (error)
                        return "listComments." + error;
                }
            }
            if (message.updateComment != null && message.hasOwnProperty("updateComment")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.UpdateComment.verify(message.updateComment);
                    if (error)
                        return "updateComment." + error;
                }
            }
            if (message.getComment != null && message.hasOwnProperty("getComment")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.GetComment.verify(message.getComment);
                    if (error)
                        return "getComment." + error;
                }
            }
            if (message.sessionData != null && message.hasOwnProperty("sessionData")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.SessionData.verify(message.sessionData);
                    if (error)
                        return "sessionData." + error;
                }
            }
            if (message.getStorageCreds != null && message.hasOwnProperty("getStorageCreds")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.GetStorageCreds.verify(message.getStorageCreds);
                    if (error)
                        return "getStorageCreds." + error;
                }
            }
            if (message.getPlan != null && message.hasOwnProperty("getPlan")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.GetPlan.verify(message.getPlan);
                    if (error)
                        return "getPlan." + error;
                }
            }
            if (message.listPlans != null && message.hasOwnProperty("listPlans")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.ListPlans.verify(message.listPlans);
                    if (error)
                        return "listPlans." + error;
                }
            }
            if (message.upgradePlan != null && message.hasOwnProperty("upgradePlan")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.UpgradePlan.verify(message.upgradePlan);
                    if (error)
                        return "upgradePlan." + error;
                }
            }
            if (message.validateCoupon != null && message.hasOwnProperty("validateCoupon")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.ValidateCoupon.verify(message.validateCoupon);
                    if (error)
                        return "validateCoupon." + error;
                }
            }
            if (message.removeVersion != null && message.hasOwnProperty("removeVersion")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.RemoveVersion.verify(message.removeVersion);
                    if (error)
                        return "removeVersion." + error;
                }
            }
            if (message.getProfilePictureOfUser != null && message.hasOwnProperty("getProfilePictureOfUser")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.GetProfilePictureOfUser.verify(message.getProfilePictureOfUser);
                    if (error)
                        return "getProfilePictureOfUser." + error;
                }
            }
            if (message.emptyTrash != null && message.hasOwnProperty("emptyTrash")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.EmptyTrash.verify(message.emptyTrash);
                    if (error)
                        return "emptyTrash." + error;
                }
            }
            if (message.setThumbnail != null && message.hasOwnProperty("setThumbnail")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.SetThumbnail.verify(message.setThumbnail);
                    if (error)
                        return "setThumbnail." + error;
                }
            }
            if (message.getThumbnail != null && message.hasOwnProperty("getThumbnail")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.GetThumbnail.verify(message.getThumbnail);
                    if (error)
                        return "getThumbnail." + error;
                }
            }
            if (message.blockUser != null && message.hasOwnProperty("blockUser")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.BlockUser.verify(message.blockUser);
                    if (error)
                        return "blockUser." + error;
                }
            }
            if (message.unblockUser != null && message.hasOwnProperty("unblockUser")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.UnblockUser.verify(message.unblockUser);
                    if (error)
                        return "unblockUser." + error;
                }
            }
            if (message.updateOrgSettings != null && message.hasOwnProperty("updateOrgSettings")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.UpdateOrgSettings.verify(message.updateOrgSettings);
                    if (error)
                        return "updateOrgSettings." + error;
                }
            }
            if (message.getOrgSettings != null && message.hasOwnProperty("getOrgSettings")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.request.GetOrgSettings.verify(message.getOrgSettings);
                    if (error)
                        return "getOrgSettings." + error;
                }
            }
            return null;
        };

        /**
         * Creates a Request message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof request.Request
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {request.Request} Request
         */
        Request.fromObject = function fromObject(object) {
            if (object instanceof $root.request.Request)
                return object;
            let message = new $root.request.Request();
            if (object.reqCreateTime != null)
                if ($util.Long)
                    (message.reqCreateTime = $util.Long.fromValue(object.reqCreateTime)).unsigned = true;
                else if (typeof object.reqCreateTime === "string")
                    message.reqCreateTime = parseInt(object.reqCreateTime, 10);
                else if (typeof object.reqCreateTime === "number")
                    message.reqCreateTime = object.reqCreateTime;
                else if (typeof object.reqCreateTime === "object")
                    message.reqCreateTime = new $util.LongBits(object.reqCreateTime.low >>> 0, object.reqCreateTime.high >>> 0).toNumber(true);
            if (object.id != null)
                if ($util.Long)
                    (message.id = $util.Long.fromValue(object.id)).unsigned = true;
                else if (typeof object.id === "string")
                    message.id = parseInt(object.id, 10);
                else if (typeof object.id === "number")
                    message.id = object.id;
                else if (typeof object.id === "object")
                    message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber(true);
            if (object.addUser != null) {
                if (typeof object.addUser !== "object")
                    throw TypeError(".request.Request.addUser: object expected");
                message.addUser = $root.request.AddUser.fromObject(object.addUser);
            }
            if (object.removeUser != null) {
                if (typeof object.removeUser !== "object")
                    throw TypeError(".request.Request.removeUser: object expected");
                message.removeUser = $root.request.RemoveUser.fromObject(object.removeUser);
            }
            if (object.passwordReset != null) {
                if (typeof object.passwordReset !== "object")
                    throw TypeError(".request.Request.passwordReset: object expected");
                message.passwordReset = $root.request.PasswordReset.fromObject(object.passwordReset);
            }
            if (object.changePassword != null) {
                if (typeof object.changePassword !== "object")
                    throw TypeError(".request.Request.changePassword: object expected");
                message.changePassword = $root.request.ChangePassword.fromObject(object.changePassword);
            }
            if (object.addOrganization != null) {
                if (typeof object.addOrganization !== "object")
                    throw TypeError(".request.Request.addOrganization: object expected");
                message.addOrganization = $root.request.AddOrganization.fromObject(object.addOrganization);
            }
            if (object.initiatePayment != null) {
                if (typeof object.initiatePayment !== "object")
                    throw TypeError(".request.Request.initiatePayment: object expected");
                message.initiatePayment = $root.request.InitiatePayment.fromObject(object.initiatePayment);
            }
            if (object.signIn != null) {
                if (typeof object.signIn !== "object")
                    throw TypeError(".request.Request.signIn: object expected");
                message.signIn = $root.request.SignIn.fromObject(object.signIn);
            }
            if (object.signOut != null) {
                if (typeof object.signOut !== "object")
                    throw TypeError(".request.Request.signOut: object expected");
                message.signOut = $root.request.SignOut.fromObject(object.signOut);
            }
            if (object.inviteUser != null) {
                if (typeof object.inviteUser !== "object")
                    throw TypeError(".request.Request.inviteUser: object expected");
                message.inviteUser = $root.request.InviteUser.fromObject(object.inviteUser);
            }
            if (object.getUser != null) {
                if (typeof object.getUser !== "object")
                    throw TypeError(".request.Request.getUser: object expected");
                message.getUser = $root.request.GetUser.fromObject(object.getUser);
            }
            if (object.listUsers != null) {
                if (typeof object.listUsers !== "object")
                    throw TypeError(".request.Request.listUsers: object expected");
                message.listUsers = $root.request.ListUsers.fromObject(object.listUsers);
            }
            if (object.removeOrganization != null) {
                if (typeof object.removeOrganization !== "object")
                    throw TypeError(".request.Request.removeOrganization: object expected");
                message.removeOrganization = $root.request.RemoveOrganization.fromObject(object.removeOrganization);
            }
            if (object.verifyOrganization != null) {
                if (typeof object.verifyOrganization !== "object")
                    throw TypeError(".request.Request.verifyOrganization: object expected");
                message.verifyOrganization = $root.request.VerifyOrganization.fromObject(object.verifyOrganization);
            }
            if (object.getOrganization != null) {
                if (typeof object.getOrganization !== "object")
                    throw TypeError(".request.Request.getOrganization: object expected");
                message.getOrganization = $root.request.GetOrganization.fromObject(object.getOrganization);
            }
            if (object.addPin != null) {
                if (typeof object.addPin !== "object")
                    throw TypeError(".request.Request.addPin: object expected");
                message.addPin = $root.request.AddPin.fromObject(object.addPin);
            }
            if (object.verifyUser != null) {
                if (typeof object.verifyUser !== "object")
                    throw TypeError(".request.Request.verifyUser: object expected");
                message.verifyUser = $root.request.VerifyUser.fromObject(object.verifyUser);
            }
            if (object.getFileHead != null) {
                if (typeof object.getFileHead !== "object")
                    throw TypeError(".request.Request.getFileHead: object expected");
                message.getFileHead = $root.request.GetFileHead.fromObject(object.getFileHead);
            }
            if (object.echo != null) {
                if (typeof object.echo !== "object")
                    throw TypeError(".request.Request.echo: object expected");
                message.echo = $root.request.Echo.fromObject(object.echo);
            }
            if (object.fileLock != null) {
                if (typeof object.fileLock !== "object")
                    throw TypeError(".request.Request.fileLock: object expected");
                message.fileLock = $root.request.FileLock.fromObject(object.fileLock);
            }
            if (object.fileUnlock != null) {
                if (typeof object.fileUnlock !== "object")
                    throw TypeError(".request.Request.fileUnlock: object expected");
                message.fileUnlock = $root.request.FileUnlock.fromObject(object.fileUnlock);
            }
            if (object.getChunk != null) {
                if (typeof object.getChunk !== "object")
                    throw TypeError(".request.Request.getChunk: object expected");
                message.getChunk = $root.request.GetChunk.fromObject(object.getChunk);
            }
            if (object.startWrite != null) {
                if (typeof object.startWrite !== "object")
                    throw TypeError(".request.Request.startWrite: object expected");
                message.startWrite = $root.request.StartWrite.fromObject(object.startWrite);
            }
            if (object.putChunk != null) {
                if (typeof object.putChunk !== "object")
                    throw TypeError(".request.Request.putChunk: object expected");
                message.putChunk = $root.request.PutChunk.fromObject(object.putChunk);
            }
            if (object.finalizeWrite != null) {
                if (typeof object.finalizeWrite !== "object")
                    throw TypeError(".request.Request.finalizeWrite: object expected");
                message.finalizeWrite = $root.request.FinalizeWrite.fromObject(object.finalizeWrite);
            }
            if (object.listFiles != null) {
                if (typeof object.listFiles !== "object")
                    throw TypeError(".request.Request.listFiles: object expected");
                message.listFiles = $root.request.ListFiles.fromObject(object.listFiles);
            }
            if (object.remove != null) {
                if (typeof object.remove !== "object")
                    throw TypeError(".request.Request.remove: object expected");
                message.remove = $root.request.Remove.fromObject(object.remove);
            }
            if (object.getFolder != null) {
                if (typeof object.getFolder !== "object")
                    throw TypeError(".request.Request.getFolder: object expected");
                message.getFolder = $root.request.GetFolder.fromObject(object.getFolder);
            }
            if (object.createFolder != null) {
                if (typeof object.createFolder !== "object")
                    throw TypeError(".request.Request.createFolder: object expected");
                message.createFolder = $root.request.CreateFolder.fromObject(object.createFolder);
            }
            if (object.CreateSnapshot != null) {
                if (typeof object.CreateSnapshot !== "object")
                    throw TypeError(".request.Request.CreateSnapshot: object expected");
                message.CreateSnapshot = $root.request.CreateSnapshot.fromObject(object.CreateSnapshot);
            }
            if (object.VerifyPayment != null) {
                if (typeof object.VerifyPayment !== "object")
                    throw TypeError(".request.Request.VerifyPayment: object expected");
                message.VerifyPayment = $root.request.VerifyPayment.fromObject(object.VerifyPayment);
            }
            if (object.getSecret != null) {
                if (typeof object.getSecret !== "object")
                    throw TypeError(".request.Request.getSecret: object expected");
                message.getSecret = $root.request.GetSecret.fromObject(object.getSecret);
            }
            if (object.addSecret != null) {
                if (typeof object.addSecret !== "object")
                    throw TypeError(".request.Request.addSecret: object expected");
                message.addSecret = $root.request.AddSecret.fromObject(object.addSecret);
            }
            if (object.deleteSecret != null) {
                if (typeof object.deleteSecret !== "object")
                    throw TypeError(".request.Request.deleteSecret: object expected");
                message.deleteSecret = $root.request.DeleteSecret.fromObject(object.deleteSecret);
            }
            if (object.updateSecret != null) {
                if (typeof object.updateSecret !== "object")
                    throw TypeError(".request.Request.updateSecret: object expected");
                message.updateSecret = $root.request.UpdateSecret.fromObject(object.updateSecret);
            }
            if (object.listSecrets != null) {
                if (typeof object.listSecrets !== "object")
                    throw TypeError(".request.Request.listSecrets: object expected");
                message.listSecrets = $root.request.ListSecrets.fromObject(object.listSecrets);
            }
            if (object.quickListSecrets != null) {
                if (typeof object.quickListSecrets !== "object")
                    throw TypeError(".request.Request.quickListSecrets: object expected");
                message.quickListSecrets = $root.request.QuickListSecrets.fromObject(object.quickListSecrets);
            }
            if (object.listSecretSubkeys != null) {
                if (typeof object.listSecretSubkeys !== "object")
                    throw TypeError(".request.Request.listSecretSubkeys: object expected");
                message.listSecretSubkeys = $root.request.ListSecretSubkeys.fromObject(object.listSecretSubkeys);
            }
            if (object.undeleteSecret != null) {
                if (typeof object.undeleteSecret !== "object")
                    throw TypeError(".request.Request.undeleteSecret: object expected");
                message.undeleteSecret = $root.request.UndeleteSecret.fromObject(object.undeleteSecret);
            }
            if (object.destroySecret != null) {
                if (typeof object.destroySecret !== "object")
                    throw TypeError(".request.Request.destroySecret: object expected");
                message.destroySecret = $root.request.DestroySecret.fromObject(object.destroySecret);
            }
            if (object.addRole != null) {
                if (typeof object.addRole !== "object")
                    throw TypeError(".request.Request.addRole: object expected");
                message.addRole = $root.request.AddRole.fromObject(object.addRole);
            }
            if (object.removeRole != null) {
                if (typeof object.removeRole !== "object")
                    throw TypeError(".request.Request.removeRole: object expected");
                message.removeRole = $root.request.RemoveRole.fromObject(object.removeRole);
            }
            if (object.updateRole != null) {
                if (typeof object.updateRole !== "object")
                    throw TypeError(".request.Request.updateRole: object expected");
                message.updateRole = $root.request.UpdateRole.fromObject(object.updateRole);
            }
            if (object.listRoles != null) {
                if (typeof object.listRoles !== "object")
                    throw TypeError(".request.Request.listRoles: object expected");
                message.listRoles = $root.request.ListRoles.fromObject(object.listRoles);
            }
            if (object.getRole != null) {
                if (typeof object.getRole !== "object")
                    throw TypeError(".request.Request.getRole: object expected");
                message.getRole = $root.request.GetRole.fromObject(object.getRole);
            }
            if (object.addTeam != null) {
                if (typeof object.addTeam !== "object")
                    throw TypeError(".request.Request.addTeam: object expected");
                message.addTeam = $root.request.AddTeam.fromObject(object.addTeam);
            }
            if (object.removeTeam != null) {
                if (typeof object.removeTeam !== "object")
                    throw TypeError(".request.Request.removeTeam: object expected");
                message.removeTeam = $root.request.RemoveTeam.fromObject(object.removeTeam);
            }
            if (object.updateTeam != null) {
                if (typeof object.updateTeam !== "object")
                    throw TypeError(".request.Request.updateTeam: object expected");
                message.updateTeam = $root.request.UpdateTeam.fromObject(object.updateTeam);
            }
            if (object.listTeams != null) {
                if (typeof object.listTeams !== "object")
                    throw TypeError(".request.Request.listTeams: object expected");
                message.listTeams = $root.request.ListTeams.fromObject(object.listTeams);
            }
            if (object.getTeam != null) {
                if (typeof object.getTeam !== "object")
                    throw TypeError(".request.Request.getTeam: object expected");
                message.getTeam = $root.request.GetTeam.fromObject(object.getTeam);
            }
            if (object.isOperationAllowed != null) {
                if (typeof object.isOperationAllowed !== "object")
                    throw TypeError(".request.Request.isOperationAllowed: object expected");
                message.isOperationAllowed = $root.request.IsOperationAllowed.fromObject(object.isOperationAllowed);
            }
            if (object.moveFile != null) {
                if (typeof object.moveFile !== "object")
                    throw TypeError(".request.Request.moveFile: object expected");
                message.moveFile = $root.request.MoveFile.fromObject(object.moveFile);
            }
            if (object.moveFolder != null) {
                if (typeof object.moveFolder !== "object")
                    throw TypeError(".request.Request.moveFolder: object expected");
                message.moveFolder = $root.request.MoveFolder.fromObject(object.moveFolder);
            }
            if (object.copyFile != null) {
                if (typeof object.copyFile !== "object")
                    throw TypeError(".request.Request.copyFile: object expected");
                message.copyFile = $root.request.CopyFile.fromObject(object.copyFile);
            }
            if (object.copyFolder != null) {
                if (typeof object.copyFolder !== "object")
                    throw TypeError(".request.Request.copyFolder: object expected");
                message.copyFolder = $root.request.CopyFolder.fromObject(object.copyFolder);
            }
            if (object.restoreVersion != null) {
                if (typeof object.restoreVersion !== "object")
                    throw TypeError(".request.Request.restoreVersion: object expected");
                message.restoreVersion = $root.request.RestoreVersion.fromObject(object.restoreVersion);
            }
            if (object.removeFile != null) {
                if (typeof object.removeFile !== "object")
                    throw TypeError(".request.Request.removeFile: object expected");
                message.removeFile = $root.request.RemoveFile.fromObject(object.removeFile);
            }
            if (object.removeFolder != null) {
                if (typeof object.removeFolder !== "object")
                    throw TypeError(".request.Request.removeFolder: object expected");
                message.removeFolder = $root.request.RemoveFolder.fromObject(object.removeFolder);
            }
            if (object.untrashFile != null) {
                if (typeof object.untrashFile !== "object")
                    throw TypeError(".request.Request.untrashFile: object expected");
                message.untrashFile = $root.request.UntrashFile.fromObject(object.untrashFile);
            }
            if (object.untrashFolder != null) {
                if (typeof object.untrashFolder !== "object")
                    throw TypeError(".request.Request.untrashFolder: object expected");
                message.untrashFolder = $root.request.UntrashFolder.fromObject(object.untrashFolder);
            }
            if (object.undoStartWrite != null) {
                if (typeof object.undoStartWrite !== "object")
                    throw TypeError(".request.Request.undoStartWrite: object expected");
                message.undoStartWrite = $root.request.UndoStartWrite.fromObject(object.undoStartWrite);
            }
            if (object.detachClonedFolder != null) {
                if (typeof object.detachClonedFolder !== "object")
                    throw TypeError(".request.Request.detachClonedFolder: object expected");
                message.detachClonedFolder = $root.request.DetachClonedFolder.fromObject(object.detachClonedFolder);
            }
            if (object.getMetaFromPath != null) {
                if (typeof object.getMetaFromPath !== "object")
                    throw TypeError(".request.Request.getMetaFromPath: object expected");
                message.getMetaFromPath = $root.request.GetMetaFromPath.fromObject(object.getMetaFromPath);
            }
            if (object.renameFile != null) {
                if (typeof object.renameFile !== "object")
                    throw TypeError(".request.Request.renameFile: object expected");
                message.renameFile = $root.request.RenameFile.fromObject(object.renameFile);
            }
            if (object.renameFolder != null) {
                if (typeof object.renameFolder !== "object")
                    throw TypeError(".request.Request.renameFolder: object expected");
                message.renameFolder = $root.request.RenameFolder.fromObject(object.renameFolder);
            }
            if (object.list != null) {
                if (typeof object.list !== "object")
                    throw TypeError(".request.Request.list: object expected");
                message.list = $root.request.List.fromObject(object.list);
            }
            if (object.auditLogMessage != null) {
                if (typeof object.auditLogMessage !== "object")
                    throw TypeError(".request.Request.auditLogMessage: object expected");
                message.auditLogMessage = $root.request.AuditLogMessage.fromObject(object.auditLogMessage);
            }
            if (object.resetVersion != null) {
                if (typeof object.resetVersion !== "object")
                    throw TypeError(".request.Request.resetVersion: object expected");
                message.resetVersion = $root.request.ResetVersion.fromObject(object.resetVersion);
            }
            if (object.setUser != null) {
                if (typeof object.setUser !== "object")
                    throw TypeError(".request.Request.setUser: object expected");
                message.setUser = $root.request.SetUser.fromObject(object.setUser);
            }
            if (object.finalizeProfileWrite != null) {
                if (typeof object.finalizeProfileWrite !== "object")
                    throw TypeError(".request.Request.finalizeProfileWrite: object expected");
                message.finalizeProfileWrite = $root.request.FinalizeProfileWrite.fromObject(object.finalizeProfileWrite);
            }
            if (object.getProfileFileMeta != null) {
                if (typeof object.getProfileFileMeta !== "object")
                    throw TypeError(".request.Request.getProfileFileMeta: object expected");
                message.getProfileFileMeta = $root.request.GetProfileFileMeta.fromObject(object.getProfileFileMeta);
            }
            if (object.profileChunkList != null) {
                if (typeof object.profileChunkList !== "object")
                    throw TypeError(".request.Request.profileChunkList: object expected");
                message.profileChunkList = $root.request.ProfileChunkList.fromObject(object.profileChunkList);
            }
            if (object.getUserType != null) {
                if (typeof object.getUserType !== "object")
                    throw TypeError(".request.Request.getUserType: object expected");
                message.getUserType = $root.request.GetUserType.fromObject(object.getUserType);
            }
            if (object.getRandomBytes != null) {
                if (typeof object.getRandomBytes !== "object")
                    throw TypeError(".request.Request.getRandomBytes: object expected");
                message.getRandomBytes = $root.request.GetRandomBytes.fromObject(object.getRandomBytes);
            }
            if (object.share != null) {
                if (typeof object.share !== "object")
                    throw TypeError(".request.Request.share: object expected");
                message.share = $root.request.Share.fromObject(object.share);
            }
            if (object.unshare != null) {
                if (typeof object.unshare !== "object")
                    throw TypeError(".request.Request.unshare: object expected");
                message.unshare = $root.request.Unshare.fromObject(object.unshare);
            }
            if (object.updateShare != null) {
                if (typeof object.updateShare !== "object")
                    throw TypeError(".request.Request.updateShare: object expected");
                message.updateShare = $root.request.UpdateShare.fromObject(object.updateShare);
            }
            if (object.listShares != null) {
                if (typeof object.listShares !== "object")
                    throw TypeError(".request.Request.listShares: object expected");
                message.listShares = $root.request.ListShares.fromObject(object.listShares);
            }
            if (object.resetTOTP != null) {
                if (typeof object.resetTOTP !== "object")
                    throw TypeError(".request.Request.resetTOTP: object expected");
                message.resetTOTP = $root.request.ResetTOTP.fromObject(object.resetTOTP);
            }
            if (object.setRolesTeamsToUser != null) {
                if (typeof object.setRolesTeamsToUser !== "object")
                    throw TypeError(".request.Request.setRolesTeamsToUser: object expected");
                message.setRolesTeamsToUser = $root.request.SetRolesTeamsToUser.fromObject(object.setRolesTeamsToUser);
            }
            if (object.updatePinOps != null) {
                if (typeof object.updatePinOps !== "object")
                    throw TypeError(".request.Request.updatePinOps: object expected");
                message.updatePinOps = $root.request.UpdatePinOps.fromObject(object.updatePinOps);
            }
            if (object.deletePin != null) {
                if (typeof object.deletePin !== "object")
                    throw TypeError(".request.Request.deletePin: object expected");
                message.deletePin = $root.request.DeletePin.fromObject(object.deletePin);
            }
            if (object.getRolesAndTeamsOfUser != null) {
                if (typeof object.getRolesAndTeamsOfUser !== "object")
                    throw TypeError(".request.Request.getRolesAndTeamsOfUser: object expected");
                message.getRolesAndTeamsOfUser = $root.request.GetRolesAndTeamsOfUser.fromObject(object.getRolesAndTeamsOfUser);
            }
            if (object.restartPutChunk != null) {
                if (typeof object.restartPutChunk !== "object")
                    throw TypeError(".request.Request.restartPutChunk: object expected");
                message.restartPutChunk = $root.request.RestartPutChunk.fromObject(object.restartPutChunk);
            }
            if (object.verifyAuditLogMeta != null) {
                if (typeof object.verifyAuditLogMeta !== "object")
                    throw TypeError(".request.Request.verifyAuditLogMeta: object expected");
                message.verifyAuditLogMeta = $root.request.VerifyAuditLogMeta.fromObject(object.verifyAuditLogMeta);
            }
            if (object.getAuditLog != null) {
                if (typeof object.getAuditLog !== "object")
                    throw TypeError(".request.Request.getAuditLog: object expected");
                message.getAuditLog = $root.request.GetAuditLog.fromObject(object.getAuditLog);
            }
            if (object.deleteAuditLog != null) {
                if (typeof object.deleteAuditLog !== "object")
                    throw TypeError(".request.Request.deleteAuditLog: object expected");
                message.deleteAuditLog = $root.request.DeleteAuditLog.fromObject(object.deleteAuditLog);
            }
            if (object.getLedgerRange != null) {
                if (typeof object.getLedgerRange !== "object")
                    throw TypeError(".request.Request.getLedgerRange: object expected");
                message.getLedgerRange = $root.request.GetLedgerRange.fromObject(object.getLedgerRange);
            }
            if (object.listPins != null) {
                if (typeof object.listPins !== "object")
                    throw TypeError(".request.Request.listPins: object expected");
                message.listPins = $root.request.ListPins.fromObject(object.listPins);
            }
            if (object.getMetaFromSharedPath != null) {
                if (typeof object.getMetaFromSharedPath !== "object")
                    throw TypeError(".request.Request.getMetaFromSharedPath: object expected");
                message.getMetaFromSharedPath = $root.request.GetMetaFromSharedPath.fromObject(object.getMetaFromSharedPath);
            }
            if (object.listQuestions != null) {
                if (typeof object.listQuestions !== "object")
                    throw TypeError(".request.Request.listQuestions: object expected");
                message.listQuestions = $root.request.ListQuestions.fromObject(object.listQuestions);
            }
            if (object.verifyBYOSCreds != null) {
                if (typeof object.verifyBYOSCreds !== "object")
                    throw TypeError(".request.Request.verifyBYOSCreds: object expected");
                message.verifyBYOSCreds = $root.request.VerifyBYOSCreds.fromObject(object.verifyBYOSCreds);
            }
            if (object.migrateToStorage != null) {
                if (typeof object.migrateToStorage !== "object")
                    throw TypeError(".request.Request.migrateToStorage: object expected");
                message.migrateToStorage = $root.request.MigrateToStorage.fromObject(object.migrateToStorage);
            }
            if (object.updateStorageCreds != null) {
                if (typeof object.updateStorageCreds !== "object")
                    throw TypeError(".request.Request.updateStorageCreds: object expected");
                message.updateStorageCreds = $root.request.UpdateStorageCreds.fromObject(object.updateStorageCreds);
            }
            if (object.verifyUserForAudit != null) {
                if (typeof object.verifyUserForAudit !== "object")
                    throw TypeError(".request.Request.verifyUserForAudit: object expected");
                message.verifyUserForAudit = $root.request.VerifyUserForAudit.fromObject(object.verifyUserForAudit);
            }
            if (object.removeOrganizationUser != null) {
                if (typeof object.removeOrganizationUser !== "object")
                    throw TypeError(".request.Request.removeOrganizationUser: object expected");
                message.removeOrganizationUser = $root.request.RemoveOrganizationUser.fromObject(object.removeOrganizationUser);
            }
            if (object.addSpace != null) {
                if (typeof object.addSpace !== "object")
                    throw TypeError(".request.Request.addSpace: object expected");
                message.addSpace = $root.request.AddSpace.fromObject(object.addSpace);
            }
            if (object.addUserToSpace != null) {
                if (typeof object.addUserToSpace !== "object")
                    throw TypeError(".request.Request.addUserToSpace: object expected");
                message.addUserToSpace = $root.request.AddUserToSpace.fromObject(object.addUserToSpace);
            }
            if (object.removeUserFromSpace != null) {
                if (typeof object.removeUserFromSpace !== "object")
                    throw TypeError(".request.Request.removeUserFromSpace: object expected");
                message.removeUserFromSpace = $root.request.RemoveUserFromSpace.fromObject(object.removeUserFromSpace);
            }
            if (object.updatePermissionsOfSpace != null) {
                if (typeof object.updatePermissionsOfSpace !== "object")
                    throw TypeError(".request.Request.updatePermissionsOfSpace: object expected");
                message.updatePermissionsOfSpace = $root.request.UpdatePermissionsOfSpace.fromObject(object.updatePermissionsOfSpace);
            }
            if (object.addObjectToSpace != null) {
                if (typeof object.addObjectToSpace !== "object")
                    throw TypeError(".request.Request.addObjectToSpace: object expected");
                message.addObjectToSpace = $root.request.AddObjectToSpace.fromObject(object.addObjectToSpace);
            }
            if (object.removeObjectFromSpace != null) {
                if (typeof object.removeObjectFromSpace !== "object")
                    throw TypeError(".request.Request.removeObjectFromSpace: object expected");
                message.removeObjectFromSpace = $root.request.RemoveObjectFromSpace.fromObject(object.removeObjectFromSpace);
            }
            if (object.removeSpace != null) {
                if (typeof object.removeSpace !== "object")
                    throw TypeError(".request.Request.removeSpace: object expected");
                message.removeSpace = $root.request.RemoveSpace.fromObject(object.removeSpace);
            }
            if (object.sendOtpToExternalUser != null) {
                if (typeof object.sendOtpToExternalUser !== "object")
                    throw TypeError(".request.Request.sendOtpToExternalUser: object expected");
                message.sendOtpToExternalUser = $root.request.SendOtpToExternalUser.fromObject(object.sendOtpToExternalUser);
            }
            if (object.signInToSpace != null) {
                if (typeof object.signInToSpace !== "object")
                    throw TypeError(".request.Request.signInToSpace: object expected");
                message.signInToSpace = $root.request.SignInToSpace.fromObject(object.signInToSpace);
            }
            if (object.listSpaces != null) {
                if (typeof object.listSpaces !== "object")
                    throw TypeError(".request.Request.listSpaces: object expected");
                message.listSpaces = $root.request.ListSpaces.fromObject(object.listSpaces);
            }
            if (object.sendOtpToExternalUserIfNotExist != null) {
                if (typeof object.sendOtpToExternalUserIfNotExist !== "object")
                    throw TypeError(".request.Request.sendOtpToExternalUserIfNotExist: object expected");
                message.sendOtpToExternalUserIfNotExist = $root.request.SendOtpToExternalUserIfNotExist.fromObject(object.sendOtpToExternalUserIfNotExist);
            }
            if (object.getStorageValue != null) {
                if (typeof object.getStorageValue !== "object")
                    throw TypeError(".request.Request.getStorageValue: object expected");
                message.getStorageValue = $root.request.GetStorageValue.fromObject(object.getStorageValue);
            }
            if (object.updateTags != null) {
                if (typeof object.updateTags !== "object")
                    throw TypeError(".request.Request.updateTags: object expected");
                message.updateTags = $root.request.UpdateTags.fromObject(object.updateTags);
            }
            if (object.addComment != null) {
                if (typeof object.addComment !== "object")
                    throw TypeError(".request.Request.addComment: object expected");
                message.addComment = $root.request.AddComment.fromObject(object.addComment);
            }
            if (object.removeComment != null) {
                if (typeof object.removeComment !== "object")
                    throw TypeError(".request.Request.removeComment: object expected");
                message.removeComment = $root.request.RemoveComment.fromObject(object.removeComment);
            }
            if (object.listComments != null) {
                if (typeof object.listComments !== "object")
                    throw TypeError(".request.Request.listComments: object expected");
                message.listComments = $root.request.ListComments.fromObject(object.listComments);
            }
            if (object.updateComment != null) {
                if (typeof object.updateComment !== "object")
                    throw TypeError(".request.Request.updateComment: object expected");
                message.updateComment = $root.request.UpdateComment.fromObject(object.updateComment);
            }
            if (object.getComment != null) {
                if (typeof object.getComment !== "object")
                    throw TypeError(".request.Request.getComment: object expected");
                message.getComment = $root.request.GetComment.fromObject(object.getComment);
            }
            if (object.sessionData != null) {
                if (typeof object.sessionData !== "object")
                    throw TypeError(".request.Request.sessionData: object expected");
                message.sessionData = $root.request.SessionData.fromObject(object.sessionData);
            }
            if (object.getStorageCreds != null) {
                if (typeof object.getStorageCreds !== "object")
                    throw TypeError(".request.Request.getStorageCreds: object expected");
                message.getStorageCreds = $root.request.GetStorageCreds.fromObject(object.getStorageCreds);
            }
            if (object.getPlan != null) {
                if (typeof object.getPlan !== "object")
                    throw TypeError(".request.Request.getPlan: object expected");
                message.getPlan = $root.request.GetPlan.fromObject(object.getPlan);
            }
            if (object.listPlans != null) {
                if (typeof object.listPlans !== "object")
                    throw TypeError(".request.Request.listPlans: object expected");
                message.listPlans = $root.request.ListPlans.fromObject(object.listPlans);
            }
            if (object.upgradePlan != null) {
                if (typeof object.upgradePlan !== "object")
                    throw TypeError(".request.Request.upgradePlan: object expected");
                message.upgradePlan = $root.request.UpgradePlan.fromObject(object.upgradePlan);
            }
            if (object.validateCoupon != null) {
                if (typeof object.validateCoupon !== "object")
                    throw TypeError(".request.Request.validateCoupon: object expected");
                message.validateCoupon = $root.request.ValidateCoupon.fromObject(object.validateCoupon);
            }
            if (object.removeVersion != null) {
                if (typeof object.removeVersion !== "object")
                    throw TypeError(".request.Request.removeVersion: object expected");
                message.removeVersion = $root.request.RemoveVersion.fromObject(object.removeVersion);
            }
            if (object.getProfilePictureOfUser != null) {
                if (typeof object.getProfilePictureOfUser !== "object")
                    throw TypeError(".request.Request.getProfilePictureOfUser: object expected");
                message.getProfilePictureOfUser = $root.request.GetProfilePictureOfUser.fromObject(object.getProfilePictureOfUser);
            }
            if (object.emptyTrash != null) {
                if (typeof object.emptyTrash !== "object")
                    throw TypeError(".request.Request.emptyTrash: object expected");
                message.emptyTrash = $root.request.EmptyTrash.fromObject(object.emptyTrash);
            }
            if (object.setThumbnail != null) {
                if (typeof object.setThumbnail !== "object")
                    throw TypeError(".request.Request.setThumbnail: object expected");
                message.setThumbnail = $root.request.SetThumbnail.fromObject(object.setThumbnail);
            }
            if (object.getThumbnail != null) {
                if (typeof object.getThumbnail !== "object")
                    throw TypeError(".request.Request.getThumbnail: object expected");
                message.getThumbnail = $root.request.GetThumbnail.fromObject(object.getThumbnail);
            }
            if (object.blockUser != null) {
                if (typeof object.blockUser !== "object")
                    throw TypeError(".request.Request.blockUser: object expected");
                message.blockUser = $root.request.BlockUser.fromObject(object.blockUser);
            }
            if (object.unblockUser != null) {
                if (typeof object.unblockUser !== "object")
                    throw TypeError(".request.Request.unblockUser: object expected");
                message.unblockUser = $root.request.UnblockUser.fromObject(object.unblockUser);
            }
            if (object.updateOrgSettings != null) {
                if (typeof object.updateOrgSettings !== "object")
                    throw TypeError(".request.Request.updateOrgSettings: object expected");
                message.updateOrgSettings = $root.request.UpdateOrgSettings.fromObject(object.updateOrgSettings);
            }
            if (object.getOrgSettings != null) {
                if (typeof object.getOrgSettings !== "object")
                    throw TypeError(".request.Request.getOrgSettings: object expected");
                message.getOrgSettings = $root.request.GetOrgSettings.fromObject(object.getOrgSettings);
            }
            return message;
        };

        /**
         * Creates a plain object from a Request message. Also converts values to other types if specified.
         * @function toObject
         * @memberof request.Request
         * @static
         * @param {request.Request} message Request
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Request.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.reqCreateTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.reqCreateTime = options.longs === String ? "0" : 0;
            if (message.addUser != null && message.hasOwnProperty("addUser")) {
                object.addUser = $root.request.AddUser.toObject(message.addUser, options);
                if (options.oneofs)
                    object.Operation = "addUser";
            }
            if (message.removeUser != null && message.hasOwnProperty("removeUser")) {
                object.removeUser = $root.request.RemoveUser.toObject(message.removeUser, options);
                if (options.oneofs)
                    object.Operation = "removeUser";
            }
            if (message.passwordReset != null && message.hasOwnProperty("passwordReset")) {
                object.passwordReset = $root.request.PasswordReset.toObject(message.passwordReset, options);
                if (options.oneofs)
                    object.Operation = "passwordReset";
            }
            if (message.changePassword != null && message.hasOwnProperty("changePassword")) {
                object.changePassword = $root.request.ChangePassword.toObject(message.changePassword, options);
                if (options.oneofs)
                    object.Operation = "changePassword";
            }
            if (message.addOrganization != null && message.hasOwnProperty("addOrganization")) {
                object.addOrganization = $root.request.AddOrganization.toObject(message.addOrganization, options);
                if (options.oneofs)
                    object.Operation = "addOrganization";
            }
            if (message.initiatePayment != null && message.hasOwnProperty("initiatePayment")) {
                object.initiatePayment = $root.request.InitiatePayment.toObject(message.initiatePayment, options);
                if (options.oneofs)
                    object.Operation = "initiatePayment";
            }
            if (message.signIn != null && message.hasOwnProperty("signIn")) {
                object.signIn = $root.request.SignIn.toObject(message.signIn, options);
                if (options.oneofs)
                    object.Operation = "signIn";
            }
            if (message.signOut != null && message.hasOwnProperty("signOut")) {
                object.signOut = $root.request.SignOut.toObject(message.signOut, options);
                if (options.oneofs)
                    object.Operation = "signOut";
            }
            if (message.inviteUser != null && message.hasOwnProperty("inviteUser")) {
                object.inviteUser = $root.request.InviteUser.toObject(message.inviteUser, options);
                if (options.oneofs)
                    object.Operation = "inviteUser";
            }
            if (message.getUser != null && message.hasOwnProperty("getUser")) {
                object.getUser = $root.request.GetUser.toObject(message.getUser, options);
                if (options.oneofs)
                    object.Operation = "getUser";
            }
            if (message.listUsers != null && message.hasOwnProperty("listUsers")) {
                object.listUsers = $root.request.ListUsers.toObject(message.listUsers, options);
                if (options.oneofs)
                    object.Operation = "listUsers";
            }
            if (message.removeOrganization != null && message.hasOwnProperty("removeOrganization")) {
                object.removeOrganization = $root.request.RemoveOrganization.toObject(message.removeOrganization, options);
                if (options.oneofs)
                    object.Operation = "removeOrganization";
            }
            if (message.verifyOrganization != null && message.hasOwnProperty("verifyOrganization")) {
                object.verifyOrganization = $root.request.VerifyOrganization.toObject(message.verifyOrganization, options);
                if (options.oneofs)
                    object.Operation = "verifyOrganization";
            }
            if (message.getOrganization != null && message.hasOwnProperty("getOrganization")) {
                object.getOrganization = $root.request.GetOrganization.toObject(message.getOrganization, options);
                if (options.oneofs)
                    object.Operation = "getOrganization";
            }
            if (message.addPin != null && message.hasOwnProperty("addPin")) {
                object.addPin = $root.request.AddPin.toObject(message.addPin, options);
                if (options.oneofs)
                    object.Operation = "addPin";
            }
            if (message.verifyUser != null && message.hasOwnProperty("verifyUser")) {
                object.verifyUser = $root.request.VerifyUser.toObject(message.verifyUser, options);
                if (options.oneofs)
                    object.Operation = "verifyUser";
            }
            if (message.getFileHead != null && message.hasOwnProperty("getFileHead")) {
                object.getFileHead = $root.request.GetFileHead.toObject(message.getFileHead, options);
                if (options.oneofs)
                    object.Operation = "getFileHead";
            }
            if (message.echo != null && message.hasOwnProperty("echo")) {
                object.echo = $root.request.Echo.toObject(message.echo, options);
                if (options.oneofs)
                    object.Operation = "echo";
            }
            if (message.fileLock != null && message.hasOwnProperty("fileLock")) {
                object.fileLock = $root.request.FileLock.toObject(message.fileLock, options);
                if (options.oneofs)
                    object.Operation = "fileLock";
            }
            if (message.fileUnlock != null && message.hasOwnProperty("fileUnlock")) {
                object.fileUnlock = $root.request.FileUnlock.toObject(message.fileUnlock, options);
                if (options.oneofs)
                    object.Operation = "fileUnlock";
            }
            if (message.getChunk != null && message.hasOwnProperty("getChunk")) {
                object.getChunk = $root.request.GetChunk.toObject(message.getChunk, options);
                if (options.oneofs)
                    object.Operation = "getChunk";
            }
            if (message.startWrite != null && message.hasOwnProperty("startWrite")) {
                object.startWrite = $root.request.StartWrite.toObject(message.startWrite, options);
                if (options.oneofs)
                    object.Operation = "startWrite";
            }
            if (message.putChunk != null && message.hasOwnProperty("putChunk")) {
                object.putChunk = $root.request.PutChunk.toObject(message.putChunk, options);
                if (options.oneofs)
                    object.Operation = "putChunk";
            }
            if (message.finalizeWrite != null && message.hasOwnProperty("finalizeWrite")) {
                object.finalizeWrite = $root.request.FinalizeWrite.toObject(message.finalizeWrite, options);
                if (options.oneofs)
                    object.Operation = "finalizeWrite";
            }
            if (message.listFiles != null && message.hasOwnProperty("listFiles")) {
                object.listFiles = $root.request.ListFiles.toObject(message.listFiles, options);
                if (options.oneofs)
                    object.Operation = "listFiles";
            }
            if (message.remove != null && message.hasOwnProperty("remove")) {
                object.remove = $root.request.Remove.toObject(message.remove, options);
                if (options.oneofs)
                    object.Operation = "remove";
            }
            if (message.getFolder != null && message.hasOwnProperty("getFolder")) {
                object.getFolder = $root.request.GetFolder.toObject(message.getFolder, options);
                if (options.oneofs)
                    object.Operation = "getFolder";
            }
            if (message.createFolder != null && message.hasOwnProperty("createFolder")) {
                object.createFolder = $root.request.CreateFolder.toObject(message.createFolder, options);
                if (options.oneofs)
                    object.Operation = "createFolder";
            }
            if (message.CreateSnapshot != null && message.hasOwnProperty("CreateSnapshot")) {
                object.CreateSnapshot = $root.request.CreateSnapshot.toObject(message.CreateSnapshot, options);
                if (options.oneofs)
                    object.Operation = "CreateSnapshot";
            }
            if (message.VerifyPayment != null && message.hasOwnProperty("VerifyPayment")) {
                object.VerifyPayment = $root.request.VerifyPayment.toObject(message.VerifyPayment, options);
                if (options.oneofs)
                    object.Operation = "VerifyPayment";
            }
            if (message.getSecret != null && message.hasOwnProperty("getSecret")) {
                object.getSecret = $root.request.GetSecret.toObject(message.getSecret, options);
                if (options.oneofs)
                    object.Operation = "getSecret";
            }
            if (message.addSecret != null && message.hasOwnProperty("addSecret")) {
                object.addSecret = $root.request.AddSecret.toObject(message.addSecret, options);
                if (options.oneofs)
                    object.Operation = "addSecret";
            }
            if (message.deleteSecret != null && message.hasOwnProperty("deleteSecret")) {
                object.deleteSecret = $root.request.DeleteSecret.toObject(message.deleteSecret, options);
                if (options.oneofs)
                    object.Operation = "deleteSecret";
            }
            if (message.updateSecret != null && message.hasOwnProperty("updateSecret")) {
                object.updateSecret = $root.request.UpdateSecret.toObject(message.updateSecret, options);
                if (options.oneofs)
                    object.Operation = "updateSecret";
            }
            if (message.listSecrets != null && message.hasOwnProperty("listSecrets")) {
                object.listSecrets = $root.request.ListSecrets.toObject(message.listSecrets, options);
                if (options.oneofs)
                    object.Operation = "listSecrets";
            }
            if (message.listSecretSubkeys != null && message.hasOwnProperty("listSecretSubkeys")) {
                object.listSecretSubkeys = $root.request.ListSecretSubkeys.toObject(message.listSecretSubkeys, options);
                if (options.oneofs)
                    object.Operation = "listSecretSubkeys";
            }
            if (message.undeleteSecret != null && message.hasOwnProperty("undeleteSecret")) {
                object.undeleteSecret = $root.request.UndeleteSecret.toObject(message.undeleteSecret, options);
                if (options.oneofs)
                    object.Operation = "undeleteSecret";
            }
            if (message.destroySecret != null && message.hasOwnProperty("destroySecret")) {
                object.destroySecret = $root.request.DestroySecret.toObject(message.destroySecret, options);
                if (options.oneofs)
                    object.Operation = "destroySecret";
            }
            if (message.addRole != null && message.hasOwnProperty("addRole")) {
                object.addRole = $root.request.AddRole.toObject(message.addRole, options);
                if (options.oneofs)
                    object.Operation = "addRole";
            }
            if (message.removeRole != null && message.hasOwnProperty("removeRole")) {
                object.removeRole = $root.request.RemoveRole.toObject(message.removeRole, options);
                if (options.oneofs)
                    object.Operation = "removeRole";
            }
            if (message.updateRole != null && message.hasOwnProperty("updateRole")) {
                object.updateRole = $root.request.UpdateRole.toObject(message.updateRole, options);
                if (options.oneofs)
                    object.Operation = "updateRole";
            }
            if (message.listRoles != null && message.hasOwnProperty("listRoles")) {
                object.listRoles = $root.request.ListRoles.toObject(message.listRoles, options);
                if (options.oneofs)
                    object.Operation = "listRoles";
            }
            if (message.addTeam != null && message.hasOwnProperty("addTeam")) {
                object.addTeam = $root.request.AddTeam.toObject(message.addTeam, options);
                if (options.oneofs)
                    object.Operation = "addTeam";
            }
            if (message.removeTeam != null && message.hasOwnProperty("removeTeam")) {
                object.removeTeam = $root.request.RemoveTeam.toObject(message.removeTeam, options);
                if (options.oneofs)
                    object.Operation = "removeTeam";
            }
            if (message.updateTeam != null && message.hasOwnProperty("updateTeam")) {
                object.updateTeam = $root.request.UpdateTeam.toObject(message.updateTeam, options);
                if (options.oneofs)
                    object.Operation = "updateTeam";
            }
            if (message.listTeams != null && message.hasOwnProperty("listTeams")) {
                object.listTeams = $root.request.ListTeams.toObject(message.listTeams, options);
                if (options.oneofs)
                    object.Operation = "listTeams";
            }
            if (message.isOperationAllowed != null && message.hasOwnProperty("isOperationAllowed")) {
                object.isOperationAllowed = $root.request.IsOperationAllowed.toObject(message.isOperationAllowed, options);
                if (options.oneofs)
                    object.Operation = "isOperationAllowed";
            }
            if (message.moveFile != null && message.hasOwnProperty("moveFile")) {
                object.moveFile = $root.request.MoveFile.toObject(message.moveFile, options);
                if (options.oneofs)
                    object.Operation = "moveFile";
            }
            if (message.moveFolder != null && message.hasOwnProperty("moveFolder")) {
                object.moveFolder = $root.request.MoveFolder.toObject(message.moveFolder, options);
                if (options.oneofs)
                    object.Operation = "moveFolder";
            }
            if (message.copyFile != null && message.hasOwnProperty("copyFile")) {
                object.copyFile = $root.request.CopyFile.toObject(message.copyFile, options);
                if (options.oneofs)
                    object.Operation = "copyFile";
            }
            if (message.copyFolder != null && message.hasOwnProperty("copyFolder")) {
                object.copyFolder = $root.request.CopyFolder.toObject(message.copyFolder, options);
                if (options.oneofs)
                    object.Operation = "copyFolder";
            }
            if (message.restoreVersion != null && message.hasOwnProperty("restoreVersion")) {
                object.restoreVersion = $root.request.RestoreVersion.toObject(message.restoreVersion, options);
                if (options.oneofs)
                    object.Operation = "restoreVersion";
            }
            if (message.removeFile != null && message.hasOwnProperty("removeFile")) {
                object.removeFile = $root.request.RemoveFile.toObject(message.removeFile, options);
                if (options.oneofs)
                    object.Operation = "removeFile";
            }
            if (message.removeFolder != null && message.hasOwnProperty("removeFolder")) {
                object.removeFolder = $root.request.RemoveFolder.toObject(message.removeFolder, options);
                if (options.oneofs)
                    object.Operation = "removeFolder";
            }
            if (message.untrashFile != null && message.hasOwnProperty("untrashFile")) {
                object.untrashFile = $root.request.UntrashFile.toObject(message.untrashFile, options);
                if (options.oneofs)
                    object.Operation = "untrashFile";
            }
            if (message.untrashFolder != null && message.hasOwnProperty("untrashFolder")) {
                object.untrashFolder = $root.request.UntrashFolder.toObject(message.untrashFolder, options);
                if (options.oneofs)
                    object.Operation = "untrashFolder";
            }
            if (message.undoStartWrite != null && message.hasOwnProperty("undoStartWrite")) {
                object.undoStartWrite = $root.request.UndoStartWrite.toObject(message.undoStartWrite, options);
                if (options.oneofs)
                    object.Operation = "undoStartWrite";
            }
            if (message.detachClonedFolder != null && message.hasOwnProperty("detachClonedFolder")) {
                object.detachClonedFolder = $root.request.DetachClonedFolder.toObject(message.detachClonedFolder, options);
                if (options.oneofs)
                    object.Operation = "detachClonedFolder";
            }
            if (message.getMetaFromPath != null && message.hasOwnProperty("getMetaFromPath")) {
                object.getMetaFromPath = $root.request.GetMetaFromPath.toObject(message.getMetaFromPath, options);
                if (options.oneofs)
                    object.Operation = "getMetaFromPath";
            }
            if (message.renameFile != null && message.hasOwnProperty("renameFile")) {
                object.renameFile = $root.request.RenameFile.toObject(message.renameFile, options);
                if (options.oneofs)
                    object.Operation = "renameFile";
            }
            if (message.renameFolder != null && message.hasOwnProperty("renameFolder")) {
                object.renameFolder = $root.request.RenameFolder.toObject(message.renameFolder, options);
                if (options.oneofs)
                    object.Operation = "renameFolder";
            }
            if (message.list != null && message.hasOwnProperty("list")) {
                object.list = $root.request.List.toObject(message.list, options);
                if (options.oneofs)
                    object.Operation = "list";
            }
            if (message.auditLogMessage != null && message.hasOwnProperty("auditLogMessage")) {
                object.auditLogMessage = $root.request.AuditLogMessage.toObject(message.auditLogMessage, options);
                if (options.oneofs)
                    object.Operation = "auditLogMessage";
            }
            if (message.resetVersion != null && message.hasOwnProperty("resetVersion")) {
                object.resetVersion = $root.request.ResetVersion.toObject(message.resetVersion, options);
                if (options.oneofs)
                    object.Operation = "resetVersion";
            }
            if (message.setUser != null && message.hasOwnProperty("setUser")) {
                object.setUser = $root.request.SetUser.toObject(message.setUser, options);
                if (options.oneofs)
                    object.Operation = "setUser";
            }
            if (message.finalizeProfileWrite != null && message.hasOwnProperty("finalizeProfileWrite")) {
                object.finalizeProfileWrite = $root.request.FinalizeProfileWrite.toObject(message.finalizeProfileWrite, options);
                if (options.oneofs)
                    object.Operation = "finalizeProfileWrite";
            }
            if (message.getProfileFileMeta != null && message.hasOwnProperty("getProfileFileMeta")) {
                object.getProfileFileMeta = $root.request.GetProfileFileMeta.toObject(message.getProfileFileMeta, options);
                if (options.oneofs)
                    object.Operation = "getProfileFileMeta";
            }
            if (message.profileChunkList != null && message.hasOwnProperty("profileChunkList")) {
                object.profileChunkList = $root.request.ProfileChunkList.toObject(message.profileChunkList, options);
                if (options.oneofs)
                    object.Operation = "profileChunkList";
            }
            if (message.getUserType != null && message.hasOwnProperty("getUserType")) {
                object.getUserType = $root.request.GetUserType.toObject(message.getUserType, options);
                if (options.oneofs)
                    object.Operation = "getUserType";
            }
            if (message.getRandomBytes != null && message.hasOwnProperty("getRandomBytes")) {
                object.getRandomBytes = $root.request.GetRandomBytes.toObject(message.getRandomBytes, options);
                if (options.oneofs)
                    object.Operation = "getRandomBytes";
            }
            if (message.share != null && message.hasOwnProperty("share")) {
                object.share = $root.request.Share.toObject(message.share, options);
                if (options.oneofs)
                    object.Operation = "share";
            }
            if (message.unshare != null && message.hasOwnProperty("unshare")) {
                object.unshare = $root.request.Unshare.toObject(message.unshare, options);
                if (options.oneofs)
                    object.Operation = "unshare";
            }
            if (message.updateShare != null && message.hasOwnProperty("updateShare")) {
                object.updateShare = $root.request.UpdateShare.toObject(message.updateShare, options);
                if (options.oneofs)
                    object.Operation = "updateShare";
            }
            if (message.listShares != null && message.hasOwnProperty("listShares")) {
                object.listShares = $root.request.ListShares.toObject(message.listShares, options);
                if (options.oneofs)
                    object.Operation = "listShares";
            }
            if (message.resetTOTP != null && message.hasOwnProperty("resetTOTP")) {
                object.resetTOTP = $root.request.ResetTOTP.toObject(message.resetTOTP, options);
                if (options.oneofs)
                    object.Operation = "resetTOTP";
            }
            if (message.getTeam != null && message.hasOwnProperty("getTeam")) {
                object.getTeam = $root.request.GetTeam.toObject(message.getTeam, options);
                if (options.oneofs)
                    object.Operation = "getTeam";
            }
            if (message.getRole != null && message.hasOwnProperty("getRole")) {
                object.getRole = $root.request.GetRole.toObject(message.getRole, options);
                if (options.oneofs)
                    object.Operation = "getRole";
            }
            if (message.setRolesTeamsToUser != null && message.hasOwnProperty("setRolesTeamsToUser")) {
                object.setRolesTeamsToUser = $root.request.SetRolesTeamsToUser.toObject(message.setRolesTeamsToUser, options);
                if (options.oneofs)
                    object.Operation = "setRolesTeamsToUser";
            }
            if (message.updatePinOps != null && message.hasOwnProperty("updatePinOps")) {
                object.updatePinOps = $root.request.UpdatePinOps.toObject(message.updatePinOps, options);
                if (options.oneofs)
                    object.Operation = "updatePinOps";
            }
            if (message.deletePin != null && message.hasOwnProperty("deletePin")) {
                object.deletePin = $root.request.DeletePin.toObject(message.deletePin, options);
                if (options.oneofs)
                    object.Operation = "deletePin";
            }
            if (message.getRolesAndTeamsOfUser != null && message.hasOwnProperty("getRolesAndTeamsOfUser")) {
                object.getRolesAndTeamsOfUser = $root.request.GetRolesAndTeamsOfUser.toObject(message.getRolesAndTeamsOfUser, options);
                if (options.oneofs)
                    object.Operation = "getRolesAndTeamsOfUser";
            }
            if (message.quickListSecrets != null && message.hasOwnProperty("quickListSecrets")) {
                object.quickListSecrets = $root.request.QuickListSecrets.toObject(message.quickListSecrets, options);
                if (options.oneofs)
                    object.Operation = "quickListSecrets";
            }
            if (message.restartPutChunk != null && message.hasOwnProperty("restartPutChunk")) {
                object.restartPutChunk = $root.request.RestartPutChunk.toObject(message.restartPutChunk, options);
                if (options.oneofs)
                    object.Operation = "restartPutChunk";
            }
            if (message.verifyAuditLogMeta != null && message.hasOwnProperty("verifyAuditLogMeta")) {
                object.verifyAuditLogMeta = $root.request.VerifyAuditLogMeta.toObject(message.verifyAuditLogMeta, options);
                if (options.oneofs)
                    object.Operation = "verifyAuditLogMeta";
            }
            if (message.getAuditLog != null && message.hasOwnProperty("getAuditLog")) {
                object.getAuditLog = $root.request.GetAuditLog.toObject(message.getAuditLog, options);
                if (options.oneofs)
                    object.Operation = "getAuditLog";
            }
            if (message.deleteAuditLog != null && message.hasOwnProperty("deleteAuditLog")) {
                object.deleteAuditLog = $root.request.DeleteAuditLog.toObject(message.deleteAuditLog, options);
                if (options.oneofs)
                    object.Operation = "deleteAuditLog";
            }
            if (message.getLedgerRange != null && message.hasOwnProperty("getLedgerRange")) {
                object.getLedgerRange = $root.request.GetLedgerRange.toObject(message.getLedgerRange, options);
                if (options.oneofs)
                    object.Operation = "getLedgerRange";
            }
            if (message.listPins != null && message.hasOwnProperty("listPins")) {
                object.listPins = $root.request.ListPins.toObject(message.listPins, options);
                if (options.oneofs)
                    object.Operation = "listPins";
            }
            if (message.getMetaFromSharedPath != null && message.hasOwnProperty("getMetaFromSharedPath")) {
                object.getMetaFromSharedPath = $root.request.GetMetaFromSharedPath.toObject(message.getMetaFromSharedPath, options);
                if (options.oneofs)
                    object.Operation = "getMetaFromSharedPath";
            }
            if (message.listQuestions != null && message.hasOwnProperty("listQuestions")) {
                object.listQuestions = $root.request.ListQuestions.toObject(message.listQuestions, options);
                if (options.oneofs)
                    object.Operation = "listQuestions";
            }
            if (message.verifyBYOSCreds != null && message.hasOwnProperty("verifyBYOSCreds")) {
                object.verifyBYOSCreds = $root.request.VerifyBYOSCreds.toObject(message.verifyBYOSCreds, options);
                if (options.oneofs)
                    object.Operation = "verifyBYOSCreds";
            }
            if (message.migrateToStorage != null && message.hasOwnProperty("migrateToStorage")) {
                object.migrateToStorage = $root.request.MigrateToStorage.toObject(message.migrateToStorage, options);
                if (options.oneofs)
                    object.Operation = "migrateToStorage";
            }
            if (message.updateStorageCreds != null && message.hasOwnProperty("updateStorageCreds")) {
                object.updateStorageCreds = $root.request.UpdateStorageCreds.toObject(message.updateStorageCreds, options);
                if (options.oneofs)
                    object.Operation = "updateStorageCreds";
            }
            if (message.verifyUserForAudit != null && message.hasOwnProperty("verifyUserForAudit")) {
                object.verifyUserForAudit = $root.request.VerifyUserForAudit.toObject(message.verifyUserForAudit, options);
                if (options.oneofs)
                    object.Operation = "verifyUserForAudit";
            }
            if (message.id != null && message.hasOwnProperty("id")) {
                if (typeof message.id === "number")
                    object.id = options.longs === String ? String(message.id) : message.id;
                else
                    object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber(true) : message.id;
                if (options.oneofs)
                    object._id = "id";
            }
            if (message.removeOrganizationUser != null && message.hasOwnProperty("removeOrganizationUser")) {
                object.removeOrganizationUser = $root.request.RemoveOrganizationUser.toObject(message.removeOrganizationUser, options);
                if (options.oneofs)
                    object.Operation = "removeOrganizationUser";
            }
            if (message.reqCreateTime != null && message.hasOwnProperty("reqCreateTime"))
                if (typeof message.reqCreateTime === "number")
                    object.reqCreateTime = options.longs === String ? String(message.reqCreateTime) : message.reqCreateTime;
                else
                    object.reqCreateTime = options.longs === String ? $util.Long.prototype.toString.call(message.reqCreateTime) : options.longs === Number ? new $util.LongBits(message.reqCreateTime.low >>> 0, message.reqCreateTime.high >>> 0).toNumber(true) : message.reqCreateTime;
            if (message.addSpace != null && message.hasOwnProperty("addSpace")) {
                object.addSpace = $root.request.AddSpace.toObject(message.addSpace, options);
                if (options.oneofs)
                    object.Operation = "addSpace";
            }
            if (message.addUserToSpace != null && message.hasOwnProperty("addUserToSpace")) {
                object.addUserToSpace = $root.request.AddUserToSpace.toObject(message.addUserToSpace, options);
                if (options.oneofs)
                    object.Operation = "addUserToSpace";
            }
            if (message.removeUserFromSpace != null && message.hasOwnProperty("removeUserFromSpace")) {
                object.removeUserFromSpace = $root.request.RemoveUserFromSpace.toObject(message.removeUserFromSpace, options);
                if (options.oneofs)
                    object.Operation = "removeUserFromSpace";
            }
            if (message.updatePermissionsOfSpace != null && message.hasOwnProperty("updatePermissionsOfSpace")) {
                object.updatePermissionsOfSpace = $root.request.UpdatePermissionsOfSpace.toObject(message.updatePermissionsOfSpace, options);
                if (options.oneofs)
                    object.Operation = "updatePermissionsOfSpace";
            }
            if (message.addObjectToSpace != null && message.hasOwnProperty("addObjectToSpace")) {
                object.addObjectToSpace = $root.request.AddObjectToSpace.toObject(message.addObjectToSpace, options);
                if (options.oneofs)
                    object.Operation = "addObjectToSpace";
            }
            if (message.removeObjectFromSpace != null && message.hasOwnProperty("removeObjectFromSpace")) {
                object.removeObjectFromSpace = $root.request.RemoveObjectFromSpace.toObject(message.removeObjectFromSpace, options);
                if (options.oneofs)
                    object.Operation = "removeObjectFromSpace";
            }
            if (message.removeSpace != null && message.hasOwnProperty("removeSpace")) {
                object.removeSpace = $root.request.RemoveSpace.toObject(message.removeSpace, options);
                if (options.oneofs)
                    object.Operation = "removeSpace";
            }
            if (message.sendOtpToExternalUser != null && message.hasOwnProperty("sendOtpToExternalUser")) {
                object.sendOtpToExternalUser = $root.request.SendOtpToExternalUser.toObject(message.sendOtpToExternalUser, options);
                if (options.oneofs)
                    object.Operation = "sendOtpToExternalUser";
            }
            if (message.signInToSpace != null && message.hasOwnProperty("signInToSpace")) {
                object.signInToSpace = $root.request.SignInToSpace.toObject(message.signInToSpace, options);
                if (options.oneofs)
                    object.Operation = "signInToSpace";
            }
            if (message.listSpaces != null && message.hasOwnProperty("listSpaces")) {
                object.listSpaces = $root.request.ListSpaces.toObject(message.listSpaces, options);
                if (options.oneofs)
                    object.Operation = "listSpaces";
            }
            if (message.sendOtpToExternalUserIfNotExist != null && message.hasOwnProperty("sendOtpToExternalUserIfNotExist")) {
                object.sendOtpToExternalUserIfNotExist = $root.request.SendOtpToExternalUserIfNotExist.toObject(message.sendOtpToExternalUserIfNotExist, options);
                if (options.oneofs)
                    object.Operation = "sendOtpToExternalUserIfNotExist";
            }
            if (message.getStorageValue != null && message.hasOwnProperty("getStorageValue")) {
                object.getStorageValue = $root.request.GetStorageValue.toObject(message.getStorageValue, options);
                if (options.oneofs)
                    object.Operation = "getStorageValue";
            }
            if (message.updateTags != null && message.hasOwnProperty("updateTags")) {
                object.updateTags = $root.request.UpdateTags.toObject(message.updateTags, options);
                if (options.oneofs)
                    object.Operation = "updateTags";
            }
            if (message.addComment != null && message.hasOwnProperty("addComment")) {
                object.addComment = $root.request.AddComment.toObject(message.addComment, options);
                if (options.oneofs)
                    object.Operation = "addComment";
            }
            if (message.removeComment != null && message.hasOwnProperty("removeComment")) {
                object.removeComment = $root.request.RemoveComment.toObject(message.removeComment, options);
                if (options.oneofs)
                    object.Operation = "removeComment";
            }
            if (message.listComments != null && message.hasOwnProperty("listComments")) {
                object.listComments = $root.request.ListComments.toObject(message.listComments, options);
                if (options.oneofs)
                    object.Operation = "listComments";
            }
            if (message.updateComment != null && message.hasOwnProperty("updateComment")) {
                object.updateComment = $root.request.UpdateComment.toObject(message.updateComment, options);
                if (options.oneofs)
                    object.Operation = "updateComment";
            }
            if (message.getComment != null && message.hasOwnProperty("getComment")) {
                object.getComment = $root.request.GetComment.toObject(message.getComment, options);
                if (options.oneofs)
                    object.Operation = "getComment";
            }
            if (message.sessionData != null && message.hasOwnProperty("sessionData")) {
                object.sessionData = $root.request.SessionData.toObject(message.sessionData, options);
                if (options.oneofs)
                    object.Operation = "sessionData";
            }
            if (message.getStorageCreds != null && message.hasOwnProperty("getStorageCreds")) {
                object.getStorageCreds = $root.request.GetStorageCreds.toObject(message.getStorageCreds, options);
                if (options.oneofs)
                    object.Operation = "getStorageCreds";
            }
            if (message.listPlans != null && message.hasOwnProperty("listPlans")) {
                object.listPlans = $root.request.ListPlans.toObject(message.listPlans, options);
                if (options.oneofs)
                    object.Operation = "listPlans";
            }
            if (message.upgradePlan != null && message.hasOwnProperty("upgradePlan")) {
                object.upgradePlan = $root.request.UpgradePlan.toObject(message.upgradePlan, options);
                if (options.oneofs)
                    object.Operation = "upgradePlan";
            }
            if (message.validateCoupon != null && message.hasOwnProperty("validateCoupon")) {
                object.validateCoupon = $root.request.ValidateCoupon.toObject(message.validateCoupon, options);
                if (options.oneofs)
                    object.Operation = "validateCoupon";
            }
            if (message.getPlan != null && message.hasOwnProperty("getPlan")) {
                object.getPlan = $root.request.GetPlan.toObject(message.getPlan, options);
                if (options.oneofs)
                    object.Operation = "getPlan";
            }
            if (message.removeVersion != null && message.hasOwnProperty("removeVersion")) {
                object.removeVersion = $root.request.RemoveVersion.toObject(message.removeVersion, options);
                if (options.oneofs)
                    object.Operation = "removeVersion";
            }
            if (message.getProfilePictureOfUser != null && message.hasOwnProperty("getProfilePictureOfUser")) {
                object.getProfilePictureOfUser = $root.request.GetProfilePictureOfUser.toObject(message.getProfilePictureOfUser, options);
                if (options.oneofs)
                    object.Operation = "getProfilePictureOfUser";
            }
            if (message.emptyTrash != null && message.hasOwnProperty("emptyTrash")) {
                object.emptyTrash = $root.request.EmptyTrash.toObject(message.emptyTrash, options);
                if (options.oneofs)
                    object.Operation = "emptyTrash";
            }
            if (message.setThumbnail != null && message.hasOwnProperty("setThumbnail")) {
                object.setThumbnail = $root.request.SetThumbnail.toObject(message.setThumbnail, options);
                if (options.oneofs)
                    object.Operation = "setThumbnail";
            }
            if (message.getThumbnail != null && message.hasOwnProperty("getThumbnail")) {
                object.getThumbnail = $root.request.GetThumbnail.toObject(message.getThumbnail, options);
                if (options.oneofs)
                    object.Operation = "getThumbnail";
            }
            if (message.blockUser != null && message.hasOwnProperty("blockUser")) {
                object.blockUser = $root.request.BlockUser.toObject(message.blockUser, options);
                if (options.oneofs)
                    object.Operation = "blockUser";
            }
            if (message.unblockUser != null && message.hasOwnProperty("unblockUser")) {
                object.unblockUser = $root.request.UnblockUser.toObject(message.unblockUser, options);
                if (options.oneofs)
                    object.Operation = "unblockUser";
            }
            if (message.updateOrgSettings != null && message.hasOwnProperty("updateOrgSettings")) {
                object.updateOrgSettings = $root.request.UpdateOrgSettings.toObject(message.updateOrgSettings, options);
                if (options.oneofs)
                    object.Operation = "updateOrgSettings";
            }
            if (message.getOrgSettings != null && message.hasOwnProperty("getOrgSettings")) {
                object.getOrgSettings = $root.request.GetOrgSettings.toObject(message.getOrgSettings, options);
                if (options.oneofs)
                    object.Operation = "getOrgSettings";
            }
            return object;
        };

        /**
         * Converts this Request to JSON.
         * @function toJSON
         * @memberof request.Request
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Request.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Request
         * @function getTypeUrl
         * @memberof request.Request
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Request.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/request.Request";
        };

        return Request;
    })();

    return request;
})();

export const response = $root.response = (() => {

    /**
     * Namespace response.
     * @exports response
     * @namespace
     */
    const response = {};

    /**
     * Status enum.
     * @name response.Status
     * @enum {number}
     * @property {number} SUCCESS=0 SUCCESS value
     * @property {number} BACKEND_ERROR=1 BACKEND_ERROR value
     * @property {number} AUTHENTICATION_FAILURE=2 AUTHENTICATION_FAILURE value
     * @property {number} CRYPTO_FAILURE=3 CRYPTO_FAILURE value
     * @property {number} STORAGE_FAILURE=4 STORAGE_FAILURE value
     * @property {number} INVALID_REQUEST=5 INVALID_REQUEST value
     * @property {number} INVALID_RESPONSE=6 INVALID_RESPONSE value
     * @property {number} OBJECT_NOT_FOUND=7 OBJECT_NOT_FOUND value
     * @property {number} OBJECT_EXISTS=8 OBJECT_EXISTS value
     * @property {number} OBJECT_CORRUPTED=9 OBJECT_CORRUPTED value
     * @property {number} OBJECT_LOCKED=10 OBJECT_LOCKED value
     * @property {number} ACCESS_DENIED=11 ACCESS_DENIED value
     * @property {number} QUOTA_EXCEEDED=12 QUOTA_EXCEEDED value
     * @property {number} STORAGE_FULL=13 STORAGE_FULL value
     * @property {number} STORAGE_UNAVAILABLE=14 STORAGE_UNAVAILABLE value
     * @property {number} STORAGE_CORRUPTED=15 STORAGE_CORRUPTED value
     * @property {number} STORAGE_MISCONFIGURED=16 STORAGE_MISCONFIGURED value
     * @property {number} STORAGE_READ_ONLY=17 STORAGE_READ_ONLY value
     * @property {number} STORAGE_DISABLED=18 STORAGE_DISABLED value
     * @property {number} BYOS_MIGRATION_IN_PROGRESS=19 BYOS_MIGRATION_IN_PROGRESS value
     * @property {number} FAILURE=100 FAILURE value
     */
    response.Status = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "SUCCESS"] = 0;
        values[valuesById[1] = "BACKEND_ERROR"] = 1;
        values[valuesById[2] = "AUTHENTICATION_FAILURE"] = 2;
        values[valuesById[3] = "CRYPTO_FAILURE"] = 3;
        values[valuesById[4] = "STORAGE_FAILURE"] = 4;
        values[valuesById[5] = "INVALID_REQUEST"] = 5;
        values[valuesById[6] = "INVALID_RESPONSE"] = 6;
        values[valuesById[7] = "OBJECT_NOT_FOUND"] = 7;
        values[valuesById[8] = "OBJECT_EXISTS"] = 8;
        values[valuesById[9] = "OBJECT_CORRUPTED"] = 9;
        values[valuesById[10] = "OBJECT_LOCKED"] = 10;
        values[valuesById[11] = "ACCESS_DENIED"] = 11;
        values[valuesById[12] = "QUOTA_EXCEEDED"] = 12;
        values[valuesById[13] = "STORAGE_FULL"] = 13;
        values[valuesById[14] = "STORAGE_UNAVAILABLE"] = 14;
        values[valuesById[15] = "STORAGE_CORRUPTED"] = 15;
        values[valuesById[16] = "STORAGE_MISCONFIGURED"] = 16;
        values[valuesById[17] = "STORAGE_READ_ONLY"] = 17;
        values[valuesById[18] = "STORAGE_DISABLED"] = 18;
        values[valuesById[19] = "BYOS_MIGRATION_IN_PROGRESS"] = 19;
        values[valuesById[100] = "FAILURE"] = 100;
        return values;
    })();

    /**
     * Plan enum.
     * @name response.Plan
     * @enum {number}
     * @property {number} Free=0 Free value
     * @property {number} Basic=1 Basic value
     * @property {number} Pro=2 Pro value
     */
    response.Plan = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "Free"] = 0;
        values[valuesById[1] = "Basic"] = 1;
        values[valuesById[2] = "Pro"] = 2;
        return values;
    })();

    response.AddUser = (function() {

        /**
         * Properties of an AddUser.
         * @memberof response
         * @interface IAddUser
         * @property {string|null} [email] AddUser email
         * @property {string|null} [organization] AddUser organization
         * @property {response.Status|null} [status] AddUser status
         * @property {string|null} [message] AddUser message
         * @property {string|null} [totpUri] AddUser totpUri
         * @property {boolean|null} [emailVerificationNeeded] AddUser emailVerificationNeeded
         */

        /**
         * Constructs a new AddUser.
         * @memberof response
         * @classdesc Represents an AddUser.
         * @implements IAddUser
         * @constructor
         * @param {response.IAddUser=} [properties] Properties to set
         */
        function AddUser(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddUser email.
         * @member {string} email
         * @memberof response.AddUser
         * @instance
         */
        AddUser.prototype.email = "";

        /**
         * AddUser organization.
         * @member {string|null|undefined} organization
         * @memberof response.AddUser
         * @instance
         */
        AddUser.prototype.organization = null;

        /**
         * AddUser status.
         * @member {response.Status} status
         * @memberof response.AddUser
         * @instance
         */
        AddUser.prototype.status = 0;

        /**
         * AddUser message.
         * @member {string|null|undefined} message
         * @memberof response.AddUser
         * @instance
         */
        AddUser.prototype.message = null;

        /**
         * AddUser totpUri.
         * @member {string|null|undefined} totpUri
         * @memberof response.AddUser
         * @instance
         */
        AddUser.prototype.totpUri = null;

        /**
         * AddUser emailVerificationNeeded.
         * @member {boolean|null|undefined} emailVerificationNeeded
         * @memberof response.AddUser
         * @instance
         */
        AddUser.prototype.emailVerificationNeeded = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(AddUser.prototype, "_organization", {
            get: $util.oneOfGetter($oneOfFields = ["organization"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(AddUser.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(AddUser.prototype, "_totpUri", {
            get: $util.oneOfGetter($oneOfFields = ["totpUri"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(AddUser.prototype, "_emailVerificationNeeded", {
            get: $util.oneOfGetter($oneOfFields = ["emailVerificationNeeded"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new AddUser instance using the specified properties.
         * @function create
         * @memberof response.AddUser
         * @static
         * @param {response.IAddUser=} [properties] Properties to set
         * @returns {response.AddUser} AddUser instance
         */
        AddUser.create = function create(properties) {
            return new AddUser(properties);
        };

        /**
         * Encodes the specified AddUser message. Does not implicitly {@link response.AddUser.verify|verify} messages.
         * @function encode
         * @memberof response.AddUser
         * @static
         * @param {response.IAddUser} message AddUser message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddUser.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.message);
            if (message.totpUri != null && Object.hasOwnProperty.call(message, "totpUri"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.totpUri);
            if (message.emailVerificationNeeded != null && Object.hasOwnProperty.call(message, "emailVerificationNeeded"))
                writer.uint32(/* id 6, wireType 0 =*/48).bool(message.emailVerificationNeeded);
            if (message.organization != null && Object.hasOwnProperty.call(message, "organization"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.organization);
            return writer;
        };

        /**
         * Encodes the specified AddUser message, length delimited. Does not implicitly {@link response.AddUser.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.AddUser
         * @static
         * @param {response.IAddUser} message AddUser message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddUser.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AddUser message from the specified reader or buffer.
         * @function decode
         * @memberof response.AddUser
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.AddUser} AddUser
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddUser.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.AddUser();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.email = reader.string();
                        break;
                    }
                case 7: {
                        message.organization = reader.string();
                        break;
                    }
                case 2: {
                        message.status = reader.int32();
                        break;
                    }
                case 4: {
                        message.message = reader.string();
                        break;
                    }
                case 5: {
                        message.totpUri = reader.string();
                        break;
                    }
                case 6: {
                        message.emailVerificationNeeded = reader.bool();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AddUser message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.AddUser
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.AddUser} AddUser
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddUser.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AddUser message.
         * @function verify
         * @memberof response.AddUser
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AddUser.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            if (message.organization != null && message.hasOwnProperty("organization")) {
                properties._organization = 1;
                if (!$util.isString(message.organization))
                    return "organization: string expected";
            }
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            if (message.totpUri != null && message.hasOwnProperty("totpUri")) {
                properties._totpUri = 1;
                if (!$util.isString(message.totpUri))
                    return "totpUri: string expected";
            }
            if (message.emailVerificationNeeded != null && message.hasOwnProperty("emailVerificationNeeded")) {
                properties._emailVerificationNeeded = 1;
                if (typeof message.emailVerificationNeeded !== "boolean")
                    return "emailVerificationNeeded: boolean expected";
            }
            return null;
        };

        /**
         * Creates an AddUser message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.AddUser
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.AddUser} AddUser
         */
        AddUser.fromObject = function fromObject(object) {
            if (object instanceof $root.response.AddUser)
                return object;
            let message = new $root.response.AddUser();
            if (object.email != null)
                message.email = String(object.email);
            if (object.organization != null)
                message.organization = String(object.organization);
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            if (object.totpUri != null)
                message.totpUri = String(object.totpUri);
            if (object.emailVerificationNeeded != null)
                message.emailVerificationNeeded = Boolean(object.emailVerificationNeeded);
            return message;
        };

        /**
         * Creates a plain object from an AddUser message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.AddUser
         * @static
         * @param {response.AddUser} message AddUser
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddUser.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.email = "";
                object.status = options.enums === String ? "SUCCESS" : 0;
            }
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            if (message.totpUri != null && message.hasOwnProperty("totpUri")) {
                object.totpUri = message.totpUri;
                if (options.oneofs)
                    object._totpUri = "totpUri";
            }
            if (message.emailVerificationNeeded != null && message.hasOwnProperty("emailVerificationNeeded")) {
                object.emailVerificationNeeded = message.emailVerificationNeeded;
                if (options.oneofs)
                    object._emailVerificationNeeded = "emailVerificationNeeded";
            }
            if (message.organization != null && message.hasOwnProperty("organization")) {
                object.organization = message.organization;
                if (options.oneofs)
                    object._organization = "organization";
            }
            return object;
        };

        /**
         * Converts this AddUser to JSON.
         * @function toJSON
         * @memberof response.AddUser
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddUser.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for AddUser
         * @function getTypeUrl
         * @memberof response.AddUser
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        AddUser.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.AddUser";
        };

        return AddUser;
    })();

    response.VerifyUser = (function() {

        /**
         * Properties of a VerifyUser.
         * @memberof response
         * @interface IVerifyUser
         * @property {string|null} [email] VerifyUser email
         * @property {response.Status|null} [status] VerifyUser status
         * @property {string|null} [message] VerifyUser message
         */

        /**
         * Constructs a new VerifyUser.
         * @memberof response
         * @classdesc Represents a VerifyUser.
         * @implements IVerifyUser
         * @constructor
         * @param {response.IVerifyUser=} [properties] Properties to set
         */
        function VerifyUser(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * VerifyUser email.
         * @member {string} email
         * @memberof response.VerifyUser
         * @instance
         */
        VerifyUser.prototype.email = "";

        /**
         * VerifyUser status.
         * @member {response.Status} status
         * @memberof response.VerifyUser
         * @instance
         */
        VerifyUser.prototype.status = 0;

        /**
         * VerifyUser message.
         * @member {string|null|undefined} message
         * @memberof response.VerifyUser
         * @instance
         */
        VerifyUser.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(VerifyUser.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new VerifyUser instance using the specified properties.
         * @function create
         * @memberof response.VerifyUser
         * @static
         * @param {response.IVerifyUser=} [properties] Properties to set
         * @returns {response.VerifyUser} VerifyUser instance
         */
        VerifyUser.create = function create(properties) {
            return new VerifyUser(properties);
        };

        /**
         * Encodes the specified VerifyUser message. Does not implicitly {@link response.VerifyUser.verify|verify} messages.
         * @function encode
         * @memberof response.VerifyUser
         * @static
         * @param {response.IVerifyUser} message VerifyUser message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        VerifyUser.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified VerifyUser message, length delimited. Does not implicitly {@link response.VerifyUser.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.VerifyUser
         * @static
         * @param {response.IVerifyUser} message VerifyUser message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        VerifyUser.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a VerifyUser message from the specified reader or buffer.
         * @function decode
         * @memberof response.VerifyUser
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.VerifyUser} VerifyUser
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        VerifyUser.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.VerifyUser();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.email = reader.string();
                        break;
                    }
                case 2: {
                        message.status = reader.int32();
                        break;
                    }
                case 3: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a VerifyUser message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.VerifyUser
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.VerifyUser} VerifyUser
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        VerifyUser.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a VerifyUser message.
         * @function verify
         * @memberof response.VerifyUser
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        VerifyUser.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a VerifyUser message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.VerifyUser
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.VerifyUser} VerifyUser
         */
        VerifyUser.fromObject = function fromObject(object) {
            if (object instanceof $root.response.VerifyUser)
                return object;
            let message = new $root.response.VerifyUser();
            if (object.email != null)
                message.email = String(object.email);
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a VerifyUser message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.VerifyUser
         * @static
         * @param {response.VerifyUser} message VerifyUser
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        VerifyUser.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.email = "";
                object.status = options.enums === String ? "SUCCESS" : 0;
            }
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this VerifyUser to JSON.
         * @function toJSON
         * @memberof response.VerifyUser
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        VerifyUser.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for VerifyUser
         * @function getTypeUrl
         * @memberof response.VerifyUser
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        VerifyUser.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.VerifyUser";
        };

        return VerifyUser;
    })();

    response.RemoveUser = (function() {

        /**
         * Properties of a RemoveUser.
         * @memberof response
         * @interface IRemoveUser
         * @property {string|null} [email] RemoveUser email
         * @property {response.Status|null} [status] RemoveUser status
         * @property {string|null} [message] RemoveUser message
         */

        /**
         * Constructs a new RemoveUser.
         * @memberof response
         * @classdesc Represents a RemoveUser.
         * @implements IRemoveUser
         * @constructor
         * @param {response.IRemoveUser=} [properties] Properties to set
         */
        function RemoveUser(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveUser email.
         * @member {string} email
         * @memberof response.RemoveUser
         * @instance
         */
        RemoveUser.prototype.email = "";

        /**
         * RemoveUser status.
         * @member {response.Status} status
         * @memberof response.RemoveUser
         * @instance
         */
        RemoveUser.prototype.status = 0;

        /**
         * RemoveUser message.
         * @member {string|null|undefined} message
         * @memberof response.RemoveUser
         * @instance
         */
        RemoveUser.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(RemoveUser.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new RemoveUser instance using the specified properties.
         * @function create
         * @memberof response.RemoveUser
         * @static
         * @param {response.IRemoveUser=} [properties] Properties to set
         * @returns {response.RemoveUser} RemoveUser instance
         */
        RemoveUser.create = function create(properties) {
            return new RemoveUser(properties);
        };

        /**
         * Encodes the specified RemoveUser message. Does not implicitly {@link response.RemoveUser.verify|verify} messages.
         * @function encode
         * @memberof response.RemoveUser
         * @static
         * @param {response.IRemoveUser} message RemoveUser message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RemoveUser.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified RemoveUser message, length delimited. Does not implicitly {@link response.RemoveUser.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.RemoveUser
         * @static
         * @param {response.IRemoveUser} message RemoveUser message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RemoveUser.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RemoveUser message from the specified reader or buffer.
         * @function decode
         * @memberof response.RemoveUser
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.RemoveUser} RemoveUser
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RemoveUser.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.RemoveUser();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.email = reader.string();
                        break;
                    }
                case 2: {
                        message.status = reader.int32();
                        break;
                    }
                case 3: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RemoveUser message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.RemoveUser
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.RemoveUser} RemoveUser
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RemoveUser.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RemoveUser message.
         * @function verify
         * @memberof response.RemoveUser
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RemoveUser.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a RemoveUser message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.RemoveUser
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.RemoveUser} RemoveUser
         */
        RemoveUser.fromObject = function fromObject(object) {
            if (object instanceof $root.response.RemoveUser)
                return object;
            let message = new $root.response.RemoveUser();
            if (object.email != null)
                message.email = String(object.email);
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a RemoveUser message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.RemoveUser
         * @static
         * @param {response.RemoveUser} message RemoveUser
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveUser.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.email = "";
                object.status = options.enums === String ? "SUCCESS" : 0;
            }
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this RemoveUser to JSON.
         * @function toJSON
         * @memberof response.RemoveUser
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveUser.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for RemoveUser
         * @function getTypeUrl
         * @memberof response.RemoveUser
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        RemoveUser.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.RemoveUser";
        };

        return RemoveUser;
    })();

    response.User = (function() {

        /**
         * Properties of a User.
         * @memberof response
         * @interface IUser
         * @property {string|null} [organization] User organization
         * @property {string|null} [email] User email
         * @property {string|null} [firstname] User firstname
         * @property {string|null} [lastname] User lastname
         * @property {string|null} [role] User role
         * @property {string|null} [location] User location
         * @property {string|null} [phone] User phone
         * @property {string|null} [address] User address
         * @property {Uint8Array|null} [profilePicture] User profilePicture
         * @property {Uint8Array|null} [userId] User userId
         * @property {Uint8Array|null} [organizationId] User organizationId
         * @property {number|null} [plan] User plan
         * @property {string|null} [paymentOrderId] User paymentOrderId
         * @property {boolean|null} [passwordReset] User passwordReset
         * @property {number|Long|null} [planExpiryDate] User planExpiryDate
         * @property {Array.<number>|null} [operations] User operations
         */

        /**
         * Constructs a new User.
         * @memberof response
         * @classdesc Represents a User.
         * @implements IUser
         * @constructor
         * @param {response.IUser=} [properties] Properties to set
         */
        function User(properties) {
            this.operations = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * User organization.
         * @member {string} organization
         * @memberof response.User
         * @instance
         */
        User.prototype.organization = "";

        /**
         * User email.
         * @member {string} email
         * @memberof response.User
         * @instance
         */
        User.prototype.email = "";

        /**
         * User firstname.
         * @member {string} firstname
         * @memberof response.User
         * @instance
         */
        User.prototype.firstname = "";

        /**
         * User lastname.
         * @member {string} lastname
         * @memberof response.User
         * @instance
         */
        User.prototype.lastname = "";

        /**
         * User role.
         * @member {string} role
         * @memberof response.User
         * @instance
         */
        User.prototype.role = "";

        /**
         * User location.
         * @member {string} location
         * @memberof response.User
         * @instance
         */
        User.prototype.location = "";

        /**
         * User phone.
         * @member {string} phone
         * @memberof response.User
         * @instance
         */
        User.prototype.phone = "";

        /**
         * User address.
         * @member {string} address
         * @memberof response.User
         * @instance
         */
        User.prototype.address = "";

        /**
         * User profilePicture.
         * @member {Uint8Array} profilePicture
         * @memberof response.User
         * @instance
         */
        User.prototype.profilePicture = $util.newBuffer([]);

        /**
         * User userId.
         * @member {Uint8Array} userId
         * @memberof response.User
         * @instance
         */
        User.prototype.userId = $util.newBuffer([]);

        /**
         * User organizationId.
         * @member {Uint8Array} organizationId
         * @memberof response.User
         * @instance
         */
        User.prototype.organizationId = $util.newBuffer([]);

        /**
         * User plan.
         * @member {number} plan
         * @memberof response.User
         * @instance
         */
        User.prototype.plan = 0;

        /**
         * User paymentOrderId.
         * @member {string|null|undefined} paymentOrderId
         * @memberof response.User
         * @instance
         */
        User.prototype.paymentOrderId = null;

        /**
         * User passwordReset.
         * @member {boolean} passwordReset
         * @memberof response.User
         * @instance
         */
        User.prototype.passwordReset = false;

        /**
         * User planExpiryDate.
         * @member {number|Long} planExpiryDate
         * @memberof response.User
         * @instance
         */
        User.prototype.planExpiryDate = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * User operations.
         * @member {Array.<number>} operations
         * @memberof response.User
         * @instance
         */
        User.prototype.operations = $util.emptyArray;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(User.prototype, "_paymentOrderId", {
            get: $util.oneOfGetter($oneOfFields = ["paymentOrderId"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new User instance using the specified properties.
         * @function create
         * @memberof response.User
         * @static
         * @param {response.IUser=} [properties] Properties to set
         * @returns {response.User} User instance
         */
        User.create = function create(properties) {
            return new User(properties);
        };

        /**
         * Encodes the specified User message. Does not implicitly {@link response.User.verify|verify} messages.
         * @function encode
         * @memberof response.User
         * @static
         * @param {response.IUser} message User message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.userId);
            if (message.organization != null && Object.hasOwnProperty.call(message, "organization"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.organization);
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.email);
            if (message.firstname != null && Object.hasOwnProperty.call(message, "firstname"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.firstname);
            if (message.lastname != null && Object.hasOwnProperty.call(message, "lastname"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.lastname);
            if (message.role != null && Object.hasOwnProperty.call(message, "role"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.role);
            if (message.location != null && Object.hasOwnProperty.call(message, "location"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.location);
            if (message.phone != null && Object.hasOwnProperty.call(message, "phone"))
                writer.uint32(/* id 9, wireType 2 =*/74).string(message.phone);
            if (message.address != null && Object.hasOwnProperty.call(message, "address"))
                writer.uint32(/* id 10, wireType 2 =*/82).string(message.address);
            if (message.profilePicture != null && Object.hasOwnProperty.call(message, "profilePicture"))
                writer.uint32(/* id 11, wireType 2 =*/90).bytes(message.profilePicture);
            if (message.organizationId != null && Object.hasOwnProperty.call(message, "organizationId"))
                writer.uint32(/* id 12, wireType 2 =*/98).bytes(message.organizationId);
            if (message.plan != null && Object.hasOwnProperty.call(message, "plan"))
                writer.uint32(/* id 15, wireType 0 =*/120).int32(message.plan);
            if (message.paymentOrderId != null && Object.hasOwnProperty.call(message, "paymentOrderId"))
                writer.uint32(/* id 16, wireType 2 =*/130).string(message.paymentOrderId);
            if (message.passwordReset != null && Object.hasOwnProperty.call(message, "passwordReset"))
                writer.uint32(/* id 17, wireType 0 =*/136).bool(message.passwordReset);
            if (message.planExpiryDate != null && Object.hasOwnProperty.call(message, "planExpiryDate"))
                writer.uint32(/* id 18, wireType 0 =*/144).uint64(message.planExpiryDate);
            if (message.operations != null && message.operations.length) {
                writer.uint32(/* id 19, wireType 2 =*/154).fork();
                for (let i = 0; i < message.operations.length; ++i)
                    writer.int32(message.operations[i]);
                writer.ldelim();
            }
            return writer;
        };

        /**
         * Encodes the specified User message, length delimited. Does not implicitly {@link response.User.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.User
         * @static
         * @param {response.IUser} message User message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        User.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a User message from the specified reader or buffer.
         * @function decode
         * @memberof response.User
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.User} User
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.User();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 2: {
                        message.organization = reader.string();
                        break;
                    }
                case 3: {
                        message.email = reader.string();
                        break;
                    }
                case 4: {
                        message.firstname = reader.string();
                        break;
                    }
                case 5: {
                        message.lastname = reader.string();
                        break;
                    }
                case 7: {
                        message.role = reader.string();
                        break;
                    }
                case 8: {
                        message.location = reader.string();
                        break;
                    }
                case 9: {
                        message.phone = reader.string();
                        break;
                    }
                case 10: {
                        message.address = reader.string();
                        break;
                    }
                case 11: {
                        message.profilePicture = reader.bytes();
                        break;
                    }
                case 1: {
                        message.userId = reader.bytes();
                        break;
                    }
                case 12: {
                        message.organizationId = reader.bytes();
                        break;
                    }
                case 15: {
                        message.plan = reader.int32();
                        break;
                    }
                case 16: {
                        message.paymentOrderId = reader.string();
                        break;
                    }
                case 17: {
                        message.passwordReset = reader.bool();
                        break;
                    }
                case 18: {
                        message.planExpiryDate = reader.uint64();
                        break;
                    }
                case 19: {
                        if (!(message.operations && message.operations.length))
                            message.operations = [];
                        if ((tag & 7) === 2) {
                            let end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.operations.push(reader.int32());
                        } else
                            message.operations.push(reader.int32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a User message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.User
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.User} User
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        User.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a User message.
         * @function verify
         * @memberof response.User
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        User.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.organization != null && message.hasOwnProperty("organization"))
                if (!$util.isString(message.organization))
                    return "organization: string expected";
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            if (message.firstname != null && message.hasOwnProperty("firstname"))
                if (!$util.isString(message.firstname))
                    return "firstname: string expected";
            if (message.lastname != null && message.hasOwnProperty("lastname"))
                if (!$util.isString(message.lastname))
                    return "lastname: string expected";
            if (message.role != null && message.hasOwnProperty("role"))
                if (!$util.isString(message.role))
                    return "role: string expected";
            if (message.location != null && message.hasOwnProperty("location"))
                if (!$util.isString(message.location))
                    return "location: string expected";
            if (message.phone != null && message.hasOwnProperty("phone"))
                if (!$util.isString(message.phone))
                    return "phone: string expected";
            if (message.address != null && message.hasOwnProperty("address"))
                if (!$util.isString(message.address))
                    return "address: string expected";
            if (message.profilePicture != null && message.hasOwnProperty("profilePicture"))
                if (!(message.profilePicture && typeof message.profilePicture.length === "number" || $util.isString(message.profilePicture)))
                    return "profilePicture: buffer expected";
            if (message.userId != null && message.hasOwnProperty("userId"))
                if (!(message.userId && typeof message.userId.length === "number" || $util.isString(message.userId)))
                    return "userId: buffer expected";
            if (message.organizationId != null && message.hasOwnProperty("organizationId"))
                if (!(message.organizationId && typeof message.organizationId.length === "number" || $util.isString(message.organizationId)))
                    return "organizationId: buffer expected";
            if (message.plan != null && message.hasOwnProperty("plan"))
                if (!$util.isInteger(message.plan))
                    return "plan: integer expected";
            if (message.paymentOrderId != null && message.hasOwnProperty("paymentOrderId")) {
                properties._paymentOrderId = 1;
                if (!$util.isString(message.paymentOrderId))
                    return "paymentOrderId: string expected";
            }
            if (message.passwordReset != null && message.hasOwnProperty("passwordReset"))
                if (typeof message.passwordReset !== "boolean")
                    return "passwordReset: boolean expected";
            if (message.planExpiryDate != null && message.hasOwnProperty("planExpiryDate"))
                if (!$util.isInteger(message.planExpiryDate) && !(message.planExpiryDate && $util.isInteger(message.planExpiryDate.low) && $util.isInteger(message.planExpiryDate.high)))
                    return "planExpiryDate: integer|Long expected";
            if (message.operations != null && message.hasOwnProperty("operations")) {
                if (!Array.isArray(message.operations))
                    return "operations: array expected";
                for (let i = 0; i < message.operations.length; ++i)
                    if (!$util.isInteger(message.operations[i]))
                        return "operations: integer[] expected";
            }
            return null;
        };

        /**
         * Creates a User message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.User
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.User} User
         */
        User.fromObject = function fromObject(object) {
            if (object instanceof $root.response.User)
                return object;
            let message = new $root.response.User();
            if (object.organization != null)
                message.organization = String(object.organization);
            if (object.email != null)
                message.email = String(object.email);
            if (object.firstname != null)
                message.firstname = String(object.firstname);
            if (object.lastname != null)
                message.lastname = String(object.lastname);
            if (object.role != null)
                message.role = String(object.role);
            if (object.location != null)
                message.location = String(object.location);
            if (object.phone != null)
                message.phone = String(object.phone);
            if (object.address != null)
                message.address = String(object.address);
            if (object.profilePicture != null)
                if (typeof object.profilePicture === "string")
                    $util.base64.decode(object.profilePicture, message.profilePicture = $util.newBuffer($util.base64.length(object.profilePicture)), 0);
                else if (object.profilePicture.length >= 0)
                    message.profilePicture = object.profilePicture;
            if (object.userId != null)
                if (typeof object.userId === "string")
                    $util.base64.decode(object.userId, message.userId = $util.newBuffer($util.base64.length(object.userId)), 0);
                else if (object.userId.length >= 0)
                    message.userId = object.userId;
            if (object.organizationId != null)
                if (typeof object.organizationId === "string")
                    $util.base64.decode(object.organizationId, message.organizationId = $util.newBuffer($util.base64.length(object.organizationId)), 0);
                else if (object.organizationId.length >= 0)
                    message.organizationId = object.organizationId;
            if (object.plan != null)
                message.plan = object.plan | 0;
            if (object.paymentOrderId != null)
                message.paymentOrderId = String(object.paymentOrderId);
            if (object.passwordReset != null)
                message.passwordReset = Boolean(object.passwordReset);
            if (object.planExpiryDate != null)
                if ($util.Long)
                    (message.planExpiryDate = $util.Long.fromValue(object.planExpiryDate)).unsigned = true;
                else if (typeof object.planExpiryDate === "string")
                    message.planExpiryDate = parseInt(object.planExpiryDate, 10);
                else if (typeof object.planExpiryDate === "number")
                    message.planExpiryDate = object.planExpiryDate;
                else if (typeof object.planExpiryDate === "object")
                    message.planExpiryDate = new $util.LongBits(object.planExpiryDate.low >>> 0, object.planExpiryDate.high >>> 0).toNumber(true);
            if (object.operations) {
                if (!Array.isArray(object.operations))
                    throw TypeError(".response.User.operations: array expected");
                message.operations = [];
                for (let i = 0; i < object.operations.length; ++i)
                    message.operations[i] = object.operations[i] | 0;
            }
            return message;
        };

        /**
         * Creates a plain object from a User message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.User
         * @static
         * @param {response.User} message User
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        User.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.operations = [];
            if (options.defaults) {
                if (options.bytes === String)
                    object.userId = "";
                else {
                    object.userId = [];
                    if (options.bytes !== Array)
                        object.userId = $util.newBuffer(object.userId);
                }
                object.organization = "";
                object.email = "";
                object.firstname = "";
                object.lastname = "";
                object.role = "";
                object.location = "";
                object.phone = "";
                object.address = "";
                if (options.bytes === String)
                    object.profilePicture = "";
                else {
                    object.profilePicture = [];
                    if (options.bytes !== Array)
                        object.profilePicture = $util.newBuffer(object.profilePicture);
                }
                if (options.bytes === String)
                    object.organizationId = "";
                else {
                    object.organizationId = [];
                    if (options.bytes !== Array)
                        object.organizationId = $util.newBuffer(object.organizationId);
                }
                object.plan = 0;
                object.passwordReset = false;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.planExpiryDate = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.planExpiryDate = options.longs === String ? "0" : 0;
            }
            if (message.userId != null && message.hasOwnProperty("userId"))
                object.userId = options.bytes === String ? $util.base64.encode(message.userId, 0, message.userId.length) : options.bytes === Array ? Array.prototype.slice.call(message.userId) : message.userId;
            if (message.organization != null && message.hasOwnProperty("organization"))
                object.organization = message.organization;
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.firstname != null && message.hasOwnProperty("firstname"))
                object.firstname = message.firstname;
            if (message.lastname != null && message.hasOwnProperty("lastname"))
                object.lastname = message.lastname;
            if (message.role != null && message.hasOwnProperty("role"))
                object.role = message.role;
            if (message.location != null && message.hasOwnProperty("location"))
                object.location = message.location;
            if (message.phone != null && message.hasOwnProperty("phone"))
                object.phone = message.phone;
            if (message.address != null && message.hasOwnProperty("address"))
                object.address = message.address;
            if (message.profilePicture != null && message.hasOwnProperty("profilePicture"))
                object.profilePicture = options.bytes === String ? $util.base64.encode(message.profilePicture, 0, message.profilePicture.length) : options.bytes === Array ? Array.prototype.slice.call(message.profilePicture) : message.profilePicture;
            if (message.organizationId != null && message.hasOwnProperty("organizationId"))
                object.organizationId = options.bytes === String ? $util.base64.encode(message.organizationId, 0, message.organizationId.length) : options.bytes === Array ? Array.prototype.slice.call(message.organizationId) : message.organizationId;
            if (message.plan != null && message.hasOwnProperty("plan"))
                object.plan = message.plan;
            if (message.paymentOrderId != null && message.hasOwnProperty("paymentOrderId")) {
                object.paymentOrderId = message.paymentOrderId;
                if (options.oneofs)
                    object._paymentOrderId = "paymentOrderId";
            }
            if (message.passwordReset != null && message.hasOwnProperty("passwordReset"))
                object.passwordReset = message.passwordReset;
            if (message.planExpiryDate != null && message.hasOwnProperty("planExpiryDate"))
                if (typeof message.planExpiryDate === "number")
                    object.planExpiryDate = options.longs === String ? String(message.planExpiryDate) : message.planExpiryDate;
                else
                    object.planExpiryDate = options.longs === String ? $util.Long.prototype.toString.call(message.planExpiryDate) : options.longs === Number ? new $util.LongBits(message.planExpiryDate.low >>> 0, message.planExpiryDate.high >>> 0).toNumber(true) : message.planExpiryDate;
            if (message.operations && message.operations.length) {
                object.operations = [];
                for (let j = 0; j < message.operations.length; ++j)
                    object.operations[j] = message.operations[j];
            }
            return object;
        };

        /**
         * Converts this User to JSON.
         * @function toJSON
         * @memberof response.User
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        User.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for User
         * @function getTypeUrl
         * @memberof response.User
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        User.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.User";
        };

        return User;
    })();

    response.Organization = (function() {

        /**
         * Properties of an Organization.
         * @memberof response
         * @interface IOrganization
         * @property {string|null} [name] Organization name
         * @property {string|null} [email] Organization email
         * @property {string|null} [phone] Organization phone
         * @property {string|null} [address] Organization address
         * @property {string|null} [taxId] Organization taxId
         * @property {string|null} [vatId] Organization vatId
         * @property {string|null} [registrationId] Organization registrationId
         * @property {number|null} [employees] Organization employees
         * @property {Uint8Array|null} [logo] Organization logo
         * @property {Uint8Array|null} [organizationId] Organization organizationId
         * @property {Uint8Array|null} [totpKey] Organization totpKey
         * @property {number|null} [plan] Organization plan
         * @property {string|null} [paymentOrderId] Organization paymentOrderId
         * @property {number|Long|null} [planExpiryDate] Organization planExpiryDate
         * @property {string|null} [location] Organization location
         */

        /**
         * Constructs a new Organization.
         * @memberof response
         * @classdesc Represents an Organization.
         * @implements IOrganization
         * @constructor
         * @param {response.IOrganization=} [properties] Properties to set
         */
        function Organization(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Organization name.
         * @member {string} name
         * @memberof response.Organization
         * @instance
         */
        Organization.prototype.name = "";

        /**
         * Organization email.
         * @member {string} email
         * @memberof response.Organization
         * @instance
         */
        Organization.prototype.email = "";

        /**
         * Organization phone.
         * @member {string} phone
         * @memberof response.Organization
         * @instance
         */
        Organization.prototype.phone = "";

        /**
         * Organization address.
         * @member {string} address
         * @memberof response.Organization
         * @instance
         */
        Organization.prototype.address = "";

        /**
         * Organization taxId.
         * @member {string} taxId
         * @memberof response.Organization
         * @instance
         */
        Organization.prototype.taxId = "";

        /**
         * Organization vatId.
         * @member {string} vatId
         * @memberof response.Organization
         * @instance
         */
        Organization.prototype.vatId = "";

        /**
         * Organization registrationId.
         * @member {string} registrationId
         * @memberof response.Organization
         * @instance
         */
        Organization.prototype.registrationId = "";

        /**
         * Organization employees.
         * @member {number} employees
         * @memberof response.Organization
         * @instance
         */
        Organization.prototype.employees = 0;

        /**
         * Organization logo.
         * @member {Uint8Array} logo
         * @memberof response.Organization
         * @instance
         */
        Organization.prototype.logo = $util.newBuffer([]);

        /**
         * Organization organizationId.
         * @member {Uint8Array} organizationId
         * @memberof response.Organization
         * @instance
         */
        Organization.prototype.organizationId = $util.newBuffer([]);

        /**
         * Organization totpKey.
         * @member {Uint8Array} totpKey
         * @memberof response.Organization
         * @instance
         */
        Organization.prototype.totpKey = $util.newBuffer([]);

        /**
         * Organization plan.
         * @member {number} plan
         * @memberof response.Organization
         * @instance
         */
        Organization.prototype.plan = 0;

        /**
         * Organization paymentOrderId.
         * @member {string|null|undefined} paymentOrderId
         * @memberof response.Organization
         * @instance
         */
        Organization.prototype.paymentOrderId = null;

        /**
         * Organization planExpiryDate.
         * @member {number|Long} planExpiryDate
         * @memberof response.Organization
         * @instance
         */
        Organization.prototype.planExpiryDate = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Organization location.
         * @member {string} location
         * @memberof response.Organization
         * @instance
         */
        Organization.prototype.location = "";

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(Organization.prototype, "_paymentOrderId", {
            get: $util.oneOfGetter($oneOfFields = ["paymentOrderId"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new Organization instance using the specified properties.
         * @function create
         * @memberof response.Organization
         * @static
         * @param {response.IOrganization=} [properties] Properties to set
         * @returns {response.Organization} Organization instance
         */
        Organization.create = function create(properties) {
            return new Organization(properties);
        };

        /**
         * Encodes the specified Organization message. Does not implicitly {@link response.Organization.verify|verify} messages.
         * @function encode
         * @memberof response.Organization
         * @static
         * @param {response.IOrganization} message Organization message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Organization.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.email);
            if (message.phone != null && Object.hasOwnProperty.call(message, "phone"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.phone);
            if (message.address != null && Object.hasOwnProperty.call(message, "address"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.address);
            if (message.taxId != null && Object.hasOwnProperty.call(message, "taxId"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.taxId);
            if (message.vatId != null && Object.hasOwnProperty.call(message, "vatId"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.vatId);
            if (message.registrationId != null && Object.hasOwnProperty.call(message, "registrationId"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.registrationId);
            if (message.employees != null && Object.hasOwnProperty.call(message, "employees"))
                writer.uint32(/* id 8, wireType 0 =*/64).uint32(message.employees);
            if (message.logo != null && Object.hasOwnProperty.call(message, "logo"))
                writer.uint32(/* id 9, wireType 2 =*/74).bytes(message.logo);
            if (message.organizationId != null && Object.hasOwnProperty.call(message, "organizationId"))
                writer.uint32(/* id 10, wireType 2 =*/82).bytes(message.organizationId);
            if (message.totpKey != null && Object.hasOwnProperty.call(message, "totpKey"))
                writer.uint32(/* id 11, wireType 2 =*/90).bytes(message.totpKey);
            if (message.plan != null && Object.hasOwnProperty.call(message, "plan"))
                writer.uint32(/* id 12, wireType 0 =*/96).int32(message.plan);
            if (message.paymentOrderId != null && Object.hasOwnProperty.call(message, "paymentOrderId"))
                writer.uint32(/* id 16, wireType 2 =*/130).string(message.paymentOrderId);
            if (message.planExpiryDate != null && Object.hasOwnProperty.call(message, "planExpiryDate"))
                writer.uint32(/* id 17, wireType 0 =*/136).uint64(message.planExpiryDate);
            if (message.location != null && Object.hasOwnProperty.call(message, "location"))
                writer.uint32(/* id 18, wireType 2 =*/146).string(message.location);
            return writer;
        };

        /**
         * Encodes the specified Organization message, length delimited. Does not implicitly {@link response.Organization.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.Organization
         * @static
         * @param {response.IOrganization} message Organization message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Organization.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an Organization message from the specified reader or buffer.
         * @function decode
         * @memberof response.Organization
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.Organization} Organization
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Organization.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.Organization();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.name = reader.string();
                        break;
                    }
                case 2: {
                        message.email = reader.string();
                        break;
                    }
                case 3: {
                        message.phone = reader.string();
                        break;
                    }
                case 4: {
                        message.address = reader.string();
                        break;
                    }
                case 5: {
                        message.taxId = reader.string();
                        break;
                    }
                case 6: {
                        message.vatId = reader.string();
                        break;
                    }
                case 7: {
                        message.registrationId = reader.string();
                        break;
                    }
                case 8: {
                        message.employees = reader.uint32();
                        break;
                    }
                case 9: {
                        message.logo = reader.bytes();
                        break;
                    }
                case 10: {
                        message.organizationId = reader.bytes();
                        break;
                    }
                case 11: {
                        message.totpKey = reader.bytes();
                        break;
                    }
                case 12: {
                        message.plan = reader.int32();
                        break;
                    }
                case 16: {
                        message.paymentOrderId = reader.string();
                        break;
                    }
                case 17: {
                        message.planExpiryDate = reader.uint64();
                        break;
                    }
                case 18: {
                        message.location = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an Organization message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.Organization
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.Organization} Organization
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Organization.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an Organization message.
         * @function verify
         * @memberof response.Organization
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Organization.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            if (message.phone != null && message.hasOwnProperty("phone"))
                if (!$util.isString(message.phone))
                    return "phone: string expected";
            if (message.address != null && message.hasOwnProperty("address"))
                if (!$util.isString(message.address))
                    return "address: string expected";
            if (message.taxId != null && message.hasOwnProperty("taxId"))
                if (!$util.isString(message.taxId))
                    return "taxId: string expected";
            if (message.vatId != null && message.hasOwnProperty("vatId"))
                if (!$util.isString(message.vatId))
                    return "vatId: string expected";
            if (message.registrationId != null && message.hasOwnProperty("registrationId"))
                if (!$util.isString(message.registrationId))
                    return "registrationId: string expected";
            if (message.employees != null && message.hasOwnProperty("employees"))
                if (!$util.isInteger(message.employees))
                    return "employees: integer expected";
            if (message.logo != null && message.hasOwnProperty("logo"))
                if (!(message.logo && typeof message.logo.length === "number" || $util.isString(message.logo)))
                    return "logo: buffer expected";
            if (message.organizationId != null && message.hasOwnProperty("organizationId"))
                if (!(message.organizationId && typeof message.organizationId.length === "number" || $util.isString(message.organizationId)))
                    return "organizationId: buffer expected";
            if (message.totpKey != null && message.hasOwnProperty("totpKey"))
                if (!(message.totpKey && typeof message.totpKey.length === "number" || $util.isString(message.totpKey)))
                    return "totpKey: buffer expected";
            if (message.plan != null && message.hasOwnProperty("plan"))
                if (!$util.isInteger(message.plan))
                    return "plan: integer expected";
            if (message.paymentOrderId != null && message.hasOwnProperty("paymentOrderId")) {
                properties._paymentOrderId = 1;
                if (!$util.isString(message.paymentOrderId))
                    return "paymentOrderId: string expected";
            }
            if (message.planExpiryDate != null && message.hasOwnProperty("planExpiryDate"))
                if (!$util.isInteger(message.planExpiryDate) && !(message.planExpiryDate && $util.isInteger(message.planExpiryDate.low) && $util.isInteger(message.planExpiryDate.high)))
                    return "planExpiryDate: integer|Long expected";
            if (message.location != null && message.hasOwnProperty("location"))
                if (!$util.isString(message.location))
                    return "location: string expected";
            return null;
        };

        /**
         * Creates an Organization message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.Organization
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.Organization} Organization
         */
        Organization.fromObject = function fromObject(object) {
            if (object instanceof $root.response.Organization)
                return object;
            let message = new $root.response.Organization();
            if (object.name != null)
                message.name = String(object.name);
            if (object.email != null)
                message.email = String(object.email);
            if (object.phone != null)
                message.phone = String(object.phone);
            if (object.address != null)
                message.address = String(object.address);
            if (object.taxId != null)
                message.taxId = String(object.taxId);
            if (object.vatId != null)
                message.vatId = String(object.vatId);
            if (object.registrationId != null)
                message.registrationId = String(object.registrationId);
            if (object.employees != null)
                message.employees = object.employees >>> 0;
            if (object.logo != null)
                if (typeof object.logo === "string")
                    $util.base64.decode(object.logo, message.logo = $util.newBuffer($util.base64.length(object.logo)), 0);
                else if (object.logo.length >= 0)
                    message.logo = object.logo;
            if (object.organizationId != null)
                if (typeof object.organizationId === "string")
                    $util.base64.decode(object.organizationId, message.organizationId = $util.newBuffer($util.base64.length(object.organizationId)), 0);
                else if (object.organizationId.length >= 0)
                    message.organizationId = object.organizationId;
            if (object.totpKey != null)
                if (typeof object.totpKey === "string")
                    $util.base64.decode(object.totpKey, message.totpKey = $util.newBuffer($util.base64.length(object.totpKey)), 0);
                else if (object.totpKey.length >= 0)
                    message.totpKey = object.totpKey;
            if (object.plan != null)
                message.plan = object.plan | 0;
            if (object.paymentOrderId != null)
                message.paymentOrderId = String(object.paymentOrderId);
            if (object.planExpiryDate != null)
                if ($util.Long)
                    (message.planExpiryDate = $util.Long.fromValue(object.planExpiryDate)).unsigned = true;
                else if (typeof object.planExpiryDate === "string")
                    message.planExpiryDate = parseInt(object.planExpiryDate, 10);
                else if (typeof object.planExpiryDate === "number")
                    message.planExpiryDate = object.planExpiryDate;
                else if (typeof object.planExpiryDate === "object")
                    message.planExpiryDate = new $util.LongBits(object.planExpiryDate.low >>> 0, object.planExpiryDate.high >>> 0).toNumber(true);
            if (object.location != null)
                message.location = String(object.location);
            return message;
        };

        /**
         * Creates a plain object from an Organization message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.Organization
         * @static
         * @param {response.Organization} message Organization
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Organization.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.name = "";
                object.email = "";
                object.phone = "";
                object.address = "";
                object.taxId = "";
                object.vatId = "";
                object.registrationId = "";
                object.employees = 0;
                if (options.bytes === String)
                    object.logo = "";
                else {
                    object.logo = [];
                    if (options.bytes !== Array)
                        object.logo = $util.newBuffer(object.logo);
                }
                if (options.bytes === String)
                    object.organizationId = "";
                else {
                    object.organizationId = [];
                    if (options.bytes !== Array)
                        object.organizationId = $util.newBuffer(object.organizationId);
                }
                if (options.bytes === String)
                    object.totpKey = "";
                else {
                    object.totpKey = [];
                    if (options.bytes !== Array)
                        object.totpKey = $util.newBuffer(object.totpKey);
                }
                object.plan = 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.planExpiryDate = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.planExpiryDate = options.longs === String ? "0" : 0;
                object.location = "";
            }
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.phone != null && message.hasOwnProperty("phone"))
                object.phone = message.phone;
            if (message.address != null && message.hasOwnProperty("address"))
                object.address = message.address;
            if (message.taxId != null && message.hasOwnProperty("taxId"))
                object.taxId = message.taxId;
            if (message.vatId != null && message.hasOwnProperty("vatId"))
                object.vatId = message.vatId;
            if (message.registrationId != null && message.hasOwnProperty("registrationId"))
                object.registrationId = message.registrationId;
            if (message.employees != null && message.hasOwnProperty("employees"))
                object.employees = message.employees;
            if (message.logo != null && message.hasOwnProperty("logo"))
                object.logo = options.bytes === String ? $util.base64.encode(message.logo, 0, message.logo.length) : options.bytes === Array ? Array.prototype.slice.call(message.logo) : message.logo;
            if (message.organizationId != null && message.hasOwnProperty("organizationId"))
                object.organizationId = options.bytes === String ? $util.base64.encode(message.organizationId, 0, message.organizationId.length) : options.bytes === Array ? Array.prototype.slice.call(message.organizationId) : message.organizationId;
            if (message.totpKey != null && message.hasOwnProperty("totpKey"))
                object.totpKey = options.bytes === String ? $util.base64.encode(message.totpKey, 0, message.totpKey.length) : options.bytes === Array ? Array.prototype.slice.call(message.totpKey) : message.totpKey;
            if (message.plan != null && message.hasOwnProperty("plan"))
                object.plan = message.plan;
            if (message.paymentOrderId != null && message.hasOwnProperty("paymentOrderId")) {
                object.paymentOrderId = message.paymentOrderId;
                if (options.oneofs)
                    object._paymentOrderId = "paymentOrderId";
            }
            if (message.planExpiryDate != null && message.hasOwnProperty("planExpiryDate"))
                if (typeof message.planExpiryDate === "number")
                    object.planExpiryDate = options.longs === String ? String(message.planExpiryDate) : message.planExpiryDate;
                else
                    object.planExpiryDate = options.longs === String ? $util.Long.prototype.toString.call(message.planExpiryDate) : options.longs === Number ? new $util.LongBits(message.planExpiryDate.low >>> 0, message.planExpiryDate.high >>> 0).toNumber(true) : message.planExpiryDate;
            if (message.location != null && message.hasOwnProperty("location"))
                object.location = message.location;
            return object;
        };

        /**
         * Converts this Organization to JSON.
         * @function toJSON
         * @memberof response.Organization
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Organization.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Organization
         * @function getTypeUrl
         * @memberof response.Organization
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Organization.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.Organization";
        };

        return Organization;
    })();

    response.UserMeta = (function() {

        /**
         * Properties of a UserMeta.
         * @memberof response
         * @interface IUserMeta
         * @property {response.IUser|null} [userObj] UserMeta userObj
         * @property {response.IOrganization|null} [organizationObj] UserMeta organizationObj
         */

        /**
         * Constructs a new UserMeta.
         * @memberof response
         * @classdesc Represents a UserMeta.
         * @implements IUserMeta
         * @constructor
         * @param {response.IUserMeta=} [properties] Properties to set
         */
        function UserMeta(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UserMeta userObj.
         * @member {response.IUser|null|undefined} userObj
         * @memberof response.UserMeta
         * @instance
         */
        UserMeta.prototype.userObj = null;

        /**
         * UserMeta organizationObj.
         * @member {response.IOrganization|null|undefined} organizationObj
         * @memberof response.UserMeta
         * @instance
         */
        UserMeta.prototype.organizationObj = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * UserMeta user.
         * @member {"userObj"|"organizationObj"|undefined} user
         * @memberof response.UserMeta
         * @instance
         */
        Object.defineProperty(UserMeta.prototype, "user", {
            get: $util.oneOfGetter($oneOfFields = ["userObj", "organizationObj"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new UserMeta instance using the specified properties.
         * @function create
         * @memberof response.UserMeta
         * @static
         * @param {response.IUserMeta=} [properties] Properties to set
         * @returns {response.UserMeta} UserMeta instance
         */
        UserMeta.create = function create(properties) {
            return new UserMeta(properties);
        };

        /**
         * Encodes the specified UserMeta message. Does not implicitly {@link response.UserMeta.verify|verify} messages.
         * @function encode
         * @memberof response.UserMeta
         * @static
         * @param {response.IUserMeta} message UserMeta message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UserMeta.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.userObj != null && Object.hasOwnProperty.call(message, "userObj"))
                $root.response.User.encode(message.userObj, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.organizationObj != null && Object.hasOwnProperty.call(message, "organizationObj"))
                $root.response.Organization.encode(message.organizationObj, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified UserMeta message, length delimited. Does not implicitly {@link response.UserMeta.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.UserMeta
         * @static
         * @param {response.IUserMeta} message UserMeta message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UserMeta.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a UserMeta message from the specified reader or buffer.
         * @function decode
         * @memberof response.UserMeta
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.UserMeta} UserMeta
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UserMeta.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.UserMeta();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.userObj = $root.response.User.decode(reader, reader.uint32());
                        break;
                    }
                case 2: {
                        message.organizationObj = $root.response.Organization.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a UserMeta message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.UserMeta
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.UserMeta} UserMeta
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UserMeta.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a UserMeta message.
         * @function verify
         * @memberof response.UserMeta
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UserMeta.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.userObj != null && message.hasOwnProperty("userObj")) {
                properties.user = 1;
                {
                    let error = $root.response.User.verify(message.userObj);
                    if (error)
                        return "userObj." + error;
                }
            }
            if (message.organizationObj != null && message.hasOwnProperty("organizationObj")) {
                if (properties.user === 1)
                    return "user: multiple values";
                properties.user = 1;
                {
                    let error = $root.response.Organization.verify(message.organizationObj);
                    if (error)
                        return "organizationObj." + error;
                }
            }
            return null;
        };

        /**
         * Creates a UserMeta message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.UserMeta
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.UserMeta} UserMeta
         */
        UserMeta.fromObject = function fromObject(object) {
            if (object instanceof $root.response.UserMeta)
                return object;
            let message = new $root.response.UserMeta();
            if (object.userObj != null) {
                if (typeof object.userObj !== "object")
                    throw TypeError(".response.UserMeta.userObj: object expected");
                message.userObj = $root.response.User.fromObject(object.userObj);
            }
            if (object.organizationObj != null) {
                if (typeof object.organizationObj !== "object")
                    throw TypeError(".response.UserMeta.organizationObj: object expected");
                message.organizationObj = $root.response.Organization.fromObject(object.organizationObj);
            }
            return message;
        };

        /**
         * Creates a plain object from a UserMeta message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.UserMeta
         * @static
         * @param {response.UserMeta} message UserMeta
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UserMeta.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (message.userObj != null && message.hasOwnProperty("userObj")) {
                object.userObj = $root.response.User.toObject(message.userObj, options);
                if (options.oneofs)
                    object.user = "userObj";
            }
            if (message.organizationObj != null && message.hasOwnProperty("organizationObj")) {
                object.organizationObj = $root.response.Organization.toObject(message.organizationObj, options);
                if (options.oneofs)
                    object.user = "organizationObj";
            }
            return object;
        };

        /**
         * Converts this UserMeta to JSON.
         * @function toJSON
         * @memberof response.UserMeta
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UserMeta.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for UserMeta
         * @function getTypeUrl
         * @memberof response.UserMeta
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        UserMeta.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.UserMeta";
        };

        return UserMeta;
    })();

    response.GetUser = (function() {

        /**
         * Properties of a GetUser.
         * @memberof response
         * @interface IGetUser
         * @property {response.Status|null} [status] GetUser status
         * @property {string|null} [message] GetUser message
         * @property {response.IUserMeta|null} [user] GetUser user
         */

        /**
         * Constructs a new GetUser.
         * @memberof response
         * @classdesc Represents a GetUser.
         * @implements IGetUser
         * @constructor
         * @param {response.IGetUser=} [properties] Properties to set
         */
        function GetUser(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetUser status.
         * @member {response.Status} status
         * @memberof response.GetUser
         * @instance
         */
        GetUser.prototype.status = 0;

        /**
         * GetUser message.
         * @member {string|null|undefined} message
         * @memberof response.GetUser
         * @instance
         */
        GetUser.prototype.message = null;

        /**
         * GetUser user.
         * @member {response.IUserMeta|null|undefined} user
         * @memberof response.GetUser
         * @instance
         */
        GetUser.prototype.user = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(GetUser.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new GetUser instance using the specified properties.
         * @function create
         * @memberof response.GetUser
         * @static
         * @param {response.IGetUser=} [properties] Properties to set
         * @returns {response.GetUser} GetUser instance
         */
        GetUser.create = function create(properties) {
            return new GetUser(properties);
        };

        /**
         * Encodes the specified GetUser message. Does not implicitly {@link response.GetUser.verify|verify} messages.
         * @function encode
         * @memberof response.GetUser
         * @static
         * @param {response.IGetUser} message GetUser message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetUser.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            if (message.user != null && Object.hasOwnProperty.call(message, "user"))
                $root.response.UserMeta.encode(message.user, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified GetUser message, length delimited. Does not implicitly {@link response.GetUser.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.GetUser
         * @static
         * @param {response.IGetUser} message GetUser message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetUser.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetUser message from the specified reader or buffer.
         * @function decode
         * @memberof response.GetUser
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.GetUser} GetUser
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetUser.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.GetUser();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                case 3: {
                        message.user = $root.response.UserMeta.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetUser message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.GetUser
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.GetUser} GetUser
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetUser.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetUser message.
         * @function verify
         * @memberof response.GetUser
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetUser.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            if (message.user != null && message.hasOwnProperty("user")) {
                let error = $root.response.UserMeta.verify(message.user);
                if (error)
                    return "user." + error;
            }
            return null;
        };

        /**
         * Creates a GetUser message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.GetUser
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.GetUser} GetUser
         */
        GetUser.fromObject = function fromObject(object) {
            if (object instanceof $root.response.GetUser)
                return object;
            let message = new $root.response.GetUser();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            if (object.user != null) {
                if (typeof object.user !== "object")
                    throw TypeError(".response.GetUser.user: object expected");
                message.user = $root.response.UserMeta.fromObject(object.user);
            }
            return message;
        };

        /**
         * Creates a plain object from a GetUser message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.GetUser
         * @static
         * @param {response.GetUser} message GetUser
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetUser.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.status = options.enums === String ? "SUCCESS" : 0;
                object.user = null;
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            if (message.user != null && message.hasOwnProperty("user"))
                object.user = $root.response.UserMeta.toObject(message.user, options);
            return object;
        };

        /**
         * Converts this GetUser to JSON.
         * @function toJSON
         * @memberof response.GetUser
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetUser.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetUser
         * @function getTypeUrl
         * @memberof response.GetUser
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetUser.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.GetUser";
        };

        return GetUser;
    })();

    response.PasswordReset = (function() {

        /**
         * Properties of a PasswordReset.
         * @memberof response
         * @interface IPasswordReset
         * @property {string|null} [email] PasswordReset email
         * @property {response.Status|null} [status] PasswordReset status
         * @property {string|null} [message] PasswordReset message
         */

        /**
         * Constructs a new PasswordReset.
         * @memberof response
         * @classdesc Represents a PasswordReset.
         * @implements IPasswordReset
         * @constructor
         * @param {response.IPasswordReset=} [properties] Properties to set
         */
        function PasswordReset(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PasswordReset email.
         * @member {string} email
         * @memberof response.PasswordReset
         * @instance
         */
        PasswordReset.prototype.email = "";

        /**
         * PasswordReset status.
         * @member {response.Status} status
         * @memberof response.PasswordReset
         * @instance
         */
        PasswordReset.prototype.status = 0;

        /**
         * PasswordReset message.
         * @member {string|null|undefined} message
         * @memberof response.PasswordReset
         * @instance
         */
        PasswordReset.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(PasswordReset.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new PasswordReset instance using the specified properties.
         * @function create
         * @memberof response.PasswordReset
         * @static
         * @param {response.IPasswordReset=} [properties] Properties to set
         * @returns {response.PasswordReset} PasswordReset instance
         */
        PasswordReset.create = function create(properties) {
            return new PasswordReset(properties);
        };

        /**
         * Encodes the specified PasswordReset message. Does not implicitly {@link response.PasswordReset.verify|verify} messages.
         * @function encode
         * @memberof response.PasswordReset
         * @static
         * @param {response.IPasswordReset} message PasswordReset message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PasswordReset.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified PasswordReset message, length delimited. Does not implicitly {@link response.PasswordReset.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.PasswordReset
         * @static
         * @param {response.IPasswordReset} message PasswordReset message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PasswordReset.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PasswordReset message from the specified reader or buffer.
         * @function decode
         * @memberof response.PasswordReset
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.PasswordReset} PasswordReset
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PasswordReset.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.PasswordReset();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.email = reader.string();
                        break;
                    }
                case 2: {
                        message.status = reader.int32();
                        break;
                    }
                case 3: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PasswordReset message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.PasswordReset
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.PasswordReset} PasswordReset
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PasswordReset.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PasswordReset message.
         * @function verify
         * @memberof response.PasswordReset
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PasswordReset.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a PasswordReset message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.PasswordReset
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.PasswordReset} PasswordReset
         */
        PasswordReset.fromObject = function fromObject(object) {
            if (object instanceof $root.response.PasswordReset)
                return object;
            let message = new $root.response.PasswordReset();
            if (object.email != null)
                message.email = String(object.email);
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a PasswordReset message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.PasswordReset
         * @static
         * @param {response.PasswordReset} message PasswordReset
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PasswordReset.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.email = "";
                object.status = options.enums === String ? "SUCCESS" : 0;
            }
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this PasswordReset to JSON.
         * @function toJSON
         * @memberof response.PasswordReset
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PasswordReset.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for PasswordReset
         * @function getTypeUrl
         * @memberof response.PasswordReset
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        PasswordReset.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.PasswordReset";
        };

        return PasswordReset;
    })();

    response.ChangePassword = (function() {

        /**
         * Properties of a ChangePassword.
         * @memberof response
         * @interface IChangePassword
         * @property {string|null} [email] ChangePassword email
         * @property {response.Status|null} [status] ChangePassword status
         * @property {string|null} [message] ChangePassword message
         * @property {Uint8Array|null} [totpKey] ChangePassword totpKey
         */

        /**
         * Constructs a new ChangePassword.
         * @memberof response
         * @classdesc Represents a ChangePassword.
         * @implements IChangePassword
         * @constructor
         * @param {response.IChangePassword=} [properties] Properties to set
         */
        function ChangePassword(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ChangePassword email.
         * @member {string} email
         * @memberof response.ChangePassword
         * @instance
         */
        ChangePassword.prototype.email = "";

        /**
         * ChangePassword status.
         * @member {response.Status} status
         * @memberof response.ChangePassword
         * @instance
         */
        ChangePassword.prototype.status = 0;

        /**
         * ChangePassword message.
         * @member {string|null|undefined} message
         * @memberof response.ChangePassword
         * @instance
         */
        ChangePassword.prototype.message = null;

        /**
         * ChangePassword totpKey.
         * @member {Uint8Array|null|undefined} totpKey
         * @memberof response.ChangePassword
         * @instance
         */
        ChangePassword.prototype.totpKey = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(ChangePassword.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(ChangePassword.prototype, "_totpKey", {
            get: $util.oneOfGetter($oneOfFields = ["totpKey"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new ChangePassword instance using the specified properties.
         * @function create
         * @memberof response.ChangePassword
         * @static
         * @param {response.IChangePassword=} [properties] Properties to set
         * @returns {response.ChangePassword} ChangePassword instance
         */
        ChangePassword.create = function create(properties) {
            return new ChangePassword(properties);
        };

        /**
         * Encodes the specified ChangePassword message. Does not implicitly {@link response.ChangePassword.verify|verify} messages.
         * @function encode
         * @memberof response.ChangePassword
         * @static
         * @param {response.IChangePassword} message ChangePassword message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ChangePassword.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.message);
            if (message.totpKey != null && Object.hasOwnProperty.call(message, "totpKey"))
                writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.totpKey);
            return writer;
        };

        /**
         * Encodes the specified ChangePassword message, length delimited. Does not implicitly {@link response.ChangePassword.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.ChangePassword
         * @static
         * @param {response.IChangePassword} message ChangePassword message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ChangePassword.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ChangePassword message from the specified reader or buffer.
         * @function decode
         * @memberof response.ChangePassword
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.ChangePassword} ChangePassword
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ChangePassword.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.ChangePassword();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.email = reader.string();
                        break;
                    }
                case 2: {
                        message.status = reader.int32();
                        break;
                    }
                case 3: {
                        message.message = reader.string();
                        break;
                    }
                case 4: {
                        message.totpKey = reader.bytes();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ChangePassword message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.ChangePassword
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.ChangePassword} ChangePassword
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ChangePassword.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ChangePassword message.
         * @function verify
         * @memberof response.ChangePassword
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ChangePassword.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            if (message.totpKey != null && message.hasOwnProperty("totpKey")) {
                properties._totpKey = 1;
                if (!(message.totpKey && typeof message.totpKey.length === "number" || $util.isString(message.totpKey)))
                    return "totpKey: buffer expected";
            }
            return null;
        };

        /**
         * Creates a ChangePassword message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.ChangePassword
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.ChangePassword} ChangePassword
         */
        ChangePassword.fromObject = function fromObject(object) {
            if (object instanceof $root.response.ChangePassword)
                return object;
            let message = new $root.response.ChangePassword();
            if (object.email != null)
                message.email = String(object.email);
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            if (object.totpKey != null)
                if (typeof object.totpKey === "string")
                    $util.base64.decode(object.totpKey, message.totpKey = $util.newBuffer($util.base64.length(object.totpKey)), 0);
                else if (object.totpKey.length >= 0)
                    message.totpKey = object.totpKey;
            return message;
        };

        /**
         * Creates a plain object from a ChangePassword message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.ChangePassword
         * @static
         * @param {response.ChangePassword} message ChangePassword
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ChangePassword.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.email = "";
                object.status = options.enums === String ? "SUCCESS" : 0;
            }
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            if (message.totpKey != null && message.hasOwnProperty("totpKey")) {
                object.totpKey = options.bytes === String ? $util.base64.encode(message.totpKey, 0, message.totpKey.length) : options.bytes === Array ? Array.prototype.slice.call(message.totpKey) : message.totpKey;
                if (options.oneofs)
                    object._totpKey = "totpKey";
            }
            return object;
        };

        /**
         * Converts this ChangePassword to JSON.
         * @function toJSON
         * @memberof response.ChangePassword
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ChangePassword.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ChangePassword
         * @function getTypeUrl
         * @memberof response.ChangePassword
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ChangePassword.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.ChangePassword";
        };

        return ChangePassword;
    })();

    response.AddOrganization = (function() {

        /**
         * Properties of an AddOrganization.
         * @memberof response
         * @interface IAddOrganization
         * @property {string|null} [organization] AddOrganization organization
         * @property {string|null} [email] AddOrganization email
         * @property {response.Status|null} [status] AddOrganization status
         * @property {string|null} [message] AddOrganization message
         * @property {string|null} [totpKey] AddOrganization totpKey
         * @property {boolean|null} [emailVerificationNeeded] AddOrganization emailVerificationNeeded
         */

        /**
         * Constructs a new AddOrganization.
         * @memberof response
         * @classdesc Represents an AddOrganization.
         * @implements IAddOrganization
         * @constructor
         * @param {response.IAddOrganization=} [properties] Properties to set
         */
        function AddOrganization(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddOrganization organization.
         * @member {string|null|undefined} organization
         * @memberof response.AddOrganization
         * @instance
         */
        AddOrganization.prototype.organization = null;

        /**
         * AddOrganization email.
         * @member {string} email
         * @memberof response.AddOrganization
         * @instance
         */
        AddOrganization.prototype.email = "";

        /**
         * AddOrganization status.
         * @member {response.Status} status
         * @memberof response.AddOrganization
         * @instance
         */
        AddOrganization.prototype.status = 0;

        /**
         * AddOrganization message.
         * @member {string|null|undefined} message
         * @memberof response.AddOrganization
         * @instance
         */
        AddOrganization.prototype.message = null;

        /**
         * AddOrganization totpKey.
         * @member {string|null|undefined} totpKey
         * @memberof response.AddOrganization
         * @instance
         */
        AddOrganization.prototype.totpKey = null;

        /**
         * AddOrganization emailVerificationNeeded.
         * @member {boolean|null|undefined} emailVerificationNeeded
         * @memberof response.AddOrganization
         * @instance
         */
        AddOrganization.prototype.emailVerificationNeeded = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(AddOrganization.prototype, "_organization", {
            get: $util.oneOfGetter($oneOfFields = ["organization"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(AddOrganization.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(AddOrganization.prototype, "_totpKey", {
            get: $util.oneOfGetter($oneOfFields = ["totpKey"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(AddOrganization.prototype, "_emailVerificationNeeded", {
            get: $util.oneOfGetter($oneOfFields = ["emailVerificationNeeded"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new AddOrganization instance using the specified properties.
         * @function create
         * @memberof response.AddOrganization
         * @static
         * @param {response.IAddOrganization=} [properties] Properties to set
         * @returns {response.AddOrganization} AddOrganization instance
         */
        AddOrganization.create = function create(properties) {
            return new AddOrganization(properties);
        };

        /**
         * Encodes the specified AddOrganization message. Does not implicitly {@link response.AddOrganization.verify|verify} messages.
         * @function encode
         * @memberof response.AddOrganization
         * @static
         * @param {response.IAddOrganization} message AddOrganization message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddOrganization.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.message);
            if (message.totpKey != null && Object.hasOwnProperty.call(message, "totpKey"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.totpKey);
            if (message.emailVerificationNeeded != null && Object.hasOwnProperty.call(message, "emailVerificationNeeded"))
                writer.uint32(/* id 5, wireType 0 =*/40).bool(message.emailVerificationNeeded);
            if (message.organization != null && Object.hasOwnProperty.call(message, "organization"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.organization);
            return writer;
        };

        /**
         * Encodes the specified AddOrganization message, length delimited. Does not implicitly {@link response.AddOrganization.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.AddOrganization
         * @static
         * @param {response.IAddOrganization} message AddOrganization message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddOrganization.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AddOrganization message from the specified reader or buffer.
         * @function decode
         * @memberof response.AddOrganization
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.AddOrganization} AddOrganization
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddOrganization.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.AddOrganization();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 6: {
                        message.organization = reader.string();
                        break;
                    }
                case 1: {
                        message.email = reader.string();
                        break;
                    }
                case 2: {
                        message.status = reader.int32();
                        break;
                    }
                case 3: {
                        message.message = reader.string();
                        break;
                    }
                case 4: {
                        message.totpKey = reader.string();
                        break;
                    }
                case 5: {
                        message.emailVerificationNeeded = reader.bool();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AddOrganization message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.AddOrganization
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.AddOrganization} AddOrganization
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddOrganization.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AddOrganization message.
         * @function verify
         * @memberof response.AddOrganization
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AddOrganization.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.organization != null && message.hasOwnProperty("organization")) {
                properties._organization = 1;
                if (!$util.isString(message.organization))
                    return "organization: string expected";
            }
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            if (message.totpKey != null && message.hasOwnProperty("totpKey")) {
                properties._totpKey = 1;
                if (!$util.isString(message.totpKey))
                    return "totpKey: string expected";
            }
            if (message.emailVerificationNeeded != null && message.hasOwnProperty("emailVerificationNeeded")) {
                properties._emailVerificationNeeded = 1;
                if (typeof message.emailVerificationNeeded !== "boolean")
                    return "emailVerificationNeeded: boolean expected";
            }
            return null;
        };

        /**
         * Creates an AddOrganization message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.AddOrganization
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.AddOrganization} AddOrganization
         */
        AddOrganization.fromObject = function fromObject(object) {
            if (object instanceof $root.response.AddOrganization)
                return object;
            let message = new $root.response.AddOrganization();
            if (object.organization != null)
                message.organization = String(object.organization);
            if (object.email != null)
                message.email = String(object.email);
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            if (object.totpKey != null)
                message.totpKey = String(object.totpKey);
            if (object.emailVerificationNeeded != null)
                message.emailVerificationNeeded = Boolean(object.emailVerificationNeeded);
            return message;
        };

        /**
         * Creates a plain object from an AddOrganization message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.AddOrganization
         * @static
         * @param {response.AddOrganization} message AddOrganization
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddOrganization.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.email = "";
                object.status = options.enums === String ? "SUCCESS" : 0;
            }
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            if (message.totpKey != null && message.hasOwnProperty("totpKey")) {
                object.totpKey = message.totpKey;
                if (options.oneofs)
                    object._totpKey = "totpKey";
            }
            if (message.emailVerificationNeeded != null && message.hasOwnProperty("emailVerificationNeeded")) {
                object.emailVerificationNeeded = message.emailVerificationNeeded;
                if (options.oneofs)
                    object._emailVerificationNeeded = "emailVerificationNeeded";
            }
            if (message.organization != null && message.hasOwnProperty("organization")) {
                object.organization = message.organization;
                if (options.oneofs)
                    object._organization = "organization";
            }
            return object;
        };

        /**
         * Converts this AddOrganization to JSON.
         * @function toJSON
         * @memberof response.AddOrganization
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddOrganization.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for AddOrganization
         * @function getTypeUrl
         * @memberof response.AddOrganization
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        AddOrganization.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.AddOrganization";
        };

        return AddOrganization;
    })();

    response.VerifyOrganization = (function() {

        /**
         * Properties of a VerifyOrganization.
         * @memberof response
         * @interface IVerifyOrganization
         * @property {string|null} [email] VerifyOrganization email
         * @property {response.Status|null} [status] VerifyOrganization status
         * @property {string|null} [message] VerifyOrganization message
         */

        /**
         * Constructs a new VerifyOrganization.
         * @memberof response
         * @classdesc Represents a VerifyOrganization.
         * @implements IVerifyOrganization
         * @constructor
         * @param {response.IVerifyOrganization=} [properties] Properties to set
         */
        function VerifyOrganization(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * VerifyOrganization email.
         * @member {string} email
         * @memberof response.VerifyOrganization
         * @instance
         */
        VerifyOrganization.prototype.email = "";

        /**
         * VerifyOrganization status.
         * @member {response.Status} status
         * @memberof response.VerifyOrganization
         * @instance
         */
        VerifyOrganization.prototype.status = 0;

        /**
         * VerifyOrganization message.
         * @member {string|null|undefined} message
         * @memberof response.VerifyOrganization
         * @instance
         */
        VerifyOrganization.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(VerifyOrganization.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new VerifyOrganization instance using the specified properties.
         * @function create
         * @memberof response.VerifyOrganization
         * @static
         * @param {response.IVerifyOrganization=} [properties] Properties to set
         * @returns {response.VerifyOrganization} VerifyOrganization instance
         */
        VerifyOrganization.create = function create(properties) {
            return new VerifyOrganization(properties);
        };

        /**
         * Encodes the specified VerifyOrganization message. Does not implicitly {@link response.VerifyOrganization.verify|verify} messages.
         * @function encode
         * @memberof response.VerifyOrganization
         * @static
         * @param {response.IVerifyOrganization} message VerifyOrganization message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        VerifyOrganization.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified VerifyOrganization message, length delimited. Does not implicitly {@link response.VerifyOrganization.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.VerifyOrganization
         * @static
         * @param {response.IVerifyOrganization} message VerifyOrganization message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        VerifyOrganization.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a VerifyOrganization message from the specified reader or buffer.
         * @function decode
         * @memberof response.VerifyOrganization
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.VerifyOrganization} VerifyOrganization
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        VerifyOrganization.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.VerifyOrganization();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.email = reader.string();
                        break;
                    }
                case 2: {
                        message.status = reader.int32();
                        break;
                    }
                case 3: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a VerifyOrganization message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.VerifyOrganization
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.VerifyOrganization} VerifyOrganization
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        VerifyOrganization.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a VerifyOrganization message.
         * @function verify
         * @memberof response.VerifyOrganization
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        VerifyOrganization.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a VerifyOrganization message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.VerifyOrganization
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.VerifyOrganization} VerifyOrganization
         */
        VerifyOrganization.fromObject = function fromObject(object) {
            if (object instanceof $root.response.VerifyOrganization)
                return object;
            let message = new $root.response.VerifyOrganization();
            if (object.email != null)
                message.email = String(object.email);
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a VerifyOrganization message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.VerifyOrganization
         * @static
         * @param {response.VerifyOrganization} message VerifyOrganization
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        VerifyOrganization.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.email = "";
                object.status = options.enums === String ? "SUCCESS" : 0;
            }
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this VerifyOrganization to JSON.
         * @function toJSON
         * @memberof response.VerifyOrganization
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        VerifyOrganization.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for VerifyOrganization
         * @function getTypeUrl
         * @memberof response.VerifyOrganization
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        VerifyOrganization.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.VerifyOrganization";
        };

        return VerifyOrganization;
    })();

    response.RemoveOrganization = (function() {

        /**
         * Properties of a RemoveOrganization.
         * @memberof response
         * @interface IRemoveOrganization
         * @property {string|null} [email] RemoveOrganization email
         * @property {response.Status|null} [status] RemoveOrganization status
         * @property {string|null} [message] RemoveOrganization message
         */

        /**
         * Constructs a new RemoveOrganization.
         * @memberof response
         * @classdesc Represents a RemoveOrganization.
         * @implements IRemoveOrganization
         * @constructor
         * @param {response.IRemoveOrganization=} [properties] Properties to set
         */
        function RemoveOrganization(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveOrganization email.
         * @member {string} email
         * @memberof response.RemoveOrganization
         * @instance
         */
        RemoveOrganization.prototype.email = "";

        /**
         * RemoveOrganization status.
         * @member {response.Status} status
         * @memberof response.RemoveOrganization
         * @instance
         */
        RemoveOrganization.prototype.status = 0;

        /**
         * RemoveOrganization message.
         * @member {string|null|undefined} message
         * @memberof response.RemoveOrganization
         * @instance
         */
        RemoveOrganization.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(RemoveOrganization.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new RemoveOrganization instance using the specified properties.
         * @function create
         * @memberof response.RemoveOrganization
         * @static
         * @param {response.IRemoveOrganization=} [properties] Properties to set
         * @returns {response.RemoveOrganization} RemoveOrganization instance
         */
        RemoveOrganization.create = function create(properties) {
            return new RemoveOrganization(properties);
        };

        /**
         * Encodes the specified RemoveOrganization message. Does not implicitly {@link response.RemoveOrganization.verify|verify} messages.
         * @function encode
         * @memberof response.RemoveOrganization
         * @static
         * @param {response.IRemoveOrganization} message RemoveOrganization message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RemoveOrganization.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified RemoveOrganization message, length delimited. Does not implicitly {@link response.RemoveOrganization.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.RemoveOrganization
         * @static
         * @param {response.IRemoveOrganization} message RemoveOrganization message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RemoveOrganization.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RemoveOrganization message from the specified reader or buffer.
         * @function decode
         * @memberof response.RemoveOrganization
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.RemoveOrganization} RemoveOrganization
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RemoveOrganization.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.RemoveOrganization();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.email = reader.string();
                        break;
                    }
                case 2: {
                        message.status = reader.int32();
                        break;
                    }
                case 3: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RemoveOrganization message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.RemoveOrganization
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.RemoveOrganization} RemoveOrganization
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RemoveOrganization.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RemoveOrganization message.
         * @function verify
         * @memberof response.RemoveOrganization
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RemoveOrganization.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a RemoveOrganization message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.RemoveOrganization
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.RemoveOrganization} RemoveOrganization
         */
        RemoveOrganization.fromObject = function fromObject(object) {
            if (object instanceof $root.response.RemoveOrganization)
                return object;
            let message = new $root.response.RemoveOrganization();
            if (object.email != null)
                message.email = String(object.email);
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a RemoveOrganization message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.RemoveOrganization
         * @static
         * @param {response.RemoveOrganization} message RemoveOrganization
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveOrganization.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.email = "";
                object.status = options.enums === String ? "SUCCESS" : 0;
            }
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this RemoveOrganization to JSON.
         * @function toJSON
         * @memberof response.RemoveOrganization
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveOrganization.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for RemoveOrganization
         * @function getTypeUrl
         * @memberof response.RemoveOrganization
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        RemoveOrganization.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.RemoveOrganization";
        };

        return RemoveOrganization;
    })();

    response.GetOrganization = (function() {

        /**
         * Properties of a GetOrganization.
         * @memberof response
         * @interface IGetOrganization
         * @property {string|null} [email] GetOrganization email
         * @property {response.Status|null} [status] GetOrganization status
         * @property {string|null} [message] GetOrganization message
         */

        /**
         * Constructs a new GetOrganization.
         * @memberof response
         * @classdesc Represents a GetOrganization.
         * @implements IGetOrganization
         * @constructor
         * @param {response.IGetOrganization=} [properties] Properties to set
         */
        function GetOrganization(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetOrganization email.
         * @member {string} email
         * @memberof response.GetOrganization
         * @instance
         */
        GetOrganization.prototype.email = "";

        /**
         * GetOrganization status.
         * @member {response.Status} status
         * @memberof response.GetOrganization
         * @instance
         */
        GetOrganization.prototype.status = 0;

        /**
         * GetOrganization message.
         * @member {string|null|undefined} message
         * @memberof response.GetOrganization
         * @instance
         */
        GetOrganization.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(GetOrganization.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new GetOrganization instance using the specified properties.
         * @function create
         * @memberof response.GetOrganization
         * @static
         * @param {response.IGetOrganization=} [properties] Properties to set
         * @returns {response.GetOrganization} GetOrganization instance
         */
        GetOrganization.create = function create(properties) {
            return new GetOrganization(properties);
        };

        /**
         * Encodes the specified GetOrganization message. Does not implicitly {@link response.GetOrganization.verify|verify} messages.
         * @function encode
         * @memberof response.GetOrganization
         * @static
         * @param {response.IGetOrganization} message GetOrganization message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetOrganization.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified GetOrganization message, length delimited. Does not implicitly {@link response.GetOrganization.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.GetOrganization
         * @static
         * @param {response.IGetOrganization} message GetOrganization message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetOrganization.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetOrganization message from the specified reader or buffer.
         * @function decode
         * @memberof response.GetOrganization
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.GetOrganization} GetOrganization
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetOrganization.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.GetOrganization();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.email = reader.string();
                        break;
                    }
                case 2: {
                        message.status = reader.int32();
                        break;
                    }
                case 3: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetOrganization message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.GetOrganization
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.GetOrganization} GetOrganization
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetOrganization.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetOrganization message.
         * @function verify
         * @memberof response.GetOrganization
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetOrganization.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a GetOrganization message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.GetOrganization
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.GetOrganization} GetOrganization
         */
        GetOrganization.fromObject = function fromObject(object) {
            if (object instanceof $root.response.GetOrganization)
                return object;
            let message = new $root.response.GetOrganization();
            if (object.email != null)
                message.email = String(object.email);
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a GetOrganization message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.GetOrganization
         * @static
         * @param {response.GetOrganization} message GetOrganization
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetOrganization.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.email = "";
                object.status = options.enums === String ? "SUCCESS" : 0;
            }
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this GetOrganization to JSON.
         * @function toJSON
         * @memberof response.GetOrganization
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetOrganization.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetOrganization
         * @function getTypeUrl
         * @memberof response.GetOrganization
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetOrganization.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.GetOrganization";
        };

        return GetOrganization;
    })();

    response.InviteUser = (function() {

        /**
         * Properties of an InviteUser.
         * @memberof response
         * @interface IInviteUser
         * @property {string|null} [organization] InviteUser organization
         * @property {string|null} [email] InviteUser email
         * @property {response.Status|null} [status] InviteUser status
         * @property {string|null} [message] InviteUser message
         */

        /**
         * Constructs a new InviteUser.
         * @memberof response
         * @classdesc Represents an InviteUser.
         * @implements IInviteUser
         * @constructor
         * @param {response.IInviteUser=} [properties] Properties to set
         */
        function InviteUser(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * InviteUser organization.
         * @member {string} organization
         * @memberof response.InviteUser
         * @instance
         */
        InviteUser.prototype.organization = "";

        /**
         * InviteUser email.
         * @member {string} email
         * @memberof response.InviteUser
         * @instance
         */
        InviteUser.prototype.email = "";

        /**
         * InviteUser status.
         * @member {response.Status} status
         * @memberof response.InviteUser
         * @instance
         */
        InviteUser.prototype.status = 0;

        /**
         * InviteUser message.
         * @member {string|null|undefined} message
         * @memberof response.InviteUser
         * @instance
         */
        InviteUser.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(InviteUser.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new InviteUser instance using the specified properties.
         * @function create
         * @memberof response.InviteUser
         * @static
         * @param {response.IInviteUser=} [properties] Properties to set
         * @returns {response.InviteUser} InviteUser instance
         */
        InviteUser.create = function create(properties) {
            return new InviteUser(properties);
        };

        /**
         * Encodes the specified InviteUser message. Does not implicitly {@link response.InviteUser.verify|verify} messages.
         * @function encode
         * @memberof response.InviteUser
         * @static
         * @param {response.IInviteUser} message InviteUser message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        InviteUser.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.organization != null && Object.hasOwnProperty.call(message, "organization"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.organization);
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.email);
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified InviteUser message, length delimited. Does not implicitly {@link response.InviteUser.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.InviteUser
         * @static
         * @param {response.IInviteUser} message InviteUser message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        InviteUser.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an InviteUser message from the specified reader or buffer.
         * @function decode
         * @memberof response.InviteUser
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.InviteUser} InviteUser
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        InviteUser.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.InviteUser();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.organization = reader.string();
                        break;
                    }
                case 2: {
                        message.email = reader.string();
                        break;
                    }
                case 4: {
                        message.status = reader.int32();
                        break;
                    }
                case 5: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an InviteUser message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.InviteUser
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.InviteUser} InviteUser
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        InviteUser.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an InviteUser message.
         * @function verify
         * @memberof response.InviteUser
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        InviteUser.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.organization != null && message.hasOwnProperty("organization"))
                if (!$util.isString(message.organization))
                    return "organization: string expected";
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates an InviteUser message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.InviteUser
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.InviteUser} InviteUser
         */
        InviteUser.fromObject = function fromObject(object) {
            if (object instanceof $root.response.InviteUser)
                return object;
            let message = new $root.response.InviteUser();
            if (object.organization != null)
                message.organization = String(object.organization);
            if (object.email != null)
                message.email = String(object.email);
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from an InviteUser message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.InviteUser
         * @static
         * @param {response.InviteUser} message InviteUser
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        InviteUser.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.organization = "";
                object.email = "";
                object.status = options.enums === String ? "SUCCESS" : 0;
            }
            if (message.organization != null && message.hasOwnProperty("organization"))
                object.organization = message.organization;
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this InviteUser to JSON.
         * @function toJSON
         * @memberof response.InviteUser
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        InviteUser.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for InviteUser
         * @function getTypeUrl
         * @memberof response.InviteUser
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        InviteUser.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.InviteUser";
        };

        return InviteUser;
    })();

    response.ResetTOTP = (function() {

        /**
         * Properties of a ResetTOTP.
         * @memberof response
         * @interface IResetTOTP
         * @property {response.Status|null} [status] ResetTOTP status
         * @property {string|null} [totpUri] ResetTOTP totpUri
         */

        /**
         * Constructs a new ResetTOTP.
         * @memberof response
         * @classdesc Represents a ResetTOTP.
         * @implements IResetTOTP
         * @constructor
         * @param {response.IResetTOTP=} [properties] Properties to set
         */
        function ResetTOTP(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ResetTOTP status.
         * @member {response.Status} status
         * @memberof response.ResetTOTP
         * @instance
         */
        ResetTOTP.prototype.status = 0;

        /**
         * ResetTOTP totpUri.
         * @member {string} totpUri
         * @memberof response.ResetTOTP
         * @instance
         */
        ResetTOTP.prototype.totpUri = "";

        /**
         * Creates a new ResetTOTP instance using the specified properties.
         * @function create
         * @memberof response.ResetTOTP
         * @static
         * @param {response.IResetTOTP=} [properties] Properties to set
         * @returns {response.ResetTOTP} ResetTOTP instance
         */
        ResetTOTP.create = function create(properties) {
            return new ResetTOTP(properties);
        };

        /**
         * Encodes the specified ResetTOTP message. Does not implicitly {@link response.ResetTOTP.verify|verify} messages.
         * @function encode
         * @memberof response.ResetTOTP
         * @static
         * @param {response.IResetTOTP} message ResetTOTP message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ResetTOTP.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.totpUri != null && Object.hasOwnProperty.call(message, "totpUri"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.totpUri);
            return writer;
        };

        /**
         * Encodes the specified ResetTOTP message, length delimited. Does not implicitly {@link response.ResetTOTP.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.ResetTOTP
         * @static
         * @param {response.IResetTOTP} message ResetTOTP message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ResetTOTP.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ResetTOTP message from the specified reader or buffer.
         * @function decode
         * @memberof response.ResetTOTP
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.ResetTOTP} ResetTOTP
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ResetTOTP.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.ResetTOTP();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.totpUri = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ResetTOTP message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.ResetTOTP
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.ResetTOTP} ResetTOTP
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ResetTOTP.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ResetTOTP message.
         * @function verify
         * @memberof response.ResetTOTP
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ResetTOTP.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.totpUri != null && message.hasOwnProperty("totpUri"))
                if (!$util.isString(message.totpUri))
                    return "totpUri: string expected";
            return null;
        };

        /**
         * Creates a ResetTOTP message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.ResetTOTP
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.ResetTOTP} ResetTOTP
         */
        ResetTOTP.fromObject = function fromObject(object) {
            if (object instanceof $root.response.ResetTOTP)
                return object;
            let message = new $root.response.ResetTOTP();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.totpUri != null)
                message.totpUri = String(object.totpUri);
            return message;
        };

        /**
         * Creates a plain object from a ResetTOTP message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.ResetTOTP
         * @static
         * @param {response.ResetTOTP} message ResetTOTP
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ResetTOTP.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.status = options.enums === String ? "SUCCESS" : 0;
                object.totpUri = "";
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.totpUri != null && message.hasOwnProperty("totpUri"))
                object.totpUri = message.totpUri;
            return object;
        };

        /**
         * Converts this ResetTOTP to JSON.
         * @function toJSON
         * @memberof response.ResetTOTP
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ResetTOTP.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ResetTOTP
         * @function getTypeUrl
         * @memberof response.ResetTOTP
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ResetTOTP.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.ResetTOTP";
        };

        return ResetTOTP;
    })();

    response.InitiatePayment = (function() {

        /**
         * Properties of an InitiatePayment.
         * @memberof response
         * @interface IInitiatePayment
         * @property {string|null} [email] InitiatePayment email
         * @property {response.Status|null} [status] InitiatePayment status
         * @property {string|null} [message] InitiatePayment message
         * @property {string|null} [orderId] InitiatePayment orderId
         * @property {string|null} [razorpayKey] InitiatePayment razorpayKey
         * @property {number|null} [amount] InitiatePayment amount
         * @property {string|null} [currency] InitiatePayment currency
         */

        /**
         * Constructs a new InitiatePayment.
         * @memberof response
         * @classdesc Represents an InitiatePayment.
         * @implements IInitiatePayment
         * @constructor
         * @param {response.IInitiatePayment=} [properties] Properties to set
         */
        function InitiatePayment(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * InitiatePayment email.
         * @member {string} email
         * @memberof response.InitiatePayment
         * @instance
         */
        InitiatePayment.prototype.email = "";

        /**
         * InitiatePayment status.
         * @member {response.Status} status
         * @memberof response.InitiatePayment
         * @instance
         */
        InitiatePayment.prototype.status = 0;

        /**
         * InitiatePayment message.
         * @member {string|null|undefined} message
         * @memberof response.InitiatePayment
         * @instance
         */
        InitiatePayment.prototype.message = null;

        /**
         * InitiatePayment orderId.
         * @member {string|null|undefined} orderId
         * @memberof response.InitiatePayment
         * @instance
         */
        InitiatePayment.prototype.orderId = null;

        /**
         * InitiatePayment razorpayKey.
         * @member {string|null|undefined} razorpayKey
         * @memberof response.InitiatePayment
         * @instance
         */
        InitiatePayment.prototype.razorpayKey = null;

        /**
         * InitiatePayment amount.
         * @member {number|null|undefined} amount
         * @memberof response.InitiatePayment
         * @instance
         */
        InitiatePayment.prototype.amount = null;

        /**
         * InitiatePayment currency.
         * @member {string|null|undefined} currency
         * @memberof response.InitiatePayment
         * @instance
         */
        InitiatePayment.prototype.currency = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(InitiatePayment.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(InitiatePayment.prototype, "_orderId", {
            get: $util.oneOfGetter($oneOfFields = ["orderId"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(InitiatePayment.prototype, "_razorpayKey", {
            get: $util.oneOfGetter($oneOfFields = ["razorpayKey"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(InitiatePayment.prototype, "_amount", {
            get: $util.oneOfGetter($oneOfFields = ["amount"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(InitiatePayment.prototype, "_currency", {
            get: $util.oneOfGetter($oneOfFields = ["currency"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new InitiatePayment instance using the specified properties.
         * @function create
         * @memberof response.InitiatePayment
         * @static
         * @param {response.IInitiatePayment=} [properties] Properties to set
         * @returns {response.InitiatePayment} InitiatePayment instance
         */
        InitiatePayment.create = function create(properties) {
            return new InitiatePayment(properties);
        };

        /**
         * Encodes the specified InitiatePayment message. Does not implicitly {@link response.InitiatePayment.verify|verify} messages.
         * @function encode
         * @memberof response.InitiatePayment
         * @static
         * @param {response.IInitiatePayment} message InitiatePayment message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        InitiatePayment.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.message);
            if (message.orderId != null && Object.hasOwnProperty.call(message, "orderId"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.orderId);
            if (message.razorpayKey != null && Object.hasOwnProperty.call(message, "razorpayKey"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.razorpayKey);
            if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
                writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.amount);
            if (message.currency != null && Object.hasOwnProperty.call(message, "currency"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.currency);
            return writer;
        };

        /**
         * Encodes the specified InitiatePayment message, length delimited. Does not implicitly {@link response.InitiatePayment.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.InitiatePayment
         * @static
         * @param {response.IInitiatePayment} message InitiatePayment message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        InitiatePayment.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an InitiatePayment message from the specified reader or buffer.
         * @function decode
         * @memberof response.InitiatePayment
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.InitiatePayment} InitiatePayment
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        InitiatePayment.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.InitiatePayment();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.email = reader.string();
                        break;
                    }
                case 2: {
                        message.status = reader.int32();
                        break;
                    }
                case 3: {
                        message.message = reader.string();
                        break;
                    }
                case 4: {
                        message.orderId = reader.string();
                        break;
                    }
                case 5: {
                        message.razorpayKey = reader.string();
                        break;
                    }
                case 6: {
                        message.amount = reader.uint32();
                        break;
                    }
                case 7: {
                        message.currency = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an InitiatePayment message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.InitiatePayment
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.InitiatePayment} InitiatePayment
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        InitiatePayment.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an InitiatePayment message.
         * @function verify
         * @memberof response.InitiatePayment
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        InitiatePayment.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            if (message.orderId != null && message.hasOwnProperty("orderId")) {
                properties._orderId = 1;
                if (!$util.isString(message.orderId))
                    return "orderId: string expected";
            }
            if (message.razorpayKey != null && message.hasOwnProperty("razorpayKey")) {
                properties._razorpayKey = 1;
                if (!$util.isString(message.razorpayKey))
                    return "razorpayKey: string expected";
            }
            if (message.amount != null && message.hasOwnProperty("amount")) {
                properties._amount = 1;
                if (!$util.isInteger(message.amount))
                    return "amount: integer expected";
            }
            if (message.currency != null && message.hasOwnProperty("currency")) {
                properties._currency = 1;
                if (!$util.isString(message.currency))
                    return "currency: string expected";
            }
            return null;
        };

        /**
         * Creates an InitiatePayment message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.InitiatePayment
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.InitiatePayment} InitiatePayment
         */
        InitiatePayment.fromObject = function fromObject(object) {
            if (object instanceof $root.response.InitiatePayment)
                return object;
            let message = new $root.response.InitiatePayment();
            if (object.email != null)
                message.email = String(object.email);
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            if (object.orderId != null)
                message.orderId = String(object.orderId);
            if (object.razorpayKey != null)
                message.razorpayKey = String(object.razorpayKey);
            if (object.amount != null)
                message.amount = object.amount >>> 0;
            if (object.currency != null)
                message.currency = String(object.currency);
            return message;
        };

        /**
         * Creates a plain object from an InitiatePayment message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.InitiatePayment
         * @static
         * @param {response.InitiatePayment} message InitiatePayment
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        InitiatePayment.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.email = "";
                object.status = options.enums === String ? "SUCCESS" : 0;
            }
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            if (message.orderId != null && message.hasOwnProperty("orderId")) {
                object.orderId = message.orderId;
                if (options.oneofs)
                    object._orderId = "orderId";
            }
            if (message.razorpayKey != null && message.hasOwnProperty("razorpayKey")) {
                object.razorpayKey = message.razorpayKey;
                if (options.oneofs)
                    object._razorpayKey = "razorpayKey";
            }
            if (message.amount != null && message.hasOwnProperty("amount")) {
                object.amount = message.amount;
                if (options.oneofs)
                    object._amount = "amount";
            }
            if (message.currency != null && message.hasOwnProperty("currency")) {
                object.currency = message.currency;
                if (options.oneofs)
                    object._currency = "currency";
            }
            return object;
        };

        /**
         * Converts this InitiatePayment to JSON.
         * @function toJSON
         * @memberof response.InitiatePayment
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        InitiatePayment.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for InitiatePayment
         * @function getTypeUrl
         * @memberof response.InitiatePayment
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        InitiatePayment.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.InitiatePayment";
        };

        return InitiatePayment;
    })();

    response.PaymentResponse = (function() {

        /**
         * Properties of a PaymentResponse.
         * @memberof response
         * @interface IPaymentResponse
         * @property {string|null} [email] PaymentResponse email
         * @property {response.Status|null} [status] PaymentResponse status
         * @property {string|null} [message] PaymentResponse message
         * @property {string|null} [orderId] PaymentResponse orderId
         * @property {string|null} [orderStatus] PaymentResponse orderStatus
         */

        /**
         * Constructs a new PaymentResponse.
         * @memberof response
         * @classdesc Represents a PaymentResponse.
         * @implements IPaymentResponse
         * @constructor
         * @param {response.IPaymentResponse=} [properties] Properties to set
         */
        function PaymentResponse(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PaymentResponse email.
         * @member {string} email
         * @memberof response.PaymentResponse
         * @instance
         */
        PaymentResponse.prototype.email = "";

        /**
         * PaymentResponse status.
         * @member {response.Status} status
         * @memberof response.PaymentResponse
         * @instance
         */
        PaymentResponse.prototype.status = 0;

        /**
         * PaymentResponse message.
         * @member {string|null|undefined} message
         * @memberof response.PaymentResponse
         * @instance
         */
        PaymentResponse.prototype.message = null;

        /**
         * PaymentResponse orderId.
         * @member {string|null|undefined} orderId
         * @memberof response.PaymentResponse
         * @instance
         */
        PaymentResponse.prototype.orderId = null;

        /**
         * PaymentResponse orderStatus.
         * @member {string|null|undefined} orderStatus
         * @memberof response.PaymentResponse
         * @instance
         */
        PaymentResponse.prototype.orderStatus = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(PaymentResponse.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(PaymentResponse.prototype, "_orderId", {
            get: $util.oneOfGetter($oneOfFields = ["orderId"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(PaymentResponse.prototype, "_orderStatus", {
            get: $util.oneOfGetter($oneOfFields = ["orderStatus"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new PaymentResponse instance using the specified properties.
         * @function create
         * @memberof response.PaymentResponse
         * @static
         * @param {response.IPaymentResponse=} [properties] Properties to set
         * @returns {response.PaymentResponse} PaymentResponse instance
         */
        PaymentResponse.create = function create(properties) {
            return new PaymentResponse(properties);
        };

        /**
         * Encodes the specified PaymentResponse message. Does not implicitly {@link response.PaymentResponse.verify|verify} messages.
         * @function encode
         * @memberof response.PaymentResponse
         * @static
         * @param {response.IPaymentResponse} message PaymentResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PaymentResponse.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.message);
            if (message.orderId != null && Object.hasOwnProperty.call(message, "orderId"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.orderId);
            if (message.orderStatus != null && Object.hasOwnProperty.call(message, "orderStatus"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.orderStatus);
            return writer;
        };

        /**
         * Encodes the specified PaymentResponse message, length delimited. Does not implicitly {@link response.PaymentResponse.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.PaymentResponse
         * @static
         * @param {response.IPaymentResponse} message PaymentResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PaymentResponse.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PaymentResponse message from the specified reader or buffer.
         * @function decode
         * @memberof response.PaymentResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.PaymentResponse} PaymentResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PaymentResponse.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.PaymentResponse();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.email = reader.string();
                        break;
                    }
                case 2: {
                        message.status = reader.int32();
                        break;
                    }
                case 3: {
                        message.message = reader.string();
                        break;
                    }
                case 4: {
                        message.orderId = reader.string();
                        break;
                    }
                case 5: {
                        message.orderStatus = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PaymentResponse message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.PaymentResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.PaymentResponse} PaymentResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PaymentResponse.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PaymentResponse message.
         * @function verify
         * @memberof response.PaymentResponse
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PaymentResponse.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            if (message.orderId != null && message.hasOwnProperty("orderId")) {
                properties._orderId = 1;
                if (!$util.isString(message.orderId))
                    return "orderId: string expected";
            }
            if (message.orderStatus != null && message.hasOwnProperty("orderStatus")) {
                properties._orderStatus = 1;
                if (!$util.isString(message.orderStatus))
                    return "orderStatus: string expected";
            }
            return null;
        };

        /**
         * Creates a PaymentResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.PaymentResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.PaymentResponse} PaymentResponse
         */
        PaymentResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.response.PaymentResponse)
                return object;
            let message = new $root.response.PaymentResponse();
            if (object.email != null)
                message.email = String(object.email);
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            if (object.orderId != null)
                message.orderId = String(object.orderId);
            if (object.orderStatus != null)
                message.orderStatus = String(object.orderStatus);
            return message;
        };

        /**
         * Creates a plain object from a PaymentResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.PaymentResponse
         * @static
         * @param {response.PaymentResponse} message PaymentResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PaymentResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.email = "";
                object.status = options.enums === String ? "SUCCESS" : 0;
            }
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            if (message.orderId != null && message.hasOwnProperty("orderId")) {
                object.orderId = message.orderId;
                if (options.oneofs)
                    object._orderId = "orderId";
            }
            if (message.orderStatus != null && message.hasOwnProperty("orderStatus")) {
                object.orderStatus = message.orderStatus;
                if (options.oneofs)
                    object._orderStatus = "orderStatus";
            }
            return object;
        };

        /**
         * Converts this PaymentResponse to JSON.
         * @function toJSON
         * @memberof response.PaymentResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PaymentResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for PaymentResponse
         * @function getTypeUrl
         * @memberof response.PaymentResponse
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        PaymentResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.PaymentResponse";
        };

        return PaymentResponse;
    })();

    response.SignIn = (function() {

        /**
         * Properties of a SignIn.
         * @memberof response
         * @interface ISignIn
         * @property {string|null} [email] SignIn email
         * @property {string|null} [orgnization] SignIn orgnization
         * @property {response.Status|null} [status] SignIn status
         * @property {string|null} [message] SignIn message
         */

        /**
         * Constructs a new SignIn.
         * @memberof response
         * @classdesc Represents a SignIn.
         * @implements ISignIn
         * @constructor
         * @param {response.ISignIn=} [properties] Properties to set
         */
        function SignIn(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SignIn email.
         * @member {string} email
         * @memberof response.SignIn
         * @instance
         */
        SignIn.prototype.email = "";

        /**
         * SignIn orgnization.
         * @member {string|null|undefined} orgnization
         * @memberof response.SignIn
         * @instance
         */
        SignIn.prototype.orgnization = null;

        /**
         * SignIn status.
         * @member {response.Status} status
         * @memberof response.SignIn
         * @instance
         */
        SignIn.prototype.status = 0;

        /**
         * SignIn message.
         * @member {string|null|undefined} message
         * @memberof response.SignIn
         * @instance
         */
        SignIn.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(SignIn.prototype, "_orgnization", {
            get: $util.oneOfGetter($oneOfFields = ["orgnization"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(SignIn.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new SignIn instance using the specified properties.
         * @function create
         * @memberof response.SignIn
         * @static
         * @param {response.ISignIn=} [properties] Properties to set
         * @returns {response.SignIn} SignIn instance
         */
        SignIn.create = function create(properties) {
            return new SignIn(properties);
        };

        /**
         * Encodes the specified SignIn message. Does not implicitly {@link response.SignIn.verify|verify} messages.
         * @function encode
         * @memberof response.SignIn
         * @static
         * @param {response.ISignIn} message SignIn message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SignIn.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.message);
            if (message.orgnization != null && Object.hasOwnProperty.call(message, "orgnization"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.orgnization);
            return writer;
        };

        /**
         * Encodes the specified SignIn message, length delimited. Does not implicitly {@link response.SignIn.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.SignIn
         * @static
         * @param {response.ISignIn} message SignIn message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SignIn.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SignIn message from the specified reader or buffer.
         * @function decode
         * @memberof response.SignIn
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.SignIn} SignIn
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SignIn.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.SignIn();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.email = reader.string();
                        break;
                    }
                case 4: {
                        message.orgnization = reader.string();
                        break;
                    }
                case 2: {
                        message.status = reader.int32();
                        break;
                    }
                case 3: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SignIn message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.SignIn
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.SignIn} SignIn
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SignIn.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SignIn message.
         * @function verify
         * @memberof response.SignIn
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SignIn.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            if (message.orgnization != null && message.hasOwnProperty("orgnization")) {
                properties._orgnization = 1;
                if (!$util.isString(message.orgnization))
                    return "orgnization: string expected";
            }
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a SignIn message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.SignIn
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.SignIn} SignIn
         */
        SignIn.fromObject = function fromObject(object) {
            if (object instanceof $root.response.SignIn)
                return object;
            let message = new $root.response.SignIn();
            if (object.email != null)
                message.email = String(object.email);
            if (object.orgnization != null)
                message.orgnization = String(object.orgnization);
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a SignIn message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.SignIn
         * @static
         * @param {response.SignIn} message SignIn
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SignIn.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.email = "";
                object.status = options.enums === String ? "SUCCESS" : 0;
            }
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            if (message.orgnization != null && message.hasOwnProperty("orgnization")) {
                object.orgnization = message.orgnization;
                if (options.oneofs)
                    object._orgnization = "orgnization";
            }
            return object;
        };

        /**
         * Converts this SignIn to JSON.
         * @function toJSON
         * @memberof response.SignIn
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SignIn.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for SignIn
         * @function getTypeUrl
         * @memberof response.SignIn
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        SignIn.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.SignIn";
        };

        return SignIn;
    })();

    response.SignOut = (function() {

        /**
         * Properties of a SignOut.
         * @memberof response
         * @interface ISignOut
         * @property {string|null} [email] SignOut email
         * @property {response.Status|null} [status] SignOut status
         * @property {string|null} [message] SignOut message
         */

        /**
         * Constructs a new SignOut.
         * @memberof response
         * @classdesc Represents a SignOut.
         * @implements ISignOut
         * @constructor
         * @param {response.ISignOut=} [properties] Properties to set
         */
        function SignOut(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SignOut email.
         * @member {string} email
         * @memberof response.SignOut
         * @instance
         */
        SignOut.prototype.email = "";

        /**
         * SignOut status.
         * @member {response.Status} status
         * @memberof response.SignOut
         * @instance
         */
        SignOut.prototype.status = 0;

        /**
         * SignOut message.
         * @member {string|null|undefined} message
         * @memberof response.SignOut
         * @instance
         */
        SignOut.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(SignOut.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new SignOut instance using the specified properties.
         * @function create
         * @memberof response.SignOut
         * @static
         * @param {response.ISignOut=} [properties] Properties to set
         * @returns {response.SignOut} SignOut instance
         */
        SignOut.create = function create(properties) {
            return new SignOut(properties);
        };

        /**
         * Encodes the specified SignOut message. Does not implicitly {@link response.SignOut.verify|verify} messages.
         * @function encode
         * @memberof response.SignOut
         * @static
         * @param {response.ISignOut} message SignOut message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SignOut.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified SignOut message, length delimited. Does not implicitly {@link response.SignOut.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.SignOut
         * @static
         * @param {response.ISignOut} message SignOut message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SignOut.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SignOut message from the specified reader or buffer.
         * @function decode
         * @memberof response.SignOut
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.SignOut} SignOut
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SignOut.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.SignOut();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.email = reader.string();
                        break;
                    }
                case 2: {
                        message.status = reader.int32();
                        break;
                    }
                case 3: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SignOut message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.SignOut
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.SignOut} SignOut
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SignOut.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SignOut message.
         * @function verify
         * @memberof response.SignOut
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SignOut.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a SignOut message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.SignOut
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.SignOut} SignOut
         */
        SignOut.fromObject = function fromObject(object) {
            if (object instanceof $root.response.SignOut)
                return object;
            let message = new $root.response.SignOut();
            if (object.email != null)
                message.email = String(object.email);
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a SignOut message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.SignOut
         * @static
         * @param {response.SignOut} message SignOut
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SignOut.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.email = "";
                object.status = options.enums === String ? "SUCCESS" : 0;
            }
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this SignOut to JSON.
         * @function toJSON
         * @memberof response.SignOut
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SignOut.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for SignOut
         * @function getTypeUrl
         * @memberof response.SignOut
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        SignOut.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.SignOut";
        };

        return SignOut;
    })();

    response.AddPin = (function() {

        /**
         * Properties of an AddPin.
         * @memberof response
         * @interface IAddPin
         * @property {string|null} [email] AddPin email
         * @property {response.Status|null} [status] AddPin status
         * @property {string|null} [message] AddPin message
         * @property {Uint8Array|null} [data] AddPin data
         * @property {Uint8Array|null} [idToClient] AddPin idToClient
         */

        /**
         * Constructs a new AddPin.
         * @memberof response
         * @classdesc Represents an AddPin.
         * @implements IAddPin
         * @constructor
         * @param {response.IAddPin=} [properties] Properties to set
         */
        function AddPin(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddPin email.
         * @member {string} email
         * @memberof response.AddPin
         * @instance
         */
        AddPin.prototype.email = "";

        /**
         * AddPin status.
         * @member {response.Status} status
         * @memberof response.AddPin
         * @instance
         */
        AddPin.prototype.status = 0;

        /**
         * AddPin message.
         * @member {string|null|undefined} message
         * @memberof response.AddPin
         * @instance
         */
        AddPin.prototype.message = null;

        /**
         * AddPin data.
         * @member {Uint8Array} data
         * @memberof response.AddPin
         * @instance
         */
        AddPin.prototype.data = $util.newBuffer([]);

        /**
         * AddPin idToClient.
         * @member {Uint8Array} idToClient
         * @memberof response.AddPin
         * @instance
         */
        AddPin.prototype.idToClient = $util.newBuffer([]);

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(AddPin.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new AddPin instance using the specified properties.
         * @function create
         * @memberof response.AddPin
         * @static
         * @param {response.IAddPin=} [properties] Properties to set
         * @returns {response.AddPin} AddPin instance
         */
        AddPin.create = function create(properties) {
            return new AddPin(properties);
        };

        /**
         * Encodes the specified AddPin message. Does not implicitly {@link response.AddPin.verify|verify} messages.
         * @function encode
         * @memberof response.AddPin
         * @static
         * @param {response.IAddPin} message AddPin message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddPin.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.data);
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.message);
            if (message.idToClient != null && Object.hasOwnProperty.call(message, "idToClient"))
                writer.uint32(/* id 5, wireType 2 =*/42).bytes(message.idToClient);
            return writer;
        };

        /**
         * Encodes the specified AddPin message, length delimited. Does not implicitly {@link response.AddPin.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.AddPin
         * @static
         * @param {response.IAddPin} message AddPin message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddPin.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AddPin message from the specified reader or buffer.
         * @function decode
         * @memberof response.AddPin
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.AddPin} AddPin
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddPin.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.AddPin();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.email = reader.string();
                        break;
                    }
                case 3: {
                        message.status = reader.int32();
                        break;
                    }
                case 4: {
                        message.message = reader.string();
                        break;
                    }
                case 2: {
                        message.data = reader.bytes();
                        break;
                    }
                case 5: {
                        message.idToClient = reader.bytes();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AddPin message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.AddPin
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.AddPin} AddPin
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddPin.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AddPin message.
         * @function verify
         * @memberof response.AddPin
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AddPin.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            if (message.idToClient != null && message.hasOwnProperty("idToClient"))
                if (!(message.idToClient && typeof message.idToClient.length === "number" || $util.isString(message.idToClient)))
                    return "idToClient: buffer expected";
            return null;
        };

        /**
         * Creates an AddPin message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.AddPin
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.AddPin} AddPin
         */
        AddPin.fromObject = function fromObject(object) {
            if (object instanceof $root.response.AddPin)
                return object;
            let message = new $root.response.AddPin();
            if (object.email != null)
                message.email = String(object.email);
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            if (object.idToClient != null)
                if (typeof object.idToClient === "string")
                    $util.base64.decode(object.idToClient, message.idToClient = $util.newBuffer($util.base64.length(object.idToClient)), 0);
                else if (object.idToClient.length >= 0)
                    message.idToClient = object.idToClient;
            return message;
        };

        /**
         * Creates a plain object from an AddPin message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.AddPin
         * @static
         * @param {response.AddPin} message AddPin
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddPin.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.email = "";
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
                object.status = options.enums === String ? "SUCCESS" : 0;
                if (options.bytes === String)
                    object.idToClient = "";
                else {
                    object.idToClient = [];
                    if (options.bytes !== Array)
                        object.idToClient = $util.newBuffer(object.idToClient);
                }
            }
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            if (message.idToClient != null && message.hasOwnProperty("idToClient"))
                object.idToClient = options.bytes === String ? $util.base64.encode(message.idToClient, 0, message.idToClient.length) : options.bytes === Array ? Array.prototype.slice.call(message.idToClient) : message.idToClient;
            return object;
        };

        /**
         * Converts this AddPin to JSON.
         * @function toJSON
         * @memberof response.AddPin
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddPin.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for AddPin
         * @function getTypeUrl
         * @memberof response.AddPin
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        AddPin.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.AddPin";
        };

        return AddPin;
    })();

    response.Chunk = (function() {

        /**
         * Properties of a Chunk.
         * @memberof response
         * @interface IChunk
         * @property {Uint8Array|null} [id] Chunk id
         * @property {number|Long|null} [size] Chunk size
         * @property {number|Long|null} [offset] Chunk offset
         * @property {Uint8Array|null} [hash] Chunk hash
         */

        /**
         * Constructs a new Chunk.
         * @memberof response
         * @classdesc Represents a Chunk.
         * @implements IChunk
         * @constructor
         * @param {response.IChunk=} [properties] Properties to set
         */
        function Chunk(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Chunk id.
         * @member {Uint8Array} id
         * @memberof response.Chunk
         * @instance
         */
        Chunk.prototype.id = $util.newBuffer([]);

        /**
         * Chunk size.
         * @member {number|Long} size
         * @memberof response.Chunk
         * @instance
         */
        Chunk.prototype.size = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Chunk offset.
         * @member {number|Long} offset
         * @memberof response.Chunk
         * @instance
         */
        Chunk.prototype.offset = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Chunk hash.
         * @member {Uint8Array} hash
         * @memberof response.Chunk
         * @instance
         */
        Chunk.prototype.hash = $util.newBuffer([]);

        /**
         * Creates a new Chunk instance using the specified properties.
         * @function create
         * @memberof response.Chunk
         * @static
         * @param {response.IChunk=} [properties] Properties to set
         * @returns {response.Chunk} Chunk instance
         */
        Chunk.create = function create(properties) {
            return new Chunk(properties);
        };

        /**
         * Encodes the specified Chunk message. Does not implicitly {@link response.Chunk.verify|verify} messages.
         * @function encode
         * @memberof response.Chunk
         * @static
         * @param {response.IChunk} message Chunk message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Chunk.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.id);
            if (message.size != null && Object.hasOwnProperty.call(message, "size"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.size);
            if (message.offset != null && Object.hasOwnProperty.call(message, "offset"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.offset);
            if (message.hash != null && Object.hasOwnProperty.call(message, "hash"))
                writer.uint32(/* id 6, wireType 2 =*/50).bytes(message.hash);
            return writer;
        };

        /**
         * Encodes the specified Chunk message, length delimited. Does not implicitly {@link response.Chunk.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.Chunk
         * @static
         * @param {response.IChunk} message Chunk message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Chunk.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Chunk message from the specified reader or buffer.
         * @function decode
         * @memberof response.Chunk
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.Chunk} Chunk
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Chunk.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.Chunk();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.id = reader.bytes();
                        break;
                    }
                case 2: {
                        message.size = reader.uint64();
                        break;
                    }
                case 3: {
                        message.offset = reader.uint64();
                        break;
                    }
                case 6: {
                        message.hash = reader.bytes();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Chunk message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.Chunk
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.Chunk} Chunk
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Chunk.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Chunk message.
         * @function verify
         * @memberof response.Chunk
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Chunk.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!(message.id && typeof message.id.length === "number" || $util.isString(message.id)))
                    return "id: buffer expected";
            if (message.size != null && message.hasOwnProperty("size"))
                if (!$util.isInteger(message.size) && !(message.size && $util.isInteger(message.size.low) && $util.isInteger(message.size.high)))
                    return "size: integer|Long expected";
            if (message.offset != null && message.hasOwnProperty("offset"))
                if (!$util.isInteger(message.offset) && !(message.offset && $util.isInteger(message.offset.low) && $util.isInteger(message.offset.high)))
                    return "offset: integer|Long expected";
            if (message.hash != null && message.hasOwnProperty("hash"))
                if (!(message.hash && typeof message.hash.length === "number" || $util.isString(message.hash)))
                    return "hash: buffer expected";
            return null;
        };

        /**
         * Creates a Chunk message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.Chunk
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.Chunk} Chunk
         */
        Chunk.fromObject = function fromObject(object) {
            if (object instanceof $root.response.Chunk)
                return object;
            let message = new $root.response.Chunk();
            if (object.id != null)
                if (typeof object.id === "string")
                    $util.base64.decode(object.id, message.id = $util.newBuffer($util.base64.length(object.id)), 0);
                else if (object.id.length >= 0)
                    message.id = object.id;
            if (object.size != null)
                if ($util.Long)
                    (message.size = $util.Long.fromValue(object.size)).unsigned = true;
                else if (typeof object.size === "string")
                    message.size = parseInt(object.size, 10);
                else if (typeof object.size === "number")
                    message.size = object.size;
                else if (typeof object.size === "object")
                    message.size = new $util.LongBits(object.size.low >>> 0, object.size.high >>> 0).toNumber(true);
            if (object.offset != null)
                if ($util.Long)
                    (message.offset = $util.Long.fromValue(object.offset)).unsigned = true;
                else if (typeof object.offset === "string")
                    message.offset = parseInt(object.offset, 10);
                else if (typeof object.offset === "number")
                    message.offset = object.offset;
                else if (typeof object.offset === "object")
                    message.offset = new $util.LongBits(object.offset.low >>> 0, object.offset.high >>> 0).toNumber(true);
            if (object.hash != null)
                if (typeof object.hash === "string")
                    $util.base64.decode(object.hash, message.hash = $util.newBuffer($util.base64.length(object.hash)), 0);
                else if (object.hash.length >= 0)
                    message.hash = object.hash;
            return message;
        };

        /**
         * Creates a plain object from a Chunk message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.Chunk
         * @static
         * @param {response.Chunk} message Chunk
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Chunk.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if (options.bytes === String)
                    object.id = "";
                else {
                    object.id = [];
                    if (options.bytes !== Array)
                        object.id = $util.newBuffer(object.id);
                }
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.size = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.size = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.offset = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.offset = options.longs === String ? "0" : 0;
                if (options.bytes === String)
                    object.hash = "";
                else {
                    object.hash = [];
                    if (options.bytes !== Array)
                        object.hash = $util.newBuffer(object.hash);
                }
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = options.bytes === String ? $util.base64.encode(message.id, 0, message.id.length) : options.bytes === Array ? Array.prototype.slice.call(message.id) : message.id;
            if (message.size != null && message.hasOwnProperty("size"))
                if (typeof message.size === "number")
                    object.size = options.longs === String ? String(message.size) : message.size;
                else
                    object.size = options.longs === String ? $util.Long.prototype.toString.call(message.size) : options.longs === Number ? new $util.LongBits(message.size.low >>> 0, message.size.high >>> 0).toNumber(true) : message.size;
            if (message.offset != null && message.hasOwnProperty("offset"))
                if (typeof message.offset === "number")
                    object.offset = options.longs === String ? String(message.offset) : message.offset;
                else
                    object.offset = options.longs === String ? $util.Long.prototype.toString.call(message.offset) : options.longs === Number ? new $util.LongBits(message.offset.low >>> 0, message.offset.high >>> 0).toNumber(true) : message.offset;
            if (message.hash != null && message.hasOwnProperty("hash"))
                object.hash = options.bytes === String ? $util.base64.encode(message.hash, 0, message.hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.hash) : message.hash;
            return object;
        };

        /**
         * Converts this Chunk to JSON.
         * @function toJSON
         * @memberof response.Chunk
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Chunk.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Chunk
         * @function getTypeUrl
         * @memberof response.Chunk
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Chunk.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.Chunk";
        };

        return Chunk;
    })();

    response.ResetVersion = (function() {

        /**
         * Properties of a ResetVersion.
         * @memberof response
         * @interface IResetVersion
         * @property {response.Status|null} [status] ResetVersion status
         * @property {string|null} [message] ResetVersion message
         */

        /**
         * Constructs a new ResetVersion.
         * @memberof response
         * @classdesc Represents a ResetVersion.
         * @implements IResetVersion
         * @constructor
         * @param {response.IResetVersion=} [properties] Properties to set
         */
        function ResetVersion(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ResetVersion status.
         * @member {response.Status} status
         * @memberof response.ResetVersion
         * @instance
         */
        ResetVersion.prototype.status = 0;

        /**
         * ResetVersion message.
         * @member {string|null|undefined} message
         * @memberof response.ResetVersion
         * @instance
         */
        ResetVersion.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(ResetVersion.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new ResetVersion instance using the specified properties.
         * @function create
         * @memberof response.ResetVersion
         * @static
         * @param {response.IResetVersion=} [properties] Properties to set
         * @returns {response.ResetVersion} ResetVersion instance
         */
        ResetVersion.create = function create(properties) {
            return new ResetVersion(properties);
        };

        /**
         * Encodes the specified ResetVersion message. Does not implicitly {@link response.ResetVersion.verify|verify} messages.
         * @function encode
         * @memberof response.ResetVersion
         * @static
         * @param {response.IResetVersion} message ResetVersion message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ResetVersion.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified ResetVersion message, length delimited. Does not implicitly {@link response.ResetVersion.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.ResetVersion
         * @static
         * @param {response.IResetVersion} message ResetVersion message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ResetVersion.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ResetVersion message from the specified reader or buffer.
         * @function decode
         * @memberof response.ResetVersion
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.ResetVersion} ResetVersion
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ResetVersion.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.ResetVersion();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ResetVersion message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.ResetVersion
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.ResetVersion} ResetVersion
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ResetVersion.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ResetVersion message.
         * @function verify
         * @memberof response.ResetVersion
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ResetVersion.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a ResetVersion message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.ResetVersion
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.ResetVersion} ResetVersion
         */
        ResetVersion.fromObject = function fromObject(object) {
            if (object instanceof $root.response.ResetVersion)
                return object;
            let message = new $root.response.ResetVersion();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a ResetVersion message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.ResetVersion
         * @static
         * @param {response.ResetVersion} message ResetVersion
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ResetVersion.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this ResetVersion to JSON.
         * @function toJSON
         * @memberof response.ResetVersion
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ResetVersion.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ResetVersion
         * @function getTypeUrl
         * @memberof response.ResetVersion
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ResetVersion.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.ResetVersion";
        };

        return ResetVersion;
    })();

    response.FileVersion = (function() {

        /**
         * Properties of a FileVersion.
         * @memberof response
         * @interface IFileVersion
         * @property {string|null} [id] FileVersion id
         * @property {Array.<Uint8Array>|null} [chunkIds] FileVersion chunkIds
         * @property {number|Long|null} [creationDate] FileVersion creationDate
         */

        /**
         * Constructs a new FileVersion.
         * @memberof response
         * @classdesc Represents a FileVersion.
         * @implements IFileVersion
         * @constructor
         * @param {response.IFileVersion=} [properties] Properties to set
         */
        function FileVersion(properties) {
            this.chunkIds = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * FileVersion id.
         * @member {string} id
         * @memberof response.FileVersion
         * @instance
         */
        FileVersion.prototype.id = "";

        /**
         * FileVersion chunkIds.
         * @member {Array.<Uint8Array>} chunkIds
         * @memberof response.FileVersion
         * @instance
         */
        FileVersion.prototype.chunkIds = $util.emptyArray;

        /**
         * FileVersion creationDate.
         * @member {number|Long} creationDate
         * @memberof response.FileVersion
         * @instance
         */
        FileVersion.prototype.creationDate = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new FileVersion instance using the specified properties.
         * @function create
         * @memberof response.FileVersion
         * @static
         * @param {response.IFileVersion=} [properties] Properties to set
         * @returns {response.FileVersion} FileVersion instance
         */
        FileVersion.create = function create(properties) {
            return new FileVersion(properties);
        };

        /**
         * Encodes the specified FileVersion message. Does not implicitly {@link response.FileVersion.verify|verify} messages.
         * @function encode
         * @memberof response.FileVersion
         * @static
         * @param {response.IFileVersion} message FileVersion message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FileVersion.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.chunkIds != null && message.chunkIds.length)
                for (let i = 0; i < message.chunkIds.length; ++i)
                    writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.chunkIds[i]);
            if (message.creationDate != null && Object.hasOwnProperty.call(message, "creationDate"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.creationDate);
            return writer;
        };

        /**
         * Encodes the specified FileVersion message, length delimited. Does not implicitly {@link response.FileVersion.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.FileVersion
         * @static
         * @param {response.IFileVersion} message FileVersion message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FileVersion.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a FileVersion message from the specified reader or buffer.
         * @function decode
         * @memberof response.FileVersion
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.FileVersion} FileVersion
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FileVersion.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.FileVersion();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.id = reader.string();
                        break;
                    }
                case 2: {
                        if (!(message.chunkIds && message.chunkIds.length))
                            message.chunkIds = [];
                        message.chunkIds.push(reader.bytes());
                        break;
                    }
                case 3: {
                        message.creationDate = reader.uint64();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a FileVersion message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.FileVersion
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.FileVersion} FileVersion
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FileVersion.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a FileVersion message.
         * @function verify
         * @memberof response.FileVersion
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        FileVersion.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.chunkIds != null && message.hasOwnProperty("chunkIds")) {
                if (!Array.isArray(message.chunkIds))
                    return "chunkIds: array expected";
                for (let i = 0; i < message.chunkIds.length; ++i)
                    if (!(message.chunkIds[i] && typeof message.chunkIds[i].length === "number" || $util.isString(message.chunkIds[i])))
                        return "chunkIds: buffer[] expected";
            }
            if (message.creationDate != null && message.hasOwnProperty("creationDate"))
                if (!$util.isInteger(message.creationDate) && !(message.creationDate && $util.isInteger(message.creationDate.low) && $util.isInteger(message.creationDate.high)))
                    return "creationDate: integer|Long expected";
            return null;
        };

        /**
         * Creates a FileVersion message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.FileVersion
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.FileVersion} FileVersion
         */
        FileVersion.fromObject = function fromObject(object) {
            if (object instanceof $root.response.FileVersion)
                return object;
            let message = new $root.response.FileVersion();
            if (object.id != null)
                message.id = String(object.id);
            if (object.chunkIds) {
                if (!Array.isArray(object.chunkIds))
                    throw TypeError(".response.FileVersion.chunkIds: array expected");
                message.chunkIds = [];
                for (let i = 0; i < object.chunkIds.length; ++i)
                    if (typeof object.chunkIds[i] === "string")
                        $util.base64.decode(object.chunkIds[i], message.chunkIds[i] = $util.newBuffer($util.base64.length(object.chunkIds[i])), 0);
                    else if (object.chunkIds[i].length >= 0)
                        message.chunkIds[i] = object.chunkIds[i];
            }
            if (object.creationDate != null)
                if ($util.Long)
                    (message.creationDate = $util.Long.fromValue(object.creationDate)).unsigned = true;
                else if (typeof object.creationDate === "string")
                    message.creationDate = parseInt(object.creationDate, 10);
                else if (typeof object.creationDate === "number")
                    message.creationDate = object.creationDate;
                else if (typeof object.creationDate === "object")
                    message.creationDate = new $util.LongBits(object.creationDate.low >>> 0, object.creationDate.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a FileVersion message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.FileVersion
         * @static
         * @param {response.FileVersion} message FileVersion
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FileVersion.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.chunkIds = [];
            if (options.defaults) {
                object.id = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.creationDate = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.creationDate = options.longs === String ? "0" : 0;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.chunkIds && message.chunkIds.length) {
                object.chunkIds = [];
                for (let j = 0; j < message.chunkIds.length; ++j)
                    object.chunkIds[j] = options.bytes === String ? $util.base64.encode(message.chunkIds[j], 0, message.chunkIds[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.chunkIds[j]) : message.chunkIds[j];
            }
            if (message.creationDate != null && message.hasOwnProperty("creationDate"))
                if (typeof message.creationDate === "number")
                    object.creationDate = options.longs === String ? String(message.creationDate) : message.creationDate;
                else
                    object.creationDate = options.longs === String ? $util.Long.prototype.toString.call(message.creationDate) : options.longs === Number ? new $util.LongBits(message.creationDate.low >>> 0, message.creationDate.high >>> 0).toNumber(true) : message.creationDate;
            return object;
        };

        /**
         * Converts this FileVersion to JSON.
         * @function toJSON
         * @memberof response.FileVersion
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FileVersion.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for FileVersion
         * @function getTypeUrl
         * @memberof response.FileVersion
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        FileVersion.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.FileVersion";
        };

        return FileVersion;
    })();

    response.File = (function() {

        /**
         * Properties of a File.
         * @memberof response
         * @interface IFile
         * @property {string|null} [name] File name
         * @property {string|null} [parentFolder] File parentFolder
         * @property {Uint8Array|null} [uuid] File uuid
         * @property {string|null} [owner] File owner
         * @property {number|Long|null} [creationDate] File creationDate
         * @property {number|Long|null} [lastModifiedDate] File lastModifiedDate
         * @property {Uint8Array|null} [currentVersion] File currentVersion
         * @property {Array.<Uint8Array>|null} [versions] File versions
         * @property {Array.<number|Long>|null} [sizes] File sizes
         * @property {Array.<number|Long>|null} [versionCreationDates] File versionCreationDates
         * @property {number|null} [currentVersionCompressionType] File currentVersionCompressionType
         * @property {number|Long|null} [currentVersionChunkSize] File currentVersionChunkSize
         * @property {Array.<string>|null} [tags] File tags
         * @property {string|null} [fileType] File fileType
         * @property {Uint8Array|null} [thunmbNail] File thunmbNail
         */

        /**
         * Constructs a new File.
         * @memberof response
         * @classdesc Represents a File.
         * @implements IFile
         * @constructor
         * @param {response.IFile=} [properties] Properties to set
         */
        function File(properties) {
            this.versions = [];
            this.sizes = [];
            this.versionCreationDates = [];
            this.tags = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * File name.
         * @member {string} name
         * @memberof response.File
         * @instance
         */
        File.prototype.name = "";

        /**
         * File parentFolder.
         * @member {string} parentFolder
         * @memberof response.File
         * @instance
         */
        File.prototype.parentFolder = "";

        /**
         * File uuid.
         * @member {Uint8Array} uuid
         * @memberof response.File
         * @instance
         */
        File.prototype.uuid = $util.newBuffer([]);

        /**
         * File owner.
         * @member {string} owner
         * @memberof response.File
         * @instance
         */
        File.prototype.owner = "";

        /**
         * File creationDate.
         * @member {number|Long} creationDate
         * @memberof response.File
         * @instance
         */
        File.prototype.creationDate = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * File lastModifiedDate.
         * @member {number|Long} lastModifiedDate
         * @memberof response.File
         * @instance
         */
        File.prototype.lastModifiedDate = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * File currentVersion.
         * @member {Uint8Array} currentVersion
         * @memberof response.File
         * @instance
         */
        File.prototype.currentVersion = $util.newBuffer([]);

        /**
         * File versions.
         * @member {Array.<Uint8Array>} versions
         * @memberof response.File
         * @instance
         */
        File.prototype.versions = $util.emptyArray;

        /**
         * File sizes.
         * @member {Array.<number|Long>} sizes
         * @memberof response.File
         * @instance
         */
        File.prototype.sizes = $util.emptyArray;

        /**
         * File versionCreationDates.
         * @member {Array.<number|Long>} versionCreationDates
         * @memberof response.File
         * @instance
         */
        File.prototype.versionCreationDates = $util.emptyArray;

        /**
         * File currentVersionCompressionType.
         * @member {number} currentVersionCompressionType
         * @memberof response.File
         * @instance
         */
        File.prototype.currentVersionCompressionType = 0;

        /**
         * File currentVersionChunkSize.
         * @member {number|Long} currentVersionChunkSize
         * @memberof response.File
         * @instance
         */
        File.prototype.currentVersionChunkSize = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * File tags.
         * @member {Array.<string>} tags
         * @memberof response.File
         * @instance
         */
        File.prototype.tags = $util.emptyArray;

        /**
         * File fileType.
         * @member {string} fileType
         * @memberof response.File
         * @instance
         */
        File.prototype.fileType = "";

        /**
         * File thunmbNail.
         * @member {Uint8Array} thunmbNail
         * @memberof response.File
         * @instance
         */
        File.prototype.thunmbNail = $util.newBuffer([]);

        /**
         * Creates a new File instance using the specified properties.
         * @function create
         * @memberof response.File
         * @static
         * @param {response.IFile=} [properties] Properties to set
         * @returns {response.File} File instance
         */
        File.create = function create(properties) {
            return new File(properties);
        };

        /**
         * Encodes the specified File message. Does not implicitly {@link response.File.verify|verify} messages.
         * @function encode
         * @memberof response.File
         * @static
         * @param {response.IFile} message File message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        File.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
            if (message.parentFolder != null && Object.hasOwnProperty.call(message, "parentFolder"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.parentFolder);
            if (message.uuid != null && Object.hasOwnProperty.call(message, "uuid"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.uuid);
            if (message.owner != null && Object.hasOwnProperty.call(message, "owner"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.owner);
            if (message.creationDate != null && Object.hasOwnProperty.call(message, "creationDate"))
                writer.uint32(/* id 5, wireType 0 =*/40).uint64(message.creationDate);
            if (message.lastModifiedDate != null && Object.hasOwnProperty.call(message, "lastModifiedDate"))
                writer.uint32(/* id 6, wireType 0 =*/48).uint64(message.lastModifiedDate);
            if (message.currentVersion != null && Object.hasOwnProperty.call(message, "currentVersion"))
                writer.uint32(/* id 7, wireType 2 =*/58).bytes(message.currentVersion);
            if (message.versions != null && message.versions.length)
                for (let i = 0; i < message.versions.length; ++i)
                    writer.uint32(/* id 8, wireType 2 =*/66).bytes(message.versions[i]);
            if (message.sizes != null && message.sizes.length) {
                writer.uint32(/* id 9, wireType 2 =*/74).fork();
                for (let i = 0; i < message.sizes.length; ++i)
                    writer.uint64(message.sizes[i]);
                writer.ldelim();
            }
            if (message.versionCreationDates != null && message.versionCreationDates.length) {
                writer.uint32(/* id 10, wireType 2 =*/82).fork();
                for (let i = 0; i < message.versionCreationDates.length; ++i)
                    writer.uint64(message.versionCreationDates[i]);
                writer.ldelim();
            }
            if (message.currentVersionCompressionType != null && Object.hasOwnProperty.call(message, "currentVersionCompressionType"))
                writer.uint32(/* id 11, wireType 0 =*/88).int32(message.currentVersionCompressionType);
            if (message.currentVersionChunkSize != null && Object.hasOwnProperty.call(message, "currentVersionChunkSize"))
                writer.uint32(/* id 12, wireType 0 =*/96).uint64(message.currentVersionChunkSize);
            if (message.tags != null && message.tags.length)
                for (let i = 0; i < message.tags.length; ++i)
                    writer.uint32(/* id 13, wireType 2 =*/106).string(message.tags[i]);
            if (message.fileType != null && Object.hasOwnProperty.call(message, "fileType"))
                writer.uint32(/* id 14, wireType 2 =*/114).string(message.fileType);
            if (message.thunmbNail != null && Object.hasOwnProperty.call(message, "thunmbNail"))
                writer.uint32(/* id 15, wireType 2 =*/122).bytes(message.thunmbNail);
            return writer;
        };

        /**
         * Encodes the specified File message, length delimited. Does not implicitly {@link response.File.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.File
         * @static
         * @param {response.IFile} message File message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        File.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a File message from the specified reader or buffer.
         * @function decode
         * @memberof response.File
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.File} File
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        File.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.File();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.name = reader.string();
                        break;
                    }
                case 2: {
                        message.parentFolder = reader.string();
                        break;
                    }
                case 3: {
                        message.uuid = reader.bytes();
                        break;
                    }
                case 4: {
                        message.owner = reader.string();
                        break;
                    }
                case 5: {
                        message.creationDate = reader.uint64();
                        break;
                    }
                case 6: {
                        message.lastModifiedDate = reader.uint64();
                        break;
                    }
                case 7: {
                        message.currentVersion = reader.bytes();
                        break;
                    }
                case 8: {
                        if (!(message.versions && message.versions.length))
                            message.versions = [];
                        message.versions.push(reader.bytes());
                        break;
                    }
                case 9: {
                        if (!(message.sizes && message.sizes.length))
                            message.sizes = [];
                        if ((tag & 7) === 2) {
                            let end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.sizes.push(reader.uint64());
                        } else
                            message.sizes.push(reader.uint64());
                        break;
                    }
                case 10: {
                        if (!(message.versionCreationDates && message.versionCreationDates.length))
                            message.versionCreationDates = [];
                        if ((tag & 7) === 2) {
                            let end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.versionCreationDates.push(reader.uint64());
                        } else
                            message.versionCreationDates.push(reader.uint64());
                        break;
                    }
                case 11: {
                        message.currentVersionCompressionType = reader.int32();
                        break;
                    }
                case 12: {
                        message.currentVersionChunkSize = reader.uint64();
                        break;
                    }
                case 13: {
                        if (!(message.tags && message.tags.length))
                            message.tags = [];
                        message.tags.push(reader.string());
                        break;
                    }
                case 14: {
                        message.fileType = reader.string();
                        break;
                    }
                case 15: {
                        message.thunmbNail = reader.bytes();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a File message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.File
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.File} File
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        File.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a File message.
         * @function verify
         * @memberof response.File
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        File.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.parentFolder != null && message.hasOwnProperty("parentFolder"))
                if (!$util.isString(message.parentFolder))
                    return "parentFolder: string expected";
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                if (!(message.uuid && typeof message.uuid.length === "number" || $util.isString(message.uuid)))
                    return "uuid: buffer expected";
            if (message.owner != null && message.hasOwnProperty("owner"))
                if (!$util.isString(message.owner))
                    return "owner: string expected";
            if (message.creationDate != null && message.hasOwnProperty("creationDate"))
                if (!$util.isInteger(message.creationDate) && !(message.creationDate && $util.isInteger(message.creationDate.low) && $util.isInteger(message.creationDate.high)))
                    return "creationDate: integer|Long expected";
            if (message.lastModifiedDate != null && message.hasOwnProperty("lastModifiedDate"))
                if (!$util.isInteger(message.lastModifiedDate) && !(message.lastModifiedDate && $util.isInteger(message.lastModifiedDate.low) && $util.isInteger(message.lastModifiedDate.high)))
                    return "lastModifiedDate: integer|Long expected";
            if (message.currentVersion != null && message.hasOwnProperty("currentVersion"))
                if (!(message.currentVersion && typeof message.currentVersion.length === "number" || $util.isString(message.currentVersion)))
                    return "currentVersion: buffer expected";
            if (message.versions != null && message.hasOwnProperty("versions")) {
                if (!Array.isArray(message.versions))
                    return "versions: array expected";
                for (let i = 0; i < message.versions.length; ++i)
                    if (!(message.versions[i] && typeof message.versions[i].length === "number" || $util.isString(message.versions[i])))
                        return "versions: buffer[] expected";
            }
            if (message.sizes != null && message.hasOwnProperty("sizes")) {
                if (!Array.isArray(message.sizes))
                    return "sizes: array expected";
                for (let i = 0; i < message.sizes.length; ++i)
                    if (!$util.isInteger(message.sizes[i]) && !(message.sizes[i] && $util.isInteger(message.sizes[i].low) && $util.isInteger(message.sizes[i].high)))
                        return "sizes: integer|Long[] expected";
            }
            if (message.versionCreationDates != null && message.hasOwnProperty("versionCreationDates")) {
                if (!Array.isArray(message.versionCreationDates))
                    return "versionCreationDates: array expected";
                for (let i = 0; i < message.versionCreationDates.length; ++i)
                    if (!$util.isInteger(message.versionCreationDates[i]) && !(message.versionCreationDates[i] && $util.isInteger(message.versionCreationDates[i].low) && $util.isInteger(message.versionCreationDates[i].high)))
                        return "versionCreationDates: integer|Long[] expected";
            }
            if (message.currentVersionCompressionType != null && message.hasOwnProperty("currentVersionCompressionType"))
                if (!$util.isInteger(message.currentVersionCompressionType))
                    return "currentVersionCompressionType: integer expected";
            if (message.currentVersionChunkSize != null && message.hasOwnProperty("currentVersionChunkSize"))
                if (!$util.isInteger(message.currentVersionChunkSize) && !(message.currentVersionChunkSize && $util.isInteger(message.currentVersionChunkSize.low) && $util.isInteger(message.currentVersionChunkSize.high)))
                    return "currentVersionChunkSize: integer|Long expected";
            if (message.tags != null && message.hasOwnProperty("tags")) {
                if (!Array.isArray(message.tags))
                    return "tags: array expected";
                for (let i = 0; i < message.tags.length; ++i)
                    if (!$util.isString(message.tags[i]))
                        return "tags: string[] expected";
            }
            if (message.fileType != null && message.hasOwnProperty("fileType"))
                if (!$util.isString(message.fileType))
                    return "fileType: string expected";
            if (message.thunmbNail != null && message.hasOwnProperty("thunmbNail"))
                if (!(message.thunmbNail && typeof message.thunmbNail.length === "number" || $util.isString(message.thunmbNail)))
                    return "thunmbNail: buffer expected";
            return null;
        };

        /**
         * Creates a File message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.File
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.File} File
         */
        File.fromObject = function fromObject(object) {
            if (object instanceof $root.response.File)
                return object;
            let message = new $root.response.File();
            if (object.name != null)
                message.name = String(object.name);
            if (object.parentFolder != null)
                message.parentFolder = String(object.parentFolder);
            if (object.uuid != null)
                if (typeof object.uuid === "string")
                    $util.base64.decode(object.uuid, message.uuid = $util.newBuffer($util.base64.length(object.uuid)), 0);
                else if (object.uuid.length >= 0)
                    message.uuid = object.uuid;
            if (object.owner != null)
                message.owner = String(object.owner);
            if (object.creationDate != null)
                if ($util.Long)
                    (message.creationDate = $util.Long.fromValue(object.creationDate)).unsigned = true;
                else if (typeof object.creationDate === "string")
                    message.creationDate = parseInt(object.creationDate, 10);
                else if (typeof object.creationDate === "number")
                    message.creationDate = object.creationDate;
                else if (typeof object.creationDate === "object")
                    message.creationDate = new $util.LongBits(object.creationDate.low >>> 0, object.creationDate.high >>> 0).toNumber(true);
            if (object.lastModifiedDate != null)
                if ($util.Long)
                    (message.lastModifiedDate = $util.Long.fromValue(object.lastModifiedDate)).unsigned = true;
                else if (typeof object.lastModifiedDate === "string")
                    message.lastModifiedDate = parseInt(object.lastModifiedDate, 10);
                else if (typeof object.lastModifiedDate === "number")
                    message.lastModifiedDate = object.lastModifiedDate;
                else if (typeof object.lastModifiedDate === "object")
                    message.lastModifiedDate = new $util.LongBits(object.lastModifiedDate.low >>> 0, object.lastModifiedDate.high >>> 0).toNumber(true);
            if (object.currentVersion != null)
                if (typeof object.currentVersion === "string")
                    $util.base64.decode(object.currentVersion, message.currentVersion = $util.newBuffer($util.base64.length(object.currentVersion)), 0);
                else if (object.currentVersion.length >= 0)
                    message.currentVersion = object.currentVersion;
            if (object.versions) {
                if (!Array.isArray(object.versions))
                    throw TypeError(".response.File.versions: array expected");
                message.versions = [];
                for (let i = 0; i < object.versions.length; ++i)
                    if (typeof object.versions[i] === "string")
                        $util.base64.decode(object.versions[i], message.versions[i] = $util.newBuffer($util.base64.length(object.versions[i])), 0);
                    else if (object.versions[i].length >= 0)
                        message.versions[i] = object.versions[i];
            }
            if (object.sizes) {
                if (!Array.isArray(object.sizes))
                    throw TypeError(".response.File.sizes: array expected");
                message.sizes = [];
                for (let i = 0; i < object.sizes.length; ++i)
                    if ($util.Long)
                        (message.sizes[i] = $util.Long.fromValue(object.sizes[i])).unsigned = true;
                    else if (typeof object.sizes[i] === "string")
                        message.sizes[i] = parseInt(object.sizes[i], 10);
                    else if (typeof object.sizes[i] === "number")
                        message.sizes[i] = object.sizes[i];
                    else if (typeof object.sizes[i] === "object")
                        message.sizes[i] = new $util.LongBits(object.sizes[i].low >>> 0, object.sizes[i].high >>> 0).toNumber(true);
            }
            if (object.versionCreationDates) {
                if (!Array.isArray(object.versionCreationDates))
                    throw TypeError(".response.File.versionCreationDates: array expected");
                message.versionCreationDates = [];
                for (let i = 0; i < object.versionCreationDates.length; ++i)
                    if ($util.Long)
                        (message.versionCreationDates[i] = $util.Long.fromValue(object.versionCreationDates[i])).unsigned = true;
                    else if (typeof object.versionCreationDates[i] === "string")
                        message.versionCreationDates[i] = parseInt(object.versionCreationDates[i], 10);
                    else if (typeof object.versionCreationDates[i] === "number")
                        message.versionCreationDates[i] = object.versionCreationDates[i];
                    else if (typeof object.versionCreationDates[i] === "object")
                        message.versionCreationDates[i] = new $util.LongBits(object.versionCreationDates[i].low >>> 0, object.versionCreationDates[i].high >>> 0).toNumber(true);
            }
            if (object.currentVersionCompressionType != null)
                message.currentVersionCompressionType = object.currentVersionCompressionType | 0;
            if (object.currentVersionChunkSize != null)
                if ($util.Long)
                    (message.currentVersionChunkSize = $util.Long.fromValue(object.currentVersionChunkSize)).unsigned = true;
                else if (typeof object.currentVersionChunkSize === "string")
                    message.currentVersionChunkSize = parseInt(object.currentVersionChunkSize, 10);
                else if (typeof object.currentVersionChunkSize === "number")
                    message.currentVersionChunkSize = object.currentVersionChunkSize;
                else if (typeof object.currentVersionChunkSize === "object")
                    message.currentVersionChunkSize = new $util.LongBits(object.currentVersionChunkSize.low >>> 0, object.currentVersionChunkSize.high >>> 0).toNumber(true);
            if (object.tags) {
                if (!Array.isArray(object.tags))
                    throw TypeError(".response.File.tags: array expected");
                message.tags = [];
                for (let i = 0; i < object.tags.length; ++i)
                    message.tags[i] = String(object.tags[i]);
            }
            if (object.fileType != null)
                message.fileType = String(object.fileType);
            if (object.thunmbNail != null)
                if (typeof object.thunmbNail === "string")
                    $util.base64.decode(object.thunmbNail, message.thunmbNail = $util.newBuffer($util.base64.length(object.thunmbNail)), 0);
                else if (object.thunmbNail.length >= 0)
                    message.thunmbNail = object.thunmbNail;
            return message;
        };

        /**
         * Creates a plain object from a File message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.File
         * @static
         * @param {response.File} message File
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        File.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.versions = [];
                object.sizes = [];
                object.versionCreationDates = [];
                object.tags = [];
            }
            if (options.defaults) {
                object.name = "";
                object.parentFolder = "";
                if (options.bytes === String)
                    object.uuid = "";
                else {
                    object.uuid = [];
                    if (options.bytes !== Array)
                        object.uuid = $util.newBuffer(object.uuid);
                }
                object.owner = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.creationDate = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.creationDate = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.lastModifiedDate = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.lastModifiedDate = options.longs === String ? "0" : 0;
                if (options.bytes === String)
                    object.currentVersion = "";
                else {
                    object.currentVersion = [];
                    if (options.bytes !== Array)
                        object.currentVersion = $util.newBuffer(object.currentVersion);
                }
                object.currentVersionCompressionType = 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.currentVersionChunkSize = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.currentVersionChunkSize = options.longs === String ? "0" : 0;
                object.fileType = "";
                if (options.bytes === String)
                    object.thunmbNail = "";
                else {
                    object.thunmbNail = [];
                    if (options.bytes !== Array)
                        object.thunmbNail = $util.newBuffer(object.thunmbNail);
                }
            }
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.parentFolder != null && message.hasOwnProperty("parentFolder"))
                object.parentFolder = message.parentFolder;
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                object.uuid = options.bytes === String ? $util.base64.encode(message.uuid, 0, message.uuid.length) : options.bytes === Array ? Array.prototype.slice.call(message.uuid) : message.uuid;
            if (message.owner != null && message.hasOwnProperty("owner"))
                object.owner = message.owner;
            if (message.creationDate != null && message.hasOwnProperty("creationDate"))
                if (typeof message.creationDate === "number")
                    object.creationDate = options.longs === String ? String(message.creationDate) : message.creationDate;
                else
                    object.creationDate = options.longs === String ? $util.Long.prototype.toString.call(message.creationDate) : options.longs === Number ? new $util.LongBits(message.creationDate.low >>> 0, message.creationDate.high >>> 0).toNumber(true) : message.creationDate;
            if (message.lastModifiedDate != null && message.hasOwnProperty("lastModifiedDate"))
                if (typeof message.lastModifiedDate === "number")
                    object.lastModifiedDate = options.longs === String ? String(message.lastModifiedDate) : message.lastModifiedDate;
                else
                    object.lastModifiedDate = options.longs === String ? $util.Long.prototype.toString.call(message.lastModifiedDate) : options.longs === Number ? new $util.LongBits(message.lastModifiedDate.low >>> 0, message.lastModifiedDate.high >>> 0).toNumber(true) : message.lastModifiedDate;
            if (message.currentVersion != null && message.hasOwnProperty("currentVersion"))
                object.currentVersion = options.bytes === String ? $util.base64.encode(message.currentVersion, 0, message.currentVersion.length) : options.bytes === Array ? Array.prototype.slice.call(message.currentVersion) : message.currentVersion;
            if (message.versions && message.versions.length) {
                object.versions = [];
                for (let j = 0; j < message.versions.length; ++j)
                    object.versions[j] = options.bytes === String ? $util.base64.encode(message.versions[j], 0, message.versions[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.versions[j]) : message.versions[j];
            }
            if (message.sizes && message.sizes.length) {
                object.sizes = [];
                for (let j = 0; j < message.sizes.length; ++j)
                    if (typeof message.sizes[j] === "number")
                        object.sizes[j] = options.longs === String ? String(message.sizes[j]) : message.sizes[j];
                    else
                        object.sizes[j] = options.longs === String ? $util.Long.prototype.toString.call(message.sizes[j]) : options.longs === Number ? new $util.LongBits(message.sizes[j].low >>> 0, message.sizes[j].high >>> 0).toNumber(true) : message.sizes[j];
            }
            if (message.versionCreationDates && message.versionCreationDates.length) {
                object.versionCreationDates = [];
                for (let j = 0; j < message.versionCreationDates.length; ++j)
                    if (typeof message.versionCreationDates[j] === "number")
                        object.versionCreationDates[j] = options.longs === String ? String(message.versionCreationDates[j]) : message.versionCreationDates[j];
                    else
                        object.versionCreationDates[j] = options.longs === String ? $util.Long.prototype.toString.call(message.versionCreationDates[j]) : options.longs === Number ? new $util.LongBits(message.versionCreationDates[j].low >>> 0, message.versionCreationDates[j].high >>> 0).toNumber(true) : message.versionCreationDates[j];
            }
            if (message.currentVersionCompressionType != null && message.hasOwnProperty("currentVersionCompressionType"))
                object.currentVersionCompressionType = message.currentVersionCompressionType;
            if (message.currentVersionChunkSize != null && message.hasOwnProperty("currentVersionChunkSize"))
                if (typeof message.currentVersionChunkSize === "number")
                    object.currentVersionChunkSize = options.longs === String ? String(message.currentVersionChunkSize) : message.currentVersionChunkSize;
                else
                    object.currentVersionChunkSize = options.longs === String ? $util.Long.prototype.toString.call(message.currentVersionChunkSize) : options.longs === Number ? new $util.LongBits(message.currentVersionChunkSize.low >>> 0, message.currentVersionChunkSize.high >>> 0).toNumber(true) : message.currentVersionChunkSize;
            if (message.tags && message.tags.length) {
                object.tags = [];
                for (let j = 0; j < message.tags.length; ++j)
                    object.tags[j] = message.tags[j];
            }
            if (message.fileType != null && message.hasOwnProperty("fileType"))
                object.fileType = message.fileType;
            if (message.thunmbNail != null && message.hasOwnProperty("thunmbNail"))
                object.thunmbNail = options.bytes === String ? $util.base64.encode(message.thunmbNail, 0, message.thunmbNail.length) : options.bytes === Array ? Array.prototype.slice.call(message.thunmbNail) : message.thunmbNail;
            return object;
        };

        /**
         * Converts this File to JSON.
         * @function toJSON
         * @memberof response.File
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        File.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for File
         * @function getTypeUrl
         * @memberof response.File
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        File.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.File";
        };

        return File;
    })();

    response.GetFileHead = (function() {

        /**
         * Properties of a GetFileHead.
         * @memberof response
         * @interface IGetFileHead
         * @property {response.Status|null} [status] GetFileHead status
         * @property {response.IFile|null} [file] GetFileHead file
         */

        /**
         * Constructs a new GetFileHead.
         * @memberof response
         * @classdesc Represents a GetFileHead.
         * @implements IGetFileHead
         * @constructor
         * @param {response.IGetFileHead=} [properties] Properties to set
         */
        function GetFileHead(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetFileHead status.
         * @member {response.Status} status
         * @memberof response.GetFileHead
         * @instance
         */
        GetFileHead.prototype.status = 0;

        /**
         * GetFileHead file.
         * @member {response.IFile|null|undefined} file
         * @memberof response.GetFileHead
         * @instance
         */
        GetFileHead.prototype.file = null;

        /**
         * Creates a new GetFileHead instance using the specified properties.
         * @function create
         * @memberof response.GetFileHead
         * @static
         * @param {response.IGetFileHead=} [properties] Properties to set
         * @returns {response.GetFileHead} GetFileHead instance
         */
        GetFileHead.create = function create(properties) {
            return new GetFileHead(properties);
        };

        /**
         * Encodes the specified GetFileHead message. Does not implicitly {@link response.GetFileHead.verify|verify} messages.
         * @function encode
         * @memberof response.GetFileHead
         * @static
         * @param {response.IGetFileHead} message GetFileHead message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetFileHead.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.file != null && Object.hasOwnProperty.call(message, "file"))
                $root.response.File.encode(message.file, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified GetFileHead message, length delimited. Does not implicitly {@link response.GetFileHead.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.GetFileHead
         * @static
         * @param {response.IGetFileHead} message GetFileHead message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetFileHead.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetFileHead message from the specified reader or buffer.
         * @function decode
         * @memberof response.GetFileHead
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.GetFileHead} GetFileHead
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetFileHead.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.GetFileHead();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.file = $root.response.File.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetFileHead message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.GetFileHead
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.GetFileHead} GetFileHead
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetFileHead.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetFileHead message.
         * @function verify
         * @memberof response.GetFileHead
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetFileHead.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.file != null && message.hasOwnProperty("file")) {
                let error = $root.response.File.verify(message.file);
                if (error)
                    return "file." + error;
            }
            return null;
        };

        /**
         * Creates a GetFileHead message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.GetFileHead
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.GetFileHead} GetFileHead
         */
        GetFileHead.fromObject = function fromObject(object) {
            if (object instanceof $root.response.GetFileHead)
                return object;
            let message = new $root.response.GetFileHead();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.file != null) {
                if (typeof object.file !== "object")
                    throw TypeError(".response.GetFileHead.file: object expected");
                message.file = $root.response.File.fromObject(object.file);
            }
            return message;
        };

        /**
         * Creates a plain object from a GetFileHead message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.GetFileHead
         * @static
         * @param {response.GetFileHead} message GetFileHead
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetFileHead.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.status = options.enums === String ? "SUCCESS" : 0;
                object.file = null;
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.file != null && message.hasOwnProperty("file"))
                object.file = $root.response.File.toObject(message.file, options);
            return object;
        };

        /**
         * Converts this GetFileHead to JSON.
         * @function toJSON
         * @memberof response.GetFileHead
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetFileHead.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetFileHead
         * @function getTypeUrl
         * @memberof response.GetFileHead
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetFileHead.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.GetFileHead";
        };

        return GetFileHead;
    })();

    /**
     * ChunkCompression enum.
     * @name response.ChunkCompression
     * @enum {number}
     * @property {number} None=0 None value
     * @property {number} GZIP=1 GZIP value
     * @property {number} ZSTD=2 ZSTD value
     * @property {number} LZ4=3 LZ4 value
     * @property {number} LZ4HC=4 LZ4HC value
     * @property {number} LZMA=5 LZMA value
     * @property {number} BZIP2=6 BZIP2 value
     * @property {number} ZLIB=7 ZLIB value
     */
    response.ChunkCompression = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "None"] = 0;
        values[valuesById[1] = "GZIP"] = 1;
        values[valuesById[2] = "ZSTD"] = 2;
        values[valuesById[3] = "LZ4"] = 3;
        values[valuesById[4] = "LZ4HC"] = 4;
        values[valuesById[5] = "LZMA"] = 5;
        values[valuesById[6] = "BZIP2"] = 6;
        values[valuesById[7] = "ZLIB"] = 7;
        return values;
    })();

    response.GetChunk = (function() {

        /**
         * Properties of a GetChunk.
         * @memberof response
         * @interface IGetChunk
         * @property {response.Status|null} [status] GetChunk status
         * @property {number|Long|null} [offset] GetChunk offset
         * @property {number|Long|null} [chunkOffset] GetChunk chunkOffset
         * @property {number|Long|null} [size] GetChunk size
         * @property {Uint8Array|null} [hash] GetChunk hash
         * @property {response.ChunkCompression|null} [compressionType] GetChunk compressionType
         * @property {Uint8Array|null} [data] GetChunk data
         * @property {boolean|null} [isLast] GetChunk isLast
         * @property {string|null} [message] GetChunk message
         */

        /**
         * Constructs a new GetChunk.
         * @memberof response
         * @classdesc Represents a GetChunk.
         * @implements IGetChunk
         * @constructor
         * @param {response.IGetChunk=} [properties] Properties to set
         */
        function GetChunk(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetChunk status.
         * @member {response.Status} status
         * @memberof response.GetChunk
         * @instance
         */
        GetChunk.prototype.status = 0;

        /**
         * GetChunk offset.
         * @member {number|Long|null|undefined} offset
         * @memberof response.GetChunk
         * @instance
         */
        GetChunk.prototype.offset = null;

        /**
         * GetChunk chunkOffset.
         * @member {number|Long|null|undefined} chunkOffset
         * @memberof response.GetChunk
         * @instance
         */
        GetChunk.prototype.chunkOffset = null;

        /**
         * GetChunk size.
         * @member {number|Long|null|undefined} size
         * @memberof response.GetChunk
         * @instance
         */
        GetChunk.prototype.size = null;

        /**
         * GetChunk hash.
         * @member {Uint8Array|null|undefined} hash
         * @memberof response.GetChunk
         * @instance
         */
        GetChunk.prototype.hash = null;

        /**
         * GetChunk compressionType.
         * @member {response.ChunkCompression|null|undefined} compressionType
         * @memberof response.GetChunk
         * @instance
         */
        GetChunk.prototype.compressionType = null;

        /**
         * GetChunk data.
         * @member {Uint8Array} data
         * @memberof response.GetChunk
         * @instance
         */
        GetChunk.prototype.data = $util.newBuffer([]);

        /**
         * GetChunk isLast.
         * @member {boolean} isLast
         * @memberof response.GetChunk
         * @instance
         */
        GetChunk.prototype.isLast = false;

        /**
         * GetChunk message.
         * @member {string|null|undefined} message
         * @memberof response.GetChunk
         * @instance
         */
        GetChunk.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(GetChunk.prototype, "_offset", {
            get: $util.oneOfGetter($oneOfFields = ["offset"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(GetChunk.prototype, "_chunkOffset", {
            get: $util.oneOfGetter($oneOfFields = ["chunkOffset"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(GetChunk.prototype, "_size", {
            get: $util.oneOfGetter($oneOfFields = ["size"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(GetChunk.prototype, "_hash", {
            get: $util.oneOfGetter($oneOfFields = ["hash"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(GetChunk.prototype, "_compressionType", {
            get: $util.oneOfGetter($oneOfFields = ["compressionType"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(GetChunk.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new GetChunk instance using the specified properties.
         * @function create
         * @memberof response.GetChunk
         * @static
         * @param {response.IGetChunk=} [properties] Properties to set
         * @returns {response.GetChunk} GetChunk instance
         */
        GetChunk.create = function create(properties) {
            return new GetChunk(properties);
        };

        /**
         * Encodes the specified GetChunk message. Does not implicitly {@link response.GetChunk.verify|verify} messages.
         * @function encode
         * @memberof response.GetChunk
         * @static
         * @param {response.IGetChunk} message GetChunk message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetChunk.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.offset != null && Object.hasOwnProperty.call(message, "offset"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.offset);
            if (message.size != null && Object.hasOwnProperty.call(message, "size"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.size);
            if (message.hash != null && Object.hasOwnProperty.call(message, "hash"))
                writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.hash);
            if (message.compressionType != null && Object.hasOwnProperty.call(message, "compressionType"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.compressionType);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 6, wireType 2 =*/50).bytes(message.data);
            if (message.isLast != null && Object.hasOwnProperty.call(message, "isLast"))
                writer.uint32(/* id 7, wireType 0 =*/56).bool(message.isLast);
            if (message.chunkOffset != null && Object.hasOwnProperty.call(message, "chunkOffset"))
                writer.uint32(/* id 8, wireType 0 =*/64).uint64(message.chunkOffset);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 9, wireType 2 =*/74).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified GetChunk message, length delimited. Does not implicitly {@link response.GetChunk.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.GetChunk
         * @static
         * @param {response.IGetChunk} message GetChunk message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetChunk.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetChunk message from the specified reader or buffer.
         * @function decode
         * @memberof response.GetChunk
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.GetChunk} GetChunk
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetChunk.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.GetChunk();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.offset = reader.uint64();
                        break;
                    }
                case 8: {
                        message.chunkOffset = reader.uint64();
                        break;
                    }
                case 3: {
                        message.size = reader.uint64();
                        break;
                    }
                case 4: {
                        message.hash = reader.bytes();
                        break;
                    }
                case 5: {
                        message.compressionType = reader.int32();
                        break;
                    }
                case 6: {
                        message.data = reader.bytes();
                        break;
                    }
                case 7: {
                        message.isLast = reader.bool();
                        break;
                    }
                case 9: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetChunk message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.GetChunk
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.GetChunk} GetChunk
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetChunk.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetChunk message.
         * @function verify
         * @memberof response.GetChunk
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetChunk.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.offset != null && message.hasOwnProperty("offset")) {
                properties._offset = 1;
                if (!$util.isInteger(message.offset) && !(message.offset && $util.isInteger(message.offset.low) && $util.isInteger(message.offset.high)))
                    return "offset: integer|Long expected";
            }
            if (message.chunkOffset != null && message.hasOwnProperty("chunkOffset")) {
                properties._chunkOffset = 1;
                if (!$util.isInteger(message.chunkOffset) && !(message.chunkOffset && $util.isInteger(message.chunkOffset.low) && $util.isInteger(message.chunkOffset.high)))
                    return "chunkOffset: integer|Long expected";
            }
            if (message.size != null && message.hasOwnProperty("size")) {
                properties._size = 1;
                if (!$util.isInteger(message.size) && !(message.size && $util.isInteger(message.size.low) && $util.isInteger(message.size.high)))
                    return "size: integer|Long expected";
            }
            if (message.hash != null && message.hasOwnProperty("hash")) {
                properties._hash = 1;
                if (!(message.hash && typeof message.hash.length === "number" || $util.isString(message.hash)))
                    return "hash: buffer expected";
            }
            if (message.compressionType != null && message.hasOwnProperty("compressionType")) {
                properties._compressionType = 1;
                switch (message.compressionType) {
                default:
                    return "compressionType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                    break;
                }
            }
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            if (message.isLast != null && message.hasOwnProperty("isLast"))
                if (typeof message.isLast !== "boolean")
                    return "isLast: boolean expected";
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a GetChunk message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.GetChunk
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.GetChunk} GetChunk
         */
        GetChunk.fromObject = function fromObject(object) {
            if (object instanceof $root.response.GetChunk)
                return object;
            let message = new $root.response.GetChunk();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.offset != null)
                if ($util.Long)
                    (message.offset = $util.Long.fromValue(object.offset)).unsigned = true;
                else if (typeof object.offset === "string")
                    message.offset = parseInt(object.offset, 10);
                else if (typeof object.offset === "number")
                    message.offset = object.offset;
                else if (typeof object.offset === "object")
                    message.offset = new $util.LongBits(object.offset.low >>> 0, object.offset.high >>> 0).toNumber(true);
            if (object.chunkOffset != null)
                if ($util.Long)
                    (message.chunkOffset = $util.Long.fromValue(object.chunkOffset)).unsigned = true;
                else if (typeof object.chunkOffset === "string")
                    message.chunkOffset = parseInt(object.chunkOffset, 10);
                else if (typeof object.chunkOffset === "number")
                    message.chunkOffset = object.chunkOffset;
                else if (typeof object.chunkOffset === "object")
                    message.chunkOffset = new $util.LongBits(object.chunkOffset.low >>> 0, object.chunkOffset.high >>> 0).toNumber(true);
            if (object.size != null)
                if ($util.Long)
                    (message.size = $util.Long.fromValue(object.size)).unsigned = true;
                else if (typeof object.size === "string")
                    message.size = parseInt(object.size, 10);
                else if (typeof object.size === "number")
                    message.size = object.size;
                else if (typeof object.size === "object")
                    message.size = new $util.LongBits(object.size.low >>> 0, object.size.high >>> 0).toNumber(true);
            if (object.hash != null)
                if (typeof object.hash === "string")
                    $util.base64.decode(object.hash, message.hash = $util.newBuffer($util.base64.length(object.hash)), 0);
                else if (object.hash.length >= 0)
                    message.hash = object.hash;
            switch (object.compressionType) {
            default:
                if (typeof object.compressionType === "number") {
                    message.compressionType = object.compressionType;
                    break;
                }
                break;
            case "None":
            case 0:
                message.compressionType = 0;
                break;
            case "GZIP":
            case 1:
                message.compressionType = 1;
                break;
            case "ZSTD":
            case 2:
                message.compressionType = 2;
                break;
            case "LZ4":
            case 3:
                message.compressionType = 3;
                break;
            case "LZ4HC":
            case 4:
                message.compressionType = 4;
                break;
            case "LZMA":
            case 5:
                message.compressionType = 5;
                break;
            case "BZIP2":
            case 6:
                message.compressionType = 6;
                break;
            case "ZLIB":
            case 7:
                message.compressionType = 7;
                break;
            }
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            if (object.isLast != null)
                message.isLast = Boolean(object.isLast);
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a GetChunk message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.GetChunk
         * @static
         * @param {response.GetChunk} message GetChunk
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetChunk.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.status = options.enums === String ? "SUCCESS" : 0;
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
                object.isLast = false;
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.offset != null && message.hasOwnProperty("offset")) {
                if (typeof message.offset === "number")
                    object.offset = options.longs === String ? String(message.offset) : message.offset;
                else
                    object.offset = options.longs === String ? $util.Long.prototype.toString.call(message.offset) : options.longs === Number ? new $util.LongBits(message.offset.low >>> 0, message.offset.high >>> 0).toNumber(true) : message.offset;
                if (options.oneofs)
                    object._offset = "offset";
            }
            if (message.size != null && message.hasOwnProperty("size")) {
                if (typeof message.size === "number")
                    object.size = options.longs === String ? String(message.size) : message.size;
                else
                    object.size = options.longs === String ? $util.Long.prototype.toString.call(message.size) : options.longs === Number ? new $util.LongBits(message.size.low >>> 0, message.size.high >>> 0).toNumber(true) : message.size;
                if (options.oneofs)
                    object._size = "size";
            }
            if (message.hash != null && message.hasOwnProperty("hash")) {
                object.hash = options.bytes === String ? $util.base64.encode(message.hash, 0, message.hash.length) : options.bytes === Array ? Array.prototype.slice.call(message.hash) : message.hash;
                if (options.oneofs)
                    object._hash = "hash";
            }
            if (message.compressionType != null && message.hasOwnProperty("compressionType")) {
                object.compressionType = options.enums === String ? $root.response.ChunkCompression[message.compressionType] === undefined ? message.compressionType : $root.response.ChunkCompression[message.compressionType] : message.compressionType;
                if (options.oneofs)
                    object._compressionType = "compressionType";
            }
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            if (message.isLast != null && message.hasOwnProperty("isLast"))
                object.isLast = message.isLast;
            if (message.chunkOffset != null && message.hasOwnProperty("chunkOffset")) {
                if (typeof message.chunkOffset === "number")
                    object.chunkOffset = options.longs === String ? String(message.chunkOffset) : message.chunkOffset;
                else
                    object.chunkOffset = options.longs === String ? $util.Long.prototype.toString.call(message.chunkOffset) : options.longs === Number ? new $util.LongBits(message.chunkOffset.low >>> 0, message.chunkOffset.high >>> 0).toNumber(true) : message.chunkOffset;
                if (options.oneofs)
                    object._chunkOffset = "chunkOffset";
            }
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this GetChunk to JSON.
         * @function toJSON
         * @memberof response.GetChunk
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetChunk.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetChunk
         * @function getTypeUrl
         * @memberof response.GetChunk
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetChunk.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.GetChunk";
        };

        return GetChunk;
    })();

    response.StartWrite = (function() {

        /**
         * Properties of a StartWrite.
         * @memberof response
         * @interface IStartWrite
         * @property {response.Status|null} [status] StartWrite status
         * @property {Uint8Array|null} [uuid] StartWrite uuid
         * @property {string|null} [message] StartWrite message
         * @property {Uint8Array|null} [fileUuiid] StartWrite fileUuiid
         */

        /**
         * Constructs a new StartWrite.
         * @memberof response
         * @classdesc Represents a StartWrite.
         * @implements IStartWrite
         * @constructor
         * @param {response.IStartWrite=} [properties] Properties to set
         */
        function StartWrite(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * StartWrite status.
         * @member {response.Status} status
         * @memberof response.StartWrite
         * @instance
         */
        StartWrite.prototype.status = 0;

        /**
         * StartWrite uuid.
         * @member {Uint8Array} uuid
         * @memberof response.StartWrite
         * @instance
         */
        StartWrite.prototype.uuid = $util.newBuffer([]);

        /**
         * StartWrite message.
         * @member {string|null|undefined} message
         * @memberof response.StartWrite
         * @instance
         */
        StartWrite.prototype.message = null;

        /**
         * StartWrite fileUuiid.
         * @member {Uint8Array} fileUuiid
         * @memberof response.StartWrite
         * @instance
         */
        StartWrite.prototype.fileUuiid = $util.newBuffer([]);

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(StartWrite.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new StartWrite instance using the specified properties.
         * @function create
         * @memberof response.StartWrite
         * @static
         * @param {response.IStartWrite=} [properties] Properties to set
         * @returns {response.StartWrite} StartWrite instance
         */
        StartWrite.create = function create(properties) {
            return new StartWrite(properties);
        };

        /**
         * Encodes the specified StartWrite message. Does not implicitly {@link response.StartWrite.verify|verify} messages.
         * @function encode
         * @memberof response.StartWrite
         * @static
         * @param {response.IStartWrite} message StartWrite message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StartWrite.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.uuid != null && Object.hasOwnProperty.call(message, "uuid"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.uuid);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.message);
            if (message.fileUuiid != null && Object.hasOwnProperty.call(message, "fileUuiid"))
                writer.uint32(/* id 5, wireType 2 =*/42).bytes(message.fileUuiid);
            return writer;
        };

        /**
         * Encodes the specified StartWrite message, length delimited. Does not implicitly {@link response.StartWrite.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.StartWrite
         * @static
         * @param {response.IStartWrite} message StartWrite message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StartWrite.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a StartWrite message from the specified reader or buffer.
         * @function decode
         * @memberof response.StartWrite
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.StartWrite} StartWrite
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StartWrite.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.StartWrite();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.uuid = reader.bytes();
                        break;
                    }
                case 4: {
                        message.message = reader.string();
                        break;
                    }
                case 5: {
                        message.fileUuiid = reader.bytes();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a StartWrite message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.StartWrite
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.StartWrite} StartWrite
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StartWrite.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a StartWrite message.
         * @function verify
         * @memberof response.StartWrite
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        StartWrite.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                if (!(message.uuid && typeof message.uuid.length === "number" || $util.isString(message.uuid)))
                    return "uuid: buffer expected";
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            if (message.fileUuiid != null && message.hasOwnProperty("fileUuiid"))
                if (!(message.fileUuiid && typeof message.fileUuiid.length === "number" || $util.isString(message.fileUuiid)))
                    return "fileUuiid: buffer expected";
            return null;
        };

        /**
         * Creates a StartWrite message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.StartWrite
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.StartWrite} StartWrite
         */
        StartWrite.fromObject = function fromObject(object) {
            if (object instanceof $root.response.StartWrite)
                return object;
            let message = new $root.response.StartWrite();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.uuid != null)
                if (typeof object.uuid === "string")
                    $util.base64.decode(object.uuid, message.uuid = $util.newBuffer($util.base64.length(object.uuid)), 0);
                else if (object.uuid.length >= 0)
                    message.uuid = object.uuid;
            if (object.message != null)
                message.message = String(object.message);
            if (object.fileUuiid != null)
                if (typeof object.fileUuiid === "string")
                    $util.base64.decode(object.fileUuiid, message.fileUuiid = $util.newBuffer($util.base64.length(object.fileUuiid)), 0);
                else if (object.fileUuiid.length >= 0)
                    message.fileUuiid = object.fileUuiid;
            return message;
        };

        /**
         * Creates a plain object from a StartWrite message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.StartWrite
         * @static
         * @param {response.StartWrite} message StartWrite
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        StartWrite.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.status = options.enums === String ? "SUCCESS" : 0;
                if (options.bytes === String)
                    object.uuid = "";
                else {
                    object.uuid = [];
                    if (options.bytes !== Array)
                        object.uuid = $util.newBuffer(object.uuid);
                }
                if (options.bytes === String)
                    object.fileUuiid = "";
                else {
                    object.fileUuiid = [];
                    if (options.bytes !== Array)
                        object.fileUuiid = $util.newBuffer(object.fileUuiid);
                }
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                object.uuid = options.bytes === String ? $util.base64.encode(message.uuid, 0, message.uuid.length) : options.bytes === Array ? Array.prototype.slice.call(message.uuid) : message.uuid;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            if (message.fileUuiid != null && message.hasOwnProperty("fileUuiid"))
                object.fileUuiid = options.bytes === String ? $util.base64.encode(message.fileUuiid, 0, message.fileUuiid.length) : options.bytes === Array ? Array.prototype.slice.call(message.fileUuiid) : message.fileUuiid;
            return object;
        };

        /**
         * Converts this StartWrite to JSON.
         * @function toJSON
         * @memberof response.StartWrite
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        StartWrite.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for StartWrite
         * @function getTypeUrl
         * @memberof response.StartWrite
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        StartWrite.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.StartWrite";
        };

        return StartWrite;
    })();

    response.PutChunk = (function() {

        /**
         * Properties of a PutChunk.
         * @memberof response
         * @interface IPutChunk
         * @property {response.Status|null} [status] PutChunk status
         * @property {Uint8Array|null} [uuid] PutChunk uuid
         * @property {response.IChunk|null} [chunk] PutChunk chunk
         * @property {string|null} [message] PutChunk message
         */

        /**
         * Constructs a new PutChunk.
         * @memberof response
         * @classdesc Represents a PutChunk.
         * @implements IPutChunk
         * @constructor
         * @param {response.IPutChunk=} [properties] Properties to set
         */
        function PutChunk(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PutChunk status.
         * @member {response.Status} status
         * @memberof response.PutChunk
         * @instance
         */
        PutChunk.prototype.status = 0;

        /**
         * PutChunk uuid.
         * @member {Uint8Array} uuid
         * @memberof response.PutChunk
         * @instance
         */
        PutChunk.prototype.uuid = $util.newBuffer([]);

        /**
         * PutChunk chunk.
         * @member {response.IChunk|null|undefined} chunk
         * @memberof response.PutChunk
         * @instance
         */
        PutChunk.prototype.chunk = null;

        /**
         * PutChunk message.
         * @member {string|null|undefined} message
         * @memberof response.PutChunk
         * @instance
         */
        PutChunk.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(PutChunk.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new PutChunk instance using the specified properties.
         * @function create
         * @memberof response.PutChunk
         * @static
         * @param {response.IPutChunk=} [properties] Properties to set
         * @returns {response.PutChunk} PutChunk instance
         */
        PutChunk.create = function create(properties) {
            return new PutChunk(properties);
        };

        /**
         * Encodes the specified PutChunk message. Does not implicitly {@link response.PutChunk.verify|verify} messages.
         * @function encode
         * @memberof response.PutChunk
         * @static
         * @param {response.IPutChunk} message PutChunk message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PutChunk.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.uuid != null && Object.hasOwnProperty.call(message, "uuid"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.uuid);
            if (message.chunk != null && Object.hasOwnProperty.call(message, "chunk"))
                $root.response.Chunk.encode(message.chunk, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified PutChunk message, length delimited. Does not implicitly {@link response.PutChunk.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.PutChunk
         * @static
         * @param {response.IPutChunk} message PutChunk message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PutChunk.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PutChunk message from the specified reader or buffer.
         * @function decode
         * @memberof response.PutChunk
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.PutChunk} PutChunk
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PutChunk.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.PutChunk();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.uuid = reader.bytes();
                        break;
                    }
                case 3: {
                        message.chunk = $root.response.Chunk.decode(reader, reader.uint32());
                        break;
                    }
                case 4: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PutChunk message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.PutChunk
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.PutChunk} PutChunk
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PutChunk.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PutChunk message.
         * @function verify
         * @memberof response.PutChunk
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PutChunk.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                if (!(message.uuid && typeof message.uuid.length === "number" || $util.isString(message.uuid)))
                    return "uuid: buffer expected";
            if (message.chunk != null && message.hasOwnProperty("chunk")) {
                let error = $root.response.Chunk.verify(message.chunk);
                if (error)
                    return "chunk." + error;
            }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a PutChunk message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.PutChunk
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.PutChunk} PutChunk
         */
        PutChunk.fromObject = function fromObject(object) {
            if (object instanceof $root.response.PutChunk)
                return object;
            let message = new $root.response.PutChunk();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.uuid != null)
                if (typeof object.uuid === "string")
                    $util.base64.decode(object.uuid, message.uuid = $util.newBuffer($util.base64.length(object.uuid)), 0);
                else if (object.uuid.length >= 0)
                    message.uuid = object.uuid;
            if (object.chunk != null) {
                if (typeof object.chunk !== "object")
                    throw TypeError(".response.PutChunk.chunk: object expected");
                message.chunk = $root.response.Chunk.fromObject(object.chunk);
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a PutChunk message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.PutChunk
         * @static
         * @param {response.PutChunk} message PutChunk
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PutChunk.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.status = options.enums === String ? "SUCCESS" : 0;
                if (options.bytes === String)
                    object.uuid = "";
                else {
                    object.uuid = [];
                    if (options.bytes !== Array)
                        object.uuid = $util.newBuffer(object.uuid);
                }
                object.chunk = null;
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                object.uuid = options.bytes === String ? $util.base64.encode(message.uuid, 0, message.uuid.length) : options.bytes === Array ? Array.prototype.slice.call(message.uuid) : message.uuid;
            if (message.chunk != null && message.hasOwnProperty("chunk"))
                object.chunk = $root.response.Chunk.toObject(message.chunk, options);
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this PutChunk to JSON.
         * @function toJSON
         * @memberof response.PutChunk
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PutChunk.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for PutChunk
         * @function getTypeUrl
         * @memberof response.PutChunk
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        PutChunk.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.PutChunk";
        };

        return PutChunk;
    })();

    response.FinalizeWrite = (function() {

        /**
         * Properties of a FinalizeWrite.
         * @memberof response
         * @interface IFinalizeWrite
         * @property {response.Status|null} [status] FinalizeWrite status
         * @property {Uint8Array|null} [uuid] FinalizeWrite uuid
         * @property {string|null} [message] FinalizeWrite message
         */

        /**
         * Constructs a new FinalizeWrite.
         * @memberof response
         * @classdesc Represents a FinalizeWrite.
         * @implements IFinalizeWrite
         * @constructor
         * @param {response.IFinalizeWrite=} [properties] Properties to set
         */
        function FinalizeWrite(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * FinalizeWrite status.
         * @member {response.Status} status
         * @memberof response.FinalizeWrite
         * @instance
         */
        FinalizeWrite.prototype.status = 0;

        /**
         * FinalizeWrite uuid.
         * @member {Uint8Array} uuid
         * @memberof response.FinalizeWrite
         * @instance
         */
        FinalizeWrite.prototype.uuid = $util.newBuffer([]);

        /**
         * FinalizeWrite message.
         * @member {string|null|undefined} message
         * @memberof response.FinalizeWrite
         * @instance
         */
        FinalizeWrite.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(FinalizeWrite.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new FinalizeWrite instance using the specified properties.
         * @function create
         * @memberof response.FinalizeWrite
         * @static
         * @param {response.IFinalizeWrite=} [properties] Properties to set
         * @returns {response.FinalizeWrite} FinalizeWrite instance
         */
        FinalizeWrite.create = function create(properties) {
            return new FinalizeWrite(properties);
        };

        /**
         * Encodes the specified FinalizeWrite message. Does not implicitly {@link response.FinalizeWrite.verify|verify} messages.
         * @function encode
         * @memberof response.FinalizeWrite
         * @static
         * @param {response.IFinalizeWrite} message FinalizeWrite message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FinalizeWrite.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.uuid != null && Object.hasOwnProperty.call(message, "uuid"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.uuid);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified FinalizeWrite message, length delimited. Does not implicitly {@link response.FinalizeWrite.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.FinalizeWrite
         * @static
         * @param {response.IFinalizeWrite} message FinalizeWrite message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FinalizeWrite.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a FinalizeWrite message from the specified reader or buffer.
         * @function decode
         * @memberof response.FinalizeWrite
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.FinalizeWrite} FinalizeWrite
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FinalizeWrite.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.FinalizeWrite();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.uuid = reader.bytes();
                        break;
                    }
                case 4: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a FinalizeWrite message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.FinalizeWrite
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.FinalizeWrite} FinalizeWrite
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FinalizeWrite.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a FinalizeWrite message.
         * @function verify
         * @memberof response.FinalizeWrite
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        FinalizeWrite.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                if (!(message.uuid && typeof message.uuid.length === "number" || $util.isString(message.uuid)))
                    return "uuid: buffer expected";
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a FinalizeWrite message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.FinalizeWrite
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.FinalizeWrite} FinalizeWrite
         */
        FinalizeWrite.fromObject = function fromObject(object) {
            if (object instanceof $root.response.FinalizeWrite)
                return object;
            let message = new $root.response.FinalizeWrite();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.uuid != null)
                if (typeof object.uuid === "string")
                    $util.base64.decode(object.uuid, message.uuid = $util.newBuffer($util.base64.length(object.uuid)), 0);
                else if (object.uuid.length >= 0)
                    message.uuid = object.uuid;
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a FinalizeWrite message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.FinalizeWrite
         * @static
         * @param {response.FinalizeWrite} message FinalizeWrite
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FinalizeWrite.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.status = options.enums === String ? "SUCCESS" : 0;
                if (options.bytes === String)
                    object.uuid = "";
                else {
                    object.uuid = [];
                    if (options.bytes !== Array)
                        object.uuid = $util.newBuffer(object.uuid);
                }
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                object.uuid = options.bytes === String ? $util.base64.encode(message.uuid, 0, message.uuid.length) : options.bytes === Array ? Array.prototype.slice.call(message.uuid) : message.uuid;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this FinalizeWrite to JSON.
         * @function toJSON
         * @memberof response.FinalizeWrite
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FinalizeWrite.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for FinalizeWrite
         * @function getTypeUrl
         * @memberof response.FinalizeWrite
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        FinalizeWrite.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.FinalizeWrite";
        };

        return FinalizeWrite;
    })();

    response.Echo = (function() {

        /**
         * Properties of an Echo.
         * @memberof response
         * @interface IEcho
         * @property {number|Long|null} [flags] Echo flags
         * @property {Uint8Array|null} [data] Echo data
         */

        /**
         * Constructs a new Echo.
         * @memberof response
         * @classdesc Represents an Echo.
         * @implements IEcho
         * @constructor
         * @param {response.IEcho=} [properties] Properties to set
         */
        function Echo(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Echo flags.
         * @member {number|Long} flags
         * @memberof response.Echo
         * @instance
         */
        Echo.prototype.flags = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Echo data.
         * @member {Uint8Array|null|undefined} data
         * @memberof response.Echo
         * @instance
         */
        Echo.prototype.data = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(Echo.prototype, "_data", {
            get: $util.oneOfGetter($oneOfFields = ["data"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new Echo instance using the specified properties.
         * @function create
         * @memberof response.Echo
         * @static
         * @param {response.IEcho=} [properties] Properties to set
         * @returns {response.Echo} Echo instance
         */
        Echo.create = function create(properties) {
            return new Echo(properties);
        };

        /**
         * Encodes the specified Echo message. Does not implicitly {@link response.Echo.verify|verify} messages.
         * @function encode
         * @memberof response.Echo
         * @static
         * @param {response.IEcho} message Echo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Echo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.flags != null && Object.hasOwnProperty.call(message, "flags"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.flags);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.data);
            return writer;
        };

        /**
         * Encodes the specified Echo message, length delimited. Does not implicitly {@link response.Echo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.Echo
         * @static
         * @param {response.IEcho} message Echo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Echo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an Echo message from the specified reader or buffer.
         * @function decode
         * @memberof response.Echo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.Echo} Echo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Echo.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.Echo();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.flags = reader.uint64();
                        break;
                    }
                case 2: {
                        message.data = reader.bytes();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an Echo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.Echo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.Echo} Echo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Echo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an Echo message.
         * @function verify
         * @memberof response.Echo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Echo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.flags != null && message.hasOwnProperty("flags"))
                if (!$util.isInteger(message.flags) && !(message.flags && $util.isInteger(message.flags.low) && $util.isInteger(message.flags.high)))
                    return "flags: integer|Long expected";
            if (message.data != null && message.hasOwnProperty("data")) {
                properties._data = 1;
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            }
            return null;
        };

        /**
         * Creates an Echo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.Echo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.Echo} Echo
         */
        Echo.fromObject = function fromObject(object) {
            if (object instanceof $root.response.Echo)
                return object;
            let message = new $root.response.Echo();
            if (object.flags != null)
                if ($util.Long)
                    (message.flags = $util.Long.fromValue(object.flags)).unsigned = true;
                else if (typeof object.flags === "string")
                    message.flags = parseInt(object.flags, 10);
                else if (typeof object.flags === "number")
                    message.flags = object.flags;
                else if (typeof object.flags === "object")
                    message.flags = new $util.LongBits(object.flags.low >>> 0, object.flags.high >>> 0).toNumber(true);
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            return message;
        };

        /**
         * Creates a plain object from an Echo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.Echo
         * @static
         * @param {response.Echo} message Echo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Echo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.flags = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.flags = options.longs === String ? "0" : 0;
            if (message.flags != null && message.hasOwnProperty("flags"))
                if (typeof message.flags === "number")
                    object.flags = options.longs === String ? String(message.flags) : message.flags;
                else
                    object.flags = options.longs === String ? $util.Long.prototype.toString.call(message.flags) : options.longs === Number ? new $util.LongBits(message.flags.low >>> 0, message.flags.high >>> 0).toNumber(true) : message.flags;
            if (message.data != null && message.hasOwnProperty("data")) {
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
                if (options.oneofs)
                    object._data = "data";
            }
            return object;
        };

        /**
         * Converts this Echo to JSON.
         * @function toJSON
         * @memberof response.Echo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Echo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Echo
         * @function getTypeUrl
         * @memberof response.Echo
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Echo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.Echo";
        };

        return Echo;
    })();

    response.Child = (function() {

        /**
         * Properties of a Child.
         * @memberof response
         * @interface IChild
         * @property {boolean|null} [isFolder] Child isFolder
         * @property {Uint8Array|null} [uuid] Child uuid
         */

        /**
         * Constructs a new Child.
         * @memberof response
         * @classdesc Represents a Child.
         * @implements IChild
         * @constructor
         * @param {response.IChild=} [properties] Properties to set
         */
        function Child(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Child isFolder.
         * @member {boolean} isFolder
         * @memberof response.Child
         * @instance
         */
        Child.prototype.isFolder = false;

        /**
         * Child uuid.
         * @member {Uint8Array} uuid
         * @memberof response.Child
         * @instance
         */
        Child.prototype.uuid = $util.newBuffer([]);

        /**
         * Creates a new Child instance using the specified properties.
         * @function create
         * @memberof response.Child
         * @static
         * @param {response.IChild=} [properties] Properties to set
         * @returns {response.Child} Child instance
         */
        Child.create = function create(properties) {
            return new Child(properties);
        };

        /**
         * Encodes the specified Child message. Does not implicitly {@link response.Child.verify|verify} messages.
         * @function encode
         * @memberof response.Child
         * @static
         * @param {response.IChild} message Child message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Child.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.isFolder != null && Object.hasOwnProperty.call(message, "isFolder"))
                writer.uint32(/* id 1, wireType 0 =*/8).bool(message.isFolder);
            if (message.uuid != null && Object.hasOwnProperty.call(message, "uuid"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.uuid);
            return writer;
        };

        /**
         * Encodes the specified Child message, length delimited. Does not implicitly {@link response.Child.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.Child
         * @static
         * @param {response.IChild} message Child message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Child.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Child message from the specified reader or buffer.
         * @function decode
         * @memberof response.Child
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.Child} Child
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Child.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.Child();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.isFolder = reader.bool();
                        break;
                    }
                case 2: {
                        message.uuid = reader.bytes();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Child message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.Child
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.Child} Child
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Child.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Child message.
         * @function verify
         * @memberof response.Child
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Child.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.isFolder != null && message.hasOwnProperty("isFolder"))
                if (typeof message.isFolder !== "boolean")
                    return "isFolder: boolean expected";
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                if (!(message.uuid && typeof message.uuid.length === "number" || $util.isString(message.uuid)))
                    return "uuid: buffer expected";
            return null;
        };

        /**
         * Creates a Child message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.Child
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.Child} Child
         */
        Child.fromObject = function fromObject(object) {
            if (object instanceof $root.response.Child)
                return object;
            let message = new $root.response.Child();
            if (object.isFolder != null)
                message.isFolder = Boolean(object.isFolder);
            if (object.uuid != null)
                if (typeof object.uuid === "string")
                    $util.base64.decode(object.uuid, message.uuid = $util.newBuffer($util.base64.length(object.uuid)), 0);
                else if (object.uuid.length >= 0)
                    message.uuid = object.uuid;
            return message;
        };

        /**
         * Creates a plain object from a Child message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.Child
         * @static
         * @param {response.Child} message Child
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Child.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.isFolder = false;
                if (options.bytes === String)
                    object.uuid = "";
                else {
                    object.uuid = [];
                    if (options.bytes !== Array)
                        object.uuid = $util.newBuffer(object.uuid);
                }
            }
            if (message.isFolder != null && message.hasOwnProperty("isFolder"))
                object.isFolder = message.isFolder;
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                object.uuid = options.bytes === String ? $util.base64.encode(message.uuid, 0, message.uuid.length) : options.bytes === Array ? Array.prototype.slice.call(message.uuid) : message.uuid;
            return object;
        };

        /**
         * Converts this Child to JSON.
         * @function toJSON
         * @memberof response.Child
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Child.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Child
         * @function getTypeUrl
         * @memberof response.Child
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Child.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.Child";
        };

        return Child;
    })();

    response.FolderSnapshot = (function() {

        /**
         * Properties of a FolderSnapshot.
         * @memberof response
         * @interface IFolderSnapshot
         * @property {string|null} [id] FolderSnapshot id
         * @property {Uint8Array|null} [uuidOfClone] FolderSnapshot uuidOfClone
         * @property {number|Long|null} [creationDate] FolderSnapshot creationDate
         */

        /**
         * Constructs a new FolderSnapshot.
         * @memberof response
         * @classdesc Represents a FolderSnapshot.
         * @implements IFolderSnapshot
         * @constructor
         * @param {response.IFolderSnapshot=} [properties] Properties to set
         */
        function FolderSnapshot(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * FolderSnapshot id.
         * @member {string} id
         * @memberof response.FolderSnapshot
         * @instance
         */
        FolderSnapshot.prototype.id = "";

        /**
         * FolderSnapshot uuidOfClone.
         * @member {Uint8Array} uuidOfClone
         * @memberof response.FolderSnapshot
         * @instance
         */
        FolderSnapshot.prototype.uuidOfClone = $util.newBuffer([]);

        /**
         * FolderSnapshot creationDate.
         * @member {number|Long} creationDate
         * @memberof response.FolderSnapshot
         * @instance
         */
        FolderSnapshot.prototype.creationDate = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new FolderSnapshot instance using the specified properties.
         * @function create
         * @memberof response.FolderSnapshot
         * @static
         * @param {response.IFolderSnapshot=} [properties] Properties to set
         * @returns {response.FolderSnapshot} FolderSnapshot instance
         */
        FolderSnapshot.create = function create(properties) {
            return new FolderSnapshot(properties);
        };

        /**
         * Encodes the specified FolderSnapshot message. Does not implicitly {@link response.FolderSnapshot.verify|verify} messages.
         * @function encode
         * @memberof response.FolderSnapshot
         * @static
         * @param {response.IFolderSnapshot} message FolderSnapshot message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FolderSnapshot.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.uuidOfClone != null && Object.hasOwnProperty.call(message, "uuidOfClone"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.uuidOfClone);
            if (message.creationDate != null && Object.hasOwnProperty.call(message, "creationDate"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.creationDate);
            return writer;
        };

        /**
         * Encodes the specified FolderSnapshot message, length delimited. Does not implicitly {@link response.FolderSnapshot.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.FolderSnapshot
         * @static
         * @param {response.IFolderSnapshot} message FolderSnapshot message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FolderSnapshot.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a FolderSnapshot message from the specified reader or buffer.
         * @function decode
         * @memberof response.FolderSnapshot
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.FolderSnapshot} FolderSnapshot
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FolderSnapshot.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.FolderSnapshot();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.id = reader.string();
                        break;
                    }
                case 2: {
                        message.uuidOfClone = reader.bytes();
                        break;
                    }
                case 3: {
                        message.creationDate = reader.uint64();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a FolderSnapshot message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.FolderSnapshot
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.FolderSnapshot} FolderSnapshot
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FolderSnapshot.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a FolderSnapshot message.
         * @function verify
         * @memberof response.FolderSnapshot
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        FolderSnapshot.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.uuidOfClone != null && message.hasOwnProperty("uuidOfClone"))
                if (!(message.uuidOfClone && typeof message.uuidOfClone.length === "number" || $util.isString(message.uuidOfClone)))
                    return "uuidOfClone: buffer expected";
            if (message.creationDate != null && message.hasOwnProperty("creationDate"))
                if (!$util.isInteger(message.creationDate) && !(message.creationDate && $util.isInteger(message.creationDate.low) && $util.isInteger(message.creationDate.high)))
                    return "creationDate: integer|Long expected";
            return null;
        };

        /**
         * Creates a FolderSnapshot message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.FolderSnapshot
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.FolderSnapshot} FolderSnapshot
         */
        FolderSnapshot.fromObject = function fromObject(object) {
            if (object instanceof $root.response.FolderSnapshot)
                return object;
            let message = new $root.response.FolderSnapshot();
            if (object.id != null)
                message.id = String(object.id);
            if (object.uuidOfClone != null)
                if (typeof object.uuidOfClone === "string")
                    $util.base64.decode(object.uuidOfClone, message.uuidOfClone = $util.newBuffer($util.base64.length(object.uuidOfClone)), 0);
                else if (object.uuidOfClone.length >= 0)
                    message.uuidOfClone = object.uuidOfClone;
            if (object.creationDate != null)
                if ($util.Long)
                    (message.creationDate = $util.Long.fromValue(object.creationDate)).unsigned = true;
                else if (typeof object.creationDate === "string")
                    message.creationDate = parseInt(object.creationDate, 10);
                else if (typeof object.creationDate === "number")
                    message.creationDate = object.creationDate;
                else if (typeof object.creationDate === "object")
                    message.creationDate = new $util.LongBits(object.creationDate.low >>> 0, object.creationDate.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a FolderSnapshot message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.FolderSnapshot
         * @static
         * @param {response.FolderSnapshot} message FolderSnapshot
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FolderSnapshot.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.id = "";
                if (options.bytes === String)
                    object.uuidOfClone = "";
                else {
                    object.uuidOfClone = [];
                    if (options.bytes !== Array)
                        object.uuidOfClone = $util.newBuffer(object.uuidOfClone);
                }
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.creationDate = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.creationDate = options.longs === String ? "0" : 0;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.uuidOfClone != null && message.hasOwnProperty("uuidOfClone"))
                object.uuidOfClone = options.bytes === String ? $util.base64.encode(message.uuidOfClone, 0, message.uuidOfClone.length) : options.bytes === Array ? Array.prototype.slice.call(message.uuidOfClone) : message.uuidOfClone;
            if (message.creationDate != null && message.hasOwnProperty("creationDate"))
                if (typeof message.creationDate === "number")
                    object.creationDate = options.longs === String ? String(message.creationDate) : message.creationDate;
                else
                    object.creationDate = options.longs === String ? $util.Long.prototype.toString.call(message.creationDate) : options.longs === Number ? new $util.LongBits(message.creationDate.low >>> 0, message.creationDate.high >>> 0).toNumber(true) : message.creationDate;
            return object;
        };

        /**
         * Converts this FolderSnapshot to JSON.
         * @function toJSON
         * @memberof response.FolderSnapshot
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FolderSnapshot.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for FolderSnapshot
         * @function getTypeUrl
         * @memberof response.FolderSnapshot
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        FolderSnapshot.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.FolderSnapshot";
        };

        return FolderSnapshot;
    })();

    /**
     * OrderBy enum.
     * @name response.OrderBy
     * @enum {number}
     * @property {number} UPDATEDTIME=0 UPDATEDTIME value
     * @property {number} CREATEDTIME=1 CREATEDTIME value
     * @property {number} NAME=2 NAME value
     * @property {number} SIZE=3 SIZE value
     */
    response.OrderBy = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UPDATEDTIME"] = 0;
        values[valuesById[1] = "CREATEDTIME"] = 1;
        values[valuesById[2] = "NAME"] = 2;
        values[valuesById[3] = "SIZE"] = 3;
        return values;
    })();

    response.PageToken = (function() {

        /**
         * Properties of a PageToken.
         * @memberof response
         * @interface IPageToken
         * @property {number|Long|null} [ttl] PageToken ttl
         * @property {number|Long|null} [creationtime] PageToken creationtime
         * @property {number|Long|null} [pageSize] PageToken pageSize
         * @property {string|null} [email] PageToken email
         * @property {number|Long|null} [NumberOfChildren] PageToken NumberOfChildren
         * @property {response.OrderBy|null} [orderby] PageToken orderby
         * @property {number|Long|null} [lastSerialNumber] PageToken lastSerialNumber
         * @property {string|null} [lastName] PageToken lastName
         * @property {number|Long|null} [lastModifiedDate] PageToken lastModifiedDate
         * @property {number|Long|null} [lastSize] PageToken lastSize
         * @property {number|Long|null} [tieLastSerialNumber] PageToken tieLastSerialNumber
         */

        /**
         * Constructs a new PageToken.
         * @memberof response
         * @classdesc Represents a PageToken.
         * @implements IPageToken
         * @constructor
         * @param {response.IPageToken=} [properties] Properties to set
         */
        function PageToken(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PageToken ttl.
         * @member {number|Long} ttl
         * @memberof response.PageToken
         * @instance
         */
        PageToken.prototype.ttl = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * PageToken creationtime.
         * @member {number|Long} creationtime
         * @memberof response.PageToken
         * @instance
         */
        PageToken.prototype.creationtime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * PageToken pageSize.
         * @member {number|Long} pageSize
         * @memberof response.PageToken
         * @instance
         */
        PageToken.prototype.pageSize = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * PageToken email.
         * @member {string} email
         * @memberof response.PageToken
         * @instance
         */
        PageToken.prototype.email = "";

        /**
         * PageToken NumberOfChildren.
         * @member {number|Long} NumberOfChildren
         * @memberof response.PageToken
         * @instance
         */
        PageToken.prototype.NumberOfChildren = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * PageToken orderby.
         * @member {response.OrderBy} orderby
         * @memberof response.PageToken
         * @instance
         */
        PageToken.prototype.orderby = 0;

        /**
         * PageToken lastSerialNumber.
         * @member {number|Long|null|undefined} lastSerialNumber
         * @memberof response.PageToken
         * @instance
         */
        PageToken.prototype.lastSerialNumber = null;

        /**
         * PageToken lastName.
         * @member {string|null|undefined} lastName
         * @memberof response.PageToken
         * @instance
         */
        PageToken.prototype.lastName = null;

        /**
         * PageToken lastModifiedDate.
         * @member {number|Long|null|undefined} lastModifiedDate
         * @memberof response.PageToken
         * @instance
         */
        PageToken.prototype.lastModifiedDate = null;

        /**
         * PageToken lastSize.
         * @member {number|Long|null|undefined} lastSize
         * @memberof response.PageToken
         * @instance
         */
        PageToken.prototype.lastSize = null;

        /**
         * PageToken tieLastSerialNumber.
         * @member {number|Long|null|undefined} tieLastSerialNumber
         * @memberof response.PageToken
         * @instance
         */
        PageToken.prototype.tieLastSerialNumber = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * PageToken lastValue.
         * @member {"lastSerialNumber"|"lastName"|"lastModifiedDate"|"lastSize"|undefined} lastValue
         * @memberof response.PageToken
         * @instance
         */
        Object.defineProperty(PageToken.prototype, "lastValue", {
            get: $util.oneOfGetter($oneOfFields = ["lastSerialNumber", "lastName", "lastModifiedDate", "lastSize"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(PageToken.prototype, "_tieLastSerialNumber", {
            get: $util.oneOfGetter($oneOfFields = ["tieLastSerialNumber"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new PageToken instance using the specified properties.
         * @function create
         * @memberof response.PageToken
         * @static
         * @param {response.IPageToken=} [properties] Properties to set
         * @returns {response.PageToken} PageToken instance
         */
        PageToken.create = function create(properties) {
            return new PageToken(properties);
        };

        /**
         * Encodes the specified PageToken message. Does not implicitly {@link response.PageToken.verify|verify} messages.
         * @function encode
         * @memberof response.PageToken
         * @static
         * @param {response.IPageToken} message PageToken message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PageToken.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.ttl != null && Object.hasOwnProperty.call(message, "ttl"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.ttl);
            if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.pageSize);
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.email);
            if (message.creationtime != null && Object.hasOwnProperty.call(message, "creationtime"))
                writer.uint32(/* id 6, wireType 0 =*/48).uint64(message.creationtime);
            if (message.NumberOfChildren != null && Object.hasOwnProperty.call(message, "NumberOfChildren"))
                writer.uint32(/* id 8, wireType 0 =*/64).uint64(message.NumberOfChildren);
            if (message.orderby != null && Object.hasOwnProperty.call(message, "orderby"))
                writer.uint32(/* id 9, wireType 0 =*/72).int32(message.orderby);
            if (message.lastSerialNumber != null && Object.hasOwnProperty.call(message, "lastSerialNumber"))
                writer.uint32(/* id 10, wireType 0 =*/80).uint64(message.lastSerialNumber);
            if (message.lastName != null && Object.hasOwnProperty.call(message, "lastName"))
                writer.uint32(/* id 11, wireType 2 =*/90).string(message.lastName);
            if (message.lastModifiedDate != null && Object.hasOwnProperty.call(message, "lastModifiedDate"))
                writer.uint32(/* id 12, wireType 0 =*/96).uint64(message.lastModifiedDate);
            if (message.lastSize != null && Object.hasOwnProperty.call(message, "lastSize"))
                writer.uint32(/* id 13, wireType 0 =*/104).uint64(message.lastSize);
            if (message.tieLastSerialNumber != null && Object.hasOwnProperty.call(message, "tieLastSerialNumber"))
                writer.uint32(/* id 14, wireType 0 =*/112).uint64(message.tieLastSerialNumber);
            return writer;
        };

        /**
         * Encodes the specified PageToken message, length delimited. Does not implicitly {@link response.PageToken.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.PageToken
         * @static
         * @param {response.IPageToken} message PageToken message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PageToken.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PageToken message from the specified reader or buffer.
         * @function decode
         * @memberof response.PageToken
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.PageToken} PageToken
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PageToken.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.PageToken();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.ttl = reader.uint64();
                        break;
                    }
                case 6: {
                        message.creationtime = reader.uint64();
                        break;
                    }
                case 2: {
                        message.pageSize = reader.uint64();
                        break;
                    }
                case 5: {
                        message.email = reader.string();
                        break;
                    }
                case 8: {
                        message.NumberOfChildren = reader.uint64();
                        break;
                    }
                case 9: {
                        message.orderby = reader.int32();
                        break;
                    }
                case 10: {
                        message.lastSerialNumber = reader.uint64();
                        break;
                    }
                case 11: {
                        message.lastName = reader.string();
                        break;
                    }
                case 12: {
                        message.lastModifiedDate = reader.uint64();
                        break;
                    }
                case 13: {
                        message.lastSize = reader.uint64();
                        break;
                    }
                case 14: {
                        message.tieLastSerialNumber = reader.uint64();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PageToken message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.PageToken
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.PageToken} PageToken
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PageToken.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PageToken message.
         * @function verify
         * @memberof response.PageToken
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PageToken.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.ttl != null && message.hasOwnProperty("ttl"))
                if (!$util.isInteger(message.ttl) && !(message.ttl && $util.isInteger(message.ttl.low) && $util.isInteger(message.ttl.high)))
                    return "ttl: integer|Long expected";
            if (message.creationtime != null && message.hasOwnProperty("creationtime"))
                if (!$util.isInteger(message.creationtime) && !(message.creationtime && $util.isInteger(message.creationtime.low) && $util.isInteger(message.creationtime.high)))
                    return "creationtime: integer|Long expected";
            if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                if (!$util.isInteger(message.pageSize) && !(message.pageSize && $util.isInteger(message.pageSize.low) && $util.isInteger(message.pageSize.high)))
                    return "pageSize: integer|Long expected";
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            if (message.NumberOfChildren != null && message.hasOwnProperty("NumberOfChildren"))
                if (!$util.isInteger(message.NumberOfChildren) && !(message.NumberOfChildren && $util.isInteger(message.NumberOfChildren.low) && $util.isInteger(message.NumberOfChildren.high)))
                    return "NumberOfChildren: integer|Long expected";
            if (message.orderby != null && message.hasOwnProperty("orderby"))
                switch (message.orderby) {
                default:
                    return "orderby: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            if (message.lastSerialNumber != null && message.hasOwnProperty("lastSerialNumber")) {
                properties.lastValue = 1;
                if (!$util.isInteger(message.lastSerialNumber) && !(message.lastSerialNumber && $util.isInteger(message.lastSerialNumber.low) && $util.isInteger(message.lastSerialNumber.high)))
                    return "lastSerialNumber: integer|Long expected";
            }
            if (message.lastName != null && message.hasOwnProperty("lastName")) {
                if (properties.lastValue === 1)
                    return "lastValue: multiple values";
                properties.lastValue = 1;
                if (!$util.isString(message.lastName))
                    return "lastName: string expected";
            }
            if (message.lastModifiedDate != null && message.hasOwnProperty("lastModifiedDate")) {
                if (properties.lastValue === 1)
                    return "lastValue: multiple values";
                properties.lastValue = 1;
                if (!$util.isInteger(message.lastModifiedDate) && !(message.lastModifiedDate && $util.isInteger(message.lastModifiedDate.low) && $util.isInteger(message.lastModifiedDate.high)))
                    return "lastModifiedDate: integer|Long expected";
            }
            if (message.lastSize != null && message.hasOwnProperty("lastSize")) {
                if (properties.lastValue === 1)
                    return "lastValue: multiple values";
                properties.lastValue = 1;
                if (!$util.isInteger(message.lastSize) && !(message.lastSize && $util.isInteger(message.lastSize.low) && $util.isInteger(message.lastSize.high)))
                    return "lastSize: integer|Long expected";
            }
            if (message.tieLastSerialNumber != null && message.hasOwnProperty("tieLastSerialNumber")) {
                properties._tieLastSerialNumber = 1;
                if (!$util.isInteger(message.tieLastSerialNumber) && !(message.tieLastSerialNumber && $util.isInteger(message.tieLastSerialNumber.low) && $util.isInteger(message.tieLastSerialNumber.high)))
                    return "tieLastSerialNumber: integer|Long expected";
            }
            return null;
        };

        /**
         * Creates a PageToken message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.PageToken
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.PageToken} PageToken
         */
        PageToken.fromObject = function fromObject(object) {
            if (object instanceof $root.response.PageToken)
                return object;
            let message = new $root.response.PageToken();
            if (object.ttl != null)
                if ($util.Long)
                    (message.ttl = $util.Long.fromValue(object.ttl)).unsigned = true;
                else if (typeof object.ttl === "string")
                    message.ttl = parseInt(object.ttl, 10);
                else if (typeof object.ttl === "number")
                    message.ttl = object.ttl;
                else if (typeof object.ttl === "object")
                    message.ttl = new $util.LongBits(object.ttl.low >>> 0, object.ttl.high >>> 0).toNumber(true);
            if (object.creationtime != null)
                if ($util.Long)
                    (message.creationtime = $util.Long.fromValue(object.creationtime)).unsigned = true;
                else if (typeof object.creationtime === "string")
                    message.creationtime = parseInt(object.creationtime, 10);
                else if (typeof object.creationtime === "number")
                    message.creationtime = object.creationtime;
                else if (typeof object.creationtime === "object")
                    message.creationtime = new $util.LongBits(object.creationtime.low >>> 0, object.creationtime.high >>> 0).toNumber(true);
            if (object.pageSize != null)
                if ($util.Long)
                    (message.pageSize = $util.Long.fromValue(object.pageSize)).unsigned = true;
                else if (typeof object.pageSize === "string")
                    message.pageSize = parseInt(object.pageSize, 10);
                else if (typeof object.pageSize === "number")
                    message.pageSize = object.pageSize;
                else if (typeof object.pageSize === "object")
                    message.pageSize = new $util.LongBits(object.pageSize.low >>> 0, object.pageSize.high >>> 0).toNumber(true);
            if (object.email != null)
                message.email = String(object.email);
            if (object.NumberOfChildren != null)
                if ($util.Long)
                    (message.NumberOfChildren = $util.Long.fromValue(object.NumberOfChildren)).unsigned = true;
                else if (typeof object.NumberOfChildren === "string")
                    message.NumberOfChildren = parseInt(object.NumberOfChildren, 10);
                else if (typeof object.NumberOfChildren === "number")
                    message.NumberOfChildren = object.NumberOfChildren;
                else if (typeof object.NumberOfChildren === "object")
                    message.NumberOfChildren = new $util.LongBits(object.NumberOfChildren.low >>> 0, object.NumberOfChildren.high >>> 0).toNumber(true);
            switch (object.orderby) {
            default:
                if (typeof object.orderby === "number") {
                    message.orderby = object.orderby;
                    break;
                }
                break;
            case "UPDATEDTIME":
            case 0:
                message.orderby = 0;
                break;
            case "CREATEDTIME":
            case 1:
                message.orderby = 1;
                break;
            case "NAME":
            case 2:
                message.orderby = 2;
                break;
            case "SIZE":
            case 3:
                message.orderby = 3;
                break;
            }
            if (object.lastSerialNumber != null)
                if ($util.Long)
                    (message.lastSerialNumber = $util.Long.fromValue(object.lastSerialNumber)).unsigned = true;
                else if (typeof object.lastSerialNumber === "string")
                    message.lastSerialNumber = parseInt(object.lastSerialNumber, 10);
                else if (typeof object.lastSerialNumber === "number")
                    message.lastSerialNumber = object.lastSerialNumber;
                else if (typeof object.lastSerialNumber === "object")
                    message.lastSerialNumber = new $util.LongBits(object.lastSerialNumber.low >>> 0, object.lastSerialNumber.high >>> 0).toNumber(true);
            if (object.lastName != null)
                message.lastName = String(object.lastName);
            if (object.lastModifiedDate != null)
                if ($util.Long)
                    (message.lastModifiedDate = $util.Long.fromValue(object.lastModifiedDate)).unsigned = true;
                else if (typeof object.lastModifiedDate === "string")
                    message.lastModifiedDate = parseInt(object.lastModifiedDate, 10);
                else if (typeof object.lastModifiedDate === "number")
                    message.lastModifiedDate = object.lastModifiedDate;
                else if (typeof object.lastModifiedDate === "object")
                    message.lastModifiedDate = new $util.LongBits(object.lastModifiedDate.low >>> 0, object.lastModifiedDate.high >>> 0).toNumber(true);
            if (object.lastSize != null)
                if ($util.Long)
                    (message.lastSize = $util.Long.fromValue(object.lastSize)).unsigned = true;
                else if (typeof object.lastSize === "string")
                    message.lastSize = parseInt(object.lastSize, 10);
                else if (typeof object.lastSize === "number")
                    message.lastSize = object.lastSize;
                else if (typeof object.lastSize === "object")
                    message.lastSize = new $util.LongBits(object.lastSize.low >>> 0, object.lastSize.high >>> 0).toNumber(true);
            if (object.tieLastSerialNumber != null)
                if ($util.Long)
                    (message.tieLastSerialNumber = $util.Long.fromValue(object.tieLastSerialNumber)).unsigned = true;
                else if (typeof object.tieLastSerialNumber === "string")
                    message.tieLastSerialNumber = parseInt(object.tieLastSerialNumber, 10);
                else if (typeof object.tieLastSerialNumber === "number")
                    message.tieLastSerialNumber = object.tieLastSerialNumber;
                else if (typeof object.tieLastSerialNumber === "object")
                    message.tieLastSerialNumber = new $util.LongBits(object.tieLastSerialNumber.low >>> 0, object.tieLastSerialNumber.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a PageToken message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.PageToken
         * @static
         * @param {response.PageToken} message PageToken
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PageToken.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.ttl = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.ttl = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.pageSize = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.pageSize = options.longs === String ? "0" : 0;
                object.email = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.creationtime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.creationtime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.NumberOfChildren = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.NumberOfChildren = options.longs === String ? "0" : 0;
                object.orderby = options.enums === String ? "UPDATEDTIME" : 0;
            }
            if (message.ttl != null && message.hasOwnProperty("ttl"))
                if (typeof message.ttl === "number")
                    object.ttl = options.longs === String ? String(message.ttl) : message.ttl;
                else
                    object.ttl = options.longs === String ? $util.Long.prototype.toString.call(message.ttl) : options.longs === Number ? new $util.LongBits(message.ttl.low >>> 0, message.ttl.high >>> 0).toNumber(true) : message.ttl;
            if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                if (typeof message.pageSize === "number")
                    object.pageSize = options.longs === String ? String(message.pageSize) : message.pageSize;
                else
                    object.pageSize = options.longs === String ? $util.Long.prototype.toString.call(message.pageSize) : options.longs === Number ? new $util.LongBits(message.pageSize.low >>> 0, message.pageSize.high >>> 0).toNumber(true) : message.pageSize;
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.creationtime != null && message.hasOwnProperty("creationtime"))
                if (typeof message.creationtime === "number")
                    object.creationtime = options.longs === String ? String(message.creationtime) : message.creationtime;
                else
                    object.creationtime = options.longs === String ? $util.Long.prototype.toString.call(message.creationtime) : options.longs === Number ? new $util.LongBits(message.creationtime.low >>> 0, message.creationtime.high >>> 0).toNumber(true) : message.creationtime;
            if (message.NumberOfChildren != null && message.hasOwnProperty("NumberOfChildren"))
                if (typeof message.NumberOfChildren === "number")
                    object.NumberOfChildren = options.longs === String ? String(message.NumberOfChildren) : message.NumberOfChildren;
                else
                    object.NumberOfChildren = options.longs === String ? $util.Long.prototype.toString.call(message.NumberOfChildren) : options.longs === Number ? new $util.LongBits(message.NumberOfChildren.low >>> 0, message.NumberOfChildren.high >>> 0).toNumber(true) : message.NumberOfChildren;
            if (message.orderby != null && message.hasOwnProperty("orderby"))
                object.orderby = options.enums === String ? $root.response.OrderBy[message.orderby] === undefined ? message.orderby : $root.response.OrderBy[message.orderby] : message.orderby;
            if (message.lastSerialNumber != null && message.hasOwnProperty("lastSerialNumber")) {
                if (typeof message.lastSerialNumber === "number")
                    object.lastSerialNumber = options.longs === String ? String(message.lastSerialNumber) : message.lastSerialNumber;
                else
                    object.lastSerialNumber = options.longs === String ? $util.Long.prototype.toString.call(message.lastSerialNumber) : options.longs === Number ? new $util.LongBits(message.lastSerialNumber.low >>> 0, message.lastSerialNumber.high >>> 0).toNumber(true) : message.lastSerialNumber;
                if (options.oneofs)
                    object.lastValue = "lastSerialNumber";
            }
            if (message.lastName != null && message.hasOwnProperty("lastName")) {
                object.lastName = message.lastName;
                if (options.oneofs)
                    object.lastValue = "lastName";
            }
            if (message.lastModifiedDate != null && message.hasOwnProperty("lastModifiedDate")) {
                if (typeof message.lastModifiedDate === "number")
                    object.lastModifiedDate = options.longs === String ? String(message.lastModifiedDate) : message.lastModifiedDate;
                else
                    object.lastModifiedDate = options.longs === String ? $util.Long.prototype.toString.call(message.lastModifiedDate) : options.longs === Number ? new $util.LongBits(message.lastModifiedDate.low >>> 0, message.lastModifiedDate.high >>> 0).toNumber(true) : message.lastModifiedDate;
                if (options.oneofs)
                    object.lastValue = "lastModifiedDate";
            }
            if (message.lastSize != null && message.hasOwnProperty("lastSize")) {
                if (typeof message.lastSize === "number")
                    object.lastSize = options.longs === String ? String(message.lastSize) : message.lastSize;
                else
                    object.lastSize = options.longs === String ? $util.Long.prototype.toString.call(message.lastSize) : options.longs === Number ? new $util.LongBits(message.lastSize.low >>> 0, message.lastSize.high >>> 0).toNumber(true) : message.lastSize;
                if (options.oneofs)
                    object.lastValue = "lastSize";
            }
            if (message.tieLastSerialNumber != null && message.hasOwnProperty("tieLastSerialNumber")) {
                if (typeof message.tieLastSerialNumber === "number")
                    object.tieLastSerialNumber = options.longs === String ? String(message.tieLastSerialNumber) : message.tieLastSerialNumber;
                else
                    object.tieLastSerialNumber = options.longs === String ? $util.Long.prototype.toString.call(message.tieLastSerialNumber) : options.longs === Number ? new $util.LongBits(message.tieLastSerialNumber.low >>> 0, message.tieLastSerialNumber.high >>> 0).toNumber(true) : message.tieLastSerialNumber;
                if (options.oneofs)
                    object._tieLastSerialNumber = "tieLastSerialNumber";
            }
            return object;
        };

        /**
         * Converts this PageToken to JSON.
         * @function toJSON
         * @memberof response.PageToken
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PageToken.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for PageToken
         * @function getTypeUrl
         * @memberof response.PageToken
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        PageToken.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.PageToken";
        };

        return PageToken;
    })();

    response.PinInList = (function() {

        /**
         * Properties of a PinInList.
         * @memberof response
         * @interface IPinInList
         * @property {string|null} [name] PinInList name
         * @property {number|Long|null} [creationTime] PinInList creationTime
         * @property {number|Long|null} [ttl] PinInList ttl
         * @property {Array.<number>|null} [allowedPinOps] PinInList allowedPinOps
         * @property {string|null} [client] PinInList client
         * @property {Uint8Array|null} [idToClient] PinInList idToClient
         */

        /**
         * Constructs a new PinInList.
         * @memberof response
         * @classdesc Represents a PinInList.
         * @implements IPinInList
         * @constructor
         * @param {response.IPinInList=} [properties] Properties to set
         */
        function PinInList(properties) {
            this.allowedPinOps = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PinInList name.
         * @member {string} name
         * @memberof response.PinInList
         * @instance
         */
        PinInList.prototype.name = "";

        /**
         * PinInList creationTime.
         * @member {number|Long} creationTime
         * @memberof response.PinInList
         * @instance
         */
        PinInList.prototype.creationTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * PinInList ttl.
         * @member {number|Long} ttl
         * @memberof response.PinInList
         * @instance
         */
        PinInList.prototype.ttl = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * PinInList allowedPinOps.
         * @member {Array.<number>} allowedPinOps
         * @memberof response.PinInList
         * @instance
         */
        PinInList.prototype.allowedPinOps = $util.emptyArray;

        /**
         * PinInList client.
         * @member {string} client
         * @memberof response.PinInList
         * @instance
         */
        PinInList.prototype.client = "";

        /**
         * PinInList idToClient.
         * @member {Uint8Array} idToClient
         * @memberof response.PinInList
         * @instance
         */
        PinInList.prototype.idToClient = $util.newBuffer([]);

        /**
         * Creates a new PinInList instance using the specified properties.
         * @function create
         * @memberof response.PinInList
         * @static
         * @param {response.IPinInList=} [properties] Properties to set
         * @returns {response.PinInList} PinInList instance
         */
        PinInList.create = function create(properties) {
            return new PinInList(properties);
        };

        /**
         * Encodes the specified PinInList message. Does not implicitly {@link response.PinInList.verify|verify} messages.
         * @function encode
         * @memberof response.PinInList
         * @static
         * @param {response.IPinInList} message PinInList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PinInList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
            if (message.creationTime != null && Object.hasOwnProperty.call(message, "creationTime"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.creationTime);
            if (message.ttl != null && Object.hasOwnProperty.call(message, "ttl"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.ttl);
            if (message.allowedPinOps != null && message.allowedPinOps.length) {
                writer.uint32(/* id 4, wireType 2 =*/34).fork();
                for (let i = 0; i < message.allowedPinOps.length; ++i)
                    writer.int32(message.allowedPinOps[i]);
                writer.ldelim();
            }
            if (message.client != null && Object.hasOwnProperty.call(message, "client"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.client);
            if (message.idToClient != null && Object.hasOwnProperty.call(message, "idToClient"))
                writer.uint32(/* id 6, wireType 2 =*/50).bytes(message.idToClient);
            return writer;
        };

        /**
         * Encodes the specified PinInList message, length delimited. Does not implicitly {@link response.PinInList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.PinInList
         * @static
         * @param {response.IPinInList} message PinInList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PinInList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PinInList message from the specified reader or buffer.
         * @function decode
         * @memberof response.PinInList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.PinInList} PinInList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PinInList.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.PinInList();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.name = reader.string();
                        break;
                    }
                case 2: {
                        message.creationTime = reader.uint64();
                        break;
                    }
                case 3: {
                        message.ttl = reader.uint64();
                        break;
                    }
                case 4: {
                        if (!(message.allowedPinOps && message.allowedPinOps.length))
                            message.allowedPinOps = [];
                        if ((tag & 7) === 2) {
                            let end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.allowedPinOps.push(reader.int32());
                        } else
                            message.allowedPinOps.push(reader.int32());
                        break;
                    }
                case 5: {
                        message.client = reader.string();
                        break;
                    }
                case 6: {
                        message.idToClient = reader.bytes();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PinInList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.PinInList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.PinInList} PinInList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PinInList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PinInList message.
         * @function verify
         * @memberof response.PinInList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PinInList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.creationTime != null && message.hasOwnProperty("creationTime"))
                if (!$util.isInteger(message.creationTime) && !(message.creationTime && $util.isInteger(message.creationTime.low) && $util.isInteger(message.creationTime.high)))
                    return "creationTime: integer|Long expected";
            if (message.ttl != null && message.hasOwnProperty("ttl"))
                if (!$util.isInteger(message.ttl) && !(message.ttl && $util.isInteger(message.ttl.low) && $util.isInteger(message.ttl.high)))
                    return "ttl: integer|Long expected";
            if (message.allowedPinOps != null && message.hasOwnProperty("allowedPinOps")) {
                if (!Array.isArray(message.allowedPinOps))
                    return "allowedPinOps: array expected";
                for (let i = 0; i < message.allowedPinOps.length; ++i)
                    if (!$util.isInteger(message.allowedPinOps[i]))
                        return "allowedPinOps: integer[] expected";
            }
            if (message.client != null && message.hasOwnProperty("client"))
                if (!$util.isString(message.client))
                    return "client: string expected";
            if (message.idToClient != null && message.hasOwnProperty("idToClient"))
                if (!(message.idToClient && typeof message.idToClient.length === "number" || $util.isString(message.idToClient)))
                    return "idToClient: buffer expected";
            return null;
        };

        /**
         * Creates a PinInList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.PinInList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.PinInList} PinInList
         */
        PinInList.fromObject = function fromObject(object) {
            if (object instanceof $root.response.PinInList)
                return object;
            let message = new $root.response.PinInList();
            if (object.name != null)
                message.name = String(object.name);
            if (object.creationTime != null)
                if ($util.Long)
                    (message.creationTime = $util.Long.fromValue(object.creationTime)).unsigned = true;
                else if (typeof object.creationTime === "string")
                    message.creationTime = parseInt(object.creationTime, 10);
                else if (typeof object.creationTime === "number")
                    message.creationTime = object.creationTime;
                else if (typeof object.creationTime === "object")
                    message.creationTime = new $util.LongBits(object.creationTime.low >>> 0, object.creationTime.high >>> 0).toNumber(true);
            if (object.ttl != null)
                if ($util.Long)
                    (message.ttl = $util.Long.fromValue(object.ttl)).unsigned = true;
                else if (typeof object.ttl === "string")
                    message.ttl = parseInt(object.ttl, 10);
                else if (typeof object.ttl === "number")
                    message.ttl = object.ttl;
                else if (typeof object.ttl === "object")
                    message.ttl = new $util.LongBits(object.ttl.low >>> 0, object.ttl.high >>> 0).toNumber(true);
            if (object.allowedPinOps) {
                if (!Array.isArray(object.allowedPinOps))
                    throw TypeError(".response.PinInList.allowedPinOps: array expected");
                message.allowedPinOps = [];
                for (let i = 0; i < object.allowedPinOps.length; ++i)
                    message.allowedPinOps[i] = object.allowedPinOps[i] | 0;
            }
            if (object.client != null)
                message.client = String(object.client);
            if (object.idToClient != null)
                if (typeof object.idToClient === "string")
                    $util.base64.decode(object.idToClient, message.idToClient = $util.newBuffer($util.base64.length(object.idToClient)), 0);
                else if (object.idToClient.length >= 0)
                    message.idToClient = object.idToClient;
            return message;
        };

        /**
         * Creates a plain object from a PinInList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.PinInList
         * @static
         * @param {response.PinInList} message PinInList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PinInList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.allowedPinOps = [];
            if (options.defaults) {
                object.name = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.creationTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.creationTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.ttl = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.ttl = options.longs === String ? "0" : 0;
                object.client = "";
                if (options.bytes === String)
                    object.idToClient = "";
                else {
                    object.idToClient = [];
                    if (options.bytes !== Array)
                        object.idToClient = $util.newBuffer(object.idToClient);
                }
            }
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.creationTime != null && message.hasOwnProperty("creationTime"))
                if (typeof message.creationTime === "number")
                    object.creationTime = options.longs === String ? String(message.creationTime) : message.creationTime;
                else
                    object.creationTime = options.longs === String ? $util.Long.prototype.toString.call(message.creationTime) : options.longs === Number ? new $util.LongBits(message.creationTime.low >>> 0, message.creationTime.high >>> 0).toNumber(true) : message.creationTime;
            if (message.ttl != null && message.hasOwnProperty("ttl"))
                if (typeof message.ttl === "number")
                    object.ttl = options.longs === String ? String(message.ttl) : message.ttl;
                else
                    object.ttl = options.longs === String ? $util.Long.prototype.toString.call(message.ttl) : options.longs === Number ? new $util.LongBits(message.ttl.low >>> 0, message.ttl.high >>> 0).toNumber(true) : message.ttl;
            if (message.allowedPinOps && message.allowedPinOps.length) {
                object.allowedPinOps = [];
                for (let j = 0; j < message.allowedPinOps.length; ++j)
                    object.allowedPinOps[j] = message.allowedPinOps[j];
            }
            if (message.client != null && message.hasOwnProperty("client"))
                object.client = message.client;
            if (message.idToClient != null && message.hasOwnProperty("idToClient"))
                object.idToClient = options.bytes === String ? $util.base64.encode(message.idToClient, 0, message.idToClient.length) : options.bytes === Array ? Array.prototype.slice.call(message.idToClient) : message.idToClient;
            return object;
        };

        /**
         * Converts this PinInList to JSON.
         * @function toJSON
         * @memberof response.PinInList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PinInList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for PinInList
         * @function getTypeUrl
         * @memberof response.PinInList
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        PinInList.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.PinInList";
        };

        return PinInList;
    })();

    response.Name = (function() {

        /**
         * Properties of a Name.
         * @memberof response
         * @interface IName
         * @property {string|null} [name] Name name
         */

        /**
         * Constructs a new Name.
         * @memberof response
         * @classdesc Represents a Name.
         * @implements IName
         * @constructor
         * @param {response.IName=} [properties] Properties to set
         */
        function Name(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Name name.
         * @member {string} name
         * @memberof response.Name
         * @instance
         */
        Name.prototype.name = "";

        /**
         * Creates a new Name instance using the specified properties.
         * @function create
         * @memberof response.Name
         * @static
         * @param {response.IName=} [properties] Properties to set
         * @returns {response.Name} Name instance
         */
        Name.create = function create(properties) {
            return new Name(properties);
        };

        /**
         * Encodes the specified Name message. Does not implicitly {@link response.Name.verify|verify} messages.
         * @function encode
         * @memberof response.Name
         * @static
         * @param {response.IName} message Name message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Name.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
            return writer;
        };

        /**
         * Encodes the specified Name message, length delimited. Does not implicitly {@link response.Name.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.Name
         * @static
         * @param {response.IName} message Name message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Name.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Name message from the specified reader or buffer.
         * @function decode
         * @memberof response.Name
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.Name} Name
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Name.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.Name();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.name = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Name message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.Name
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.Name} Name
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Name.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Name message.
         * @function verify
         * @memberof response.Name
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Name.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            return null;
        };

        /**
         * Creates a Name message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.Name
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.Name} Name
         */
        Name.fromObject = function fromObject(object) {
            if (object instanceof $root.response.Name)
                return object;
            let message = new $root.response.Name();
            if (object.name != null)
                message.name = String(object.name);
            return message;
        };

        /**
         * Creates a plain object from a Name message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.Name
         * @static
         * @param {response.Name} message Name
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Name.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.name = "";
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            return object;
        };

        /**
         * Converts this Name to JSON.
         * @function toJSON
         * @memberof response.Name
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Name.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Name
         * @function getTypeUrl
         * @memberof response.Name
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Name.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.Name";
        };

        return Name;
    })();

    response.MetaObj = (function() {

        /**
         * Properties of a MetaObj.
         * @memberof response
         * @interface IMetaObj
         * @property {response.IFile|null} [fileMeta] MetaObj fileMeta
         * @property {response.IFolder|null} [folderMeta] MetaObj folderMeta
         * @property {response.IChunk|null} [chunkMeta] MetaObj chunkMeta
         * @property {response.IAuditLog|null} [auditLogMeta] MetaObj auditLogMeta
         * @property {response.IName|null} [nameMeta] MetaObj nameMeta
         */

        /**
         * Constructs a new MetaObj.
         * @memberof response
         * @classdesc Represents a MetaObj.
         * @implements IMetaObj
         * @constructor
         * @param {response.IMetaObj=} [properties] Properties to set
         */
        function MetaObj(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MetaObj fileMeta.
         * @member {response.IFile|null|undefined} fileMeta
         * @memberof response.MetaObj
         * @instance
         */
        MetaObj.prototype.fileMeta = null;

        /**
         * MetaObj folderMeta.
         * @member {response.IFolder|null|undefined} folderMeta
         * @memberof response.MetaObj
         * @instance
         */
        MetaObj.prototype.folderMeta = null;

        /**
         * MetaObj chunkMeta.
         * @member {response.IChunk|null|undefined} chunkMeta
         * @memberof response.MetaObj
         * @instance
         */
        MetaObj.prototype.chunkMeta = null;

        /**
         * MetaObj auditLogMeta.
         * @member {response.IAuditLog|null|undefined} auditLogMeta
         * @memberof response.MetaObj
         * @instance
         */
        MetaObj.prototype.auditLogMeta = null;

        /**
         * MetaObj nameMeta.
         * @member {response.IName|null|undefined} nameMeta
         * @memberof response.MetaObj
         * @instance
         */
        MetaObj.prototype.nameMeta = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * MetaObj meta.
         * @member {"fileMeta"|"folderMeta"|"chunkMeta"|"auditLogMeta"|"nameMeta"|undefined} meta
         * @memberof response.MetaObj
         * @instance
         */
        Object.defineProperty(MetaObj.prototype, "meta", {
            get: $util.oneOfGetter($oneOfFields = ["fileMeta", "folderMeta", "chunkMeta", "auditLogMeta", "nameMeta"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new MetaObj instance using the specified properties.
         * @function create
         * @memberof response.MetaObj
         * @static
         * @param {response.IMetaObj=} [properties] Properties to set
         * @returns {response.MetaObj} MetaObj instance
         */
        MetaObj.create = function create(properties) {
            return new MetaObj(properties);
        };

        /**
         * Encodes the specified MetaObj message. Does not implicitly {@link response.MetaObj.verify|verify} messages.
         * @function encode
         * @memberof response.MetaObj
         * @static
         * @param {response.IMetaObj} message MetaObj message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MetaObj.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.fileMeta != null && Object.hasOwnProperty.call(message, "fileMeta"))
                $root.response.File.encode(message.fileMeta, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.folderMeta != null && Object.hasOwnProperty.call(message, "folderMeta"))
                $root.response.Folder.encode(message.folderMeta, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.chunkMeta != null && Object.hasOwnProperty.call(message, "chunkMeta"))
                $root.response.Chunk.encode(message.chunkMeta, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.auditLogMeta != null && Object.hasOwnProperty.call(message, "auditLogMeta"))
                $root.response.AuditLog.encode(message.auditLogMeta, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            if (message.nameMeta != null && Object.hasOwnProperty.call(message, "nameMeta"))
                $root.response.Name.encode(message.nameMeta, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified MetaObj message, length delimited. Does not implicitly {@link response.MetaObj.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.MetaObj
         * @static
         * @param {response.IMetaObj} message MetaObj message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MetaObj.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MetaObj message from the specified reader or buffer.
         * @function decode
         * @memberof response.MetaObj
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.MetaObj} MetaObj
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MetaObj.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.MetaObj();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.fileMeta = $root.response.File.decode(reader, reader.uint32());
                        break;
                    }
                case 2: {
                        message.folderMeta = $root.response.Folder.decode(reader, reader.uint32());
                        break;
                    }
                case 3: {
                        message.chunkMeta = $root.response.Chunk.decode(reader, reader.uint32());
                        break;
                    }
                case 4: {
                        message.auditLogMeta = $root.response.AuditLog.decode(reader, reader.uint32());
                        break;
                    }
                case 6: {
                        message.nameMeta = $root.response.Name.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MetaObj message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.MetaObj
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.MetaObj} MetaObj
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MetaObj.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MetaObj message.
         * @function verify
         * @memberof response.MetaObj
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MetaObj.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.fileMeta != null && message.hasOwnProperty("fileMeta")) {
                properties.meta = 1;
                {
                    let error = $root.response.File.verify(message.fileMeta);
                    if (error)
                        return "fileMeta." + error;
                }
            }
            if (message.folderMeta != null && message.hasOwnProperty("folderMeta")) {
                if (properties.meta === 1)
                    return "meta: multiple values";
                properties.meta = 1;
                {
                    let error = $root.response.Folder.verify(message.folderMeta);
                    if (error)
                        return "folderMeta." + error;
                }
            }
            if (message.chunkMeta != null && message.hasOwnProperty("chunkMeta")) {
                if (properties.meta === 1)
                    return "meta: multiple values";
                properties.meta = 1;
                {
                    let error = $root.response.Chunk.verify(message.chunkMeta);
                    if (error)
                        return "chunkMeta." + error;
                }
            }
            if (message.auditLogMeta != null && message.hasOwnProperty("auditLogMeta")) {
                if (properties.meta === 1)
                    return "meta: multiple values";
                properties.meta = 1;
                {
                    let error = $root.response.AuditLog.verify(message.auditLogMeta);
                    if (error)
                        return "auditLogMeta." + error;
                }
            }
            if (message.nameMeta != null && message.hasOwnProperty("nameMeta")) {
                if (properties.meta === 1)
                    return "meta: multiple values";
                properties.meta = 1;
                {
                    let error = $root.response.Name.verify(message.nameMeta);
                    if (error)
                        return "nameMeta." + error;
                }
            }
            return null;
        };

        /**
         * Creates a MetaObj message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.MetaObj
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.MetaObj} MetaObj
         */
        MetaObj.fromObject = function fromObject(object) {
            if (object instanceof $root.response.MetaObj)
                return object;
            let message = new $root.response.MetaObj();
            if (object.fileMeta != null) {
                if (typeof object.fileMeta !== "object")
                    throw TypeError(".response.MetaObj.fileMeta: object expected");
                message.fileMeta = $root.response.File.fromObject(object.fileMeta);
            }
            if (object.folderMeta != null) {
                if (typeof object.folderMeta !== "object")
                    throw TypeError(".response.MetaObj.folderMeta: object expected");
                message.folderMeta = $root.response.Folder.fromObject(object.folderMeta);
            }
            if (object.chunkMeta != null) {
                if (typeof object.chunkMeta !== "object")
                    throw TypeError(".response.MetaObj.chunkMeta: object expected");
                message.chunkMeta = $root.response.Chunk.fromObject(object.chunkMeta);
            }
            if (object.auditLogMeta != null) {
                if (typeof object.auditLogMeta !== "object")
                    throw TypeError(".response.MetaObj.auditLogMeta: object expected");
                message.auditLogMeta = $root.response.AuditLog.fromObject(object.auditLogMeta);
            }
            if (object.nameMeta != null) {
                if (typeof object.nameMeta !== "object")
                    throw TypeError(".response.MetaObj.nameMeta: object expected");
                message.nameMeta = $root.response.Name.fromObject(object.nameMeta);
            }
            return message;
        };

        /**
         * Creates a plain object from a MetaObj message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.MetaObj
         * @static
         * @param {response.MetaObj} message MetaObj
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MetaObj.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (message.fileMeta != null && message.hasOwnProperty("fileMeta")) {
                object.fileMeta = $root.response.File.toObject(message.fileMeta, options);
                if (options.oneofs)
                    object.meta = "fileMeta";
            }
            if (message.folderMeta != null && message.hasOwnProperty("folderMeta")) {
                object.folderMeta = $root.response.Folder.toObject(message.folderMeta, options);
                if (options.oneofs)
                    object.meta = "folderMeta";
            }
            if (message.chunkMeta != null && message.hasOwnProperty("chunkMeta")) {
                object.chunkMeta = $root.response.Chunk.toObject(message.chunkMeta, options);
                if (options.oneofs)
                    object.meta = "chunkMeta";
            }
            if (message.auditLogMeta != null && message.hasOwnProperty("auditLogMeta")) {
                object.auditLogMeta = $root.response.AuditLog.toObject(message.auditLogMeta, options);
                if (options.oneofs)
                    object.meta = "auditLogMeta";
            }
            if (message.nameMeta != null && message.hasOwnProperty("nameMeta")) {
                object.nameMeta = $root.response.Name.toObject(message.nameMeta, options);
                if (options.oneofs)
                    object.meta = "nameMeta";
            }
            return object;
        };

        /**
         * Converts this MetaObj to JSON.
         * @function toJSON
         * @memberof response.MetaObj
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MetaObj.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for MetaObj
         * @function getTypeUrl
         * @memberof response.MetaObj
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        MetaObj.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.MetaObj";
        };

        return MetaObj;
    })();

    response.GetMetaFromPath = (function() {

        /**
         * Properties of a GetMetaFromPath.
         * @memberof response
         * @interface IGetMetaFromPath
         * @property {response.Status|null} [status] GetMetaFromPath status
         * @property {response.IMetaObj|null} [meta] GetMetaFromPath meta
         * @property {string|null} [message] GetMetaFromPath message
         */

        /**
         * Constructs a new GetMetaFromPath.
         * @memberof response
         * @classdesc Represents a GetMetaFromPath.
         * @implements IGetMetaFromPath
         * @constructor
         * @param {response.IGetMetaFromPath=} [properties] Properties to set
         */
        function GetMetaFromPath(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetMetaFromPath status.
         * @member {response.Status} status
         * @memberof response.GetMetaFromPath
         * @instance
         */
        GetMetaFromPath.prototype.status = 0;

        /**
         * GetMetaFromPath meta.
         * @member {response.IMetaObj|null|undefined} meta
         * @memberof response.GetMetaFromPath
         * @instance
         */
        GetMetaFromPath.prototype.meta = null;

        /**
         * GetMetaFromPath message.
         * @member {string|null|undefined} message
         * @memberof response.GetMetaFromPath
         * @instance
         */
        GetMetaFromPath.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(GetMetaFromPath.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new GetMetaFromPath instance using the specified properties.
         * @function create
         * @memberof response.GetMetaFromPath
         * @static
         * @param {response.IGetMetaFromPath=} [properties] Properties to set
         * @returns {response.GetMetaFromPath} GetMetaFromPath instance
         */
        GetMetaFromPath.create = function create(properties) {
            return new GetMetaFromPath(properties);
        };

        /**
         * Encodes the specified GetMetaFromPath message. Does not implicitly {@link response.GetMetaFromPath.verify|verify} messages.
         * @function encode
         * @memberof response.GetMetaFromPath
         * @static
         * @param {response.IGetMetaFromPath} message GetMetaFromPath message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetMetaFromPath.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.meta != null && Object.hasOwnProperty.call(message, "meta"))
                $root.response.MetaObj.encode(message.meta, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified GetMetaFromPath message, length delimited. Does not implicitly {@link response.GetMetaFromPath.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.GetMetaFromPath
         * @static
         * @param {response.IGetMetaFromPath} message GetMetaFromPath message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetMetaFromPath.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetMetaFromPath message from the specified reader or buffer.
         * @function decode
         * @memberof response.GetMetaFromPath
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.GetMetaFromPath} GetMetaFromPath
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetMetaFromPath.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.GetMetaFromPath();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.meta = $root.response.MetaObj.decode(reader, reader.uint32());
                        break;
                    }
                case 3: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetMetaFromPath message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.GetMetaFromPath
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.GetMetaFromPath} GetMetaFromPath
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetMetaFromPath.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetMetaFromPath message.
         * @function verify
         * @memberof response.GetMetaFromPath
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetMetaFromPath.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.meta != null && message.hasOwnProperty("meta")) {
                let error = $root.response.MetaObj.verify(message.meta);
                if (error)
                    return "meta." + error;
            }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a GetMetaFromPath message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.GetMetaFromPath
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.GetMetaFromPath} GetMetaFromPath
         */
        GetMetaFromPath.fromObject = function fromObject(object) {
            if (object instanceof $root.response.GetMetaFromPath)
                return object;
            let message = new $root.response.GetMetaFromPath();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.meta != null) {
                if (typeof object.meta !== "object")
                    throw TypeError(".response.GetMetaFromPath.meta: object expected");
                message.meta = $root.response.MetaObj.fromObject(object.meta);
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a GetMetaFromPath message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.GetMetaFromPath
         * @static
         * @param {response.GetMetaFromPath} message GetMetaFromPath
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetMetaFromPath.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.status = options.enums === String ? "SUCCESS" : 0;
                object.meta = null;
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.meta != null && message.hasOwnProperty("meta"))
                object.meta = $root.response.MetaObj.toObject(message.meta, options);
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this GetMetaFromPath to JSON.
         * @function toJSON
         * @memberof response.GetMetaFromPath
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetMetaFromPath.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetMetaFromPath
         * @function getTypeUrl
         * @memberof response.GetMetaFromPath
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetMetaFromPath.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.GetMetaFromPath";
        };

        return GetMetaFromPath;
    })();

    response.AuditLog = (function() {

        /**
         * Properties of an AuditLog.
         * @memberof response
         * @interface IAuditLog
         * @property {string|null} [name] AuditLog name
         * @property {number|Long|null} [startTime] AuditLog startTime
         * @property {number|Long|null} [endTime] AuditLog endTime
         * @property {number|Long|null} [size] AuditLog size
         * @property {Uint8Array|null} [logHash] AuditLog logHash
         * @property {Uint8Array|null} [signedLogHash] AuditLog signedLogHash
         */

        /**
         * Constructs a new AuditLog.
         * @memberof response
         * @classdesc Represents an AuditLog.
         * @implements IAuditLog
         * @constructor
         * @param {response.IAuditLog=} [properties] Properties to set
         */
        function AuditLog(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AuditLog name.
         * @member {string} name
         * @memberof response.AuditLog
         * @instance
         */
        AuditLog.prototype.name = "";

        /**
         * AuditLog startTime.
         * @member {number|Long|null|undefined} startTime
         * @memberof response.AuditLog
         * @instance
         */
        AuditLog.prototype.startTime = null;

        /**
         * AuditLog endTime.
         * @member {number|Long|null|undefined} endTime
         * @memberof response.AuditLog
         * @instance
         */
        AuditLog.prototype.endTime = null;

        /**
         * AuditLog size.
         * @member {number|Long|null|undefined} size
         * @memberof response.AuditLog
         * @instance
         */
        AuditLog.prototype.size = null;

        /**
         * AuditLog logHash.
         * @member {Uint8Array|null|undefined} logHash
         * @memberof response.AuditLog
         * @instance
         */
        AuditLog.prototype.logHash = null;

        /**
         * AuditLog signedLogHash.
         * @member {Uint8Array|null|undefined} signedLogHash
         * @memberof response.AuditLog
         * @instance
         */
        AuditLog.prototype.signedLogHash = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(AuditLog.prototype, "_startTime", {
            get: $util.oneOfGetter($oneOfFields = ["startTime"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(AuditLog.prototype, "_endTime", {
            get: $util.oneOfGetter($oneOfFields = ["endTime"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(AuditLog.prototype, "_size", {
            get: $util.oneOfGetter($oneOfFields = ["size"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(AuditLog.prototype, "_logHash", {
            get: $util.oneOfGetter($oneOfFields = ["logHash"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(AuditLog.prototype, "_signedLogHash", {
            get: $util.oneOfGetter($oneOfFields = ["signedLogHash"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new AuditLog instance using the specified properties.
         * @function create
         * @memberof response.AuditLog
         * @static
         * @param {response.IAuditLog=} [properties] Properties to set
         * @returns {response.AuditLog} AuditLog instance
         */
        AuditLog.create = function create(properties) {
            return new AuditLog(properties);
        };

        /**
         * Encodes the specified AuditLog message. Does not implicitly {@link response.AuditLog.verify|verify} messages.
         * @function encode
         * @memberof response.AuditLog
         * @static
         * @param {response.IAuditLog} message AuditLog message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AuditLog.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
            if (message.startTime != null && Object.hasOwnProperty.call(message, "startTime"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.startTime);
            if (message.endTime != null && Object.hasOwnProperty.call(message, "endTime"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.endTime);
            if (message.size != null && Object.hasOwnProperty.call(message, "size"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.size);
            if (message.logHash != null && Object.hasOwnProperty.call(message, "logHash"))
                writer.uint32(/* id 5, wireType 2 =*/42).bytes(message.logHash);
            if (message.signedLogHash != null && Object.hasOwnProperty.call(message, "signedLogHash"))
                writer.uint32(/* id 6, wireType 2 =*/50).bytes(message.signedLogHash);
            return writer;
        };

        /**
         * Encodes the specified AuditLog message, length delimited. Does not implicitly {@link response.AuditLog.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.AuditLog
         * @static
         * @param {response.IAuditLog} message AuditLog message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AuditLog.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AuditLog message from the specified reader or buffer.
         * @function decode
         * @memberof response.AuditLog
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.AuditLog} AuditLog
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AuditLog.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.AuditLog();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.name = reader.string();
                        break;
                    }
                case 2: {
                        message.startTime = reader.uint64();
                        break;
                    }
                case 3: {
                        message.endTime = reader.uint64();
                        break;
                    }
                case 4: {
                        message.size = reader.uint64();
                        break;
                    }
                case 5: {
                        message.logHash = reader.bytes();
                        break;
                    }
                case 6: {
                        message.signedLogHash = reader.bytes();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AuditLog message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.AuditLog
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.AuditLog} AuditLog
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AuditLog.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AuditLog message.
         * @function verify
         * @memberof response.AuditLog
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AuditLog.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.startTime != null && message.hasOwnProperty("startTime")) {
                properties._startTime = 1;
                if (!$util.isInteger(message.startTime) && !(message.startTime && $util.isInteger(message.startTime.low) && $util.isInteger(message.startTime.high)))
                    return "startTime: integer|Long expected";
            }
            if (message.endTime != null && message.hasOwnProperty("endTime")) {
                properties._endTime = 1;
                if (!$util.isInteger(message.endTime) && !(message.endTime && $util.isInteger(message.endTime.low) && $util.isInteger(message.endTime.high)))
                    return "endTime: integer|Long expected";
            }
            if (message.size != null && message.hasOwnProperty("size")) {
                properties._size = 1;
                if (!$util.isInteger(message.size) && !(message.size && $util.isInteger(message.size.low) && $util.isInteger(message.size.high)))
                    return "size: integer|Long expected";
            }
            if (message.logHash != null && message.hasOwnProperty("logHash")) {
                properties._logHash = 1;
                if (!(message.logHash && typeof message.logHash.length === "number" || $util.isString(message.logHash)))
                    return "logHash: buffer expected";
            }
            if (message.signedLogHash != null && message.hasOwnProperty("signedLogHash")) {
                properties._signedLogHash = 1;
                if (!(message.signedLogHash && typeof message.signedLogHash.length === "number" || $util.isString(message.signedLogHash)))
                    return "signedLogHash: buffer expected";
            }
            return null;
        };

        /**
         * Creates an AuditLog message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.AuditLog
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.AuditLog} AuditLog
         */
        AuditLog.fromObject = function fromObject(object) {
            if (object instanceof $root.response.AuditLog)
                return object;
            let message = new $root.response.AuditLog();
            if (object.name != null)
                message.name = String(object.name);
            if (object.startTime != null)
                if ($util.Long)
                    (message.startTime = $util.Long.fromValue(object.startTime)).unsigned = true;
                else if (typeof object.startTime === "string")
                    message.startTime = parseInt(object.startTime, 10);
                else if (typeof object.startTime === "number")
                    message.startTime = object.startTime;
                else if (typeof object.startTime === "object")
                    message.startTime = new $util.LongBits(object.startTime.low >>> 0, object.startTime.high >>> 0).toNumber(true);
            if (object.endTime != null)
                if ($util.Long)
                    (message.endTime = $util.Long.fromValue(object.endTime)).unsigned = true;
                else if (typeof object.endTime === "string")
                    message.endTime = parseInt(object.endTime, 10);
                else if (typeof object.endTime === "number")
                    message.endTime = object.endTime;
                else if (typeof object.endTime === "object")
                    message.endTime = new $util.LongBits(object.endTime.low >>> 0, object.endTime.high >>> 0).toNumber(true);
            if (object.size != null)
                if ($util.Long)
                    (message.size = $util.Long.fromValue(object.size)).unsigned = true;
                else if (typeof object.size === "string")
                    message.size = parseInt(object.size, 10);
                else if (typeof object.size === "number")
                    message.size = object.size;
                else if (typeof object.size === "object")
                    message.size = new $util.LongBits(object.size.low >>> 0, object.size.high >>> 0).toNumber(true);
            if (object.logHash != null)
                if (typeof object.logHash === "string")
                    $util.base64.decode(object.logHash, message.logHash = $util.newBuffer($util.base64.length(object.logHash)), 0);
                else if (object.logHash.length >= 0)
                    message.logHash = object.logHash;
            if (object.signedLogHash != null)
                if (typeof object.signedLogHash === "string")
                    $util.base64.decode(object.signedLogHash, message.signedLogHash = $util.newBuffer($util.base64.length(object.signedLogHash)), 0);
                else if (object.signedLogHash.length >= 0)
                    message.signedLogHash = object.signedLogHash;
            return message;
        };

        /**
         * Creates a plain object from an AuditLog message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.AuditLog
         * @static
         * @param {response.AuditLog} message AuditLog
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AuditLog.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.name = "";
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.startTime != null && message.hasOwnProperty("startTime")) {
                if (typeof message.startTime === "number")
                    object.startTime = options.longs === String ? String(message.startTime) : message.startTime;
                else
                    object.startTime = options.longs === String ? $util.Long.prototype.toString.call(message.startTime) : options.longs === Number ? new $util.LongBits(message.startTime.low >>> 0, message.startTime.high >>> 0).toNumber(true) : message.startTime;
                if (options.oneofs)
                    object._startTime = "startTime";
            }
            if (message.endTime != null && message.hasOwnProperty("endTime")) {
                if (typeof message.endTime === "number")
                    object.endTime = options.longs === String ? String(message.endTime) : message.endTime;
                else
                    object.endTime = options.longs === String ? $util.Long.prototype.toString.call(message.endTime) : options.longs === Number ? new $util.LongBits(message.endTime.low >>> 0, message.endTime.high >>> 0).toNumber(true) : message.endTime;
                if (options.oneofs)
                    object._endTime = "endTime";
            }
            if (message.size != null && message.hasOwnProperty("size")) {
                if (typeof message.size === "number")
                    object.size = options.longs === String ? String(message.size) : message.size;
                else
                    object.size = options.longs === String ? $util.Long.prototype.toString.call(message.size) : options.longs === Number ? new $util.LongBits(message.size.low >>> 0, message.size.high >>> 0).toNumber(true) : message.size;
                if (options.oneofs)
                    object._size = "size";
            }
            if (message.logHash != null && message.hasOwnProperty("logHash")) {
                object.logHash = options.bytes === String ? $util.base64.encode(message.logHash, 0, message.logHash.length) : options.bytes === Array ? Array.prototype.slice.call(message.logHash) : message.logHash;
                if (options.oneofs)
                    object._logHash = "logHash";
            }
            if (message.signedLogHash != null && message.hasOwnProperty("signedLogHash")) {
                object.signedLogHash = options.bytes === String ? $util.base64.encode(message.signedLogHash, 0, message.signedLogHash.length) : options.bytes === Array ? Array.prototype.slice.call(message.signedLogHash) : message.signedLogHash;
                if (options.oneofs)
                    object._signedLogHash = "signedLogHash";
            }
            return object;
        };

        /**
         * Converts this AuditLog to JSON.
         * @function toJSON
         * @memberof response.AuditLog
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AuditLog.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for AuditLog
         * @function getTypeUrl
         * @memberof response.AuditLog
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        AuditLog.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.AuditLog";
        };

        return AuditLog;
    })();

    response.Folder = (function() {

        /**
         * Properties of a Folder.
         * @memberof response
         * @interface IFolder
         * @property {string|null} [name] Folder name
         * @property {string|null} [parentFolder] Folder parentFolder
         * @property {Uint8Array|null} [uuid] Folder uuid
         * @property {string|null} [owner] Folder owner
         * @property {number|Long|null} [creationDate] Folder creationDate
         * @property {number|Long|null} [lastModifiedDate] Folder lastModifiedDate
         * @property {Uint8Array|null} [currentVersion] Folder currentVersion
         * @property {Array.<Uint8Array>|null} [versions] Folder versions
         * @property {number|Long|null} [size] Folder size
         * @property {Uint8Array|null} [policy] Folder policy
         */

        /**
         * Constructs a new Folder.
         * @memberof response
         * @classdesc Represents a Folder.
         * @implements IFolder
         * @constructor
         * @param {response.IFolder=} [properties] Properties to set
         */
        function Folder(properties) {
            this.versions = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Folder name.
         * @member {string} name
         * @memberof response.Folder
         * @instance
         */
        Folder.prototype.name = "";

        /**
         * Folder parentFolder.
         * @member {string} parentFolder
         * @memberof response.Folder
         * @instance
         */
        Folder.prototype.parentFolder = "";

        /**
         * Folder uuid.
         * @member {Uint8Array} uuid
         * @memberof response.Folder
         * @instance
         */
        Folder.prototype.uuid = $util.newBuffer([]);

        /**
         * Folder owner.
         * @member {string} owner
         * @memberof response.Folder
         * @instance
         */
        Folder.prototype.owner = "";

        /**
         * Folder creationDate.
         * @member {number|Long} creationDate
         * @memberof response.Folder
         * @instance
         */
        Folder.prototype.creationDate = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Folder lastModifiedDate.
         * @member {number|Long} lastModifiedDate
         * @memberof response.Folder
         * @instance
         */
        Folder.prototype.lastModifiedDate = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Folder currentVersion.
         * @member {Uint8Array} currentVersion
         * @memberof response.Folder
         * @instance
         */
        Folder.prototype.currentVersion = $util.newBuffer([]);

        /**
         * Folder versions.
         * @member {Array.<Uint8Array>} versions
         * @memberof response.Folder
         * @instance
         */
        Folder.prototype.versions = $util.emptyArray;

        /**
         * Folder size.
         * @member {number|Long} size
         * @memberof response.Folder
         * @instance
         */
        Folder.prototype.size = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Folder policy.
         * @member {Uint8Array} policy
         * @memberof response.Folder
         * @instance
         */
        Folder.prototype.policy = $util.newBuffer([]);

        /**
         * Creates a new Folder instance using the specified properties.
         * @function create
         * @memberof response.Folder
         * @static
         * @param {response.IFolder=} [properties] Properties to set
         * @returns {response.Folder} Folder instance
         */
        Folder.create = function create(properties) {
            return new Folder(properties);
        };

        /**
         * Encodes the specified Folder message. Does not implicitly {@link response.Folder.verify|verify} messages.
         * @function encode
         * @memberof response.Folder
         * @static
         * @param {response.IFolder} message Folder message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Folder.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
            if (message.parentFolder != null && Object.hasOwnProperty.call(message, "parentFolder"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.parentFolder);
            if (message.uuid != null && Object.hasOwnProperty.call(message, "uuid"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.uuid);
            if (message.owner != null && Object.hasOwnProperty.call(message, "owner"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.owner);
            if (message.creationDate != null && Object.hasOwnProperty.call(message, "creationDate"))
                writer.uint32(/* id 5, wireType 0 =*/40).uint64(message.creationDate);
            if (message.lastModifiedDate != null && Object.hasOwnProperty.call(message, "lastModifiedDate"))
                writer.uint32(/* id 6, wireType 0 =*/48).uint64(message.lastModifiedDate);
            if (message.currentVersion != null && Object.hasOwnProperty.call(message, "currentVersion"))
                writer.uint32(/* id 7, wireType 2 =*/58).bytes(message.currentVersion);
            if (message.versions != null && message.versions.length)
                for (let i = 0; i < message.versions.length; ++i)
                    writer.uint32(/* id 8, wireType 2 =*/66).bytes(message.versions[i]);
            if (message.size != null && Object.hasOwnProperty.call(message, "size"))
                writer.uint32(/* id 9, wireType 0 =*/72).uint64(message.size);
            if (message.policy != null && Object.hasOwnProperty.call(message, "policy"))
                writer.uint32(/* id 10, wireType 2 =*/82).bytes(message.policy);
            return writer;
        };

        /**
         * Encodes the specified Folder message, length delimited. Does not implicitly {@link response.Folder.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.Folder
         * @static
         * @param {response.IFolder} message Folder message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Folder.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Folder message from the specified reader or buffer.
         * @function decode
         * @memberof response.Folder
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.Folder} Folder
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Folder.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.Folder();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.name = reader.string();
                        break;
                    }
                case 2: {
                        message.parentFolder = reader.string();
                        break;
                    }
                case 3: {
                        message.uuid = reader.bytes();
                        break;
                    }
                case 4: {
                        message.owner = reader.string();
                        break;
                    }
                case 5: {
                        message.creationDate = reader.uint64();
                        break;
                    }
                case 6: {
                        message.lastModifiedDate = reader.uint64();
                        break;
                    }
                case 7: {
                        message.currentVersion = reader.bytes();
                        break;
                    }
                case 8: {
                        if (!(message.versions && message.versions.length))
                            message.versions = [];
                        message.versions.push(reader.bytes());
                        break;
                    }
                case 9: {
                        message.size = reader.uint64();
                        break;
                    }
                case 10: {
                        message.policy = reader.bytes();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Folder message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.Folder
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.Folder} Folder
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Folder.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Folder message.
         * @function verify
         * @memberof response.Folder
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Folder.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.parentFolder != null && message.hasOwnProperty("parentFolder"))
                if (!$util.isString(message.parentFolder))
                    return "parentFolder: string expected";
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                if (!(message.uuid && typeof message.uuid.length === "number" || $util.isString(message.uuid)))
                    return "uuid: buffer expected";
            if (message.owner != null && message.hasOwnProperty("owner"))
                if (!$util.isString(message.owner))
                    return "owner: string expected";
            if (message.creationDate != null && message.hasOwnProperty("creationDate"))
                if (!$util.isInteger(message.creationDate) && !(message.creationDate && $util.isInteger(message.creationDate.low) && $util.isInteger(message.creationDate.high)))
                    return "creationDate: integer|Long expected";
            if (message.lastModifiedDate != null && message.hasOwnProperty("lastModifiedDate"))
                if (!$util.isInteger(message.lastModifiedDate) && !(message.lastModifiedDate && $util.isInteger(message.lastModifiedDate.low) && $util.isInteger(message.lastModifiedDate.high)))
                    return "lastModifiedDate: integer|Long expected";
            if (message.currentVersion != null && message.hasOwnProperty("currentVersion"))
                if (!(message.currentVersion && typeof message.currentVersion.length === "number" || $util.isString(message.currentVersion)))
                    return "currentVersion: buffer expected";
            if (message.versions != null && message.hasOwnProperty("versions")) {
                if (!Array.isArray(message.versions))
                    return "versions: array expected";
                for (let i = 0; i < message.versions.length; ++i)
                    if (!(message.versions[i] && typeof message.versions[i].length === "number" || $util.isString(message.versions[i])))
                        return "versions: buffer[] expected";
            }
            if (message.size != null && message.hasOwnProperty("size"))
                if (!$util.isInteger(message.size) && !(message.size && $util.isInteger(message.size.low) && $util.isInteger(message.size.high)))
                    return "size: integer|Long expected";
            if (message.policy != null && message.hasOwnProperty("policy"))
                if (!(message.policy && typeof message.policy.length === "number" || $util.isString(message.policy)))
                    return "policy: buffer expected";
            return null;
        };

        /**
         * Creates a Folder message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.Folder
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.Folder} Folder
         */
        Folder.fromObject = function fromObject(object) {
            if (object instanceof $root.response.Folder)
                return object;
            let message = new $root.response.Folder();
            if (object.name != null)
                message.name = String(object.name);
            if (object.parentFolder != null)
                message.parentFolder = String(object.parentFolder);
            if (object.uuid != null)
                if (typeof object.uuid === "string")
                    $util.base64.decode(object.uuid, message.uuid = $util.newBuffer($util.base64.length(object.uuid)), 0);
                else if (object.uuid.length >= 0)
                    message.uuid = object.uuid;
            if (object.owner != null)
                message.owner = String(object.owner);
            if (object.creationDate != null)
                if ($util.Long)
                    (message.creationDate = $util.Long.fromValue(object.creationDate)).unsigned = true;
                else if (typeof object.creationDate === "string")
                    message.creationDate = parseInt(object.creationDate, 10);
                else if (typeof object.creationDate === "number")
                    message.creationDate = object.creationDate;
                else if (typeof object.creationDate === "object")
                    message.creationDate = new $util.LongBits(object.creationDate.low >>> 0, object.creationDate.high >>> 0).toNumber(true);
            if (object.lastModifiedDate != null)
                if ($util.Long)
                    (message.lastModifiedDate = $util.Long.fromValue(object.lastModifiedDate)).unsigned = true;
                else if (typeof object.lastModifiedDate === "string")
                    message.lastModifiedDate = parseInt(object.lastModifiedDate, 10);
                else if (typeof object.lastModifiedDate === "number")
                    message.lastModifiedDate = object.lastModifiedDate;
                else if (typeof object.lastModifiedDate === "object")
                    message.lastModifiedDate = new $util.LongBits(object.lastModifiedDate.low >>> 0, object.lastModifiedDate.high >>> 0).toNumber(true);
            if (object.currentVersion != null)
                if (typeof object.currentVersion === "string")
                    $util.base64.decode(object.currentVersion, message.currentVersion = $util.newBuffer($util.base64.length(object.currentVersion)), 0);
                else if (object.currentVersion.length >= 0)
                    message.currentVersion = object.currentVersion;
            if (object.versions) {
                if (!Array.isArray(object.versions))
                    throw TypeError(".response.Folder.versions: array expected");
                message.versions = [];
                for (let i = 0; i < object.versions.length; ++i)
                    if (typeof object.versions[i] === "string")
                        $util.base64.decode(object.versions[i], message.versions[i] = $util.newBuffer($util.base64.length(object.versions[i])), 0);
                    else if (object.versions[i].length >= 0)
                        message.versions[i] = object.versions[i];
            }
            if (object.size != null)
                if ($util.Long)
                    (message.size = $util.Long.fromValue(object.size)).unsigned = true;
                else if (typeof object.size === "string")
                    message.size = parseInt(object.size, 10);
                else if (typeof object.size === "number")
                    message.size = object.size;
                else if (typeof object.size === "object")
                    message.size = new $util.LongBits(object.size.low >>> 0, object.size.high >>> 0).toNumber(true);
            if (object.policy != null)
                if (typeof object.policy === "string")
                    $util.base64.decode(object.policy, message.policy = $util.newBuffer($util.base64.length(object.policy)), 0);
                else if (object.policy.length >= 0)
                    message.policy = object.policy;
            return message;
        };

        /**
         * Creates a plain object from a Folder message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.Folder
         * @static
         * @param {response.Folder} message Folder
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Folder.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.versions = [];
            if (options.defaults) {
                object.name = "";
                object.parentFolder = "";
                if (options.bytes === String)
                    object.uuid = "";
                else {
                    object.uuid = [];
                    if (options.bytes !== Array)
                        object.uuid = $util.newBuffer(object.uuid);
                }
                object.owner = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.creationDate = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.creationDate = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.lastModifiedDate = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.lastModifiedDate = options.longs === String ? "0" : 0;
                if (options.bytes === String)
                    object.currentVersion = "";
                else {
                    object.currentVersion = [];
                    if (options.bytes !== Array)
                        object.currentVersion = $util.newBuffer(object.currentVersion);
                }
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.size = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.size = options.longs === String ? "0" : 0;
                if (options.bytes === String)
                    object.policy = "";
                else {
                    object.policy = [];
                    if (options.bytes !== Array)
                        object.policy = $util.newBuffer(object.policy);
                }
            }
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.parentFolder != null && message.hasOwnProperty("parentFolder"))
                object.parentFolder = message.parentFolder;
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                object.uuid = options.bytes === String ? $util.base64.encode(message.uuid, 0, message.uuid.length) : options.bytes === Array ? Array.prototype.slice.call(message.uuid) : message.uuid;
            if (message.owner != null && message.hasOwnProperty("owner"))
                object.owner = message.owner;
            if (message.creationDate != null && message.hasOwnProperty("creationDate"))
                if (typeof message.creationDate === "number")
                    object.creationDate = options.longs === String ? String(message.creationDate) : message.creationDate;
                else
                    object.creationDate = options.longs === String ? $util.Long.prototype.toString.call(message.creationDate) : options.longs === Number ? new $util.LongBits(message.creationDate.low >>> 0, message.creationDate.high >>> 0).toNumber(true) : message.creationDate;
            if (message.lastModifiedDate != null && message.hasOwnProperty("lastModifiedDate"))
                if (typeof message.lastModifiedDate === "number")
                    object.lastModifiedDate = options.longs === String ? String(message.lastModifiedDate) : message.lastModifiedDate;
                else
                    object.lastModifiedDate = options.longs === String ? $util.Long.prototype.toString.call(message.lastModifiedDate) : options.longs === Number ? new $util.LongBits(message.lastModifiedDate.low >>> 0, message.lastModifiedDate.high >>> 0).toNumber(true) : message.lastModifiedDate;
            if (message.currentVersion != null && message.hasOwnProperty("currentVersion"))
                object.currentVersion = options.bytes === String ? $util.base64.encode(message.currentVersion, 0, message.currentVersion.length) : options.bytes === Array ? Array.prototype.slice.call(message.currentVersion) : message.currentVersion;
            if (message.versions && message.versions.length) {
                object.versions = [];
                for (let j = 0; j < message.versions.length; ++j)
                    object.versions[j] = options.bytes === String ? $util.base64.encode(message.versions[j], 0, message.versions[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.versions[j]) : message.versions[j];
            }
            if (message.size != null && message.hasOwnProperty("size"))
                if (typeof message.size === "number")
                    object.size = options.longs === String ? String(message.size) : message.size;
                else
                    object.size = options.longs === String ? $util.Long.prototype.toString.call(message.size) : options.longs === Number ? new $util.LongBits(message.size.low >>> 0, message.size.high >>> 0).toNumber(true) : message.size;
            if (message.policy != null && message.hasOwnProperty("policy"))
                object.policy = options.bytes === String ? $util.base64.encode(message.policy, 0, message.policy.length) : options.bytes === Array ? Array.prototype.slice.call(message.policy) : message.policy;
            return object;
        };

        /**
         * Converts this Folder to JSON.
         * @function toJSON
         * @memberof response.Folder
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Folder.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Folder
         * @function getTypeUrl
         * @memberof response.Folder
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Folder.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.Folder";
        };

        return Folder;
    })();

    response.RenameFile = (function() {

        /**
         * Properties of a RenameFile.
         * @memberof response
         * @interface IRenameFile
         * @property {response.Status|null} [status] RenameFile status
         * @property {string|null} [message] RenameFile message
         */

        /**
         * Constructs a new RenameFile.
         * @memberof response
         * @classdesc Represents a RenameFile.
         * @implements IRenameFile
         * @constructor
         * @param {response.IRenameFile=} [properties] Properties to set
         */
        function RenameFile(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RenameFile status.
         * @member {response.Status} status
         * @memberof response.RenameFile
         * @instance
         */
        RenameFile.prototype.status = 0;

        /**
         * RenameFile message.
         * @member {string|null|undefined} message
         * @memberof response.RenameFile
         * @instance
         */
        RenameFile.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(RenameFile.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new RenameFile instance using the specified properties.
         * @function create
         * @memberof response.RenameFile
         * @static
         * @param {response.IRenameFile=} [properties] Properties to set
         * @returns {response.RenameFile} RenameFile instance
         */
        RenameFile.create = function create(properties) {
            return new RenameFile(properties);
        };

        /**
         * Encodes the specified RenameFile message. Does not implicitly {@link response.RenameFile.verify|verify} messages.
         * @function encode
         * @memberof response.RenameFile
         * @static
         * @param {response.IRenameFile} message RenameFile message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RenameFile.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified RenameFile message, length delimited. Does not implicitly {@link response.RenameFile.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.RenameFile
         * @static
         * @param {response.IRenameFile} message RenameFile message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RenameFile.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RenameFile message from the specified reader or buffer.
         * @function decode
         * @memberof response.RenameFile
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.RenameFile} RenameFile
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RenameFile.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.RenameFile();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RenameFile message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.RenameFile
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.RenameFile} RenameFile
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RenameFile.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RenameFile message.
         * @function verify
         * @memberof response.RenameFile
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RenameFile.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a RenameFile message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.RenameFile
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.RenameFile} RenameFile
         */
        RenameFile.fromObject = function fromObject(object) {
            if (object instanceof $root.response.RenameFile)
                return object;
            let message = new $root.response.RenameFile();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a RenameFile message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.RenameFile
         * @static
         * @param {response.RenameFile} message RenameFile
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RenameFile.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this RenameFile to JSON.
         * @function toJSON
         * @memberof response.RenameFile
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RenameFile.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for RenameFile
         * @function getTypeUrl
         * @memberof response.RenameFile
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        RenameFile.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.RenameFile";
        };

        return RenameFile;
    })();

    response.RenameFolder = (function() {

        /**
         * Properties of a RenameFolder.
         * @memberof response
         * @interface IRenameFolder
         * @property {response.Status|null} [status] RenameFolder status
         * @property {string|null} [message] RenameFolder message
         */

        /**
         * Constructs a new RenameFolder.
         * @memberof response
         * @classdesc Represents a RenameFolder.
         * @implements IRenameFolder
         * @constructor
         * @param {response.IRenameFolder=} [properties] Properties to set
         */
        function RenameFolder(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RenameFolder status.
         * @member {response.Status} status
         * @memberof response.RenameFolder
         * @instance
         */
        RenameFolder.prototype.status = 0;

        /**
         * RenameFolder message.
         * @member {string|null|undefined} message
         * @memberof response.RenameFolder
         * @instance
         */
        RenameFolder.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(RenameFolder.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new RenameFolder instance using the specified properties.
         * @function create
         * @memberof response.RenameFolder
         * @static
         * @param {response.IRenameFolder=} [properties] Properties to set
         * @returns {response.RenameFolder} RenameFolder instance
         */
        RenameFolder.create = function create(properties) {
            return new RenameFolder(properties);
        };

        /**
         * Encodes the specified RenameFolder message. Does not implicitly {@link response.RenameFolder.verify|verify} messages.
         * @function encode
         * @memberof response.RenameFolder
         * @static
         * @param {response.IRenameFolder} message RenameFolder message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RenameFolder.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified RenameFolder message, length delimited. Does not implicitly {@link response.RenameFolder.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.RenameFolder
         * @static
         * @param {response.IRenameFolder} message RenameFolder message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RenameFolder.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RenameFolder message from the specified reader or buffer.
         * @function decode
         * @memberof response.RenameFolder
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.RenameFolder} RenameFolder
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RenameFolder.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.RenameFolder();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RenameFolder message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.RenameFolder
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.RenameFolder} RenameFolder
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RenameFolder.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RenameFolder message.
         * @function verify
         * @memberof response.RenameFolder
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RenameFolder.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a RenameFolder message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.RenameFolder
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.RenameFolder} RenameFolder
         */
        RenameFolder.fromObject = function fromObject(object) {
            if (object instanceof $root.response.RenameFolder)
                return object;
            let message = new $root.response.RenameFolder();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a RenameFolder message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.RenameFolder
         * @static
         * @param {response.RenameFolder} message RenameFolder
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RenameFolder.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this RenameFolder to JSON.
         * @function toJSON
         * @memberof response.RenameFolder
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RenameFolder.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for RenameFolder
         * @function getTypeUrl
         * @memberof response.RenameFolder
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        RenameFolder.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.RenameFolder";
        };

        return RenameFolder;
    })();

    response.ListFiles = (function() {

        /**
         * Properties of a ListFiles.
         * @memberof response
         * @interface IListFiles
         * @property {response.Status|null} [status] ListFiles status
         * @property {Array.<response.IFile>|null} [files] ListFiles files
         * @property {Array.<response.IFolder>|null} [folders] ListFiles folders
         * @property {Uint8Array|null} [pageToken] ListFiles pageToken
         * @property {string|null} [message] ListFiles message
         */

        /**
         * Constructs a new ListFiles.
         * @memberof response
         * @classdesc Represents a ListFiles.
         * @implements IListFiles
         * @constructor
         * @param {response.IListFiles=} [properties] Properties to set
         */
        function ListFiles(properties) {
            this.files = [];
            this.folders = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListFiles status.
         * @member {response.Status} status
         * @memberof response.ListFiles
         * @instance
         */
        ListFiles.prototype.status = 0;

        /**
         * ListFiles files.
         * @member {Array.<response.IFile>} files
         * @memberof response.ListFiles
         * @instance
         */
        ListFiles.prototype.files = $util.emptyArray;

        /**
         * ListFiles folders.
         * @member {Array.<response.IFolder>} folders
         * @memberof response.ListFiles
         * @instance
         */
        ListFiles.prototype.folders = $util.emptyArray;

        /**
         * ListFiles pageToken.
         * @member {Uint8Array|null|undefined} pageToken
         * @memberof response.ListFiles
         * @instance
         */
        ListFiles.prototype.pageToken = null;

        /**
         * ListFiles message.
         * @member {string|null|undefined} message
         * @memberof response.ListFiles
         * @instance
         */
        ListFiles.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(ListFiles.prototype, "_pageToken", {
            get: $util.oneOfGetter($oneOfFields = ["pageToken"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(ListFiles.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new ListFiles instance using the specified properties.
         * @function create
         * @memberof response.ListFiles
         * @static
         * @param {response.IListFiles=} [properties] Properties to set
         * @returns {response.ListFiles} ListFiles instance
         */
        ListFiles.create = function create(properties) {
            return new ListFiles(properties);
        };

        /**
         * Encodes the specified ListFiles message. Does not implicitly {@link response.ListFiles.verify|verify} messages.
         * @function encode
         * @memberof response.ListFiles
         * @static
         * @param {response.IListFiles} message ListFiles message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListFiles.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.files != null && message.files.length)
                for (let i = 0; i < message.files.length; ++i)
                    $root.response.File.encode(message.files[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.folders != null && message.folders.length)
                for (let i = 0; i < message.folders.length; ++i)
                    $root.response.Folder.encode(message.folders[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.pageToken);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified ListFiles message, length delimited. Does not implicitly {@link response.ListFiles.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.ListFiles
         * @static
         * @param {response.IListFiles} message ListFiles message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListFiles.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ListFiles message from the specified reader or buffer.
         * @function decode
         * @memberof response.ListFiles
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.ListFiles} ListFiles
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListFiles.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.ListFiles();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        if (!(message.files && message.files.length))
                            message.files = [];
                        message.files.push($root.response.File.decode(reader, reader.uint32()));
                        break;
                    }
                case 3: {
                        if (!(message.folders && message.folders.length))
                            message.folders = [];
                        message.folders.push($root.response.Folder.decode(reader, reader.uint32()));
                        break;
                    }
                case 4: {
                        message.pageToken = reader.bytes();
                        break;
                    }
                case 5: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ListFiles message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.ListFiles
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.ListFiles} ListFiles
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListFiles.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ListFiles message.
         * @function verify
         * @memberof response.ListFiles
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ListFiles.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.files != null && message.hasOwnProperty("files")) {
                if (!Array.isArray(message.files))
                    return "files: array expected";
                for (let i = 0; i < message.files.length; ++i) {
                    let error = $root.response.File.verify(message.files[i]);
                    if (error)
                        return "files." + error;
                }
            }
            if (message.folders != null && message.hasOwnProperty("folders")) {
                if (!Array.isArray(message.folders))
                    return "folders: array expected";
                for (let i = 0; i < message.folders.length; ++i) {
                    let error = $root.response.Folder.verify(message.folders[i]);
                    if (error)
                        return "folders." + error;
                }
            }
            if (message.pageToken != null && message.hasOwnProperty("pageToken")) {
                properties._pageToken = 1;
                if (!(message.pageToken && typeof message.pageToken.length === "number" || $util.isString(message.pageToken)))
                    return "pageToken: buffer expected";
            }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a ListFiles message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.ListFiles
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.ListFiles} ListFiles
         */
        ListFiles.fromObject = function fromObject(object) {
            if (object instanceof $root.response.ListFiles)
                return object;
            let message = new $root.response.ListFiles();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.files) {
                if (!Array.isArray(object.files))
                    throw TypeError(".response.ListFiles.files: array expected");
                message.files = [];
                for (let i = 0; i < object.files.length; ++i) {
                    if (typeof object.files[i] !== "object")
                        throw TypeError(".response.ListFiles.files: object expected");
                    message.files[i] = $root.response.File.fromObject(object.files[i]);
                }
            }
            if (object.folders) {
                if (!Array.isArray(object.folders))
                    throw TypeError(".response.ListFiles.folders: array expected");
                message.folders = [];
                for (let i = 0; i < object.folders.length; ++i) {
                    if (typeof object.folders[i] !== "object")
                        throw TypeError(".response.ListFiles.folders: object expected");
                    message.folders[i] = $root.response.Folder.fromObject(object.folders[i]);
                }
            }
            if (object.pageToken != null)
                if (typeof object.pageToken === "string")
                    $util.base64.decode(object.pageToken, message.pageToken = $util.newBuffer($util.base64.length(object.pageToken)), 0);
                else if (object.pageToken.length >= 0)
                    message.pageToken = object.pageToken;
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a ListFiles message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.ListFiles
         * @static
         * @param {response.ListFiles} message ListFiles
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListFiles.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.files = [];
                object.folders = [];
            }
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.files && message.files.length) {
                object.files = [];
                for (let j = 0; j < message.files.length; ++j)
                    object.files[j] = $root.response.File.toObject(message.files[j], options);
            }
            if (message.folders && message.folders.length) {
                object.folders = [];
                for (let j = 0; j < message.folders.length; ++j)
                    object.folders[j] = $root.response.Folder.toObject(message.folders[j], options);
            }
            if (message.pageToken != null && message.hasOwnProperty("pageToken")) {
                object.pageToken = options.bytes === String ? $util.base64.encode(message.pageToken, 0, message.pageToken.length) : options.bytes === Array ? Array.prototype.slice.call(message.pageToken) : message.pageToken;
                if (options.oneofs)
                    object._pageToken = "pageToken";
            }
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this ListFiles to JSON.
         * @function toJSON
         * @memberof response.ListFiles
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListFiles.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ListFiles
         * @function getTypeUrl
         * @memberof response.ListFiles
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ListFiles.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.ListFiles";
        };

        return ListFiles;
    })();

    response.Remove = (function() {

        /**
         * Properties of a Remove.
         * @memberof response
         * @interface IRemove
         * @property {response.Status|null} [status] Remove status
         * @property {string|null} [message] Remove message
         */

        /**
         * Constructs a new Remove.
         * @memberof response
         * @classdesc Represents a Remove.
         * @implements IRemove
         * @constructor
         * @param {response.IRemove=} [properties] Properties to set
         */
        function Remove(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Remove status.
         * @member {response.Status} status
         * @memberof response.Remove
         * @instance
         */
        Remove.prototype.status = 0;

        /**
         * Remove message.
         * @member {string|null|undefined} message
         * @memberof response.Remove
         * @instance
         */
        Remove.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(Remove.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new Remove instance using the specified properties.
         * @function create
         * @memberof response.Remove
         * @static
         * @param {response.IRemove=} [properties] Properties to set
         * @returns {response.Remove} Remove instance
         */
        Remove.create = function create(properties) {
            return new Remove(properties);
        };

        /**
         * Encodes the specified Remove message. Does not implicitly {@link response.Remove.verify|verify} messages.
         * @function encode
         * @memberof response.Remove
         * @static
         * @param {response.IRemove} message Remove message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Remove.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified Remove message, length delimited. Does not implicitly {@link response.Remove.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.Remove
         * @static
         * @param {response.IRemove} message Remove message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Remove.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Remove message from the specified reader or buffer.
         * @function decode
         * @memberof response.Remove
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.Remove} Remove
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Remove.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.Remove();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 4: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Remove message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.Remove
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.Remove} Remove
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Remove.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Remove message.
         * @function verify
         * @memberof response.Remove
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Remove.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a Remove message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.Remove
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.Remove} Remove
         */
        Remove.fromObject = function fromObject(object) {
            if (object instanceof $root.response.Remove)
                return object;
            let message = new $root.response.Remove();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a Remove message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.Remove
         * @static
         * @param {response.Remove} message Remove
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Remove.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this Remove to JSON.
         * @function toJSON
         * @memberof response.Remove
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Remove.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Remove
         * @function getTypeUrl
         * @memberof response.Remove
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Remove.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.Remove";
        };

        return Remove;
    })();

    response.Copy = (function() {

        /**
         * Properties of a Copy.
         * @memberof response
         * @interface ICopy
         * @property {response.Status|null} [status] Copy status
         */

        /**
         * Constructs a new Copy.
         * @memberof response
         * @classdesc Represents a Copy.
         * @implements ICopy
         * @constructor
         * @param {response.ICopy=} [properties] Properties to set
         */
        function Copy(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Copy status.
         * @member {response.Status} status
         * @memberof response.Copy
         * @instance
         */
        Copy.prototype.status = 0;

        /**
         * Creates a new Copy instance using the specified properties.
         * @function create
         * @memberof response.Copy
         * @static
         * @param {response.ICopy=} [properties] Properties to set
         * @returns {response.Copy} Copy instance
         */
        Copy.create = function create(properties) {
            return new Copy(properties);
        };

        /**
         * Encodes the specified Copy message. Does not implicitly {@link response.Copy.verify|verify} messages.
         * @function encode
         * @memberof response.Copy
         * @static
         * @param {response.ICopy} message Copy message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Copy.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            return writer;
        };

        /**
         * Encodes the specified Copy message, length delimited. Does not implicitly {@link response.Copy.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.Copy
         * @static
         * @param {response.ICopy} message Copy message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Copy.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Copy message from the specified reader or buffer.
         * @function decode
         * @memberof response.Copy
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.Copy} Copy
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Copy.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.Copy();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Copy message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.Copy
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.Copy} Copy
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Copy.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Copy message.
         * @function verify
         * @memberof response.Copy
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Copy.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            return null;
        };

        /**
         * Creates a Copy message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.Copy
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.Copy} Copy
         */
        Copy.fromObject = function fromObject(object) {
            if (object instanceof $root.response.Copy)
                return object;
            let message = new $root.response.Copy();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a Copy message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.Copy
         * @static
         * @param {response.Copy} message Copy
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Copy.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            return object;
        };

        /**
         * Converts this Copy to JSON.
         * @function toJSON
         * @memberof response.Copy
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Copy.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Copy
         * @function getTypeUrl
         * @memberof response.Copy
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Copy.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.Copy";
        };

        return Copy;
    })();

    response.Move = (function() {

        /**
         * Properties of a Move.
         * @memberof response
         * @interface IMove
         * @property {response.Status|null} [status] Move status
         */

        /**
         * Constructs a new Move.
         * @memberof response
         * @classdesc Represents a Move.
         * @implements IMove
         * @constructor
         * @param {response.IMove=} [properties] Properties to set
         */
        function Move(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Move status.
         * @member {response.Status} status
         * @memberof response.Move
         * @instance
         */
        Move.prototype.status = 0;

        /**
         * Creates a new Move instance using the specified properties.
         * @function create
         * @memberof response.Move
         * @static
         * @param {response.IMove=} [properties] Properties to set
         * @returns {response.Move} Move instance
         */
        Move.create = function create(properties) {
            return new Move(properties);
        };

        /**
         * Encodes the specified Move message. Does not implicitly {@link response.Move.verify|verify} messages.
         * @function encode
         * @memberof response.Move
         * @static
         * @param {response.IMove} message Move message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Move.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            return writer;
        };

        /**
         * Encodes the specified Move message, length delimited. Does not implicitly {@link response.Move.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.Move
         * @static
         * @param {response.IMove} message Move message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Move.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Move message from the specified reader or buffer.
         * @function decode
         * @memberof response.Move
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.Move} Move
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Move.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.Move();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Move message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.Move
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.Move} Move
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Move.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Move message.
         * @function verify
         * @memberof response.Move
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Move.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            return null;
        };

        /**
         * Creates a Move message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.Move
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.Move} Move
         */
        Move.fromObject = function fromObject(object) {
            if (object instanceof $root.response.Move)
                return object;
            let message = new $root.response.Move();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a Move message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.Move
         * @static
         * @param {response.Move} message Move
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Move.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            return object;
        };

        /**
         * Converts this Move to JSON.
         * @function toJSON
         * @memberof response.Move
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Move.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Move
         * @function getTypeUrl
         * @memberof response.Move
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Move.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.Move";
        };

        return Move;
    })();

    response.FileLock = (function() {

        /**
         * Properties of a FileLock.
         * @memberof response
         * @interface IFileLock
         * @property {response.Status|null} [status] FileLock status
         * @property {string|null} [message] FileLock message
         */

        /**
         * Constructs a new FileLock.
         * @memberof response
         * @classdesc Represents a FileLock.
         * @implements IFileLock
         * @constructor
         * @param {response.IFileLock=} [properties] Properties to set
         */
        function FileLock(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * FileLock status.
         * @member {response.Status} status
         * @memberof response.FileLock
         * @instance
         */
        FileLock.prototype.status = 0;

        /**
         * FileLock message.
         * @member {string|null|undefined} message
         * @memberof response.FileLock
         * @instance
         */
        FileLock.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(FileLock.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new FileLock instance using the specified properties.
         * @function create
         * @memberof response.FileLock
         * @static
         * @param {response.IFileLock=} [properties] Properties to set
         * @returns {response.FileLock} FileLock instance
         */
        FileLock.create = function create(properties) {
            return new FileLock(properties);
        };

        /**
         * Encodes the specified FileLock message. Does not implicitly {@link response.FileLock.verify|verify} messages.
         * @function encode
         * @memberof response.FileLock
         * @static
         * @param {response.IFileLock} message FileLock message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FileLock.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified FileLock message, length delimited. Does not implicitly {@link response.FileLock.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.FileLock
         * @static
         * @param {response.IFileLock} message FileLock message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FileLock.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a FileLock message from the specified reader or buffer.
         * @function decode
         * @memberof response.FileLock
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.FileLock} FileLock
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FileLock.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.FileLock();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 4: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a FileLock message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.FileLock
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.FileLock} FileLock
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FileLock.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a FileLock message.
         * @function verify
         * @memberof response.FileLock
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        FileLock.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a FileLock message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.FileLock
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.FileLock} FileLock
         */
        FileLock.fromObject = function fromObject(object) {
            if (object instanceof $root.response.FileLock)
                return object;
            let message = new $root.response.FileLock();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a FileLock message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.FileLock
         * @static
         * @param {response.FileLock} message FileLock
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FileLock.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this FileLock to JSON.
         * @function toJSON
         * @memberof response.FileLock
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FileLock.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for FileLock
         * @function getTypeUrl
         * @memberof response.FileLock
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        FileLock.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.FileLock";
        };

        return FileLock;
    })();

    response.FileUnlock = (function() {

        /**
         * Properties of a FileUnlock.
         * @memberof response
         * @interface IFileUnlock
         * @property {response.Status|null} [status] FileUnlock status
         * @property {string|null} [message] FileUnlock message
         */

        /**
         * Constructs a new FileUnlock.
         * @memberof response
         * @classdesc Represents a FileUnlock.
         * @implements IFileUnlock
         * @constructor
         * @param {response.IFileUnlock=} [properties] Properties to set
         */
        function FileUnlock(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * FileUnlock status.
         * @member {response.Status} status
         * @memberof response.FileUnlock
         * @instance
         */
        FileUnlock.prototype.status = 0;

        /**
         * FileUnlock message.
         * @member {string|null|undefined} message
         * @memberof response.FileUnlock
         * @instance
         */
        FileUnlock.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(FileUnlock.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new FileUnlock instance using the specified properties.
         * @function create
         * @memberof response.FileUnlock
         * @static
         * @param {response.IFileUnlock=} [properties] Properties to set
         * @returns {response.FileUnlock} FileUnlock instance
         */
        FileUnlock.create = function create(properties) {
            return new FileUnlock(properties);
        };

        /**
         * Encodes the specified FileUnlock message. Does not implicitly {@link response.FileUnlock.verify|verify} messages.
         * @function encode
         * @memberof response.FileUnlock
         * @static
         * @param {response.IFileUnlock} message FileUnlock message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FileUnlock.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified FileUnlock message, length delimited. Does not implicitly {@link response.FileUnlock.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.FileUnlock
         * @static
         * @param {response.IFileUnlock} message FileUnlock message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FileUnlock.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a FileUnlock message from the specified reader or buffer.
         * @function decode
         * @memberof response.FileUnlock
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.FileUnlock} FileUnlock
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FileUnlock.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.FileUnlock();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 4: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a FileUnlock message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.FileUnlock
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.FileUnlock} FileUnlock
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FileUnlock.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a FileUnlock message.
         * @function verify
         * @memberof response.FileUnlock
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        FileUnlock.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a FileUnlock message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.FileUnlock
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.FileUnlock} FileUnlock
         */
        FileUnlock.fromObject = function fromObject(object) {
            if (object instanceof $root.response.FileUnlock)
                return object;
            let message = new $root.response.FileUnlock();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a FileUnlock message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.FileUnlock
         * @static
         * @param {response.FileUnlock} message FileUnlock
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FileUnlock.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this FileUnlock to JSON.
         * @function toJSON
         * @memberof response.FileUnlock
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FileUnlock.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for FileUnlock
         * @function getTypeUrl
         * @memberof response.FileUnlock
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        FileUnlock.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.FileUnlock";
        };

        return FileUnlock;
    })();

    response.GetFolder = (function() {

        /**
         * Properties of a GetFolder.
         * @memberof response
         * @interface IGetFolder
         * @property {response.Status|null} [status] GetFolder status
         * @property {response.IFolder|null} [folder] GetFolder folder
         * @property {string|null} [message] GetFolder message
         */

        /**
         * Constructs a new GetFolder.
         * @memberof response
         * @classdesc Represents a GetFolder.
         * @implements IGetFolder
         * @constructor
         * @param {response.IGetFolder=} [properties] Properties to set
         */
        function GetFolder(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetFolder status.
         * @member {response.Status} status
         * @memberof response.GetFolder
         * @instance
         */
        GetFolder.prototype.status = 0;

        /**
         * GetFolder folder.
         * @member {response.IFolder|null|undefined} folder
         * @memberof response.GetFolder
         * @instance
         */
        GetFolder.prototype.folder = null;

        /**
         * GetFolder message.
         * @member {string|null|undefined} message
         * @memberof response.GetFolder
         * @instance
         */
        GetFolder.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(GetFolder.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new GetFolder instance using the specified properties.
         * @function create
         * @memberof response.GetFolder
         * @static
         * @param {response.IGetFolder=} [properties] Properties to set
         * @returns {response.GetFolder} GetFolder instance
         */
        GetFolder.create = function create(properties) {
            return new GetFolder(properties);
        };

        /**
         * Encodes the specified GetFolder message. Does not implicitly {@link response.GetFolder.verify|verify} messages.
         * @function encode
         * @memberof response.GetFolder
         * @static
         * @param {response.IGetFolder} message GetFolder message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetFolder.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.folder != null && Object.hasOwnProperty.call(message, "folder"))
                $root.response.Folder.encode(message.folder, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified GetFolder message, length delimited. Does not implicitly {@link response.GetFolder.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.GetFolder
         * @static
         * @param {response.IGetFolder} message GetFolder message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetFolder.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetFolder message from the specified reader or buffer.
         * @function decode
         * @memberof response.GetFolder
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.GetFolder} GetFolder
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetFolder.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.GetFolder();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.folder = $root.response.Folder.decode(reader, reader.uint32());
                        break;
                    }
                case 4: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetFolder message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.GetFolder
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.GetFolder} GetFolder
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetFolder.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetFolder message.
         * @function verify
         * @memberof response.GetFolder
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetFolder.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.folder != null && message.hasOwnProperty("folder")) {
                let error = $root.response.Folder.verify(message.folder);
                if (error)
                    return "folder." + error;
            }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a GetFolder message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.GetFolder
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.GetFolder} GetFolder
         */
        GetFolder.fromObject = function fromObject(object) {
            if (object instanceof $root.response.GetFolder)
                return object;
            let message = new $root.response.GetFolder();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.folder != null) {
                if (typeof object.folder !== "object")
                    throw TypeError(".response.GetFolder.folder: object expected");
                message.folder = $root.response.Folder.fromObject(object.folder);
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a GetFolder message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.GetFolder
         * @static
         * @param {response.GetFolder} message GetFolder
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetFolder.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.status = options.enums === String ? "SUCCESS" : 0;
                object.folder = null;
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.folder != null && message.hasOwnProperty("folder"))
                object.folder = $root.response.Folder.toObject(message.folder, options);
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this GetFolder to JSON.
         * @function toJSON
         * @memberof response.GetFolder
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetFolder.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetFolder
         * @function getTypeUrl
         * @memberof response.GetFolder
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetFolder.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.GetFolder";
        };

        return GetFolder;
    })();

    response.CreateFolder = (function() {

        /**
         * Properties of a CreateFolder.
         * @memberof response
         * @interface ICreateFolder
         * @property {response.Status|null} [status] CreateFolder status
         * @property {string|null} [message] CreateFolder message
         */

        /**
         * Constructs a new CreateFolder.
         * @memberof response
         * @classdesc Represents a CreateFolder.
         * @implements ICreateFolder
         * @constructor
         * @param {response.ICreateFolder=} [properties] Properties to set
         */
        function CreateFolder(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CreateFolder status.
         * @member {response.Status} status
         * @memberof response.CreateFolder
         * @instance
         */
        CreateFolder.prototype.status = 0;

        /**
         * CreateFolder message.
         * @member {string|null|undefined} message
         * @memberof response.CreateFolder
         * @instance
         */
        CreateFolder.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(CreateFolder.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new CreateFolder instance using the specified properties.
         * @function create
         * @memberof response.CreateFolder
         * @static
         * @param {response.ICreateFolder=} [properties] Properties to set
         * @returns {response.CreateFolder} CreateFolder instance
         */
        CreateFolder.create = function create(properties) {
            return new CreateFolder(properties);
        };

        /**
         * Encodes the specified CreateFolder message. Does not implicitly {@link response.CreateFolder.verify|verify} messages.
         * @function encode
         * @memberof response.CreateFolder
         * @static
         * @param {response.ICreateFolder} message CreateFolder message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateFolder.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified CreateFolder message, length delimited. Does not implicitly {@link response.CreateFolder.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.CreateFolder
         * @static
         * @param {response.ICreateFolder} message CreateFolder message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateFolder.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CreateFolder message from the specified reader or buffer.
         * @function decode
         * @memberof response.CreateFolder
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.CreateFolder} CreateFolder
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateFolder.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.CreateFolder();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 4: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CreateFolder message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.CreateFolder
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.CreateFolder} CreateFolder
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateFolder.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CreateFolder message.
         * @function verify
         * @memberof response.CreateFolder
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CreateFolder.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a CreateFolder message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.CreateFolder
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.CreateFolder} CreateFolder
         */
        CreateFolder.fromObject = function fromObject(object) {
            if (object instanceof $root.response.CreateFolder)
                return object;
            let message = new $root.response.CreateFolder();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a CreateFolder message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.CreateFolder
         * @static
         * @param {response.CreateFolder} message CreateFolder
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CreateFolder.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this CreateFolder to JSON.
         * @function toJSON
         * @memberof response.CreateFolder
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CreateFolder.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CreateFolder
         * @function getTypeUrl
         * @memberof response.CreateFolder
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CreateFolder.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.CreateFolder";
        };

        return CreateFolder;
    })();

    response.CreateSnapshot = (function() {

        /**
         * Properties of a CreateSnapshot.
         * @memberof response
         * @interface ICreateSnapshot
         * @property {response.Status|null} [status] CreateSnapshot status
         * @property {response.IFolderSnapshot|null} [folderSnapshot] CreateSnapshot folderSnapshot
         * @property {string|null} [message] CreateSnapshot message
         */

        /**
         * Constructs a new CreateSnapshot.
         * @memberof response
         * @classdesc Represents a CreateSnapshot.
         * @implements ICreateSnapshot
         * @constructor
         * @param {response.ICreateSnapshot=} [properties] Properties to set
         */
        function CreateSnapshot(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CreateSnapshot status.
         * @member {response.Status} status
         * @memberof response.CreateSnapshot
         * @instance
         */
        CreateSnapshot.prototype.status = 0;

        /**
         * CreateSnapshot folderSnapshot.
         * @member {response.IFolderSnapshot|null|undefined} folderSnapshot
         * @memberof response.CreateSnapshot
         * @instance
         */
        CreateSnapshot.prototype.folderSnapshot = null;

        /**
         * CreateSnapshot message.
         * @member {string|null|undefined} message
         * @memberof response.CreateSnapshot
         * @instance
         */
        CreateSnapshot.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(CreateSnapshot.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new CreateSnapshot instance using the specified properties.
         * @function create
         * @memberof response.CreateSnapshot
         * @static
         * @param {response.ICreateSnapshot=} [properties] Properties to set
         * @returns {response.CreateSnapshot} CreateSnapshot instance
         */
        CreateSnapshot.create = function create(properties) {
            return new CreateSnapshot(properties);
        };

        /**
         * Encodes the specified CreateSnapshot message. Does not implicitly {@link response.CreateSnapshot.verify|verify} messages.
         * @function encode
         * @memberof response.CreateSnapshot
         * @static
         * @param {response.ICreateSnapshot} message CreateSnapshot message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateSnapshot.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.folderSnapshot != null && Object.hasOwnProperty.call(message, "folderSnapshot"))
                $root.response.FolderSnapshot.encode(message.folderSnapshot, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified CreateSnapshot message, length delimited. Does not implicitly {@link response.CreateSnapshot.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.CreateSnapshot
         * @static
         * @param {response.ICreateSnapshot} message CreateSnapshot message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateSnapshot.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CreateSnapshot message from the specified reader or buffer.
         * @function decode
         * @memberof response.CreateSnapshot
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.CreateSnapshot} CreateSnapshot
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateSnapshot.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.CreateSnapshot();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.folderSnapshot = $root.response.FolderSnapshot.decode(reader, reader.uint32());
                        break;
                    }
                case 4: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CreateSnapshot message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.CreateSnapshot
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.CreateSnapshot} CreateSnapshot
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateSnapshot.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CreateSnapshot message.
         * @function verify
         * @memberof response.CreateSnapshot
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CreateSnapshot.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.folderSnapshot != null && message.hasOwnProperty("folderSnapshot")) {
                let error = $root.response.FolderSnapshot.verify(message.folderSnapshot);
                if (error)
                    return "folderSnapshot." + error;
            }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a CreateSnapshot message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.CreateSnapshot
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.CreateSnapshot} CreateSnapshot
         */
        CreateSnapshot.fromObject = function fromObject(object) {
            if (object instanceof $root.response.CreateSnapshot)
                return object;
            let message = new $root.response.CreateSnapshot();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.folderSnapshot != null) {
                if (typeof object.folderSnapshot !== "object")
                    throw TypeError(".response.CreateSnapshot.folderSnapshot: object expected");
                message.folderSnapshot = $root.response.FolderSnapshot.fromObject(object.folderSnapshot);
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a CreateSnapshot message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.CreateSnapshot
         * @static
         * @param {response.CreateSnapshot} message CreateSnapshot
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CreateSnapshot.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.status = options.enums === String ? "SUCCESS" : 0;
                object.folderSnapshot = null;
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.folderSnapshot != null && message.hasOwnProperty("folderSnapshot"))
                object.folderSnapshot = $root.response.FolderSnapshot.toObject(message.folderSnapshot, options);
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this CreateSnapshot to JSON.
         * @function toJSON
         * @memberof response.CreateSnapshot
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CreateSnapshot.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CreateSnapshot
         * @function getTypeUrl
         * @memberof response.CreateSnapshot
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CreateSnapshot.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.CreateSnapshot";
        };

        return CreateSnapshot;
    })();

    response.VerifyPayment = (function() {

        /**
         * Properties of a VerifyPayment.
         * @memberof response
         * @interface IVerifyPayment
         * @property {response.Status|null} [status] VerifyPayment status
         * @property {string|null} [message] VerifyPayment message
         */

        /**
         * Constructs a new VerifyPayment.
         * @memberof response
         * @classdesc Represents a VerifyPayment.
         * @implements IVerifyPayment
         * @constructor
         * @param {response.IVerifyPayment=} [properties] Properties to set
         */
        function VerifyPayment(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * VerifyPayment status.
         * @member {response.Status} status
         * @memberof response.VerifyPayment
         * @instance
         */
        VerifyPayment.prototype.status = 0;

        /**
         * VerifyPayment message.
         * @member {string|null|undefined} message
         * @memberof response.VerifyPayment
         * @instance
         */
        VerifyPayment.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(VerifyPayment.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new VerifyPayment instance using the specified properties.
         * @function create
         * @memberof response.VerifyPayment
         * @static
         * @param {response.IVerifyPayment=} [properties] Properties to set
         * @returns {response.VerifyPayment} VerifyPayment instance
         */
        VerifyPayment.create = function create(properties) {
            return new VerifyPayment(properties);
        };

        /**
         * Encodes the specified VerifyPayment message. Does not implicitly {@link response.VerifyPayment.verify|verify} messages.
         * @function encode
         * @memberof response.VerifyPayment
         * @static
         * @param {response.IVerifyPayment} message VerifyPayment message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        VerifyPayment.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified VerifyPayment message, length delimited. Does not implicitly {@link response.VerifyPayment.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.VerifyPayment
         * @static
         * @param {response.IVerifyPayment} message VerifyPayment message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        VerifyPayment.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a VerifyPayment message from the specified reader or buffer.
         * @function decode
         * @memberof response.VerifyPayment
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.VerifyPayment} VerifyPayment
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        VerifyPayment.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.VerifyPayment();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 3: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a VerifyPayment message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.VerifyPayment
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.VerifyPayment} VerifyPayment
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        VerifyPayment.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a VerifyPayment message.
         * @function verify
         * @memberof response.VerifyPayment
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        VerifyPayment.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a VerifyPayment message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.VerifyPayment
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.VerifyPayment} VerifyPayment
         */
        VerifyPayment.fromObject = function fromObject(object) {
            if (object instanceof $root.response.VerifyPayment)
                return object;
            let message = new $root.response.VerifyPayment();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a VerifyPayment message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.VerifyPayment
         * @static
         * @param {response.VerifyPayment} message VerifyPayment
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        VerifyPayment.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this VerifyPayment to JSON.
         * @function toJSON
         * @memberof response.VerifyPayment
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        VerifyPayment.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for VerifyPayment
         * @function getTypeUrl
         * @memberof response.VerifyPayment
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        VerifyPayment.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.VerifyPayment";
        };

        return VerifyPayment;
    })();

    /**
     * SecretType enum.
     * @name response.SecretType
     * @enum {number}
     * @property {number} PASSWORD=0 PASSWORD value
     * @property {number} CARD=1 CARD value
     * @property {number} NOTE=2 NOTE value
     * @property {number} IDENTITY=3 IDENTITY value
     * @property {number} KEYVALUES=4 KEYVALUES value
     * @property {number} KEYS=5 KEYS value
     * @property {number} CERTIFICATE=6 CERTIFICATE value
     * @property {number} PRIVATEKEY=7 PRIVATEKEY value
     */
    response.SecretType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "PASSWORD"] = 0;
        values[valuesById[1] = "CARD"] = 1;
        values[valuesById[2] = "NOTE"] = 2;
        values[valuesById[3] = "IDENTITY"] = 3;
        values[valuesById[4] = "KEYVALUES"] = 4;
        values[valuesById[5] = "KEYS"] = 5;
        values[valuesById[6] = "CERTIFICATE"] = 6;
        values[valuesById[7] = "PRIVATEKEY"] = 7;
        return values;
    })();

    response.GetSecret = (function() {

        /**
         * Properties of a GetSecret.
         * @memberof response
         * @interface IGetSecret
         * @property {response.Status|null} [status] GetSecret status
         * @property {string|null} [message] GetSecret message
         * @property {Uint8Array|null} [data] GetSecret data
         */

        /**
         * Constructs a new GetSecret.
         * @memberof response
         * @classdesc Represents a GetSecret.
         * @implements IGetSecret
         * @constructor
         * @param {response.IGetSecret=} [properties] Properties to set
         */
        function GetSecret(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetSecret status.
         * @member {response.Status} status
         * @memberof response.GetSecret
         * @instance
         */
        GetSecret.prototype.status = 0;

        /**
         * GetSecret message.
         * @member {string|null|undefined} message
         * @memberof response.GetSecret
         * @instance
         */
        GetSecret.prototype.message = null;

        /**
         * GetSecret data.
         * @member {Uint8Array} data
         * @memberof response.GetSecret
         * @instance
         */
        GetSecret.prototype.data = $util.newBuffer([]);

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(GetSecret.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new GetSecret instance using the specified properties.
         * @function create
         * @memberof response.GetSecret
         * @static
         * @param {response.IGetSecret=} [properties] Properties to set
         * @returns {response.GetSecret} GetSecret instance
         */
        GetSecret.create = function create(properties) {
            return new GetSecret(properties);
        };

        /**
         * Encodes the specified GetSecret message. Does not implicitly {@link response.GetSecret.verify|verify} messages.
         * @function encode
         * @memberof response.GetSecret
         * @static
         * @param {response.IGetSecret} message GetSecret message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetSecret.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.data);
            return writer;
        };

        /**
         * Encodes the specified GetSecret message, length delimited. Does not implicitly {@link response.GetSecret.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.GetSecret
         * @static
         * @param {response.IGetSecret} message GetSecret message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetSecret.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetSecret message from the specified reader or buffer.
         * @function decode
         * @memberof response.GetSecret
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.GetSecret} GetSecret
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetSecret.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.GetSecret();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                case 3: {
                        message.data = reader.bytes();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetSecret message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.GetSecret
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.GetSecret} GetSecret
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetSecret.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetSecret message.
         * @function verify
         * @memberof response.GetSecret
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetSecret.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            return null;
        };

        /**
         * Creates a GetSecret message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.GetSecret
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.GetSecret} GetSecret
         */
        GetSecret.fromObject = function fromObject(object) {
            if (object instanceof $root.response.GetSecret)
                return object;
            let message = new $root.response.GetSecret();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            return message;
        };

        /**
         * Creates a plain object from a GetSecret message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.GetSecret
         * @static
         * @param {response.GetSecret} message GetSecret
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetSecret.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.status = options.enums === String ? "SUCCESS" : 0;
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            return object;
        };

        /**
         * Converts this GetSecret to JSON.
         * @function toJSON
         * @memberof response.GetSecret
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetSecret.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetSecret
         * @function getTypeUrl
         * @memberof response.GetSecret
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetSecret.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.GetSecret";
        };

        return GetSecret;
    })();

    response.AddSecret = (function() {

        /**
         * Properties of an AddSecret.
         * @memberof response
         * @interface IAddSecret
         * @property {response.Status|null} [status] AddSecret status
         * @property {string|null} [message] AddSecret message
         */

        /**
         * Constructs a new AddSecret.
         * @memberof response
         * @classdesc Represents an AddSecret.
         * @implements IAddSecret
         * @constructor
         * @param {response.IAddSecret=} [properties] Properties to set
         */
        function AddSecret(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddSecret status.
         * @member {response.Status} status
         * @memberof response.AddSecret
         * @instance
         */
        AddSecret.prototype.status = 0;

        /**
         * AddSecret message.
         * @member {string|null|undefined} message
         * @memberof response.AddSecret
         * @instance
         */
        AddSecret.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(AddSecret.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new AddSecret instance using the specified properties.
         * @function create
         * @memberof response.AddSecret
         * @static
         * @param {response.IAddSecret=} [properties] Properties to set
         * @returns {response.AddSecret} AddSecret instance
         */
        AddSecret.create = function create(properties) {
            return new AddSecret(properties);
        };

        /**
         * Encodes the specified AddSecret message. Does not implicitly {@link response.AddSecret.verify|verify} messages.
         * @function encode
         * @memberof response.AddSecret
         * @static
         * @param {response.IAddSecret} message AddSecret message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddSecret.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified AddSecret message, length delimited. Does not implicitly {@link response.AddSecret.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.AddSecret
         * @static
         * @param {response.IAddSecret} message AddSecret message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddSecret.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AddSecret message from the specified reader or buffer.
         * @function decode
         * @memberof response.AddSecret
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.AddSecret} AddSecret
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddSecret.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.AddSecret();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AddSecret message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.AddSecret
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.AddSecret} AddSecret
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddSecret.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AddSecret message.
         * @function verify
         * @memberof response.AddSecret
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AddSecret.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates an AddSecret message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.AddSecret
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.AddSecret} AddSecret
         */
        AddSecret.fromObject = function fromObject(object) {
            if (object instanceof $root.response.AddSecret)
                return object;
            let message = new $root.response.AddSecret();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from an AddSecret message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.AddSecret
         * @static
         * @param {response.AddSecret} message AddSecret
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddSecret.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this AddSecret to JSON.
         * @function toJSON
         * @memberof response.AddSecret
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddSecret.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for AddSecret
         * @function getTypeUrl
         * @memberof response.AddSecret
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        AddSecret.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.AddSecret";
        };

        return AddSecret;
    })();

    response.DeleteSecret = (function() {

        /**
         * Properties of a DeleteSecret.
         * @memberof response
         * @interface IDeleteSecret
         * @property {response.Status|null} [status] DeleteSecret status
         * @property {string|null} [message] DeleteSecret message
         */

        /**
         * Constructs a new DeleteSecret.
         * @memberof response
         * @classdesc Represents a DeleteSecret.
         * @implements IDeleteSecret
         * @constructor
         * @param {response.IDeleteSecret=} [properties] Properties to set
         */
        function DeleteSecret(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DeleteSecret status.
         * @member {response.Status} status
         * @memberof response.DeleteSecret
         * @instance
         */
        DeleteSecret.prototype.status = 0;

        /**
         * DeleteSecret message.
         * @member {string|null|undefined} message
         * @memberof response.DeleteSecret
         * @instance
         */
        DeleteSecret.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(DeleteSecret.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new DeleteSecret instance using the specified properties.
         * @function create
         * @memberof response.DeleteSecret
         * @static
         * @param {response.IDeleteSecret=} [properties] Properties to set
         * @returns {response.DeleteSecret} DeleteSecret instance
         */
        DeleteSecret.create = function create(properties) {
            return new DeleteSecret(properties);
        };

        /**
         * Encodes the specified DeleteSecret message. Does not implicitly {@link response.DeleteSecret.verify|verify} messages.
         * @function encode
         * @memberof response.DeleteSecret
         * @static
         * @param {response.IDeleteSecret} message DeleteSecret message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DeleteSecret.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified DeleteSecret message, length delimited. Does not implicitly {@link response.DeleteSecret.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.DeleteSecret
         * @static
         * @param {response.IDeleteSecret} message DeleteSecret message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DeleteSecret.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a DeleteSecret message from the specified reader or buffer.
         * @function decode
         * @memberof response.DeleteSecret
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.DeleteSecret} DeleteSecret
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DeleteSecret.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.DeleteSecret();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a DeleteSecret message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.DeleteSecret
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.DeleteSecret} DeleteSecret
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DeleteSecret.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a DeleteSecret message.
         * @function verify
         * @memberof response.DeleteSecret
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        DeleteSecret.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a DeleteSecret message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.DeleteSecret
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.DeleteSecret} DeleteSecret
         */
        DeleteSecret.fromObject = function fromObject(object) {
            if (object instanceof $root.response.DeleteSecret)
                return object;
            let message = new $root.response.DeleteSecret();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a DeleteSecret message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.DeleteSecret
         * @static
         * @param {response.DeleteSecret} message DeleteSecret
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DeleteSecret.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this DeleteSecret to JSON.
         * @function toJSON
         * @memberof response.DeleteSecret
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DeleteSecret.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for DeleteSecret
         * @function getTypeUrl
         * @memberof response.DeleteSecret
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        DeleteSecret.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.DeleteSecret";
        };

        return DeleteSecret;
    })();

    response.DestroySecret = (function() {

        /**
         * Properties of a DestroySecret.
         * @memberof response
         * @interface IDestroySecret
         * @property {response.Status|null} [status] DestroySecret status
         * @property {string|null} [message] DestroySecret message
         */

        /**
         * Constructs a new DestroySecret.
         * @memberof response
         * @classdesc Represents a DestroySecret.
         * @implements IDestroySecret
         * @constructor
         * @param {response.IDestroySecret=} [properties] Properties to set
         */
        function DestroySecret(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DestroySecret status.
         * @member {response.Status} status
         * @memberof response.DestroySecret
         * @instance
         */
        DestroySecret.prototype.status = 0;

        /**
         * DestroySecret message.
         * @member {string|null|undefined} message
         * @memberof response.DestroySecret
         * @instance
         */
        DestroySecret.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(DestroySecret.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new DestroySecret instance using the specified properties.
         * @function create
         * @memberof response.DestroySecret
         * @static
         * @param {response.IDestroySecret=} [properties] Properties to set
         * @returns {response.DestroySecret} DestroySecret instance
         */
        DestroySecret.create = function create(properties) {
            return new DestroySecret(properties);
        };

        /**
         * Encodes the specified DestroySecret message. Does not implicitly {@link response.DestroySecret.verify|verify} messages.
         * @function encode
         * @memberof response.DestroySecret
         * @static
         * @param {response.IDestroySecret} message DestroySecret message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DestroySecret.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified DestroySecret message, length delimited. Does not implicitly {@link response.DestroySecret.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.DestroySecret
         * @static
         * @param {response.IDestroySecret} message DestroySecret message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DestroySecret.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a DestroySecret message from the specified reader or buffer.
         * @function decode
         * @memberof response.DestroySecret
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.DestroySecret} DestroySecret
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DestroySecret.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.DestroySecret();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a DestroySecret message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.DestroySecret
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.DestroySecret} DestroySecret
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DestroySecret.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a DestroySecret message.
         * @function verify
         * @memberof response.DestroySecret
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        DestroySecret.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a DestroySecret message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.DestroySecret
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.DestroySecret} DestroySecret
         */
        DestroySecret.fromObject = function fromObject(object) {
            if (object instanceof $root.response.DestroySecret)
                return object;
            let message = new $root.response.DestroySecret();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a DestroySecret message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.DestroySecret
         * @static
         * @param {response.DestroySecret} message DestroySecret
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DestroySecret.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this DestroySecret to JSON.
         * @function toJSON
         * @memberof response.DestroySecret
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DestroySecret.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for DestroySecret
         * @function getTypeUrl
         * @memberof response.DestroySecret
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        DestroySecret.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.DestroySecret";
        };

        return DestroySecret;
    })();

    response.UpdateSecret = (function() {

        /**
         * Properties of an UpdateSecret.
         * @memberof response
         * @interface IUpdateSecret
         * @property {response.Status|null} [status] UpdateSecret status
         * @property {string|null} [message] UpdateSecret message
         */

        /**
         * Constructs a new UpdateSecret.
         * @memberof response
         * @classdesc Represents an UpdateSecret.
         * @implements IUpdateSecret
         * @constructor
         * @param {response.IUpdateSecret=} [properties] Properties to set
         */
        function UpdateSecret(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateSecret status.
         * @member {response.Status} status
         * @memberof response.UpdateSecret
         * @instance
         */
        UpdateSecret.prototype.status = 0;

        /**
         * UpdateSecret message.
         * @member {string|null|undefined} message
         * @memberof response.UpdateSecret
         * @instance
         */
        UpdateSecret.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(UpdateSecret.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new UpdateSecret instance using the specified properties.
         * @function create
         * @memberof response.UpdateSecret
         * @static
         * @param {response.IUpdateSecret=} [properties] Properties to set
         * @returns {response.UpdateSecret} UpdateSecret instance
         */
        UpdateSecret.create = function create(properties) {
            return new UpdateSecret(properties);
        };

        /**
         * Encodes the specified UpdateSecret message. Does not implicitly {@link response.UpdateSecret.verify|verify} messages.
         * @function encode
         * @memberof response.UpdateSecret
         * @static
         * @param {response.IUpdateSecret} message UpdateSecret message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateSecret.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified UpdateSecret message, length delimited. Does not implicitly {@link response.UpdateSecret.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.UpdateSecret
         * @static
         * @param {response.IUpdateSecret} message UpdateSecret message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateSecret.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UpdateSecret message from the specified reader or buffer.
         * @function decode
         * @memberof response.UpdateSecret
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.UpdateSecret} UpdateSecret
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateSecret.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.UpdateSecret();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UpdateSecret message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.UpdateSecret
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.UpdateSecret} UpdateSecret
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateSecret.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UpdateSecret message.
         * @function verify
         * @memberof response.UpdateSecret
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UpdateSecret.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates an UpdateSecret message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.UpdateSecret
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.UpdateSecret} UpdateSecret
         */
        UpdateSecret.fromObject = function fromObject(object) {
            if (object instanceof $root.response.UpdateSecret)
                return object;
            let message = new $root.response.UpdateSecret();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from an UpdateSecret message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.UpdateSecret
         * @static
         * @param {response.UpdateSecret} message UpdateSecret
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateSecret.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this UpdateSecret to JSON.
         * @function toJSON
         * @memberof response.UpdateSecret
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateSecret.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for UpdateSecret
         * @function getTypeUrl
         * @memberof response.UpdateSecret
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        UpdateSecret.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.UpdateSecret";
        };

        return UpdateSecret;
    })();

    response.ListSecrets = (function() {

        /**
         * Properties of a ListSecrets.
         * @memberof response
         * @interface IListSecrets
         * @property {response.Status|null} [status] ListSecrets status
         * @property {string|null} [message] ListSecrets message
         * @property {Array.<response.ISecret>|null} [secrets] ListSecrets secrets
         */

        /**
         * Constructs a new ListSecrets.
         * @memberof response
         * @classdesc Represents a ListSecrets.
         * @implements IListSecrets
         * @constructor
         * @param {response.IListSecrets=} [properties] Properties to set
         */
        function ListSecrets(properties) {
            this.secrets = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListSecrets status.
         * @member {response.Status} status
         * @memberof response.ListSecrets
         * @instance
         */
        ListSecrets.prototype.status = 0;

        /**
         * ListSecrets message.
         * @member {string|null|undefined} message
         * @memberof response.ListSecrets
         * @instance
         */
        ListSecrets.prototype.message = null;

        /**
         * ListSecrets secrets.
         * @member {Array.<response.ISecret>} secrets
         * @memberof response.ListSecrets
         * @instance
         */
        ListSecrets.prototype.secrets = $util.emptyArray;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(ListSecrets.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new ListSecrets instance using the specified properties.
         * @function create
         * @memberof response.ListSecrets
         * @static
         * @param {response.IListSecrets=} [properties] Properties to set
         * @returns {response.ListSecrets} ListSecrets instance
         */
        ListSecrets.create = function create(properties) {
            return new ListSecrets(properties);
        };

        /**
         * Encodes the specified ListSecrets message. Does not implicitly {@link response.ListSecrets.verify|verify} messages.
         * @function encode
         * @memberof response.ListSecrets
         * @static
         * @param {response.IListSecrets} message ListSecrets message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListSecrets.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            if (message.secrets != null && message.secrets.length)
                for (let i = 0; i < message.secrets.length; ++i)
                    $root.response.Secret.encode(message.secrets[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified ListSecrets message, length delimited. Does not implicitly {@link response.ListSecrets.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.ListSecrets
         * @static
         * @param {response.IListSecrets} message ListSecrets message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListSecrets.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ListSecrets message from the specified reader or buffer.
         * @function decode
         * @memberof response.ListSecrets
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.ListSecrets} ListSecrets
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListSecrets.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.ListSecrets();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                case 3: {
                        if (!(message.secrets && message.secrets.length))
                            message.secrets = [];
                        message.secrets.push($root.response.Secret.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ListSecrets message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.ListSecrets
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.ListSecrets} ListSecrets
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListSecrets.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ListSecrets message.
         * @function verify
         * @memberof response.ListSecrets
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ListSecrets.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            if (message.secrets != null && message.hasOwnProperty("secrets")) {
                if (!Array.isArray(message.secrets))
                    return "secrets: array expected";
                for (let i = 0; i < message.secrets.length; ++i) {
                    let error = $root.response.Secret.verify(message.secrets[i]);
                    if (error)
                        return "secrets." + error;
                }
            }
            return null;
        };

        /**
         * Creates a ListSecrets message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.ListSecrets
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.ListSecrets} ListSecrets
         */
        ListSecrets.fromObject = function fromObject(object) {
            if (object instanceof $root.response.ListSecrets)
                return object;
            let message = new $root.response.ListSecrets();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            if (object.secrets) {
                if (!Array.isArray(object.secrets))
                    throw TypeError(".response.ListSecrets.secrets: array expected");
                message.secrets = [];
                for (let i = 0; i < object.secrets.length; ++i) {
                    if (typeof object.secrets[i] !== "object")
                        throw TypeError(".response.ListSecrets.secrets: object expected");
                    message.secrets[i] = $root.response.Secret.fromObject(object.secrets[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a ListSecrets message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.ListSecrets
         * @static
         * @param {response.ListSecrets} message ListSecrets
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListSecrets.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.secrets = [];
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            if (message.secrets && message.secrets.length) {
                object.secrets = [];
                for (let j = 0; j < message.secrets.length; ++j)
                    object.secrets[j] = $root.response.Secret.toObject(message.secrets[j], options);
            }
            return object;
        };

        /**
         * Converts this ListSecrets to JSON.
         * @function toJSON
         * @memberof response.ListSecrets
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListSecrets.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ListSecrets
         * @function getTypeUrl
         * @memberof response.ListSecrets
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ListSecrets.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.ListSecrets";
        };

        return ListSecrets;
    })();

    response.QuickSecret = (function() {

        /**
         * Properties of a QuickSecret.
         * @memberof response
         * @interface IQuickSecret
         * @property {string|null} [path] QuickSecret path
         * @property {number|Long|null} [expiry] QuickSecret expiry
         */

        /**
         * Constructs a new QuickSecret.
         * @memberof response
         * @classdesc Represents a QuickSecret.
         * @implements IQuickSecret
         * @constructor
         * @param {response.IQuickSecret=} [properties] Properties to set
         */
        function QuickSecret(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * QuickSecret path.
         * @member {string} path
         * @memberof response.QuickSecret
         * @instance
         */
        QuickSecret.prototype.path = "";

        /**
         * QuickSecret expiry.
         * @member {number|Long} expiry
         * @memberof response.QuickSecret
         * @instance
         */
        QuickSecret.prototype.expiry = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new QuickSecret instance using the specified properties.
         * @function create
         * @memberof response.QuickSecret
         * @static
         * @param {response.IQuickSecret=} [properties] Properties to set
         * @returns {response.QuickSecret} QuickSecret instance
         */
        QuickSecret.create = function create(properties) {
            return new QuickSecret(properties);
        };

        /**
         * Encodes the specified QuickSecret message. Does not implicitly {@link response.QuickSecret.verify|verify} messages.
         * @function encode
         * @memberof response.QuickSecret
         * @static
         * @param {response.IQuickSecret} message QuickSecret message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        QuickSecret.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.path != null && Object.hasOwnProperty.call(message, "path"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.path);
            if (message.expiry != null && Object.hasOwnProperty.call(message, "expiry"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.expiry);
            return writer;
        };

        /**
         * Encodes the specified QuickSecret message, length delimited. Does not implicitly {@link response.QuickSecret.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.QuickSecret
         * @static
         * @param {response.IQuickSecret} message QuickSecret message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        QuickSecret.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a QuickSecret message from the specified reader or buffer.
         * @function decode
         * @memberof response.QuickSecret
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.QuickSecret} QuickSecret
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        QuickSecret.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.QuickSecret();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.path = reader.string();
                        break;
                    }
                case 2: {
                        message.expiry = reader.uint64();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a QuickSecret message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.QuickSecret
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.QuickSecret} QuickSecret
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        QuickSecret.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a QuickSecret message.
         * @function verify
         * @memberof response.QuickSecret
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        QuickSecret.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.path != null && message.hasOwnProperty("path"))
                if (!$util.isString(message.path))
                    return "path: string expected";
            if (message.expiry != null && message.hasOwnProperty("expiry"))
                if (!$util.isInteger(message.expiry) && !(message.expiry && $util.isInteger(message.expiry.low) && $util.isInteger(message.expiry.high)))
                    return "expiry: integer|Long expected";
            return null;
        };

        /**
         * Creates a QuickSecret message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.QuickSecret
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.QuickSecret} QuickSecret
         */
        QuickSecret.fromObject = function fromObject(object) {
            if (object instanceof $root.response.QuickSecret)
                return object;
            let message = new $root.response.QuickSecret();
            if (object.path != null)
                message.path = String(object.path);
            if (object.expiry != null)
                if ($util.Long)
                    (message.expiry = $util.Long.fromValue(object.expiry)).unsigned = true;
                else if (typeof object.expiry === "string")
                    message.expiry = parseInt(object.expiry, 10);
                else if (typeof object.expiry === "number")
                    message.expiry = object.expiry;
                else if (typeof object.expiry === "object")
                    message.expiry = new $util.LongBits(object.expiry.low >>> 0, object.expiry.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a QuickSecret message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.QuickSecret
         * @static
         * @param {response.QuickSecret} message QuickSecret
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        QuickSecret.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.path = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.expiry = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.expiry = options.longs === String ? "0" : 0;
            }
            if (message.path != null && message.hasOwnProperty("path"))
                object.path = message.path;
            if (message.expiry != null && message.hasOwnProperty("expiry"))
                if (typeof message.expiry === "number")
                    object.expiry = options.longs === String ? String(message.expiry) : message.expiry;
                else
                    object.expiry = options.longs === String ? $util.Long.prototype.toString.call(message.expiry) : options.longs === Number ? new $util.LongBits(message.expiry.low >>> 0, message.expiry.high >>> 0).toNumber(true) : message.expiry;
            return object;
        };

        /**
         * Converts this QuickSecret to JSON.
         * @function toJSON
         * @memberof response.QuickSecret
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        QuickSecret.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for QuickSecret
         * @function getTypeUrl
         * @memberof response.QuickSecret
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        QuickSecret.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.QuickSecret";
        };

        return QuickSecret;
    })();

    response.QuickListSecrets = (function() {

        /**
         * Properties of a QuickListSecrets.
         * @memberof response
         * @interface IQuickListSecrets
         * @property {response.Status|null} [status] QuickListSecrets status
         * @property {string|null} [message] QuickListSecrets message
         * @property {Array.<response.IQuickSecret>|null} [quickSecrets] QuickListSecrets quickSecrets
         */

        /**
         * Constructs a new QuickListSecrets.
         * @memberof response
         * @classdesc Represents a QuickListSecrets.
         * @implements IQuickListSecrets
         * @constructor
         * @param {response.IQuickListSecrets=} [properties] Properties to set
         */
        function QuickListSecrets(properties) {
            this.quickSecrets = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * QuickListSecrets status.
         * @member {response.Status} status
         * @memberof response.QuickListSecrets
         * @instance
         */
        QuickListSecrets.prototype.status = 0;

        /**
         * QuickListSecrets message.
         * @member {string|null|undefined} message
         * @memberof response.QuickListSecrets
         * @instance
         */
        QuickListSecrets.prototype.message = null;

        /**
         * QuickListSecrets quickSecrets.
         * @member {Array.<response.IQuickSecret>} quickSecrets
         * @memberof response.QuickListSecrets
         * @instance
         */
        QuickListSecrets.prototype.quickSecrets = $util.emptyArray;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(QuickListSecrets.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new QuickListSecrets instance using the specified properties.
         * @function create
         * @memberof response.QuickListSecrets
         * @static
         * @param {response.IQuickListSecrets=} [properties] Properties to set
         * @returns {response.QuickListSecrets} QuickListSecrets instance
         */
        QuickListSecrets.create = function create(properties) {
            return new QuickListSecrets(properties);
        };

        /**
         * Encodes the specified QuickListSecrets message. Does not implicitly {@link response.QuickListSecrets.verify|verify} messages.
         * @function encode
         * @memberof response.QuickListSecrets
         * @static
         * @param {response.IQuickListSecrets} message QuickListSecrets message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        QuickListSecrets.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            if (message.quickSecrets != null && message.quickSecrets.length)
                for (let i = 0; i < message.quickSecrets.length; ++i)
                    $root.response.QuickSecret.encode(message.quickSecrets[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified QuickListSecrets message, length delimited. Does not implicitly {@link response.QuickListSecrets.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.QuickListSecrets
         * @static
         * @param {response.IQuickListSecrets} message QuickListSecrets message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        QuickListSecrets.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a QuickListSecrets message from the specified reader or buffer.
         * @function decode
         * @memberof response.QuickListSecrets
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.QuickListSecrets} QuickListSecrets
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        QuickListSecrets.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.QuickListSecrets();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                case 3: {
                        if (!(message.quickSecrets && message.quickSecrets.length))
                            message.quickSecrets = [];
                        message.quickSecrets.push($root.response.QuickSecret.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a QuickListSecrets message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.QuickListSecrets
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.QuickListSecrets} QuickListSecrets
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        QuickListSecrets.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a QuickListSecrets message.
         * @function verify
         * @memberof response.QuickListSecrets
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        QuickListSecrets.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            if (message.quickSecrets != null && message.hasOwnProperty("quickSecrets")) {
                if (!Array.isArray(message.quickSecrets))
                    return "quickSecrets: array expected";
                for (let i = 0; i < message.quickSecrets.length; ++i) {
                    let error = $root.response.QuickSecret.verify(message.quickSecrets[i]);
                    if (error)
                        return "quickSecrets." + error;
                }
            }
            return null;
        };

        /**
         * Creates a QuickListSecrets message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.QuickListSecrets
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.QuickListSecrets} QuickListSecrets
         */
        QuickListSecrets.fromObject = function fromObject(object) {
            if (object instanceof $root.response.QuickListSecrets)
                return object;
            let message = new $root.response.QuickListSecrets();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            if (object.quickSecrets) {
                if (!Array.isArray(object.quickSecrets))
                    throw TypeError(".response.QuickListSecrets.quickSecrets: array expected");
                message.quickSecrets = [];
                for (let i = 0; i < object.quickSecrets.length; ++i) {
                    if (typeof object.quickSecrets[i] !== "object")
                        throw TypeError(".response.QuickListSecrets.quickSecrets: object expected");
                    message.quickSecrets[i] = $root.response.QuickSecret.fromObject(object.quickSecrets[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a QuickListSecrets message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.QuickListSecrets
         * @static
         * @param {response.QuickListSecrets} message QuickListSecrets
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        QuickListSecrets.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.quickSecrets = [];
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            if (message.quickSecrets && message.quickSecrets.length) {
                object.quickSecrets = [];
                for (let j = 0; j < message.quickSecrets.length; ++j)
                    object.quickSecrets[j] = $root.response.QuickSecret.toObject(message.quickSecrets[j], options);
            }
            return object;
        };

        /**
         * Converts this QuickListSecrets to JSON.
         * @function toJSON
         * @memberof response.QuickListSecrets
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        QuickListSecrets.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for QuickListSecrets
         * @function getTypeUrl
         * @memberof response.QuickListSecrets
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        QuickListSecrets.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.QuickListSecrets";
        };

        return QuickListSecrets;
    })();

    response.ListSecretSubkeys = (function() {

        /**
         * Properties of a ListSecretSubkeys.
         * @memberof response
         * @interface IListSecretSubkeys
         * @property {response.Status|null} [status] ListSecretSubkeys status
         * @property {string|null} [message] ListSecretSubkeys message
         * @property {Array.<string>|null} [subkeys] ListSecretSubkeys subkeys
         */

        /**
         * Constructs a new ListSecretSubkeys.
         * @memberof response
         * @classdesc Represents a ListSecretSubkeys.
         * @implements IListSecretSubkeys
         * @constructor
         * @param {response.IListSecretSubkeys=} [properties] Properties to set
         */
        function ListSecretSubkeys(properties) {
            this.subkeys = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListSecretSubkeys status.
         * @member {response.Status} status
         * @memberof response.ListSecretSubkeys
         * @instance
         */
        ListSecretSubkeys.prototype.status = 0;

        /**
         * ListSecretSubkeys message.
         * @member {string|null|undefined} message
         * @memberof response.ListSecretSubkeys
         * @instance
         */
        ListSecretSubkeys.prototype.message = null;

        /**
         * ListSecretSubkeys subkeys.
         * @member {Array.<string>} subkeys
         * @memberof response.ListSecretSubkeys
         * @instance
         */
        ListSecretSubkeys.prototype.subkeys = $util.emptyArray;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(ListSecretSubkeys.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new ListSecretSubkeys instance using the specified properties.
         * @function create
         * @memberof response.ListSecretSubkeys
         * @static
         * @param {response.IListSecretSubkeys=} [properties] Properties to set
         * @returns {response.ListSecretSubkeys} ListSecretSubkeys instance
         */
        ListSecretSubkeys.create = function create(properties) {
            return new ListSecretSubkeys(properties);
        };

        /**
         * Encodes the specified ListSecretSubkeys message. Does not implicitly {@link response.ListSecretSubkeys.verify|verify} messages.
         * @function encode
         * @memberof response.ListSecretSubkeys
         * @static
         * @param {response.IListSecretSubkeys} message ListSecretSubkeys message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListSecretSubkeys.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            if (message.subkeys != null && message.subkeys.length)
                for (let i = 0; i < message.subkeys.length; ++i)
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.subkeys[i]);
            return writer;
        };

        /**
         * Encodes the specified ListSecretSubkeys message, length delimited. Does not implicitly {@link response.ListSecretSubkeys.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.ListSecretSubkeys
         * @static
         * @param {response.IListSecretSubkeys} message ListSecretSubkeys message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListSecretSubkeys.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ListSecretSubkeys message from the specified reader or buffer.
         * @function decode
         * @memberof response.ListSecretSubkeys
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.ListSecretSubkeys} ListSecretSubkeys
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListSecretSubkeys.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.ListSecretSubkeys();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                case 3: {
                        if (!(message.subkeys && message.subkeys.length))
                            message.subkeys = [];
                        message.subkeys.push(reader.string());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ListSecretSubkeys message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.ListSecretSubkeys
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.ListSecretSubkeys} ListSecretSubkeys
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListSecretSubkeys.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ListSecretSubkeys message.
         * @function verify
         * @memberof response.ListSecretSubkeys
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ListSecretSubkeys.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            if (message.subkeys != null && message.hasOwnProperty("subkeys")) {
                if (!Array.isArray(message.subkeys))
                    return "subkeys: array expected";
                for (let i = 0; i < message.subkeys.length; ++i)
                    if (!$util.isString(message.subkeys[i]))
                        return "subkeys: string[] expected";
            }
            return null;
        };

        /**
         * Creates a ListSecretSubkeys message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.ListSecretSubkeys
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.ListSecretSubkeys} ListSecretSubkeys
         */
        ListSecretSubkeys.fromObject = function fromObject(object) {
            if (object instanceof $root.response.ListSecretSubkeys)
                return object;
            let message = new $root.response.ListSecretSubkeys();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            if (object.subkeys) {
                if (!Array.isArray(object.subkeys))
                    throw TypeError(".response.ListSecretSubkeys.subkeys: array expected");
                message.subkeys = [];
                for (let i = 0; i < object.subkeys.length; ++i)
                    message.subkeys[i] = String(object.subkeys[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a ListSecretSubkeys message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.ListSecretSubkeys
         * @static
         * @param {response.ListSecretSubkeys} message ListSecretSubkeys
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListSecretSubkeys.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.subkeys = [];
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            if (message.subkeys && message.subkeys.length) {
                object.subkeys = [];
                for (let j = 0; j < message.subkeys.length; ++j)
                    object.subkeys[j] = message.subkeys[j];
            }
            return object;
        };

        /**
         * Converts this ListSecretSubkeys to JSON.
         * @function toJSON
         * @memberof response.ListSecretSubkeys
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListSecretSubkeys.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ListSecretSubkeys
         * @function getTypeUrl
         * @memberof response.ListSecretSubkeys
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ListSecretSubkeys.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.ListSecretSubkeys";
        };

        return ListSecretSubkeys;
    })();

    response.UndeleteSecret = (function() {

        /**
         * Properties of an UndeleteSecret.
         * @memberof response
         * @interface IUndeleteSecret
         * @property {response.Status|null} [status] UndeleteSecret status
         * @property {string|null} [message] UndeleteSecret message
         */

        /**
         * Constructs a new UndeleteSecret.
         * @memberof response
         * @classdesc Represents an UndeleteSecret.
         * @implements IUndeleteSecret
         * @constructor
         * @param {response.IUndeleteSecret=} [properties] Properties to set
         */
        function UndeleteSecret(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UndeleteSecret status.
         * @member {response.Status} status
         * @memberof response.UndeleteSecret
         * @instance
         */
        UndeleteSecret.prototype.status = 0;

        /**
         * UndeleteSecret message.
         * @member {string|null|undefined} message
         * @memberof response.UndeleteSecret
         * @instance
         */
        UndeleteSecret.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(UndeleteSecret.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new UndeleteSecret instance using the specified properties.
         * @function create
         * @memberof response.UndeleteSecret
         * @static
         * @param {response.IUndeleteSecret=} [properties] Properties to set
         * @returns {response.UndeleteSecret} UndeleteSecret instance
         */
        UndeleteSecret.create = function create(properties) {
            return new UndeleteSecret(properties);
        };

        /**
         * Encodes the specified UndeleteSecret message. Does not implicitly {@link response.UndeleteSecret.verify|verify} messages.
         * @function encode
         * @memberof response.UndeleteSecret
         * @static
         * @param {response.IUndeleteSecret} message UndeleteSecret message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UndeleteSecret.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified UndeleteSecret message, length delimited. Does not implicitly {@link response.UndeleteSecret.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.UndeleteSecret
         * @static
         * @param {response.IUndeleteSecret} message UndeleteSecret message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UndeleteSecret.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UndeleteSecret message from the specified reader or buffer.
         * @function decode
         * @memberof response.UndeleteSecret
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.UndeleteSecret} UndeleteSecret
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UndeleteSecret.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.UndeleteSecret();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UndeleteSecret message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.UndeleteSecret
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.UndeleteSecret} UndeleteSecret
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UndeleteSecret.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UndeleteSecret message.
         * @function verify
         * @memberof response.UndeleteSecret
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UndeleteSecret.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates an UndeleteSecret message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.UndeleteSecret
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.UndeleteSecret} UndeleteSecret
         */
        UndeleteSecret.fromObject = function fromObject(object) {
            if (object instanceof $root.response.UndeleteSecret)
                return object;
            let message = new $root.response.UndeleteSecret();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from an UndeleteSecret message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.UndeleteSecret
         * @static
         * @param {response.UndeleteSecret} message UndeleteSecret
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UndeleteSecret.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this UndeleteSecret to JSON.
         * @function toJSON
         * @memberof response.UndeleteSecret
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UndeleteSecret.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for UndeleteSecret
         * @function getTypeUrl
         * @memberof response.UndeleteSecret
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        UndeleteSecret.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.UndeleteSecret";
        };

        return UndeleteSecret;
    })();

    response.Password = (function() {

        /**
         * Properties of a Password.
         * @memberof response
         * @interface IPassword
         * @property {string|null} [username] Password username
         * @property {string|null} [password] Password password
         * @property {string|null} [url] Password url
         * @property {string|null} [totpSecret] Password totpSecret
         * @property {string|null} [notes] Password notes
         */

        /**
         * Constructs a new Password.
         * @memberof response
         * @classdesc Represents a Password.
         * @implements IPassword
         * @constructor
         * @param {response.IPassword=} [properties] Properties to set
         */
        function Password(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Password username.
         * @member {string} username
         * @memberof response.Password
         * @instance
         */
        Password.prototype.username = "";

        /**
         * Password password.
         * @member {string} password
         * @memberof response.Password
         * @instance
         */
        Password.prototype.password = "";

        /**
         * Password url.
         * @member {string} url
         * @memberof response.Password
         * @instance
         */
        Password.prototype.url = "";

        /**
         * Password totpSecret.
         * @member {string} totpSecret
         * @memberof response.Password
         * @instance
         */
        Password.prototype.totpSecret = "";

        /**
         * Password notes.
         * @member {string} notes
         * @memberof response.Password
         * @instance
         */
        Password.prototype.notes = "";

        /**
         * Creates a new Password instance using the specified properties.
         * @function create
         * @memberof response.Password
         * @static
         * @param {response.IPassword=} [properties] Properties to set
         * @returns {response.Password} Password instance
         */
        Password.create = function create(properties) {
            return new Password(properties);
        };

        /**
         * Encodes the specified Password message. Does not implicitly {@link response.Password.verify|verify} messages.
         * @function encode
         * @memberof response.Password
         * @static
         * @param {response.IPassword} message Password message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Password.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.username != null && Object.hasOwnProperty.call(message, "username"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.username);
            if (message.password != null && Object.hasOwnProperty.call(message, "password"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.password);
            if (message.url != null && Object.hasOwnProperty.call(message, "url"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.url);
            if (message.notes != null && Object.hasOwnProperty.call(message, "notes"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.notes);
            if (message.totpSecret != null && Object.hasOwnProperty.call(message, "totpSecret"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.totpSecret);
            return writer;
        };

        /**
         * Encodes the specified Password message, length delimited. Does not implicitly {@link response.Password.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.Password
         * @static
         * @param {response.IPassword} message Password message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Password.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Password message from the specified reader or buffer.
         * @function decode
         * @memberof response.Password
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.Password} Password
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Password.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.Password();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 2: {
                        message.username = reader.string();
                        break;
                    }
                case 3: {
                        message.password = reader.string();
                        break;
                    }
                case 4: {
                        message.url = reader.string();
                        break;
                    }
                case 6: {
                        message.totpSecret = reader.string();
                        break;
                    }
                case 5: {
                        message.notes = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Password message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.Password
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.Password} Password
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Password.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Password message.
         * @function verify
         * @memberof response.Password
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Password.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.username != null && message.hasOwnProperty("username"))
                if (!$util.isString(message.username))
                    return "username: string expected";
            if (message.password != null && message.hasOwnProperty("password"))
                if (!$util.isString(message.password))
                    return "password: string expected";
            if (message.url != null && message.hasOwnProperty("url"))
                if (!$util.isString(message.url))
                    return "url: string expected";
            if (message.totpSecret != null && message.hasOwnProperty("totpSecret"))
                if (!$util.isString(message.totpSecret))
                    return "totpSecret: string expected";
            if (message.notes != null && message.hasOwnProperty("notes"))
                if (!$util.isString(message.notes))
                    return "notes: string expected";
            return null;
        };

        /**
         * Creates a Password message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.Password
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.Password} Password
         */
        Password.fromObject = function fromObject(object) {
            if (object instanceof $root.response.Password)
                return object;
            let message = new $root.response.Password();
            if (object.username != null)
                message.username = String(object.username);
            if (object.password != null)
                message.password = String(object.password);
            if (object.url != null)
                message.url = String(object.url);
            if (object.totpSecret != null)
                message.totpSecret = String(object.totpSecret);
            if (object.notes != null)
                message.notes = String(object.notes);
            return message;
        };

        /**
         * Creates a plain object from a Password message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.Password
         * @static
         * @param {response.Password} message Password
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Password.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.username = "";
                object.password = "";
                object.url = "";
                object.notes = "";
                object.totpSecret = "";
            }
            if (message.username != null && message.hasOwnProperty("username"))
                object.username = message.username;
            if (message.password != null && message.hasOwnProperty("password"))
                object.password = message.password;
            if (message.url != null && message.hasOwnProperty("url"))
                object.url = message.url;
            if (message.notes != null && message.hasOwnProperty("notes"))
                object.notes = message.notes;
            if (message.totpSecret != null && message.hasOwnProperty("totpSecret"))
                object.totpSecret = message.totpSecret;
            return object;
        };

        /**
         * Converts this Password to JSON.
         * @function toJSON
         * @memberof response.Password
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Password.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Password
         * @function getTypeUrl
         * @memberof response.Password
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Password.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.Password";
        };

        return Password;
    })();

    response.Card = (function() {

        /**
         * Properties of a Card.
         * @memberof response
         * @interface ICard
         * @property {string|null} [number] Card number
         * @property {string|null} [cvv] Card cvv
         * @property {string|null} [expiry] Card expiry
         * @property {string|null} [notes] Card notes
         */

        /**
         * Constructs a new Card.
         * @memberof response
         * @classdesc Represents a Card.
         * @implements ICard
         * @constructor
         * @param {response.ICard=} [properties] Properties to set
         */
        function Card(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Card number.
         * @member {string} number
         * @memberof response.Card
         * @instance
         */
        Card.prototype.number = "";

        /**
         * Card cvv.
         * @member {string} cvv
         * @memberof response.Card
         * @instance
         */
        Card.prototype.cvv = "";

        /**
         * Card expiry.
         * @member {string} expiry
         * @memberof response.Card
         * @instance
         */
        Card.prototype.expiry = "";

        /**
         * Card notes.
         * @member {string} notes
         * @memberof response.Card
         * @instance
         */
        Card.prototype.notes = "";

        /**
         * Creates a new Card instance using the specified properties.
         * @function create
         * @memberof response.Card
         * @static
         * @param {response.ICard=} [properties] Properties to set
         * @returns {response.Card} Card instance
         */
        Card.create = function create(properties) {
            return new Card(properties);
        };

        /**
         * Encodes the specified Card message. Does not implicitly {@link response.Card.verify|verify} messages.
         * @function encode
         * @memberof response.Card
         * @static
         * @param {response.ICard} message Card message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Card.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.number != null && Object.hasOwnProperty.call(message, "number"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.number);
            if (message.cvv != null && Object.hasOwnProperty.call(message, "cvv"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.cvv);
            if (message.expiry != null && Object.hasOwnProperty.call(message, "expiry"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.expiry);
            if (message.notes != null && Object.hasOwnProperty.call(message, "notes"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.notes);
            return writer;
        };

        /**
         * Encodes the specified Card message, length delimited. Does not implicitly {@link response.Card.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.Card
         * @static
         * @param {response.ICard} message Card message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Card.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Card message from the specified reader or buffer.
         * @function decode
         * @memberof response.Card
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.Card} Card
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Card.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.Card();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 2: {
                        message.number = reader.string();
                        break;
                    }
                case 3: {
                        message.cvv = reader.string();
                        break;
                    }
                case 4: {
                        message.expiry = reader.string();
                        break;
                    }
                case 5: {
                        message.notes = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Card message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.Card
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.Card} Card
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Card.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Card message.
         * @function verify
         * @memberof response.Card
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Card.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.number != null && message.hasOwnProperty("number"))
                if (!$util.isString(message.number))
                    return "number: string expected";
            if (message.cvv != null && message.hasOwnProperty("cvv"))
                if (!$util.isString(message.cvv))
                    return "cvv: string expected";
            if (message.expiry != null && message.hasOwnProperty("expiry"))
                if (!$util.isString(message.expiry))
                    return "expiry: string expected";
            if (message.notes != null && message.hasOwnProperty("notes"))
                if (!$util.isString(message.notes))
                    return "notes: string expected";
            return null;
        };

        /**
         * Creates a Card message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.Card
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.Card} Card
         */
        Card.fromObject = function fromObject(object) {
            if (object instanceof $root.response.Card)
                return object;
            let message = new $root.response.Card();
            if (object.number != null)
                message.number = String(object.number);
            if (object.cvv != null)
                message.cvv = String(object.cvv);
            if (object.expiry != null)
                message.expiry = String(object.expiry);
            if (object.notes != null)
                message.notes = String(object.notes);
            return message;
        };

        /**
         * Creates a plain object from a Card message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.Card
         * @static
         * @param {response.Card} message Card
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Card.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.number = "";
                object.cvv = "";
                object.expiry = "";
                object.notes = "";
            }
            if (message.number != null && message.hasOwnProperty("number"))
                object.number = message.number;
            if (message.cvv != null && message.hasOwnProperty("cvv"))
                object.cvv = message.cvv;
            if (message.expiry != null && message.hasOwnProperty("expiry"))
                object.expiry = message.expiry;
            if (message.notes != null && message.hasOwnProperty("notes"))
                object.notes = message.notes;
            return object;
        };

        /**
         * Converts this Card to JSON.
         * @function toJSON
         * @memberof response.Card
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Card.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Card
         * @function getTypeUrl
         * @memberof response.Card
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Card.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.Card";
        };

        return Card;
    })();

    response.Note = (function() {

        /**
         * Properties of a Note.
         * @memberof response
         * @interface INote
         * @property {string|null} [content] Note content
         */

        /**
         * Constructs a new Note.
         * @memberof response
         * @classdesc Represents a Note.
         * @implements INote
         * @constructor
         * @param {response.INote=} [properties] Properties to set
         */
        function Note(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Note content.
         * @member {string} content
         * @memberof response.Note
         * @instance
         */
        Note.prototype.content = "";

        /**
         * Creates a new Note instance using the specified properties.
         * @function create
         * @memberof response.Note
         * @static
         * @param {response.INote=} [properties] Properties to set
         * @returns {response.Note} Note instance
         */
        Note.create = function create(properties) {
            return new Note(properties);
        };

        /**
         * Encodes the specified Note message. Does not implicitly {@link response.Note.verify|verify} messages.
         * @function encode
         * @memberof response.Note
         * @static
         * @param {response.INote} message Note message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Note.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.content != null && Object.hasOwnProperty.call(message, "content"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.content);
            return writer;
        };

        /**
         * Encodes the specified Note message, length delimited. Does not implicitly {@link response.Note.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.Note
         * @static
         * @param {response.INote} message Note message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Note.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Note message from the specified reader or buffer.
         * @function decode
         * @memberof response.Note
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.Note} Note
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Note.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.Note();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 2: {
                        message.content = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Note message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.Note
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.Note} Note
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Note.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Note message.
         * @function verify
         * @memberof response.Note
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Note.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.content != null && message.hasOwnProperty("content"))
                if (!$util.isString(message.content))
                    return "content: string expected";
            return null;
        };

        /**
         * Creates a Note message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.Note
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.Note} Note
         */
        Note.fromObject = function fromObject(object) {
            if (object instanceof $root.response.Note)
                return object;
            let message = new $root.response.Note();
            if (object.content != null)
                message.content = String(object.content);
            return message;
        };

        /**
         * Creates a plain object from a Note message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.Note
         * @static
         * @param {response.Note} message Note
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Note.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.content = "";
            if (message.content != null && message.hasOwnProperty("content"))
                object.content = message.content;
            return object;
        };

        /**
         * Converts this Note to JSON.
         * @function toJSON
         * @memberof response.Note
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Note.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Note
         * @function getTypeUrl
         * @memberof response.Note
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Note.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.Note";
        };

        return Note;
    })();

    response.Identity = (function() {

        /**
         * Properties of an Identity.
         * @memberof response
         * @interface IIdentity
         * @property {string|null} [number] Identity number
         * @property {string|null} [notes] Identity notes
         */

        /**
         * Constructs a new Identity.
         * @memberof response
         * @classdesc Represents an Identity.
         * @implements IIdentity
         * @constructor
         * @param {response.IIdentity=} [properties] Properties to set
         */
        function Identity(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Identity number.
         * @member {string} number
         * @memberof response.Identity
         * @instance
         */
        Identity.prototype.number = "";

        /**
         * Identity notes.
         * @member {string} notes
         * @memberof response.Identity
         * @instance
         */
        Identity.prototype.notes = "";

        /**
         * Creates a new Identity instance using the specified properties.
         * @function create
         * @memberof response.Identity
         * @static
         * @param {response.IIdentity=} [properties] Properties to set
         * @returns {response.Identity} Identity instance
         */
        Identity.create = function create(properties) {
            return new Identity(properties);
        };

        /**
         * Encodes the specified Identity message. Does not implicitly {@link response.Identity.verify|verify} messages.
         * @function encode
         * @memberof response.Identity
         * @static
         * @param {response.IIdentity} message Identity message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Identity.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.number != null && Object.hasOwnProperty.call(message, "number"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.number);
            if (message.notes != null && Object.hasOwnProperty.call(message, "notes"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.notes);
            return writer;
        };

        /**
         * Encodes the specified Identity message, length delimited. Does not implicitly {@link response.Identity.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.Identity
         * @static
         * @param {response.IIdentity} message Identity message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Identity.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an Identity message from the specified reader or buffer.
         * @function decode
         * @memberof response.Identity
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.Identity} Identity
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Identity.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.Identity();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 2: {
                        message.number = reader.string();
                        break;
                    }
                case 5: {
                        message.notes = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an Identity message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.Identity
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.Identity} Identity
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Identity.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an Identity message.
         * @function verify
         * @memberof response.Identity
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Identity.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.number != null && message.hasOwnProperty("number"))
                if (!$util.isString(message.number))
                    return "number: string expected";
            if (message.notes != null && message.hasOwnProperty("notes"))
                if (!$util.isString(message.notes))
                    return "notes: string expected";
            return null;
        };

        /**
         * Creates an Identity message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.Identity
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.Identity} Identity
         */
        Identity.fromObject = function fromObject(object) {
            if (object instanceof $root.response.Identity)
                return object;
            let message = new $root.response.Identity();
            if (object.number != null)
                message.number = String(object.number);
            if (object.notes != null)
                message.notes = String(object.notes);
            return message;
        };

        /**
         * Creates a plain object from an Identity message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.Identity
         * @static
         * @param {response.Identity} message Identity
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Identity.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.number = "";
                object.notes = "";
            }
            if (message.number != null && message.hasOwnProperty("number"))
                object.number = message.number;
            if (message.notes != null && message.hasOwnProperty("notes"))
                object.notes = message.notes;
            return object;
        };

        /**
         * Converts this Identity to JSON.
         * @function toJSON
         * @memberof response.Identity
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Identity.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Identity
         * @function getTypeUrl
         * @memberof response.Identity
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Identity.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.Identity";
        };

        return Identity;
    })();

    response.KeyValue = (function() {

        /**
         * Properties of a KeyValue.
         * @memberof response
         * @interface IKeyValue
         * @property {Array.<string>|null} [key] KeyValue key
         * @property {Array.<string>|null} [value] KeyValue value
         */

        /**
         * Constructs a new KeyValue.
         * @memberof response
         * @classdesc Represents a KeyValue.
         * @implements IKeyValue
         * @constructor
         * @param {response.IKeyValue=} [properties] Properties to set
         */
        function KeyValue(properties) {
            this.key = [];
            this.value = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * KeyValue key.
         * @member {Array.<string>} key
         * @memberof response.KeyValue
         * @instance
         */
        KeyValue.prototype.key = $util.emptyArray;

        /**
         * KeyValue value.
         * @member {Array.<string>} value
         * @memberof response.KeyValue
         * @instance
         */
        KeyValue.prototype.value = $util.emptyArray;

        /**
         * Creates a new KeyValue instance using the specified properties.
         * @function create
         * @memberof response.KeyValue
         * @static
         * @param {response.IKeyValue=} [properties] Properties to set
         * @returns {response.KeyValue} KeyValue instance
         */
        KeyValue.create = function create(properties) {
            return new KeyValue(properties);
        };

        /**
         * Encodes the specified KeyValue message. Does not implicitly {@link response.KeyValue.verify|verify} messages.
         * @function encode
         * @memberof response.KeyValue
         * @static
         * @param {response.IKeyValue} message KeyValue message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        KeyValue.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.key != null && message.key.length)
                for (let i = 0; i < message.key.length; ++i)
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.key[i]);
            if (message.value != null && message.value.length)
                for (let i = 0; i < message.value.length; ++i)
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.value[i]);
            return writer;
        };

        /**
         * Encodes the specified KeyValue message, length delimited. Does not implicitly {@link response.KeyValue.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.KeyValue
         * @static
         * @param {response.IKeyValue} message KeyValue message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        KeyValue.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a KeyValue message from the specified reader or buffer.
         * @function decode
         * @memberof response.KeyValue
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.KeyValue} KeyValue
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        KeyValue.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.KeyValue();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        if (!(message.key && message.key.length))
                            message.key = [];
                        message.key.push(reader.string());
                        break;
                    }
                case 2: {
                        if (!(message.value && message.value.length))
                            message.value = [];
                        message.value.push(reader.string());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a KeyValue message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.KeyValue
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.KeyValue} KeyValue
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        KeyValue.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a KeyValue message.
         * @function verify
         * @memberof response.KeyValue
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        KeyValue.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.key != null && message.hasOwnProperty("key")) {
                if (!Array.isArray(message.key))
                    return "key: array expected";
                for (let i = 0; i < message.key.length; ++i)
                    if (!$util.isString(message.key[i]))
                        return "key: string[] expected";
            }
            if (message.value != null && message.hasOwnProperty("value")) {
                if (!Array.isArray(message.value))
                    return "value: array expected";
                for (let i = 0; i < message.value.length; ++i)
                    if (!$util.isString(message.value[i]))
                        return "value: string[] expected";
            }
            return null;
        };

        /**
         * Creates a KeyValue message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.KeyValue
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.KeyValue} KeyValue
         */
        KeyValue.fromObject = function fromObject(object) {
            if (object instanceof $root.response.KeyValue)
                return object;
            let message = new $root.response.KeyValue();
            if (object.key) {
                if (!Array.isArray(object.key))
                    throw TypeError(".response.KeyValue.key: array expected");
                message.key = [];
                for (let i = 0; i < object.key.length; ++i)
                    message.key[i] = String(object.key[i]);
            }
            if (object.value) {
                if (!Array.isArray(object.value))
                    throw TypeError(".response.KeyValue.value: array expected");
                message.value = [];
                for (let i = 0; i < object.value.length; ++i)
                    message.value[i] = String(object.value[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a KeyValue message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.KeyValue
         * @static
         * @param {response.KeyValue} message KeyValue
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        KeyValue.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.key = [];
                object.value = [];
            }
            if (message.key && message.key.length) {
                object.key = [];
                for (let j = 0; j < message.key.length; ++j)
                    object.key[j] = message.key[j];
            }
            if (message.value && message.value.length) {
                object.value = [];
                for (let j = 0; j < message.value.length; ++j)
                    object.value[j] = message.value[j];
            }
            return object;
        };

        /**
         * Converts this KeyValue to JSON.
         * @function toJSON
         * @memberof response.KeyValue
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        KeyValue.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for KeyValue
         * @function getTypeUrl
         * @memberof response.KeyValue
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        KeyValue.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.KeyValue";
        };

        return KeyValue;
    })();

    response.Key = (function() {

        /**
         * Properties of a Key.
         * @memberof response
         * @interface IKey
         * @property {Uint8Array|null} [random] Key random
         * @property {Uint8Array|null} [alphanumeric] Key alphanumeric
         * @property {number|null} [minSize] Key minSize
         * @property {number|null} [maxSize] Key maxSize
         */

        /**
         * Constructs a new Key.
         * @memberof response
         * @classdesc Represents a Key.
         * @implements IKey
         * @constructor
         * @param {response.IKey=} [properties] Properties to set
         */
        function Key(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Key random.
         * @member {Uint8Array|null|undefined} random
         * @memberof response.Key
         * @instance
         */
        Key.prototype.random = null;

        /**
         * Key alphanumeric.
         * @member {Uint8Array|null|undefined} alphanumeric
         * @memberof response.Key
         * @instance
         */
        Key.prototype.alphanumeric = null;

        /**
         * Key minSize.
         * @member {number|null|undefined} minSize
         * @memberof response.Key
         * @instance
         */
        Key.prototype.minSize = null;

        /**
         * Key maxSize.
         * @member {number|null|undefined} maxSize
         * @memberof response.Key
         * @instance
         */
        Key.prototype.maxSize = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * Key Format.
         * @member {"random"|"alphanumeric"|undefined} Format
         * @memberof response.Key
         * @instance
         */
        Object.defineProperty(Key.prototype, "Format", {
            get: $util.oneOfGetter($oneOfFields = ["random", "alphanumeric"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(Key.prototype, "_minSize", {
            get: $util.oneOfGetter($oneOfFields = ["minSize"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(Key.prototype, "_maxSize", {
            get: $util.oneOfGetter($oneOfFields = ["maxSize"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new Key instance using the specified properties.
         * @function create
         * @memberof response.Key
         * @static
         * @param {response.IKey=} [properties] Properties to set
         * @returns {response.Key} Key instance
         */
        Key.create = function create(properties) {
            return new Key(properties);
        };

        /**
         * Encodes the specified Key message. Does not implicitly {@link response.Key.verify|verify} messages.
         * @function encode
         * @memberof response.Key
         * @static
         * @param {response.IKey} message Key message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Key.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.random != null && Object.hasOwnProperty.call(message, "random"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.random);
            if (message.alphanumeric != null && Object.hasOwnProperty.call(message, "alphanumeric"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.alphanumeric);
            if (message.minSize != null && Object.hasOwnProperty.call(message, "minSize"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.minSize);
            if (message.maxSize != null && Object.hasOwnProperty.call(message, "maxSize"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.maxSize);
            return writer;
        };

        /**
         * Encodes the specified Key message, length delimited. Does not implicitly {@link response.Key.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.Key
         * @static
         * @param {response.IKey} message Key message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Key.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Key message from the specified reader or buffer.
         * @function decode
         * @memberof response.Key
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.Key} Key
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Key.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.Key();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 2: {
                        message.random = reader.bytes();
                        break;
                    }
                case 3: {
                        message.alphanumeric = reader.bytes();
                        break;
                    }
                case 4: {
                        message.minSize = reader.int32();
                        break;
                    }
                case 5: {
                        message.maxSize = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Key message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.Key
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.Key} Key
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Key.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Key message.
         * @function verify
         * @memberof response.Key
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Key.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.random != null && message.hasOwnProperty("random")) {
                properties.Format = 1;
                if (!(message.random && typeof message.random.length === "number" || $util.isString(message.random)))
                    return "random: buffer expected";
            }
            if (message.alphanumeric != null && message.hasOwnProperty("alphanumeric")) {
                if (properties.Format === 1)
                    return "Format: multiple values";
                properties.Format = 1;
                if (!(message.alphanumeric && typeof message.alphanumeric.length === "number" || $util.isString(message.alphanumeric)))
                    return "alphanumeric: buffer expected";
            }
            if (message.minSize != null && message.hasOwnProperty("minSize")) {
                properties._minSize = 1;
                if (!$util.isInteger(message.minSize))
                    return "minSize: integer expected";
            }
            if (message.maxSize != null && message.hasOwnProperty("maxSize")) {
                properties._maxSize = 1;
                if (!$util.isInteger(message.maxSize))
                    return "maxSize: integer expected";
            }
            return null;
        };

        /**
         * Creates a Key message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.Key
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.Key} Key
         */
        Key.fromObject = function fromObject(object) {
            if (object instanceof $root.response.Key)
                return object;
            let message = new $root.response.Key();
            if (object.random != null)
                if (typeof object.random === "string")
                    $util.base64.decode(object.random, message.random = $util.newBuffer($util.base64.length(object.random)), 0);
                else if (object.random.length >= 0)
                    message.random = object.random;
            if (object.alphanumeric != null)
                if (typeof object.alphanumeric === "string")
                    $util.base64.decode(object.alphanumeric, message.alphanumeric = $util.newBuffer($util.base64.length(object.alphanumeric)), 0);
                else if (object.alphanumeric.length >= 0)
                    message.alphanumeric = object.alphanumeric;
            if (object.minSize != null)
                message.minSize = object.minSize | 0;
            if (object.maxSize != null)
                message.maxSize = object.maxSize | 0;
            return message;
        };

        /**
         * Creates a plain object from a Key message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.Key
         * @static
         * @param {response.Key} message Key
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Key.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (message.random != null && message.hasOwnProperty("random")) {
                object.random = options.bytes === String ? $util.base64.encode(message.random, 0, message.random.length) : options.bytes === Array ? Array.prototype.slice.call(message.random) : message.random;
                if (options.oneofs)
                    object.Format = "random";
            }
            if (message.alphanumeric != null && message.hasOwnProperty("alphanumeric")) {
                object.alphanumeric = options.bytes === String ? $util.base64.encode(message.alphanumeric, 0, message.alphanumeric.length) : options.bytes === Array ? Array.prototype.slice.call(message.alphanumeric) : message.alphanumeric;
                if (options.oneofs)
                    object.Format = "alphanumeric";
            }
            if (message.minSize != null && message.hasOwnProperty("minSize")) {
                object.minSize = message.minSize;
                if (options.oneofs)
                    object._minSize = "minSize";
            }
            if (message.maxSize != null && message.hasOwnProperty("maxSize")) {
                object.maxSize = message.maxSize;
                if (options.oneofs)
                    object._maxSize = "maxSize";
            }
            return object;
        };

        /**
         * Converts this Key to JSON.
         * @function toJSON
         * @memberof response.Key
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Key.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Key
         * @function getTypeUrl
         * @memberof response.Key
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Key.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.Key";
        };

        return Key;
    })();

    response.Certificate = (function() {

        /**
         * Properties of a Certificate.
         * @memberof response
         * @interface ICertificate
         * @property {Uint8Array|null} [value] Certificate value
         */

        /**
         * Constructs a new Certificate.
         * @memberof response
         * @classdesc Represents a Certificate.
         * @implements ICertificate
         * @constructor
         * @param {response.ICertificate=} [properties] Properties to set
         */
        function Certificate(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Certificate value.
         * @member {Uint8Array} value
         * @memberof response.Certificate
         * @instance
         */
        Certificate.prototype.value = $util.newBuffer([]);

        /**
         * Creates a new Certificate instance using the specified properties.
         * @function create
         * @memberof response.Certificate
         * @static
         * @param {response.ICertificate=} [properties] Properties to set
         * @returns {response.Certificate} Certificate instance
         */
        Certificate.create = function create(properties) {
            return new Certificate(properties);
        };

        /**
         * Encodes the specified Certificate message. Does not implicitly {@link response.Certificate.verify|verify} messages.
         * @function encode
         * @memberof response.Certificate
         * @static
         * @param {response.ICertificate} message Certificate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Certificate.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.value);
            return writer;
        };

        /**
         * Encodes the specified Certificate message, length delimited. Does not implicitly {@link response.Certificate.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.Certificate
         * @static
         * @param {response.ICertificate} message Certificate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Certificate.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Certificate message from the specified reader or buffer.
         * @function decode
         * @memberof response.Certificate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.Certificate} Certificate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Certificate.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.Certificate();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.value = reader.bytes();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Certificate message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.Certificate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.Certificate} Certificate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Certificate.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Certificate message.
         * @function verify
         * @memberof response.Certificate
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Certificate.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.value != null && message.hasOwnProperty("value"))
                if (!(message.value && typeof message.value.length === "number" || $util.isString(message.value)))
                    return "value: buffer expected";
            return null;
        };

        /**
         * Creates a Certificate message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.Certificate
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.Certificate} Certificate
         */
        Certificate.fromObject = function fromObject(object) {
            if (object instanceof $root.response.Certificate)
                return object;
            let message = new $root.response.Certificate();
            if (object.value != null)
                if (typeof object.value === "string")
                    $util.base64.decode(object.value, message.value = $util.newBuffer($util.base64.length(object.value)), 0);
                else if (object.value.length >= 0)
                    message.value = object.value;
            return message;
        };

        /**
         * Creates a plain object from a Certificate message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.Certificate
         * @static
         * @param {response.Certificate} message Certificate
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Certificate.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                if (options.bytes === String)
                    object.value = "";
                else {
                    object.value = [];
                    if (options.bytes !== Array)
                        object.value = $util.newBuffer(object.value);
                }
            if (message.value != null && message.hasOwnProperty("value"))
                object.value = options.bytes === String ? $util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
            return object;
        };

        /**
         * Converts this Certificate to JSON.
         * @function toJSON
         * @memberof response.Certificate
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Certificate.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Certificate
         * @function getTypeUrl
         * @memberof response.Certificate
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Certificate.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.Certificate";
        };

        return Certificate;
    })();

    response.PrivateKey = (function() {

        /**
         * Properties of a PrivateKey.
         * @memberof response
         * @interface IPrivateKey
         * @property {Uint8Array|null} [value] PrivateKey value
         */

        /**
         * Constructs a new PrivateKey.
         * @memberof response
         * @classdesc Represents a PrivateKey.
         * @implements IPrivateKey
         * @constructor
         * @param {response.IPrivateKey=} [properties] Properties to set
         */
        function PrivateKey(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PrivateKey value.
         * @member {Uint8Array} value
         * @memberof response.PrivateKey
         * @instance
         */
        PrivateKey.prototype.value = $util.newBuffer([]);

        /**
         * Creates a new PrivateKey instance using the specified properties.
         * @function create
         * @memberof response.PrivateKey
         * @static
         * @param {response.IPrivateKey=} [properties] Properties to set
         * @returns {response.PrivateKey} PrivateKey instance
         */
        PrivateKey.create = function create(properties) {
            return new PrivateKey(properties);
        };

        /**
         * Encodes the specified PrivateKey message. Does not implicitly {@link response.PrivateKey.verify|verify} messages.
         * @function encode
         * @memberof response.PrivateKey
         * @static
         * @param {response.IPrivateKey} message PrivateKey message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PrivateKey.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.value);
            return writer;
        };

        /**
         * Encodes the specified PrivateKey message, length delimited. Does not implicitly {@link response.PrivateKey.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.PrivateKey
         * @static
         * @param {response.IPrivateKey} message PrivateKey message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PrivateKey.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PrivateKey message from the specified reader or buffer.
         * @function decode
         * @memberof response.PrivateKey
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.PrivateKey} PrivateKey
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PrivateKey.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.PrivateKey();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.value = reader.bytes();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PrivateKey message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.PrivateKey
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.PrivateKey} PrivateKey
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PrivateKey.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PrivateKey message.
         * @function verify
         * @memberof response.PrivateKey
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PrivateKey.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.value != null && message.hasOwnProperty("value"))
                if (!(message.value && typeof message.value.length === "number" || $util.isString(message.value)))
                    return "value: buffer expected";
            return null;
        };

        /**
         * Creates a PrivateKey message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.PrivateKey
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.PrivateKey} PrivateKey
         */
        PrivateKey.fromObject = function fromObject(object) {
            if (object instanceof $root.response.PrivateKey)
                return object;
            let message = new $root.response.PrivateKey();
            if (object.value != null)
                if (typeof object.value === "string")
                    $util.base64.decode(object.value, message.value = $util.newBuffer($util.base64.length(object.value)), 0);
                else if (object.value.length >= 0)
                    message.value = object.value;
            return message;
        };

        /**
         * Creates a plain object from a PrivateKey message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.PrivateKey
         * @static
         * @param {response.PrivateKey} message PrivateKey
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PrivateKey.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                if (options.bytes === String)
                    object.value = "";
                else {
                    object.value = [];
                    if (options.bytes !== Array)
                        object.value = $util.newBuffer(object.value);
                }
            if (message.value != null && message.hasOwnProperty("value"))
                object.value = options.bytes === String ? $util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
            return object;
        };

        /**
         * Converts this PrivateKey to JSON.
         * @function toJSON
         * @memberof response.PrivateKey
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PrivateKey.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for PrivateKey
         * @function getTypeUrl
         * @memberof response.PrivateKey
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        PrivateKey.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.PrivateKey";
        };

        return PrivateKey;
    })();

    response.SecretData = (function() {

        /**
         * Properties of a SecretData.
         * @memberof response
         * @interface ISecretData
         * @property {response.SecretType|null} [type] SecretData type
         * @property {response.IPassword|null} [password] SecretData password
         * @property {response.ICard|null} [card] SecretData card
         * @property {response.INote|null} [note] SecretData note
         * @property {response.IIdentity|null} [identity] SecretData identity
         * @property {response.IKeyValue|null} [keyValue] SecretData keyValue
         * @property {response.IKey|null} [key] SecretData key
         * @property {response.ICertificate|null} [certificate] SecretData certificate
         * @property {response.IPrivateKey|null} [privatekey] SecretData privatekey
         */

        /**
         * Constructs a new SecretData.
         * @memberof response
         * @classdesc Represents a SecretData.
         * @implements ISecretData
         * @constructor
         * @param {response.ISecretData=} [properties] Properties to set
         */
        function SecretData(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SecretData type.
         * @member {response.SecretType} type
         * @memberof response.SecretData
         * @instance
         */
        SecretData.prototype.type = 0;

        /**
         * SecretData password.
         * @member {response.IPassword|null|undefined} password
         * @memberof response.SecretData
         * @instance
         */
        SecretData.prototype.password = null;

        /**
         * SecretData card.
         * @member {response.ICard|null|undefined} card
         * @memberof response.SecretData
         * @instance
         */
        SecretData.prototype.card = null;

        /**
         * SecretData note.
         * @member {response.INote|null|undefined} note
         * @memberof response.SecretData
         * @instance
         */
        SecretData.prototype.note = null;

        /**
         * SecretData identity.
         * @member {response.IIdentity|null|undefined} identity
         * @memberof response.SecretData
         * @instance
         */
        SecretData.prototype.identity = null;

        /**
         * SecretData keyValue.
         * @member {response.IKeyValue|null|undefined} keyValue
         * @memberof response.SecretData
         * @instance
         */
        SecretData.prototype.keyValue = null;

        /**
         * SecretData key.
         * @member {response.IKey|null|undefined} key
         * @memberof response.SecretData
         * @instance
         */
        SecretData.prototype.key = null;

        /**
         * SecretData certificate.
         * @member {response.ICertificate|null|undefined} certificate
         * @memberof response.SecretData
         * @instance
         */
        SecretData.prototype.certificate = null;

        /**
         * SecretData privatekey.
         * @member {response.IPrivateKey|null|undefined} privatekey
         * @memberof response.SecretData
         * @instance
         */
        SecretData.prototype.privatekey = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * SecretData Data.
         * @member {"password"|"card"|"note"|"identity"|"keyValue"|"key"|"certificate"|"privatekey"|undefined} Data
         * @memberof response.SecretData
         * @instance
         */
        Object.defineProperty(SecretData.prototype, "Data", {
            get: $util.oneOfGetter($oneOfFields = ["password", "card", "note", "identity", "keyValue", "key", "certificate", "privatekey"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new SecretData instance using the specified properties.
         * @function create
         * @memberof response.SecretData
         * @static
         * @param {response.ISecretData=} [properties] Properties to set
         * @returns {response.SecretData} SecretData instance
         */
        SecretData.create = function create(properties) {
            return new SecretData(properties);
        };

        /**
         * Encodes the specified SecretData message. Does not implicitly {@link response.SecretData.verify|verify} messages.
         * @function encode
         * @memberof response.SecretData
         * @static
         * @param {response.ISecretData} message SecretData message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SecretData.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.type);
            if (message.password != null && Object.hasOwnProperty.call(message, "password"))
                $root.response.Password.encode(message.password, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
            if (message.card != null && Object.hasOwnProperty.call(message, "card"))
                $root.response.Card.encode(message.card, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
            if (message.note != null && Object.hasOwnProperty.call(message, "note"))
                $root.response.Note.encode(message.note, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
            if (message.identity != null && Object.hasOwnProperty.call(message, "identity"))
                $root.response.Identity.encode(message.identity, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
            if (message.keyValue != null && Object.hasOwnProperty.call(message, "keyValue"))
                $root.response.KeyValue.encode(message.keyValue, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
            if (message.key != null && Object.hasOwnProperty.call(message, "key"))
                $root.response.Key.encode(message.key, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
            if (message.certificate != null && Object.hasOwnProperty.call(message, "certificate"))
                $root.response.Certificate.encode(message.certificate, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
            if (message.privatekey != null && Object.hasOwnProperty.call(message, "privatekey"))
                $root.response.PrivateKey.encode(message.privatekey, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified SecretData message, length delimited. Does not implicitly {@link response.SecretData.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.SecretData
         * @static
         * @param {response.ISecretData} message SecretData message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SecretData.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SecretData message from the specified reader or buffer.
         * @function decode
         * @memberof response.SecretData
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.SecretData} SecretData
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SecretData.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.SecretData();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.type = reader.int32();
                        break;
                    }
                case 5: {
                        message.password = $root.response.Password.decode(reader, reader.uint32());
                        break;
                    }
                case 6: {
                        message.card = $root.response.Card.decode(reader, reader.uint32());
                        break;
                    }
                case 7: {
                        message.note = $root.response.Note.decode(reader, reader.uint32());
                        break;
                    }
                case 8: {
                        message.identity = $root.response.Identity.decode(reader, reader.uint32());
                        break;
                    }
                case 9: {
                        message.keyValue = $root.response.KeyValue.decode(reader, reader.uint32());
                        break;
                    }
                case 10: {
                        message.key = $root.response.Key.decode(reader, reader.uint32());
                        break;
                    }
                case 11: {
                        message.certificate = $root.response.Certificate.decode(reader, reader.uint32());
                        break;
                    }
                case 12: {
                        message.privatekey = $root.response.PrivateKey.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SecretData message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.SecretData
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.SecretData} SecretData
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SecretData.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SecretData message.
         * @function verify
         * @memberof response.SecretData
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SecretData.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.type != null && message.hasOwnProperty("type"))
                switch (message.type) {
                default:
                    return "type: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                    break;
                }
            if (message.password != null && message.hasOwnProperty("password")) {
                properties.Data = 1;
                {
                    let error = $root.response.Password.verify(message.password);
                    if (error)
                        return "password." + error;
                }
            }
            if (message.card != null && message.hasOwnProperty("card")) {
                if (properties.Data === 1)
                    return "Data: multiple values";
                properties.Data = 1;
                {
                    let error = $root.response.Card.verify(message.card);
                    if (error)
                        return "card." + error;
                }
            }
            if (message.note != null && message.hasOwnProperty("note")) {
                if (properties.Data === 1)
                    return "Data: multiple values";
                properties.Data = 1;
                {
                    let error = $root.response.Note.verify(message.note);
                    if (error)
                        return "note." + error;
                }
            }
            if (message.identity != null && message.hasOwnProperty("identity")) {
                if (properties.Data === 1)
                    return "Data: multiple values";
                properties.Data = 1;
                {
                    let error = $root.response.Identity.verify(message.identity);
                    if (error)
                        return "identity." + error;
                }
            }
            if (message.keyValue != null && message.hasOwnProperty("keyValue")) {
                if (properties.Data === 1)
                    return "Data: multiple values";
                properties.Data = 1;
                {
                    let error = $root.response.KeyValue.verify(message.keyValue);
                    if (error)
                        return "keyValue." + error;
                }
            }
            if (message.key != null && message.hasOwnProperty("key")) {
                if (properties.Data === 1)
                    return "Data: multiple values";
                properties.Data = 1;
                {
                    let error = $root.response.Key.verify(message.key);
                    if (error)
                        return "key." + error;
                }
            }
            if (message.certificate != null && message.hasOwnProperty("certificate")) {
                if (properties.Data === 1)
                    return "Data: multiple values";
                properties.Data = 1;
                {
                    let error = $root.response.Certificate.verify(message.certificate);
                    if (error)
                        return "certificate." + error;
                }
            }
            if (message.privatekey != null && message.hasOwnProperty("privatekey")) {
                if (properties.Data === 1)
                    return "Data: multiple values";
                properties.Data = 1;
                {
                    let error = $root.response.PrivateKey.verify(message.privatekey);
                    if (error)
                        return "privatekey." + error;
                }
            }
            return null;
        };

        /**
         * Creates a SecretData message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.SecretData
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.SecretData} SecretData
         */
        SecretData.fromObject = function fromObject(object) {
            if (object instanceof $root.response.SecretData)
                return object;
            let message = new $root.response.SecretData();
            switch (object.type) {
            default:
                if (typeof object.type === "number") {
                    message.type = object.type;
                    break;
                }
                break;
            case "PASSWORD":
            case 0:
                message.type = 0;
                break;
            case "CARD":
            case 1:
                message.type = 1;
                break;
            case "NOTE":
            case 2:
                message.type = 2;
                break;
            case "IDENTITY":
            case 3:
                message.type = 3;
                break;
            case "KEYVALUES":
            case 4:
                message.type = 4;
                break;
            case "KEYS":
            case 5:
                message.type = 5;
                break;
            case "CERTIFICATE":
            case 6:
                message.type = 6;
                break;
            case "PRIVATEKEY":
            case 7:
                message.type = 7;
                break;
            }
            if (object.password != null) {
                if (typeof object.password !== "object")
                    throw TypeError(".response.SecretData.password: object expected");
                message.password = $root.response.Password.fromObject(object.password);
            }
            if (object.card != null) {
                if (typeof object.card !== "object")
                    throw TypeError(".response.SecretData.card: object expected");
                message.card = $root.response.Card.fromObject(object.card);
            }
            if (object.note != null) {
                if (typeof object.note !== "object")
                    throw TypeError(".response.SecretData.note: object expected");
                message.note = $root.response.Note.fromObject(object.note);
            }
            if (object.identity != null) {
                if (typeof object.identity !== "object")
                    throw TypeError(".response.SecretData.identity: object expected");
                message.identity = $root.response.Identity.fromObject(object.identity);
            }
            if (object.keyValue != null) {
                if (typeof object.keyValue !== "object")
                    throw TypeError(".response.SecretData.keyValue: object expected");
                message.keyValue = $root.response.KeyValue.fromObject(object.keyValue);
            }
            if (object.key != null) {
                if (typeof object.key !== "object")
                    throw TypeError(".response.SecretData.key: object expected");
                message.key = $root.response.Key.fromObject(object.key);
            }
            if (object.certificate != null) {
                if (typeof object.certificate !== "object")
                    throw TypeError(".response.SecretData.certificate: object expected");
                message.certificate = $root.response.Certificate.fromObject(object.certificate);
            }
            if (object.privatekey != null) {
                if (typeof object.privatekey !== "object")
                    throw TypeError(".response.SecretData.privatekey: object expected");
                message.privatekey = $root.response.PrivateKey.fromObject(object.privatekey);
            }
            return message;
        };

        /**
         * Creates a plain object from a SecretData message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.SecretData
         * @static
         * @param {response.SecretData} message SecretData
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SecretData.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.type = options.enums === String ? "PASSWORD" : 0;
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = options.enums === String ? $root.response.SecretType[message.type] === undefined ? message.type : $root.response.SecretType[message.type] : message.type;
            if (message.password != null && message.hasOwnProperty("password")) {
                object.password = $root.response.Password.toObject(message.password, options);
                if (options.oneofs)
                    object.Data = "password";
            }
            if (message.card != null && message.hasOwnProperty("card")) {
                object.card = $root.response.Card.toObject(message.card, options);
                if (options.oneofs)
                    object.Data = "card";
            }
            if (message.note != null && message.hasOwnProperty("note")) {
                object.note = $root.response.Note.toObject(message.note, options);
                if (options.oneofs)
                    object.Data = "note";
            }
            if (message.identity != null && message.hasOwnProperty("identity")) {
                object.identity = $root.response.Identity.toObject(message.identity, options);
                if (options.oneofs)
                    object.Data = "identity";
            }
            if (message.keyValue != null && message.hasOwnProperty("keyValue")) {
                object.keyValue = $root.response.KeyValue.toObject(message.keyValue, options);
                if (options.oneofs)
                    object.Data = "keyValue";
            }
            if (message.key != null && message.hasOwnProperty("key")) {
                object.key = $root.response.Key.toObject(message.key, options);
                if (options.oneofs)
                    object.Data = "key";
            }
            if (message.certificate != null && message.hasOwnProperty("certificate")) {
                object.certificate = $root.response.Certificate.toObject(message.certificate, options);
                if (options.oneofs)
                    object.Data = "certificate";
            }
            if (message.privatekey != null && message.hasOwnProperty("privatekey")) {
                object.privatekey = $root.response.PrivateKey.toObject(message.privatekey, options);
                if (options.oneofs)
                    object.Data = "privatekey";
            }
            return object;
        };

        /**
         * Converts this SecretData to JSON.
         * @function toJSON
         * @memberof response.SecretData
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SecretData.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for SecretData
         * @function getTypeUrl
         * @memberof response.SecretData
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        SecretData.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.SecretData";
        };

        return SecretData;
    })();

    response.SecretVersion = (function() {

        /**
         * Properties of a SecretVersion.
         * @memberof response
         * @interface ISecretVersion
         * @property {number|Long|null} [id] SecretVersion id
         * @property {number|Long|null} [creationTime] SecretVersion creationTime
         * @property {response.ISecretData|null} [secretData] SecretVersion secretData
         */

        /**
         * Constructs a new SecretVersion.
         * @memberof response
         * @classdesc Represents a SecretVersion.
         * @implements ISecretVersion
         * @constructor
         * @param {response.ISecretVersion=} [properties] Properties to set
         */
        function SecretVersion(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SecretVersion id.
         * @member {number|Long} id
         * @memberof response.SecretVersion
         * @instance
         */
        SecretVersion.prototype.id = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * SecretVersion creationTime.
         * @member {number|Long} creationTime
         * @memberof response.SecretVersion
         * @instance
         */
        SecretVersion.prototype.creationTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * SecretVersion secretData.
         * @member {response.ISecretData|null|undefined} secretData
         * @memberof response.SecretVersion
         * @instance
         */
        SecretVersion.prototype.secretData = null;

        /**
         * Creates a new SecretVersion instance using the specified properties.
         * @function create
         * @memberof response.SecretVersion
         * @static
         * @param {response.ISecretVersion=} [properties] Properties to set
         * @returns {response.SecretVersion} SecretVersion instance
         */
        SecretVersion.create = function create(properties) {
            return new SecretVersion(properties);
        };

        /**
         * Encodes the specified SecretVersion message. Does not implicitly {@link response.SecretVersion.verify|verify} messages.
         * @function encode
         * @memberof response.SecretVersion
         * @static
         * @param {response.ISecretVersion} message SecretVersion message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SecretVersion.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.id);
            if (message.creationTime != null && Object.hasOwnProperty.call(message, "creationTime"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.creationTime);
            if (message.secretData != null && Object.hasOwnProperty.call(message, "secretData"))
                $root.response.SecretData.encode(message.secretData, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified SecretVersion message, length delimited. Does not implicitly {@link response.SecretVersion.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.SecretVersion
         * @static
         * @param {response.ISecretVersion} message SecretVersion message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SecretVersion.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SecretVersion message from the specified reader or buffer.
         * @function decode
         * @memberof response.SecretVersion
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.SecretVersion} SecretVersion
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SecretVersion.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.SecretVersion();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.id = reader.uint64();
                        break;
                    }
                case 2: {
                        message.creationTime = reader.uint64();
                        break;
                    }
                case 3: {
                        message.secretData = $root.response.SecretData.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SecretVersion message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.SecretVersion
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.SecretVersion} SecretVersion
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SecretVersion.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SecretVersion message.
         * @function verify
         * @memberof response.SecretVersion
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SecretVersion.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                    return "id: integer|Long expected";
            if (message.creationTime != null && message.hasOwnProperty("creationTime"))
                if (!$util.isInteger(message.creationTime) && !(message.creationTime && $util.isInteger(message.creationTime.low) && $util.isInteger(message.creationTime.high)))
                    return "creationTime: integer|Long expected";
            if (message.secretData != null && message.hasOwnProperty("secretData")) {
                let error = $root.response.SecretData.verify(message.secretData);
                if (error)
                    return "secretData." + error;
            }
            return null;
        };

        /**
         * Creates a SecretVersion message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.SecretVersion
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.SecretVersion} SecretVersion
         */
        SecretVersion.fromObject = function fromObject(object) {
            if (object instanceof $root.response.SecretVersion)
                return object;
            let message = new $root.response.SecretVersion();
            if (object.id != null)
                if ($util.Long)
                    (message.id = $util.Long.fromValue(object.id)).unsigned = true;
                else if (typeof object.id === "string")
                    message.id = parseInt(object.id, 10);
                else if (typeof object.id === "number")
                    message.id = object.id;
                else if (typeof object.id === "object")
                    message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber(true);
            if (object.creationTime != null)
                if ($util.Long)
                    (message.creationTime = $util.Long.fromValue(object.creationTime)).unsigned = true;
                else if (typeof object.creationTime === "string")
                    message.creationTime = parseInt(object.creationTime, 10);
                else if (typeof object.creationTime === "number")
                    message.creationTime = object.creationTime;
                else if (typeof object.creationTime === "object")
                    message.creationTime = new $util.LongBits(object.creationTime.low >>> 0, object.creationTime.high >>> 0).toNumber(true);
            if (object.secretData != null) {
                if (typeof object.secretData !== "object")
                    throw TypeError(".response.SecretVersion.secretData: object expected");
                message.secretData = $root.response.SecretData.fromObject(object.secretData);
            }
            return message;
        };

        /**
         * Creates a plain object from a SecretVersion message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.SecretVersion
         * @static
         * @param {response.SecretVersion} message SecretVersion
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SecretVersion.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.id = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.creationTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.creationTime = options.longs === String ? "0" : 0;
                object.secretData = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                if (typeof message.id === "number")
                    object.id = options.longs === String ? String(message.id) : message.id;
                else
                    object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber(true) : message.id;
            if (message.creationTime != null && message.hasOwnProperty("creationTime"))
                if (typeof message.creationTime === "number")
                    object.creationTime = options.longs === String ? String(message.creationTime) : message.creationTime;
                else
                    object.creationTime = options.longs === String ? $util.Long.prototype.toString.call(message.creationTime) : options.longs === Number ? new $util.LongBits(message.creationTime.low >>> 0, message.creationTime.high >>> 0).toNumber(true) : message.creationTime;
            if (message.secretData != null && message.hasOwnProperty("secretData"))
                object.secretData = $root.response.SecretData.toObject(message.secretData, options);
            return object;
        };

        /**
         * Converts this SecretVersion to JSON.
         * @function toJSON
         * @memberof response.SecretVersion
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SecretVersion.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for SecretVersion
         * @function getTypeUrl
         * @memberof response.SecretVersion
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        SecretVersion.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.SecretVersion";
        };

        return SecretVersion;
    })();

    response.Secret = (function() {

        /**
         * Properties of a Secret.
         * @memberof response
         * @interface ISecret
         * @property {string|null} [path] Secret path
         * @property {Uint8Array|null} [uuid] Secret uuid
         * @property {number|Long|null} [expiry] Secret expiry
         * @property {Array.<response.ISecretVersion>|null} [versions] Secret versions
         * @property {boolean|null} [isExpired] Secret isExpired
         * @property {number|Long|null} [rotateInterval] Secret rotateInterval
         * @property {number|Long|null} [lastRotatedTime] Secret lastRotatedTime
         */

        /**
         * Constructs a new Secret.
         * @memberof response
         * @classdesc Represents a Secret.
         * @implements ISecret
         * @constructor
         * @param {response.ISecret=} [properties] Properties to set
         */
        function Secret(properties) {
            this.versions = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Secret path.
         * @member {string} path
         * @memberof response.Secret
         * @instance
         */
        Secret.prototype.path = "";

        /**
         * Secret uuid.
         * @member {Uint8Array} uuid
         * @memberof response.Secret
         * @instance
         */
        Secret.prototype.uuid = $util.newBuffer([]);

        /**
         * Secret expiry.
         * @member {number|Long} expiry
         * @memberof response.Secret
         * @instance
         */
        Secret.prototype.expiry = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Secret versions.
         * @member {Array.<response.ISecretVersion>} versions
         * @memberof response.Secret
         * @instance
         */
        Secret.prototype.versions = $util.emptyArray;

        /**
         * Secret isExpired.
         * @member {boolean} isExpired
         * @memberof response.Secret
         * @instance
         */
        Secret.prototype.isExpired = false;

        /**
         * Secret rotateInterval.
         * @member {number|Long} rotateInterval
         * @memberof response.Secret
         * @instance
         */
        Secret.prototype.rotateInterval = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Secret lastRotatedTime.
         * @member {number|Long} lastRotatedTime
         * @memberof response.Secret
         * @instance
         */
        Secret.prototype.lastRotatedTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new Secret instance using the specified properties.
         * @function create
         * @memberof response.Secret
         * @static
         * @param {response.ISecret=} [properties] Properties to set
         * @returns {response.Secret} Secret instance
         */
        Secret.create = function create(properties) {
            return new Secret(properties);
        };

        /**
         * Encodes the specified Secret message. Does not implicitly {@link response.Secret.verify|verify} messages.
         * @function encode
         * @memberof response.Secret
         * @static
         * @param {response.ISecret} message Secret message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Secret.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.path != null && Object.hasOwnProperty.call(message, "path"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.path);
            if (message.uuid != null && Object.hasOwnProperty.call(message, "uuid"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.uuid);
            if (message.expiry != null && Object.hasOwnProperty.call(message, "expiry"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.expiry);
            if (message.versions != null && message.versions.length)
                for (let i = 0; i < message.versions.length; ++i)
                    $root.response.SecretVersion.encode(message.versions[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
            if (message.isExpired != null && Object.hasOwnProperty.call(message, "isExpired"))
                writer.uint32(/* id 6, wireType 0 =*/48).bool(message.isExpired);
            if (message.rotateInterval != null && Object.hasOwnProperty.call(message, "rotateInterval"))
                writer.uint32(/* id 8, wireType 0 =*/64).uint64(message.rotateInterval);
            if (message.lastRotatedTime != null && Object.hasOwnProperty.call(message, "lastRotatedTime"))
                writer.uint32(/* id 9, wireType 0 =*/72).uint64(message.lastRotatedTime);
            return writer;
        };

        /**
         * Encodes the specified Secret message, length delimited. Does not implicitly {@link response.Secret.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.Secret
         * @static
         * @param {response.ISecret} message Secret message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Secret.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Secret message from the specified reader or buffer.
         * @function decode
         * @memberof response.Secret
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.Secret} Secret
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Secret.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.Secret();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 2: {
                        message.path = reader.string();
                        break;
                    }
                case 3: {
                        message.uuid = reader.bytes();
                        break;
                    }
                case 4: {
                        message.expiry = reader.uint64();
                        break;
                    }
                case 5: {
                        if (!(message.versions && message.versions.length))
                            message.versions = [];
                        message.versions.push($root.response.SecretVersion.decode(reader, reader.uint32()));
                        break;
                    }
                case 6: {
                        message.isExpired = reader.bool();
                        break;
                    }
                case 8: {
                        message.rotateInterval = reader.uint64();
                        break;
                    }
                case 9: {
                        message.lastRotatedTime = reader.uint64();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Secret message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.Secret
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.Secret} Secret
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Secret.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Secret message.
         * @function verify
         * @memberof response.Secret
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Secret.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.path != null && message.hasOwnProperty("path"))
                if (!$util.isString(message.path))
                    return "path: string expected";
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                if (!(message.uuid && typeof message.uuid.length === "number" || $util.isString(message.uuid)))
                    return "uuid: buffer expected";
            if (message.expiry != null && message.hasOwnProperty("expiry"))
                if (!$util.isInteger(message.expiry) && !(message.expiry && $util.isInteger(message.expiry.low) && $util.isInteger(message.expiry.high)))
                    return "expiry: integer|Long expected";
            if (message.versions != null && message.hasOwnProperty("versions")) {
                if (!Array.isArray(message.versions))
                    return "versions: array expected";
                for (let i = 0; i < message.versions.length; ++i) {
                    let error = $root.response.SecretVersion.verify(message.versions[i]);
                    if (error)
                        return "versions." + error;
                }
            }
            if (message.isExpired != null && message.hasOwnProperty("isExpired"))
                if (typeof message.isExpired !== "boolean")
                    return "isExpired: boolean expected";
            if (message.rotateInterval != null && message.hasOwnProperty("rotateInterval"))
                if (!$util.isInteger(message.rotateInterval) && !(message.rotateInterval && $util.isInteger(message.rotateInterval.low) && $util.isInteger(message.rotateInterval.high)))
                    return "rotateInterval: integer|Long expected";
            if (message.lastRotatedTime != null && message.hasOwnProperty("lastRotatedTime"))
                if (!$util.isInteger(message.lastRotatedTime) && !(message.lastRotatedTime && $util.isInteger(message.lastRotatedTime.low) && $util.isInteger(message.lastRotatedTime.high)))
                    return "lastRotatedTime: integer|Long expected";
            return null;
        };

        /**
         * Creates a Secret message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.Secret
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.Secret} Secret
         */
        Secret.fromObject = function fromObject(object) {
            if (object instanceof $root.response.Secret)
                return object;
            let message = new $root.response.Secret();
            if (object.path != null)
                message.path = String(object.path);
            if (object.uuid != null)
                if (typeof object.uuid === "string")
                    $util.base64.decode(object.uuid, message.uuid = $util.newBuffer($util.base64.length(object.uuid)), 0);
                else if (object.uuid.length >= 0)
                    message.uuid = object.uuid;
            if (object.expiry != null)
                if ($util.Long)
                    (message.expiry = $util.Long.fromValue(object.expiry)).unsigned = true;
                else if (typeof object.expiry === "string")
                    message.expiry = parseInt(object.expiry, 10);
                else if (typeof object.expiry === "number")
                    message.expiry = object.expiry;
                else if (typeof object.expiry === "object")
                    message.expiry = new $util.LongBits(object.expiry.low >>> 0, object.expiry.high >>> 0).toNumber(true);
            if (object.versions) {
                if (!Array.isArray(object.versions))
                    throw TypeError(".response.Secret.versions: array expected");
                message.versions = [];
                for (let i = 0; i < object.versions.length; ++i) {
                    if (typeof object.versions[i] !== "object")
                        throw TypeError(".response.Secret.versions: object expected");
                    message.versions[i] = $root.response.SecretVersion.fromObject(object.versions[i]);
                }
            }
            if (object.isExpired != null)
                message.isExpired = Boolean(object.isExpired);
            if (object.rotateInterval != null)
                if ($util.Long)
                    (message.rotateInterval = $util.Long.fromValue(object.rotateInterval)).unsigned = true;
                else if (typeof object.rotateInterval === "string")
                    message.rotateInterval = parseInt(object.rotateInterval, 10);
                else if (typeof object.rotateInterval === "number")
                    message.rotateInterval = object.rotateInterval;
                else if (typeof object.rotateInterval === "object")
                    message.rotateInterval = new $util.LongBits(object.rotateInterval.low >>> 0, object.rotateInterval.high >>> 0).toNumber(true);
            if (object.lastRotatedTime != null)
                if ($util.Long)
                    (message.lastRotatedTime = $util.Long.fromValue(object.lastRotatedTime)).unsigned = true;
                else if (typeof object.lastRotatedTime === "string")
                    message.lastRotatedTime = parseInt(object.lastRotatedTime, 10);
                else if (typeof object.lastRotatedTime === "number")
                    message.lastRotatedTime = object.lastRotatedTime;
                else if (typeof object.lastRotatedTime === "object")
                    message.lastRotatedTime = new $util.LongBits(object.lastRotatedTime.low >>> 0, object.lastRotatedTime.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a Secret message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.Secret
         * @static
         * @param {response.Secret} message Secret
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Secret.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.versions = [];
            if (options.defaults) {
                object.path = "";
                if (options.bytes === String)
                    object.uuid = "";
                else {
                    object.uuid = [];
                    if (options.bytes !== Array)
                        object.uuid = $util.newBuffer(object.uuid);
                }
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.expiry = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.expiry = options.longs === String ? "0" : 0;
                object.isExpired = false;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.rotateInterval = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.rotateInterval = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.lastRotatedTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.lastRotatedTime = options.longs === String ? "0" : 0;
            }
            if (message.path != null && message.hasOwnProperty("path"))
                object.path = message.path;
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                object.uuid = options.bytes === String ? $util.base64.encode(message.uuid, 0, message.uuid.length) : options.bytes === Array ? Array.prototype.slice.call(message.uuid) : message.uuid;
            if (message.expiry != null && message.hasOwnProperty("expiry"))
                if (typeof message.expiry === "number")
                    object.expiry = options.longs === String ? String(message.expiry) : message.expiry;
                else
                    object.expiry = options.longs === String ? $util.Long.prototype.toString.call(message.expiry) : options.longs === Number ? new $util.LongBits(message.expiry.low >>> 0, message.expiry.high >>> 0).toNumber(true) : message.expiry;
            if (message.versions && message.versions.length) {
                object.versions = [];
                for (let j = 0; j < message.versions.length; ++j)
                    object.versions[j] = $root.response.SecretVersion.toObject(message.versions[j], options);
            }
            if (message.isExpired != null && message.hasOwnProperty("isExpired"))
                object.isExpired = message.isExpired;
            if (message.rotateInterval != null && message.hasOwnProperty("rotateInterval"))
                if (typeof message.rotateInterval === "number")
                    object.rotateInterval = options.longs === String ? String(message.rotateInterval) : message.rotateInterval;
                else
                    object.rotateInterval = options.longs === String ? $util.Long.prototype.toString.call(message.rotateInterval) : options.longs === Number ? new $util.LongBits(message.rotateInterval.low >>> 0, message.rotateInterval.high >>> 0).toNumber(true) : message.rotateInterval;
            if (message.lastRotatedTime != null && message.hasOwnProperty("lastRotatedTime"))
                if (typeof message.lastRotatedTime === "number")
                    object.lastRotatedTime = options.longs === String ? String(message.lastRotatedTime) : message.lastRotatedTime;
                else
                    object.lastRotatedTime = options.longs === String ? $util.Long.prototype.toString.call(message.lastRotatedTime) : options.longs === Number ? new $util.LongBits(message.lastRotatedTime.low >>> 0, message.lastRotatedTime.high >>> 0).toNumber(true) : message.lastRotatedTime;
            return object;
        };

        /**
         * Converts this Secret to JSON.
         * @function toJSON
         * @memberof response.Secret
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Secret.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Secret
         * @function getTypeUrl
         * @memberof response.Secret
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Secret.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.Secret";
        };

        return Secret;
    })();

    response.GetRandomBytes = (function() {

        /**
         * Properties of a GetRandomBytes.
         * @memberof response
         * @interface IGetRandomBytes
         * @property {response.Status|null} [status] GetRandomBytes status
         * @property {string|null} [message] GetRandomBytes message
         * @property {Uint8Array|null} [randomBytes] GetRandomBytes randomBytes
         */

        /**
         * Constructs a new GetRandomBytes.
         * @memberof response
         * @classdesc Represents a GetRandomBytes.
         * @implements IGetRandomBytes
         * @constructor
         * @param {response.IGetRandomBytes=} [properties] Properties to set
         */
        function GetRandomBytes(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetRandomBytes status.
         * @member {response.Status} status
         * @memberof response.GetRandomBytes
         * @instance
         */
        GetRandomBytes.prototype.status = 0;

        /**
         * GetRandomBytes message.
         * @member {string|null|undefined} message
         * @memberof response.GetRandomBytes
         * @instance
         */
        GetRandomBytes.prototype.message = null;

        /**
         * GetRandomBytes randomBytes.
         * @member {Uint8Array} randomBytes
         * @memberof response.GetRandomBytes
         * @instance
         */
        GetRandomBytes.prototype.randomBytes = $util.newBuffer([]);

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(GetRandomBytes.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new GetRandomBytes instance using the specified properties.
         * @function create
         * @memberof response.GetRandomBytes
         * @static
         * @param {response.IGetRandomBytes=} [properties] Properties to set
         * @returns {response.GetRandomBytes} GetRandomBytes instance
         */
        GetRandomBytes.create = function create(properties) {
            return new GetRandomBytes(properties);
        };

        /**
         * Encodes the specified GetRandomBytes message. Does not implicitly {@link response.GetRandomBytes.verify|verify} messages.
         * @function encode
         * @memberof response.GetRandomBytes
         * @static
         * @param {response.IGetRandomBytes} message GetRandomBytes message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetRandomBytes.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            if (message.randomBytes != null && Object.hasOwnProperty.call(message, "randomBytes"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.randomBytes);
            return writer;
        };

        /**
         * Encodes the specified GetRandomBytes message, length delimited. Does not implicitly {@link response.GetRandomBytes.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.GetRandomBytes
         * @static
         * @param {response.IGetRandomBytes} message GetRandomBytes message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetRandomBytes.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetRandomBytes message from the specified reader or buffer.
         * @function decode
         * @memberof response.GetRandomBytes
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.GetRandomBytes} GetRandomBytes
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetRandomBytes.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.GetRandomBytes();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                case 3: {
                        message.randomBytes = reader.bytes();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetRandomBytes message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.GetRandomBytes
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.GetRandomBytes} GetRandomBytes
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetRandomBytes.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetRandomBytes message.
         * @function verify
         * @memberof response.GetRandomBytes
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetRandomBytes.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            if (message.randomBytes != null && message.hasOwnProperty("randomBytes"))
                if (!(message.randomBytes && typeof message.randomBytes.length === "number" || $util.isString(message.randomBytes)))
                    return "randomBytes: buffer expected";
            return null;
        };

        /**
         * Creates a GetRandomBytes message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.GetRandomBytes
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.GetRandomBytes} GetRandomBytes
         */
        GetRandomBytes.fromObject = function fromObject(object) {
            if (object instanceof $root.response.GetRandomBytes)
                return object;
            let message = new $root.response.GetRandomBytes();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            if (object.randomBytes != null)
                if (typeof object.randomBytes === "string")
                    $util.base64.decode(object.randomBytes, message.randomBytes = $util.newBuffer($util.base64.length(object.randomBytes)), 0);
                else if (object.randomBytes.length >= 0)
                    message.randomBytes = object.randomBytes;
            return message;
        };

        /**
         * Creates a plain object from a GetRandomBytes message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.GetRandomBytes
         * @static
         * @param {response.GetRandomBytes} message GetRandomBytes
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetRandomBytes.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.status = options.enums === String ? "SUCCESS" : 0;
                if (options.bytes === String)
                    object.randomBytes = "";
                else {
                    object.randomBytes = [];
                    if (options.bytes !== Array)
                        object.randomBytes = $util.newBuffer(object.randomBytes);
                }
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            if (message.randomBytes != null && message.hasOwnProperty("randomBytes"))
                object.randomBytes = options.bytes === String ? $util.base64.encode(message.randomBytes, 0, message.randomBytes.length) : options.bytes === Array ? Array.prototype.slice.call(message.randomBytes) : message.randomBytes;
            return object;
        };

        /**
         * Converts this GetRandomBytes to JSON.
         * @function toJSON
         * @memberof response.GetRandomBytes
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetRandomBytes.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetRandomBytes
         * @function getTypeUrl
         * @memberof response.GetRandomBytes
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetRandomBytes.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.GetRandomBytes";
        };

        return GetRandomBytes;
    })();

    response.AddRole = (function() {

        /**
         * Properties of an AddRole.
         * @memberof response
         * @interface IAddRole
         * @property {response.Status|null} [status] AddRole status
         * @property {string|null} [message] AddRole message
         */

        /**
         * Constructs a new AddRole.
         * @memberof response
         * @classdesc Represents an AddRole.
         * @implements IAddRole
         * @constructor
         * @param {response.IAddRole=} [properties] Properties to set
         */
        function AddRole(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddRole status.
         * @member {response.Status} status
         * @memberof response.AddRole
         * @instance
         */
        AddRole.prototype.status = 0;

        /**
         * AddRole message.
         * @member {string|null|undefined} message
         * @memberof response.AddRole
         * @instance
         */
        AddRole.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(AddRole.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new AddRole instance using the specified properties.
         * @function create
         * @memberof response.AddRole
         * @static
         * @param {response.IAddRole=} [properties] Properties to set
         * @returns {response.AddRole} AddRole instance
         */
        AddRole.create = function create(properties) {
            return new AddRole(properties);
        };

        /**
         * Encodes the specified AddRole message. Does not implicitly {@link response.AddRole.verify|verify} messages.
         * @function encode
         * @memberof response.AddRole
         * @static
         * @param {response.IAddRole} message AddRole message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddRole.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified AddRole message, length delimited. Does not implicitly {@link response.AddRole.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.AddRole
         * @static
         * @param {response.IAddRole} message AddRole message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddRole.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AddRole message from the specified reader or buffer.
         * @function decode
         * @memberof response.AddRole
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.AddRole} AddRole
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddRole.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.AddRole();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AddRole message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.AddRole
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.AddRole} AddRole
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddRole.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AddRole message.
         * @function verify
         * @memberof response.AddRole
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AddRole.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates an AddRole message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.AddRole
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.AddRole} AddRole
         */
        AddRole.fromObject = function fromObject(object) {
            if (object instanceof $root.response.AddRole)
                return object;
            let message = new $root.response.AddRole();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from an AddRole message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.AddRole
         * @static
         * @param {response.AddRole} message AddRole
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddRole.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this AddRole to JSON.
         * @function toJSON
         * @memberof response.AddRole
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddRole.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for AddRole
         * @function getTypeUrl
         * @memberof response.AddRole
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        AddRole.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.AddRole";
        };

        return AddRole;
    })();

    response.RemoveRole = (function() {

        /**
         * Properties of a RemoveRole.
         * @memberof response
         * @interface IRemoveRole
         * @property {response.Status|null} [status] RemoveRole status
         * @property {string|null} [message] RemoveRole message
         */

        /**
         * Constructs a new RemoveRole.
         * @memberof response
         * @classdesc Represents a RemoveRole.
         * @implements IRemoveRole
         * @constructor
         * @param {response.IRemoveRole=} [properties] Properties to set
         */
        function RemoveRole(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveRole status.
         * @member {response.Status} status
         * @memberof response.RemoveRole
         * @instance
         */
        RemoveRole.prototype.status = 0;

        /**
         * RemoveRole message.
         * @member {string|null|undefined} message
         * @memberof response.RemoveRole
         * @instance
         */
        RemoveRole.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(RemoveRole.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new RemoveRole instance using the specified properties.
         * @function create
         * @memberof response.RemoveRole
         * @static
         * @param {response.IRemoveRole=} [properties] Properties to set
         * @returns {response.RemoveRole} RemoveRole instance
         */
        RemoveRole.create = function create(properties) {
            return new RemoveRole(properties);
        };

        /**
         * Encodes the specified RemoveRole message. Does not implicitly {@link response.RemoveRole.verify|verify} messages.
         * @function encode
         * @memberof response.RemoveRole
         * @static
         * @param {response.IRemoveRole} message RemoveRole message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RemoveRole.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified RemoveRole message, length delimited. Does not implicitly {@link response.RemoveRole.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.RemoveRole
         * @static
         * @param {response.IRemoveRole} message RemoveRole message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RemoveRole.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RemoveRole message from the specified reader or buffer.
         * @function decode
         * @memberof response.RemoveRole
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.RemoveRole} RemoveRole
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RemoveRole.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.RemoveRole();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RemoveRole message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.RemoveRole
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.RemoveRole} RemoveRole
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RemoveRole.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RemoveRole message.
         * @function verify
         * @memberof response.RemoveRole
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RemoveRole.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a RemoveRole message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.RemoveRole
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.RemoveRole} RemoveRole
         */
        RemoveRole.fromObject = function fromObject(object) {
            if (object instanceof $root.response.RemoveRole)
                return object;
            let message = new $root.response.RemoveRole();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a RemoveRole message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.RemoveRole
         * @static
         * @param {response.RemoveRole} message RemoveRole
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveRole.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this RemoveRole to JSON.
         * @function toJSON
         * @memberof response.RemoveRole
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveRole.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for RemoveRole
         * @function getTypeUrl
         * @memberof response.RemoveRole
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        RemoveRole.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.RemoveRole";
        };

        return RemoveRole;
    })();

    response.UpdateRole = (function() {

        /**
         * Properties of an UpdateRole.
         * @memberof response
         * @interface IUpdateRole
         * @property {response.Status|null} [status] UpdateRole status
         * @property {string|null} [message] UpdateRole message
         */

        /**
         * Constructs a new UpdateRole.
         * @memberof response
         * @classdesc Represents an UpdateRole.
         * @implements IUpdateRole
         * @constructor
         * @param {response.IUpdateRole=} [properties] Properties to set
         */
        function UpdateRole(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateRole status.
         * @member {response.Status} status
         * @memberof response.UpdateRole
         * @instance
         */
        UpdateRole.prototype.status = 0;

        /**
         * UpdateRole message.
         * @member {string|null|undefined} message
         * @memberof response.UpdateRole
         * @instance
         */
        UpdateRole.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(UpdateRole.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new UpdateRole instance using the specified properties.
         * @function create
         * @memberof response.UpdateRole
         * @static
         * @param {response.IUpdateRole=} [properties] Properties to set
         * @returns {response.UpdateRole} UpdateRole instance
         */
        UpdateRole.create = function create(properties) {
            return new UpdateRole(properties);
        };

        /**
         * Encodes the specified UpdateRole message. Does not implicitly {@link response.UpdateRole.verify|verify} messages.
         * @function encode
         * @memberof response.UpdateRole
         * @static
         * @param {response.IUpdateRole} message UpdateRole message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateRole.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified UpdateRole message, length delimited. Does not implicitly {@link response.UpdateRole.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.UpdateRole
         * @static
         * @param {response.IUpdateRole} message UpdateRole message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateRole.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UpdateRole message from the specified reader or buffer.
         * @function decode
         * @memberof response.UpdateRole
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.UpdateRole} UpdateRole
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateRole.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.UpdateRole();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UpdateRole message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.UpdateRole
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.UpdateRole} UpdateRole
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateRole.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UpdateRole message.
         * @function verify
         * @memberof response.UpdateRole
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UpdateRole.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates an UpdateRole message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.UpdateRole
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.UpdateRole} UpdateRole
         */
        UpdateRole.fromObject = function fromObject(object) {
            if (object instanceof $root.response.UpdateRole)
                return object;
            let message = new $root.response.UpdateRole();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from an UpdateRole message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.UpdateRole
         * @static
         * @param {response.UpdateRole} message UpdateRole
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateRole.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this UpdateRole to JSON.
         * @function toJSON
         * @memberof response.UpdateRole
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateRole.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for UpdateRole
         * @function getTypeUrl
         * @memberof response.UpdateRole
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        UpdateRole.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.UpdateRole";
        };

        return UpdateRole;
    })();

    response.ListRoles = (function() {

        /**
         * Properties of a ListRoles.
         * @memberof response
         * @interface IListRoles
         * @property {response.Status|null} [status] ListRoles status
         * @property {string|null} [message] ListRoles message
         * @property {Array.<string>|null} [roles] ListRoles roles
         */

        /**
         * Constructs a new ListRoles.
         * @memberof response
         * @classdesc Represents a ListRoles.
         * @implements IListRoles
         * @constructor
         * @param {response.IListRoles=} [properties] Properties to set
         */
        function ListRoles(properties) {
            this.roles = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListRoles status.
         * @member {response.Status} status
         * @memberof response.ListRoles
         * @instance
         */
        ListRoles.prototype.status = 0;

        /**
         * ListRoles message.
         * @member {string|null|undefined} message
         * @memberof response.ListRoles
         * @instance
         */
        ListRoles.prototype.message = null;

        /**
         * ListRoles roles.
         * @member {Array.<string>} roles
         * @memberof response.ListRoles
         * @instance
         */
        ListRoles.prototype.roles = $util.emptyArray;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(ListRoles.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new ListRoles instance using the specified properties.
         * @function create
         * @memberof response.ListRoles
         * @static
         * @param {response.IListRoles=} [properties] Properties to set
         * @returns {response.ListRoles} ListRoles instance
         */
        ListRoles.create = function create(properties) {
            return new ListRoles(properties);
        };

        /**
         * Encodes the specified ListRoles message. Does not implicitly {@link response.ListRoles.verify|verify} messages.
         * @function encode
         * @memberof response.ListRoles
         * @static
         * @param {response.IListRoles} message ListRoles message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListRoles.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            if (message.roles != null && message.roles.length)
                for (let i = 0; i < message.roles.length; ++i)
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.roles[i]);
            return writer;
        };

        /**
         * Encodes the specified ListRoles message, length delimited. Does not implicitly {@link response.ListRoles.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.ListRoles
         * @static
         * @param {response.IListRoles} message ListRoles message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListRoles.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ListRoles message from the specified reader or buffer.
         * @function decode
         * @memberof response.ListRoles
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.ListRoles} ListRoles
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListRoles.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.ListRoles();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                case 3: {
                        if (!(message.roles && message.roles.length))
                            message.roles = [];
                        message.roles.push(reader.string());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ListRoles message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.ListRoles
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.ListRoles} ListRoles
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListRoles.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ListRoles message.
         * @function verify
         * @memberof response.ListRoles
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ListRoles.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            if (message.roles != null && message.hasOwnProperty("roles")) {
                if (!Array.isArray(message.roles))
                    return "roles: array expected";
                for (let i = 0; i < message.roles.length; ++i)
                    if (!$util.isString(message.roles[i]))
                        return "roles: string[] expected";
            }
            return null;
        };

        /**
         * Creates a ListRoles message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.ListRoles
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.ListRoles} ListRoles
         */
        ListRoles.fromObject = function fromObject(object) {
            if (object instanceof $root.response.ListRoles)
                return object;
            let message = new $root.response.ListRoles();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            if (object.roles) {
                if (!Array.isArray(object.roles))
                    throw TypeError(".response.ListRoles.roles: array expected");
                message.roles = [];
                for (let i = 0; i < object.roles.length; ++i)
                    message.roles[i] = String(object.roles[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a ListRoles message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.ListRoles
         * @static
         * @param {response.ListRoles} message ListRoles
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListRoles.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.roles = [];
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            if (message.roles && message.roles.length) {
                object.roles = [];
                for (let j = 0; j < message.roles.length; ++j)
                    object.roles[j] = message.roles[j];
            }
            return object;
        };

        /**
         * Converts this ListRoles to JSON.
         * @function toJSON
         * @memberof response.ListRoles
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListRoles.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ListRoles
         * @function getTypeUrl
         * @memberof response.ListRoles
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ListRoles.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.ListRoles";
        };

        return ListRoles;
    })();

    response.GetRole = (function() {

        /**
         * Properties of a GetRole.
         * @memberof response
         * @interface IGetRole
         * @property {response.Status|null} [status] GetRole status
         * @property {string|null} [message] GetRole message
         * @property {Uint8Array|null} [role] GetRole role
         */

        /**
         * Constructs a new GetRole.
         * @memberof response
         * @classdesc Represents a GetRole.
         * @implements IGetRole
         * @constructor
         * @param {response.IGetRole=} [properties] Properties to set
         */
        function GetRole(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetRole status.
         * @member {response.Status} status
         * @memberof response.GetRole
         * @instance
         */
        GetRole.prototype.status = 0;

        /**
         * GetRole message.
         * @member {string|null|undefined} message
         * @memberof response.GetRole
         * @instance
         */
        GetRole.prototype.message = null;

        /**
         * GetRole role.
         * @member {Uint8Array} role
         * @memberof response.GetRole
         * @instance
         */
        GetRole.prototype.role = $util.newBuffer([]);

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(GetRole.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new GetRole instance using the specified properties.
         * @function create
         * @memberof response.GetRole
         * @static
         * @param {response.IGetRole=} [properties] Properties to set
         * @returns {response.GetRole} GetRole instance
         */
        GetRole.create = function create(properties) {
            return new GetRole(properties);
        };

        /**
         * Encodes the specified GetRole message. Does not implicitly {@link response.GetRole.verify|verify} messages.
         * @function encode
         * @memberof response.GetRole
         * @static
         * @param {response.IGetRole} message GetRole message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetRole.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            if (message.role != null && Object.hasOwnProperty.call(message, "role"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.role);
            return writer;
        };

        /**
         * Encodes the specified GetRole message, length delimited. Does not implicitly {@link response.GetRole.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.GetRole
         * @static
         * @param {response.IGetRole} message GetRole message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetRole.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetRole message from the specified reader or buffer.
         * @function decode
         * @memberof response.GetRole
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.GetRole} GetRole
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetRole.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.GetRole();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                case 3: {
                        message.role = reader.bytes();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetRole message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.GetRole
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.GetRole} GetRole
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetRole.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetRole message.
         * @function verify
         * @memberof response.GetRole
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetRole.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            if (message.role != null && message.hasOwnProperty("role"))
                if (!(message.role && typeof message.role.length === "number" || $util.isString(message.role)))
                    return "role: buffer expected";
            return null;
        };

        /**
         * Creates a GetRole message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.GetRole
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.GetRole} GetRole
         */
        GetRole.fromObject = function fromObject(object) {
            if (object instanceof $root.response.GetRole)
                return object;
            let message = new $root.response.GetRole();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            if (object.role != null)
                if (typeof object.role === "string")
                    $util.base64.decode(object.role, message.role = $util.newBuffer($util.base64.length(object.role)), 0);
                else if (object.role.length >= 0)
                    message.role = object.role;
            return message;
        };

        /**
         * Creates a plain object from a GetRole message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.GetRole
         * @static
         * @param {response.GetRole} message GetRole
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetRole.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.status = options.enums === String ? "SUCCESS" : 0;
                if (options.bytes === String)
                    object.role = "";
                else {
                    object.role = [];
                    if (options.bytes !== Array)
                        object.role = $util.newBuffer(object.role);
                }
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            if (message.role != null && message.hasOwnProperty("role"))
                object.role = options.bytes === String ? $util.base64.encode(message.role, 0, message.role.length) : options.bytes === Array ? Array.prototype.slice.call(message.role) : message.role;
            return object;
        };

        /**
         * Converts this GetRole to JSON.
         * @function toJSON
         * @memberof response.GetRole
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetRole.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetRole
         * @function getTypeUrl
         * @memberof response.GetRole
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetRole.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.GetRole";
        };

        return GetRole;
    })();

    response.AddTeam = (function() {

        /**
         * Properties of an AddTeam.
         * @memberof response
         * @interface IAddTeam
         * @property {response.Status|null} [status] AddTeam status
         * @property {string|null} [message] AddTeam message
         */

        /**
         * Constructs a new AddTeam.
         * @memberof response
         * @classdesc Represents an AddTeam.
         * @implements IAddTeam
         * @constructor
         * @param {response.IAddTeam=} [properties] Properties to set
         */
        function AddTeam(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddTeam status.
         * @member {response.Status} status
         * @memberof response.AddTeam
         * @instance
         */
        AddTeam.prototype.status = 0;

        /**
         * AddTeam message.
         * @member {string|null|undefined} message
         * @memberof response.AddTeam
         * @instance
         */
        AddTeam.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(AddTeam.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new AddTeam instance using the specified properties.
         * @function create
         * @memberof response.AddTeam
         * @static
         * @param {response.IAddTeam=} [properties] Properties to set
         * @returns {response.AddTeam} AddTeam instance
         */
        AddTeam.create = function create(properties) {
            return new AddTeam(properties);
        };

        /**
         * Encodes the specified AddTeam message. Does not implicitly {@link response.AddTeam.verify|verify} messages.
         * @function encode
         * @memberof response.AddTeam
         * @static
         * @param {response.IAddTeam} message AddTeam message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddTeam.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified AddTeam message, length delimited. Does not implicitly {@link response.AddTeam.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.AddTeam
         * @static
         * @param {response.IAddTeam} message AddTeam message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddTeam.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AddTeam message from the specified reader or buffer.
         * @function decode
         * @memberof response.AddTeam
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.AddTeam} AddTeam
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddTeam.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.AddTeam();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AddTeam message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.AddTeam
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.AddTeam} AddTeam
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddTeam.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AddTeam message.
         * @function verify
         * @memberof response.AddTeam
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AddTeam.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates an AddTeam message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.AddTeam
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.AddTeam} AddTeam
         */
        AddTeam.fromObject = function fromObject(object) {
            if (object instanceof $root.response.AddTeam)
                return object;
            let message = new $root.response.AddTeam();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from an AddTeam message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.AddTeam
         * @static
         * @param {response.AddTeam} message AddTeam
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddTeam.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this AddTeam to JSON.
         * @function toJSON
         * @memberof response.AddTeam
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddTeam.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for AddTeam
         * @function getTypeUrl
         * @memberof response.AddTeam
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        AddTeam.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.AddTeam";
        };

        return AddTeam;
    })();

    response.RemoveTeam = (function() {

        /**
         * Properties of a RemoveTeam.
         * @memberof response
         * @interface IRemoveTeam
         * @property {response.Status|null} [status] RemoveTeam status
         * @property {string|null} [message] RemoveTeam message
         */

        /**
         * Constructs a new RemoveTeam.
         * @memberof response
         * @classdesc Represents a RemoveTeam.
         * @implements IRemoveTeam
         * @constructor
         * @param {response.IRemoveTeam=} [properties] Properties to set
         */
        function RemoveTeam(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveTeam status.
         * @member {response.Status} status
         * @memberof response.RemoveTeam
         * @instance
         */
        RemoveTeam.prototype.status = 0;

        /**
         * RemoveTeam message.
         * @member {string|null|undefined} message
         * @memberof response.RemoveTeam
         * @instance
         */
        RemoveTeam.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(RemoveTeam.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new RemoveTeam instance using the specified properties.
         * @function create
         * @memberof response.RemoveTeam
         * @static
         * @param {response.IRemoveTeam=} [properties] Properties to set
         * @returns {response.RemoveTeam} RemoveTeam instance
         */
        RemoveTeam.create = function create(properties) {
            return new RemoveTeam(properties);
        };

        /**
         * Encodes the specified RemoveTeam message. Does not implicitly {@link response.RemoveTeam.verify|verify} messages.
         * @function encode
         * @memberof response.RemoveTeam
         * @static
         * @param {response.IRemoveTeam} message RemoveTeam message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RemoveTeam.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified RemoveTeam message, length delimited. Does not implicitly {@link response.RemoveTeam.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.RemoveTeam
         * @static
         * @param {response.IRemoveTeam} message RemoveTeam message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RemoveTeam.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RemoveTeam message from the specified reader or buffer.
         * @function decode
         * @memberof response.RemoveTeam
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.RemoveTeam} RemoveTeam
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RemoveTeam.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.RemoveTeam();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RemoveTeam message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.RemoveTeam
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.RemoveTeam} RemoveTeam
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RemoveTeam.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RemoveTeam message.
         * @function verify
         * @memberof response.RemoveTeam
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RemoveTeam.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a RemoveTeam message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.RemoveTeam
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.RemoveTeam} RemoveTeam
         */
        RemoveTeam.fromObject = function fromObject(object) {
            if (object instanceof $root.response.RemoveTeam)
                return object;
            let message = new $root.response.RemoveTeam();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a RemoveTeam message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.RemoveTeam
         * @static
         * @param {response.RemoveTeam} message RemoveTeam
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveTeam.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this RemoveTeam to JSON.
         * @function toJSON
         * @memberof response.RemoveTeam
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveTeam.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for RemoveTeam
         * @function getTypeUrl
         * @memberof response.RemoveTeam
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        RemoveTeam.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.RemoveTeam";
        };

        return RemoveTeam;
    })();

    response.UpdateTeam = (function() {

        /**
         * Properties of an UpdateTeam.
         * @memberof response
         * @interface IUpdateTeam
         * @property {response.Status|null} [status] UpdateTeam status
         * @property {string|null} [message] UpdateTeam message
         */

        /**
         * Constructs a new UpdateTeam.
         * @memberof response
         * @classdesc Represents an UpdateTeam.
         * @implements IUpdateTeam
         * @constructor
         * @param {response.IUpdateTeam=} [properties] Properties to set
         */
        function UpdateTeam(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateTeam status.
         * @member {response.Status} status
         * @memberof response.UpdateTeam
         * @instance
         */
        UpdateTeam.prototype.status = 0;

        /**
         * UpdateTeam message.
         * @member {string|null|undefined} message
         * @memberof response.UpdateTeam
         * @instance
         */
        UpdateTeam.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(UpdateTeam.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new UpdateTeam instance using the specified properties.
         * @function create
         * @memberof response.UpdateTeam
         * @static
         * @param {response.IUpdateTeam=} [properties] Properties to set
         * @returns {response.UpdateTeam} UpdateTeam instance
         */
        UpdateTeam.create = function create(properties) {
            return new UpdateTeam(properties);
        };

        /**
         * Encodes the specified UpdateTeam message. Does not implicitly {@link response.UpdateTeam.verify|verify} messages.
         * @function encode
         * @memberof response.UpdateTeam
         * @static
         * @param {response.IUpdateTeam} message UpdateTeam message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateTeam.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified UpdateTeam message, length delimited. Does not implicitly {@link response.UpdateTeam.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.UpdateTeam
         * @static
         * @param {response.IUpdateTeam} message UpdateTeam message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateTeam.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UpdateTeam message from the specified reader or buffer.
         * @function decode
         * @memberof response.UpdateTeam
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.UpdateTeam} UpdateTeam
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateTeam.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.UpdateTeam();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UpdateTeam message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.UpdateTeam
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.UpdateTeam} UpdateTeam
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateTeam.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UpdateTeam message.
         * @function verify
         * @memberof response.UpdateTeam
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UpdateTeam.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates an UpdateTeam message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.UpdateTeam
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.UpdateTeam} UpdateTeam
         */
        UpdateTeam.fromObject = function fromObject(object) {
            if (object instanceof $root.response.UpdateTeam)
                return object;
            let message = new $root.response.UpdateTeam();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from an UpdateTeam message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.UpdateTeam
         * @static
         * @param {response.UpdateTeam} message UpdateTeam
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateTeam.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this UpdateTeam to JSON.
         * @function toJSON
         * @memberof response.UpdateTeam
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateTeam.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for UpdateTeam
         * @function getTypeUrl
         * @memberof response.UpdateTeam
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        UpdateTeam.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.UpdateTeam";
        };

        return UpdateTeam;
    })();

    response.ListTeams = (function() {

        /**
         * Properties of a ListTeams.
         * @memberof response
         * @interface IListTeams
         * @property {response.Status|null} [status] ListTeams status
         * @property {string|null} [message] ListTeams message
         * @property {Array.<string>|null} [teams] ListTeams teams
         */

        /**
         * Constructs a new ListTeams.
         * @memberof response
         * @classdesc Represents a ListTeams.
         * @implements IListTeams
         * @constructor
         * @param {response.IListTeams=} [properties] Properties to set
         */
        function ListTeams(properties) {
            this.teams = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListTeams status.
         * @member {response.Status} status
         * @memberof response.ListTeams
         * @instance
         */
        ListTeams.prototype.status = 0;

        /**
         * ListTeams message.
         * @member {string|null|undefined} message
         * @memberof response.ListTeams
         * @instance
         */
        ListTeams.prototype.message = null;

        /**
         * ListTeams teams.
         * @member {Array.<string>} teams
         * @memberof response.ListTeams
         * @instance
         */
        ListTeams.prototype.teams = $util.emptyArray;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(ListTeams.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new ListTeams instance using the specified properties.
         * @function create
         * @memberof response.ListTeams
         * @static
         * @param {response.IListTeams=} [properties] Properties to set
         * @returns {response.ListTeams} ListTeams instance
         */
        ListTeams.create = function create(properties) {
            return new ListTeams(properties);
        };

        /**
         * Encodes the specified ListTeams message. Does not implicitly {@link response.ListTeams.verify|verify} messages.
         * @function encode
         * @memberof response.ListTeams
         * @static
         * @param {response.IListTeams} message ListTeams message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListTeams.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            if (message.teams != null && message.teams.length)
                for (let i = 0; i < message.teams.length; ++i)
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.teams[i]);
            return writer;
        };

        /**
         * Encodes the specified ListTeams message, length delimited. Does not implicitly {@link response.ListTeams.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.ListTeams
         * @static
         * @param {response.IListTeams} message ListTeams message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListTeams.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ListTeams message from the specified reader or buffer.
         * @function decode
         * @memberof response.ListTeams
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.ListTeams} ListTeams
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListTeams.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.ListTeams();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                case 3: {
                        if (!(message.teams && message.teams.length))
                            message.teams = [];
                        message.teams.push(reader.string());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ListTeams message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.ListTeams
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.ListTeams} ListTeams
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListTeams.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ListTeams message.
         * @function verify
         * @memberof response.ListTeams
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ListTeams.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            if (message.teams != null && message.hasOwnProperty("teams")) {
                if (!Array.isArray(message.teams))
                    return "teams: array expected";
                for (let i = 0; i < message.teams.length; ++i)
                    if (!$util.isString(message.teams[i]))
                        return "teams: string[] expected";
            }
            return null;
        };

        /**
         * Creates a ListTeams message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.ListTeams
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.ListTeams} ListTeams
         */
        ListTeams.fromObject = function fromObject(object) {
            if (object instanceof $root.response.ListTeams)
                return object;
            let message = new $root.response.ListTeams();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            if (object.teams) {
                if (!Array.isArray(object.teams))
                    throw TypeError(".response.ListTeams.teams: array expected");
                message.teams = [];
                for (let i = 0; i < object.teams.length; ++i)
                    message.teams[i] = String(object.teams[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a ListTeams message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.ListTeams
         * @static
         * @param {response.ListTeams} message ListTeams
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListTeams.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.teams = [];
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            if (message.teams && message.teams.length) {
                object.teams = [];
                for (let j = 0; j < message.teams.length; ++j)
                    object.teams[j] = message.teams[j];
            }
            return object;
        };

        /**
         * Converts this ListTeams to JSON.
         * @function toJSON
         * @memberof response.ListTeams
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListTeams.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ListTeams
         * @function getTypeUrl
         * @memberof response.ListTeams
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ListTeams.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.ListTeams";
        };

        return ListTeams;
    })();

    response.GetTeam = (function() {

        /**
         * Properties of a GetTeam.
         * @memberof response
         * @interface IGetTeam
         * @property {response.Status|null} [status] GetTeam status
         * @property {string|null} [message] GetTeam message
         * @property {Uint8Array|null} [team] GetTeam team
         */

        /**
         * Constructs a new GetTeam.
         * @memberof response
         * @classdesc Represents a GetTeam.
         * @implements IGetTeam
         * @constructor
         * @param {response.IGetTeam=} [properties] Properties to set
         */
        function GetTeam(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetTeam status.
         * @member {response.Status} status
         * @memberof response.GetTeam
         * @instance
         */
        GetTeam.prototype.status = 0;

        /**
         * GetTeam message.
         * @member {string|null|undefined} message
         * @memberof response.GetTeam
         * @instance
         */
        GetTeam.prototype.message = null;

        /**
         * GetTeam team.
         * @member {Uint8Array} team
         * @memberof response.GetTeam
         * @instance
         */
        GetTeam.prototype.team = $util.newBuffer([]);

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(GetTeam.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new GetTeam instance using the specified properties.
         * @function create
         * @memberof response.GetTeam
         * @static
         * @param {response.IGetTeam=} [properties] Properties to set
         * @returns {response.GetTeam} GetTeam instance
         */
        GetTeam.create = function create(properties) {
            return new GetTeam(properties);
        };

        /**
         * Encodes the specified GetTeam message. Does not implicitly {@link response.GetTeam.verify|verify} messages.
         * @function encode
         * @memberof response.GetTeam
         * @static
         * @param {response.IGetTeam} message GetTeam message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetTeam.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            if (message.team != null && Object.hasOwnProperty.call(message, "team"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.team);
            return writer;
        };

        /**
         * Encodes the specified GetTeam message, length delimited. Does not implicitly {@link response.GetTeam.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.GetTeam
         * @static
         * @param {response.IGetTeam} message GetTeam message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetTeam.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetTeam message from the specified reader or buffer.
         * @function decode
         * @memberof response.GetTeam
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.GetTeam} GetTeam
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetTeam.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.GetTeam();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                case 3: {
                        message.team = reader.bytes();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetTeam message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.GetTeam
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.GetTeam} GetTeam
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetTeam.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetTeam message.
         * @function verify
         * @memberof response.GetTeam
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetTeam.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            if (message.team != null && message.hasOwnProperty("team"))
                if (!(message.team && typeof message.team.length === "number" || $util.isString(message.team)))
                    return "team: buffer expected";
            return null;
        };

        /**
         * Creates a GetTeam message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.GetTeam
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.GetTeam} GetTeam
         */
        GetTeam.fromObject = function fromObject(object) {
            if (object instanceof $root.response.GetTeam)
                return object;
            let message = new $root.response.GetTeam();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            if (object.team != null)
                if (typeof object.team === "string")
                    $util.base64.decode(object.team, message.team = $util.newBuffer($util.base64.length(object.team)), 0);
                else if (object.team.length >= 0)
                    message.team = object.team;
            return message;
        };

        /**
         * Creates a plain object from a GetTeam message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.GetTeam
         * @static
         * @param {response.GetTeam} message GetTeam
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetTeam.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.status = options.enums === String ? "SUCCESS" : 0;
                if (options.bytes === String)
                    object.team = "";
                else {
                    object.team = [];
                    if (options.bytes !== Array)
                        object.team = $util.newBuffer(object.team);
                }
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            if (message.team != null && message.hasOwnProperty("team"))
                object.team = options.bytes === String ? $util.base64.encode(message.team, 0, message.team.length) : options.bytes === Array ? Array.prototype.slice.call(message.team) : message.team;
            return object;
        };

        /**
         * Converts this GetTeam to JSON.
         * @function toJSON
         * @memberof response.GetTeam
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetTeam.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetTeam
         * @function getTypeUrl
         * @memberof response.GetTeam
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetTeam.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.GetTeam";
        };

        return GetTeam;
    })();

    response.IsOperationAllowed = (function() {

        /**
         * Properties of an IsOperationAllowed.
         * @memberof response
         * @interface IIsOperationAllowed
         * @property {response.Status|null} [status] IsOperationAllowed status
         * @property {string|null} [message] IsOperationAllowed message
         */

        /**
         * Constructs a new IsOperationAllowed.
         * @memberof response
         * @classdesc Represents an IsOperationAllowed.
         * @implements IIsOperationAllowed
         * @constructor
         * @param {response.IIsOperationAllowed=} [properties] Properties to set
         */
        function IsOperationAllowed(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * IsOperationAllowed status.
         * @member {response.Status} status
         * @memberof response.IsOperationAllowed
         * @instance
         */
        IsOperationAllowed.prototype.status = 0;

        /**
         * IsOperationAllowed message.
         * @member {string|null|undefined} message
         * @memberof response.IsOperationAllowed
         * @instance
         */
        IsOperationAllowed.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(IsOperationAllowed.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new IsOperationAllowed instance using the specified properties.
         * @function create
         * @memberof response.IsOperationAllowed
         * @static
         * @param {response.IIsOperationAllowed=} [properties] Properties to set
         * @returns {response.IsOperationAllowed} IsOperationAllowed instance
         */
        IsOperationAllowed.create = function create(properties) {
            return new IsOperationAllowed(properties);
        };

        /**
         * Encodes the specified IsOperationAllowed message. Does not implicitly {@link response.IsOperationAllowed.verify|verify} messages.
         * @function encode
         * @memberof response.IsOperationAllowed
         * @static
         * @param {response.IIsOperationAllowed} message IsOperationAllowed message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        IsOperationAllowed.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified IsOperationAllowed message, length delimited. Does not implicitly {@link response.IsOperationAllowed.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.IsOperationAllowed
         * @static
         * @param {response.IIsOperationAllowed} message IsOperationAllowed message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        IsOperationAllowed.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an IsOperationAllowed message from the specified reader or buffer.
         * @function decode
         * @memberof response.IsOperationAllowed
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.IsOperationAllowed} IsOperationAllowed
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        IsOperationAllowed.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.IsOperationAllowed();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an IsOperationAllowed message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.IsOperationAllowed
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.IsOperationAllowed} IsOperationAllowed
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        IsOperationAllowed.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an IsOperationAllowed message.
         * @function verify
         * @memberof response.IsOperationAllowed
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        IsOperationAllowed.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates an IsOperationAllowed message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.IsOperationAllowed
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.IsOperationAllowed} IsOperationAllowed
         */
        IsOperationAllowed.fromObject = function fromObject(object) {
            if (object instanceof $root.response.IsOperationAllowed)
                return object;
            let message = new $root.response.IsOperationAllowed();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from an IsOperationAllowed message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.IsOperationAllowed
         * @static
         * @param {response.IsOperationAllowed} message IsOperationAllowed
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        IsOperationAllowed.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this IsOperationAllowed to JSON.
         * @function toJSON
         * @memberof response.IsOperationAllowed
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        IsOperationAllowed.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for IsOperationAllowed
         * @function getTypeUrl
         * @memberof response.IsOperationAllowed
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        IsOperationAllowed.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.IsOperationAllowed";
        };

        return IsOperationAllowed;
    })();

    response.MoveFile = (function() {

        /**
         * Properties of a MoveFile.
         * @memberof response
         * @interface IMoveFile
         * @property {response.Status|null} [status] MoveFile status
         * @property {string|null} [message] MoveFile message
         */

        /**
         * Constructs a new MoveFile.
         * @memberof response
         * @classdesc Represents a MoveFile.
         * @implements IMoveFile
         * @constructor
         * @param {response.IMoveFile=} [properties] Properties to set
         */
        function MoveFile(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MoveFile status.
         * @member {response.Status} status
         * @memberof response.MoveFile
         * @instance
         */
        MoveFile.prototype.status = 0;

        /**
         * MoveFile message.
         * @member {string|null|undefined} message
         * @memberof response.MoveFile
         * @instance
         */
        MoveFile.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(MoveFile.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new MoveFile instance using the specified properties.
         * @function create
         * @memberof response.MoveFile
         * @static
         * @param {response.IMoveFile=} [properties] Properties to set
         * @returns {response.MoveFile} MoveFile instance
         */
        MoveFile.create = function create(properties) {
            return new MoveFile(properties);
        };

        /**
         * Encodes the specified MoveFile message. Does not implicitly {@link response.MoveFile.verify|verify} messages.
         * @function encode
         * @memberof response.MoveFile
         * @static
         * @param {response.IMoveFile} message MoveFile message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MoveFile.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified MoveFile message, length delimited. Does not implicitly {@link response.MoveFile.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.MoveFile
         * @static
         * @param {response.IMoveFile} message MoveFile message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MoveFile.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MoveFile message from the specified reader or buffer.
         * @function decode
         * @memberof response.MoveFile
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.MoveFile} MoveFile
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MoveFile.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.MoveFile();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MoveFile message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.MoveFile
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.MoveFile} MoveFile
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MoveFile.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MoveFile message.
         * @function verify
         * @memberof response.MoveFile
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MoveFile.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a MoveFile message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.MoveFile
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.MoveFile} MoveFile
         */
        MoveFile.fromObject = function fromObject(object) {
            if (object instanceof $root.response.MoveFile)
                return object;
            let message = new $root.response.MoveFile();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a MoveFile message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.MoveFile
         * @static
         * @param {response.MoveFile} message MoveFile
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MoveFile.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this MoveFile to JSON.
         * @function toJSON
         * @memberof response.MoveFile
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MoveFile.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for MoveFile
         * @function getTypeUrl
         * @memberof response.MoveFile
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        MoveFile.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.MoveFile";
        };

        return MoveFile;
    })();

    response.MoveFolder = (function() {

        /**
         * Properties of a MoveFolder.
         * @memberof response
         * @interface IMoveFolder
         * @property {response.Status|null} [status] MoveFolder status
         * @property {string|null} [message] MoveFolder message
         */

        /**
         * Constructs a new MoveFolder.
         * @memberof response
         * @classdesc Represents a MoveFolder.
         * @implements IMoveFolder
         * @constructor
         * @param {response.IMoveFolder=} [properties] Properties to set
         */
        function MoveFolder(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MoveFolder status.
         * @member {response.Status} status
         * @memberof response.MoveFolder
         * @instance
         */
        MoveFolder.prototype.status = 0;

        /**
         * MoveFolder message.
         * @member {string|null|undefined} message
         * @memberof response.MoveFolder
         * @instance
         */
        MoveFolder.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(MoveFolder.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new MoveFolder instance using the specified properties.
         * @function create
         * @memberof response.MoveFolder
         * @static
         * @param {response.IMoveFolder=} [properties] Properties to set
         * @returns {response.MoveFolder} MoveFolder instance
         */
        MoveFolder.create = function create(properties) {
            return new MoveFolder(properties);
        };

        /**
         * Encodes the specified MoveFolder message. Does not implicitly {@link response.MoveFolder.verify|verify} messages.
         * @function encode
         * @memberof response.MoveFolder
         * @static
         * @param {response.IMoveFolder} message MoveFolder message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MoveFolder.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified MoveFolder message, length delimited. Does not implicitly {@link response.MoveFolder.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.MoveFolder
         * @static
         * @param {response.IMoveFolder} message MoveFolder message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MoveFolder.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MoveFolder message from the specified reader or buffer.
         * @function decode
         * @memberof response.MoveFolder
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.MoveFolder} MoveFolder
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MoveFolder.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.MoveFolder();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MoveFolder message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.MoveFolder
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.MoveFolder} MoveFolder
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MoveFolder.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MoveFolder message.
         * @function verify
         * @memberof response.MoveFolder
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MoveFolder.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a MoveFolder message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.MoveFolder
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.MoveFolder} MoveFolder
         */
        MoveFolder.fromObject = function fromObject(object) {
            if (object instanceof $root.response.MoveFolder)
                return object;
            let message = new $root.response.MoveFolder();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a MoveFolder message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.MoveFolder
         * @static
         * @param {response.MoveFolder} message MoveFolder
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MoveFolder.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this MoveFolder to JSON.
         * @function toJSON
         * @memberof response.MoveFolder
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MoveFolder.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for MoveFolder
         * @function getTypeUrl
         * @memberof response.MoveFolder
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        MoveFolder.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.MoveFolder";
        };

        return MoveFolder;
    })();

    response.CopyFile = (function() {

        /**
         * Properties of a CopyFile.
         * @memberof response
         * @interface ICopyFile
         * @property {response.Status|null} [status] CopyFile status
         * @property {string|null} [message] CopyFile message
         */

        /**
         * Constructs a new CopyFile.
         * @memberof response
         * @classdesc Represents a CopyFile.
         * @implements ICopyFile
         * @constructor
         * @param {response.ICopyFile=} [properties] Properties to set
         */
        function CopyFile(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CopyFile status.
         * @member {response.Status} status
         * @memberof response.CopyFile
         * @instance
         */
        CopyFile.prototype.status = 0;

        /**
         * CopyFile message.
         * @member {string|null|undefined} message
         * @memberof response.CopyFile
         * @instance
         */
        CopyFile.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(CopyFile.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new CopyFile instance using the specified properties.
         * @function create
         * @memberof response.CopyFile
         * @static
         * @param {response.ICopyFile=} [properties] Properties to set
         * @returns {response.CopyFile} CopyFile instance
         */
        CopyFile.create = function create(properties) {
            return new CopyFile(properties);
        };

        /**
         * Encodes the specified CopyFile message. Does not implicitly {@link response.CopyFile.verify|verify} messages.
         * @function encode
         * @memberof response.CopyFile
         * @static
         * @param {response.ICopyFile} message CopyFile message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CopyFile.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified CopyFile message, length delimited. Does not implicitly {@link response.CopyFile.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.CopyFile
         * @static
         * @param {response.ICopyFile} message CopyFile message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CopyFile.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CopyFile message from the specified reader or buffer.
         * @function decode
         * @memberof response.CopyFile
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.CopyFile} CopyFile
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CopyFile.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.CopyFile();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CopyFile message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.CopyFile
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.CopyFile} CopyFile
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CopyFile.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CopyFile message.
         * @function verify
         * @memberof response.CopyFile
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CopyFile.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a CopyFile message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.CopyFile
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.CopyFile} CopyFile
         */
        CopyFile.fromObject = function fromObject(object) {
            if (object instanceof $root.response.CopyFile)
                return object;
            let message = new $root.response.CopyFile();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a CopyFile message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.CopyFile
         * @static
         * @param {response.CopyFile} message CopyFile
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CopyFile.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this CopyFile to JSON.
         * @function toJSON
         * @memberof response.CopyFile
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CopyFile.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CopyFile
         * @function getTypeUrl
         * @memberof response.CopyFile
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CopyFile.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.CopyFile";
        };

        return CopyFile;
    })();

    response.CopyFolder = (function() {

        /**
         * Properties of a CopyFolder.
         * @memberof response
         * @interface ICopyFolder
         * @property {response.Status|null} [status] CopyFolder status
         * @property {string|null} [message] CopyFolder message
         * @property {Array.<string>|null} [pathsOfFilesFailedToCopy] CopyFolder pathsOfFilesFailedToCopy
         */

        /**
         * Constructs a new CopyFolder.
         * @memberof response
         * @classdesc Represents a CopyFolder.
         * @implements ICopyFolder
         * @constructor
         * @param {response.ICopyFolder=} [properties] Properties to set
         */
        function CopyFolder(properties) {
            this.pathsOfFilesFailedToCopy = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CopyFolder status.
         * @member {response.Status} status
         * @memberof response.CopyFolder
         * @instance
         */
        CopyFolder.prototype.status = 0;

        /**
         * CopyFolder message.
         * @member {string|null|undefined} message
         * @memberof response.CopyFolder
         * @instance
         */
        CopyFolder.prototype.message = null;

        /**
         * CopyFolder pathsOfFilesFailedToCopy.
         * @member {Array.<string>} pathsOfFilesFailedToCopy
         * @memberof response.CopyFolder
         * @instance
         */
        CopyFolder.prototype.pathsOfFilesFailedToCopy = $util.emptyArray;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(CopyFolder.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new CopyFolder instance using the specified properties.
         * @function create
         * @memberof response.CopyFolder
         * @static
         * @param {response.ICopyFolder=} [properties] Properties to set
         * @returns {response.CopyFolder} CopyFolder instance
         */
        CopyFolder.create = function create(properties) {
            return new CopyFolder(properties);
        };

        /**
         * Encodes the specified CopyFolder message. Does not implicitly {@link response.CopyFolder.verify|verify} messages.
         * @function encode
         * @memberof response.CopyFolder
         * @static
         * @param {response.ICopyFolder} message CopyFolder message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CopyFolder.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.message);
            if (message.pathsOfFilesFailedToCopy != null && message.pathsOfFilesFailedToCopy.length)
                for (let i = 0; i < message.pathsOfFilesFailedToCopy.length; ++i)
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.pathsOfFilesFailedToCopy[i]);
            return writer;
        };

        /**
         * Encodes the specified CopyFolder message, length delimited. Does not implicitly {@link response.CopyFolder.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.CopyFolder
         * @static
         * @param {response.ICopyFolder} message CopyFolder message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CopyFolder.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CopyFolder message from the specified reader or buffer.
         * @function decode
         * @memberof response.CopyFolder
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.CopyFolder} CopyFolder
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CopyFolder.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.CopyFolder();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 4: {
                        message.message = reader.string();
                        break;
                    }
                case 5: {
                        if (!(message.pathsOfFilesFailedToCopy && message.pathsOfFilesFailedToCopy.length))
                            message.pathsOfFilesFailedToCopy = [];
                        message.pathsOfFilesFailedToCopy.push(reader.string());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CopyFolder message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.CopyFolder
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.CopyFolder} CopyFolder
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CopyFolder.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CopyFolder message.
         * @function verify
         * @memberof response.CopyFolder
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CopyFolder.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            if (message.pathsOfFilesFailedToCopy != null && message.hasOwnProperty("pathsOfFilesFailedToCopy")) {
                if (!Array.isArray(message.pathsOfFilesFailedToCopy))
                    return "pathsOfFilesFailedToCopy: array expected";
                for (let i = 0; i < message.pathsOfFilesFailedToCopy.length; ++i)
                    if (!$util.isString(message.pathsOfFilesFailedToCopy[i]))
                        return "pathsOfFilesFailedToCopy: string[] expected";
            }
            return null;
        };

        /**
         * Creates a CopyFolder message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.CopyFolder
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.CopyFolder} CopyFolder
         */
        CopyFolder.fromObject = function fromObject(object) {
            if (object instanceof $root.response.CopyFolder)
                return object;
            let message = new $root.response.CopyFolder();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            if (object.pathsOfFilesFailedToCopy) {
                if (!Array.isArray(object.pathsOfFilesFailedToCopy))
                    throw TypeError(".response.CopyFolder.pathsOfFilesFailedToCopy: array expected");
                message.pathsOfFilesFailedToCopy = [];
                for (let i = 0; i < object.pathsOfFilesFailedToCopy.length; ++i)
                    message.pathsOfFilesFailedToCopy[i] = String(object.pathsOfFilesFailedToCopy[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a CopyFolder message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.CopyFolder
         * @static
         * @param {response.CopyFolder} message CopyFolder
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CopyFolder.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.pathsOfFilesFailedToCopy = [];
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            if (message.pathsOfFilesFailedToCopy && message.pathsOfFilesFailedToCopy.length) {
                object.pathsOfFilesFailedToCopy = [];
                for (let j = 0; j < message.pathsOfFilesFailedToCopy.length; ++j)
                    object.pathsOfFilesFailedToCopy[j] = message.pathsOfFilesFailedToCopy[j];
            }
            return object;
        };

        /**
         * Converts this CopyFolder to JSON.
         * @function toJSON
         * @memberof response.CopyFolder
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CopyFolder.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CopyFolder
         * @function getTypeUrl
         * @memberof response.CopyFolder
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CopyFolder.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.CopyFolder";
        };

        return CopyFolder;
    })();

    response.RestoreVersion = (function() {

        /**
         * Properties of a RestoreVersion.
         * @memberof response
         * @interface IRestoreVersion
         * @property {response.Status|null} [status] RestoreVersion status
         * @property {string|null} [message] RestoreVersion message
         */

        /**
         * Constructs a new RestoreVersion.
         * @memberof response
         * @classdesc Represents a RestoreVersion.
         * @implements IRestoreVersion
         * @constructor
         * @param {response.IRestoreVersion=} [properties] Properties to set
         */
        function RestoreVersion(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RestoreVersion status.
         * @member {response.Status} status
         * @memberof response.RestoreVersion
         * @instance
         */
        RestoreVersion.prototype.status = 0;

        /**
         * RestoreVersion message.
         * @member {string|null|undefined} message
         * @memberof response.RestoreVersion
         * @instance
         */
        RestoreVersion.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(RestoreVersion.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new RestoreVersion instance using the specified properties.
         * @function create
         * @memberof response.RestoreVersion
         * @static
         * @param {response.IRestoreVersion=} [properties] Properties to set
         * @returns {response.RestoreVersion} RestoreVersion instance
         */
        RestoreVersion.create = function create(properties) {
            return new RestoreVersion(properties);
        };

        /**
         * Encodes the specified RestoreVersion message. Does not implicitly {@link response.RestoreVersion.verify|verify} messages.
         * @function encode
         * @memberof response.RestoreVersion
         * @static
         * @param {response.IRestoreVersion} message RestoreVersion message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RestoreVersion.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified RestoreVersion message, length delimited. Does not implicitly {@link response.RestoreVersion.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.RestoreVersion
         * @static
         * @param {response.IRestoreVersion} message RestoreVersion message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RestoreVersion.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RestoreVersion message from the specified reader or buffer.
         * @function decode
         * @memberof response.RestoreVersion
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.RestoreVersion} RestoreVersion
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RestoreVersion.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.RestoreVersion();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 4: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RestoreVersion message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.RestoreVersion
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.RestoreVersion} RestoreVersion
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RestoreVersion.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RestoreVersion message.
         * @function verify
         * @memberof response.RestoreVersion
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RestoreVersion.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a RestoreVersion message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.RestoreVersion
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.RestoreVersion} RestoreVersion
         */
        RestoreVersion.fromObject = function fromObject(object) {
            if (object instanceof $root.response.RestoreVersion)
                return object;
            let message = new $root.response.RestoreVersion();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a RestoreVersion message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.RestoreVersion
         * @static
         * @param {response.RestoreVersion} message RestoreVersion
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RestoreVersion.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this RestoreVersion to JSON.
         * @function toJSON
         * @memberof response.RestoreVersion
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RestoreVersion.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for RestoreVersion
         * @function getTypeUrl
         * @memberof response.RestoreVersion
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        RestoreVersion.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.RestoreVersion";
        };

        return RestoreVersion;
    })();

    response.RemoveFile = (function() {

        /**
         * Properties of a RemoveFile.
         * @memberof response
         * @interface IRemoveFile
         * @property {response.Status|null} [status] RemoveFile status
         * @property {string|null} [message] RemoveFile message
         */

        /**
         * Constructs a new RemoveFile.
         * @memberof response
         * @classdesc Represents a RemoveFile.
         * @implements IRemoveFile
         * @constructor
         * @param {response.IRemoveFile=} [properties] Properties to set
         */
        function RemoveFile(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveFile status.
         * @member {response.Status} status
         * @memberof response.RemoveFile
         * @instance
         */
        RemoveFile.prototype.status = 0;

        /**
         * RemoveFile message.
         * @member {string|null|undefined} message
         * @memberof response.RemoveFile
         * @instance
         */
        RemoveFile.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(RemoveFile.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new RemoveFile instance using the specified properties.
         * @function create
         * @memberof response.RemoveFile
         * @static
         * @param {response.IRemoveFile=} [properties] Properties to set
         * @returns {response.RemoveFile} RemoveFile instance
         */
        RemoveFile.create = function create(properties) {
            return new RemoveFile(properties);
        };

        /**
         * Encodes the specified RemoveFile message. Does not implicitly {@link response.RemoveFile.verify|verify} messages.
         * @function encode
         * @memberof response.RemoveFile
         * @static
         * @param {response.IRemoveFile} message RemoveFile message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RemoveFile.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified RemoveFile message, length delimited. Does not implicitly {@link response.RemoveFile.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.RemoveFile
         * @static
         * @param {response.IRemoveFile} message RemoveFile message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RemoveFile.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RemoveFile message from the specified reader or buffer.
         * @function decode
         * @memberof response.RemoveFile
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.RemoveFile} RemoveFile
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RemoveFile.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.RemoveFile();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 4: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RemoveFile message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.RemoveFile
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.RemoveFile} RemoveFile
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RemoveFile.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RemoveFile message.
         * @function verify
         * @memberof response.RemoveFile
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RemoveFile.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a RemoveFile message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.RemoveFile
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.RemoveFile} RemoveFile
         */
        RemoveFile.fromObject = function fromObject(object) {
            if (object instanceof $root.response.RemoveFile)
                return object;
            let message = new $root.response.RemoveFile();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a RemoveFile message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.RemoveFile
         * @static
         * @param {response.RemoveFile} message RemoveFile
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveFile.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this RemoveFile to JSON.
         * @function toJSON
         * @memberof response.RemoveFile
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveFile.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for RemoveFile
         * @function getTypeUrl
         * @memberof response.RemoveFile
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        RemoveFile.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.RemoveFile";
        };

        return RemoveFile;
    })();

    response.RemoveFolder = (function() {

        /**
         * Properties of a RemoveFolder.
         * @memberof response
         * @interface IRemoveFolder
         * @property {response.Status|null} [status] RemoveFolder status
         * @property {string|null} [message] RemoveFolder message
         */

        /**
         * Constructs a new RemoveFolder.
         * @memberof response
         * @classdesc Represents a RemoveFolder.
         * @implements IRemoveFolder
         * @constructor
         * @param {response.IRemoveFolder=} [properties] Properties to set
         */
        function RemoveFolder(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveFolder status.
         * @member {response.Status} status
         * @memberof response.RemoveFolder
         * @instance
         */
        RemoveFolder.prototype.status = 0;

        /**
         * RemoveFolder message.
         * @member {string|null|undefined} message
         * @memberof response.RemoveFolder
         * @instance
         */
        RemoveFolder.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(RemoveFolder.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new RemoveFolder instance using the specified properties.
         * @function create
         * @memberof response.RemoveFolder
         * @static
         * @param {response.IRemoveFolder=} [properties] Properties to set
         * @returns {response.RemoveFolder} RemoveFolder instance
         */
        RemoveFolder.create = function create(properties) {
            return new RemoveFolder(properties);
        };

        /**
         * Encodes the specified RemoveFolder message. Does not implicitly {@link response.RemoveFolder.verify|verify} messages.
         * @function encode
         * @memberof response.RemoveFolder
         * @static
         * @param {response.IRemoveFolder} message RemoveFolder message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RemoveFolder.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified RemoveFolder message, length delimited. Does not implicitly {@link response.RemoveFolder.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.RemoveFolder
         * @static
         * @param {response.IRemoveFolder} message RemoveFolder message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RemoveFolder.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RemoveFolder message from the specified reader or buffer.
         * @function decode
         * @memberof response.RemoveFolder
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.RemoveFolder} RemoveFolder
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RemoveFolder.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.RemoveFolder();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 4: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RemoveFolder message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.RemoveFolder
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.RemoveFolder} RemoveFolder
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RemoveFolder.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RemoveFolder message.
         * @function verify
         * @memberof response.RemoveFolder
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RemoveFolder.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a RemoveFolder message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.RemoveFolder
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.RemoveFolder} RemoveFolder
         */
        RemoveFolder.fromObject = function fromObject(object) {
            if (object instanceof $root.response.RemoveFolder)
                return object;
            let message = new $root.response.RemoveFolder();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a RemoveFolder message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.RemoveFolder
         * @static
         * @param {response.RemoveFolder} message RemoveFolder
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveFolder.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this RemoveFolder to JSON.
         * @function toJSON
         * @memberof response.RemoveFolder
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveFolder.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for RemoveFolder
         * @function getTypeUrl
         * @memberof response.RemoveFolder
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        RemoveFolder.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.RemoveFolder";
        };

        return RemoveFolder;
    })();

    response.UntrashFile = (function() {

        /**
         * Properties of an UntrashFile.
         * @memberof response
         * @interface IUntrashFile
         * @property {response.Status|null} [status] UntrashFile status
         * @property {string|null} [message] UntrashFile message
         */

        /**
         * Constructs a new UntrashFile.
         * @memberof response
         * @classdesc Represents an UntrashFile.
         * @implements IUntrashFile
         * @constructor
         * @param {response.IUntrashFile=} [properties] Properties to set
         */
        function UntrashFile(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UntrashFile status.
         * @member {response.Status} status
         * @memberof response.UntrashFile
         * @instance
         */
        UntrashFile.prototype.status = 0;

        /**
         * UntrashFile message.
         * @member {string|null|undefined} message
         * @memberof response.UntrashFile
         * @instance
         */
        UntrashFile.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(UntrashFile.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new UntrashFile instance using the specified properties.
         * @function create
         * @memberof response.UntrashFile
         * @static
         * @param {response.IUntrashFile=} [properties] Properties to set
         * @returns {response.UntrashFile} UntrashFile instance
         */
        UntrashFile.create = function create(properties) {
            return new UntrashFile(properties);
        };

        /**
         * Encodes the specified UntrashFile message. Does not implicitly {@link response.UntrashFile.verify|verify} messages.
         * @function encode
         * @memberof response.UntrashFile
         * @static
         * @param {response.IUntrashFile} message UntrashFile message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UntrashFile.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified UntrashFile message, length delimited. Does not implicitly {@link response.UntrashFile.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.UntrashFile
         * @static
         * @param {response.IUntrashFile} message UntrashFile message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UntrashFile.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UntrashFile message from the specified reader or buffer.
         * @function decode
         * @memberof response.UntrashFile
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.UntrashFile} UntrashFile
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UntrashFile.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.UntrashFile();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 4: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UntrashFile message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.UntrashFile
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.UntrashFile} UntrashFile
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UntrashFile.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UntrashFile message.
         * @function verify
         * @memberof response.UntrashFile
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UntrashFile.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates an UntrashFile message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.UntrashFile
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.UntrashFile} UntrashFile
         */
        UntrashFile.fromObject = function fromObject(object) {
            if (object instanceof $root.response.UntrashFile)
                return object;
            let message = new $root.response.UntrashFile();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from an UntrashFile message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.UntrashFile
         * @static
         * @param {response.UntrashFile} message UntrashFile
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UntrashFile.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this UntrashFile to JSON.
         * @function toJSON
         * @memberof response.UntrashFile
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UntrashFile.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for UntrashFile
         * @function getTypeUrl
         * @memberof response.UntrashFile
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        UntrashFile.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.UntrashFile";
        };

        return UntrashFile;
    })();

    response.UntrashFolder = (function() {

        /**
         * Properties of an UntrashFolder.
         * @memberof response
         * @interface IUntrashFolder
         * @property {response.Status|null} [status] UntrashFolder status
         * @property {string|null} [message] UntrashFolder message
         */

        /**
         * Constructs a new UntrashFolder.
         * @memberof response
         * @classdesc Represents an UntrashFolder.
         * @implements IUntrashFolder
         * @constructor
         * @param {response.IUntrashFolder=} [properties] Properties to set
         */
        function UntrashFolder(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UntrashFolder status.
         * @member {response.Status} status
         * @memberof response.UntrashFolder
         * @instance
         */
        UntrashFolder.prototype.status = 0;

        /**
         * UntrashFolder message.
         * @member {string|null|undefined} message
         * @memberof response.UntrashFolder
         * @instance
         */
        UntrashFolder.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(UntrashFolder.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new UntrashFolder instance using the specified properties.
         * @function create
         * @memberof response.UntrashFolder
         * @static
         * @param {response.IUntrashFolder=} [properties] Properties to set
         * @returns {response.UntrashFolder} UntrashFolder instance
         */
        UntrashFolder.create = function create(properties) {
            return new UntrashFolder(properties);
        };

        /**
         * Encodes the specified UntrashFolder message. Does not implicitly {@link response.UntrashFolder.verify|verify} messages.
         * @function encode
         * @memberof response.UntrashFolder
         * @static
         * @param {response.IUntrashFolder} message UntrashFolder message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UntrashFolder.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified UntrashFolder message, length delimited. Does not implicitly {@link response.UntrashFolder.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.UntrashFolder
         * @static
         * @param {response.IUntrashFolder} message UntrashFolder message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UntrashFolder.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UntrashFolder message from the specified reader or buffer.
         * @function decode
         * @memberof response.UntrashFolder
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.UntrashFolder} UntrashFolder
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UntrashFolder.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.UntrashFolder();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 4: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UntrashFolder message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.UntrashFolder
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.UntrashFolder} UntrashFolder
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UntrashFolder.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UntrashFolder message.
         * @function verify
         * @memberof response.UntrashFolder
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UntrashFolder.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates an UntrashFolder message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.UntrashFolder
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.UntrashFolder} UntrashFolder
         */
        UntrashFolder.fromObject = function fromObject(object) {
            if (object instanceof $root.response.UntrashFolder)
                return object;
            let message = new $root.response.UntrashFolder();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from an UntrashFolder message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.UntrashFolder
         * @static
         * @param {response.UntrashFolder} message UntrashFolder
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UntrashFolder.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this UntrashFolder to JSON.
         * @function toJSON
         * @memberof response.UntrashFolder
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UntrashFolder.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for UntrashFolder
         * @function getTypeUrl
         * @memberof response.UntrashFolder
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        UntrashFolder.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.UntrashFolder";
        };

        return UntrashFolder;
    })();

    response.UndoStartWrite = (function() {

        /**
         * Properties of an UndoStartWrite.
         * @memberof response
         * @interface IUndoStartWrite
         * @property {response.Status|null} [status] UndoStartWrite status
         * @property {string|null} [message] UndoStartWrite message
         */

        /**
         * Constructs a new UndoStartWrite.
         * @memberof response
         * @classdesc Represents an UndoStartWrite.
         * @implements IUndoStartWrite
         * @constructor
         * @param {response.IUndoStartWrite=} [properties] Properties to set
         */
        function UndoStartWrite(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UndoStartWrite status.
         * @member {response.Status} status
         * @memberof response.UndoStartWrite
         * @instance
         */
        UndoStartWrite.prototype.status = 0;

        /**
         * UndoStartWrite message.
         * @member {string|null|undefined} message
         * @memberof response.UndoStartWrite
         * @instance
         */
        UndoStartWrite.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(UndoStartWrite.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new UndoStartWrite instance using the specified properties.
         * @function create
         * @memberof response.UndoStartWrite
         * @static
         * @param {response.IUndoStartWrite=} [properties] Properties to set
         * @returns {response.UndoStartWrite} UndoStartWrite instance
         */
        UndoStartWrite.create = function create(properties) {
            return new UndoStartWrite(properties);
        };

        /**
         * Encodes the specified UndoStartWrite message. Does not implicitly {@link response.UndoStartWrite.verify|verify} messages.
         * @function encode
         * @memberof response.UndoStartWrite
         * @static
         * @param {response.IUndoStartWrite} message UndoStartWrite message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UndoStartWrite.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified UndoStartWrite message, length delimited. Does not implicitly {@link response.UndoStartWrite.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.UndoStartWrite
         * @static
         * @param {response.IUndoStartWrite} message UndoStartWrite message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UndoStartWrite.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UndoStartWrite message from the specified reader or buffer.
         * @function decode
         * @memberof response.UndoStartWrite
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.UndoStartWrite} UndoStartWrite
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UndoStartWrite.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.UndoStartWrite();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 4: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UndoStartWrite message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.UndoStartWrite
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.UndoStartWrite} UndoStartWrite
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UndoStartWrite.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UndoStartWrite message.
         * @function verify
         * @memberof response.UndoStartWrite
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UndoStartWrite.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates an UndoStartWrite message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.UndoStartWrite
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.UndoStartWrite} UndoStartWrite
         */
        UndoStartWrite.fromObject = function fromObject(object) {
            if (object instanceof $root.response.UndoStartWrite)
                return object;
            let message = new $root.response.UndoStartWrite();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from an UndoStartWrite message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.UndoStartWrite
         * @static
         * @param {response.UndoStartWrite} message UndoStartWrite
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UndoStartWrite.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this UndoStartWrite to JSON.
         * @function toJSON
         * @memberof response.UndoStartWrite
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UndoStartWrite.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for UndoStartWrite
         * @function getTypeUrl
         * @memberof response.UndoStartWrite
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        UndoStartWrite.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.UndoStartWrite";
        };

        return UndoStartWrite;
    })();

    response.DetachClonedFolder = (function() {

        /**
         * Properties of a DetachClonedFolder.
         * @memberof response
         * @interface IDetachClonedFolder
         * @property {response.Status|null} [status] DetachClonedFolder status
         * @property {string|null} [message] DetachClonedFolder message
         */

        /**
         * Constructs a new DetachClonedFolder.
         * @memberof response
         * @classdesc Represents a DetachClonedFolder.
         * @implements IDetachClonedFolder
         * @constructor
         * @param {response.IDetachClonedFolder=} [properties] Properties to set
         */
        function DetachClonedFolder(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DetachClonedFolder status.
         * @member {response.Status} status
         * @memberof response.DetachClonedFolder
         * @instance
         */
        DetachClonedFolder.prototype.status = 0;

        /**
         * DetachClonedFolder message.
         * @member {string|null|undefined} message
         * @memberof response.DetachClonedFolder
         * @instance
         */
        DetachClonedFolder.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(DetachClonedFolder.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new DetachClonedFolder instance using the specified properties.
         * @function create
         * @memberof response.DetachClonedFolder
         * @static
         * @param {response.IDetachClonedFolder=} [properties] Properties to set
         * @returns {response.DetachClonedFolder} DetachClonedFolder instance
         */
        DetachClonedFolder.create = function create(properties) {
            return new DetachClonedFolder(properties);
        };

        /**
         * Encodes the specified DetachClonedFolder message. Does not implicitly {@link response.DetachClonedFolder.verify|verify} messages.
         * @function encode
         * @memberof response.DetachClonedFolder
         * @static
         * @param {response.IDetachClonedFolder} message DetachClonedFolder message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DetachClonedFolder.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified DetachClonedFolder message, length delimited. Does not implicitly {@link response.DetachClonedFolder.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.DetachClonedFolder
         * @static
         * @param {response.IDetachClonedFolder} message DetachClonedFolder message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DetachClonedFolder.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a DetachClonedFolder message from the specified reader or buffer.
         * @function decode
         * @memberof response.DetachClonedFolder
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.DetachClonedFolder} DetachClonedFolder
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DetachClonedFolder.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.DetachClonedFolder();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 4: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a DetachClonedFolder message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.DetachClonedFolder
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.DetachClonedFolder} DetachClonedFolder
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DetachClonedFolder.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a DetachClonedFolder message.
         * @function verify
         * @memberof response.DetachClonedFolder
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        DetachClonedFolder.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a DetachClonedFolder message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.DetachClonedFolder
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.DetachClonedFolder} DetachClonedFolder
         */
        DetachClonedFolder.fromObject = function fromObject(object) {
            if (object instanceof $root.response.DetachClonedFolder)
                return object;
            let message = new $root.response.DetachClonedFolder();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a DetachClonedFolder message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.DetachClonedFolder
         * @static
         * @param {response.DetachClonedFolder} message DetachClonedFolder
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DetachClonedFolder.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this DetachClonedFolder to JSON.
         * @function toJSON
         * @memberof response.DetachClonedFolder
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DetachClonedFolder.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for DetachClonedFolder
         * @function getTypeUrl
         * @memberof response.DetachClonedFolder
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        DetachClonedFolder.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.DetachClonedFolder";
        };

        return DetachClonedFolder;
    })();

    response.AuditLogMessage = (function() {

        /**
         * Properties of an AuditLogMessage.
         * @memberof response
         * @interface IAuditLogMessage
         * @property {response.Status|null} [status] AuditLogMessage status
         * @property {string|null} [logFile] AuditLogMessage logFile
         * @property {string|null} [message] AuditLogMessage message
         */

        /**
         * Constructs a new AuditLogMessage.
         * @memberof response
         * @classdesc Represents an AuditLogMessage.
         * @implements IAuditLogMessage
         * @constructor
         * @param {response.IAuditLogMessage=} [properties] Properties to set
         */
        function AuditLogMessage(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AuditLogMessage status.
         * @member {response.Status} status
         * @memberof response.AuditLogMessage
         * @instance
         */
        AuditLogMessage.prototype.status = 0;

        /**
         * AuditLogMessage logFile.
         * @member {string|null|undefined} logFile
         * @memberof response.AuditLogMessage
         * @instance
         */
        AuditLogMessage.prototype.logFile = null;

        /**
         * AuditLogMessage message.
         * @member {string|null|undefined} message
         * @memberof response.AuditLogMessage
         * @instance
         */
        AuditLogMessage.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(AuditLogMessage.prototype, "_logFile", {
            get: $util.oneOfGetter($oneOfFields = ["logFile"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(AuditLogMessage.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new AuditLogMessage instance using the specified properties.
         * @function create
         * @memberof response.AuditLogMessage
         * @static
         * @param {response.IAuditLogMessage=} [properties] Properties to set
         * @returns {response.AuditLogMessage} AuditLogMessage instance
         */
        AuditLogMessage.create = function create(properties) {
            return new AuditLogMessage(properties);
        };

        /**
         * Encodes the specified AuditLogMessage message. Does not implicitly {@link response.AuditLogMessage.verify|verify} messages.
         * @function encode
         * @memberof response.AuditLogMessage
         * @static
         * @param {response.IAuditLogMessage} message AuditLogMessage message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AuditLogMessage.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.logFile != null && Object.hasOwnProperty.call(message, "logFile"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.logFile);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified AuditLogMessage message, length delimited. Does not implicitly {@link response.AuditLogMessage.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.AuditLogMessage
         * @static
         * @param {response.IAuditLogMessage} message AuditLogMessage message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AuditLogMessage.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AuditLogMessage message from the specified reader or buffer.
         * @function decode
         * @memberof response.AuditLogMessage
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.AuditLogMessage} AuditLogMessage
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AuditLogMessage.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.AuditLogMessage();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.logFile = reader.string();
                        break;
                    }
                case 3: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AuditLogMessage message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.AuditLogMessage
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.AuditLogMessage} AuditLogMessage
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AuditLogMessage.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AuditLogMessage message.
         * @function verify
         * @memberof response.AuditLogMessage
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AuditLogMessage.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.logFile != null && message.hasOwnProperty("logFile")) {
                properties._logFile = 1;
                if (!$util.isString(message.logFile))
                    return "logFile: string expected";
            }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates an AuditLogMessage message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.AuditLogMessage
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.AuditLogMessage} AuditLogMessage
         */
        AuditLogMessage.fromObject = function fromObject(object) {
            if (object instanceof $root.response.AuditLogMessage)
                return object;
            let message = new $root.response.AuditLogMessage();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.logFile != null)
                message.logFile = String(object.logFile);
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from an AuditLogMessage message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.AuditLogMessage
         * @static
         * @param {response.AuditLogMessage} message AuditLogMessage
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AuditLogMessage.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.logFile != null && message.hasOwnProperty("logFile")) {
                object.logFile = message.logFile;
                if (options.oneofs)
                    object._logFile = "logFile";
            }
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this AuditLogMessage to JSON.
         * @function toJSON
         * @memberof response.AuditLogMessage
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AuditLogMessage.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for AuditLogMessage
         * @function getTypeUrl
         * @memberof response.AuditLogMessage
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        AuditLogMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.AuditLogMessage";
        };

        return AuditLogMessage;
    })();

    response.GetLedgerRange = (function() {

        /**
         * Properties of a GetLedgerRange.
         * @memberof response
         * @interface IGetLedgerRange
         * @property {response.Status|null} [status] GetLedgerRange status
         * @property {Array.<string>|null} [logNames] GetLedgerRange logNames
         * @property {string|null} [message] GetLedgerRange message
         */

        /**
         * Constructs a new GetLedgerRange.
         * @memberof response
         * @classdesc Represents a GetLedgerRange.
         * @implements IGetLedgerRange
         * @constructor
         * @param {response.IGetLedgerRange=} [properties] Properties to set
         */
        function GetLedgerRange(properties) {
            this.logNames = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetLedgerRange status.
         * @member {response.Status} status
         * @memberof response.GetLedgerRange
         * @instance
         */
        GetLedgerRange.prototype.status = 0;

        /**
         * GetLedgerRange logNames.
         * @member {Array.<string>} logNames
         * @memberof response.GetLedgerRange
         * @instance
         */
        GetLedgerRange.prototype.logNames = $util.emptyArray;

        /**
         * GetLedgerRange message.
         * @member {string|null|undefined} message
         * @memberof response.GetLedgerRange
         * @instance
         */
        GetLedgerRange.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(GetLedgerRange.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new GetLedgerRange instance using the specified properties.
         * @function create
         * @memberof response.GetLedgerRange
         * @static
         * @param {response.IGetLedgerRange=} [properties] Properties to set
         * @returns {response.GetLedgerRange} GetLedgerRange instance
         */
        GetLedgerRange.create = function create(properties) {
            return new GetLedgerRange(properties);
        };

        /**
         * Encodes the specified GetLedgerRange message. Does not implicitly {@link response.GetLedgerRange.verify|verify} messages.
         * @function encode
         * @memberof response.GetLedgerRange
         * @static
         * @param {response.IGetLedgerRange} message GetLedgerRange message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetLedgerRange.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.logNames != null && message.logNames.length)
                for (let i = 0; i < message.logNames.length; ++i)
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.logNames[i]);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified GetLedgerRange message, length delimited. Does not implicitly {@link response.GetLedgerRange.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.GetLedgerRange
         * @static
         * @param {response.IGetLedgerRange} message GetLedgerRange message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetLedgerRange.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetLedgerRange message from the specified reader or buffer.
         * @function decode
         * @memberof response.GetLedgerRange
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.GetLedgerRange} GetLedgerRange
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetLedgerRange.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.GetLedgerRange();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        if (!(message.logNames && message.logNames.length))
                            message.logNames = [];
                        message.logNames.push(reader.string());
                        break;
                    }
                case 4: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetLedgerRange message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.GetLedgerRange
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.GetLedgerRange} GetLedgerRange
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetLedgerRange.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetLedgerRange message.
         * @function verify
         * @memberof response.GetLedgerRange
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetLedgerRange.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.logNames != null && message.hasOwnProperty("logNames")) {
                if (!Array.isArray(message.logNames))
                    return "logNames: array expected";
                for (let i = 0; i < message.logNames.length; ++i)
                    if (!$util.isString(message.logNames[i]))
                        return "logNames: string[] expected";
            }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a GetLedgerRange message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.GetLedgerRange
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.GetLedgerRange} GetLedgerRange
         */
        GetLedgerRange.fromObject = function fromObject(object) {
            if (object instanceof $root.response.GetLedgerRange)
                return object;
            let message = new $root.response.GetLedgerRange();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.logNames) {
                if (!Array.isArray(object.logNames))
                    throw TypeError(".response.GetLedgerRange.logNames: array expected");
                message.logNames = [];
                for (let i = 0; i < object.logNames.length; ++i)
                    message.logNames[i] = String(object.logNames[i]);
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a GetLedgerRange message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.GetLedgerRange
         * @static
         * @param {response.GetLedgerRange} message GetLedgerRange
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetLedgerRange.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.logNames = [];
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.logNames && message.logNames.length) {
                object.logNames = [];
                for (let j = 0; j < message.logNames.length; ++j)
                    object.logNames[j] = message.logNames[j];
            }
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this GetLedgerRange to JSON.
         * @function toJSON
         * @memberof response.GetLedgerRange
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetLedgerRange.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetLedgerRange
         * @function getTypeUrl
         * @memberof response.GetLedgerRange
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetLedgerRange.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.GetLedgerRange";
        };

        return GetLedgerRange;
    })();

    response.VerifyAuditLogMeta = (function() {

        /**
         * Properties of a VerifyAuditLogMeta.
         * @memberof response
         * @interface IVerifyAuditLogMeta
         * @property {response.Status|null} [status] VerifyAuditLogMeta status
         * @property {string|null} [data] VerifyAuditLogMeta data
         * @property {string|null} [message] VerifyAuditLogMeta message
         */

        /**
         * Constructs a new VerifyAuditLogMeta.
         * @memberof response
         * @classdesc Represents a VerifyAuditLogMeta.
         * @implements IVerifyAuditLogMeta
         * @constructor
         * @param {response.IVerifyAuditLogMeta=} [properties] Properties to set
         */
        function VerifyAuditLogMeta(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * VerifyAuditLogMeta status.
         * @member {response.Status} status
         * @memberof response.VerifyAuditLogMeta
         * @instance
         */
        VerifyAuditLogMeta.prototype.status = 0;

        /**
         * VerifyAuditLogMeta data.
         * @member {string} data
         * @memberof response.VerifyAuditLogMeta
         * @instance
         */
        VerifyAuditLogMeta.prototype.data = "";

        /**
         * VerifyAuditLogMeta message.
         * @member {string|null|undefined} message
         * @memberof response.VerifyAuditLogMeta
         * @instance
         */
        VerifyAuditLogMeta.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(VerifyAuditLogMeta.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new VerifyAuditLogMeta instance using the specified properties.
         * @function create
         * @memberof response.VerifyAuditLogMeta
         * @static
         * @param {response.IVerifyAuditLogMeta=} [properties] Properties to set
         * @returns {response.VerifyAuditLogMeta} VerifyAuditLogMeta instance
         */
        VerifyAuditLogMeta.create = function create(properties) {
            return new VerifyAuditLogMeta(properties);
        };

        /**
         * Encodes the specified VerifyAuditLogMeta message. Does not implicitly {@link response.VerifyAuditLogMeta.verify|verify} messages.
         * @function encode
         * @memberof response.VerifyAuditLogMeta
         * @static
         * @param {response.IVerifyAuditLogMeta} message VerifyAuditLogMeta message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        VerifyAuditLogMeta.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.data);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified VerifyAuditLogMeta message, length delimited. Does not implicitly {@link response.VerifyAuditLogMeta.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.VerifyAuditLogMeta
         * @static
         * @param {response.IVerifyAuditLogMeta} message VerifyAuditLogMeta message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        VerifyAuditLogMeta.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a VerifyAuditLogMeta message from the specified reader or buffer.
         * @function decode
         * @memberof response.VerifyAuditLogMeta
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.VerifyAuditLogMeta} VerifyAuditLogMeta
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        VerifyAuditLogMeta.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.VerifyAuditLogMeta();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.data = reader.string();
                        break;
                    }
                case 3: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a VerifyAuditLogMeta message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.VerifyAuditLogMeta
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.VerifyAuditLogMeta} VerifyAuditLogMeta
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        VerifyAuditLogMeta.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a VerifyAuditLogMeta message.
         * @function verify
         * @memberof response.VerifyAuditLogMeta
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        VerifyAuditLogMeta.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.data != null && message.hasOwnProperty("data"))
                if (!$util.isString(message.data))
                    return "data: string expected";
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a VerifyAuditLogMeta message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.VerifyAuditLogMeta
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.VerifyAuditLogMeta} VerifyAuditLogMeta
         */
        VerifyAuditLogMeta.fromObject = function fromObject(object) {
            if (object instanceof $root.response.VerifyAuditLogMeta)
                return object;
            let message = new $root.response.VerifyAuditLogMeta();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.data != null)
                message.data = String(object.data);
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a VerifyAuditLogMeta message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.VerifyAuditLogMeta
         * @static
         * @param {response.VerifyAuditLogMeta} message VerifyAuditLogMeta
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        VerifyAuditLogMeta.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.status = options.enums === String ? "SUCCESS" : 0;
                object.data = "";
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = message.data;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this VerifyAuditLogMeta to JSON.
         * @function toJSON
         * @memberof response.VerifyAuditLogMeta
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        VerifyAuditLogMeta.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for VerifyAuditLogMeta
         * @function getTypeUrl
         * @memberof response.VerifyAuditLogMeta
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        VerifyAuditLogMeta.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.VerifyAuditLogMeta";
        };

        return VerifyAuditLogMeta;
    })();

    response.GetAuditLog = (function() {

        /**
         * Properties of a GetAuditLog.
         * @memberof response
         * @interface IGetAuditLog
         * @property {response.Status|null} [status] GetAuditLog status
         * @property {Uint8Array|null} [data] GetAuditLog data
         * @property {boolean|null} [isLast] GetAuditLog isLast
         * @property {string|null} [message] GetAuditLog message
         */

        /**
         * Constructs a new GetAuditLog.
         * @memberof response
         * @classdesc Represents a GetAuditLog.
         * @implements IGetAuditLog
         * @constructor
         * @param {response.IGetAuditLog=} [properties] Properties to set
         */
        function GetAuditLog(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetAuditLog status.
         * @member {response.Status} status
         * @memberof response.GetAuditLog
         * @instance
         */
        GetAuditLog.prototype.status = 0;

        /**
         * GetAuditLog data.
         * @member {Uint8Array} data
         * @memberof response.GetAuditLog
         * @instance
         */
        GetAuditLog.prototype.data = $util.newBuffer([]);

        /**
         * GetAuditLog isLast.
         * @member {boolean} isLast
         * @memberof response.GetAuditLog
         * @instance
         */
        GetAuditLog.prototype.isLast = false;

        /**
         * GetAuditLog message.
         * @member {string} message
         * @memberof response.GetAuditLog
         * @instance
         */
        GetAuditLog.prototype.message = "";

        /**
         * Creates a new GetAuditLog instance using the specified properties.
         * @function create
         * @memberof response.GetAuditLog
         * @static
         * @param {response.IGetAuditLog=} [properties] Properties to set
         * @returns {response.GetAuditLog} GetAuditLog instance
         */
        GetAuditLog.create = function create(properties) {
            return new GetAuditLog(properties);
        };

        /**
         * Encodes the specified GetAuditLog message. Does not implicitly {@link response.GetAuditLog.verify|verify} messages.
         * @function encode
         * @memberof response.GetAuditLog
         * @static
         * @param {response.IGetAuditLog} message GetAuditLog message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetAuditLog.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.data);
            if (message.isLast != null && Object.hasOwnProperty.call(message, "isLast"))
                writer.uint32(/* id 3, wireType 0 =*/24).bool(message.isLast);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified GetAuditLog message, length delimited. Does not implicitly {@link response.GetAuditLog.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.GetAuditLog
         * @static
         * @param {response.IGetAuditLog} message GetAuditLog message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetAuditLog.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetAuditLog message from the specified reader or buffer.
         * @function decode
         * @memberof response.GetAuditLog
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.GetAuditLog} GetAuditLog
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetAuditLog.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.GetAuditLog();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.data = reader.bytes();
                        break;
                    }
                case 3: {
                        message.isLast = reader.bool();
                        break;
                    }
                case 5: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetAuditLog message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.GetAuditLog
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.GetAuditLog} GetAuditLog
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetAuditLog.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetAuditLog message.
         * @function verify
         * @memberof response.GetAuditLog
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetAuditLog.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            if (message.isLast != null && message.hasOwnProperty("isLast"))
                if (typeof message.isLast !== "boolean")
                    return "isLast: boolean expected";
            if (message.message != null && message.hasOwnProperty("message"))
                if (!$util.isString(message.message))
                    return "message: string expected";
            return null;
        };

        /**
         * Creates a GetAuditLog message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.GetAuditLog
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.GetAuditLog} GetAuditLog
         */
        GetAuditLog.fromObject = function fromObject(object) {
            if (object instanceof $root.response.GetAuditLog)
                return object;
            let message = new $root.response.GetAuditLog();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            if (object.isLast != null)
                message.isLast = Boolean(object.isLast);
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a GetAuditLog message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.GetAuditLog
         * @static
         * @param {response.GetAuditLog} message GetAuditLog
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetAuditLog.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.status = options.enums === String ? "SUCCESS" : 0;
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
                object.isLast = false;
                object.message = "";
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            if (message.isLast != null && message.hasOwnProperty("isLast"))
                object.isLast = message.isLast;
            if (message.message != null && message.hasOwnProperty("message"))
                object.message = message.message;
            return object;
        };

        /**
         * Converts this GetAuditLog to JSON.
         * @function toJSON
         * @memberof response.GetAuditLog
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetAuditLog.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetAuditLog
         * @function getTypeUrl
         * @memberof response.GetAuditLog
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetAuditLog.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.GetAuditLog";
        };

        return GetAuditLog;
    })();

    response.DeleteAuditLog = (function() {

        /**
         * Properties of a DeleteAuditLog.
         * @memberof response
         * @interface IDeleteAuditLog
         * @property {response.Status|null} [status] DeleteAuditLog status
         * @property {string|null} [message] DeleteAuditLog message
         */

        /**
         * Constructs a new DeleteAuditLog.
         * @memberof response
         * @classdesc Represents a DeleteAuditLog.
         * @implements IDeleteAuditLog
         * @constructor
         * @param {response.IDeleteAuditLog=} [properties] Properties to set
         */
        function DeleteAuditLog(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DeleteAuditLog status.
         * @member {response.Status} status
         * @memberof response.DeleteAuditLog
         * @instance
         */
        DeleteAuditLog.prototype.status = 0;

        /**
         * DeleteAuditLog message.
         * @member {string} message
         * @memberof response.DeleteAuditLog
         * @instance
         */
        DeleteAuditLog.prototype.message = "";

        /**
         * Creates a new DeleteAuditLog instance using the specified properties.
         * @function create
         * @memberof response.DeleteAuditLog
         * @static
         * @param {response.IDeleteAuditLog=} [properties] Properties to set
         * @returns {response.DeleteAuditLog} DeleteAuditLog instance
         */
        DeleteAuditLog.create = function create(properties) {
            return new DeleteAuditLog(properties);
        };

        /**
         * Encodes the specified DeleteAuditLog message. Does not implicitly {@link response.DeleteAuditLog.verify|verify} messages.
         * @function encode
         * @memberof response.DeleteAuditLog
         * @static
         * @param {response.IDeleteAuditLog} message DeleteAuditLog message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DeleteAuditLog.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified DeleteAuditLog message, length delimited. Does not implicitly {@link response.DeleteAuditLog.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.DeleteAuditLog
         * @static
         * @param {response.IDeleteAuditLog} message DeleteAuditLog message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DeleteAuditLog.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a DeleteAuditLog message from the specified reader or buffer.
         * @function decode
         * @memberof response.DeleteAuditLog
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.DeleteAuditLog} DeleteAuditLog
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DeleteAuditLog.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.DeleteAuditLog();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a DeleteAuditLog message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.DeleteAuditLog
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.DeleteAuditLog} DeleteAuditLog
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DeleteAuditLog.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a DeleteAuditLog message.
         * @function verify
         * @memberof response.DeleteAuditLog
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        DeleteAuditLog.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message"))
                if (!$util.isString(message.message))
                    return "message: string expected";
            return null;
        };

        /**
         * Creates a DeleteAuditLog message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.DeleteAuditLog
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.DeleteAuditLog} DeleteAuditLog
         */
        DeleteAuditLog.fromObject = function fromObject(object) {
            if (object instanceof $root.response.DeleteAuditLog)
                return object;
            let message = new $root.response.DeleteAuditLog();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a DeleteAuditLog message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.DeleteAuditLog
         * @static
         * @param {response.DeleteAuditLog} message DeleteAuditLog
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DeleteAuditLog.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.status = options.enums === String ? "SUCCESS" : 0;
                object.message = "";
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message"))
                object.message = message.message;
            return object;
        };

        /**
         * Converts this DeleteAuditLog to JSON.
         * @function toJSON
         * @memberof response.DeleteAuditLog
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DeleteAuditLog.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for DeleteAuditLog
         * @function getTypeUrl
         * @memberof response.DeleteAuditLog
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        DeleteAuditLog.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.DeleteAuditLog";
        };

        return DeleteAuditLog;
    })();

    response.ListPins = (function() {

        /**
         * Properties of a ListPins.
         * @memberof response
         * @interface IListPins
         * @property {response.Status|null} [status] ListPins status
         * @property {number|Long|null} [totalCount] ListPins totalCount
         * @property {Array.<response.IPinInList>|null} [pinObjects] ListPins pinObjects
         * @property {boolean|null} [isLast] ListPins isLast
         * @property {Uint8Array|null} [pageToken] ListPins pageToken
         */

        /**
         * Constructs a new ListPins.
         * @memberof response
         * @classdesc Represents a ListPins.
         * @implements IListPins
         * @constructor
         * @param {response.IListPins=} [properties] Properties to set
         */
        function ListPins(properties) {
            this.pinObjects = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListPins status.
         * @member {response.Status} status
         * @memberof response.ListPins
         * @instance
         */
        ListPins.prototype.status = 0;

        /**
         * ListPins totalCount.
         * @member {number|Long|null|undefined} totalCount
         * @memberof response.ListPins
         * @instance
         */
        ListPins.prototype.totalCount = null;

        /**
         * ListPins pinObjects.
         * @member {Array.<response.IPinInList>} pinObjects
         * @memberof response.ListPins
         * @instance
         */
        ListPins.prototype.pinObjects = $util.emptyArray;

        /**
         * ListPins isLast.
         * @member {boolean} isLast
         * @memberof response.ListPins
         * @instance
         */
        ListPins.prototype.isLast = false;

        /**
         * ListPins pageToken.
         * @member {Uint8Array|null|undefined} pageToken
         * @memberof response.ListPins
         * @instance
         */
        ListPins.prototype.pageToken = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(ListPins.prototype, "_totalCount", {
            get: $util.oneOfGetter($oneOfFields = ["totalCount"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(ListPins.prototype, "_pageToken", {
            get: $util.oneOfGetter($oneOfFields = ["pageToken"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new ListPins instance using the specified properties.
         * @function create
         * @memberof response.ListPins
         * @static
         * @param {response.IListPins=} [properties] Properties to set
         * @returns {response.ListPins} ListPins instance
         */
        ListPins.create = function create(properties) {
            return new ListPins(properties);
        };

        /**
         * Encodes the specified ListPins message. Does not implicitly {@link response.ListPins.verify|verify} messages.
         * @function encode
         * @memberof response.ListPins
         * @static
         * @param {response.IListPins} message ListPins message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListPins.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.totalCount != null && Object.hasOwnProperty.call(message, "totalCount"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.totalCount);
            if (message.pinObjects != null && message.pinObjects.length)
                for (let i = 0; i < message.pinObjects.length; ++i)
                    $root.response.PinInList.encode(message.pinObjects[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.isLast != null && Object.hasOwnProperty.call(message, "isLast"))
                writer.uint32(/* id 4, wireType 0 =*/32).bool(message.isLast);
            if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                writer.uint32(/* id 5, wireType 2 =*/42).bytes(message.pageToken);
            return writer;
        };

        /**
         * Encodes the specified ListPins message, length delimited. Does not implicitly {@link response.ListPins.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.ListPins
         * @static
         * @param {response.IListPins} message ListPins message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListPins.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ListPins message from the specified reader or buffer.
         * @function decode
         * @memberof response.ListPins
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.ListPins} ListPins
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListPins.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.ListPins();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.totalCount = reader.uint64();
                        break;
                    }
                case 3: {
                        if (!(message.pinObjects && message.pinObjects.length))
                            message.pinObjects = [];
                        message.pinObjects.push($root.response.PinInList.decode(reader, reader.uint32()));
                        break;
                    }
                case 4: {
                        message.isLast = reader.bool();
                        break;
                    }
                case 5: {
                        message.pageToken = reader.bytes();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ListPins message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.ListPins
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.ListPins} ListPins
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListPins.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ListPins message.
         * @function verify
         * @memberof response.ListPins
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ListPins.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.totalCount != null && message.hasOwnProperty("totalCount")) {
                properties._totalCount = 1;
                if (!$util.isInteger(message.totalCount) && !(message.totalCount && $util.isInteger(message.totalCount.low) && $util.isInteger(message.totalCount.high)))
                    return "totalCount: integer|Long expected";
            }
            if (message.pinObjects != null && message.hasOwnProperty("pinObjects")) {
                if (!Array.isArray(message.pinObjects))
                    return "pinObjects: array expected";
                for (let i = 0; i < message.pinObjects.length; ++i) {
                    let error = $root.response.PinInList.verify(message.pinObjects[i]);
                    if (error)
                        return "pinObjects." + error;
                }
            }
            if (message.isLast != null && message.hasOwnProperty("isLast"))
                if (typeof message.isLast !== "boolean")
                    return "isLast: boolean expected";
            if (message.pageToken != null && message.hasOwnProperty("pageToken")) {
                properties._pageToken = 1;
                if (!(message.pageToken && typeof message.pageToken.length === "number" || $util.isString(message.pageToken)))
                    return "pageToken: buffer expected";
            }
            return null;
        };

        /**
         * Creates a ListPins message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.ListPins
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.ListPins} ListPins
         */
        ListPins.fromObject = function fromObject(object) {
            if (object instanceof $root.response.ListPins)
                return object;
            let message = new $root.response.ListPins();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.totalCount != null)
                if ($util.Long)
                    (message.totalCount = $util.Long.fromValue(object.totalCount)).unsigned = true;
                else if (typeof object.totalCount === "string")
                    message.totalCount = parseInt(object.totalCount, 10);
                else if (typeof object.totalCount === "number")
                    message.totalCount = object.totalCount;
                else if (typeof object.totalCount === "object")
                    message.totalCount = new $util.LongBits(object.totalCount.low >>> 0, object.totalCount.high >>> 0).toNumber(true);
            if (object.pinObjects) {
                if (!Array.isArray(object.pinObjects))
                    throw TypeError(".response.ListPins.pinObjects: array expected");
                message.pinObjects = [];
                for (let i = 0; i < object.pinObjects.length; ++i) {
                    if (typeof object.pinObjects[i] !== "object")
                        throw TypeError(".response.ListPins.pinObjects: object expected");
                    message.pinObjects[i] = $root.response.PinInList.fromObject(object.pinObjects[i]);
                }
            }
            if (object.isLast != null)
                message.isLast = Boolean(object.isLast);
            if (object.pageToken != null)
                if (typeof object.pageToken === "string")
                    $util.base64.decode(object.pageToken, message.pageToken = $util.newBuffer($util.base64.length(object.pageToken)), 0);
                else if (object.pageToken.length >= 0)
                    message.pageToken = object.pageToken;
            return message;
        };

        /**
         * Creates a plain object from a ListPins message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.ListPins
         * @static
         * @param {response.ListPins} message ListPins
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListPins.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.pinObjects = [];
            if (options.defaults) {
                object.status = options.enums === String ? "SUCCESS" : 0;
                object.isLast = false;
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.totalCount != null && message.hasOwnProperty("totalCount")) {
                if (typeof message.totalCount === "number")
                    object.totalCount = options.longs === String ? String(message.totalCount) : message.totalCount;
                else
                    object.totalCount = options.longs === String ? $util.Long.prototype.toString.call(message.totalCount) : options.longs === Number ? new $util.LongBits(message.totalCount.low >>> 0, message.totalCount.high >>> 0).toNumber(true) : message.totalCount;
                if (options.oneofs)
                    object._totalCount = "totalCount";
            }
            if (message.pinObjects && message.pinObjects.length) {
                object.pinObjects = [];
                for (let j = 0; j < message.pinObjects.length; ++j)
                    object.pinObjects[j] = $root.response.PinInList.toObject(message.pinObjects[j], options);
            }
            if (message.isLast != null && message.hasOwnProperty("isLast"))
                object.isLast = message.isLast;
            if (message.pageToken != null && message.hasOwnProperty("pageToken")) {
                object.pageToken = options.bytes === String ? $util.base64.encode(message.pageToken, 0, message.pageToken.length) : options.bytes === Array ? Array.prototype.slice.call(message.pageToken) : message.pageToken;
                if (options.oneofs)
                    object._pageToken = "pageToken";
            }
            return object;
        };

        /**
         * Converts this ListPins to JSON.
         * @function toJSON
         * @memberof response.ListPins
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListPins.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ListPins
         * @function getTypeUrl
         * @memberof response.ListPins
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ListPins.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.ListPins";
        };

        return ListPins;
    })();

    response.List = (function() {

        /**
         * Properties of a List.
         * @memberof response
         * @interface IList
         * @property {response.Status|null} [status] List status
         * @property {number|Long|null} [totalCount] List totalCount
         * @property {Array.<response.IMetaObj>|null} [objects] List objects
         * @property {Uint8Array|null} [pageToken] List pageToken
         * @property {boolean|null} [isLast] List isLast
         * @property {string|null} [message] List message
         */

        /**
         * Constructs a new List.
         * @memberof response
         * @classdesc Represents a List.
         * @implements IList
         * @constructor
         * @param {response.IList=} [properties] Properties to set
         */
        function List(properties) {
            this.objects = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * List status.
         * @member {response.Status} status
         * @memberof response.List
         * @instance
         */
        List.prototype.status = 0;

        /**
         * List totalCount.
         * @member {number|Long|null|undefined} totalCount
         * @memberof response.List
         * @instance
         */
        List.prototype.totalCount = null;

        /**
         * List objects.
         * @member {Array.<response.IMetaObj>} objects
         * @memberof response.List
         * @instance
         */
        List.prototype.objects = $util.emptyArray;

        /**
         * List pageToken.
         * @member {Uint8Array|null|undefined} pageToken
         * @memberof response.List
         * @instance
         */
        List.prototype.pageToken = null;

        /**
         * List isLast.
         * @member {boolean} isLast
         * @memberof response.List
         * @instance
         */
        List.prototype.isLast = false;

        /**
         * List message.
         * @member {string|null|undefined} message
         * @memberof response.List
         * @instance
         */
        List.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(List.prototype, "_totalCount", {
            get: $util.oneOfGetter($oneOfFields = ["totalCount"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(List.prototype, "_pageToken", {
            get: $util.oneOfGetter($oneOfFields = ["pageToken"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(List.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new List instance using the specified properties.
         * @function create
         * @memberof response.List
         * @static
         * @param {response.IList=} [properties] Properties to set
         * @returns {response.List} List instance
         */
        List.create = function create(properties) {
            return new List(properties);
        };

        /**
         * Encodes the specified List message. Does not implicitly {@link response.List.verify|verify} messages.
         * @function encode
         * @memberof response.List
         * @static
         * @param {response.IList} message List message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        List.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.totalCount != null && Object.hasOwnProperty.call(message, "totalCount"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.totalCount);
            if (message.objects != null && message.objects.length)
                for (let i = 0; i < message.objects.length; ++i)
                    $root.response.MetaObj.encode(message.objects[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.pageToken);
            if (message.isLast != null && Object.hasOwnProperty.call(message, "isLast"))
                writer.uint32(/* id 5, wireType 0 =*/40).bool(message.isLast);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified List message, length delimited. Does not implicitly {@link response.List.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.List
         * @static
         * @param {response.IList} message List message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        List.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a List message from the specified reader or buffer.
         * @function decode
         * @memberof response.List
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.List} List
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        List.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.List();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.totalCount = reader.uint64();
                        break;
                    }
                case 3: {
                        if (!(message.objects && message.objects.length))
                            message.objects = [];
                        message.objects.push($root.response.MetaObj.decode(reader, reader.uint32()));
                        break;
                    }
                case 4: {
                        message.pageToken = reader.bytes();
                        break;
                    }
                case 5: {
                        message.isLast = reader.bool();
                        break;
                    }
                case 6: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a List message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.List
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.List} List
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        List.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a List message.
         * @function verify
         * @memberof response.List
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        List.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.totalCount != null && message.hasOwnProperty("totalCount")) {
                properties._totalCount = 1;
                if (!$util.isInteger(message.totalCount) && !(message.totalCount && $util.isInteger(message.totalCount.low) && $util.isInteger(message.totalCount.high)))
                    return "totalCount: integer|Long expected";
            }
            if (message.objects != null && message.hasOwnProperty("objects")) {
                if (!Array.isArray(message.objects))
                    return "objects: array expected";
                for (let i = 0; i < message.objects.length; ++i) {
                    let error = $root.response.MetaObj.verify(message.objects[i]);
                    if (error)
                        return "objects." + error;
                }
            }
            if (message.pageToken != null && message.hasOwnProperty("pageToken")) {
                properties._pageToken = 1;
                if (!(message.pageToken && typeof message.pageToken.length === "number" || $util.isString(message.pageToken)))
                    return "pageToken: buffer expected";
            }
            if (message.isLast != null && message.hasOwnProperty("isLast"))
                if (typeof message.isLast !== "boolean")
                    return "isLast: boolean expected";
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a List message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.List
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.List} List
         */
        List.fromObject = function fromObject(object) {
            if (object instanceof $root.response.List)
                return object;
            let message = new $root.response.List();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.totalCount != null)
                if ($util.Long)
                    (message.totalCount = $util.Long.fromValue(object.totalCount)).unsigned = true;
                else if (typeof object.totalCount === "string")
                    message.totalCount = parseInt(object.totalCount, 10);
                else if (typeof object.totalCount === "number")
                    message.totalCount = object.totalCount;
                else if (typeof object.totalCount === "object")
                    message.totalCount = new $util.LongBits(object.totalCount.low >>> 0, object.totalCount.high >>> 0).toNumber(true);
            if (object.objects) {
                if (!Array.isArray(object.objects))
                    throw TypeError(".response.List.objects: array expected");
                message.objects = [];
                for (let i = 0; i < object.objects.length; ++i) {
                    if (typeof object.objects[i] !== "object")
                        throw TypeError(".response.List.objects: object expected");
                    message.objects[i] = $root.response.MetaObj.fromObject(object.objects[i]);
                }
            }
            if (object.pageToken != null)
                if (typeof object.pageToken === "string")
                    $util.base64.decode(object.pageToken, message.pageToken = $util.newBuffer($util.base64.length(object.pageToken)), 0);
                else if (object.pageToken.length >= 0)
                    message.pageToken = object.pageToken;
            if (object.isLast != null)
                message.isLast = Boolean(object.isLast);
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a List message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.List
         * @static
         * @param {response.List} message List
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        List.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.objects = [];
            if (options.defaults) {
                object.status = options.enums === String ? "SUCCESS" : 0;
                object.isLast = false;
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.totalCount != null && message.hasOwnProperty("totalCount")) {
                if (typeof message.totalCount === "number")
                    object.totalCount = options.longs === String ? String(message.totalCount) : message.totalCount;
                else
                    object.totalCount = options.longs === String ? $util.Long.prototype.toString.call(message.totalCount) : options.longs === Number ? new $util.LongBits(message.totalCount.low >>> 0, message.totalCount.high >>> 0).toNumber(true) : message.totalCount;
                if (options.oneofs)
                    object._totalCount = "totalCount";
            }
            if (message.objects && message.objects.length) {
                object.objects = [];
                for (let j = 0; j < message.objects.length; ++j)
                    object.objects[j] = $root.response.MetaObj.toObject(message.objects[j], options);
            }
            if (message.pageToken != null && message.hasOwnProperty("pageToken")) {
                object.pageToken = options.bytes === String ? $util.base64.encode(message.pageToken, 0, message.pageToken.length) : options.bytes === Array ? Array.prototype.slice.call(message.pageToken) : message.pageToken;
                if (options.oneofs)
                    object._pageToken = "pageToken";
            }
            if (message.isLast != null && message.hasOwnProperty("isLast"))
                object.isLast = message.isLast;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this List to JSON.
         * @function toJSON
         * @memberof response.List
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        List.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for List
         * @function getTypeUrl
         * @memberof response.List
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        List.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.List";
        };

        return List;
    })();

    response.SetUser = (function() {

        /**
         * Properties of a SetUser.
         * @memberof response
         * @interface ISetUser
         * @property {response.Status|null} [status] SetUser status
         * @property {string|null} [message] SetUser message
         */

        /**
         * Constructs a new SetUser.
         * @memberof response
         * @classdesc Represents a SetUser.
         * @implements ISetUser
         * @constructor
         * @param {response.ISetUser=} [properties] Properties to set
         */
        function SetUser(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SetUser status.
         * @member {response.Status} status
         * @memberof response.SetUser
         * @instance
         */
        SetUser.prototype.status = 0;

        /**
         * SetUser message.
         * @member {string|null|undefined} message
         * @memberof response.SetUser
         * @instance
         */
        SetUser.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(SetUser.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new SetUser instance using the specified properties.
         * @function create
         * @memberof response.SetUser
         * @static
         * @param {response.ISetUser=} [properties] Properties to set
         * @returns {response.SetUser} SetUser instance
         */
        SetUser.create = function create(properties) {
            return new SetUser(properties);
        };

        /**
         * Encodes the specified SetUser message. Does not implicitly {@link response.SetUser.verify|verify} messages.
         * @function encode
         * @memberof response.SetUser
         * @static
         * @param {response.ISetUser} message SetUser message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SetUser.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified SetUser message, length delimited. Does not implicitly {@link response.SetUser.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.SetUser
         * @static
         * @param {response.ISetUser} message SetUser message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SetUser.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SetUser message from the specified reader or buffer.
         * @function decode
         * @memberof response.SetUser
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.SetUser} SetUser
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SetUser.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.SetUser();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SetUser message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.SetUser
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.SetUser} SetUser
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SetUser.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SetUser message.
         * @function verify
         * @memberof response.SetUser
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SetUser.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a SetUser message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.SetUser
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.SetUser} SetUser
         */
        SetUser.fromObject = function fromObject(object) {
            if (object instanceof $root.response.SetUser)
                return object;
            let message = new $root.response.SetUser();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a SetUser message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.SetUser
         * @static
         * @param {response.SetUser} message SetUser
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SetUser.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this SetUser to JSON.
         * @function toJSON
         * @memberof response.SetUser
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SetUser.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for SetUser
         * @function getTypeUrl
         * @memberof response.SetUser
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        SetUser.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.SetUser";
        };

        return SetUser;
    })();

    response.FinalizeProfileWrite = (function() {

        /**
         * Properties of a FinalizeProfileWrite.
         * @memberof response
         * @interface IFinalizeProfileWrite
         * @property {response.Status|null} [status] FinalizeProfileWrite status
         * @property {Uint8Array|null} [uuid] FinalizeProfileWrite uuid
         * @property {string|null} [message] FinalizeProfileWrite message
         */

        /**
         * Constructs a new FinalizeProfileWrite.
         * @memberof response
         * @classdesc Represents a FinalizeProfileWrite.
         * @implements IFinalizeProfileWrite
         * @constructor
         * @param {response.IFinalizeProfileWrite=} [properties] Properties to set
         */
        function FinalizeProfileWrite(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * FinalizeProfileWrite status.
         * @member {response.Status} status
         * @memberof response.FinalizeProfileWrite
         * @instance
         */
        FinalizeProfileWrite.prototype.status = 0;

        /**
         * FinalizeProfileWrite uuid.
         * @member {Uint8Array} uuid
         * @memberof response.FinalizeProfileWrite
         * @instance
         */
        FinalizeProfileWrite.prototype.uuid = $util.newBuffer([]);

        /**
         * FinalizeProfileWrite message.
         * @member {string|null|undefined} message
         * @memberof response.FinalizeProfileWrite
         * @instance
         */
        FinalizeProfileWrite.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(FinalizeProfileWrite.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new FinalizeProfileWrite instance using the specified properties.
         * @function create
         * @memberof response.FinalizeProfileWrite
         * @static
         * @param {response.IFinalizeProfileWrite=} [properties] Properties to set
         * @returns {response.FinalizeProfileWrite} FinalizeProfileWrite instance
         */
        FinalizeProfileWrite.create = function create(properties) {
            return new FinalizeProfileWrite(properties);
        };

        /**
         * Encodes the specified FinalizeProfileWrite message. Does not implicitly {@link response.FinalizeProfileWrite.verify|verify} messages.
         * @function encode
         * @memberof response.FinalizeProfileWrite
         * @static
         * @param {response.IFinalizeProfileWrite} message FinalizeProfileWrite message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FinalizeProfileWrite.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.uuid != null && Object.hasOwnProperty.call(message, "uuid"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.uuid);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified FinalizeProfileWrite message, length delimited. Does not implicitly {@link response.FinalizeProfileWrite.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.FinalizeProfileWrite
         * @static
         * @param {response.IFinalizeProfileWrite} message FinalizeProfileWrite message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FinalizeProfileWrite.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a FinalizeProfileWrite message from the specified reader or buffer.
         * @function decode
         * @memberof response.FinalizeProfileWrite
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.FinalizeProfileWrite} FinalizeProfileWrite
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FinalizeProfileWrite.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.FinalizeProfileWrite();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.uuid = reader.bytes();
                        break;
                    }
                case 3: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a FinalizeProfileWrite message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.FinalizeProfileWrite
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.FinalizeProfileWrite} FinalizeProfileWrite
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FinalizeProfileWrite.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a FinalizeProfileWrite message.
         * @function verify
         * @memberof response.FinalizeProfileWrite
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        FinalizeProfileWrite.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                if (!(message.uuid && typeof message.uuid.length === "number" || $util.isString(message.uuid)))
                    return "uuid: buffer expected";
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a FinalizeProfileWrite message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.FinalizeProfileWrite
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.FinalizeProfileWrite} FinalizeProfileWrite
         */
        FinalizeProfileWrite.fromObject = function fromObject(object) {
            if (object instanceof $root.response.FinalizeProfileWrite)
                return object;
            let message = new $root.response.FinalizeProfileWrite();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.uuid != null)
                if (typeof object.uuid === "string")
                    $util.base64.decode(object.uuid, message.uuid = $util.newBuffer($util.base64.length(object.uuid)), 0);
                else if (object.uuid.length >= 0)
                    message.uuid = object.uuid;
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a FinalizeProfileWrite message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.FinalizeProfileWrite
         * @static
         * @param {response.FinalizeProfileWrite} message FinalizeProfileWrite
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FinalizeProfileWrite.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.status = options.enums === String ? "SUCCESS" : 0;
                if (options.bytes === String)
                    object.uuid = "";
                else {
                    object.uuid = [];
                    if (options.bytes !== Array)
                        object.uuid = $util.newBuffer(object.uuid);
                }
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                object.uuid = options.bytes === String ? $util.base64.encode(message.uuid, 0, message.uuid.length) : options.bytes === Array ? Array.prototype.slice.call(message.uuid) : message.uuid;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this FinalizeProfileWrite to JSON.
         * @function toJSON
         * @memberof response.FinalizeProfileWrite
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FinalizeProfileWrite.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for FinalizeProfileWrite
         * @function getTypeUrl
         * @memberof response.FinalizeProfileWrite
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        FinalizeProfileWrite.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.FinalizeProfileWrite";
        };

        return FinalizeProfileWrite;
    })();

    response.GetProfileFileMeta = (function() {

        /**
         * Properties of a GetProfileFileMeta.
         * @memberof response
         * @interface IGetProfileFileMeta
         * @property {response.Status|null} [status] GetProfileFileMeta status
         * @property {Uint8Array|null} [versionUuid] GetProfileFileMeta versionUuid
         * @property {Uint8Array|null} [fileUuid] GetProfileFileMeta fileUuid
         * @property {string|null} [message] GetProfileFileMeta message
         */

        /**
         * Constructs a new GetProfileFileMeta.
         * @memberof response
         * @classdesc Represents a GetProfileFileMeta.
         * @implements IGetProfileFileMeta
         * @constructor
         * @param {response.IGetProfileFileMeta=} [properties] Properties to set
         */
        function GetProfileFileMeta(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetProfileFileMeta status.
         * @member {response.Status} status
         * @memberof response.GetProfileFileMeta
         * @instance
         */
        GetProfileFileMeta.prototype.status = 0;

        /**
         * GetProfileFileMeta versionUuid.
         * @member {Uint8Array} versionUuid
         * @memberof response.GetProfileFileMeta
         * @instance
         */
        GetProfileFileMeta.prototype.versionUuid = $util.newBuffer([]);

        /**
         * GetProfileFileMeta fileUuid.
         * @member {Uint8Array} fileUuid
         * @memberof response.GetProfileFileMeta
         * @instance
         */
        GetProfileFileMeta.prototype.fileUuid = $util.newBuffer([]);

        /**
         * GetProfileFileMeta message.
         * @member {string|null|undefined} message
         * @memberof response.GetProfileFileMeta
         * @instance
         */
        GetProfileFileMeta.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(GetProfileFileMeta.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new GetProfileFileMeta instance using the specified properties.
         * @function create
         * @memberof response.GetProfileFileMeta
         * @static
         * @param {response.IGetProfileFileMeta=} [properties] Properties to set
         * @returns {response.GetProfileFileMeta} GetProfileFileMeta instance
         */
        GetProfileFileMeta.create = function create(properties) {
            return new GetProfileFileMeta(properties);
        };

        /**
         * Encodes the specified GetProfileFileMeta message. Does not implicitly {@link response.GetProfileFileMeta.verify|verify} messages.
         * @function encode
         * @memberof response.GetProfileFileMeta
         * @static
         * @param {response.IGetProfileFileMeta} message GetProfileFileMeta message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetProfileFileMeta.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.fileUuid != null && Object.hasOwnProperty.call(message, "fileUuid"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.fileUuid);
            if (message.versionUuid != null && Object.hasOwnProperty.call(message, "versionUuid"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.versionUuid);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified GetProfileFileMeta message, length delimited. Does not implicitly {@link response.GetProfileFileMeta.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.GetProfileFileMeta
         * @static
         * @param {response.IGetProfileFileMeta} message GetProfileFileMeta message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetProfileFileMeta.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetProfileFileMeta message from the specified reader or buffer.
         * @function decode
         * @memberof response.GetProfileFileMeta
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.GetProfileFileMeta} GetProfileFileMeta
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetProfileFileMeta.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.GetProfileFileMeta();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 3: {
                        message.versionUuid = reader.bytes();
                        break;
                    }
                case 2: {
                        message.fileUuid = reader.bytes();
                        break;
                    }
                case 4: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetProfileFileMeta message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.GetProfileFileMeta
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.GetProfileFileMeta} GetProfileFileMeta
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetProfileFileMeta.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetProfileFileMeta message.
         * @function verify
         * @memberof response.GetProfileFileMeta
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetProfileFileMeta.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.versionUuid != null && message.hasOwnProperty("versionUuid"))
                if (!(message.versionUuid && typeof message.versionUuid.length === "number" || $util.isString(message.versionUuid)))
                    return "versionUuid: buffer expected";
            if (message.fileUuid != null && message.hasOwnProperty("fileUuid"))
                if (!(message.fileUuid && typeof message.fileUuid.length === "number" || $util.isString(message.fileUuid)))
                    return "fileUuid: buffer expected";
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a GetProfileFileMeta message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.GetProfileFileMeta
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.GetProfileFileMeta} GetProfileFileMeta
         */
        GetProfileFileMeta.fromObject = function fromObject(object) {
            if (object instanceof $root.response.GetProfileFileMeta)
                return object;
            let message = new $root.response.GetProfileFileMeta();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.versionUuid != null)
                if (typeof object.versionUuid === "string")
                    $util.base64.decode(object.versionUuid, message.versionUuid = $util.newBuffer($util.base64.length(object.versionUuid)), 0);
                else if (object.versionUuid.length >= 0)
                    message.versionUuid = object.versionUuid;
            if (object.fileUuid != null)
                if (typeof object.fileUuid === "string")
                    $util.base64.decode(object.fileUuid, message.fileUuid = $util.newBuffer($util.base64.length(object.fileUuid)), 0);
                else if (object.fileUuid.length >= 0)
                    message.fileUuid = object.fileUuid;
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a GetProfileFileMeta message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.GetProfileFileMeta
         * @static
         * @param {response.GetProfileFileMeta} message GetProfileFileMeta
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetProfileFileMeta.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.status = options.enums === String ? "SUCCESS" : 0;
                if (options.bytes === String)
                    object.fileUuid = "";
                else {
                    object.fileUuid = [];
                    if (options.bytes !== Array)
                        object.fileUuid = $util.newBuffer(object.fileUuid);
                }
                if (options.bytes === String)
                    object.versionUuid = "";
                else {
                    object.versionUuid = [];
                    if (options.bytes !== Array)
                        object.versionUuid = $util.newBuffer(object.versionUuid);
                }
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.fileUuid != null && message.hasOwnProperty("fileUuid"))
                object.fileUuid = options.bytes === String ? $util.base64.encode(message.fileUuid, 0, message.fileUuid.length) : options.bytes === Array ? Array.prototype.slice.call(message.fileUuid) : message.fileUuid;
            if (message.versionUuid != null && message.hasOwnProperty("versionUuid"))
                object.versionUuid = options.bytes === String ? $util.base64.encode(message.versionUuid, 0, message.versionUuid.length) : options.bytes === Array ? Array.prototype.slice.call(message.versionUuid) : message.versionUuid;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this GetProfileFileMeta to JSON.
         * @function toJSON
         * @memberof response.GetProfileFileMeta
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetProfileFileMeta.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetProfileFileMeta
         * @function getTypeUrl
         * @memberof response.GetProfileFileMeta
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetProfileFileMeta.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.GetProfileFileMeta";
        };

        return GetProfileFileMeta;
    })();

    response.ProfileChunkList = (function() {

        /**
         * Properties of a ProfileChunkList.
         * @memberof response
         * @interface IProfileChunkList
         * @property {response.Status|null} [status] ProfileChunkList status
         * @property {number|Long|null} [totalCount] ProfileChunkList totalCount
         * @property {Array.<response.IChunk>|null} [objects] ProfileChunkList objects
         * @property {Uint8Array|null} [pageToken] ProfileChunkList pageToken
         * @property {boolean|null} [isLast] ProfileChunkList isLast
         * @property {string|null} [message] ProfileChunkList message
         */

        /**
         * Constructs a new ProfileChunkList.
         * @memberof response
         * @classdesc Represents a ProfileChunkList.
         * @implements IProfileChunkList
         * @constructor
         * @param {response.IProfileChunkList=} [properties] Properties to set
         */
        function ProfileChunkList(properties) {
            this.objects = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ProfileChunkList status.
         * @member {response.Status} status
         * @memberof response.ProfileChunkList
         * @instance
         */
        ProfileChunkList.prototype.status = 0;

        /**
         * ProfileChunkList totalCount.
         * @member {number|Long|null|undefined} totalCount
         * @memberof response.ProfileChunkList
         * @instance
         */
        ProfileChunkList.prototype.totalCount = null;

        /**
         * ProfileChunkList objects.
         * @member {Array.<response.IChunk>} objects
         * @memberof response.ProfileChunkList
         * @instance
         */
        ProfileChunkList.prototype.objects = $util.emptyArray;

        /**
         * ProfileChunkList pageToken.
         * @member {Uint8Array|null|undefined} pageToken
         * @memberof response.ProfileChunkList
         * @instance
         */
        ProfileChunkList.prototype.pageToken = null;

        /**
         * ProfileChunkList isLast.
         * @member {boolean} isLast
         * @memberof response.ProfileChunkList
         * @instance
         */
        ProfileChunkList.prototype.isLast = false;

        /**
         * ProfileChunkList message.
         * @member {string|null|undefined} message
         * @memberof response.ProfileChunkList
         * @instance
         */
        ProfileChunkList.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(ProfileChunkList.prototype, "_totalCount", {
            get: $util.oneOfGetter($oneOfFields = ["totalCount"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(ProfileChunkList.prototype, "_pageToken", {
            get: $util.oneOfGetter($oneOfFields = ["pageToken"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(ProfileChunkList.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new ProfileChunkList instance using the specified properties.
         * @function create
         * @memberof response.ProfileChunkList
         * @static
         * @param {response.IProfileChunkList=} [properties] Properties to set
         * @returns {response.ProfileChunkList} ProfileChunkList instance
         */
        ProfileChunkList.create = function create(properties) {
            return new ProfileChunkList(properties);
        };

        /**
         * Encodes the specified ProfileChunkList message. Does not implicitly {@link response.ProfileChunkList.verify|verify} messages.
         * @function encode
         * @memberof response.ProfileChunkList
         * @static
         * @param {response.IProfileChunkList} message ProfileChunkList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProfileChunkList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.totalCount != null && Object.hasOwnProperty.call(message, "totalCount"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.totalCount);
            if (message.objects != null && message.objects.length)
                for (let i = 0; i < message.objects.length; ++i)
                    $root.response.Chunk.encode(message.objects[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.pageToken);
            if (message.isLast != null && Object.hasOwnProperty.call(message, "isLast"))
                writer.uint32(/* id 5, wireType 0 =*/40).bool(message.isLast);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified ProfileChunkList message, length delimited. Does not implicitly {@link response.ProfileChunkList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.ProfileChunkList
         * @static
         * @param {response.IProfileChunkList} message ProfileChunkList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ProfileChunkList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ProfileChunkList message from the specified reader or buffer.
         * @function decode
         * @memberof response.ProfileChunkList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.ProfileChunkList} ProfileChunkList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProfileChunkList.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.ProfileChunkList();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.totalCount = reader.uint64();
                        break;
                    }
                case 3: {
                        if (!(message.objects && message.objects.length))
                            message.objects = [];
                        message.objects.push($root.response.Chunk.decode(reader, reader.uint32()));
                        break;
                    }
                case 4: {
                        message.pageToken = reader.bytes();
                        break;
                    }
                case 5: {
                        message.isLast = reader.bool();
                        break;
                    }
                case 6: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ProfileChunkList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.ProfileChunkList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.ProfileChunkList} ProfileChunkList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ProfileChunkList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ProfileChunkList message.
         * @function verify
         * @memberof response.ProfileChunkList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ProfileChunkList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.totalCount != null && message.hasOwnProperty("totalCount")) {
                properties._totalCount = 1;
                if (!$util.isInteger(message.totalCount) && !(message.totalCount && $util.isInteger(message.totalCount.low) && $util.isInteger(message.totalCount.high)))
                    return "totalCount: integer|Long expected";
            }
            if (message.objects != null && message.hasOwnProperty("objects")) {
                if (!Array.isArray(message.objects))
                    return "objects: array expected";
                for (let i = 0; i < message.objects.length; ++i) {
                    let error = $root.response.Chunk.verify(message.objects[i]);
                    if (error)
                        return "objects." + error;
                }
            }
            if (message.pageToken != null && message.hasOwnProperty("pageToken")) {
                properties._pageToken = 1;
                if (!(message.pageToken && typeof message.pageToken.length === "number" || $util.isString(message.pageToken)))
                    return "pageToken: buffer expected";
            }
            if (message.isLast != null && message.hasOwnProperty("isLast"))
                if (typeof message.isLast !== "boolean")
                    return "isLast: boolean expected";
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a ProfileChunkList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.ProfileChunkList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.ProfileChunkList} ProfileChunkList
         */
        ProfileChunkList.fromObject = function fromObject(object) {
            if (object instanceof $root.response.ProfileChunkList)
                return object;
            let message = new $root.response.ProfileChunkList();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.totalCount != null)
                if ($util.Long)
                    (message.totalCount = $util.Long.fromValue(object.totalCount)).unsigned = true;
                else if (typeof object.totalCount === "string")
                    message.totalCount = parseInt(object.totalCount, 10);
                else if (typeof object.totalCount === "number")
                    message.totalCount = object.totalCount;
                else if (typeof object.totalCount === "object")
                    message.totalCount = new $util.LongBits(object.totalCount.low >>> 0, object.totalCount.high >>> 0).toNumber(true);
            if (object.objects) {
                if (!Array.isArray(object.objects))
                    throw TypeError(".response.ProfileChunkList.objects: array expected");
                message.objects = [];
                for (let i = 0; i < object.objects.length; ++i) {
                    if (typeof object.objects[i] !== "object")
                        throw TypeError(".response.ProfileChunkList.objects: object expected");
                    message.objects[i] = $root.response.Chunk.fromObject(object.objects[i]);
                }
            }
            if (object.pageToken != null)
                if (typeof object.pageToken === "string")
                    $util.base64.decode(object.pageToken, message.pageToken = $util.newBuffer($util.base64.length(object.pageToken)), 0);
                else if (object.pageToken.length >= 0)
                    message.pageToken = object.pageToken;
            if (object.isLast != null)
                message.isLast = Boolean(object.isLast);
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a ProfileChunkList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.ProfileChunkList
         * @static
         * @param {response.ProfileChunkList} message ProfileChunkList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ProfileChunkList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.objects = [];
            if (options.defaults) {
                object.status = options.enums === String ? "SUCCESS" : 0;
                object.isLast = false;
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.totalCount != null && message.hasOwnProperty("totalCount")) {
                if (typeof message.totalCount === "number")
                    object.totalCount = options.longs === String ? String(message.totalCount) : message.totalCount;
                else
                    object.totalCount = options.longs === String ? $util.Long.prototype.toString.call(message.totalCount) : options.longs === Number ? new $util.LongBits(message.totalCount.low >>> 0, message.totalCount.high >>> 0).toNumber(true) : message.totalCount;
                if (options.oneofs)
                    object._totalCount = "totalCount";
            }
            if (message.objects && message.objects.length) {
                object.objects = [];
                for (let j = 0; j < message.objects.length; ++j)
                    object.objects[j] = $root.response.Chunk.toObject(message.objects[j], options);
            }
            if (message.pageToken != null && message.hasOwnProperty("pageToken")) {
                object.pageToken = options.bytes === String ? $util.base64.encode(message.pageToken, 0, message.pageToken.length) : options.bytes === Array ? Array.prototype.slice.call(message.pageToken) : message.pageToken;
                if (options.oneofs)
                    object._pageToken = "pageToken";
            }
            if (message.isLast != null && message.hasOwnProperty("isLast"))
                object.isLast = message.isLast;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this ProfileChunkList to JSON.
         * @function toJSON
         * @memberof response.ProfileChunkList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ProfileChunkList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ProfileChunkList
         * @function getTypeUrl
         * @memberof response.ProfileChunkList
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ProfileChunkList.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.ProfileChunkList";
        };

        return ProfileChunkList;
    })();

    /**
     * TypeOfUser enum.
     * @name response.TypeOfUser
     * @enum {number}
     * @property {number} INDIVIDUAL_USER=0 INDIVIDUAL_USER value
     * @property {number} ORGANIZATION_USER=1 ORGANIZATION_USER value
     * @property {number} ORGANIZATION=2 ORGANIZATION value
     */
    response.TypeOfUser = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "INDIVIDUAL_USER"] = 0;
        values[valuesById[1] = "ORGANIZATION_USER"] = 1;
        values[valuesById[2] = "ORGANIZATION"] = 2;
        return values;
    })();

    response.GetUserType = (function() {

        /**
         * Properties of a GetUserType.
         * @memberof response
         * @interface IGetUserType
         * @property {response.TypeOfUser|null} [type] GetUserType type
         * @property {response.Status|null} [status] GetUserType status
         * @property {string|null} [message] GetUserType message
         */

        /**
         * Constructs a new GetUserType.
         * @memberof response
         * @classdesc Represents a GetUserType.
         * @implements IGetUserType
         * @constructor
         * @param {response.IGetUserType=} [properties] Properties to set
         */
        function GetUserType(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetUserType type.
         * @member {response.TypeOfUser} type
         * @memberof response.GetUserType
         * @instance
         */
        GetUserType.prototype.type = 0;

        /**
         * GetUserType status.
         * @member {response.Status} status
         * @memberof response.GetUserType
         * @instance
         */
        GetUserType.prototype.status = 0;

        /**
         * GetUserType message.
         * @member {string|null|undefined} message
         * @memberof response.GetUserType
         * @instance
         */
        GetUserType.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(GetUserType.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new GetUserType instance using the specified properties.
         * @function create
         * @memberof response.GetUserType
         * @static
         * @param {response.IGetUserType=} [properties] Properties to set
         * @returns {response.GetUserType} GetUserType instance
         */
        GetUserType.create = function create(properties) {
            return new GetUserType(properties);
        };

        /**
         * Encodes the specified GetUserType message. Does not implicitly {@link response.GetUserType.verify|verify} messages.
         * @function encode
         * @memberof response.GetUserType
         * @static
         * @param {response.IGetUserType} message GetUserType message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetUserType.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.type);
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified GetUserType message, length delimited. Does not implicitly {@link response.GetUserType.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.GetUserType
         * @static
         * @param {response.IGetUserType} message GetUserType message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetUserType.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetUserType message from the specified reader or buffer.
         * @function decode
         * @memberof response.GetUserType
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.GetUserType} GetUserType
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetUserType.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.GetUserType();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.type = reader.int32();
                        break;
                    }
                case 2: {
                        message.status = reader.int32();
                        break;
                    }
                case 3: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetUserType message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.GetUserType
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.GetUserType} GetUserType
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetUserType.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetUserType message.
         * @function verify
         * @memberof response.GetUserType
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetUserType.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.type != null && message.hasOwnProperty("type"))
                switch (message.type) {
                default:
                    return "type: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a GetUserType message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.GetUserType
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.GetUserType} GetUserType
         */
        GetUserType.fromObject = function fromObject(object) {
            if (object instanceof $root.response.GetUserType)
                return object;
            let message = new $root.response.GetUserType();
            switch (object.type) {
            default:
                if (typeof object.type === "number") {
                    message.type = object.type;
                    break;
                }
                break;
            case "INDIVIDUAL_USER":
            case 0:
                message.type = 0;
                break;
            case "ORGANIZATION_USER":
            case 1:
                message.type = 1;
                break;
            case "ORGANIZATION":
            case 2:
                message.type = 2;
                break;
            }
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a GetUserType message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.GetUserType
         * @static
         * @param {response.GetUserType} message GetUserType
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetUserType.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.type = options.enums === String ? "INDIVIDUAL_USER" : 0;
                object.status = options.enums === String ? "SUCCESS" : 0;
            }
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = options.enums === String ? $root.response.TypeOfUser[message.type] === undefined ? message.type : $root.response.TypeOfUser[message.type] : message.type;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this GetUserType to JSON.
         * @function toJSON
         * @memberof response.GetUserType
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetUserType.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetUserType
         * @function getTypeUrl
         * @memberof response.GetUserType
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetUserType.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.GetUserType";
        };

        return GetUserType;
    })();

    response.Share = (function() {

        /**
         * Properties of a Share.
         * @memberof response
         * @interface IShare
         * @property {response.Status|null} [status] Share status
         * @property {string|null} [message] Share message
         */

        /**
         * Constructs a new Share.
         * @memberof response
         * @classdesc Represents a Share.
         * @implements IShare
         * @constructor
         * @param {response.IShare=} [properties] Properties to set
         */
        function Share(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Share status.
         * @member {response.Status} status
         * @memberof response.Share
         * @instance
         */
        Share.prototype.status = 0;

        /**
         * Share message.
         * @member {string} message
         * @memberof response.Share
         * @instance
         */
        Share.prototype.message = "";

        /**
         * Creates a new Share instance using the specified properties.
         * @function create
         * @memberof response.Share
         * @static
         * @param {response.IShare=} [properties] Properties to set
         * @returns {response.Share} Share instance
         */
        Share.create = function create(properties) {
            return new Share(properties);
        };

        /**
         * Encodes the specified Share message. Does not implicitly {@link response.Share.verify|verify} messages.
         * @function encode
         * @memberof response.Share
         * @static
         * @param {response.IShare} message Share message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Share.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified Share message, length delimited. Does not implicitly {@link response.Share.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.Share
         * @static
         * @param {response.IShare} message Share message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Share.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Share message from the specified reader or buffer.
         * @function decode
         * @memberof response.Share
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.Share} Share
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Share.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.Share();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Share message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.Share
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.Share} Share
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Share.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Share message.
         * @function verify
         * @memberof response.Share
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Share.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message"))
                if (!$util.isString(message.message))
                    return "message: string expected";
            return null;
        };

        /**
         * Creates a Share message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.Share
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.Share} Share
         */
        Share.fromObject = function fromObject(object) {
            if (object instanceof $root.response.Share)
                return object;
            let message = new $root.response.Share();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a Share message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.Share
         * @static
         * @param {response.Share} message Share
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Share.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.status = options.enums === String ? "SUCCESS" : 0;
                object.message = "";
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message"))
                object.message = message.message;
            return object;
        };

        /**
         * Converts this Share to JSON.
         * @function toJSON
         * @memberof response.Share
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Share.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Share
         * @function getTypeUrl
         * @memberof response.Share
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Share.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.Share";
        };

        return Share;
    })();

    response.Unshare = (function() {

        /**
         * Properties of an Unshare.
         * @memberof response
         * @interface IUnshare
         * @property {response.Status|null} [status] Unshare status
         * @property {string|null} [message] Unshare message
         */

        /**
         * Constructs a new Unshare.
         * @memberof response
         * @classdesc Represents an Unshare.
         * @implements IUnshare
         * @constructor
         * @param {response.IUnshare=} [properties] Properties to set
         */
        function Unshare(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Unshare status.
         * @member {response.Status} status
         * @memberof response.Unshare
         * @instance
         */
        Unshare.prototype.status = 0;

        /**
         * Unshare message.
         * @member {string} message
         * @memberof response.Unshare
         * @instance
         */
        Unshare.prototype.message = "";

        /**
         * Creates a new Unshare instance using the specified properties.
         * @function create
         * @memberof response.Unshare
         * @static
         * @param {response.IUnshare=} [properties] Properties to set
         * @returns {response.Unshare} Unshare instance
         */
        Unshare.create = function create(properties) {
            return new Unshare(properties);
        };

        /**
         * Encodes the specified Unshare message. Does not implicitly {@link response.Unshare.verify|verify} messages.
         * @function encode
         * @memberof response.Unshare
         * @static
         * @param {response.IUnshare} message Unshare message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Unshare.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified Unshare message, length delimited. Does not implicitly {@link response.Unshare.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.Unshare
         * @static
         * @param {response.IUnshare} message Unshare message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Unshare.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an Unshare message from the specified reader or buffer.
         * @function decode
         * @memberof response.Unshare
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.Unshare} Unshare
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Unshare.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.Unshare();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an Unshare message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.Unshare
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.Unshare} Unshare
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Unshare.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an Unshare message.
         * @function verify
         * @memberof response.Unshare
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Unshare.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message"))
                if (!$util.isString(message.message))
                    return "message: string expected";
            return null;
        };

        /**
         * Creates an Unshare message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.Unshare
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.Unshare} Unshare
         */
        Unshare.fromObject = function fromObject(object) {
            if (object instanceof $root.response.Unshare)
                return object;
            let message = new $root.response.Unshare();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from an Unshare message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.Unshare
         * @static
         * @param {response.Unshare} message Unshare
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Unshare.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.status = options.enums === String ? "SUCCESS" : 0;
                object.message = "";
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message"))
                object.message = message.message;
            return object;
        };

        /**
         * Converts this Unshare to JSON.
         * @function toJSON
         * @memberof response.Unshare
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Unshare.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Unshare
         * @function getTypeUrl
         * @memberof response.Unshare
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Unshare.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.Unshare";
        };

        return Unshare;
    })();

    response.UpdateShare = (function() {

        /**
         * Properties of an UpdateShare.
         * @memberof response
         * @interface IUpdateShare
         * @property {response.Status|null} [status] UpdateShare status
         * @property {string|null} [message] UpdateShare message
         */

        /**
         * Constructs a new UpdateShare.
         * @memberof response
         * @classdesc Represents an UpdateShare.
         * @implements IUpdateShare
         * @constructor
         * @param {response.IUpdateShare=} [properties] Properties to set
         */
        function UpdateShare(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateShare status.
         * @member {response.Status} status
         * @memberof response.UpdateShare
         * @instance
         */
        UpdateShare.prototype.status = 0;

        /**
         * UpdateShare message.
         * @member {string} message
         * @memberof response.UpdateShare
         * @instance
         */
        UpdateShare.prototype.message = "";

        /**
         * Creates a new UpdateShare instance using the specified properties.
         * @function create
         * @memberof response.UpdateShare
         * @static
         * @param {response.IUpdateShare=} [properties] Properties to set
         * @returns {response.UpdateShare} UpdateShare instance
         */
        UpdateShare.create = function create(properties) {
            return new UpdateShare(properties);
        };

        /**
         * Encodes the specified UpdateShare message. Does not implicitly {@link response.UpdateShare.verify|verify} messages.
         * @function encode
         * @memberof response.UpdateShare
         * @static
         * @param {response.IUpdateShare} message UpdateShare message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateShare.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified UpdateShare message, length delimited. Does not implicitly {@link response.UpdateShare.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.UpdateShare
         * @static
         * @param {response.IUpdateShare} message UpdateShare message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateShare.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UpdateShare message from the specified reader or buffer.
         * @function decode
         * @memberof response.UpdateShare
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.UpdateShare} UpdateShare
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateShare.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.UpdateShare();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UpdateShare message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.UpdateShare
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.UpdateShare} UpdateShare
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateShare.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UpdateShare message.
         * @function verify
         * @memberof response.UpdateShare
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UpdateShare.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message"))
                if (!$util.isString(message.message))
                    return "message: string expected";
            return null;
        };

        /**
         * Creates an UpdateShare message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.UpdateShare
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.UpdateShare} UpdateShare
         */
        UpdateShare.fromObject = function fromObject(object) {
            if (object instanceof $root.response.UpdateShare)
                return object;
            let message = new $root.response.UpdateShare();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from an UpdateShare message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.UpdateShare
         * @static
         * @param {response.UpdateShare} message UpdateShare
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateShare.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.status = options.enums === String ? "SUCCESS" : 0;
                object.message = "";
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message"))
                object.message = message.message;
            return object;
        };

        /**
         * Converts this UpdateShare to JSON.
         * @function toJSON
         * @memberof response.UpdateShare
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateShare.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for UpdateShare
         * @function getTypeUrl
         * @memberof response.UpdateShare
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        UpdateShare.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.UpdateShare";
        };

        return UpdateShare;
    })();

    response.ListShares = (function() {

        /**
         * Properties of a ListShares.
         * @memberof response
         * @interface IListShares
         * @property {response.Status|null} [status] ListShares status
         * @property {string|null} [message] ListShares message
         * @property {Uint8Array|null} [acl] ListShares acl
         */

        /**
         * Constructs a new ListShares.
         * @memberof response
         * @classdesc Represents a ListShares.
         * @implements IListShares
         * @constructor
         * @param {response.IListShares=} [properties] Properties to set
         */
        function ListShares(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListShares status.
         * @member {response.Status} status
         * @memberof response.ListShares
         * @instance
         */
        ListShares.prototype.status = 0;

        /**
         * ListShares message.
         * @member {string} message
         * @memberof response.ListShares
         * @instance
         */
        ListShares.prototype.message = "";

        /**
         * ListShares acl.
         * @member {Uint8Array} acl
         * @memberof response.ListShares
         * @instance
         */
        ListShares.prototype.acl = $util.newBuffer([]);

        /**
         * Creates a new ListShares instance using the specified properties.
         * @function create
         * @memberof response.ListShares
         * @static
         * @param {response.IListShares=} [properties] Properties to set
         * @returns {response.ListShares} ListShares instance
         */
        ListShares.create = function create(properties) {
            return new ListShares(properties);
        };

        /**
         * Encodes the specified ListShares message. Does not implicitly {@link response.ListShares.verify|verify} messages.
         * @function encode
         * @memberof response.ListShares
         * @static
         * @param {response.IListShares} message ListShares message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListShares.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            if (message.acl != null && Object.hasOwnProperty.call(message, "acl"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.acl);
            return writer;
        };

        /**
         * Encodes the specified ListShares message, length delimited. Does not implicitly {@link response.ListShares.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.ListShares
         * @static
         * @param {response.IListShares} message ListShares message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListShares.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ListShares message from the specified reader or buffer.
         * @function decode
         * @memberof response.ListShares
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.ListShares} ListShares
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListShares.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.ListShares();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                case 3: {
                        message.acl = reader.bytes();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ListShares message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.ListShares
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.ListShares} ListShares
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListShares.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ListShares message.
         * @function verify
         * @memberof response.ListShares
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ListShares.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message"))
                if (!$util.isString(message.message))
                    return "message: string expected";
            if (message.acl != null && message.hasOwnProperty("acl"))
                if (!(message.acl && typeof message.acl.length === "number" || $util.isString(message.acl)))
                    return "acl: buffer expected";
            return null;
        };

        /**
         * Creates a ListShares message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.ListShares
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.ListShares} ListShares
         */
        ListShares.fromObject = function fromObject(object) {
            if (object instanceof $root.response.ListShares)
                return object;
            let message = new $root.response.ListShares();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            if (object.acl != null)
                if (typeof object.acl === "string")
                    $util.base64.decode(object.acl, message.acl = $util.newBuffer($util.base64.length(object.acl)), 0);
                else if (object.acl.length >= 0)
                    message.acl = object.acl;
            return message;
        };

        /**
         * Creates a plain object from a ListShares message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.ListShares
         * @static
         * @param {response.ListShares} message ListShares
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListShares.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.status = options.enums === String ? "SUCCESS" : 0;
                object.message = "";
                if (options.bytes === String)
                    object.acl = "";
                else {
                    object.acl = [];
                    if (options.bytes !== Array)
                        object.acl = $util.newBuffer(object.acl);
                }
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message"))
                object.message = message.message;
            if (message.acl != null && message.hasOwnProperty("acl"))
                object.acl = options.bytes === String ? $util.base64.encode(message.acl, 0, message.acl.length) : options.bytes === Array ? Array.prototype.slice.call(message.acl) : message.acl;
            return object;
        };

        /**
         * Converts this ListShares to JSON.
         * @function toJSON
         * @memberof response.ListShares
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListShares.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ListShares
         * @function getTypeUrl
         * @memberof response.ListShares
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ListShares.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.ListShares";
        };

        return ListShares;
    })();

    response.SetRolesTeamsToUser = (function() {

        /**
         * Properties of a SetRolesTeamsToUser.
         * @memberof response
         * @interface ISetRolesTeamsToUser
         * @property {response.Status|null} [status] SetRolesTeamsToUser status
         * @property {string|null} [message] SetRolesTeamsToUser message
         */

        /**
         * Constructs a new SetRolesTeamsToUser.
         * @memberof response
         * @classdesc Represents a SetRolesTeamsToUser.
         * @implements ISetRolesTeamsToUser
         * @constructor
         * @param {response.ISetRolesTeamsToUser=} [properties] Properties to set
         */
        function SetRolesTeamsToUser(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SetRolesTeamsToUser status.
         * @member {response.Status} status
         * @memberof response.SetRolesTeamsToUser
         * @instance
         */
        SetRolesTeamsToUser.prototype.status = 0;

        /**
         * SetRolesTeamsToUser message.
         * @member {string|null|undefined} message
         * @memberof response.SetRolesTeamsToUser
         * @instance
         */
        SetRolesTeamsToUser.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(SetRolesTeamsToUser.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new SetRolesTeamsToUser instance using the specified properties.
         * @function create
         * @memberof response.SetRolesTeamsToUser
         * @static
         * @param {response.ISetRolesTeamsToUser=} [properties] Properties to set
         * @returns {response.SetRolesTeamsToUser} SetRolesTeamsToUser instance
         */
        SetRolesTeamsToUser.create = function create(properties) {
            return new SetRolesTeamsToUser(properties);
        };

        /**
         * Encodes the specified SetRolesTeamsToUser message. Does not implicitly {@link response.SetRolesTeamsToUser.verify|verify} messages.
         * @function encode
         * @memberof response.SetRolesTeamsToUser
         * @static
         * @param {response.ISetRolesTeamsToUser} message SetRolesTeamsToUser message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SetRolesTeamsToUser.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified SetRolesTeamsToUser message, length delimited. Does not implicitly {@link response.SetRolesTeamsToUser.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.SetRolesTeamsToUser
         * @static
         * @param {response.ISetRolesTeamsToUser} message SetRolesTeamsToUser message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SetRolesTeamsToUser.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SetRolesTeamsToUser message from the specified reader or buffer.
         * @function decode
         * @memberof response.SetRolesTeamsToUser
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.SetRolesTeamsToUser} SetRolesTeamsToUser
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SetRolesTeamsToUser.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.SetRolesTeamsToUser();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SetRolesTeamsToUser message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.SetRolesTeamsToUser
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.SetRolesTeamsToUser} SetRolesTeamsToUser
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SetRolesTeamsToUser.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SetRolesTeamsToUser message.
         * @function verify
         * @memberof response.SetRolesTeamsToUser
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SetRolesTeamsToUser.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a SetRolesTeamsToUser message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.SetRolesTeamsToUser
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.SetRolesTeamsToUser} SetRolesTeamsToUser
         */
        SetRolesTeamsToUser.fromObject = function fromObject(object) {
            if (object instanceof $root.response.SetRolesTeamsToUser)
                return object;
            let message = new $root.response.SetRolesTeamsToUser();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a SetRolesTeamsToUser message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.SetRolesTeamsToUser
         * @static
         * @param {response.SetRolesTeamsToUser} message SetRolesTeamsToUser
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SetRolesTeamsToUser.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this SetRolesTeamsToUser to JSON.
         * @function toJSON
         * @memberof response.SetRolesTeamsToUser
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SetRolesTeamsToUser.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for SetRolesTeamsToUser
         * @function getTypeUrl
         * @memberof response.SetRolesTeamsToUser
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        SetRolesTeamsToUser.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.SetRolesTeamsToUser";
        };

        return SetRolesTeamsToUser;
    })();

    response.UpdatePinOps = (function() {

        /**
         * Properties of an UpdatePinOps.
         * @memberof response
         * @interface IUpdatePinOps
         * @property {response.Status|null} [status] UpdatePinOps status
         * @property {string|null} [message] UpdatePinOps message
         */

        /**
         * Constructs a new UpdatePinOps.
         * @memberof response
         * @classdesc Represents an UpdatePinOps.
         * @implements IUpdatePinOps
         * @constructor
         * @param {response.IUpdatePinOps=} [properties] Properties to set
         */
        function UpdatePinOps(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdatePinOps status.
         * @member {response.Status} status
         * @memberof response.UpdatePinOps
         * @instance
         */
        UpdatePinOps.prototype.status = 0;

        /**
         * UpdatePinOps message.
         * @member {string|null|undefined} message
         * @memberof response.UpdatePinOps
         * @instance
         */
        UpdatePinOps.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(UpdatePinOps.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new UpdatePinOps instance using the specified properties.
         * @function create
         * @memberof response.UpdatePinOps
         * @static
         * @param {response.IUpdatePinOps=} [properties] Properties to set
         * @returns {response.UpdatePinOps} UpdatePinOps instance
         */
        UpdatePinOps.create = function create(properties) {
            return new UpdatePinOps(properties);
        };

        /**
         * Encodes the specified UpdatePinOps message. Does not implicitly {@link response.UpdatePinOps.verify|verify} messages.
         * @function encode
         * @memberof response.UpdatePinOps
         * @static
         * @param {response.IUpdatePinOps} message UpdatePinOps message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdatePinOps.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified UpdatePinOps message, length delimited. Does not implicitly {@link response.UpdatePinOps.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.UpdatePinOps
         * @static
         * @param {response.IUpdatePinOps} message UpdatePinOps message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdatePinOps.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UpdatePinOps message from the specified reader or buffer.
         * @function decode
         * @memberof response.UpdatePinOps
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.UpdatePinOps} UpdatePinOps
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdatePinOps.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.UpdatePinOps();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UpdatePinOps message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.UpdatePinOps
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.UpdatePinOps} UpdatePinOps
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdatePinOps.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UpdatePinOps message.
         * @function verify
         * @memberof response.UpdatePinOps
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UpdatePinOps.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates an UpdatePinOps message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.UpdatePinOps
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.UpdatePinOps} UpdatePinOps
         */
        UpdatePinOps.fromObject = function fromObject(object) {
            if (object instanceof $root.response.UpdatePinOps)
                return object;
            let message = new $root.response.UpdatePinOps();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from an UpdatePinOps message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.UpdatePinOps
         * @static
         * @param {response.UpdatePinOps} message UpdatePinOps
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdatePinOps.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this UpdatePinOps to JSON.
         * @function toJSON
         * @memberof response.UpdatePinOps
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdatePinOps.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for UpdatePinOps
         * @function getTypeUrl
         * @memberof response.UpdatePinOps
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        UpdatePinOps.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.UpdatePinOps";
        };

        return UpdatePinOps;
    })();

    response.DeletePin = (function() {

        /**
         * Properties of a DeletePin.
         * @memberof response
         * @interface IDeletePin
         * @property {response.Status|null} [status] DeletePin status
         * @property {string|null} [message] DeletePin message
         */

        /**
         * Constructs a new DeletePin.
         * @memberof response
         * @classdesc Represents a DeletePin.
         * @implements IDeletePin
         * @constructor
         * @param {response.IDeletePin=} [properties] Properties to set
         */
        function DeletePin(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DeletePin status.
         * @member {response.Status} status
         * @memberof response.DeletePin
         * @instance
         */
        DeletePin.prototype.status = 0;

        /**
         * DeletePin message.
         * @member {string|null|undefined} message
         * @memberof response.DeletePin
         * @instance
         */
        DeletePin.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(DeletePin.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new DeletePin instance using the specified properties.
         * @function create
         * @memberof response.DeletePin
         * @static
         * @param {response.IDeletePin=} [properties] Properties to set
         * @returns {response.DeletePin} DeletePin instance
         */
        DeletePin.create = function create(properties) {
            return new DeletePin(properties);
        };

        /**
         * Encodes the specified DeletePin message. Does not implicitly {@link response.DeletePin.verify|verify} messages.
         * @function encode
         * @memberof response.DeletePin
         * @static
         * @param {response.IDeletePin} message DeletePin message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DeletePin.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified DeletePin message, length delimited. Does not implicitly {@link response.DeletePin.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.DeletePin
         * @static
         * @param {response.IDeletePin} message DeletePin message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DeletePin.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a DeletePin message from the specified reader or buffer.
         * @function decode
         * @memberof response.DeletePin
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.DeletePin} DeletePin
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DeletePin.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.DeletePin();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a DeletePin message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.DeletePin
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.DeletePin} DeletePin
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DeletePin.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a DeletePin message.
         * @function verify
         * @memberof response.DeletePin
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        DeletePin.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a DeletePin message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.DeletePin
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.DeletePin} DeletePin
         */
        DeletePin.fromObject = function fromObject(object) {
            if (object instanceof $root.response.DeletePin)
                return object;
            let message = new $root.response.DeletePin();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a DeletePin message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.DeletePin
         * @static
         * @param {response.DeletePin} message DeletePin
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DeletePin.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this DeletePin to JSON.
         * @function toJSON
         * @memberof response.DeletePin
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DeletePin.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for DeletePin
         * @function getTypeUrl
         * @memberof response.DeletePin
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        DeletePin.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.DeletePin";
        };

        return DeletePin;
    })();

    response.GetRolesAndTeamsOfUser = (function() {

        /**
         * Properties of a GetRolesAndTeamsOfUser.
         * @memberof response
         * @interface IGetRolesAndTeamsOfUser
         * @property {response.Status|null} [status] GetRolesAndTeamsOfUser status
         * @property {string|null} [message] GetRolesAndTeamsOfUser message
         * @property {Array.<string>|null} [nameOfRoles] GetRolesAndTeamsOfUser nameOfRoles
         * @property {Array.<string>|null} [nameOfTeams] GetRolesAndTeamsOfUser nameOfTeams
         */

        /**
         * Constructs a new GetRolesAndTeamsOfUser.
         * @memberof response
         * @classdesc Represents a GetRolesAndTeamsOfUser.
         * @implements IGetRolesAndTeamsOfUser
         * @constructor
         * @param {response.IGetRolesAndTeamsOfUser=} [properties] Properties to set
         */
        function GetRolesAndTeamsOfUser(properties) {
            this.nameOfRoles = [];
            this.nameOfTeams = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetRolesAndTeamsOfUser status.
         * @member {response.Status} status
         * @memberof response.GetRolesAndTeamsOfUser
         * @instance
         */
        GetRolesAndTeamsOfUser.prototype.status = 0;

        /**
         * GetRolesAndTeamsOfUser message.
         * @member {string|null|undefined} message
         * @memberof response.GetRolesAndTeamsOfUser
         * @instance
         */
        GetRolesAndTeamsOfUser.prototype.message = null;

        /**
         * GetRolesAndTeamsOfUser nameOfRoles.
         * @member {Array.<string>} nameOfRoles
         * @memberof response.GetRolesAndTeamsOfUser
         * @instance
         */
        GetRolesAndTeamsOfUser.prototype.nameOfRoles = $util.emptyArray;

        /**
         * GetRolesAndTeamsOfUser nameOfTeams.
         * @member {Array.<string>} nameOfTeams
         * @memberof response.GetRolesAndTeamsOfUser
         * @instance
         */
        GetRolesAndTeamsOfUser.prototype.nameOfTeams = $util.emptyArray;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(GetRolesAndTeamsOfUser.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new GetRolesAndTeamsOfUser instance using the specified properties.
         * @function create
         * @memberof response.GetRolesAndTeamsOfUser
         * @static
         * @param {response.IGetRolesAndTeamsOfUser=} [properties] Properties to set
         * @returns {response.GetRolesAndTeamsOfUser} GetRolesAndTeamsOfUser instance
         */
        GetRolesAndTeamsOfUser.create = function create(properties) {
            return new GetRolesAndTeamsOfUser(properties);
        };

        /**
         * Encodes the specified GetRolesAndTeamsOfUser message. Does not implicitly {@link response.GetRolesAndTeamsOfUser.verify|verify} messages.
         * @function encode
         * @memberof response.GetRolesAndTeamsOfUser
         * @static
         * @param {response.IGetRolesAndTeamsOfUser} message GetRolesAndTeamsOfUser message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetRolesAndTeamsOfUser.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            if (message.nameOfRoles != null && message.nameOfRoles.length)
                for (let i = 0; i < message.nameOfRoles.length; ++i)
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.nameOfRoles[i]);
            if (message.nameOfTeams != null && message.nameOfTeams.length)
                for (let i = 0; i < message.nameOfTeams.length; ++i)
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.nameOfTeams[i]);
            return writer;
        };

        /**
         * Encodes the specified GetRolesAndTeamsOfUser message, length delimited. Does not implicitly {@link response.GetRolesAndTeamsOfUser.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.GetRolesAndTeamsOfUser
         * @static
         * @param {response.IGetRolesAndTeamsOfUser} message GetRolesAndTeamsOfUser message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetRolesAndTeamsOfUser.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetRolesAndTeamsOfUser message from the specified reader or buffer.
         * @function decode
         * @memberof response.GetRolesAndTeamsOfUser
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.GetRolesAndTeamsOfUser} GetRolesAndTeamsOfUser
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetRolesAndTeamsOfUser.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.GetRolesAndTeamsOfUser();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                case 3: {
                        if (!(message.nameOfRoles && message.nameOfRoles.length))
                            message.nameOfRoles = [];
                        message.nameOfRoles.push(reader.string());
                        break;
                    }
                case 4: {
                        if (!(message.nameOfTeams && message.nameOfTeams.length))
                            message.nameOfTeams = [];
                        message.nameOfTeams.push(reader.string());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetRolesAndTeamsOfUser message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.GetRolesAndTeamsOfUser
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.GetRolesAndTeamsOfUser} GetRolesAndTeamsOfUser
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetRolesAndTeamsOfUser.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetRolesAndTeamsOfUser message.
         * @function verify
         * @memberof response.GetRolesAndTeamsOfUser
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetRolesAndTeamsOfUser.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            if (message.nameOfRoles != null && message.hasOwnProperty("nameOfRoles")) {
                if (!Array.isArray(message.nameOfRoles))
                    return "nameOfRoles: array expected";
                for (let i = 0; i < message.nameOfRoles.length; ++i)
                    if (!$util.isString(message.nameOfRoles[i]))
                        return "nameOfRoles: string[] expected";
            }
            if (message.nameOfTeams != null && message.hasOwnProperty("nameOfTeams")) {
                if (!Array.isArray(message.nameOfTeams))
                    return "nameOfTeams: array expected";
                for (let i = 0; i < message.nameOfTeams.length; ++i)
                    if (!$util.isString(message.nameOfTeams[i]))
                        return "nameOfTeams: string[] expected";
            }
            return null;
        };

        /**
         * Creates a GetRolesAndTeamsOfUser message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.GetRolesAndTeamsOfUser
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.GetRolesAndTeamsOfUser} GetRolesAndTeamsOfUser
         */
        GetRolesAndTeamsOfUser.fromObject = function fromObject(object) {
            if (object instanceof $root.response.GetRolesAndTeamsOfUser)
                return object;
            let message = new $root.response.GetRolesAndTeamsOfUser();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            if (object.nameOfRoles) {
                if (!Array.isArray(object.nameOfRoles))
                    throw TypeError(".response.GetRolesAndTeamsOfUser.nameOfRoles: array expected");
                message.nameOfRoles = [];
                for (let i = 0; i < object.nameOfRoles.length; ++i)
                    message.nameOfRoles[i] = String(object.nameOfRoles[i]);
            }
            if (object.nameOfTeams) {
                if (!Array.isArray(object.nameOfTeams))
                    throw TypeError(".response.GetRolesAndTeamsOfUser.nameOfTeams: array expected");
                message.nameOfTeams = [];
                for (let i = 0; i < object.nameOfTeams.length; ++i)
                    message.nameOfTeams[i] = String(object.nameOfTeams[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a GetRolesAndTeamsOfUser message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.GetRolesAndTeamsOfUser
         * @static
         * @param {response.GetRolesAndTeamsOfUser} message GetRolesAndTeamsOfUser
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetRolesAndTeamsOfUser.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.nameOfRoles = [];
                object.nameOfTeams = [];
            }
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            if (message.nameOfRoles && message.nameOfRoles.length) {
                object.nameOfRoles = [];
                for (let j = 0; j < message.nameOfRoles.length; ++j)
                    object.nameOfRoles[j] = message.nameOfRoles[j];
            }
            if (message.nameOfTeams && message.nameOfTeams.length) {
                object.nameOfTeams = [];
                for (let j = 0; j < message.nameOfTeams.length; ++j)
                    object.nameOfTeams[j] = message.nameOfTeams[j];
            }
            return object;
        };

        /**
         * Converts this GetRolesAndTeamsOfUser to JSON.
         * @function toJSON
         * @memberof response.GetRolesAndTeamsOfUser
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetRolesAndTeamsOfUser.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetRolesAndTeamsOfUser
         * @function getTypeUrl
         * @memberof response.GetRolesAndTeamsOfUser
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetRolesAndTeamsOfUser.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.GetRolesAndTeamsOfUser";
        };

        return GetRolesAndTeamsOfUser;
    })();

    response.UserMetaForList = (function() {

        /**
         * Properties of a UserMetaForList.
         * @memberof response
         * @interface IUserMetaForList
         * @property {string|null} [email] UserMetaForList email
         * @property {Array.<string>|null} [teamsOfUser] UserMetaForList teamsOfUser
         * @property {Array.<string>|null} [rolesOfUser] UserMetaForList rolesOfUser
         * @property {Uint8Array|null} [profilePicture] UserMetaForList profilePicture
         * @property {boolean|null} [blockStatus] UserMetaForList blockStatus
         */

        /**
         * Constructs a new UserMetaForList.
         * @memberof response
         * @classdesc Represents a UserMetaForList.
         * @implements IUserMetaForList
         * @constructor
         * @param {response.IUserMetaForList=} [properties] Properties to set
         */
        function UserMetaForList(properties) {
            this.teamsOfUser = [];
            this.rolesOfUser = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UserMetaForList email.
         * @member {string} email
         * @memberof response.UserMetaForList
         * @instance
         */
        UserMetaForList.prototype.email = "";

        /**
         * UserMetaForList teamsOfUser.
         * @member {Array.<string>} teamsOfUser
         * @memberof response.UserMetaForList
         * @instance
         */
        UserMetaForList.prototype.teamsOfUser = $util.emptyArray;

        /**
         * UserMetaForList rolesOfUser.
         * @member {Array.<string>} rolesOfUser
         * @memberof response.UserMetaForList
         * @instance
         */
        UserMetaForList.prototype.rolesOfUser = $util.emptyArray;

        /**
         * UserMetaForList profilePicture.
         * @member {Uint8Array} profilePicture
         * @memberof response.UserMetaForList
         * @instance
         */
        UserMetaForList.prototype.profilePicture = $util.newBuffer([]);

        /**
         * UserMetaForList blockStatus.
         * @member {boolean|null|undefined} blockStatus
         * @memberof response.UserMetaForList
         * @instance
         */
        UserMetaForList.prototype.blockStatus = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(UserMetaForList.prototype, "_blockStatus", {
            get: $util.oneOfGetter($oneOfFields = ["blockStatus"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new UserMetaForList instance using the specified properties.
         * @function create
         * @memberof response.UserMetaForList
         * @static
         * @param {response.IUserMetaForList=} [properties] Properties to set
         * @returns {response.UserMetaForList} UserMetaForList instance
         */
        UserMetaForList.create = function create(properties) {
            return new UserMetaForList(properties);
        };

        /**
         * Encodes the specified UserMetaForList message. Does not implicitly {@link response.UserMetaForList.verify|verify} messages.
         * @function encode
         * @memberof response.UserMetaForList
         * @static
         * @param {response.IUserMetaForList} message UserMetaForList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UserMetaForList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
            if (message.teamsOfUser != null && message.teamsOfUser.length)
                for (let i = 0; i < message.teamsOfUser.length; ++i)
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.teamsOfUser[i]);
            if (message.rolesOfUser != null && message.rolesOfUser.length)
                for (let i = 0; i < message.rolesOfUser.length; ++i)
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.rolesOfUser[i]);
            if (message.profilePicture != null && Object.hasOwnProperty.call(message, "profilePicture"))
                writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.profilePicture);
            if (message.blockStatus != null && Object.hasOwnProperty.call(message, "blockStatus"))
                writer.uint32(/* id 5, wireType 0 =*/40).bool(message.blockStatus);
            return writer;
        };

        /**
         * Encodes the specified UserMetaForList message, length delimited. Does not implicitly {@link response.UserMetaForList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.UserMetaForList
         * @static
         * @param {response.IUserMetaForList} message UserMetaForList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UserMetaForList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a UserMetaForList message from the specified reader or buffer.
         * @function decode
         * @memberof response.UserMetaForList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.UserMetaForList} UserMetaForList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UserMetaForList.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.UserMetaForList();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.email = reader.string();
                        break;
                    }
                case 2: {
                        if (!(message.teamsOfUser && message.teamsOfUser.length))
                            message.teamsOfUser = [];
                        message.teamsOfUser.push(reader.string());
                        break;
                    }
                case 3: {
                        if (!(message.rolesOfUser && message.rolesOfUser.length))
                            message.rolesOfUser = [];
                        message.rolesOfUser.push(reader.string());
                        break;
                    }
                case 4: {
                        message.profilePicture = reader.bytes();
                        break;
                    }
                case 5: {
                        message.blockStatus = reader.bool();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a UserMetaForList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.UserMetaForList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.UserMetaForList} UserMetaForList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UserMetaForList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a UserMetaForList message.
         * @function verify
         * @memberof response.UserMetaForList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UserMetaForList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            if (message.teamsOfUser != null && message.hasOwnProperty("teamsOfUser")) {
                if (!Array.isArray(message.teamsOfUser))
                    return "teamsOfUser: array expected";
                for (let i = 0; i < message.teamsOfUser.length; ++i)
                    if (!$util.isString(message.teamsOfUser[i]))
                        return "teamsOfUser: string[] expected";
            }
            if (message.rolesOfUser != null && message.hasOwnProperty("rolesOfUser")) {
                if (!Array.isArray(message.rolesOfUser))
                    return "rolesOfUser: array expected";
                for (let i = 0; i < message.rolesOfUser.length; ++i)
                    if (!$util.isString(message.rolesOfUser[i]))
                        return "rolesOfUser: string[] expected";
            }
            if (message.profilePicture != null && message.hasOwnProperty("profilePicture"))
                if (!(message.profilePicture && typeof message.profilePicture.length === "number" || $util.isString(message.profilePicture)))
                    return "profilePicture: buffer expected";
            if (message.blockStatus != null && message.hasOwnProperty("blockStatus")) {
                properties._blockStatus = 1;
                if (typeof message.blockStatus !== "boolean")
                    return "blockStatus: boolean expected";
            }
            return null;
        };

        /**
         * Creates a UserMetaForList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.UserMetaForList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.UserMetaForList} UserMetaForList
         */
        UserMetaForList.fromObject = function fromObject(object) {
            if (object instanceof $root.response.UserMetaForList)
                return object;
            let message = new $root.response.UserMetaForList();
            if (object.email != null)
                message.email = String(object.email);
            if (object.teamsOfUser) {
                if (!Array.isArray(object.teamsOfUser))
                    throw TypeError(".response.UserMetaForList.teamsOfUser: array expected");
                message.teamsOfUser = [];
                for (let i = 0; i < object.teamsOfUser.length; ++i)
                    message.teamsOfUser[i] = String(object.teamsOfUser[i]);
            }
            if (object.rolesOfUser) {
                if (!Array.isArray(object.rolesOfUser))
                    throw TypeError(".response.UserMetaForList.rolesOfUser: array expected");
                message.rolesOfUser = [];
                for (let i = 0; i < object.rolesOfUser.length; ++i)
                    message.rolesOfUser[i] = String(object.rolesOfUser[i]);
            }
            if (object.profilePicture != null)
                if (typeof object.profilePicture === "string")
                    $util.base64.decode(object.profilePicture, message.profilePicture = $util.newBuffer($util.base64.length(object.profilePicture)), 0);
                else if (object.profilePicture.length >= 0)
                    message.profilePicture = object.profilePicture;
            if (object.blockStatus != null)
                message.blockStatus = Boolean(object.blockStatus);
            return message;
        };

        /**
         * Creates a plain object from a UserMetaForList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.UserMetaForList
         * @static
         * @param {response.UserMetaForList} message UserMetaForList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UserMetaForList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.teamsOfUser = [];
                object.rolesOfUser = [];
            }
            if (options.defaults) {
                object.email = "";
                if (options.bytes === String)
                    object.profilePicture = "";
                else {
                    object.profilePicture = [];
                    if (options.bytes !== Array)
                        object.profilePicture = $util.newBuffer(object.profilePicture);
                }
            }
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.teamsOfUser && message.teamsOfUser.length) {
                object.teamsOfUser = [];
                for (let j = 0; j < message.teamsOfUser.length; ++j)
                    object.teamsOfUser[j] = message.teamsOfUser[j];
            }
            if (message.rolesOfUser && message.rolesOfUser.length) {
                object.rolesOfUser = [];
                for (let j = 0; j < message.rolesOfUser.length; ++j)
                    object.rolesOfUser[j] = message.rolesOfUser[j];
            }
            if (message.profilePicture != null && message.hasOwnProperty("profilePicture"))
                object.profilePicture = options.bytes === String ? $util.base64.encode(message.profilePicture, 0, message.profilePicture.length) : options.bytes === Array ? Array.prototype.slice.call(message.profilePicture) : message.profilePicture;
            if (message.blockStatus != null && message.hasOwnProperty("blockStatus")) {
                object.blockStatus = message.blockStatus;
                if (options.oneofs)
                    object._blockStatus = "blockStatus";
            }
            return object;
        };

        /**
         * Converts this UserMetaForList to JSON.
         * @function toJSON
         * @memberof response.UserMetaForList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UserMetaForList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for UserMetaForList
         * @function getTypeUrl
         * @memberof response.UserMetaForList
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        UserMetaForList.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.UserMetaForList";
        };

        return UserMetaForList;
    })();

    response.pageTokenListUser = (function() {

        /**
         * Properties of a pageTokenListUser.
         * @memberof response
         * @interface IpageTokenListUser
         * @property {number|Long|null} [lastSerialNumber] pageTokenListUser lastSerialNumber
         * @property {number|null} [pageSize] pageTokenListUser pageSize
         */

        /**
         * Constructs a new pageTokenListUser.
         * @memberof response
         * @classdesc Represents a pageTokenListUser.
         * @implements IpageTokenListUser
         * @constructor
         * @param {response.IpageTokenListUser=} [properties] Properties to set
         */
        function pageTokenListUser(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * pageTokenListUser lastSerialNumber.
         * @member {number|Long} lastSerialNumber
         * @memberof response.pageTokenListUser
         * @instance
         */
        pageTokenListUser.prototype.lastSerialNumber = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * pageTokenListUser pageSize.
         * @member {number} pageSize
         * @memberof response.pageTokenListUser
         * @instance
         */
        pageTokenListUser.prototype.pageSize = 0;

        /**
         * Creates a new pageTokenListUser instance using the specified properties.
         * @function create
         * @memberof response.pageTokenListUser
         * @static
         * @param {response.IpageTokenListUser=} [properties] Properties to set
         * @returns {response.pageTokenListUser} pageTokenListUser instance
         */
        pageTokenListUser.create = function create(properties) {
            return new pageTokenListUser(properties);
        };

        /**
         * Encodes the specified pageTokenListUser message. Does not implicitly {@link response.pageTokenListUser.verify|verify} messages.
         * @function encode
         * @memberof response.pageTokenListUser
         * @static
         * @param {response.IpageTokenListUser} message pageTokenListUser message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        pageTokenListUser.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.lastSerialNumber != null && Object.hasOwnProperty.call(message, "lastSerialNumber"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.lastSerialNumber);
            if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.pageSize);
            return writer;
        };

        /**
         * Encodes the specified pageTokenListUser message, length delimited. Does not implicitly {@link response.pageTokenListUser.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.pageTokenListUser
         * @static
         * @param {response.IpageTokenListUser} message pageTokenListUser message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        pageTokenListUser.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a pageTokenListUser message from the specified reader or buffer.
         * @function decode
         * @memberof response.pageTokenListUser
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.pageTokenListUser} pageTokenListUser
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        pageTokenListUser.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.pageTokenListUser();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.lastSerialNumber = reader.uint64();
                        break;
                    }
                case 2: {
                        message.pageSize = reader.uint32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a pageTokenListUser message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.pageTokenListUser
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.pageTokenListUser} pageTokenListUser
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        pageTokenListUser.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a pageTokenListUser message.
         * @function verify
         * @memberof response.pageTokenListUser
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        pageTokenListUser.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.lastSerialNumber != null && message.hasOwnProperty("lastSerialNumber"))
                if (!$util.isInteger(message.lastSerialNumber) && !(message.lastSerialNumber && $util.isInteger(message.lastSerialNumber.low) && $util.isInteger(message.lastSerialNumber.high)))
                    return "lastSerialNumber: integer|Long expected";
            if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                if (!$util.isInteger(message.pageSize))
                    return "pageSize: integer expected";
            return null;
        };

        /**
         * Creates a pageTokenListUser message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.pageTokenListUser
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.pageTokenListUser} pageTokenListUser
         */
        pageTokenListUser.fromObject = function fromObject(object) {
            if (object instanceof $root.response.pageTokenListUser)
                return object;
            let message = new $root.response.pageTokenListUser();
            if (object.lastSerialNumber != null)
                if ($util.Long)
                    (message.lastSerialNumber = $util.Long.fromValue(object.lastSerialNumber)).unsigned = true;
                else if (typeof object.lastSerialNumber === "string")
                    message.lastSerialNumber = parseInt(object.lastSerialNumber, 10);
                else if (typeof object.lastSerialNumber === "number")
                    message.lastSerialNumber = object.lastSerialNumber;
                else if (typeof object.lastSerialNumber === "object")
                    message.lastSerialNumber = new $util.LongBits(object.lastSerialNumber.low >>> 0, object.lastSerialNumber.high >>> 0).toNumber(true);
            if (object.pageSize != null)
                message.pageSize = object.pageSize >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a pageTokenListUser message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.pageTokenListUser
         * @static
         * @param {response.pageTokenListUser} message pageTokenListUser
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        pageTokenListUser.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.lastSerialNumber = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.lastSerialNumber = options.longs === String ? "0" : 0;
                object.pageSize = 0;
            }
            if (message.lastSerialNumber != null && message.hasOwnProperty("lastSerialNumber"))
                if (typeof message.lastSerialNumber === "number")
                    object.lastSerialNumber = options.longs === String ? String(message.lastSerialNumber) : message.lastSerialNumber;
                else
                    object.lastSerialNumber = options.longs === String ? $util.Long.prototype.toString.call(message.lastSerialNumber) : options.longs === Number ? new $util.LongBits(message.lastSerialNumber.low >>> 0, message.lastSerialNumber.high >>> 0).toNumber(true) : message.lastSerialNumber;
            if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                object.pageSize = message.pageSize;
            return object;
        };

        /**
         * Converts this pageTokenListUser to JSON.
         * @function toJSON
         * @memberof response.pageTokenListUser
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        pageTokenListUser.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for pageTokenListUser
         * @function getTypeUrl
         * @memberof response.pageTokenListUser
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        pageTokenListUser.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.pageTokenListUser";
        };

        return pageTokenListUser;
    })();

    response.ListUsers = (function() {

        /**
         * Properties of a ListUsers.
         * @memberof response
         * @interface IListUsers
         * @property {response.Status|null} [status] ListUsers status
         * @property {string|null} [message] ListUsers message
         * @property {Array.<response.IUserMetaForList>|null} [users] ListUsers users
         * @property {Uint8Array|null} [pageTokenListUser] ListUsers pageTokenListUser
         */

        /**
         * Constructs a new ListUsers.
         * @memberof response
         * @classdesc Represents a ListUsers.
         * @implements IListUsers
         * @constructor
         * @param {response.IListUsers=} [properties] Properties to set
         */
        function ListUsers(properties) {
            this.users = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListUsers status.
         * @member {response.Status} status
         * @memberof response.ListUsers
         * @instance
         */
        ListUsers.prototype.status = 0;

        /**
         * ListUsers message.
         * @member {string|null|undefined} message
         * @memberof response.ListUsers
         * @instance
         */
        ListUsers.prototype.message = null;

        /**
         * ListUsers users.
         * @member {Array.<response.IUserMetaForList>} users
         * @memberof response.ListUsers
         * @instance
         */
        ListUsers.prototype.users = $util.emptyArray;

        /**
         * ListUsers pageTokenListUser.
         * @member {Uint8Array|null|undefined} pageTokenListUser
         * @memberof response.ListUsers
         * @instance
         */
        ListUsers.prototype.pageTokenListUser = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(ListUsers.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(ListUsers.prototype, "_pageTokenListUser", {
            get: $util.oneOfGetter($oneOfFields = ["pageTokenListUser"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new ListUsers instance using the specified properties.
         * @function create
         * @memberof response.ListUsers
         * @static
         * @param {response.IListUsers=} [properties] Properties to set
         * @returns {response.ListUsers} ListUsers instance
         */
        ListUsers.create = function create(properties) {
            return new ListUsers(properties);
        };

        /**
         * Encodes the specified ListUsers message. Does not implicitly {@link response.ListUsers.verify|verify} messages.
         * @function encode
         * @memberof response.ListUsers
         * @static
         * @param {response.IListUsers} message ListUsers message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListUsers.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            if (message.users != null && message.users.length)
                for (let i = 0; i < message.users.length; ++i)
                    $root.response.UserMetaForList.encode(message.users[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.pageTokenListUser != null && Object.hasOwnProperty.call(message, "pageTokenListUser"))
                writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.pageTokenListUser);
            return writer;
        };

        /**
         * Encodes the specified ListUsers message, length delimited. Does not implicitly {@link response.ListUsers.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.ListUsers
         * @static
         * @param {response.IListUsers} message ListUsers message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListUsers.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ListUsers message from the specified reader or buffer.
         * @function decode
         * @memberof response.ListUsers
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.ListUsers} ListUsers
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListUsers.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.ListUsers();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                case 3: {
                        if (!(message.users && message.users.length))
                            message.users = [];
                        message.users.push($root.response.UserMetaForList.decode(reader, reader.uint32()));
                        break;
                    }
                case 4: {
                        message.pageTokenListUser = reader.bytes();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ListUsers message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.ListUsers
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.ListUsers} ListUsers
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListUsers.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ListUsers message.
         * @function verify
         * @memberof response.ListUsers
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ListUsers.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            if (message.users != null && message.hasOwnProperty("users")) {
                if (!Array.isArray(message.users))
                    return "users: array expected";
                for (let i = 0; i < message.users.length; ++i) {
                    let error = $root.response.UserMetaForList.verify(message.users[i]);
                    if (error)
                        return "users." + error;
                }
            }
            if (message.pageTokenListUser != null && message.hasOwnProperty("pageTokenListUser")) {
                properties._pageTokenListUser = 1;
                if (!(message.pageTokenListUser && typeof message.pageTokenListUser.length === "number" || $util.isString(message.pageTokenListUser)))
                    return "pageTokenListUser: buffer expected";
            }
            return null;
        };

        /**
         * Creates a ListUsers message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.ListUsers
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.ListUsers} ListUsers
         */
        ListUsers.fromObject = function fromObject(object) {
            if (object instanceof $root.response.ListUsers)
                return object;
            let message = new $root.response.ListUsers();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            if (object.users) {
                if (!Array.isArray(object.users))
                    throw TypeError(".response.ListUsers.users: array expected");
                message.users = [];
                for (let i = 0; i < object.users.length; ++i) {
                    if (typeof object.users[i] !== "object")
                        throw TypeError(".response.ListUsers.users: object expected");
                    message.users[i] = $root.response.UserMetaForList.fromObject(object.users[i]);
                }
            }
            if (object.pageTokenListUser != null)
                if (typeof object.pageTokenListUser === "string")
                    $util.base64.decode(object.pageTokenListUser, message.pageTokenListUser = $util.newBuffer($util.base64.length(object.pageTokenListUser)), 0);
                else if (object.pageTokenListUser.length >= 0)
                    message.pageTokenListUser = object.pageTokenListUser;
            return message;
        };

        /**
         * Creates a plain object from a ListUsers message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.ListUsers
         * @static
         * @param {response.ListUsers} message ListUsers
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListUsers.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.users = [];
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            if (message.users && message.users.length) {
                object.users = [];
                for (let j = 0; j < message.users.length; ++j)
                    object.users[j] = $root.response.UserMetaForList.toObject(message.users[j], options);
            }
            if (message.pageTokenListUser != null && message.hasOwnProperty("pageTokenListUser")) {
                object.pageTokenListUser = options.bytes === String ? $util.base64.encode(message.pageTokenListUser, 0, message.pageTokenListUser.length) : options.bytes === Array ? Array.prototype.slice.call(message.pageTokenListUser) : message.pageTokenListUser;
                if (options.oneofs)
                    object._pageTokenListUser = "pageTokenListUser";
            }
            return object;
        };

        /**
         * Converts this ListUsers to JSON.
         * @function toJSON
         * @memberof response.ListUsers
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListUsers.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ListUsers
         * @function getTypeUrl
         * @memberof response.ListUsers
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ListUsers.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.ListUsers";
        };

        return ListUsers;
    })();

    response.RestartPutChunk = (function() {

        /**
         * Properties of a RestartPutChunk.
         * @memberof response
         * @interface IRestartPutChunk
         * @property {response.Status|null} [status] RestartPutChunk status
         * @property {string|null} [message] RestartPutChunk message
         */

        /**
         * Constructs a new RestartPutChunk.
         * @memberof response
         * @classdesc Represents a RestartPutChunk.
         * @implements IRestartPutChunk
         * @constructor
         * @param {response.IRestartPutChunk=} [properties] Properties to set
         */
        function RestartPutChunk(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RestartPutChunk status.
         * @member {response.Status} status
         * @memberof response.RestartPutChunk
         * @instance
         */
        RestartPutChunk.prototype.status = 0;

        /**
         * RestartPutChunk message.
         * @member {string} message
         * @memberof response.RestartPutChunk
         * @instance
         */
        RestartPutChunk.prototype.message = "";

        /**
         * Creates a new RestartPutChunk instance using the specified properties.
         * @function create
         * @memberof response.RestartPutChunk
         * @static
         * @param {response.IRestartPutChunk=} [properties] Properties to set
         * @returns {response.RestartPutChunk} RestartPutChunk instance
         */
        RestartPutChunk.create = function create(properties) {
            return new RestartPutChunk(properties);
        };

        /**
         * Encodes the specified RestartPutChunk message. Does not implicitly {@link response.RestartPutChunk.verify|verify} messages.
         * @function encode
         * @memberof response.RestartPutChunk
         * @static
         * @param {response.IRestartPutChunk} message RestartPutChunk message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RestartPutChunk.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified RestartPutChunk message, length delimited. Does not implicitly {@link response.RestartPutChunk.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.RestartPutChunk
         * @static
         * @param {response.IRestartPutChunk} message RestartPutChunk message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RestartPutChunk.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RestartPutChunk message from the specified reader or buffer.
         * @function decode
         * @memberof response.RestartPutChunk
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.RestartPutChunk} RestartPutChunk
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RestartPutChunk.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.RestartPutChunk();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RestartPutChunk message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.RestartPutChunk
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.RestartPutChunk} RestartPutChunk
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RestartPutChunk.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RestartPutChunk message.
         * @function verify
         * @memberof response.RestartPutChunk
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RestartPutChunk.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message"))
                if (!$util.isString(message.message))
                    return "message: string expected";
            return null;
        };

        /**
         * Creates a RestartPutChunk message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.RestartPutChunk
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.RestartPutChunk} RestartPutChunk
         */
        RestartPutChunk.fromObject = function fromObject(object) {
            if (object instanceof $root.response.RestartPutChunk)
                return object;
            let message = new $root.response.RestartPutChunk();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a RestartPutChunk message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.RestartPutChunk
         * @static
         * @param {response.RestartPutChunk} message RestartPutChunk
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RestartPutChunk.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.status = options.enums === String ? "SUCCESS" : 0;
                object.message = "";
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message"))
                object.message = message.message;
            return object;
        };

        /**
         * Converts this RestartPutChunk to JSON.
         * @function toJSON
         * @memberof response.RestartPutChunk
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RestartPutChunk.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for RestartPutChunk
         * @function getTypeUrl
         * @memberof response.RestartPutChunk
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        RestartPutChunk.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.RestartPutChunk";
        };

        return RestartPutChunk;
    })();

    response.GetPolicyFromName = (function() {

        /**
         * Properties of a GetPolicyFromName.
         * @memberof response
         * @interface IGetPolicyFromName
         * @property {response.Status|null} [status] GetPolicyFromName status
         * @property {Uint8Array|null} [data] GetPolicyFromName data
         */

        /**
         * Constructs a new GetPolicyFromName.
         * @memberof response
         * @classdesc Represents a GetPolicyFromName.
         * @implements IGetPolicyFromName
         * @constructor
         * @param {response.IGetPolicyFromName=} [properties] Properties to set
         */
        function GetPolicyFromName(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetPolicyFromName status.
         * @member {response.Status} status
         * @memberof response.GetPolicyFromName
         * @instance
         */
        GetPolicyFromName.prototype.status = 0;

        /**
         * GetPolicyFromName data.
         * @member {Uint8Array} data
         * @memberof response.GetPolicyFromName
         * @instance
         */
        GetPolicyFromName.prototype.data = $util.newBuffer([]);

        /**
         * Creates a new GetPolicyFromName instance using the specified properties.
         * @function create
         * @memberof response.GetPolicyFromName
         * @static
         * @param {response.IGetPolicyFromName=} [properties] Properties to set
         * @returns {response.GetPolicyFromName} GetPolicyFromName instance
         */
        GetPolicyFromName.create = function create(properties) {
            return new GetPolicyFromName(properties);
        };

        /**
         * Encodes the specified GetPolicyFromName message. Does not implicitly {@link response.GetPolicyFromName.verify|verify} messages.
         * @function encode
         * @memberof response.GetPolicyFromName
         * @static
         * @param {response.IGetPolicyFromName} message GetPolicyFromName message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetPolicyFromName.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.data);
            return writer;
        };

        /**
         * Encodes the specified GetPolicyFromName message, length delimited. Does not implicitly {@link response.GetPolicyFromName.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.GetPolicyFromName
         * @static
         * @param {response.IGetPolicyFromName} message GetPolicyFromName message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetPolicyFromName.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetPolicyFromName message from the specified reader or buffer.
         * @function decode
         * @memberof response.GetPolicyFromName
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.GetPolicyFromName} GetPolicyFromName
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetPolicyFromName.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.GetPolicyFromName();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.data = reader.bytes();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetPolicyFromName message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.GetPolicyFromName
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.GetPolicyFromName} GetPolicyFromName
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetPolicyFromName.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetPolicyFromName message.
         * @function verify
         * @memberof response.GetPolicyFromName
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetPolicyFromName.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            return null;
        };

        /**
         * Creates a GetPolicyFromName message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.GetPolicyFromName
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.GetPolicyFromName} GetPolicyFromName
         */
        GetPolicyFromName.fromObject = function fromObject(object) {
            if (object instanceof $root.response.GetPolicyFromName)
                return object;
            let message = new $root.response.GetPolicyFromName();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            return message;
        };

        /**
         * Creates a plain object from a GetPolicyFromName message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.GetPolicyFromName
         * @static
         * @param {response.GetPolicyFromName} message GetPolicyFromName
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetPolicyFromName.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.status = options.enums === String ? "SUCCESS" : 0;
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            return object;
        };

        /**
         * Converts this GetPolicyFromName to JSON.
         * @function toJSON
         * @memberof response.GetPolicyFromName
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetPolicyFromName.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetPolicyFromName
         * @function getTypeUrl
         * @memberof response.GetPolicyFromName
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetPolicyFromName.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.GetPolicyFromName";
        };

        return GetPolicyFromName;
    })();

    response.GetMetaFromSharedPath = (function() {

        /**
         * Properties of a GetMetaFromSharedPath.
         * @memberof response
         * @interface IGetMetaFromSharedPath
         * @property {response.Status|null} [status] GetMetaFromSharedPath status
         * @property {response.IMetaObj|null} [meta] GetMetaFromSharedPath meta
         * @property {string|null} [message] GetMetaFromSharedPath message
         */

        /**
         * Constructs a new GetMetaFromSharedPath.
         * @memberof response
         * @classdesc Represents a GetMetaFromSharedPath.
         * @implements IGetMetaFromSharedPath
         * @constructor
         * @param {response.IGetMetaFromSharedPath=} [properties] Properties to set
         */
        function GetMetaFromSharedPath(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetMetaFromSharedPath status.
         * @member {response.Status} status
         * @memberof response.GetMetaFromSharedPath
         * @instance
         */
        GetMetaFromSharedPath.prototype.status = 0;

        /**
         * GetMetaFromSharedPath meta.
         * @member {response.IMetaObj|null|undefined} meta
         * @memberof response.GetMetaFromSharedPath
         * @instance
         */
        GetMetaFromSharedPath.prototype.meta = null;

        /**
         * GetMetaFromSharedPath message.
         * @member {string|null|undefined} message
         * @memberof response.GetMetaFromSharedPath
         * @instance
         */
        GetMetaFromSharedPath.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(GetMetaFromSharedPath.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new GetMetaFromSharedPath instance using the specified properties.
         * @function create
         * @memberof response.GetMetaFromSharedPath
         * @static
         * @param {response.IGetMetaFromSharedPath=} [properties] Properties to set
         * @returns {response.GetMetaFromSharedPath} GetMetaFromSharedPath instance
         */
        GetMetaFromSharedPath.create = function create(properties) {
            return new GetMetaFromSharedPath(properties);
        };

        /**
         * Encodes the specified GetMetaFromSharedPath message. Does not implicitly {@link response.GetMetaFromSharedPath.verify|verify} messages.
         * @function encode
         * @memberof response.GetMetaFromSharedPath
         * @static
         * @param {response.IGetMetaFromSharedPath} message GetMetaFromSharedPath message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetMetaFromSharedPath.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.meta != null && Object.hasOwnProperty.call(message, "meta"))
                $root.response.MetaObj.encode(message.meta, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified GetMetaFromSharedPath message, length delimited. Does not implicitly {@link response.GetMetaFromSharedPath.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.GetMetaFromSharedPath
         * @static
         * @param {response.IGetMetaFromSharedPath} message GetMetaFromSharedPath message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetMetaFromSharedPath.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetMetaFromSharedPath message from the specified reader or buffer.
         * @function decode
         * @memberof response.GetMetaFromSharedPath
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.GetMetaFromSharedPath} GetMetaFromSharedPath
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetMetaFromSharedPath.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.GetMetaFromSharedPath();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.meta = $root.response.MetaObj.decode(reader, reader.uint32());
                        break;
                    }
                case 3: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetMetaFromSharedPath message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.GetMetaFromSharedPath
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.GetMetaFromSharedPath} GetMetaFromSharedPath
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetMetaFromSharedPath.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetMetaFromSharedPath message.
         * @function verify
         * @memberof response.GetMetaFromSharedPath
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetMetaFromSharedPath.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.meta != null && message.hasOwnProperty("meta")) {
                let error = $root.response.MetaObj.verify(message.meta);
                if (error)
                    return "meta." + error;
            }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a GetMetaFromSharedPath message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.GetMetaFromSharedPath
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.GetMetaFromSharedPath} GetMetaFromSharedPath
         */
        GetMetaFromSharedPath.fromObject = function fromObject(object) {
            if (object instanceof $root.response.GetMetaFromSharedPath)
                return object;
            let message = new $root.response.GetMetaFromSharedPath();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.meta != null) {
                if (typeof object.meta !== "object")
                    throw TypeError(".response.GetMetaFromSharedPath.meta: object expected");
                message.meta = $root.response.MetaObj.fromObject(object.meta);
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a GetMetaFromSharedPath message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.GetMetaFromSharedPath
         * @static
         * @param {response.GetMetaFromSharedPath} message GetMetaFromSharedPath
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetMetaFromSharedPath.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.status = options.enums === String ? "SUCCESS" : 0;
                object.meta = null;
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.meta != null && message.hasOwnProperty("meta"))
                object.meta = $root.response.MetaObj.toObject(message.meta, options);
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this GetMetaFromSharedPath to JSON.
         * @function toJSON
         * @memberof response.GetMetaFromSharedPath
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetMetaFromSharedPath.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetMetaFromSharedPath
         * @function getTypeUrl
         * @memberof response.GetMetaFromSharedPath
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetMetaFromSharedPath.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.GetMetaFromSharedPath";
        };

        return GetMetaFromSharedPath;
    })();

    response.ListQuestions = (function() {

        /**
         * Properties of a ListQuestions.
         * @memberof response
         * @interface IListQuestions
         * @property {response.Status|null} [status] ListQuestions status
         * @property {string|null} [question] ListQuestions question
         * @property {string|null} [message] ListQuestions message
         */

        /**
         * Constructs a new ListQuestions.
         * @memberof response
         * @classdesc Represents a ListQuestions.
         * @implements IListQuestions
         * @constructor
         * @param {response.IListQuestions=} [properties] Properties to set
         */
        function ListQuestions(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListQuestions status.
         * @member {response.Status} status
         * @memberof response.ListQuestions
         * @instance
         */
        ListQuestions.prototype.status = 0;

        /**
         * ListQuestions question.
         * @member {string} question
         * @memberof response.ListQuestions
         * @instance
         */
        ListQuestions.prototype.question = "";

        /**
         * ListQuestions message.
         * @member {string|null|undefined} message
         * @memberof response.ListQuestions
         * @instance
         */
        ListQuestions.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(ListQuestions.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new ListQuestions instance using the specified properties.
         * @function create
         * @memberof response.ListQuestions
         * @static
         * @param {response.IListQuestions=} [properties] Properties to set
         * @returns {response.ListQuestions} ListQuestions instance
         */
        ListQuestions.create = function create(properties) {
            return new ListQuestions(properties);
        };

        /**
         * Encodes the specified ListQuestions message. Does not implicitly {@link response.ListQuestions.verify|verify} messages.
         * @function encode
         * @memberof response.ListQuestions
         * @static
         * @param {response.IListQuestions} message ListQuestions message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListQuestions.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.question != null && Object.hasOwnProperty.call(message, "question"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.question);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified ListQuestions message, length delimited. Does not implicitly {@link response.ListQuestions.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.ListQuestions
         * @static
         * @param {response.IListQuestions} message ListQuestions message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListQuestions.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ListQuestions message from the specified reader or buffer.
         * @function decode
         * @memberof response.ListQuestions
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.ListQuestions} ListQuestions
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListQuestions.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.ListQuestions();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.question = reader.string();
                        break;
                    }
                case 3: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ListQuestions message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.ListQuestions
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.ListQuestions} ListQuestions
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListQuestions.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ListQuestions message.
         * @function verify
         * @memberof response.ListQuestions
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ListQuestions.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.question != null && message.hasOwnProperty("question"))
                if (!$util.isString(message.question))
                    return "question: string expected";
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a ListQuestions message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.ListQuestions
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.ListQuestions} ListQuestions
         */
        ListQuestions.fromObject = function fromObject(object) {
            if (object instanceof $root.response.ListQuestions)
                return object;
            let message = new $root.response.ListQuestions();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.question != null)
                message.question = String(object.question);
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a ListQuestions message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.ListQuestions
         * @static
         * @param {response.ListQuestions} message ListQuestions
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListQuestions.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.status = options.enums === String ? "SUCCESS" : 0;
                object.question = "";
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.question != null && message.hasOwnProperty("question"))
                object.question = message.question;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this ListQuestions to JSON.
         * @function toJSON
         * @memberof response.ListQuestions
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListQuestions.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ListQuestions
         * @function getTypeUrl
         * @memberof response.ListQuestions
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ListQuestions.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.ListQuestions";
        };

        return ListQuestions;
    })();

    response.VerifyUserForAudit = (function() {

        /**
         * Properties of a VerifyUserForAudit.
         * @memberof response
         * @interface IVerifyUserForAudit
         * @property {response.Status|null} [status] VerifyUserForAudit status
         * @property {string|null} [email] VerifyUserForAudit email
         * @property {Uint8Array|null} [organizationIdentifier] VerifyUserForAudit organizationIdentifier
         * @property {Uint8Array|null} [storageUuid] VerifyUserForAudit storageUuid
         * @property {string|null} [orgEmail] VerifyUserForAudit orgEmail
         * @property {Uint8Array|null} [storageData] VerifyUserForAudit storageData
         */

        /**
         * Constructs a new VerifyUserForAudit.
         * @memberof response
         * @classdesc Represents a VerifyUserForAudit.
         * @implements IVerifyUserForAudit
         * @constructor
         * @param {response.IVerifyUserForAudit=} [properties] Properties to set
         */
        function VerifyUserForAudit(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * VerifyUserForAudit status.
         * @member {response.Status} status
         * @memberof response.VerifyUserForAudit
         * @instance
         */
        VerifyUserForAudit.prototype.status = 0;

        /**
         * VerifyUserForAudit email.
         * @member {string} email
         * @memberof response.VerifyUserForAudit
         * @instance
         */
        VerifyUserForAudit.prototype.email = "";

        /**
         * VerifyUserForAudit organizationIdentifier.
         * @member {Uint8Array} organizationIdentifier
         * @memberof response.VerifyUserForAudit
         * @instance
         */
        VerifyUserForAudit.prototype.organizationIdentifier = $util.newBuffer([]);

        /**
         * VerifyUserForAudit storageUuid.
         * @member {Uint8Array|null|undefined} storageUuid
         * @memberof response.VerifyUserForAudit
         * @instance
         */
        VerifyUserForAudit.prototype.storageUuid = null;

        /**
         * VerifyUserForAudit orgEmail.
         * @member {string} orgEmail
         * @memberof response.VerifyUserForAudit
         * @instance
         */
        VerifyUserForAudit.prototype.orgEmail = "";

        /**
         * VerifyUserForAudit storageData.
         * @member {Uint8Array} storageData
         * @memberof response.VerifyUserForAudit
         * @instance
         */
        VerifyUserForAudit.prototype.storageData = $util.newBuffer([]);

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(VerifyUserForAudit.prototype, "_storageUuid", {
            get: $util.oneOfGetter($oneOfFields = ["storageUuid"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new VerifyUserForAudit instance using the specified properties.
         * @function create
         * @memberof response.VerifyUserForAudit
         * @static
         * @param {response.IVerifyUserForAudit=} [properties] Properties to set
         * @returns {response.VerifyUserForAudit} VerifyUserForAudit instance
         */
        VerifyUserForAudit.create = function create(properties) {
            return new VerifyUserForAudit(properties);
        };

        /**
         * Encodes the specified VerifyUserForAudit message. Does not implicitly {@link response.VerifyUserForAudit.verify|verify} messages.
         * @function encode
         * @memberof response.VerifyUserForAudit
         * @static
         * @param {response.IVerifyUserForAudit} message VerifyUserForAudit message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        VerifyUserForAudit.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.orgEmail != null && Object.hasOwnProperty.call(message, "orgEmail"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.orgEmail);
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.email);
            if (message.organizationIdentifier != null && Object.hasOwnProperty.call(message, "organizationIdentifier"))
                writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.organizationIdentifier);
            if (message.storageUuid != null && Object.hasOwnProperty.call(message, "storageUuid"))
                writer.uint32(/* id 5, wireType 2 =*/42).bytes(message.storageUuid);
            if (message.storageData != null && Object.hasOwnProperty.call(message, "storageData"))
                writer.uint32(/* id 6, wireType 2 =*/50).bytes(message.storageData);
            return writer;
        };

        /**
         * Encodes the specified VerifyUserForAudit message, length delimited. Does not implicitly {@link response.VerifyUserForAudit.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.VerifyUserForAudit
         * @static
         * @param {response.IVerifyUserForAudit} message VerifyUserForAudit message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        VerifyUserForAudit.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a VerifyUserForAudit message from the specified reader or buffer.
         * @function decode
         * @memberof response.VerifyUserForAudit
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.VerifyUserForAudit} VerifyUserForAudit
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        VerifyUserForAudit.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.VerifyUserForAudit();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 3: {
                        message.email = reader.string();
                        break;
                    }
                case 4: {
                        message.organizationIdentifier = reader.bytes();
                        break;
                    }
                case 5: {
                        message.storageUuid = reader.bytes();
                        break;
                    }
                case 2: {
                        message.orgEmail = reader.string();
                        break;
                    }
                case 6: {
                        message.storageData = reader.bytes();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a VerifyUserForAudit message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.VerifyUserForAudit
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.VerifyUserForAudit} VerifyUserForAudit
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        VerifyUserForAudit.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a VerifyUserForAudit message.
         * @function verify
         * @memberof response.VerifyUserForAudit
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        VerifyUserForAudit.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            if (message.organizationIdentifier != null && message.hasOwnProperty("organizationIdentifier"))
                if (!(message.organizationIdentifier && typeof message.organizationIdentifier.length === "number" || $util.isString(message.organizationIdentifier)))
                    return "organizationIdentifier: buffer expected";
            if (message.storageUuid != null && message.hasOwnProperty("storageUuid")) {
                properties._storageUuid = 1;
                if (!(message.storageUuid && typeof message.storageUuid.length === "number" || $util.isString(message.storageUuid)))
                    return "storageUuid: buffer expected";
            }
            if (message.orgEmail != null && message.hasOwnProperty("orgEmail"))
                if (!$util.isString(message.orgEmail))
                    return "orgEmail: string expected";
            if (message.storageData != null && message.hasOwnProperty("storageData"))
                if (!(message.storageData && typeof message.storageData.length === "number" || $util.isString(message.storageData)))
                    return "storageData: buffer expected";
            return null;
        };

        /**
         * Creates a VerifyUserForAudit message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.VerifyUserForAudit
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.VerifyUserForAudit} VerifyUserForAudit
         */
        VerifyUserForAudit.fromObject = function fromObject(object) {
            if (object instanceof $root.response.VerifyUserForAudit)
                return object;
            let message = new $root.response.VerifyUserForAudit();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.email != null)
                message.email = String(object.email);
            if (object.organizationIdentifier != null)
                if (typeof object.organizationIdentifier === "string")
                    $util.base64.decode(object.organizationIdentifier, message.organizationIdentifier = $util.newBuffer($util.base64.length(object.organizationIdentifier)), 0);
                else if (object.organizationIdentifier.length >= 0)
                    message.organizationIdentifier = object.organizationIdentifier;
            if (object.storageUuid != null)
                if (typeof object.storageUuid === "string")
                    $util.base64.decode(object.storageUuid, message.storageUuid = $util.newBuffer($util.base64.length(object.storageUuid)), 0);
                else if (object.storageUuid.length >= 0)
                    message.storageUuid = object.storageUuid;
            if (object.orgEmail != null)
                message.orgEmail = String(object.orgEmail);
            if (object.storageData != null)
                if (typeof object.storageData === "string")
                    $util.base64.decode(object.storageData, message.storageData = $util.newBuffer($util.base64.length(object.storageData)), 0);
                else if (object.storageData.length >= 0)
                    message.storageData = object.storageData;
            return message;
        };

        /**
         * Creates a plain object from a VerifyUserForAudit message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.VerifyUserForAudit
         * @static
         * @param {response.VerifyUserForAudit} message VerifyUserForAudit
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        VerifyUserForAudit.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.status = options.enums === String ? "SUCCESS" : 0;
                object.orgEmail = "";
                object.email = "";
                if (options.bytes === String)
                    object.organizationIdentifier = "";
                else {
                    object.organizationIdentifier = [];
                    if (options.bytes !== Array)
                        object.organizationIdentifier = $util.newBuffer(object.organizationIdentifier);
                }
                if (options.bytes === String)
                    object.storageData = "";
                else {
                    object.storageData = [];
                    if (options.bytes !== Array)
                        object.storageData = $util.newBuffer(object.storageData);
                }
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.orgEmail != null && message.hasOwnProperty("orgEmail"))
                object.orgEmail = message.orgEmail;
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.organizationIdentifier != null && message.hasOwnProperty("organizationIdentifier"))
                object.organizationIdentifier = options.bytes === String ? $util.base64.encode(message.organizationIdentifier, 0, message.organizationIdentifier.length) : options.bytes === Array ? Array.prototype.slice.call(message.organizationIdentifier) : message.organizationIdentifier;
            if (message.storageUuid != null && message.hasOwnProperty("storageUuid")) {
                object.storageUuid = options.bytes === String ? $util.base64.encode(message.storageUuid, 0, message.storageUuid.length) : options.bytes === Array ? Array.prototype.slice.call(message.storageUuid) : message.storageUuid;
                if (options.oneofs)
                    object._storageUuid = "storageUuid";
            }
            if (message.storageData != null && message.hasOwnProperty("storageData"))
                object.storageData = options.bytes === String ? $util.base64.encode(message.storageData, 0, message.storageData.length) : options.bytes === Array ? Array.prototype.slice.call(message.storageData) : message.storageData;
            return object;
        };

        /**
         * Converts this VerifyUserForAudit to JSON.
         * @function toJSON
         * @memberof response.VerifyUserForAudit
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        VerifyUserForAudit.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for VerifyUserForAudit
         * @function getTypeUrl
         * @memberof response.VerifyUserForAudit
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        VerifyUserForAudit.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.VerifyUserForAudit";
        };

        return VerifyUserForAudit;
    })();

    response.GetAwsS3 = (function() {

        /**
         * Properties of a GetAwsS3.
         * @memberof response
         * @interface IGetAwsS3
         */

        /**
         * Constructs a new GetAwsS3.
         * @memberof response
         * @classdesc Represents a GetAwsS3.
         * @implements IGetAwsS3
         * @constructor
         * @param {response.IGetAwsS3=} [properties] Properties to set
         */
        function GetAwsS3(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new GetAwsS3 instance using the specified properties.
         * @function create
         * @memberof response.GetAwsS3
         * @static
         * @param {response.IGetAwsS3=} [properties] Properties to set
         * @returns {response.GetAwsS3} GetAwsS3 instance
         */
        GetAwsS3.create = function create(properties) {
            return new GetAwsS3(properties);
        };

        /**
         * Encodes the specified GetAwsS3 message. Does not implicitly {@link response.GetAwsS3.verify|verify} messages.
         * @function encode
         * @memberof response.GetAwsS3
         * @static
         * @param {response.IGetAwsS3} message GetAwsS3 message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetAwsS3.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified GetAwsS3 message, length delimited. Does not implicitly {@link response.GetAwsS3.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.GetAwsS3
         * @static
         * @param {response.IGetAwsS3} message GetAwsS3 message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetAwsS3.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetAwsS3 message from the specified reader or buffer.
         * @function decode
         * @memberof response.GetAwsS3
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.GetAwsS3} GetAwsS3
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetAwsS3.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.GetAwsS3();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetAwsS3 message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.GetAwsS3
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.GetAwsS3} GetAwsS3
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetAwsS3.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetAwsS3 message.
         * @function verify
         * @memberof response.GetAwsS3
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetAwsS3.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a GetAwsS3 message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.GetAwsS3
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.GetAwsS3} GetAwsS3
         */
        GetAwsS3.fromObject = function fromObject(object) {
            if (object instanceof $root.response.GetAwsS3)
                return object;
            return new $root.response.GetAwsS3();
        };

        /**
         * Creates a plain object from a GetAwsS3 message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.GetAwsS3
         * @static
         * @param {response.GetAwsS3} message GetAwsS3
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetAwsS3.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this GetAwsS3 to JSON.
         * @function toJSON
         * @memberof response.GetAwsS3
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetAwsS3.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetAwsS3
         * @function getTypeUrl
         * @memberof response.GetAwsS3
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetAwsS3.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.GetAwsS3";
        };

        return GetAwsS3;
    })();

    response.GetAzureBlob = (function() {

        /**
         * Properties of a GetAzureBlob.
         * @memberof response
         * @interface IGetAzureBlob
         * @property {string|null} [accountName] GetAzureBlob accountName
         */

        /**
         * Constructs a new GetAzureBlob.
         * @memberof response
         * @classdesc Represents a GetAzureBlob.
         * @implements IGetAzureBlob
         * @constructor
         * @param {response.IGetAzureBlob=} [properties] Properties to set
         */
        function GetAzureBlob(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetAzureBlob accountName.
         * @member {string} accountName
         * @memberof response.GetAzureBlob
         * @instance
         */
        GetAzureBlob.prototype.accountName = "";

        /**
         * Creates a new GetAzureBlob instance using the specified properties.
         * @function create
         * @memberof response.GetAzureBlob
         * @static
         * @param {response.IGetAzureBlob=} [properties] Properties to set
         * @returns {response.GetAzureBlob} GetAzureBlob instance
         */
        GetAzureBlob.create = function create(properties) {
            return new GetAzureBlob(properties);
        };

        /**
         * Encodes the specified GetAzureBlob message. Does not implicitly {@link response.GetAzureBlob.verify|verify} messages.
         * @function encode
         * @memberof response.GetAzureBlob
         * @static
         * @param {response.IGetAzureBlob} message GetAzureBlob message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetAzureBlob.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.accountName != null && Object.hasOwnProperty.call(message, "accountName"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.accountName);
            return writer;
        };

        /**
         * Encodes the specified GetAzureBlob message, length delimited. Does not implicitly {@link response.GetAzureBlob.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.GetAzureBlob
         * @static
         * @param {response.IGetAzureBlob} message GetAzureBlob message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetAzureBlob.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetAzureBlob message from the specified reader or buffer.
         * @function decode
         * @memberof response.GetAzureBlob
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.GetAzureBlob} GetAzureBlob
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetAzureBlob.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.GetAzureBlob();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.accountName = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetAzureBlob message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.GetAzureBlob
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.GetAzureBlob} GetAzureBlob
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetAzureBlob.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetAzureBlob message.
         * @function verify
         * @memberof response.GetAzureBlob
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetAzureBlob.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.accountName != null && message.hasOwnProperty("accountName"))
                if (!$util.isString(message.accountName))
                    return "accountName: string expected";
            return null;
        };

        /**
         * Creates a GetAzureBlob message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.GetAzureBlob
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.GetAzureBlob} GetAzureBlob
         */
        GetAzureBlob.fromObject = function fromObject(object) {
            if (object instanceof $root.response.GetAzureBlob)
                return object;
            let message = new $root.response.GetAzureBlob();
            if (object.accountName != null)
                message.accountName = String(object.accountName);
            return message;
        };

        /**
         * Creates a plain object from a GetAzureBlob message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.GetAzureBlob
         * @static
         * @param {response.GetAzureBlob} message GetAzureBlob
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetAzureBlob.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.accountName = "";
            if (message.accountName != null && message.hasOwnProperty("accountName"))
                object.accountName = message.accountName;
            return object;
        };

        /**
         * Converts this GetAzureBlob to JSON.
         * @function toJSON
         * @memberof response.GetAzureBlob
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetAzureBlob.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetAzureBlob
         * @function getTypeUrl
         * @memberof response.GetAzureBlob
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetAzureBlob.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.GetAzureBlob";
        };

        return GetAzureBlob;
    })();

    response.GetMinio = (function() {

        /**
         * Properties of a GetMinio.
         * @memberof response
         * @interface IGetMinio
         */

        /**
         * Constructs a new GetMinio.
         * @memberof response
         * @classdesc Represents a GetMinio.
         * @implements IGetMinio
         * @constructor
         * @param {response.IGetMinio=} [properties] Properties to set
         */
        function GetMinio(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new GetMinio instance using the specified properties.
         * @function create
         * @memberof response.GetMinio
         * @static
         * @param {response.IGetMinio=} [properties] Properties to set
         * @returns {response.GetMinio} GetMinio instance
         */
        GetMinio.create = function create(properties) {
            return new GetMinio(properties);
        };

        /**
         * Encodes the specified GetMinio message. Does not implicitly {@link response.GetMinio.verify|verify} messages.
         * @function encode
         * @memberof response.GetMinio
         * @static
         * @param {response.IGetMinio} message GetMinio message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetMinio.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified GetMinio message, length delimited. Does not implicitly {@link response.GetMinio.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.GetMinio
         * @static
         * @param {response.IGetMinio} message GetMinio message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetMinio.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetMinio message from the specified reader or buffer.
         * @function decode
         * @memberof response.GetMinio
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.GetMinio} GetMinio
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetMinio.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.GetMinio();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetMinio message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.GetMinio
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.GetMinio} GetMinio
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetMinio.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetMinio message.
         * @function verify
         * @memberof response.GetMinio
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetMinio.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a GetMinio message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.GetMinio
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.GetMinio} GetMinio
         */
        GetMinio.fromObject = function fromObject(object) {
            if (object instanceof $root.response.GetMinio)
                return object;
            return new $root.response.GetMinio();
        };

        /**
         * Creates a plain object from a GetMinio message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.GetMinio
         * @static
         * @param {response.GetMinio} message GetMinio
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetMinio.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this GetMinio to JSON.
         * @function toJSON
         * @memberof response.GetMinio
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetMinio.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetMinio
         * @function getTypeUrl
         * @memberof response.GetMinio
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetMinio.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.GetMinio";
        };

        return GetMinio;
    })();

    response.StorageDetails = (function() {

        /**
         * Properties of a StorageDetails.
         * @memberof response
         * @interface IStorageDetails
         * @property {response.IGetAwsS3|null} [awsS3] StorageDetails awsS3
         * @property {response.IGetAzureBlob|null} [azureBlob] StorageDetails azureBlob
         * @property {response.IGetMinio|null} [minio] StorageDetails minio
         */

        /**
         * Constructs a new StorageDetails.
         * @memberof response
         * @classdesc Represents a StorageDetails.
         * @implements IStorageDetails
         * @constructor
         * @param {response.IStorageDetails=} [properties] Properties to set
         */
        function StorageDetails(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * StorageDetails awsS3.
         * @member {response.IGetAwsS3|null|undefined} awsS3
         * @memberof response.StorageDetails
         * @instance
         */
        StorageDetails.prototype.awsS3 = null;

        /**
         * StorageDetails azureBlob.
         * @member {response.IGetAzureBlob|null|undefined} azureBlob
         * @memberof response.StorageDetails
         * @instance
         */
        StorageDetails.prototype.azureBlob = null;

        /**
         * StorageDetails minio.
         * @member {response.IGetMinio|null|undefined} minio
         * @memberof response.StorageDetails
         * @instance
         */
        StorageDetails.prototype.minio = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * StorageDetails storage.
         * @member {"awsS3"|"azureBlob"|"minio"|undefined} storage
         * @memberof response.StorageDetails
         * @instance
         */
        Object.defineProperty(StorageDetails.prototype, "storage", {
            get: $util.oneOfGetter($oneOfFields = ["awsS3", "azureBlob", "minio"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new StorageDetails instance using the specified properties.
         * @function create
         * @memberof response.StorageDetails
         * @static
         * @param {response.IStorageDetails=} [properties] Properties to set
         * @returns {response.StorageDetails} StorageDetails instance
         */
        StorageDetails.create = function create(properties) {
            return new StorageDetails(properties);
        };

        /**
         * Encodes the specified StorageDetails message. Does not implicitly {@link response.StorageDetails.verify|verify} messages.
         * @function encode
         * @memberof response.StorageDetails
         * @static
         * @param {response.IStorageDetails} message StorageDetails message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StorageDetails.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.awsS3 != null && Object.hasOwnProperty.call(message, "awsS3"))
                $root.response.GetAwsS3.encode(message.awsS3, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.azureBlob != null && Object.hasOwnProperty.call(message, "azureBlob"))
                $root.response.GetAzureBlob.encode(message.azureBlob, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.minio != null && Object.hasOwnProperty.call(message, "minio"))
                $root.response.GetMinio.encode(message.minio, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified StorageDetails message, length delimited. Does not implicitly {@link response.StorageDetails.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.StorageDetails
         * @static
         * @param {response.IStorageDetails} message StorageDetails message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StorageDetails.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a StorageDetails message from the specified reader or buffer.
         * @function decode
         * @memberof response.StorageDetails
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.StorageDetails} StorageDetails
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StorageDetails.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.StorageDetails();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.awsS3 = $root.response.GetAwsS3.decode(reader, reader.uint32());
                        break;
                    }
                case 2: {
                        message.azureBlob = $root.response.GetAzureBlob.decode(reader, reader.uint32());
                        break;
                    }
                case 3: {
                        message.minio = $root.response.GetMinio.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a StorageDetails message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.StorageDetails
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.StorageDetails} StorageDetails
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StorageDetails.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a StorageDetails message.
         * @function verify
         * @memberof response.StorageDetails
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        StorageDetails.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.awsS3 != null && message.hasOwnProperty("awsS3")) {
                properties.storage = 1;
                {
                    let error = $root.response.GetAwsS3.verify(message.awsS3);
                    if (error)
                        return "awsS3." + error;
                }
            }
            if (message.azureBlob != null && message.hasOwnProperty("azureBlob")) {
                if (properties.storage === 1)
                    return "storage: multiple values";
                properties.storage = 1;
                {
                    let error = $root.response.GetAzureBlob.verify(message.azureBlob);
                    if (error)
                        return "azureBlob." + error;
                }
            }
            if (message.minio != null && message.hasOwnProperty("minio")) {
                if (properties.storage === 1)
                    return "storage: multiple values";
                properties.storage = 1;
                {
                    let error = $root.response.GetMinio.verify(message.minio);
                    if (error)
                        return "minio." + error;
                }
            }
            return null;
        };

        /**
         * Creates a StorageDetails message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.StorageDetails
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.StorageDetails} StorageDetails
         */
        StorageDetails.fromObject = function fromObject(object) {
            if (object instanceof $root.response.StorageDetails)
                return object;
            let message = new $root.response.StorageDetails();
            if (object.awsS3 != null) {
                if (typeof object.awsS3 !== "object")
                    throw TypeError(".response.StorageDetails.awsS3: object expected");
                message.awsS3 = $root.response.GetAwsS3.fromObject(object.awsS3);
            }
            if (object.azureBlob != null) {
                if (typeof object.azureBlob !== "object")
                    throw TypeError(".response.StorageDetails.azureBlob: object expected");
                message.azureBlob = $root.response.GetAzureBlob.fromObject(object.azureBlob);
            }
            if (object.minio != null) {
                if (typeof object.minio !== "object")
                    throw TypeError(".response.StorageDetails.minio: object expected");
                message.minio = $root.response.GetMinio.fromObject(object.minio);
            }
            return message;
        };

        /**
         * Creates a plain object from a StorageDetails message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.StorageDetails
         * @static
         * @param {response.StorageDetails} message StorageDetails
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        StorageDetails.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (message.awsS3 != null && message.hasOwnProperty("awsS3")) {
                object.awsS3 = $root.response.GetAwsS3.toObject(message.awsS3, options);
                if (options.oneofs)
                    object.storage = "awsS3";
            }
            if (message.azureBlob != null && message.hasOwnProperty("azureBlob")) {
                object.azureBlob = $root.response.GetAzureBlob.toObject(message.azureBlob, options);
                if (options.oneofs)
                    object.storage = "azureBlob";
            }
            if (message.minio != null && message.hasOwnProperty("minio")) {
                object.minio = $root.response.GetMinio.toObject(message.minio, options);
                if (options.oneofs)
                    object.storage = "minio";
            }
            return object;
        };

        /**
         * Converts this StorageDetails to JSON.
         * @function toJSON
         * @memberof response.StorageDetails
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        StorageDetails.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for StorageDetails
         * @function getTypeUrl
         * @memberof response.StorageDetails
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        StorageDetails.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.StorageDetails";
        };

        return StorageDetails;
    })();

    response.BYOSOperation = (function() {

        /**
         * Properties of a BYOSOperation.
         * @memberof response
         * @interface IBYOSOperation
         * @property {string|null} [operation] BYOSOperation operation
         * @property {boolean|null} [status] BYOSOperation status
         * @property {string|null} [message] BYOSOperation message
         */

        /**
         * Constructs a new BYOSOperation.
         * @memberof response
         * @classdesc Represents a BYOSOperation.
         * @implements IBYOSOperation
         * @constructor
         * @param {response.IBYOSOperation=} [properties] Properties to set
         */
        function BYOSOperation(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BYOSOperation operation.
         * @member {string} operation
         * @memberof response.BYOSOperation
         * @instance
         */
        BYOSOperation.prototype.operation = "";

        /**
         * BYOSOperation status.
         * @member {boolean} status
         * @memberof response.BYOSOperation
         * @instance
         */
        BYOSOperation.prototype.status = false;

        /**
         * BYOSOperation message.
         * @member {string} message
         * @memberof response.BYOSOperation
         * @instance
         */
        BYOSOperation.prototype.message = "";

        /**
         * Creates a new BYOSOperation instance using the specified properties.
         * @function create
         * @memberof response.BYOSOperation
         * @static
         * @param {response.IBYOSOperation=} [properties] Properties to set
         * @returns {response.BYOSOperation} BYOSOperation instance
         */
        BYOSOperation.create = function create(properties) {
            return new BYOSOperation(properties);
        };

        /**
         * Encodes the specified BYOSOperation message. Does not implicitly {@link response.BYOSOperation.verify|verify} messages.
         * @function encode
         * @memberof response.BYOSOperation
         * @static
         * @param {response.IBYOSOperation} message BYOSOperation message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BYOSOperation.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.operation != null && Object.hasOwnProperty.call(message, "operation"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.operation);
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 2, wireType 0 =*/16).bool(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified BYOSOperation message, length delimited. Does not implicitly {@link response.BYOSOperation.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.BYOSOperation
         * @static
         * @param {response.IBYOSOperation} message BYOSOperation message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BYOSOperation.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a BYOSOperation message from the specified reader or buffer.
         * @function decode
         * @memberof response.BYOSOperation
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.BYOSOperation} BYOSOperation
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BYOSOperation.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.BYOSOperation();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.operation = reader.string();
                        break;
                    }
                case 2: {
                        message.status = reader.bool();
                        break;
                    }
                case 3: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a BYOSOperation message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.BYOSOperation
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.BYOSOperation} BYOSOperation
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BYOSOperation.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a BYOSOperation message.
         * @function verify
         * @memberof response.BYOSOperation
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        BYOSOperation.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.operation != null && message.hasOwnProperty("operation"))
                if (!$util.isString(message.operation))
                    return "operation: string expected";
            if (message.status != null && message.hasOwnProperty("status"))
                if (typeof message.status !== "boolean")
                    return "status: boolean expected";
            if (message.message != null && message.hasOwnProperty("message"))
                if (!$util.isString(message.message))
                    return "message: string expected";
            return null;
        };

        /**
         * Creates a BYOSOperation message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.BYOSOperation
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.BYOSOperation} BYOSOperation
         */
        BYOSOperation.fromObject = function fromObject(object) {
            if (object instanceof $root.response.BYOSOperation)
                return object;
            let message = new $root.response.BYOSOperation();
            if (object.operation != null)
                message.operation = String(object.operation);
            if (object.status != null)
                message.status = Boolean(object.status);
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a BYOSOperation message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.BYOSOperation
         * @static
         * @param {response.BYOSOperation} message BYOSOperation
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BYOSOperation.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.operation = "";
                object.status = false;
                object.message = "";
            }
            if (message.operation != null && message.hasOwnProperty("operation"))
                object.operation = message.operation;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = message.status;
            if (message.message != null && message.hasOwnProperty("message"))
                object.message = message.message;
            return object;
        };

        /**
         * Converts this BYOSOperation to JSON.
         * @function toJSON
         * @memberof response.BYOSOperation
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BYOSOperation.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for BYOSOperation
         * @function getTypeUrl
         * @memberof response.BYOSOperation
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        BYOSOperation.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.BYOSOperation";
        };

        return BYOSOperation;
    })();

    response.VerifyBYOSCreds = (function() {

        /**
         * Properties of a VerifyBYOSCreds.
         * @memberof response
         * @interface IVerifyBYOSCreds
         * @property {response.Status|null} [status] VerifyBYOSCreds status
         * @property {Array.<response.IBYOSOperation>|null} [byosOperation] VerifyBYOSCreds byosOperation
         * @property {string|null} [message] VerifyBYOSCreds message
         */

        /**
         * Constructs a new VerifyBYOSCreds.
         * @memberof response
         * @classdesc Represents a VerifyBYOSCreds.
         * @implements IVerifyBYOSCreds
         * @constructor
         * @param {response.IVerifyBYOSCreds=} [properties] Properties to set
         */
        function VerifyBYOSCreds(properties) {
            this.byosOperation = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * VerifyBYOSCreds status.
         * @member {response.Status} status
         * @memberof response.VerifyBYOSCreds
         * @instance
         */
        VerifyBYOSCreds.prototype.status = 0;

        /**
         * VerifyBYOSCreds byosOperation.
         * @member {Array.<response.IBYOSOperation>} byosOperation
         * @memberof response.VerifyBYOSCreds
         * @instance
         */
        VerifyBYOSCreds.prototype.byosOperation = $util.emptyArray;

        /**
         * VerifyBYOSCreds message.
         * @member {string|null|undefined} message
         * @memberof response.VerifyBYOSCreds
         * @instance
         */
        VerifyBYOSCreds.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(VerifyBYOSCreds.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new VerifyBYOSCreds instance using the specified properties.
         * @function create
         * @memberof response.VerifyBYOSCreds
         * @static
         * @param {response.IVerifyBYOSCreds=} [properties] Properties to set
         * @returns {response.VerifyBYOSCreds} VerifyBYOSCreds instance
         */
        VerifyBYOSCreds.create = function create(properties) {
            return new VerifyBYOSCreds(properties);
        };

        /**
         * Encodes the specified VerifyBYOSCreds message. Does not implicitly {@link response.VerifyBYOSCreds.verify|verify} messages.
         * @function encode
         * @memberof response.VerifyBYOSCreds
         * @static
         * @param {response.IVerifyBYOSCreds} message VerifyBYOSCreds message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        VerifyBYOSCreds.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.byosOperation != null && message.byosOperation.length)
                for (let i = 0; i < message.byosOperation.length; ++i)
                    $root.response.BYOSOperation.encode(message.byosOperation[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified VerifyBYOSCreds message, length delimited. Does not implicitly {@link response.VerifyBYOSCreds.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.VerifyBYOSCreds
         * @static
         * @param {response.IVerifyBYOSCreds} message VerifyBYOSCreds message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        VerifyBYOSCreds.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a VerifyBYOSCreds message from the specified reader or buffer.
         * @function decode
         * @memberof response.VerifyBYOSCreds
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.VerifyBYOSCreds} VerifyBYOSCreds
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        VerifyBYOSCreds.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.VerifyBYOSCreds();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        if (!(message.byosOperation && message.byosOperation.length))
                            message.byosOperation = [];
                        message.byosOperation.push($root.response.BYOSOperation.decode(reader, reader.uint32()));
                        break;
                    }
                case 3: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a VerifyBYOSCreds message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.VerifyBYOSCreds
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.VerifyBYOSCreds} VerifyBYOSCreds
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        VerifyBYOSCreds.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a VerifyBYOSCreds message.
         * @function verify
         * @memberof response.VerifyBYOSCreds
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        VerifyBYOSCreds.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.byosOperation != null && message.hasOwnProperty("byosOperation")) {
                if (!Array.isArray(message.byosOperation))
                    return "byosOperation: array expected";
                for (let i = 0; i < message.byosOperation.length; ++i) {
                    let error = $root.response.BYOSOperation.verify(message.byosOperation[i]);
                    if (error)
                        return "byosOperation." + error;
                }
            }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a VerifyBYOSCreds message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.VerifyBYOSCreds
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.VerifyBYOSCreds} VerifyBYOSCreds
         */
        VerifyBYOSCreds.fromObject = function fromObject(object) {
            if (object instanceof $root.response.VerifyBYOSCreds)
                return object;
            let message = new $root.response.VerifyBYOSCreds();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.byosOperation) {
                if (!Array.isArray(object.byosOperation))
                    throw TypeError(".response.VerifyBYOSCreds.byosOperation: array expected");
                message.byosOperation = [];
                for (let i = 0; i < object.byosOperation.length; ++i) {
                    if (typeof object.byosOperation[i] !== "object")
                        throw TypeError(".response.VerifyBYOSCreds.byosOperation: object expected");
                    message.byosOperation[i] = $root.response.BYOSOperation.fromObject(object.byosOperation[i]);
                }
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a VerifyBYOSCreds message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.VerifyBYOSCreds
         * @static
         * @param {response.VerifyBYOSCreds} message VerifyBYOSCreds
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        VerifyBYOSCreds.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.byosOperation = [];
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.byosOperation && message.byosOperation.length) {
                object.byosOperation = [];
                for (let j = 0; j < message.byosOperation.length; ++j)
                    object.byosOperation[j] = $root.response.BYOSOperation.toObject(message.byosOperation[j], options);
            }
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this VerifyBYOSCreds to JSON.
         * @function toJSON
         * @memberof response.VerifyBYOSCreds
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        VerifyBYOSCreds.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for VerifyBYOSCreds
         * @function getTypeUrl
         * @memberof response.VerifyBYOSCreds
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        VerifyBYOSCreds.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.VerifyBYOSCreds";
        };

        return VerifyBYOSCreds;
    })();

    response.MigrateToStorage = (function() {

        /**
         * Properties of a MigrateToStorage.
         * @memberof response
         * @interface IMigrateToStorage
         * @property {response.Status|null} [status] MigrateToStorage status
         * @property {string|null} [message] MigrateToStorage message
         */

        /**
         * Constructs a new MigrateToStorage.
         * @memberof response
         * @classdesc Represents a MigrateToStorage.
         * @implements IMigrateToStorage
         * @constructor
         * @param {response.IMigrateToStorage=} [properties] Properties to set
         */
        function MigrateToStorage(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MigrateToStorage status.
         * @member {response.Status} status
         * @memberof response.MigrateToStorage
         * @instance
         */
        MigrateToStorage.prototype.status = 0;

        /**
         * MigrateToStorage message.
         * @member {string|null|undefined} message
         * @memberof response.MigrateToStorage
         * @instance
         */
        MigrateToStorage.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(MigrateToStorage.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new MigrateToStorage instance using the specified properties.
         * @function create
         * @memberof response.MigrateToStorage
         * @static
         * @param {response.IMigrateToStorage=} [properties] Properties to set
         * @returns {response.MigrateToStorage} MigrateToStorage instance
         */
        MigrateToStorage.create = function create(properties) {
            return new MigrateToStorage(properties);
        };

        /**
         * Encodes the specified MigrateToStorage message. Does not implicitly {@link response.MigrateToStorage.verify|verify} messages.
         * @function encode
         * @memberof response.MigrateToStorage
         * @static
         * @param {response.IMigrateToStorage} message MigrateToStorage message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MigrateToStorage.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified MigrateToStorage message, length delimited. Does not implicitly {@link response.MigrateToStorage.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.MigrateToStorage
         * @static
         * @param {response.IMigrateToStorage} message MigrateToStorage message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MigrateToStorage.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MigrateToStorage message from the specified reader or buffer.
         * @function decode
         * @memberof response.MigrateToStorage
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.MigrateToStorage} MigrateToStorage
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MigrateToStorage.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.MigrateToStorage();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MigrateToStorage message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.MigrateToStorage
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.MigrateToStorage} MigrateToStorage
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MigrateToStorage.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MigrateToStorage message.
         * @function verify
         * @memberof response.MigrateToStorage
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MigrateToStorage.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a MigrateToStorage message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.MigrateToStorage
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.MigrateToStorage} MigrateToStorage
         */
        MigrateToStorage.fromObject = function fromObject(object) {
            if (object instanceof $root.response.MigrateToStorage)
                return object;
            let message = new $root.response.MigrateToStorage();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a MigrateToStorage message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.MigrateToStorage
         * @static
         * @param {response.MigrateToStorage} message MigrateToStorage
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MigrateToStorage.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this MigrateToStorage to JSON.
         * @function toJSON
         * @memberof response.MigrateToStorage
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MigrateToStorage.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for MigrateToStorage
         * @function getTypeUrl
         * @memberof response.MigrateToStorage
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        MigrateToStorage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.MigrateToStorage";
        };

        return MigrateToStorage;
    })();

    response.UpdateStorageCreds = (function() {

        /**
         * Properties of an UpdateStorageCreds.
         * @memberof response
         * @interface IUpdateStorageCreds
         * @property {response.Status|null} [status] UpdateStorageCreds status
         * @property {string|null} [message] UpdateStorageCreds message
         */

        /**
         * Constructs a new UpdateStorageCreds.
         * @memberof response
         * @classdesc Represents an UpdateStorageCreds.
         * @implements IUpdateStorageCreds
         * @constructor
         * @param {response.IUpdateStorageCreds=} [properties] Properties to set
         */
        function UpdateStorageCreds(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateStorageCreds status.
         * @member {response.Status} status
         * @memberof response.UpdateStorageCreds
         * @instance
         */
        UpdateStorageCreds.prototype.status = 0;

        /**
         * UpdateStorageCreds message.
         * @member {string|null|undefined} message
         * @memberof response.UpdateStorageCreds
         * @instance
         */
        UpdateStorageCreds.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(UpdateStorageCreds.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new UpdateStorageCreds instance using the specified properties.
         * @function create
         * @memberof response.UpdateStorageCreds
         * @static
         * @param {response.IUpdateStorageCreds=} [properties] Properties to set
         * @returns {response.UpdateStorageCreds} UpdateStorageCreds instance
         */
        UpdateStorageCreds.create = function create(properties) {
            return new UpdateStorageCreds(properties);
        };

        /**
         * Encodes the specified UpdateStorageCreds message. Does not implicitly {@link response.UpdateStorageCreds.verify|verify} messages.
         * @function encode
         * @memberof response.UpdateStorageCreds
         * @static
         * @param {response.IUpdateStorageCreds} message UpdateStorageCreds message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateStorageCreds.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified UpdateStorageCreds message, length delimited. Does not implicitly {@link response.UpdateStorageCreds.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.UpdateStorageCreds
         * @static
         * @param {response.IUpdateStorageCreds} message UpdateStorageCreds message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateStorageCreds.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UpdateStorageCreds message from the specified reader or buffer.
         * @function decode
         * @memberof response.UpdateStorageCreds
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.UpdateStorageCreds} UpdateStorageCreds
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateStorageCreds.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.UpdateStorageCreds();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UpdateStorageCreds message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.UpdateStorageCreds
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.UpdateStorageCreds} UpdateStorageCreds
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateStorageCreds.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UpdateStorageCreds message.
         * @function verify
         * @memberof response.UpdateStorageCreds
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UpdateStorageCreds.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates an UpdateStorageCreds message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.UpdateStorageCreds
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.UpdateStorageCreds} UpdateStorageCreds
         */
        UpdateStorageCreds.fromObject = function fromObject(object) {
            if (object instanceof $root.response.UpdateStorageCreds)
                return object;
            let message = new $root.response.UpdateStorageCreds();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from an UpdateStorageCreds message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.UpdateStorageCreds
         * @static
         * @param {response.UpdateStorageCreds} message UpdateStorageCreds
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateStorageCreds.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this UpdateStorageCreds to JSON.
         * @function toJSON
         * @memberof response.UpdateStorageCreds
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateStorageCreds.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for UpdateStorageCreds
         * @function getTypeUrl
         * @memberof response.UpdateStorageCreds
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        UpdateStorageCreds.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.UpdateStorageCreds";
        };

        return UpdateStorageCreds;
    })();

    response.GetStorageCreds = (function() {

        /**
         * Properties of a GetStorageCreds.
         * @memberof response
         * @interface IGetStorageCreds
         * @property {response.Status|null} [status] GetStorageCreds status
         * @property {string|null} [message] GetStorageCreds message
         * @property {response.IStorageDetails|null} [storageDetails] GetStorageCreds storageDetails
         */

        /**
         * Constructs a new GetStorageCreds.
         * @memberof response
         * @classdesc Represents a GetStorageCreds.
         * @implements IGetStorageCreds
         * @constructor
         * @param {response.IGetStorageCreds=} [properties] Properties to set
         */
        function GetStorageCreds(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetStorageCreds status.
         * @member {response.Status} status
         * @memberof response.GetStorageCreds
         * @instance
         */
        GetStorageCreds.prototype.status = 0;

        /**
         * GetStorageCreds message.
         * @member {string|null|undefined} message
         * @memberof response.GetStorageCreds
         * @instance
         */
        GetStorageCreds.prototype.message = null;

        /**
         * GetStorageCreds storageDetails.
         * @member {response.IStorageDetails|null|undefined} storageDetails
         * @memberof response.GetStorageCreds
         * @instance
         */
        GetStorageCreds.prototype.storageDetails = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(GetStorageCreds.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new GetStorageCreds instance using the specified properties.
         * @function create
         * @memberof response.GetStorageCreds
         * @static
         * @param {response.IGetStorageCreds=} [properties] Properties to set
         * @returns {response.GetStorageCreds} GetStorageCreds instance
         */
        GetStorageCreds.create = function create(properties) {
            return new GetStorageCreds(properties);
        };

        /**
         * Encodes the specified GetStorageCreds message. Does not implicitly {@link response.GetStorageCreds.verify|verify} messages.
         * @function encode
         * @memberof response.GetStorageCreds
         * @static
         * @param {response.IGetStorageCreds} message GetStorageCreds message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetStorageCreds.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            if (message.storageDetails != null && Object.hasOwnProperty.call(message, "storageDetails"))
                $root.response.StorageDetails.encode(message.storageDetails, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified GetStorageCreds message, length delimited. Does not implicitly {@link response.GetStorageCreds.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.GetStorageCreds
         * @static
         * @param {response.IGetStorageCreds} message GetStorageCreds message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetStorageCreds.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetStorageCreds message from the specified reader or buffer.
         * @function decode
         * @memberof response.GetStorageCreds
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.GetStorageCreds} GetStorageCreds
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetStorageCreds.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.GetStorageCreds();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                case 3: {
                        message.storageDetails = $root.response.StorageDetails.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetStorageCreds message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.GetStorageCreds
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.GetStorageCreds} GetStorageCreds
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetStorageCreds.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetStorageCreds message.
         * @function verify
         * @memberof response.GetStorageCreds
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetStorageCreds.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            if (message.storageDetails != null && message.hasOwnProperty("storageDetails")) {
                let error = $root.response.StorageDetails.verify(message.storageDetails);
                if (error)
                    return "storageDetails." + error;
            }
            return null;
        };

        /**
         * Creates a GetStorageCreds message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.GetStorageCreds
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.GetStorageCreds} GetStorageCreds
         */
        GetStorageCreds.fromObject = function fromObject(object) {
            if (object instanceof $root.response.GetStorageCreds)
                return object;
            let message = new $root.response.GetStorageCreds();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            if (object.storageDetails != null) {
                if (typeof object.storageDetails !== "object")
                    throw TypeError(".response.GetStorageCreds.storageDetails: object expected");
                message.storageDetails = $root.response.StorageDetails.fromObject(object.storageDetails);
            }
            return message;
        };

        /**
         * Creates a plain object from a GetStorageCreds message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.GetStorageCreds
         * @static
         * @param {response.GetStorageCreds} message GetStorageCreds
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetStorageCreds.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.status = options.enums === String ? "SUCCESS" : 0;
                object.storageDetails = null;
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            if (message.storageDetails != null && message.hasOwnProperty("storageDetails"))
                object.storageDetails = $root.response.StorageDetails.toObject(message.storageDetails, options);
            return object;
        };

        /**
         * Converts this GetStorageCreds to JSON.
         * @function toJSON
         * @memberof response.GetStorageCreds
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetStorageCreds.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetStorageCreds
         * @function getTypeUrl
         * @memberof response.GetStorageCreds
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetStorageCreds.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.GetStorageCreds";
        };

        return GetStorageCreds;
    })();

    response.RemoveOrganizationUser = (function() {

        /**
         * Properties of a RemoveOrganizationUser.
         * @memberof response
         * @interface IRemoveOrganizationUser
         * @property {response.Status|null} [status] RemoveOrganizationUser status
         * @property {string|null} [message] RemoveOrganizationUser message
         */

        /**
         * Constructs a new RemoveOrganizationUser.
         * @memberof response
         * @classdesc Represents a RemoveOrganizationUser.
         * @implements IRemoveOrganizationUser
         * @constructor
         * @param {response.IRemoveOrganizationUser=} [properties] Properties to set
         */
        function RemoveOrganizationUser(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveOrganizationUser status.
         * @member {response.Status} status
         * @memberof response.RemoveOrganizationUser
         * @instance
         */
        RemoveOrganizationUser.prototype.status = 0;

        /**
         * RemoveOrganizationUser message.
         * @member {string|null|undefined} message
         * @memberof response.RemoveOrganizationUser
         * @instance
         */
        RemoveOrganizationUser.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(RemoveOrganizationUser.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new RemoveOrganizationUser instance using the specified properties.
         * @function create
         * @memberof response.RemoveOrganizationUser
         * @static
         * @param {response.IRemoveOrganizationUser=} [properties] Properties to set
         * @returns {response.RemoveOrganizationUser} RemoveOrganizationUser instance
         */
        RemoveOrganizationUser.create = function create(properties) {
            return new RemoveOrganizationUser(properties);
        };

        /**
         * Encodes the specified RemoveOrganizationUser message. Does not implicitly {@link response.RemoveOrganizationUser.verify|verify} messages.
         * @function encode
         * @memberof response.RemoveOrganizationUser
         * @static
         * @param {response.IRemoveOrganizationUser} message RemoveOrganizationUser message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RemoveOrganizationUser.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified RemoveOrganizationUser message, length delimited. Does not implicitly {@link response.RemoveOrganizationUser.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.RemoveOrganizationUser
         * @static
         * @param {response.IRemoveOrganizationUser} message RemoveOrganizationUser message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RemoveOrganizationUser.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RemoveOrganizationUser message from the specified reader or buffer.
         * @function decode
         * @memberof response.RemoveOrganizationUser
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.RemoveOrganizationUser} RemoveOrganizationUser
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RemoveOrganizationUser.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.RemoveOrganizationUser();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RemoveOrganizationUser message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.RemoveOrganizationUser
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.RemoveOrganizationUser} RemoveOrganizationUser
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RemoveOrganizationUser.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RemoveOrganizationUser message.
         * @function verify
         * @memberof response.RemoveOrganizationUser
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RemoveOrganizationUser.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a RemoveOrganizationUser message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.RemoveOrganizationUser
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.RemoveOrganizationUser} RemoveOrganizationUser
         */
        RemoveOrganizationUser.fromObject = function fromObject(object) {
            if (object instanceof $root.response.RemoveOrganizationUser)
                return object;
            let message = new $root.response.RemoveOrganizationUser();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a RemoveOrganizationUser message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.RemoveOrganizationUser
         * @static
         * @param {response.RemoveOrganizationUser} message RemoveOrganizationUser
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveOrganizationUser.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this RemoveOrganizationUser to JSON.
         * @function toJSON
         * @memberof response.RemoveOrganizationUser
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveOrganizationUser.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for RemoveOrganizationUser
         * @function getTypeUrl
         * @memberof response.RemoveOrganizationUser
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        RemoveOrganizationUser.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.RemoveOrganizationUser";
        };

        return RemoveOrganizationUser;
    })();

    response.GetStorageValue = (function() {

        /**
         * Properties of a GetStorageValue.
         * @memberof response
         * @interface IGetStorageValue
         * @property {response.Status|null} [status] GetStorageValue status
         * @property {string|null} [message] GetStorageValue message
         * @property {number|Long|null} [value] GetStorageValue value
         * @property {number|null} [limit] GetStorageValue limit
         */

        /**
         * Constructs a new GetStorageValue.
         * @memberof response
         * @classdesc Represents a GetStorageValue.
         * @implements IGetStorageValue
         * @constructor
         * @param {response.IGetStorageValue=} [properties] Properties to set
         */
        function GetStorageValue(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetStorageValue status.
         * @member {response.Status} status
         * @memberof response.GetStorageValue
         * @instance
         */
        GetStorageValue.prototype.status = 0;

        /**
         * GetStorageValue message.
         * @member {string|null|undefined} message
         * @memberof response.GetStorageValue
         * @instance
         */
        GetStorageValue.prototype.message = null;

        /**
         * GetStorageValue value.
         * @member {number|Long} value
         * @memberof response.GetStorageValue
         * @instance
         */
        GetStorageValue.prototype.value = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * GetStorageValue limit.
         * @member {number} limit
         * @memberof response.GetStorageValue
         * @instance
         */
        GetStorageValue.prototype.limit = 0;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(GetStorageValue.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new GetStorageValue instance using the specified properties.
         * @function create
         * @memberof response.GetStorageValue
         * @static
         * @param {response.IGetStorageValue=} [properties] Properties to set
         * @returns {response.GetStorageValue} GetStorageValue instance
         */
        GetStorageValue.create = function create(properties) {
            return new GetStorageValue(properties);
        };

        /**
         * Encodes the specified GetStorageValue message. Does not implicitly {@link response.GetStorageValue.verify|verify} messages.
         * @function encode
         * @memberof response.GetStorageValue
         * @static
         * @param {response.IGetStorageValue} message GetStorageValue message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetStorageValue.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.value);
            if (message.limit != null && Object.hasOwnProperty.call(message, "limit"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.limit);
            return writer;
        };

        /**
         * Encodes the specified GetStorageValue message, length delimited. Does not implicitly {@link response.GetStorageValue.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.GetStorageValue
         * @static
         * @param {response.IGetStorageValue} message GetStorageValue message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetStorageValue.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetStorageValue message from the specified reader or buffer.
         * @function decode
         * @memberof response.GetStorageValue
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.GetStorageValue} GetStorageValue
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetStorageValue.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.GetStorageValue();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                case 3: {
                        message.value = reader.uint64();
                        break;
                    }
                case 4: {
                        message.limit = reader.uint32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetStorageValue message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.GetStorageValue
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.GetStorageValue} GetStorageValue
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetStorageValue.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetStorageValue message.
         * @function verify
         * @memberof response.GetStorageValue
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetStorageValue.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            if (message.value != null && message.hasOwnProperty("value"))
                if (!$util.isInteger(message.value) && !(message.value && $util.isInteger(message.value.low) && $util.isInteger(message.value.high)))
                    return "value: integer|Long expected";
            if (message.limit != null && message.hasOwnProperty("limit"))
                if (!$util.isInteger(message.limit))
                    return "limit: integer expected";
            return null;
        };

        /**
         * Creates a GetStorageValue message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.GetStorageValue
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.GetStorageValue} GetStorageValue
         */
        GetStorageValue.fromObject = function fromObject(object) {
            if (object instanceof $root.response.GetStorageValue)
                return object;
            let message = new $root.response.GetStorageValue();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            if (object.value != null)
                if ($util.Long)
                    (message.value = $util.Long.fromValue(object.value)).unsigned = true;
                else if (typeof object.value === "string")
                    message.value = parseInt(object.value, 10);
                else if (typeof object.value === "number")
                    message.value = object.value;
                else if (typeof object.value === "object")
                    message.value = new $util.LongBits(object.value.low >>> 0, object.value.high >>> 0).toNumber(true);
            if (object.limit != null)
                message.limit = object.limit >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a GetStorageValue message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.GetStorageValue
         * @static
         * @param {response.GetStorageValue} message GetStorageValue
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetStorageValue.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.status = options.enums === String ? "SUCCESS" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.value = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.value = options.longs === String ? "0" : 0;
                object.limit = 0;
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            if (message.value != null && message.hasOwnProperty("value"))
                if (typeof message.value === "number")
                    object.value = options.longs === String ? String(message.value) : message.value;
                else
                    object.value = options.longs === String ? $util.Long.prototype.toString.call(message.value) : options.longs === Number ? new $util.LongBits(message.value.low >>> 0, message.value.high >>> 0).toNumber(true) : message.value;
            if (message.limit != null && message.hasOwnProperty("limit"))
                object.limit = message.limit;
            return object;
        };

        /**
         * Converts this GetStorageValue to JSON.
         * @function toJSON
         * @memberof response.GetStorageValue
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetStorageValue.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetStorageValue
         * @function getTypeUrl
         * @memberof response.GetStorageValue
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetStorageValue.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.GetStorageValue";
        };

        return GetStorageValue;
    })();

    response.AddSpace = (function() {

        /**
         * Properties of an AddSpace.
         * @memberof response
         * @interface IAddSpace
         * @property {response.Status|null} [status] AddSpace status
         * @property {response.ISpaceObjInResponse|null} [spaceObject] AddSpace spaceObject
         * @property {string|null} [message] AddSpace message
         */

        /**
         * Constructs a new AddSpace.
         * @memberof response
         * @classdesc Represents an AddSpace.
         * @implements IAddSpace
         * @constructor
         * @param {response.IAddSpace=} [properties] Properties to set
         */
        function AddSpace(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddSpace status.
         * @member {response.Status} status
         * @memberof response.AddSpace
         * @instance
         */
        AddSpace.prototype.status = 0;

        /**
         * AddSpace spaceObject.
         * @member {response.ISpaceObjInResponse|null|undefined} spaceObject
         * @memberof response.AddSpace
         * @instance
         */
        AddSpace.prototype.spaceObject = null;

        /**
         * AddSpace message.
         * @member {string|null|undefined} message
         * @memberof response.AddSpace
         * @instance
         */
        AddSpace.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(AddSpace.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new AddSpace instance using the specified properties.
         * @function create
         * @memberof response.AddSpace
         * @static
         * @param {response.IAddSpace=} [properties] Properties to set
         * @returns {response.AddSpace} AddSpace instance
         */
        AddSpace.create = function create(properties) {
            return new AddSpace(properties);
        };

        /**
         * Encodes the specified AddSpace message. Does not implicitly {@link response.AddSpace.verify|verify} messages.
         * @function encode
         * @memberof response.AddSpace
         * @static
         * @param {response.IAddSpace} message AddSpace message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddSpace.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.spaceObject != null && Object.hasOwnProperty.call(message, "spaceObject"))
                $root.response.SpaceObjInResponse.encode(message.spaceObject, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified AddSpace message, length delimited. Does not implicitly {@link response.AddSpace.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.AddSpace
         * @static
         * @param {response.IAddSpace} message AddSpace message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddSpace.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AddSpace message from the specified reader or buffer.
         * @function decode
         * @memberof response.AddSpace
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.AddSpace} AddSpace
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddSpace.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.AddSpace();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.spaceObject = $root.response.SpaceObjInResponse.decode(reader, reader.uint32());
                        break;
                    }
                case 3: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AddSpace message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.AddSpace
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.AddSpace} AddSpace
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddSpace.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AddSpace message.
         * @function verify
         * @memberof response.AddSpace
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AddSpace.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.spaceObject != null && message.hasOwnProperty("spaceObject")) {
                let error = $root.response.SpaceObjInResponse.verify(message.spaceObject);
                if (error)
                    return "spaceObject." + error;
            }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates an AddSpace message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.AddSpace
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.AddSpace} AddSpace
         */
        AddSpace.fromObject = function fromObject(object) {
            if (object instanceof $root.response.AddSpace)
                return object;
            let message = new $root.response.AddSpace();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.spaceObject != null) {
                if (typeof object.spaceObject !== "object")
                    throw TypeError(".response.AddSpace.spaceObject: object expected");
                message.spaceObject = $root.response.SpaceObjInResponse.fromObject(object.spaceObject);
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from an AddSpace message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.AddSpace
         * @static
         * @param {response.AddSpace} message AddSpace
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddSpace.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.status = options.enums === String ? "SUCCESS" : 0;
                object.spaceObject = null;
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.spaceObject != null && message.hasOwnProperty("spaceObject"))
                object.spaceObject = $root.response.SpaceObjInResponse.toObject(message.spaceObject, options);
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this AddSpace to JSON.
         * @function toJSON
         * @memberof response.AddSpace
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddSpace.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for AddSpace
         * @function getTypeUrl
         * @memberof response.AddSpace
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        AddSpace.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.AddSpace";
        };

        return AddSpace;
    })();

    response.AddUserToSpace = (function() {

        /**
         * Properties of an AddUserToSpace.
         * @memberof response
         * @interface IAddUserToSpace
         * @property {response.Status|null} [status] AddUserToSpace status
         * @property {string|null} [message] AddUserToSpace message
         */

        /**
         * Constructs a new AddUserToSpace.
         * @memberof response
         * @classdesc Represents an AddUserToSpace.
         * @implements IAddUserToSpace
         * @constructor
         * @param {response.IAddUserToSpace=} [properties] Properties to set
         */
        function AddUserToSpace(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddUserToSpace status.
         * @member {response.Status} status
         * @memberof response.AddUserToSpace
         * @instance
         */
        AddUserToSpace.prototype.status = 0;

        /**
         * AddUserToSpace message.
         * @member {string|null|undefined} message
         * @memberof response.AddUserToSpace
         * @instance
         */
        AddUserToSpace.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(AddUserToSpace.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new AddUserToSpace instance using the specified properties.
         * @function create
         * @memberof response.AddUserToSpace
         * @static
         * @param {response.IAddUserToSpace=} [properties] Properties to set
         * @returns {response.AddUserToSpace} AddUserToSpace instance
         */
        AddUserToSpace.create = function create(properties) {
            return new AddUserToSpace(properties);
        };

        /**
         * Encodes the specified AddUserToSpace message. Does not implicitly {@link response.AddUserToSpace.verify|verify} messages.
         * @function encode
         * @memberof response.AddUserToSpace
         * @static
         * @param {response.IAddUserToSpace} message AddUserToSpace message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddUserToSpace.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified AddUserToSpace message, length delimited. Does not implicitly {@link response.AddUserToSpace.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.AddUserToSpace
         * @static
         * @param {response.IAddUserToSpace} message AddUserToSpace message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddUserToSpace.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AddUserToSpace message from the specified reader or buffer.
         * @function decode
         * @memberof response.AddUserToSpace
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.AddUserToSpace} AddUserToSpace
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddUserToSpace.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.AddUserToSpace();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AddUserToSpace message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.AddUserToSpace
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.AddUserToSpace} AddUserToSpace
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddUserToSpace.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AddUserToSpace message.
         * @function verify
         * @memberof response.AddUserToSpace
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AddUserToSpace.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates an AddUserToSpace message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.AddUserToSpace
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.AddUserToSpace} AddUserToSpace
         */
        AddUserToSpace.fromObject = function fromObject(object) {
            if (object instanceof $root.response.AddUserToSpace)
                return object;
            let message = new $root.response.AddUserToSpace();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from an AddUserToSpace message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.AddUserToSpace
         * @static
         * @param {response.AddUserToSpace} message AddUserToSpace
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddUserToSpace.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this AddUserToSpace to JSON.
         * @function toJSON
         * @memberof response.AddUserToSpace
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddUserToSpace.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for AddUserToSpace
         * @function getTypeUrl
         * @memberof response.AddUserToSpace
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        AddUserToSpace.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.AddUserToSpace";
        };

        return AddUserToSpace;
    })();

    response.RemoveUserFromSpace = (function() {

        /**
         * Properties of a RemoveUserFromSpace.
         * @memberof response
         * @interface IRemoveUserFromSpace
         * @property {response.Status|null} [status] RemoveUserFromSpace status
         * @property {string|null} [message] RemoveUserFromSpace message
         */

        /**
         * Constructs a new RemoveUserFromSpace.
         * @memberof response
         * @classdesc Represents a RemoveUserFromSpace.
         * @implements IRemoveUserFromSpace
         * @constructor
         * @param {response.IRemoveUserFromSpace=} [properties] Properties to set
         */
        function RemoveUserFromSpace(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveUserFromSpace status.
         * @member {response.Status} status
         * @memberof response.RemoveUserFromSpace
         * @instance
         */
        RemoveUserFromSpace.prototype.status = 0;

        /**
         * RemoveUserFromSpace message.
         * @member {string|null|undefined} message
         * @memberof response.RemoveUserFromSpace
         * @instance
         */
        RemoveUserFromSpace.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(RemoveUserFromSpace.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new RemoveUserFromSpace instance using the specified properties.
         * @function create
         * @memberof response.RemoveUserFromSpace
         * @static
         * @param {response.IRemoveUserFromSpace=} [properties] Properties to set
         * @returns {response.RemoveUserFromSpace} RemoveUserFromSpace instance
         */
        RemoveUserFromSpace.create = function create(properties) {
            return new RemoveUserFromSpace(properties);
        };

        /**
         * Encodes the specified RemoveUserFromSpace message. Does not implicitly {@link response.RemoveUserFromSpace.verify|verify} messages.
         * @function encode
         * @memberof response.RemoveUserFromSpace
         * @static
         * @param {response.IRemoveUserFromSpace} message RemoveUserFromSpace message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RemoveUserFromSpace.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified RemoveUserFromSpace message, length delimited. Does not implicitly {@link response.RemoveUserFromSpace.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.RemoveUserFromSpace
         * @static
         * @param {response.IRemoveUserFromSpace} message RemoveUserFromSpace message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RemoveUserFromSpace.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RemoveUserFromSpace message from the specified reader or buffer.
         * @function decode
         * @memberof response.RemoveUserFromSpace
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.RemoveUserFromSpace} RemoveUserFromSpace
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RemoveUserFromSpace.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.RemoveUserFromSpace();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RemoveUserFromSpace message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.RemoveUserFromSpace
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.RemoveUserFromSpace} RemoveUserFromSpace
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RemoveUserFromSpace.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RemoveUserFromSpace message.
         * @function verify
         * @memberof response.RemoveUserFromSpace
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RemoveUserFromSpace.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a RemoveUserFromSpace message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.RemoveUserFromSpace
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.RemoveUserFromSpace} RemoveUserFromSpace
         */
        RemoveUserFromSpace.fromObject = function fromObject(object) {
            if (object instanceof $root.response.RemoveUserFromSpace)
                return object;
            let message = new $root.response.RemoveUserFromSpace();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a RemoveUserFromSpace message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.RemoveUserFromSpace
         * @static
         * @param {response.RemoveUserFromSpace} message RemoveUserFromSpace
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveUserFromSpace.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this RemoveUserFromSpace to JSON.
         * @function toJSON
         * @memberof response.RemoveUserFromSpace
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveUserFromSpace.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for RemoveUserFromSpace
         * @function getTypeUrl
         * @memberof response.RemoveUserFromSpace
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        RemoveUserFromSpace.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.RemoveUserFromSpace";
        };

        return RemoveUserFromSpace;
    })();

    response.UpdatePermissionsOfSpace = (function() {

        /**
         * Properties of an UpdatePermissionsOfSpace.
         * @memberof response
         * @interface IUpdatePermissionsOfSpace
         * @property {response.Status|null} [status] UpdatePermissionsOfSpace status
         * @property {string|null} [message] UpdatePermissionsOfSpace message
         */

        /**
         * Constructs a new UpdatePermissionsOfSpace.
         * @memberof response
         * @classdesc Represents an UpdatePermissionsOfSpace.
         * @implements IUpdatePermissionsOfSpace
         * @constructor
         * @param {response.IUpdatePermissionsOfSpace=} [properties] Properties to set
         */
        function UpdatePermissionsOfSpace(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdatePermissionsOfSpace status.
         * @member {response.Status} status
         * @memberof response.UpdatePermissionsOfSpace
         * @instance
         */
        UpdatePermissionsOfSpace.prototype.status = 0;

        /**
         * UpdatePermissionsOfSpace message.
         * @member {string|null|undefined} message
         * @memberof response.UpdatePermissionsOfSpace
         * @instance
         */
        UpdatePermissionsOfSpace.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(UpdatePermissionsOfSpace.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new UpdatePermissionsOfSpace instance using the specified properties.
         * @function create
         * @memberof response.UpdatePermissionsOfSpace
         * @static
         * @param {response.IUpdatePermissionsOfSpace=} [properties] Properties to set
         * @returns {response.UpdatePermissionsOfSpace} UpdatePermissionsOfSpace instance
         */
        UpdatePermissionsOfSpace.create = function create(properties) {
            return new UpdatePermissionsOfSpace(properties);
        };

        /**
         * Encodes the specified UpdatePermissionsOfSpace message. Does not implicitly {@link response.UpdatePermissionsOfSpace.verify|verify} messages.
         * @function encode
         * @memberof response.UpdatePermissionsOfSpace
         * @static
         * @param {response.IUpdatePermissionsOfSpace} message UpdatePermissionsOfSpace message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdatePermissionsOfSpace.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified UpdatePermissionsOfSpace message, length delimited. Does not implicitly {@link response.UpdatePermissionsOfSpace.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.UpdatePermissionsOfSpace
         * @static
         * @param {response.IUpdatePermissionsOfSpace} message UpdatePermissionsOfSpace message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdatePermissionsOfSpace.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UpdatePermissionsOfSpace message from the specified reader or buffer.
         * @function decode
         * @memberof response.UpdatePermissionsOfSpace
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.UpdatePermissionsOfSpace} UpdatePermissionsOfSpace
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdatePermissionsOfSpace.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.UpdatePermissionsOfSpace();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UpdatePermissionsOfSpace message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.UpdatePermissionsOfSpace
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.UpdatePermissionsOfSpace} UpdatePermissionsOfSpace
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdatePermissionsOfSpace.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UpdatePermissionsOfSpace message.
         * @function verify
         * @memberof response.UpdatePermissionsOfSpace
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UpdatePermissionsOfSpace.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates an UpdatePermissionsOfSpace message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.UpdatePermissionsOfSpace
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.UpdatePermissionsOfSpace} UpdatePermissionsOfSpace
         */
        UpdatePermissionsOfSpace.fromObject = function fromObject(object) {
            if (object instanceof $root.response.UpdatePermissionsOfSpace)
                return object;
            let message = new $root.response.UpdatePermissionsOfSpace();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from an UpdatePermissionsOfSpace message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.UpdatePermissionsOfSpace
         * @static
         * @param {response.UpdatePermissionsOfSpace} message UpdatePermissionsOfSpace
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdatePermissionsOfSpace.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this UpdatePermissionsOfSpace to JSON.
         * @function toJSON
         * @memberof response.UpdatePermissionsOfSpace
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdatePermissionsOfSpace.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for UpdatePermissionsOfSpace
         * @function getTypeUrl
         * @memberof response.UpdatePermissionsOfSpace
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        UpdatePermissionsOfSpace.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.UpdatePermissionsOfSpace";
        };

        return UpdatePermissionsOfSpace;
    })();

    response.AddObjectToSpace = (function() {

        /**
         * Properties of an AddObjectToSpace.
         * @memberof response
         * @interface IAddObjectToSpace
         * @property {response.Status|null} [status] AddObjectToSpace status
         * @property {string|null} [message] AddObjectToSpace message
         */

        /**
         * Constructs a new AddObjectToSpace.
         * @memberof response
         * @classdesc Represents an AddObjectToSpace.
         * @implements IAddObjectToSpace
         * @constructor
         * @param {response.IAddObjectToSpace=} [properties] Properties to set
         */
        function AddObjectToSpace(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddObjectToSpace status.
         * @member {response.Status} status
         * @memberof response.AddObjectToSpace
         * @instance
         */
        AddObjectToSpace.prototype.status = 0;

        /**
         * AddObjectToSpace message.
         * @member {string|null|undefined} message
         * @memberof response.AddObjectToSpace
         * @instance
         */
        AddObjectToSpace.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(AddObjectToSpace.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new AddObjectToSpace instance using the specified properties.
         * @function create
         * @memberof response.AddObjectToSpace
         * @static
         * @param {response.IAddObjectToSpace=} [properties] Properties to set
         * @returns {response.AddObjectToSpace} AddObjectToSpace instance
         */
        AddObjectToSpace.create = function create(properties) {
            return new AddObjectToSpace(properties);
        };

        /**
         * Encodes the specified AddObjectToSpace message. Does not implicitly {@link response.AddObjectToSpace.verify|verify} messages.
         * @function encode
         * @memberof response.AddObjectToSpace
         * @static
         * @param {response.IAddObjectToSpace} message AddObjectToSpace message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddObjectToSpace.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified AddObjectToSpace message, length delimited. Does not implicitly {@link response.AddObjectToSpace.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.AddObjectToSpace
         * @static
         * @param {response.IAddObjectToSpace} message AddObjectToSpace message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddObjectToSpace.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AddObjectToSpace message from the specified reader or buffer.
         * @function decode
         * @memberof response.AddObjectToSpace
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.AddObjectToSpace} AddObjectToSpace
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddObjectToSpace.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.AddObjectToSpace();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AddObjectToSpace message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.AddObjectToSpace
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.AddObjectToSpace} AddObjectToSpace
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddObjectToSpace.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AddObjectToSpace message.
         * @function verify
         * @memberof response.AddObjectToSpace
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AddObjectToSpace.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates an AddObjectToSpace message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.AddObjectToSpace
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.AddObjectToSpace} AddObjectToSpace
         */
        AddObjectToSpace.fromObject = function fromObject(object) {
            if (object instanceof $root.response.AddObjectToSpace)
                return object;
            let message = new $root.response.AddObjectToSpace();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from an AddObjectToSpace message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.AddObjectToSpace
         * @static
         * @param {response.AddObjectToSpace} message AddObjectToSpace
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddObjectToSpace.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this AddObjectToSpace to JSON.
         * @function toJSON
         * @memberof response.AddObjectToSpace
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddObjectToSpace.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for AddObjectToSpace
         * @function getTypeUrl
         * @memberof response.AddObjectToSpace
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        AddObjectToSpace.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.AddObjectToSpace";
        };

        return AddObjectToSpace;
    })();

    response.RemoveObjectFromSpace = (function() {

        /**
         * Properties of a RemoveObjectFromSpace.
         * @memberof response
         * @interface IRemoveObjectFromSpace
         * @property {response.Status|null} [status] RemoveObjectFromSpace status
         * @property {string|null} [message] RemoveObjectFromSpace message
         */

        /**
         * Constructs a new RemoveObjectFromSpace.
         * @memberof response
         * @classdesc Represents a RemoveObjectFromSpace.
         * @implements IRemoveObjectFromSpace
         * @constructor
         * @param {response.IRemoveObjectFromSpace=} [properties] Properties to set
         */
        function RemoveObjectFromSpace(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveObjectFromSpace status.
         * @member {response.Status} status
         * @memberof response.RemoveObjectFromSpace
         * @instance
         */
        RemoveObjectFromSpace.prototype.status = 0;

        /**
         * RemoveObjectFromSpace message.
         * @member {string|null|undefined} message
         * @memberof response.RemoveObjectFromSpace
         * @instance
         */
        RemoveObjectFromSpace.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(RemoveObjectFromSpace.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new RemoveObjectFromSpace instance using the specified properties.
         * @function create
         * @memberof response.RemoveObjectFromSpace
         * @static
         * @param {response.IRemoveObjectFromSpace=} [properties] Properties to set
         * @returns {response.RemoveObjectFromSpace} RemoveObjectFromSpace instance
         */
        RemoveObjectFromSpace.create = function create(properties) {
            return new RemoveObjectFromSpace(properties);
        };

        /**
         * Encodes the specified RemoveObjectFromSpace message. Does not implicitly {@link response.RemoveObjectFromSpace.verify|verify} messages.
         * @function encode
         * @memberof response.RemoveObjectFromSpace
         * @static
         * @param {response.IRemoveObjectFromSpace} message RemoveObjectFromSpace message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RemoveObjectFromSpace.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified RemoveObjectFromSpace message, length delimited. Does not implicitly {@link response.RemoveObjectFromSpace.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.RemoveObjectFromSpace
         * @static
         * @param {response.IRemoveObjectFromSpace} message RemoveObjectFromSpace message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RemoveObjectFromSpace.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RemoveObjectFromSpace message from the specified reader or buffer.
         * @function decode
         * @memberof response.RemoveObjectFromSpace
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.RemoveObjectFromSpace} RemoveObjectFromSpace
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RemoveObjectFromSpace.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.RemoveObjectFromSpace();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RemoveObjectFromSpace message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.RemoveObjectFromSpace
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.RemoveObjectFromSpace} RemoveObjectFromSpace
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RemoveObjectFromSpace.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RemoveObjectFromSpace message.
         * @function verify
         * @memberof response.RemoveObjectFromSpace
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RemoveObjectFromSpace.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a RemoveObjectFromSpace message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.RemoveObjectFromSpace
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.RemoveObjectFromSpace} RemoveObjectFromSpace
         */
        RemoveObjectFromSpace.fromObject = function fromObject(object) {
            if (object instanceof $root.response.RemoveObjectFromSpace)
                return object;
            let message = new $root.response.RemoveObjectFromSpace();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a RemoveObjectFromSpace message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.RemoveObjectFromSpace
         * @static
         * @param {response.RemoveObjectFromSpace} message RemoveObjectFromSpace
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveObjectFromSpace.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this RemoveObjectFromSpace to JSON.
         * @function toJSON
         * @memberof response.RemoveObjectFromSpace
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveObjectFromSpace.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for RemoveObjectFromSpace
         * @function getTypeUrl
         * @memberof response.RemoveObjectFromSpace
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        RemoveObjectFromSpace.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.RemoveObjectFromSpace";
        };

        return RemoveObjectFromSpace;
    })();

    response.RemoveSpace = (function() {

        /**
         * Properties of a RemoveSpace.
         * @memberof response
         * @interface IRemoveSpace
         * @property {response.Status|null} [status] RemoveSpace status
         * @property {string|null} [message] RemoveSpace message
         */

        /**
         * Constructs a new RemoveSpace.
         * @memberof response
         * @classdesc Represents a RemoveSpace.
         * @implements IRemoveSpace
         * @constructor
         * @param {response.IRemoveSpace=} [properties] Properties to set
         */
        function RemoveSpace(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveSpace status.
         * @member {response.Status} status
         * @memberof response.RemoveSpace
         * @instance
         */
        RemoveSpace.prototype.status = 0;

        /**
         * RemoveSpace message.
         * @member {string|null|undefined} message
         * @memberof response.RemoveSpace
         * @instance
         */
        RemoveSpace.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(RemoveSpace.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new RemoveSpace instance using the specified properties.
         * @function create
         * @memberof response.RemoveSpace
         * @static
         * @param {response.IRemoveSpace=} [properties] Properties to set
         * @returns {response.RemoveSpace} RemoveSpace instance
         */
        RemoveSpace.create = function create(properties) {
            return new RemoveSpace(properties);
        };

        /**
         * Encodes the specified RemoveSpace message. Does not implicitly {@link response.RemoveSpace.verify|verify} messages.
         * @function encode
         * @memberof response.RemoveSpace
         * @static
         * @param {response.IRemoveSpace} message RemoveSpace message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RemoveSpace.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified RemoveSpace message, length delimited. Does not implicitly {@link response.RemoveSpace.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.RemoveSpace
         * @static
         * @param {response.IRemoveSpace} message RemoveSpace message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RemoveSpace.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RemoveSpace message from the specified reader or buffer.
         * @function decode
         * @memberof response.RemoveSpace
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.RemoveSpace} RemoveSpace
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RemoveSpace.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.RemoveSpace();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RemoveSpace message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.RemoveSpace
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.RemoveSpace} RemoveSpace
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RemoveSpace.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RemoveSpace message.
         * @function verify
         * @memberof response.RemoveSpace
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RemoveSpace.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a RemoveSpace message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.RemoveSpace
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.RemoveSpace} RemoveSpace
         */
        RemoveSpace.fromObject = function fromObject(object) {
            if (object instanceof $root.response.RemoveSpace)
                return object;
            let message = new $root.response.RemoveSpace();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a RemoveSpace message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.RemoveSpace
         * @static
         * @param {response.RemoveSpace} message RemoveSpace
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveSpace.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this RemoveSpace to JSON.
         * @function toJSON
         * @memberof response.RemoveSpace
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveSpace.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for RemoveSpace
         * @function getTypeUrl
         * @memberof response.RemoveSpace
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        RemoveSpace.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.RemoveSpace";
        };

        return RemoveSpace;
    })();

    response.SendOtpToExternalUser = (function() {

        /**
         * Properties of a SendOtpToExternalUser.
         * @memberof response
         * @interface ISendOtpToExternalUser
         * @property {response.Status|null} [status] SendOtpToExternalUser status
         * @property {string|null} [message] SendOtpToExternalUser message
         */

        /**
         * Constructs a new SendOtpToExternalUser.
         * @memberof response
         * @classdesc Represents a SendOtpToExternalUser.
         * @implements ISendOtpToExternalUser
         * @constructor
         * @param {response.ISendOtpToExternalUser=} [properties] Properties to set
         */
        function SendOtpToExternalUser(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SendOtpToExternalUser status.
         * @member {response.Status} status
         * @memberof response.SendOtpToExternalUser
         * @instance
         */
        SendOtpToExternalUser.prototype.status = 0;

        /**
         * SendOtpToExternalUser message.
         * @member {string|null|undefined} message
         * @memberof response.SendOtpToExternalUser
         * @instance
         */
        SendOtpToExternalUser.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(SendOtpToExternalUser.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new SendOtpToExternalUser instance using the specified properties.
         * @function create
         * @memberof response.SendOtpToExternalUser
         * @static
         * @param {response.ISendOtpToExternalUser=} [properties] Properties to set
         * @returns {response.SendOtpToExternalUser} SendOtpToExternalUser instance
         */
        SendOtpToExternalUser.create = function create(properties) {
            return new SendOtpToExternalUser(properties);
        };

        /**
         * Encodes the specified SendOtpToExternalUser message. Does not implicitly {@link response.SendOtpToExternalUser.verify|verify} messages.
         * @function encode
         * @memberof response.SendOtpToExternalUser
         * @static
         * @param {response.ISendOtpToExternalUser} message SendOtpToExternalUser message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SendOtpToExternalUser.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified SendOtpToExternalUser message, length delimited. Does not implicitly {@link response.SendOtpToExternalUser.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.SendOtpToExternalUser
         * @static
         * @param {response.ISendOtpToExternalUser} message SendOtpToExternalUser message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SendOtpToExternalUser.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SendOtpToExternalUser message from the specified reader or buffer.
         * @function decode
         * @memberof response.SendOtpToExternalUser
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.SendOtpToExternalUser} SendOtpToExternalUser
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SendOtpToExternalUser.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.SendOtpToExternalUser();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SendOtpToExternalUser message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.SendOtpToExternalUser
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.SendOtpToExternalUser} SendOtpToExternalUser
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SendOtpToExternalUser.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SendOtpToExternalUser message.
         * @function verify
         * @memberof response.SendOtpToExternalUser
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SendOtpToExternalUser.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a SendOtpToExternalUser message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.SendOtpToExternalUser
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.SendOtpToExternalUser} SendOtpToExternalUser
         */
        SendOtpToExternalUser.fromObject = function fromObject(object) {
            if (object instanceof $root.response.SendOtpToExternalUser)
                return object;
            let message = new $root.response.SendOtpToExternalUser();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a SendOtpToExternalUser message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.SendOtpToExternalUser
         * @static
         * @param {response.SendOtpToExternalUser} message SendOtpToExternalUser
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SendOtpToExternalUser.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this SendOtpToExternalUser to JSON.
         * @function toJSON
         * @memberof response.SendOtpToExternalUser
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SendOtpToExternalUser.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for SendOtpToExternalUser
         * @function getTypeUrl
         * @memberof response.SendOtpToExternalUser
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        SendOtpToExternalUser.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.SendOtpToExternalUser";
        };

        return SendOtpToExternalUser;
    })();

    response.SendOtpToExternalUserIfNotExist = (function() {

        /**
         * Properties of a SendOtpToExternalUserIfNotExist.
         * @memberof response
         * @interface ISendOtpToExternalUserIfNotExist
         * @property {response.Status|null} [status] SendOtpToExternalUserIfNotExist status
         * @property {string|null} [message] SendOtpToExternalUserIfNotExist message
         */

        /**
         * Constructs a new SendOtpToExternalUserIfNotExist.
         * @memberof response
         * @classdesc Represents a SendOtpToExternalUserIfNotExist.
         * @implements ISendOtpToExternalUserIfNotExist
         * @constructor
         * @param {response.ISendOtpToExternalUserIfNotExist=} [properties] Properties to set
         */
        function SendOtpToExternalUserIfNotExist(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SendOtpToExternalUserIfNotExist status.
         * @member {response.Status} status
         * @memberof response.SendOtpToExternalUserIfNotExist
         * @instance
         */
        SendOtpToExternalUserIfNotExist.prototype.status = 0;

        /**
         * SendOtpToExternalUserIfNotExist message.
         * @member {string|null|undefined} message
         * @memberof response.SendOtpToExternalUserIfNotExist
         * @instance
         */
        SendOtpToExternalUserIfNotExist.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(SendOtpToExternalUserIfNotExist.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new SendOtpToExternalUserIfNotExist instance using the specified properties.
         * @function create
         * @memberof response.SendOtpToExternalUserIfNotExist
         * @static
         * @param {response.ISendOtpToExternalUserIfNotExist=} [properties] Properties to set
         * @returns {response.SendOtpToExternalUserIfNotExist} SendOtpToExternalUserIfNotExist instance
         */
        SendOtpToExternalUserIfNotExist.create = function create(properties) {
            return new SendOtpToExternalUserIfNotExist(properties);
        };

        /**
         * Encodes the specified SendOtpToExternalUserIfNotExist message. Does not implicitly {@link response.SendOtpToExternalUserIfNotExist.verify|verify} messages.
         * @function encode
         * @memberof response.SendOtpToExternalUserIfNotExist
         * @static
         * @param {response.ISendOtpToExternalUserIfNotExist} message SendOtpToExternalUserIfNotExist message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SendOtpToExternalUserIfNotExist.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified SendOtpToExternalUserIfNotExist message, length delimited. Does not implicitly {@link response.SendOtpToExternalUserIfNotExist.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.SendOtpToExternalUserIfNotExist
         * @static
         * @param {response.ISendOtpToExternalUserIfNotExist} message SendOtpToExternalUserIfNotExist message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SendOtpToExternalUserIfNotExist.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SendOtpToExternalUserIfNotExist message from the specified reader or buffer.
         * @function decode
         * @memberof response.SendOtpToExternalUserIfNotExist
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.SendOtpToExternalUserIfNotExist} SendOtpToExternalUserIfNotExist
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SendOtpToExternalUserIfNotExist.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.SendOtpToExternalUserIfNotExist();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SendOtpToExternalUserIfNotExist message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.SendOtpToExternalUserIfNotExist
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.SendOtpToExternalUserIfNotExist} SendOtpToExternalUserIfNotExist
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SendOtpToExternalUserIfNotExist.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SendOtpToExternalUserIfNotExist message.
         * @function verify
         * @memberof response.SendOtpToExternalUserIfNotExist
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SendOtpToExternalUserIfNotExist.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a SendOtpToExternalUserIfNotExist message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.SendOtpToExternalUserIfNotExist
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.SendOtpToExternalUserIfNotExist} SendOtpToExternalUserIfNotExist
         */
        SendOtpToExternalUserIfNotExist.fromObject = function fromObject(object) {
            if (object instanceof $root.response.SendOtpToExternalUserIfNotExist)
                return object;
            let message = new $root.response.SendOtpToExternalUserIfNotExist();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a SendOtpToExternalUserIfNotExist message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.SendOtpToExternalUserIfNotExist
         * @static
         * @param {response.SendOtpToExternalUserIfNotExist} message SendOtpToExternalUserIfNotExist
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SendOtpToExternalUserIfNotExist.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this SendOtpToExternalUserIfNotExist to JSON.
         * @function toJSON
         * @memberof response.SendOtpToExternalUserIfNotExist
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SendOtpToExternalUserIfNotExist.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for SendOtpToExternalUserIfNotExist
         * @function getTypeUrl
         * @memberof response.SendOtpToExternalUserIfNotExist
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        SendOtpToExternalUserIfNotExist.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.SendOtpToExternalUserIfNotExist";
        };

        return SendOtpToExternalUserIfNotExist;
    })();

    response.SignInToSpace = (function() {

        /**
         * Properties of a SignInToSpace.
         * @memberof response
         * @interface ISignInToSpace
         * @property {response.Status|null} [status] SignInToSpace status
         * @property {Array.<response.IInfoOfExternalSharedInResponse>|null} [infoSharedObjects] SignInToSpace infoSharedObjects
         * @property {string|null} [message] SignInToSpace message
         */

        /**
         * Constructs a new SignInToSpace.
         * @memberof response
         * @classdesc Represents a SignInToSpace.
         * @implements ISignInToSpace
         * @constructor
         * @param {response.ISignInToSpace=} [properties] Properties to set
         */
        function SignInToSpace(properties) {
            this.infoSharedObjects = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SignInToSpace status.
         * @member {response.Status} status
         * @memberof response.SignInToSpace
         * @instance
         */
        SignInToSpace.prototype.status = 0;

        /**
         * SignInToSpace infoSharedObjects.
         * @member {Array.<response.IInfoOfExternalSharedInResponse>} infoSharedObjects
         * @memberof response.SignInToSpace
         * @instance
         */
        SignInToSpace.prototype.infoSharedObjects = $util.emptyArray;

        /**
         * SignInToSpace message.
         * @member {string|null|undefined} message
         * @memberof response.SignInToSpace
         * @instance
         */
        SignInToSpace.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(SignInToSpace.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new SignInToSpace instance using the specified properties.
         * @function create
         * @memberof response.SignInToSpace
         * @static
         * @param {response.ISignInToSpace=} [properties] Properties to set
         * @returns {response.SignInToSpace} SignInToSpace instance
         */
        SignInToSpace.create = function create(properties) {
            return new SignInToSpace(properties);
        };

        /**
         * Encodes the specified SignInToSpace message. Does not implicitly {@link response.SignInToSpace.verify|verify} messages.
         * @function encode
         * @memberof response.SignInToSpace
         * @static
         * @param {response.ISignInToSpace} message SignInToSpace message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SignInToSpace.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.infoSharedObjects != null && message.infoSharedObjects.length)
                for (let i = 0; i < message.infoSharedObjects.length; ++i)
                    $root.response.InfoOfExternalSharedInResponse.encode(message.infoSharedObjects[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified SignInToSpace message, length delimited. Does not implicitly {@link response.SignInToSpace.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.SignInToSpace
         * @static
         * @param {response.ISignInToSpace} message SignInToSpace message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SignInToSpace.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SignInToSpace message from the specified reader or buffer.
         * @function decode
         * @memberof response.SignInToSpace
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.SignInToSpace} SignInToSpace
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SignInToSpace.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.SignInToSpace();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        if (!(message.infoSharedObjects && message.infoSharedObjects.length))
                            message.infoSharedObjects = [];
                        message.infoSharedObjects.push($root.response.InfoOfExternalSharedInResponse.decode(reader, reader.uint32()));
                        break;
                    }
                case 3: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SignInToSpace message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.SignInToSpace
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.SignInToSpace} SignInToSpace
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SignInToSpace.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SignInToSpace message.
         * @function verify
         * @memberof response.SignInToSpace
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SignInToSpace.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.infoSharedObjects != null && message.hasOwnProperty("infoSharedObjects")) {
                if (!Array.isArray(message.infoSharedObjects))
                    return "infoSharedObjects: array expected";
                for (let i = 0; i < message.infoSharedObjects.length; ++i) {
                    let error = $root.response.InfoOfExternalSharedInResponse.verify(message.infoSharedObjects[i]);
                    if (error)
                        return "infoSharedObjects." + error;
                }
            }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a SignInToSpace message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.SignInToSpace
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.SignInToSpace} SignInToSpace
         */
        SignInToSpace.fromObject = function fromObject(object) {
            if (object instanceof $root.response.SignInToSpace)
                return object;
            let message = new $root.response.SignInToSpace();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.infoSharedObjects) {
                if (!Array.isArray(object.infoSharedObjects))
                    throw TypeError(".response.SignInToSpace.infoSharedObjects: array expected");
                message.infoSharedObjects = [];
                for (let i = 0; i < object.infoSharedObjects.length; ++i) {
                    if (typeof object.infoSharedObjects[i] !== "object")
                        throw TypeError(".response.SignInToSpace.infoSharedObjects: object expected");
                    message.infoSharedObjects[i] = $root.response.InfoOfExternalSharedInResponse.fromObject(object.infoSharedObjects[i]);
                }
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a SignInToSpace message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.SignInToSpace
         * @static
         * @param {response.SignInToSpace} message SignInToSpace
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SignInToSpace.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.infoSharedObjects = [];
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.infoSharedObjects && message.infoSharedObjects.length) {
                object.infoSharedObjects = [];
                for (let j = 0; j < message.infoSharedObjects.length; ++j)
                    object.infoSharedObjects[j] = $root.response.InfoOfExternalSharedInResponse.toObject(message.infoSharedObjects[j], options);
            }
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this SignInToSpace to JSON.
         * @function toJSON
         * @memberof response.SignInToSpace
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SignInToSpace.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for SignInToSpace
         * @function getTypeUrl
         * @memberof response.SignInToSpace
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        SignInToSpace.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.SignInToSpace";
        };

        return SignInToSpace;
    })();

    /**
     * TypeOfPath enum.
     * @name response.TypeOfPath
     * @enum {number}
     * @property {number} TShareUser=0 TShareUser value
     * @property {number} TFolder=1 TFolder value
     * @property {number} TShareTeam=2 TShareTeam value
     * @property {number} TShareExternal=3 TShareExternal value
     */
    response.TypeOfPath = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "TShareUser"] = 0;
        values[valuesById[1] = "TFolder"] = 1;
        values[valuesById[2] = "TShareTeam"] = 2;
        values[valuesById[3] = "TShareExternal"] = 3;
        return values;
    })();

    response.ExternalOwnedObjInfo = (function() {

        /**
         * Properties of an ExternalOwnedObjInfo.
         * @memberof response
         * @interface IExternalOwnedObjInfo
         * @property {string|null} [path] ExternalOwnedObjInfo path
         * @property {string|null} [name] ExternalOwnedObjInfo name
         */

        /**
         * Constructs a new ExternalOwnedObjInfo.
         * @memberof response
         * @classdesc Represents an ExternalOwnedObjInfo.
         * @implements IExternalOwnedObjInfo
         * @constructor
         * @param {response.IExternalOwnedObjInfo=} [properties] Properties to set
         */
        function ExternalOwnedObjInfo(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ExternalOwnedObjInfo path.
         * @member {string} path
         * @memberof response.ExternalOwnedObjInfo
         * @instance
         */
        ExternalOwnedObjInfo.prototype.path = "";

        /**
         * ExternalOwnedObjInfo name.
         * @member {string} name
         * @memberof response.ExternalOwnedObjInfo
         * @instance
         */
        ExternalOwnedObjInfo.prototype.name = "";

        /**
         * Creates a new ExternalOwnedObjInfo instance using the specified properties.
         * @function create
         * @memberof response.ExternalOwnedObjInfo
         * @static
         * @param {response.IExternalOwnedObjInfo=} [properties] Properties to set
         * @returns {response.ExternalOwnedObjInfo} ExternalOwnedObjInfo instance
         */
        ExternalOwnedObjInfo.create = function create(properties) {
            return new ExternalOwnedObjInfo(properties);
        };

        /**
         * Encodes the specified ExternalOwnedObjInfo message. Does not implicitly {@link response.ExternalOwnedObjInfo.verify|verify} messages.
         * @function encode
         * @memberof response.ExternalOwnedObjInfo
         * @static
         * @param {response.IExternalOwnedObjInfo} message ExternalOwnedObjInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ExternalOwnedObjInfo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.path != null && Object.hasOwnProperty.call(message, "path"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.path);
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
            return writer;
        };

        /**
         * Encodes the specified ExternalOwnedObjInfo message, length delimited. Does not implicitly {@link response.ExternalOwnedObjInfo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.ExternalOwnedObjInfo
         * @static
         * @param {response.IExternalOwnedObjInfo} message ExternalOwnedObjInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ExternalOwnedObjInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ExternalOwnedObjInfo message from the specified reader or buffer.
         * @function decode
         * @memberof response.ExternalOwnedObjInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.ExternalOwnedObjInfo} ExternalOwnedObjInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ExternalOwnedObjInfo.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.ExternalOwnedObjInfo();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.path = reader.string();
                        break;
                    }
                case 2: {
                        message.name = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an ExternalOwnedObjInfo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.ExternalOwnedObjInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.ExternalOwnedObjInfo} ExternalOwnedObjInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ExternalOwnedObjInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ExternalOwnedObjInfo message.
         * @function verify
         * @memberof response.ExternalOwnedObjInfo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ExternalOwnedObjInfo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.path != null && message.hasOwnProperty("path"))
                if (!$util.isString(message.path))
                    return "path: string expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            return null;
        };

        /**
         * Creates an ExternalOwnedObjInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.ExternalOwnedObjInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.ExternalOwnedObjInfo} ExternalOwnedObjInfo
         */
        ExternalOwnedObjInfo.fromObject = function fromObject(object) {
            if (object instanceof $root.response.ExternalOwnedObjInfo)
                return object;
            let message = new $root.response.ExternalOwnedObjInfo();
            if (object.path != null)
                message.path = String(object.path);
            if (object.name != null)
                message.name = String(object.name);
            return message;
        };

        /**
         * Creates a plain object from an ExternalOwnedObjInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.ExternalOwnedObjInfo
         * @static
         * @param {response.ExternalOwnedObjInfo} message ExternalOwnedObjInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ExternalOwnedObjInfo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.path = "";
                object.name = "";
            }
            if (message.path != null && message.hasOwnProperty("path"))
                object.path = message.path;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            return object;
        };

        /**
         * Converts this ExternalOwnedObjInfo to JSON.
         * @function toJSON
         * @memberof response.ExternalOwnedObjInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ExternalOwnedObjInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ExternalOwnedObjInfo
         * @function getTypeUrl
         * @memberof response.ExternalOwnedObjInfo
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ExternalOwnedObjInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.ExternalOwnedObjInfo";
        };

        return ExternalOwnedObjInfo;
    })();

    response.ExternalSharedObjInfo = (function() {

        /**
         * Properties of an ExternalSharedObjInfo.
         * @memberof response
         * @interface IExternalSharedObjInfo
         * @property {string|null} [sharedPath] ExternalSharedObjInfo sharedPath
         * @property {string|null} [name] ExternalSharedObjInfo name
         */

        /**
         * Constructs a new ExternalSharedObjInfo.
         * @memberof response
         * @classdesc Represents an ExternalSharedObjInfo.
         * @implements IExternalSharedObjInfo
         * @constructor
         * @param {response.IExternalSharedObjInfo=} [properties] Properties to set
         */
        function ExternalSharedObjInfo(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ExternalSharedObjInfo sharedPath.
         * @member {string} sharedPath
         * @memberof response.ExternalSharedObjInfo
         * @instance
         */
        ExternalSharedObjInfo.prototype.sharedPath = "";

        /**
         * ExternalSharedObjInfo name.
         * @member {string} name
         * @memberof response.ExternalSharedObjInfo
         * @instance
         */
        ExternalSharedObjInfo.prototype.name = "";

        /**
         * Creates a new ExternalSharedObjInfo instance using the specified properties.
         * @function create
         * @memberof response.ExternalSharedObjInfo
         * @static
         * @param {response.IExternalSharedObjInfo=} [properties] Properties to set
         * @returns {response.ExternalSharedObjInfo} ExternalSharedObjInfo instance
         */
        ExternalSharedObjInfo.create = function create(properties) {
            return new ExternalSharedObjInfo(properties);
        };

        /**
         * Encodes the specified ExternalSharedObjInfo message. Does not implicitly {@link response.ExternalSharedObjInfo.verify|verify} messages.
         * @function encode
         * @memberof response.ExternalSharedObjInfo
         * @static
         * @param {response.IExternalSharedObjInfo} message ExternalSharedObjInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ExternalSharedObjInfo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.sharedPath != null && Object.hasOwnProperty.call(message, "sharedPath"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.sharedPath);
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
            return writer;
        };

        /**
         * Encodes the specified ExternalSharedObjInfo message, length delimited. Does not implicitly {@link response.ExternalSharedObjInfo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.ExternalSharedObjInfo
         * @static
         * @param {response.IExternalSharedObjInfo} message ExternalSharedObjInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ExternalSharedObjInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ExternalSharedObjInfo message from the specified reader or buffer.
         * @function decode
         * @memberof response.ExternalSharedObjInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.ExternalSharedObjInfo} ExternalSharedObjInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ExternalSharedObjInfo.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.ExternalSharedObjInfo();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.sharedPath = reader.string();
                        break;
                    }
                case 2: {
                        message.name = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an ExternalSharedObjInfo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.ExternalSharedObjInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.ExternalSharedObjInfo} ExternalSharedObjInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ExternalSharedObjInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ExternalSharedObjInfo message.
         * @function verify
         * @memberof response.ExternalSharedObjInfo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ExternalSharedObjInfo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.sharedPath != null && message.hasOwnProperty("sharedPath"))
                if (!$util.isString(message.sharedPath))
                    return "sharedPath: string expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            return null;
        };

        /**
         * Creates an ExternalSharedObjInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.ExternalSharedObjInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.ExternalSharedObjInfo} ExternalSharedObjInfo
         */
        ExternalSharedObjInfo.fromObject = function fromObject(object) {
            if (object instanceof $root.response.ExternalSharedObjInfo)
                return object;
            let message = new $root.response.ExternalSharedObjInfo();
            if (object.sharedPath != null)
                message.sharedPath = String(object.sharedPath);
            if (object.name != null)
                message.name = String(object.name);
            return message;
        };

        /**
         * Creates a plain object from an ExternalSharedObjInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.ExternalSharedObjInfo
         * @static
         * @param {response.ExternalSharedObjInfo} message ExternalSharedObjInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ExternalSharedObjInfo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.sharedPath = "";
                object.name = "";
            }
            if (message.sharedPath != null && message.hasOwnProperty("sharedPath"))
                object.sharedPath = message.sharedPath;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            return object;
        };

        /**
         * Converts this ExternalSharedObjInfo to JSON.
         * @function toJSON
         * @memberof response.ExternalSharedObjInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ExternalSharedObjInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ExternalSharedObjInfo
         * @function getTypeUrl
         * @memberof response.ExternalSharedObjInfo
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ExternalSharedObjInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.ExternalSharedObjInfo";
        };

        return ExternalSharedObjInfo;
    })();

    /**
     * TypeOfObj enum.
     * @name response.TypeOfObj
     * @enum {number}
     * @property {number} TypeFolder=0 TypeFolder value
     * @property {number} TypeFile=1 TypeFile value
     */
    response.TypeOfObj = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "TypeFolder"] = 0;
        values[valuesById[1] = "TypeFile"] = 1;
        return values;
    })();

    response.ExternalShareObjInfo = (function() {

        /**
         * Properties of an ExternalShareObjInfo.
         * @memberof response
         * @interface IExternalShareObjInfo
         * @property {response.IExternalOwnedObjInfo|null} [externalOwnedObjInfo] ExternalShareObjInfo externalOwnedObjInfo
         * @property {response.IExternalSharedObjInfo|null} [externalSharedObjInfo] ExternalShareObjInfo externalSharedObjInfo
         * @property {Uint8Array|null} [uuidOfObj] ExternalShareObjInfo uuidOfObj
         * @property {response.TypeOfPath|null} [typeOfPath] ExternalShareObjInfo typeOfPath
         * @property {response.TypeOfObj|null} [typeOfObj] ExternalShareObjInfo typeOfObj
         */

        /**
         * Constructs a new ExternalShareObjInfo.
         * @memberof response
         * @classdesc Represents an ExternalShareObjInfo.
         * @implements IExternalShareObjInfo
         * @constructor
         * @param {response.IExternalShareObjInfo=} [properties] Properties to set
         */
        function ExternalShareObjInfo(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ExternalShareObjInfo externalOwnedObjInfo.
         * @member {response.IExternalOwnedObjInfo|null|undefined} externalOwnedObjInfo
         * @memberof response.ExternalShareObjInfo
         * @instance
         */
        ExternalShareObjInfo.prototype.externalOwnedObjInfo = null;

        /**
         * ExternalShareObjInfo externalSharedObjInfo.
         * @member {response.IExternalSharedObjInfo|null|undefined} externalSharedObjInfo
         * @memberof response.ExternalShareObjInfo
         * @instance
         */
        ExternalShareObjInfo.prototype.externalSharedObjInfo = null;

        /**
         * ExternalShareObjInfo uuidOfObj.
         * @member {Uint8Array} uuidOfObj
         * @memberof response.ExternalShareObjInfo
         * @instance
         */
        ExternalShareObjInfo.prototype.uuidOfObj = $util.newBuffer([]);

        /**
         * ExternalShareObjInfo typeOfPath.
         * @member {response.TypeOfPath} typeOfPath
         * @memberof response.ExternalShareObjInfo
         * @instance
         */
        ExternalShareObjInfo.prototype.typeOfPath = 0;

        /**
         * ExternalShareObjInfo typeOfObj.
         * @member {response.TypeOfObj} typeOfObj
         * @memberof response.ExternalShareObjInfo
         * @instance
         */
        ExternalShareObjInfo.prototype.typeOfObj = 0;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * ExternalShareObjInfo ShareType.
         * @member {"externalOwnedObjInfo"|"externalSharedObjInfo"|undefined} ShareType
         * @memberof response.ExternalShareObjInfo
         * @instance
         */
        Object.defineProperty(ExternalShareObjInfo.prototype, "ShareType", {
            get: $util.oneOfGetter($oneOfFields = ["externalOwnedObjInfo", "externalSharedObjInfo"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new ExternalShareObjInfo instance using the specified properties.
         * @function create
         * @memberof response.ExternalShareObjInfo
         * @static
         * @param {response.IExternalShareObjInfo=} [properties] Properties to set
         * @returns {response.ExternalShareObjInfo} ExternalShareObjInfo instance
         */
        ExternalShareObjInfo.create = function create(properties) {
            return new ExternalShareObjInfo(properties);
        };

        /**
         * Encodes the specified ExternalShareObjInfo message. Does not implicitly {@link response.ExternalShareObjInfo.verify|verify} messages.
         * @function encode
         * @memberof response.ExternalShareObjInfo
         * @static
         * @param {response.IExternalShareObjInfo} message ExternalShareObjInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ExternalShareObjInfo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.externalOwnedObjInfo != null && Object.hasOwnProperty.call(message, "externalOwnedObjInfo"))
                $root.response.ExternalOwnedObjInfo.encode(message.externalOwnedObjInfo, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.externalSharedObjInfo != null && Object.hasOwnProperty.call(message, "externalSharedObjInfo"))
                $root.response.ExternalSharedObjInfo.encode(message.externalSharedObjInfo, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.uuidOfObj != null && Object.hasOwnProperty.call(message, "uuidOfObj"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.uuidOfObj);
            if (message.typeOfPath != null && Object.hasOwnProperty.call(message, "typeOfPath"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.typeOfPath);
            if (message.typeOfObj != null && Object.hasOwnProperty.call(message, "typeOfObj"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.typeOfObj);
            return writer;
        };

        /**
         * Encodes the specified ExternalShareObjInfo message, length delimited. Does not implicitly {@link response.ExternalShareObjInfo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.ExternalShareObjInfo
         * @static
         * @param {response.IExternalShareObjInfo} message ExternalShareObjInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ExternalShareObjInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ExternalShareObjInfo message from the specified reader or buffer.
         * @function decode
         * @memberof response.ExternalShareObjInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.ExternalShareObjInfo} ExternalShareObjInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ExternalShareObjInfo.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.ExternalShareObjInfo();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.externalOwnedObjInfo = $root.response.ExternalOwnedObjInfo.decode(reader, reader.uint32());
                        break;
                    }
                case 2: {
                        message.externalSharedObjInfo = $root.response.ExternalSharedObjInfo.decode(reader, reader.uint32());
                        break;
                    }
                case 3: {
                        message.uuidOfObj = reader.bytes();
                        break;
                    }
                case 4: {
                        message.typeOfPath = reader.int32();
                        break;
                    }
                case 5: {
                        message.typeOfObj = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an ExternalShareObjInfo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.ExternalShareObjInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.ExternalShareObjInfo} ExternalShareObjInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ExternalShareObjInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ExternalShareObjInfo message.
         * @function verify
         * @memberof response.ExternalShareObjInfo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ExternalShareObjInfo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.externalOwnedObjInfo != null && message.hasOwnProperty("externalOwnedObjInfo")) {
                properties.ShareType = 1;
                {
                    let error = $root.response.ExternalOwnedObjInfo.verify(message.externalOwnedObjInfo);
                    if (error)
                        return "externalOwnedObjInfo." + error;
                }
            }
            if (message.externalSharedObjInfo != null && message.hasOwnProperty("externalSharedObjInfo")) {
                if (properties.ShareType === 1)
                    return "ShareType: multiple values";
                properties.ShareType = 1;
                {
                    let error = $root.response.ExternalSharedObjInfo.verify(message.externalSharedObjInfo);
                    if (error)
                        return "externalSharedObjInfo." + error;
                }
            }
            if (message.uuidOfObj != null && message.hasOwnProperty("uuidOfObj"))
                if (!(message.uuidOfObj && typeof message.uuidOfObj.length === "number" || $util.isString(message.uuidOfObj)))
                    return "uuidOfObj: buffer expected";
            if (message.typeOfPath != null && message.hasOwnProperty("typeOfPath"))
                switch (message.typeOfPath) {
                default:
                    return "typeOfPath: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            if (message.typeOfObj != null && message.hasOwnProperty("typeOfObj"))
                switch (message.typeOfObj) {
                default:
                    return "typeOfObj: enum value expected";
                case 0:
                case 1:
                    break;
                }
            return null;
        };

        /**
         * Creates an ExternalShareObjInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.ExternalShareObjInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.ExternalShareObjInfo} ExternalShareObjInfo
         */
        ExternalShareObjInfo.fromObject = function fromObject(object) {
            if (object instanceof $root.response.ExternalShareObjInfo)
                return object;
            let message = new $root.response.ExternalShareObjInfo();
            if (object.externalOwnedObjInfo != null) {
                if (typeof object.externalOwnedObjInfo !== "object")
                    throw TypeError(".response.ExternalShareObjInfo.externalOwnedObjInfo: object expected");
                message.externalOwnedObjInfo = $root.response.ExternalOwnedObjInfo.fromObject(object.externalOwnedObjInfo);
            }
            if (object.externalSharedObjInfo != null) {
                if (typeof object.externalSharedObjInfo !== "object")
                    throw TypeError(".response.ExternalShareObjInfo.externalSharedObjInfo: object expected");
                message.externalSharedObjInfo = $root.response.ExternalSharedObjInfo.fromObject(object.externalSharedObjInfo);
            }
            if (object.uuidOfObj != null)
                if (typeof object.uuidOfObj === "string")
                    $util.base64.decode(object.uuidOfObj, message.uuidOfObj = $util.newBuffer($util.base64.length(object.uuidOfObj)), 0);
                else if (object.uuidOfObj.length >= 0)
                    message.uuidOfObj = object.uuidOfObj;
            switch (object.typeOfPath) {
            default:
                if (typeof object.typeOfPath === "number") {
                    message.typeOfPath = object.typeOfPath;
                    break;
                }
                break;
            case "TShareUser":
            case 0:
                message.typeOfPath = 0;
                break;
            case "TFolder":
            case 1:
                message.typeOfPath = 1;
                break;
            case "TShareTeam":
            case 2:
                message.typeOfPath = 2;
                break;
            case "TShareExternal":
            case 3:
                message.typeOfPath = 3;
                break;
            }
            switch (object.typeOfObj) {
            default:
                if (typeof object.typeOfObj === "number") {
                    message.typeOfObj = object.typeOfObj;
                    break;
                }
                break;
            case "TypeFolder":
            case 0:
                message.typeOfObj = 0;
                break;
            case "TypeFile":
            case 1:
                message.typeOfObj = 1;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from an ExternalShareObjInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.ExternalShareObjInfo
         * @static
         * @param {response.ExternalShareObjInfo} message ExternalShareObjInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ExternalShareObjInfo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if (options.bytes === String)
                    object.uuidOfObj = "";
                else {
                    object.uuidOfObj = [];
                    if (options.bytes !== Array)
                        object.uuidOfObj = $util.newBuffer(object.uuidOfObj);
                }
                object.typeOfPath = options.enums === String ? "TShareUser" : 0;
                object.typeOfObj = options.enums === String ? "TypeFolder" : 0;
            }
            if (message.externalOwnedObjInfo != null && message.hasOwnProperty("externalOwnedObjInfo")) {
                object.externalOwnedObjInfo = $root.response.ExternalOwnedObjInfo.toObject(message.externalOwnedObjInfo, options);
                if (options.oneofs)
                    object.ShareType = "externalOwnedObjInfo";
            }
            if (message.externalSharedObjInfo != null && message.hasOwnProperty("externalSharedObjInfo")) {
                object.externalSharedObjInfo = $root.response.ExternalSharedObjInfo.toObject(message.externalSharedObjInfo, options);
                if (options.oneofs)
                    object.ShareType = "externalSharedObjInfo";
            }
            if (message.uuidOfObj != null && message.hasOwnProperty("uuidOfObj"))
                object.uuidOfObj = options.bytes === String ? $util.base64.encode(message.uuidOfObj, 0, message.uuidOfObj.length) : options.bytes === Array ? Array.prototype.slice.call(message.uuidOfObj) : message.uuidOfObj;
            if (message.typeOfPath != null && message.hasOwnProperty("typeOfPath"))
                object.typeOfPath = options.enums === String ? $root.response.TypeOfPath[message.typeOfPath] === undefined ? message.typeOfPath : $root.response.TypeOfPath[message.typeOfPath] : message.typeOfPath;
            if (message.typeOfObj != null && message.hasOwnProperty("typeOfObj"))
                object.typeOfObj = options.enums === String ? $root.response.TypeOfObj[message.typeOfObj] === undefined ? message.typeOfObj : $root.response.TypeOfObj[message.typeOfObj] : message.typeOfObj;
            return object;
        };

        /**
         * Converts this ExternalShareObjInfo to JSON.
         * @function toJSON
         * @memberof response.ExternalShareObjInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ExternalShareObjInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ExternalShareObjInfo
         * @function getTypeUrl
         * @memberof response.ExternalShareObjInfo
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ExternalShareObjInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.ExternalShareObjInfo";
        };

        return ExternalShareObjInfo;
    })();

    /**
     * SpaceAutoDeletion enum.
     * @name response.SpaceAutoDeletion
     * @enum {number}
     * @property {number} USER=0 USER value
     * @property {number} OBJECT=1 OBJECT value
     * @property {number} SPACE=2 SPACE value
     */
    response.SpaceAutoDeletion = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "USER"] = 0;
        values[valuesById[1] = "OBJECT"] = 1;
        values[valuesById[2] = "SPACE"] = 2;
        return values;
    })();

    response.SpaceAutoObjectDeletion = (function() {

        /**
         * Properties of a SpaceAutoObjectDeletion.
         * @memberof response
         * @interface ISpaceAutoObjectDeletion
         * @property {string|null} [object] SpaceAutoObjectDeletion object
         * @property {number|Long|null} [time] SpaceAutoObjectDeletion time
         * @property {response.SpaceAutoDeletion|null} [spaceAutoDeletion] SpaceAutoObjectDeletion spaceAutoDeletion
         */

        /**
         * Constructs a new SpaceAutoObjectDeletion.
         * @memberof response
         * @classdesc Represents a SpaceAutoObjectDeletion.
         * @implements ISpaceAutoObjectDeletion
         * @constructor
         * @param {response.ISpaceAutoObjectDeletion=} [properties] Properties to set
         */
        function SpaceAutoObjectDeletion(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SpaceAutoObjectDeletion object.
         * @member {string} object
         * @memberof response.SpaceAutoObjectDeletion
         * @instance
         */
        SpaceAutoObjectDeletion.prototype.object = "";

        /**
         * SpaceAutoObjectDeletion time.
         * @member {number|Long} time
         * @memberof response.SpaceAutoObjectDeletion
         * @instance
         */
        SpaceAutoObjectDeletion.prototype.time = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * SpaceAutoObjectDeletion spaceAutoDeletion.
         * @member {response.SpaceAutoDeletion} spaceAutoDeletion
         * @memberof response.SpaceAutoObjectDeletion
         * @instance
         */
        SpaceAutoObjectDeletion.prototype.spaceAutoDeletion = 0;

        /**
         * Creates a new SpaceAutoObjectDeletion instance using the specified properties.
         * @function create
         * @memberof response.SpaceAutoObjectDeletion
         * @static
         * @param {response.ISpaceAutoObjectDeletion=} [properties] Properties to set
         * @returns {response.SpaceAutoObjectDeletion} SpaceAutoObjectDeletion instance
         */
        SpaceAutoObjectDeletion.create = function create(properties) {
            return new SpaceAutoObjectDeletion(properties);
        };

        /**
         * Encodes the specified SpaceAutoObjectDeletion message. Does not implicitly {@link response.SpaceAutoObjectDeletion.verify|verify} messages.
         * @function encode
         * @memberof response.SpaceAutoObjectDeletion
         * @static
         * @param {response.ISpaceAutoObjectDeletion} message SpaceAutoObjectDeletion message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SpaceAutoObjectDeletion.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.object != null && Object.hasOwnProperty.call(message, "object"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.object);
            if (message.time != null && Object.hasOwnProperty.call(message, "time"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.time);
            if (message.spaceAutoDeletion != null && Object.hasOwnProperty.call(message, "spaceAutoDeletion"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.spaceAutoDeletion);
            return writer;
        };

        /**
         * Encodes the specified SpaceAutoObjectDeletion message, length delimited. Does not implicitly {@link response.SpaceAutoObjectDeletion.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.SpaceAutoObjectDeletion
         * @static
         * @param {response.ISpaceAutoObjectDeletion} message SpaceAutoObjectDeletion message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SpaceAutoObjectDeletion.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SpaceAutoObjectDeletion message from the specified reader or buffer.
         * @function decode
         * @memberof response.SpaceAutoObjectDeletion
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.SpaceAutoObjectDeletion} SpaceAutoObjectDeletion
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SpaceAutoObjectDeletion.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.SpaceAutoObjectDeletion();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.object = reader.string();
                        break;
                    }
                case 2: {
                        message.time = reader.uint64();
                        break;
                    }
                case 3: {
                        message.spaceAutoDeletion = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SpaceAutoObjectDeletion message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.SpaceAutoObjectDeletion
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.SpaceAutoObjectDeletion} SpaceAutoObjectDeletion
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SpaceAutoObjectDeletion.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SpaceAutoObjectDeletion message.
         * @function verify
         * @memberof response.SpaceAutoObjectDeletion
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SpaceAutoObjectDeletion.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.object != null && message.hasOwnProperty("object"))
                if (!$util.isString(message.object))
                    return "object: string expected";
            if (message.time != null && message.hasOwnProperty("time"))
                if (!$util.isInteger(message.time) && !(message.time && $util.isInteger(message.time.low) && $util.isInteger(message.time.high)))
                    return "time: integer|Long expected";
            if (message.spaceAutoDeletion != null && message.hasOwnProperty("spaceAutoDeletion"))
                switch (message.spaceAutoDeletion) {
                default:
                    return "spaceAutoDeletion: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            return null;
        };

        /**
         * Creates a SpaceAutoObjectDeletion message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.SpaceAutoObjectDeletion
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.SpaceAutoObjectDeletion} SpaceAutoObjectDeletion
         */
        SpaceAutoObjectDeletion.fromObject = function fromObject(object) {
            if (object instanceof $root.response.SpaceAutoObjectDeletion)
                return object;
            let message = new $root.response.SpaceAutoObjectDeletion();
            if (object.object != null)
                message.object = String(object.object);
            if (object.time != null)
                if ($util.Long)
                    (message.time = $util.Long.fromValue(object.time)).unsigned = true;
                else if (typeof object.time === "string")
                    message.time = parseInt(object.time, 10);
                else if (typeof object.time === "number")
                    message.time = object.time;
                else if (typeof object.time === "object")
                    message.time = new $util.LongBits(object.time.low >>> 0, object.time.high >>> 0).toNumber(true);
            switch (object.spaceAutoDeletion) {
            default:
                if (typeof object.spaceAutoDeletion === "number") {
                    message.spaceAutoDeletion = object.spaceAutoDeletion;
                    break;
                }
                break;
            case "USER":
            case 0:
                message.spaceAutoDeletion = 0;
                break;
            case "OBJECT":
            case 1:
                message.spaceAutoDeletion = 1;
                break;
            case "SPACE":
            case 2:
                message.spaceAutoDeletion = 2;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a SpaceAutoObjectDeletion message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.SpaceAutoObjectDeletion
         * @static
         * @param {response.SpaceAutoObjectDeletion} message SpaceAutoObjectDeletion
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SpaceAutoObjectDeletion.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.object = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.time = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.time = options.longs === String ? "0" : 0;
                object.spaceAutoDeletion = options.enums === String ? "USER" : 0;
            }
            if (message.object != null && message.hasOwnProperty("object"))
                object.object = message.object;
            if (message.time != null && message.hasOwnProperty("time"))
                if (typeof message.time === "number")
                    object.time = options.longs === String ? String(message.time) : message.time;
                else
                    object.time = options.longs === String ? $util.Long.prototype.toString.call(message.time) : options.longs === Number ? new $util.LongBits(message.time.low >>> 0, message.time.high >>> 0).toNumber(true) : message.time;
            if (message.spaceAutoDeletion != null && message.hasOwnProperty("spaceAutoDeletion"))
                object.spaceAutoDeletion = options.enums === String ? $root.response.SpaceAutoDeletion[message.spaceAutoDeletion] === undefined ? message.spaceAutoDeletion : $root.response.SpaceAutoDeletion[message.spaceAutoDeletion] : message.spaceAutoDeletion;
            return object;
        };

        /**
         * Converts this SpaceAutoObjectDeletion to JSON.
         * @function toJSON
         * @memberof response.SpaceAutoObjectDeletion
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SpaceAutoObjectDeletion.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for SpaceAutoObjectDeletion
         * @function getTypeUrl
         * @memberof response.SpaceAutoObjectDeletion
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        SpaceAutoObjectDeletion.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.SpaceAutoObjectDeletion";
        };

        return SpaceAutoObjectDeletion;
    })();

    response.IpRange = (function() {

        /**
         * Properties of an IpRange.
         * @memberof response
         * @interface IIpRange
         * @property {string|null} [start] IpRange start
         * @property {string|null} [end] IpRange end
         */

        /**
         * Constructs a new IpRange.
         * @memberof response
         * @classdesc Represents an IpRange.
         * @implements IIpRange
         * @constructor
         * @param {response.IIpRange=} [properties] Properties to set
         */
        function IpRange(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * IpRange start.
         * @member {string} start
         * @memberof response.IpRange
         * @instance
         */
        IpRange.prototype.start = "";

        /**
         * IpRange end.
         * @member {string} end
         * @memberof response.IpRange
         * @instance
         */
        IpRange.prototype.end = "";

        /**
         * Creates a new IpRange instance using the specified properties.
         * @function create
         * @memberof response.IpRange
         * @static
         * @param {response.IIpRange=} [properties] Properties to set
         * @returns {response.IpRange} IpRange instance
         */
        IpRange.create = function create(properties) {
            return new IpRange(properties);
        };

        /**
         * Encodes the specified IpRange message. Does not implicitly {@link response.IpRange.verify|verify} messages.
         * @function encode
         * @memberof response.IpRange
         * @static
         * @param {response.IIpRange} message IpRange message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        IpRange.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.start != null && Object.hasOwnProperty.call(message, "start"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.start);
            if (message.end != null && Object.hasOwnProperty.call(message, "end"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.end);
            return writer;
        };

        /**
         * Encodes the specified IpRange message, length delimited. Does not implicitly {@link response.IpRange.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.IpRange
         * @static
         * @param {response.IIpRange} message IpRange message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        IpRange.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an IpRange message from the specified reader or buffer.
         * @function decode
         * @memberof response.IpRange
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.IpRange} IpRange
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        IpRange.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.IpRange();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.start = reader.string();
                        break;
                    }
                case 2: {
                        message.end = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an IpRange message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.IpRange
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.IpRange} IpRange
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        IpRange.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an IpRange message.
         * @function verify
         * @memberof response.IpRange
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        IpRange.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.start != null && message.hasOwnProperty("start"))
                if (!$util.isString(message.start))
                    return "start: string expected";
            if (message.end != null && message.hasOwnProperty("end"))
                if (!$util.isString(message.end))
                    return "end: string expected";
            return null;
        };

        /**
         * Creates an IpRange message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.IpRange
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.IpRange} IpRange
         */
        IpRange.fromObject = function fromObject(object) {
            if (object instanceof $root.response.IpRange)
                return object;
            let message = new $root.response.IpRange();
            if (object.start != null)
                message.start = String(object.start);
            if (object.end != null)
                message.end = String(object.end);
            return message;
        };

        /**
         * Creates a plain object from an IpRange message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.IpRange
         * @static
         * @param {response.IpRange} message IpRange
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        IpRange.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.start = "";
                object.end = "";
            }
            if (message.start != null && message.hasOwnProperty("start"))
                object.start = message.start;
            if (message.end != null && message.hasOwnProperty("end"))
                object.end = message.end;
            return object;
        };

        /**
         * Converts this IpRange to JSON.
         * @function toJSON
         * @memberof response.IpRange
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        IpRange.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for IpRange
         * @function getTypeUrl
         * @memberof response.IpRange
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        IpRange.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.IpRange";
        };

        return IpRange;
    })();

    response.SpaceObj = (function() {

        /**
         * Properties of a SpaceObj.
         * @memberof response
         * @interface ISpaceObj
         * @property {Array.<string>|null} [userEmails] SpaceObj userEmails
         * @property {Array.<response.IExternalShareObjInfo>|null} [infoOfSharedObjs] SpaceObj infoOfSharedObjs
         * @property {string|null} [name] SpaceObj name
         * @property {Array.<response.SpaceOpPermissions>|null} [operations] SpaceObj operations
         * @property {number|Long|null} [creationTime] SpaceObj creationTime
         * @property {number|Long|null} [updatedTime] SpaceObj updatedTime
         * @property {string|null} [token] SpaceObj token
         * @property {number|Long|null} [maxSpaceSize] SpaceObj maxSpaceSize
         * @property {number|Long|null} [maxFileSize] SpaceObj maxFileSize
         * @property {Array.<response.ISpaceAutoObjectDeletion>|null} [objects] SpaceObj objects
         * @property {Array.<string>|null} [allowedFileTypes] SpaceObj allowedFileTypes
         * @property {number|Long|null} [sizeConsumed] SpaceObj sizeConsumed
         * @property {Array.<string>|null} [deniedFileTypes] SpaceObj deniedFileTypes
         * @property {Array.<string>|null} [allowedLocations] SpaceObj allowedLocations
         * @property {Array.<string>|null} [deniedLocations] SpaceObj deniedLocations
         * @property {Array.<string>|null} [allowedRegions] SpaceObj allowedRegions
         * @property {Array.<string>|null} [deniedRegions] SpaceObj deniedRegions
         * @property {Array.<string>|null} [allowedIps] SpaceObj allowedIps
         * @property {Array.<string>|null} [deniedIps] SpaceObj deniedIps
         * @property {number|null} [userTillNow] SpaceObj userTillNow
         * @property {number|null} [objectsTillNow] SpaceObj objectsTillNow
         */

        /**
         * Constructs a new SpaceObj.
         * @memberof response
         * @classdesc Represents a SpaceObj.
         * @implements ISpaceObj
         * @constructor
         * @param {response.ISpaceObj=} [properties] Properties to set
         */
        function SpaceObj(properties) {
            this.userEmails = [];
            this.infoOfSharedObjs = [];
            this.operations = [];
            this.objects = [];
            this.allowedFileTypes = [];
            this.deniedFileTypes = [];
            this.allowedLocations = [];
            this.deniedLocations = [];
            this.allowedRegions = [];
            this.deniedRegions = [];
            this.allowedIps = [];
            this.deniedIps = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SpaceObj userEmails.
         * @member {Array.<string>} userEmails
         * @memberof response.SpaceObj
         * @instance
         */
        SpaceObj.prototype.userEmails = $util.emptyArray;

        /**
         * SpaceObj infoOfSharedObjs.
         * @member {Array.<response.IExternalShareObjInfo>} infoOfSharedObjs
         * @memberof response.SpaceObj
         * @instance
         */
        SpaceObj.prototype.infoOfSharedObjs = $util.emptyArray;

        /**
         * SpaceObj name.
         * @member {string} name
         * @memberof response.SpaceObj
         * @instance
         */
        SpaceObj.prototype.name = "";

        /**
         * SpaceObj operations.
         * @member {Array.<response.SpaceOpPermissions>} operations
         * @memberof response.SpaceObj
         * @instance
         */
        SpaceObj.prototype.operations = $util.emptyArray;

        /**
         * SpaceObj creationTime.
         * @member {number|Long} creationTime
         * @memberof response.SpaceObj
         * @instance
         */
        SpaceObj.prototype.creationTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * SpaceObj updatedTime.
         * @member {number|Long} updatedTime
         * @memberof response.SpaceObj
         * @instance
         */
        SpaceObj.prototype.updatedTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * SpaceObj token.
         * @member {string} token
         * @memberof response.SpaceObj
         * @instance
         */
        SpaceObj.prototype.token = "";

        /**
         * SpaceObj maxSpaceSize.
         * @member {number|Long|null|undefined} maxSpaceSize
         * @memberof response.SpaceObj
         * @instance
         */
        SpaceObj.prototype.maxSpaceSize = null;

        /**
         * SpaceObj maxFileSize.
         * @member {number|Long|null|undefined} maxFileSize
         * @memberof response.SpaceObj
         * @instance
         */
        SpaceObj.prototype.maxFileSize = null;

        /**
         * SpaceObj objects.
         * @member {Array.<response.ISpaceAutoObjectDeletion>} objects
         * @memberof response.SpaceObj
         * @instance
         */
        SpaceObj.prototype.objects = $util.emptyArray;

        /**
         * SpaceObj allowedFileTypes.
         * @member {Array.<string>} allowedFileTypes
         * @memberof response.SpaceObj
         * @instance
         */
        SpaceObj.prototype.allowedFileTypes = $util.emptyArray;

        /**
         * SpaceObj sizeConsumed.
         * @member {number|Long|null|undefined} sizeConsumed
         * @memberof response.SpaceObj
         * @instance
         */
        SpaceObj.prototype.sizeConsumed = null;

        /**
         * SpaceObj deniedFileTypes.
         * @member {Array.<string>} deniedFileTypes
         * @memberof response.SpaceObj
         * @instance
         */
        SpaceObj.prototype.deniedFileTypes = $util.emptyArray;

        /**
         * SpaceObj allowedLocations.
         * @member {Array.<string>} allowedLocations
         * @memberof response.SpaceObj
         * @instance
         */
        SpaceObj.prototype.allowedLocations = $util.emptyArray;

        /**
         * SpaceObj deniedLocations.
         * @member {Array.<string>} deniedLocations
         * @memberof response.SpaceObj
         * @instance
         */
        SpaceObj.prototype.deniedLocations = $util.emptyArray;

        /**
         * SpaceObj allowedRegions.
         * @member {Array.<string>} allowedRegions
         * @memberof response.SpaceObj
         * @instance
         */
        SpaceObj.prototype.allowedRegions = $util.emptyArray;

        /**
         * SpaceObj deniedRegions.
         * @member {Array.<string>} deniedRegions
         * @memberof response.SpaceObj
         * @instance
         */
        SpaceObj.prototype.deniedRegions = $util.emptyArray;

        /**
         * SpaceObj allowedIps.
         * @member {Array.<string>} allowedIps
         * @memberof response.SpaceObj
         * @instance
         */
        SpaceObj.prototype.allowedIps = $util.emptyArray;

        /**
         * SpaceObj deniedIps.
         * @member {Array.<string>} deniedIps
         * @memberof response.SpaceObj
         * @instance
         */
        SpaceObj.prototype.deniedIps = $util.emptyArray;

        /**
         * SpaceObj userTillNow.
         * @member {number} userTillNow
         * @memberof response.SpaceObj
         * @instance
         */
        SpaceObj.prototype.userTillNow = 0;

        /**
         * SpaceObj objectsTillNow.
         * @member {number} objectsTillNow
         * @memberof response.SpaceObj
         * @instance
         */
        SpaceObj.prototype.objectsTillNow = 0;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(SpaceObj.prototype, "_maxSpaceSize", {
            get: $util.oneOfGetter($oneOfFields = ["maxSpaceSize"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(SpaceObj.prototype, "_maxFileSize", {
            get: $util.oneOfGetter($oneOfFields = ["maxFileSize"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(SpaceObj.prototype, "_sizeConsumed", {
            get: $util.oneOfGetter($oneOfFields = ["sizeConsumed"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new SpaceObj instance using the specified properties.
         * @function create
         * @memberof response.SpaceObj
         * @static
         * @param {response.ISpaceObj=} [properties] Properties to set
         * @returns {response.SpaceObj} SpaceObj instance
         */
        SpaceObj.create = function create(properties) {
            return new SpaceObj(properties);
        };

        /**
         * Encodes the specified SpaceObj message. Does not implicitly {@link response.SpaceObj.verify|verify} messages.
         * @function encode
         * @memberof response.SpaceObj
         * @static
         * @param {response.ISpaceObj} message SpaceObj message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SpaceObj.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.userEmails != null && message.userEmails.length)
                for (let i = 0; i < message.userEmails.length; ++i)
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.userEmails[i]);
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.name);
            if (message.operations != null && message.operations.length) {
                writer.uint32(/* id 4, wireType 2 =*/34).fork();
                for (let i = 0; i < message.operations.length; ++i)
                    writer.int32(message.operations[i]);
                writer.ldelim();
            }
            if (message.creationTime != null && Object.hasOwnProperty.call(message, "creationTime"))
                writer.uint32(/* id 5, wireType 0 =*/40).uint64(message.creationTime);
            if (message.updatedTime != null && Object.hasOwnProperty.call(message, "updatedTime"))
                writer.uint32(/* id 6, wireType 0 =*/48).uint64(message.updatedTime);
            if (message.infoOfSharedObjs != null && message.infoOfSharedObjs.length)
                for (let i = 0; i < message.infoOfSharedObjs.length; ++i)
                    $root.response.ExternalShareObjInfo.encode(message.infoOfSharedObjs[i], writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
            if (message.token != null && Object.hasOwnProperty.call(message, "token"))
                writer.uint32(/* id 9, wireType 2 =*/74).string(message.token);
            if (message.maxSpaceSize != null && Object.hasOwnProperty.call(message, "maxSpaceSize"))
                writer.uint32(/* id 10, wireType 0 =*/80).uint64(message.maxSpaceSize);
            if (message.maxFileSize != null && Object.hasOwnProperty.call(message, "maxFileSize"))
                writer.uint32(/* id 11, wireType 0 =*/88).uint64(message.maxFileSize);
            if (message.objects != null && message.objects.length)
                for (let i = 0; i < message.objects.length; ++i)
                    $root.response.SpaceAutoObjectDeletion.encode(message.objects[i], writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
            if (message.allowedFileTypes != null && message.allowedFileTypes.length)
                for (let i = 0; i < message.allowedFileTypes.length; ++i)
                    writer.uint32(/* id 13, wireType 2 =*/106).string(message.allowedFileTypes[i]);
            if (message.sizeConsumed != null && Object.hasOwnProperty.call(message, "sizeConsumed"))
                writer.uint32(/* id 14, wireType 0 =*/112).uint64(message.sizeConsumed);
            if (message.deniedFileTypes != null && message.deniedFileTypes.length)
                for (let i = 0; i < message.deniedFileTypes.length; ++i)
                    writer.uint32(/* id 15, wireType 2 =*/122).string(message.deniedFileTypes[i]);
            if (message.allowedLocations != null && message.allowedLocations.length)
                for (let i = 0; i < message.allowedLocations.length; ++i)
                    writer.uint32(/* id 16, wireType 2 =*/130).string(message.allowedLocations[i]);
            if (message.deniedLocations != null && message.deniedLocations.length)
                for (let i = 0; i < message.deniedLocations.length; ++i)
                    writer.uint32(/* id 17, wireType 2 =*/138).string(message.deniedLocations[i]);
            if (message.allowedRegions != null && message.allowedRegions.length)
                for (let i = 0; i < message.allowedRegions.length; ++i)
                    writer.uint32(/* id 18, wireType 2 =*/146).string(message.allowedRegions[i]);
            if (message.deniedRegions != null && message.deniedRegions.length)
                for (let i = 0; i < message.deniedRegions.length; ++i)
                    writer.uint32(/* id 19, wireType 2 =*/154).string(message.deniedRegions[i]);
            if (message.allowedIps != null && message.allowedIps.length)
                for (let i = 0; i < message.allowedIps.length; ++i)
                    writer.uint32(/* id 20, wireType 2 =*/162).string(message.allowedIps[i]);
            if (message.deniedIps != null && message.deniedIps.length)
                for (let i = 0; i < message.deniedIps.length; ++i)
                    writer.uint32(/* id 21, wireType 2 =*/170).string(message.deniedIps[i]);
            if (message.userTillNow != null && Object.hasOwnProperty.call(message, "userTillNow"))
                writer.uint32(/* id 22, wireType 0 =*/176).uint32(message.userTillNow);
            if (message.objectsTillNow != null && Object.hasOwnProperty.call(message, "objectsTillNow"))
                writer.uint32(/* id 23, wireType 0 =*/184).uint32(message.objectsTillNow);
            return writer;
        };

        /**
         * Encodes the specified SpaceObj message, length delimited. Does not implicitly {@link response.SpaceObj.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.SpaceObj
         * @static
         * @param {response.ISpaceObj} message SpaceObj message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SpaceObj.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SpaceObj message from the specified reader or buffer.
         * @function decode
         * @memberof response.SpaceObj
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.SpaceObj} SpaceObj
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SpaceObj.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.SpaceObj();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        if (!(message.userEmails && message.userEmails.length))
                            message.userEmails = [];
                        message.userEmails.push(reader.string());
                        break;
                    }
                case 7: {
                        if (!(message.infoOfSharedObjs && message.infoOfSharedObjs.length))
                            message.infoOfSharedObjs = [];
                        message.infoOfSharedObjs.push($root.response.ExternalShareObjInfo.decode(reader, reader.uint32()));
                        break;
                    }
                case 3: {
                        message.name = reader.string();
                        break;
                    }
                case 4: {
                        if (!(message.operations && message.operations.length))
                            message.operations = [];
                        if ((tag & 7) === 2) {
                            let end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.operations.push(reader.int32());
                        } else
                            message.operations.push(reader.int32());
                        break;
                    }
                case 5: {
                        message.creationTime = reader.uint64();
                        break;
                    }
                case 6: {
                        message.updatedTime = reader.uint64();
                        break;
                    }
                case 9: {
                        message.token = reader.string();
                        break;
                    }
                case 10: {
                        message.maxSpaceSize = reader.uint64();
                        break;
                    }
                case 11: {
                        message.maxFileSize = reader.uint64();
                        break;
                    }
                case 12: {
                        if (!(message.objects && message.objects.length))
                            message.objects = [];
                        message.objects.push($root.response.SpaceAutoObjectDeletion.decode(reader, reader.uint32()));
                        break;
                    }
                case 13: {
                        if (!(message.allowedFileTypes && message.allowedFileTypes.length))
                            message.allowedFileTypes = [];
                        message.allowedFileTypes.push(reader.string());
                        break;
                    }
                case 14: {
                        message.sizeConsumed = reader.uint64();
                        break;
                    }
                case 15: {
                        if (!(message.deniedFileTypes && message.deniedFileTypes.length))
                            message.deniedFileTypes = [];
                        message.deniedFileTypes.push(reader.string());
                        break;
                    }
                case 16: {
                        if (!(message.allowedLocations && message.allowedLocations.length))
                            message.allowedLocations = [];
                        message.allowedLocations.push(reader.string());
                        break;
                    }
                case 17: {
                        if (!(message.deniedLocations && message.deniedLocations.length))
                            message.deniedLocations = [];
                        message.deniedLocations.push(reader.string());
                        break;
                    }
                case 18: {
                        if (!(message.allowedRegions && message.allowedRegions.length))
                            message.allowedRegions = [];
                        message.allowedRegions.push(reader.string());
                        break;
                    }
                case 19: {
                        if (!(message.deniedRegions && message.deniedRegions.length))
                            message.deniedRegions = [];
                        message.deniedRegions.push(reader.string());
                        break;
                    }
                case 20: {
                        if (!(message.allowedIps && message.allowedIps.length))
                            message.allowedIps = [];
                        message.allowedIps.push(reader.string());
                        break;
                    }
                case 21: {
                        if (!(message.deniedIps && message.deniedIps.length))
                            message.deniedIps = [];
                        message.deniedIps.push(reader.string());
                        break;
                    }
                case 22: {
                        message.userTillNow = reader.uint32();
                        break;
                    }
                case 23: {
                        message.objectsTillNow = reader.uint32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SpaceObj message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.SpaceObj
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.SpaceObj} SpaceObj
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SpaceObj.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SpaceObj message.
         * @function verify
         * @memberof response.SpaceObj
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SpaceObj.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.userEmails != null && message.hasOwnProperty("userEmails")) {
                if (!Array.isArray(message.userEmails))
                    return "userEmails: array expected";
                for (let i = 0; i < message.userEmails.length; ++i)
                    if (!$util.isString(message.userEmails[i]))
                        return "userEmails: string[] expected";
            }
            if (message.infoOfSharedObjs != null && message.hasOwnProperty("infoOfSharedObjs")) {
                if (!Array.isArray(message.infoOfSharedObjs))
                    return "infoOfSharedObjs: array expected";
                for (let i = 0; i < message.infoOfSharedObjs.length; ++i) {
                    let error = $root.response.ExternalShareObjInfo.verify(message.infoOfSharedObjs[i]);
                    if (error)
                        return "infoOfSharedObjs." + error;
                }
            }
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.operations != null && message.hasOwnProperty("operations")) {
                if (!Array.isArray(message.operations))
                    return "operations: array expected";
                for (let i = 0; i < message.operations.length; ++i)
                    switch (message.operations[i]) {
                    default:
                        return "operations: enum value[] expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                    case 8:
                    case 9:
                    case 10:
                    case 11:
                    case 12:
                    case 13:
                    case 14:
                    case 15:
                        break;
                    }
            }
            if (message.creationTime != null && message.hasOwnProperty("creationTime"))
                if (!$util.isInteger(message.creationTime) && !(message.creationTime && $util.isInteger(message.creationTime.low) && $util.isInteger(message.creationTime.high)))
                    return "creationTime: integer|Long expected";
            if (message.updatedTime != null && message.hasOwnProperty("updatedTime"))
                if (!$util.isInteger(message.updatedTime) && !(message.updatedTime && $util.isInteger(message.updatedTime.low) && $util.isInteger(message.updatedTime.high)))
                    return "updatedTime: integer|Long expected";
            if (message.token != null && message.hasOwnProperty("token"))
                if (!$util.isString(message.token))
                    return "token: string expected";
            if (message.maxSpaceSize != null && message.hasOwnProperty("maxSpaceSize")) {
                properties._maxSpaceSize = 1;
                if (!$util.isInteger(message.maxSpaceSize) && !(message.maxSpaceSize && $util.isInteger(message.maxSpaceSize.low) && $util.isInteger(message.maxSpaceSize.high)))
                    return "maxSpaceSize: integer|Long expected";
            }
            if (message.maxFileSize != null && message.hasOwnProperty("maxFileSize")) {
                properties._maxFileSize = 1;
                if (!$util.isInteger(message.maxFileSize) && !(message.maxFileSize && $util.isInteger(message.maxFileSize.low) && $util.isInteger(message.maxFileSize.high)))
                    return "maxFileSize: integer|Long expected";
            }
            if (message.objects != null && message.hasOwnProperty("objects")) {
                if (!Array.isArray(message.objects))
                    return "objects: array expected";
                for (let i = 0; i < message.objects.length; ++i) {
                    let error = $root.response.SpaceAutoObjectDeletion.verify(message.objects[i]);
                    if (error)
                        return "objects." + error;
                }
            }
            if (message.allowedFileTypes != null && message.hasOwnProperty("allowedFileTypes")) {
                if (!Array.isArray(message.allowedFileTypes))
                    return "allowedFileTypes: array expected";
                for (let i = 0; i < message.allowedFileTypes.length; ++i)
                    if (!$util.isString(message.allowedFileTypes[i]))
                        return "allowedFileTypes: string[] expected";
            }
            if (message.sizeConsumed != null && message.hasOwnProperty("sizeConsumed")) {
                properties._sizeConsumed = 1;
                if (!$util.isInteger(message.sizeConsumed) && !(message.sizeConsumed && $util.isInteger(message.sizeConsumed.low) && $util.isInteger(message.sizeConsumed.high)))
                    return "sizeConsumed: integer|Long expected";
            }
            if (message.deniedFileTypes != null && message.hasOwnProperty("deniedFileTypes")) {
                if (!Array.isArray(message.deniedFileTypes))
                    return "deniedFileTypes: array expected";
                for (let i = 0; i < message.deniedFileTypes.length; ++i)
                    if (!$util.isString(message.deniedFileTypes[i]))
                        return "deniedFileTypes: string[] expected";
            }
            if (message.allowedLocations != null && message.hasOwnProperty("allowedLocations")) {
                if (!Array.isArray(message.allowedLocations))
                    return "allowedLocations: array expected";
                for (let i = 0; i < message.allowedLocations.length; ++i)
                    if (!$util.isString(message.allowedLocations[i]))
                        return "allowedLocations: string[] expected";
            }
            if (message.deniedLocations != null && message.hasOwnProperty("deniedLocations")) {
                if (!Array.isArray(message.deniedLocations))
                    return "deniedLocations: array expected";
                for (let i = 0; i < message.deniedLocations.length; ++i)
                    if (!$util.isString(message.deniedLocations[i]))
                        return "deniedLocations: string[] expected";
            }
            if (message.allowedRegions != null && message.hasOwnProperty("allowedRegions")) {
                if (!Array.isArray(message.allowedRegions))
                    return "allowedRegions: array expected";
                for (let i = 0; i < message.allowedRegions.length; ++i)
                    if (!$util.isString(message.allowedRegions[i]))
                        return "allowedRegions: string[] expected";
            }
            if (message.deniedRegions != null && message.hasOwnProperty("deniedRegions")) {
                if (!Array.isArray(message.deniedRegions))
                    return "deniedRegions: array expected";
                for (let i = 0; i < message.deniedRegions.length; ++i)
                    if (!$util.isString(message.deniedRegions[i]))
                        return "deniedRegions: string[] expected";
            }
            if (message.allowedIps != null && message.hasOwnProperty("allowedIps")) {
                if (!Array.isArray(message.allowedIps))
                    return "allowedIps: array expected";
                for (let i = 0; i < message.allowedIps.length; ++i)
                    if (!$util.isString(message.allowedIps[i]))
                        return "allowedIps: string[] expected";
            }
            if (message.deniedIps != null && message.hasOwnProperty("deniedIps")) {
                if (!Array.isArray(message.deniedIps))
                    return "deniedIps: array expected";
                for (let i = 0; i < message.deniedIps.length; ++i)
                    if (!$util.isString(message.deniedIps[i]))
                        return "deniedIps: string[] expected";
            }
            if (message.userTillNow != null && message.hasOwnProperty("userTillNow"))
                if (!$util.isInteger(message.userTillNow))
                    return "userTillNow: integer expected";
            if (message.objectsTillNow != null && message.hasOwnProperty("objectsTillNow"))
                if (!$util.isInteger(message.objectsTillNow))
                    return "objectsTillNow: integer expected";
            return null;
        };

        /**
         * Creates a SpaceObj message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.SpaceObj
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.SpaceObj} SpaceObj
         */
        SpaceObj.fromObject = function fromObject(object) {
            if (object instanceof $root.response.SpaceObj)
                return object;
            let message = new $root.response.SpaceObj();
            if (object.userEmails) {
                if (!Array.isArray(object.userEmails))
                    throw TypeError(".response.SpaceObj.userEmails: array expected");
                message.userEmails = [];
                for (let i = 0; i < object.userEmails.length; ++i)
                    message.userEmails[i] = String(object.userEmails[i]);
            }
            if (object.infoOfSharedObjs) {
                if (!Array.isArray(object.infoOfSharedObjs))
                    throw TypeError(".response.SpaceObj.infoOfSharedObjs: array expected");
                message.infoOfSharedObjs = [];
                for (let i = 0; i < object.infoOfSharedObjs.length; ++i) {
                    if (typeof object.infoOfSharedObjs[i] !== "object")
                        throw TypeError(".response.SpaceObj.infoOfSharedObjs: object expected");
                    message.infoOfSharedObjs[i] = $root.response.ExternalShareObjInfo.fromObject(object.infoOfSharedObjs[i]);
                }
            }
            if (object.name != null)
                message.name = String(object.name);
            if (object.operations) {
                if (!Array.isArray(object.operations))
                    throw TypeError(".response.SpaceObj.operations: array expected");
                message.operations = [];
                for (let i = 0; i < object.operations.length; ++i)
                    switch (object.operations[i]) {
                    default:
                        if (typeof object.operations[i] === "number") {
                            message.operations[i] = object.operations[i];
                            break;
                        }
                    case "SpaceOpGetMetaFromPath":
                    case 0:
                        message.operations[i] = 0;
                        break;
                    case "SpaceOpGetChunk":
                    case 1:
                        message.operations[i] = 1;
                        break;
                    case "SpaceOpListFiles":
                    case 2:
                        message.operations[i] = 2;
                        break;
                    case "SpaceOpGetFolder":
                    case 3:
                        message.operations[i] = 3;
                        break;
                    case "SpaceOpStartWrite":
                    case 4:
                        message.operations[i] = 4;
                        break;
                    case "SpaceOpPutChunk":
                    case 5:
                        message.operations[i] = 5;
                        break;
                    case "SpaceOpFinalizeWrite":
                    case 6:
                        message.operations[i] = 6;
                        break;
                    case "SpaceOpCreateFolder":
                    case 7:
                        message.operations[i] = 7;
                        break;
                    case "SpaceOpCopyFile":
                    case 8:
                        message.operations[i] = 8;
                        break;
                    case "SpaceOpCopyFolder":
                    case 9:
                        message.operations[i] = 9;
                        break;
                    case "SpaceOpCopy":
                    case 10:
                        message.operations[i] = 10;
                        break;
                    case "SpaceAddComment":
                    case 11:
                        message.operations[i] = 11;
                        break;
                    case "SpaceListComments":
                    case 12:
                        message.operations[i] = 12;
                        break;
                    case "SpaceUpdateComment":
                    case 13:
                        message.operations[i] = 13;
                        break;
                    case "SpaceRemoveComment":
                    case 14:
                        message.operations[i] = 14;
                        break;
                    case "SpaceGetComment":
                    case 15:
                        message.operations[i] = 15;
                        break;
                    }
            }
            if (object.creationTime != null)
                if ($util.Long)
                    (message.creationTime = $util.Long.fromValue(object.creationTime)).unsigned = true;
                else if (typeof object.creationTime === "string")
                    message.creationTime = parseInt(object.creationTime, 10);
                else if (typeof object.creationTime === "number")
                    message.creationTime = object.creationTime;
                else if (typeof object.creationTime === "object")
                    message.creationTime = new $util.LongBits(object.creationTime.low >>> 0, object.creationTime.high >>> 0).toNumber(true);
            if (object.updatedTime != null)
                if ($util.Long)
                    (message.updatedTime = $util.Long.fromValue(object.updatedTime)).unsigned = true;
                else if (typeof object.updatedTime === "string")
                    message.updatedTime = parseInt(object.updatedTime, 10);
                else if (typeof object.updatedTime === "number")
                    message.updatedTime = object.updatedTime;
                else if (typeof object.updatedTime === "object")
                    message.updatedTime = new $util.LongBits(object.updatedTime.low >>> 0, object.updatedTime.high >>> 0).toNumber(true);
            if (object.token != null)
                message.token = String(object.token);
            if (object.maxSpaceSize != null)
                if ($util.Long)
                    (message.maxSpaceSize = $util.Long.fromValue(object.maxSpaceSize)).unsigned = true;
                else if (typeof object.maxSpaceSize === "string")
                    message.maxSpaceSize = parseInt(object.maxSpaceSize, 10);
                else if (typeof object.maxSpaceSize === "number")
                    message.maxSpaceSize = object.maxSpaceSize;
                else if (typeof object.maxSpaceSize === "object")
                    message.maxSpaceSize = new $util.LongBits(object.maxSpaceSize.low >>> 0, object.maxSpaceSize.high >>> 0).toNumber(true);
            if (object.maxFileSize != null)
                if ($util.Long)
                    (message.maxFileSize = $util.Long.fromValue(object.maxFileSize)).unsigned = true;
                else if (typeof object.maxFileSize === "string")
                    message.maxFileSize = parseInt(object.maxFileSize, 10);
                else if (typeof object.maxFileSize === "number")
                    message.maxFileSize = object.maxFileSize;
                else if (typeof object.maxFileSize === "object")
                    message.maxFileSize = new $util.LongBits(object.maxFileSize.low >>> 0, object.maxFileSize.high >>> 0).toNumber(true);
            if (object.objects) {
                if (!Array.isArray(object.objects))
                    throw TypeError(".response.SpaceObj.objects: array expected");
                message.objects = [];
                for (let i = 0; i < object.objects.length; ++i) {
                    if (typeof object.objects[i] !== "object")
                        throw TypeError(".response.SpaceObj.objects: object expected");
                    message.objects[i] = $root.response.SpaceAutoObjectDeletion.fromObject(object.objects[i]);
                }
            }
            if (object.allowedFileTypes) {
                if (!Array.isArray(object.allowedFileTypes))
                    throw TypeError(".response.SpaceObj.allowedFileTypes: array expected");
                message.allowedFileTypes = [];
                for (let i = 0; i < object.allowedFileTypes.length; ++i)
                    message.allowedFileTypes[i] = String(object.allowedFileTypes[i]);
            }
            if (object.sizeConsumed != null)
                if ($util.Long)
                    (message.sizeConsumed = $util.Long.fromValue(object.sizeConsumed)).unsigned = true;
                else if (typeof object.sizeConsumed === "string")
                    message.sizeConsumed = parseInt(object.sizeConsumed, 10);
                else if (typeof object.sizeConsumed === "number")
                    message.sizeConsumed = object.sizeConsumed;
                else if (typeof object.sizeConsumed === "object")
                    message.sizeConsumed = new $util.LongBits(object.sizeConsumed.low >>> 0, object.sizeConsumed.high >>> 0).toNumber(true);
            if (object.deniedFileTypes) {
                if (!Array.isArray(object.deniedFileTypes))
                    throw TypeError(".response.SpaceObj.deniedFileTypes: array expected");
                message.deniedFileTypes = [];
                for (let i = 0; i < object.deniedFileTypes.length; ++i)
                    message.deniedFileTypes[i] = String(object.deniedFileTypes[i]);
            }
            if (object.allowedLocations) {
                if (!Array.isArray(object.allowedLocations))
                    throw TypeError(".response.SpaceObj.allowedLocations: array expected");
                message.allowedLocations = [];
                for (let i = 0; i < object.allowedLocations.length; ++i)
                    message.allowedLocations[i] = String(object.allowedLocations[i]);
            }
            if (object.deniedLocations) {
                if (!Array.isArray(object.deniedLocations))
                    throw TypeError(".response.SpaceObj.deniedLocations: array expected");
                message.deniedLocations = [];
                for (let i = 0; i < object.deniedLocations.length; ++i)
                    message.deniedLocations[i] = String(object.deniedLocations[i]);
            }
            if (object.allowedRegions) {
                if (!Array.isArray(object.allowedRegions))
                    throw TypeError(".response.SpaceObj.allowedRegions: array expected");
                message.allowedRegions = [];
                for (let i = 0; i < object.allowedRegions.length; ++i)
                    message.allowedRegions[i] = String(object.allowedRegions[i]);
            }
            if (object.deniedRegions) {
                if (!Array.isArray(object.deniedRegions))
                    throw TypeError(".response.SpaceObj.deniedRegions: array expected");
                message.deniedRegions = [];
                for (let i = 0; i < object.deniedRegions.length; ++i)
                    message.deniedRegions[i] = String(object.deniedRegions[i]);
            }
            if (object.allowedIps) {
                if (!Array.isArray(object.allowedIps))
                    throw TypeError(".response.SpaceObj.allowedIps: array expected");
                message.allowedIps = [];
                for (let i = 0; i < object.allowedIps.length; ++i)
                    message.allowedIps[i] = String(object.allowedIps[i]);
            }
            if (object.deniedIps) {
                if (!Array.isArray(object.deniedIps))
                    throw TypeError(".response.SpaceObj.deniedIps: array expected");
                message.deniedIps = [];
                for (let i = 0; i < object.deniedIps.length; ++i)
                    message.deniedIps[i] = String(object.deniedIps[i]);
            }
            if (object.userTillNow != null)
                message.userTillNow = object.userTillNow >>> 0;
            if (object.objectsTillNow != null)
                message.objectsTillNow = object.objectsTillNow >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a SpaceObj message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.SpaceObj
         * @static
         * @param {response.SpaceObj} message SpaceObj
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SpaceObj.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.userEmails = [];
                object.operations = [];
                object.infoOfSharedObjs = [];
                object.objects = [];
                object.allowedFileTypes = [];
                object.deniedFileTypes = [];
                object.allowedLocations = [];
                object.deniedLocations = [];
                object.allowedRegions = [];
                object.deniedRegions = [];
                object.allowedIps = [];
                object.deniedIps = [];
            }
            if (options.defaults) {
                object.name = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.creationTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.creationTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.updatedTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.updatedTime = options.longs === String ? "0" : 0;
                object.token = "";
                object.userTillNow = 0;
                object.objectsTillNow = 0;
            }
            if (message.userEmails && message.userEmails.length) {
                object.userEmails = [];
                for (let j = 0; j < message.userEmails.length; ++j)
                    object.userEmails[j] = message.userEmails[j];
            }
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.operations && message.operations.length) {
                object.operations = [];
                for (let j = 0; j < message.operations.length; ++j)
                    object.operations[j] = options.enums === String ? $root.response.SpaceOpPermissions[message.operations[j]] === undefined ? message.operations[j] : $root.response.SpaceOpPermissions[message.operations[j]] : message.operations[j];
            }
            if (message.creationTime != null && message.hasOwnProperty("creationTime"))
                if (typeof message.creationTime === "number")
                    object.creationTime = options.longs === String ? String(message.creationTime) : message.creationTime;
                else
                    object.creationTime = options.longs === String ? $util.Long.prototype.toString.call(message.creationTime) : options.longs === Number ? new $util.LongBits(message.creationTime.low >>> 0, message.creationTime.high >>> 0).toNumber(true) : message.creationTime;
            if (message.updatedTime != null && message.hasOwnProperty("updatedTime"))
                if (typeof message.updatedTime === "number")
                    object.updatedTime = options.longs === String ? String(message.updatedTime) : message.updatedTime;
                else
                    object.updatedTime = options.longs === String ? $util.Long.prototype.toString.call(message.updatedTime) : options.longs === Number ? new $util.LongBits(message.updatedTime.low >>> 0, message.updatedTime.high >>> 0).toNumber(true) : message.updatedTime;
            if (message.infoOfSharedObjs && message.infoOfSharedObjs.length) {
                object.infoOfSharedObjs = [];
                for (let j = 0; j < message.infoOfSharedObjs.length; ++j)
                    object.infoOfSharedObjs[j] = $root.response.ExternalShareObjInfo.toObject(message.infoOfSharedObjs[j], options);
            }
            if (message.token != null && message.hasOwnProperty("token"))
                object.token = message.token;
            if (message.maxSpaceSize != null && message.hasOwnProperty("maxSpaceSize")) {
                if (typeof message.maxSpaceSize === "number")
                    object.maxSpaceSize = options.longs === String ? String(message.maxSpaceSize) : message.maxSpaceSize;
                else
                    object.maxSpaceSize = options.longs === String ? $util.Long.prototype.toString.call(message.maxSpaceSize) : options.longs === Number ? new $util.LongBits(message.maxSpaceSize.low >>> 0, message.maxSpaceSize.high >>> 0).toNumber(true) : message.maxSpaceSize;
                if (options.oneofs)
                    object._maxSpaceSize = "maxSpaceSize";
            }
            if (message.maxFileSize != null && message.hasOwnProperty("maxFileSize")) {
                if (typeof message.maxFileSize === "number")
                    object.maxFileSize = options.longs === String ? String(message.maxFileSize) : message.maxFileSize;
                else
                    object.maxFileSize = options.longs === String ? $util.Long.prototype.toString.call(message.maxFileSize) : options.longs === Number ? new $util.LongBits(message.maxFileSize.low >>> 0, message.maxFileSize.high >>> 0).toNumber(true) : message.maxFileSize;
                if (options.oneofs)
                    object._maxFileSize = "maxFileSize";
            }
            if (message.objects && message.objects.length) {
                object.objects = [];
                for (let j = 0; j < message.objects.length; ++j)
                    object.objects[j] = $root.response.SpaceAutoObjectDeletion.toObject(message.objects[j], options);
            }
            if (message.allowedFileTypes && message.allowedFileTypes.length) {
                object.allowedFileTypes = [];
                for (let j = 0; j < message.allowedFileTypes.length; ++j)
                    object.allowedFileTypes[j] = message.allowedFileTypes[j];
            }
            if (message.sizeConsumed != null && message.hasOwnProperty("sizeConsumed")) {
                if (typeof message.sizeConsumed === "number")
                    object.sizeConsumed = options.longs === String ? String(message.sizeConsumed) : message.sizeConsumed;
                else
                    object.sizeConsumed = options.longs === String ? $util.Long.prototype.toString.call(message.sizeConsumed) : options.longs === Number ? new $util.LongBits(message.sizeConsumed.low >>> 0, message.sizeConsumed.high >>> 0).toNumber(true) : message.sizeConsumed;
                if (options.oneofs)
                    object._sizeConsumed = "sizeConsumed";
            }
            if (message.deniedFileTypes && message.deniedFileTypes.length) {
                object.deniedFileTypes = [];
                for (let j = 0; j < message.deniedFileTypes.length; ++j)
                    object.deniedFileTypes[j] = message.deniedFileTypes[j];
            }
            if (message.allowedLocations && message.allowedLocations.length) {
                object.allowedLocations = [];
                for (let j = 0; j < message.allowedLocations.length; ++j)
                    object.allowedLocations[j] = message.allowedLocations[j];
            }
            if (message.deniedLocations && message.deniedLocations.length) {
                object.deniedLocations = [];
                for (let j = 0; j < message.deniedLocations.length; ++j)
                    object.deniedLocations[j] = message.deniedLocations[j];
            }
            if (message.allowedRegions && message.allowedRegions.length) {
                object.allowedRegions = [];
                for (let j = 0; j < message.allowedRegions.length; ++j)
                    object.allowedRegions[j] = message.allowedRegions[j];
            }
            if (message.deniedRegions && message.deniedRegions.length) {
                object.deniedRegions = [];
                for (let j = 0; j < message.deniedRegions.length; ++j)
                    object.deniedRegions[j] = message.deniedRegions[j];
            }
            if (message.allowedIps && message.allowedIps.length) {
                object.allowedIps = [];
                for (let j = 0; j < message.allowedIps.length; ++j)
                    object.allowedIps[j] = message.allowedIps[j];
            }
            if (message.deniedIps && message.deniedIps.length) {
                object.deniedIps = [];
                for (let j = 0; j < message.deniedIps.length; ++j)
                    object.deniedIps[j] = message.deniedIps[j];
            }
            if (message.userTillNow != null && message.hasOwnProperty("userTillNow"))
                object.userTillNow = message.userTillNow;
            if (message.objectsTillNow != null && message.hasOwnProperty("objectsTillNow"))
                object.objectsTillNow = message.objectsTillNow;
            return object;
        };

        /**
         * Converts this SpaceObj to JSON.
         * @function toJSON
         * @memberof response.SpaceObj
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SpaceObj.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for SpaceObj
         * @function getTypeUrl
         * @memberof response.SpaceObj
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        SpaceObj.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.SpaceObj";
        };

        return SpaceObj;
    })();

    response.InfoOfExternalSharedInResponse = (function() {

        /**
         * Properties of an InfoOfExternalSharedInResponse.
         * @memberof response
         * @interface IInfoOfExternalSharedInResponse
         * @property {Uint8Array|null} [uuid] InfoOfExternalSharedInResponse uuid
         * @property {string|null} [name] InfoOfExternalSharedInResponse name
         * @property {response.TypeOfObj|null} [typeOfObj] InfoOfExternalSharedInResponse typeOfObj
         */

        /**
         * Constructs a new InfoOfExternalSharedInResponse.
         * @memberof response
         * @classdesc Represents an InfoOfExternalSharedInResponse.
         * @implements IInfoOfExternalSharedInResponse
         * @constructor
         * @param {response.IInfoOfExternalSharedInResponse=} [properties] Properties to set
         */
        function InfoOfExternalSharedInResponse(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * InfoOfExternalSharedInResponse uuid.
         * @member {Uint8Array} uuid
         * @memberof response.InfoOfExternalSharedInResponse
         * @instance
         */
        InfoOfExternalSharedInResponse.prototype.uuid = $util.newBuffer([]);

        /**
         * InfoOfExternalSharedInResponse name.
         * @member {string} name
         * @memberof response.InfoOfExternalSharedInResponse
         * @instance
         */
        InfoOfExternalSharedInResponse.prototype.name = "";

        /**
         * InfoOfExternalSharedInResponse typeOfObj.
         * @member {response.TypeOfObj} typeOfObj
         * @memberof response.InfoOfExternalSharedInResponse
         * @instance
         */
        InfoOfExternalSharedInResponse.prototype.typeOfObj = 0;

        /**
         * Creates a new InfoOfExternalSharedInResponse instance using the specified properties.
         * @function create
         * @memberof response.InfoOfExternalSharedInResponse
         * @static
         * @param {response.IInfoOfExternalSharedInResponse=} [properties] Properties to set
         * @returns {response.InfoOfExternalSharedInResponse} InfoOfExternalSharedInResponse instance
         */
        InfoOfExternalSharedInResponse.create = function create(properties) {
            return new InfoOfExternalSharedInResponse(properties);
        };

        /**
         * Encodes the specified InfoOfExternalSharedInResponse message. Does not implicitly {@link response.InfoOfExternalSharedInResponse.verify|verify} messages.
         * @function encode
         * @memberof response.InfoOfExternalSharedInResponse
         * @static
         * @param {response.IInfoOfExternalSharedInResponse} message InfoOfExternalSharedInResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        InfoOfExternalSharedInResponse.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uuid != null && Object.hasOwnProperty.call(message, "uuid"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.uuid);
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
            if (message.typeOfObj != null && Object.hasOwnProperty.call(message, "typeOfObj"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.typeOfObj);
            return writer;
        };

        /**
         * Encodes the specified InfoOfExternalSharedInResponse message, length delimited. Does not implicitly {@link response.InfoOfExternalSharedInResponse.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.InfoOfExternalSharedInResponse
         * @static
         * @param {response.IInfoOfExternalSharedInResponse} message InfoOfExternalSharedInResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        InfoOfExternalSharedInResponse.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an InfoOfExternalSharedInResponse message from the specified reader or buffer.
         * @function decode
         * @memberof response.InfoOfExternalSharedInResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.InfoOfExternalSharedInResponse} InfoOfExternalSharedInResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        InfoOfExternalSharedInResponse.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.InfoOfExternalSharedInResponse();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.uuid = reader.bytes();
                        break;
                    }
                case 2: {
                        message.name = reader.string();
                        break;
                    }
                case 3: {
                        message.typeOfObj = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an InfoOfExternalSharedInResponse message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.InfoOfExternalSharedInResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.InfoOfExternalSharedInResponse} InfoOfExternalSharedInResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        InfoOfExternalSharedInResponse.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an InfoOfExternalSharedInResponse message.
         * @function verify
         * @memberof response.InfoOfExternalSharedInResponse
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        InfoOfExternalSharedInResponse.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                if (!(message.uuid && typeof message.uuid.length === "number" || $util.isString(message.uuid)))
                    return "uuid: buffer expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.typeOfObj != null && message.hasOwnProperty("typeOfObj"))
                switch (message.typeOfObj) {
                default:
                    return "typeOfObj: enum value expected";
                case 0:
                case 1:
                    break;
                }
            return null;
        };

        /**
         * Creates an InfoOfExternalSharedInResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.InfoOfExternalSharedInResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.InfoOfExternalSharedInResponse} InfoOfExternalSharedInResponse
         */
        InfoOfExternalSharedInResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.response.InfoOfExternalSharedInResponse)
                return object;
            let message = new $root.response.InfoOfExternalSharedInResponse();
            if (object.uuid != null)
                if (typeof object.uuid === "string")
                    $util.base64.decode(object.uuid, message.uuid = $util.newBuffer($util.base64.length(object.uuid)), 0);
                else if (object.uuid.length >= 0)
                    message.uuid = object.uuid;
            if (object.name != null)
                message.name = String(object.name);
            switch (object.typeOfObj) {
            default:
                if (typeof object.typeOfObj === "number") {
                    message.typeOfObj = object.typeOfObj;
                    break;
                }
                break;
            case "TypeFolder":
            case 0:
                message.typeOfObj = 0;
                break;
            case "TypeFile":
            case 1:
                message.typeOfObj = 1;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from an InfoOfExternalSharedInResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.InfoOfExternalSharedInResponse
         * @static
         * @param {response.InfoOfExternalSharedInResponse} message InfoOfExternalSharedInResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        InfoOfExternalSharedInResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if (options.bytes === String)
                    object.uuid = "";
                else {
                    object.uuid = [];
                    if (options.bytes !== Array)
                        object.uuid = $util.newBuffer(object.uuid);
                }
                object.name = "";
                object.typeOfObj = options.enums === String ? "TypeFolder" : 0;
            }
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                object.uuid = options.bytes === String ? $util.base64.encode(message.uuid, 0, message.uuid.length) : options.bytes === Array ? Array.prototype.slice.call(message.uuid) : message.uuid;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.typeOfObj != null && message.hasOwnProperty("typeOfObj"))
                object.typeOfObj = options.enums === String ? $root.response.TypeOfObj[message.typeOfObj] === undefined ? message.typeOfObj : $root.response.TypeOfObj[message.typeOfObj] : message.typeOfObj;
            return object;
        };

        /**
         * Converts this InfoOfExternalSharedInResponse to JSON.
         * @function toJSON
         * @memberof response.InfoOfExternalSharedInResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        InfoOfExternalSharedInResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for InfoOfExternalSharedInResponse
         * @function getTypeUrl
         * @memberof response.InfoOfExternalSharedInResponse
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        InfoOfExternalSharedInResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.InfoOfExternalSharedInResponse";
        };

        return InfoOfExternalSharedInResponse;
    })();

    response.SpaceObjInResponse = (function() {

        /**
         * Properties of a SpaceObjInResponse.
         * @memberof response
         * @interface ISpaceObjInResponse
         * @property {Array.<string>|null} [userEmails] SpaceObjInResponse userEmails
         * @property {Array.<response.IInfoOfExternalSharedInResponse>|null} [infoOfSharedObjs] SpaceObjInResponse infoOfSharedObjs
         * @property {string|null} [name] SpaceObjInResponse name
         * @property {Array.<response.SpaceOpPermissions>|null} [operations] SpaceObjInResponse operations
         * @property {number|Long|null} [creationTime] SpaceObjInResponse creationTime
         * @property {number|Long|null} [updatedTime] SpaceObjInResponse updatedTime
         * @property {number|Long|null} [maxSpaceSize] SpaceObjInResponse maxSpaceSize
         * @property {number|Long|null} [maxFileSize] SpaceObjInResponse maxFileSize
         * @property {Array.<response.ISpaceAutoObjectDeletion>|null} [objects] SpaceObjInResponse objects
         * @property {Array.<string>|null} [allowedFileTypes] SpaceObjInResponse allowedFileTypes
         * @property {number|Long|null} [sizeConsumed] SpaceObjInResponse sizeConsumed
         * @property {Array.<string>|null} [deniedFileTypes] SpaceObjInResponse deniedFileTypes
         * @property {Array.<string>|null} [allowedLocations] SpaceObjInResponse allowedLocations
         * @property {Array.<string>|null} [deniedLocations] SpaceObjInResponse deniedLocations
         * @property {Array.<string>|null} [allowedRegions] SpaceObjInResponse allowedRegions
         * @property {Array.<string>|null} [deniedRegions] SpaceObjInResponse deniedRegions
         * @property {Array.<string>|null} [allowedIps] SpaceObjInResponse allowedIps
         * @property {Array.<string>|null} [deniedIps] SpaceObjInResponse deniedIps
         * @property {number|null} [userTillNow] SpaceObjInResponse userTillNow
         * @property {number|null} [objectsTillNow] SpaceObjInResponse objectsTillNow
         */

        /**
         * Constructs a new SpaceObjInResponse.
         * @memberof response
         * @classdesc Represents a SpaceObjInResponse.
         * @implements ISpaceObjInResponse
         * @constructor
         * @param {response.ISpaceObjInResponse=} [properties] Properties to set
         */
        function SpaceObjInResponse(properties) {
            this.userEmails = [];
            this.infoOfSharedObjs = [];
            this.operations = [];
            this.objects = [];
            this.allowedFileTypes = [];
            this.deniedFileTypes = [];
            this.allowedLocations = [];
            this.deniedLocations = [];
            this.allowedRegions = [];
            this.deniedRegions = [];
            this.allowedIps = [];
            this.deniedIps = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SpaceObjInResponse userEmails.
         * @member {Array.<string>} userEmails
         * @memberof response.SpaceObjInResponse
         * @instance
         */
        SpaceObjInResponse.prototype.userEmails = $util.emptyArray;

        /**
         * SpaceObjInResponse infoOfSharedObjs.
         * @member {Array.<response.IInfoOfExternalSharedInResponse>} infoOfSharedObjs
         * @memberof response.SpaceObjInResponse
         * @instance
         */
        SpaceObjInResponse.prototype.infoOfSharedObjs = $util.emptyArray;

        /**
         * SpaceObjInResponse name.
         * @member {string} name
         * @memberof response.SpaceObjInResponse
         * @instance
         */
        SpaceObjInResponse.prototype.name = "";

        /**
         * SpaceObjInResponse operations.
         * @member {Array.<response.SpaceOpPermissions>} operations
         * @memberof response.SpaceObjInResponse
         * @instance
         */
        SpaceObjInResponse.prototype.operations = $util.emptyArray;

        /**
         * SpaceObjInResponse creationTime.
         * @member {number|Long} creationTime
         * @memberof response.SpaceObjInResponse
         * @instance
         */
        SpaceObjInResponse.prototype.creationTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * SpaceObjInResponse updatedTime.
         * @member {number|Long} updatedTime
         * @memberof response.SpaceObjInResponse
         * @instance
         */
        SpaceObjInResponse.prototype.updatedTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * SpaceObjInResponse maxSpaceSize.
         * @member {number|Long|null|undefined} maxSpaceSize
         * @memberof response.SpaceObjInResponse
         * @instance
         */
        SpaceObjInResponse.prototype.maxSpaceSize = null;

        /**
         * SpaceObjInResponse maxFileSize.
         * @member {number|Long|null|undefined} maxFileSize
         * @memberof response.SpaceObjInResponse
         * @instance
         */
        SpaceObjInResponse.prototype.maxFileSize = null;

        /**
         * SpaceObjInResponse objects.
         * @member {Array.<response.ISpaceAutoObjectDeletion>} objects
         * @memberof response.SpaceObjInResponse
         * @instance
         */
        SpaceObjInResponse.prototype.objects = $util.emptyArray;

        /**
         * SpaceObjInResponse allowedFileTypes.
         * @member {Array.<string>} allowedFileTypes
         * @memberof response.SpaceObjInResponse
         * @instance
         */
        SpaceObjInResponse.prototype.allowedFileTypes = $util.emptyArray;

        /**
         * SpaceObjInResponse sizeConsumed.
         * @member {number|Long|null|undefined} sizeConsumed
         * @memberof response.SpaceObjInResponse
         * @instance
         */
        SpaceObjInResponse.prototype.sizeConsumed = null;

        /**
         * SpaceObjInResponse deniedFileTypes.
         * @member {Array.<string>} deniedFileTypes
         * @memberof response.SpaceObjInResponse
         * @instance
         */
        SpaceObjInResponse.prototype.deniedFileTypes = $util.emptyArray;

        /**
         * SpaceObjInResponse allowedLocations.
         * @member {Array.<string>} allowedLocations
         * @memberof response.SpaceObjInResponse
         * @instance
         */
        SpaceObjInResponse.prototype.allowedLocations = $util.emptyArray;

        /**
         * SpaceObjInResponse deniedLocations.
         * @member {Array.<string>} deniedLocations
         * @memberof response.SpaceObjInResponse
         * @instance
         */
        SpaceObjInResponse.prototype.deniedLocations = $util.emptyArray;

        /**
         * SpaceObjInResponse allowedRegions.
         * @member {Array.<string>} allowedRegions
         * @memberof response.SpaceObjInResponse
         * @instance
         */
        SpaceObjInResponse.prototype.allowedRegions = $util.emptyArray;

        /**
         * SpaceObjInResponse deniedRegions.
         * @member {Array.<string>} deniedRegions
         * @memberof response.SpaceObjInResponse
         * @instance
         */
        SpaceObjInResponse.prototype.deniedRegions = $util.emptyArray;

        /**
         * SpaceObjInResponse allowedIps.
         * @member {Array.<string>} allowedIps
         * @memberof response.SpaceObjInResponse
         * @instance
         */
        SpaceObjInResponse.prototype.allowedIps = $util.emptyArray;

        /**
         * SpaceObjInResponse deniedIps.
         * @member {Array.<string>} deniedIps
         * @memberof response.SpaceObjInResponse
         * @instance
         */
        SpaceObjInResponse.prototype.deniedIps = $util.emptyArray;

        /**
         * SpaceObjInResponse userTillNow.
         * @member {number} userTillNow
         * @memberof response.SpaceObjInResponse
         * @instance
         */
        SpaceObjInResponse.prototype.userTillNow = 0;

        /**
         * SpaceObjInResponse objectsTillNow.
         * @member {number} objectsTillNow
         * @memberof response.SpaceObjInResponse
         * @instance
         */
        SpaceObjInResponse.prototype.objectsTillNow = 0;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(SpaceObjInResponse.prototype, "_maxSpaceSize", {
            get: $util.oneOfGetter($oneOfFields = ["maxSpaceSize"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(SpaceObjInResponse.prototype, "_maxFileSize", {
            get: $util.oneOfGetter($oneOfFields = ["maxFileSize"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(SpaceObjInResponse.prototype, "_sizeConsumed", {
            get: $util.oneOfGetter($oneOfFields = ["sizeConsumed"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new SpaceObjInResponse instance using the specified properties.
         * @function create
         * @memberof response.SpaceObjInResponse
         * @static
         * @param {response.ISpaceObjInResponse=} [properties] Properties to set
         * @returns {response.SpaceObjInResponse} SpaceObjInResponse instance
         */
        SpaceObjInResponse.create = function create(properties) {
            return new SpaceObjInResponse(properties);
        };

        /**
         * Encodes the specified SpaceObjInResponse message. Does not implicitly {@link response.SpaceObjInResponse.verify|verify} messages.
         * @function encode
         * @memberof response.SpaceObjInResponse
         * @static
         * @param {response.ISpaceObjInResponse} message SpaceObjInResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SpaceObjInResponse.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.userEmails != null && message.userEmails.length)
                for (let i = 0; i < message.userEmails.length; ++i)
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.userEmails[i]);
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.name);
            if (message.operations != null && message.operations.length) {
                writer.uint32(/* id 4, wireType 2 =*/34).fork();
                for (let i = 0; i < message.operations.length; ++i)
                    writer.int32(message.operations[i]);
                writer.ldelim();
            }
            if (message.creationTime != null && Object.hasOwnProperty.call(message, "creationTime"))
                writer.uint32(/* id 5, wireType 0 =*/40).uint64(message.creationTime);
            if (message.updatedTime != null && Object.hasOwnProperty.call(message, "updatedTime"))
                writer.uint32(/* id 6, wireType 0 =*/48).uint64(message.updatedTime);
            if (message.infoOfSharedObjs != null && message.infoOfSharedObjs.length)
                for (let i = 0; i < message.infoOfSharedObjs.length; ++i)
                    $root.response.InfoOfExternalSharedInResponse.encode(message.infoOfSharedObjs[i], writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
            if (message.maxSpaceSize != null && Object.hasOwnProperty.call(message, "maxSpaceSize"))
                writer.uint32(/* id 10, wireType 0 =*/80).uint64(message.maxSpaceSize);
            if (message.maxFileSize != null && Object.hasOwnProperty.call(message, "maxFileSize"))
                writer.uint32(/* id 11, wireType 0 =*/88).uint64(message.maxFileSize);
            if (message.objects != null && message.objects.length)
                for (let i = 0; i < message.objects.length; ++i)
                    $root.response.SpaceAutoObjectDeletion.encode(message.objects[i], writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
            if (message.allowedFileTypes != null && message.allowedFileTypes.length)
                for (let i = 0; i < message.allowedFileTypes.length; ++i)
                    writer.uint32(/* id 13, wireType 2 =*/106).string(message.allowedFileTypes[i]);
            if (message.sizeConsumed != null && Object.hasOwnProperty.call(message, "sizeConsumed"))
                writer.uint32(/* id 14, wireType 0 =*/112).uint64(message.sizeConsumed);
            if (message.deniedFileTypes != null && message.deniedFileTypes.length)
                for (let i = 0; i < message.deniedFileTypes.length; ++i)
                    writer.uint32(/* id 15, wireType 2 =*/122).string(message.deniedFileTypes[i]);
            if (message.allowedLocations != null && message.allowedLocations.length)
                for (let i = 0; i < message.allowedLocations.length; ++i)
                    writer.uint32(/* id 16, wireType 2 =*/130).string(message.allowedLocations[i]);
            if (message.deniedLocations != null && message.deniedLocations.length)
                for (let i = 0; i < message.deniedLocations.length; ++i)
                    writer.uint32(/* id 17, wireType 2 =*/138).string(message.deniedLocations[i]);
            if (message.allowedRegions != null && message.allowedRegions.length)
                for (let i = 0; i < message.allowedRegions.length; ++i)
                    writer.uint32(/* id 18, wireType 2 =*/146).string(message.allowedRegions[i]);
            if (message.deniedRegions != null && message.deniedRegions.length)
                for (let i = 0; i < message.deniedRegions.length; ++i)
                    writer.uint32(/* id 19, wireType 2 =*/154).string(message.deniedRegions[i]);
            if (message.allowedIps != null && message.allowedIps.length)
                for (let i = 0; i < message.allowedIps.length; ++i)
                    writer.uint32(/* id 20, wireType 2 =*/162).string(message.allowedIps[i]);
            if (message.deniedIps != null && message.deniedIps.length)
                for (let i = 0; i < message.deniedIps.length; ++i)
                    writer.uint32(/* id 21, wireType 2 =*/170).string(message.deniedIps[i]);
            if (message.userTillNow != null && Object.hasOwnProperty.call(message, "userTillNow"))
                writer.uint32(/* id 22, wireType 0 =*/176).uint32(message.userTillNow);
            if (message.objectsTillNow != null && Object.hasOwnProperty.call(message, "objectsTillNow"))
                writer.uint32(/* id 23, wireType 0 =*/184).uint32(message.objectsTillNow);
            return writer;
        };

        /**
         * Encodes the specified SpaceObjInResponse message, length delimited. Does not implicitly {@link response.SpaceObjInResponse.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.SpaceObjInResponse
         * @static
         * @param {response.ISpaceObjInResponse} message SpaceObjInResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SpaceObjInResponse.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SpaceObjInResponse message from the specified reader or buffer.
         * @function decode
         * @memberof response.SpaceObjInResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.SpaceObjInResponse} SpaceObjInResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SpaceObjInResponse.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.SpaceObjInResponse();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        if (!(message.userEmails && message.userEmails.length))
                            message.userEmails = [];
                        message.userEmails.push(reader.string());
                        break;
                    }
                case 7: {
                        if (!(message.infoOfSharedObjs && message.infoOfSharedObjs.length))
                            message.infoOfSharedObjs = [];
                        message.infoOfSharedObjs.push($root.response.InfoOfExternalSharedInResponse.decode(reader, reader.uint32()));
                        break;
                    }
                case 3: {
                        message.name = reader.string();
                        break;
                    }
                case 4: {
                        if (!(message.operations && message.operations.length))
                            message.operations = [];
                        if ((tag & 7) === 2) {
                            let end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.operations.push(reader.int32());
                        } else
                            message.operations.push(reader.int32());
                        break;
                    }
                case 5: {
                        message.creationTime = reader.uint64();
                        break;
                    }
                case 6: {
                        message.updatedTime = reader.uint64();
                        break;
                    }
                case 10: {
                        message.maxSpaceSize = reader.uint64();
                        break;
                    }
                case 11: {
                        message.maxFileSize = reader.uint64();
                        break;
                    }
                case 12: {
                        if (!(message.objects && message.objects.length))
                            message.objects = [];
                        message.objects.push($root.response.SpaceAutoObjectDeletion.decode(reader, reader.uint32()));
                        break;
                    }
                case 13: {
                        if (!(message.allowedFileTypes && message.allowedFileTypes.length))
                            message.allowedFileTypes = [];
                        message.allowedFileTypes.push(reader.string());
                        break;
                    }
                case 14: {
                        message.sizeConsumed = reader.uint64();
                        break;
                    }
                case 15: {
                        if (!(message.deniedFileTypes && message.deniedFileTypes.length))
                            message.deniedFileTypes = [];
                        message.deniedFileTypes.push(reader.string());
                        break;
                    }
                case 16: {
                        if (!(message.allowedLocations && message.allowedLocations.length))
                            message.allowedLocations = [];
                        message.allowedLocations.push(reader.string());
                        break;
                    }
                case 17: {
                        if (!(message.deniedLocations && message.deniedLocations.length))
                            message.deniedLocations = [];
                        message.deniedLocations.push(reader.string());
                        break;
                    }
                case 18: {
                        if (!(message.allowedRegions && message.allowedRegions.length))
                            message.allowedRegions = [];
                        message.allowedRegions.push(reader.string());
                        break;
                    }
                case 19: {
                        if (!(message.deniedRegions && message.deniedRegions.length))
                            message.deniedRegions = [];
                        message.deniedRegions.push(reader.string());
                        break;
                    }
                case 20: {
                        if (!(message.allowedIps && message.allowedIps.length))
                            message.allowedIps = [];
                        message.allowedIps.push(reader.string());
                        break;
                    }
                case 21: {
                        if (!(message.deniedIps && message.deniedIps.length))
                            message.deniedIps = [];
                        message.deniedIps.push(reader.string());
                        break;
                    }
                case 22: {
                        message.userTillNow = reader.uint32();
                        break;
                    }
                case 23: {
                        message.objectsTillNow = reader.uint32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SpaceObjInResponse message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.SpaceObjInResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.SpaceObjInResponse} SpaceObjInResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SpaceObjInResponse.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SpaceObjInResponse message.
         * @function verify
         * @memberof response.SpaceObjInResponse
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SpaceObjInResponse.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.userEmails != null && message.hasOwnProperty("userEmails")) {
                if (!Array.isArray(message.userEmails))
                    return "userEmails: array expected";
                for (let i = 0; i < message.userEmails.length; ++i)
                    if (!$util.isString(message.userEmails[i]))
                        return "userEmails: string[] expected";
            }
            if (message.infoOfSharedObjs != null && message.hasOwnProperty("infoOfSharedObjs")) {
                if (!Array.isArray(message.infoOfSharedObjs))
                    return "infoOfSharedObjs: array expected";
                for (let i = 0; i < message.infoOfSharedObjs.length; ++i) {
                    let error = $root.response.InfoOfExternalSharedInResponse.verify(message.infoOfSharedObjs[i]);
                    if (error)
                        return "infoOfSharedObjs." + error;
                }
            }
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.operations != null && message.hasOwnProperty("operations")) {
                if (!Array.isArray(message.operations))
                    return "operations: array expected";
                for (let i = 0; i < message.operations.length; ++i)
                    switch (message.operations[i]) {
                    default:
                        return "operations: enum value[] expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                    case 8:
                    case 9:
                    case 10:
                    case 11:
                    case 12:
                    case 13:
                    case 14:
                    case 15:
                        break;
                    }
            }
            if (message.creationTime != null && message.hasOwnProperty("creationTime"))
                if (!$util.isInteger(message.creationTime) && !(message.creationTime && $util.isInteger(message.creationTime.low) && $util.isInteger(message.creationTime.high)))
                    return "creationTime: integer|Long expected";
            if (message.updatedTime != null && message.hasOwnProperty("updatedTime"))
                if (!$util.isInteger(message.updatedTime) && !(message.updatedTime && $util.isInteger(message.updatedTime.low) && $util.isInteger(message.updatedTime.high)))
                    return "updatedTime: integer|Long expected";
            if (message.maxSpaceSize != null && message.hasOwnProperty("maxSpaceSize")) {
                properties._maxSpaceSize = 1;
                if (!$util.isInteger(message.maxSpaceSize) && !(message.maxSpaceSize && $util.isInteger(message.maxSpaceSize.low) && $util.isInteger(message.maxSpaceSize.high)))
                    return "maxSpaceSize: integer|Long expected";
            }
            if (message.maxFileSize != null && message.hasOwnProperty("maxFileSize")) {
                properties._maxFileSize = 1;
                if (!$util.isInteger(message.maxFileSize) && !(message.maxFileSize && $util.isInteger(message.maxFileSize.low) && $util.isInteger(message.maxFileSize.high)))
                    return "maxFileSize: integer|Long expected";
            }
            if (message.objects != null && message.hasOwnProperty("objects")) {
                if (!Array.isArray(message.objects))
                    return "objects: array expected";
                for (let i = 0; i < message.objects.length; ++i) {
                    let error = $root.response.SpaceAutoObjectDeletion.verify(message.objects[i]);
                    if (error)
                        return "objects." + error;
                }
            }
            if (message.allowedFileTypes != null && message.hasOwnProperty("allowedFileTypes")) {
                if (!Array.isArray(message.allowedFileTypes))
                    return "allowedFileTypes: array expected";
                for (let i = 0; i < message.allowedFileTypes.length; ++i)
                    if (!$util.isString(message.allowedFileTypes[i]))
                        return "allowedFileTypes: string[] expected";
            }
            if (message.sizeConsumed != null && message.hasOwnProperty("sizeConsumed")) {
                properties._sizeConsumed = 1;
                if (!$util.isInteger(message.sizeConsumed) && !(message.sizeConsumed && $util.isInteger(message.sizeConsumed.low) && $util.isInteger(message.sizeConsumed.high)))
                    return "sizeConsumed: integer|Long expected";
            }
            if (message.deniedFileTypes != null && message.hasOwnProperty("deniedFileTypes")) {
                if (!Array.isArray(message.deniedFileTypes))
                    return "deniedFileTypes: array expected";
                for (let i = 0; i < message.deniedFileTypes.length; ++i)
                    if (!$util.isString(message.deniedFileTypes[i]))
                        return "deniedFileTypes: string[] expected";
            }
            if (message.allowedLocations != null && message.hasOwnProperty("allowedLocations")) {
                if (!Array.isArray(message.allowedLocations))
                    return "allowedLocations: array expected";
                for (let i = 0; i < message.allowedLocations.length; ++i)
                    if (!$util.isString(message.allowedLocations[i]))
                        return "allowedLocations: string[] expected";
            }
            if (message.deniedLocations != null && message.hasOwnProperty("deniedLocations")) {
                if (!Array.isArray(message.deniedLocations))
                    return "deniedLocations: array expected";
                for (let i = 0; i < message.deniedLocations.length; ++i)
                    if (!$util.isString(message.deniedLocations[i]))
                        return "deniedLocations: string[] expected";
            }
            if (message.allowedRegions != null && message.hasOwnProperty("allowedRegions")) {
                if (!Array.isArray(message.allowedRegions))
                    return "allowedRegions: array expected";
                for (let i = 0; i < message.allowedRegions.length; ++i)
                    if (!$util.isString(message.allowedRegions[i]))
                        return "allowedRegions: string[] expected";
            }
            if (message.deniedRegions != null && message.hasOwnProperty("deniedRegions")) {
                if (!Array.isArray(message.deniedRegions))
                    return "deniedRegions: array expected";
                for (let i = 0; i < message.deniedRegions.length; ++i)
                    if (!$util.isString(message.deniedRegions[i]))
                        return "deniedRegions: string[] expected";
            }
            if (message.allowedIps != null && message.hasOwnProperty("allowedIps")) {
                if (!Array.isArray(message.allowedIps))
                    return "allowedIps: array expected";
                for (let i = 0; i < message.allowedIps.length; ++i)
                    if (!$util.isString(message.allowedIps[i]))
                        return "allowedIps: string[] expected";
            }
            if (message.deniedIps != null && message.hasOwnProperty("deniedIps")) {
                if (!Array.isArray(message.deniedIps))
                    return "deniedIps: array expected";
                for (let i = 0; i < message.deniedIps.length; ++i)
                    if (!$util.isString(message.deniedIps[i]))
                        return "deniedIps: string[] expected";
            }
            if (message.userTillNow != null && message.hasOwnProperty("userTillNow"))
                if (!$util.isInteger(message.userTillNow))
                    return "userTillNow: integer expected";
            if (message.objectsTillNow != null && message.hasOwnProperty("objectsTillNow"))
                if (!$util.isInteger(message.objectsTillNow))
                    return "objectsTillNow: integer expected";
            return null;
        };

        /**
         * Creates a SpaceObjInResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.SpaceObjInResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.SpaceObjInResponse} SpaceObjInResponse
         */
        SpaceObjInResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.response.SpaceObjInResponse)
                return object;
            let message = new $root.response.SpaceObjInResponse();
            if (object.userEmails) {
                if (!Array.isArray(object.userEmails))
                    throw TypeError(".response.SpaceObjInResponse.userEmails: array expected");
                message.userEmails = [];
                for (let i = 0; i < object.userEmails.length; ++i)
                    message.userEmails[i] = String(object.userEmails[i]);
            }
            if (object.infoOfSharedObjs) {
                if (!Array.isArray(object.infoOfSharedObjs))
                    throw TypeError(".response.SpaceObjInResponse.infoOfSharedObjs: array expected");
                message.infoOfSharedObjs = [];
                for (let i = 0; i < object.infoOfSharedObjs.length; ++i) {
                    if (typeof object.infoOfSharedObjs[i] !== "object")
                        throw TypeError(".response.SpaceObjInResponse.infoOfSharedObjs: object expected");
                    message.infoOfSharedObjs[i] = $root.response.InfoOfExternalSharedInResponse.fromObject(object.infoOfSharedObjs[i]);
                }
            }
            if (object.name != null)
                message.name = String(object.name);
            if (object.operations) {
                if (!Array.isArray(object.operations))
                    throw TypeError(".response.SpaceObjInResponse.operations: array expected");
                message.operations = [];
                for (let i = 0; i < object.operations.length; ++i)
                    switch (object.operations[i]) {
                    default:
                        if (typeof object.operations[i] === "number") {
                            message.operations[i] = object.operations[i];
                            break;
                        }
                    case "SpaceOpGetMetaFromPath":
                    case 0:
                        message.operations[i] = 0;
                        break;
                    case "SpaceOpGetChunk":
                    case 1:
                        message.operations[i] = 1;
                        break;
                    case "SpaceOpListFiles":
                    case 2:
                        message.operations[i] = 2;
                        break;
                    case "SpaceOpGetFolder":
                    case 3:
                        message.operations[i] = 3;
                        break;
                    case "SpaceOpStartWrite":
                    case 4:
                        message.operations[i] = 4;
                        break;
                    case "SpaceOpPutChunk":
                    case 5:
                        message.operations[i] = 5;
                        break;
                    case "SpaceOpFinalizeWrite":
                    case 6:
                        message.operations[i] = 6;
                        break;
                    case "SpaceOpCreateFolder":
                    case 7:
                        message.operations[i] = 7;
                        break;
                    case "SpaceOpCopyFile":
                    case 8:
                        message.operations[i] = 8;
                        break;
                    case "SpaceOpCopyFolder":
                    case 9:
                        message.operations[i] = 9;
                        break;
                    case "SpaceOpCopy":
                    case 10:
                        message.operations[i] = 10;
                        break;
                    case "SpaceAddComment":
                    case 11:
                        message.operations[i] = 11;
                        break;
                    case "SpaceListComments":
                    case 12:
                        message.operations[i] = 12;
                        break;
                    case "SpaceUpdateComment":
                    case 13:
                        message.operations[i] = 13;
                        break;
                    case "SpaceRemoveComment":
                    case 14:
                        message.operations[i] = 14;
                        break;
                    case "SpaceGetComment":
                    case 15:
                        message.operations[i] = 15;
                        break;
                    }
            }
            if (object.creationTime != null)
                if ($util.Long)
                    (message.creationTime = $util.Long.fromValue(object.creationTime)).unsigned = true;
                else if (typeof object.creationTime === "string")
                    message.creationTime = parseInt(object.creationTime, 10);
                else if (typeof object.creationTime === "number")
                    message.creationTime = object.creationTime;
                else if (typeof object.creationTime === "object")
                    message.creationTime = new $util.LongBits(object.creationTime.low >>> 0, object.creationTime.high >>> 0).toNumber(true);
            if (object.updatedTime != null)
                if ($util.Long)
                    (message.updatedTime = $util.Long.fromValue(object.updatedTime)).unsigned = true;
                else if (typeof object.updatedTime === "string")
                    message.updatedTime = parseInt(object.updatedTime, 10);
                else if (typeof object.updatedTime === "number")
                    message.updatedTime = object.updatedTime;
                else if (typeof object.updatedTime === "object")
                    message.updatedTime = new $util.LongBits(object.updatedTime.low >>> 0, object.updatedTime.high >>> 0).toNumber(true);
            if (object.maxSpaceSize != null)
                if ($util.Long)
                    (message.maxSpaceSize = $util.Long.fromValue(object.maxSpaceSize)).unsigned = true;
                else if (typeof object.maxSpaceSize === "string")
                    message.maxSpaceSize = parseInt(object.maxSpaceSize, 10);
                else if (typeof object.maxSpaceSize === "number")
                    message.maxSpaceSize = object.maxSpaceSize;
                else if (typeof object.maxSpaceSize === "object")
                    message.maxSpaceSize = new $util.LongBits(object.maxSpaceSize.low >>> 0, object.maxSpaceSize.high >>> 0).toNumber(true);
            if (object.maxFileSize != null)
                if ($util.Long)
                    (message.maxFileSize = $util.Long.fromValue(object.maxFileSize)).unsigned = true;
                else if (typeof object.maxFileSize === "string")
                    message.maxFileSize = parseInt(object.maxFileSize, 10);
                else if (typeof object.maxFileSize === "number")
                    message.maxFileSize = object.maxFileSize;
                else if (typeof object.maxFileSize === "object")
                    message.maxFileSize = new $util.LongBits(object.maxFileSize.low >>> 0, object.maxFileSize.high >>> 0).toNumber(true);
            if (object.objects) {
                if (!Array.isArray(object.objects))
                    throw TypeError(".response.SpaceObjInResponse.objects: array expected");
                message.objects = [];
                for (let i = 0; i < object.objects.length; ++i) {
                    if (typeof object.objects[i] !== "object")
                        throw TypeError(".response.SpaceObjInResponse.objects: object expected");
                    message.objects[i] = $root.response.SpaceAutoObjectDeletion.fromObject(object.objects[i]);
                }
            }
            if (object.allowedFileTypes) {
                if (!Array.isArray(object.allowedFileTypes))
                    throw TypeError(".response.SpaceObjInResponse.allowedFileTypes: array expected");
                message.allowedFileTypes = [];
                for (let i = 0; i < object.allowedFileTypes.length; ++i)
                    message.allowedFileTypes[i] = String(object.allowedFileTypes[i]);
            }
            if (object.sizeConsumed != null)
                if ($util.Long)
                    (message.sizeConsumed = $util.Long.fromValue(object.sizeConsumed)).unsigned = true;
                else if (typeof object.sizeConsumed === "string")
                    message.sizeConsumed = parseInt(object.sizeConsumed, 10);
                else if (typeof object.sizeConsumed === "number")
                    message.sizeConsumed = object.sizeConsumed;
                else if (typeof object.sizeConsumed === "object")
                    message.sizeConsumed = new $util.LongBits(object.sizeConsumed.low >>> 0, object.sizeConsumed.high >>> 0).toNumber(true);
            if (object.deniedFileTypes) {
                if (!Array.isArray(object.deniedFileTypes))
                    throw TypeError(".response.SpaceObjInResponse.deniedFileTypes: array expected");
                message.deniedFileTypes = [];
                for (let i = 0; i < object.deniedFileTypes.length; ++i)
                    message.deniedFileTypes[i] = String(object.deniedFileTypes[i]);
            }
            if (object.allowedLocations) {
                if (!Array.isArray(object.allowedLocations))
                    throw TypeError(".response.SpaceObjInResponse.allowedLocations: array expected");
                message.allowedLocations = [];
                for (let i = 0; i < object.allowedLocations.length; ++i)
                    message.allowedLocations[i] = String(object.allowedLocations[i]);
            }
            if (object.deniedLocations) {
                if (!Array.isArray(object.deniedLocations))
                    throw TypeError(".response.SpaceObjInResponse.deniedLocations: array expected");
                message.deniedLocations = [];
                for (let i = 0; i < object.deniedLocations.length; ++i)
                    message.deniedLocations[i] = String(object.deniedLocations[i]);
            }
            if (object.allowedRegions) {
                if (!Array.isArray(object.allowedRegions))
                    throw TypeError(".response.SpaceObjInResponse.allowedRegions: array expected");
                message.allowedRegions = [];
                for (let i = 0; i < object.allowedRegions.length; ++i)
                    message.allowedRegions[i] = String(object.allowedRegions[i]);
            }
            if (object.deniedRegions) {
                if (!Array.isArray(object.deniedRegions))
                    throw TypeError(".response.SpaceObjInResponse.deniedRegions: array expected");
                message.deniedRegions = [];
                for (let i = 0; i < object.deniedRegions.length; ++i)
                    message.deniedRegions[i] = String(object.deniedRegions[i]);
            }
            if (object.allowedIps) {
                if (!Array.isArray(object.allowedIps))
                    throw TypeError(".response.SpaceObjInResponse.allowedIps: array expected");
                message.allowedIps = [];
                for (let i = 0; i < object.allowedIps.length; ++i)
                    message.allowedIps[i] = String(object.allowedIps[i]);
            }
            if (object.deniedIps) {
                if (!Array.isArray(object.deniedIps))
                    throw TypeError(".response.SpaceObjInResponse.deniedIps: array expected");
                message.deniedIps = [];
                for (let i = 0; i < object.deniedIps.length; ++i)
                    message.deniedIps[i] = String(object.deniedIps[i]);
            }
            if (object.userTillNow != null)
                message.userTillNow = object.userTillNow >>> 0;
            if (object.objectsTillNow != null)
                message.objectsTillNow = object.objectsTillNow >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a SpaceObjInResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.SpaceObjInResponse
         * @static
         * @param {response.SpaceObjInResponse} message SpaceObjInResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SpaceObjInResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.userEmails = [];
                object.operations = [];
                object.infoOfSharedObjs = [];
                object.objects = [];
                object.allowedFileTypes = [];
                object.deniedFileTypes = [];
                object.allowedLocations = [];
                object.deniedLocations = [];
                object.allowedRegions = [];
                object.deniedRegions = [];
                object.allowedIps = [];
                object.deniedIps = [];
            }
            if (options.defaults) {
                object.name = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.creationTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.creationTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.updatedTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.updatedTime = options.longs === String ? "0" : 0;
                object.userTillNow = 0;
                object.objectsTillNow = 0;
            }
            if (message.userEmails && message.userEmails.length) {
                object.userEmails = [];
                for (let j = 0; j < message.userEmails.length; ++j)
                    object.userEmails[j] = message.userEmails[j];
            }
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.operations && message.operations.length) {
                object.operations = [];
                for (let j = 0; j < message.operations.length; ++j)
                    object.operations[j] = options.enums === String ? $root.response.SpaceOpPermissions[message.operations[j]] === undefined ? message.operations[j] : $root.response.SpaceOpPermissions[message.operations[j]] : message.operations[j];
            }
            if (message.creationTime != null && message.hasOwnProperty("creationTime"))
                if (typeof message.creationTime === "number")
                    object.creationTime = options.longs === String ? String(message.creationTime) : message.creationTime;
                else
                    object.creationTime = options.longs === String ? $util.Long.prototype.toString.call(message.creationTime) : options.longs === Number ? new $util.LongBits(message.creationTime.low >>> 0, message.creationTime.high >>> 0).toNumber(true) : message.creationTime;
            if (message.updatedTime != null && message.hasOwnProperty("updatedTime"))
                if (typeof message.updatedTime === "number")
                    object.updatedTime = options.longs === String ? String(message.updatedTime) : message.updatedTime;
                else
                    object.updatedTime = options.longs === String ? $util.Long.prototype.toString.call(message.updatedTime) : options.longs === Number ? new $util.LongBits(message.updatedTime.low >>> 0, message.updatedTime.high >>> 0).toNumber(true) : message.updatedTime;
            if (message.infoOfSharedObjs && message.infoOfSharedObjs.length) {
                object.infoOfSharedObjs = [];
                for (let j = 0; j < message.infoOfSharedObjs.length; ++j)
                    object.infoOfSharedObjs[j] = $root.response.InfoOfExternalSharedInResponse.toObject(message.infoOfSharedObjs[j], options);
            }
            if (message.maxSpaceSize != null && message.hasOwnProperty("maxSpaceSize")) {
                if (typeof message.maxSpaceSize === "number")
                    object.maxSpaceSize = options.longs === String ? String(message.maxSpaceSize) : message.maxSpaceSize;
                else
                    object.maxSpaceSize = options.longs === String ? $util.Long.prototype.toString.call(message.maxSpaceSize) : options.longs === Number ? new $util.LongBits(message.maxSpaceSize.low >>> 0, message.maxSpaceSize.high >>> 0).toNumber(true) : message.maxSpaceSize;
                if (options.oneofs)
                    object._maxSpaceSize = "maxSpaceSize";
            }
            if (message.maxFileSize != null && message.hasOwnProperty("maxFileSize")) {
                if (typeof message.maxFileSize === "number")
                    object.maxFileSize = options.longs === String ? String(message.maxFileSize) : message.maxFileSize;
                else
                    object.maxFileSize = options.longs === String ? $util.Long.prototype.toString.call(message.maxFileSize) : options.longs === Number ? new $util.LongBits(message.maxFileSize.low >>> 0, message.maxFileSize.high >>> 0).toNumber(true) : message.maxFileSize;
                if (options.oneofs)
                    object._maxFileSize = "maxFileSize";
            }
            if (message.objects && message.objects.length) {
                object.objects = [];
                for (let j = 0; j < message.objects.length; ++j)
                    object.objects[j] = $root.response.SpaceAutoObjectDeletion.toObject(message.objects[j], options);
            }
            if (message.allowedFileTypes && message.allowedFileTypes.length) {
                object.allowedFileTypes = [];
                for (let j = 0; j < message.allowedFileTypes.length; ++j)
                    object.allowedFileTypes[j] = message.allowedFileTypes[j];
            }
            if (message.sizeConsumed != null && message.hasOwnProperty("sizeConsumed")) {
                if (typeof message.sizeConsumed === "number")
                    object.sizeConsumed = options.longs === String ? String(message.sizeConsumed) : message.sizeConsumed;
                else
                    object.sizeConsumed = options.longs === String ? $util.Long.prototype.toString.call(message.sizeConsumed) : options.longs === Number ? new $util.LongBits(message.sizeConsumed.low >>> 0, message.sizeConsumed.high >>> 0).toNumber(true) : message.sizeConsumed;
                if (options.oneofs)
                    object._sizeConsumed = "sizeConsumed";
            }
            if (message.deniedFileTypes && message.deniedFileTypes.length) {
                object.deniedFileTypes = [];
                for (let j = 0; j < message.deniedFileTypes.length; ++j)
                    object.deniedFileTypes[j] = message.deniedFileTypes[j];
            }
            if (message.allowedLocations && message.allowedLocations.length) {
                object.allowedLocations = [];
                for (let j = 0; j < message.allowedLocations.length; ++j)
                    object.allowedLocations[j] = message.allowedLocations[j];
            }
            if (message.deniedLocations && message.deniedLocations.length) {
                object.deniedLocations = [];
                for (let j = 0; j < message.deniedLocations.length; ++j)
                    object.deniedLocations[j] = message.deniedLocations[j];
            }
            if (message.allowedRegions && message.allowedRegions.length) {
                object.allowedRegions = [];
                for (let j = 0; j < message.allowedRegions.length; ++j)
                    object.allowedRegions[j] = message.allowedRegions[j];
            }
            if (message.deniedRegions && message.deniedRegions.length) {
                object.deniedRegions = [];
                for (let j = 0; j < message.deniedRegions.length; ++j)
                    object.deniedRegions[j] = message.deniedRegions[j];
            }
            if (message.allowedIps && message.allowedIps.length) {
                object.allowedIps = [];
                for (let j = 0; j < message.allowedIps.length; ++j)
                    object.allowedIps[j] = message.allowedIps[j];
            }
            if (message.deniedIps && message.deniedIps.length) {
                object.deniedIps = [];
                for (let j = 0; j < message.deniedIps.length; ++j)
                    object.deniedIps[j] = message.deniedIps[j];
            }
            if (message.userTillNow != null && message.hasOwnProperty("userTillNow"))
                object.userTillNow = message.userTillNow;
            if (message.objectsTillNow != null && message.hasOwnProperty("objectsTillNow"))
                object.objectsTillNow = message.objectsTillNow;
            return object;
        };

        /**
         * Converts this SpaceObjInResponse to JSON.
         * @function toJSON
         * @memberof response.SpaceObjInResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SpaceObjInResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for SpaceObjInResponse
         * @function getTypeUrl
         * @memberof response.SpaceObjInResponse
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        SpaceObjInResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.SpaceObjInResponse";
        };

        return SpaceObjInResponse;
    })();

    /**
     * SpaceOpPermissions enum.
     * @name response.SpaceOpPermissions
     * @enum {number}
     * @property {number} SpaceOpGetMetaFromPath=0 SpaceOpGetMetaFromPath value
     * @property {number} SpaceOpGetChunk=1 SpaceOpGetChunk value
     * @property {number} SpaceOpListFiles=2 SpaceOpListFiles value
     * @property {number} SpaceOpGetFolder=3 SpaceOpGetFolder value
     * @property {number} SpaceOpStartWrite=4 SpaceOpStartWrite value
     * @property {number} SpaceOpPutChunk=5 SpaceOpPutChunk value
     * @property {number} SpaceOpFinalizeWrite=6 SpaceOpFinalizeWrite value
     * @property {number} SpaceOpCreateFolder=7 SpaceOpCreateFolder value
     * @property {number} SpaceOpCopyFile=8 SpaceOpCopyFile value
     * @property {number} SpaceOpCopyFolder=9 SpaceOpCopyFolder value
     * @property {number} SpaceOpCopy=10 SpaceOpCopy value
     * @property {number} SpaceAddComment=11 SpaceAddComment value
     * @property {number} SpaceListComments=12 SpaceListComments value
     * @property {number} SpaceUpdateComment=13 SpaceUpdateComment value
     * @property {number} SpaceRemoveComment=14 SpaceRemoveComment value
     * @property {number} SpaceGetComment=15 SpaceGetComment value
     */
    response.SpaceOpPermissions = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "SpaceOpGetMetaFromPath"] = 0;
        values[valuesById[1] = "SpaceOpGetChunk"] = 1;
        values[valuesById[2] = "SpaceOpListFiles"] = 2;
        values[valuesById[3] = "SpaceOpGetFolder"] = 3;
        values[valuesById[4] = "SpaceOpStartWrite"] = 4;
        values[valuesById[5] = "SpaceOpPutChunk"] = 5;
        values[valuesById[6] = "SpaceOpFinalizeWrite"] = 6;
        values[valuesById[7] = "SpaceOpCreateFolder"] = 7;
        values[valuesById[8] = "SpaceOpCopyFile"] = 8;
        values[valuesById[9] = "SpaceOpCopyFolder"] = 9;
        values[valuesById[10] = "SpaceOpCopy"] = 10;
        values[valuesById[11] = "SpaceAddComment"] = 11;
        values[valuesById[12] = "SpaceListComments"] = 12;
        values[valuesById[13] = "SpaceUpdateComment"] = 13;
        values[valuesById[14] = "SpaceRemoveComment"] = 14;
        values[valuesById[15] = "SpaceGetComment"] = 15;
        return values;
    })();

    response.ListSpaces = (function() {

        /**
         * Properties of a ListSpaces.
         * @memberof response
         * @interface IListSpaces
         * @property {Array.<response.ISpaceObjInResponse>|null} [spaceObjects] ListSpaces spaceObjects
         * @property {response.Status|null} [status] ListSpaces status
         * @property {string|null} [message] ListSpaces message
         */

        /**
         * Constructs a new ListSpaces.
         * @memberof response
         * @classdesc Represents a ListSpaces.
         * @implements IListSpaces
         * @constructor
         * @param {response.IListSpaces=} [properties] Properties to set
         */
        function ListSpaces(properties) {
            this.spaceObjects = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListSpaces spaceObjects.
         * @member {Array.<response.ISpaceObjInResponse>} spaceObjects
         * @memberof response.ListSpaces
         * @instance
         */
        ListSpaces.prototype.spaceObjects = $util.emptyArray;

        /**
         * ListSpaces status.
         * @member {response.Status} status
         * @memberof response.ListSpaces
         * @instance
         */
        ListSpaces.prototype.status = 0;

        /**
         * ListSpaces message.
         * @member {string} message
         * @memberof response.ListSpaces
         * @instance
         */
        ListSpaces.prototype.message = "";

        /**
         * Creates a new ListSpaces instance using the specified properties.
         * @function create
         * @memberof response.ListSpaces
         * @static
         * @param {response.IListSpaces=} [properties] Properties to set
         * @returns {response.ListSpaces} ListSpaces instance
         */
        ListSpaces.create = function create(properties) {
            return new ListSpaces(properties);
        };

        /**
         * Encodes the specified ListSpaces message. Does not implicitly {@link response.ListSpaces.verify|verify} messages.
         * @function encode
         * @memberof response.ListSpaces
         * @static
         * @param {response.IListSpaces} message ListSpaces message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListSpaces.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.spaceObjects != null && message.spaceObjects.length)
                for (let i = 0; i < message.spaceObjects.length; ++i)
                    $root.response.SpaceObjInResponse.encode(message.spaceObjects[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified ListSpaces message, length delimited. Does not implicitly {@link response.ListSpaces.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.ListSpaces
         * @static
         * @param {response.IListSpaces} message ListSpaces message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListSpaces.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ListSpaces message from the specified reader or buffer.
         * @function decode
         * @memberof response.ListSpaces
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.ListSpaces} ListSpaces
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListSpaces.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.ListSpaces();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        if (!(message.spaceObjects && message.spaceObjects.length))
                            message.spaceObjects = [];
                        message.spaceObjects.push($root.response.SpaceObjInResponse.decode(reader, reader.uint32()));
                        break;
                    }
                case 2: {
                        message.status = reader.int32();
                        break;
                    }
                case 3: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ListSpaces message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.ListSpaces
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.ListSpaces} ListSpaces
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListSpaces.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ListSpaces message.
         * @function verify
         * @memberof response.ListSpaces
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ListSpaces.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.spaceObjects != null && message.hasOwnProperty("spaceObjects")) {
                if (!Array.isArray(message.spaceObjects))
                    return "spaceObjects: array expected";
                for (let i = 0; i < message.spaceObjects.length; ++i) {
                    let error = $root.response.SpaceObjInResponse.verify(message.spaceObjects[i]);
                    if (error)
                        return "spaceObjects." + error;
                }
            }
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message"))
                if (!$util.isString(message.message))
                    return "message: string expected";
            return null;
        };

        /**
         * Creates a ListSpaces message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.ListSpaces
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.ListSpaces} ListSpaces
         */
        ListSpaces.fromObject = function fromObject(object) {
            if (object instanceof $root.response.ListSpaces)
                return object;
            let message = new $root.response.ListSpaces();
            if (object.spaceObjects) {
                if (!Array.isArray(object.spaceObjects))
                    throw TypeError(".response.ListSpaces.spaceObjects: array expected");
                message.spaceObjects = [];
                for (let i = 0; i < object.spaceObjects.length; ++i) {
                    if (typeof object.spaceObjects[i] !== "object")
                        throw TypeError(".response.ListSpaces.spaceObjects: object expected");
                    message.spaceObjects[i] = $root.response.SpaceObjInResponse.fromObject(object.spaceObjects[i]);
                }
            }
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a ListSpaces message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.ListSpaces
         * @static
         * @param {response.ListSpaces} message ListSpaces
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListSpaces.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.spaceObjects = [];
            if (options.defaults) {
                object.status = options.enums === String ? "SUCCESS" : 0;
                object.message = "";
            }
            if (message.spaceObjects && message.spaceObjects.length) {
                object.spaceObjects = [];
                for (let j = 0; j < message.spaceObjects.length; ++j)
                    object.spaceObjects[j] = $root.response.SpaceObjInResponse.toObject(message.spaceObjects[j], options);
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message"))
                object.message = message.message;
            return object;
        };

        /**
         * Converts this ListSpaces to JSON.
         * @function toJSON
         * @memberof response.ListSpaces
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListSpaces.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ListSpaces
         * @function getTypeUrl
         * @memberof response.ListSpaces
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ListSpaces.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.ListSpaces";
        };

        return ListSpaces;
    })();

    response.UpdateTags = (function() {

        /**
         * Properties of an UpdateTags.
         * @memberof response
         * @interface IUpdateTags
         * @property {response.Status|null} [status] UpdateTags status
         * @property {string|null} [message] UpdateTags message
         */

        /**
         * Constructs a new UpdateTags.
         * @memberof response
         * @classdesc Represents an UpdateTags.
         * @implements IUpdateTags
         * @constructor
         * @param {response.IUpdateTags=} [properties] Properties to set
         */
        function UpdateTags(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateTags status.
         * @member {response.Status} status
         * @memberof response.UpdateTags
         * @instance
         */
        UpdateTags.prototype.status = 0;

        /**
         * UpdateTags message.
         * @member {string} message
         * @memberof response.UpdateTags
         * @instance
         */
        UpdateTags.prototype.message = "";

        /**
         * Creates a new UpdateTags instance using the specified properties.
         * @function create
         * @memberof response.UpdateTags
         * @static
         * @param {response.IUpdateTags=} [properties] Properties to set
         * @returns {response.UpdateTags} UpdateTags instance
         */
        UpdateTags.create = function create(properties) {
            return new UpdateTags(properties);
        };

        /**
         * Encodes the specified UpdateTags message. Does not implicitly {@link response.UpdateTags.verify|verify} messages.
         * @function encode
         * @memberof response.UpdateTags
         * @static
         * @param {response.IUpdateTags} message UpdateTags message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateTags.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified UpdateTags message, length delimited. Does not implicitly {@link response.UpdateTags.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.UpdateTags
         * @static
         * @param {response.IUpdateTags} message UpdateTags message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateTags.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UpdateTags message from the specified reader or buffer.
         * @function decode
         * @memberof response.UpdateTags
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.UpdateTags} UpdateTags
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateTags.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.UpdateTags();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UpdateTags message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.UpdateTags
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.UpdateTags} UpdateTags
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateTags.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UpdateTags message.
         * @function verify
         * @memberof response.UpdateTags
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UpdateTags.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message"))
                if (!$util.isString(message.message))
                    return "message: string expected";
            return null;
        };

        /**
         * Creates an UpdateTags message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.UpdateTags
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.UpdateTags} UpdateTags
         */
        UpdateTags.fromObject = function fromObject(object) {
            if (object instanceof $root.response.UpdateTags)
                return object;
            let message = new $root.response.UpdateTags();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from an UpdateTags message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.UpdateTags
         * @static
         * @param {response.UpdateTags} message UpdateTags
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateTags.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.status = options.enums === String ? "SUCCESS" : 0;
                object.message = "";
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message"))
                object.message = message.message;
            return object;
        };

        /**
         * Converts this UpdateTags to JSON.
         * @function toJSON
         * @memberof response.UpdateTags
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateTags.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for UpdateTags
         * @function getTypeUrl
         * @memberof response.UpdateTags
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        UpdateTags.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.UpdateTags";
        };

        return UpdateTags;
    })();

    response.Reply = (function() {

        /**
         * Properties of a Reply.
         * @memberof response
         * @interface IReply
         * @property {string|null} [email] Reply email
         * @property {string|null} [content] Reply content
         * @property {number|Long|null} [createdTime] Reply createdTime
         * @property {number|Long|null} [modifiedTime] Reply modifiedTime
         */

        /**
         * Constructs a new Reply.
         * @memberof response
         * @classdesc Represents a Reply.
         * @implements IReply
         * @constructor
         * @param {response.IReply=} [properties] Properties to set
         */
        function Reply(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Reply email.
         * @member {string} email
         * @memberof response.Reply
         * @instance
         */
        Reply.prototype.email = "";

        /**
         * Reply content.
         * @member {string} content
         * @memberof response.Reply
         * @instance
         */
        Reply.prototype.content = "";

        /**
         * Reply createdTime.
         * @member {number|Long} createdTime
         * @memberof response.Reply
         * @instance
         */
        Reply.prototype.createdTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Reply modifiedTime.
         * @member {number|Long} modifiedTime
         * @memberof response.Reply
         * @instance
         */
        Reply.prototype.modifiedTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new Reply instance using the specified properties.
         * @function create
         * @memberof response.Reply
         * @static
         * @param {response.IReply=} [properties] Properties to set
         * @returns {response.Reply} Reply instance
         */
        Reply.create = function create(properties) {
            return new Reply(properties);
        };

        /**
         * Encodes the specified Reply message. Does not implicitly {@link response.Reply.verify|verify} messages.
         * @function encode
         * @memberof response.Reply
         * @static
         * @param {response.IReply} message Reply message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Reply.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
            if (message.content != null && Object.hasOwnProperty.call(message, "content"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.content);
            if (message.createdTime != null && Object.hasOwnProperty.call(message, "createdTime"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.createdTime);
            if (message.modifiedTime != null && Object.hasOwnProperty.call(message, "modifiedTime"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.modifiedTime);
            return writer;
        };

        /**
         * Encodes the specified Reply message, length delimited. Does not implicitly {@link response.Reply.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.Reply
         * @static
         * @param {response.IReply} message Reply message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Reply.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Reply message from the specified reader or buffer.
         * @function decode
         * @memberof response.Reply
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.Reply} Reply
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Reply.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.Reply();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.email = reader.string();
                        break;
                    }
                case 2: {
                        message.content = reader.string();
                        break;
                    }
                case 3: {
                        message.createdTime = reader.uint64();
                        break;
                    }
                case 4: {
                        message.modifiedTime = reader.uint64();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Reply message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.Reply
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.Reply} Reply
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Reply.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Reply message.
         * @function verify
         * @memberof response.Reply
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Reply.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            if (message.content != null && message.hasOwnProperty("content"))
                if (!$util.isString(message.content))
                    return "content: string expected";
            if (message.createdTime != null && message.hasOwnProperty("createdTime"))
                if (!$util.isInteger(message.createdTime) && !(message.createdTime && $util.isInteger(message.createdTime.low) && $util.isInteger(message.createdTime.high)))
                    return "createdTime: integer|Long expected";
            if (message.modifiedTime != null && message.hasOwnProperty("modifiedTime"))
                if (!$util.isInteger(message.modifiedTime) && !(message.modifiedTime && $util.isInteger(message.modifiedTime.low) && $util.isInteger(message.modifiedTime.high)))
                    return "modifiedTime: integer|Long expected";
            return null;
        };

        /**
         * Creates a Reply message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.Reply
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.Reply} Reply
         */
        Reply.fromObject = function fromObject(object) {
            if (object instanceof $root.response.Reply)
                return object;
            let message = new $root.response.Reply();
            if (object.email != null)
                message.email = String(object.email);
            if (object.content != null)
                message.content = String(object.content);
            if (object.createdTime != null)
                if ($util.Long)
                    (message.createdTime = $util.Long.fromValue(object.createdTime)).unsigned = true;
                else if (typeof object.createdTime === "string")
                    message.createdTime = parseInt(object.createdTime, 10);
                else if (typeof object.createdTime === "number")
                    message.createdTime = object.createdTime;
                else if (typeof object.createdTime === "object")
                    message.createdTime = new $util.LongBits(object.createdTime.low >>> 0, object.createdTime.high >>> 0).toNumber(true);
            if (object.modifiedTime != null)
                if ($util.Long)
                    (message.modifiedTime = $util.Long.fromValue(object.modifiedTime)).unsigned = true;
                else if (typeof object.modifiedTime === "string")
                    message.modifiedTime = parseInt(object.modifiedTime, 10);
                else if (typeof object.modifiedTime === "number")
                    message.modifiedTime = object.modifiedTime;
                else if (typeof object.modifiedTime === "object")
                    message.modifiedTime = new $util.LongBits(object.modifiedTime.low >>> 0, object.modifiedTime.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a plain object from a Reply message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.Reply
         * @static
         * @param {response.Reply} message Reply
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Reply.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.email = "";
                object.content = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.createdTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.createdTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.modifiedTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.modifiedTime = options.longs === String ? "0" : 0;
            }
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.content != null && message.hasOwnProperty("content"))
                object.content = message.content;
            if (message.createdTime != null && message.hasOwnProperty("createdTime"))
                if (typeof message.createdTime === "number")
                    object.createdTime = options.longs === String ? String(message.createdTime) : message.createdTime;
                else
                    object.createdTime = options.longs === String ? $util.Long.prototype.toString.call(message.createdTime) : options.longs === Number ? new $util.LongBits(message.createdTime.low >>> 0, message.createdTime.high >>> 0).toNumber(true) : message.createdTime;
            if (message.modifiedTime != null && message.hasOwnProperty("modifiedTime"))
                if (typeof message.modifiedTime === "number")
                    object.modifiedTime = options.longs === String ? String(message.modifiedTime) : message.modifiedTime;
                else
                    object.modifiedTime = options.longs === String ? $util.Long.prototype.toString.call(message.modifiedTime) : options.longs === Number ? new $util.LongBits(message.modifiedTime.low >>> 0, message.modifiedTime.high >>> 0).toNumber(true) : message.modifiedTime;
            return object;
        };

        /**
         * Converts this Reply to JSON.
         * @function toJSON
         * @memberof response.Reply
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Reply.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Reply
         * @function getTypeUrl
         * @memberof response.Reply
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Reply.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.Reply";
        };

        return Reply;
    })();

    response.Comment = (function() {

        /**
         * Properties of a Comment.
         * @memberof response
         * @interface IComment
         * @property {string|null} [email] Comment email
         * @property {string|null} [content] Comment content
         * @property {number|Long|null} [createdTime] Comment createdTime
         * @property {number|Long|null} [modifiedTime] Comment modifiedTime
         * @property {Array.<string>|null} [mentionedEmails] Comment mentionedEmails
         * @property {Array.<response.IReply>|null} [replies] Comment replies
         */

        /**
         * Constructs a new Comment.
         * @memberof response
         * @classdesc Represents a Comment.
         * @implements IComment
         * @constructor
         * @param {response.IComment=} [properties] Properties to set
         */
        function Comment(properties) {
            this.mentionedEmails = [];
            this.replies = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Comment email.
         * @member {string} email
         * @memberof response.Comment
         * @instance
         */
        Comment.prototype.email = "";

        /**
         * Comment content.
         * @member {string} content
         * @memberof response.Comment
         * @instance
         */
        Comment.prototype.content = "";

        /**
         * Comment createdTime.
         * @member {number|Long} createdTime
         * @memberof response.Comment
         * @instance
         */
        Comment.prototype.createdTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Comment modifiedTime.
         * @member {number|Long} modifiedTime
         * @memberof response.Comment
         * @instance
         */
        Comment.prototype.modifiedTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Comment mentionedEmails.
         * @member {Array.<string>} mentionedEmails
         * @memberof response.Comment
         * @instance
         */
        Comment.prototype.mentionedEmails = $util.emptyArray;

        /**
         * Comment replies.
         * @member {Array.<response.IReply>} replies
         * @memberof response.Comment
         * @instance
         */
        Comment.prototype.replies = $util.emptyArray;

        /**
         * Creates a new Comment instance using the specified properties.
         * @function create
         * @memberof response.Comment
         * @static
         * @param {response.IComment=} [properties] Properties to set
         * @returns {response.Comment} Comment instance
         */
        Comment.create = function create(properties) {
            return new Comment(properties);
        };

        /**
         * Encodes the specified Comment message. Does not implicitly {@link response.Comment.verify|verify} messages.
         * @function encode
         * @memberof response.Comment
         * @static
         * @param {response.IComment} message Comment message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Comment.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
            if (message.content != null && Object.hasOwnProperty.call(message, "content"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.content);
            if (message.createdTime != null && Object.hasOwnProperty.call(message, "createdTime"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.createdTime);
            if (message.modifiedTime != null && Object.hasOwnProperty.call(message, "modifiedTime"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.modifiedTime);
            if (message.mentionedEmails != null && message.mentionedEmails.length)
                for (let i = 0; i < message.mentionedEmails.length; ++i)
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.mentionedEmails[i]);
            if (message.replies != null && message.replies.length)
                for (let i = 0; i < message.replies.length; ++i)
                    $root.response.Reply.encode(message.replies[i], writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified Comment message, length delimited. Does not implicitly {@link response.Comment.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.Comment
         * @static
         * @param {response.IComment} message Comment message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Comment.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Comment message from the specified reader or buffer.
         * @function decode
         * @memberof response.Comment
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.Comment} Comment
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Comment.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.Comment();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.email = reader.string();
                        break;
                    }
                case 2: {
                        message.content = reader.string();
                        break;
                    }
                case 3: {
                        message.createdTime = reader.uint64();
                        break;
                    }
                case 4: {
                        message.modifiedTime = reader.uint64();
                        break;
                    }
                case 5: {
                        if (!(message.mentionedEmails && message.mentionedEmails.length))
                            message.mentionedEmails = [];
                        message.mentionedEmails.push(reader.string());
                        break;
                    }
                case 6: {
                        if (!(message.replies && message.replies.length))
                            message.replies = [];
                        message.replies.push($root.response.Reply.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Comment message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.Comment
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.Comment} Comment
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Comment.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Comment message.
         * @function verify
         * @memberof response.Comment
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Comment.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            if (message.content != null && message.hasOwnProperty("content"))
                if (!$util.isString(message.content))
                    return "content: string expected";
            if (message.createdTime != null && message.hasOwnProperty("createdTime"))
                if (!$util.isInteger(message.createdTime) && !(message.createdTime && $util.isInteger(message.createdTime.low) && $util.isInteger(message.createdTime.high)))
                    return "createdTime: integer|Long expected";
            if (message.modifiedTime != null && message.hasOwnProperty("modifiedTime"))
                if (!$util.isInteger(message.modifiedTime) && !(message.modifiedTime && $util.isInteger(message.modifiedTime.low) && $util.isInteger(message.modifiedTime.high)))
                    return "modifiedTime: integer|Long expected";
            if (message.mentionedEmails != null && message.hasOwnProperty("mentionedEmails")) {
                if (!Array.isArray(message.mentionedEmails))
                    return "mentionedEmails: array expected";
                for (let i = 0; i < message.mentionedEmails.length; ++i)
                    if (!$util.isString(message.mentionedEmails[i]))
                        return "mentionedEmails: string[] expected";
            }
            if (message.replies != null && message.hasOwnProperty("replies")) {
                if (!Array.isArray(message.replies))
                    return "replies: array expected";
                for (let i = 0; i < message.replies.length; ++i) {
                    let error = $root.response.Reply.verify(message.replies[i]);
                    if (error)
                        return "replies." + error;
                }
            }
            return null;
        };

        /**
         * Creates a Comment message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.Comment
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.Comment} Comment
         */
        Comment.fromObject = function fromObject(object) {
            if (object instanceof $root.response.Comment)
                return object;
            let message = new $root.response.Comment();
            if (object.email != null)
                message.email = String(object.email);
            if (object.content != null)
                message.content = String(object.content);
            if (object.createdTime != null)
                if ($util.Long)
                    (message.createdTime = $util.Long.fromValue(object.createdTime)).unsigned = true;
                else if (typeof object.createdTime === "string")
                    message.createdTime = parseInt(object.createdTime, 10);
                else if (typeof object.createdTime === "number")
                    message.createdTime = object.createdTime;
                else if (typeof object.createdTime === "object")
                    message.createdTime = new $util.LongBits(object.createdTime.low >>> 0, object.createdTime.high >>> 0).toNumber(true);
            if (object.modifiedTime != null)
                if ($util.Long)
                    (message.modifiedTime = $util.Long.fromValue(object.modifiedTime)).unsigned = true;
                else if (typeof object.modifiedTime === "string")
                    message.modifiedTime = parseInt(object.modifiedTime, 10);
                else if (typeof object.modifiedTime === "number")
                    message.modifiedTime = object.modifiedTime;
                else if (typeof object.modifiedTime === "object")
                    message.modifiedTime = new $util.LongBits(object.modifiedTime.low >>> 0, object.modifiedTime.high >>> 0).toNumber(true);
            if (object.mentionedEmails) {
                if (!Array.isArray(object.mentionedEmails))
                    throw TypeError(".response.Comment.mentionedEmails: array expected");
                message.mentionedEmails = [];
                for (let i = 0; i < object.mentionedEmails.length; ++i)
                    message.mentionedEmails[i] = String(object.mentionedEmails[i]);
            }
            if (object.replies) {
                if (!Array.isArray(object.replies))
                    throw TypeError(".response.Comment.replies: array expected");
                message.replies = [];
                for (let i = 0; i < object.replies.length; ++i) {
                    if (typeof object.replies[i] !== "object")
                        throw TypeError(".response.Comment.replies: object expected");
                    message.replies[i] = $root.response.Reply.fromObject(object.replies[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a Comment message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.Comment
         * @static
         * @param {response.Comment} message Comment
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Comment.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.mentionedEmails = [];
                object.replies = [];
            }
            if (options.defaults) {
                object.email = "";
                object.content = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.createdTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.createdTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.modifiedTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.modifiedTime = options.longs === String ? "0" : 0;
            }
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.content != null && message.hasOwnProperty("content"))
                object.content = message.content;
            if (message.createdTime != null && message.hasOwnProperty("createdTime"))
                if (typeof message.createdTime === "number")
                    object.createdTime = options.longs === String ? String(message.createdTime) : message.createdTime;
                else
                    object.createdTime = options.longs === String ? $util.Long.prototype.toString.call(message.createdTime) : options.longs === Number ? new $util.LongBits(message.createdTime.low >>> 0, message.createdTime.high >>> 0).toNumber(true) : message.createdTime;
            if (message.modifiedTime != null && message.hasOwnProperty("modifiedTime"))
                if (typeof message.modifiedTime === "number")
                    object.modifiedTime = options.longs === String ? String(message.modifiedTime) : message.modifiedTime;
                else
                    object.modifiedTime = options.longs === String ? $util.Long.prototype.toString.call(message.modifiedTime) : options.longs === Number ? new $util.LongBits(message.modifiedTime.low >>> 0, message.modifiedTime.high >>> 0).toNumber(true) : message.modifiedTime;
            if (message.mentionedEmails && message.mentionedEmails.length) {
                object.mentionedEmails = [];
                for (let j = 0; j < message.mentionedEmails.length; ++j)
                    object.mentionedEmails[j] = message.mentionedEmails[j];
            }
            if (message.replies && message.replies.length) {
                object.replies = [];
                for (let j = 0; j < message.replies.length; ++j)
                    object.replies[j] = $root.response.Reply.toObject(message.replies[j], options);
            }
            return object;
        };

        /**
         * Converts this Comment to JSON.
         * @function toJSON
         * @memberof response.Comment
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Comment.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Comment
         * @function getTypeUrl
         * @memberof response.Comment
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Comment.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.Comment";
        };

        return Comment;
    })();

    response.AddComment = (function() {

        /**
         * Properties of an AddComment.
         * @memberof response
         * @interface IAddComment
         * @property {response.Status|null} [status] AddComment status
         * @property {Uint8Array|null} [commentId] AddComment commentId
         * @property {string|null} [message] AddComment message
         */

        /**
         * Constructs a new AddComment.
         * @memberof response
         * @classdesc Represents an AddComment.
         * @implements IAddComment
         * @constructor
         * @param {response.IAddComment=} [properties] Properties to set
         */
        function AddComment(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddComment status.
         * @member {response.Status} status
         * @memberof response.AddComment
         * @instance
         */
        AddComment.prototype.status = 0;

        /**
         * AddComment commentId.
         * @member {Uint8Array} commentId
         * @memberof response.AddComment
         * @instance
         */
        AddComment.prototype.commentId = $util.newBuffer([]);

        /**
         * AddComment message.
         * @member {string|null|undefined} message
         * @memberof response.AddComment
         * @instance
         */
        AddComment.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(AddComment.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new AddComment instance using the specified properties.
         * @function create
         * @memberof response.AddComment
         * @static
         * @param {response.IAddComment=} [properties] Properties to set
         * @returns {response.AddComment} AddComment instance
         */
        AddComment.create = function create(properties) {
            return new AddComment(properties);
        };

        /**
         * Encodes the specified AddComment message. Does not implicitly {@link response.AddComment.verify|verify} messages.
         * @function encode
         * @memberof response.AddComment
         * @static
         * @param {response.IAddComment} message AddComment message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddComment.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.commentId != null && Object.hasOwnProperty.call(message, "commentId"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.commentId);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified AddComment message, length delimited. Does not implicitly {@link response.AddComment.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.AddComment
         * @static
         * @param {response.IAddComment} message AddComment message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddComment.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AddComment message from the specified reader or buffer.
         * @function decode
         * @memberof response.AddComment
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.AddComment} AddComment
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddComment.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.AddComment();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.commentId = reader.bytes();
                        break;
                    }
                case 3: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AddComment message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.AddComment
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.AddComment} AddComment
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddComment.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AddComment message.
         * @function verify
         * @memberof response.AddComment
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AddComment.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.commentId != null && message.hasOwnProperty("commentId"))
                if (!(message.commentId && typeof message.commentId.length === "number" || $util.isString(message.commentId)))
                    return "commentId: buffer expected";
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates an AddComment message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.AddComment
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.AddComment} AddComment
         */
        AddComment.fromObject = function fromObject(object) {
            if (object instanceof $root.response.AddComment)
                return object;
            let message = new $root.response.AddComment();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.commentId != null)
                if (typeof object.commentId === "string")
                    $util.base64.decode(object.commentId, message.commentId = $util.newBuffer($util.base64.length(object.commentId)), 0);
                else if (object.commentId.length >= 0)
                    message.commentId = object.commentId;
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from an AddComment message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.AddComment
         * @static
         * @param {response.AddComment} message AddComment
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddComment.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.status = options.enums === String ? "SUCCESS" : 0;
                if (options.bytes === String)
                    object.commentId = "";
                else {
                    object.commentId = [];
                    if (options.bytes !== Array)
                        object.commentId = $util.newBuffer(object.commentId);
                }
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.commentId != null && message.hasOwnProperty("commentId"))
                object.commentId = options.bytes === String ? $util.base64.encode(message.commentId, 0, message.commentId.length) : options.bytes === Array ? Array.prototype.slice.call(message.commentId) : message.commentId;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this AddComment to JSON.
         * @function toJSON
         * @memberof response.AddComment
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddComment.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for AddComment
         * @function getTypeUrl
         * @memberof response.AddComment
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        AddComment.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.AddComment";
        };

        return AddComment;
    })();

    response.RemoveComment = (function() {

        /**
         * Properties of a RemoveComment.
         * @memberof response
         * @interface IRemoveComment
         * @property {response.Status|null} [status] RemoveComment status
         * @property {string|null} [message] RemoveComment message
         */

        /**
         * Constructs a new RemoveComment.
         * @memberof response
         * @classdesc Represents a RemoveComment.
         * @implements IRemoveComment
         * @constructor
         * @param {response.IRemoveComment=} [properties] Properties to set
         */
        function RemoveComment(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveComment status.
         * @member {response.Status} status
         * @memberof response.RemoveComment
         * @instance
         */
        RemoveComment.prototype.status = 0;

        /**
         * RemoveComment message.
         * @member {string|null|undefined} message
         * @memberof response.RemoveComment
         * @instance
         */
        RemoveComment.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(RemoveComment.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new RemoveComment instance using the specified properties.
         * @function create
         * @memberof response.RemoveComment
         * @static
         * @param {response.IRemoveComment=} [properties] Properties to set
         * @returns {response.RemoveComment} RemoveComment instance
         */
        RemoveComment.create = function create(properties) {
            return new RemoveComment(properties);
        };

        /**
         * Encodes the specified RemoveComment message. Does not implicitly {@link response.RemoveComment.verify|verify} messages.
         * @function encode
         * @memberof response.RemoveComment
         * @static
         * @param {response.IRemoveComment} message RemoveComment message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RemoveComment.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified RemoveComment message, length delimited. Does not implicitly {@link response.RemoveComment.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.RemoveComment
         * @static
         * @param {response.IRemoveComment} message RemoveComment message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RemoveComment.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RemoveComment message from the specified reader or buffer.
         * @function decode
         * @memberof response.RemoveComment
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.RemoveComment} RemoveComment
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RemoveComment.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.RemoveComment();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 3: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RemoveComment message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.RemoveComment
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.RemoveComment} RemoveComment
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RemoveComment.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RemoveComment message.
         * @function verify
         * @memberof response.RemoveComment
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RemoveComment.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a RemoveComment message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.RemoveComment
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.RemoveComment} RemoveComment
         */
        RemoveComment.fromObject = function fromObject(object) {
            if (object instanceof $root.response.RemoveComment)
                return object;
            let message = new $root.response.RemoveComment();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a RemoveComment message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.RemoveComment
         * @static
         * @param {response.RemoveComment} message RemoveComment
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveComment.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this RemoveComment to JSON.
         * @function toJSON
         * @memberof response.RemoveComment
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveComment.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for RemoveComment
         * @function getTypeUrl
         * @memberof response.RemoveComment
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        RemoveComment.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.RemoveComment";
        };

        return RemoveComment;
    })();

    response.UpdateComment = (function() {

        /**
         * Properties of an UpdateComment.
         * @memberof response
         * @interface IUpdateComment
         * @property {response.Status|null} [status] UpdateComment status
         * @property {string|null} [message] UpdateComment message
         */

        /**
         * Constructs a new UpdateComment.
         * @memberof response
         * @classdesc Represents an UpdateComment.
         * @implements IUpdateComment
         * @constructor
         * @param {response.IUpdateComment=} [properties] Properties to set
         */
        function UpdateComment(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateComment status.
         * @member {response.Status} status
         * @memberof response.UpdateComment
         * @instance
         */
        UpdateComment.prototype.status = 0;

        /**
         * UpdateComment message.
         * @member {string|null|undefined} message
         * @memberof response.UpdateComment
         * @instance
         */
        UpdateComment.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(UpdateComment.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new UpdateComment instance using the specified properties.
         * @function create
         * @memberof response.UpdateComment
         * @static
         * @param {response.IUpdateComment=} [properties] Properties to set
         * @returns {response.UpdateComment} UpdateComment instance
         */
        UpdateComment.create = function create(properties) {
            return new UpdateComment(properties);
        };

        /**
         * Encodes the specified UpdateComment message. Does not implicitly {@link response.UpdateComment.verify|verify} messages.
         * @function encode
         * @memberof response.UpdateComment
         * @static
         * @param {response.IUpdateComment} message UpdateComment message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateComment.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified UpdateComment message, length delimited. Does not implicitly {@link response.UpdateComment.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.UpdateComment
         * @static
         * @param {response.IUpdateComment} message UpdateComment message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateComment.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UpdateComment message from the specified reader or buffer.
         * @function decode
         * @memberof response.UpdateComment
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.UpdateComment} UpdateComment
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateComment.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.UpdateComment();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 3: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UpdateComment message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.UpdateComment
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.UpdateComment} UpdateComment
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateComment.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UpdateComment message.
         * @function verify
         * @memberof response.UpdateComment
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UpdateComment.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates an UpdateComment message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.UpdateComment
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.UpdateComment} UpdateComment
         */
        UpdateComment.fromObject = function fromObject(object) {
            if (object instanceof $root.response.UpdateComment)
                return object;
            let message = new $root.response.UpdateComment();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from an UpdateComment message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.UpdateComment
         * @static
         * @param {response.UpdateComment} message UpdateComment
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateComment.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this UpdateComment to JSON.
         * @function toJSON
         * @memberof response.UpdateComment
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateComment.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for UpdateComment
         * @function getTypeUrl
         * @memberof response.UpdateComment
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        UpdateComment.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.UpdateComment";
        };

        return UpdateComment;
    })();

    response.GetComment = (function() {

        /**
         * Properties of a GetComment.
         * @memberof response
         * @interface IGetComment
         * @property {response.Status|null} [status] GetComment status
         * @property {Uint8Array|null} [comment] GetComment comment
         * @property {string|null} [location] GetComment location
         * @property {string|null} [commentStatus] GetComment commentStatus
         * @property {string|null} [message] GetComment message
         */

        /**
         * Constructs a new GetComment.
         * @memberof response
         * @classdesc Represents a GetComment.
         * @implements IGetComment
         * @constructor
         * @param {response.IGetComment=} [properties] Properties to set
         */
        function GetComment(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetComment status.
         * @member {response.Status} status
         * @memberof response.GetComment
         * @instance
         */
        GetComment.prototype.status = 0;

        /**
         * GetComment comment.
         * @member {Uint8Array} comment
         * @memberof response.GetComment
         * @instance
         */
        GetComment.prototype.comment = $util.newBuffer([]);

        /**
         * GetComment location.
         * @member {string} location
         * @memberof response.GetComment
         * @instance
         */
        GetComment.prototype.location = "";

        /**
         * GetComment commentStatus.
         * @member {string} commentStatus
         * @memberof response.GetComment
         * @instance
         */
        GetComment.prototype.commentStatus = "";

        /**
         * GetComment message.
         * @member {string|null|undefined} message
         * @memberof response.GetComment
         * @instance
         */
        GetComment.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(GetComment.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new GetComment instance using the specified properties.
         * @function create
         * @memberof response.GetComment
         * @static
         * @param {response.IGetComment=} [properties] Properties to set
         * @returns {response.GetComment} GetComment instance
         */
        GetComment.create = function create(properties) {
            return new GetComment(properties);
        };

        /**
         * Encodes the specified GetComment message. Does not implicitly {@link response.GetComment.verify|verify} messages.
         * @function encode
         * @memberof response.GetComment
         * @static
         * @param {response.IGetComment} message GetComment message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetComment.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.comment != null && Object.hasOwnProperty.call(message, "comment"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.comment);
            if (message.location != null && Object.hasOwnProperty.call(message, "location"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.location);
            if (message.commentStatus != null && Object.hasOwnProperty.call(message, "commentStatus"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.commentStatus);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified GetComment message, length delimited. Does not implicitly {@link response.GetComment.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.GetComment
         * @static
         * @param {response.IGetComment} message GetComment message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetComment.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetComment message from the specified reader or buffer.
         * @function decode
         * @memberof response.GetComment
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.GetComment} GetComment
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetComment.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.GetComment();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.comment = reader.bytes();
                        break;
                    }
                case 3: {
                        message.location = reader.string();
                        break;
                    }
                case 4: {
                        message.commentStatus = reader.string();
                        break;
                    }
                case 5: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetComment message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.GetComment
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.GetComment} GetComment
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetComment.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetComment message.
         * @function verify
         * @memberof response.GetComment
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetComment.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.comment != null && message.hasOwnProperty("comment"))
                if (!(message.comment && typeof message.comment.length === "number" || $util.isString(message.comment)))
                    return "comment: buffer expected";
            if (message.location != null && message.hasOwnProperty("location"))
                if (!$util.isString(message.location))
                    return "location: string expected";
            if (message.commentStatus != null && message.hasOwnProperty("commentStatus"))
                if (!$util.isString(message.commentStatus))
                    return "commentStatus: string expected";
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a GetComment message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.GetComment
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.GetComment} GetComment
         */
        GetComment.fromObject = function fromObject(object) {
            if (object instanceof $root.response.GetComment)
                return object;
            let message = new $root.response.GetComment();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.comment != null)
                if (typeof object.comment === "string")
                    $util.base64.decode(object.comment, message.comment = $util.newBuffer($util.base64.length(object.comment)), 0);
                else if (object.comment.length >= 0)
                    message.comment = object.comment;
            if (object.location != null)
                message.location = String(object.location);
            if (object.commentStatus != null)
                message.commentStatus = String(object.commentStatus);
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a GetComment message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.GetComment
         * @static
         * @param {response.GetComment} message GetComment
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetComment.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.status = options.enums === String ? "SUCCESS" : 0;
                if (options.bytes === String)
                    object.comment = "";
                else {
                    object.comment = [];
                    if (options.bytes !== Array)
                        object.comment = $util.newBuffer(object.comment);
                }
                object.location = "";
                object.commentStatus = "";
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.comment != null && message.hasOwnProperty("comment"))
                object.comment = options.bytes === String ? $util.base64.encode(message.comment, 0, message.comment.length) : options.bytes === Array ? Array.prototype.slice.call(message.comment) : message.comment;
            if (message.location != null && message.hasOwnProperty("location"))
                object.location = message.location;
            if (message.commentStatus != null && message.hasOwnProperty("commentStatus"))
                object.commentStatus = message.commentStatus;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this GetComment to JSON.
         * @function toJSON
         * @memberof response.GetComment
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetComment.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetComment
         * @function getTypeUrl
         * @memberof response.GetComment
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetComment.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.GetComment";
        };

        return GetComment;
    })();

    response.ListComments = (function() {

        /**
         * Properties of a ListComments.
         * @memberof response
         * @interface IListComments
         * @property {response.Status|null} [status] ListComments status
         * @property {Array.<Uint8Array>|null} [comments] ListComments comments
         * @property {Array.<string>|null} [locations] ListComments locations
         * @property {Array.<string>|null} [commentStatus] ListComments commentStatus
         * @property {Array.<Uint8Array>|null} [commentIds] ListComments commentIds
         * @property {string|null} [listStatus] ListComments listStatus
         * @property {string|null} [message] ListComments message
         */

        /**
         * Constructs a new ListComments.
         * @memberof response
         * @classdesc Represents a ListComments.
         * @implements IListComments
         * @constructor
         * @param {response.IListComments=} [properties] Properties to set
         */
        function ListComments(properties) {
            this.comments = [];
            this.locations = [];
            this.commentStatus = [];
            this.commentIds = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListComments status.
         * @member {response.Status} status
         * @memberof response.ListComments
         * @instance
         */
        ListComments.prototype.status = 0;

        /**
         * ListComments comments.
         * @member {Array.<Uint8Array>} comments
         * @memberof response.ListComments
         * @instance
         */
        ListComments.prototype.comments = $util.emptyArray;

        /**
         * ListComments locations.
         * @member {Array.<string>} locations
         * @memberof response.ListComments
         * @instance
         */
        ListComments.prototype.locations = $util.emptyArray;

        /**
         * ListComments commentStatus.
         * @member {Array.<string>} commentStatus
         * @memberof response.ListComments
         * @instance
         */
        ListComments.prototype.commentStatus = $util.emptyArray;

        /**
         * ListComments commentIds.
         * @member {Array.<Uint8Array>} commentIds
         * @memberof response.ListComments
         * @instance
         */
        ListComments.prototype.commentIds = $util.emptyArray;

        /**
         * ListComments listStatus.
         * @member {string} listStatus
         * @memberof response.ListComments
         * @instance
         */
        ListComments.prototype.listStatus = "";

        /**
         * ListComments message.
         * @member {string|null|undefined} message
         * @memberof response.ListComments
         * @instance
         */
        ListComments.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(ListComments.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new ListComments instance using the specified properties.
         * @function create
         * @memberof response.ListComments
         * @static
         * @param {response.IListComments=} [properties] Properties to set
         * @returns {response.ListComments} ListComments instance
         */
        ListComments.create = function create(properties) {
            return new ListComments(properties);
        };

        /**
         * Encodes the specified ListComments message. Does not implicitly {@link response.ListComments.verify|verify} messages.
         * @function encode
         * @memberof response.ListComments
         * @static
         * @param {response.IListComments} message ListComments message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListComments.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.comments != null && message.comments.length)
                for (let i = 0; i < message.comments.length; ++i)
                    writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.comments[i]);
            if (message.locations != null && message.locations.length)
                for (let i = 0; i < message.locations.length; ++i)
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.locations[i]);
            if (message.commentStatus != null && message.commentStatus.length)
                for (let i = 0; i < message.commentStatus.length; ++i)
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.commentStatus[i]);
            if (message.commentIds != null && message.commentIds.length)
                for (let i = 0; i < message.commentIds.length; ++i)
                    writer.uint32(/* id 5, wireType 2 =*/42).bytes(message.commentIds[i]);
            if (message.listStatus != null && Object.hasOwnProperty.call(message, "listStatus"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.listStatus);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified ListComments message, length delimited. Does not implicitly {@link response.ListComments.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.ListComments
         * @static
         * @param {response.IListComments} message ListComments message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListComments.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ListComments message from the specified reader or buffer.
         * @function decode
         * @memberof response.ListComments
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.ListComments} ListComments
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListComments.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.ListComments();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        if (!(message.comments && message.comments.length))
                            message.comments = [];
                        message.comments.push(reader.bytes());
                        break;
                    }
                case 3: {
                        if (!(message.locations && message.locations.length))
                            message.locations = [];
                        message.locations.push(reader.string());
                        break;
                    }
                case 4: {
                        if (!(message.commentStatus && message.commentStatus.length))
                            message.commentStatus = [];
                        message.commentStatus.push(reader.string());
                        break;
                    }
                case 5: {
                        if (!(message.commentIds && message.commentIds.length))
                            message.commentIds = [];
                        message.commentIds.push(reader.bytes());
                        break;
                    }
                case 6: {
                        message.listStatus = reader.string();
                        break;
                    }
                case 7: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ListComments message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.ListComments
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.ListComments} ListComments
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListComments.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ListComments message.
         * @function verify
         * @memberof response.ListComments
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ListComments.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.comments != null && message.hasOwnProperty("comments")) {
                if (!Array.isArray(message.comments))
                    return "comments: array expected";
                for (let i = 0; i < message.comments.length; ++i)
                    if (!(message.comments[i] && typeof message.comments[i].length === "number" || $util.isString(message.comments[i])))
                        return "comments: buffer[] expected";
            }
            if (message.locations != null && message.hasOwnProperty("locations")) {
                if (!Array.isArray(message.locations))
                    return "locations: array expected";
                for (let i = 0; i < message.locations.length; ++i)
                    if (!$util.isString(message.locations[i]))
                        return "locations: string[] expected";
            }
            if (message.commentStatus != null && message.hasOwnProperty("commentStatus")) {
                if (!Array.isArray(message.commentStatus))
                    return "commentStatus: array expected";
                for (let i = 0; i < message.commentStatus.length; ++i)
                    if (!$util.isString(message.commentStatus[i]))
                        return "commentStatus: string[] expected";
            }
            if (message.commentIds != null && message.hasOwnProperty("commentIds")) {
                if (!Array.isArray(message.commentIds))
                    return "commentIds: array expected";
                for (let i = 0; i < message.commentIds.length; ++i)
                    if (!(message.commentIds[i] && typeof message.commentIds[i].length === "number" || $util.isString(message.commentIds[i])))
                        return "commentIds: buffer[] expected";
            }
            if (message.listStatus != null && message.hasOwnProperty("listStatus"))
                if (!$util.isString(message.listStatus))
                    return "listStatus: string expected";
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a ListComments message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.ListComments
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.ListComments} ListComments
         */
        ListComments.fromObject = function fromObject(object) {
            if (object instanceof $root.response.ListComments)
                return object;
            let message = new $root.response.ListComments();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.comments) {
                if (!Array.isArray(object.comments))
                    throw TypeError(".response.ListComments.comments: array expected");
                message.comments = [];
                for (let i = 0; i < object.comments.length; ++i)
                    if (typeof object.comments[i] === "string")
                        $util.base64.decode(object.comments[i], message.comments[i] = $util.newBuffer($util.base64.length(object.comments[i])), 0);
                    else if (object.comments[i].length >= 0)
                        message.comments[i] = object.comments[i];
            }
            if (object.locations) {
                if (!Array.isArray(object.locations))
                    throw TypeError(".response.ListComments.locations: array expected");
                message.locations = [];
                for (let i = 0; i < object.locations.length; ++i)
                    message.locations[i] = String(object.locations[i]);
            }
            if (object.commentStatus) {
                if (!Array.isArray(object.commentStatus))
                    throw TypeError(".response.ListComments.commentStatus: array expected");
                message.commentStatus = [];
                for (let i = 0; i < object.commentStatus.length; ++i)
                    message.commentStatus[i] = String(object.commentStatus[i]);
            }
            if (object.commentIds) {
                if (!Array.isArray(object.commentIds))
                    throw TypeError(".response.ListComments.commentIds: array expected");
                message.commentIds = [];
                for (let i = 0; i < object.commentIds.length; ++i)
                    if (typeof object.commentIds[i] === "string")
                        $util.base64.decode(object.commentIds[i], message.commentIds[i] = $util.newBuffer($util.base64.length(object.commentIds[i])), 0);
                    else if (object.commentIds[i].length >= 0)
                        message.commentIds[i] = object.commentIds[i];
            }
            if (object.listStatus != null)
                message.listStatus = String(object.listStatus);
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a ListComments message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.ListComments
         * @static
         * @param {response.ListComments} message ListComments
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListComments.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.comments = [];
                object.locations = [];
                object.commentStatus = [];
                object.commentIds = [];
            }
            if (options.defaults) {
                object.status = options.enums === String ? "SUCCESS" : 0;
                object.listStatus = "";
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.comments && message.comments.length) {
                object.comments = [];
                for (let j = 0; j < message.comments.length; ++j)
                    object.comments[j] = options.bytes === String ? $util.base64.encode(message.comments[j], 0, message.comments[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.comments[j]) : message.comments[j];
            }
            if (message.locations && message.locations.length) {
                object.locations = [];
                for (let j = 0; j < message.locations.length; ++j)
                    object.locations[j] = message.locations[j];
            }
            if (message.commentStatus && message.commentStatus.length) {
                object.commentStatus = [];
                for (let j = 0; j < message.commentStatus.length; ++j)
                    object.commentStatus[j] = message.commentStatus[j];
            }
            if (message.commentIds && message.commentIds.length) {
                object.commentIds = [];
                for (let j = 0; j < message.commentIds.length; ++j)
                    object.commentIds[j] = options.bytes === String ? $util.base64.encode(message.commentIds[j], 0, message.commentIds[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.commentIds[j]) : message.commentIds[j];
            }
            if (message.listStatus != null && message.hasOwnProperty("listStatus"))
                object.listStatus = message.listStatus;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this ListComments to JSON.
         * @function toJSON
         * @memberof response.ListComments
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListComments.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ListComments
         * @function getTypeUrl
         * @memberof response.ListComments
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ListComments.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.ListComments";
        };

        return ListComments;
    })();

    response.StoragePlan = (function() {

        /**
         * Properties of a StoragePlan.
         * @memberof response
         * @interface IStoragePlan
         * @property {number|null} [planId] StoragePlan planId
         * @property {string|null} [type] StoragePlan type
         * @property {number|Long|null} [price] StoragePlan price
         * @property {number|Long|null} [maxTeams] StoragePlan maxTeams
         * @property {number|Long|null} [maxRoles] StoragePlan maxRoles
         * @property {number|Long|null} [maxLogAnalysis] StoragePlan maxLogAnalysis
         * @property {number|Long|null} [storage] StoragePlan storage
         * @property {number|Long|null} [maxSpaces] StoragePlan maxSpaces
         * @property {number|Long|null} [maxFlows] StoragePlan maxFlows
         * @property {number|Long|null} [maxFlowTypes] StoragePlan maxFlowTypes
         * @property {number|Long|null} [minUsers] StoragePlan minUsers
         * @property {number|Long|null} [perUserCost] StoragePlan perUserCost
         * @property {number|Long|null} [perGbCost] StoragePlan perGbCost
         * @property {number|Long|null} [maxPins] StoragePlan maxPins
         * @property {number|Long|null} [maxAlerts] StoragePlan maxAlerts
         * @property {number|Long|null} [trash] StoragePlan trash
         * @property {number|Long|null} [logsHistory] StoragePlan logsHistory
         * @property {boolean|null} [autoAddUsers] StoragePlan autoAddUsers
         * @property {boolean|null} [autoAddStorage] StoragePlan autoAddStorage
         * @property {number|Long|null} [maxTags] StoragePlan maxTags
         * @property {number|Long|null} [maxVersions] StoragePlan maxVersions
         * @property {string|null} [name] StoragePlan name
         * @property {string|null} [redundancy] StoragePlan redundancy
         * @property {string|null} [support] StoragePlan support
         * @property {boolean|null} [ransomwareProtection] StoragePlan ransomwareProtection
         * @property {boolean|null} [collabration] StoragePlan collabration
         * @property {boolean|null} [internalSharing] StoragePlan internalSharing
         * @property {boolean|null} [tagBasedAnalysis] StoragePlan tagBasedAnalysis
         * @property {boolean|null} [advacedSpaceFeatures] StoragePlan advacedSpaceFeatures
         * @property {boolean|null} [compilanceReports] StoragePlan compilanceReports
         * @property {boolean|null} [geoLocationBasedAlerts] StoragePlan geoLocationBasedAlerts
         * @property {boolean|null} [dedicatedCluster] StoragePlan dedicatedCluster
         * @property {number|null} [maxDevices] StoragePlan maxDevices
         * @property {number|null} [parallelEdits] StoragePlan parallelEdits
         * @property {boolean|null} [docsAndSheets] StoragePlan docsAndSheets
         */

        /**
         * Constructs a new StoragePlan.
         * @memberof response
         * @classdesc Represents a StoragePlan.
         * @implements IStoragePlan
         * @constructor
         * @param {response.IStoragePlan=} [properties] Properties to set
         */
        function StoragePlan(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * StoragePlan planId.
         * @member {number} planId
         * @memberof response.StoragePlan
         * @instance
         */
        StoragePlan.prototype.planId = 0;

        /**
         * StoragePlan type.
         * @member {string} type
         * @memberof response.StoragePlan
         * @instance
         */
        StoragePlan.prototype.type = "";

        /**
         * StoragePlan price.
         * @member {number|Long} price
         * @memberof response.StoragePlan
         * @instance
         */
        StoragePlan.prototype.price = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * StoragePlan maxTeams.
         * @member {number|Long} maxTeams
         * @memberof response.StoragePlan
         * @instance
         */
        StoragePlan.prototype.maxTeams = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * StoragePlan maxRoles.
         * @member {number|Long} maxRoles
         * @memberof response.StoragePlan
         * @instance
         */
        StoragePlan.prototype.maxRoles = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * StoragePlan maxLogAnalysis.
         * @member {number|Long} maxLogAnalysis
         * @memberof response.StoragePlan
         * @instance
         */
        StoragePlan.prototype.maxLogAnalysis = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * StoragePlan storage.
         * @member {number|Long} storage
         * @memberof response.StoragePlan
         * @instance
         */
        StoragePlan.prototype.storage = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * StoragePlan maxSpaces.
         * @member {number|Long} maxSpaces
         * @memberof response.StoragePlan
         * @instance
         */
        StoragePlan.prototype.maxSpaces = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * StoragePlan maxFlows.
         * @member {number|Long} maxFlows
         * @memberof response.StoragePlan
         * @instance
         */
        StoragePlan.prototype.maxFlows = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * StoragePlan maxFlowTypes.
         * @member {number|Long} maxFlowTypes
         * @memberof response.StoragePlan
         * @instance
         */
        StoragePlan.prototype.maxFlowTypes = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * StoragePlan minUsers.
         * @member {number|Long} minUsers
         * @memberof response.StoragePlan
         * @instance
         */
        StoragePlan.prototype.minUsers = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * StoragePlan perUserCost.
         * @member {number|Long} perUserCost
         * @memberof response.StoragePlan
         * @instance
         */
        StoragePlan.prototype.perUserCost = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * StoragePlan perGbCost.
         * @member {number|Long} perGbCost
         * @memberof response.StoragePlan
         * @instance
         */
        StoragePlan.prototype.perGbCost = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * StoragePlan maxPins.
         * @member {number|Long} maxPins
         * @memberof response.StoragePlan
         * @instance
         */
        StoragePlan.prototype.maxPins = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * StoragePlan maxAlerts.
         * @member {number|Long} maxAlerts
         * @memberof response.StoragePlan
         * @instance
         */
        StoragePlan.prototype.maxAlerts = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * StoragePlan trash.
         * @member {number|Long} trash
         * @memberof response.StoragePlan
         * @instance
         */
        StoragePlan.prototype.trash = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * StoragePlan logsHistory.
         * @member {number|Long} logsHistory
         * @memberof response.StoragePlan
         * @instance
         */
        StoragePlan.prototype.logsHistory = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * StoragePlan autoAddUsers.
         * @member {boolean} autoAddUsers
         * @memberof response.StoragePlan
         * @instance
         */
        StoragePlan.prototype.autoAddUsers = false;

        /**
         * StoragePlan autoAddStorage.
         * @member {boolean} autoAddStorage
         * @memberof response.StoragePlan
         * @instance
         */
        StoragePlan.prototype.autoAddStorage = false;

        /**
         * StoragePlan maxTags.
         * @member {number|Long} maxTags
         * @memberof response.StoragePlan
         * @instance
         */
        StoragePlan.prototype.maxTags = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * StoragePlan maxVersions.
         * @member {number|Long} maxVersions
         * @memberof response.StoragePlan
         * @instance
         */
        StoragePlan.prototype.maxVersions = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * StoragePlan name.
         * @member {string} name
         * @memberof response.StoragePlan
         * @instance
         */
        StoragePlan.prototype.name = "";

        /**
         * StoragePlan redundancy.
         * @member {string} redundancy
         * @memberof response.StoragePlan
         * @instance
         */
        StoragePlan.prototype.redundancy = "";

        /**
         * StoragePlan support.
         * @member {string} support
         * @memberof response.StoragePlan
         * @instance
         */
        StoragePlan.prototype.support = "";

        /**
         * StoragePlan ransomwareProtection.
         * @member {boolean} ransomwareProtection
         * @memberof response.StoragePlan
         * @instance
         */
        StoragePlan.prototype.ransomwareProtection = false;

        /**
         * StoragePlan collabration.
         * @member {boolean} collabration
         * @memberof response.StoragePlan
         * @instance
         */
        StoragePlan.prototype.collabration = false;

        /**
         * StoragePlan internalSharing.
         * @member {boolean} internalSharing
         * @memberof response.StoragePlan
         * @instance
         */
        StoragePlan.prototype.internalSharing = false;

        /**
         * StoragePlan tagBasedAnalysis.
         * @member {boolean} tagBasedAnalysis
         * @memberof response.StoragePlan
         * @instance
         */
        StoragePlan.prototype.tagBasedAnalysis = false;

        /**
         * StoragePlan advacedSpaceFeatures.
         * @member {boolean} advacedSpaceFeatures
         * @memberof response.StoragePlan
         * @instance
         */
        StoragePlan.prototype.advacedSpaceFeatures = false;

        /**
         * StoragePlan compilanceReports.
         * @member {boolean} compilanceReports
         * @memberof response.StoragePlan
         * @instance
         */
        StoragePlan.prototype.compilanceReports = false;

        /**
         * StoragePlan geoLocationBasedAlerts.
         * @member {boolean} geoLocationBasedAlerts
         * @memberof response.StoragePlan
         * @instance
         */
        StoragePlan.prototype.geoLocationBasedAlerts = false;

        /**
         * StoragePlan dedicatedCluster.
         * @member {boolean} dedicatedCluster
         * @memberof response.StoragePlan
         * @instance
         */
        StoragePlan.prototype.dedicatedCluster = false;

        /**
         * StoragePlan maxDevices.
         * @member {number} maxDevices
         * @memberof response.StoragePlan
         * @instance
         */
        StoragePlan.prototype.maxDevices = 0;

        /**
         * StoragePlan parallelEdits.
         * @member {number} parallelEdits
         * @memberof response.StoragePlan
         * @instance
         */
        StoragePlan.prototype.parallelEdits = 0;

        /**
         * StoragePlan docsAndSheets.
         * @member {boolean} docsAndSheets
         * @memberof response.StoragePlan
         * @instance
         */
        StoragePlan.prototype.docsAndSheets = false;

        /**
         * Creates a new StoragePlan instance using the specified properties.
         * @function create
         * @memberof response.StoragePlan
         * @static
         * @param {response.IStoragePlan=} [properties] Properties to set
         * @returns {response.StoragePlan} StoragePlan instance
         */
        StoragePlan.create = function create(properties) {
            return new StoragePlan(properties);
        };

        /**
         * Encodes the specified StoragePlan message. Does not implicitly {@link response.StoragePlan.verify|verify} messages.
         * @function encode
         * @memberof response.StoragePlan
         * @static
         * @param {response.IStoragePlan} message StoragePlan message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StoragePlan.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.type);
            if (message.price != null && Object.hasOwnProperty.call(message, "price"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.price);
            if (message.maxTeams != null && Object.hasOwnProperty.call(message, "maxTeams"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.maxTeams);
            if (message.maxRoles != null && Object.hasOwnProperty.call(message, "maxRoles"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.maxRoles);
            if (message.maxLogAnalysis != null && Object.hasOwnProperty.call(message, "maxLogAnalysis"))
                writer.uint32(/* id 5, wireType 0 =*/40).uint64(message.maxLogAnalysis);
            if (message.storage != null && Object.hasOwnProperty.call(message, "storage"))
                writer.uint32(/* id 6, wireType 0 =*/48).uint64(message.storage);
            if (message.maxSpaces != null && Object.hasOwnProperty.call(message, "maxSpaces"))
                writer.uint32(/* id 7, wireType 0 =*/56).uint64(message.maxSpaces);
            if (message.maxFlows != null && Object.hasOwnProperty.call(message, "maxFlows"))
                writer.uint32(/* id 8, wireType 0 =*/64).uint64(message.maxFlows);
            if (message.maxFlowTypes != null && Object.hasOwnProperty.call(message, "maxFlowTypes"))
                writer.uint32(/* id 9, wireType 0 =*/72).uint64(message.maxFlowTypes);
            if (message.minUsers != null && Object.hasOwnProperty.call(message, "minUsers"))
                writer.uint32(/* id 10, wireType 0 =*/80).uint64(message.minUsers);
            if (message.perUserCost != null && Object.hasOwnProperty.call(message, "perUserCost"))
                writer.uint32(/* id 11, wireType 0 =*/88).uint64(message.perUserCost);
            if (message.perGbCost != null && Object.hasOwnProperty.call(message, "perGbCost"))
                writer.uint32(/* id 12, wireType 0 =*/96).uint64(message.perGbCost);
            if (message.maxPins != null && Object.hasOwnProperty.call(message, "maxPins"))
                writer.uint32(/* id 13, wireType 0 =*/104).uint64(message.maxPins);
            if (message.maxAlerts != null && Object.hasOwnProperty.call(message, "maxAlerts"))
                writer.uint32(/* id 14, wireType 0 =*/112).uint64(message.maxAlerts);
            if (message.trash != null && Object.hasOwnProperty.call(message, "trash"))
                writer.uint32(/* id 15, wireType 0 =*/120).uint64(message.trash);
            if (message.logsHistory != null && Object.hasOwnProperty.call(message, "logsHistory"))
                writer.uint32(/* id 16, wireType 0 =*/128).uint64(message.logsHistory);
            if (message.autoAddUsers != null && Object.hasOwnProperty.call(message, "autoAddUsers"))
                writer.uint32(/* id 17, wireType 0 =*/136).bool(message.autoAddUsers);
            if (message.autoAddStorage != null && Object.hasOwnProperty.call(message, "autoAddStorage"))
                writer.uint32(/* id 18, wireType 0 =*/144).bool(message.autoAddStorage);
            if (message.maxTags != null && Object.hasOwnProperty.call(message, "maxTags"))
                writer.uint32(/* id 19, wireType 0 =*/152).uint64(message.maxTags);
            if (message.planId != null && Object.hasOwnProperty.call(message, "planId"))
                writer.uint32(/* id 20, wireType 0 =*/160).uint32(message.planId);
            if (message.maxVersions != null && Object.hasOwnProperty.call(message, "maxVersions"))
                writer.uint32(/* id 21, wireType 0 =*/168).uint64(message.maxVersions);
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 22, wireType 2 =*/178).string(message.name);
            if (message.support != null && Object.hasOwnProperty.call(message, "support"))
                writer.uint32(/* id 23, wireType 2 =*/186).string(message.support);
            if (message.ransomwareProtection != null && Object.hasOwnProperty.call(message, "ransomwareProtection"))
                writer.uint32(/* id 24, wireType 0 =*/192).bool(message.ransomwareProtection);
            if (message.collabration != null && Object.hasOwnProperty.call(message, "collabration"))
                writer.uint32(/* id 25, wireType 0 =*/200).bool(message.collabration);
            if (message.redundancy != null && Object.hasOwnProperty.call(message, "redundancy"))
                writer.uint32(/* id 26, wireType 2 =*/210).string(message.redundancy);
            if (message.internalSharing != null && Object.hasOwnProperty.call(message, "internalSharing"))
                writer.uint32(/* id 27, wireType 0 =*/216).bool(message.internalSharing);
            if (message.tagBasedAnalysis != null && Object.hasOwnProperty.call(message, "tagBasedAnalysis"))
                writer.uint32(/* id 28, wireType 0 =*/224).bool(message.tagBasedAnalysis);
            if (message.advacedSpaceFeatures != null && Object.hasOwnProperty.call(message, "advacedSpaceFeatures"))
                writer.uint32(/* id 29, wireType 0 =*/232).bool(message.advacedSpaceFeatures);
            if (message.compilanceReports != null && Object.hasOwnProperty.call(message, "compilanceReports"))
                writer.uint32(/* id 30, wireType 0 =*/240).bool(message.compilanceReports);
            if (message.geoLocationBasedAlerts != null && Object.hasOwnProperty.call(message, "geoLocationBasedAlerts"))
                writer.uint32(/* id 31, wireType 0 =*/248).bool(message.geoLocationBasedAlerts);
            if (message.dedicatedCluster != null && Object.hasOwnProperty.call(message, "dedicatedCluster"))
                writer.uint32(/* id 32, wireType 0 =*/256).bool(message.dedicatedCluster);
            if (message.maxDevices != null && Object.hasOwnProperty.call(message, "maxDevices"))
                writer.uint32(/* id 33, wireType 0 =*/264).int32(message.maxDevices);
            if (message.parallelEdits != null && Object.hasOwnProperty.call(message, "parallelEdits"))
                writer.uint32(/* id 34, wireType 0 =*/272).int32(message.parallelEdits);
            if (message.docsAndSheets != null && Object.hasOwnProperty.call(message, "docsAndSheets"))
                writer.uint32(/* id 35, wireType 0 =*/280).bool(message.docsAndSheets);
            return writer;
        };

        /**
         * Encodes the specified StoragePlan message, length delimited. Does not implicitly {@link response.StoragePlan.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.StoragePlan
         * @static
         * @param {response.IStoragePlan} message StoragePlan message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StoragePlan.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a StoragePlan message from the specified reader or buffer.
         * @function decode
         * @memberof response.StoragePlan
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.StoragePlan} StoragePlan
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StoragePlan.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.StoragePlan();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 20: {
                        message.planId = reader.uint32();
                        break;
                    }
                case 1: {
                        message.type = reader.string();
                        break;
                    }
                case 2: {
                        message.price = reader.uint64();
                        break;
                    }
                case 3: {
                        message.maxTeams = reader.uint64();
                        break;
                    }
                case 4: {
                        message.maxRoles = reader.uint64();
                        break;
                    }
                case 5: {
                        message.maxLogAnalysis = reader.uint64();
                        break;
                    }
                case 6: {
                        message.storage = reader.uint64();
                        break;
                    }
                case 7: {
                        message.maxSpaces = reader.uint64();
                        break;
                    }
                case 8: {
                        message.maxFlows = reader.uint64();
                        break;
                    }
                case 9: {
                        message.maxFlowTypes = reader.uint64();
                        break;
                    }
                case 10: {
                        message.minUsers = reader.uint64();
                        break;
                    }
                case 11: {
                        message.perUserCost = reader.uint64();
                        break;
                    }
                case 12: {
                        message.perGbCost = reader.uint64();
                        break;
                    }
                case 13: {
                        message.maxPins = reader.uint64();
                        break;
                    }
                case 14: {
                        message.maxAlerts = reader.uint64();
                        break;
                    }
                case 15: {
                        message.trash = reader.uint64();
                        break;
                    }
                case 16: {
                        message.logsHistory = reader.uint64();
                        break;
                    }
                case 17: {
                        message.autoAddUsers = reader.bool();
                        break;
                    }
                case 18: {
                        message.autoAddStorage = reader.bool();
                        break;
                    }
                case 19: {
                        message.maxTags = reader.uint64();
                        break;
                    }
                case 21: {
                        message.maxVersions = reader.uint64();
                        break;
                    }
                case 22: {
                        message.name = reader.string();
                        break;
                    }
                case 26: {
                        message.redundancy = reader.string();
                        break;
                    }
                case 23: {
                        message.support = reader.string();
                        break;
                    }
                case 24: {
                        message.ransomwareProtection = reader.bool();
                        break;
                    }
                case 25: {
                        message.collabration = reader.bool();
                        break;
                    }
                case 27: {
                        message.internalSharing = reader.bool();
                        break;
                    }
                case 28: {
                        message.tagBasedAnalysis = reader.bool();
                        break;
                    }
                case 29: {
                        message.advacedSpaceFeatures = reader.bool();
                        break;
                    }
                case 30: {
                        message.compilanceReports = reader.bool();
                        break;
                    }
                case 31: {
                        message.geoLocationBasedAlerts = reader.bool();
                        break;
                    }
                case 32: {
                        message.dedicatedCluster = reader.bool();
                        break;
                    }
                case 33: {
                        message.maxDevices = reader.int32();
                        break;
                    }
                case 34: {
                        message.parallelEdits = reader.int32();
                        break;
                    }
                case 35: {
                        message.docsAndSheets = reader.bool();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a StoragePlan message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.StoragePlan
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.StoragePlan} StoragePlan
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StoragePlan.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a StoragePlan message.
         * @function verify
         * @memberof response.StoragePlan
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        StoragePlan.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.planId != null && message.hasOwnProperty("planId"))
                if (!$util.isInteger(message.planId))
                    return "planId: integer expected";
            if (message.type != null && message.hasOwnProperty("type"))
                if (!$util.isString(message.type))
                    return "type: string expected";
            if (message.price != null && message.hasOwnProperty("price"))
                if (!$util.isInteger(message.price) && !(message.price && $util.isInteger(message.price.low) && $util.isInteger(message.price.high)))
                    return "price: integer|Long expected";
            if (message.maxTeams != null && message.hasOwnProperty("maxTeams"))
                if (!$util.isInteger(message.maxTeams) && !(message.maxTeams && $util.isInteger(message.maxTeams.low) && $util.isInteger(message.maxTeams.high)))
                    return "maxTeams: integer|Long expected";
            if (message.maxRoles != null && message.hasOwnProperty("maxRoles"))
                if (!$util.isInteger(message.maxRoles) && !(message.maxRoles && $util.isInteger(message.maxRoles.low) && $util.isInteger(message.maxRoles.high)))
                    return "maxRoles: integer|Long expected";
            if (message.maxLogAnalysis != null && message.hasOwnProperty("maxLogAnalysis"))
                if (!$util.isInteger(message.maxLogAnalysis) && !(message.maxLogAnalysis && $util.isInteger(message.maxLogAnalysis.low) && $util.isInteger(message.maxLogAnalysis.high)))
                    return "maxLogAnalysis: integer|Long expected";
            if (message.storage != null && message.hasOwnProperty("storage"))
                if (!$util.isInteger(message.storage) && !(message.storage && $util.isInteger(message.storage.low) && $util.isInteger(message.storage.high)))
                    return "storage: integer|Long expected";
            if (message.maxSpaces != null && message.hasOwnProperty("maxSpaces"))
                if (!$util.isInteger(message.maxSpaces) && !(message.maxSpaces && $util.isInteger(message.maxSpaces.low) && $util.isInteger(message.maxSpaces.high)))
                    return "maxSpaces: integer|Long expected";
            if (message.maxFlows != null && message.hasOwnProperty("maxFlows"))
                if (!$util.isInteger(message.maxFlows) && !(message.maxFlows && $util.isInteger(message.maxFlows.low) && $util.isInteger(message.maxFlows.high)))
                    return "maxFlows: integer|Long expected";
            if (message.maxFlowTypes != null && message.hasOwnProperty("maxFlowTypes"))
                if (!$util.isInteger(message.maxFlowTypes) && !(message.maxFlowTypes && $util.isInteger(message.maxFlowTypes.low) && $util.isInteger(message.maxFlowTypes.high)))
                    return "maxFlowTypes: integer|Long expected";
            if (message.minUsers != null && message.hasOwnProperty("minUsers"))
                if (!$util.isInteger(message.minUsers) && !(message.minUsers && $util.isInteger(message.minUsers.low) && $util.isInteger(message.minUsers.high)))
                    return "minUsers: integer|Long expected";
            if (message.perUserCost != null && message.hasOwnProperty("perUserCost"))
                if (!$util.isInteger(message.perUserCost) && !(message.perUserCost && $util.isInteger(message.perUserCost.low) && $util.isInteger(message.perUserCost.high)))
                    return "perUserCost: integer|Long expected";
            if (message.perGbCost != null && message.hasOwnProperty("perGbCost"))
                if (!$util.isInteger(message.perGbCost) && !(message.perGbCost && $util.isInteger(message.perGbCost.low) && $util.isInteger(message.perGbCost.high)))
                    return "perGbCost: integer|Long expected";
            if (message.maxPins != null && message.hasOwnProperty("maxPins"))
                if (!$util.isInteger(message.maxPins) && !(message.maxPins && $util.isInteger(message.maxPins.low) && $util.isInteger(message.maxPins.high)))
                    return "maxPins: integer|Long expected";
            if (message.maxAlerts != null && message.hasOwnProperty("maxAlerts"))
                if (!$util.isInteger(message.maxAlerts) && !(message.maxAlerts && $util.isInteger(message.maxAlerts.low) && $util.isInteger(message.maxAlerts.high)))
                    return "maxAlerts: integer|Long expected";
            if (message.trash != null && message.hasOwnProperty("trash"))
                if (!$util.isInteger(message.trash) && !(message.trash && $util.isInteger(message.trash.low) && $util.isInteger(message.trash.high)))
                    return "trash: integer|Long expected";
            if (message.logsHistory != null && message.hasOwnProperty("logsHistory"))
                if (!$util.isInteger(message.logsHistory) && !(message.logsHistory && $util.isInteger(message.logsHistory.low) && $util.isInteger(message.logsHistory.high)))
                    return "logsHistory: integer|Long expected";
            if (message.autoAddUsers != null && message.hasOwnProperty("autoAddUsers"))
                if (typeof message.autoAddUsers !== "boolean")
                    return "autoAddUsers: boolean expected";
            if (message.autoAddStorage != null && message.hasOwnProperty("autoAddStorage"))
                if (typeof message.autoAddStorage !== "boolean")
                    return "autoAddStorage: boolean expected";
            if (message.maxTags != null && message.hasOwnProperty("maxTags"))
                if (!$util.isInteger(message.maxTags) && !(message.maxTags && $util.isInteger(message.maxTags.low) && $util.isInteger(message.maxTags.high)))
                    return "maxTags: integer|Long expected";
            if (message.maxVersions != null && message.hasOwnProperty("maxVersions"))
                if (!$util.isInteger(message.maxVersions) && !(message.maxVersions && $util.isInteger(message.maxVersions.low) && $util.isInteger(message.maxVersions.high)))
                    return "maxVersions: integer|Long expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.redundancy != null && message.hasOwnProperty("redundancy"))
                if (!$util.isString(message.redundancy))
                    return "redundancy: string expected";
            if (message.support != null && message.hasOwnProperty("support"))
                if (!$util.isString(message.support))
                    return "support: string expected";
            if (message.ransomwareProtection != null && message.hasOwnProperty("ransomwareProtection"))
                if (typeof message.ransomwareProtection !== "boolean")
                    return "ransomwareProtection: boolean expected";
            if (message.collabration != null && message.hasOwnProperty("collabration"))
                if (typeof message.collabration !== "boolean")
                    return "collabration: boolean expected";
            if (message.internalSharing != null && message.hasOwnProperty("internalSharing"))
                if (typeof message.internalSharing !== "boolean")
                    return "internalSharing: boolean expected";
            if (message.tagBasedAnalysis != null && message.hasOwnProperty("tagBasedAnalysis"))
                if (typeof message.tagBasedAnalysis !== "boolean")
                    return "tagBasedAnalysis: boolean expected";
            if (message.advacedSpaceFeatures != null && message.hasOwnProperty("advacedSpaceFeatures"))
                if (typeof message.advacedSpaceFeatures !== "boolean")
                    return "advacedSpaceFeatures: boolean expected";
            if (message.compilanceReports != null && message.hasOwnProperty("compilanceReports"))
                if (typeof message.compilanceReports !== "boolean")
                    return "compilanceReports: boolean expected";
            if (message.geoLocationBasedAlerts != null && message.hasOwnProperty("geoLocationBasedAlerts"))
                if (typeof message.geoLocationBasedAlerts !== "boolean")
                    return "geoLocationBasedAlerts: boolean expected";
            if (message.dedicatedCluster != null && message.hasOwnProperty("dedicatedCluster"))
                if (typeof message.dedicatedCluster !== "boolean")
                    return "dedicatedCluster: boolean expected";
            if (message.maxDevices != null && message.hasOwnProperty("maxDevices"))
                if (!$util.isInteger(message.maxDevices))
                    return "maxDevices: integer expected";
            if (message.parallelEdits != null && message.hasOwnProperty("parallelEdits"))
                if (!$util.isInteger(message.parallelEdits))
                    return "parallelEdits: integer expected";
            if (message.docsAndSheets != null && message.hasOwnProperty("docsAndSheets"))
                if (typeof message.docsAndSheets !== "boolean")
                    return "docsAndSheets: boolean expected";
            return null;
        };

        /**
         * Creates a StoragePlan message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.StoragePlan
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.StoragePlan} StoragePlan
         */
        StoragePlan.fromObject = function fromObject(object) {
            if (object instanceof $root.response.StoragePlan)
                return object;
            let message = new $root.response.StoragePlan();
            if (object.planId != null)
                message.planId = object.planId >>> 0;
            if (object.type != null)
                message.type = String(object.type);
            if (object.price != null)
                if ($util.Long)
                    (message.price = $util.Long.fromValue(object.price)).unsigned = true;
                else if (typeof object.price === "string")
                    message.price = parseInt(object.price, 10);
                else if (typeof object.price === "number")
                    message.price = object.price;
                else if (typeof object.price === "object")
                    message.price = new $util.LongBits(object.price.low >>> 0, object.price.high >>> 0).toNumber(true);
            if (object.maxTeams != null)
                if ($util.Long)
                    (message.maxTeams = $util.Long.fromValue(object.maxTeams)).unsigned = true;
                else if (typeof object.maxTeams === "string")
                    message.maxTeams = parseInt(object.maxTeams, 10);
                else if (typeof object.maxTeams === "number")
                    message.maxTeams = object.maxTeams;
                else if (typeof object.maxTeams === "object")
                    message.maxTeams = new $util.LongBits(object.maxTeams.low >>> 0, object.maxTeams.high >>> 0).toNumber(true);
            if (object.maxRoles != null)
                if ($util.Long)
                    (message.maxRoles = $util.Long.fromValue(object.maxRoles)).unsigned = true;
                else if (typeof object.maxRoles === "string")
                    message.maxRoles = parseInt(object.maxRoles, 10);
                else if (typeof object.maxRoles === "number")
                    message.maxRoles = object.maxRoles;
                else if (typeof object.maxRoles === "object")
                    message.maxRoles = new $util.LongBits(object.maxRoles.low >>> 0, object.maxRoles.high >>> 0).toNumber(true);
            if (object.maxLogAnalysis != null)
                if ($util.Long)
                    (message.maxLogAnalysis = $util.Long.fromValue(object.maxLogAnalysis)).unsigned = true;
                else if (typeof object.maxLogAnalysis === "string")
                    message.maxLogAnalysis = parseInt(object.maxLogAnalysis, 10);
                else if (typeof object.maxLogAnalysis === "number")
                    message.maxLogAnalysis = object.maxLogAnalysis;
                else if (typeof object.maxLogAnalysis === "object")
                    message.maxLogAnalysis = new $util.LongBits(object.maxLogAnalysis.low >>> 0, object.maxLogAnalysis.high >>> 0).toNumber(true);
            if (object.storage != null)
                if ($util.Long)
                    (message.storage = $util.Long.fromValue(object.storage)).unsigned = true;
                else if (typeof object.storage === "string")
                    message.storage = parseInt(object.storage, 10);
                else if (typeof object.storage === "number")
                    message.storage = object.storage;
                else if (typeof object.storage === "object")
                    message.storage = new $util.LongBits(object.storage.low >>> 0, object.storage.high >>> 0).toNumber(true);
            if (object.maxSpaces != null)
                if ($util.Long)
                    (message.maxSpaces = $util.Long.fromValue(object.maxSpaces)).unsigned = true;
                else if (typeof object.maxSpaces === "string")
                    message.maxSpaces = parseInt(object.maxSpaces, 10);
                else if (typeof object.maxSpaces === "number")
                    message.maxSpaces = object.maxSpaces;
                else if (typeof object.maxSpaces === "object")
                    message.maxSpaces = new $util.LongBits(object.maxSpaces.low >>> 0, object.maxSpaces.high >>> 0).toNumber(true);
            if (object.maxFlows != null)
                if ($util.Long)
                    (message.maxFlows = $util.Long.fromValue(object.maxFlows)).unsigned = true;
                else if (typeof object.maxFlows === "string")
                    message.maxFlows = parseInt(object.maxFlows, 10);
                else if (typeof object.maxFlows === "number")
                    message.maxFlows = object.maxFlows;
                else if (typeof object.maxFlows === "object")
                    message.maxFlows = new $util.LongBits(object.maxFlows.low >>> 0, object.maxFlows.high >>> 0).toNumber(true);
            if (object.maxFlowTypes != null)
                if ($util.Long)
                    (message.maxFlowTypes = $util.Long.fromValue(object.maxFlowTypes)).unsigned = true;
                else if (typeof object.maxFlowTypes === "string")
                    message.maxFlowTypes = parseInt(object.maxFlowTypes, 10);
                else if (typeof object.maxFlowTypes === "number")
                    message.maxFlowTypes = object.maxFlowTypes;
                else if (typeof object.maxFlowTypes === "object")
                    message.maxFlowTypes = new $util.LongBits(object.maxFlowTypes.low >>> 0, object.maxFlowTypes.high >>> 0).toNumber(true);
            if (object.minUsers != null)
                if ($util.Long)
                    (message.minUsers = $util.Long.fromValue(object.minUsers)).unsigned = true;
                else if (typeof object.minUsers === "string")
                    message.minUsers = parseInt(object.minUsers, 10);
                else if (typeof object.minUsers === "number")
                    message.minUsers = object.minUsers;
                else if (typeof object.minUsers === "object")
                    message.minUsers = new $util.LongBits(object.minUsers.low >>> 0, object.minUsers.high >>> 0).toNumber(true);
            if (object.perUserCost != null)
                if ($util.Long)
                    (message.perUserCost = $util.Long.fromValue(object.perUserCost)).unsigned = true;
                else if (typeof object.perUserCost === "string")
                    message.perUserCost = parseInt(object.perUserCost, 10);
                else if (typeof object.perUserCost === "number")
                    message.perUserCost = object.perUserCost;
                else if (typeof object.perUserCost === "object")
                    message.perUserCost = new $util.LongBits(object.perUserCost.low >>> 0, object.perUserCost.high >>> 0).toNumber(true);
            if (object.perGbCost != null)
                if ($util.Long)
                    (message.perGbCost = $util.Long.fromValue(object.perGbCost)).unsigned = true;
                else if (typeof object.perGbCost === "string")
                    message.perGbCost = parseInt(object.perGbCost, 10);
                else if (typeof object.perGbCost === "number")
                    message.perGbCost = object.perGbCost;
                else if (typeof object.perGbCost === "object")
                    message.perGbCost = new $util.LongBits(object.perGbCost.low >>> 0, object.perGbCost.high >>> 0).toNumber(true);
            if (object.maxPins != null)
                if ($util.Long)
                    (message.maxPins = $util.Long.fromValue(object.maxPins)).unsigned = true;
                else if (typeof object.maxPins === "string")
                    message.maxPins = parseInt(object.maxPins, 10);
                else if (typeof object.maxPins === "number")
                    message.maxPins = object.maxPins;
                else if (typeof object.maxPins === "object")
                    message.maxPins = new $util.LongBits(object.maxPins.low >>> 0, object.maxPins.high >>> 0).toNumber(true);
            if (object.maxAlerts != null)
                if ($util.Long)
                    (message.maxAlerts = $util.Long.fromValue(object.maxAlerts)).unsigned = true;
                else if (typeof object.maxAlerts === "string")
                    message.maxAlerts = parseInt(object.maxAlerts, 10);
                else if (typeof object.maxAlerts === "number")
                    message.maxAlerts = object.maxAlerts;
                else if (typeof object.maxAlerts === "object")
                    message.maxAlerts = new $util.LongBits(object.maxAlerts.low >>> 0, object.maxAlerts.high >>> 0).toNumber(true);
            if (object.trash != null)
                if ($util.Long)
                    (message.trash = $util.Long.fromValue(object.trash)).unsigned = true;
                else if (typeof object.trash === "string")
                    message.trash = parseInt(object.trash, 10);
                else if (typeof object.trash === "number")
                    message.trash = object.trash;
                else if (typeof object.trash === "object")
                    message.trash = new $util.LongBits(object.trash.low >>> 0, object.trash.high >>> 0).toNumber(true);
            if (object.logsHistory != null)
                if ($util.Long)
                    (message.logsHistory = $util.Long.fromValue(object.logsHistory)).unsigned = true;
                else if (typeof object.logsHistory === "string")
                    message.logsHistory = parseInt(object.logsHistory, 10);
                else if (typeof object.logsHistory === "number")
                    message.logsHistory = object.logsHistory;
                else if (typeof object.logsHistory === "object")
                    message.logsHistory = new $util.LongBits(object.logsHistory.low >>> 0, object.logsHistory.high >>> 0).toNumber(true);
            if (object.autoAddUsers != null)
                message.autoAddUsers = Boolean(object.autoAddUsers);
            if (object.autoAddStorage != null)
                message.autoAddStorage = Boolean(object.autoAddStorage);
            if (object.maxTags != null)
                if ($util.Long)
                    (message.maxTags = $util.Long.fromValue(object.maxTags)).unsigned = true;
                else if (typeof object.maxTags === "string")
                    message.maxTags = parseInt(object.maxTags, 10);
                else if (typeof object.maxTags === "number")
                    message.maxTags = object.maxTags;
                else if (typeof object.maxTags === "object")
                    message.maxTags = new $util.LongBits(object.maxTags.low >>> 0, object.maxTags.high >>> 0).toNumber(true);
            if (object.maxVersions != null)
                if ($util.Long)
                    (message.maxVersions = $util.Long.fromValue(object.maxVersions)).unsigned = true;
                else if (typeof object.maxVersions === "string")
                    message.maxVersions = parseInt(object.maxVersions, 10);
                else if (typeof object.maxVersions === "number")
                    message.maxVersions = object.maxVersions;
                else if (typeof object.maxVersions === "object")
                    message.maxVersions = new $util.LongBits(object.maxVersions.low >>> 0, object.maxVersions.high >>> 0).toNumber(true);
            if (object.name != null)
                message.name = String(object.name);
            if (object.redundancy != null)
                message.redundancy = String(object.redundancy);
            if (object.support != null)
                message.support = String(object.support);
            if (object.ransomwareProtection != null)
                message.ransomwareProtection = Boolean(object.ransomwareProtection);
            if (object.collabration != null)
                message.collabration = Boolean(object.collabration);
            if (object.internalSharing != null)
                message.internalSharing = Boolean(object.internalSharing);
            if (object.tagBasedAnalysis != null)
                message.tagBasedAnalysis = Boolean(object.tagBasedAnalysis);
            if (object.advacedSpaceFeatures != null)
                message.advacedSpaceFeatures = Boolean(object.advacedSpaceFeatures);
            if (object.compilanceReports != null)
                message.compilanceReports = Boolean(object.compilanceReports);
            if (object.geoLocationBasedAlerts != null)
                message.geoLocationBasedAlerts = Boolean(object.geoLocationBasedAlerts);
            if (object.dedicatedCluster != null)
                message.dedicatedCluster = Boolean(object.dedicatedCluster);
            if (object.maxDevices != null)
                message.maxDevices = object.maxDevices | 0;
            if (object.parallelEdits != null)
                message.parallelEdits = object.parallelEdits | 0;
            if (object.docsAndSheets != null)
                message.docsAndSheets = Boolean(object.docsAndSheets);
            return message;
        };

        /**
         * Creates a plain object from a StoragePlan message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.StoragePlan
         * @static
         * @param {response.StoragePlan} message StoragePlan
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        StoragePlan.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.type = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.price = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.price = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.maxTeams = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.maxTeams = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.maxRoles = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.maxRoles = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.maxLogAnalysis = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.maxLogAnalysis = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.storage = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.storage = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.maxSpaces = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.maxSpaces = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.maxFlows = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.maxFlows = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.maxFlowTypes = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.maxFlowTypes = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.minUsers = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.minUsers = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.perUserCost = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.perUserCost = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.perGbCost = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.perGbCost = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.maxPins = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.maxPins = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.maxAlerts = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.maxAlerts = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.trash = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.trash = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.logsHistory = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.logsHistory = options.longs === String ? "0" : 0;
                object.autoAddUsers = false;
                object.autoAddStorage = false;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.maxTags = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.maxTags = options.longs === String ? "0" : 0;
                object.planId = 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.maxVersions = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.maxVersions = options.longs === String ? "0" : 0;
                object.name = "";
                object.support = "";
                object.ransomwareProtection = false;
                object.collabration = false;
                object.redundancy = "";
                object.internalSharing = false;
                object.tagBasedAnalysis = false;
                object.advacedSpaceFeatures = false;
                object.compilanceReports = false;
                object.geoLocationBasedAlerts = false;
                object.dedicatedCluster = false;
                object.maxDevices = 0;
                object.parallelEdits = 0;
                object.docsAndSheets = false;
            }
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = message.type;
            if (message.price != null && message.hasOwnProperty("price"))
                if (typeof message.price === "number")
                    object.price = options.longs === String ? String(message.price) : message.price;
                else
                    object.price = options.longs === String ? $util.Long.prototype.toString.call(message.price) : options.longs === Number ? new $util.LongBits(message.price.low >>> 0, message.price.high >>> 0).toNumber(true) : message.price;
            if (message.maxTeams != null && message.hasOwnProperty("maxTeams"))
                if (typeof message.maxTeams === "number")
                    object.maxTeams = options.longs === String ? String(message.maxTeams) : message.maxTeams;
                else
                    object.maxTeams = options.longs === String ? $util.Long.prototype.toString.call(message.maxTeams) : options.longs === Number ? new $util.LongBits(message.maxTeams.low >>> 0, message.maxTeams.high >>> 0).toNumber(true) : message.maxTeams;
            if (message.maxRoles != null && message.hasOwnProperty("maxRoles"))
                if (typeof message.maxRoles === "number")
                    object.maxRoles = options.longs === String ? String(message.maxRoles) : message.maxRoles;
                else
                    object.maxRoles = options.longs === String ? $util.Long.prototype.toString.call(message.maxRoles) : options.longs === Number ? new $util.LongBits(message.maxRoles.low >>> 0, message.maxRoles.high >>> 0).toNumber(true) : message.maxRoles;
            if (message.maxLogAnalysis != null && message.hasOwnProperty("maxLogAnalysis"))
                if (typeof message.maxLogAnalysis === "number")
                    object.maxLogAnalysis = options.longs === String ? String(message.maxLogAnalysis) : message.maxLogAnalysis;
                else
                    object.maxLogAnalysis = options.longs === String ? $util.Long.prototype.toString.call(message.maxLogAnalysis) : options.longs === Number ? new $util.LongBits(message.maxLogAnalysis.low >>> 0, message.maxLogAnalysis.high >>> 0).toNumber(true) : message.maxLogAnalysis;
            if (message.storage != null && message.hasOwnProperty("storage"))
                if (typeof message.storage === "number")
                    object.storage = options.longs === String ? String(message.storage) : message.storage;
                else
                    object.storage = options.longs === String ? $util.Long.prototype.toString.call(message.storage) : options.longs === Number ? new $util.LongBits(message.storage.low >>> 0, message.storage.high >>> 0).toNumber(true) : message.storage;
            if (message.maxSpaces != null && message.hasOwnProperty("maxSpaces"))
                if (typeof message.maxSpaces === "number")
                    object.maxSpaces = options.longs === String ? String(message.maxSpaces) : message.maxSpaces;
                else
                    object.maxSpaces = options.longs === String ? $util.Long.prototype.toString.call(message.maxSpaces) : options.longs === Number ? new $util.LongBits(message.maxSpaces.low >>> 0, message.maxSpaces.high >>> 0).toNumber(true) : message.maxSpaces;
            if (message.maxFlows != null && message.hasOwnProperty("maxFlows"))
                if (typeof message.maxFlows === "number")
                    object.maxFlows = options.longs === String ? String(message.maxFlows) : message.maxFlows;
                else
                    object.maxFlows = options.longs === String ? $util.Long.prototype.toString.call(message.maxFlows) : options.longs === Number ? new $util.LongBits(message.maxFlows.low >>> 0, message.maxFlows.high >>> 0).toNumber(true) : message.maxFlows;
            if (message.maxFlowTypes != null && message.hasOwnProperty("maxFlowTypes"))
                if (typeof message.maxFlowTypes === "number")
                    object.maxFlowTypes = options.longs === String ? String(message.maxFlowTypes) : message.maxFlowTypes;
                else
                    object.maxFlowTypes = options.longs === String ? $util.Long.prototype.toString.call(message.maxFlowTypes) : options.longs === Number ? new $util.LongBits(message.maxFlowTypes.low >>> 0, message.maxFlowTypes.high >>> 0).toNumber(true) : message.maxFlowTypes;
            if (message.minUsers != null && message.hasOwnProperty("minUsers"))
                if (typeof message.minUsers === "number")
                    object.minUsers = options.longs === String ? String(message.minUsers) : message.minUsers;
                else
                    object.minUsers = options.longs === String ? $util.Long.prototype.toString.call(message.minUsers) : options.longs === Number ? new $util.LongBits(message.minUsers.low >>> 0, message.minUsers.high >>> 0).toNumber(true) : message.minUsers;
            if (message.perUserCost != null && message.hasOwnProperty("perUserCost"))
                if (typeof message.perUserCost === "number")
                    object.perUserCost = options.longs === String ? String(message.perUserCost) : message.perUserCost;
                else
                    object.perUserCost = options.longs === String ? $util.Long.prototype.toString.call(message.perUserCost) : options.longs === Number ? new $util.LongBits(message.perUserCost.low >>> 0, message.perUserCost.high >>> 0).toNumber(true) : message.perUserCost;
            if (message.perGbCost != null && message.hasOwnProperty("perGbCost"))
                if (typeof message.perGbCost === "number")
                    object.perGbCost = options.longs === String ? String(message.perGbCost) : message.perGbCost;
                else
                    object.perGbCost = options.longs === String ? $util.Long.prototype.toString.call(message.perGbCost) : options.longs === Number ? new $util.LongBits(message.perGbCost.low >>> 0, message.perGbCost.high >>> 0).toNumber(true) : message.perGbCost;
            if (message.maxPins != null && message.hasOwnProperty("maxPins"))
                if (typeof message.maxPins === "number")
                    object.maxPins = options.longs === String ? String(message.maxPins) : message.maxPins;
                else
                    object.maxPins = options.longs === String ? $util.Long.prototype.toString.call(message.maxPins) : options.longs === Number ? new $util.LongBits(message.maxPins.low >>> 0, message.maxPins.high >>> 0).toNumber(true) : message.maxPins;
            if (message.maxAlerts != null && message.hasOwnProperty("maxAlerts"))
                if (typeof message.maxAlerts === "number")
                    object.maxAlerts = options.longs === String ? String(message.maxAlerts) : message.maxAlerts;
                else
                    object.maxAlerts = options.longs === String ? $util.Long.prototype.toString.call(message.maxAlerts) : options.longs === Number ? new $util.LongBits(message.maxAlerts.low >>> 0, message.maxAlerts.high >>> 0).toNumber(true) : message.maxAlerts;
            if (message.trash != null && message.hasOwnProperty("trash"))
                if (typeof message.trash === "number")
                    object.trash = options.longs === String ? String(message.trash) : message.trash;
                else
                    object.trash = options.longs === String ? $util.Long.prototype.toString.call(message.trash) : options.longs === Number ? new $util.LongBits(message.trash.low >>> 0, message.trash.high >>> 0).toNumber(true) : message.trash;
            if (message.logsHistory != null && message.hasOwnProperty("logsHistory"))
                if (typeof message.logsHistory === "number")
                    object.logsHistory = options.longs === String ? String(message.logsHistory) : message.logsHistory;
                else
                    object.logsHistory = options.longs === String ? $util.Long.prototype.toString.call(message.logsHistory) : options.longs === Number ? new $util.LongBits(message.logsHistory.low >>> 0, message.logsHistory.high >>> 0).toNumber(true) : message.logsHistory;
            if (message.autoAddUsers != null && message.hasOwnProperty("autoAddUsers"))
                object.autoAddUsers = message.autoAddUsers;
            if (message.autoAddStorage != null && message.hasOwnProperty("autoAddStorage"))
                object.autoAddStorage = message.autoAddStorage;
            if (message.maxTags != null && message.hasOwnProperty("maxTags"))
                if (typeof message.maxTags === "number")
                    object.maxTags = options.longs === String ? String(message.maxTags) : message.maxTags;
                else
                    object.maxTags = options.longs === String ? $util.Long.prototype.toString.call(message.maxTags) : options.longs === Number ? new $util.LongBits(message.maxTags.low >>> 0, message.maxTags.high >>> 0).toNumber(true) : message.maxTags;
            if (message.planId != null && message.hasOwnProperty("planId"))
                object.planId = message.planId;
            if (message.maxVersions != null && message.hasOwnProperty("maxVersions"))
                if (typeof message.maxVersions === "number")
                    object.maxVersions = options.longs === String ? String(message.maxVersions) : message.maxVersions;
                else
                    object.maxVersions = options.longs === String ? $util.Long.prototype.toString.call(message.maxVersions) : options.longs === Number ? new $util.LongBits(message.maxVersions.low >>> 0, message.maxVersions.high >>> 0).toNumber(true) : message.maxVersions;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.support != null && message.hasOwnProperty("support"))
                object.support = message.support;
            if (message.ransomwareProtection != null && message.hasOwnProperty("ransomwareProtection"))
                object.ransomwareProtection = message.ransomwareProtection;
            if (message.collabration != null && message.hasOwnProperty("collabration"))
                object.collabration = message.collabration;
            if (message.redundancy != null && message.hasOwnProperty("redundancy"))
                object.redundancy = message.redundancy;
            if (message.internalSharing != null && message.hasOwnProperty("internalSharing"))
                object.internalSharing = message.internalSharing;
            if (message.tagBasedAnalysis != null && message.hasOwnProperty("tagBasedAnalysis"))
                object.tagBasedAnalysis = message.tagBasedAnalysis;
            if (message.advacedSpaceFeatures != null && message.hasOwnProperty("advacedSpaceFeatures"))
                object.advacedSpaceFeatures = message.advacedSpaceFeatures;
            if (message.compilanceReports != null && message.hasOwnProperty("compilanceReports"))
                object.compilanceReports = message.compilanceReports;
            if (message.geoLocationBasedAlerts != null && message.hasOwnProperty("geoLocationBasedAlerts"))
                object.geoLocationBasedAlerts = message.geoLocationBasedAlerts;
            if (message.dedicatedCluster != null && message.hasOwnProperty("dedicatedCluster"))
                object.dedicatedCluster = message.dedicatedCluster;
            if (message.maxDevices != null && message.hasOwnProperty("maxDevices"))
                object.maxDevices = message.maxDevices;
            if (message.parallelEdits != null && message.hasOwnProperty("parallelEdits"))
                object.parallelEdits = message.parallelEdits;
            if (message.docsAndSheets != null && message.hasOwnProperty("docsAndSheets"))
                object.docsAndSheets = message.docsAndSheets;
            return object;
        };

        /**
         * Converts this StoragePlan to JSON.
         * @function toJSON
         * @memberof response.StoragePlan
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        StoragePlan.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for StoragePlan
         * @function getTypeUrl
         * @memberof response.StoragePlan
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        StoragePlan.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.StoragePlan";
        };

        return StoragePlan;
    })();

    response.GetPlan = (function() {

        /**
         * Properties of a GetPlan.
         * @memberof response
         * @interface IGetPlan
         * @property {response.IStoragePlan|null} [plan] GetPlan plan
         * @property {response.Status|null} [status] GetPlan status
         * @property {string|null} [message] GetPlan message
         */

        /**
         * Constructs a new GetPlan.
         * @memberof response
         * @classdesc Represents a GetPlan.
         * @implements IGetPlan
         * @constructor
         * @param {response.IGetPlan=} [properties] Properties to set
         */
        function GetPlan(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetPlan plan.
         * @member {response.IStoragePlan|null|undefined} plan
         * @memberof response.GetPlan
         * @instance
         */
        GetPlan.prototype.plan = null;

        /**
         * GetPlan status.
         * @member {response.Status} status
         * @memberof response.GetPlan
         * @instance
         */
        GetPlan.prototype.status = 0;

        /**
         * GetPlan message.
         * @member {string|null|undefined} message
         * @memberof response.GetPlan
         * @instance
         */
        GetPlan.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(GetPlan.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new GetPlan instance using the specified properties.
         * @function create
         * @memberof response.GetPlan
         * @static
         * @param {response.IGetPlan=} [properties] Properties to set
         * @returns {response.GetPlan} GetPlan instance
         */
        GetPlan.create = function create(properties) {
            return new GetPlan(properties);
        };

        /**
         * Encodes the specified GetPlan message. Does not implicitly {@link response.GetPlan.verify|verify} messages.
         * @function encode
         * @memberof response.GetPlan
         * @static
         * @param {response.IGetPlan} message GetPlan message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetPlan.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.plan != null && Object.hasOwnProperty.call(message, "plan"))
                $root.response.StoragePlan.encode(message.plan, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified GetPlan message, length delimited. Does not implicitly {@link response.GetPlan.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.GetPlan
         * @static
         * @param {response.IGetPlan} message GetPlan message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetPlan.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetPlan message from the specified reader or buffer.
         * @function decode
         * @memberof response.GetPlan
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.GetPlan} GetPlan
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetPlan.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.GetPlan();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 2: {
                        message.plan = $root.response.StoragePlan.decode(reader, reader.uint32());
                        break;
                    }
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 3: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetPlan message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.GetPlan
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.GetPlan} GetPlan
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetPlan.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetPlan message.
         * @function verify
         * @memberof response.GetPlan
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetPlan.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.plan != null && message.hasOwnProperty("plan")) {
                let error = $root.response.StoragePlan.verify(message.plan);
                if (error)
                    return "plan." + error;
            }
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a GetPlan message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.GetPlan
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.GetPlan} GetPlan
         */
        GetPlan.fromObject = function fromObject(object) {
            if (object instanceof $root.response.GetPlan)
                return object;
            let message = new $root.response.GetPlan();
            if (object.plan != null) {
                if (typeof object.plan !== "object")
                    throw TypeError(".response.GetPlan.plan: object expected");
                message.plan = $root.response.StoragePlan.fromObject(object.plan);
            }
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a GetPlan message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.GetPlan
         * @static
         * @param {response.GetPlan} message GetPlan
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetPlan.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.status = options.enums === String ? "SUCCESS" : 0;
                object.plan = null;
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.plan != null && message.hasOwnProperty("plan"))
                object.plan = $root.response.StoragePlan.toObject(message.plan, options);
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this GetPlan to JSON.
         * @function toJSON
         * @memberof response.GetPlan
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetPlan.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetPlan
         * @function getTypeUrl
         * @memberof response.GetPlan
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetPlan.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.GetPlan";
        };

        return GetPlan;
    })();

    response.ListPlans = (function() {

        /**
         * Properties of a ListPlans.
         * @memberof response
         * @interface IListPlans
         * @property {response.Status|null} [status] ListPlans status
         * @property {Array.<response.IStoragePlan>|null} [plans] ListPlans plans
         * @property {string|null} [message] ListPlans message
         */

        /**
         * Constructs a new ListPlans.
         * @memberof response
         * @classdesc Represents a ListPlans.
         * @implements IListPlans
         * @constructor
         * @param {response.IListPlans=} [properties] Properties to set
         */
        function ListPlans(properties) {
            this.plans = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListPlans status.
         * @member {response.Status} status
         * @memberof response.ListPlans
         * @instance
         */
        ListPlans.prototype.status = 0;

        /**
         * ListPlans plans.
         * @member {Array.<response.IStoragePlan>} plans
         * @memberof response.ListPlans
         * @instance
         */
        ListPlans.prototype.plans = $util.emptyArray;

        /**
         * ListPlans message.
         * @member {string|null|undefined} message
         * @memberof response.ListPlans
         * @instance
         */
        ListPlans.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(ListPlans.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new ListPlans instance using the specified properties.
         * @function create
         * @memberof response.ListPlans
         * @static
         * @param {response.IListPlans=} [properties] Properties to set
         * @returns {response.ListPlans} ListPlans instance
         */
        ListPlans.create = function create(properties) {
            return new ListPlans(properties);
        };

        /**
         * Encodes the specified ListPlans message. Does not implicitly {@link response.ListPlans.verify|verify} messages.
         * @function encode
         * @memberof response.ListPlans
         * @static
         * @param {response.IListPlans} message ListPlans message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListPlans.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.plans != null && message.plans.length)
                for (let i = 0; i < message.plans.length; ++i)
                    $root.response.StoragePlan.encode(message.plans[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified ListPlans message, length delimited. Does not implicitly {@link response.ListPlans.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.ListPlans
         * @static
         * @param {response.IListPlans} message ListPlans message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListPlans.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ListPlans message from the specified reader or buffer.
         * @function decode
         * @memberof response.ListPlans
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.ListPlans} ListPlans
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListPlans.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.ListPlans();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        if (!(message.plans && message.plans.length))
                            message.plans = [];
                        message.plans.push($root.response.StoragePlan.decode(reader, reader.uint32()));
                        break;
                    }
                case 3: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ListPlans message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.ListPlans
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.ListPlans} ListPlans
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListPlans.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ListPlans message.
         * @function verify
         * @memberof response.ListPlans
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ListPlans.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.plans != null && message.hasOwnProperty("plans")) {
                if (!Array.isArray(message.plans))
                    return "plans: array expected";
                for (let i = 0; i < message.plans.length; ++i) {
                    let error = $root.response.StoragePlan.verify(message.plans[i]);
                    if (error)
                        return "plans." + error;
                }
            }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a ListPlans message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.ListPlans
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.ListPlans} ListPlans
         */
        ListPlans.fromObject = function fromObject(object) {
            if (object instanceof $root.response.ListPlans)
                return object;
            let message = new $root.response.ListPlans();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.plans) {
                if (!Array.isArray(object.plans))
                    throw TypeError(".response.ListPlans.plans: array expected");
                message.plans = [];
                for (let i = 0; i < object.plans.length; ++i) {
                    if (typeof object.plans[i] !== "object")
                        throw TypeError(".response.ListPlans.plans: object expected");
                    message.plans[i] = $root.response.StoragePlan.fromObject(object.plans[i]);
                }
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a ListPlans message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.ListPlans
         * @static
         * @param {response.ListPlans} message ListPlans
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListPlans.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.plans = [];
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.plans && message.plans.length) {
                object.plans = [];
                for (let j = 0; j < message.plans.length; ++j)
                    object.plans[j] = $root.response.StoragePlan.toObject(message.plans[j], options);
            }
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this ListPlans to JSON.
         * @function toJSON
         * @memberof response.ListPlans
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListPlans.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ListPlans
         * @function getTypeUrl
         * @memberof response.ListPlans
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ListPlans.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.ListPlans";
        };

        return ListPlans;
    })();

    response.UpgradePlan = (function() {

        /**
         * Properties of an UpgradePlan.
         * @memberof response
         * @interface IUpgradePlan
         * @property {response.Status|null} [status] UpgradePlan status
         * @property {Array.<response.IStoragePlan>|null} [plans] UpgradePlan plans
         * @property {string|null} [message] UpgradePlan message
         */

        /**
         * Constructs a new UpgradePlan.
         * @memberof response
         * @classdesc Represents an UpgradePlan.
         * @implements IUpgradePlan
         * @constructor
         * @param {response.IUpgradePlan=} [properties] Properties to set
         */
        function UpgradePlan(properties) {
            this.plans = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpgradePlan status.
         * @member {response.Status} status
         * @memberof response.UpgradePlan
         * @instance
         */
        UpgradePlan.prototype.status = 0;

        /**
         * UpgradePlan plans.
         * @member {Array.<response.IStoragePlan>} plans
         * @memberof response.UpgradePlan
         * @instance
         */
        UpgradePlan.prototype.plans = $util.emptyArray;

        /**
         * UpgradePlan message.
         * @member {string|null|undefined} message
         * @memberof response.UpgradePlan
         * @instance
         */
        UpgradePlan.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(UpgradePlan.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new UpgradePlan instance using the specified properties.
         * @function create
         * @memberof response.UpgradePlan
         * @static
         * @param {response.IUpgradePlan=} [properties] Properties to set
         * @returns {response.UpgradePlan} UpgradePlan instance
         */
        UpgradePlan.create = function create(properties) {
            return new UpgradePlan(properties);
        };

        /**
         * Encodes the specified UpgradePlan message. Does not implicitly {@link response.UpgradePlan.verify|verify} messages.
         * @function encode
         * @memberof response.UpgradePlan
         * @static
         * @param {response.IUpgradePlan} message UpgradePlan message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpgradePlan.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.plans != null && message.plans.length)
                for (let i = 0; i < message.plans.length; ++i)
                    $root.response.StoragePlan.encode(message.plans[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified UpgradePlan message, length delimited. Does not implicitly {@link response.UpgradePlan.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.UpgradePlan
         * @static
         * @param {response.IUpgradePlan} message UpgradePlan message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpgradePlan.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UpgradePlan message from the specified reader or buffer.
         * @function decode
         * @memberof response.UpgradePlan
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.UpgradePlan} UpgradePlan
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpgradePlan.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.UpgradePlan();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        if (!(message.plans && message.plans.length))
                            message.plans = [];
                        message.plans.push($root.response.StoragePlan.decode(reader, reader.uint32()));
                        break;
                    }
                case 3: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UpgradePlan message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.UpgradePlan
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.UpgradePlan} UpgradePlan
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpgradePlan.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UpgradePlan message.
         * @function verify
         * @memberof response.UpgradePlan
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UpgradePlan.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.plans != null && message.hasOwnProperty("plans")) {
                if (!Array.isArray(message.plans))
                    return "plans: array expected";
                for (let i = 0; i < message.plans.length; ++i) {
                    let error = $root.response.StoragePlan.verify(message.plans[i]);
                    if (error)
                        return "plans." + error;
                }
            }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates an UpgradePlan message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.UpgradePlan
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.UpgradePlan} UpgradePlan
         */
        UpgradePlan.fromObject = function fromObject(object) {
            if (object instanceof $root.response.UpgradePlan)
                return object;
            let message = new $root.response.UpgradePlan();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.plans) {
                if (!Array.isArray(object.plans))
                    throw TypeError(".response.UpgradePlan.plans: array expected");
                message.plans = [];
                for (let i = 0; i < object.plans.length; ++i) {
                    if (typeof object.plans[i] !== "object")
                        throw TypeError(".response.UpgradePlan.plans: object expected");
                    message.plans[i] = $root.response.StoragePlan.fromObject(object.plans[i]);
                }
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from an UpgradePlan message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.UpgradePlan
         * @static
         * @param {response.UpgradePlan} message UpgradePlan
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpgradePlan.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.plans = [];
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.plans && message.plans.length) {
                object.plans = [];
                for (let j = 0; j < message.plans.length; ++j)
                    object.plans[j] = $root.response.StoragePlan.toObject(message.plans[j], options);
            }
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this UpgradePlan to JSON.
         * @function toJSON
         * @memberof response.UpgradePlan
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpgradePlan.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for UpgradePlan
         * @function getTypeUrl
         * @memberof response.UpgradePlan
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        UpgradePlan.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.UpgradePlan";
        };

        return UpgradePlan;
    })();

    response.ValidateCoupon = (function() {

        /**
         * Properties of a ValidateCoupon.
         * @memberof response
         * @interface IValidateCoupon
         * @property {response.Status|null} [status] ValidateCoupon status
         * @property {number|null} [discount] ValidateCoupon discount
         * @property {string|null} [message] ValidateCoupon message
         */

        /**
         * Constructs a new ValidateCoupon.
         * @memberof response
         * @classdesc Represents a ValidateCoupon.
         * @implements IValidateCoupon
         * @constructor
         * @param {response.IValidateCoupon=} [properties] Properties to set
         */
        function ValidateCoupon(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ValidateCoupon status.
         * @member {response.Status} status
         * @memberof response.ValidateCoupon
         * @instance
         */
        ValidateCoupon.prototype.status = 0;

        /**
         * ValidateCoupon discount.
         * @member {number} discount
         * @memberof response.ValidateCoupon
         * @instance
         */
        ValidateCoupon.prototype.discount = 0;

        /**
         * ValidateCoupon message.
         * @member {string|null|undefined} message
         * @memberof response.ValidateCoupon
         * @instance
         */
        ValidateCoupon.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(ValidateCoupon.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new ValidateCoupon instance using the specified properties.
         * @function create
         * @memberof response.ValidateCoupon
         * @static
         * @param {response.IValidateCoupon=} [properties] Properties to set
         * @returns {response.ValidateCoupon} ValidateCoupon instance
         */
        ValidateCoupon.create = function create(properties) {
            return new ValidateCoupon(properties);
        };

        /**
         * Encodes the specified ValidateCoupon message. Does not implicitly {@link response.ValidateCoupon.verify|verify} messages.
         * @function encode
         * @memberof response.ValidateCoupon
         * @static
         * @param {response.IValidateCoupon} message ValidateCoupon message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ValidateCoupon.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.discount != null && Object.hasOwnProperty.call(message, "discount"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.discount);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified ValidateCoupon message, length delimited. Does not implicitly {@link response.ValidateCoupon.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.ValidateCoupon
         * @static
         * @param {response.IValidateCoupon} message ValidateCoupon message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ValidateCoupon.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ValidateCoupon message from the specified reader or buffer.
         * @function decode
         * @memberof response.ValidateCoupon
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.ValidateCoupon} ValidateCoupon
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ValidateCoupon.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.ValidateCoupon();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.discount = reader.int32();
                        break;
                    }
                case 3: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ValidateCoupon message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.ValidateCoupon
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.ValidateCoupon} ValidateCoupon
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ValidateCoupon.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ValidateCoupon message.
         * @function verify
         * @memberof response.ValidateCoupon
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ValidateCoupon.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.discount != null && message.hasOwnProperty("discount"))
                if (!$util.isInteger(message.discount))
                    return "discount: integer expected";
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a ValidateCoupon message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.ValidateCoupon
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.ValidateCoupon} ValidateCoupon
         */
        ValidateCoupon.fromObject = function fromObject(object) {
            if (object instanceof $root.response.ValidateCoupon)
                return object;
            let message = new $root.response.ValidateCoupon();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.discount != null)
                message.discount = object.discount | 0;
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a ValidateCoupon message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.ValidateCoupon
         * @static
         * @param {response.ValidateCoupon} message ValidateCoupon
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ValidateCoupon.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.status = options.enums === String ? "SUCCESS" : 0;
                object.discount = 0;
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.discount != null && message.hasOwnProperty("discount"))
                object.discount = message.discount;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this ValidateCoupon to JSON.
         * @function toJSON
         * @memberof response.ValidateCoupon
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ValidateCoupon.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ValidateCoupon
         * @function getTypeUrl
         * @memberof response.ValidateCoupon
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ValidateCoupon.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.ValidateCoupon";
        };

        return ValidateCoupon;
    })();

    response.SessionData = (function() {

        /**
         * Properties of a SessionData.
         * @memberof response
         * @interface ISessionData
         * @property {response.Status|null} [status] SessionData status
         * @property {number|Long|null} [timestamp] SessionData timestamp
         * @property {Uint8Array|null} [data] SessionData data
         * @property {string|null} [message] SessionData message
         */

        /**
         * Constructs a new SessionData.
         * @memberof response
         * @classdesc Represents a SessionData.
         * @implements ISessionData
         * @constructor
         * @param {response.ISessionData=} [properties] Properties to set
         */
        function SessionData(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SessionData status.
         * @member {response.Status} status
         * @memberof response.SessionData
         * @instance
         */
        SessionData.prototype.status = 0;

        /**
         * SessionData timestamp.
         * @member {number|Long} timestamp
         * @memberof response.SessionData
         * @instance
         */
        SessionData.prototype.timestamp = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * SessionData data.
         * @member {Uint8Array} data
         * @memberof response.SessionData
         * @instance
         */
        SessionData.prototype.data = $util.newBuffer([]);

        /**
         * SessionData message.
         * @member {string|null|undefined} message
         * @memberof response.SessionData
         * @instance
         */
        SessionData.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(SessionData.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new SessionData instance using the specified properties.
         * @function create
         * @memberof response.SessionData
         * @static
         * @param {response.ISessionData=} [properties] Properties to set
         * @returns {response.SessionData} SessionData instance
         */
        SessionData.create = function create(properties) {
            return new SessionData(properties);
        };

        /**
         * Encodes the specified SessionData message. Does not implicitly {@link response.SessionData.verify|verify} messages.
         * @function encode
         * @memberof response.SessionData
         * @static
         * @param {response.ISessionData} message SessionData message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SessionData.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.timestamp);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.data);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified SessionData message, length delimited. Does not implicitly {@link response.SessionData.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.SessionData
         * @static
         * @param {response.ISessionData} message SessionData message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SessionData.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SessionData message from the specified reader or buffer.
         * @function decode
         * @memberof response.SessionData
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.SessionData} SessionData
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SessionData.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.SessionData();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.timestamp = reader.uint64();
                        break;
                    }
                case 3: {
                        message.data = reader.bytes();
                        break;
                    }
                case 4: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SessionData message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.SessionData
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.SessionData} SessionData
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SessionData.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SessionData message.
         * @function verify
         * @memberof response.SessionData
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SessionData.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                if (!$util.isInteger(message.timestamp) && !(message.timestamp && $util.isInteger(message.timestamp.low) && $util.isInteger(message.timestamp.high)))
                    return "timestamp: integer|Long expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                    return "data: buffer expected";
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a SessionData message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.SessionData
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.SessionData} SessionData
         */
        SessionData.fromObject = function fromObject(object) {
            if (object instanceof $root.response.SessionData)
                return object;
            let message = new $root.response.SessionData();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.timestamp != null)
                if ($util.Long)
                    (message.timestamp = $util.Long.fromValue(object.timestamp)).unsigned = true;
                else if (typeof object.timestamp === "string")
                    message.timestamp = parseInt(object.timestamp, 10);
                else if (typeof object.timestamp === "number")
                    message.timestamp = object.timestamp;
                else if (typeof object.timestamp === "object")
                    message.timestamp = new $util.LongBits(object.timestamp.low >>> 0, object.timestamp.high >>> 0).toNumber(true);
            if (object.data != null)
                if (typeof object.data === "string")
                    $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                else if (object.data.length >= 0)
                    message.data = object.data;
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a SessionData message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.SessionData
         * @static
         * @param {response.SessionData} message SessionData
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SessionData.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.status = options.enums === String ? "SUCCESS" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.timestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.timestamp = options.longs === String ? "0" : 0;
                if (options.bytes === String)
                    object.data = "";
                else {
                    object.data = [];
                    if (options.bytes !== Array)
                        object.data = $util.newBuffer(object.data);
                }
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                if (typeof message.timestamp === "number")
                    object.timestamp = options.longs === String ? String(message.timestamp) : message.timestamp;
                else
                    object.timestamp = options.longs === String ? $util.Long.prototype.toString.call(message.timestamp) : options.longs === Number ? new $util.LongBits(message.timestamp.low >>> 0, message.timestamp.high >>> 0).toNumber(true) : message.timestamp;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this SessionData to JSON.
         * @function toJSON
         * @memberof response.SessionData
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SessionData.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for SessionData
         * @function getTypeUrl
         * @memberof response.SessionData
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        SessionData.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.SessionData";
        };

        return SessionData;
    })();

    response.RemoveVersion = (function() {

        /**
         * Properties of a RemoveVersion.
         * @memberof response
         * @interface IRemoveVersion
         * @property {response.Status|null} [status] RemoveVersion status
         * @property {string|null} [message] RemoveVersion message
         */

        /**
         * Constructs a new RemoveVersion.
         * @memberof response
         * @classdesc Represents a RemoveVersion.
         * @implements IRemoveVersion
         * @constructor
         * @param {response.IRemoveVersion=} [properties] Properties to set
         */
        function RemoveVersion(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveVersion status.
         * @member {response.Status} status
         * @memberof response.RemoveVersion
         * @instance
         */
        RemoveVersion.prototype.status = 0;

        /**
         * RemoveVersion message.
         * @member {string|null|undefined} message
         * @memberof response.RemoveVersion
         * @instance
         */
        RemoveVersion.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(RemoveVersion.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new RemoveVersion instance using the specified properties.
         * @function create
         * @memberof response.RemoveVersion
         * @static
         * @param {response.IRemoveVersion=} [properties] Properties to set
         * @returns {response.RemoveVersion} RemoveVersion instance
         */
        RemoveVersion.create = function create(properties) {
            return new RemoveVersion(properties);
        };

        /**
         * Encodes the specified RemoveVersion message. Does not implicitly {@link response.RemoveVersion.verify|verify} messages.
         * @function encode
         * @memberof response.RemoveVersion
         * @static
         * @param {response.IRemoveVersion} message RemoveVersion message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RemoveVersion.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified RemoveVersion message, length delimited. Does not implicitly {@link response.RemoveVersion.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.RemoveVersion
         * @static
         * @param {response.IRemoveVersion} message RemoveVersion message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RemoveVersion.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RemoveVersion message from the specified reader or buffer.
         * @function decode
         * @memberof response.RemoveVersion
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.RemoveVersion} RemoveVersion
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RemoveVersion.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.RemoveVersion();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RemoveVersion message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.RemoveVersion
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.RemoveVersion} RemoveVersion
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RemoveVersion.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RemoveVersion message.
         * @function verify
         * @memberof response.RemoveVersion
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RemoveVersion.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a RemoveVersion message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.RemoveVersion
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.RemoveVersion} RemoveVersion
         */
        RemoveVersion.fromObject = function fromObject(object) {
            if (object instanceof $root.response.RemoveVersion)
                return object;
            let message = new $root.response.RemoveVersion();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a RemoveVersion message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.RemoveVersion
         * @static
         * @param {response.RemoveVersion} message RemoveVersion
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveVersion.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this RemoveVersion to JSON.
         * @function toJSON
         * @memberof response.RemoveVersion
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveVersion.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for RemoveVersion
         * @function getTypeUrl
         * @memberof response.RemoveVersion
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        RemoveVersion.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.RemoveVersion";
        };

        return RemoveVersion;
    })();

    response.GetProfilePictureOfUser = (function() {

        /**
         * Properties of a GetProfilePictureOfUser.
         * @memberof response
         * @interface IGetProfilePictureOfUser
         * @property {response.Status|null} [status] GetProfilePictureOfUser status
         * @property {Uint8Array|null} [profilePicture] GetProfilePictureOfUser profilePicture
         * @property {string|null} [message] GetProfilePictureOfUser message
         */

        /**
         * Constructs a new GetProfilePictureOfUser.
         * @memberof response
         * @classdesc Represents a GetProfilePictureOfUser.
         * @implements IGetProfilePictureOfUser
         * @constructor
         * @param {response.IGetProfilePictureOfUser=} [properties] Properties to set
         */
        function GetProfilePictureOfUser(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetProfilePictureOfUser status.
         * @member {response.Status} status
         * @memberof response.GetProfilePictureOfUser
         * @instance
         */
        GetProfilePictureOfUser.prototype.status = 0;

        /**
         * GetProfilePictureOfUser profilePicture.
         * @member {Uint8Array} profilePicture
         * @memberof response.GetProfilePictureOfUser
         * @instance
         */
        GetProfilePictureOfUser.prototype.profilePicture = $util.newBuffer([]);

        /**
         * GetProfilePictureOfUser message.
         * @member {string|null|undefined} message
         * @memberof response.GetProfilePictureOfUser
         * @instance
         */
        GetProfilePictureOfUser.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(GetProfilePictureOfUser.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new GetProfilePictureOfUser instance using the specified properties.
         * @function create
         * @memberof response.GetProfilePictureOfUser
         * @static
         * @param {response.IGetProfilePictureOfUser=} [properties] Properties to set
         * @returns {response.GetProfilePictureOfUser} GetProfilePictureOfUser instance
         */
        GetProfilePictureOfUser.create = function create(properties) {
            return new GetProfilePictureOfUser(properties);
        };

        /**
         * Encodes the specified GetProfilePictureOfUser message. Does not implicitly {@link response.GetProfilePictureOfUser.verify|verify} messages.
         * @function encode
         * @memberof response.GetProfilePictureOfUser
         * @static
         * @param {response.IGetProfilePictureOfUser} message GetProfilePictureOfUser message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetProfilePictureOfUser.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.profilePicture != null && Object.hasOwnProperty.call(message, "profilePicture"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.profilePicture);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified GetProfilePictureOfUser message, length delimited. Does not implicitly {@link response.GetProfilePictureOfUser.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.GetProfilePictureOfUser
         * @static
         * @param {response.IGetProfilePictureOfUser} message GetProfilePictureOfUser message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetProfilePictureOfUser.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetProfilePictureOfUser message from the specified reader or buffer.
         * @function decode
         * @memberof response.GetProfilePictureOfUser
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.GetProfilePictureOfUser} GetProfilePictureOfUser
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetProfilePictureOfUser.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.GetProfilePictureOfUser();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.profilePicture = reader.bytes();
                        break;
                    }
                case 3: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetProfilePictureOfUser message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.GetProfilePictureOfUser
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.GetProfilePictureOfUser} GetProfilePictureOfUser
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetProfilePictureOfUser.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetProfilePictureOfUser message.
         * @function verify
         * @memberof response.GetProfilePictureOfUser
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetProfilePictureOfUser.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.profilePicture != null && message.hasOwnProperty("profilePicture"))
                if (!(message.profilePicture && typeof message.profilePicture.length === "number" || $util.isString(message.profilePicture)))
                    return "profilePicture: buffer expected";
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a GetProfilePictureOfUser message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.GetProfilePictureOfUser
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.GetProfilePictureOfUser} GetProfilePictureOfUser
         */
        GetProfilePictureOfUser.fromObject = function fromObject(object) {
            if (object instanceof $root.response.GetProfilePictureOfUser)
                return object;
            let message = new $root.response.GetProfilePictureOfUser();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.profilePicture != null)
                if (typeof object.profilePicture === "string")
                    $util.base64.decode(object.profilePicture, message.profilePicture = $util.newBuffer($util.base64.length(object.profilePicture)), 0);
                else if (object.profilePicture.length >= 0)
                    message.profilePicture = object.profilePicture;
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a GetProfilePictureOfUser message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.GetProfilePictureOfUser
         * @static
         * @param {response.GetProfilePictureOfUser} message GetProfilePictureOfUser
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetProfilePictureOfUser.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.status = options.enums === String ? "SUCCESS" : 0;
                if (options.bytes === String)
                    object.profilePicture = "";
                else {
                    object.profilePicture = [];
                    if (options.bytes !== Array)
                        object.profilePicture = $util.newBuffer(object.profilePicture);
                }
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.profilePicture != null && message.hasOwnProperty("profilePicture"))
                object.profilePicture = options.bytes === String ? $util.base64.encode(message.profilePicture, 0, message.profilePicture.length) : options.bytes === Array ? Array.prototype.slice.call(message.profilePicture) : message.profilePicture;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this GetProfilePictureOfUser to JSON.
         * @function toJSON
         * @memberof response.GetProfilePictureOfUser
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetProfilePictureOfUser.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetProfilePictureOfUser
         * @function getTypeUrl
         * @memberof response.GetProfilePictureOfUser
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetProfilePictureOfUser.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.GetProfilePictureOfUser";
        };

        return GetProfilePictureOfUser;
    })();

    response.EmptyTrash = (function() {

        /**
         * Properties of an EmptyTrash.
         * @memberof response
         * @interface IEmptyTrash
         * @property {response.Status|null} [status] EmptyTrash status
         * @property {string|null} [message] EmptyTrash message
         */

        /**
         * Constructs a new EmptyTrash.
         * @memberof response
         * @classdesc Represents an EmptyTrash.
         * @implements IEmptyTrash
         * @constructor
         * @param {response.IEmptyTrash=} [properties] Properties to set
         */
        function EmptyTrash(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * EmptyTrash status.
         * @member {response.Status} status
         * @memberof response.EmptyTrash
         * @instance
         */
        EmptyTrash.prototype.status = 0;

        /**
         * EmptyTrash message.
         * @member {string} message
         * @memberof response.EmptyTrash
         * @instance
         */
        EmptyTrash.prototype.message = "";

        /**
         * Creates a new EmptyTrash instance using the specified properties.
         * @function create
         * @memberof response.EmptyTrash
         * @static
         * @param {response.IEmptyTrash=} [properties] Properties to set
         * @returns {response.EmptyTrash} EmptyTrash instance
         */
        EmptyTrash.create = function create(properties) {
            return new EmptyTrash(properties);
        };

        /**
         * Encodes the specified EmptyTrash message. Does not implicitly {@link response.EmptyTrash.verify|verify} messages.
         * @function encode
         * @memberof response.EmptyTrash
         * @static
         * @param {response.IEmptyTrash} message EmptyTrash message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EmptyTrash.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified EmptyTrash message, length delimited. Does not implicitly {@link response.EmptyTrash.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.EmptyTrash
         * @static
         * @param {response.IEmptyTrash} message EmptyTrash message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EmptyTrash.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an EmptyTrash message from the specified reader or buffer.
         * @function decode
         * @memberof response.EmptyTrash
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.EmptyTrash} EmptyTrash
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EmptyTrash.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.EmptyTrash();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an EmptyTrash message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.EmptyTrash
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.EmptyTrash} EmptyTrash
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EmptyTrash.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an EmptyTrash message.
         * @function verify
         * @memberof response.EmptyTrash
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        EmptyTrash.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message"))
                if (!$util.isString(message.message))
                    return "message: string expected";
            return null;
        };

        /**
         * Creates an EmptyTrash message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.EmptyTrash
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.EmptyTrash} EmptyTrash
         */
        EmptyTrash.fromObject = function fromObject(object) {
            if (object instanceof $root.response.EmptyTrash)
                return object;
            let message = new $root.response.EmptyTrash();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from an EmptyTrash message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.EmptyTrash
         * @static
         * @param {response.EmptyTrash} message EmptyTrash
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        EmptyTrash.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.status = options.enums === String ? "SUCCESS" : 0;
                object.message = "";
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message"))
                object.message = message.message;
            return object;
        };

        /**
         * Converts this EmptyTrash to JSON.
         * @function toJSON
         * @memberof response.EmptyTrash
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        EmptyTrash.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for EmptyTrash
         * @function getTypeUrl
         * @memberof response.EmptyTrash
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        EmptyTrash.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.EmptyTrash";
        };

        return EmptyTrash;
    })();

    response.SetThumbnail = (function() {

        /**
         * Properties of a SetThumbnail.
         * @memberof response
         * @interface ISetThumbnail
         * @property {response.Status|null} [status] SetThumbnail status
         * @property {string|null} [message] SetThumbnail message
         */

        /**
         * Constructs a new SetThumbnail.
         * @memberof response
         * @classdesc Represents a SetThumbnail.
         * @implements ISetThumbnail
         * @constructor
         * @param {response.ISetThumbnail=} [properties] Properties to set
         */
        function SetThumbnail(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SetThumbnail status.
         * @member {response.Status} status
         * @memberof response.SetThumbnail
         * @instance
         */
        SetThumbnail.prototype.status = 0;

        /**
         * SetThumbnail message.
         * @member {string|null|undefined} message
         * @memberof response.SetThumbnail
         * @instance
         */
        SetThumbnail.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(SetThumbnail.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new SetThumbnail instance using the specified properties.
         * @function create
         * @memberof response.SetThumbnail
         * @static
         * @param {response.ISetThumbnail=} [properties] Properties to set
         * @returns {response.SetThumbnail} SetThumbnail instance
         */
        SetThumbnail.create = function create(properties) {
            return new SetThumbnail(properties);
        };

        /**
         * Encodes the specified SetThumbnail message. Does not implicitly {@link response.SetThumbnail.verify|verify} messages.
         * @function encode
         * @memberof response.SetThumbnail
         * @static
         * @param {response.ISetThumbnail} message SetThumbnail message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SetThumbnail.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified SetThumbnail message, length delimited. Does not implicitly {@link response.SetThumbnail.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.SetThumbnail
         * @static
         * @param {response.ISetThumbnail} message SetThumbnail message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SetThumbnail.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SetThumbnail message from the specified reader or buffer.
         * @function decode
         * @memberof response.SetThumbnail
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.SetThumbnail} SetThumbnail
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SetThumbnail.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.SetThumbnail();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SetThumbnail message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.SetThumbnail
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.SetThumbnail} SetThumbnail
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SetThumbnail.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SetThumbnail message.
         * @function verify
         * @memberof response.SetThumbnail
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SetThumbnail.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a SetThumbnail message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.SetThumbnail
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.SetThumbnail} SetThumbnail
         */
        SetThumbnail.fromObject = function fromObject(object) {
            if (object instanceof $root.response.SetThumbnail)
                return object;
            let message = new $root.response.SetThumbnail();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a SetThumbnail message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.SetThumbnail
         * @static
         * @param {response.SetThumbnail} message SetThumbnail
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SetThumbnail.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this SetThumbnail to JSON.
         * @function toJSON
         * @memberof response.SetThumbnail
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SetThumbnail.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for SetThumbnail
         * @function getTypeUrl
         * @memberof response.SetThumbnail
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        SetThumbnail.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.SetThumbnail";
        };

        return SetThumbnail;
    })();

    response.GetThumbnail = (function() {

        /**
         * Properties of a GetThumbnail.
         * @memberof response
         * @interface IGetThumbnail
         * @property {response.Status|null} [status] GetThumbnail status
         * @property {Uint8Array|null} [thumbnail] GetThumbnail thumbnail
         * @property {string|null} [message] GetThumbnail message
         */

        /**
         * Constructs a new GetThumbnail.
         * @memberof response
         * @classdesc Represents a GetThumbnail.
         * @implements IGetThumbnail
         * @constructor
         * @param {response.IGetThumbnail=} [properties] Properties to set
         */
        function GetThumbnail(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetThumbnail status.
         * @member {response.Status} status
         * @memberof response.GetThumbnail
         * @instance
         */
        GetThumbnail.prototype.status = 0;

        /**
         * GetThumbnail thumbnail.
         * @member {Uint8Array} thumbnail
         * @memberof response.GetThumbnail
         * @instance
         */
        GetThumbnail.prototype.thumbnail = $util.newBuffer([]);

        /**
         * GetThumbnail message.
         * @member {string|null|undefined} message
         * @memberof response.GetThumbnail
         * @instance
         */
        GetThumbnail.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(GetThumbnail.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new GetThumbnail instance using the specified properties.
         * @function create
         * @memberof response.GetThumbnail
         * @static
         * @param {response.IGetThumbnail=} [properties] Properties to set
         * @returns {response.GetThumbnail} GetThumbnail instance
         */
        GetThumbnail.create = function create(properties) {
            return new GetThumbnail(properties);
        };

        /**
         * Encodes the specified GetThumbnail message. Does not implicitly {@link response.GetThumbnail.verify|verify} messages.
         * @function encode
         * @memberof response.GetThumbnail
         * @static
         * @param {response.IGetThumbnail} message GetThumbnail message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetThumbnail.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.thumbnail != null && Object.hasOwnProperty.call(message, "thumbnail"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.thumbnail);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified GetThumbnail message, length delimited. Does not implicitly {@link response.GetThumbnail.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.GetThumbnail
         * @static
         * @param {response.IGetThumbnail} message GetThumbnail message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetThumbnail.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetThumbnail message from the specified reader or buffer.
         * @function decode
         * @memberof response.GetThumbnail
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.GetThumbnail} GetThumbnail
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetThumbnail.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.GetThumbnail();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.thumbnail = reader.bytes();
                        break;
                    }
                case 3: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetThumbnail message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.GetThumbnail
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.GetThumbnail} GetThumbnail
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetThumbnail.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetThumbnail message.
         * @function verify
         * @memberof response.GetThumbnail
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetThumbnail.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.thumbnail != null && message.hasOwnProperty("thumbnail"))
                if (!(message.thumbnail && typeof message.thumbnail.length === "number" || $util.isString(message.thumbnail)))
                    return "thumbnail: buffer expected";
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a GetThumbnail message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.GetThumbnail
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.GetThumbnail} GetThumbnail
         */
        GetThumbnail.fromObject = function fromObject(object) {
            if (object instanceof $root.response.GetThumbnail)
                return object;
            let message = new $root.response.GetThumbnail();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.thumbnail != null)
                if (typeof object.thumbnail === "string")
                    $util.base64.decode(object.thumbnail, message.thumbnail = $util.newBuffer($util.base64.length(object.thumbnail)), 0);
                else if (object.thumbnail.length >= 0)
                    message.thumbnail = object.thumbnail;
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a GetThumbnail message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.GetThumbnail
         * @static
         * @param {response.GetThumbnail} message GetThumbnail
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetThumbnail.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.status = options.enums === String ? "SUCCESS" : 0;
                if (options.bytes === String)
                    object.thumbnail = "";
                else {
                    object.thumbnail = [];
                    if (options.bytes !== Array)
                        object.thumbnail = $util.newBuffer(object.thumbnail);
                }
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.thumbnail != null && message.hasOwnProperty("thumbnail"))
                object.thumbnail = options.bytes === String ? $util.base64.encode(message.thumbnail, 0, message.thumbnail.length) : options.bytes === Array ? Array.prototype.slice.call(message.thumbnail) : message.thumbnail;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this GetThumbnail to JSON.
         * @function toJSON
         * @memberof response.GetThumbnail
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetThumbnail.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetThumbnail
         * @function getTypeUrl
         * @memberof response.GetThumbnail
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetThumbnail.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.GetThumbnail";
        };

        return GetThumbnail;
    })();

    response.BlockUser = (function() {

        /**
         * Properties of a BlockUser.
         * @memberof response
         * @interface IBlockUser
         * @property {response.Status|null} [status] BlockUser status
         * @property {string|null} [message] BlockUser message
         */

        /**
         * Constructs a new BlockUser.
         * @memberof response
         * @classdesc Represents a BlockUser.
         * @implements IBlockUser
         * @constructor
         * @param {response.IBlockUser=} [properties] Properties to set
         */
        function BlockUser(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BlockUser status.
         * @member {response.Status} status
         * @memberof response.BlockUser
         * @instance
         */
        BlockUser.prototype.status = 0;

        /**
         * BlockUser message.
         * @member {string|null|undefined} message
         * @memberof response.BlockUser
         * @instance
         */
        BlockUser.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(BlockUser.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new BlockUser instance using the specified properties.
         * @function create
         * @memberof response.BlockUser
         * @static
         * @param {response.IBlockUser=} [properties] Properties to set
         * @returns {response.BlockUser} BlockUser instance
         */
        BlockUser.create = function create(properties) {
            return new BlockUser(properties);
        };

        /**
         * Encodes the specified BlockUser message. Does not implicitly {@link response.BlockUser.verify|verify} messages.
         * @function encode
         * @memberof response.BlockUser
         * @static
         * @param {response.IBlockUser} message BlockUser message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BlockUser.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified BlockUser message, length delimited. Does not implicitly {@link response.BlockUser.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.BlockUser
         * @static
         * @param {response.IBlockUser} message BlockUser message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BlockUser.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a BlockUser message from the specified reader or buffer.
         * @function decode
         * @memberof response.BlockUser
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.BlockUser} BlockUser
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BlockUser.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.BlockUser();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a BlockUser message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.BlockUser
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.BlockUser} BlockUser
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BlockUser.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a BlockUser message.
         * @function verify
         * @memberof response.BlockUser
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        BlockUser.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a BlockUser message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.BlockUser
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.BlockUser} BlockUser
         */
        BlockUser.fromObject = function fromObject(object) {
            if (object instanceof $root.response.BlockUser)
                return object;
            let message = new $root.response.BlockUser();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a BlockUser message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.BlockUser
         * @static
         * @param {response.BlockUser} message BlockUser
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BlockUser.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this BlockUser to JSON.
         * @function toJSON
         * @memberof response.BlockUser
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BlockUser.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for BlockUser
         * @function getTypeUrl
         * @memberof response.BlockUser
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        BlockUser.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.BlockUser";
        };

        return BlockUser;
    })();

    response.UnblockUser = (function() {

        /**
         * Properties of an UnblockUser.
         * @memberof response
         * @interface IUnblockUser
         * @property {response.Status|null} [status] UnblockUser status
         * @property {string|null} [message] UnblockUser message
         */

        /**
         * Constructs a new UnblockUser.
         * @memberof response
         * @classdesc Represents an UnblockUser.
         * @implements IUnblockUser
         * @constructor
         * @param {response.IUnblockUser=} [properties] Properties to set
         */
        function UnblockUser(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UnblockUser status.
         * @member {response.Status} status
         * @memberof response.UnblockUser
         * @instance
         */
        UnblockUser.prototype.status = 0;

        /**
         * UnblockUser message.
         * @member {string|null|undefined} message
         * @memberof response.UnblockUser
         * @instance
         */
        UnblockUser.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(UnblockUser.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new UnblockUser instance using the specified properties.
         * @function create
         * @memberof response.UnblockUser
         * @static
         * @param {response.IUnblockUser=} [properties] Properties to set
         * @returns {response.UnblockUser} UnblockUser instance
         */
        UnblockUser.create = function create(properties) {
            return new UnblockUser(properties);
        };

        /**
         * Encodes the specified UnblockUser message. Does not implicitly {@link response.UnblockUser.verify|verify} messages.
         * @function encode
         * @memberof response.UnblockUser
         * @static
         * @param {response.IUnblockUser} message UnblockUser message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UnblockUser.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified UnblockUser message, length delimited. Does not implicitly {@link response.UnblockUser.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.UnblockUser
         * @static
         * @param {response.IUnblockUser} message UnblockUser message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UnblockUser.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UnblockUser message from the specified reader or buffer.
         * @function decode
         * @memberof response.UnblockUser
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.UnblockUser} UnblockUser
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UnblockUser.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.UnblockUser();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UnblockUser message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.UnblockUser
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.UnblockUser} UnblockUser
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UnblockUser.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UnblockUser message.
         * @function verify
         * @memberof response.UnblockUser
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UnblockUser.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates an UnblockUser message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.UnblockUser
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.UnblockUser} UnblockUser
         */
        UnblockUser.fromObject = function fromObject(object) {
            if (object instanceof $root.response.UnblockUser)
                return object;
            let message = new $root.response.UnblockUser();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from an UnblockUser message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.UnblockUser
         * @static
         * @param {response.UnblockUser} message UnblockUser
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UnblockUser.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this UnblockUser to JSON.
         * @function toJSON
         * @memberof response.UnblockUser
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UnblockUser.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for UnblockUser
         * @function getTypeUrl
         * @memberof response.UnblockUser
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        UnblockUser.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.UnblockUser";
        };

        return UnblockUser;
    })();

    response.GetOrgSettings = (function() {

        /**
         * Properties of a GetOrgSettings.
         * @memberof response
         * @interface IGetOrgSettings
         * @property {Array.<string>|null} [allowedCountries] GetOrgSettings allowedCountries
         * @property {Array.<string>|null} [deniedCountries] GetOrgSettings deniedCountries
         * @property {Array.<string>|null} [allowedRegions] GetOrgSettings allowedRegions
         * @property {Array.<string>|null} [deniedRegions] GetOrgSettings deniedRegions
         * @property {Array.<string>|null} [allowedFileTypes] GetOrgSettings allowedFileTypes
         * @property {Array.<string>|null} [deniedFileTypes] GetOrgSettings deniedFileTypes
         * @property {response.Status|null} [status] GetOrgSettings status
         * @property {string|null} [message] GetOrgSettings message
         */

        /**
         * Constructs a new GetOrgSettings.
         * @memberof response
         * @classdesc Represents a GetOrgSettings.
         * @implements IGetOrgSettings
         * @constructor
         * @param {response.IGetOrgSettings=} [properties] Properties to set
         */
        function GetOrgSettings(properties) {
            this.allowedCountries = [];
            this.deniedCountries = [];
            this.allowedRegions = [];
            this.deniedRegions = [];
            this.allowedFileTypes = [];
            this.deniedFileTypes = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetOrgSettings allowedCountries.
         * @member {Array.<string>} allowedCountries
         * @memberof response.GetOrgSettings
         * @instance
         */
        GetOrgSettings.prototype.allowedCountries = $util.emptyArray;

        /**
         * GetOrgSettings deniedCountries.
         * @member {Array.<string>} deniedCountries
         * @memberof response.GetOrgSettings
         * @instance
         */
        GetOrgSettings.prototype.deniedCountries = $util.emptyArray;

        /**
         * GetOrgSettings allowedRegions.
         * @member {Array.<string>} allowedRegions
         * @memberof response.GetOrgSettings
         * @instance
         */
        GetOrgSettings.prototype.allowedRegions = $util.emptyArray;

        /**
         * GetOrgSettings deniedRegions.
         * @member {Array.<string>} deniedRegions
         * @memberof response.GetOrgSettings
         * @instance
         */
        GetOrgSettings.prototype.deniedRegions = $util.emptyArray;

        /**
         * GetOrgSettings allowedFileTypes.
         * @member {Array.<string>} allowedFileTypes
         * @memberof response.GetOrgSettings
         * @instance
         */
        GetOrgSettings.prototype.allowedFileTypes = $util.emptyArray;

        /**
         * GetOrgSettings deniedFileTypes.
         * @member {Array.<string>} deniedFileTypes
         * @memberof response.GetOrgSettings
         * @instance
         */
        GetOrgSettings.prototype.deniedFileTypes = $util.emptyArray;

        /**
         * GetOrgSettings status.
         * @member {response.Status} status
         * @memberof response.GetOrgSettings
         * @instance
         */
        GetOrgSettings.prototype.status = 0;

        /**
         * GetOrgSettings message.
         * @member {string|null|undefined} message
         * @memberof response.GetOrgSettings
         * @instance
         */
        GetOrgSettings.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(GetOrgSettings.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new GetOrgSettings instance using the specified properties.
         * @function create
         * @memberof response.GetOrgSettings
         * @static
         * @param {response.IGetOrgSettings=} [properties] Properties to set
         * @returns {response.GetOrgSettings} GetOrgSettings instance
         */
        GetOrgSettings.create = function create(properties) {
            return new GetOrgSettings(properties);
        };

        /**
         * Encodes the specified GetOrgSettings message. Does not implicitly {@link response.GetOrgSettings.verify|verify} messages.
         * @function encode
         * @memberof response.GetOrgSettings
         * @static
         * @param {response.IGetOrgSettings} message GetOrgSettings message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetOrgSettings.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.allowedCountries != null && message.allowedCountries.length)
                for (let i = 0; i < message.allowedCountries.length; ++i)
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.allowedCountries[i]);
            if (message.deniedCountries != null && message.deniedCountries.length)
                for (let i = 0; i < message.deniedCountries.length; ++i)
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.deniedCountries[i]);
            if (message.allowedRegions != null && message.allowedRegions.length)
                for (let i = 0; i < message.allowedRegions.length; ++i)
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.allowedRegions[i]);
            if (message.deniedRegions != null && message.deniedRegions.length)
                for (let i = 0; i < message.deniedRegions.length; ++i)
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.deniedRegions[i]);
            if (message.allowedFileTypes != null && message.allowedFileTypes.length)
                for (let i = 0; i < message.allowedFileTypes.length; ++i)
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.allowedFileTypes[i]);
            if (message.deniedFileTypes != null && message.deniedFileTypes.length)
                for (let i = 0; i < message.deniedFileTypes.length; ++i)
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.deniedFileTypes[i]);
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 7, wireType 0 =*/56).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified GetOrgSettings message, length delimited. Does not implicitly {@link response.GetOrgSettings.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.GetOrgSettings
         * @static
         * @param {response.IGetOrgSettings} message GetOrgSettings message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetOrgSettings.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetOrgSettings message from the specified reader or buffer.
         * @function decode
         * @memberof response.GetOrgSettings
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.GetOrgSettings} GetOrgSettings
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetOrgSettings.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.GetOrgSettings();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        if (!(message.allowedCountries && message.allowedCountries.length))
                            message.allowedCountries = [];
                        message.allowedCountries.push(reader.string());
                        break;
                    }
                case 2: {
                        if (!(message.deniedCountries && message.deniedCountries.length))
                            message.deniedCountries = [];
                        message.deniedCountries.push(reader.string());
                        break;
                    }
                case 3: {
                        if (!(message.allowedRegions && message.allowedRegions.length))
                            message.allowedRegions = [];
                        message.allowedRegions.push(reader.string());
                        break;
                    }
                case 4: {
                        if (!(message.deniedRegions && message.deniedRegions.length))
                            message.deniedRegions = [];
                        message.deniedRegions.push(reader.string());
                        break;
                    }
                case 5: {
                        if (!(message.allowedFileTypes && message.allowedFileTypes.length))
                            message.allowedFileTypes = [];
                        message.allowedFileTypes.push(reader.string());
                        break;
                    }
                case 6: {
                        if (!(message.deniedFileTypes && message.deniedFileTypes.length))
                            message.deniedFileTypes = [];
                        message.deniedFileTypes.push(reader.string());
                        break;
                    }
                case 7: {
                        message.status = reader.int32();
                        break;
                    }
                case 8: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetOrgSettings message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.GetOrgSettings
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.GetOrgSettings} GetOrgSettings
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetOrgSettings.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetOrgSettings message.
         * @function verify
         * @memberof response.GetOrgSettings
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetOrgSettings.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.allowedCountries != null && message.hasOwnProperty("allowedCountries")) {
                if (!Array.isArray(message.allowedCountries))
                    return "allowedCountries: array expected";
                for (let i = 0; i < message.allowedCountries.length; ++i)
                    if (!$util.isString(message.allowedCountries[i]))
                        return "allowedCountries: string[] expected";
            }
            if (message.deniedCountries != null && message.hasOwnProperty("deniedCountries")) {
                if (!Array.isArray(message.deniedCountries))
                    return "deniedCountries: array expected";
                for (let i = 0; i < message.deniedCountries.length; ++i)
                    if (!$util.isString(message.deniedCountries[i]))
                        return "deniedCountries: string[] expected";
            }
            if (message.allowedRegions != null && message.hasOwnProperty("allowedRegions")) {
                if (!Array.isArray(message.allowedRegions))
                    return "allowedRegions: array expected";
                for (let i = 0; i < message.allowedRegions.length; ++i)
                    if (!$util.isString(message.allowedRegions[i]))
                        return "allowedRegions: string[] expected";
            }
            if (message.deniedRegions != null && message.hasOwnProperty("deniedRegions")) {
                if (!Array.isArray(message.deniedRegions))
                    return "deniedRegions: array expected";
                for (let i = 0; i < message.deniedRegions.length; ++i)
                    if (!$util.isString(message.deniedRegions[i]))
                        return "deniedRegions: string[] expected";
            }
            if (message.allowedFileTypes != null && message.hasOwnProperty("allowedFileTypes")) {
                if (!Array.isArray(message.allowedFileTypes))
                    return "allowedFileTypes: array expected";
                for (let i = 0; i < message.allowedFileTypes.length; ++i)
                    if (!$util.isString(message.allowedFileTypes[i]))
                        return "allowedFileTypes: string[] expected";
            }
            if (message.deniedFileTypes != null && message.hasOwnProperty("deniedFileTypes")) {
                if (!Array.isArray(message.deniedFileTypes))
                    return "deniedFileTypes: array expected";
                for (let i = 0; i < message.deniedFileTypes.length; ++i)
                    if (!$util.isString(message.deniedFileTypes[i]))
                        return "deniedFileTypes: string[] expected";
            }
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates a GetOrgSettings message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.GetOrgSettings
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.GetOrgSettings} GetOrgSettings
         */
        GetOrgSettings.fromObject = function fromObject(object) {
            if (object instanceof $root.response.GetOrgSettings)
                return object;
            let message = new $root.response.GetOrgSettings();
            if (object.allowedCountries) {
                if (!Array.isArray(object.allowedCountries))
                    throw TypeError(".response.GetOrgSettings.allowedCountries: array expected");
                message.allowedCountries = [];
                for (let i = 0; i < object.allowedCountries.length; ++i)
                    message.allowedCountries[i] = String(object.allowedCountries[i]);
            }
            if (object.deniedCountries) {
                if (!Array.isArray(object.deniedCountries))
                    throw TypeError(".response.GetOrgSettings.deniedCountries: array expected");
                message.deniedCountries = [];
                for (let i = 0; i < object.deniedCountries.length; ++i)
                    message.deniedCountries[i] = String(object.deniedCountries[i]);
            }
            if (object.allowedRegions) {
                if (!Array.isArray(object.allowedRegions))
                    throw TypeError(".response.GetOrgSettings.allowedRegions: array expected");
                message.allowedRegions = [];
                for (let i = 0; i < object.allowedRegions.length; ++i)
                    message.allowedRegions[i] = String(object.allowedRegions[i]);
            }
            if (object.deniedRegions) {
                if (!Array.isArray(object.deniedRegions))
                    throw TypeError(".response.GetOrgSettings.deniedRegions: array expected");
                message.deniedRegions = [];
                for (let i = 0; i < object.deniedRegions.length; ++i)
                    message.deniedRegions[i] = String(object.deniedRegions[i]);
            }
            if (object.allowedFileTypes) {
                if (!Array.isArray(object.allowedFileTypes))
                    throw TypeError(".response.GetOrgSettings.allowedFileTypes: array expected");
                message.allowedFileTypes = [];
                for (let i = 0; i < object.allowedFileTypes.length; ++i)
                    message.allowedFileTypes[i] = String(object.allowedFileTypes[i]);
            }
            if (object.deniedFileTypes) {
                if (!Array.isArray(object.deniedFileTypes))
                    throw TypeError(".response.GetOrgSettings.deniedFileTypes: array expected");
                message.deniedFileTypes = [];
                for (let i = 0; i < object.deniedFileTypes.length; ++i)
                    message.deniedFileTypes[i] = String(object.deniedFileTypes[i]);
            }
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from a GetOrgSettings message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.GetOrgSettings
         * @static
         * @param {response.GetOrgSettings} message GetOrgSettings
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetOrgSettings.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults) {
                object.allowedCountries = [];
                object.deniedCountries = [];
                object.allowedRegions = [];
                object.deniedRegions = [];
                object.allowedFileTypes = [];
                object.deniedFileTypes = [];
            }
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.allowedCountries && message.allowedCountries.length) {
                object.allowedCountries = [];
                for (let j = 0; j < message.allowedCountries.length; ++j)
                    object.allowedCountries[j] = message.allowedCountries[j];
            }
            if (message.deniedCountries && message.deniedCountries.length) {
                object.deniedCountries = [];
                for (let j = 0; j < message.deniedCountries.length; ++j)
                    object.deniedCountries[j] = message.deniedCountries[j];
            }
            if (message.allowedRegions && message.allowedRegions.length) {
                object.allowedRegions = [];
                for (let j = 0; j < message.allowedRegions.length; ++j)
                    object.allowedRegions[j] = message.allowedRegions[j];
            }
            if (message.deniedRegions && message.deniedRegions.length) {
                object.deniedRegions = [];
                for (let j = 0; j < message.deniedRegions.length; ++j)
                    object.deniedRegions[j] = message.deniedRegions[j];
            }
            if (message.allowedFileTypes && message.allowedFileTypes.length) {
                object.allowedFileTypes = [];
                for (let j = 0; j < message.allowedFileTypes.length; ++j)
                    object.allowedFileTypes[j] = message.allowedFileTypes[j];
            }
            if (message.deniedFileTypes && message.deniedFileTypes.length) {
                object.deniedFileTypes = [];
                for (let j = 0; j < message.deniedFileTypes.length; ++j)
                    object.deniedFileTypes[j] = message.deniedFileTypes[j];
            }
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this GetOrgSettings to JSON.
         * @function toJSON
         * @memberof response.GetOrgSettings
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetOrgSettings.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetOrgSettings
         * @function getTypeUrl
         * @memberof response.GetOrgSettings
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetOrgSettings.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.GetOrgSettings";
        };

        return GetOrgSettings;
    })();

    response.UpdateOrgSettings = (function() {

        /**
         * Properties of an UpdateOrgSettings.
         * @memberof response
         * @interface IUpdateOrgSettings
         * @property {response.Status|null} [status] UpdateOrgSettings status
         * @property {string|null} [message] UpdateOrgSettings message
         */

        /**
         * Constructs a new UpdateOrgSettings.
         * @memberof response
         * @classdesc Represents an UpdateOrgSettings.
         * @implements IUpdateOrgSettings
         * @constructor
         * @param {response.IUpdateOrgSettings=} [properties] Properties to set
         */
        function UpdateOrgSettings(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateOrgSettings status.
         * @member {response.Status} status
         * @memberof response.UpdateOrgSettings
         * @instance
         */
        UpdateOrgSettings.prototype.status = 0;

        /**
         * UpdateOrgSettings message.
         * @member {string|null|undefined} message
         * @memberof response.UpdateOrgSettings
         * @instance
         */
        UpdateOrgSettings.prototype.message = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(UpdateOrgSettings.prototype, "_message", {
            get: $util.oneOfGetter($oneOfFields = ["message"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new UpdateOrgSettings instance using the specified properties.
         * @function create
         * @memberof response.UpdateOrgSettings
         * @static
         * @param {response.IUpdateOrgSettings=} [properties] Properties to set
         * @returns {response.UpdateOrgSettings} UpdateOrgSettings instance
         */
        UpdateOrgSettings.create = function create(properties) {
            return new UpdateOrgSettings(properties);
        };

        /**
         * Encodes the specified UpdateOrgSettings message. Does not implicitly {@link response.UpdateOrgSettings.verify|verify} messages.
         * @function encode
         * @memberof response.UpdateOrgSettings
         * @static
         * @param {response.IUpdateOrgSettings} message UpdateOrgSettings message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateOrgSettings.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            return writer;
        };

        /**
         * Encodes the specified UpdateOrgSettings message, length delimited. Does not implicitly {@link response.UpdateOrgSettings.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.UpdateOrgSettings
         * @static
         * @param {response.IUpdateOrgSettings} message UpdateOrgSettings message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateOrgSettings.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UpdateOrgSettings message from the specified reader or buffer.
         * @function decode
         * @memberof response.UpdateOrgSettings
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.UpdateOrgSettings} UpdateOrgSettings
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateOrgSettings.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.UpdateOrgSettings();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.status = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UpdateOrgSettings message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.UpdateOrgSettings
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.UpdateOrgSettings} UpdateOrgSettings
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateOrgSettings.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UpdateOrgSettings message.
         * @function verify
         * @memberof response.UpdateOrgSettings
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UpdateOrgSettings.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 100:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message")) {
                properties._message = 1;
                if (!$util.isString(message.message))
                    return "message: string expected";
            }
            return null;
        };

        /**
         * Creates an UpdateOrgSettings message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.UpdateOrgSettings
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.UpdateOrgSettings} UpdateOrgSettings
         */
        UpdateOrgSettings.fromObject = function fromObject(object) {
            if (object instanceof $root.response.UpdateOrgSettings)
                return object;
            let message = new $root.response.UpdateOrgSettings();
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "SUCCESS":
            case 0:
                message.status = 0;
                break;
            case "BACKEND_ERROR":
            case 1:
                message.status = 1;
                break;
            case "AUTHENTICATION_FAILURE":
            case 2:
                message.status = 2;
                break;
            case "CRYPTO_FAILURE":
            case 3:
                message.status = 3;
                break;
            case "STORAGE_FAILURE":
            case 4:
                message.status = 4;
                break;
            case "INVALID_REQUEST":
            case 5:
                message.status = 5;
                break;
            case "INVALID_RESPONSE":
            case 6:
                message.status = 6;
                break;
            case "OBJECT_NOT_FOUND":
            case 7:
                message.status = 7;
                break;
            case "OBJECT_EXISTS":
            case 8:
                message.status = 8;
                break;
            case "OBJECT_CORRUPTED":
            case 9:
                message.status = 9;
                break;
            case "OBJECT_LOCKED":
            case 10:
                message.status = 10;
                break;
            case "ACCESS_DENIED":
            case 11:
                message.status = 11;
                break;
            case "QUOTA_EXCEEDED":
            case 12:
                message.status = 12;
                break;
            case "STORAGE_FULL":
            case 13:
                message.status = 13;
                break;
            case "STORAGE_UNAVAILABLE":
            case 14:
                message.status = 14;
                break;
            case "STORAGE_CORRUPTED":
            case 15:
                message.status = 15;
                break;
            case "STORAGE_MISCONFIGURED":
            case 16:
                message.status = 16;
                break;
            case "STORAGE_READ_ONLY":
            case 17:
                message.status = 17;
                break;
            case "STORAGE_DISABLED":
            case 18:
                message.status = 18;
                break;
            case "BYOS_MIGRATION_IN_PROGRESS":
            case 19:
                message.status = 19;
                break;
            case "FAILURE":
            case 100:
                message.status = 100;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            return message;
        };

        /**
         * Creates a plain object from an UpdateOrgSettings message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.UpdateOrgSettings
         * @static
         * @param {response.UpdateOrgSettings} message UpdateOrgSettings
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateOrgSettings.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.status = options.enums === String ? "SUCCESS" : 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.response.Status[message.status] === undefined ? message.status : $root.response.Status[message.status] : message.status;
            if (message.message != null && message.hasOwnProperty("message")) {
                object.message = message.message;
                if (options.oneofs)
                    object._message = "message";
            }
            return object;
        };

        /**
         * Converts this UpdateOrgSettings to JSON.
         * @function toJSON
         * @memberof response.UpdateOrgSettings
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateOrgSettings.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for UpdateOrgSettings
         * @function getTypeUrl
         * @memberof response.UpdateOrgSettings
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        UpdateOrgSettings.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.UpdateOrgSettings";
        };

        return UpdateOrgSettings;
    })();

    response.Response = (function() {

        /**
         * Properties of a Response.
         * @memberof response
         * @interface IResponse
         * @property {number|Long|null} [id] Response id
         * @property {response.IAddUser|null} [addUser] Response addUser
         * @property {response.IVerifyUser|null} [verifyUser] Response verifyUser
         * @property {response.IRemoveUser|null} [removeUser] Response removeUser
         * @property {response.IPasswordReset|null} [passwordReset] Response passwordReset
         * @property {response.IChangePassword|null} [changePassword] Response changePassword
         * @property {response.IAddOrganization|null} [addOrganization] Response addOrganization
         * @property {response.IInitiatePayment|null} [initiatePayment] Response initiatePayment
         * @property {response.IPaymentResponse|null} [paymentResponse] Response paymentResponse
         * @property {response.ISignIn|null} [signIn] Response signIn
         * @property {response.ISignOut|null} [signOut] Response signOut
         * @property {response.IInviteUser|null} [inviteUser] Response inviteUser
         * @property {response.IGetUser|null} [getUser] Response getUser
         * @property {response.IListUsers|null} [listUsers] Response listUsers
         * @property {response.IRemoveOrganization|null} [removeOrganization] Response removeOrganization
         * @property {response.IVerifyOrganization|null} [verifyOrganization] Response verifyOrganization
         * @property {response.IGetOrganization|null} [getOrganization] Response getOrganization
         * @property {response.IAddPin|null} [addPin] Response addPin
         * @property {response.IEcho|null} [echo] Response echo
         * @property {response.IGetFileHead|null} [getFileHead] Response getFileHead
         * @property {response.IGetChunk|null} [getChunk] Response getChunk
         * @property {response.IStartWrite|null} [startWrite] Response startWrite
         * @property {response.IPutChunk|null} [putChunk] Response putChunk
         * @property {response.IFinalizeWrite|null} [finalizeWrite] Response finalizeWrite
         * @property {response.IListFiles|null} [listFiles] Response listFiles
         * @property {response.IRemove|null} [remove] Response remove
         * @property {response.IFileLock|null} [fileLock] Response fileLock
         * @property {response.IFileUnlock|null} [fileUnlock] Response fileUnlock
         * @property {response.IGetFolder|null} [getFolder] Response getFolder
         * @property {response.ICreateFolder|null} [createFolder] Response createFolder
         * @property {response.ICreateSnapshot|null} [CreateSnapshot] Response CreateSnapshot
         * @property {response.IVerifyPayment|null} [verifyPayment] Response verifyPayment
         * @property {response.IGetSecret|null} [getSecret] Response getSecret
         * @property {response.IAddSecret|null} [addSecret] Response addSecret
         * @property {response.IDeleteSecret|null} [deleteSecret] Response deleteSecret
         * @property {response.IUpdateSecret|null} [updateSecret] Response updateSecret
         * @property {response.IListSecrets|null} [listSecrets] Response listSecrets
         * @property {response.IListSecretSubkeys|null} [listSecretSubkeys] Response listSecretSubkeys
         * @property {response.IQuickListSecrets|null} [quickListSecrets] Response quickListSecrets
         * @property {response.IUndeleteSecret|null} [undeleteSecret] Response undeleteSecret
         * @property {response.IDestroySecret|null} [destroySecret] Response destroySecret
         * @property {response.IAddRole|null} [addRole] Response addRole
         * @property {response.IRemoveRole|null} [removeRole] Response removeRole
         * @property {response.IUpdateRole|null} [updateRole] Response updateRole
         * @property {response.IListRoles|null} [listRoles] Response listRoles
         * @property {response.IGetRole|null} [getRole] Response getRole
         * @property {response.IAddTeam|null} [addTeam] Response addTeam
         * @property {response.IRemoveTeam|null} [removeTeam] Response removeTeam
         * @property {response.IUpdateTeam|null} [updateTeam] Response updateTeam
         * @property {response.IListTeams|null} [listTeams] Response listTeams
         * @property {response.IGetTeam|null} [getTeam] Response getTeam
         * @property {response.IIsOperationAllowed|null} [isOperationAllowed] Response isOperationAllowed
         * @property {response.IMoveFile|null} [moveFile] Response moveFile
         * @property {response.IMoveFolder|null} [moveFolder] Response moveFolder
         * @property {response.ICopyFile|null} [copyFile] Response copyFile
         * @property {response.ICopyFolder|null} [copyFolder] Response copyFolder
         * @property {response.IRestoreVersion|null} [restoreVersion] Response restoreVersion
         * @property {response.IRemoveFile|null} [removeFile] Response removeFile
         * @property {response.IRemoveFolder|null} [removeFolder] Response removeFolder
         * @property {response.IUntrashFile|null} [untrashFile] Response untrashFile
         * @property {response.IUntrashFolder|null} [untrashFolder] Response untrashFolder
         * @property {response.IUndoStartWrite|null} [undoStartWrite] Response undoStartWrite
         * @property {response.IDetachClonedFolder|null} [detachClonedFolder] Response detachClonedFolder
         * @property {response.IGetMetaFromPath|null} [getMetaFromPath] Response getMetaFromPath
         * @property {response.IRenameFile|null} [renameFile] Response renameFile
         * @property {response.IRenameFolder|null} [renameFolder] Response renameFolder
         * @property {response.IList|null} [list] Response list
         * @property {response.IAuditLogMessage|null} [auditLogMessage] Response auditLogMessage
         * @property {response.IResetVersion|null} [resetVersion] Response resetVersion
         * @property {response.ISetUser|null} [setUser] Response setUser
         * @property {response.IFinalizeProfileWrite|null} [finalizeProfileWrite] Response finalizeProfileWrite
         * @property {response.IGetProfileFileMeta|null} [getProfileFileMeta] Response getProfileFileMeta
         * @property {response.IProfileChunkList|null} [profileChunkList] Response profileChunkList
         * @property {response.IGetUserType|null} [getUserType] Response getUserType
         * @property {response.IGetRandomBytes|null} [getRandomBytes] Response getRandomBytes
         * @property {response.IShare|null} [share] Response share
         * @property {response.IUnshare|null} [unshare] Response unshare
         * @property {response.IUpdateShare|null} [updateShare] Response updateShare
         * @property {response.IListShares|null} [listShares] Response listShares
         * @property {response.IResetTOTP|null} [resetTOTP] Response resetTOTP
         * @property {response.ISetRolesTeamsToUser|null} [setRolesTeamsToUser] Response setRolesTeamsToUser
         * @property {response.IUpdatePinOps|null} [updatePinOps] Response updatePinOps
         * @property {response.IDeletePin|null} [deletePin] Response deletePin
         * @property {response.IGetRolesAndTeamsOfUser|null} [getRolesAndTeamsOfUser] Response getRolesAndTeamsOfUser
         * @property {response.IRestartPutChunk|null} [restartPutChunk] Response restartPutChunk
         * @property {response.IVerifyAuditLogMeta|null} [verifyAuditLogMeta] Response verifyAuditLogMeta
         * @property {response.IGetAuditLog|null} [getAuditLog] Response getAuditLog
         * @property {response.IDeleteAuditLog|null} [deleteAuditLog] Response deleteAuditLog
         * @property {response.IGetLedgerRange|null} [getLedgerRange] Response getLedgerRange
         * @property {response.IListPins|null} [listPins] Response listPins
         * @property {response.IGetMetaFromSharedPath|null} [GetMetaFromSharedPath] Response GetMetaFromSharedPath
         * @property {response.IListQuestions|null} [listQuestions] Response listQuestions
         * @property {response.IVerifyBYOSCreds|null} [verifyBYOSCreds] Response verifyBYOSCreds
         * @property {response.IMigrateToStorage|null} [MigrateToStorage] Response MigrateToStorage
         * @property {response.IUpdateStorageCreds|null} [updateStorageCreds] Response updateStorageCreds
         * @property {response.IVerifyUserForAudit|null} [verifyUserForAudit] Response verifyUserForAudit
         * @property {response.IRemoveOrganizationUser|null} [removeOrganizationUser] Response removeOrganizationUser
         * @property {response.IAddSpace|null} [addSpace] Response addSpace
         * @property {response.IAddUserToSpace|null} [addUserToSpace] Response addUserToSpace
         * @property {response.IRemoveUserFromSpace|null} [removeUserFromSpace] Response removeUserFromSpace
         * @property {response.IUpdatePermissionsOfSpace|null} [updatePermissionsOfSpace] Response updatePermissionsOfSpace
         * @property {response.IAddObjectToSpace|null} [addObjectToSpace] Response addObjectToSpace
         * @property {response.IRemoveObjectFromSpace|null} [removeObjectFromSpace] Response removeObjectFromSpace
         * @property {response.IRemoveSpace|null} [removeSpace] Response removeSpace
         * @property {response.ISendOtpToExternalUser|null} [sendOtpToExternalUser] Response sendOtpToExternalUser
         * @property {response.ISignInToSpace|null} [signInToSpace] Response signInToSpace
         * @property {response.IListSpaces|null} [listSpaces] Response listSpaces
         * @property {response.ISendOtpToExternalUserIfNotExist|null} [sendOtpToExternalUserIfNotExist] Response sendOtpToExternalUserIfNotExist
         * @property {response.IGetStorageValue|null} [getStorageValue] Response getStorageValue
         * @property {response.IUpdateTags|null} [updateTags] Response updateTags
         * @property {response.IAddComment|null} [addComment] Response addComment
         * @property {response.IRemoveComment|null} [removeComment] Response removeComment
         * @property {response.IListComments|null} [listComments] Response listComments
         * @property {response.IUpdateComment|null} [updateComment] Response updateComment
         * @property {response.IGetComment|null} [getComment] Response getComment
         * @property {response.ISessionData|null} [sessionData] Response sessionData
         * @property {response.IGetStorageCreds|null} [getStorageCreds] Response getStorageCreds
         * @property {response.IGetPlan|null} [getPlan] Response getPlan
         * @property {response.IListPlans|null} [listPlans] Response listPlans
         * @property {response.IUpgradePlan|null} [upgradePlan] Response upgradePlan
         * @property {response.IValidateCoupon|null} [validateCoupon] Response validateCoupon
         * @property {response.IRemoveVersion|null} [removeVersion] Response removeVersion
         * @property {response.IGetProfilePictureOfUser|null} [getProfilePictureOfUser] Response getProfilePictureOfUser
         * @property {response.IEmptyTrash|null} [emptyTrash] Response emptyTrash
         * @property {response.ISetThumbnail|null} [setThumbnail] Response setThumbnail
         * @property {response.IGetThumbnail|null} [getThumbnail] Response getThumbnail
         * @property {response.IBlockUser|null} [blockUser] Response blockUser
         * @property {response.IUnblockUser|null} [unblockUser] Response unblockUser
         * @property {response.IUpdateOrgSettings|null} [updateOrgSettings] Response updateOrgSettings
         * @property {response.IGetOrgSettings|null} [getOrgSettings] Response getOrgSettings
         */

        /**
         * Constructs a new Response.
         * @memberof response
         * @classdesc Represents a Response.
         * @implements IResponse
         * @constructor
         * @param {response.IResponse=} [properties] Properties to set
         */
        function Response(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Response id.
         * @member {number|Long|null|undefined} id
         * @memberof response.Response
         * @instance
         */
        Response.prototype.id = null;

        /**
         * Response addUser.
         * @member {response.IAddUser|null|undefined} addUser
         * @memberof response.Response
         * @instance
         */
        Response.prototype.addUser = null;

        /**
         * Response verifyUser.
         * @member {response.IVerifyUser|null|undefined} verifyUser
         * @memberof response.Response
         * @instance
         */
        Response.prototype.verifyUser = null;

        /**
         * Response removeUser.
         * @member {response.IRemoveUser|null|undefined} removeUser
         * @memberof response.Response
         * @instance
         */
        Response.prototype.removeUser = null;

        /**
         * Response passwordReset.
         * @member {response.IPasswordReset|null|undefined} passwordReset
         * @memberof response.Response
         * @instance
         */
        Response.prototype.passwordReset = null;

        /**
         * Response changePassword.
         * @member {response.IChangePassword|null|undefined} changePassword
         * @memberof response.Response
         * @instance
         */
        Response.prototype.changePassword = null;

        /**
         * Response addOrganization.
         * @member {response.IAddOrganization|null|undefined} addOrganization
         * @memberof response.Response
         * @instance
         */
        Response.prototype.addOrganization = null;

        /**
         * Response initiatePayment.
         * @member {response.IInitiatePayment|null|undefined} initiatePayment
         * @memberof response.Response
         * @instance
         */
        Response.prototype.initiatePayment = null;

        /**
         * Response paymentResponse.
         * @member {response.IPaymentResponse|null|undefined} paymentResponse
         * @memberof response.Response
         * @instance
         */
        Response.prototype.paymentResponse = null;

        /**
         * Response signIn.
         * @member {response.ISignIn|null|undefined} signIn
         * @memberof response.Response
         * @instance
         */
        Response.prototype.signIn = null;

        /**
         * Response signOut.
         * @member {response.ISignOut|null|undefined} signOut
         * @memberof response.Response
         * @instance
         */
        Response.prototype.signOut = null;

        /**
         * Response inviteUser.
         * @member {response.IInviteUser|null|undefined} inviteUser
         * @memberof response.Response
         * @instance
         */
        Response.prototype.inviteUser = null;

        /**
         * Response getUser.
         * @member {response.IGetUser|null|undefined} getUser
         * @memberof response.Response
         * @instance
         */
        Response.prototype.getUser = null;

        /**
         * Response listUsers.
         * @member {response.IListUsers|null|undefined} listUsers
         * @memberof response.Response
         * @instance
         */
        Response.prototype.listUsers = null;

        /**
         * Response removeOrganization.
         * @member {response.IRemoveOrganization|null|undefined} removeOrganization
         * @memberof response.Response
         * @instance
         */
        Response.prototype.removeOrganization = null;

        /**
         * Response verifyOrganization.
         * @member {response.IVerifyOrganization|null|undefined} verifyOrganization
         * @memberof response.Response
         * @instance
         */
        Response.prototype.verifyOrganization = null;

        /**
         * Response getOrganization.
         * @member {response.IGetOrganization|null|undefined} getOrganization
         * @memberof response.Response
         * @instance
         */
        Response.prototype.getOrganization = null;

        /**
         * Response addPin.
         * @member {response.IAddPin|null|undefined} addPin
         * @memberof response.Response
         * @instance
         */
        Response.prototype.addPin = null;

        /**
         * Response echo.
         * @member {response.IEcho|null|undefined} echo
         * @memberof response.Response
         * @instance
         */
        Response.prototype.echo = null;

        /**
         * Response getFileHead.
         * @member {response.IGetFileHead|null|undefined} getFileHead
         * @memberof response.Response
         * @instance
         */
        Response.prototype.getFileHead = null;

        /**
         * Response getChunk.
         * @member {response.IGetChunk|null|undefined} getChunk
         * @memberof response.Response
         * @instance
         */
        Response.prototype.getChunk = null;

        /**
         * Response startWrite.
         * @member {response.IStartWrite|null|undefined} startWrite
         * @memberof response.Response
         * @instance
         */
        Response.prototype.startWrite = null;

        /**
         * Response putChunk.
         * @member {response.IPutChunk|null|undefined} putChunk
         * @memberof response.Response
         * @instance
         */
        Response.prototype.putChunk = null;

        /**
         * Response finalizeWrite.
         * @member {response.IFinalizeWrite|null|undefined} finalizeWrite
         * @memberof response.Response
         * @instance
         */
        Response.prototype.finalizeWrite = null;

        /**
         * Response listFiles.
         * @member {response.IListFiles|null|undefined} listFiles
         * @memberof response.Response
         * @instance
         */
        Response.prototype.listFiles = null;

        /**
         * Response remove.
         * @member {response.IRemove|null|undefined} remove
         * @memberof response.Response
         * @instance
         */
        Response.prototype.remove = null;

        /**
         * Response fileLock.
         * @member {response.IFileLock|null|undefined} fileLock
         * @memberof response.Response
         * @instance
         */
        Response.prototype.fileLock = null;

        /**
         * Response fileUnlock.
         * @member {response.IFileUnlock|null|undefined} fileUnlock
         * @memberof response.Response
         * @instance
         */
        Response.prototype.fileUnlock = null;

        /**
         * Response getFolder.
         * @member {response.IGetFolder|null|undefined} getFolder
         * @memberof response.Response
         * @instance
         */
        Response.prototype.getFolder = null;

        /**
         * Response createFolder.
         * @member {response.ICreateFolder|null|undefined} createFolder
         * @memberof response.Response
         * @instance
         */
        Response.prototype.createFolder = null;

        /**
         * Response CreateSnapshot.
         * @member {response.ICreateSnapshot|null|undefined} CreateSnapshot
         * @memberof response.Response
         * @instance
         */
        Response.prototype.CreateSnapshot = null;

        /**
         * Response verifyPayment.
         * @member {response.IVerifyPayment|null|undefined} verifyPayment
         * @memberof response.Response
         * @instance
         */
        Response.prototype.verifyPayment = null;

        /**
         * Response getSecret.
         * @member {response.IGetSecret|null|undefined} getSecret
         * @memberof response.Response
         * @instance
         */
        Response.prototype.getSecret = null;

        /**
         * Response addSecret.
         * @member {response.IAddSecret|null|undefined} addSecret
         * @memberof response.Response
         * @instance
         */
        Response.prototype.addSecret = null;

        /**
         * Response deleteSecret.
         * @member {response.IDeleteSecret|null|undefined} deleteSecret
         * @memberof response.Response
         * @instance
         */
        Response.prototype.deleteSecret = null;

        /**
         * Response updateSecret.
         * @member {response.IUpdateSecret|null|undefined} updateSecret
         * @memberof response.Response
         * @instance
         */
        Response.prototype.updateSecret = null;

        /**
         * Response listSecrets.
         * @member {response.IListSecrets|null|undefined} listSecrets
         * @memberof response.Response
         * @instance
         */
        Response.prototype.listSecrets = null;

        /**
         * Response listSecretSubkeys.
         * @member {response.IListSecretSubkeys|null|undefined} listSecretSubkeys
         * @memberof response.Response
         * @instance
         */
        Response.prototype.listSecretSubkeys = null;

        /**
         * Response quickListSecrets.
         * @member {response.IQuickListSecrets|null|undefined} quickListSecrets
         * @memberof response.Response
         * @instance
         */
        Response.prototype.quickListSecrets = null;

        /**
         * Response undeleteSecret.
         * @member {response.IUndeleteSecret|null|undefined} undeleteSecret
         * @memberof response.Response
         * @instance
         */
        Response.prototype.undeleteSecret = null;

        /**
         * Response destroySecret.
         * @member {response.IDestroySecret|null|undefined} destroySecret
         * @memberof response.Response
         * @instance
         */
        Response.prototype.destroySecret = null;

        /**
         * Response addRole.
         * @member {response.IAddRole|null|undefined} addRole
         * @memberof response.Response
         * @instance
         */
        Response.prototype.addRole = null;

        /**
         * Response removeRole.
         * @member {response.IRemoveRole|null|undefined} removeRole
         * @memberof response.Response
         * @instance
         */
        Response.prototype.removeRole = null;

        /**
         * Response updateRole.
         * @member {response.IUpdateRole|null|undefined} updateRole
         * @memberof response.Response
         * @instance
         */
        Response.prototype.updateRole = null;

        /**
         * Response listRoles.
         * @member {response.IListRoles|null|undefined} listRoles
         * @memberof response.Response
         * @instance
         */
        Response.prototype.listRoles = null;

        /**
         * Response getRole.
         * @member {response.IGetRole|null|undefined} getRole
         * @memberof response.Response
         * @instance
         */
        Response.prototype.getRole = null;

        /**
         * Response addTeam.
         * @member {response.IAddTeam|null|undefined} addTeam
         * @memberof response.Response
         * @instance
         */
        Response.prototype.addTeam = null;

        /**
         * Response removeTeam.
         * @member {response.IRemoveTeam|null|undefined} removeTeam
         * @memberof response.Response
         * @instance
         */
        Response.prototype.removeTeam = null;

        /**
         * Response updateTeam.
         * @member {response.IUpdateTeam|null|undefined} updateTeam
         * @memberof response.Response
         * @instance
         */
        Response.prototype.updateTeam = null;

        /**
         * Response listTeams.
         * @member {response.IListTeams|null|undefined} listTeams
         * @memberof response.Response
         * @instance
         */
        Response.prototype.listTeams = null;

        /**
         * Response getTeam.
         * @member {response.IGetTeam|null|undefined} getTeam
         * @memberof response.Response
         * @instance
         */
        Response.prototype.getTeam = null;

        /**
         * Response isOperationAllowed.
         * @member {response.IIsOperationAllowed|null|undefined} isOperationAllowed
         * @memberof response.Response
         * @instance
         */
        Response.prototype.isOperationAllowed = null;

        /**
         * Response moveFile.
         * @member {response.IMoveFile|null|undefined} moveFile
         * @memberof response.Response
         * @instance
         */
        Response.prototype.moveFile = null;

        /**
         * Response moveFolder.
         * @member {response.IMoveFolder|null|undefined} moveFolder
         * @memberof response.Response
         * @instance
         */
        Response.prototype.moveFolder = null;

        /**
         * Response copyFile.
         * @member {response.ICopyFile|null|undefined} copyFile
         * @memberof response.Response
         * @instance
         */
        Response.prototype.copyFile = null;

        /**
         * Response copyFolder.
         * @member {response.ICopyFolder|null|undefined} copyFolder
         * @memberof response.Response
         * @instance
         */
        Response.prototype.copyFolder = null;

        /**
         * Response restoreVersion.
         * @member {response.IRestoreVersion|null|undefined} restoreVersion
         * @memberof response.Response
         * @instance
         */
        Response.prototype.restoreVersion = null;

        /**
         * Response removeFile.
         * @member {response.IRemoveFile|null|undefined} removeFile
         * @memberof response.Response
         * @instance
         */
        Response.prototype.removeFile = null;

        /**
         * Response removeFolder.
         * @member {response.IRemoveFolder|null|undefined} removeFolder
         * @memberof response.Response
         * @instance
         */
        Response.prototype.removeFolder = null;

        /**
         * Response untrashFile.
         * @member {response.IUntrashFile|null|undefined} untrashFile
         * @memberof response.Response
         * @instance
         */
        Response.prototype.untrashFile = null;

        /**
         * Response untrashFolder.
         * @member {response.IUntrashFolder|null|undefined} untrashFolder
         * @memberof response.Response
         * @instance
         */
        Response.prototype.untrashFolder = null;

        /**
         * Response undoStartWrite.
         * @member {response.IUndoStartWrite|null|undefined} undoStartWrite
         * @memberof response.Response
         * @instance
         */
        Response.prototype.undoStartWrite = null;

        /**
         * Response detachClonedFolder.
         * @member {response.IDetachClonedFolder|null|undefined} detachClonedFolder
         * @memberof response.Response
         * @instance
         */
        Response.prototype.detachClonedFolder = null;

        /**
         * Response getMetaFromPath.
         * @member {response.IGetMetaFromPath|null|undefined} getMetaFromPath
         * @memberof response.Response
         * @instance
         */
        Response.prototype.getMetaFromPath = null;

        /**
         * Response renameFile.
         * @member {response.IRenameFile|null|undefined} renameFile
         * @memberof response.Response
         * @instance
         */
        Response.prototype.renameFile = null;

        /**
         * Response renameFolder.
         * @member {response.IRenameFolder|null|undefined} renameFolder
         * @memberof response.Response
         * @instance
         */
        Response.prototype.renameFolder = null;

        /**
         * Response list.
         * @member {response.IList|null|undefined} list
         * @memberof response.Response
         * @instance
         */
        Response.prototype.list = null;

        /**
         * Response auditLogMessage.
         * @member {response.IAuditLogMessage|null|undefined} auditLogMessage
         * @memberof response.Response
         * @instance
         */
        Response.prototype.auditLogMessage = null;

        /**
         * Response resetVersion.
         * @member {response.IResetVersion|null|undefined} resetVersion
         * @memberof response.Response
         * @instance
         */
        Response.prototype.resetVersion = null;

        /**
         * Response setUser.
         * @member {response.ISetUser|null|undefined} setUser
         * @memberof response.Response
         * @instance
         */
        Response.prototype.setUser = null;

        /**
         * Response finalizeProfileWrite.
         * @member {response.IFinalizeProfileWrite|null|undefined} finalizeProfileWrite
         * @memberof response.Response
         * @instance
         */
        Response.prototype.finalizeProfileWrite = null;

        /**
         * Response getProfileFileMeta.
         * @member {response.IGetProfileFileMeta|null|undefined} getProfileFileMeta
         * @memberof response.Response
         * @instance
         */
        Response.prototype.getProfileFileMeta = null;

        /**
         * Response profileChunkList.
         * @member {response.IProfileChunkList|null|undefined} profileChunkList
         * @memberof response.Response
         * @instance
         */
        Response.prototype.profileChunkList = null;

        /**
         * Response getUserType.
         * @member {response.IGetUserType|null|undefined} getUserType
         * @memberof response.Response
         * @instance
         */
        Response.prototype.getUserType = null;

        /**
         * Response getRandomBytes.
         * @member {response.IGetRandomBytes|null|undefined} getRandomBytes
         * @memberof response.Response
         * @instance
         */
        Response.prototype.getRandomBytes = null;

        /**
         * Response share.
         * @member {response.IShare|null|undefined} share
         * @memberof response.Response
         * @instance
         */
        Response.prototype.share = null;

        /**
         * Response unshare.
         * @member {response.IUnshare|null|undefined} unshare
         * @memberof response.Response
         * @instance
         */
        Response.prototype.unshare = null;

        /**
         * Response updateShare.
         * @member {response.IUpdateShare|null|undefined} updateShare
         * @memberof response.Response
         * @instance
         */
        Response.prototype.updateShare = null;

        /**
         * Response listShares.
         * @member {response.IListShares|null|undefined} listShares
         * @memberof response.Response
         * @instance
         */
        Response.prototype.listShares = null;

        /**
         * Response resetTOTP.
         * @member {response.IResetTOTP|null|undefined} resetTOTP
         * @memberof response.Response
         * @instance
         */
        Response.prototype.resetTOTP = null;

        /**
         * Response setRolesTeamsToUser.
         * @member {response.ISetRolesTeamsToUser|null|undefined} setRolesTeamsToUser
         * @memberof response.Response
         * @instance
         */
        Response.prototype.setRolesTeamsToUser = null;

        /**
         * Response updatePinOps.
         * @member {response.IUpdatePinOps|null|undefined} updatePinOps
         * @memberof response.Response
         * @instance
         */
        Response.prototype.updatePinOps = null;

        /**
         * Response deletePin.
         * @member {response.IDeletePin|null|undefined} deletePin
         * @memberof response.Response
         * @instance
         */
        Response.prototype.deletePin = null;

        /**
         * Response getRolesAndTeamsOfUser.
         * @member {response.IGetRolesAndTeamsOfUser|null|undefined} getRolesAndTeamsOfUser
         * @memberof response.Response
         * @instance
         */
        Response.prototype.getRolesAndTeamsOfUser = null;

        /**
         * Response restartPutChunk.
         * @member {response.IRestartPutChunk|null|undefined} restartPutChunk
         * @memberof response.Response
         * @instance
         */
        Response.prototype.restartPutChunk = null;

        /**
         * Response verifyAuditLogMeta.
         * @member {response.IVerifyAuditLogMeta|null|undefined} verifyAuditLogMeta
         * @memberof response.Response
         * @instance
         */
        Response.prototype.verifyAuditLogMeta = null;

        /**
         * Response getAuditLog.
         * @member {response.IGetAuditLog|null|undefined} getAuditLog
         * @memberof response.Response
         * @instance
         */
        Response.prototype.getAuditLog = null;

        /**
         * Response deleteAuditLog.
         * @member {response.IDeleteAuditLog|null|undefined} deleteAuditLog
         * @memberof response.Response
         * @instance
         */
        Response.prototype.deleteAuditLog = null;

        /**
         * Response getLedgerRange.
         * @member {response.IGetLedgerRange|null|undefined} getLedgerRange
         * @memberof response.Response
         * @instance
         */
        Response.prototype.getLedgerRange = null;

        /**
         * Response listPins.
         * @member {response.IListPins|null|undefined} listPins
         * @memberof response.Response
         * @instance
         */
        Response.prototype.listPins = null;

        /**
         * Response GetMetaFromSharedPath.
         * @member {response.IGetMetaFromSharedPath|null|undefined} GetMetaFromSharedPath
         * @memberof response.Response
         * @instance
         */
        Response.prototype.GetMetaFromSharedPath = null;

        /**
         * Response listQuestions.
         * @member {response.IListQuestions|null|undefined} listQuestions
         * @memberof response.Response
         * @instance
         */
        Response.prototype.listQuestions = null;

        /**
         * Response verifyBYOSCreds.
         * @member {response.IVerifyBYOSCreds|null|undefined} verifyBYOSCreds
         * @memberof response.Response
         * @instance
         */
        Response.prototype.verifyBYOSCreds = null;

        /**
         * Response MigrateToStorage.
         * @member {response.IMigrateToStorage|null|undefined} MigrateToStorage
         * @memberof response.Response
         * @instance
         */
        Response.prototype.MigrateToStorage = null;

        /**
         * Response updateStorageCreds.
         * @member {response.IUpdateStorageCreds|null|undefined} updateStorageCreds
         * @memberof response.Response
         * @instance
         */
        Response.prototype.updateStorageCreds = null;

        /**
         * Response verifyUserForAudit.
         * @member {response.IVerifyUserForAudit|null|undefined} verifyUserForAudit
         * @memberof response.Response
         * @instance
         */
        Response.prototype.verifyUserForAudit = null;

        /**
         * Response removeOrganizationUser.
         * @member {response.IRemoveOrganizationUser|null|undefined} removeOrganizationUser
         * @memberof response.Response
         * @instance
         */
        Response.prototype.removeOrganizationUser = null;

        /**
         * Response addSpace.
         * @member {response.IAddSpace|null|undefined} addSpace
         * @memberof response.Response
         * @instance
         */
        Response.prototype.addSpace = null;

        /**
         * Response addUserToSpace.
         * @member {response.IAddUserToSpace|null|undefined} addUserToSpace
         * @memberof response.Response
         * @instance
         */
        Response.prototype.addUserToSpace = null;

        /**
         * Response removeUserFromSpace.
         * @member {response.IRemoveUserFromSpace|null|undefined} removeUserFromSpace
         * @memberof response.Response
         * @instance
         */
        Response.prototype.removeUserFromSpace = null;

        /**
         * Response updatePermissionsOfSpace.
         * @member {response.IUpdatePermissionsOfSpace|null|undefined} updatePermissionsOfSpace
         * @memberof response.Response
         * @instance
         */
        Response.prototype.updatePermissionsOfSpace = null;

        /**
         * Response addObjectToSpace.
         * @member {response.IAddObjectToSpace|null|undefined} addObjectToSpace
         * @memberof response.Response
         * @instance
         */
        Response.prototype.addObjectToSpace = null;

        /**
         * Response removeObjectFromSpace.
         * @member {response.IRemoveObjectFromSpace|null|undefined} removeObjectFromSpace
         * @memberof response.Response
         * @instance
         */
        Response.prototype.removeObjectFromSpace = null;

        /**
         * Response removeSpace.
         * @member {response.IRemoveSpace|null|undefined} removeSpace
         * @memberof response.Response
         * @instance
         */
        Response.prototype.removeSpace = null;

        /**
         * Response sendOtpToExternalUser.
         * @member {response.ISendOtpToExternalUser|null|undefined} sendOtpToExternalUser
         * @memberof response.Response
         * @instance
         */
        Response.prototype.sendOtpToExternalUser = null;

        /**
         * Response signInToSpace.
         * @member {response.ISignInToSpace|null|undefined} signInToSpace
         * @memberof response.Response
         * @instance
         */
        Response.prototype.signInToSpace = null;

        /**
         * Response listSpaces.
         * @member {response.IListSpaces|null|undefined} listSpaces
         * @memberof response.Response
         * @instance
         */
        Response.prototype.listSpaces = null;

        /**
         * Response sendOtpToExternalUserIfNotExist.
         * @member {response.ISendOtpToExternalUserIfNotExist|null|undefined} sendOtpToExternalUserIfNotExist
         * @memberof response.Response
         * @instance
         */
        Response.prototype.sendOtpToExternalUserIfNotExist = null;

        /**
         * Response getStorageValue.
         * @member {response.IGetStorageValue|null|undefined} getStorageValue
         * @memberof response.Response
         * @instance
         */
        Response.prototype.getStorageValue = null;

        /**
         * Response updateTags.
         * @member {response.IUpdateTags|null|undefined} updateTags
         * @memberof response.Response
         * @instance
         */
        Response.prototype.updateTags = null;

        /**
         * Response addComment.
         * @member {response.IAddComment|null|undefined} addComment
         * @memberof response.Response
         * @instance
         */
        Response.prototype.addComment = null;

        /**
         * Response removeComment.
         * @member {response.IRemoveComment|null|undefined} removeComment
         * @memberof response.Response
         * @instance
         */
        Response.prototype.removeComment = null;

        /**
         * Response listComments.
         * @member {response.IListComments|null|undefined} listComments
         * @memberof response.Response
         * @instance
         */
        Response.prototype.listComments = null;

        /**
         * Response updateComment.
         * @member {response.IUpdateComment|null|undefined} updateComment
         * @memberof response.Response
         * @instance
         */
        Response.prototype.updateComment = null;

        /**
         * Response getComment.
         * @member {response.IGetComment|null|undefined} getComment
         * @memberof response.Response
         * @instance
         */
        Response.prototype.getComment = null;

        /**
         * Response sessionData.
         * @member {response.ISessionData|null|undefined} sessionData
         * @memberof response.Response
         * @instance
         */
        Response.prototype.sessionData = null;

        /**
         * Response getStorageCreds.
         * @member {response.IGetStorageCreds|null|undefined} getStorageCreds
         * @memberof response.Response
         * @instance
         */
        Response.prototype.getStorageCreds = null;

        /**
         * Response getPlan.
         * @member {response.IGetPlan|null|undefined} getPlan
         * @memberof response.Response
         * @instance
         */
        Response.prototype.getPlan = null;

        /**
         * Response listPlans.
         * @member {response.IListPlans|null|undefined} listPlans
         * @memberof response.Response
         * @instance
         */
        Response.prototype.listPlans = null;

        /**
         * Response upgradePlan.
         * @member {response.IUpgradePlan|null|undefined} upgradePlan
         * @memberof response.Response
         * @instance
         */
        Response.prototype.upgradePlan = null;

        /**
         * Response validateCoupon.
         * @member {response.IValidateCoupon|null|undefined} validateCoupon
         * @memberof response.Response
         * @instance
         */
        Response.prototype.validateCoupon = null;

        /**
         * Response removeVersion.
         * @member {response.IRemoveVersion|null|undefined} removeVersion
         * @memberof response.Response
         * @instance
         */
        Response.prototype.removeVersion = null;

        /**
         * Response getProfilePictureOfUser.
         * @member {response.IGetProfilePictureOfUser|null|undefined} getProfilePictureOfUser
         * @memberof response.Response
         * @instance
         */
        Response.prototype.getProfilePictureOfUser = null;

        /**
         * Response emptyTrash.
         * @member {response.IEmptyTrash|null|undefined} emptyTrash
         * @memberof response.Response
         * @instance
         */
        Response.prototype.emptyTrash = null;

        /**
         * Response setThumbnail.
         * @member {response.ISetThumbnail|null|undefined} setThumbnail
         * @memberof response.Response
         * @instance
         */
        Response.prototype.setThumbnail = null;

        /**
         * Response getThumbnail.
         * @member {response.IGetThumbnail|null|undefined} getThumbnail
         * @memberof response.Response
         * @instance
         */
        Response.prototype.getThumbnail = null;

        /**
         * Response blockUser.
         * @member {response.IBlockUser|null|undefined} blockUser
         * @memberof response.Response
         * @instance
         */
        Response.prototype.blockUser = null;

        /**
         * Response unblockUser.
         * @member {response.IUnblockUser|null|undefined} unblockUser
         * @memberof response.Response
         * @instance
         */
        Response.prototype.unblockUser = null;

        /**
         * Response updateOrgSettings.
         * @member {response.IUpdateOrgSettings|null|undefined} updateOrgSettings
         * @memberof response.Response
         * @instance
         */
        Response.prototype.updateOrgSettings = null;

        /**
         * Response getOrgSettings.
         * @member {response.IGetOrgSettings|null|undefined} getOrgSettings
         * @memberof response.Response
         * @instance
         */
        Response.prototype.getOrgSettings = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        // Virtual OneOf for proto3 optional field
        Object.defineProperty(Response.prototype, "_id", {
            get: $util.oneOfGetter($oneOfFields = ["id"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Response Operation.
         * @member {"addUser"|"verifyUser"|"removeUser"|"passwordReset"|"changePassword"|"addOrganization"|"initiatePayment"|"paymentResponse"|"signIn"|"signOut"|"inviteUser"|"getUser"|"listUsers"|"removeOrganization"|"verifyOrganization"|"getOrganization"|"addPin"|"echo"|"getFileHead"|"getChunk"|"startWrite"|"putChunk"|"finalizeWrite"|"listFiles"|"remove"|"fileLock"|"fileUnlock"|"getFolder"|"createFolder"|"CreateSnapshot"|"verifyPayment"|"getSecret"|"addSecret"|"deleteSecret"|"updateSecret"|"listSecrets"|"listSecretSubkeys"|"quickListSecrets"|"undeleteSecret"|"destroySecret"|"addRole"|"removeRole"|"updateRole"|"listRoles"|"getRole"|"addTeam"|"removeTeam"|"updateTeam"|"listTeams"|"getTeam"|"isOperationAllowed"|"moveFile"|"moveFolder"|"copyFile"|"copyFolder"|"restoreVersion"|"removeFile"|"removeFolder"|"untrashFile"|"untrashFolder"|"undoStartWrite"|"detachClonedFolder"|"getMetaFromPath"|"renameFile"|"renameFolder"|"list"|"auditLogMessage"|"resetVersion"|"setUser"|"finalizeProfileWrite"|"getProfileFileMeta"|"profileChunkList"|"getUserType"|"getRandomBytes"|"share"|"unshare"|"updateShare"|"listShares"|"resetTOTP"|"setRolesTeamsToUser"|"updatePinOps"|"deletePin"|"getRolesAndTeamsOfUser"|"restartPutChunk"|"verifyAuditLogMeta"|"getAuditLog"|"deleteAuditLog"|"getLedgerRange"|"listPins"|"GetMetaFromSharedPath"|"listQuestions"|"verifyBYOSCreds"|"MigrateToStorage"|"updateStorageCreds"|"verifyUserForAudit"|"removeOrganizationUser"|"addSpace"|"addUserToSpace"|"removeUserFromSpace"|"updatePermissionsOfSpace"|"addObjectToSpace"|"removeObjectFromSpace"|"removeSpace"|"sendOtpToExternalUser"|"signInToSpace"|"listSpaces"|"sendOtpToExternalUserIfNotExist"|"getStorageValue"|"updateTags"|"addComment"|"removeComment"|"listComments"|"updateComment"|"getComment"|"sessionData"|"getStorageCreds"|"getPlan"|"listPlans"|"upgradePlan"|"validateCoupon"|"removeVersion"|"getProfilePictureOfUser"|"emptyTrash"|"setThumbnail"|"getThumbnail"|"blockUser"|"unblockUser"|"updateOrgSettings"|"getOrgSettings"|undefined} Operation
         * @memberof response.Response
         * @instance
         */
        Object.defineProperty(Response.prototype, "Operation", {
            get: $util.oneOfGetter($oneOfFields = ["addUser", "verifyUser", "removeUser", "passwordReset", "changePassword", "addOrganization", "initiatePayment", "paymentResponse", "signIn", "signOut", "inviteUser", "getUser", "listUsers", "removeOrganization", "verifyOrganization", "getOrganization", "addPin", "echo", "getFileHead", "getChunk", "startWrite", "putChunk", "finalizeWrite", "listFiles", "remove", "fileLock", "fileUnlock", "getFolder", "createFolder", "CreateSnapshot", "verifyPayment", "getSecret", "addSecret", "deleteSecret", "updateSecret", "listSecrets", "listSecretSubkeys", "quickListSecrets", "undeleteSecret", "destroySecret", "addRole", "removeRole", "updateRole", "listRoles", "getRole", "addTeam", "removeTeam", "updateTeam", "listTeams", "getTeam", "isOperationAllowed", "moveFile", "moveFolder", "copyFile", "copyFolder", "restoreVersion", "removeFile", "removeFolder", "untrashFile", "untrashFolder", "undoStartWrite", "detachClonedFolder", "getMetaFromPath", "renameFile", "renameFolder", "list", "auditLogMessage", "resetVersion", "setUser", "finalizeProfileWrite", "getProfileFileMeta", "profileChunkList", "getUserType", "getRandomBytes", "share", "unshare", "updateShare", "listShares", "resetTOTP", "setRolesTeamsToUser", "updatePinOps", "deletePin", "getRolesAndTeamsOfUser", "restartPutChunk", "verifyAuditLogMeta", "getAuditLog", "deleteAuditLog", "getLedgerRange", "listPins", "GetMetaFromSharedPath", "listQuestions", "verifyBYOSCreds", "MigrateToStorage", "updateStorageCreds", "verifyUserForAudit", "removeOrganizationUser", "addSpace", "addUserToSpace", "removeUserFromSpace", "updatePermissionsOfSpace", "addObjectToSpace", "removeObjectFromSpace", "removeSpace", "sendOtpToExternalUser", "signInToSpace", "listSpaces", "sendOtpToExternalUserIfNotExist", "getStorageValue", "updateTags", "addComment", "removeComment", "listComments", "updateComment", "getComment", "sessionData", "getStorageCreds", "getPlan", "listPlans", "upgradePlan", "validateCoupon", "removeVersion", "getProfilePictureOfUser", "emptyTrash", "setThumbnail", "getThumbnail", "blockUser", "unblockUser", "updateOrgSettings", "getOrgSettings"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new Response instance using the specified properties.
         * @function create
         * @memberof response.Response
         * @static
         * @param {response.IResponse=} [properties] Properties to set
         * @returns {response.Response} Response instance
         */
        Response.create = function create(properties) {
            return new Response(properties);
        };

        /**
         * Encodes the specified Response message. Does not implicitly {@link response.Response.verify|verify} messages.
         * @function encode
         * @memberof response.Response
         * @static
         * @param {response.IResponse} message Response message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Response.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.addUser != null && Object.hasOwnProperty.call(message, "addUser"))
                $root.response.AddUser.encode(message.addUser, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.verifyUser != null && Object.hasOwnProperty.call(message, "verifyUser"))
                $root.response.VerifyUser.encode(message.verifyUser, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.removeUser != null && Object.hasOwnProperty.call(message, "removeUser"))
                $root.response.RemoveUser.encode(message.removeUser, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.passwordReset != null && Object.hasOwnProperty.call(message, "passwordReset"))
                $root.response.PasswordReset.encode(message.passwordReset, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            if (message.changePassword != null && Object.hasOwnProperty.call(message, "changePassword"))
                $root.response.ChangePassword.encode(message.changePassword, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
            if (message.addOrganization != null && Object.hasOwnProperty.call(message, "addOrganization"))
                $root.response.AddOrganization.encode(message.addOrganization, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
            if (message.initiatePayment != null && Object.hasOwnProperty.call(message, "initiatePayment"))
                $root.response.InitiatePayment.encode(message.initiatePayment, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
            if (message.paymentResponse != null && Object.hasOwnProperty.call(message, "paymentResponse"))
                $root.response.PaymentResponse.encode(message.paymentResponse, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
            if (message.signIn != null && Object.hasOwnProperty.call(message, "signIn"))
                $root.response.SignIn.encode(message.signIn, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
            if (message.signOut != null && Object.hasOwnProperty.call(message, "signOut"))
                $root.response.SignOut.encode(message.signOut, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
            if (message.inviteUser != null && Object.hasOwnProperty.call(message, "inviteUser"))
                $root.response.InviteUser.encode(message.inviteUser, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
            if (message.getUser != null && Object.hasOwnProperty.call(message, "getUser"))
                $root.response.GetUser.encode(message.getUser, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
            if (message.listUsers != null && Object.hasOwnProperty.call(message, "listUsers"))
                $root.response.ListUsers.encode(message.listUsers, writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
            if (message.removeOrganization != null && Object.hasOwnProperty.call(message, "removeOrganization"))
                $root.response.RemoveOrganization.encode(message.removeOrganization, writer.uint32(/* id 14, wireType 2 =*/114).fork()).ldelim();
            if (message.verifyOrganization != null && Object.hasOwnProperty.call(message, "verifyOrganization"))
                $root.response.VerifyOrganization.encode(message.verifyOrganization, writer.uint32(/* id 15, wireType 2 =*/122).fork()).ldelim();
            if (message.getOrganization != null && Object.hasOwnProperty.call(message, "getOrganization"))
                $root.response.GetOrganization.encode(message.getOrganization, writer.uint32(/* id 16, wireType 2 =*/130).fork()).ldelim();
            if (message.addPin != null && Object.hasOwnProperty.call(message, "addPin"))
                $root.response.AddPin.encode(message.addPin, writer.uint32(/* id 17, wireType 2 =*/138).fork()).ldelim();
            if (message.echo != null && Object.hasOwnProperty.call(message, "echo"))
                $root.response.Echo.encode(message.echo, writer.uint32(/* id 18, wireType 2 =*/146).fork()).ldelim();
            if (message.getFileHead != null && Object.hasOwnProperty.call(message, "getFileHead"))
                $root.response.GetFileHead.encode(message.getFileHead, writer.uint32(/* id 19, wireType 2 =*/154).fork()).ldelim();
            if (message.getChunk != null && Object.hasOwnProperty.call(message, "getChunk"))
                $root.response.GetChunk.encode(message.getChunk, writer.uint32(/* id 22, wireType 2 =*/178).fork()).ldelim();
            if (message.startWrite != null && Object.hasOwnProperty.call(message, "startWrite"))
                $root.response.StartWrite.encode(message.startWrite, writer.uint32(/* id 23, wireType 2 =*/186).fork()).ldelim();
            if (message.putChunk != null && Object.hasOwnProperty.call(message, "putChunk"))
                $root.response.PutChunk.encode(message.putChunk, writer.uint32(/* id 24, wireType 2 =*/194).fork()).ldelim();
            if (message.finalizeWrite != null && Object.hasOwnProperty.call(message, "finalizeWrite"))
                $root.response.FinalizeWrite.encode(message.finalizeWrite, writer.uint32(/* id 25, wireType 2 =*/202).fork()).ldelim();
            if (message.listFiles != null && Object.hasOwnProperty.call(message, "listFiles"))
                $root.response.ListFiles.encode(message.listFiles, writer.uint32(/* id 26, wireType 2 =*/210).fork()).ldelim();
            if (message.remove != null && Object.hasOwnProperty.call(message, "remove"))
                $root.response.Remove.encode(message.remove, writer.uint32(/* id 27, wireType 2 =*/218).fork()).ldelim();
            if (message.fileLock != null && Object.hasOwnProperty.call(message, "fileLock"))
                $root.response.FileLock.encode(message.fileLock, writer.uint32(/* id 30, wireType 2 =*/242).fork()).ldelim();
            if (message.fileUnlock != null && Object.hasOwnProperty.call(message, "fileUnlock"))
                $root.response.FileUnlock.encode(message.fileUnlock, writer.uint32(/* id 31, wireType 2 =*/250).fork()).ldelim();
            if (message.getFolder != null && Object.hasOwnProperty.call(message, "getFolder"))
                $root.response.GetFolder.encode(message.getFolder, writer.uint32(/* id 32, wireType 2 =*/258).fork()).ldelim();
            if (message.createFolder != null && Object.hasOwnProperty.call(message, "createFolder"))
                $root.response.CreateFolder.encode(message.createFolder, writer.uint32(/* id 33, wireType 2 =*/266).fork()).ldelim();
            if (message.CreateSnapshot != null && Object.hasOwnProperty.call(message, "CreateSnapshot"))
                $root.response.CreateSnapshot.encode(message.CreateSnapshot, writer.uint32(/* id 34, wireType 2 =*/274).fork()).ldelim();
            if (message.verifyPayment != null && Object.hasOwnProperty.call(message, "verifyPayment"))
                $root.response.VerifyPayment.encode(message.verifyPayment, writer.uint32(/* id 35, wireType 2 =*/282).fork()).ldelim();
            if (message.getSecret != null && Object.hasOwnProperty.call(message, "getSecret"))
                $root.response.GetSecret.encode(message.getSecret, writer.uint32(/* id 36, wireType 2 =*/290).fork()).ldelim();
            if (message.addSecret != null && Object.hasOwnProperty.call(message, "addSecret"))
                $root.response.AddSecret.encode(message.addSecret, writer.uint32(/* id 37, wireType 2 =*/298).fork()).ldelim();
            if (message.deleteSecret != null && Object.hasOwnProperty.call(message, "deleteSecret"))
                $root.response.DeleteSecret.encode(message.deleteSecret, writer.uint32(/* id 38, wireType 2 =*/306).fork()).ldelim();
            if (message.updateSecret != null && Object.hasOwnProperty.call(message, "updateSecret"))
                $root.response.UpdateSecret.encode(message.updateSecret, writer.uint32(/* id 39, wireType 2 =*/314).fork()).ldelim();
            if (message.listSecrets != null && Object.hasOwnProperty.call(message, "listSecrets"))
                $root.response.ListSecrets.encode(message.listSecrets, writer.uint32(/* id 40, wireType 2 =*/322).fork()).ldelim();
            if (message.listSecretSubkeys != null && Object.hasOwnProperty.call(message, "listSecretSubkeys"))
                $root.response.ListSecretSubkeys.encode(message.listSecretSubkeys, writer.uint32(/* id 41, wireType 2 =*/330).fork()).ldelim();
            if (message.undeleteSecret != null && Object.hasOwnProperty.call(message, "undeleteSecret"))
                $root.response.UndeleteSecret.encode(message.undeleteSecret, writer.uint32(/* id 42, wireType 2 =*/338).fork()).ldelim();
            if (message.destroySecret != null && Object.hasOwnProperty.call(message, "destroySecret"))
                $root.response.DestroySecret.encode(message.destroySecret, writer.uint32(/* id 43, wireType 2 =*/346).fork()).ldelim();
            if (message.addRole != null && Object.hasOwnProperty.call(message, "addRole"))
                $root.response.AddRole.encode(message.addRole, writer.uint32(/* id 44, wireType 2 =*/354).fork()).ldelim();
            if (message.removeRole != null && Object.hasOwnProperty.call(message, "removeRole"))
                $root.response.RemoveRole.encode(message.removeRole, writer.uint32(/* id 45, wireType 2 =*/362).fork()).ldelim();
            if (message.updateRole != null && Object.hasOwnProperty.call(message, "updateRole"))
                $root.response.UpdateRole.encode(message.updateRole, writer.uint32(/* id 46, wireType 2 =*/370).fork()).ldelim();
            if (message.listRoles != null && Object.hasOwnProperty.call(message, "listRoles"))
                $root.response.ListRoles.encode(message.listRoles, writer.uint32(/* id 47, wireType 2 =*/378).fork()).ldelim();
            if (message.addTeam != null && Object.hasOwnProperty.call(message, "addTeam"))
                $root.response.AddTeam.encode(message.addTeam, writer.uint32(/* id 48, wireType 2 =*/386).fork()).ldelim();
            if (message.removeTeam != null && Object.hasOwnProperty.call(message, "removeTeam"))
                $root.response.RemoveTeam.encode(message.removeTeam, writer.uint32(/* id 49, wireType 2 =*/394).fork()).ldelim();
            if (message.updateTeam != null && Object.hasOwnProperty.call(message, "updateTeam"))
                $root.response.UpdateTeam.encode(message.updateTeam, writer.uint32(/* id 50, wireType 2 =*/402).fork()).ldelim();
            if (message.listTeams != null && Object.hasOwnProperty.call(message, "listTeams"))
                $root.response.ListTeams.encode(message.listTeams, writer.uint32(/* id 51, wireType 2 =*/410).fork()).ldelim();
            if (message.isOperationAllowed != null && Object.hasOwnProperty.call(message, "isOperationAllowed"))
                $root.response.IsOperationAllowed.encode(message.isOperationAllowed, writer.uint32(/* id 52, wireType 2 =*/418).fork()).ldelim();
            if (message.moveFile != null && Object.hasOwnProperty.call(message, "moveFile"))
                $root.response.MoveFile.encode(message.moveFile, writer.uint32(/* id 53, wireType 2 =*/426).fork()).ldelim();
            if (message.moveFolder != null && Object.hasOwnProperty.call(message, "moveFolder"))
                $root.response.MoveFolder.encode(message.moveFolder, writer.uint32(/* id 54, wireType 2 =*/434).fork()).ldelim();
            if (message.copyFile != null && Object.hasOwnProperty.call(message, "copyFile"))
                $root.response.CopyFile.encode(message.copyFile, writer.uint32(/* id 55, wireType 2 =*/442).fork()).ldelim();
            if (message.copyFolder != null && Object.hasOwnProperty.call(message, "copyFolder"))
                $root.response.CopyFolder.encode(message.copyFolder, writer.uint32(/* id 56, wireType 2 =*/450).fork()).ldelim();
            if (message.restoreVersion != null && Object.hasOwnProperty.call(message, "restoreVersion"))
                $root.response.RestoreVersion.encode(message.restoreVersion, writer.uint32(/* id 57, wireType 2 =*/458).fork()).ldelim();
            if (message.removeFile != null && Object.hasOwnProperty.call(message, "removeFile"))
                $root.response.RemoveFile.encode(message.removeFile, writer.uint32(/* id 58, wireType 2 =*/466).fork()).ldelim();
            if (message.removeFolder != null && Object.hasOwnProperty.call(message, "removeFolder"))
                $root.response.RemoveFolder.encode(message.removeFolder, writer.uint32(/* id 59, wireType 2 =*/474).fork()).ldelim();
            if (message.untrashFile != null && Object.hasOwnProperty.call(message, "untrashFile"))
                $root.response.UntrashFile.encode(message.untrashFile, writer.uint32(/* id 60, wireType 2 =*/482).fork()).ldelim();
            if (message.untrashFolder != null && Object.hasOwnProperty.call(message, "untrashFolder"))
                $root.response.UntrashFolder.encode(message.untrashFolder, writer.uint32(/* id 61, wireType 2 =*/490).fork()).ldelim();
            if (message.undoStartWrite != null && Object.hasOwnProperty.call(message, "undoStartWrite"))
                $root.response.UndoStartWrite.encode(message.undoStartWrite, writer.uint32(/* id 62, wireType 2 =*/498).fork()).ldelim();
            if (message.detachClonedFolder != null && Object.hasOwnProperty.call(message, "detachClonedFolder"))
                $root.response.DetachClonedFolder.encode(message.detachClonedFolder, writer.uint32(/* id 63, wireType 2 =*/506).fork()).ldelim();
            if (message.getMetaFromPath != null && Object.hasOwnProperty.call(message, "getMetaFromPath"))
                $root.response.GetMetaFromPath.encode(message.getMetaFromPath, writer.uint32(/* id 64, wireType 2 =*/514).fork()).ldelim();
            if (message.renameFile != null && Object.hasOwnProperty.call(message, "renameFile"))
                $root.response.RenameFile.encode(message.renameFile, writer.uint32(/* id 65, wireType 2 =*/522).fork()).ldelim();
            if (message.renameFolder != null && Object.hasOwnProperty.call(message, "renameFolder"))
                $root.response.RenameFolder.encode(message.renameFolder, writer.uint32(/* id 66, wireType 2 =*/530).fork()).ldelim();
            if (message.list != null && Object.hasOwnProperty.call(message, "list"))
                $root.response.List.encode(message.list, writer.uint32(/* id 67, wireType 2 =*/538).fork()).ldelim();
            if (message.auditLogMessage != null && Object.hasOwnProperty.call(message, "auditLogMessage"))
                $root.response.AuditLogMessage.encode(message.auditLogMessage, writer.uint32(/* id 68, wireType 2 =*/546).fork()).ldelim();
            if (message.resetVersion != null && Object.hasOwnProperty.call(message, "resetVersion"))
                $root.response.ResetVersion.encode(message.resetVersion, writer.uint32(/* id 69, wireType 2 =*/554).fork()).ldelim();
            if (message.setUser != null && Object.hasOwnProperty.call(message, "setUser"))
                $root.response.SetUser.encode(message.setUser, writer.uint32(/* id 70, wireType 2 =*/562).fork()).ldelim();
            if (message.finalizeProfileWrite != null && Object.hasOwnProperty.call(message, "finalizeProfileWrite"))
                $root.response.FinalizeProfileWrite.encode(message.finalizeProfileWrite, writer.uint32(/* id 71, wireType 2 =*/570).fork()).ldelim();
            if (message.getProfileFileMeta != null && Object.hasOwnProperty.call(message, "getProfileFileMeta"))
                $root.response.GetProfileFileMeta.encode(message.getProfileFileMeta, writer.uint32(/* id 72, wireType 2 =*/578).fork()).ldelim();
            if (message.profileChunkList != null && Object.hasOwnProperty.call(message, "profileChunkList"))
                $root.response.ProfileChunkList.encode(message.profileChunkList, writer.uint32(/* id 73, wireType 2 =*/586).fork()).ldelim();
            if (message.getUserType != null && Object.hasOwnProperty.call(message, "getUserType"))
                $root.response.GetUserType.encode(message.getUserType, writer.uint32(/* id 74, wireType 2 =*/594).fork()).ldelim();
            if (message.getRandomBytes != null && Object.hasOwnProperty.call(message, "getRandomBytes"))
                $root.response.GetRandomBytes.encode(message.getRandomBytes, writer.uint32(/* id 75, wireType 2 =*/602).fork()).ldelim();
            if (message.share != null && Object.hasOwnProperty.call(message, "share"))
                $root.response.Share.encode(message.share, writer.uint32(/* id 76, wireType 2 =*/610).fork()).ldelim();
            if (message.unshare != null && Object.hasOwnProperty.call(message, "unshare"))
                $root.response.Unshare.encode(message.unshare, writer.uint32(/* id 77, wireType 2 =*/618).fork()).ldelim();
            if (message.updateShare != null && Object.hasOwnProperty.call(message, "updateShare"))
                $root.response.UpdateShare.encode(message.updateShare, writer.uint32(/* id 78, wireType 2 =*/626).fork()).ldelim();
            if (message.listShares != null && Object.hasOwnProperty.call(message, "listShares"))
                $root.response.ListShares.encode(message.listShares, writer.uint32(/* id 79, wireType 2 =*/634).fork()).ldelim();
            if (message.getTeam != null && Object.hasOwnProperty.call(message, "getTeam"))
                $root.response.GetTeam.encode(message.getTeam, writer.uint32(/* id 80, wireType 2 =*/642).fork()).ldelim();
            if (message.getRole != null && Object.hasOwnProperty.call(message, "getRole"))
                $root.response.GetRole.encode(message.getRole, writer.uint32(/* id 81, wireType 2 =*/650).fork()).ldelim();
            if (message.resetTOTP != null && Object.hasOwnProperty.call(message, "resetTOTP"))
                $root.response.ResetTOTP.encode(message.resetTOTP, writer.uint32(/* id 82, wireType 2 =*/658).fork()).ldelim();
            if (message.quickListSecrets != null && Object.hasOwnProperty.call(message, "quickListSecrets"))
                $root.response.QuickListSecrets.encode(message.quickListSecrets, writer.uint32(/* id 83, wireType 2 =*/666).fork()).ldelim();
            if (message.setRolesTeamsToUser != null && Object.hasOwnProperty.call(message, "setRolesTeamsToUser"))
                $root.response.SetRolesTeamsToUser.encode(message.setRolesTeamsToUser, writer.uint32(/* id 86, wireType 2 =*/690).fork()).ldelim();
            if (message.updatePinOps != null && Object.hasOwnProperty.call(message, "updatePinOps"))
                $root.response.UpdatePinOps.encode(message.updatePinOps, writer.uint32(/* id 87, wireType 2 =*/698).fork()).ldelim();
            if (message.deletePin != null && Object.hasOwnProperty.call(message, "deletePin"))
                $root.response.DeletePin.encode(message.deletePin, writer.uint32(/* id 88, wireType 2 =*/706).fork()).ldelim();
            if (message.getRolesAndTeamsOfUser != null && Object.hasOwnProperty.call(message, "getRolesAndTeamsOfUser"))
                $root.response.GetRolesAndTeamsOfUser.encode(message.getRolesAndTeamsOfUser, writer.uint32(/* id 89, wireType 2 =*/714).fork()).ldelim();
            if (message.restartPutChunk != null && Object.hasOwnProperty.call(message, "restartPutChunk"))
                $root.response.RestartPutChunk.encode(message.restartPutChunk, writer.uint32(/* id 90, wireType 2 =*/722).fork()).ldelim();
            if (message.verifyAuditLogMeta != null && Object.hasOwnProperty.call(message, "verifyAuditLogMeta"))
                $root.response.VerifyAuditLogMeta.encode(message.verifyAuditLogMeta, writer.uint32(/* id 91, wireType 2 =*/730).fork()).ldelim();
            if (message.getAuditLog != null && Object.hasOwnProperty.call(message, "getAuditLog"))
                $root.response.GetAuditLog.encode(message.getAuditLog, writer.uint32(/* id 92, wireType 2 =*/738).fork()).ldelim();
            if (message.deleteAuditLog != null && Object.hasOwnProperty.call(message, "deleteAuditLog"))
                $root.response.DeleteAuditLog.encode(message.deleteAuditLog, writer.uint32(/* id 93, wireType 2 =*/746).fork()).ldelim();
            if (message.getLedgerRange != null && Object.hasOwnProperty.call(message, "getLedgerRange"))
                $root.response.GetLedgerRange.encode(message.getLedgerRange, writer.uint32(/* id 94, wireType 2 =*/754).fork()).ldelim();
            if (message.listPins != null && Object.hasOwnProperty.call(message, "listPins"))
                $root.response.ListPins.encode(message.listPins, writer.uint32(/* id 95, wireType 2 =*/762).fork()).ldelim();
            if (message.GetMetaFromSharedPath != null && Object.hasOwnProperty.call(message, "GetMetaFromSharedPath"))
                $root.response.GetMetaFromSharedPath.encode(message.GetMetaFromSharedPath, writer.uint32(/* id 96, wireType 2 =*/770).fork()).ldelim();
            if (message.listQuestions != null && Object.hasOwnProperty.call(message, "listQuestions"))
                $root.response.ListQuestions.encode(message.listQuestions, writer.uint32(/* id 97, wireType 2 =*/778).fork()).ldelim();
            if (message.verifyBYOSCreds != null && Object.hasOwnProperty.call(message, "verifyBYOSCreds"))
                $root.response.VerifyBYOSCreds.encode(message.verifyBYOSCreds, writer.uint32(/* id 98, wireType 2 =*/786).fork()).ldelim();
            if (message.MigrateToStorage != null && Object.hasOwnProperty.call(message, "MigrateToStorage"))
                $root.response.MigrateToStorage.encode(message.MigrateToStorage, writer.uint32(/* id 99, wireType 2 =*/794).fork()).ldelim();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 100, wireType 0 =*/800).uint64(message.id);
            if (message.updateStorageCreds != null && Object.hasOwnProperty.call(message, "updateStorageCreds"))
                $root.response.UpdateStorageCreds.encode(message.updateStorageCreds, writer.uint32(/* id 101, wireType 2 =*/810).fork()).ldelim();
            if (message.verifyUserForAudit != null && Object.hasOwnProperty.call(message, "verifyUserForAudit"))
                $root.response.VerifyUserForAudit.encode(message.verifyUserForAudit, writer.uint32(/* id 102, wireType 2 =*/818).fork()).ldelim();
            if (message.removeOrganizationUser != null && Object.hasOwnProperty.call(message, "removeOrganizationUser"))
                $root.response.RemoveOrganizationUser.encode(message.removeOrganizationUser, writer.uint32(/* id 103, wireType 2 =*/826).fork()).ldelim();
            if (message.addSpace != null && Object.hasOwnProperty.call(message, "addSpace"))
                $root.response.AddSpace.encode(message.addSpace, writer.uint32(/* id 104, wireType 2 =*/834).fork()).ldelim();
            if (message.addUserToSpace != null && Object.hasOwnProperty.call(message, "addUserToSpace"))
                $root.response.AddUserToSpace.encode(message.addUserToSpace, writer.uint32(/* id 105, wireType 2 =*/842).fork()).ldelim();
            if (message.removeUserFromSpace != null && Object.hasOwnProperty.call(message, "removeUserFromSpace"))
                $root.response.RemoveUserFromSpace.encode(message.removeUserFromSpace, writer.uint32(/* id 106, wireType 2 =*/850).fork()).ldelim();
            if (message.updatePermissionsOfSpace != null && Object.hasOwnProperty.call(message, "updatePermissionsOfSpace"))
                $root.response.UpdatePermissionsOfSpace.encode(message.updatePermissionsOfSpace, writer.uint32(/* id 107, wireType 2 =*/858).fork()).ldelim();
            if (message.addObjectToSpace != null && Object.hasOwnProperty.call(message, "addObjectToSpace"))
                $root.response.AddObjectToSpace.encode(message.addObjectToSpace, writer.uint32(/* id 108, wireType 2 =*/866).fork()).ldelim();
            if (message.removeObjectFromSpace != null && Object.hasOwnProperty.call(message, "removeObjectFromSpace"))
                $root.response.RemoveObjectFromSpace.encode(message.removeObjectFromSpace, writer.uint32(/* id 109, wireType 2 =*/874).fork()).ldelim();
            if (message.removeSpace != null && Object.hasOwnProperty.call(message, "removeSpace"))
                $root.response.RemoveSpace.encode(message.removeSpace, writer.uint32(/* id 110, wireType 2 =*/882).fork()).ldelim();
            if (message.sendOtpToExternalUser != null && Object.hasOwnProperty.call(message, "sendOtpToExternalUser"))
                $root.response.SendOtpToExternalUser.encode(message.sendOtpToExternalUser, writer.uint32(/* id 111, wireType 2 =*/890).fork()).ldelim();
            if (message.signInToSpace != null && Object.hasOwnProperty.call(message, "signInToSpace"))
                $root.response.SignInToSpace.encode(message.signInToSpace, writer.uint32(/* id 112, wireType 2 =*/898).fork()).ldelim();
            if (message.listSpaces != null && Object.hasOwnProperty.call(message, "listSpaces"))
                $root.response.ListSpaces.encode(message.listSpaces, writer.uint32(/* id 113, wireType 2 =*/906).fork()).ldelim();
            if (message.sendOtpToExternalUserIfNotExist != null && Object.hasOwnProperty.call(message, "sendOtpToExternalUserIfNotExist"))
                $root.response.SendOtpToExternalUserIfNotExist.encode(message.sendOtpToExternalUserIfNotExist, writer.uint32(/* id 114, wireType 2 =*/914).fork()).ldelim();
            if (message.getStorageValue != null && Object.hasOwnProperty.call(message, "getStorageValue"))
                $root.response.GetStorageValue.encode(message.getStorageValue, writer.uint32(/* id 115, wireType 2 =*/922).fork()).ldelim();
            if (message.updateTags != null && Object.hasOwnProperty.call(message, "updateTags"))
                $root.response.UpdateTags.encode(message.updateTags, writer.uint32(/* id 116, wireType 2 =*/930).fork()).ldelim();
            if (message.addComment != null && Object.hasOwnProperty.call(message, "addComment"))
                $root.response.AddComment.encode(message.addComment, writer.uint32(/* id 117, wireType 2 =*/938).fork()).ldelim();
            if (message.removeComment != null && Object.hasOwnProperty.call(message, "removeComment"))
                $root.response.RemoveComment.encode(message.removeComment, writer.uint32(/* id 118, wireType 2 =*/946).fork()).ldelim();
            if (message.listComments != null && Object.hasOwnProperty.call(message, "listComments"))
                $root.response.ListComments.encode(message.listComments, writer.uint32(/* id 119, wireType 2 =*/954).fork()).ldelim();
            if (message.updateComment != null && Object.hasOwnProperty.call(message, "updateComment"))
                $root.response.UpdateComment.encode(message.updateComment, writer.uint32(/* id 120, wireType 2 =*/962).fork()).ldelim();
            if (message.getComment != null && Object.hasOwnProperty.call(message, "getComment"))
                $root.response.GetComment.encode(message.getComment, writer.uint32(/* id 121, wireType 2 =*/970).fork()).ldelim();
            if (message.sessionData != null && Object.hasOwnProperty.call(message, "sessionData"))
                $root.response.SessionData.encode(message.sessionData, writer.uint32(/* id 122, wireType 2 =*/978).fork()).ldelim();
            if (message.getStorageCreds != null && Object.hasOwnProperty.call(message, "getStorageCreds"))
                $root.response.GetStorageCreds.encode(message.getStorageCreds, writer.uint32(/* id 123, wireType 2 =*/986).fork()).ldelim();
            if (message.listPlans != null && Object.hasOwnProperty.call(message, "listPlans"))
                $root.response.ListPlans.encode(message.listPlans, writer.uint32(/* id 124, wireType 2 =*/994).fork()).ldelim();
            if (message.upgradePlan != null && Object.hasOwnProperty.call(message, "upgradePlan"))
                $root.response.UpgradePlan.encode(message.upgradePlan, writer.uint32(/* id 125, wireType 2 =*/1002).fork()).ldelim();
            if (message.validateCoupon != null && Object.hasOwnProperty.call(message, "validateCoupon"))
                $root.response.ValidateCoupon.encode(message.validateCoupon, writer.uint32(/* id 126, wireType 2 =*/1010).fork()).ldelim();
            if (message.getPlan != null && Object.hasOwnProperty.call(message, "getPlan"))
                $root.response.GetPlan.encode(message.getPlan, writer.uint32(/* id 127, wireType 2 =*/1018).fork()).ldelim();
            if (message.removeVersion != null && Object.hasOwnProperty.call(message, "removeVersion"))
                $root.response.RemoveVersion.encode(message.removeVersion, writer.uint32(/* id 128, wireType 2 =*/1026).fork()).ldelim();
            if (message.getProfilePictureOfUser != null && Object.hasOwnProperty.call(message, "getProfilePictureOfUser"))
                $root.response.GetProfilePictureOfUser.encode(message.getProfilePictureOfUser, writer.uint32(/* id 129, wireType 2 =*/1034).fork()).ldelim();
            if (message.emptyTrash != null && Object.hasOwnProperty.call(message, "emptyTrash"))
                $root.response.EmptyTrash.encode(message.emptyTrash, writer.uint32(/* id 130, wireType 2 =*/1042).fork()).ldelim();
            if (message.setThumbnail != null && Object.hasOwnProperty.call(message, "setThumbnail"))
                $root.response.SetThumbnail.encode(message.setThumbnail, writer.uint32(/* id 131, wireType 2 =*/1050).fork()).ldelim();
            if (message.getThumbnail != null && Object.hasOwnProperty.call(message, "getThumbnail"))
                $root.response.GetThumbnail.encode(message.getThumbnail, writer.uint32(/* id 132, wireType 2 =*/1058).fork()).ldelim();
            if (message.blockUser != null && Object.hasOwnProperty.call(message, "blockUser"))
                $root.response.BlockUser.encode(message.blockUser, writer.uint32(/* id 133, wireType 2 =*/1066).fork()).ldelim();
            if (message.unblockUser != null && Object.hasOwnProperty.call(message, "unblockUser"))
                $root.response.UnblockUser.encode(message.unblockUser, writer.uint32(/* id 134, wireType 2 =*/1074).fork()).ldelim();
            if (message.updateOrgSettings != null && Object.hasOwnProperty.call(message, "updateOrgSettings"))
                $root.response.UpdateOrgSettings.encode(message.updateOrgSettings, writer.uint32(/* id 135, wireType 2 =*/1082).fork()).ldelim();
            if (message.getOrgSettings != null && Object.hasOwnProperty.call(message, "getOrgSettings"))
                $root.response.GetOrgSettings.encode(message.getOrgSettings, writer.uint32(/* id 136, wireType 2 =*/1090).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified Response message, length delimited. Does not implicitly {@link response.Response.verify|verify} messages.
         * @function encodeDelimited
         * @memberof response.Response
         * @static
         * @param {response.IResponse} message Response message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Response.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Response message from the specified reader or buffer.
         * @function decode
         * @memberof response.Response
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {response.Response} Response
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Response.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.response.Response();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 100: {
                        message.id = reader.uint64();
                        break;
                    }
                case 1: {
                        message.addUser = $root.response.AddUser.decode(reader, reader.uint32());
                        break;
                    }
                case 2: {
                        message.verifyUser = $root.response.VerifyUser.decode(reader, reader.uint32());
                        break;
                    }
                case 3: {
                        message.removeUser = $root.response.RemoveUser.decode(reader, reader.uint32());
                        break;
                    }
                case 4: {
                        message.passwordReset = $root.response.PasswordReset.decode(reader, reader.uint32());
                        break;
                    }
                case 5: {
                        message.changePassword = $root.response.ChangePassword.decode(reader, reader.uint32());
                        break;
                    }
                case 6: {
                        message.addOrganization = $root.response.AddOrganization.decode(reader, reader.uint32());
                        break;
                    }
                case 7: {
                        message.initiatePayment = $root.response.InitiatePayment.decode(reader, reader.uint32());
                        break;
                    }
                case 8: {
                        message.paymentResponse = $root.response.PaymentResponse.decode(reader, reader.uint32());
                        break;
                    }
                case 9: {
                        message.signIn = $root.response.SignIn.decode(reader, reader.uint32());
                        break;
                    }
                case 10: {
                        message.signOut = $root.response.SignOut.decode(reader, reader.uint32());
                        break;
                    }
                case 11: {
                        message.inviteUser = $root.response.InviteUser.decode(reader, reader.uint32());
                        break;
                    }
                case 12: {
                        message.getUser = $root.response.GetUser.decode(reader, reader.uint32());
                        break;
                    }
                case 13: {
                        message.listUsers = $root.response.ListUsers.decode(reader, reader.uint32());
                        break;
                    }
                case 14: {
                        message.removeOrganization = $root.response.RemoveOrganization.decode(reader, reader.uint32());
                        break;
                    }
                case 15: {
                        message.verifyOrganization = $root.response.VerifyOrganization.decode(reader, reader.uint32());
                        break;
                    }
                case 16: {
                        message.getOrganization = $root.response.GetOrganization.decode(reader, reader.uint32());
                        break;
                    }
                case 17: {
                        message.addPin = $root.response.AddPin.decode(reader, reader.uint32());
                        break;
                    }
                case 18: {
                        message.echo = $root.response.Echo.decode(reader, reader.uint32());
                        break;
                    }
                case 19: {
                        message.getFileHead = $root.response.GetFileHead.decode(reader, reader.uint32());
                        break;
                    }
                case 22: {
                        message.getChunk = $root.response.GetChunk.decode(reader, reader.uint32());
                        break;
                    }
                case 23: {
                        message.startWrite = $root.response.StartWrite.decode(reader, reader.uint32());
                        break;
                    }
                case 24: {
                        message.putChunk = $root.response.PutChunk.decode(reader, reader.uint32());
                        break;
                    }
                case 25: {
                        message.finalizeWrite = $root.response.FinalizeWrite.decode(reader, reader.uint32());
                        break;
                    }
                case 26: {
                        message.listFiles = $root.response.ListFiles.decode(reader, reader.uint32());
                        break;
                    }
                case 27: {
                        message.remove = $root.response.Remove.decode(reader, reader.uint32());
                        break;
                    }
                case 30: {
                        message.fileLock = $root.response.FileLock.decode(reader, reader.uint32());
                        break;
                    }
                case 31: {
                        message.fileUnlock = $root.response.FileUnlock.decode(reader, reader.uint32());
                        break;
                    }
                case 32: {
                        message.getFolder = $root.response.GetFolder.decode(reader, reader.uint32());
                        break;
                    }
                case 33: {
                        message.createFolder = $root.response.CreateFolder.decode(reader, reader.uint32());
                        break;
                    }
                case 34: {
                        message.CreateSnapshot = $root.response.CreateSnapshot.decode(reader, reader.uint32());
                        break;
                    }
                case 35: {
                        message.verifyPayment = $root.response.VerifyPayment.decode(reader, reader.uint32());
                        break;
                    }
                case 36: {
                        message.getSecret = $root.response.GetSecret.decode(reader, reader.uint32());
                        break;
                    }
                case 37: {
                        message.addSecret = $root.response.AddSecret.decode(reader, reader.uint32());
                        break;
                    }
                case 38: {
                        message.deleteSecret = $root.response.DeleteSecret.decode(reader, reader.uint32());
                        break;
                    }
                case 39: {
                        message.updateSecret = $root.response.UpdateSecret.decode(reader, reader.uint32());
                        break;
                    }
                case 40: {
                        message.listSecrets = $root.response.ListSecrets.decode(reader, reader.uint32());
                        break;
                    }
                case 41: {
                        message.listSecretSubkeys = $root.response.ListSecretSubkeys.decode(reader, reader.uint32());
                        break;
                    }
                case 83: {
                        message.quickListSecrets = $root.response.QuickListSecrets.decode(reader, reader.uint32());
                        break;
                    }
                case 42: {
                        message.undeleteSecret = $root.response.UndeleteSecret.decode(reader, reader.uint32());
                        break;
                    }
                case 43: {
                        message.destroySecret = $root.response.DestroySecret.decode(reader, reader.uint32());
                        break;
                    }
                case 44: {
                        message.addRole = $root.response.AddRole.decode(reader, reader.uint32());
                        break;
                    }
                case 45: {
                        message.removeRole = $root.response.RemoveRole.decode(reader, reader.uint32());
                        break;
                    }
                case 46: {
                        message.updateRole = $root.response.UpdateRole.decode(reader, reader.uint32());
                        break;
                    }
                case 47: {
                        message.listRoles = $root.response.ListRoles.decode(reader, reader.uint32());
                        break;
                    }
                case 81: {
                        message.getRole = $root.response.GetRole.decode(reader, reader.uint32());
                        break;
                    }
                case 48: {
                        message.addTeam = $root.response.AddTeam.decode(reader, reader.uint32());
                        break;
                    }
                case 49: {
                        message.removeTeam = $root.response.RemoveTeam.decode(reader, reader.uint32());
                        break;
                    }
                case 50: {
                        message.updateTeam = $root.response.UpdateTeam.decode(reader, reader.uint32());
                        break;
                    }
                case 51: {
                        message.listTeams = $root.response.ListTeams.decode(reader, reader.uint32());
                        break;
                    }
                case 80: {
                        message.getTeam = $root.response.GetTeam.decode(reader, reader.uint32());
                        break;
                    }
                case 52: {
                        message.isOperationAllowed = $root.response.IsOperationAllowed.decode(reader, reader.uint32());
                        break;
                    }
                case 53: {
                        message.moveFile = $root.response.MoveFile.decode(reader, reader.uint32());
                        break;
                    }
                case 54: {
                        message.moveFolder = $root.response.MoveFolder.decode(reader, reader.uint32());
                        break;
                    }
                case 55: {
                        message.copyFile = $root.response.CopyFile.decode(reader, reader.uint32());
                        break;
                    }
                case 56: {
                        message.copyFolder = $root.response.CopyFolder.decode(reader, reader.uint32());
                        break;
                    }
                case 57: {
                        message.restoreVersion = $root.response.RestoreVersion.decode(reader, reader.uint32());
                        break;
                    }
                case 58: {
                        message.removeFile = $root.response.RemoveFile.decode(reader, reader.uint32());
                        break;
                    }
                case 59: {
                        message.removeFolder = $root.response.RemoveFolder.decode(reader, reader.uint32());
                        break;
                    }
                case 60: {
                        message.untrashFile = $root.response.UntrashFile.decode(reader, reader.uint32());
                        break;
                    }
                case 61: {
                        message.untrashFolder = $root.response.UntrashFolder.decode(reader, reader.uint32());
                        break;
                    }
                case 62: {
                        message.undoStartWrite = $root.response.UndoStartWrite.decode(reader, reader.uint32());
                        break;
                    }
                case 63: {
                        message.detachClonedFolder = $root.response.DetachClonedFolder.decode(reader, reader.uint32());
                        break;
                    }
                case 64: {
                        message.getMetaFromPath = $root.response.GetMetaFromPath.decode(reader, reader.uint32());
                        break;
                    }
                case 65: {
                        message.renameFile = $root.response.RenameFile.decode(reader, reader.uint32());
                        break;
                    }
                case 66: {
                        message.renameFolder = $root.response.RenameFolder.decode(reader, reader.uint32());
                        break;
                    }
                case 67: {
                        message.list = $root.response.List.decode(reader, reader.uint32());
                        break;
                    }
                case 68: {
                        message.auditLogMessage = $root.response.AuditLogMessage.decode(reader, reader.uint32());
                        break;
                    }
                case 69: {
                        message.resetVersion = $root.response.ResetVersion.decode(reader, reader.uint32());
                        break;
                    }
                case 70: {
                        message.setUser = $root.response.SetUser.decode(reader, reader.uint32());
                        break;
                    }
                case 71: {
                        message.finalizeProfileWrite = $root.response.FinalizeProfileWrite.decode(reader, reader.uint32());
                        break;
                    }
                case 72: {
                        message.getProfileFileMeta = $root.response.GetProfileFileMeta.decode(reader, reader.uint32());
                        break;
                    }
                case 73: {
                        message.profileChunkList = $root.response.ProfileChunkList.decode(reader, reader.uint32());
                        break;
                    }
                case 74: {
                        message.getUserType = $root.response.GetUserType.decode(reader, reader.uint32());
                        break;
                    }
                case 75: {
                        message.getRandomBytes = $root.response.GetRandomBytes.decode(reader, reader.uint32());
                        break;
                    }
                case 76: {
                        message.share = $root.response.Share.decode(reader, reader.uint32());
                        break;
                    }
                case 77: {
                        message.unshare = $root.response.Unshare.decode(reader, reader.uint32());
                        break;
                    }
                case 78: {
                        message.updateShare = $root.response.UpdateShare.decode(reader, reader.uint32());
                        break;
                    }
                case 79: {
                        message.listShares = $root.response.ListShares.decode(reader, reader.uint32());
                        break;
                    }
                case 82: {
                        message.resetTOTP = $root.response.ResetTOTP.decode(reader, reader.uint32());
                        break;
                    }
                case 86: {
                        message.setRolesTeamsToUser = $root.response.SetRolesTeamsToUser.decode(reader, reader.uint32());
                        break;
                    }
                case 87: {
                        message.updatePinOps = $root.response.UpdatePinOps.decode(reader, reader.uint32());
                        break;
                    }
                case 88: {
                        message.deletePin = $root.response.DeletePin.decode(reader, reader.uint32());
                        break;
                    }
                case 89: {
                        message.getRolesAndTeamsOfUser = $root.response.GetRolesAndTeamsOfUser.decode(reader, reader.uint32());
                        break;
                    }
                case 90: {
                        message.restartPutChunk = $root.response.RestartPutChunk.decode(reader, reader.uint32());
                        break;
                    }
                case 91: {
                        message.verifyAuditLogMeta = $root.response.VerifyAuditLogMeta.decode(reader, reader.uint32());
                        break;
                    }
                case 92: {
                        message.getAuditLog = $root.response.GetAuditLog.decode(reader, reader.uint32());
                        break;
                    }
                case 93: {
                        message.deleteAuditLog = $root.response.DeleteAuditLog.decode(reader, reader.uint32());
                        break;
                    }
                case 94: {
                        message.getLedgerRange = $root.response.GetLedgerRange.decode(reader, reader.uint32());
                        break;
                    }
                case 95: {
                        message.listPins = $root.response.ListPins.decode(reader, reader.uint32());
                        break;
                    }
                case 96: {
                        message.GetMetaFromSharedPath = $root.response.GetMetaFromSharedPath.decode(reader, reader.uint32());
                        break;
                    }
                case 97: {
                        message.listQuestions = $root.response.ListQuestions.decode(reader, reader.uint32());
                        break;
                    }
                case 98: {
                        message.verifyBYOSCreds = $root.response.VerifyBYOSCreds.decode(reader, reader.uint32());
                        break;
                    }
                case 99: {
                        message.MigrateToStorage = $root.response.MigrateToStorage.decode(reader, reader.uint32());
                        break;
                    }
                case 101: {
                        message.updateStorageCreds = $root.response.UpdateStorageCreds.decode(reader, reader.uint32());
                        break;
                    }
                case 102: {
                        message.verifyUserForAudit = $root.response.VerifyUserForAudit.decode(reader, reader.uint32());
                        break;
                    }
                case 103: {
                        message.removeOrganizationUser = $root.response.RemoveOrganizationUser.decode(reader, reader.uint32());
                        break;
                    }
                case 104: {
                        message.addSpace = $root.response.AddSpace.decode(reader, reader.uint32());
                        break;
                    }
                case 105: {
                        message.addUserToSpace = $root.response.AddUserToSpace.decode(reader, reader.uint32());
                        break;
                    }
                case 106: {
                        message.removeUserFromSpace = $root.response.RemoveUserFromSpace.decode(reader, reader.uint32());
                        break;
                    }
                case 107: {
                        message.updatePermissionsOfSpace = $root.response.UpdatePermissionsOfSpace.decode(reader, reader.uint32());
                        break;
                    }
                case 108: {
                        message.addObjectToSpace = $root.response.AddObjectToSpace.decode(reader, reader.uint32());
                        break;
                    }
                case 109: {
                        message.removeObjectFromSpace = $root.response.RemoveObjectFromSpace.decode(reader, reader.uint32());
                        break;
                    }
                case 110: {
                        message.removeSpace = $root.response.RemoveSpace.decode(reader, reader.uint32());
                        break;
                    }
                case 111: {
                        message.sendOtpToExternalUser = $root.response.SendOtpToExternalUser.decode(reader, reader.uint32());
                        break;
                    }
                case 112: {
                        message.signInToSpace = $root.response.SignInToSpace.decode(reader, reader.uint32());
                        break;
                    }
                case 113: {
                        message.listSpaces = $root.response.ListSpaces.decode(reader, reader.uint32());
                        break;
                    }
                case 114: {
                        message.sendOtpToExternalUserIfNotExist = $root.response.SendOtpToExternalUserIfNotExist.decode(reader, reader.uint32());
                        break;
                    }
                case 115: {
                        message.getStorageValue = $root.response.GetStorageValue.decode(reader, reader.uint32());
                        break;
                    }
                case 116: {
                        message.updateTags = $root.response.UpdateTags.decode(reader, reader.uint32());
                        break;
                    }
                case 117: {
                        message.addComment = $root.response.AddComment.decode(reader, reader.uint32());
                        break;
                    }
                case 118: {
                        message.removeComment = $root.response.RemoveComment.decode(reader, reader.uint32());
                        break;
                    }
                case 119: {
                        message.listComments = $root.response.ListComments.decode(reader, reader.uint32());
                        break;
                    }
                case 120: {
                        message.updateComment = $root.response.UpdateComment.decode(reader, reader.uint32());
                        break;
                    }
                case 121: {
                        message.getComment = $root.response.GetComment.decode(reader, reader.uint32());
                        break;
                    }
                case 122: {
                        message.sessionData = $root.response.SessionData.decode(reader, reader.uint32());
                        break;
                    }
                case 123: {
                        message.getStorageCreds = $root.response.GetStorageCreds.decode(reader, reader.uint32());
                        break;
                    }
                case 127: {
                        message.getPlan = $root.response.GetPlan.decode(reader, reader.uint32());
                        break;
                    }
                case 124: {
                        message.listPlans = $root.response.ListPlans.decode(reader, reader.uint32());
                        break;
                    }
                case 125: {
                        message.upgradePlan = $root.response.UpgradePlan.decode(reader, reader.uint32());
                        break;
                    }
                case 126: {
                        message.validateCoupon = $root.response.ValidateCoupon.decode(reader, reader.uint32());
                        break;
                    }
                case 128: {
                        message.removeVersion = $root.response.RemoveVersion.decode(reader, reader.uint32());
                        break;
                    }
                case 129: {
                        message.getProfilePictureOfUser = $root.response.GetProfilePictureOfUser.decode(reader, reader.uint32());
                        break;
                    }
                case 130: {
                        message.emptyTrash = $root.response.EmptyTrash.decode(reader, reader.uint32());
                        break;
                    }
                case 131: {
                        message.setThumbnail = $root.response.SetThumbnail.decode(reader, reader.uint32());
                        break;
                    }
                case 132: {
                        message.getThumbnail = $root.response.GetThumbnail.decode(reader, reader.uint32());
                        break;
                    }
                case 133: {
                        message.blockUser = $root.response.BlockUser.decode(reader, reader.uint32());
                        break;
                    }
                case 134: {
                        message.unblockUser = $root.response.UnblockUser.decode(reader, reader.uint32());
                        break;
                    }
                case 135: {
                        message.updateOrgSettings = $root.response.UpdateOrgSettings.decode(reader, reader.uint32());
                        break;
                    }
                case 136: {
                        message.getOrgSettings = $root.response.GetOrgSettings.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Response message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof response.Response
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {response.Response} Response
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Response.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Response message.
         * @function verify
         * @memberof response.Response
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Response.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.id != null && message.hasOwnProperty("id")) {
                properties._id = 1;
                if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                    return "id: integer|Long expected";
            }
            if (message.addUser != null && message.hasOwnProperty("addUser")) {
                properties.Operation = 1;
                {
                    let error = $root.response.AddUser.verify(message.addUser);
                    if (error)
                        return "addUser." + error;
                }
            }
            if (message.verifyUser != null && message.hasOwnProperty("verifyUser")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.VerifyUser.verify(message.verifyUser);
                    if (error)
                        return "verifyUser." + error;
                }
            }
            if (message.removeUser != null && message.hasOwnProperty("removeUser")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.RemoveUser.verify(message.removeUser);
                    if (error)
                        return "removeUser." + error;
                }
            }
            if (message.passwordReset != null && message.hasOwnProperty("passwordReset")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.PasswordReset.verify(message.passwordReset);
                    if (error)
                        return "passwordReset." + error;
                }
            }
            if (message.changePassword != null && message.hasOwnProperty("changePassword")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.ChangePassword.verify(message.changePassword);
                    if (error)
                        return "changePassword." + error;
                }
            }
            if (message.addOrganization != null && message.hasOwnProperty("addOrganization")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.AddOrganization.verify(message.addOrganization);
                    if (error)
                        return "addOrganization." + error;
                }
            }
            if (message.initiatePayment != null && message.hasOwnProperty("initiatePayment")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.InitiatePayment.verify(message.initiatePayment);
                    if (error)
                        return "initiatePayment." + error;
                }
            }
            if (message.paymentResponse != null && message.hasOwnProperty("paymentResponse")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.PaymentResponse.verify(message.paymentResponse);
                    if (error)
                        return "paymentResponse." + error;
                }
            }
            if (message.signIn != null && message.hasOwnProperty("signIn")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.SignIn.verify(message.signIn);
                    if (error)
                        return "signIn." + error;
                }
            }
            if (message.signOut != null && message.hasOwnProperty("signOut")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.SignOut.verify(message.signOut);
                    if (error)
                        return "signOut." + error;
                }
            }
            if (message.inviteUser != null && message.hasOwnProperty("inviteUser")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.InviteUser.verify(message.inviteUser);
                    if (error)
                        return "inviteUser." + error;
                }
            }
            if (message.getUser != null && message.hasOwnProperty("getUser")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.GetUser.verify(message.getUser);
                    if (error)
                        return "getUser." + error;
                }
            }
            if (message.listUsers != null && message.hasOwnProperty("listUsers")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.ListUsers.verify(message.listUsers);
                    if (error)
                        return "listUsers." + error;
                }
            }
            if (message.removeOrganization != null && message.hasOwnProperty("removeOrganization")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.RemoveOrganization.verify(message.removeOrganization);
                    if (error)
                        return "removeOrganization." + error;
                }
            }
            if (message.verifyOrganization != null && message.hasOwnProperty("verifyOrganization")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.VerifyOrganization.verify(message.verifyOrganization);
                    if (error)
                        return "verifyOrganization." + error;
                }
            }
            if (message.getOrganization != null && message.hasOwnProperty("getOrganization")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.GetOrganization.verify(message.getOrganization);
                    if (error)
                        return "getOrganization." + error;
                }
            }
            if (message.addPin != null && message.hasOwnProperty("addPin")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.AddPin.verify(message.addPin);
                    if (error)
                        return "addPin." + error;
                }
            }
            if (message.echo != null && message.hasOwnProperty("echo")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.Echo.verify(message.echo);
                    if (error)
                        return "echo." + error;
                }
            }
            if (message.getFileHead != null && message.hasOwnProperty("getFileHead")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.GetFileHead.verify(message.getFileHead);
                    if (error)
                        return "getFileHead." + error;
                }
            }
            if (message.getChunk != null && message.hasOwnProperty("getChunk")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.GetChunk.verify(message.getChunk);
                    if (error)
                        return "getChunk." + error;
                }
            }
            if (message.startWrite != null && message.hasOwnProperty("startWrite")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.StartWrite.verify(message.startWrite);
                    if (error)
                        return "startWrite." + error;
                }
            }
            if (message.putChunk != null && message.hasOwnProperty("putChunk")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.PutChunk.verify(message.putChunk);
                    if (error)
                        return "putChunk." + error;
                }
            }
            if (message.finalizeWrite != null && message.hasOwnProperty("finalizeWrite")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.FinalizeWrite.verify(message.finalizeWrite);
                    if (error)
                        return "finalizeWrite." + error;
                }
            }
            if (message.listFiles != null && message.hasOwnProperty("listFiles")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.ListFiles.verify(message.listFiles);
                    if (error)
                        return "listFiles." + error;
                }
            }
            if (message.remove != null && message.hasOwnProperty("remove")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.Remove.verify(message.remove);
                    if (error)
                        return "remove." + error;
                }
            }
            if (message.fileLock != null && message.hasOwnProperty("fileLock")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.FileLock.verify(message.fileLock);
                    if (error)
                        return "fileLock." + error;
                }
            }
            if (message.fileUnlock != null && message.hasOwnProperty("fileUnlock")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.FileUnlock.verify(message.fileUnlock);
                    if (error)
                        return "fileUnlock." + error;
                }
            }
            if (message.getFolder != null && message.hasOwnProperty("getFolder")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.GetFolder.verify(message.getFolder);
                    if (error)
                        return "getFolder." + error;
                }
            }
            if (message.createFolder != null && message.hasOwnProperty("createFolder")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.CreateFolder.verify(message.createFolder);
                    if (error)
                        return "createFolder." + error;
                }
            }
            if (message.CreateSnapshot != null && message.hasOwnProperty("CreateSnapshot")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.CreateSnapshot.verify(message.CreateSnapshot);
                    if (error)
                        return "CreateSnapshot." + error;
                }
            }
            if (message.verifyPayment != null && message.hasOwnProperty("verifyPayment")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.VerifyPayment.verify(message.verifyPayment);
                    if (error)
                        return "verifyPayment." + error;
                }
            }
            if (message.getSecret != null && message.hasOwnProperty("getSecret")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.GetSecret.verify(message.getSecret);
                    if (error)
                        return "getSecret." + error;
                }
            }
            if (message.addSecret != null && message.hasOwnProperty("addSecret")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.AddSecret.verify(message.addSecret);
                    if (error)
                        return "addSecret." + error;
                }
            }
            if (message.deleteSecret != null && message.hasOwnProperty("deleteSecret")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.DeleteSecret.verify(message.deleteSecret);
                    if (error)
                        return "deleteSecret." + error;
                }
            }
            if (message.updateSecret != null && message.hasOwnProperty("updateSecret")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.UpdateSecret.verify(message.updateSecret);
                    if (error)
                        return "updateSecret." + error;
                }
            }
            if (message.listSecrets != null && message.hasOwnProperty("listSecrets")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.ListSecrets.verify(message.listSecrets);
                    if (error)
                        return "listSecrets." + error;
                }
            }
            if (message.listSecretSubkeys != null && message.hasOwnProperty("listSecretSubkeys")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.ListSecretSubkeys.verify(message.listSecretSubkeys);
                    if (error)
                        return "listSecretSubkeys." + error;
                }
            }
            if (message.quickListSecrets != null && message.hasOwnProperty("quickListSecrets")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.QuickListSecrets.verify(message.quickListSecrets);
                    if (error)
                        return "quickListSecrets." + error;
                }
            }
            if (message.undeleteSecret != null && message.hasOwnProperty("undeleteSecret")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.UndeleteSecret.verify(message.undeleteSecret);
                    if (error)
                        return "undeleteSecret." + error;
                }
            }
            if (message.destroySecret != null && message.hasOwnProperty("destroySecret")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.DestroySecret.verify(message.destroySecret);
                    if (error)
                        return "destroySecret." + error;
                }
            }
            if (message.addRole != null && message.hasOwnProperty("addRole")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.AddRole.verify(message.addRole);
                    if (error)
                        return "addRole." + error;
                }
            }
            if (message.removeRole != null && message.hasOwnProperty("removeRole")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.RemoveRole.verify(message.removeRole);
                    if (error)
                        return "removeRole." + error;
                }
            }
            if (message.updateRole != null && message.hasOwnProperty("updateRole")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.UpdateRole.verify(message.updateRole);
                    if (error)
                        return "updateRole." + error;
                }
            }
            if (message.listRoles != null && message.hasOwnProperty("listRoles")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.ListRoles.verify(message.listRoles);
                    if (error)
                        return "listRoles." + error;
                }
            }
            if (message.getRole != null && message.hasOwnProperty("getRole")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.GetRole.verify(message.getRole);
                    if (error)
                        return "getRole." + error;
                }
            }
            if (message.addTeam != null && message.hasOwnProperty("addTeam")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.AddTeam.verify(message.addTeam);
                    if (error)
                        return "addTeam." + error;
                }
            }
            if (message.removeTeam != null && message.hasOwnProperty("removeTeam")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.RemoveTeam.verify(message.removeTeam);
                    if (error)
                        return "removeTeam." + error;
                }
            }
            if (message.updateTeam != null && message.hasOwnProperty("updateTeam")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.UpdateTeam.verify(message.updateTeam);
                    if (error)
                        return "updateTeam." + error;
                }
            }
            if (message.listTeams != null && message.hasOwnProperty("listTeams")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.ListTeams.verify(message.listTeams);
                    if (error)
                        return "listTeams." + error;
                }
            }
            if (message.getTeam != null && message.hasOwnProperty("getTeam")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.GetTeam.verify(message.getTeam);
                    if (error)
                        return "getTeam." + error;
                }
            }
            if (message.isOperationAllowed != null && message.hasOwnProperty("isOperationAllowed")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.IsOperationAllowed.verify(message.isOperationAllowed);
                    if (error)
                        return "isOperationAllowed." + error;
                }
            }
            if (message.moveFile != null && message.hasOwnProperty("moveFile")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.MoveFile.verify(message.moveFile);
                    if (error)
                        return "moveFile." + error;
                }
            }
            if (message.moveFolder != null && message.hasOwnProperty("moveFolder")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.MoveFolder.verify(message.moveFolder);
                    if (error)
                        return "moveFolder." + error;
                }
            }
            if (message.copyFile != null && message.hasOwnProperty("copyFile")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.CopyFile.verify(message.copyFile);
                    if (error)
                        return "copyFile." + error;
                }
            }
            if (message.copyFolder != null && message.hasOwnProperty("copyFolder")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.CopyFolder.verify(message.copyFolder);
                    if (error)
                        return "copyFolder." + error;
                }
            }
            if (message.restoreVersion != null && message.hasOwnProperty("restoreVersion")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.RestoreVersion.verify(message.restoreVersion);
                    if (error)
                        return "restoreVersion." + error;
                }
            }
            if (message.removeFile != null && message.hasOwnProperty("removeFile")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.RemoveFile.verify(message.removeFile);
                    if (error)
                        return "removeFile." + error;
                }
            }
            if (message.removeFolder != null && message.hasOwnProperty("removeFolder")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.RemoveFolder.verify(message.removeFolder);
                    if (error)
                        return "removeFolder." + error;
                }
            }
            if (message.untrashFile != null && message.hasOwnProperty("untrashFile")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.UntrashFile.verify(message.untrashFile);
                    if (error)
                        return "untrashFile." + error;
                }
            }
            if (message.untrashFolder != null && message.hasOwnProperty("untrashFolder")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.UntrashFolder.verify(message.untrashFolder);
                    if (error)
                        return "untrashFolder." + error;
                }
            }
            if (message.undoStartWrite != null && message.hasOwnProperty("undoStartWrite")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.UndoStartWrite.verify(message.undoStartWrite);
                    if (error)
                        return "undoStartWrite." + error;
                }
            }
            if (message.detachClonedFolder != null && message.hasOwnProperty("detachClonedFolder")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.DetachClonedFolder.verify(message.detachClonedFolder);
                    if (error)
                        return "detachClonedFolder." + error;
                }
            }
            if (message.getMetaFromPath != null && message.hasOwnProperty("getMetaFromPath")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.GetMetaFromPath.verify(message.getMetaFromPath);
                    if (error)
                        return "getMetaFromPath." + error;
                }
            }
            if (message.renameFile != null && message.hasOwnProperty("renameFile")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.RenameFile.verify(message.renameFile);
                    if (error)
                        return "renameFile." + error;
                }
            }
            if (message.renameFolder != null && message.hasOwnProperty("renameFolder")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.RenameFolder.verify(message.renameFolder);
                    if (error)
                        return "renameFolder." + error;
                }
            }
            if (message.list != null && message.hasOwnProperty("list")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.List.verify(message.list);
                    if (error)
                        return "list." + error;
                }
            }
            if (message.auditLogMessage != null && message.hasOwnProperty("auditLogMessage")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.AuditLogMessage.verify(message.auditLogMessage);
                    if (error)
                        return "auditLogMessage." + error;
                }
            }
            if (message.resetVersion != null && message.hasOwnProperty("resetVersion")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.ResetVersion.verify(message.resetVersion);
                    if (error)
                        return "resetVersion." + error;
                }
            }
            if (message.setUser != null && message.hasOwnProperty("setUser")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.SetUser.verify(message.setUser);
                    if (error)
                        return "setUser." + error;
                }
            }
            if (message.finalizeProfileWrite != null && message.hasOwnProperty("finalizeProfileWrite")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.FinalizeProfileWrite.verify(message.finalizeProfileWrite);
                    if (error)
                        return "finalizeProfileWrite." + error;
                }
            }
            if (message.getProfileFileMeta != null && message.hasOwnProperty("getProfileFileMeta")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.GetProfileFileMeta.verify(message.getProfileFileMeta);
                    if (error)
                        return "getProfileFileMeta." + error;
                }
            }
            if (message.profileChunkList != null && message.hasOwnProperty("profileChunkList")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.ProfileChunkList.verify(message.profileChunkList);
                    if (error)
                        return "profileChunkList." + error;
                }
            }
            if (message.getUserType != null && message.hasOwnProperty("getUserType")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.GetUserType.verify(message.getUserType);
                    if (error)
                        return "getUserType." + error;
                }
            }
            if (message.getRandomBytes != null && message.hasOwnProperty("getRandomBytes")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.GetRandomBytes.verify(message.getRandomBytes);
                    if (error)
                        return "getRandomBytes." + error;
                }
            }
            if (message.share != null && message.hasOwnProperty("share")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.Share.verify(message.share);
                    if (error)
                        return "share." + error;
                }
            }
            if (message.unshare != null && message.hasOwnProperty("unshare")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.Unshare.verify(message.unshare);
                    if (error)
                        return "unshare." + error;
                }
            }
            if (message.updateShare != null && message.hasOwnProperty("updateShare")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.UpdateShare.verify(message.updateShare);
                    if (error)
                        return "updateShare." + error;
                }
            }
            if (message.listShares != null && message.hasOwnProperty("listShares")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.ListShares.verify(message.listShares);
                    if (error)
                        return "listShares." + error;
                }
            }
            if (message.resetTOTP != null && message.hasOwnProperty("resetTOTP")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.ResetTOTP.verify(message.resetTOTP);
                    if (error)
                        return "resetTOTP." + error;
                }
            }
            if (message.setRolesTeamsToUser != null && message.hasOwnProperty("setRolesTeamsToUser")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.SetRolesTeamsToUser.verify(message.setRolesTeamsToUser);
                    if (error)
                        return "setRolesTeamsToUser." + error;
                }
            }
            if (message.updatePinOps != null && message.hasOwnProperty("updatePinOps")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.UpdatePinOps.verify(message.updatePinOps);
                    if (error)
                        return "updatePinOps." + error;
                }
            }
            if (message.deletePin != null && message.hasOwnProperty("deletePin")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.DeletePin.verify(message.deletePin);
                    if (error)
                        return "deletePin." + error;
                }
            }
            if (message.getRolesAndTeamsOfUser != null && message.hasOwnProperty("getRolesAndTeamsOfUser")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.GetRolesAndTeamsOfUser.verify(message.getRolesAndTeamsOfUser);
                    if (error)
                        return "getRolesAndTeamsOfUser." + error;
                }
            }
            if (message.restartPutChunk != null && message.hasOwnProperty("restartPutChunk")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.RestartPutChunk.verify(message.restartPutChunk);
                    if (error)
                        return "restartPutChunk." + error;
                }
            }
            if (message.verifyAuditLogMeta != null && message.hasOwnProperty("verifyAuditLogMeta")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.VerifyAuditLogMeta.verify(message.verifyAuditLogMeta);
                    if (error)
                        return "verifyAuditLogMeta." + error;
                }
            }
            if (message.getAuditLog != null && message.hasOwnProperty("getAuditLog")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.GetAuditLog.verify(message.getAuditLog);
                    if (error)
                        return "getAuditLog." + error;
                }
            }
            if (message.deleteAuditLog != null && message.hasOwnProperty("deleteAuditLog")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.DeleteAuditLog.verify(message.deleteAuditLog);
                    if (error)
                        return "deleteAuditLog." + error;
                }
            }
            if (message.getLedgerRange != null && message.hasOwnProperty("getLedgerRange")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.GetLedgerRange.verify(message.getLedgerRange);
                    if (error)
                        return "getLedgerRange." + error;
                }
            }
            if (message.listPins != null && message.hasOwnProperty("listPins")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.ListPins.verify(message.listPins);
                    if (error)
                        return "listPins." + error;
                }
            }
            if (message.GetMetaFromSharedPath != null && message.hasOwnProperty("GetMetaFromSharedPath")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.GetMetaFromSharedPath.verify(message.GetMetaFromSharedPath);
                    if (error)
                        return "GetMetaFromSharedPath." + error;
                }
            }
            if (message.listQuestions != null && message.hasOwnProperty("listQuestions")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.ListQuestions.verify(message.listQuestions);
                    if (error)
                        return "listQuestions." + error;
                }
            }
            if (message.verifyBYOSCreds != null && message.hasOwnProperty("verifyBYOSCreds")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.VerifyBYOSCreds.verify(message.verifyBYOSCreds);
                    if (error)
                        return "verifyBYOSCreds." + error;
                }
            }
            if (message.MigrateToStorage != null && message.hasOwnProperty("MigrateToStorage")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.MigrateToStorage.verify(message.MigrateToStorage);
                    if (error)
                        return "MigrateToStorage." + error;
                }
            }
            if (message.updateStorageCreds != null && message.hasOwnProperty("updateStorageCreds")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.UpdateStorageCreds.verify(message.updateStorageCreds);
                    if (error)
                        return "updateStorageCreds." + error;
                }
            }
            if (message.verifyUserForAudit != null && message.hasOwnProperty("verifyUserForAudit")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.VerifyUserForAudit.verify(message.verifyUserForAudit);
                    if (error)
                        return "verifyUserForAudit." + error;
                }
            }
            if (message.removeOrganizationUser != null && message.hasOwnProperty("removeOrganizationUser")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.RemoveOrganizationUser.verify(message.removeOrganizationUser);
                    if (error)
                        return "removeOrganizationUser." + error;
                }
            }
            if (message.addSpace != null && message.hasOwnProperty("addSpace")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.AddSpace.verify(message.addSpace);
                    if (error)
                        return "addSpace." + error;
                }
            }
            if (message.addUserToSpace != null && message.hasOwnProperty("addUserToSpace")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.AddUserToSpace.verify(message.addUserToSpace);
                    if (error)
                        return "addUserToSpace." + error;
                }
            }
            if (message.removeUserFromSpace != null && message.hasOwnProperty("removeUserFromSpace")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.RemoveUserFromSpace.verify(message.removeUserFromSpace);
                    if (error)
                        return "removeUserFromSpace." + error;
                }
            }
            if (message.updatePermissionsOfSpace != null && message.hasOwnProperty("updatePermissionsOfSpace")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.UpdatePermissionsOfSpace.verify(message.updatePermissionsOfSpace);
                    if (error)
                        return "updatePermissionsOfSpace." + error;
                }
            }
            if (message.addObjectToSpace != null && message.hasOwnProperty("addObjectToSpace")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.AddObjectToSpace.verify(message.addObjectToSpace);
                    if (error)
                        return "addObjectToSpace." + error;
                }
            }
            if (message.removeObjectFromSpace != null && message.hasOwnProperty("removeObjectFromSpace")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.RemoveObjectFromSpace.verify(message.removeObjectFromSpace);
                    if (error)
                        return "removeObjectFromSpace." + error;
                }
            }
            if (message.removeSpace != null && message.hasOwnProperty("removeSpace")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.RemoveSpace.verify(message.removeSpace);
                    if (error)
                        return "removeSpace." + error;
                }
            }
            if (message.sendOtpToExternalUser != null && message.hasOwnProperty("sendOtpToExternalUser")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.SendOtpToExternalUser.verify(message.sendOtpToExternalUser);
                    if (error)
                        return "sendOtpToExternalUser." + error;
                }
            }
            if (message.signInToSpace != null && message.hasOwnProperty("signInToSpace")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.SignInToSpace.verify(message.signInToSpace);
                    if (error)
                        return "signInToSpace." + error;
                }
            }
            if (message.listSpaces != null && message.hasOwnProperty("listSpaces")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.ListSpaces.verify(message.listSpaces);
                    if (error)
                        return "listSpaces." + error;
                }
            }
            if (message.sendOtpToExternalUserIfNotExist != null && message.hasOwnProperty("sendOtpToExternalUserIfNotExist")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.SendOtpToExternalUserIfNotExist.verify(message.sendOtpToExternalUserIfNotExist);
                    if (error)
                        return "sendOtpToExternalUserIfNotExist." + error;
                }
            }
            if (message.getStorageValue != null && message.hasOwnProperty("getStorageValue")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.GetStorageValue.verify(message.getStorageValue);
                    if (error)
                        return "getStorageValue." + error;
                }
            }
            if (message.updateTags != null && message.hasOwnProperty("updateTags")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.UpdateTags.verify(message.updateTags);
                    if (error)
                        return "updateTags." + error;
                }
            }
            if (message.addComment != null && message.hasOwnProperty("addComment")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.AddComment.verify(message.addComment);
                    if (error)
                        return "addComment." + error;
                }
            }
            if (message.removeComment != null && message.hasOwnProperty("removeComment")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.RemoveComment.verify(message.removeComment);
                    if (error)
                        return "removeComment." + error;
                }
            }
            if (message.listComments != null && message.hasOwnProperty("listComments")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.ListComments.verify(message.listComments);
                    if (error)
                        return "listComments." + error;
                }
            }
            if (message.updateComment != null && message.hasOwnProperty("updateComment")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.UpdateComment.verify(message.updateComment);
                    if (error)
                        return "updateComment." + error;
                }
            }
            if (message.getComment != null && message.hasOwnProperty("getComment")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.GetComment.verify(message.getComment);
                    if (error)
                        return "getComment." + error;
                }
            }
            if (message.sessionData != null && message.hasOwnProperty("sessionData")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.SessionData.verify(message.sessionData);
                    if (error)
                        return "sessionData." + error;
                }
            }
            if (message.getStorageCreds != null && message.hasOwnProperty("getStorageCreds")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.GetStorageCreds.verify(message.getStorageCreds);
                    if (error)
                        return "getStorageCreds." + error;
                }
            }
            if (message.getPlan != null && message.hasOwnProperty("getPlan")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.GetPlan.verify(message.getPlan);
                    if (error)
                        return "getPlan." + error;
                }
            }
            if (message.listPlans != null && message.hasOwnProperty("listPlans")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.ListPlans.verify(message.listPlans);
                    if (error)
                        return "listPlans." + error;
                }
            }
            if (message.upgradePlan != null && message.hasOwnProperty("upgradePlan")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.UpgradePlan.verify(message.upgradePlan);
                    if (error)
                        return "upgradePlan." + error;
                }
            }
            if (message.validateCoupon != null && message.hasOwnProperty("validateCoupon")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.ValidateCoupon.verify(message.validateCoupon);
                    if (error)
                        return "validateCoupon." + error;
                }
            }
            if (message.removeVersion != null && message.hasOwnProperty("removeVersion")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.RemoveVersion.verify(message.removeVersion);
                    if (error)
                        return "removeVersion." + error;
                }
            }
            if (message.getProfilePictureOfUser != null && message.hasOwnProperty("getProfilePictureOfUser")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.GetProfilePictureOfUser.verify(message.getProfilePictureOfUser);
                    if (error)
                        return "getProfilePictureOfUser." + error;
                }
            }
            if (message.emptyTrash != null && message.hasOwnProperty("emptyTrash")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.EmptyTrash.verify(message.emptyTrash);
                    if (error)
                        return "emptyTrash." + error;
                }
            }
            if (message.setThumbnail != null && message.hasOwnProperty("setThumbnail")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.SetThumbnail.verify(message.setThumbnail);
                    if (error)
                        return "setThumbnail." + error;
                }
            }
            if (message.getThumbnail != null && message.hasOwnProperty("getThumbnail")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.GetThumbnail.verify(message.getThumbnail);
                    if (error)
                        return "getThumbnail." + error;
                }
            }
            if (message.blockUser != null && message.hasOwnProperty("blockUser")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.BlockUser.verify(message.blockUser);
                    if (error)
                        return "blockUser." + error;
                }
            }
            if (message.unblockUser != null && message.hasOwnProperty("unblockUser")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.UnblockUser.verify(message.unblockUser);
                    if (error)
                        return "unblockUser." + error;
                }
            }
            if (message.updateOrgSettings != null && message.hasOwnProperty("updateOrgSettings")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.UpdateOrgSettings.verify(message.updateOrgSettings);
                    if (error)
                        return "updateOrgSettings." + error;
                }
            }
            if (message.getOrgSettings != null && message.hasOwnProperty("getOrgSettings")) {
                if (properties.Operation === 1)
                    return "Operation: multiple values";
                properties.Operation = 1;
                {
                    let error = $root.response.GetOrgSettings.verify(message.getOrgSettings);
                    if (error)
                        return "getOrgSettings." + error;
                }
            }
            return null;
        };

        /**
         * Creates a Response message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof response.Response
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {response.Response} Response
         */
        Response.fromObject = function fromObject(object) {
            if (object instanceof $root.response.Response)
                return object;
            let message = new $root.response.Response();
            if (object.id != null)
                if ($util.Long)
                    (message.id = $util.Long.fromValue(object.id)).unsigned = true;
                else if (typeof object.id === "string")
                    message.id = parseInt(object.id, 10);
                else if (typeof object.id === "number")
                    message.id = object.id;
                else if (typeof object.id === "object")
                    message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber(true);
            if (object.addUser != null) {
                if (typeof object.addUser !== "object")
                    throw TypeError(".response.Response.addUser: object expected");
                message.addUser = $root.response.AddUser.fromObject(object.addUser);
            }
            if (object.verifyUser != null) {
                if (typeof object.verifyUser !== "object")
                    throw TypeError(".response.Response.verifyUser: object expected");
                message.verifyUser = $root.response.VerifyUser.fromObject(object.verifyUser);
            }
            if (object.removeUser != null) {
                if (typeof object.removeUser !== "object")
                    throw TypeError(".response.Response.removeUser: object expected");
                message.removeUser = $root.response.RemoveUser.fromObject(object.removeUser);
            }
            if (object.passwordReset != null) {
                if (typeof object.passwordReset !== "object")
                    throw TypeError(".response.Response.passwordReset: object expected");
                message.passwordReset = $root.response.PasswordReset.fromObject(object.passwordReset);
            }
            if (object.changePassword != null) {
                if (typeof object.changePassword !== "object")
                    throw TypeError(".response.Response.changePassword: object expected");
                message.changePassword = $root.response.ChangePassword.fromObject(object.changePassword);
            }
            if (object.addOrganization != null) {
                if (typeof object.addOrganization !== "object")
                    throw TypeError(".response.Response.addOrganization: object expected");
                message.addOrganization = $root.response.AddOrganization.fromObject(object.addOrganization);
            }
            if (object.initiatePayment != null) {
                if (typeof object.initiatePayment !== "object")
                    throw TypeError(".response.Response.initiatePayment: object expected");
                message.initiatePayment = $root.response.InitiatePayment.fromObject(object.initiatePayment);
            }
            if (object.paymentResponse != null) {
                if (typeof object.paymentResponse !== "object")
                    throw TypeError(".response.Response.paymentResponse: object expected");
                message.paymentResponse = $root.response.PaymentResponse.fromObject(object.paymentResponse);
            }
            if (object.signIn != null) {
                if (typeof object.signIn !== "object")
                    throw TypeError(".response.Response.signIn: object expected");
                message.signIn = $root.response.SignIn.fromObject(object.signIn);
            }
            if (object.signOut != null) {
                if (typeof object.signOut !== "object")
                    throw TypeError(".response.Response.signOut: object expected");
                message.signOut = $root.response.SignOut.fromObject(object.signOut);
            }
            if (object.inviteUser != null) {
                if (typeof object.inviteUser !== "object")
                    throw TypeError(".response.Response.inviteUser: object expected");
                message.inviteUser = $root.response.InviteUser.fromObject(object.inviteUser);
            }
            if (object.getUser != null) {
                if (typeof object.getUser !== "object")
                    throw TypeError(".response.Response.getUser: object expected");
                message.getUser = $root.response.GetUser.fromObject(object.getUser);
            }
            if (object.listUsers != null) {
                if (typeof object.listUsers !== "object")
                    throw TypeError(".response.Response.listUsers: object expected");
                message.listUsers = $root.response.ListUsers.fromObject(object.listUsers);
            }
            if (object.removeOrganization != null) {
                if (typeof object.removeOrganization !== "object")
                    throw TypeError(".response.Response.removeOrganization: object expected");
                message.removeOrganization = $root.response.RemoveOrganization.fromObject(object.removeOrganization);
            }
            if (object.verifyOrganization != null) {
                if (typeof object.verifyOrganization !== "object")
                    throw TypeError(".response.Response.verifyOrganization: object expected");
                message.verifyOrganization = $root.response.VerifyOrganization.fromObject(object.verifyOrganization);
            }
            if (object.getOrganization != null) {
                if (typeof object.getOrganization !== "object")
                    throw TypeError(".response.Response.getOrganization: object expected");
                message.getOrganization = $root.response.GetOrganization.fromObject(object.getOrganization);
            }
            if (object.addPin != null) {
                if (typeof object.addPin !== "object")
                    throw TypeError(".response.Response.addPin: object expected");
                message.addPin = $root.response.AddPin.fromObject(object.addPin);
            }
            if (object.echo != null) {
                if (typeof object.echo !== "object")
                    throw TypeError(".response.Response.echo: object expected");
                message.echo = $root.response.Echo.fromObject(object.echo);
            }
            if (object.getFileHead != null) {
                if (typeof object.getFileHead !== "object")
                    throw TypeError(".response.Response.getFileHead: object expected");
                message.getFileHead = $root.response.GetFileHead.fromObject(object.getFileHead);
            }
            if (object.getChunk != null) {
                if (typeof object.getChunk !== "object")
                    throw TypeError(".response.Response.getChunk: object expected");
                message.getChunk = $root.response.GetChunk.fromObject(object.getChunk);
            }
            if (object.startWrite != null) {
                if (typeof object.startWrite !== "object")
                    throw TypeError(".response.Response.startWrite: object expected");
                message.startWrite = $root.response.StartWrite.fromObject(object.startWrite);
            }
            if (object.putChunk != null) {
                if (typeof object.putChunk !== "object")
                    throw TypeError(".response.Response.putChunk: object expected");
                message.putChunk = $root.response.PutChunk.fromObject(object.putChunk);
            }
            if (object.finalizeWrite != null) {
                if (typeof object.finalizeWrite !== "object")
                    throw TypeError(".response.Response.finalizeWrite: object expected");
                message.finalizeWrite = $root.response.FinalizeWrite.fromObject(object.finalizeWrite);
            }
            if (object.listFiles != null) {
                if (typeof object.listFiles !== "object")
                    throw TypeError(".response.Response.listFiles: object expected");
                message.listFiles = $root.response.ListFiles.fromObject(object.listFiles);
            }
            if (object.remove != null) {
                if (typeof object.remove !== "object")
                    throw TypeError(".response.Response.remove: object expected");
                message.remove = $root.response.Remove.fromObject(object.remove);
            }
            if (object.fileLock != null) {
                if (typeof object.fileLock !== "object")
                    throw TypeError(".response.Response.fileLock: object expected");
                message.fileLock = $root.response.FileLock.fromObject(object.fileLock);
            }
            if (object.fileUnlock != null) {
                if (typeof object.fileUnlock !== "object")
                    throw TypeError(".response.Response.fileUnlock: object expected");
                message.fileUnlock = $root.response.FileUnlock.fromObject(object.fileUnlock);
            }
            if (object.getFolder != null) {
                if (typeof object.getFolder !== "object")
                    throw TypeError(".response.Response.getFolder: object expected");
                message.getFolder = $root.response.GetFolder.fromObject(object.getFolder);
            }
            if (object.createFolder != null) {
                if (typeof object.createFolder !== "object")
                    throw TypeError(".response.Response.createFolder: object expected");
                message.createFolder = $root.response.CreateFolder.fromObject(object.createFolder);
            }
            if (object.CreateSnapshot != null) {
                if (typeof object.CreateSnapshot !== "object")
                    throw TypeError(".response.Response.CreateSnapshot: object expected");
                message.CreateSnapshot = $root.response.CreateSnapshot.fromObject(object.CreateSnapshot);
            }
            if (object.verifyPayment != null) {
                if (typeof object.verifyPayment !== "object")
                    throw TypeError(".response.Response.verifyPayment: object expected");
                message.verifyPayment = $root.response.VerifyPayment.fromObject(object.verifyPayment);
            }
            if (object.getSecret != null) {
                if (typeof object.getSecret !== "object")
                    throw TypeError(".response.Response.getSecret: object expected");
                message.getSecret = $root.response.GetSecret.fromObject(object.getSecret);
            }
            if (object.addSecret != null) {
                if (typeof object.addSecret !== "object")
                    throw TypeError(".response.Response.addSecret: object expected");
                message.addSecret = $root.response.AddSecret.fromObject(object.addSecret);
            }
            if (object.deleteSecret != null) {
                if (typeof object.deleteSecret !== "object")
                    throw TypeError(".response.Response.deleteSecret: object expected");
                message.deleteSecret = $root.response.DeleteSecret.fromObject(object.deleteSecret);
            }
            if (object.updateSecret != null) {
                if (typeof object.updateSecret !== "object")
                    throw TypeError(".response.Response.updateSecret: object expected");
                message.updateSecret = $root.response.UpdateSecret.fromObject(object.updateSecret);
            }
            if (object.listSecrets != null) {
                if (typeof object.listSecrets !== "object")
                    throw TypeError(".response.Response.listSecrets: object expected");
                message.listSecrets = $root.response.ListSecrets.fromObject(object.listSecrets);
            }
            if (object.listSecretSubkeys != null) {
                if (typeof object.listSecretSubkeys !== "object")
                    throw TypeError(".response.Response.listSecretSubkeys: object expected");
                message.listSecretSubkeys = $root.response.ListSecretSubkeys.fromObject(object.listSecretSubkeys);
            }
            if (object.quickListSecrets != null) {
                if (typeof object.quickListSecrets !== "object")
                    throw TypeError(".response.Response.quickListSecrets: object expected");
                message.quickListSecrets = $root.response.QuickListSecrets.fromObject(object.quickListSecrets);
            }
            if (object.undeleteSecret != null) {
                if (typeof object.undeleteSecret !== "object")
                    throw TypeError(".response.Response.undeleteSecret: object expected");
                message.undeleteSecret = $root.response.UndeleteSecret.fromObject(object.undeleteSecret);
            }
            if (object.destroySecret != null) {
                if (typeof object.destroySecret !== "object")
                    throw TypeError(".response.Response.destroySecret: object expected");
                message.destroySecret = $root.response.DestroySecret.fromObject(object.destroySecret);
            }
            if (object.addRole != null) {
                if (typeof object.addRole !== "object")
                    throw TypeError(".response.Response.addRole: object expected");
                message.addRole = $root.response.AddRole.fromObject(object.addRole);
            }
            if (object.removeRole != null) {
                if (typeof object.removeRole !== "object")
                    throw TypeError(".response.Response.removeRole: object expected");
                message.removeRole = $root.response.RemoveRole.fromObject(object.removeRole);
            }
            if (object.updateRole != null) {
                if (typeof object.updateRole !== "object")
                    throw TypeError(".response.Response.updateRole: object expected");
                message.updateRole = $root.response.UpdateRole.fromObject(object.updateRole);
            }
            if (object.listRoles != null) {
                if (typeof object.listRoles !== "object")
                    throw TypeError(".response.Response.listRoles: object expected");
                message.listRoles = $root.response.ListRoles.fromObject(object.listRoles);
            }
            if (object.getRole != null) {
                if (typeof object.getRole !== "object")
                    throw TypeError(".response.Response.getRole: object expected");
                message.getRole = $root.response.GetRole.fromObject(object.getRole);
            }
            if (object.addTeam != null) {
                if (typeof object.addTeam !== "object")
                    throw TypeError(".response.Response.addTeam: object expected");
                message.addTeam = $root.response.AddTeam.fromObject(object.addTeam);
            }
            if (object.removeTeam != null) {
                if (typeof object.removeTeam !== "object")
                    throw TypeError(".response.Response.removeTeam: object expected");
                message.removeTeam = $root.response.RemoveTeam.fromObject(object.removeTeam);
            }
            if (object.updateTeam != null) {
                if (typeof object.updateTeam !== "object")
                    throw TypeError(".response.Response.updateTeam: object expected");
                message.updateTeam = $root.response.UpdateTeam.fromObject(object.updateTeam);
            }
            if (object.listTeams != null) {
                if (typeof object.listTeams !== "object")
                    throw TypeError(".response.Response.listTeams: object expected");
                message.listTeams = $root.response.ListTeams.fromObject(object.listTeams);
            }
            if (object.getTeam != null) {
                if (typeof object.getTeam !== "object")
                    throw TypeError(".response.Response.getTeam: object expected");
                message.getTeam = $root.response.GetTeam.fromObject(object.getTeam);
            }
            if (object.isOperationAllowed != null) {
                if (typeof object.isOperationAllowed !== "object")
                    throw TypeError(".response.Response.isOperationAllowed: object expected");
                message.isOperationAllowed = $root.response.IsOperationAllowed.fromObject(object.isOperationAllowed);
            }
            if (object.moveFile != null) {
                if (typeof object.moveFile !== "object")
                    throw TypeError(".response.Response.moveFile: object expected");
                message.moveFile = $root.response.MoveFile.fromObject(object.moveFile);
            }
            if (object.moveFolder != null) {
                if (typeof object.moveFolder !== "object")
                    throw TypeError(".response.Response.moveFolder: object expected");
                message.moveFolder = $root.response.MoveFolder.fromObject(object.moveFolder);
            }
            if (object.copyFile != null) {
                if (typeof object.copyFile !== "object")
                    throw TypeError(".response.Response.copyFile: object expected");
                message.copyFile = $root.response.CopyFile.fromObject(object.copyFile);
            }
            if (object.copyFolder != null) {
                if (typeof object.copyFolder !== "object")
                    throw TypeError(".response.Response.copyFolder: object expected");
                message.copyFolder = $root.response.CopyFolder.fromObject(object.copyFolder);
            }
            if (object.restoreVersion != null) {
                if (typeof object.restoreVersion !== "object")
                    throw TypeError(".response.Response.restoreVersion: object expected");
                message.restoreVersion = $root.response.RestoreVersion.fromObject(object.restoreVersion);
            }
            if (object.removeFile != null) {
                if (typeof object.removeFile !== "object")
                    throw TypeError(".response.Response.removeFile: object expected");
                message.removeFile = $root.response.RemoveFile.fromObject(object.removeFile);
            }
            if (object.removeFolder != null) {
                if (typeof object.removeFolder !== "object")
                    throw TypeError(".response.Response.removeFolder: object expected");
                message.removeFolder = $root.response.RemoveFolder.fromObject(object.removeFolder);
            }
            if (object.untrashFile != null) {
                if (typeof object.untrashFile !== "object")
                    throw TypeError(".response.Response.untrashFile: object expected");
                message.untrashFile = $root.response.UntrashFile.fromObject(object.untrashFile);
            }
            if (object.untrashFolder != null) {
                if (typeof object.untrashFolder !== "object")
                    throw TypeError(".response.Response.untrashFolder: object expected");
                message.untrashFolder = $root.response.UntrashFolder.fromObject(object.untrashFolder);
            }
            if (object.undoStartWrite != null) {
                if (typeof object.undoStartWrite !== "object")
                    throw TypeError(".response.Response.undoStartWrite: object expected");
                message.undoStartWrite = $root.response.UndoStartWrite.fromObject(object.undoStartWrite);
            }
            if (object.detachClonedFolder != null) {
                if (typeof object.detachClonedFolder !== "object")
                    throw TypeError(".response.Response.detachClonedFolder: object expected");
                message.detachClonedFolder = $root.response.DetachClonedFolder.fromObject(object.detachClonedFolder);
            }
            if (object.getMetaFromPath != null) {
                if (typeof object.getMetaFromPath !== "object")
                    throw TypeError(".response.Response.getMetaFromPath: object expected");
                message.getMetaFromPath = $root.response.GetMetaFromPath.fromObject(object.getMetaFromPath);
            }
            if (object.renameFile != null) {
                if (typeof object.renameFile !== "object")
                    throw TypeError(".response.Response.renameFile: object expected");
                message.renameFile = $root.response.RenameFile.fromObject(object.renameFile);
            }
            if (object.renameFolder != null) {
                if (typeof object.renameFolder !== "object")
                    throw TypeError(".response.Response.renameFolder: object expected");
                message.renameFolder = $root.response.RenameFolder.fromObject(object.renameFolder);
            }
            if (object.list != null) {
                if (typeof object.list !== "object")
                    throw TypeError(".response.Response.list: object expected");
                message.list = $root.response.List.fromObject(object.list);
            }
            if (object.auditLogMessage != null) {
                if (typeof object.auditLogMessage !== "object")
                    throw TypeError(".response.Response.auditLogMessage: object expected");
                message.auditLogMessage = $root.response.AuditLogMessage.fromObject(object.auditLogMessage);
            }
            if (object.resetVersion != null) {
                if (typeof object.resetVersion !== "object")
                    throw TypeError(".response.Response.resetVersion: object expected");
                message.resetVersion = $root.response.ResetVersion.fromObject(object.resetVersion);
            }
            if (object.setUser != null) {
                if (typeof object.setUser !== "object")
                    throw TypeError(".response.Response.setUser: object expected");
                message.setUser = $root.response.SetUser.fromObject(object.setUser);
            }
            if (object.finalizeProfileWrite != null) {
                if (typeof object.finalizeProfileWrite !== "object")
                    throw TypeError(".response.Response.finalizeProfileWrite: object expected");
                message.finalizeProfileWrite = $root.response.FinalizeProfileWrite.fromObject(object.finalizeProfileWrite);
            }
            if (object.getProfileFileMeta != null) {
                if (typeof object.getProfileFileMeta !== "object")
                    throw TypeError(".response.Response.getProfileFileMeta: object expected");
                message.getProfileFileMeta = $root.response.GetProfileFileMeta.fromObject(object.getProfileFileMeta);
            }
            if (object.profileChunkList != null) {
                if (typeof object.profileChunkList !== "object")
                    throw TypeError(".response.Response.profileChunkList: object expected");
                message.profileChunkList = $root.response.ProfileChunkList.fromObject(object.profileChunkList);
            }
            if (object.getUserType != null) {
                if (typeof object.getUserType !== "object")
                    throw TypeError(".response.Response.getUserType: object expected");
                message.getUserType = $root.response.GetUserType.fromObject(object.getUserType);
            }
            if (object.getRandomBytes != null) {
                if (typeof object.getRandomBytes !== "object")
                    throw TypeError(".response.Response.getRandomBytes: object expected");
                message.getRandomBytes = $root.response.GetRandomBytes.fromObject(object.getRandomBytes);
            }
            if (object.share != null) {
                if (typeof object.share !== "object")
                    throw TypeError(".response.Response.share: object expected");
                message.share = $root.response.Share.fromObject(object.share);
            }
            if (object.unshare != null) {
                if (typeof object.unshare !== "object")
                    throw TypeError(".response.Response.unshare: object expected");
                message.unshare = $root.response.Unshare.fromObject(object.unshare);
            }
            if (object.updateShare != null) {
                if (typeof object.updateShare !== "object")
                    throw TypeError(".response.Response.updateShare: object expected");
                message.updateShare = $root.response.UpdateShare.fromObject(object.updateShare);
            }
            if (object.listShares != null) {
                if (typeof object.listShares !== "object")
                    throw TypeError(".response.Response.listShares: object expected");
                message.listShares = $root.response.ListShares.fromObject(object.listShares);
            }
            if (object.resetTOTP != null) {
                if (typeof object.resetTOTP !== "object")
                    throw TypeError(".response.Response.resetTOTP: object expected");
                message.resetTOTP = $root.response.ResetTOTP.fromObject(object.resetTOTP);
            }
            if (object.setRolesTeamsToUser != null) {
                if (typeof object.setRolesTeamsToUser !== "object")
                    throw TypeError(".response.Response.setRolesTeamsToUser: object expected");
                message.setRolesTeamsToUser = $root.response.SetRolesTeamsToUser.fromObject(object.setRolesTeamsToUser);
            }
            if (object.updatePinOps != null) {
                if (typeof object.updatePinOps !== "object")
                    throw TypeError(".response.Response.updatePinOps: object expected");
                message.updatePinOps = $root.response.UpdatePinOps.fromObject(object.updatePinOps);
            }
            if (object.deletePin != null) {
                if (typeof object.deletePin !== "object")
                    throw TypeError(".response.Response.deletePin: object expected");
                message.deletePin = $root.response.DeletePin.fromObject(object.deletePin);
            }
            if (object.getRolesAndTeamsOfUser != null) {
                if (typeof object.getRolesAndTeamsOfUser !== "object")
                    throw TypeError(".response.Response.getRolesAndTeamsOfUser: object expected");
                message.getRolesAndTeamsOfUser = $root.response.GetRolesAndTeamsOfUser.fromObject(object.getRolesAndTeamsOfUser);
            }
            if (object.restartPutChunk != null) {
                if (typeof object.restartPutChunk !== "object")
                    throw TypeError(".response.Response.restartPutChunk: object expected");
                message.restartPutChunk = $root.response.RestartPutChunk.fromObject(object.restartPutChunk);
            }
            if (object.verifyAuditLogMeta != null) {
                if (typeof object.verifyAuditLogMeta !== "object")
                    throw TypeError(".response.Response.verifyAuditLogMeta: object expected");
                message.verifyAuditLogMeta = $root.response.VerifyAuditLogMeta.fromObject(object.verifyAuditLogMeta);
            }
            if (object.getAuditLog != null) {
                if (typeof object.getAuditLog !== "object")
                    throw TypeError(".response.Response.getAuditLog: object expected");
                message.getAuditLog = $root.response.GetAuditLog.fromObject(object.getAuditLog);
            }
            if (object.deleteAuditLog != null) {
                if (typeof object.deleteAuditLog !== "object")
                    throw TypeError(".response.Response.deleteAuditLog: object expected");
                message.deleteAuditLog = $root.response.DeleteAuditLog.fromObject(object.deleteAuditLog);
            }
            if (object.getLedgerRange != null) {
                if (typeof object.getLedgerRange !== "object")
                    throw TypeError(".response.Response.getLedgerRange: object expected");
                message.getLedgerRange = $root.response.GetLedgerRange.fromObject(object.getLedgerRange);
            }
            if (object.listPins != null) {
                if (typeof object.listPins !== "object")
                    throw TypeError(".response.Response.listPins: object expected");
                message.listPins = $root.response.ListPins.fromObject(object.listPins);
            }
            if (object.GetMetaFromSharedPath != null) {
                if (typeof object.GetMetaFromSharedPath !== "object")
                    throw TypeError(".response.Response.GetMetaFromSharedPath: object expected");
                message.GetMetaFromSharedPath = $root.response.GetMetaFromSharedPath.fromObject(object.GetMetaFromSharedPath);
            }
            if (object.listQuestions != null) {
                if (typeof object.listQuestions !== "object")
                    throw TypeError(".response.Response.listQuestions: object expected");
                message.listQuestions = $root.response.ListQuestions.fromObject(object.listQuestions);
            }
            if (object.verifyBYOSCreds != null) {
                if (typeof object.verifyBYOSCreds !== "object")
                    throw TypeError(".response.Response.verifyBYOSCreds: object expected");
                message.verifyBYOSCreds = $root.response.VerifyBYOSCreds.fromObject(object.verifyBYOSCreds);
            }
            if (object.MigrateToStorage != null) {
                if (typeof object.MigrateToStorage !== "object")
                    throw TypeError(".response.Response.MigrateToStorage: object expected");
                message.MigrateToStorage = $root.response.MigrateToStorage.fromObject(object.MigrateToStorage);
            }
            if (object.updateStorageCreds != null) {
                if (typeof object.updateStorageCreds !== "object")
                    throw TypeError(".response.Response.updateStorageCreds: object expected");
                message.updateStorageCreds = $root.response.UpdateStorageCreds.fromObject(object.updateStorageCreds);
            }
            if (object.verifyUserForAudit != null) {
                if (typeof object.verifyUserForAudit !== "object")
                    throw TypeError(".response.Response.verifyUserForAudit: object expected");
                message.verifyUserForAudit = $root.response.VerifyUserForAudit.fromObject(object.verifyUserForAudit);
            }
            if (object.removeOrganizationUser != null) {
                if (typeof object.removeOrganizationUser !== "object")
                    throw TypeError(".response.Response.removeOrganizationUser: object expected");
                message.removeOrganizationUser = $root.response.RemoveOrganizationUser.fromObject(object.removeOrganizationUser);
            }
            if (object.addSpace != null) {
                if (typeof object.addSpace !== "object")
                    throw TypeError(".response.Response.addSpace: object expected");
                message.addSpace = $root.response.AddSpace.fromObject(object.addSpace);
            }
            if (object.addUserToSpace != null) {
                if (typeof object.addUserToSpace !== "object")
                    throw TypeError(".response.Response.addUserToSpace: object expected");
                message.addUserToSpace = $root.response.AddUserToSpace.fromObject(object.addUserToSpace);
            }
            if (object.removeUserFromSpace != null) {
                if (typeof object.removeUserFromSpace !== "object")
                    throw TypeError(".response.Response.removeUserFromSpace: object expected");
                message.removeUserFromSpace = $root.response.RemoveUserFromSpace.fromObject(object.removeUserFromSpace);
            }
            if (object.updatePermissionsOfSpace != null) {
                if (typeof object.updatePermissionsOfSpace !== "object")
                    throw TypeError(".response.Response.updatePermissionsOfSpace: object expected");
                message.updatePermissionsOfSpace = $root.response.UpdatePermissionsOfSpace.fromObject(object.updatePermissionsOfSpace);
            }
            if (object.addObjectToSpace != null) {
                if (typeof object.addObjectToSpace !== "object")
                    throw TypeError(".response.Response.addObjectToSpace: object expected");
                message.addObjectToSpace = $root.response.AddObjectToSpace.fromObject(object.addObjectToSpace);
            }
            if (object.removeObjectFromSpace != null) {
                if (typeof object.removeObjectFromSpace !== "object")
                    throw TypeError(".response.Response.removeObjectFromSpace: object expected");
                message.removeObjectFromSpace = $root.response.RemoveObjectFromSpace.fromObject(object.removeObjectFromSpace);
            }
            if (object.removeSpace != null) {
                if (typeof object.removeSpace !== "object")
                    throw TypeError(".response.Response.removeSpace: object expected");
                message.removeSpace = $root.response.RemoveSpace.fromObject(object.removeSpace);
            }
            if (object.sendOtpToExternalUser != null) {
                if (typeof object.sendOtpToExternalUser !== "object")
                    throw TypeError(".response.Response.sendOtpToExternalUser: object expected");
                message.sendOtpToExternalUser = $root.response.SendOtpToExternalUser.fromObject(object.sendOtpToExternalUser);
            }
            if (object.signInToSpace != null) {
                if (typeof object.signInToSpace !== "object")
                    throw TypeError(".response.Response.signInToSpace: object expected");
                message.signInToSpace = $root.response.SignInToSpace.fromObject(object.signInToSpace);
            }
            if (object.listSpaces != null) {
                if (typeof object.listSpaces !== "object")
                    throw TypeError(".response.Response.listSpaces: object expected");
                message.listSpaces = $root.response.ListSpaces.fromObject(object.listSpaces);
            }
            if (object.sendOtpToExternalUserIfNotExist != null) {
                if (typeof object.sendOtpToExternalUserIfNotExist !== "object")
                    throw TypeError(".response.Response.sendOtpToExternalUserIfNotExist: object expected");
                message.sendOtpToExternalUserIfNotExist = $root.response.SendOtpToExternalUserIfNotExist.fromObject(object.sendOtpToExternalUserIfNotExist);
            }
            if (object.getStorageValue != null) {
                if (typeof object.getStorageValue !== "object")
                    throw TypeError(".response.Response.getStorageValue: object expected");
                message.getStorageValue = $root.response.GetStorageValue.fromObject(object.getStorageValue);
            }
            if (object.updateTags != null) {
                if (typeof object.updateTags !== "object")
                    throw TypeError(".response.Response.updateTags: object expected");
                message.updateTags = $root.response.UpdateTags.fromObject(object.updateTags);
            }
            if (object.addComment != null) {
                if (typeof object.addComment !== "object")
                    throw TypeError(".response.Response.addComment: object expected");
                message.addComment = $root.response.AddComment.fromObject(object.addComment);
            }
            if (object.removeComment != null) {
                if (typeof object.removeComment !== "object")
                    throw TypeError(".response.Response.removeComment: object expected");
                message.removeComment = $root.response.RemoveComment.fromObject(object.removeComment);
            }
            if (object.listComments != null) {
                if (typeof object.listComments !== "object")
                    throw TypeError(".response.Response.listComments: object expected");
                message.listComments = $root.response.ListComments.fromObject(object.listComments);
            }
            if (object.updateComment != null) {
                if (typeof object.updateComment !== "object")
                    throw TypeError(".response.Response.updateComment: object expected");
                message.updateComment = $root.response.UpdateComment.fromObject(object.updateComment);
            }
            if (object.getComment != null) {
                if (typeof object.getComment !== "object")
                    throw TypeError(".response.Response.getComment: object expected");
                message.getComment = $root.response.GetComment.fromObject(object.getComment);
            }
            if (object.sessionData != null) {
                if (typeof object.sessionData !== "object")
                    throw TypeError(".response.Response.sessionData: object expected");
                message.sessionData = $root.response.SessionData.fromObject(object.sessionData);
            }
            if (object.getStorageCreds != null) {
                if (typeof object.getStorageCreds !== "object")
                    throw TypeError(".response.Response.getStorageCreds: object expected");
                message.getStorageCreds = $root.response.GetStorageCreds.fromObject(object.getStorageCreds);
            }
            if (object.getPlan != null) {
                if (typeof object.getPlan !== "object")
                    throw TypeError(".response.Response.getPlan: object expected");
                message.getPlan = $root.response.GetPlan.fromObject(object.getPlan);
            }
            if (object.listPlans != null) {
                if (typeof object.listPlans !== "object")
                    throw TypeError(".response.Response.listPlans: object expected");
                message.listPlans = $root.response.ListPlans.fromObject(object.listPlans);
            }
            if (object.upgradePlan != null) {
                if (typeof object.upgradePlan !== "object")
                    throw TypeError(".response.Response.upgradePlan: object expected");
                message.upgradePlan = $root.response.UpgradePlan.fromObject(object.upgradePlan);
            }
            if (object.validateCoupon != null) {
                if (typeof object.validateCoupon !== "object")
                    throw TypeError(".response.Response.validateCoupon: object expected");
                message.validateCoupon = $root.response.ValidateCoupon.fromObject(object.validateCoupon);
            }
            if (object.removeVersion != null) {
                if (typeof object.removeVersion !== "object")
                    throw TypeError(".response.Response.removeVersion: object expected");
                message.removeVersion = $root.response.RemoveVersion.fromObject(object.removeVersion);
            }
            if (object.getProfilePictureOfUser != null) {
                if (typeof object.getProfilePictureOfUser !== "object")
                    throw TypeError(".response.Response.getProfilePictureOfUser: object expected");
                message.getProfilePictureOfUser = $root.response.GetProfilePictureOfUser.fromObject(object.getProfilePictureOfUser);
            }
            if (object.emptyTrash != null) {
                if (typeof object.emptyTrash !== "object")
                    throw TypeError(".response.Response.emptyTrash: object expected");
                message.emptyTrash = $root.response.EmptyTrash.fromObject(object.emptyTrash);
            }
            if (object.setThumbnail != null) {
                if (typeof object.setThumbnail !== "object")
                    throw TypeError(".response.Response.setThumbnail: object expected");
                message.setThumbnail = $root.response.SetThumbnail.fromObject(object.setThumbnail);
            }
            if (object.getThumbnail != null) {
                if (typeof object.getThumbnail !== "object")
                    throw TypeError(".response.Response.getThumbnail: object expected");
                message.getThumbnail = $root.response.GetThumbnail.fromObject(object.getThumbnail);
            }
            if (object.blockUser != null) {
                if (typeof object.blockUser !== "object")
                    throw TypeError(".response.Response.blockUser: object expected");
                message.blockUser = $root.response.BlockUser.fromObject(object.blockUser);
            }
            if (object.unblockUser != null) {
                if (typeof object.unblockUser !== "object")
                    throw TypeError(".response.Response.unblockUser: object expected");
                message.unblockUser = $root.response.UnblockUser.fromObject(object.unblockUser);
            }
            if (object.updateOrgSettings != null) {
                if (typeof object.updateOrgSettings !== "object")
                    throw TypeError(".response.Response.updateOrgSettings: object expected");
                message.updateOrgSettings = $root.response.UpdateOrgSettings.fromObject(object.updateOrgSettings);
            }
            if (object.getOrgSettings != null) {
                if (typeof object.getOrgSettings !== "object")
                    throw TypeError(".response.Response.getOrgSettings: object expected");
                message.getOrgSettings = $root.response.GetOrgSettings.fromObject(object.getOrgSettings);
            }
            return message;
        };

        /**
         * Creates a plain object from a Response message. Also converts values to other types if specified.
         * @function toObject
         * @memberof response.Response
         * @static
         * @param {response.Response} message Response
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Response.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (message.addUser != null && message.hasOwnProperty("addUser")) {
                object.addUser = $root.response.AddUser.toObject(message.addUser, options);
                if (options.oneofs)
                    object.Operation = "addUser";
            }
            if (message.verifyUser != null && message.hasOwnProperty("verifyUser")) {
                object.verifyUser = $root.response.VerifyUser.toObject(message.verifyUser, options);
                if (options.oneofs)
                    object.Operation = "verifyUser";
            }
            if (message.removeUser != null && message.hasOwnProperty("removeUser")) {
                object.removeUser = $root.response.RemoveUser.toObject(message.removeUser, options);
                if (options.oneofs)
                    object.Operation = "removeUser";
            }
            if (message.passwordReset != null && message.hasOwnProperty("passwordReset")) {
                object.passwordReset = $root.response.PasswordReset.toObject(message.passwordReset, options);
                if (options.oneofs)
                    object.Operation = "passwordReset";
            }
            if (message.changePassword != null && message.hasOwnProperty("changePassword")) {
                object.changePassword = $root.response.ChangePassword.toObject(message.changePassword, options);
                if (options.oneofs)
                    object.Operation = "changePassword";
            }
            if (message.addOrganization != null && message.hasOwnProperty("addOrganization")) {
                object.addOrganization = $root.response.AddOrganization.toObject(message.addOrganization, options);
                if (options.oneofs)
                    object.Operation = "addOrganization";
            }
            if (message.initiatePayment != null && message.hasOwnProperty("initiatePayment")) {
                object.initiatePayment = $root.response.InitiatePayment.toObject(message.initiatePayment, options);
                if (options.oneofs)
                    object.Operation = "initiatePayment";
            }
            if (message.paymentResponse != null && message.hasOwnProperty("paymentResponse")) {
                object.paymentResponse = $root.response.PaymentResponse.toObject(message.paymentResponse, options);
                if (options.oneofs)
                    object.Operation = "paymentResponse";
            }
            if (message.signIn != null && message.hasOwnProperty("signIn")) {
                object.signIn = $root.response.SignIn.toObject(message.signIn, options);
                if (options.oneofs)
                    object.Operation = "signIn";
            }
            if (message.signOut != null && message.hasOwnProperty("signOut")) {
                object.signOut = $root.response.SignOut.toObject(message.signOut, options);
                if (options.oneofs)
                    object.Operation = "signOut";
            }
            if (message.inviteUser != null && message.hasOwnProperty("inviteUser")) {
                object.inviteUser = $root.response.InviteUser.toObject(message.inviteUser, options);
                if (options.oneofs)
                    object.Operation = "inviteUser";
            }
            if (message.getUser != null && message.hasOwnProperty("getUser")) {
                object.getUser = $root.response.GetUser.toObject(message.getUser, options);
                if (options.oneofs)
                    object.Operation = "getUser";
            }
            if (message.listUsers != null && message.hasOwnProperty("listUsers")) {
                object.listUsers = $root.response.ListUsers.toObject(message.listUsers, options);
                if (options.oneofs)
                    object.Operation = "listUsers";
            }
            if (message.removeOrganization != null && message.hasOwnProperty("removeOrganization")) {
                object.removeOrganization = $root.response.RemoveOrganization.toObject(message.removeOrganization, options);
                if (options.oneofs)
                    object.Operation = "removeOrganization";
            }
            if (message.verifyOrganization != null && message.hasOwnProperty("verifyOrganization")) {
                object.verifyOrganization = $root.response.VerifyOrganization.toObject(message.verifyOrganization, options);
                if (options.oneofs)
                    object.Operation = "verifyOrganization";
            }
            if (message.getOrganization != null && message.hasOwnProperty("getOrganization")) {
                object.getOrganization = $root.response.GetOrganization.toObject(message.getOrganization, options);
                if (options.oneofs)
                    object.Operation = "getOrganization";
            }
            if (message.addPin != null && message.hasOwnProperty("addPin")) {
                object.addPin = $root.response.AddPin.toObject(message.addPin, options);
                if (options.oneofs)
                    object.Operation = "addPin";
            }
            if (message.echo != null && message.hasOwnProperty("echo")) {
                object.echo = $root.response.Echo.toObject(message.echo, options);
                if (options.oneofs)
                    object.Operation = "echo";
            }
            if (message.getFileHead != null && message.hasOwnProperty("getFileHead")) {
                object.getFileHead = $root.response.GetFileHead.toObject(message.getFileHead, options);
                if (options.oneofs)
                    object.Operation = "getFileHead";
            }
            if (message.getChunk != null && message.hasOwnProperty("getChunk")) {
                object.getChunk = $root.response.GetChunk.toObject(message.getChunk, options);
                if (options.oneofs)
                    object.Operation = "getChunk";
            }
            if (message.startWrite != null && message.hasOwnProperty("startWrite")) {
                object.startWrite = $root.response.StartWrite.toObject(message.startWrite, options);
                if (options.oneofs)
                    object.Operation = "startWrite";
            }
            if (message.putChunk != null && message.hasOwnProperty("putChunk")) {
                object.putChunk = $root.response.PutChunk.toObject(message.putChunk, options);
                if (options.oneofs)
                    object.Operation = "putChunk";
            }
            if (message.finalizeWrite != null && message.hasOwnProperty("finalizeWrite")) {
                object.finalizeWrite = $root.response.FinalizeWrite.toObject(message.finalizeWrite, options);
                if (options.oneofs)
                    object.Operation = "finalizeWrite";
            }
            if (message.listFiles != null && message.hasOwnProperty("listFiles")) {
                object.listFiles = $root.response.ListFiles.toObject(message.listFiles, options);
                if (options.oneofs)
                    object.Operation = "listFiles";
            }
            if (message.remove != null && message.hasOwnProperty("remove")) {
                object.remove = $root.response.Remove.toObject(message.remove, options);
                if (options.oneofs)
                    object.Operation = "remove";
            }
            if (message.fileLock != null && message.hasOwnProperty("fileLock")) {
                object.fileLock = $root.response.FileLock.toObject(message.fileLock, options);
                if (options.oneofs)
                    object.Operation = "fileLock";
            }
            if (message.fileUnlock != null && message.hasOwnProperty("fileUnlock")) {
                object.fileUnlock = $root.response.FileUnlock.toObject(message.fileUnlock, options);
                if (options.oneofs)
                    object.Operation = "fileUnlock";
            }
            if (message.getFolder != null && message.hasOwnProperty("getFolder")) {
                object.getFolder = $root.response.GetFolder.toObject(message.getFolder, options);
                if (options.oneofs)
                    object.Operation = "getFolder";
            }
            if (message.createFolder != null && message.hasOwnProperty("createFolder")) {
                object.createFolder = $root.response.CreateFolder.toObject(message.createFolder, options);
                if (options.oneofs)
                    object.Operation = "createFolder";
            }
            if (message.CreateSnapshot != null && message.hasOwnProperty("CreateSnapshot")) {
                object.CreateSnapshot = $root.response.CreateSnapshot.toObject(message.CreateSnapshot, options);
                if (options.oneofs)
                    object.Operation = "CreateSnapshot";
            }
            if (message.verifyPayment != null && message.hasOwnProperty("verifyPayment")) {
                object.verifyPayment = $root.response.VerifyPayment.toObject(message.verifyPayment, options);
                if (options.oneofs)
                    object.Operation = "verifyPayment";
            }
            if (message.getSecret != null && message.hasOwnProperty("getSecret")) {
                object.getSecret = $root.response.GetSecret.toObject(message.getSecret, options);
                if (options.oneofs)
                    object.Operation = "getSecret";
            }
            if (message.addSecret != null && message.hasOwnProperty("addSecret")) {
                object.addSecret = $root.response.AddSecret.toObject(message.addSecret, options);
                if (options.oneofs)
                    object.Operation = "addSecret";
            }
            if (message.deleteSecret != null && message.hasOwnProperty("deleteSecret")) {
                object.deleteSecret = $root.response.DeleteSecret.toObject(message.deleteSecret, options);
                if (options.oneofs)
                    object.Operation = "deleteSecret";
            }
            if (message.updateSecret != null && message.hasOwnProperty("updateSecret")) {
                object.updateSecret = $root.response.UpdateSecret.toObject(message.updateSecret, options);
                if (options.oneofs)
                    object.Operation = "updateSecret";
            }
            if (message.listSecrets != null && message.hasOwnProperty("listSecrets")) {
                object.listSecrets = $root.response.ListSecrets.toObject(message.listSecrets, options);
                if (options.oneofs)
                    object.Operation = "listSecrets";
            }
            if (message.listSecretSubkeys != null && message.hasOwnProperty("listSecretSubkeys")) {
                object.listSecretSubkeys = $root.response.ListSecretSubkeys.toObject(message.listSecretSubkeys, options);
                if (options.oneofs)
                    object.Operation = "listSecretSubkeys";
            }
            if (message.undeleteSecret != null && message.hasOwnProperty("undeleteSecret")) {
                object.undeleteSecret = $root.response.UndeleteSecret.toObject(message.undeleteSecret, options);
                if (options.oneofs)
                    object.Operation = "undeleteSecret";
            }
            if (message.destroySecret != null && message.hasOwnProperty("destroySecret")) {
                object.destroySecret = $root.response.DestroySecret.toObject(message.destroySecret, options);
                if (options.oneofs)
                    object.Operation = "destroySecret";
            }
            if (message.addRole != null && message.hasOwnProperty("addRole")) {
                object.addRole = $root.response.AddRole.toObject(message.addRole, options);
                if (options.oneofs)
                    object.Operation = "addRole";
            }
            if (message.removeRole != null && message.hasOwnProperty("removeRole")) {
                object.removeRole = $root.response.RemoveRole.toObject(message.removeRole, options);
                if (options.oneofs)
                    object.Operation = "removeRole";
            }
            if (message.updateRole != null && message.hasOwnProperty("updateRole")) {
                object.updateRole = $root.response.UpdateRole.toObject(message.updateRole, options);
                if (options.oneofs)
                    object.Operation = "updateRole";
            }
            if (message.listRoles != null && message.hasOwnProperty("listRoles")) {
                object.listRoles = $root.response.ListRoles.toObject(message.listRoles, options);
                if (options.oneofs)
                    object.Operation = "listRoles";
            }
            if (message.addTeam != null && message.hasOwnProperty("addTeam")) {
                object.addTeam = $root.response.AddTeam.toObject(message.addTeam, options);
                if (options.oneofs)
                    object.Operation = "addTeam";
            }
            if (message.removeTeam != null && message.hasOwnProperty("removeTeam")) {
                object.removeTeam = $root.response.RemoveTeam.toObject(message.removeTeam, options);
                if (options.oneofs)
                    object.Operation = "removeTeam";
            }
            if (message.updateTeam != null && message.hasOwnProperty("updateTeam")) {
                object.updateTeam = $root.response.UpdateTeam.toObject(message.updateTeam, options);
                if (options.oneofs)
                    object.Operation = "updateTeam";
            }
            if (message.listTeams != null && message.hasOwnProperty("listTeams")) {
                object.listTeams = $root.response.ListTeams.toObject(message.listTeams, options);
                if (options.oneofs)
                    object.Operation = "listTeams";
            }
            if (message.isOperationAllowed != null && message.hasOwnProperty("isOperationAllowed")) {
                object.isOperationAllowed = $root.response.IsOperationAllowed.toObject(message.isOperationAllowed, options);
                if (options.oneofs)
                    object.Operation = "isOperationAllowed";
            }
            if (message.moveFile != null && message.hasOwnProperty("moveFile")) {
                object.moveFile = $root.response.MoveFile.toObject(message.moveFile, options);
                if (options.oneofs)
                    object.Operation = "moveFile";
            }
            if (message.moveFolder != null && message.hasOwnProperty("moveFolder")) {
                object.moveFolder = $root.response.MoveFolder.toObject(message.moveFolder, options);
                if (options.oneofs)
                    object.Operation = "moveFolder";
            }
            if (message.copyFile != null && message.hasOwnProperty("copyFile")) {
                object.copyFile = $root.response.CopyFile.toObject(message.copyFile, options);
                if (options.oneofs)
                    object.Operation = "copyFile";
            }
            if (message.copyFolder != null && message.hasOwnProperty("copyFolder")) {
                object.copyFolder = $root.response.CopyFolder.toObject(message.copyFolder, options);
                if (options.oneofs)
                    object.Operation = "copyFolder";
            }
            if (message.restoreVersion != null && message.hasOwnProperty("restoreVersion")) {
                object.restoreVersion = $root.response.RestoreVersion.toObject(message.restoreVersion, options);
                if (options.oneofs)
                    object.Operation = "restoreVersion";
            }
            if (message.removeFile != null && message.hasOwnProperty("removeFile")) {
                object.removeFile = $root.response.RemoveFile.toObject(message.removeFile, options);
                if (options.oneofs)
                    object.Operation = "removeFile";
            }
            if (message.removeFolder != null && message.hasOwnProperty("removeFolder")) {
                object.removeFolder = $root.response.RemoveFolder.toObject(message.removeFolder, options);
                if (options.oneofs)
                    object.Operation = "removeFolder";
            }
            if (message.untrashFile != null && message.hasOwnProperty("untrashFile")) {
                object.untrashFile = $root.response.UntrashFile.toObject(message.untrashFile, options);
                if (options.oneofs)
                    object.Operation = "untrashFile";
            }
            if (message.untrashFolder != null && message.hasOwnProperty("untrashFolder")) {
                object.untrashFolder = $root.response.UntrashFolder.toObject(message.untrashFolder, options);
                if (options.oneofs)
                    object.Operation = "untrashFolder";
            }
            if (message.undoStartWrite != null && message.hasOwnProperty("undoStartWrite")) {
                object.undoStartWrite = $root.response.UndoStartWrite.toObject(message.undoStartWrite, options);
                if (options.oneofs)
                    object.Operation = "undoStartWrite";
            }
            if (message.detachClonedFolder != null && message.hasOwnProperty("detachClonedFolder")) {
                object.detachClonedFolder = $root.response.DetachClonedFolder.toObject(message.detachClonedFolder, options);
                if (options.oneofs)
                    object.Operation = "detachClonedFolder";
            }
            if (message.getMetaFromPath != null && message.hasOwnProperty("getMetaFromPath")) {
                object.getMetaFromPath = $root.response.GetMetaFromPath.toObject(message.getMetaFromPath, options);
                if (options.oneofs)
                    object.Operation = "getMetaFromPath";
            }
            if (message.renameFile != null && message.hasOwnProperty("renameFile")) {
                object.renameFile = $root.response.RenameFile.toObject(message.renameFile, options);
                if (options.oneofs)
                    object.Operation = "renameFile";
            }
            if (message.renameFolder != null && message.hasOwnProperty("renameFolder")) {
                object.renameFolder = $root.response.RenameFolder.toObject(message.renameFolder, options);
                if (options.oneofs)
                    object.Operation = "renameFolder";
            }
            if (message.list != null && message.hasOwnProperty("list")) {
                object.list = $root.response.List.toObject(message.list, options);
                if (options.oneofs)
                    object.Operation = "list";
            }
            if (message.auditLogMessage != null && message.hasOwnProperty("auditLogMessage")) {
                object.auditLogMessage = $root.response.AuditLogMessage.toObject(message.auditLogMessage, options);
                if (options.oneofs)
                    object.Operation = "auditLogMessage";
            }
            if (message.resetVersion != null && message.hasOwnProperty("resetVersion")) {
                object.resetVersion = $root.response.ResetVersion.toObject(message.resetVersion, options);
                if (options.oneofs)
                    object.Operation = "resetVersion";
            }
            if (message.setUser != null && message.hasOwnProperty("setUser")) {
                object.setUser = $root.response.SetUser.toObject(message.setUser, options);
                if (options.oneofs)
                    object.Operation = "setUser";
            }
            if (message.finalizeProfileWrite != null && message.hasOwnProperty("finalizeProfileWrite")) {
                object.finalizeProfileWrite = $root.response.FinalizeProfileWrite.toObject(message.finalizeProfileWrite, options);
                if (options.oneofs)
                    object.Operation = "finalizeProfileWrite";
            }
            if (message.getProfileFileMeta != null && message.hasOwnProperty("getProfileFileMeta")) {
                object.getProfileFileMeta = $root.response.GetProfileFileMeta.toObject(message.getProfileFileMeta, options);
                if (options.oneofs)
                    object.Operation = "getProfileFileMeta";
            }
            if (message.profileChunkList != null && message.hasOwnProperty("profileChunkList")) {
                object.profileChunkList = $root.response.ProfileChunkList.toObject(message.profileChunkList, options);
                if (options.oneofs)
                    object.Operation = "profileChunkList";
            }
            if (message.getUserType != null && message.hasOwnProperty("getUserType")) {
                object.getUserType = $root.response.GetUserType.toObject(message.getUserType, options);
                if (options.oneofs)
                    object.Operation = "getUserType";
            }
            if (message.getRandomBytes != null && message.hasOwnProperty("getRandomBytes")) {
                object.getRandomBytes = $root.response.GetRandomBytes.toObject(message.getRandomBytes, options);
                if (options.oneofs)
                    object.Operation = "getRandomBytes";
            }
            if (message.share != null && message.hasOwnProperty("share")) {
                object.share = $root.response.Share.toObject(message.share, options);
                if (options.oneofs)
                    object.Operation = "share";
            }
            if (message.unshare != null && message.hasOwnProperty("unshare")) {
                object.unshare = $root.response.Unshare.toObject(message.unshare, options);
                if (options.oneofs)
                    object.Operation = "unshare";
            }
            if (message.updateShare != null && message.hasOwnProperty("updateShare")) {
                object.updateShare = $root.response.UpdateShare.toObject(message.updateShare, options);
                if (options.oneofs)
                    object.Operation = "updateShare";
            }
            if (message.listShares != null && message.hasOwnProperty("listShares")) {
                object.listShares = $root.response.ListShares.toObject(message.listShares, options);
                if (options.oneofs)
                    object.Operation = "listShares";
            }
            if (message.getTeam != null && message.hasOwnProperty("getTeam")) {
                object.getTeam = $root.response.GetTeam.toObject(message.getTeam, options);
                if (options.oneofs)
                    object.Operation = "getTeam";
            }
            if (message.getRole != null && message.hasOwnProperty("getRole")) {
                object.getRole = $root.response.GetRole.toObject(message.getRole, options);
                if (options.oneofs)
                    object.Operation = "getRole";
            }
            if (message.resetTOTP != null && message.hasOwnProperty("resetTOTP")) {
                object.resetTOTP = $root.response.ResetTOTP.toObject(message.resetTOTP, options);
                if (options.oneofs)
                    object.Operation = "resetTOTP";
            }
            if (message.quickListSecrets != null && message.hasOwnProperty("quickListSecrets")) {
                object.quickListSecrets = $root.response.QuickListSecrets.toObject(message.quickListSecrets, options);
                if (options.oneofs)
                    object.Operation = "quickListSecrets";
            }
            if (message.setRolesTeamsToUser != null && message.hasOwnProperty("setRolesTeamsToUser")) {
                object.setRolesTeamsToUser = $root.response.SetRolesTeamsToUser.toObject(message.setRolesTeamsToUser, options);
                if (options.oneofs)
                    object.Operation = "setRolesTeamsToUser";
            }
            if (message.updatePinOps != null && message.hasOwnProperty("updatePinOps")) {
                object.updatePinOps = $root.response.UpdatePinOps.toObject(message.updatePinOps, options);
                if (options.oneofs)
                    object.Operation = "updatePinOps";
            }
            if (message.deletePin != null && message.hasOwnProperty("deletePin")) {
                object.deletePin = $root.response.DeletePin.toObject(message.deletePin, options);
                if (options.oneofs)
                    object.Operation = "deletePin";
            }
            if (message.getRolesAndTeamsOfUser != null && message.hasOwnProperty("getRolesAndTeamsOfUser")) {
                object.getRolesAndTeamsOfUser = $root.response.GetRolesAndTeamsOfUser.toObject(message.getRolesAndTeamsOfUser, options);
                if (options.oneofs)
                    object.Operation = "getRolesAndTeamsOfUser";
            }
            if (message.restartPutChunk != null && message.hasOwnProperty("restartPutChunk")) {
                object.restartPutChunk = $root.response.RestartPutChunk.toObject(message.restartPutChunk, options);
                if (options.oneofs)
                    object.Operation = "restartPutChunk";
            }
            if (message.verifyAuditLogMeta != null && message.hasOwnProperty("verifyAuditLogMeta")) {
                object.verifyAuditLogMeta = $root.response.VerifyAuditLogMeta.toObject(message.verifyAuditLogMeta, options);
                if (options.oneofs)
                    object.Operation = "verifyAuditLogMeta";
            }
            if (message.getAuditLog != null && message.hasOwnProperty("getAuditLog")) {
                object.getAuditLog = $root.response.GetAuditLog.toObject(message.getAuditLog, options);
                if (options.oneofs)
                    object.Operation = "getAuditLog";
            }
            if (message.deleteAuditLog != null && message.hasOwnProperty("deleteAuditLog")) {
                object.deleteAuditLog = $root.response.DeleteAuditLog.toObject(message.deleteAuditLog, options);
                if (options.oneofs)
                    object.Operation = "deleteAuditLog";
            }
            if (message.getLedgerRange != null && message.hasOwnProperty("getLedgerRange")) {
                object.getLedgerRange = $root.response.GetLedgerRange.toObject(message.getLedgerRange, options);
                if (options.oneofs)
                    object.Operation = "getLedgerRange";
            }
            if (message.listPins != null && message.hasOwnProperty("listPins")) {
                object.listPins = $root.response.ListPins.toObject(message.listPins, options);
                if (options.oneofs)
                    object.Operation = "listPins";
            }
            if (message.GetMetaFromSharedPath != null && message.hasOwnProperty("GetMetaFromSharedPath")) {
                object.GetMetaFromSharedPath = $root.response.GetMetaFromSharedPath.toObject(message.GetMetaFromSharedPath, options);
                if (options.oneofs)
                    object.Operation = "GetMetaFromSharedPath";
            }
            if (message.listQuestions != null && message.hasOwnProperty("listQuestions")) {
                object.listQuestions = $root.response.ListQuestions.toObject(message.listQuestions, options);
                if (options.oneofs)
                    object.Operation = "listQuestions";
            }
            if (message.verifyBYOSCreds != null && message.hasOwnProperty("verifyBYOSCreds")) {
                object.verifyBYOSCreds = $root.response.VerifyBYOSCreds.toObject(message.verifyBYOSCreds, options);
                if (options.oneofs)
                    object.Operation = "verifyBYOSCreds";
            }
            if (message.MigrateToStorage != null && message.hasOwnProperty("MigrateToStorage")) {
                object.MigrateToStorage = $root.response.MigrateToStorage.toObject(message.MigrateToStorage, options);
                if (options.oneofs)
                    object.Operation = "MigrateToStorage";
            }
            if (message.id != null && message.hasOwnProperty("id")) {
                if (typeof message.id === "number")
                    object.id = options.longs === String ? String(message.id) : message.id;
                else
                    object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber(true) : message.id;
                if (options.oneofs)
                    object._id = "id";
            }
            if (message.updateStorageCreds != null && message.hasOwnProperty("updateStorageCreds")) {
                object.updateStorageCreds = $root.response.UpdateStorageCreds.toObject(message.updateStorageCreds, options);
                if (options.oneofs)
                    object.Operation = "updateStorageCreds";
            }
            if (message.verifyUserForAudit != null && message.hasOwnProperty("verifyUserForAudit")) {
                object.verifyUserForAudit = $root.response.VerifyUserForAudit.toObject(message.verifyUserForAudit, options);
                if (options.oneofs)
                    object.Operation = "verifyUserForAudit";
            }
            if (message.removeOrganizationUser != null && message.hasOwnProperty("removeOrganizationUser")) {
                object.removeOrganizationUser = $root.response.RemoveOrganizationUser.toObject(message.removeOrganizationUser, options);
                if (options.oneofs)
                    object.Operation = "removeOrganizationUser";
            }
            if (message.addSpace != null && message.hasOwnProperty("addSpace")) {
                object.addSpace = $root.response.AddSpace.toObject(message.addSpace, options);
                if (options.oneofs)
                    object.Operation = "addSpace";
            }
            if (message.addUserToSpace != null && message.hasOwnProperty("addUserToSpace")) {
                object.addUserToSpace = $root.response.AddUserToSpace.toObject(message.addUserToSpace, options);
                if (options.oneofs)
                    object.Operation = "addUserToSpace";
            }
            if (message.removeUserFromSpace != null && message.hasOwnProperty("removeUserFromSpace")) {
                object.removeUserFromSpace = $root.response.RemoveUserFromSpace.toObject(message.removeUserFromSpace, options);
                if (options.oneofs)
                    object.Operation = "removeUserFromSpace";
            }
            if (message.updatePermissionsOfSpace != null && message.hasOwnProperty("updatePermissionsOfSpace")) {
                object.updatePermissionsOfSpace = $root.response.UpdatePermissionsOfSpace.toObject(message.updatePermissionsOfSpace, options);
                if (options.oneofs)
                    object.Operation = "updatePermissionsOfSpace";
            }
            if (message.addObjectToSpace != null && message.hasOwnProperty("addObjectToSpace")) {
                object.addObjectToSpace = $root.response.AddObjectToSpace.toObject(message.addObjectToSpace, options);
                if (options.oneofs)
                    object.Operation = "addObjectToSpace";
            }
            if (message.removeObjectFromSpace != null && message.hasOwnProperty("removeObjectFromSpace")) {
                object.removeObjectFromSpace = $root.response.RemoveObjectFromSpace.toObject(message.removeObjectFromSpace, options);
                if (options.oneofs)
                    object.Operation = "removeObjectFromSpace";
            }
            if (message.removeSpace != null && message.hasOwnProperty("removeSpace")) {
                object.removeSpace = $root.response.RemoveSpace.toObject(message.removeSpace, options);
                if (options.oneofs)
                    object.Operation = "removeSpace";
            }
            if (message.sendOtpToExternalUser != null && message.hasOwnProperty("sendOtpToExternalUser")) {
                object.sendOtpToExternalUser = $root.response.SendOtpToExternalUser.toObject(message.sendOtpToExternalUser, options);
                if (options.oneofs)
                    object.Operation = "sendOtpToExternalUser";
            }
            if (message.signInToSpace != null && message.hasOwnProperty("signInToSpace")) {
                object.signInToSpace = $root.response.SignInToSpace.toObject(message.signInToSpace, options);
                if (options.oneofs)
                    object.Operation = "signInToSpace";
            }
            if (message.listSpaces != null && message.hasOwnProperty("listSpaces")) {
                object.listSpaces = $root.response.ListSpaces.toObject(message.listSpaces, options);
                if (options.oneofs)
                    object.Operation = "listSpaces";
            }
            if (message.sendOtpToExternalUserIfNotExist != null && message.hasOwnProperty("sendOtpToExternalUserIfNotExist")) {
                object.sendOtpToExternalUserIfNotExist = $root.response.SendOtpToExternalUserIfNotExist.toObject(message.sendOtpToExternalUserIfNotExist, options);
                if (options.oneofs)
                    object.Operation = "sendOtpToExternalUserIfNotExist";
            }
            if (message.getStorageValue != null && message.hasOwnProperty("getStorageValue")) {
                object.getStorageValue = $root.response.GetStorageValue.toObject(message.getStorageValue, options);
                if (options.oneofs)
                    object.Operation = "getStorageValue";
            }
            if (message.updateTags != null && message.hasOwnProperty("updateTags")) {
                object.updateTags = $root.response.UpdateTags.toObject(message.updateTags, options);
                if (options.oneofs)
                    object.Operation = "updateTags";
            }
            if (message.addComment != null && message.hasOwnProperty("addComment")) {
                object.addComment = $root.response.AddComment.toObject(message.addComment, options);
                if (options.oneofs)
                    object.Operation = "addComment";
            }
            if (message.removeComment != null && message.hasOwnProperty("removeComment")) {
                object.removeComment = $root.response.RemoveComment.toObject(message.removeComment, options);
                if (options.oneofs)
                    object.Operation = "removeComment";
            }
            if (message.listComments != null && message.hasOwnProperty("listComments")) {
                object.listComments = $root.response.ListComments.toObject(message.listComments, options);
                if (options.oneofs)
                    object.Operation = "listComments";
            }
            if (message.updateComment != null && message.hasOwnProperty("updateComment")) {
                object.updateComment = $root.response.UpdateComment.toObject(message.updateComment, options);
                if (options.oneofs)
                    object.Operation = "updateComment";
            }
            if (message.getComment != null && message.hasOwnProperty("getComment")) {
                object.getComment = $root.response.GetComment.toObject(message.getComment, options);
                if (options.oneofs)
                    object.Operation = "getComment";
            }
            if (message.sessionData != null && message.hasOwnProperty("sessionData")) {
                object.sessionData = $root.response.SessionData.toObject(message.sessionData, options);
                if (options.oneofs)
                    object.Operation = "sessionData";
            }
            if (message.getStorageCreds != null && message.hasOwnProperty("getStorageCreds")) {
                object.getStorageCreds = $root.response.GetStorageCreds.toObject(message.getStorageCreds, options);
                if (options.oneofs)
                    object.Operation = "getStorageCreds";
            }
            if (message.listPlans != null && message.hasOwnProperty("listPlans")) {
                object.listPlans = $root.response.ListPlans.toObject(message.listPlans, options);
                if (options.oneofs)
                    object.Operation = "listPlans";
            }
            if (message.upgradePlan != null && message.hasOwnProperty("upgradePlan")) {
                object.upgradePlan = $root.response.UpgradePlan.toObject(message.upgradePlan, options);
                if (options.oneofs)
                    object.Operation = "upgradePlan";
            }
            if (message.validateCoupon != null && message.hasOwnProperty("validateCoupon")) {
                object.validateCoupon = $root.response.ValidateCoupon.toObject(message.validateCoupon, options);
                if (options.oneofs)
                    object.Operation = "validateCoupon";
            }
            if (message.getPlan != null && message.hasOwnProperty("getPlan")) {
                object.getPlan = $root.response.GetPlan.toObject(message.getPlan, options);
                if (options.oneofs)
                    object.Operation = "getPlan";
            }
            if (message.removeVersion != null && message.hasOwnProperty("removeVersion")) {
                object.removeVersion = $root.response.RemoveVersion.toObject(message.removeVersion, options);
                if (options.oneofs)
                    object.Operation = "removeVersion";
            }
            if (message.getProfilePictureOfUser != null && message.hasOwnProperty("getProfilePictureOfUser")) {
                object.getProfilePictureOfUser = $root.response.GetProfilePictureOfUser.toObject(message.getProfilePictureOfUser, options);
                if (options.oneofs)
                    object.Operation = "getProfilePictureOfUser";
            }
            if (message.emptyTrash != null && message.hasOwnProperty("emptyTrash")) {
                object.emptyTrash = $root.response.EmptyTrash.toObject(message.emptyTrash, options);
                if (options.oneofs)
                    object.Operation = "emptyTrash";
            }
            if (message.setThumbnail != null && message.hasOwnProperty("setThumbnail")) {
                object.setThumbnail = $root.response.SetThumbnail.toObject(message.setThumbnail, options);
                if (options.oneofs)
                    object.Operation = "setThumbnail";
            }
            if (message.getThumbnail != null && message.hasOwnProperty("getThumbnail")) {
                object.getThumbnail = $root.response.GetThumbnail.toObject(message.getThumbnail, options);
                if (options.oneofs)
                    object.Operation = "getThumbnail";
            }
            if (message.blockUser != null && message.hasOwnProperty("blockUser")) {
                object.blockUser = $root.response.BlockUser.toObject(message.blockUser, options);
                if (options.oneofs)
                    object.Operation = "blockUser";
            }
            if (message.unblockUser != null && message.hasOwnProperty("unblockUser")) {
                object.unblockUser = $root.response.UnblockUser.toObject(message.unblockUser, options);
                if (options.oneofs)
                    object.Operation = "unblockUser";
            }
            if (message.updateOrgSettings != null && message.hasOwnProperty("updateOrgSettings")) {
                object.updateOrgSettings = $root.response.UpdateOrgSettings.toObject(message.updateOrgSettings, options);
                if (options.oneofs)
                    object.Operation = "updateOrgSettings";
            }
            if (message.getOrgSettings != null && message.hasOwnProperty("getOrgSettings")) {
                object.getOrgSettings = $root.response.GetOrgSettings.toObject(message.getOrgSettings, options);
                if (options.oneofs)
                    object.Operation = "getOrgSettings";
            }
            return object;
        };

        /**
         * Converts this Response to JSON.
         * @function toJSON
         * @memberof response.Response
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Response.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Response
         * @function getTypeUrl
         * @memberof response.Response
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Response.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/response.Response";
        };

        return Response;
    })();

    return response;
})();

export { $root as default };
